webpackJsonp([0],{

/***/ "../node_modules/core-js/fn/array/find.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es6.array.find.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").Array.find;

/***/ }),

/***/ "../node_modules/core-js/fn/array/includes.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es7.array.includes.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").Array.includes;

/***/ }),

/***/ "../node_modules/core-js/fn/object/entries.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es7.object.entries.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").Object.entries;

/***/ }),

/***/ "../node_modules/core-js/fn/object/values.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es7.object.values.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").Object.values;

/***/ }),

/***/ "../node_modules/core-js/fn/string/includes.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es6.string.includes.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").String.includes;

/***/ }),

/***/ "../node_modules/core-js/modules/_a-function.js":
/***/ (function(module, exports) {



module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_add-to-unscopables.js":
/***/ (function(module, exports, __webpack_require__) {



// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("../node_modules/core-js/modules/_wks.js")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("../node_modules/core-js/modules/_hide.js")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_an-object.js":
/***/ (function(module, exports, __webpack_require__) {



var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_array-includes.js":
/***/ (function(module, exports, __webpack_require__) {



// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var toAbsoluteIndex = __webpack_require__("../node_modules/core-js/modules/_to-absolute-index.js");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
      // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
    }return !IS_INCLUDES && -1;
  };
};

/***/ }),

/***/ "../node_modules/core-js/modules/_array-methods.js":
/***/ (function(module, exports, __webpack_require__) {



// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__("../node_modules/core-js/modules/_ctx.js");
var IObject = __webpack_require__("../node_modules/core-js/modules/_iobject.js");
var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var asc = __webpack_require__("../node_modules/core-js/modules/_array-species-create.js");
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (; length > index; index++) {
      if (NO_HOLES || index in self) {
        val = self[index];
        res = f(val, index, O);
        if (TYPE) {
          if (IS_MAP) result[index] = res; // map
          else if (res) switch (TYPE) {
              case 3:
                return true; // some
              case 5:
                return val; // find
              case 6:
                return index; // findIndex
              case 2:
                result.push(val); // filter
            } else if (IS_EVERY) return false; // every
        }
      }
    }return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

/***/ }),

/***/ "../node_modules/core-js/modules/_array-species-constructor.js":
/***/ (function(module, exports, __webpack_require__) {



var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var isArray = __webpack_require__("../node_modules/core-js/modules/_is-array.js");
var SPECIES = __webpack_require__("../node_modules/core-js/modules/_wks.js")('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  }return C === undefined ? Array : C;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_array-species-create.js":
/***/ (function(module, exports, __webpack_require__) {



// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__("../node_modules/core-js/modules/_array-species-constructor.js");

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_cof.js":
/***/ (function(module, exports) {



var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_core.js":
/***/ (function(module, exports) {



var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

/***/ }),

/***/ "../node_modules/core-js/modules/_ctx.js":
/***/ (function(module, exports, __webpack_require__) {



// optional / simple context binding
var aFunction = __webpack_require__("../node_modules/core-js/modules/_a-function.js");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };
    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };
    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }
  return function () /* ...args */{
    return fn.apply(that, arguments);
  };
};

/***/ }),

/***/ "../node_modules/core-js/modules/_defined.js":
/***/ (function(module, exports) {



// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_descriptors.js":
/***/ (function(module, exports, __webpack_require__) {



// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  return Object.defineProperty({}, 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),

/***/ "../node_modules/core-js/modules/_dom-create.js":
/***/ (function(module, exports, __webpack_require__) {



var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var document = __webpack_require__("../node_modules/core-js/modules/_global.js").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

/***/ }),

/***/ "../node_modules/core-js/modules/_enum-bug-keys.js":
/***/ (function(module, exports) {



// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

/***/ }),

/***/ "../node_modules/core-js/modules/_export.js":
/***/ (function(module, exports, __webpack_require__) {



var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var core = __webpack_require__("../node_modules/core-js/modules/_core.js");
var hide = __webpack_require__("../node_modules/core-js/modules/_hide.js");
var redefine = __webpack_require__("../node_modules/core-js/modules/_redefine.js");
var ctx = __webpack_require__("../node_modules/core-js/modules/_ctx.js");
var PROTOTYPE = 'prototype';

var $export = function $export(type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1; // forced
$export.G = 2; // global
$export.S = 4; // static
$export.P = 8; // proto
$export.B = 16; // bind
$export.W = 32; // wrap
$export.U = 64; // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

/***/ }),

/***/ "../node_modules/core-js/modules/_fails-is-regexp.js":
/***/ (function(module, exports, __webpack_require__) {



var MATCH = __webpack_require__("../node_modules/core-js/modules/_wks.js")('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) {/* empty */}
  }return true;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_fails.js":
/***/ (function(module, exports) {



module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

/***/ }),

/***/ "../node_modules/core-js/modules/_global.js":
/***/ (function(module, exports) {



// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
// eslint-disable-next-line no-new-func
: Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

/***/ }),

/***/ "../node_modules/core-js/modules/_has.js":
/***/ (function(module, exports) {



var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_hide.js":
/***/ (function(module, exports, __webpack_require__) {



var dP = __webpack_require__("../node_modules/core-js/modules/_object-dp.js");
var createDesc = __webpack_require__("../node_modules/core-js/modules/_property-desc.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_descriptors.js") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_ie8-dom-define.js":
/***/ (function(module, exports, __webpack_require__) {



module.exports = !__webpack_require__("../node_modules/core-js/modules/_descriptors.js") && !__webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  return Object.defineProperty(__webpack_require__("../node_modules/core-js/modules/_dom-create.js")('div'), 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),

/***/ "../node_modules/core-js/modules/_iobject.js":
/***/ (function(module, exports, __webpack_require__) {



// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_is-array.js":
/***/ (function(module, exports, __webpack_require__) {



// 7.2.2 IsArray(argument)
var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

/***/ }),

/***/ "../node_modules/core-js/modules/_is-object.js":
/***/ (function(module, exports) {



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function (it) {
  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),

/***/ "../node_modules/core-js/modules/_is-regexp.js":
/***/ (function(module, exports, __webpack_require__) {



// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js");
var MATCH = __webpack_require__("../node_modules/core-js/modules/_wks.js")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};

/***/ }),

/***/ "../node_modules/core-js/modules/_library.js":
/***/ (function(module, exports) {



module.exports = false;

/***/ }),

/***/ "../node_modules/core-js/modules/_object-dp.js":
/***/ (function(module, exports, __webpack_require__) {



var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var IE8_DOM_DEFINE = __webpack_require__("../node_modules/core-js/modules/_ie8-dom-define.js");
var toPrimitive = __webpack_require__("../node_modules/core-js/modules/_to-primitive.js");
var dP = Object.defineProperty;

exports.f = __webpack_require__("../node_modules/core-js/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) {/* empty */}
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_object-keys-internal.js":
/***/ (function(module, exports, __webpack_require__) {



var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var arrayIndexOf = __webpack_require__("../node_modules/core-js/modules/_array-includes.js")(false);
var IE_PROTO = __webpack_require__("../node_modules/core-js/modules/_shared-key.js")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) {
    if (key != IE_PROTO) has(O, key) && result.push(key);
  } // Don't enum bug & hidden keys
  while (names.length > i) {
    if (has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
  }return result;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_object-keys.js":
/***/ (function(module, exports, __webpack_require__) {



// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("../node_modules/core-js/modules/_object-keys-internal.js");
var enumBugKeys = __webpack_require__("../node_modules/core-js/modules/_enum-bug-keys.js");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_object-pie.js":
/***/ (function(module, exports) {



exports.f = {}.propertyIsEnumerable;

/***/ }),

/***/ "../node_modules/core-js/modules/_object-to-array.js":
/***/ (function(module, exports, __webpack_require__) {



var getKeys = __webpack_require__("../node_modules/core-js/modules/_object-keys.js");
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var isEnum = __webpack_require__("../node_modules/core-js/modules/_object-pie.js").f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      if (isEnum.call(O, key = keys[i++])) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }return result;
  };
};

/***/ }),

/***/ "../node_modules/core-js/modules/_property-desc.js":
/***/ (function(module, exports) {



module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

/***/ }),

/***/ "../node_modules/core-js/modules/_redefine.js":
/***/ (function(module, exports, __webpack_require__) {



var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var hide = __webpack_require__("../node_modules/core-js/modules/_hide.js");
var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var SRC = __webpack_require__("../node_modules/core-js/modules/_uid.js")('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("../node_modules/core-js/modules/_core.js").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
  // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

/***/ }),

/***/ "../node_modules/core-js/modules/_shared-key.js":
/***/ (function(module, exports, __webpack_require__) {



var shared = __webpack_require__("../node_modules/core-js/modules/_shared.js")('keys');
var uid = __webpack_require__("../node_modules/core-js/modules/_uid.js");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),

/***/ "../node_modules/core-js/modules/_shared.js":
/***/ (function(module, exports, __webpack_require__) {



var core = __webpack_require__("../node_modules/core-js/modules/_core.js");
var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("../node_modules/core-js/modules/_library.js") ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});

/***/ }),

/***/ "../node_modules/core-js/modules/_string-context.js":
/***/ (function(module, exports, __webpack_require__) {



// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__("../node_modules/core-js/modules/_is-regexp.js");
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-absolute-index.js":
/***/ (function(module, exports, __webpack_require__) {



var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-integer.js":
/***/ (function(module, exports) {



// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-iobject.js":
/***/ (function(module, exports, __webpack_require__) {



// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("../node_modules/core-js/modules/_iobject.js");
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");
module.exports = function (it) {
  return IObject(defined(it));
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-length.js":
/***/ (function(module, exports, __webpack_require__) {



// 7.1.15 ToLength
var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-object.js":
/***/ (function(module, exports, __webpack_require__) {



// 7.1.13 ToObject(argument)
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");
module.exports = function (it) {
  return Object(defined(it));
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {



// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),

/***/ "../node_modules/core-js/modules/_uid.js":
/***/ (function(module, exports) {



var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),

/***/ "../node_modules/core-js/modules/_wks.js":
/***/ (function(module, exports, __webpack_require__) {



var store = __webpack_require__("../node_modules/core-js/modules/_shared.js")('wks');
var uid = __webpack_require__("../node_modules/core-js/modules/_uid.js");
var _Symbol = __webpack_require__("../node_modules/core-js/modules/_global.js").Symbol;
var USE_SYMBOL = typeof _Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),

/***/ "../node_modules/core-js/modules/es6.array.find.js":
/***/ (function(module, exports, __webpack_require__) {


// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $find = __webpack_require__("../node_modules/core-js/modules/_array-methods.js")(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () {
  forced = false;
});
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js")(KEY);

/***/ }),

/***/ "../node_modules/core-js/modules/es6.string.includes.js":
/***/ (function(module, exports, __webpack_require__) {

// 21.1.3.7 String.prototype.includes(searchString, position = 0)


var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var context = __webpack_require__("../node_modules/core-js/modules/_string-context.js");
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails-is-regexp.js")(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

/***/ }),

/***/ "../node_modules/core-js/modules/es7.array.includes.js":
/***/ (function(module, exports, __webpack_require__) {


// https://github.com/tc39/Array.prototype.includes

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $includes = __webpack_require__("../node_modules/core-js/modules/_array-includes.js")(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js")('includes');

/***/ }),

/***/ "../node_modules/core-js/modules/es7.object.entries.js":
/***/ (function(module, exports, __webpack_require__) {



// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $entries = __webpack_require__("../node_modules/core-js/modules/_object-to-array.js")(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});

/***/ }),

/***/ "../node_modules/core-js/modules/es7.object.values.js":
/***/ (function(module, exports, __webpack_require__) {



// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $values = __webpack_require__("../node_modules/core-js/modules/_object-to-array.js")(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

/***/ }),

/***/ "../node_modules/node-uuid/uuid.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {var __WEBPACK_AMD_DEFINE_RESULT__;//     uuid.js
//
//     Copyright (c) 2010-2012 Robert Kieffer
//     MIT License - http://opensource.org/licenses/mit-license.php

/*global window, require, define */
(function(_window) {
  

  // Unique ID creation requires a high quality random # generator.  We feature
  // detect to determine the best RNG source, normalizing to a function that
  // returns 128-bits of randomness, since that's what's usually required
  var _rng, _mathRNG, _nodeRNG, _whatwgRNG, _previousRoot;

  function setupBrowser() {
    // Allow for MSIE11 msCrypto
    var _crypto = _window.crypto || _window.msCrypto;

    if (!_rng && _crypto && _crypto.getRandomValues) {
      // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
      //
      // Moderately fast, high quality
      try {
        var _rnds8 = new Uint8Array(16);
        _whatwgRNG = _rng = function whatwgRNG() {
          _crypto.getRandomValues(_rnds8);
          return _rnds8;
        };
        _rng();
      } catch(e) {}
    }

    if (!_rng) {
      // Math.random()-based (RNG)
      //
      // If all else fails, use Math.random().  It's fast, but is of unspecified
      // quality.
      var  _rnds = new Array(16);
      _mathRNG = _rng = function() {
        for (var i = 0, r; i < 16; i++) {
          if ((i & 0x03) === 0) { r = Math.random() * 0x100000000; }
          _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }

        return _rnds;
      };
      if ('undefined' !== typeof console && console.warn) {
        console.warn("[SECURITY] node-uuid: crypto not usable, falling back to insecure Math.random()");
      }
    }
  }

  function setupNode() {
    // Node.js crypto-based RNG - http://nodejs.org/docs/v0.6.2/api/crypto.html
    //
    // Moderately fast, high quality
    if (true) {
      try {
        var _rb = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"crypto\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())).randomBytes;
        _nodeRNG = _rng = _rb && function() {return _rb(16);};
        _rng();
      } catch(e) {}
    }
  }

  if (_window) {
    setupBrowser();
  } else {
    setupNode();
  }

  // Buffer class to use
  var BufferClass = ('function' === typeof Buffer) ? Buffer : Array;

  // Maps for number <-> hex string conversion
  var _byteToHex = [];
  var _hexToByte = {};
  for (var i = 0; i < 256; i++) {
    _byteToHex[i] = (i + 0x100).toString(16).substr(1);
    _hexToByte[_byteToHex[i]] = i;
  }

  // **`parse()` - Parse a UUID into it's component bytes**
  function parse(s, buf, offset) {
    var i = (buf && offset) || 0, ii = 0;

    buf = buf || [];
    s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
      if (ii < 16) { // Don't overflow!
        buf[i + ii++] = _hexToByte[oct];
      }
    });

    // Zero out remaining bytes if string was short
    while (ii < 16) {
      buf[i + ii++] = 0;
    }

    return buf;
  }

  // **`unparse()` - Convert UUID byte array (ala parse()) into a string**
  function unparse(buf, offset) {
    var i = offset || 0, bth = _byteToHex;
    return  bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]];
  }

  // **`v1()` - Generate time-based UUID**
  //
  // Inspired by https://github.com/LiosK/UUID.js
  // and http://docs.python.org/library/uuid.html

  // random #'s we need to init node and clockseq
  var _seedBytes = _rng();

  // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
  var _nodeId = [
    _seedBytes[0] | 0x01,
    _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
  ];

  // Per 4.2.2, randomize (14 bit) clockseq
  var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

  // Previous uuid creation time
  var _lastMSecs = 0, _lastNSecs = 0;

  // See https://github.com/broofa/node-uuid for API details
  function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];

    options = options || {};

    var clockseq = (options.clockseq != null) ? options.clockseq : _clockseq;

    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = (options.msecs != null) ? options.msecs : new Date().getTime();

    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = (options.nsecs != null) ? options.nsecs : _lastNSecs + 1;

    // Time since last uuid creation (in msecs)
    var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq == null) {
      clockseq = clockseq + 1 & 0x3fff;
    }

    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs == null) {
      nsecs = 0;
    }

    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) {
      throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    }

    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq;

    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;

    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;

    // `time_mid`
    var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;

    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;

    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;

    // `clock_seq_low`
    b[i++] = clockseq & 0xff;

    // `node`
    var node = options.node || _nodeId;
    for (var n = 0; n < 6; n++) {
      b[i + n] = node[n];
    }

    return buf ? buf : unparse(b);
  }

  // **`v4()` - Generate random UUID**

  // See https://github.com/broofa/node-uuid for API details
  function v4(options, buf, offset) {
    // Deprecated - 'format' argument, as supported in v1.2
    var i = buf && offset || 0;

    if (typeof(options) === 'string') {
      buf = (options === 'binary') ? new BufferClass(16) : null;
      options = null;
    }
    options = options || {};

    var rnds = options.random || (options.rng || _rng)();

    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = (rnds[6] & 0x0f) | 0x40;
    rnds[8] = (rnds[8] & 0x3f) | 0x80;

    // Copy bytes to buffer, if provided
    if (buf) {
      for (var ii = 0; ii < 16; ii++) {
        buf[i + ii] = rnds[ii];
      }
    }

    return buf || unparse(rnds);
  }

  // Export public API
  var uuid = v4;
  uuid.v1 = v1;
  uuid.v4 = v4;
  uuid.parse = parse;
  uuid.unparse = unparse;
  uuid.BufferClass = BufferClass;
  uuid._rng = _rng;
  uuid._mathRNG = _mathRNG;
  uuid._nodeRNG = _nodeRNG;
  uuid._whatwgRNG = _whatwgRNG;

  if (('undefined' !== typeof module) && module.exports) {
    // Publish as node.js module
    module.exports = uuid;
  } else if (true) {
    // Publish as AMD module
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {return uuid;}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


  } else {
    // Publish as global (in browsers)
    _previousRoot = _window.uuid;

    // **`noConflict()` - (browser only) to reset global 'uuid' var**
    uuid.noConflict = function() {
      _window.uuid = _previousRoot;
      return uuid;
    };

    _window.uuid = uuid;
  }
})('undefined' !== typeof window ? window : null);


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-credit-components/src/choose-credit-offer/faq/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"faq\">\n    <div class=\"clearfix\">\n        <a id=\"toggleAll\" class=\"hideAll\" ng-click=\"actions.toggleAllFAQ()\">{{toggleText}}</a>\n        <h2 class=\"beta\" id=\"title\">{{content('FAQ.title')}}</h2>\n    </div>\n    <ul>\n        <li ng-class=\"{ expanded:faqExtended[0], collapsed:!faqExtended[0], faqContent:true}\">\n            <div class='action' ng-click=\"actions.toggleFAQ(0)\">\n                <span ng-class=\"{ plus:!faqExtended[0], minus:faqExtended[0], faqAction:true}\"></span>\n                <p class=\"gamma\">{{content('FAQ.question1')}}</p>\n            </div>\n            <div class=\"answer secondary longerAnswer\">\n                <span class='action' ng-bind-html=\"htmlContent('FAQ.answer1')\"></span>\n                <div class=\"amortizationTableDEContainer\">\n                    <table class=\"amortizationTableDE\">\n                        <tbody>\n                            <tr class=\"amortizationHeader lastRow\">\n                                <th/>\n                                <th>{{content('FAQ.month')}}</th>\n                                <th>{{content('FAQ.amountBefore')}}</th>\n                                <th>{{content('FAQ.installment')}}</th>\n                                <th>{{content('FAQ.interest')}}</th>\n                                <th>{{content('FAQ.repayment')}}</th>\n                                <th>{{content('FAQ.amountAfter')}}</th>\n                            </tr>\n                            <tr class=\"amortizationContent\">\n                                <td class=\"firstColumn\" rowspan=\"6\">\n                                    <p class=\"firstRow\" ng-bind-html=\"htmlContent('FAQ.examplePurchaseAmount1')\" />\n                                    <p ng-bind-html=\"htmlContent('FAQ.exampleAPR1')\" />\n                                </td>\n                                <td> 1 </td>\n                                <td> 389,00 </td>\n                                <td> 66,66 </td>\n                                <td> 3,10 </td>\n                                <td> 63,56 </td>\n                                <td> 325,44 </td>\n\n                            </tr>\n                             <tr class=\"amortizationContent\">\n\n                                <td> 2 </td>\n                                <td> 325,44 </td>\n                                <td> 66,66 </td>\n                                <td> 2,59 </td>\n                                <td> 64,07 </td>\n                                <td> 261,37 </td>\n\n                            </tr>\n                            <tr class=\"amortizationContent\">\n\n                                <td> 3 </td>\n                                <td> 261,37 </td>\n                                <td> 66,66 </td>\n                                <td> 2,08 </td>\n                                <td> 64,58 </td>\n                                <td> 196,79 </td>\n\n                            </tr>\n                            <tr class=\"amortizationContent\">\n\n                                <td> 4 </td>\n                                <td> 196,79 </td>\n                                <td> 66,66 </td>\n                                <td> 1,57 </td>\n                                <td> 65,09 </td>\n                                <td> 131,70 </td>\n\n                            </tr>\n                            <tr class=\"amortizationContent\">\n\n                                 <td> 5 </td>\n                                <td> 131,70 </td>\n                                <td> 66,66 </td>\n                                <td> 1,05 </td>\n                                <td> 65,61 </td>\n                                <td> 66,09 </td>\n\n                            </tr>\n                            <tr class=\"amortizationContent lastRow\">\n                                <td> 6 </td>\n                                <td> 66,09 </td>\n                                <td> 66,62 </td>\n                                <td> 0,53 </td>\n                                <td> 66,09 </td>\n                                <td> 0,00 </td>\n\n                            </tr>\n                            <tr class=\"amortizationContent\">\n                                <td class=\"firstColumn endOfTable\" rowspan=\"12\">\n                                    <p class=\"firstRow\" ng-bind-html=\"htmlContent('FAQ.examplePurchaseAmount2')\" />\n                                    <p class=\"firstRow\" ng-bind-html=\"htmlContent('FAQ.exampleInstallmentTerm2')\" />\n                                    <p ng-bind-html=\"htmlContent('FAQ.exampleAPR2')\" />\n                                </td>\n                                <td> 1 </td>\n                                <td> 699,00 </td>\n                                <td> 60,72 </td>\n                                <td> 4,49 </td>\n                                <td> 56,23 </td>\n                                <td> 642,77 </td>\n\n                            </tr>\n                             <tr class=\"amortizationContent\">\n                                <td> 2 </td>\n                                <td> 642,77 </td>\n                                <td> 60,72 </td>\n                                <td> 4,13 </td>\n                                <td> 56,59 </td>\n                                <td> 586,18 </td>\n\n                            </tr>\n                            <tr class=\"amortizationContent\">\n                                <td> 3 </td>\n                                <td> 586,18 </td>\n                                <td> 60,72 </td>\n                                <td> 3,77 </td>\n                                <td> 56,95 </td>\n                                <td> 529,23 </td>\n\n                            </tr>\n                            <tr class=\"amortizationContent\">\n                                <td> 4 </td>\n                                <td> 529,23 </td>\n                                <td> 60,72 </td>\n                                <td> 3,40 </td>\n                                <td> 57,32 </td>\n                                <td>  471,91</td>\n\n                            </tr>\n                            <tr class=\"amortizationContent\">\n\n                                 <td> 5 </td>\n                                <td> 471,91 </td>\n                                <td> 60,72 </td>\n                                <td> 3,03 </td>\n                                <td> 57,69 </td>\n                                <td> 414,22 </td>\n\n                            </tr>\n                            <tr class=\"amortizationContent\">\n                                <td> 6 </td>\n                                <td> 414,22 </td>\n                                <td> 60,72 </td>\n                                <td> 2,56 </td>\n                                <td> 58,06 </td>\n                                <td> 356,16 </td>\n                            </tr>\n                            <tr class=\"amortizationContent\">\n                                <td> 7 </td>\n                                <td> 356,16 </td>\n                                <td> 60,72 </td>\n                                <td> 2,29 </td>\n                                <td> 58,43 </td>\n                                <td> 297,73 </td>\n                            </tr>\n                            <tr class=\"amortizationContent\">\n                                <td> 8 </td>\n                                <td> 297,73 </td>\n                                <td> 60,72 </td>\n                                <td> 1,91 </td>\n                                <td> 58,81 </td>\n                                <td> 238,92 </td>\n                            </tr>\n                            <tr class=\"amortizationContent\">\n                                <td> 9 </td>\n                                <td> 238,92 </td>\n                                <td> 60,72 </td>\n                                <td> 1,54 </td>\n                                <td> 59,18 </td>\n                                <td> 179,74 </td>\n                            </tr>\n                            <tr class=\"amortizationContent\">\n\n                                <td> 10 </td>\n                                <td> 179,74 </td>\n                                <td> 60,72 </td>\n                                <td> 1,16 </td>\n                                <td> 59,56 </td>\n                                <td> 120,18 </td>\n                            </tr>\n                             <tr class=\"amortizationContent\">\n                                <td> 11 </td>\n                                <td> 120,18 </td>\n                                <td> 60,72 </td>\n                                <td> 0,77 </td>\n                                <td> 59,95 </td>\n                                <td> 60,23 </td>\n                            </tr>\n                             <tr class=\"amortizationContent\">\n                                <td class=\"endOfTable\"> 12 </td>\n                                <td class=\"endOfTable\"> 60,23 </td>\n                                <td class=\"endOfTable\"> 60,62 </td>\n                                <td class=\"endOfTable\"> 0,39 </td>\n                                <td class=\"endOfTable\"> 60,23 </td>\n                                <td class=\"endOfTable\"> 0,00 </td>\n                            </tr>\n                        </tbody>\n                    </table>\n                </div>\n\n            </div>\n        </li>\n             \n        <li ng-class=\"{ expanded:faqExtended[1], collapsed:!faqExtended[1], faqContent:true}\">\n            <div class='action' ng-click=\"actions.toggleFAQ(1)\">\n                <span ng-class=\"{ plus:!faqExtended[1], minus:faqExtended[1], faqAction:true}\"></span>\n                <p class=\"gamma\">{{content('FAQ.question3')}}</p>\n            </div>\n            <div class=\"answer secondary\">{{content('FAQ.answer3')}}</div>\n        </li>\n        <li ng-class=\"{ expanded:faqExtended[2], collapsed:!faqExtended[2], faqContent:true, last:true}\">\n            <div class='action' ng-click=\"actions.toggleFAQ(2)\">\n                <span ng-class=\"{ plus:!faqExtended[2], minus:faqExtended[2], faqAction:true}\"></span>\n                <p class=\"gamma\">{{content('FAQ.question4')}}</p>\n            </div>\n            <div class=\"answer secondary\">{{content('FAQ.answer4')}}</div>\n        </li>\n    </ul>\n</div>"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-page-components/src/value-props/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"props {{type}}\" content>\n    <div class=\"prop-img\"></div>\n    <h2 class=\"vprop-header\">{{ title }}</h2>\n    <p ng-if=\"textContent\" ng-bind-html=\"htmlContent(textContent)\"></p>\n    <p ng-if=\"!textContent\" ng-bind-html=\"text\"></p>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/escape-hatch/closeFrame/template.html":
/***/ (function(module, exports) {

module.exports = "<a ng-show=\"isIFrame\" href=\"{{redirectURL}}\" id=\"closeButton\" target=\"_parent\" role=\"button\" ng-click=\"closeFrame($event)\">{{ content('base.closePayPalCheckoutLabel') }}</a>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/escape-hatch/escapeHatch/template.html":
/***/ (function(module, exports) {

module.exports = "<button ng-show=\"isIFrame\" title=\"{{content('footer.escHatch')}}\" class='btn escapeHatch' ng-click=\"closeFrame()\"><span class=\"accessAid\">{{content('footer.escHatch')}}</span></button>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/generic-message/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"genericMessage\" content>\n    <div class=\"container\">\n        <div class=\"logo\"></div>\n        <div class=\"title\" ng-if=\"titleKey\">\n            {{content(titleKey)}}\n        </div>\n        <div class=\"message\" ng-if=\"contentKey\">\n            {{content(contentKey)}}\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/message/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"message.msgs || message.msgKeys\">\n    <div id=\"notifications\" role=\"alert\" aria-live=\"assertive\" content >\n        <div id=\"pageLevelErrors\" ng-class=\"[{'extendedMsg': isgreyheader}, 'msg-' + message.type, 'msgPage']\">\n            <span class=\"icon\"></span>\n            <ul role=\"presentation\">\n                <li ng-repeat=\"msg in message.msgs track by $index\">\n                    <span data-ng-bind-html=\"msg\" data-test-id=\"message\"></span>\n                </li>\n                <li ng-repeat=\"keys in message.msgKeys track by $index\" ng-if=\"message.msgKeys\">\n                    <div data-ng-bind-html=\"htmlContent(keys, message.compileWith)\" data-test-id=\"message\"></div>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/spinner-button/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"spinnerBtn\" content>\n    <button track-submit={{track}} ng-click=\"submit()\" class=\"btn full\">\n        <div ng-show=\"isProcessing\" ng-class=\"{processing: isProcessing}\" class=\"spinner\"></div>\n        <div ng-hide=\"isProcessing\" class=\"text\" ng-bind-html=\"htmlContent(buttonText)\"></div>\n    </button>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/spinner/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"loading\" id=\"spinner\" class=\"spinner\">\n    <div class=\"spinWrap\">\n        <p class=\"spinnerImage\"></p>\n        <p class=\"loader\"></p>\n        <p id=\"spinner-message\" tabIndex=\"0\" class=\"loadingMessage\">{{message}}</p>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/object-assign/index.js":
/***/ (function(module, exports) {

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};



/***/ }),

/***/ "../node_modules/squid/dist/core/api.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$Api = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.$getLatestCorrelationID = $getLatestCorrelationID;

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _event = __webpack_require__("../node_modules/squid/dist/core/event.js");

var _class = __webpack_require__("../node_modules/squid/dist/core/class.js");

var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");

var _promise = __webpack_require__("../node_modules/squid/dist/core/promise.js");

var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");

var _error = __webpack_require__("../node_modules/squid/dist/core/error.js");

var _loader = __webpack_require__("../node_modules/squid/dist/core/loader.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/*
 API
 ---

 This layer is responsible for handling api requests. It has a number of responsibilities:

 - Caching responses
 - Transparently returning data that has been preloaded into the initial page response
 - Instrumentation
 - Batching multiple api calls into a single http request
 - Handling multiple types of responses and dispatching to the correct handlers
 - Emitting loading events for all http calls
 */

_config.$meta.headers = _config.$meta.headers || {};
_config.$meta.headers['x-cookies'] = _typeof(_config.$meta.headers['x-cookies']) !== 'object' ? JSON.parse(_config.$meta.headers['x-cookies'] || '{}') : _config.$meta.headers['x-cookies'];

// Are we in 'cookies disabled' mode? (Do we need to keep a local store of cookies)
function cookiesEnabled() {
    return _util.$util.cookiesEnabled() && window.location.hostname.indexOf('.paypal.com') > -1;
}

// Cache for api responses, when cache: true
var cache = {};
var standardHeaders = {};

var latestCorrelationID = _config.$meta.correlationId;

// Window load promise
var windowLoad = _util.$util.memoize(function () {
    return _promise.$promise.resolver(function (resolve) {
        if (document.readyState === 'complete') {
            resolve();
        } else {
            window.addEventListener('load', resolve);
        }
    });
});

// Buffer for batch requests made within the same frame
var batchQueue = {};

// Backwards compat
window.pre = {};

// Transient cache resolvers
var transientCache = {};

// Transient cache resolvers
var transientCacheResolvers = {};

// Metabuilder
var metaBuilder = void 0;

// Add to transientCache
window.preload = function (method, url, data, name) {

    if (name) {
        window.pre[name] = {
            method: method,
            uri: url,
            res: data
        };
    }

    var key = method + ':' + url;
    var resolvers = transientCacheResolvers[key] || [];

    transientCache[key] = data;

    while (resolvers.length) {
        resolvers.pop().call();
    }
};

// Preload complete
var preloadComplete = false;

window.preloadComplete = function () {
    preloadComplete = true;
    Object.keys(transientCacheResolvers).forEach(function (key) {
        var resolvers = transientCacheResolvers[key] || [];

        while (resolvers.length) {
            resolvers.pop().call();
        }
    });
};

_logger.$logger.info(cookiesEnabled() ? 'cookies_enabled' : 'cookies_disabled');

var $Api = exports.$Api = _class.$Class.extend('$Api', {

    // Cache any GET responses indefinitely
    cache: false,

    // Http timeout for all requests
    timeout: 45000,

    // Default number of attempts on aborted requests and 500 server errors
    getAttempts: 3,
    postAttempts: 1,

    // POST on a resource with an action name myapi.action('foo') -> POST /my/api/foo
    action: function action(_action, options) {
        options.action = _action;
        return this.post(options);
    },

    // GET on a resource myapi.retrieve() -> GET /my/api
    retrieve: function retrieve(options) {
        options.method = 'get';
        return this.call(options);
    },

    // POST on a resource myapi.retrieve() -> POST /my/api
    post: function post(options) {
        options.method = 'post';
        return this.call(options);
    },

    // Generic handler for calling an api and dispatching requests to the right place
    call: function call(options) {
        var self = this;

        // Set up request options and params. `options` is an object which should contain everything
        // the request needs to run and handle the response

        options.api = this;
        options.uri = this.getURI(options.model, options.action);
        options.params = options.params || {};
        options.cache = options.cache || self.cache && options.method === 'get';
        options.name = this.buildAPIName(options);
        options.meta = this.buildMeta();
        options.transientError = options.transientError || false;
        options.cacheKey = _util.$util.buildURL(options.uri, options.params);

        _logger.$logger.info(options.name + '_call', {
            name: options.name,
            method: options.method,
            uri: options.uri
        });

        if (!options.silent) {
            _event.$event.emit('loading');
        }

        // Decide where to get the response
        return _promise.$promise.first([

        // If caching is enabled and we have the data in local cache, use the cache
        function () {
            if (options.cache && cache[options.cacheKey]) {
                return cache[options.cacheKey];
            }
        },

        // Otherwise if we have transient cache data for this api, we can use that
        function () {
            return _promise.$promise.providing(self.hasTransientCacheData(options), function () {

                // The reason we use self.attemptRequest here is so any errors in the cached response
                // can trigger the retry code path, as if it were a regular request
                return self.attemptRequest(options);
            });
        },

        // If we're in batch mode, queue up a batch request
        function () {
            if (options.batch) {
                return self.batchRequest(options);
            }
        },

        // Otherwise attempt a regular http request (at this point an http call is guaranteed)
        function () {
            return self.attemptRequest(options);
        }])['finally'](function () {

            if (!options.silent) {
                _event.$event.emit('loaded');
            }
        }).then(function (res) {

            // Cache the response if we need to
            if (options.cache) {
                cache[options.cacheKey] = res;
            }

            // Handle the response
            return self.handleResponse(res.data, options);
        }, function (err) {

            // $BatchShortCircuit will be thrown if:
            //
            // 1. batch api call B depends on api call A, but-
            // 2. api call A fails
            //
            // In which case we end up in a situation where had it been a regular chain of events,
            // api B would never have been called in the first place.
            //
            // One possibility here is to return $unresolved, which prevents the promise from ever
            // resolving, but this has the potential to cause a lot of difficulty debugging and strange
            // corner cases.
            //
            // Instead we opt to simply reject the promise, and not call any of the response handlers

            if (err instanceof _error.$BatchShortCircuit) {
                return _promise.$promise.reject(err);
            }

            // Otherwise, handle the error normally
            return self.handleErrorResponse(err, options);
        });
    },

    // Set up a batch request for processing in the next frame
    batchRequest: function batchRequest(options) {

        // Batch Requests are an optimization layer on top of regular api calls. The purpose of this
        // layer is to combine multiple atomic api calls into a single http request, without forcing
        // developers to create large orchestration layers on the client/server with cross-cutting concerns.
        //
        // This layer will queue up multiple requests made in the same frame whenever batch-mode is enabled,
        // attach them all to an http call to /api/batch/:name, then on the response it will dispatch each
        // individual api call to the correct handler.
        //
        // The way this is implemented is to place each response in the transient api cache, then to yield
        // control to the regular api request handler, which will handle instrumentation and retries

        // For quick dev-time feedback...
        _util.$util.assert(options.batch.name, 'Must define a "name" for batch request: ' + options.batch);
        _util.$util.assert(options.batch.id, 'Must define a "id" for batch request: ' + options.batch);

        var name = options.batch.name;
        var id = options.batch.id;

        // Add the batch request options to the batchQueue for processing on the next frame
        var batch = batchQueue[name] = batchQueue[name] || {};

        batch[id] = options;

        // Fire off a batch request. This will be debounced: calls in the same frame will be combined to one
        return this.buildBatchRequest(name).then(function (results) {

            // We get back a mapping of id->response, so we now extract the response for our api
            // call. If we have no response, we can assume the call was never made, and short circuit.
            return results[id].then(function (result) {
                return result || _promise.$promise.reject(new _error.$BatchShortCircuit());
            });
        });
    },

    // Process all of the accumulated batch api requests
    buildBatchRequest: _promise.$promise.debounce(function (name) {

        var self = this;
        var batch = batchQueue[name];
        var batchIds = _class.$Class.keys(batch);
        var batchData = {};
        var headers = {};

        delete batchQueue[name];

        // If we have just a single request, we can short-circuit and just hit that api

        if (batchIds.length === 1) {

            var batchId = batchIds[0];
            var opts = batch[batchId];

            var results = {};

            results[batchId] = opts.api.attemptRequest(opts);
            return results;
        }

        // Build the request to send to the server side. This is an mapping of id->request, each containing
        // the method, uri, data, and dependencies for each api.
        //
        // Specifying a dependency for an api essentially means the back-end will only
        // call api-B if api-A returns ack=success. Otherwise there will be no response for api B.

        _util.$util.forEach(batch, function (options, id) {

            batchData[id] = {
                method: options.method,
                uri: options.api.getURI(options.model, options.action, true),
                data: options.data,
                params: options.params,
                dependencies: options.batch.dependencies
            };

            _util.$util.extend(headers, options.headers);
        });

        // Unfortunate circular dependency... $Api depends on another api.
        //
        // $batchApi is subject to all of the same rules regarding retries, so if for some reason the server
        // does not respond the first time, our batch request can still get through.

        return $batchApi.action(name, { // eslint-disable-line no-use-before-define
            data: batchData,
            headers: headers
        }).then(function (res) {

            // The final response will be a mapping of id->response-promise.
            //
            // However, we do not treat this data as our final response. Instead, we simply use it to
            // prime our transient cache, then proceed to jump to our regular request handler. This will
            // take care of retries and instrumentation as if this were a regular request.
            //
            // Note that a retry for $batchApi is different to a retry for an individual api. If
            // an *individual* api call fails, we do not want to re-do the entire batch call; instead we
            // can just retry the individual api call.

            return self.handleBatchResponse(batch, res.data);
        });
    }),

    // Process the responses for all of the batch requests we sent to the server
    handleBatchResponse: function handleBatchResponse(batch, data) {

        var self = this;

        var promises = {};

        // Loop over each individual api response contained in the batch response, and process the result

        _util.$util.forEach(batch, function (options, id) {

            // Store each response promise so we can check and wait for api dependencies

            promises[id] = _promise.$promise.run(function () {

                // Check if all of the dependencies are present for our individual api call. To do this
                // we must wait until the dependent api call is entirely complete, including any retries.

                var depsPresent = _promise.$promise.every(options.batch.dependencies || [], function (depName) {

                    if (!batch[depName]) {
                        _logger.$logger.info('missing_batch_dependency', {
                            dependency: depName,
                            available: Object.keys(batch).join('|')
                        });
                    }

                    return !batch[depName] || promises[depName].then(function (dependency) {
                        return dependency && dependency.data && dependency.data.ack === 'success';
                    });
                });

                // If our dependencies are present, we can continue, otherwise we are not interested in
                // the result of the individual api call - if its dependency is not present, it will not be.

                return _promise.$promise.providing(depsPresent, function () {

                    // If there is data returned for the individual call, add it to the transient cache

                    return _promise.$promise.providing(data[id], function (result) {
                        var uri = options.api.getURI(options.model, options.action);

                        uri = _util.$util.buildURL(uri, options.params);

                        self.addTransientCacheData(options.method, uri, result);
                    }).then(function () {

                        // Regardless of whether or not there is data, we can now attempt the request.
                        // This will either get the data from the transient cache, or make an http call,
                        // and handle any retries that need to be made.

                        return options.api.attemptRequest(options);
                    });
                });
            });
        });

        return promises;
    },

    // Handle the request and any retries, using either the transient cache or http calls
    attemptRequest: function attemptRequest(options) {
        var self = this;

        var attempts = options.method === 'get' ? this.getAttempts : this.postAttempts;

        // We allow a certain number of attempts/retries for each api call
        return _promise.$promise.attempt(attempts, function (remaining) {

            // Query the transient cache
            return self.getTransientCacheResponse(options).then(function (res) {

                // If we can get a response from the transient cache, then use it
                if (res) {
                    return res;
                }

                // Otherwise resort to making an http call
                return self.getHttpResponse(options);
            })['catch'](function (res) {

                // If our request was aborted without even a status code, force a single retry
                if ((!res || !res.status) && attempts === 1) {

                    _logger.$logger.warn('api_retry_aborted', {
                        method: options.method,
                        uri: options.uri
                    });

                    return self.getHttpResponse(options);
                }

                return _promise.$promise.reject(res);
            })['catch'](function (res) {

                // If our request was 401 denied (probably due to a CSRF error), force a single retry
                if (res.status === 401) {

                    _logger.$logger.warn('api_retry_401', {
                        method: options.method,
                        uri: options.uri
                    });

                    return self.getHttpResponse(options);
                }

                return _promise.$promise.reject(res);
            })['catch'](function (res) {

                // Set the correct response and ack for 401
                if (res.status === 401) {
                    return {
                        data: {
                            ack: 'permission_denied'
                        }
                    };
                }

                // Setup to throw a TOO_MANY_REQUESTS contingency for 429 response from ratelimiter (velocityserv)
                if (res.status === 429) {
                    return {
                        data: {
                            ack: 'contingency',
                            contingency: 'TOO_MANY_REQUESTS'
                        }
                    };
                }

                // If we have any remaining retries, log and reject
                if (remaining) {

                    _logger.$logger.warn('api_retry', {
                        method: options.method,
                        uri: options.uri
                    });

                    return _promise.$promise.reject(res);
                }

                // Otherwise reject the request with the appropriate error

                // We got ack=error in the response
                if (res && res.data && res.data.ack === 'error') {
                    return _promise.$promise.reject(new _error.$ApiError('api_error', { // eslint-disable-line no-reserved-keys
                        name: options.name,
                        method: options.method,
                        uri: options.uri,
                        stack: res.data.stack,
                        transient: options.transientError
                    }));
                }

                // We got a response error status
                else if (res && res.status) {
                        return _promise.$promise.reject(new _error.$ApiError('response_status_' + res.status, { // eslint-disable-line no-reserved-keys
                            uri: options.uri,
                            transient: options.transientError
                        }));
                    } else if (res && res.error) {
                        return _promise.$promise.reject(new _error.$ApiError('request_' + res.error, { // eslint-disable-line no-reserved-keys
                            uri: options.uri,
                            transient: options.transientError
                        }));
                    }

                    // The request was aborted
                    else {
                            return _promise.$promise.reject(new _error.$ApiError('request_aborted', { // eslint-disable-line no-reserved-keys
                                uri: options.uri,
                                transient: options.transientError
                            }));
                        }
            });
        });
    },

    // Get an api response via http
    getHttpResponse: function getHttpResponse(options) {
        var self = this;

        var startTime = _util.$util.now();

        var request = this.http(options);

        return request['finally'](function () {

            // Calculate the end-to-end duration of the request from the client's perspective
            options.duration = _util.$util.now() - startTime;
        })['catch'](function (res) {

            // Turn responses with an ack into a 'success' so it makes it to the standard handlers
            if (res && res.status && res.data && res.data.ack && res.data.ack !== 'error') {
                return res;
            }

            return _promise.$promise.reject(res);
        }).then(function (res) {
            self.saveResponseState(res);

            var loggerPayload = {
                name: options.name,
                method: options.method,
                uri: options.uri,
                server: res.data.server,
                time: options.duration,
                duration: options.duration,
                corrid: res && res.headers('Paypal-Debug-Id')
            };

            // In certain browsers we can match up this api call to the performance data from the browser
            if (window.performance && window.performance.getEntries) {
                _util.$util.forEach(window.performance.getEntries(), function (resource) {
                    if (resource.name && resource.name.indexOf(options.uri) > -1) {
                        _util.$util.extend(loggerPayload, resource);
                    }
                });
            }

            _logger.$logger.info('api_response', loggerPayload);

            if (res && res.status) {
                _logger.$logger.info('http_response_' + res.status);
            }

            return res;
        }, function (res) {
            self.saveResponseState(res);

            if (res && res.status) {
                _logger.$logger.info('http_response_' + res.status, {
                    corrid: res.headers('Paypal-Debug-Id'),
                    referenceId: res.headers('X-Reference-Header') || undefined // To not serialize this data if not present
                });
            }

            return _promise.$promise.reject(res);
        });
    },

    setTransientCache: function setTransientCache(data) {
        throw new Error('NotImplemented');
    },

    // Get an individual api response from the transient cache, as an object
    getTransientCacheData: function getTransientCacheData(options, pop) {

        if (!_config.$config.enablePreload) {
            return _promise.$promise.resolve();
        }

        var preMethod = options.method.toLowerCase();
        var preUri = _util.$util.buildURL(options.uri, options.params);

        var key = preMethod + ':' + preUri;

        return _promise.$promise.resolver(function (resolve) {

            function res() {
                var data = transientCache[key];

                if (pop) {
                    delete transientCache[key];
                }
                resolve(data);
            }

            if (transientCache[key] || document.readyState === 'complete' || preloadComplete) {
                return res();
            }

            transientCacheResolvers[key] = transientCacheResolvers[key] || [];
            transientCacheResolvers[key].push(res);

            windowLoad().then(res);
        });
    },

    // Check if the transient cache has the data for a particular api
    hasTransientCacheData: function hasTransientCacheData(options) {
        return this.getTransientCacheData(options, false).then(function (data) {
            return Boolean(data);
        });
    },

    // Add data to the transient cache
    addTransientCacheData: function addTransientCacheData(method, uri, data) {
        var key = method + ':' + uri;

        transientCache[key] = data;
    },

    // Get an individual api response from transient cache, as a res promise with the correct status code
    getTransientCacheResponse: function getTransientCacheResponse(options) {

        return this.getTransientCacheData(options, true).then(function (data) {

            // Preload data does not come with a response code, so massage it into a response promise
            if (data) {
                if (data.ack === 'error') {
                    return _promise.$promise.reject({
                        status: 500,
                        data: data
                    });
                } else if (data.ack === 'permission_denied') {
                    return _promise.$promise.reject({
                        status: 401,
                        data: data
                    });
                } else if (data.ack === 'contingency' || data.ack === 'validation_error') {
                    return {
                        status: 400,
                        data: data
                    };
                } else {
                    return {
                        status: 200,
                        data: data
                    };
                }
            }

            // Log a cache miss if we are currently in the first-page load
            else if (options.method === 'get' && !_loader.$loader.firstLoad() && !options.silent) {
                    _logger.$logger.info('preload_cache_miss', {
                        uri: options.uri
                    });
                }
        });
    },

    getHeaders: function getHeaders(options) {

        if (!_config.$meta.headers['x-csrf-jwt'] && !_config.$meta.csrfJwt) {
            _logger.$logger.warn('missing_csrf_jwt');
        }

        var headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'x-csrf-jwt': _config.$meta.headers['x-csrf-jwt'] || _config.$meta.csrfJwt
        };

        _util.$util.extend(headers, standardHeaders);

        if (!cookiesEnabled()) {
            headers['x-cookies'] = JSON.stringify(_config.$meta.headers['x-cookies']);
        }

        if (options.headers) {
            _util.$util.extend(headers, options.headers);
        }

        return headers;
    },
    http: function http(options) {
        return this.httpJQuery(options);
    },


    /*
     // Raw http call
    httpAngular: function(options) {
         let request = {
            method: options.method,
            url: options.uri,
            data: {
                data: options.data,
                meta: options.meta
            },
            headers: this.getHeaders(options),
            params: options.params,
            requestType: 'json',
            responseType: 'json',
            timeout: this.timeout
        };
         if (options.method === 'get' && options.meta && Object.keys(options.meta).length) {
            request.params.meta = JSON.stringify(options.meta);
        }
         return $http(request);
    },
     */

    httpJQuery: function httpJQuery(options) {

        var request = {
            method: options.method,
            data: options.method === 'get' ? options.params : JSON.stringify({
                data: options.data,
                meta: options.meta || {}
            }),
            headers: this.getHeaders(options),
            timeout: this.timeout
        };

        if (options.method === 'post') {
            request.headers['Content-Type'] = 'application/json;charset=UTF-8';
        } else if (options.method === 'get') {
            request.data.meta = JSON.stringify(options.meta);
        }

        return _promise.$promise.resolver(function (resolve, reject) {

            function getRes(res, data) {
                return {
                    status: res.status,
                    data: data,
                    headers: function headers(name) {
                        return res.getResponseHeader(name);
                    }
                };
            }

            request.success = function (data, status, res) {
                return resolve(getRes(res, data));
            };

            request.error = function (res) {
                if (res && res.status) {
                    if (res.status >= 400) {
                        return reject(getRes(res, res.responseJSON));
                    } else {
                        return resolve(getRes(res, res.responseJSON));
                    }
                }

                return reject({
                    status: 0,
                    headers: _util.$util.noop,
                    error: res && res.statusText
                });
            };

            _jquery2['default'].ajax(options.uri, request);
        });
    },

    // Save cookies and jwt-csrf token from the response
    saveResponseState: function saveResponseState(res) {

        if (res.headers('x-csrf-jwt')) {
            _config.$meta.headers['x-csrf-jwt'] = res.headers('x-csrf-jwt');
            _config.$meta.csrfJwt = res.headers('x-csrf-jwt');
            _config.$meta.headers['x-csrf-jwt-hash'] = res.headers('x-csrf-jwt-hash');
        }

        if (res.headers('X-cookies')) {

            _config.$meta.headers['x-cookies-hash'] = res.headers('x-cookies-hash');

            // Extend local cookie jar of encrypted-cookie-name->encrypted-cookie-value with any new cookies
            _util.$util.extend(_config.$meta.headers['x-cookies'], JSON.parse(res.headers('X-cookies') || '{}'));
        }

        latestCorrelationID = res.headers('Paypal-Debug-Id') || latestCorrelationID;
    },

    // Dispatch the response to the correct handlers
    handleResponse: function handleResponse(res, options) {
        var loggerName = 'ui_' + options.name;

        var loggerPayload = {
            name: options.name,
            method: options.method,
            uri: options.uri,
            time: options.duration,
            duration: options.duration
        };

        // Here we dispatch the response to the correct handler based on the ack.
        //
        // ack=success     -> options.success()
        // ack=error       -> options.error()
        // ack=validation  -> options.validation()
        // ack=contingency -> options.contingencies[contingency]()
        //
        // Why do this rather than just rejecting the promise with a custom error?
        //
        // a) Angular promises have no `.catchType()`, so this saves us a lot of `instanceof` checks
        // b) Angular promises have no `.done()`, so callers can not assert that they have handled
        //    every error they want to. This is exacerbated by the fact that there is no single thread
        //    of execution on the front-end a la node, so we can't just call `.done()` at the very end :(
        //
        // This way, if somebody passes a handler, it will be called. Otherwise, an error will be thrown
        // and the global error handler will be invoked. The api responses are also given as promises.

        var resultModel = options.resultModel || options.model;

        /* jshint maxcomplexity: 17 */
        return _promise.$promise.call(function () {

            // If we are given a `resultModel`, we always extend it with `res.data`, no matter the ack

            if (res.data && resultModel) {

                if (resultModel.populate) {
                    resultModel.populate(res.data);
                } else {
                    _util.$util.extend(resultModel, res.data);
                }
            }

            if (res && res.ack === 'success' && resultModel && resultModel.fetchChildren) {
                return _promise.$promise.resolve(resultModel.fetchChildren()).then(function (children) {
                    return _util.$util.extend(resultModel, children);
                });
            }
        }).then(function () {
            // eslint-disable-line max-statements

            // Handle each ack type, throw errors accordingly

            if (res.ack === 'success') {
                _logger.$logger.info(loggerName + '_success', loggerPayload);

                if (options.success) {
                    if (options.success instanceof Function) {
                        return options.success(res.data);
                    }
                    return options.success;
                }

                return res;
            }

            if (options.failSilently) {
                return;
            }

            if (res.ack === 'contingency') {
                _logger.$logger.info(loggerName + '_contingency', _util.$util.extend(loggerPayload, {
                    contingency: res.contingency
                }));

                if (!res.contingency) {
                    throw new _error.$ApiError('expected_contingency_name', {
                        api: options.name
                    });
                }

                var contingency = new _error.$Contingency(res.contingency, { // eslint-disable-line no-reserved-keys
                    transient: options.transientError
                });

                if (resultModel) {
                    resultModel.errorData = res.errorData || {};
                }

                var handler = options.contingencies && (options.contingencies[contingency.message] || options.contingencies['DEFAULT']);

                _util.$util.extend(contingency, res.errorData);

                if (handler) {
                    if (handler instanceof Function) {
                        return handler(contingency.message, contingency);
                    }
                    return handler;
                }

                throw contingency;
            } else if (res.ack === 'validation') {
                _logger.$logger.info(loggerName + '_validation', _util.$util.extend(loggerPayload, {
                    validation: res.validation
                }));

                if (options.validation) {
                    return options.validation(res.validation);
                }

                throw new _error.$ApiError('validation', { // eslint-disable-line no-reserved-keys
                    transient: options.transientError
                });
            } else if (res.ack === 'permission_denied') {
                _logger.$logger.info(loggerName + '_denied', loggerPayload);

                var properties = {
                    transient: options.transientError
                };

                if (res.reason) {
                    properties.reason = res.reason;
                }

                throw new _error.$Forbidden(options.uri + ': forbidden', properties);
            } else {
                _logger.$logger.info(loggerName + '_noack', loggerPayload);

                throw new _error.$ApiError('noack', { // eslint-disable-line no-reserved-keys
                    transient: options.transientError
                });
            }
        });
    },

    // Handle http error responses (ack=error or unhandled errors)
    handleErrorResponse: function handleErrorResponse(err, options) {

        return _promise.$promise.run(function () {

            // If the caller provides an error handler, let them handle it
            if (options.error) {
                return options.error(err);
            }

            // Otherwise we throw the error. Please not that this is NOT just rejecting the promise,
            // this will always end up in the global error handler due to how angular promises work.
            throw err;
        });
    },

    // Build the uri for the api call
    getURI: function getURI(model, action, relative) {
        var self = this;

        // build the uri as a seriest of segments
        var uri = [];

        uri.push(this.uri.replace(/\/:[\w\.]+\?/g, function (key) {

            // Add any *optional* dynamic keys from the model (/foo/:bar? -> /foo/{{model.bar}})

            key = key.slice(2);
            key = key.substring(0, key.length - 1);

            var component = model.get ? model.get(key) : model[key];

            if (!component) {
                return '';
            }

            return '/' + component;
        }).replace(/:[\w\.]+/g, function (key) {

            // Add any dynamic keys from the model (/foo/:bar -> /foo/{{model.bar}})

            key = key.slice(1);

            var component = model.get ? model.get(key) : model[key];

            if (!component) {
                throw new Error('Property "' + key + '" not found in model for: ' + self.uri);
            }

            return component;
        }));

        // Add the action, if provided (`foo.action('bar', {...})` -> /api/foo/bar
        if (action) {
            uri.push(action);
        }

        // Add the extension (e.g. for doing a GET on a .json resource)
        if (this.ext) {
            uri[uri.length - 1] += '.' + this.ext;
        }

        // Join the uri segments and strip any extra slashes
        uri = '/' + uri.join('/').replace(/\/{2,}/g, '/').replace(/^\//, '');

        // Add on the base uri, e.g. /webapps/hermes
        if (!relative) {
            uri = (this.baseURI || _config.$config.urls.baseUrl) + uri;
        }

        return uri;
    },

    // Attach meta data provided by the parent app
    buildMeta: function buildMeta() {
        if (metaBuilder) {
            return metaBuilder();
        }
    },

    // Build the name of the api for logging. /api/foo/bar -> api_foo_bar
    buildAPIName: function buildAPIName(options) {
        var self = this;
        var apiName = self.uri.replace(/^\/+/, ''). // Remove leading '/'
        replace(/\//g, '_'). // Replace remaining '/' with '_'
        replace(/\?(.*)/, ''). // Remove everything after '?'
        replace(/[^a-zA-Z0-9_]/g, '');

        apiName = options.action ? apiName + '_' + options.action : apiName;
        apiName = apiName.charAt(0) === '_' ? apiName.slice(1) : apiName;
        return apiName;
    }
});

$Api.reopenClass({
    clearCache: function clearCache() {
        cache = {};
    }
});

$Api.registerMetaBuilder = function (builder) {
    metaBuilder = builder;
};

$Api.addHeader = function (name, value) {
    standardHeaders[name] = value;
};

var $batchApi = new $Api({
    uri: '/api/batch',
    postAttempts: 3
});

function $getLatestCorrelationID() {
    return latestCorrelationID;
}

angular.value("$Api", $Api);
angular.value("$getLatestCorrelationID", $getLatestCorrelationID);
_logger.$logger;

_event.$event;

_class.$Class;

_util.$util;

_promise.$promise;

_config.$config;

_config.$meta;

_error.$Contingency;

_error.$Forbidden;

_error.$ApiError;

_error.$BatchShortCircuit;

_loader.$loader;

/***/ }),

/***/ "../node_modules/squid/dist/core/class.js":
/***/ (function(module, exports) {



exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
 Class
 -----

 A class pattern, adding sugar on top of javascript prototypes

 ### Basic Usage

 let MyClass = Class.extend({
 foo: 'bar';
 });

 myInstance = new MyClass({
 hello: 'world'
 });

 console.log(myInstance.foo, myInstance.hello)

 In this example, `foo` becomes a property on `MyClass`'s prototype,
 and `hello` becomes a property on `myInstance`.

 ### Default Object Methods

 - `init()`: Called after the object is first instantiated, with all properties available

 - `get(<path>, <default>)`: Get an object an arbitrary number of levels deep, or return a default

 e.g. `myInstance.get('foo.bar.baz', 'some_default');`

 Default return value is undefined

 - `set(<path>, <value>)`: Set an object an arbitrary number of levels deep

 e.g. `myInstance.set('foo.bar.baz', 'some_value');`

 Error is thrown if no object is found to set the value on

 - `setProperties(<object>)`: Set all the properties from an object onto your object

 e.g. `myInstance.setProperties({foo: 'bar', hello: 'world'})`

 Can not be used with nested properties

 - `forEach(<callback>)`: Loop through the object and call callback(<key>, <value>) for each key/val pair

 */

// Object Create
// -------------
//
// Shim for Object.create, if it is not supported by our browser
//
// let myPrototype = {foo: 'bar'}
// let myObject = create(myPrototype)

// Create an empty anonymous constructor with no side effects, for re-use later
var EmptyConstructor = function EmptyConstructor() {}; // eslint-disable-line no-empty-function

var create = Object.create || function create(obj) {

    // Set a temporary prototype
    EmptyConstructor.prototype = obj;

    // Create an object using our temporary constructor/prototype
    var instance = new EmptyConstructor();

    // Reset the prototype for next time
    EmptyConstructor.prototype = null;

    // Return our new object, created without side effects
    return instance;
};

function _extend(obj, source) {

    if (!source) {
        return obj;
    }

    for (var key in source) {
        if (source.hasOwnProperty(key)) {
            obj[key] = source[key];
        }
    }

    return obj;
}

// Is Object
// ---------
//
// Check of a let is an object or not
//
// isobject({}) -> true
// isobject('foo') -> false

function isobject(obj) {
    return obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj instanceof Object;
}

// Transpose properties
// -------------------------------------------------------------------
//
// Transpose properties from a list of objects onto a recipient object
//
// let recipient = {};
// transpose(recipient, [{a: 1, b: 2}, {c: 3}])
// recipient -> {a: 1, b: 2, c:3}

function transpose(recipient, args) {

    // Loop through all args
    for (var i = 0; i < args.length; i++) {
        var ob = args[i];

        // Ignore anything that is not an object
        if (!isobject(ob)) {
            continue;
        }

        // Loop through all keys in our object
        for (var key in ob) {

            // Ignore any prototypal properties
            if (!ob.hasOwnProperty(key)) {
                continue;
            }

            var item = ob[key];

            // Give the function a name
            if (item instanceof Function) {
                item.__name__ = key;
            }

            recipient[key] = item;
        }
    }
}

// Construct a Class
// -----------------
//
// This is the primary constructor for all $Class objects

function construct() {
    // eslint-disable-line no-unused-vars

    // Call any custom constructor;
    if (this.construct) {
        var ob = this.construct.apply(this, arguments);

        // If we get a new object back, return that to the user
        if (isobject(ob)) {
            return ob;
        }
    }

    // Load any provided properties directly onto the object
    transpose(this, arguments);

    // Initialize the object
    if (this.init) {
        this.init();
    }
}

// Reopen an object
// ----------------
//
// Add properties to the constructor's prototype
//
//     let Animal = $Class.extend();
//
//     Animal.reopen({
//       type: 'animal',
//     });
//
//     let cat = new Animal;
//     console.log(cat.type);
function reopen() {

    // Add some more properies to our prototype
    transpose(this.prototype, arguments);

    return this;
}

// Reopen a class
// --------------
//
// Add properties to the constructor. These will propogate through future extends
//
//     let Animal = $Class.extend();
//
//     Animal.reopenClass({
//       fromCache: function(id) {
//         return cache[id] || new this({id: id});
//       }
//     }
//
//     let cat = Animal.fromCache('cat_54');

function reopenClass() {

    // Add some more properies to our class
    transpose(this, arguments);

    // Add to __classmethods__
    transpose(this.__classmethods__, arguments);

    return this;
}

function isChild(Cls) {
    return Cls && Cls.prototype instanceof this;
}

// Generate a new class
// --------------------
//
// Generate a new constructor, with the specified name, and attach all static and prototypal methods

var id = 0;

function extend(name) {
    // eslint-disable-line max-statements
    var Cls = void 0;
    var className = void 0;
    var args = void 0;
    var argsLength = void 0;
    var startIndex = void 0;

    // Accept an optional class name
    if (typeof name === 'string') {

        // Guard against javascript injection
        if (!name.match(/^[\w$][\w\d]*$/)) {
            throw new Error('Class name can not include special characters: ' + name);
        }

        // Use the provided name and slice out the first argument
        className = name;
        argsLength = arguments.length && arguments.length - 1;
        startIndex = 1;
    } else {

        // Otherwise default to the parent name, or 'Object' if generating our first class
        className = this.name || 'Object';
        argsLength = arguments.length;
        startIndex = 0;
    }

    args = new Array(argsLength);
    for (var i = startIndex; i < arguments.length; i++) {
        args[i - startIndex] = arguments[i];
    }

    // Dynamically create our constructor with a custom name
    eval('Cls = function ' + className + '() { return construct.apply(this, arguments) }'); // eslint-disable-line no-eval

    // Store the class name for future reference
    Cls.__name__ = className;

    // Set up a classmethods object. These will be inherited through subsequent extend() calls
    Cls.__classmethods__ = {
        extend: extend,
        reopen: reopen,
        reopenClass: reopenClass,
        isChild: isChild
    };

    id += 1;
    Cls.id = id;

    // If we're being called on an existing class, e.g. Class.extend(), we should inherit from that class
    if (this && this !== window) {

        // Inherit everything from superclass prototype
        Cls.prototype = create(this.prototype);

        // Re-set the constructor, which is overwritten by create
        Cls.prototype.constructor = Cls;

        // Add a reference to the superclass prototype for super method calls
        Cls.prototype._super = this.prototype;

        // Inherit any class methods from the superclass
        _extend(Cls.__classmethods__, this.__classmethods__);
    }

    // Add the class methods to our existing class
    _extend(Cls, Cls.__classmethods__);

    // Load any provided properties onto the constructor's prototype
    transpose(Cls.prototype, args);

    // Temporary: allow access from console/debugger
    if (className.indexOf('$') === 0) {
        window[className] = Cls;
    } else {
        window['$' + className] = Cls;
    }

    return Cls;
}

// Multi-layer get
// ---------------
//
// Recursively gets a deep path from an object, returning a default value if any level is not found
//
// let obj = {bar: {baz: 1}}
// get(obj, 'bar.baz', 'default') -> 1
// get(obj, 'aaa.bbb', 'default') -> default

function _get(item, path, def) {

    if (!path) {
        return def;
    }

    path = path.split('.');

    // Loop through each section of our key path
    for (var i = 0; i < path.length; i++) {

        // If we have an object, we can get the key
        if (isobject(item)) {
            item = item[path[i]];
            // Otherwise, we should return the default (undefined if not provided)
        } else {
            return def;
        }
    }

    // If our final result is undefined, we should return the default
    return item === undefined ? def : item;
}

// Multi-layer set
// ---------------
//
// Recursively sets a deep path from an object
//
// let obj = {bar: {baz: 1}}
// set(obj, 'bar.baz', 2)
// obj.bar.baz -> 1

function _set(item, path, value) {
    path = path.split('.');

    // Loop through each section of our key path except the last
    for (var i = 0; i < path.length - 1; i++) {

        // Get the next item down
        item = item[path[i]];

        // If we have an object, we're good
        if (isobject(item)) {
            continue;
            // Otherwise, there's nothing to set our key on
        } else {
            throw new Error(path[i - 1] + '.' + path[i] + ' is not an object');
        }
    }

    // Do the set on the retrieved object with our value
    item[path[path.length - 1]] = value;
}

// Loop through object
// -------------------
//
// Loop an object and apply a function for each key/value
//
// let ob = {a: 1, b: 2, c: 3}
// each(ob, console.log) -> a 1  b 2  c 3

function each(ob, callback) {
    for (var key in ob) {
        if (ob.hasOwnProperty(key)) {
            callback.call(ob, key, ob[key]);
        }
    }
}

// Gey keys of object
// ------------------
//
// Shim for Object.keys if it does not already exist
//
// let ob = {a: 1, b: 2, c: 3}
// keys(ob) -> ['a', 'b', 'c']

function _keys(ob) {

    if (Object.keys) {
        return Object.keys(ob);
    }

    var result = [];

    for (var key in ob) {
        if (ob.hasOwnProperty(key)) {
            result.push(key);
        }
    }

    return result;
}

// Create a base class that can be inherited from
// ----------------------------------------------
//
// This is the public interface to the Class module.
// All classes with extend from Class and be provided with a set of base convenience methods.

var $Class = exports.$Class = extend('Class', {

    init: function init() {
        // Empty init class, so calls to _super can be safely made
    },

    get: function get(path, def) {
        return _get(this, path, def);
    },

    set: function set(path, value) {
        _set(this, path, value);
    },

    setProperties: function setProperties() {
        transpose(this, arguments);
    },

    forEach: function forEach(callback) {
        each(this, callback);
    },

    keys: function keys() {
        return _keys(this);
    }
});

$Class.get = _get;
$Class.set = _set;
$Class.keys = _keys;

angular.value("$Class", $Class);

/***/ }),

/***/ "../node_modules/squid/dist/core/config.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var $meta = exports.$meta = window.meta || {};
var $cookies = exports.$cookies = window.cookies || {};
var $config = exports.$config = window.config || {};
angular.value("$meta", $meta);
angular.value("$cookies", $cookies);
angular.value("$config", $config);

/***/ }),

/***/ "../node_modules/squid/dist/core/dom.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$dom = undefined;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _promise = __webpack_require__("../node_modules/squid/dist/core/promise.js");

var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");

var $dom = exports.$dom = {

    elementReady: function elementReady(id) {

        return _promise.$promise.resolver(function (resolve, reject) {

            if (document.getElementById(id)) {
                return resolve();
            }

            var interval = setInterval(function () {
                if (document.getElementById(id)) {
                    clearInterval(interval);
                    return resolve();
                }
            }, 10);

            setTimeout(60000, reject);
        });
    },

    loadScript: function loadScript(name, src, timeout) {
        var attributes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

        return _promise.$promise.resolver(function (resolve, reject) {
            var script = document.createElement('script');
            var loadTimeout = void 0;

            function clearScriptLoadTimeout() {
                if (loadTimeout) {
                    clearTimeout(loadTimeout);
                    loadTimeout = undefined;
                }
            }

            script.onload = function () {
                clearScriptLoadTimeout();
                setTimeout(resolve, 10);
            };

            // For Internet explorer 8 support
            script.onreadystatechange = function () {
                if (this.readyState === 'complete' || this.readyState === 'loaded') {
                    clearScriptLoadTimeout();
                    setTimeout(resolve, 10);
                }
            };

            script.onerror = function (event) {
                _logger.$logger.info('script_error', {
                    script: src
                });
                return reject(new Error(name + '_loading_error'));
            };

            if (timeout) {
                loadTimeout = setTimeout(function () {
                    _logger.$logger.info('script_load_timedout', {
                        script: src
                    });
                    return reject(new Error(name + '_loading_timed_out'));
                }, timeout);
            }

            script.setAttribute('src', src);

            for (var _iterator = Object.keys(attributes), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }

                var attribute = _ref;

                script.setAttribute(attribute, attributes[attribute]);
            }

            document.body.appendChild(script);
        });
    },

    cssReady: function cssReady(id) {

        var el = document.getElementById(id);

        return _promise.$promise.resolver(function (resolve, reject) {

            var timeout = void 0;
            var interval = void 0;

            function check() {
                _util.$util.forEach(document.styleSheets, function (stylesheet) {
                    if (stylesheet.href === el.href) {
                        clearInterval(interval);
                        clearTimeout(timeout);
                        resolve();
                    }
                });
            }

            timeout = setTimeout(function () {
                clearInterval(interval);
                reject();
                throw new Error('css_loading_timed_out');
            }, 30000);

            interval = setInterval(check, 20);
            check();
        });
    }
};

angular.value("$dom", $dom);
_logger.$logger;

_promise.$promise;

_util.$util;

/***/ }),

/***/ "../node_modules/squid/dist/core/error.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$BatchShortCircuit = exports.$ShortCircuit = exports.$FallbackError = exports.$ApiError = exports.$Forbidden = exports.$Contingency = exports.$Error = undefined;

var _event = __webpack_require__("../node_modules/squid/dist/core/event.js");

var _class = __webpack_require__("../node_modules/squid/dist/core/class.js");

var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");

_util.$util.monkeyPatch(window, 'onerror', function (_ref, original) {
    var message = _ref[0],
        file = _ref[1],
        line = _ref[2],
        col = _ref[3],
        err = _ref[4];


    original();

    _event.$event.emit('$windowError', {
        message: message && (message.stack || message).toString(),
        file: file && file.toString(),
        line: line && line.toString(),
        col: col && col.toString(),
        stack: err && (err.stack || err).toString()
    });
});

var $Error = exports.$Error = _class.$Class.extend.call(Error, '$Error', {

    construct: function construct(err, properties) {

        if (err instanceof Error) {
            err = err.message;
        }

        if (properties) {
            _util.$util.extend(this, properties);
        }

        this.payload = properties;

        this.message = err;
    }
});

var $Contingency = exports.$Contingency = $Error.extend('$Contingency', {
    handle: function handle(handlers) {
        var handler = handlers[this.message] || handlers['DEFAULT'];

        if (handler) {
            var result = handler.call(this, this.message, this);

            if (typeof result !== 'undefined') {
                return result;
            }
            return true;
        }
    }
});

var $Forbidden = exports.$Forbidden = $Error.extend('$Forbidden');

var $ApiError = exports.$ApiError = $Error.extend('$ApiError');

var $FallbackError = exports.$FallbackError = $Error.extend('$FallbackError', {
    init: function init() {
        this.reason = this.reason || '';
        this.product = this.product || '';
        this.entryPoint = this.entryPoint || '';
    }
});

/**
 * $ShortCircuit should be thrown if you want to bypass the remainder of a promise chain, and you've already
 * done error handling for the rejection. It should be handled with a no-op in app's $exceptionHandler
 */
var $ShortCircuit = exports.$ShortCircuit = $Error.extend('$ShortCircuit');

// TO-BE-DEPRECATED: Use $ShortCircuit instead
var $BatchShortCircuit = exports.$BatchShortCircuit = $ShortCircuit;

angular.value("$Error", $Error);
angular.value("$Contingency", $Contingency);
angular.value("$Forbidden", $Forbidden);
angular.value("$ApiError", $ApiError);
angular.value("$FallbackError", $FallbackError);
angular.value("$ShortCircuit", $ShortCircuit);
angular.value("$BatchShortCircuit", $BatchShortCircuit);
_event.$event;

_class.$Class;

_util.$util;

/***/ }),

/***/ "../node_modules/squid/dist/core/event.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$event = undefined;

var _promise = __webpack_require__("../node_modules/squid/dist/core/promise.js");

var handlers = {};

var customEventEmitter = void 0;

var $event = exports.$event = {
    use: function use(eventEmitter) {
        customEventEmitter = eventEmitter;

        for (var _iterator = Object.keys(handlers), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var eventName = _ref;

            if (handlers[eventName]) {
                for (var _iterator2 = handlers[eventName], _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
                    var _ref2;

                    if (_isArray2) {
                        if (_i2 >= _iterator2.length) break;
                        _ref2 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) break;
                        _ref2 = _i2.value;
                    }

                    var handler = _ref2;

                    customEventEmitter.on(eventName, handler);
                }
            }
        }
    },
    on: function on(eventName, method) {

        if (customEventEmitter) {
            return customEventEmitter.on(eventName, method);
        }

        handlers[eventName] = handlers[eventName] || [];
        handlers[eventName].push(method);

        var cancelled = false;

        function cancel() {
            if (!cancelled) {
                handlers[eventName].splice(handlers[eventName].indexOf(method), 1);
                cancelled = true;
            }
        }

        cancel.cancel = cancel;
        return cancel;
    },
    once: function once(eventName, method) {

        if (customEventEmitter) {
            return customEventEmitter.once(eventName, method);
        }

        var listener = $event.on(eventName, function () {
            listener.cancel();
            return method.apply(this, arguments);
        });

        return listener;
    },
    emit: function emit(eventName) {
        if (customEventEmitter) {
            var _customEventEmitter;

            return (_customEventEmitter = customEventEmitter).emit.apply(_customEventEmitter, arguments);
        }

        var event = {
            preventDefault: function preventDefault() {
                event.defaultPrevented = true;
            }
        };

        if (handlers[eventName]) {
            for (var _iterator3 = Array.prototype.slice.apply(handlers[eventName]), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
                var _ref3;

                if (_isArray3) {
                    if (_i3 >= _iterator3.length) break;
                    _ref3 = _iterator3[_i3++];
                } else {
                    _i3 = _iterator3.next();
                    if (_i3.done) break;
                    _ref3 = _i3.value;
                }

                var handler = _ref3;

                handler.apply(this, [event].concat(Array.prototype.slice.call(arguments)));
            }
        }

        return event;
    },
    broadcast: function broadcast(eventName) {

        if (customEventEmitter) {
            var _customEventEmitter2;

            return (_customEventEmitter2 = customEventEmitter).broadcast.apply(_customEventEmitter2, arguments);
        }

        return $event.emit.apply($event, arguments);
    },


    refCount: function refCount($scope, start, stop) {
        return _promise.$promise.resolver(function (resolve) {

            var count = 0;

            var cancelStartListener = $scope.$on(start, function (event, data) {
                count += 1;
            });

            var cancelStopListener = $scope.$on(stop, function (event, data) {
                setTimeout(function () {
                    count -= 1;
                    res(); // eslint-disable-line no-use-before-define
                }, 50);
            });

            function res() {
                if (!count) {

                    if (cancelStartListener && cancelStopListener) {
                        cancelStartListener();
                        cancelStopListener();
                    }

                    return resolve();
                }
            }

            setTimeout(res, 50);
        });
    },

    compose: function compose(start, end, startAll, endAll) {
        var debounce = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;


        var count = 0;
        var active = false;

        $event.on(start, function () {
            if (!count) {
                setTimeout(function () {
                    if (count && !active) {
                        active = true;
                        $event.emit(startAll);
                    }
                }, debounce);
            }

            count += 1;
        });

        $event.on(end, function () {

            setTimeout(function () {
                count -= 1;

                if (!count && active) {
                    active = false;
                    $event.emit(endAll);
                }
            }, 0);
        });

        return {
            getCount: function getCount() {
                return count;
            },
            isActive: function isActive() {
                return Boolean(count);
            },
            reset: function reset() {
                count = 0;
            }
        };
    }
};

angular.value("$event", $event);
_promise.$promise;

/***/ }),

/***/ "../node_modules/squid/dist/core/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _api = __webpack_require__("../node_modules/squid/dist/core/api.js");

Object.keys(_api).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _api[key];
    }
  });
});

var _class = __webpack_require__("../node_modules/squid/dist/core/class.js");

Object.keys(_class).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _class[key];
    }
  });
});

var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");

Object.keys(_config).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _config[key];
    }
  });
});

var _error = __webpack_require__("../node_modules/squid/dist/core/error.js");

Object.keys(_error).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _error[key];
    }
  });
});

var _event = __webpack_require__("../node_modules/squid/dist/core/event.js");

Object.keys(_event).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _event[key];
    }
  });
});

var _integration = __webpack_require__("../node_modules/squid/dist/core/integration.js");

Object.keys(_integration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _integration[key];
    }
  });
});

var _model = __webpack_require__("../node_modules/squid/dist/core/model.js");

Object.keys(_model).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _model[key];
    }
  });
});

var _promise = __webpack_require__("../node_modules/squid/dist/core/promise.js");

Object.keys(_promise).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _promise[key];
    }
  });
});

var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");

Object.keys(_util).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _util[key];
    }
  });
});

var _loader = __webpack_require__("../node_modules/squid/dist/core/loader.js");

Object.keys(_loader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _loader[key];
    }
  });
});

var _dom = __webpack_require__("../node_modules/squid/dist/core/dom.js");

Object.keys(_dom).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _dom[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/squid/dist/core/integration.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$integration = exports.$CONTEXT = exports.$DEFAULT = undefined;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var $DEFAULT = exports.$DEFAULT = 'DEFAULT';

var $CONTEXT = exports.$CONTEXT = {

    // Full page checkout
    FULLPAGE: 'FULLPAGE',

    // Checkout in popup
    POPUP: 'POPUP',

    // Checkout in lightbox (iframe)
    LIGHTBOX: 'LIGHTBOX',

    // Web view
    WEBVIEW: 'WEBVIEW',

    // Native checkout
    NATIVE_CHECKOUT: 'NATIVE_CHECKOUT'
};

var $integration = exports.$integration = {

    flow: $DEFAULT,

    init: function init(flow, config) {
        this.config = config || {};

        if (flow) {
            this.setFlow(flow);
        }

        this.setContext(this.getContext());
    },
    getContext: function getContext() {

        if (this.isIFrame()) {
            return $CONTEXT.LIGHTBOX;
        } else if (this.isPopup()) {
            return $CONTEXT.POPUP;
        } else {
            return $CONTEXT.FULLPAGE;
        }
    },
    isPopup: function isPopup() {
        return Boolean(window.opener);
    },
    isIFrame: function isIFrame() {
        return window.top !== window.self;
    },
    setContext: function setContext(context) {
        _logger.$logger.info('integration_context_' + context);
        this.context = context;
    },
    setFlow: function setFlow(flow) {
        _logger.$logger.info('integration_flow_' + flow);
        this.flow = flow;
    },
    is: function is(context, flow) {
        return this.isContext(context) && this.isFlow(flow);
    },
    isContext: function isContext(context) {
        return this.context === context;
    },
    isFlow: function isFlow(flow) {
        return this.flow === flow;
    },
    getConfig: function getConfig(key) {

        this.context = this.getContext();

        if (!this.config) {
            return;
        }

        if (this.config.hasOwnProperty(this.context) && this.config[this.context].hasOwnProperty(this.flow) && this.config[this.context][this.flow].hasOwnProperty(key)) {

            return this.config[this.context][this.flow][key];
        }

        if (this.config.hasOwnProperty(this.context) && this.config[this.context].hasOwnProperty(key)) {

            return this.config[this.context][key];
        }

        if (this.config.hasOwnProperty($DEFAULT) && this.config[$DEFAULT].hasOwnProperty(this.flow) && this.config[$DEFAULT][this.flow].hasOwnProperty(key)) {

            return this.config[$DEFAULT][this.flow][key];
        }

        if (this.config.hasOwnProperty($DEFAULT) && this.config[$DEFAULT].hasOwnProperty(key)) {

            return this.config[$DEFAULT][key];
        }
    },
    error: function error(message) {
        return new Error('Integration error: ' + this.context + ' / ' + this.flow + ' :: ' + message);
    }
};

angular.value("$DEFAULT", $DEFAULT);
angular.value("$CONTEXT", $CONTEXT);
angular.value("$integration", $integration);
_logger.$logger;

/***/ }),

/***/ "../node_modules/squid/dist/core/loader.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$loader = undefined;

var _event = __webpack_require__("../node_modules/squid/dist/core/event.js");

var _firstLoad = false;

var loader = _event.$event.compose('loading', 'loaded', 'startLoad', 'allLoaded', 100);

var $loader = exports.$loader = {

    isLoading: function isLoading() {
        return Boolean(loader.getCount());
    },
    firstLoad: function firstLoad() {
        return _firstLoad;
    },
    reset: function reset() {
        loader.reset();
    }
};

_event.$event.on('allLoaded', function () {
    _firstLoad = true;
});

angular.value("$loader", $loader);
_event.$event;

/***/ }),

/***/ "../node_modules/squid/dist/core/model.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {

exports.__esModule = true;
exports.$Model = undefined;

var _class = __webpack_require__("../node_modules/squid/dist/core/class.js");

var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");

var _promise = __webpack_require__("../node_modules/squid/dist/core/promise.js");

var $Model = exports.$Model = _class.$Class.extend('$Model', {

    init: function init() {

        if (this.keys().length) {
            this.onPopulate();
        }

        if (this.id) {
            var _cache = this.constructor._modelCache = this.constructor._modelCache || {};

            _cache[this.id] = this;
        }

        this.meta = {
            populated: false
        };
    },

    /**
     * Add the passed in properties to this Model.
     * Sets the meta.populated to true. This flag
     * can be used later to determine if the model is populated.
     * Calls onPopulate() in the end.
     */
    populate: function populate() {

        this.meta.populated = true;
        this.setProperties.apply(this, arguments);
        delete this.meta.invalidated;
        this.onPopulate();
        return this;
    },

    fetchChildren: function fetchChildren() {
        return _promise.$promise.resolve();
    },

    /**
     * Override this method, to execute any logic after model is populated.
     */
    onPopulate: function onPopulate() {// eslint-disable-line no-empty-function

    },

    /**
     * Override this method, to execute any logic after model is invalidated.
     */
    onInvalidate: function onInvalidate() {// eslint-disable-line no-empty-function

    },

    /**
     * Override this method to return a Mock instance. Must return a promise which resolves to model.
     */
    fetchMock: function fetchMock() {// eslint-disable-line no-empty-function

    },

    /**
     * Retrieves the model.
     *
     * If model is already populated just returns a promise which resolves to `this`
     * If there is a retriever for this model, then return the retreiver.
     * Else calls the api to retrieve the model.
     *
     * @param options
     * @returns {*}
     */
    retrieve: function retrieve(options) {
        var self = this;

        options = options || {};

        if (self.meta.populated) {

            if (options.success) {
                return _promise.$promise.resolve(options.success(self));
            }

            return _promise.$promise.resolve(this);
        }

        if (this.retriever) {
            return this.retriever;
        }

        if (!this.api) {
            throw new Error('Tried to populate a model with no api');
        }

        options.model = this;

        this.retriever = this.api.retrieve(options).then(function (res) {
            return self;
        })['finally'](function () {
            delete self.retriever;
        });

        return this.retriever;
    },

    /**
     * Calls a post on the api to save this model. Takes options as parameters.
     * options will passed down to api.post.
     *
     * @param options
     * @returns {*|HttpPromise}
     */
    save: function save(options) {
        options = options || {};
        options.model = this;

        options.data = options.data || this.serialize();

        return this.api.post(options);
    },

    /**
     * Calls Api.action to perform any action on the model.
     *
     * Takes action name and optional 'options' object as parameters.
     *
     * Ex: $CheckoutSession.actions('create', [options])
     *
     * @param action
     * @param options
     * @returns {*}
     */
    action: function action(_action, options) {
        options = options || {};
        options.model = this;

        return this.api.action(_action, options);
    },

    /**
     * Use this method to force a api call to get the data.
     *
     * @param options
     * @returns {*}
     */
    reload: function reload(options) {
        this.meta.populated = false;
        return this.retrieve(options);
    },

    stringify: function stringify() {
        return JSON.stringify(this, 2);
    },

    log: function log() {
        console.log(this.stringify());
    },

    serialize: function serialize() {// eslint-disable-line no-empty-function

    },

    /**
     * Invalidate the current model. Sets the meta.populated to false and sets meta.invalidated to true.
     */
    invalidate: function invalidate() {
        this.meta.populated = false;
        this.meta.invalidated = true;
        this.onInvalidate();
    },

    /**
     * Creates a new Class with properties from `child`. Then assigns `this` as parent to the new Class.
     *
     * @param Cls
     * @param child
     * @returns {*}
     */
    child: function child(Cls, _child) {

        if (!_child) {
            return;
        }

        return Cls.create(_child.id || this.id, { parent: this }).populate(_child);
    },

    /**
     *
     * @param Cls
     * @param children
     * @returns {*}
     */
    children: function children(Cls, _children) {
        var self = this;

        if (!_children) {
            return _children;
        }

        return _util.$util.map(_children, function (child) {
            return self.child(Cls, child);
        });
    }
});

var cache = {};

$Model.reopenClass({

    instance: function instance(id) {

        var modelCache = cache[this.id] = cache[this.id] || {};
        var instance = modelCache[id || 0] || this.create.apply(this, arguments);

        return instance;
    },

    retrieveInstance: function retrieveInstance() {
        return this.instance.apply(this, arguments).retrieve();
    },

    create: function create(id) {

        var modelCache = cache[this.id] = cache[this.id] || {};
        var instance = modelCache[id || 0] = new this({ // eslint-disable-line new-cap
            id: id || 0
        });

        instance.setProperties.apply(instance, Array.prototype.slice.call(arguments, 1));

        return instance;
    },

    fetch: function fetch() {
        console.warn('Model.fetch is deprecated, please use Model.instance');
        return this.instance.apply(this, arguments);
    },

    clearCache: function clearCache() {
        cache = {};
    },

    /**
     * should invalidate all models where the invalidationKey is found truthy
     *
     * invalidationKey: key of type string to look for in a model
     * example: $Model.bulkInvalidate('invalidateOnLogout');
     */
    bulkInvalidate: function bulkInvalidate(invalidationKey) {
        if (!invalidationKey) {
            return;
        }
        _util.$util.forEach(cache, function (modelCache, key) {
            _util.$util.forEach(modelCache, function (modelInstance, instanceId) {
                if (modelInstance[invalidationKey]) {
                    modelInstance.invalidate();
                }
            });
        });
    }
});

angular.value("$Model", $Model);
_class.$Class;

_util.$util;

_promise.$promise;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/squid/dist/core/promise.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$promise = $promise;

var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");

var _error = __webpack_require__("../node_modules/squid/dist/core/error.js");

var Promise = window.Promise;

function $promise(obj) {
    return Promise.resolve(obj);
}

_util.$util.extend($promise, {
    use: function use(CustomPromise) {
        Promise = CustomPromise;
        if (!window.Promise) {
            window.Promise = CustomPromise;
        }
    },
    resolver: function resolver(method) {
        return new Promise(method);
    },
    resolve: function resolve(value) {
        return Promise.resolve(value);
    },
    reject: function reject(value) {
        return Promise.reject(value);
    },


    run: function run(method) {
        return Promise.resolve().then(method);
    },

    call: function call(method) {
        return Promise.resolve().then(method);
    },

    sequential: function sequential(methods) {

        var prom = Promise.resolve();

        _util.$util.forEach(methods, function (method) {
            prom = prom.then(method);
        });

        return prom;
    },

    sleep: function sleep(time) {
        return new Promise(function (resolve) {
            setTimeout(resolve, time);
        });
    },

    map: function map(items, method) {

        var promises = void 0;

        if (items instanceof Array) {
            promises = [];
        } else if (items instanceof Object) {
            promises = {};
        } else {
            return Promise.resolve();
        }

        return this.all(_util.$util.map(items, function (item, key) {

            promises[key] = Promise.resolve(item).then(function (result) {
                return method(result, key, promises);
            });

            return promises[key];
        }));
    },

    all: function all(items) {

        if (items instanceof Array) {
            return Promise.all(items);
        } else if (items instanceof Object) {
            return this.hash(items);
        }

        return Promise.resolve([]);
    },

    hash: function hash(obj) {
        var results = {};

        return Promise.all(_util.$util.map(obj, function (item, key) {
            return Promise.resolve(item).then(function (result) {
                results[key] = result;
            });
        })).then(function () {
            return results;
        });
    },

    extend: function extend(obj, hash) {
        return this.hash(hash || {}).then(function (data) {
            _util.$util.extend(obj, data);
        });
    },

    attempt: function attempt(attempts, method) {

        attempts -= 1;

        return Promise.resolve().then(function () {
            return method(attempts);
        })['catch'](function (err) {

            if (attempts) {
                return $promise.attempt(attempts, method);
            }

            return Promise.reject(err);
        });
    },

    debounce: function debounce(method, time) {

        var timeout = void 0;
        var resolvers = {};

        return function () {

            var self = this;
            var args = arguments;
            var key = JSON.stringify(args);

            resolvers[key] = resolvers[key] || [];

            return new Promise(function (resolve) {
                resolvers[key].push(resolve);
                clearTimeout(timeout);

                timeout = setTimeout(function () {

                    var result = method.apply(self, args);

                    _util.$util.forEach(resolvers[key], function (resolver) {
                        resolver(result);
                    });

                    delete resolvers[key];
                }, time);
            });
        };
    },

    every: function every(collection, handler) {
        return this.map(collection, function (item) {
            return handler(item);
        }).then(function (results) {
            return _util.$util.every(results);
        });
    },

    providing: function providing(condition, handler) {
        return Promise.resolve(condition).then(function (result) {
            if (result) {
                return handler(result);
            }
        });
    },

    until: function until(condition, pollTime, timeout, alwaysResolve) {

        return new Promise(function (resolve, reject) {
            if (condition()) {
                return resolve();
            }

            var interval = setInterval(function () {
                if (condition()) {
                    clearInterval(interval);
                    return resolve();
                }
            }, pollTime);

            if (timeout) {
                setTimeout(function () {
                    clearInterval(interval);
                    return alwaysResolve ? resolve() : reject();
                }, timeout);
            }
        });
    },

    first: function first(handlers) {

        var prom = $promise.resolve();
        var result = void 0;

        _util.$util.forEach(handlers, function (handler) {
            prom = prom.then(function () {
                return result || handler();
            }).then(function (handlerResult) {
                result = handlerResult;
                return result;
            });
        });

        return prom;
    },

    shortCircuit: function shortCircuit() {
        return $promise.reject(new _error.$ShortCircuit());
    }
});

angular.value("$promise", $promise);
_util.$util;

_error.$ShortCircuit;

/***/ }),

/***/ "../node_modules/squid/dist/core/util.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$unresolved = exports.$util = exports.isUnsafeRedirect = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.$getRedirectUrl = $getRedirectUrl;
exports.$dispatch = $dispatch;
exports.$experiment = $experiment;

var _event = __webpack_require__("../node_modules/squid/dist/core/event.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");

var _integration = __webpack_require__("../node_modules/squid/dist/core/integration.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var redirected = false;
var paramCache = {};

var blacklist = ['password', 'pr_password'];
var blacklistRegex = new RegExp('(' + blacklist.join('|') + ')=([^&]*)', 'g');
var sanitizeUrlForLogging = function sanitizeUrlForLogging(inputUrl) {
    return inputUrl.replace(blacklistRegex, function (match, key, value) {
        return key + '=**';
    });
};

var isUnsafeRedirect = exports.isUnsafeRedirect = function isUnsafeRedirect(url) {
    return url.toLowerCase().replace(/\s/g, '').indexOf('javascript:') !== -1;
}; // eslint-disable-line no-script-url

var $util = exports.$util = {

    forEach: function forEach(collection, method) {
        if (collection instanceof Array) {
            for (var i = 0; i < collection.length; i++) {
                method(collection[i], i);
            }
        } else if (collection instanceof Object) {
            for (var key in collection) {
                if (collection.hasOwnProperty(key)) {
                    method(collection[key], key);
                }
            }
        }
    },

    idleTimeout: function idleTimeout(time) {
        setTimeout(function () {
            _logger.$logger.info('page_idle');
            $util.reload();
        }, time);
    },


    reload: function reload() {
        _logger.$logger.info('reload');
        _event.$event.emit('loading');
        location.reload();
    },

    /**
     * replace:
     * Insert URL params provided and reload the window
     * This does not find the param if it already exists in the URL. It will add it again
     * @param params {Object} param - Params to add as URL params
     */
    replace: function replace(params) {
        if (params) {
            // Note: This won't replace the
            var url = $util.buildURL(location.href.split('#')[0], params);

            url = '' + url + window.location.hash;

            _logger.$logger.info('replace', { url: url });
            _event.$event.emit('loading');
            location.replace(url);
        } else {
            $util.reload();
        }
    },

    redirect: function redirect(url, options) {

        // optional flag to allow an iframe to Bust out of iframe mode by setting window.top.location = window.location.href
        var frameBust = options && options.frameBust;

        if (isUnsafeRedirect(url)) {
            // eslint-disable-line
            _logger.$logger.error('unsafe_redirect_url', {
                url: url
            });
            throw new Error('Unsafe redirect url: ' + url);
        }

        _logger.$logger.info('redirect', {
            url: sanitizeUrlForLogging(url)
        });

        _event.$event.on('$stateChangeStart', function (event) {
            _logger.$logger.info('state_change_after_redirect');
            event.preventDefault();
        });

        function redir() {

            if (redirected) {
                return;
            }

            _logger.$logger.info('redirect', {
                url: sanitizeUrlForLogging(url)
            });

            window.onunload = window.onbeforeunload = function () {}; // eslint-disable-line no-empty-function

            if (_integration.$integration.getConfig('REDIRECT_TOP') !== false || frameBust) {
                window.top.location = url;
            } else {
                window.location = url;
            }

            redirected = true;
        }

        _event.$event.emit('loading');

        _logger.$logger.flush().then(redir);
        setTimeout(redir, 500);

        _logger.$logger.done();
    },

    cookiesEnabled: function cookiesEnabled() {
        var cookiesEnabled = void 0;

        document.cookie = '_cookiecheck=1';
        cookiesEnabled = Boolean(document.cookie.indexOf('_cookiecheck') > -1);
        document.cookie = '_cookiecheck=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = '_cookiecheck; expires=Thu, 01 Jan 1970 00:00:01 GMT;';

        return cookiesEnabled;
    },

    storageEnabled: function storageEnabled(api) {
        try {
            window[api].setItem('__feature_test__', '0');
            window[api].removeItem('__feature_test__');
            return true;
        } catch (e) {
            return false;
        }
    },

    sessionStorageEnabled: function sessionStorageEnabled() {
        return this.storageEnabled('sessionStorage');
    },

    localStorageEnabled: function localStorageEnabled() {
        return this.storageEnabled('localStorage');
    },

    params: function params(string) {

        if (typeof string !== 'string') {
            string = this.queryString().slice(1);
        }

        var params = {};

        if (!string) {
            return params;
        }

        if (paramCache[string]) {
            return $util.extend({}, paramCache[string]);
        }

        $util.forEach(string.split('&'), function (pair) {
            pair = pair.split('=');

            if (pair[0]) {
                params[decodeURIComponent(pair[0])] = pair[1] && decodeURIComponent(pair[1]);
            }
        });

        paramCache[string] = params;

        return params;
    },

    queryString: function queryString() {
        if (window.location.search) {
            return window.location.search;
        } else {
            var string = window.location.href;
            var idx = string.indexOf('&');
            var rIdx = string.lastIndexOf('#');

            if (idx) {
                return '?' + string.substring(idx, rIdx >= 0 ? rIdx : string.length);
            }
        }
        return '';
    },

    queryStringSplice: function queryStringSplice(qs, insert, remove) {
        if (qs.indexOf('?') === 0) {
            qs = qs.slice(1);
        }

        var params = $util.extend(this.params(qs), insert);

        $util.forEach(remove, function (key) {
            delete params[key];
        });

        return '?' + this.paramToQueryString(params);
    },

    extend: function extend(obj, source) {

        if (!source) {
            return obj;
        }

        for (var key in source) {
            if (source.hasOwnProperty(key)) {
                obj[key] = source[key];
            }
        }

        return obj;
    },


    paramToQueryString: function paramToQueryString(params) {
        return this.filter(this.map(Object.keys(params).sort(), function (key) {
            if (!params[key]) {
                return;
            }

            return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
        })).join('&');
    },

    param: function $param(name) {
        return this.params()[name];
    },

    hashParam: function hashParam(name) {
        return this.params(window.location.hash.slice(1))[name];
    },

    base64Decode: function base64Decode(encodedString) {
        return encodedString && window.atob(encodedString); // eslint-disable-line block-scoped-var,no-undef
    },

    base64Encode: function base64Encode(decodedString) {
        return decodedString && window.btoa(decodedString); // eslint-disable-line block-scoped-var,no-undef
    },

    /*
     * decodeAndParse :
     * 1 - Base64Decode
     * 2 - URI Decode
     * 3 - Split string into a nvp object
     * return obj
     */
    decodeAndParse: function decodeAndParse(encodedString) {
        if (encodedString) {
            return this.params(decodeURIComponent(this.base64Decode(encodedString)));
        }
    },

    assert: function $assert(value, message, payload) {
        if (!value) {
            throw new Error(message, payload || {});
        }
    },

    map: function $map(array, method) {

        array = array || [];

        var results = void 0;

        if (array instanceof Array) {
            results = [];

            $util.forEach(array, function () {
                results.push(method.apply(this, arguments));
            });

            return results;
        } else if (array instanceof Object) {

            results = {};

            $util.forEach(array, function (val, key) {
                results[key] = method.apply(this, arguments);
            });

            return results;
        } else {
            throw new Error('$util.map expects array or object');
        }
    },

    filter: function $filter(array, method) {
        method = method || Boolean;
        var results = [];

        $util.forEach(array, function (item) {
            if (method.apply(this, arguments)) {
                results.push(item);
            }
        });

        return results;
    },

    /**
     * Deprecated.
     *
     * If you have an array, use Array#find()
     * If you have an object, use the lodash or underscore .find() method
     *
     * @deprecated
     */
    find: function $find(array, method) {
        if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
            _angular.$log.warn('deprecated_method: squid.$util.find() is deprecated, use Array#find, which we have polyfilled, or _.find() for Objects instead.');
        }

        if (!array) {
            return;
        }

        for (var i = 0; i < array.length; i++) {
            if (method(array[i])) {
                return array[i];
            }
        }
    },

    findIndex: function $find(array, method) {

        if (!array) {
            return;
        }

        for (var i = 0; i < array.length; i++) {
            if (method(array[i])) {
                return i;
            }
        }
    },

    range: function range(start, end) {
        if (!end) {
            end = start;
            start = 0;
        }

        var result = [];

        for (var i = start; i < end; i++) {
            result.push(i);
        }

        return result;
    },

    pad: function $pad(string, n, char) {

        n = n || 0;
        char = char || '0';

        var padding = Array(n + 1).join(char.toString());

        return (padding + string).slice(-n);
    },

    /**
     * Deprecated.
     *
     * If you have an array, use Array#some() -- NOTE: Unlike Array#some(),
     * the return value of $util.some() isn't always a Boolean. It's return value
     * is whatever the passed callback returns. If you are using $util.some to
     * find an object in an array then you need to use $util.find instead of Array#some().
     * Ex:
     *      1. const preferredCard = $util.some(cardsArray, cards => card.isPreferred && card);
     *          preferredCard will be the preferred card object or undefined if there isn't a
     *          preferred card.
     *      2. const hasPreferred = cardsArray.some(cards => card.isPreferred && card);
     *          Taking the code from #1 and simply swapping out $util.some for Array#some()
     *          will result in a different return value, in this case the Boolean true if
     *          there is a preferred card, otherwise false. In this case, instead of using
     *          Array#some() you should use $util.find() (Array#find() isn't supported in IE9)
     *          as seen below:
     *         const preferredCard = $util.find(cardsArray, card => card.isPreferred);
     *
     * If you have an object, use the lodash or underscore .some() method
     *
     * @deprecated
     */
    some: function $some(array, method) {
        if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
            _angular.$log.warn('deprecated_method: squid.$util.some() is deprecated, use Array#some (use $util.find() if you are using\n                        $util.some() to return someting other than a boolean) or lodash/underscore.some() instead.');
        }

        var result = void 0;

        $util.forEach(array, function (item, key) {
            if (!result) {
                result = method(item, key);
            }
        });

        return result;
    },

    /**
     * Deprecated.
     *
     * If you have an array, use Array#every()
     * If you have an object, use the lodash or underscore .every() method
     *
     * @deprecated
     */
    every: function $every(array, method) {
        if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
            _angular.$log.warn('deprecated_method: squid.$util.every() is deprecated, use Array#every, which we have polyfilled, or _.every() for Objects instead.');
        }

        method = method || Boolean;

        var result = true;

        $util.forEach(array, function (item) {
            if (!method(item)) {
                result = false;
            }
        });

        return result;
    },

    reduce: function $reduce(array, method, intial) {
        $util.forEach(array, function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            intial = method.apply(undefined, [intial].concat(args));
        });

        return intial;
    },

    isPopup: function isPopup() {
        return _integration.$integration.isPopup();
    },

    isIFrame: function isIFrame() {
        return _integration.$integration.isIFrame();
    },

    buildURL: function buildURL(url, params) {
        /*
         * Do NOT add a check for anchor cause this function is also used for building XO success / cancel urls.
         * These urls are defined by the merchants and can also contain urls like "abc.com#merchantanchor" and merchants
         * expect (!) the following outcome: abc.com#merchantanchor?paypalparam=2
         */
        this.assert(url, 'buildURL :: expected url');

        var paramKeys = Object.keys(params || {});

        if (JSON.stringify(params) === '{}') {
            return url;
        }

        if (!paramKeys.length) {
            return url;
        }

        if (url.indexOf('?') === -1) {
            url += '?';
        } else {
            url += '&';
        }

        url += this.paramToQueryString(params);

        return url;
    },

    paypalURL: function paypalURL(url, params) {
        url = 'https://' + (_config.$meta.stage ? _config.$meta.stage : window.location.host) + url;

        return this.buildURL(url, params);
    },

    override: function override(obj, methodName, handler) {
        var existing = obj[methodName];

        obj[methodName] = function () {
            if (existing) {
                try {
                    existing.apply(obj, arguments);
                } catch (err) {
                    _logger.$logger.error(methodName + 'event_error', {
                        error: err.toString
                    });
                }
            }

            return handler.apply(obj, arguments);
        };
    },

    result: function result(method) {
        return method();
    },

    memoize: function memoize(method) {

        function memoized() {
            var key = JSON.stringify(arguments, function (_, value) {
                switch (typeof value === 'undefined' ? 'undefined' : _typeof(value)) {
                    case 'function':
                        throw new Error('Cannot memoize functional arguments');
                    case 'undefined':
                        return 'undefined';
                    default:
                        return value;
                }
            });

            if (!memoized.cache.hasOwnProperty(key)) {
                memoized.cache[key] = method.apply(this, arguments);
            }

            return memoized.cache[key];
        }

        memoized.cache = {};

        memoized.flush = function () {
            memoized.cache = {};
        };

        return memoized;
    },

    now: function now() {
        return window.enablePerformance ? parseInt(window.performance.now(), 10) : Date.now();
    },

    bindObject: function bindObject(obj, self) {
        return $util.map(obj, function (method) {
            return method.bind(self);
        });
    },

    hashStr: function hashStr(str) {
        var hash = 0;
        var i = void 0;
        var chr = void 0;
        var len = void 0;

        if (str.length === 0) {
            return hash;
        }
        for (i = 0, len = str.length; i < len; i++) {
            chr = str.charCodeAt(i);
            hash = (hash << 5) - hash + chr; // eslint-disable-line no-bitwise, no-extra-parens
            // Convert to 32bit integer
            hash |= 0; // eslint-disable-line no-bitwise
        }
        return Math.abs(hash);
    },

    hash: function hash() {
        return this.hashStr(Math.random());
    },

    popup: function popup(name, url, options, callback) {

        callback = $util.once(callback);

        var win = window.open(url, name, $util.map(Object.keys(options), function (key) {
            return key + '=' + options[key];
        }).join(', '));

        var interval = void 0;

        function checkWindowClosed() {
            if (win.closed) {
                clearInterval(interval);
                callback();
            }
        }

        interval = setInterval(checkWindowClosed, 50);
        setTimeout(checkWindowClosed);

        try {
            var close = win.close;

            win.close = function () {
                close.apply(this, arguments);
                checkWindowClosed();
            };
        } catch (err) {
            // pass
        }

        return win;
    },

    unique: function unique(collection) {
        return collection.filter(function (value, index, self) {
            return self.indexOf(value) === index;
        });
    },

    monkeyPatch: function monkeyPatch(mod, prop, method) {
        var original = mod[prop];

        mod[prop] = function () {
            var _this = this,
                _arguments = arguments;

            return method.call(this, arguments, function (self, args) {
                if (original) {
                    return original.apply(self || _this, args || _arguments);
                }
            });
        };
    },
    once: function once(method) {
        var called = false;

        return function () {
            if (!called) {
                called = true;
                return method.apply(this, arguments);
            }
        };
    },
    camelToDasherize: function camelToDasherize(string) {
        return string.replace(/([A-Z])/g, function (g) {
            return '-' + g.toLowerCase();
        });
    },
    camelToCapsUnderscore: function camelToCapsUnderscore(string) {
        return string.replace(/([a-z][A-Z])/g, function (g) {
            return g[0] + '_' + g[1];
        }).toUpperCase();
    },
    dasherizeToCamel: function dasherizeToCamel(string) {
        return string.replace(/-([a-z])/g, function (g) {
            return g[1].toUpperCase();
        });
    },


    parentWindow: function parentWindow() {
        if (window.opener) {
            return window.opener;
        } else if (window.parent !== window) {
            return window.parent;
        }
    },

    hasRTL: function hasRTL(str) {
        return new RegExp('[\u0590-\u07BF]').test(str);
    },
    noop: function noop() {// eslint-disable-line no-empty-function

    },


    /**
     * @function isObject - tests to see if a passed argument is an Object. Returns `false`
     *      for anything that is 'object-like' but not an actual Object (Array, Set, Map, ect)
     *      as well as for `null` and `Object.create(null)`
     * @param {*} o
     * @returns {boolean}
     */
    isObject: function isObject(o) {
        var oAsString = Object.prototype.toString.call(o);

        return o instanceof Object && oAsString === '[object Object]';
    },


    /**
     * @function debounce
     * @param {function} callback
     * @param {number} time
     * @returns {function}
     */
    debounce: function debounce(callback, time) {
        var timeout = void 0;

        return function () {
            var _this2 = this;

            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            var functionCall = function functionCall() {
                return callback.apply(_this2, args);
            };

            clearTimeout(timeout);
            timeout = setTimeout(functionCall, time);
        };
    },


    /**
     * @function getProperty
     * @param {object} obj
     * @param {string} propString
     * @param {string} splitOn
     * @returns {*}
     *
     * Ex:
     *  const obj = {
     *      a: {
     *          b: {
     *              c: 'property c'
     *          },
     *          'key.with.periods': 10
     *      }
     *  };
     *  const c = $util.getProperty(obj, 'a.b.c'); // c === 'property c'
     *  const f = $util.getProperty(obj, 'a.b.c.d.e.f'); // f === undefined
     *  const fDefault = $util.getProperty(
     *      obj,
     *      'a.b.c.d.e.f',
     *      { default: 'default value for f' }
     *  ); // f === 'default value for f'
     *  const n = $util.getProperty(obj, 'a,b,key.with.periods', { splitOn: ',' }); // n === 10
     */
    getProperty: function getProperty(obj) {
        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var _options$splitOn = options.splitOn,
            splitOn = _options$splitOn === undefined ? '.' : _options$splitOn,
            defaultValue = options['default'];


        if (!this.isObject(obj) || typeof path !== 'string' || typeof splitOn !== 'string') {
            return;
        }

        var pathArray = path.split(splitOn);
        var prop = obj[pathArray.shift()];

        while (prop && pathArray.length && this.isObject(prop)) {
            prop = prop[pathArray.shift()];
        }

        return pathArray.length || prop === undefined ? defaultValue : prop;
    }
};

var $unresolved = exports.$unresolved = { then: $util.noop, 'catch': $util.noop };

function $getRedirectUrl(product, params) {
    var url = '';
    var urlParams = $util.params();

    if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
        url = _config.$config.urls.dispatch && _config.$config.urls.dispatch[product] || '';
    }

    url += _config.$config.urls.fallbackUrl[product];

    $util.extend(urlParams, params || {});

    // cmd is a reserved slingshot param
    if (urlParams.cmd) {
        delete urlParams.cmd;
    }

    return $util.buildURL(url, urlParams);
}

function $dispatch(product, params, stateChange) {
    $util.assert(product, 'expected product');

    _logger.$logger.log('info', 'dispatch', {
        product: product
    });

    _event.$event.emit('loading');

    var url = '';

    url = $getRedirectUrl(product, params);

    // fire an event for xo-tracking to listen to and do fpti logging
    if (stateChange) {
        _event.$event.emit('page_loaded', stateChange.fromState, stateChange.toState);
    }

    return $util.redirect(url);
}

function $experiment(name, sample, id, loggerPayload) {

    var throttle = $util.hashStr(name + '_' + id) % 100;

    var group = void 0;

    if ($util.param(name) === 'true') {
        group = 'test_forced';
    } else if ($util.param(name) === 'false') {
        group = 'control_forced';
    } else if (throttle < sample) {
        group = 'test';
    } else if (sample >= 50 || sample <= throttle && throttle < sample * 2) {
        // eslint-disable-line no-extra-parens
        group = 'control';
    } else {
        group = 'throttle';
    }

    _logger.$logger.info('fpti_pxp_check', {
        from: 'PXP_CHECK',
        to: 'process_pxp_check',
        pxp_exp_id: name,
        pxp_trtmnt_id: group
    });

    _logger.$logger.info(name + '_' + group, loggerPayload || {});

    if (group === 'test' || group === 'test_forced') {
        return true;
    } else if (group === 'control') {
        return false;
    }
}

angular.value("isUnsafeRedirect", isUnsafeRedirect);
angular.value("$util", $util);
angular.value("$unresolved", $unresolved);
angular.value("$getRedirectUrl", $getRedirectUrl);
angular.value("$dispatch", $dispatch);
angular.value("$experiment", $experiment);
_event.$event;

_logger.$logger;

_config.$config;

_config.$meta;

_integration.$integration;

_angular.$log;

/***/ }),

/***/ "../node_modules/squid/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _ng = __webpack_require__("../node_modules/squid/dist/ng/index.js");

Object.keys(_ng).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ng[key];
    }
  });
});

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

Object.keys(_core).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _core[key];
    }
  });
});

var _locale = __webpack_require__("../node_modules/squid/dist/locale/index.js");

Object.keys(_locale).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _locale[key];
    }
  });
});

var _paypal = __webpack_require__("../node_modules/squid/dist/paypal/index.js");

Object.keys(_paypal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _paypal[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/squid/dist/locale/currency.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getCurrencySymbol = exports.truncateCurrencyConversionString = undefined;
exports.roundingAndSeparators = roundingAndSeparators;
exports.formatCurrency = formatCurrency;

var _locale = __webpack_require__("../node_modules/squid/dist/locale/locale.js");

var ALL_NON_BREAKING_SPACE = new RegExp('\xa0+', 'g'); // everything to do with currency formatting

// quick Griffin reference on currency format:
// ¤ : Currency Symbol = $
// # : Amount = 186432.431
// C : Currency Code = USD

var CODE_IN_FRONT = new RegExp('^([^¤#]*)(C[\\s]*)(.*)$'); // matching groups: (any negative symbol)(code)(the rest)
var ENDS_IN_WHITESPACE = new RegExp('\s$');
var THOUSANDS_SPLITTER = /\B(?=(\d{3})+(?!\d))/g; // eslint-disable-line fasec/no-unsafe-regex
var HUNDREDS_SPLITTER = /(\d)(?=(\d\d)+\d$)/g; // eslint-disable-line fasec/no-unsafe-regex

// This seems to be the only currency / locale specific exception in Griffin
var STYLE_EXCEPTION = {
    'tr TR TRY': '# ¤;-# ¤'
};

var AmountOnlyStyle = '#;-#'; // A currency style for number only. $9USD -> 9.00

// Griffin exceptions for separators at hundreds- xx,xx,xxx format
var HUNDREDS_SEPARATOR_EXCEPTION = ['IN', 'BT', 'MV', 'NP'];

var isObject = function isObject(param) {
    return Object.prototype.toString.call(param) === '[object Object]';
};

// Griffin "fuzzy logic"
// apparently if the symbol is at least "66% similar" to the code, ignore it
function maybeIgnoreSymbol(style, symbol, code) {

    // THIS IS NOT COMMUTATIVE
    function fuzzyMatch(code, symbol) {
        // eslint-disable-line no-shadow
        if (code === symbol) {
            return 100;
        } else {
            var codeParts = code.split('');
            var symbolParts = symbol.split('');
            var equivalency = codeParts.reduce(function (equiv, codePart) {
                var symbolPos = symbolParts.indexOf(codePart);

                if (symbolPos !== -1) {
                    symbolParts.splice(symbolPos, 1);
                    return equiv + 1;
                }
                return equiv;
            }, 0);
            var weight = equivalency / codeParts.length;

            return weight * 100;
        }
    }

    var ignoreSymbol = symbol.length > 1 && fuzzyMatch(code, symbol) >= 66;

    return ignoreSymbol ? style.replace(/¤\s*/g, '') : style;
}

// deal with rounding due to truncation (Griffin rounds up) as well as dot/comma symbols
// and thousand separators
function roundingAndSeparators(amountString, _ref, _ref2) {
    var lang = _ref.lang,
        country = _ref.country;
    var decimalPlaces = _ref2.decimalPlaces,
        dot = _ref2.dot,
        comma = _ref2.comma;

    var value = parseFloat(amountString);
    var truncate = decimalPlaces === 0;
    var amountParts = truncate && !isNaN(value) ? Math.round(value).toString().split('.') : amountString.split('.');
    var exception = HUNDREDS_SEPARATOR_EXCEPTION.indexOf(country) > -1; // special exceptions
    var wholeString = exception ? amountParts[0].replace(HUNDREDS_SPLITTER, '$1,') : amountParts[0].replace(THOUSANDS_SPLITTER, comma);
    var decimalString = amountParts[1] || '00';

    return truncate ? wholeString : '' + wholeString + dot + decimalString;
}

// this is an agreement with UED for visual consistency - the currency code, if displayed, is always on the right
function forceCodeToRight(style) {
    var parts = CODE_IN_FRONT.exec(style) || [];
    var endsWithWhitespace = ENDS_IN_WHITESPACE.test(style);
    var newStyle = style;

    // if CODE_IN_FRONT regex matches, array indexes -
    // [1] negative symbol plus whitespace, if any,
    // [2] the "C" plus any whitespace,
    // [3] whatever is after "C"
    if (parts.length === 4) {
        newStyle = parts[1] + parts[3] + (endsWithWhitespace ? 'C' : ' C');
    }

    return newStyle;
}

// deal with
// 1. exceptions for specific locales
// 2. positive and negative styles
// 3. griffin fuzzy logic
// 4. UED consistency logic
function getFinalStyle() {
    var styleString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ';';
    var _ref3 = arguments[1];
    var lang = _ref3.lang,
        country = _ref3.country;
    var _ref4 = arguments[2];
    var value = _ref4.value,
        _ref4$symbol = _ref4.symbol,
        symbol = _ref4$symbol === undefined ? '' : _ref4$symbol,
        code = _ref4.code;

    var exception = STYLE_EXCEPTION[[lang, country, code].join(' ')]; // special exceptions
    var currencyStyle = exception || styleString;

    var _currencyStyle$split = currencyStyle.split(';'),
        positiveStyle = _currencyStyle$split[0],
        negativeStyle = _currencyStyle$split[1]; // the style is separated by postive and negative notation via a ;


    var baseStyle = value < 0 ? negativeStyle || '-¤# C' : positiveStyle || '¤# C';
    var griffinStyle = exception ? baseStyle : maybeIgnoreSymbol(baseStyle, symbol, code); // don't apply fuzzy logic on exceptions

    return forceCodeToRight(griffinStyle);
}

// take the style and the formatted amount (rounded / truncated / thousands separator / decimal separator)
// and produce the final result.
//
// wrapCodeInSpan - wraps the currency code in a span.currencyCode for styling purposes
function applyCurrencyStyle(finalStyle, amountFormatted, _ref5) {
    var symbol = _ref5.symbol,
        code = _ref5.code,
        _ref5$wrapCodeInSpan = _ref5.wrapCodeInSpan,
        wrapCodeInSpan = _ref5$wrapCodeInSpan === undefined ? false : _ref5$wrapCodeInSpan;

    // the style will take care of negative symbol (see getFinalStyle function above)
    var absoluteAmountFormatted = amountFormatted.replace('-', '');

    // parallel operation is safer than serial replace
    return finalStyle.split('').map(function (char) {
        switch (char) {
            case 'C':
                return wrapCodeInSpan ? '<span class="currencyCode">' + code + '</span>' : code;
            case '¤':
                return symbol;
            case '#':
                return absoluteAmountFormatted;
            default:
                return char;
        }
    }).join('').replace(ALL_NON_BREAKING_SPACE, ' ');
}

/**
 * @function formatCurrency
 * @param {string|number} amount Amount can be a string or a number
 * @param {string} code
 * @param {boolean} wrapCodeInSpan
 * @param {string} [style=SymbolISOCurrency]
 * @returns {string} formatted currency string
 */
function formatCurrency(amount, code, wrapCodeInSpan) {
    var style = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'SymbolISOCurrency';

    if (isObject(amount) || typeof amount === 'undefined' || amount === null) {
        return;
    }

    var _ref6 = _locale.$locale.metadata || {},
        _ref6$number = _ref6.number,
        numberConfig = _ref6$number === undefined ? {} : _ref6$number,
        _ref6$currency = _ref6.currency,
        currencyConfig = _ref6$currency === undefined ? {} : _ref6$currency;

    var _currencyConfig$digit = currencyConfig.digits,
        digits = _currencyConfig$digit === undefined ? {} : _currencyConfig$digit,
        _currencyConfig$style = currencyConfig.styles,
        styles = _currencyConfig$style === undefined ? {} : _currencyConfig$style,
        _currencyConfig$suppo = currencyConfig.supportedSymbols,
        currencySymbols = _currencyConfig$suppo === undefined ? {} : _currencyConfig$suppo;

    var value = parseFloat(amount);

    styles.AmountOnlyStyle = AmountOnlyStyle;
    var dot = numberConfig.DECIMAL_SEP === undefined ? '.' : numberConfig.DECIMAL_SEP;
    var comma = numberConfig.GROUP_SEP === undefined ? ',' : numberConfig.GROUP_SEP;

    var amountFormatted = roundingAndSeparators(amount.toString(), _locale.$locale, { decimalPlaces: digits[code], dot: dot, comma: comma });

    if (code) {
        var symbol = currencySymbols[code];
        var finalStyle = getFinalStyle(styles[style], _locale.$locale, { value: value, symbol: symbol, code: code });

        return applyCurrencyStyle(finalStyle, amountFormatted, { symbol: symbol, code: code, wrapCodeInSpan: wrapCodeInSpan });
    }

    return amountFormatted; // HTML?
}

/**
 * @function truncateCurrencyConversionString
 * @description Takes a fullString, amount, and amountForex and truncates
 *      the number in the full string to number of digits in amountForex.
 *      This function is used to format the PayPal currency conversion
 *      rate that is displayed to the user (e.g. '1 CAD = $0.7459 USD')
 *      e.g. inputs of:
 *          fullString = '$0.745994235 USD'
 *          amount = '0.745994235'
 *          amountForex = '0.7459'
 *      results in an output of '$0.7459 USD'
 * @param {object} Contains keys 'fullString', 'amount', and 'amountForex'
 * @returns {string}
 */
var truncateCurrencyConversionString = exports.truncateCurrencyConversionString = function truncateCurrencyConversionString() {
    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        fullString = _ref7.fullString,
        amount = _ref7.amount,
        amountForex = _ref7.amountForex;

    var allArgsAreStrings = [fullString, amount, amountForex].every(function (s) {
        return typeof s === 'string';
    });

    if (!allArgsAreStrings) {
        return fullString || '';
    }

    // Some countries, e.g. France, use commas instead of decimals
    var target = amountForex.includes(',') ? amount.replace('.', ',') : amount;

    return fullString.replace(target, amountForex);
};

/**
 * @description takes a currency code and
 *  returns either a code or a symbol based
 *  on our currency mapping.
 *  eg: USD -> $ , RUB -> RUB
 *
 * @param {*} code
 * @returns {string}
 */
var getCurrencySymbol = exports.getCurrencySymbol = function getCurrencySymbol(code) {
    var _ref8 = _locale.$locale.metadata || {},
        _ref8$currency = _ref8.currency,
        currency = _ref8$currency === undefined ? {
        supportedSymbols: {}
    } : _ref8$currency;

    return currency.supportedSymbols[code];
};

_locale.$locale;

/***/ }),

/***/ "../node_modules/squid/dist/locale/feature.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$feature = $feature;
exports.$featureCountries = $featureCountries;

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _locale = __webpack_require__("../node_modules/squid/dist/locale/locale.js");

function $feature(prop, def, country) {

    var features = _core.$config.features || {};

    country = country || _locale.$locale.country;
    // 1. Check the feature is present in country
    var result = _core.$Class.get(features[country], prop);

    if (result !== undefined) {
        return result;
    }
    // 2. Check the feature is present in feature group

    Object.keys(_core.$config.regions).some(function (region) {
        if (_core.$config.regions[region].indexOf(country) !== -1) {
            result = _core.$Class.get(features[region], prop);
            return result !== undefined;
        }

        return false;
    });

    if (result !== undefined) {
        return result;
    }
    // 3. Check the feature is present in default group
    result = _core.$Class.get(features.DEFAULT, prop);

    if (result !== undefined) {
        return result;
    }
    return def;
}

// Build a list of all countries in our feature list and regions
// populate countries with out REGION names in the list
var allCountries = _core.$Class.keys(_core.$config.features || {}).filter(function (country) {
    return country !== 'DEFAULT' && !(_core.$config.regions && _core.$config.regions.hasOwnProperty(country));
});

// populate all the region countries in to allcountries
_core.$util.forEach(_core.$config.regions, function (countries, region) {
    _core.$util.forEach(countries, function (country) {
        if (allCountries.indexOf(country) === -1) {
            allCountries.push(country);
        }
    });
});

function $featureCountries(prop) {
    // Find the countries with a certain feature enabled
    return allCountries.filter(function (country) {
        return $feature(prop, false, country);
    });
}

angular.value("$feature", $feature);
angular.value("$featureCountries", $featureCountries);
_core.$config;

_core.$Class;

_core.$util;

_locale.$locale;

/***/ }),

/***/ "../node_modules/squid/dist/locale/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _locale = __webpack_require__("../node_modules/squid/dist/locale/locale.js");

Object.keys(_locale).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _locale[key];
    }
  });
});

var _currency = __webpack_require__("../node_modules/squid/dist/locale/currency.js");

Object.keys(_currency).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _currency[key];
    }
  });
});

var _feature = __webpack_require__("../node_modules/squid/dist/locale/feature.js");

Object.keys(_feature).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _feature[key];
    }
  });
});

var _name = __webpack_require__("../node_modules/squid/dist/locale/name.js");

Object.keys(_name).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _name[key];
    }
  });
});

var _quantity = __webpack_require__("../node_modules/squid/dist/locale/quantity.js");

Object.keys(_quantity).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _quantity[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/squid/dist/locale/locale.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$localeHelper = exports.$locale = exports.$LocaleModel = exports.$MetadataModel = exports.$ContentModel = undefined;
exports.sanitize = sanitize;
exports.Content = Content;
exports.$contentVersion = $contentVersion;
exports.$renderContent = $renderContent;
exports.$flushContent = $flushContent;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _paypal = __webpack_require__("../node_modules/squid/dist/paypal/index.js");

function sanitize(html) {
    return html && html.toString().replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\//g, '&#x2F;');
} /* eslint-disable no-use-before-define */


var JSONStringify = JSON.stringify;

JSON.stringify = function (item) {
    if (item instanceof Content) {
        return item.toString();
    }
    return JSONStringify.apply(this, arguments);
};

function Content(key, props) {
    this.key = key;
    this.props = props;
}

Content.cache = {};

Content.get = function (key, props) {

    if (!key) {
        return '';
    }

    props = props || {};

    var cacheKey = $locale.country + '_' + $locale.lang + '_' + key + '_' + JSONStringify.call(JSON, props);
    var cacheVal = Content.cache[cacheKey];

    if (cacheVal !== undefined) {
        return cacheVal;
    }

    cacheVal = Content.cache[cacheKey] = new Content(key, props);

    return cacheVal;
};

Content.prototype.toString = Content.prototype.valueOf = function () {
    if (this.string) {
        return this.string;
    }

    this.string = this.render(false);

    return this.string;
};

Content.prototype.toSafeString = function () {
    if (this.safeString) {
        return this.safeString;
    }

    this.safeString = this.render(true);

    return this.safeString;
};

Content.prototype.render = function (safe) {
    var _this = this;

    if (!this.key) {
        return '';
    }

    var value = contentCache[$locale.country] && contentCache[$locale.country][$locale.lang];
    var keys = this.key.split('.');

    for (var i = 0; i < keys.length; i++) {
        if (value) {
            value = value[keys[i]];
        } else {
            break;
        }
    }

    if (!value) {
        return '';
    }

    return value.replace(/\{\w+\}/g, function (prop) {
        prop = prop.slice(1, prop.length - 1);

        if (prop === 'country') {
            return $locale.country;
        }

        if (prop === 'lang') {
            return $locale.lang;
        }

        if (!_this.props[prop]) {
            if (!_core.$loader.isLoading()) {
                _logger.$logger.warn('missing_content_prop', {
                    key: _this.key,
                    prop: prop
                }, { unique: true });
            }

            return '';
        }

        var propStr = _this.props[prop].toString();

        if (safe) {
            return sanitize(propStr);
        }

        return propStr;
    });
};

var contentCache = {};
var currentVersion = void 0;

window.addContent = function (country, lang, content, version) {
    var countryCache = contentCache[country] = contentCache[country] || {};

    countryCache[lang] = content;
    currentVersion = version;
};

var metadataCache = {};

window.addMetadata = function (country, lang, metadata) {
    var metadataVersion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'default';

    var countryCache = metadataCache[country] = metadataCache[country] || {};

    countryCache[lang] = countryCache[lang] || {};
    countryCache[lang][metadataVersion] = metadata;
};

function $contentVersion() {
    return currentVersion || '';
}

var PP_SPECIAL_COUNTRIES_ISO_CODES = {
    C2: 'CN'
};

var $ContentModel = exports.$ContentModel = _core.$Model.extend('$ContentModel', {
    api: new _core.$Api({

        baseURI: _core.$meta.staticUrl,
        uri: '/locales/:countryCode/:lang',
        ext: 'js',

        retrieve: function retrieve(options) {
            var self = this;
            var model = options.model;

            var uri = self.getURI(model);

            return _core.$promise.resolve().then(function () {

                if (contentCache[model.countryCode] && contentCache[model.countryCode][model.lang]) {
                    _logger.$logger.info('cached_content');
                    return contentCache[model.countryCode][model.lang];
                }

                _logger.$logger.info('retrieve_content', {
                    uri: uri
                });

                _core.$event.emit('loading');

                return _core.$promise.attempt(3, function () {
                    return _core.$dom.loadScript('content', uri, 10000).then(function () {
                        if (contentCache[model.countryCode] && contentCache[model.countryCode][model.lang]) {
                            _logger.$logger.info('content_retrieved');
                            return contentCache[model.countryCode][model.lang];
                        }

                        throw new Error('content_not_available');
                    });
                })['catch'](function (err) {
                    throw err;
                })['finally'](function () {
                    _core.$event.emit('loaded');
                });
            }).then(function (content) {
                model.setProperties(content);
                return content;
            });
        }
    }),

    change: function change(country, lang) {

        if (country === this.countryCode && lang === this.lang) {
            return _core.$promise.resolve(this);
        }

        this.countryCode = country;
        this.lang = lang;

        return this.reload().then(function () {
            _core.$event.broadcast('contentChange');
        });
    }
});

var $MetadataModel = exports.$MetadataModel = _core.$Model.extend('$MetadataModel', {

    api: new _core.$Api({

        baseURI: _core.$meta.staticUrl,
        uri: '/metadata/:country/:lang/:version?/metadata',
        ext: 'js',

        retrieve: function retrieve(options) {
            var self = this;
            var model = options.model;

            var uri = self.getURI(model);

            return _core.$promise.resolve().then(function () {

                var metadataVersion = model.version || 'default';

                if (metadataCache[model.country] && metadataCache[model.country][model.lang] && metadataCache[model.country][model.lang][metadataVersion]) {
                    _logger.$logger.info('cached_metadata');
                    return metadataCache[model.country][model.lang][metadataVersion];
                }

                _logger.$logger.info('retrieve_metadata', {
                    uri: uri
                });

                _core.$event.emit('loading');

                return _core.$promise.attempt(3, function () {
                    return _core.$dom.loadScript('metadata', uri, 10000).then(function () {
                        if (metadataCache[model.country] && metadataCache[model.country][model.lang] && metadataCache[model.country][model.lang][metadataVersion]) {
                            _logger.$logger.info('metadata_retrieved', {
                                uri: uri
                            });
                            return metadataCache[model.country][model.lang][metadataVersion];
                        }

                        // Retry if not found in cache
                        _logger.$logger.info('metadata_not_available', {
                            uri: uri
                        });
                        return _core.$promise.reject(new Error('metadata_not_available'));
                    });
                })['catch'](function (err) {
                    throw err;
                })['finally'](function () {
                    _core.$event.emit('loaded');
                });
            }).then(function (metadata) {
                model.setProperties(metadata);
                return metadata;
            });
        }
    }),

    setVersion: function setVersion(country, lang) {
        var _this2 = this;

        var versionPxpName = _core.$config.features[country] && _core.$config.features[country].metadataVersionName;

        if (versionPxpName && _core.$config.metadataPxpExperiments[versionPxpName]) {
            var pxp = (0, _paypal.$pxp)(_core.$config.metadataPxpExperiments[versionPxpName].experimentName, {
                'ctx.COUNTRY': country,
                'ctx.LANGUAGE': lang
            }, _core.$config.metadataPxpExperiments[versionPxpName].experimentTreatmentName);

            return pxp.then(function (treatment) {
                if (treatment) {
                    _this2.version = versionPxpName;
                    _logger.$logger.info('metadata_version_set', {
                        country: country,
                        lang: lang,
                        version: versionPxpName
                    });
                } else {
                    delete _this2.version;
                }
            })['catch'](function () {
                delete _this2.version;
            })['finally'](function () {
                return _core.$promise.resolve();
            });
        } else {
            delete this.version;
            return _core.$promise.resolve();
        }
    },

    change: function change(country, lang) {
        var _this3 = this;

        this.country = country;
        this.lang = lang;

        return this.setVersion(country, lang).then(function () {
            return _this3.reload().then(function () {
                if (!_this3.noBroadcast) {
                    _core.$event.broadcast('metadataChange');
                }
            });
        });
    },

    choose: function choose(country, lang, override) {

        if (country && (!this.chosenCountry || override !== false)) {
            this.chosenCountry = country;
        }

        if (lang && (!this.chosenLang || override !== false)) {
            this.chosenLang = lang;
        }

        country = this.chosenCountry || this.country;
        lang = this.chosenLang;

        if (_core.$config.supportedCountries) {
            if (!_core.$config.supportedCountries[country]) {
                country = this.country;
            }

            if (_core.$config.supportedCountries[country].indexOf(lang) === -1) {
                lang = _core.$config.supportedCountries[country][0];
            }
        }

        if (!lang) {
            lang = this.lang;
        }

        return this.change(country, lang);
    },

    normalizeAddressFields: function normalizeAddressFields(content) {

        var CONTENT_MAPPING = {
            line1Label: 'streetAddress',
            line2Label: 'streetAddress2',
            cityLabel: 'city',
            stateLabel: 'state',
            postcodeLabel: 'postalCode'
        };

        // Loop over all layout props, if they don't exist in Griffin, get them from xo-content
        for (var prop in CONTENT_MAPPING) {
            if (this.addressEntry && this.addressEntry.strings[prop]) {
                this.addressEntry.strings[prop] = this.addressEntry.strings[prop] || content.get('common.' + CONTENT_MAPPING[prop]);
            }
        }
    }
});

function mapLanguage(lang) {
    var unselectableLanguages = _core.$config.unselectableLanguages || [];

    if (unselectableLanguages.indexOf(lang) !== -1) {
        if (!(_core.$meta.corp && _core.$config.betaLanguages && _core.$config.betaLanguages.indexOf(lang) !== -1)) {
            return 'en';
        }
    }

    var unsupportedLanguages = _core.$config.unsupportedLanguages || [];

    if (unsupportedLanguages.indexOf(lang) !== -1) {
        if (!(_core.$meta.corp && _core.$config.betaLanguages && _core.$config.betaLanguages.indexOf(lang) !== -1)) {
            var s = lang + '_locale_not_supported';

            throw new Error(s);
        }
    }

    return lang;
}

var $LocaleModel = exports.$LocaleModel = _core.$Model.extend('LocaleModel', {
    api: new _core.$Api({
        uri: '/api/locale'
    }),

    init: function init() {
        this._super.init.apply(this);
        this.content = $ContentModel.instance();
        this.metadata = $MetadataModel.instance();
    },

    retrieve: function retrieve() {
        var self = this;

        return this._super.retrieve.apply(this, arguments).then(function (result) {
            self.lang = mapLanguage(self.lang);
            return _core.$promise.all([self.content.change(self.country, self.lang), self.metadata.change(self.country, self.lang)]).then(function () {

                // TODO: This at build time... or make sure griffin metadata is complete
                self.metadata.normalizeAddressFields(self.content);

                return result;
            });
        });
    },

    change: function change(country, lang) {

        var self = this;

        lang = mapLanguage(lang);

        if (country === this.country && lang === this.lang) {
            return _core.$promise.resolve(this);
        }

        _logger.$logger.info('locale_change', {
            country: country,
            lang: lang
        });

        this.country = country;
        this.lang = lang;

        return _core.$promise.all([this.content.change(country, lang), this.metadata.change(country, lang)]).then(function (loadedData) {

            // TODO: This at build time... or make sure griffin metadata is complete
            self.metadata.normalizeAddressFields(self.content);

            _core.$event.broadcast('localeChange'); // broadcast only when data has all been loaded
            return loadedData;
        });
    },

    choose: function choose(country, lang, override) {

        if (country && (!this.chosenCountry || override !== false)) {
            this.chosenCountry = country;
        }

        if (lang && (!this.chosenLang || override !== false)) {
            this.chosenLang = lang;
        }

        country = this.chosenCountry || this.country;
        lang = this.chosenLang;

        if (!_core.$config.supportedCountries[country]) {
            country = this.country;
        }

        if (_core.$config.supportedCountries[country].indexOf(lang) === -1) {
            lang = _core.$config.supportedCountries[country][0];
        }

        if (!lang) {
            lang = this.lang;
        }

        return this.change(country, lang);
    },

    chooseCountry: function chooseCountry(country) {
        return this.choose(country, null);
    },

    chooseLang: function chooseLang(lang) {
        return this.choose(null, lang);
    },

    getLocaleCode: function getLocaleCode() {
        return this.lang + '_' + this.country;
    },

    getCountryCodeISO: function getCountryCodeISO() {
        return PP_SPECIAL_COUNTRIES_ISO_CODES[this.country] || this.country;
    }
});

var $locale = exports.$locale = $LocaleModel.instance();

function $renderContent(key, props) {
    return Content.get(key, props);
}

function $flushContent() {
    contentCache = {};
    Content.cache = {};
    $locale.content = $ContentModel.create();
    $locale.metadata = $MetadataModel.create();
    metadataCache = {};
}

var $localeHelper = exports.$localeHelper = {
    /**
     *
     * @param locale - Ex: en_US
     * @returns {{country: *, dialect}}
     */
    normalizeLocale: function normalizeLocale(locale) {
        if (!locale) {
            return {};
        }

        locale = locale.replace('-', '_');

        var country = void 0;
        var language = void 0;

        if (locale.match(/^\w{2}_\w{2}$/)) {
            locale = locale.split('_');

            language = locale[0];
            country = locale[1];
        } else {
            language = locale;
        }

        return {
            country: country,
            language: language
        };
    }
};

angular.value("sanitize", sanitize);
angular.value("Content", Content);
angular.value("$contentVersion", $contentVersion);
angular.value("$ContentModel", $ContentModel);
angular.value("$MetadataModel", $MetadataModel);
angular.value("$LocaleModel", $LocaleModel);
angular.value("$locale", $locale);
angular.value("$renderContent", $renderContent);
angular.value("$flushContent", $flushContent);
angular.value("$localeHelper", $localeHelper);
_logger.$logger;

_core.$event;

_core.$Model;

_core.$Api;

_core.$meta;

_core.$promise;

_core.$config;

_core.$loader;

_core.$dom;

_paypal.$pxp;

/***/ }),

/***/ "../node_modules/squid/dist/locale/name.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.formatNameInformal = formatNameInformal;

var _locale = __webpack_require__("../node_modules/squid/dist/locale/locale.js");

// Mapping of Griffin fields to name fields that should be used
var SUBSTITUTED_FIELDS = {
    givenName: 'first_name',
    surname: 'last_name'
};

// Taken from griffin-paypal: test if a string is Latin
function isLatin(str) {
    if (!str) {
        return true;
    }

    for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) > 0x24F) {
            return false;
        }
    }

    return true;
}

/**
 * Formats name into informal format based on Griffin metadata
 * @param  {Object} name The name to be formatted, containing first_name and last_name properties
 * @return {String}      The formatted string, or null if data is missing
 */
function formatNameInformal(name) {
    var layoutMetadata = _locale.$locale.metadata.nameInformal;
    var layout = null;

    if (!layoutMetadata) {
        return name.first_name || null; // Default to first name if metadata not loaded
    }

    // According to Griffin, if the name is all Latin and there is a Latin formatting variant, use that one
    if (layoutMetadata['latinLayout'] && isLatin(name.first_name) && isLatin(name.last_name)) {
        layout = layoutMetadata['latinLayout'];
    } else {
        layout = layoutMetadata['layout'];
    }

    // Map griffin layout parts to the name passed in. If it requires a value not passed in name, returns null early
    var formattedName = [];

    for (var i = 0; i < layout.length; i++) {
        var namePart = layout[i];

        if (name[SUBSTITUTED_FIELDS[namePart['$']]]) {
            formattedName.push(name[SUBSTITUTED_FIELDS[namePart['$']]]);
        } else if (namePart['$'] === 'separator') {
            formattedName.push(namePart._);
        }
    }

    return formattedName.join('');
}

_locale.$locale;

/***/ }),

/***/ "../node_modules/squid/dist/locale/quantity.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.formatQuantity = formatQuantity;

var _locale = __webpack_require__("../node_modules/squid/dist/locale/locale.js");

var _currency = __webpack_require__("../node_modules/squid/dist/locale/currency.js");

// format a quantity to add a thousand separator based on a locality
function formatQuantity(quantity) {
    var _ref = _locale.$locale.metadata || {},
        _ref$number = _ref.number,
        numberConfig = _ref$number === undefined ? {} : _ref$number;

    var dot = '';
    var comma = numberConfig.GROUP_SEP === undefined ? ',' : numberConfig.GROUP_SEP;

    return (0, _currency.roundingAndSeparators)(quantity.toString(), _locale.$locale, { decimalPlaces: 0, dot: dot, comma: comma });
}

_locale.$locale;

_currency.roundingAndSeparators;

/***/ }),

/***/ "../node_modules/squid/dist/ng/component.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {

exports.__esModule = true;
exports.$Component = undefined;
exports.$populate = $populate;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _ng = __webpack_require__("../node_modules/squid/dist/ng/ng.js");

var _directive = __webpack_require__("../node_modules/squid/dist/ng/directive.js");

(0, _directive.$registerDirective)('prevent-default', function () {

    return {
        restrict: 'A',
        link: function link($scope, $element, $attrs) {
            $element.on('click', function (event) {
                event.preventDefault();
            });
        }
    };
});

(0, _directive.$registerDirective)('stop-propagation', function () {

    return {
        restrict: 'A',
        link: function link($scope, $element, $attrs) {
            $element.on('click keydown keypress keyup', function (event) {
                event.stopPropagation();
            });
        }
    };
});

(0, _directive.$registerDirective)('validate-submit', function () {

    return {
        link: function link($scope, $element, $attrs) {

            var $form = $element.closest('form');
            var form = $scope[$form.prop('name')];
            var formID_element = $attrs.form; // take the form attribute from submit button
            var formID_linked = $element[0] // take the id from the linked form element
            && $element[0].form && $element[0].form.id;
            var isLinkedForm = formID_element && formID_element === formID_linked; // Checking for confirmation. May not be required. Presence should be good enough.

            if (isLinkedForm) {
                $form = angular.element(document.getElementById(formID_linked));
                var scope = $form.scope(); // Linked forms should mantain form scope

                form = scope[$form.prop('name')];
            }

            $element.on('click', function (event) {
                event.preventDefault();

                $form.addClass('validated');
                $scope.validated = true;
                form.$setSubmitted();

                if (form.$valid) {
                    try {
                        $scope.$eval($attrs.validateSubmit);
                    } catch (err) {
                        _angular.$injector.get('$exceptionHandler')(err);
                    }
                } else {
                    $form.find('.ng-invalid:first').focus();
                }
            });
        }
    };
});

function assertModelsRetrievedOrEmpty(items) {
    if (_core.$config.deploy.isLocal() || _core.$config.deploy.isStage()) {
        angular.forEach(items, function (item, name) {
            if (item instanceof _core.$Model) {
                if (item.meta.populated) {
                    throw new Error(name + ' is already populated. Please call .retrieve() to ensure your code is not relying on cache being present.');
                }
            }
        });
    }
}

function setUpComponentRoute($scope, $Component, angular) {
    var componentRoute = $scope.componentRoute;

    componentRoute.scope = $scope;

    componentRoute.scope.goto = function (route) {
        componentRoute.goto(route);
    };

    var parentRoute = componentRoute.parent;

    if (parentRoute) {
        var parentScope = parentRoute.scope;
        var parentDirective = parentRoute.getDirective();
        var childSpec = componentRoute.childSpec;

        if (childSpec.config) {
            if (parentDirective instanceof $Component) {
                parentScope.viewConfig = childSpec.config.call(parentScope);
            } else {
                throw new Error('In order to use config() for child routes,\n                    ' + parentRoute.getDirectiveTag() + ' must be instance of new\n                    style $Component');
            }
        }

        if (childSpec.props) {
            if (parentDirective instanceof $Component) {
                angular.extend($scope, childSpec.props.call(parentScope));
            } else {
                throw new Error('In order to use props() for child routes,\n                    ' + parentRoute.getDirectiveTag() + ' must be instance of new\n                    style $Component');
            }
        }
    }
}

var $Component = exports.$Component = _core.$Class.extend('$Component', {

    onPopulate: angular.noop,

    init: function init() {
        var _this = this,
            _arguments = arguments;

        this.validate();

        this.name = _core.$util.dasherizeToCamel(this.tag);

        var wrapperType = this.wrapperType === 'span' ? 'span' : 'div';

        this.template = '<' + wrapperType + ' class="' + this.tag + '-wrapper" ng-if="populated && display">' + this.template + '</' + wrapperType + '>';

        this.scope = this.scope || {};
        this.resolve = this.resolve || {};
        this.props = this.props || {};
        this.rootEvents = this.rootEvents || {};

        this.actions = this.actions || {};

        this.lifecycle = this.lifecycle || {};
        this.lifecycle.enter = this.lifecycle.enter || angular.noop;
        this.lifecycle.reenter = this.lifecycle.reenter || angular.noop;
        this.lifecycle.exit = this.lifecycle.exit || angular.noop;
        this.lifecycle.populate = this.lifecycle.populate || angular.noop;

        if (this.scope && Object.keys(this.scope).length) {

            if (this.props && Object.keys(this.props).length) {
                throw new Error('Can not defined scope and props on the same component');
            }

            this.scope.componentRoute = '=';
            this.scope['export'] = '@';

            this.props = _core.$util.map(this.scope, function (type, key) {
                return {
                    type: {
                        '=': 'var',
                        '@': 'str'
                    }[type],
                    required: false
                };
            });
        } else {

            this.props.componentRoute = {
                type: 'var',
                required: false
            };

            this.props['export'] = {
                type: 'str',
                required: false
            };

            var isRequired = function isRequired() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                    required = _ref.required,
                    optional = _ref.optional;

                return [true, 'true'].indexOf(required) > -1 || [false, 'false'].indexOf(optional) > -1;
            };

            this.scope = _core.$util.map(this.props, function (spec, key) {
                return {
                    'var': isRequired(spec) ? '=' : '=?',
                    str: isRequired(spec) ? '@' : '@?'
                }[spec.type || 'var'];
            });
        }

        var originalController = this.controller || angular.noop;

        this.controller = ['$scope', '$element', function ($scope, $element) {
            $scope.$element = $element;

            $scope.$on('$destroy', function () {
                if ($scope.componentRoute && $scope.componentRoute.parent && $scope.componentRoute.parent.scope) {
                    delete $scope.componentRoute.parent.scope.viewConfig;
                }
                _this.lifecycle.exit.call($scope);
            });

            $scope.props = {};

            if ($scope.componentRoute) {
                setUpComponentRoute($scope, $Component, angular);
            }

            angular.forEach(_this.props, function (type, key) {

                var prop = _this.props[key];
                var required = prop.required !== false;
                var def = void 0;

                if (prop['default'] instanceof Function) {
                    def = _core.$util.memoize(prop['default'].bind($scope));
                } else {
                    def = function def() {
                        return prop['default'];
                    };
                }

                var UNDEFINED = {
                    'var': undefined,
                    str: ''
                }[prop.type];

                Object.defineProperty($scope.props, key, {
                    get: function get() {
                        var val = $scope[key];

                        if (val === UNDEFINED) {
                            if (required) {
                                throw new Error('Prop required for component :: ' + _this.tag + ' :: ' + key);
                            }

                            return def();
                        }

                        return val;
                    },

                    set: function set() {
                        throw new Error('Prop is immutable :: ' + _this.tag + ' :: ' + key);
                    }
                });
            });

            $scope.fields = {};

            $scope.actions = _core.$util.bindObject(_this.actions, $scope);

            Object.keys(_this.rootEvents).forEach(function (eventName) {
                var cancel = _core.$event.on(eventName, function (event) {
                    _this.rootEvents[eventName].apply($scope, _arguments);
                });

                $scope.$on('$destroy', cancel);
            });

            $scope.display = true;

            $scope.reload = function () {

                if (!$scope.populated) {
                    throw new Error('Can not reload unpopulated component');
                }

                $scope.display = false;
                setTimeout(function () {
                    $scope.display = true;
                });
            };

            $scope.componentScope = $scope;

            if ($scope.props['export'] && $scope.$parent.componentScope) {

                $scope.exports = angular.extend({}, _this.exports || {}, {
                    reload: $scope.reload
                });

                Object.defineProperty($scope.$parent.componentScope, $scope.props['export'], {
                    get: function get() {
                        return $scope.exports;
                    },

                    configurable: true
                });
            }

            $scope._enablePopulateEvents = true;

            _angular.$injector.invoke(originalController, _this, { $scope: $scope, $element: $element });
            _this.lifecycle.enter.call($scope);

            $scope._enablePopulateEvents = false;

            var cancelReEnterEvent = _core.$event.on('$stateChangeSuccess', function (event, toState) {
                if (toState === $scope.props.componentRoute) {
                    _this.lifecycle.reenter.call($scope);
                }
            });

            $scope.$on('$destroy', cancelReEnterEvent);

            return _core.$promise.sequential([function () {
                $scope.$emit('_populating');
            }, function () {
                return _core.$promise.map(_this.resolve, function (resolver, name, resolverPromises) {

                    if (angular.isObject(resolver)) {
                        $scope[name] = resolver;
                        return resolver;
                    }

                    return _core.$promise.resolve(resolver.call($scope, resolverPromises)).then(function (data) {
                        assertModelsRetrievedOrEmpty(data);

                        return _core.$promise.hash(data).then(function (resolvedData) {

                            $scope[name] = resolvedData;
                            return resolvedData;
                        });
                    });
                });
            }, function () {

                $scope.populated = true;

                $scope.$emit('_populated');

                _core.$event.refCount($scope, '_populating', '_populated').then(function () {

                    $scope.$on('populated', function (populatedEvent) {
                        populatedEvent.stopPropagation();
                    });

                    $scope.$emit('populated');
                    _this.onPopulate.call($scope);
                    _this.lifecycle.populate.call($scope);
                });
            }]);
        }];
    },

    validate: function validate() {

        if (_core.$config.deploy.isLive() && !_core.$config.deploy.isTest()) {
            return;
        }

        var componentName = this.constructor.name;

        if (!this.tag) {
            throw new Error(componentName + ' :: expected property \'tag\'');
        }

        if (!this.tag.match(/^[a-z0-9-]+$/)) {
            throw new Error(componentName + ' :: tag should contain only lowercase alphanumeric characters and dashes');
        }

        if (!this.template) {
            throw new Error(componentName + ' :: expected property \'template\'');
        }

        if (this.resolve) {
            angular.forEach(this.resolve, function (resolver, name) {
                if (!(resolver instanceof Function)) {
                    throw new Error(componentName + ' :: expected \'resolve.' + name + '\' to be a function');
                }
            });
        }

        if (this.props) {
            angular.forEach(this.props, function (prop, name) {

                if (!(prop instanceof Object)) {
                    throw new Error(componentName + ' :: expected \'props.' + name + '\' to be a function');
                }

                if (prop.type && ['var', 'str'].indexOf(prop.type) === -1) {
                    throw new Error(componentName + ' :: expected \'props.' + name + '.type\' to be one of var, str');
                }

                if (prop['default'] && prop.required) {
                    throw new Error(componentName + ' :: unnecessary \'props.' + name + '.default\', since prop is required');
                }

                if (prop['default'] && prop['default'] instanceof Object && !(prop['default'] instanceof Function)) {
                    throw new Error(componentName + ' :: expected \'props.' + name + '.default\' to be a primitive or a function - please do not pass mutable objects');
                }
            });
        }

        if (this.actions) {
            angular.forEach(this.actions, function (action, name) {
                if (!(action instanceof Function)) {
                    throw new Error(componentName + ' :: expected \'actions.' + name + '\' to be a function');
                }
            });
        }

        if (this.lifecycle) {
            Object.keys(this.lifecycle).forEach(function (name) {
                if (['enter', 'populate', 'exit', 'reenter'].indexOf(name) === -1) {
                    throw new Error(componentName + ' :: unexpected \'lifecycle.' + name + '\'');
                }
            });
        }
    }
});

$Component.reopenClass({

    extend: function extend() {

        var SubClass = _core.$Class.extend.apply(this, arguments);
        var spec = new SubClass();

        angular.module().directive(spec.name, function () {
            return spec;
        });

        return SubClass;
    },

    render: function render(scope) {
        _core.$event.emit('$resetState');

        var $scope = _angular.$rootScope.$new();

        angular.extend($scope, scope);

        var attrs = Object.keys(scope).map(function (key) {
            return _core.$util.camelToDasherize(key) + '="' + (this.prototype.props[key].type === 'var' ? key : scope[key]) + '"';
        }.bind(this)).join(' ');

        var cleanRootScope = (0, _ng.$cleanRootScope)(_angular.$rootScope);
        var html = '<' + this.prototype.tag + ' ' + attrs + '></' + this.prototype.tag + '>';

        console.log('RENDER', html, scope);

        var element = (0, _angular.$compile)(html)($scope);

        // attaching to the document so DOM Api works in karma flow tests (e.g document.getElementById('myId'))
        angular.element(document.body).append(element);

        afterEach(_core.$util.once(function () {
            $scope.$destroy();
            cleanRootScope();
            element.remove();
        }));

        setTimeout.flush();

        element.isolateScope = function () {
            throw new Error('Please test this element by interfacing with its public api: define mock endpoints, and interact with html links, buttons and form fields');
        };

        element.updateProps = function (props) {
            angular.extend($scope, props);
            $scope.$digest();
            setTimeout.flush();
        };

        return element;
    }
});

function autoConvertDirectiveToComponent(_ref2, original) {
    var name = _ref2[0],
        factory = _ref2[1];


    if (!angular.isFunction(factory)) {
        return original();
    }

    var tag = _core.$util.camelToDasherize(name);
    var spec = _angular.$injector.invoke(factory);

    if (spec.controller) {
        var originalController = spec.controller;

        spec.controller = ['$scope', '$element', function ($scope, $element) {
            $scope._enablePopulateEvents = true;
            var result = _angular.$injector.invoke(originalController, this, { $scope: $scope, $element: $element });

            $scope._enablePopulateEvents = false;
            return result;
        }];
    }

    if (spec instanceof $Component || !spec.template || !spec.controller || name.indexOf('xo') !== 0 || spec.transclude) {
        return original(this, [name, function () {
            return spec;
        }]);
    }

    if (spec.componentize) {

        $Component.extend('$' + name + 'Component', spec, {
            tag: tag
        });

        return this;
    }

    return original(this, [name, function () {
        return spec;
    }]);
}

_core.$util.monkeyPatch(_angular.$compileProvider, 'directive', autoConvertDirectiveToComponent);
_core.$util.monkeyPatch(angular.module(), 'directive', autoConvertDirectiveToComponent);

// $populate needs to go away

function $populate($scope, instances) {

    $scope.$on = $scope.$on || angular.noop;
    $scope.$emit = $scope.$emit || angular.noop;

    var _enablePopulateEvents = $scope._enablePopulateEvents;

    if (_enablePopulateEvents) {
        _core.$event.refCount($scope, '_populating', '_populated').then(function () {
            $scope.$emit('populated');
        });
    }

    $scope.$on('populated', function (populatedEvent) {
        populatedEvent.stopPropagation();
    });

    if (_enablePopulateEvents) {
        $scope.$emit('_populating');
    }

    return _core.$promise.all(_core.$util.map(instances, function (instance, name) {

        var promise = void 0;

        if (instance.then) {
            promise = instance;
        } else {
            promise = instance.retrieve();
            $scope[name] = instance;
        }

        return promise.then(function (result) {
            $scope[name] = result;
            return result;
        });
    })).then(function (result) {

        if (_enablePopulateEvents) {
            $scope.$emit('_populated');
        }

        return result;
    });
}

angular.value("$Component", $Component);
angular.value("$populate", $populate);
_angular.$rootScope;

_angular.$compile;

_angular.$injector;

_angular.$compileProvider;

_core.$Class;

_core.$Model;

_core.$util;

_core.$promise;

_core.$config;

_core.$event;

_ng.$cleanRootScope;

_directive.$registerDirective;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/squid/dist/ng/core.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

_core.$event.use({
    on: function on() {
        return _angular.$rootScope.$on.apply(_angular.$rootScope, arguments);
    },
    once: function once(name, handler) {
        var cancel = _core.$event.on(name, function () {
            cancel();
            handler.apply(this, arguments);
        }, true);

        return cancel;
    },
    emit: function emit() {
        return _angular.$rootScope.$emit.apply(_angular.$rootScope, arguments);
    },
    broadcast: function broadcast() {
        return _angular.$rootScope.$broadcast.apply(_angular.$rootScope, arguments);
    }
});

_core.$promise.use(_angular.$q);

_angular.$q;

_angular.$rootScope;

_core.$event;

_core.$promise;

/***/ }),

/***/ "../node_modules/squid/dist/ng/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$registerDirective = $registerDirective;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function $registerDirective(tag, definition) {

    var directiveName = tag.replace(/-([a-z])/g, function (g) {
        return g[1].toUpperCase();
    });

    return _angular2["default"].module().directive(directiveName, definition);
}

_angular2["default"].value("$registerDirective", $registerDirective);

/***/ }),

/***/ "../node_modules/squid/dist/ng/events.js":
/***/ (function(module, exports, __webpack_require__) {



var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

angular.module().run(function () {

    _core.$event.on('$stateChangeStart', function (event) {
        _core.$event.emit('loading');
        _core.$event.emit('loaded');
    });

    var startLoadTime = 0;
    var currentState = 'checkout_init';

    function currentStateName() {
        return _uiRouter.$state.current.name && _uiRouter.$state.current.name.replace(/\./g, '_');
    }

    _core.$event.on('startLoad', function () {

        if (startLoadTime) {
            startLoadTime = _core.$util.now();
        } else if (window.enablePerformance && window.performance.timing.connectEnd && window.performance.timing.navigationStart) {

            var performance = window.performance;
            var timing = window.performance.timing || {};
            var now = performance.now();

            startLoadTime = parseInt(now - (timing.connectEnd - timing.navigationStart), 10);
        }
    });

    _core.$event.on('allLoaded', function () {

        var newState = currentStateName();

        if (!newState) {
            return;
        }

        if (currentState === newState) {
            _core.$event.emit('page_reloaded', currentState);
        } else {

            var duration = void 0;

            if (startLoadTime) {
                duration = _core.$util.now() - startLoadTime;
            }

            var payload = {
                start: currentState,
                end: newState,
                time: duration,
                duration: duration
            };

            _core.$event.emit('$transition', {
                from: currentState,
                toState: _uiRouter.$state.current,
                duration: duration
            });

            _logger.$logger.info('transition', payload);
            _logger.$logger.info('transition_' + currentState + '_to_' + newState, payload);

            _core.$event.emit('page_loaded', currentState, newState);
            _logger.$logger.flush();

            currentState = newState;
        }
    });

    _core.$event.emit('loading');

    var cancel = _core.$event.on('$stateChangeSuccess', function () {
        if (_uiRouter.$state.current.template) {
            cancel();
            setTimeout(function () {
                _core.$event.emit('loaded');
            }, 50);
        }
    });
});

_uiRouter.$state;

_logger.$logger;

_core.$event;

_core.$util;

/***/ }),

/***/ "../node_modules/squid/dist/ng/feature.js":
/***/ (function(module, exports, __webpack_require__) {



var _directive = __webpack_require__("../node_modules/squid/dist/ng/directive.js");

var _locale = __webpack_require__("../node_modules/squid/dist/locale/index.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

(0, _directive.$registerDirective)('feature', function () {
    return {
        restrict: 'A',
        transclude: true,
        scope: {},
        template: '<span ng-if="enabled()" ng-transclude></span>',
        link: function link($scope, element, attr) {
            $scope.enabled = function () {
                return (0, _locale.$feature)(attr.feature) || _core.$integration.getConfig(attr.feature);
            };
        }
    };
});

(0, _directive.$registerDirective)('unless-feature', function () {
    return {
        restrict: 'A',
        transclude: true,
        scope: {},
        template: '<span ng-if="!enabled()" ng-transclude></span>',
        link: function link($scope, element, attr) {
            $scope.enabled = function () {
                return (0, _locale.$feature)(attr.unlessFeature) || _core.$integration.getConfig(attr.unlessFeature);
            };
        }
    };
});
_directive.$registerDirective;

_locale.$feature;

_core.$integration;

/***/ }),

/***/ "../node_modules/squid/dist/ng/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _core = __webpack_require__("../node_modules/squid/dist/ng/core.js");

Object.keys(_core).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _core[key];
    }
  });
});

var _route = __webpack_require__("../node_modules/squid/dist/ng/route.js");

Object.keys(_route).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _route[key];
    }
  });
});

var _component = __webpack_require__("../node_modules/squid/dist/ng/component.js");

Object.keys(_component).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _component[key];
    }
  });
});

var _feature = __webpack_require__("../node_modules/squid/dist/ng/feature.js");

Object.keys(_feature).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _feature[key];
    }
  });
});

var _locale = __webpack_require__("../node_modules/squid/dist/ng/locale.js");

Object.keys(_locale).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _locale[key];
    }
  });
});

var _module = __webpack_require__("../node_modules/squid/dist/ng/module.js");

Object.keys(_module).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _module[key];
    }
  });
});

var _ng = __webpack_require__("../node_modules/squid/dist/ng/ng.js");

Object.keys(_ng).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ng[key];
    }
  });
});

var _directive = __webpack_require__("../node_modules/squid/dist/ng/directive.js");

Object.keys(_directive).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _directive[key];
    }
  });
});

var _events = __webpack_require__("../node_modules/squid/dist/ng/events.js");

Object.keys(_events).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _events[key];
    }
  });
});

var _pxp = __webpack_require__("../node_modules/squid/dist/ng/pxp.js");

Object.keys(_pxp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _pxp[key];
    }
  });
});

var _lazyLoadRoutes = __webpack_require__("../node_modules/squid/dist/ng/lazyLoadRoutes.js");

Object.keys(_lazyLoadRoutes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _lazyLoadRoutes[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/squid/dist/ng/lazyLoadRoutes.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.lazyLoadRoute = exports.findRelativeState = exports.initRoute = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");

var getHash = function getHash(url) {
    if (!url || !~url.indexOf('#')) {
        // eslint-disable-line no-bitwise
        return;
    }

    url = url.split('#');
    return url[url.length - 1];
};

/**
 *
 * get parent state, e.g "checkout.sidebar.addCard" -> "checkout.sidebar"
 */
var getParentState = function getParentState(path) {
    return _uiRouter.$state.get(path.slice(0, path.lastIndexOf('.')));
};

/**
 * Find route by slug
 * path - full path of the current route, e.g "checkout.payWithSelection"
 * slug - path of the route that we want to search, e.g "payWithSelection"
 */
var getRoute = function getRoute(path, slug) {
    var route = getParentState(path);

    if (!route) {
        return;
    }
    var children = route.children;

    if (children) {
        return children.find(function (child) {
            return child.slug === slug;
        });
    }
};

/**
 * Lazy load children routes in the background
 */
var lazyLoadChildren = function lazyLoadChildren(children) {
    if (children) {
        _logger.$logger.info('lazy_loading_route_load_children');
        children.forEach(function (child) {
            if (child.lazyRoute) {
                // request to download js chunk (dynamic import)
                child.lazyRoute();
            }
        });
    }
};

/**
 * Dynamically load route and initialize / register it
 * @param {Object} routeObj - route object from Route definition, e.g
 *  {
 *      name: '$PayWithSelection',
 *      slug: 'payWithSelection',
 *      lazyRouter: () => import('pages/payWithSelection/route)
 *  }
 *
 * @param {Route} parent - parent of the passed routeObj
 * @param {String} fullRoutePath - full path of the route, e.g "checkout.payWithselection"
 */
var initRoute = exports.initRoute = function initRoute(routeObj, parent, fullRoutePath) {
    if (!routeObj) {
        return;
    }

    var name = routeObj.name,
        slug = routeObj.slug,
        attributes = routeObj.attributes,
        lazyRoute = routeObj.lazyRoute;


    _logger.$logger.info('lazy_loading_route_init', {
        name: name,
        slug: slug,
        fullRoutePath: fullRoutePath
    });

    return lazyRoute().then(function (route) {
        if (!route) {
            return;
        }
        if ((typeof route === 'undefined' ? 'undefined' : _typeof(route)) === 'object') {
            route = route[name];
        }
        var childRoute = new route({ //eslint-disable-line
            parent: parent || getParentState(fullRoutePath),
            childSpec: _core.$util.extend(routeObj, { route: route }),
            childAttributes: attributes
        });
        childRoute.register();
        return childRoute;
    });
};

/**
 * Promisify all lazy routes
 * Example:
 *      targetState = 'checkout.sidebar.addCardFlow.addCard'
 *      Lets say 'addCard', 'addCardFlow' and 'addCard' are lazy routes
 *      1. Go through each possible route, e.g 'checkout', 'checkout.sidebar', 'checkout.sidebar.addCardFlow', 'checkout.sidebar.addCardFlow.addCard'
 *      2. Check if each exists / already registered
 *      3. if route is not registered -> find that route and return promise
 * @param {String} targetState full path of the target route
 * Returns an array of promisified functions
 */
var findAndPromisifyRoutes = function findAndPromisifyRoutes(targetState) {
    var splittedTargetState = targetState.split('.');
    var states = splittedTargetState.slice(1);
    var routes = [];
    var path = splittedTargetState[0];

    states.forEach(function (state) {
        path += '.' + state;
        var fullRoutePath = path;

        if (!_uiRouter.$state.get(path)) {
            routes.push(function (parent) {
                var route = getRoute(fullRoutePath, state);

                return initRoute(route, parent, fullRoutePath);
            });
        }
    });
    return routes;
};

/**
 * Checks if it's a relative path (having `.` or `^`)
 * @param {String} stateName - path of the state, e.g `.mychildRoute`
 */
var isRelative = function isRelative(stateName) {
    return stateName.indexOf('.') === 0 || stateName.indexOf('^') === 0;
};

/**
 * finds a full path of the relative state name
 * examples:
 * '^' - will go to a parent state
 * '^.sibling' - will go to a sibling state
 * '.child.grandchild' - will go to grandchild state
 * @param {String / Object} stateOrName - state to find, e.g `^.selectFi`
 * Returns full path name of the state, e.g `^.selectFi` -> `checkout.selectFi`
 */
var findRelativeState = exports.findRelativeState = function findRelativeState(stateOrName) {
    if (!stateOrName) {
        return;
    }
    var base = _uiRouter.$state.current;

    var rel = stateOrName.split('.');
    var current = base;
    var i = 0;

    for (; i < rel.length; i++) {
        if (rel[i] === '' && i === 0) {
            current = base;
            continue;
        }
        if (rel[i] === '^') {
            if (!current.parent) {
                throw new Error('lazy-loading: path \'' + stateOrName + '\' not valid for state \'' + base.name + '\'');
            }
            current = current.parent;
            continue;
        }
        break;
    }
    rel = rel.slice(i).join('.');
    return current.name + (current.name && rel ? '.' : '') + rel;
};

/**
 * Lazy load route and redirect if successfull or reject if route was not found
 * Note: routes will be loading sequentialy for now to load parent routes first if they are lazy as well.
 * Example:
 *      targetState = 'checkout.sidebar.addCardFlow.addCard'
 *      Lets say 'addCard', 'addCardFlow' and 'addCard' are lazy routes and represent separate js chunk
 *      We have to load each js chunk in order one by one to be able to register them and attach to corresponding parents.
 * @param {String} targetState - route path, e.g 'checkout.payWithSelection'
 * @param {Object} targetParams - params which route may need
 * @param {Boolean} shouldChangeState - if state should be changed after route is loaded
 */
var lazyLoadRoute = exports.lazyLoadRoute = function lazyLoadRoute(targetState) {
    var targetParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var shouldChangeState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    if (!targetState) {
        return _core.$promise.reject(new Error('lazy_loading_target_state_is_empty'));
    }
    _logger.$logger.info('lazy_loading_route', {
        targetState: targetState,
        targetParams: targetParams
    });
    if (isRelative(targetState)) {
        targetState = findRelativeState(targetState, _uiRouter.$state.current);
    }
    _core.$event.emit('loading');

    var routes = findAndPromisifyRoutes(targetState);

    return _core.$promise.sequential(routes).then(function (result) {
        if (_uiRouter.$state.get(targetState)) {
            if (result) {
                lazyLoadChildren(result.children);
            }
            _logger.$logger.info('lazy_loading_route_state_change', {
                targetState: targetState,
                targetParams: targetParams
            });
            if (!shouldChangeState) {
                return _core.$promise.resolve();
            }
            return _uiRouter.$state.go(targetState, targetParams)['catch'](function (err) {
                if (err.message === 'transition prevented' || err.message === 'transition superseded') {
                    return _core.$promise.resolve();
                }
                return _core.$promise.reject(err);
            });
        } else {
            return _core.$promise.reject(new Error('lazy_loading_state_was_not_loaded'));
        }
    })['catch'](function (error) {
        // in case of exceptions, spinner must dissapear, because for each 'loading' event
        // that's sent in the beginning of the function must be corresponding 'loaded' event
        // otherwise, there will be infinite spinner

        _logger.$logger.info('lazy_loading_route_error', {
            targetState: targetState,
            targetParams: targetParams,
            errorMessage: error && error.message,
            errorStack: error && error.stack
        });

        return _core.$promise.reject(error);
    })['finally'](function () {
        _core.$event.emit('loaded');
    });
};

/**
 * mostly needed for use cases when user types route manually
 */
window.addEventListener('hashchange', function (event) {
    if (_config.$meta.codeSplitting) {
        var fromHash = getHash(event.oldURL);
        var toHash = getHash(event.newURL || window.location.hash);

        // skip lazy loading in case hash is undefined or empty
        // example -> <a href="#" ng-click="openModal()">OpenModal</a>
        // in that case `toHash` will be empty
        if (!toHash) {
            return;
        }

        var getHashQueryParams = function getHashQueryParams(path) {
            var splittedPath = path.split('?');
            // e.g #/checkout/genericError?code=ERROR_CODE -> code=ERROR_CODE
            var hashParams = splittedPath.length > 1 && splittedPath[1];

            if (hashParams) {
                // e.g code=ERROR_CODE -> { code: ERROR_CODE }
                return _core.$util.params(hashParams);
            }
        };
        // e.g #/checkout/review -> checkout.review
        var path = toHash.slice(1).replace(/\//g, '.');
        var hashQueryParams = getHashQueryParams(path);

        if (hashQueryParams) {
            // e.g checkout.genericError?code=ERROR_CODE -> checkout.genericError
            path = path.split('?')[0];
        }

        if (_uiRouter.$state.get(path)) {
            return;
        }

        _logger.$logger.info('hashchange_lazy_loading', {
            from: fromHash,
            to: toHash
        });

        lazyLoadRoute(path, hashQueryParams)['catch'](function () {
            _logger.$logger.info('hashchange_lazy_loading_error', {
                from: fromHash,
                to: toHash,
                params: hashQueryParams
            });
        });
    }
});

_uiRouter.$state;

_logger.$logger;

_core.$util;

_core.$promise;

_core.$event;

_config.$meta;

/***/ }),

/***/ "../node_modules/squid/dist/ng/locale.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _locale = __webpack_require__("../node_modules/squid/dist/locale/index.js");

(0, _angular.$registerDirective)('content', function () {
    return {
        restrict: 'A',

        link: function link($scope, element, attributes) {
            $scope.content = $scope.htmlContent = function (key, props) {
                if (attributes.content) {
                    key = attributes.content + '.' + key;
                }
                var content = _locale.Content.get(key, props);

                if (content.toString()) {
                    return content;
                } else {
                    return;
                }
            };
        }
    };
});

(0, _angular.$registerDirective)('bind-html-compile', function () {

    return {
        restrict: 'A',
        link: function link($scope, $element, $attrs) {
            $scope.$watch(function () {
                return $scope.$eval($attrs.bindHtmlCompile);
            }, function (value) {
                $element.html(value && value.toString());
                (0, _angular.$compile)($element.contents())($scope);
            });
        }
    };
});

(0, _angular.$registerDirective)('format-currency', function () {

    return {
        restrict: 'E',
        template: '<span ng-bind-html="amount_formatted" class="ltrOverride"></span>',
        scope: {
            amount: '=?',
            symbol: '=?',
            code: '=?',
            currencyStyle: '@?'
        },
        controller: ['$scope', function ($scope) {

            function format() {
                $scope.amount_formatted = _angular.$sce.trustAsHtml((0, _locale.formatCurrency)($scope.amount, $scope.code, true, $scope.currencyStyle));
            }

            $scope.$on('$destroy', _core.$event.on('localeChange', format));

            $scope.$watch('amount', function (newValue, oldValue) {
                if (newValue !== oldValue && _locale.$locale.country) {
                    format();
                }
            });

            if (_locale.$locale.country) {
                format();
            }
        }] // controller
    }; // return
}); // registerDirective


(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().value('$sanitize', function (val) {
    if (val instanceof _locale.Content) {
        return val.toSafeString();
    }
    return (0, _locale.sanitize)(val);
});

_angular.$sce;

_angular.$registerDirective;

_angular.$compile;

_core.$event;

_locale.formatCurrency;

_locale.sanitize;

_locale.Content;

_locale.$locale;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/squid/dist/ng", "../node_modules/squid/dist/ng/locale.js"))

/***/ }),

/***/ "../node_modules/squid/dist/ng/module.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.module = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _module = _angular2['default'].module;
exports.module = _module;

/***/ }),

/***/ "../node_modules/squid/dist/ng/ng.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$angularInvoke = $angularInvoke;
exports.$once = $once;
exports.$cleanRootScope = $cleanRootScope;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

function $angularInvoke(method) {
    try {
        return method();
    } catch (err) {
        _angular.$injector.get('$exceptionHandler')(err);
    }
}

function $once(name, handler) {
    var cancel = _core.$event.on(name, function () {
        cancel();
        handler.apply(this, arguments);
    }, true);
}

function $cleanRootScope(rootScope) {

    var keys = Object.keys(rootScope);

    var autoCleanupEventHandlers = [];
    var eventHandlers = [];
    var eventCancelers = [];

    _core.$util.monkeyPatch(rootScope, '$on', function (_ref, original) {
        var name = _ref[0],
            handler = _ref[1],
            once = _ref[2];


        var cancel = original();

        var $state = void 0;

        try {
            $state = _angular.$injector.get('$state');
        } catch (err) {
            // pass
        }

        if (name === '$destroy' || !$state || !$state.current || !$state.current.name || $state.current.name === 'default') {
            autoCleanupEventHandlers.push(cancel);
            return function autoCleanedUpCancel() {}; // eslint-disable-line no-empty-function
        }

        if (once) {
            eventCancelers.push(cancel);
            return cancel;
        }

        // Let ng-router do its thing
        if (handler.toString().indexOf('updateView') !== -1) {
            return cancel;
        }

        var stack = void 0;

        try {
            throw new Error('$rootScope.$on');
        } catch (err) {
            stack = err.stack;
        }

        var reference = {
            name: name,
            handler: handler.toString(),
            stack: stack
        };

        eventHandlers.push(reference);

        return function () {
            cancel();
            eventHandlers.splice(eventHandlers.indexOf(reference), 1);
        };
    });

    return function () {

        _core.$event.emit('$destroy');

        autoCleanupEventHandlers.forEach(function (canceler) {
            return canceler();
        });
        autoCleanupEventHandlers = [];

        Object.keys(rootScope).forEach(function (key) {
            if (keys.indexOf(key) === -1) {
                delete rootScope[key];
            }
        });

        if (eventHandlers.length) {
            throw new Error('$rootScope event handlers not cleaned up:\n\n' + eventHandlers.map(function (eventHandler) {
                return eventHandler.name + '\n\n' + eventHandler.handler + '\n\n' + eventHandler.stack;
            }).join('\n\n'));
        }

        eventCancelers.forEach(function (cancel) {
            return cancel();
        });
    };
}

angular.value("$angularInvoke", $angularInvoke);
angular.value("$once", $once);
angular.value("$cleanRootScope", $cleanRootScope);
_angular.$injector;

_core.$util;

_core.$event;

/***/ }),

/***/ "../node_modules/squid/dist/ng/pxp.js":
/***/ (function(module, exports, __webpack_require__) {



var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

_core.$event.on('pxp_res', function (event, pxpRes) {
    _uiRouter.$state.current.trackingData = _uiRouter.$state.current.trackingData || {};
    _uiRouter.$state.current.trackingData.pxpData = _uiRouter.$state.current.trackingData.pxpData || [];
    _uiRouter.$state.current.trackingData.pxpData.push(pxpRes);
});

_uiRouter.$state;

_core.$event;

/***/ }),

/***/ "../node_modules/squid/dist/ng/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ComponentRoute = exports.$Route = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _locale = __webpack_require__("../node_modules/squid/dist/locale/index.js");

var _component = __webpack_require__("../node_modules/squid/dist/ng/component.js");

var _ng = __webpack_require__("../node_modules/squid/dist/ng/ng.js");

var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");

var _lazyLoadRoutes = __webpack_require__("../node_modules/squid/dist/ng/lazyLoadRoutes.js");

var $Route = exports.$Route = _core.$Class.extend('$ComponentRoute', {

    childSpec: {},

    init: function init() {
        var _this = this;

        this.validate();

        this.url = '/' + (this.path || this.name);

        if (this.query) {
            this.url += '?' + this.query.join('&');
        }

        this.hasResolver = Boolean(this.resolve);

        var controller = this.controller = ['$scope', function ($scope) {
            $scope.route = _this;
            if ($scope.componentScope) {
                delete $scope.componentScope.view;
            }
        }];

        if (this.get('resolve.action')) {
            this.controller = ['$scope', 'action', function ($scope, action) {
                _angular.$injector.invoke(controller, this, { $scope: $scope });
                if (action) {
                    if (!action.newState) {
                        _angular.$location.replace();
                    }

                    if (angular.isObject(action) && action.to) {
                        _uiRouter.$state.go(action.to, action.params);
                    } else {
                        _uiRouter.$state.go(action);
                    }
                }
            }];
        }
    },

    validate: function validate() {

        if (_core.$config.deploy.isLive() && !_core.$config.deploy.isTest()) {
            return;
        }

        var routeName = this.constructor.name;

        if (!this.name && !this.path) {
            throw new Error(routeName + ' :: expected property \'path\'');
        }

        if (this.url) {
            _logger.$logger.warn(routeName + ' :: unexpected property \'url\' :: ' + this.url);
        }

        if (this.query && !(this.query instanceof Array)) {
            throw new Error(routeName + ' :: expected property \'query\' to be array of query params');
        }

        if (this.controller) {
            // throw new Error(`${routeName} :: unexpected property 'controller'`);
        }

        if (this.resolve) {
            if (this.resolve.action && !(this.resolve.action instanceof Function)) {
                throw new Error(routeName + ' :: expected property \'resolve.action\' to be a function');
            }

            Object.keys(this.resolve).forEach(function (name) {
                if (name === 'data') {
                    _logger.$logger.warn(routeName + ' :: unexpected resolver :: ' + name);
                } else if (name !== 'action') {
                    throw new Error(routeName + ' :: unexpected resolver :: ' + name);
                }
            });
        }

        if (this.template) {
            throw new Error(routeName + ' :: unexpected property \'template\'');
        }

        if (!this.directive && !this.resolve && !this.resolve.action) {
            throw new Error(routeName + ' :: expected property \'directive\'');
        }

        if (this.directive && angular.isString(this.directive) && !this.getDirective()) {
            throw new Error(routeName + ' :: unknown directive \'' + this.directive + '\'');
        }

        if (this.directive && !angular.isString(this.directive) && !_component.$Component.isChild(this.directive)) {
            throw new Error(routeName + ' :: expected directive to be subclass of $Component');
        }

        if (this.children) {
            this.children.forEach(function (childSpec) {

                if (!childSpec.route && !childSpec.name) {
                    throw new Error(routeName + ' :: child expected property \'route\'');
                }

                var ChildRoute = childSpec.route;
                var childName = childSpec.name || ChildRoute.name;

                // skip loading route as it won't be available to validate
                if (_config.$meta.codeSplitting && childSpec.lazyRoute) {
                    return;
                }

                if (!ChildRoute && childSpec.name) {
                    try {
                        ChildRoute = _angular.$injector.get(childSpec.name);
                    } catch (err) {
                        throw new Error(routeName + ' :: could not find child route \'' + childName + '\'');
                    }
                }

                if (!$Route.isChild(ChildRoute)) {
                    throw new Error(routeName + ' :: ' + childName + ' :: expected child to be instance of $Route');
                }
            });
        }
    },
    goto: function goto(route) {
        return _uiRouter.$state.go(route.replace('this.', this.absolutePath + '.'));
    },
    getDirective: function getDirective() {
        return _angular.$injector.get(_core.$util.dasherizeToCamel(this.getDirectiveTag() + 'Directive'))[0];
    },
    getDirectiveTag: function getDirectiveTag() {
        return angular.isString(this.directive) ? this.directive : this.directive.prototype.tag;
    },


    bootstrap: function bootstrap(defaultState, middleware) {
        var _this2 = this;

        return (0, _ng.$angularInvoke)(function () {
            // only bootstrap if not bootstrapped already
            var element = angular.element(document.body);

            if (!element.injector()) {
                angular.bootstrap(element, ['app']);
            }

            return _this2.load(defaultState, middleware);
        });
    },

    load: function load(defaultState, middleware) {

        defaultState = defaultState || this.defaultState;
        middleware = middleware || this.middleware;

        _logger.$logger.info('bootstrap_route', {
            route: this.path || this.name
        });

        var logStateNotFoundAndThrow = function logStateNotFoundAndThrow(_ref) {
            var unfoundState = _ref.unfoundState,
                fromState = _ref.fromState,
                fromParams = _ref.fromParams,
                _ref$logName = _ref.logName,
                logName = _ref$logName === undefined ? '' : _ref$logName;

            _logger.$logger.error('state_not_found' + logName, {
                name: unfoundState.to,
                from: fromState.name,
                fromParams: fromParams,
                hash: window.location.hash
            });
            throw new Error('state_not_found' + logName + ': ' + unfoundState.to);
        };

        (0, _ng.$once)('$stateNotFound', function (event, unfoundState, fromState, fromParams) {
            if (!_config.$meta.codeSplitting) {
                event.preventDefault();
                logStateNotFoundAndThrow({ unfoundState: unfoundState, fromState: fromState, fromParams: fromParams });
            }
        });

        // for code splitting this event handler will be triggered every single time user tries to load lazy route
        // so we need to have it being listening more than once
        _core.$event.on('$stateNotFound', function (event, unfoundState, fromState, fromParams) {
            if (_config.$meta.codeSplitting) {
                event.preventDefault();
                // if route was not found - lazy load it or throw state_not_found if it was not found
                (0, _lazyLoadRoutes.lazyLoadRoute)(unfoundState.to, unfoundState.toParams)['catch'](function () {
                    logStateNotFoundAndThrow({ unfoundState: unfoundState, fromState: fromState, fromParams: fromParams, logName: '_lazy_loading' });
                });
            }
        });

        this.register();

        _uiRouter.$urlRouterProvider.otherwise(function () {
            return _logger.$logger.info('otherwise_after_bootstrap', {
                hash: window.location.hash
            });
        });

        this.runMiddleware(middleware).then(function () {
            var targetState = void 0;
            var targetParams = void 0;

            if (window.location.hash && window.location.hash.indexOf('#/') === 0) {

                targetState = window.location.hash.slice(2).split('?')[0].replace(/^\/+/, '').replace(/\/+$/, '').replace(/\//g, '.');

                targetParams = _core.$util.params(window.location.hash.slice(2).split('?')[1] || '');
            }

            _logger.$logger.info('initializing_route', {
                target: targetState,
                defaultState: defaultState,
                hash: window.location.hash
            });

            _angular.$location.replace();

            /**
             * load default state in case target state was not found
             * e.g checkout.landing - is the default state in Hermes
             */
            var loadDefaultState = function loadDefaultState() {
                if (_uiRouter.$state.get(defaultState)) {
                    _logger.$logger.info('default_state', {
                        stateName: defaultState
                    });
                    return _uiRouter.$state.go(defaultState)['catch'](function (err) {
                        if (err.message === 'transition prevented') {
                            _logger.$logger.warn('transition_prevented', {
                                targetState: defaultState
                            });
                            return _core.$promise.resolve();
                        }
                        return _core.$promise.reject(err);
                    });
                }

                throw new Error('Default state not found: ' + defaultState);
            };

            if (targetState) {
                var logUnknownState = function logUnknownState() {
                    var logName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

                    _logger.$logger.info('unknown_state' + logName, {
                        stateName: targetState
                    });
                };

                if (_uiRouter.$state.get(targetState)) {
                    _logger.$logger.info('existing_state', {
                        stateName: targetState
                    });
                    return _uiRouter.$state.go(targetState, targetParams)['catch'](function (err) {
                        // lib/js/security.js event listener handles auth required state changes
                        // and cancels transitions if user not authenticated
                        if (err.message === 'transition prevented') {
                            _logger.$logger.warn('transition_prevented', {
                                targetState: targetState
                            });
                            return _core.$promise.resolve();
                        }
                        return _core.$promise.reject(err);
                    });
                } else if (_config.$meta.codeSplitting) {
                    // try to lazy load route and catch / handle redirect errors
                    // 1. If route was not found -> log and try to load default state
                    // 2. If route was found but redirect throws an error -> reject
                    return (0, _lazyLoadRoutes.lazyLoadRoute)(targetState, targetParams)['catch'](function (err) {
                        if (err.message === 'lazy_loading_state_was_not_loaded') {
                            logUnknownState('_lazy_loading');
                            return loadDefaultState();
                        } else {
                            return _core.$promise.reject(err);
                        }
                    });
                } else {
                    logUnknownState();
                }
            }
            return loadDefaultState();
        })['catch'](function (err) {
            return _angular.$injector.get('$exceptionHandler')(err);
        });
    },

    runMiddleware: function runMiddleware(middleware) {

        _logger.$logger.info('middleware', {
            priority: _core.$util.map(middleware, function (method) {
                return method.name;
            }).join('|')
        });

        var promise = _core.$promise.resolve();

        angular.forEach(middleware, function (method) {
            promise = promise.then(function () {

                if (method.name) {
                    _logger.$logger.info('middleware_' + method.name);
                }

                return method();
            });
        });

        return promise;
    },

    register: function register() {
        var _this3 = this;

        this.template = this.constructTemplate(this.childAttributes || {});

        this.absolutePath = this.path || this.name;

        if (this.parent) {
            this.absolutePath = this.parent.absolutePath + '.' + this.absolutePath;
        }

        if (!_uiRouter.$state.get(this.absolutePath)) {
            _uiRouter.$stateProvider.state(this.absolutePath, this);
        }

        angular.forEach(this.children, function (childSpec) {
            // skip registering child if it's supposed to be lazy loaded
            if (_config.$meta.codeSplitting && childSpec.lazyRoute) {
                return;
            }
            var ChildRoute = childSpec.route || _angular.$injector.get(childSpec.name);

            var childRoute = new ChildRoute({
                parent: _this3,
                childSpec: childSpec,
                childAttributes: childSpec.attributes
            });

            childRoute.register();
        });
    },

    /**
     * Constructs the template string for this route. If route.directive = 'xo-add-bank', then the template will be
     * '<xo-add-bank/>'.
     * If attributes are specified, they will be passed to directive. Ex: <xo-add-bank attrname = "attrvalue"/>
     *
     * @param attributes - A map of name value pairs - {name: value}.
     * @returns {string}
     */
    constructTemplate: function constructTemplate(attributes) {
        var self = this;

        if (!self.directive) {
            return;
        }

        attributes['component-route'] = 'route';

        if (this.parent) {
            attributes['export'] = 'view';
        }

        var tag = this.getDirectiveTag();

        var paramString = '';

        angular.forEach(attributes, function (value, key) {
            paramString += ' ' + key + '="' + value + '"';
        });

        return '<div ' + tag + ' ' + paramString + '></div>';
    }
});

if (!_uiRouter.$state.get('default')) {
    _uiRouter.$stateProvider.state('default', {
        auth: false
    });
}

$Route.reopenClass({
    render: function render(props) {

        _core.$event.emit('$resetState');
        _core.$loader.reset();
        _uiRouter.$state.go('default');
        setTimeout.flush();

        var $scope = angular.extend(_angular.$rootScope.$new(), props);

        var cleanRootScope = (0, _ng.$cleanRootScope)(_angular.$rootScope);
        var element = (0, _angular.$compile)('<div id="app"><ui-view></ui-view></div>')($scope);

        afterEach(_core.$util.once(function () {
            $scope.$destroy();
            cleanRootScope();
            _core.$loader.reset();
            angular.element(document.getElementById('app')).remove();
        }));

        var route = new this({
            // Pass child attributes to simulate a route receiving scope variables from the parent
            childAttributes: _core.$util.reduce(props, function (result, val, key) {
                result[_core.$util.camelToDasherize(key)] = key;
                return result;
            }, {})
        });

        route.bootstrap(route.defaultState || route.path || route.name);
        setTimeout.flush();

        element.isolateScope = function () {
            throw new Error('Please test this element by interfacing with its public api: define mock endpoints, and interact with html links, buttons and form fields');
        };

        // attaching to the document so DOM Api works in karma flow tests (e.g document.getElementById('myId'))
        angular.element(document.body).append(element);

        return element;
    },


    assertActive: function assertActive() {
        var isState = _uiRouter.$state.current instanceof this;

        if (!isState) {
            throw new Error('Current state should be "' + (this.prototype.path || this.prototype.name) + '", found "' + _uiRouter.$state.current.name + '"');
        }
    }
});

function getPageTitle(stateName) {

    var state = _uiRouter.$state.get(stateName);

    if (!state) {
        return;
    }

    if (state.titleContent) {
        return _locale.$locale.content.get(state.titleContent);
    }
}

function changePageTitle() {

    document.documentElement.setAttribute('lang', _locale.$locale.lang);

    if (!_uiRouter.$state.current || !_uiRouter.$state.current.name) {
        return;
    }

    var fullStateTitle = [];

    _uiRouter.$state.current.name.split('.').reduce(function (a, b) {

        var stateName = [a, b].filter(Boolean).join('.');
        var stateTitle = getPageTitle(stateName);

        if (stateTitle) {
            fullStateTitle.push(stateTitle);
        }

        return stateName;
    }, null);

    document.title = _core.$util.unique(fullStateTitle).join(' - ');
}

_core.$event.on('$stateChangeSuccess', changePageTitle);
_core.$event.on('contentChange', changePageTitle);

var $ComponentRoute = exports.$ComponentRoute = $Route;

angular.value("$Route", $Route);
angular.value("$ComponentRoute", $ComponentRoute);
_angular.$rootScope;

_angular.$location;

_angular.$injector;

_angular.$compile;

_uiRouter.$state;

_uiRouter.$stateProvider;

_uiRouter.$urlRouterProvider;

_logger.$logger;

_core.$config;

_core.$Class;

_core.$util;

_core.$promise;

_core.$event;

_core.$loader;

_locale.$locale;

_component.$Component;

_ng.$cleanRootScope;

_ng.$angularInvoke;

_ng.$once;

_config.$meta;

_lazyLoadRoutes.lazyLoadRoute;

/***/ }),

/***/ "../node_modules/squid/dist/paypal/config.js":
/***/ (function(module, exports, __webpack_require__) {



var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _env = __webpack_require__("../node_modules/squid/dist/paypal/env.js");

_core.$config.deploy = _core.$config.deploy || _env.$env;

_core.$config;

_env.$env;

/***/ }),

/***/ "../node_modules/squid/dist/paypal/env.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var $env = exports.$env = {

    isLocal: function isLocal() {
        return window.location.hostname === 'localhost' || window.location.hostname === 'localhost.paypal.com';
    },

    isStage: function isStage() {
        return Boolean(window.location.hostname.match(/^.*\.qa\.paypal\.com$/));
    },

    isSandbox: function isSandbox() {
        return Boolean(window.location.hostname.match(/^.*\.sandbox\.paypal\.com$/));
    },

    isLive: function isLive() {
        return window.location.hostname === 'www.paypal.com';
    },

    isTest: function isTest() {
        return false;
    }
};

angular.value("$env", $env);

/***/ }),

/***/ "../node_modules/squid/dist/paypal/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _env = __webpack_require__("../node_modules/squid/dist/paypal/env.js");

Object.keys(_env).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _env[key];
    }
  });
});

var _config = __webpack_require__("../node_modules/squid/dist/paypal/config.js");

Object.keys(_config).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _config[key];
    }
  });
});

var _pxp = __webpack_require__("../node_modules/squid/dist/paypal/pxp.js");

Object.keys(_pxp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _pxp[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/squid/dist/paypal/pxp.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$PXPModel = undefined;
exports.$getPxpTreatments = $getPxpTreatments;
exports.$pxp = $pxp;
exports.$pxpMatch = $pxpMatch;
exports.$pxpFactors = $pxpFactors;
exports.$elmo = $elmo;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _locale = __webpack_require__("../node_modules/squid/dist/locale/index.js");

var $PXPModel = exports.$PXPModel = _core.$Model.extend({
    api: new _core.$Api({
        uri: '/api/pxp/:pagename'
    })
});

function logPxp(pxpRes, params, logPayload) {
    var exp_name = [];
    var xe = [];
    var xt = [];
    var isElmoExperiment = params.isElmoExperiment;

    angular.forEach(pxpRes.treatments, function (treatment) {

        _logger.$logger.info('treatment_' + treatment.treatment_name, angular.extend({
            experiment: pxpRes.pagename,
            treatment: treatment.treatment_name,
            experiment_id: treatment.experiment_id,
            treatment_id: treatment.treatment_id,
            loc_country: _locale.$locale.country,
            loc_lang: _locale.$locale.lang,
            exp_source: isElmoExperiment ? 'elmo' : 'pxp'
        }, params, logPayload));

        exp_name.push(treatment.treatment_name);
        xe.push(treatment.experiment_id);
        xt.push(treatment.treatment_id);
    });

    _logger.$logger.info('pxp_' + pxpRes.pagename, angular.extend({
        pxp_exp_id: xe.join('|'),
        pxp_trtmnt_id: xt.join('|'),
        treatments: exp_name.join('|'),
        loc_country: _locale.$locale.country,
        loc_lang: _locale.$locale.lang,
        exp_source: isElmoExperiment ? 'elmo' : 'pxp'
    }, params, logPayload));

    _logger.$logger.info('fpti_pxp_check', {
        from: 'PXP_CHECK',
        to: 'process_pxp_check',
        pxp_exp_id: xe.join(','),
        pxp_trtmnt_id: xt.join(','),
        exp_source: isElmoExperiment ? 'elmo' : 'pxp'
    });

    _core.$event.emit('pxp_res', pxpRes);
}

function $getPxpTreatments(id, params, logPayload) {
    var forceApiCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var silent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var isElmoExperiment = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;


    return _core.$promise.run(function () {
        if (isElmoExperiment) {
            Object.assign(params, { isElmoExperiment: isElmoExperiment });
        }

        var pxp = $PXPModel.instance(_core.$util.buildURL(id, params), { pagename: id });
        var forceTreatments = _core.$util.param('pxp_' + id) || _core.$util.param('elmo_' + id);

        if (forceTreatments) {
            var treatments = forceTreatments.split(',').filter(Boolean);

            pxp.treatments = treatments.map(function (treatment_name) {
                return {
                    treatment_name: treatment_name
                };
            });

            return pxp;
        }

        if (forceApiCall) {
            pxp.cached = false;

            return pxp.reload({
                params: params,
                silent: silent
            });
        }

        return pxp.retrieve({
            params: params,
            silent: silent,
            // Ignore all errors from this api, by passing transientError as true
            // Pxps are not critical calls, so they should fail silently without fallbacks (page reload / showing error page)
            transientError: true
        });
    }).then(function (pxp) {
        if (!pxp.cached) {
            logPxp(pxp, params, logPayload);
        }

        pxp.cached = true;

        return pxp;
    });
}

function $pxp(id, params, pattern) {
    var forceApiCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var silent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var isElmoExperiment = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

    if (!pattern) {
        pattern = params;
        params = {};
    }

    pattern = new RegExp('^' + pattern + '$');

    return exports.$getPxpTreatments(id, params, null, forceApiCall, silent, isElmoExperiment).then(function (experimentResponse) {
        var result = void 0;

        (experimentResponse.treatments || []).some(function (treatment) {
            if (!pattern.test(treatment.treatment_name)) {
                return false;
            }

            result = {
                treatment_name: treatment.treatment_name,
                factors: treatment.factors
            };

            return true;
        });

        return result;
    });
}

function $pxpMatch(id, params, patterns, logPayload) {
    if (!patterns) {
        patterns = params;
        params = {};
    }

    return exports.$getPxpTreatments(id, params, logPayload).then(function (pxpResponse) {
        var result = {};

        angular.forEach(patterns, function (pattern, name) {
            pattern = new RegExp('^' + pattern + '$');
            result[name] = false;

            (pxpResponse.treatments || []).some(function (treatment) {
                if (!pattern.test(treatment.treatment_name)) {
                    return false;
                }

                result[name] = true;
                return true;
            });
        });

        return result;
    });
}

function $pxpFactors(id, params, pattern) {
    params.factors = 'true';
    return $pxp(id, params, pattern).then(function (pxpResponse) {
        var result = void 0;

        if (pxpResponse && pxpResponse.factors) {
            result = { treatment_name: pxpResponse.treatment_name };
            var pxpFactors = pxpResponse.factors;
            var length = pxpFactors.length;

            for (var i = 0; i < length; i++) {
                result[pxpFactors[i].name] = pxpFactors[i].value;
            }
        }

        return result;
    });
}

function $elmo(id, params, pattern) {
    var forceApiCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var silent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

    var isElmoExperiment = true;

    return $pxp(id, params, pattern, forceApiCall, silent, isElmoExperiment);
}

window.$pxp = $pxp;
window.$elmo = $elmo;

angular.value("$PXPModel", $PXPModel);
angular.value("$getPxpTreatments", $getPxpTreatments);
angular.value("$pxp", $pxp);
angular.value("$pxpMatch", $pxpMatch);
angular.value("$pxpFactors", $pxpFactors);
angular.value("$elmo", $elmo);
_logger.$logger;

_core.$Model;

_core.$Api;

_core.$util;

_core.$promise;

_core.$event;

_locale.$locale;

/***/ }),

/***/ "../node_modules/ul-inline/dist/inject.js":
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function() {

!function(a,b){a.PAYPAL=a.PAYPAL||{},a.PAYPAL.unifiedLogin=b()}(this,function(){function a(a,b){var c,d={src:a,height:b.height||239,style:"width: 100%;",name:b.name||"injectedUl",frameborder:0,scrolling:b.scrolling||"no",title:b.title||"PayPal",sandbox:"allow-same-origin allow-scripts allow-popups allow-forms allow-top-navigation"},e=document.createElement("iframe");b.hide&&(d.style=d.style+"display: none;");for(c in d)e.setAttribute(c,d[c]);return e}function b(a,b,c){var d,e=a||window.location.origin||window.location.protocol+"//"+window.location.host,f=e+(c||"/signin/inject/"),g=b?"?":"",h=0;if(!b)return f;for(d in b)h>0&&(g+="&"),g=g+d+"="+encodeURIComponent(b[d]),h+=1;return f+g}function c(a){var b,c="";try{if(a.source.name!==q.name)return}catch(d){return}if(b=g(a.origin),!f(b))throw new Error("PostMessage iframe domain ("+b+"), must be a *.paypal.com domain");if(c=a&&a.data,"string"==typeof c)try{c=JSON.parse(c)}catch(h){throw new Error("Invalid JSON string sent to onPostMessage handler: "+c)}c.data&&"resize"===c.data.event?e(q,c.data.heightInPx):c.data&&"htmlRendered"===c.data.event?x=!0:!w&&p?p(c):w&&v.push(c)}function d(a){a&&"resize"===a.event?e(s,a.heightInPx):r(a)}function e(a,b){a.setAttribute("height",b)}function f(a){var b=/\.paypal\.com$/gi;return b.test(a)}function g(a){if(a){var b=/^https?:\/\/(.*\.paypal\.com)(:[0-9]+)?$/gi,c=b.exec(a);return c&&c[1]}}function h(){var a;if(p){for(a=0;a<v.length;a++)p(v[a]);v=[],w=!1}}function i(c){var d,e,h,i,k;if(!c||!c.targetElement)throw h="targetElement",new Error("The "+h+" option is required");if(c.origin&&(i=g(c.origin),!f(i)))throw new Error('All values for the "origin" setting must match *.paypal.com');for(u=c.config||{},e=b(c.origin,c.queryParams,c.iframePathname),k=c.xhrRequest&&c.xhrRequest===!0,d=k||c.preLoadedSource?a("about:blank",u):a(e,u),t=c.targetElement;c.targetElement.hasChildNodes();)c.targetElement.removeChild(c.targetElement.lastChild);return c.targetElement.appendChild(d),"directMessageIframe"===c.iframeType?(s=d,r=c.onPostMessage):(q=d,p=c.onPostMessage,j()),k?n(e,function(a){a&&o(d,a)}):c.preLoadedSource&&o(d,c.preLoadedSource),w=p?!1:!0,{iframe:d,onPostMessageCallback:p}}function j(){window.addEventListener?window.addEventListener("message",c,!1):window.attachEvent("onmessage",c)}function k(a){p=a,h()}function l(){t.parentNode&&t.parentNode.removeChild(t)}function m(b){var c,d,e,f,g="about:blank";if(!x)return void setTimeout(function(){m(b)},50);for(b.onPostMessage&&k(b.onPostMessage),u.hide=!1,c=a(g,u);b.targetElement.hasChildNodes();)b.targetElement.removeChild(b.targetElement.lastChild);b.targetElement.appendChild(c),d=q.contentWindow.document,e=d.documentElement.outerHTML,f=c.contentWindow.document,f.open(),f.write(e),f.close(),l(),q=c,t=b.targetElement}function n(a,b){var c;window.XMLHttpRequest?c=new XMLHttpRequest:window.ActiveXObject&&(c=new ActiveXObject("Microsoft.XMLHTTP")),c&&(c.onreadystatechange=function(){4==c.readyState&&200==c.status&&b(c.responseText)},c.open("GET",a,!0),c.send())}function o(a,b){a.contentWindow.inlineUlContents=b,a.src='javascript:window["inlineUlContents"]'}var p,q,r,s,t,u,v=[],w=!1,x=!1;return{inject:i,copyPasteIframe:m,removeTargetElement:l,messageDispatcher:c,nonPostMessageDispatcher:d}});

}.call(window));

/***/ }),

/***/ "../node_modules/xo-address-components/src/add-address/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoAddAddressComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown-multiline/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/prefix-attrs-with/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/name-input/directive.js");

var _index = __webpack_require__("../node_modules/xo-models/src/address/index.js");

__webpack_require__("../node_modules/xo-form-components/src/zipcode/directive.js");

var _template = __webpack_require__("../node_modules/xo-address-components/src/add-address/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoAddAddressComponent = exports.$xoAddAddressComponent = _squid.$Component.extend('$xoAddAddressComponent', {
    tag: 'xo-add-address',
    template: _template2['default'],
    props: {
        address: {
            type: 'var',
            required: false
        },
        isShipping: {
            type: 'var',
            required: false
        },
        country: {
            type: 'var',
            required: false
        },
        metadata: {
            type: 'str',
            required: false
        },
        hideButtonHandler: {
            type: 'var',
            required: false
        },
        hideCep: {
            type: 'var',
            required: false
        },
        hideName: {
            type: 'var',
            required: false
        },
        triggerZipCodeBlur: {
            type: 'var',
            required: false
        },
        triggerZipCodeKeyPress: {
            type: 'var',
            required: false
        },
        renderBillingAddCheckbox: {
            type: 'var',
            required: false
        }
    },
    controller: ['$scope', function ($scope) {
        // eslint-disable-line max-statements
        var sortStates = void 0;
        var country = $scope.country || $scope.address && $scope.address.country;

        $scope.country = country;
        $scope.locale = _squid.$locale;
        $scope.metadata = _squid.$MetadataModel.create();

        // If the user changes their shipping/billing address country, fetch that metadata (if needed) and re-render.
        $scope.$watch('country', function () {
            $scope.metadata.choose($scope.country, $scope.locale.lang);
            onCountryChange();
        });

        function onCountryChange() {
            sortStates = (0, _squid.$feature)('sortStatesForAddress', false, $scope.country);

            if (sortStates) {
                getSortedStateList();
            }
        }

        onCountryChange();

        // If the user changes languagle toggle, fetch that metadata (if needed) and re-render.
        $scope.$on('contentChange', function () {
            $scope.metadata.choose($scope.country, $scope.locale.lang);
        });

        /**
         * Prefix to use for `id`, `name`, and `for` attributes. This is needed because Xoon will sometimes display both billing
         * and shipping address forms on the same page and without a prefix there will be duplicte `id`s and `name`s on the page.
         */
        $scope.attrPrefix = $scope.isShipping ? 'shipping' : 'billing';

        $scope.$watch('address.state', function () {
            _angular.$rootScope.$emit($scope.attrPrefix + 'AddressStateChange', $scope.address);
        });

        $scope.normalizeCountry = function (countryCode) {
            return (0, _squid.$feature)('AddressFormat', countryCode, countryCode) || countryCode;
        };

        $scope.isAddPreferred = (0, _squid.$feature)('preferredShipping', false, $scope.country) && $scope.isShipping;
        $scope.isAddressLookupEnabled = (0, _squid.$feature)('addressLookup', false, $scope.country);
        $scope.isShowLookupFields = $scope.isAddressLookupEnabled;

        if ($scope.isShowLookupFields) {
            // Show the Address Lookup Fields only when the hideButtonHandler function is passed by the caller.
            if ($scope.hideButtonHandler) {
                $scope.hideButtonHandler(true);
            } else {
                $scope.isShowLookupFields = false;
            }
        }

        function getSortedStateList() {
            var states = _squid.$locale.content.get(sortStates, {});
            var statesList = [];

            angular.forEach(states, function (key, value) {
                statesList.push({ code: value, sname: key });
            });
            statesList.sort(function (a, b) {
                return a.sname.localeCompare(b.sname);
            });

            $scope.sortedStatesList = statesList;
        }

        $scope.formatZip = function () {
            var unformatted = $scope.address.postal_code && $scope.address.postal_code.replace(/[^0-9]/gi, '');
            var formatted = [['', unformatted.slice(0, 3)], ['-', unformatted.slice(3)]].map(function (x) {
                return x[1] && x[0] + x[1] || '';
            }).join('');

            $scope.address.postal_code = formatted;
        };

        function getAddress(address) {
            var COMMA = ', ';
            var SPACE = ' ';
            var line1 = void 0;
            var line2 = void 0;

            function prefix(str, prefixStr) {
                if (str) {
                    return (prefixStr ? prefixStr : '') + str;
                }
                return '';
            }

            if (!address.deliveryAddresses || angular.isArray(address.deliveryAddresses) && address.deliveryAddresses.length === 0) {
                // if deliveryAddresses is not an array or is empty
                // line would be empty, hence return to caller.
                return;
            }

            var array = address.deliveryAddresses;

            if (array.length > 1) {
                // populate line2 from the last element
                line2 = array.pop();
            }
            line1 = array.join(COMMA);

            var displayLine1 = line1 + prefix(line2, COMMA);
            var displayLine2 = prefix(address.city) + prefix(address.state, COMMA) + prefix(address.postal_code, SPACE);
            var displayLine3 = prefix(address.country);

            return {
                line1: line1,
                line2: line2,
                city: address.city,
                state: address.state,
                postal_code: address.postal_code,
                country: address.country,
                displayLine1: displayLine1,
                displayLine2: displayLine2,
                displayLine3: displayLine3,
                dropDownAddress: displayLine1 + prefix(displayLine2, ' \\n ') + prefix(displayLine3, ' \\n ')
            };
        }

        function populateAddressFormFields(address) {
            $scope.address.line1 = address.line1;
            $scope.address.line2 = address.line2;
            $scope.address.city = address.city;
            $scope.address.state = address.state;
            $scope.address.postal_code = address.postal_code;
            $scope.address.neighborhood = address.neighborhood;
        }

        /**
         * Show error message and display the full-address fields
         */
        function populateErrorMessage() {
            var messages = [];

            messages.push($scope.locale.content.get('addressBook.lookupError'));
            $scope.lookupFailureMessage = {
                msgs: messages,
                type: 'warning'
            };
            $scope.isShowLookupFields = false;
            $scope.isLookupFailure = true;
        }

        function processLookupResult(list) {
            if (list.length > 1) {
                // Show drop-down list of all addresses
                $scope.isLookupSuccess = true;
                $scope.isShowLookupDropDown = true;
                $scope.lookupAddressList = list.map(function (addr) {
                    return getAddress(addr);
                });
            } else if (list.length === 1) {
                // Show single address component
                $scope.isLookupSuccess = true;
                $scope.isShowLookupDropDown = false;

                var address = getAddress(list[0]);

                $scope.singleAddress = address;
                populateAddressFormFields(address);
            } else {
                populateErrorMessage();
            }
        }

        if ($scope.address) {
            $scope.lastPrefilledZip = $scope.address.postal_code;
        }

        $scope.prefill = function () {
            var cepPattern = /^(\d{5}-\d{3}|\d{5}|\d{8})$/;
            var first_name = void 0;
            var last_name = void 0;

            if ($scope.lastPrefilledZip === $scope.address.postal_code || !cepPattern.test($scope.address.postal_code)) {
                return;
            }

            if ($scope.isShipping) {
                first_name = $scope.address.first_name;
                last_name = $scope.address.last_name;
            }

            $scope.prefillAddress = new _index.$PrefillAddressModel({
                id: $scope.token,
                address: {
                    country: $scope.address.country,
                    postal_code: $scope.address.postal_code
                }
            });

            return $scope.prefillAddress.save({
                data: $scope.prefillAddress,
                success: function success(result) {
                    if (result) {
                        populateAddressFormFields(result);
                        $scope.lastPrefilledZip = $scope.address.postal_code;
                        if ($scope.isShipping) {
                            $scope.address.first_name = first_name;
                            $scope.address.last_name = last_name;
                        }
                    }
                }
            });
        };

        $scope.findAddress = function () {
            $scope.lookupAddress = _index.$PrefillAddressModel.create($scope.token, {
                address: {
                    country: $scope.address.country,
                    postal_code: $scope.address.postal_code,
                    house_number: $scope.address.house_number,
                    building_name: $scope.address.building_name
                }
            });

            if (document.querySelector('#lookupZip.ng-invalid')) {
                document.querySelector('#addressLookupFields').classList.add('validated');
            } else {
                $scope.isLookupProcessing = true;
                $scope.lookupAddress.save({
                    data: $scope.lookupAddress,
                    silent: true,
                    success: function success(result) {
                        processLookupResult(result);
                        $scope.hideButtonHandler(false);
                    },
                    contingencies: {
                        INTERNAL_ERROR: populateErrorMessage
                    }
                });
            }
        };

        $scope.changeAddressDropDown = function () {
            populateAddressFormFields($scope.address.selectedAddress);
        };

        $scope.showFullAddress = function () {
            $scope.isShowLookupFields = false;
            $scope.hideButtonHandler(false);
        };

        /**
         * Pass an array of group names to retrieve the list of states
         * e.g. ['england', 'northernIreland', 'scotland', 'wales', 'ukOffshoreDependencies']
         */
        var stateNamesInGroup = [];

        $scope.retrieveStateNamesInGroup = function (groups) {
            if (stateNamesInGroup.length) {
                // Angular keeps watching for this method as its used in ng-model, hence return cached data.
                return stateNamesInGroup;
            }
            var content = _squid.$locale.content;

            angular.forEach(groups, function (group) {
                var groupName = content.common[group];
                var statesList = content[group];

                angular.forEach(statesList, function (value, key) {
                    stateNamesInGroup.push({
                        key: key,
                        value: value,
                        group: groupName
                    });
                });
            });
            return stateNamesInGroup;
        };

        $scope.zipCodeBlur = function () {
            if ($scope.triggerZipCodeBlur) {
                _angular.$rootScope.$emit('zip_code_blur');
            }
        };

        $scope.zipCodeKeyPress = function (event) {
            if ($scope.triggerZipCodeKeyPress) {
                _angular.$rootScope.$emit('zip_code_keypress', { event: event });
            }
        };
    }]
});

angular.value("$xoAddAddressComponent", $xoAddAddressComponent);
_angular.$rootScope;

_squid.$Component;

_squid.$feature;

_squid.$locale;

_squid.$MetadataModel;

_index.$PrefillAddressModel;

/***/ }),

/***/ "../node_modules/xo-address-components/src/add-address/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"addressForm\" class=\"addressForm\" content ng-class=\"country\">\n    <xo-name-input user=\"address\" country=\"{{country}}\" ng-if=\"isShipping && !hideName\" attr-prefix=\"attrPrefix\"></xo-name-input>\n    <div ng-switch=\"normalizeCountry(country)\" class=\"addressGroup clearfix\">\n        <div ng-switch-when=\"BR\">\n            <xo-zipcode id=\"zipcode\" prefix-attrs-with=\"{{attrPrefix}}\" attr-prefix=\"attrPrefix\" country=\"BR\" address=\"address\"\n                zip-label=\"{{content('common.cep')}}\" zip-error-key=\"common.valueInvalid\" done-fn=\"prefill\" ng-if=\"!hideCep\"></xo-zipcode>\n\n            <div id=\"addressFields\" prefix-attrs-with=\"{{attrPrefix}}\">\n                <div class=\"streetName clearfix\">\n                    <div class=\"inputField confidential line1\" floating-label>\n                        <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\"\n                            maxlength=\"60\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"\n                            data-error-key=\"common.valueInvalid\" xo-error-tooltip required prefix-attrs-with=\"{{attrPrefix}}\"/>\n                        <label for=\"line1\" id=\"line1Label\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ content('common.streetAddress') }}\n                        </label>\n                    </div>\n                    <div class=\"inputField streetNumber\" floating-label>\n                        <input type=\"text\" name=\"streetNumber\" id=\"streetNumber\" ng-pattern=\"/^(?=.*[0-9])([a-zA-Z0-9]+)$/\"\n                            ng-model=\"address.streetNumber\" value=\"\" maxlength=\"6\" ariaRequired=\"true\" autocomplete=\"off\"\n                            data-error-key=\"common.valueInvalid\" prefix-attrs-with=\"{{attrPrefix}}\" xo-error-tooltip required />\n                        <label for=\"streetNumber\" id=\"streetNumberLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ content('common.streetNumber') }}\n                        </label>\n                    </div>\n                </div>\n                <div class=\"inputField confidential line2\" floating-label>\n                    <input type=\"text\" name=\"line2\" id=\"line2\" ng-model=\"address.line2\" value=\"\"\n                        maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                    <label for=\"line2\" id=\"line2Label\" prefix-attrs-with=\"{{attrPrefix}}\">{{ content('common.streetAddress2') }}</label>\n                </div>\n                <div class=\"inputField confidential neighborhood\" floating-label>\n                    <input type=\"text\" name=\"neighborhood\" id=\"neighborhood\" ng-model=\"address.neighborhood\"\n                        value=\"\" maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\" ariaRequired=\"true\"\n                        data-error-key=\"common.valueInvalid\" prefix-attrs-with=\"{{attrPrefix}}\" xo-error-tooltip required />\n                    <label for=\"neighborhood\" id=\"neighborhoodLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                        {{ content('common.neighborhood') }}\n                    </label>\n                </div>\n                <div class=\"inputField confidential clearfix\">\n                    <div class=\"inputField confidential city\" floating-label>\n                        <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\"\n                            autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" prefix-attrs-with=\"{{attrPrefix}}\"\n                            data-error-key=\"common.valueInvalid\" xo-error-tooltip required />\n                        <label for=\"city\" id=\"cityLabel\" prefix-attrs-with=\"{{attrPrefix}}\">{{ content('common.onlyCity') }}</label>\n                    </div>\n                    <div class=\"dropdown confidential state nullable inputField\" floating-label-dropdown>\n                        <select xo-dropdown name=\"state\" ng-options=\"state.code as state.sname for state in sortedStatesList\"\n                            ng-model=\"address.state\" id=\"state\" aria-labelledby=\"stateLabel\" aria-required=\"true\"\n                            data-test-id=\"BR:addressProvince\" prefix-attrs-with=\"{{attrPrefix}}\" required >\n                            <option value=\"\">{{ content('common.otherState') }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ content('common.otherState') }}\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div ng-switch-when=\"GB\">\n            <!-- start: Show all the fields for Add Address if isShowLookupFields is false -->\n            <div ng-if=\"!isShowLookupFields\">\n                <div ng-if=\"isAddressLookupEnabled\">\n                    <div ng-if=\"isShipping\" class=\"lookupHeading\">\n                        <span class=\"lookupTitle\">{{ content('addressBook.address') }}</span>\n                    </div>\n                    <div ng-show=\"isLookupFailure\" class=\"lookupFailureMsg\">\n                        <xo-message message=\"lookupFailureMessage\"></xo-message>\n                    </div>\n                </div>\n                <div class=\"inputField confidential line1\" floating-label>\n                    <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\" maxlength=\"50\"\n                        autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\"\n                        prefix-attrs-with=\"{{attrPrefix}}\" xo-error-tooltip required />\n                    <label for=\"line1\" id=\"line1Label\" prefix-attrs-with=\"{{attrPrefix}}\">{{ content('common.streetAddress') }}</label>\n                </div>\n                <div class=\"inputField confidential line2\" floating-label>\n                    <input type=\"text\" name=\"line2\" id=\"line2\" ng-model=\"address.line2\" value=\"\" maxlength=\"50\"\n                        autocapitalize=\"off\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                    <label for=\"line2\" id=\"line2Label\" prefix-attrs-with=\"{{attrPrefix}}\">{{ content('common.streetAddress2') }}</label>\n                </div>\n                <div class=\"inputField confidential city\" floating-label>\n                    <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\"\n                        autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\"\n                        prefix-attrs-with=\"{{attrPrefix}}\" xo-error-tooltip required />\n                    <label for=\"city\" id=\"cityLabel\" prefix-attrs-with=\"{{attrPrefix}}\">{{ content('common.onlyCity') }}</label>\n                </div>\n                <div class=\"stateZip clearfix\">\n                    <div class=\"dropdown confidential state inputField\" floating-label-dropdown>\n                        <select xo-dropdown name=\"state\" ng-model=\"address.state\" id=\"state\" aria-labelledby=\"stateLabel\"\n                                aria-required=\"true\" prefix-attrs-with=\"{{attrPrefix}}\"\n                                ng-options=\"c.key as c.value group by c.group for c in retrieveStateNamesInGroup(['england', 'northernIreland', 'scotland', 'wales', 'ukOffshoreDependencies'])\">\n                            <option value=\"\">{{ content('common.countyOptional') }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">{{ content('common.countyOptional') }}</label>\n                    </div>\n                    <div class=\"inputField confidential postalCode\" floating-label>\n                        <input type=\"text\" name=\"postalCode\" id=\"postalCode\" ng-model=\"address.postal_code\" value=\"\"\n                            autocapitalize=\"off\" aria-required=\"true\" ng-blur=\"zipCodeBlur()\"  ng-keypress=\"zipCodeKeyPress()\"\n                            autocomplete=\"off\" data-error-key=\"validation.validZipCode\" prefix-attrs-with=\"{{attrPrefix}}\"\n                            xo-validation='{\n                                    \"validator\": \"validZip\",\n                                    \"options\": {\n                                        \"country\": \"GB\"\n                                    }\n                                }'\n                            xo-error-tooltip required />\n                        <label for=\"postalCode\" id=\"postalCodeLabel\" prefix-attrs-with=\"{{attrPrefix}}\">{{ content('common.zip') }}</label>\n                    </div>\n                </div>\n            </div>\n            <!-- end: Show all the fields -->\n            <!-- start: Show only the address lookup fields -->\n            <div ng-if=\"isShowLookupFields\" id=\"addressLookup\" class=\"addressLookup\" prefix-attrs-with=\"{{attrPrefix}}\">\n                <div ng-hide=\"isLookupSuccess\" id=\"addressLookupFields\" prefix-attrs-with=\"{{attrPrefix}}\"> <!-- class=\"validated\" -->\n                    <div class=\"lookupHeading\">\n                        <span class=\"lookupTitle\">{{ content('addBillingAddress.lookupTitle') }}</span>\n                        <a class=\"editAddress\" ng-click=\"showFullAddress()\">{{ content('addressBook.enterFullAddress') }}</a>\n                    </div>\n                    <div class=\"fieldGroup\">\n                        <div class=\"inputField confidential lookupZip\">\n                            <input type=\"text\" name=\"lookupZip\" id=\"lookupZip\" ng-model=\"address.postal_code\" value=\"\"\n                                autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"\n                                data-error-key=\"validation.validZipCode\" prefix-attrs-with=\"{{attrPrefix}}\"\n                                xo-validation='{\n                                    \"validator\": \"validZip\",\n                                    \"options\": {\n                                    \"country\": \"GB\"\n                                    }\n                                }'\n                                ng-disabled=\"isLookupProcessing\" xo-error-tooltip required />\n                            <label for=\"lookupZip\" id=\"postalCodeLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                                {{ content('common.zip') }}\n                            </label>\n                        </div>\n                    </div>\n                    <div class=\"inputField confidential houseNo\" floating-label>\n                        <input type=\"text\" id=\"houseNo\" name=\"houseNo\" ng-model=\"address.house_number\"\n                            value=\"\" maxlength=\"50\" prefix-attrs-with=\"{{attrPrefix}}\"\n                            autocapitalize=\"off\" aria-required=\"false\" autocomplete=\"off\"\n                            data-error-key=\"common.valueInvalid\" xo-error-tooltip\n                            ng-disabled=\"isLookupProcessing\" />\n                        <label for=\"houseNo\" id=\"houseNoLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ content('common.houseBldgNo') }}\n                        </label>\n                    </div>\n                    <div class=\"inputField confidential buildingName\" floating-label>\n                        <input type=\"text\" id=\"buildingName\" ng-model=\"address.building_name\"\n                            value=\"\" maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\"\n                            data-error-key=\"common.valueInvalid\" name=\"buildingName\"\n                            ng-disabled=\"isLookupProcessing\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"buildingName\" id=\"buildingNameLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ content('common.houseBldgName') }}\n                        </label>\n                    </div>\n                    <button track-submit ng-click=\"findAddress()\" id=\"findAddressButton\" class=\"btn full continue\"\n                            ng-class=\"{processing: isLookupProcessing}\" prefix-attrs-with=\"{{attrPrefix}}\">\n                        <div ng-show=\"isLookupProcessing\" class=\"spinner\">\n                            <p class=\"loader\" ></p>\n                        </div>\n                        <div ng-hide=\"isLookupProcessing\" class=\"text\">{{ content('addressBook.findAddress') }}</div>\n                    </button>\n                </div>\n                <div ng-show=\"isLookupSuccess\">\n                    <div class=\"lookupHeading\">\n                        <span class=\"lookupTitle\">{{ content('addressBook.address') }}</span>\n                        <a class=\"editAddress\" ng-click=\"showFullAddress()\">\n                            {{ content('common.change') }}\n                        </a>\n                    </div>\n                    <div ng-if=\"isShowLookupDropDown\" id=\"lookedupDropDown\"\n                        class=\"dropdown confidential clearfix\" prefix-attrs-with=\"{{attrPrefix}}\">\n\n                        <select xo-dropdown-multiline ng-model=\"address.selectedAddress\"\n                                ng-change=\"changeAddressDropDown()\" prefix-attrs-with=\"{{attrPrefix}}\"\n                                id=\"addressDropDown\" ng-required=\"isShowLookupDropDown\">\n                            <option value=\"\" selected=\"selected\">\n                                {{ content('addressBook.selectYourAddress', { count: lookupAddressList.length}) }}\n                            </option>\n                            <option ng-repeat=\"addr in lookupAddressList track by $index\" value=\"{{$index}}\">\n                                {{ addr.dropDownAddress }}\n                            </option>\n                        </select>\n                    </div>\n                    <div ng-hide=\"isShowLookupDropDown\" class=\"singleAddress\">\n                        {{ singleAddress.displayLine1 }}<br/>\n                        {{ singleAddress.displayLine2 }}<br/>\n                        {{ singleAddress.displayLine3 }}\n                    </div>\n                </div>\n            </div>\n            <!-- end: Show only the address lookup fields -->\n        </div>\n        <!-- GB end -->\n        <!-- IE begin -->\n        <div ng-switch-when=\"IE\">\n            <div ng-if=\"metadata.addressEntry.layout\" ng-repeat=\"layoutItem in metadata.addressEntry.layout track by $index\">\n                <div ng-if=\"layoutItem.$ === 'line1'\">\n                    <div class=\"inputField confidential line1\" floating-label>\n                        <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\" maxlength=\"50\"\n                            autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\"\n                            xo-error-tooltip ng-required=\"{{layoutItem.required}}\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"line1\" id=\"line1Label\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].line1Label || metadata.addressEntry.strings[country].line1Label }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'line2'\">\n                    <div class=\"inputField confidential line2\" floating-label>\n                        <input type=\"text\" name=\"line2\" id=\"line2\" ng-model=\"address.line2\" value=\"\" prefix-attrs-with=\"{{attrPrefix}}\"\n                            maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" />\n                        <label for=\"line2\" id=\"line2Label\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].line2Label || metadata.addressEntry.strings[country].line2Label }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'city'\">\n                    <div class=\"inputField confidential city\" floating-label>\n                        <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\"\n                            autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\"\n                            xo-error-tooltip ng-required=\"{{layoutItem.required}}\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"city\" id=\"cityLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].cityLabel || metadata.addressEntry.strings[country].cityLabel }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'state'\">\n                    <div ng-if=\"locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateList || metadata.addressEntry.strings[country].stateList\"\n                        class=\"dropdown confidential state nullable inputField\" floating-label-dropdown>\n                        <select name=\"state\" xo-dropdown prefix-attrs-with=\"{{attrPrefix}}\"\n                            ng-options=\"state.$id as state.$id for state in (locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateList || metadata.addressEntry.strings[country].stateList)\"\n                            ng-model=\"address.state\" id=\"state\" aria-labelledby=\"stateLabel\" aria-required=\"true\" ng-required=\"{{layoutItem.required}}\">\n                            <option value=\"\">{{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateLabel || metadata.addressEntry.strings[country].stateList }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateLabel || metadata.addressEntry.strings[country].stateLabel }}\n                        </label>\n                    </div>\n                    <div ng-if=\"!(locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateList || metadata.addressEntry.strings[country].stateList)\" class=\"inputField confidential state\"\n                        floating-label>\n                        <input type=\"text\" name=\"state\" id=\"state\" ng-model=\"address.state\" value=\"\"\n                            autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateLabel || metadata.addressEntry.strings[country].stateLabel }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'postcode'\">\n                    <div class=\"inputField confidential postalCode\" floating-label>\n                        <input type=\"text\" name=\"postalCode\" id=\"postalCode\" ng-model=\"address.postal_code\" ng-blur=\"zipCodeBlur()\"\n                            ng-keypress=\"zipCodeKeyPress()\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"\n                            data-error-key=\"validation.validZipCode\" maxlength=\"{{layoutItem.maxLength}}\" xo-error-tooltip prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"postalCode\" id=\"postalCodeLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].postcodeLabel || metadata.addressEntry.strings[country].postcodeLabel }}\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <!-- IE end -->\n\n        <div ng-switch-default>\n            <!-- Griffin metadata DOES exist for this country -->\n            <div ng-if=\"metadata.addressEntry.layout\" ng-repeat=\"layoutItem in metadata.addressEntry.layout track by $index\">\n                <div ng-if=\"layoutItem.$ === 'line1'\">\n                    <div class=\"inputField confidential line1\" floating-label directionality>\n                        <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\" maxlength=\"50\"\n                            autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\"\n                            xo-error-tooltip ng-required=\"{{layoutItem.required}}\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"line1\" id=\"line1Label\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].line1Label || metadata.addressEntry.strings[country].line1Label }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'line2'\">\n                    <div class=\"inputField confidential line2\" floating-label directionality>\n                        <input type=\"text\" name=\"line2\" id=\"line2\" ng-model=\"address.line2\" value=\"\" maxlength=\"50\"\n                            autocapitalize=\"off\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"line2\" id=\"line2Label\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].line2Label || metadata.addressEntry.strings[country].line2Label }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'city'\">\n                    <div class=\"inputField confidential city\" floating-label directionality>\n                        <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\"\n                            autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\"\n                            xo-error-tooltip ng-required=\"{{layoutItem.required}}\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"city\" id=\"cityLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].cityLabel || metadata.addressEntry.strings[country].cityLabel }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'state'\">\n                    <div ng-if=\"locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateList || metadata.addressEntry.strings[country].stateList\"\n                        class=\"dropdown confidential state nullable inputField\" floating-label-dropdown>\n                        <select name=\"state\" xo-dropdown ng-options=\"state.$id as state.$elt for state in (locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateList || metadata.addressEntry.strings[country].stateList)\"\n                            ng-model=\"address.state\" id=\"state\" aria-required=\"true\" ng-required=\"{{layoutItem.required}}\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            <option value=\"\">{{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateLabel || metadata.addressEntry.strings[country].stateLabel }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateLabel || metadata.addressEntry.strings[country].stateLabel }}\n                        </label>\n                    </div>\n                    <div ng-if=\"!(locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateList || metadata.addressEntry.strings[country].stateList)\" class=\"inputField confidential state\"\n                        floating-label directionality>\n                        <input type=\"text\" name=\"state\" id=\"state\" ng-model=\"address.state\" value=\"\" autocapitalize=\"off\"\n                        aria-required=\"true\" autocomplete=\"off\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateLabel || metadata.addressEntry.strings[country].stateLabel }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'postcode'\">\n                    <xo-zipcode id=\"zipcode\" zip-entry=\"layoutItem\" country=\"{{country}}\"\n                                max-length=\"layoutItem.maxLength\" address=\"address\" attr-prefix=\"attrPrefix\"\n                                done-fn=\"zipCodeBlur\" prefix-attrs-with=\"{{attrPrefix}}\"\n                                key-press-fn=\"zipCodeKeyPress\" zip-required=\"layoutItem.required\"\n                                zip-label=\"{{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].postcodeLabel || metadata.addressEntry.strings[country].postcodeLabel }}\"\n                                zip-error-key=\"validation.validZipCode\"></xo-zipcode>\n                </div>\n            </div>\n            <!-- Griffin metadata DOES NOT exist for this country -->\n            <div ng-if=\"!metadata.addressEntry.layout\">\n                <div class=\"inputField confidential line1\" floating-label directionality>\n                    <input type=\"text\" name=\"line1\" id=\"line1\" data-test-id=\"addrSt\" ng-model=\"address.line1\"\n                        value=\"\" maxlength=\"50\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"\n                        data-error-key=\"common.valueInvalid\" xo-error-tooltip required prefix-attrs-with=\"{{attrPrefix}}\" />\n                    <label for=\"line1\" id=\"line1Label\" prefix-attrs-with=\"{{attrPrefix}}\">\n                        {{ content('common.stAddress') }}\n                    </label>\n                </div>\n\n                <div class=\"inputField confidential city\" floating-label directionality>\n                    <input type=\"text\" name=\"city\" id=\"city\"data-test-id=\"addrCity\" maxLength=\"100\" ng-model=\"address.city\"\n                        value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\"\n                        prefix-attrs-with=\"{{attrPrefix}}\" xo-error-tooltip required />\n                    <label for=\"city\" id=\"cityLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                        {{ content('common.otherCity') }}\n                    </label>\n                </div>\n\n                <div class=\"inputField confidential state\" floating-label directionality>\n                    <input type=\"text\" name=\"state\" id=\"state\" data-test-id=\"addrState\" ng-model=\"address.state\"\n                        value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                    <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                        {{ content('common.optionalState') }}\n                    </label>\n                </div>\n\n                <div class=\"inputField confidential postalCode\" floating-label directionality>\n                    <input type=\"text\" name=\"postalCode\" id=\"postalCode\" data-test-id=\"addrZipcode\" ng-model=\"address.postal_code\"\n                        value=\"\"  ng-blur=\"zipCodeBlur()\" ng-keypress=\"zipCodeKeyPress()\" autocapitalize=\"off\" aria-required=\"true\"\n                        autocomplete=\"off\" data-error-key=\"validation.validZipCode\" prefix-attrs-with=\"{{attrPrefix}}\"/>\n                    <label for=\"postalCode\" id=\"zipLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                        {{ content('common.optionalPostalCode') }}\n                    </label>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if=\"isAddPreferred\" class=\"addPreferredShipping sCheckbox checkbox\">\n        <input type=\"checkbox\" ng-model=\"address.preferred_address\" name=\"addPreferred\" id=\"addPreferred\" />\n        <label for=\"addPreferred\">{{ content('memberReview.makePreferredShipping') }}</label>\n    </div>\n\n    <div ng-if=\"renderBillingAddCheckbox\" class=\"addPreferredShipping sCheckbox checkbox\">\n        <input type=\"checkbox\"  ng-model=\"address.isBA\" name=\"isBA\" id=\"addVenmoBA\" />\n        <label for=\"addVenmoBA\">{{ content('memberReview.useShippingAsBilling') }}</label>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-display/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoAddressDisplayComponent = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-address-components/src/address-display/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-address-components/src/address-display/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoAddressDisplayComponent = exports.$xoAddressDisplayComponent = _squid.$Component.extend('$xoAddressDisplayComponent', {
    tag: 'xo-address-display',
    template: _template2['default'],
    props: {
        address: {
            type: 'var',
            required: false
        },
        showPreferred: {
            type: 'str',
            required: false
        },
        countryCode: {
            type: 'var',
            required: false
        },
        displayFormattedAddr: {
            type: 'var',
            required: false
        }
    },
    actions: {
        formatAddress: function formatAddress(address) {
            var COMMA = ', ';
            var SPACE = ' ';

            function prefix(str, prefixStr) {
                if (str) {
                    return (prefixStr ? prefixStr : '') + str;
                }
                return '';
            }

            var displayLine1 = (address.line1 ? address.line1 : '') + (address.line2 ? prefix(address.line2, COMMA) : '');
            var displayLine2 = (address.city ? prefix(address.city) : '') + (address.state ? prefix(address.state, COMMA) : '') + (address.postal_code ? prefix(address.postal_code, SPACE) : '');
            var displayLine3 = address.country ? prefix(address.country) : '';

            return {
                displayLine1: displayLine1,
                displayLine2: displayLine2,
                displayLine3: displayLine3
            };
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this = this;

            var address = this.props.address || {};
            var countryCode = typeof this.props.countryCode === 'undefined' ? address.country || address.country_code : this.props.countryCode;

            this.isPreferred = this.props.showPreferred && address.preferred_address && (0, _squid.$feature)('preferredShipping', false, countryCode);
            if (this.props.displayFormattedAddr) {
                this.formattedAddr = this.actions.formatAddress(address);
                this.$watchCollection('props.address', function (newVal) {
                    _this.formattedAddr = _this.actions.formatAddress(newVal);
                });
            }
        }
    }
});

angular.value("$xoAddressDisplayComponent", $xoAddressDisplayComponent);
_squid.$Component;

_squid.$feature;

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-display/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-display/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"adr\" ng-class=[props.countryCode] content>\n    <div ng-if=\"props.address.full_address && !props.displayFormattedAddr\" class=\"confidential\">\n        <span class=\"full-address\" directionality-text=\"props.address.full_address\" data-test-id=\"fullAddress\">{{props.address.full_address}}</span>\n        <span class=\"country adr-break\">{{content('countryList.'+props.address.country)}}</span>\n    </div>\n\n    <div ng-if=\"props.displayFormattedAddr\" class=\"shippingAddress\">\n        {{formattedAddr.displayLine1}}<br/>\n        {{formattedAddr.displayLine2}}<br/>\n        {{formattedAddr.displayLine3}}\n    </div>\n\n    <div ng-if=\"isPreferred\" class=\"preferred\">\n        <span>\n            {{content('shippingAddress.preferred')}}\n        </span>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-normalization/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/address/index.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-tray-height/dist/directive.js");

__webpack_require__("../node_modules/xo-address-components/src/address-normalization/styles.less");

var _template = __webpack_require__("../node_modules/xo-address-components/src/address-normalization/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddressNormalization', function () {
    return {
        template: _template2['default'],
        scope: {
            id: '=?',
            address: '=?',
            doneFn: '=?',
            sidebar: '=?',
            hideBackButton: '=?'
        },

        controller: ['$scope', function ($scope) {
            _squid.$util.assert($scope.address, 'Original Address cannot be empty');

            $scope.showNormalization = false;

            var normalize = (0, _squid.$feature)('addressNormalization', false, $scope.address.country);
            if (!normalize) {
                $scope.doneFn($scope.address, false);
                return;
            }

            var userEnteredAddress;
            var addrFormat = (0, _squid.$feature)('FormatAddressForNormalization', $scope.address.country, $scope.address.country);

            $scope.addressSelected = 'normalizedAddress';
            $scope.transitionName = 'address_normalization_normalizedAddress';

            // Brazil specific format
            if (addrFormat === 'AddressBR') {
                userEnteredAddress = angular.fromJson(angular.toJson($scope.address));
                userEnteredAddress.line1 = $scope.address.line1 + '  ' + $scope.address.streetNumber;
                userEnteredAddress.line2 = $scope.address.neighborhood;
            }

            $scope.servAddress = userEnteredAddress ? userEnteredAddress : $scope.address;
            $scope.servAddress.normalization_status = 'UNNORMALIZED_USER_PREFERRED';

            $scope.addressNormalization = new _index.$AddressNormalizationModel({
                id: $scope.id,
                address: $scope.servAddress
            });

            function centerLightBox() {
                var element = $('#lbox');
                if (!element.length) {
                    return;
                }

                var windowElement = $(window);
                var lboxContainerElem = $('#lboxContainer');
                element.css('top', Math.max(0, (windowElement.height() - element.outerHeight()) / 2) + 'px');
                element.css('width', '65%');
                var computedLeft = (windowElement.width() - element.outerWidth()) / 2;
                var leftBound = lboxContainerElem.offset().left + lboxContainerElem.width() * 0.1;
                var elementLeft = computedLeft < leftBound ? leftBound : computedLeft;
                if (computedLeft < leftBound) {
                    element.css('width', lboxContainerElem.width() * 0.8);
                }
                element.css('left', Math.max(0, elementLeft) + 'px');
                return element;
            }

            function trinityResponseCallback() {
                $scope.showNormalization = true;

                // default behavior of $timeout with no 2nd param is to wait for dom to finish rendering before executing callback
                (0, _angular.$timeout)(function () {
                    centerLightBox();
                    $(window).resize(centerLightBox);
                });
            }

            $scope.addressNormalization.save({
                data: $scope.addressNormalization,

                contingencies: {
                    VALIDATION_ERROR: function VALIDATION_ERROR() {
                        trinityResponseCallback();
                        $scope.transitionName = 'address_normalization_enteredAddress';
                        return;
                    }
                },

                success: function success(result) {
                    trinityResponseCallback();
                    if (result === false) {
                        // trinity doesn't find any match
                        $scope.transitionName = 'address_normalization_enteredAddress';
                        return;
                    }
                    $scope.normalizedAddress = result;
                    $scope.normalizedAddress.normalization_status = 'NORMALIZED';

                    if (addrFormat === 'AddressBR') {
                        $scope.normalizedAddress.line1 = $scope.normalizedAddress.streetName + '  ' + $scope.normalizedAddress.streetNumber;
                        $scope.normalizedAddress.line2 = $scope.normalizedAddress.neighborhood;
                    }

                    // if the two addresses equal, no need to show the panel
                    if ($scope.isEqual($scope.normalizedAddress, $scope.servAddress)) {
                        if ($scope.servAddress.preferred_address) {
                            $scope.normalizedAddress.preferred_address = true;
                        }

                        if (addrFormat === 'AddressBR' && $scope.address.line2) {
                            $scope.normalizedAddress.line1 = $scope.normalizedAddress.line1 + '  ' + $scope.address.line2;
                        }
                        $scope.callback($scope.normalizedAddress, false);
                    } else if (addrFormat === 'AddressBR' && $scope.address.line2) {
                        $scope.normalizedAddress.line1 = $scope.normalizedAddress.line1 + '  ' + $scope.address.line2;
                    }
                },

                error: trinityResponseCallback
            });

            // make space and case insensitive. sub empty vals for undefined.
            function desensitizedAddress(addr) {
                for (var key in addr) {
                    var val = addr[key];
                    if (addr.hasOwnProperty(key)) {
                        if (val && val.length) {
                            addr[key] = val.trim().toLowerCase();
                        } else {
                            addr[key] = undefined;
                        }
                    }
                }
                return addr;
            }

            // check if the two address are the same
            $scope.isEqual = function (address1, address2) {
                var addressOne = desensitizedAddress(JSON.parse(JSON.stringify(address1)));
                var addressTwo = desensitizedAddress(JSON.parse(JSON.stringify(address2)));

                if (!addressOne || !addressTwo) {
                    return false;
                }

                return addressOne.line1 === addressTwo.line1 && addressOne.line2 === addressTwo.line2 && addressOne.city === addressTwo.city && addressOne.state === addressTwo.state && addressOne.postal_code === addressTwo.postal_code && addressOne.country === addressTwo.country;
            };

            // Australia displays address line2 first
            $scope.isLine2First = function () {
                return $scope.address.country === 'AU';
            };

            $scope.onBack = function () {
                $scope.callback($scope.address, true);
            };

            $scope.selection = function (value) {
                $scope.transitionName = 'address_normalization_' + value;
            };

            $scope.onContinue = function () {
                $scope.addressSelected = this.addressNormalizationForm.addressSelected;

                if ($scope.addressSelected && $scope.addressSelected.$modelValue === 'normalizedAddress') {
                    if ($scope.servAddress.preferred_address) {
                        $scope.normalizedAddress.preferred_address = true;
                    }
                    $scope.callback($scope.normalizedAddress, false);
                } else {
                    $scope.servAddress.normalization_status = 'UNNORMALIZED_USER_PREFERRED';
                    if (addrFormat === 'AddressBR' && $scope.address.line2) {
                        $scope.servAddress.line1 = $scope.servAddress.line1 + ' ' + $scope.address.line2;
                    }
                    $scope.callback($scope.servAddress, false);
                }
            };

            $scope.callback = function (address, isBack) {
                $scope.doneFn(address, isBack);
            };
        }]
    };
});

_angular.$timeout;

_squid.$feature;

_squid.$util;

_index.$AddressNormalizationModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-normalization/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$AddressNormalizationRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-address-components/src/address-normalization/directive.js");

var $AddressNormalizationRoute = exports.$AddressNormalizationRoute = _squid.$ComponentRoute.extend('AddressNormalizationRoute', {
    name: 'addressNormalization',
    titleContent: 'addressNormalization.addressmatch',
    directive: 'xo-address-normalization',
    trackingData: {
        fptiState: 'address_normalization',
        buzname: {
            'fullpage': {
                'pagename': '%::address_normalization',
                'pagename2': '%::address_normalization:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    loginRequired: true,

    children: []
});

angular.value("$AddressNormalizationRoute", $AddressNormalizationRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-normalization/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-normalization/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-show=\"showNormalization\" content id=\"addressNormalization\" xo-tray-height>\n    <xo-aside-header heading='asideHeader.selectNormalizedAddress' hidex='true' ng-if=\"sidebar\"></xo-aside-header>\n    <div class=\"asideContent\">\n        <form method=\"post\" class=\"formSmall asideView container\" novalidate=\"novalidate\" name=\"addressNormalizationForm\">\n            <div ng-if=\"normalizedAddress\">\n                <h2 class=\"gamma\">{{ content('addressNormalization.title') }}</h2>\n                <p class=\"theta\">{{ content('addressNormalization.intro') }}</p>\n                <div class=\"normalizedAdrSection radio\">\n                    <p class=\"theta\" data-ng-bind-html=\"htmlContent('addressNormalization.addressmatch')\"></p>\n                    <label class=\"noBottom narrow addrLabel row-fluid\">\n                        <input type=\"radio\" id=\"defaultAddress\" ng-model=\"addressSelected\" name=\"addressSelected\" value=\"normalizedAddress\" ng-click=\"selection('normalizedAddress')\" class=\"addrRadio span2\" checked=\"true\">\n                        <div class=\"adr span20\">\n                            <div class=\"confidential streets street-address\">\n                                <div ng-if=\"normalizedAddress.line2\">{{normalizedAddress.line1}}, {{normalizedAddress.line2}},</div>\n                                <div ng-if=\"!normalizedAddress.line2\">{{normalizedAddress.line1}},</div>\n                            </div>\n                            <div class=\"confidential\">\n                                <span class=\"locality\">{{normalizedAddress.city}}</span>, <span class=\"state\">{{normalizedAddress.state}}</span>\n                                <span class=\"postal-code adr-break\">{{normalizedAddress.postal_code}},&nbsp;{{content('countryList.'+servAddress.country)}}</span>\n                            </div>\n                        </div>\n                    </label>\n                </div>\n                <div class=\"enteredAddrSection radio subContainer\">\n                    <p class=\"addressNormalizationIntro\" data-ng-bind-html=\"htmlContent('addressNormalization.addressenter')\"></p>\n\n                    <label class=\"noBottom narrow addrLabel row-fluid\">\n                        <input type=\"radio\" ng-model=\"addressSelected\" name=\"addressSelected\" value=\"enteredAddress\" ng-click=\"selection('enteredAddress')\" class=\"addrRadio span2\">\n                        <div class=\"adr span20\">\n                            <div class=\"confidential streets street-address\" ng-show=\"isLine2First()\">\n                                <div ng-if=\"servAddress.line2\">{{servAddress.line2}}, </div>{{servAddress.line1}},\n                            </div>\n                            <div class=\"confidential streets street-address\" ng-hide=\"isLine2First()\">\n                                <div ng-if=\"address.line2\">{{servAddress.line1}}, {{address.line2}}, {{servAddress.line2}},</div>\n                                <div ng-if=\"!address.line2\">{{servAddress.line1}}, {{servAddress.line2}},</div>\n                            </div>\n                            <div class=\"confidential\">\n                                <span class=\"locality\">{{servAddress.city}}</span>, <span class=\"state\">{{servAddress.state}}</span>\n                                <span class=\"postal-code adr-break\">{{servAddress.postal_code}},&nbsp;{{content('countryList.'+servAddress.country)}}</span>\n                            </div>\n                        </div>\n                    </label>\n                </div>\n            </div>\n            <div ng-if=\"!normalizedAddress\">\n                <h2 class=\"gamma\">{{ content('addressNormalization.noaddressmatchTitle') }}</h2>\n                <p class=\"theta\">{{ content('addressNormalization.noaddressmatchMsg') }}</p>\n                <input type=\"hidden\" name=\"addressdisplay\" value=\"enteredAddress\">\n                <div class=\"enteredAddrSection subContainer\">\n                    <p class=\"theta\">{{ content('addressNormalization.addressyouenter') }}</p>\n                    <div class=\"adr\">\n                        <div class=\"confidential streets street-address\" ng-show=\"isLine2First()\">\n                            {{servAddress.line2}} {{servAddress.line1}},\n                        </div>\n                        <div class=\"confidential streets street-address\" ng-hide=\"isLine2First()\">\n                            <div ng-if=\"address.line2\">{{servAddress.line1}}, {{address.line2}}, {{servAddress.line2}}</div>\n                            <div ng-if=\"!address.line2\">{{servAddress.line1}}, {{servAddress.line2}}</div>\n                        </div>\n                        <div class=\"confidential\">\n                            <span class=\"locality\">{{servAddress.city}}</span>, <span class=\"state\">{{servAddress.state}}</span>\n                            <span class=\"postal-code adr-break\">{{servAddress.postal_code}},&nbsp;{{content('countryList.'+servAddress.country)}}</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"buttons\" ng-if=\"!hideBackButton\">\n                <input id=\"back\" type=\"submit\" value=\"{{ content('common.back') }}\" class=\"btn firstHalf btn-secondary\" ng-click=\"onBack()\" >\n                <input track-submit=\"{{transitionName}}\" id=\"continue\" type=\"submit\" value=\"{{ content('common.continueLabel') }}\" class=\"btn secondHalf\" ng-click=\"onContinue()\">\n            </div>\n            <div class=\"buttons\" ng-if=\"hideBackButton\">\n                <input track-submit=\"{{transitionName}}\" id=\"fullContinue\" type=\"submit\" value=\"{{ content('common.continueLabel') }}\" class=\"btn\" ng-click=\"onContinue()\">\n            </div>\n        </form>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-beaver/dist/level.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module('beaver.level', []).factory('$logLevel', function () {
    return {
        INFO: 'info',
        DEBUG: 'debug',
        ERROR: 'error',
        WARN: 'warn',
        ALERT: 'alert'
    };
}).factory('$consoleLogLevel', function () {
    return {
        info: 'info',
        debug: 'debug',
        error: 'error',
        warn: 'warn',
        alert: 'info'
    };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-beaver/dist", "../node_modules/xo-beaver/dist/level.js"))

/***/ }),

/***/ "../node_modules/xo-beaver/dist/logger.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _level = __webpack_require__("../node_modules/xo-beaver/dist/level.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* eslint-disable angular/di */

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$Logger', function () {
    var logger = {};
    var HERMES_DEV_COOKIE = 'hermesdev';

    _angular2['default'].forEach(_level.$logLevel, function (level) {
        logger[level] = function (event, payload, settings) {
            return this.log(level, event, payload, settings);
        };
    });

    var hostname = _angular.$window.location && _angular.$window.location.hostname || '';
    var uniqueEvents = [];

    _angular2['default'].extend(logger, {
        autoLog: [_level.$logLevel.WARNING, _level.$logLevel.ERROR],
        flushInterval: 10 * 60 * 1000,
        heartbeatInterval: 5000,
        sizeLimit: 500,
        debounceInterval: 10,
        uri: '/api/log',
        rootTxnUri: '/api/log/crt',
        hearbeatMaxThreshold: 50,
        deploy: {
            isLocal: function isLocal() {
                return hostname === 'localhost' || hostname === 'localhost.paypal.com';
            },

            isStage: function isStage() {
                return Boolean(hostname.match(/^.*\.qa\.paypal\.com$/));
            },

            isLive: function isLive() {
                return hostname === 'www.paypal.com';
            }
        },

        init: function init() {
            var self = this;

            this.buffer = [];

            var previousBeforeUnloadHandler = _angular.$window.onbeforeunload;

            _angular.$window.onbeforeunload = function (event) {
                if (self.isDone) {
                    return;
                }

                self.info('window_beforeunload');

                if (previousBeforeUnloadHandler) {
                    return previousBeforeUnloadHandler.apply(this, arguments);
                }
            };

            var previousUnloadHandler = _angular.$window.onunload;

            _angular.$window.onunload = function (event) {

                if (self.isDone) {
                    return;
                }

                self.info('window_unload');
                self._flush();

                self.done();

                if (previousUnloadHandler) {
                    return previousUnloadHandler.apply(this, arguments);
                }
            };

            this.heartbeat();
            this.daemon();
        },

        heartbeat: function heartbeat() {
            var self = this;

            if (!window.enablePerformance) {
                return;
            }

            function timestamp() {
                var perf = window.performance;

                return parseInt(perf.now() - (perf.timing.connectEnd - perf.timing.navigationStart), 10);
            }

            var howBusy = {
                lastSampledTime: timestamp(),
                lastLag: 0,
                maxLag: 0,
                dampendedLag: 0
            };

            var count = 0;

            (0, _angular.$interval)(function () {

                if (!self.buffer.length || self.buffer[self.buffer.length - 1].event !== 'heartbeat') {
                    count = 0;
                }

                if (!self.buffer.length || count > self.hearbeatMaxThreshold) {
                    return;
                }

                count += 1;

                var payload = {
                    count: count
                };

                var now = timestamp();

                howBusy.lastLag = now - howBusy.lastSampledTime - self.heartbeatInterval;
                howBusy.maxLag = howBusy.lastLag > howBusy.maxLag ? howBusy.lastLag : howBusy.maxLag;
                howBusy.dampendedLag = (howBusy.lastLag + howBusy.dampendedLag * 2) / 3;
                howBusy.lastSampledTime = now;

                payload.lastLag = howBusy.lastLag.toFixed(4);
                payload.maxLag = howBusy.maxLag.toFixed(4);
                payload.dampendedLag = howBusy.dampendedLag.toFixed(4);
                payload.lastSampledTime = howBusy.lastSampledTime.toFixed(4);

                if (howBusy.lastLag > 10000) {
                    self.info('toobusy', {}, {
                        noConsole: true,
                        unique: true
                    });
                }

                self.info('heartbeat', payload, {
                    noConsole: true
                });
            }, this.heartbeatInterval);
        },

        done: function done() {
            this.flush(true);
            this.isDone = true;
        },

        addPerformanceData: function addPerformanceData(payload) {

            if (window.enablePerformance) {
                var performance = window.performance;
                var timing = window.performance.timing || {};
                var now = performance.now();

                if (window.clientStartTime && _angular2['default'].isUndefined(payload.client_elapsed)) {
                    payload.client_elapsed = parseInt(now - window.clientStartTime, 10);
                }

                if (timing.connectEnd && timing.navigationStart && _angular2['default'].isUndefined(payload.req_elapsed)) {
                    payload.req_elapsed = parseInt(now - (timing.connectEnd - timing.navigationStart), 10);
                }
            }
        },

        addLocaleData: function addLocaleData(payload) {

            var context = {};

            try {
                context = _angular.$injector.get('$metaBuilder').buildContext();
            } catch (err) {
                return; // Continue without adding locale data
            }
            if (context.locale && context.locale.country) {
                payload.site_cntry = context.locale.country;
            }
        },

        /* jslint maxcomplexity: false */
        log: function log(level, event, payload, settings) {
            var self = this;

            payload = payload || {};

            if (_angular2['default'].isArray(payload) || !_angular2['default'].isObject(payload)) {
                payload = {
                    payload: payload
                };
            }
            settings = settings || {};

            if (settings.unique) {
                var hash = event + ':' + _angular2['default'].toJson(payload);

                if (uniqueEvents.indexOf(hash) > -1) {
                    return self;
                }
                uniqueEvents.push(hash);
            }

            payload.pageID = window.meta && window.meta.pageID;

            this.addPerformanceData(payload);
            this.addLocaleData(payload);

            self.print(level, event, payload, settings);

            if (this.buffer.length >= this.sizeLimit) {
                if (this.buffer.length === this.sizeLimit) {
                    return self.enqueue('warn', 'logger_max_buffer_length');
                }
                return self;
            }

            return self.enqueue(level, event, payload, settings);
        },

        getTimestamp: function getTimestamp() {
            var now = Date.now();

            return window.logOffset ? window.logOffset + now : now;
        },

        enqueue: function enqueue(level, event, payload, settings) {
            payload = payload || {};
            settings = settings || {};

            var data = {
                level: level,
                event: event,
                timestamp: this.getTimestamp(),
                payload: payload
            };

            this.buffer.push(data);

            // If the log level is classified as autolog, then flush the data
            if (this.autoLog.indexOf(level) > -1) {
                this.flush();
            }

            return this;
        },

        shouldPrintLogsToConsole: function shouldPrintLogsToConsole(settings) {

            if (settings.noConsole) {
                return false;
            }

            if (window.meta && window.meta.corp) {
                return true;
            }

            if (this.deploy.isLocal() || this.deploy.isStage()) {
                return true;
            }

            var cookies = window.cookies || {};

            if (cookies[HERMES_DEV_COOKIE] && cookies[HERMES_DEV_COOKIE] === '1') {
                return true;
            }

            return false;
        },

        print: function print(level, event, payload, settings) {

            if (!this.shouldPrintLogsToConsole(settings)) {
                return;
            }

            var args = [event];

            if (payload) {
                args.push(payload);

                if (payload.stack || payload.error || payload.warning) {
                    args.push('\n\n', payload.stack || payload.error || payload.warning);
                }
            }

            _angular.$log[_level.$consoleLogLevel[level] || 'info'].apply(_angular.$log, args);
        },

        flush: function flush(immediate) {
            var self = this;

            if (!this.buffer.length) {
                return _angular.$q.when();
            }

            if (immediate) {
                return _angular.$q.when(this._flush());
            }

            if (self.debouncer_timeout) {
                _angular.$timeout.cancel(self.debouncer_timeout);
            }

            self.debouncer_timeout = (0, _angular.$timeout)(function () {

                var resolver = self.debouncer_resolver;

                delete self.debouncer_promise;
                delete self.debouncer_resolver;
                delete self.debouncer_timeout;

                self._flush().then(function () {
                    resolver();
                });
            }, this.debounceInterval);

            self.debouncer_promise = self.debouncer_promise || (0, _angular.$q)(function (resolver) {
                self.debouncer_resolver = resolver;
            });

            return self.debouncer_promise;
        },

        _flush: function _flush() {
            var self = this;

            if (!self.buffer.length) {
                return _angular.$q.when();
            }

            var meta = {};

            try {
                meta = _angular.$injector.get('$metaBuilder').build();
            } catch (err) {
                // @TODO - Log error
            }

            var req = this.ajax('post', _angular.$window.meta.logURL || _angular.$window.config.urls.baseUrl + this.uri, {
                data: {
                    events: self.buffer
                },
                meta: meta
            });

            self.buffer = [];

            return req;
        },

        ajax: function ajax(method, url, json) {
            return (0, _angular.$q)(function (resolve) {
                var XRequest = window.XMLHttpRequest || ActiveXObject; // eslint-disable-line no-undef, block-scoped-var
                var req = new XRequest('MSXML2.XMLHTTP.3.0');
                var logAppName = _angular.$window.meta.logAppName;

                req.open(method.toUpperCase(), url);

                req.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                req.setRequestHeader('Content-type', 'application/json');

                if (logAppName) {
                    req.setRequestHeader('x-app-name', logAppName);
                }

                req.onreadystatechange = function () {
                    if (req.readyState > 3) {
                        resolve();
                    }
                };
                req.send(_angular2['default'].toJson(json).replace(/&/g, '%26')); // eslint-disable-line angular/ng_json_functions
            });
        },

        daemon: function daemon() {
            this.stop();

            var self = this;

            this.timer = (0, _angular.$interval)(function () {
                self.flush();
            }, this.flushInterval);
        },

        stop: function stop() {
            if (this.timer) {
                _angular.$interval.cancel(this.timer);
            }
        },

        createCalRootTxn: function createCalRootTxn(data, txnName) {
            if (data !== null && _angular2['default'].isObject(data)) {
                var rootTxnData = { 'data': {}, 'transactionName': '' };
                var url = '' + _angular.$window.config.urls.baseUrl + this.rootTxnUri;
                if (_angular2['default'].isString(txnName)) {
                    rootTxnData.transactionName = txnName;
                }
                Object.assign(rootTxnData.data, data);
                this.ajax('post', url, rootTxnData);
            }
        }
    });

    function Logger(val) {
        _angular2['default'].extend(this, val);
        this.init();
    }

    Logger.prototype = logger;
    Logger.prototype.constructor = Logger;

    return Logger;
}).factory('$logger', ['$Logger', function ($Logger) {
    return new $Logger();
}]).run(['$logger', function ($logger) {
    _angular2['default'].forEach(window.beaconQueue, function (payload) {
        $logger.log(payload.level, payload.event, payload);
    });

    window.beacon = function (level, events, payload) {
        _angular2['default'].forEach(events, function (event) {
            $logger.log(level, event, payload);
        });
    };
}]);

_level.$logLevel;

_level.$consoleLogLevel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-beaver/dist", "../node_modules/xo-beaver/dist/logger.js"))

/***/ }),

/***/ "../node_modules/xo-credit-components/src/banner-interstitial/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

__webpack_require__("../node_modules/xo-credit-components/src/banner-interstitial/styles.less");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/banner-interstitial/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var VALID_TREATMENTS = [1];
var TREATMENT_PREFIX = 'bannerInterstitialPageTreatment';

exports['default'] = _squid.$Component.extend('$xoBannerInterstitialDirective', {
    tag: 'xo-banner-interstitial',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },
    actions: {
        redirectToReview: function redirectToReview() {
            _logger.$logger.info('Redirecting to review page from banner-interstitial');
            _uiRouter.$state.go('checkout.review');
        },
        redirectToCAPE: function redirectToCAPE() {
            _logger.$logger.info('Redirecting to cape from banner-interstitial');
            _uiRouter.$state.go('checkout.redirectToCape', {}, { location: false });
        }
    },
    lifecycle: {
        enter: function enter() {
            _logger.$logger.info('$xoBannerInterstitialDirective:enter():$stateParams', _uiRouter.$stateParams);
            (0, _jquery2['default'])('body').addClass('bannerInterstitialPage');
            // if in an invalid state, redirect
            if (!_angular2['default'].isObject(_uiRouter.$stateParams) || !_angular2['default'].isObject(_uiRouter.$stateParams.banner) || !_uiRouter.$stateParams.banner.hasOwnProperty('bodyText') || VALID_TREATMENTS.indexOf(_uiRouter.$stateParams.creditInterstitialTreatment) === -1) {
                this.actions.redirectToReview();
            } else {
                (0, _jquery2['default'])('body').addClass('' + TREATMENT_PREFIX + _uiRouter.$stateParams.creditInterstitialTreatment);
                this.banner = _uiRouter.$stateParams.banner;
            }
        },
        exit: function exit() {
            _logger.$logger.info('$xoBannerInterstitialDirective:exit()');
            (0, _jquery2['default'])('body').removeClass('bannerInterstitialPage');
            _angular2['default'].forEach(VALID_TREATMENTS, function (t) {
                (0, _jquery2['default'])('body').removeClass('' + TREATMENT_PREFIX + t);
            });
        }
    }
});


_squid.$Component;

_logger.$logger;

_uiRouter.$state;

_uiRouter.$stateParams;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-credit-components/src/banner-interstitial/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$BannerInterstitialRoute = undefined;

__webpack_require__("../node_modules/xo-credit-components/src/banner-interstitial/directive.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $BannerInterstitialRoute = exports.$BannerInterstitialRoute = _squid.$ComponentRoute.extend('$BannerInterstitialRoute', {
    path: 'bannerInterstitial',
    params: {
        creditInterstitialTreatment: null,
        banner: null
    },
    directive: 'xo-banner-interstitial',
    titleContent: 'bannerInterstitial.interstitial',
    trackingData: {
        fptiState: 'banner_interstitial',
        buzname: {
            'fullpage': {
                'pagename': '%::banner_interstitial',
                'pagename2': '%::banner_interstitial:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    children: []
});

exports['default'] = $BannerInterstitialRoute;

angular.value("$BannerInterstitialRoute", $BannerInterstitialRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/banner-interstitial/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-credit-components/src/banner-interstitial/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"bannerInterstitial\">\n\n  <input type=\"hidden\" id=\"bannerInterstitialMessageId\" value=\"{{banner.messageId}}\"/>\n\n  <div class=\"bannerInterstitialColumn\">\n\n    <div class=\"bannerInterstitialLogo\">\n      <img\n        src=\"https://www.paypalobjects.com/webstatic/credit/img/PPClogo_banner.png\"\n        width=\"90\"\n      />\n    </div>\n\n    <div class=\"bannerInterstitialImage\"></div>\n\n    <div class=\"bannerInterstitialXCloseContainer\">\n      <input\n        track-submit=\"acquisition_offer_interstitial_x_close_review_submit\"\n        type=\"submit\"\n        value=\"\"\n        id=\"buttonRedirectToReviewXClose\"\n        class=\"bannerInterstitialXClose\"\n        ng-click=\"actions.redirectToReview()\"\n      />\n    </div>\n\n    <div class=\"bannerInterstitialHeadline\">\n      <span ng-bind-html=\"banner.bodyText\"></span>\n    </div>\n\n    <div class=\"bannerInterstitialTagline\">\n      <span ng-bind-html=\"banner.bodyText2\"></span>\n    </div>\n\n    <div class=\"bannerInterstitialTermsContent\">\n      <span ng-bind-html=\"banner.termsText2\"></span>\n      <span ng-bind-html=\"banner.termsText\"></span>\n      <a\n        href=\"{{banner.termsLink}}\"\n        class=\"popup bmlTermsLink bannerInterstitialTermsLink\"\n        target=\"_blank\"\n        xo-popup\n        track-link=\"acquisition_offer_interstitial_terms_link\"\n        ng-bind-html=\"banner.termsLinkText\"\n      >\n      </a>\n    </div>\n\n    <div class=\"button buttonCape\">\n        <input\n          track-submit=\"acquisition_offer_interstitial_cape_submit\"\n          type=\"submit\"\n          value=\"{{banner.ctaText}}\"\n          id=\"buttonRedirectToCAPE\"\n          class=\"btn full confirmButton continueButton\"\n          ng-click=\"actions.redirectToCAPE()\"\n        />\n    </div>\n\n    <div class=\"button buttonReview\">\n        <input\n          track-submit=\"acquisition_offer_interstitial_review_submit\"\n          type=\"submit\"\n          value=\"Maybe Later\"\n          id=\"buttonRedirectToReview\"\n          class=\"btn full confirmButton continueButton\"\n          ng-click=\"actions.redirectToReview()\"\n        />\n    </div>\n\n  </div>\n\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename, $) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/bml-display/template.html");

var _template2 = _interopRequireDefault(_template);

var _bml = __webpack_require__("../node_modules/xo-models/src/bml/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$BMLStateHandler', function () {
    var APPROVED = 'APPROVED';
    var SOFT_DECLINED = 'SOFT_DECLINED';
    var DECLINED = 'DECLINED';
    var FUNDING_INSTRUMENT_ASSOCIATED_WITH_DIFFERENT_MEMBER = 'FUNDING_INSTRUMENT_ASSOCIATED_WITH_DIFFERENT_MEMBER';
    var NEED_SIGNATURE = 'NEED_SIGNATURE';
    var PENDING_COMPLETION_STATUS = 'PENDING_COMPLETION_STATUS';
    var FULL_APPLY_REQUIRED = 'FULL_APPLY_REQUIRED';
    var UNKNOWN_DECISION = 'UNKNOWN_DECISION';
    var INELIGIBLE = 'INELIGIBLE'; // TODO; This state is returned by applybml but was not defined in Aries
    var MAX_SOFT_DECLINES = config.bmlMaxSoftDeclines; // eslint-disable-line block-scoped-var,no-undef

    var BMLStateHandler = function BMLStateHandler(bmlData) {
        this.reviewUrl = bmlData.reviewUrl;
        this.bml = bmlData.bml;
        this.bmlApply = bmlData.bmlApply;
        this.bmlComplete = bmlData.bmlComplete;
        this.checkoutSession = bmlData.checkoutSession;
        this.auth = bmlData.auth;
        this.purchase = bmlData.purchase;
        this.patchPhone = bmlData.patchPhone;
        this.billingAddresses = bmlData.billingAddresses;
        this.merchant = bmlData.merchant;
        this.merchantId = bmlData.merchantId;

        this.handlers = {};
        this.handlers[APPROVED] = this.handleAppStatusApproved;
        this.handlers[DECLINED] = this.handleAppStatusDeclined;
        this.handlers[SOFT_DECLINED] = this.handleAppStatusSoftDeclined;
        this.handlers[FUNDING_INSTRUMENT_ASSOCIATED_WITH_DIFFERENT_MEMBER] = this.handleAppStatusFundingInsExist;
        this.handlers[NEED_SIGNATURE] = this.handleAppStatusNeedSignature;
        this.handlers[PENDING_COMPLETION_STATUS] = this.handleAppStatusPendingCompletion;
        this.handlers[UNKNOWN_DECISION] = this.handleAppStatusUnknownDecision;
        this.handlers[FULL_APPLY_REQUIRED] = this.handleAppStatusFullApplyRequired;
        this.handlers[INELIGIBLE] = this.handleAppStatusIneligible;
    };

    BMLStateHandler.prototype.payInFullRedirect = function payInFullRedirect(result) {
        _logger.$logger.info('APPLYFORBML_VIEW_OPTOUTBML');
        _uiRouter.$state.go(this.reviewUrl);
    };

    BMLStateHandler.prototype.termsAndCondition = function termsAndCondition(result) {
        _uiRouter.$state.go('^.bmltermsandconditions');
    };

    BMLStateHandler.prototype.handleAppStatusIneligible = function handleAppStatusIneligible(result) {
        _logger.$logger.info('APPLYFORBML_INELIGIBLE');
        _logger.$logger.info('checkout_fpti', {
            'ppc_status': 'bmlIneligible'
        });
        this.checkoutSession.creditOffer = false;
        this.checkoutSession.showDeclinePopup = true;
        _uiRouter.$state.go(this.reviewUrl);
    };

    BMLStateHandler.prototype.handleAppStatusUnknownDecision = function handleAppStatusUnknownDecision(result) {
        _logger.$logger.info('APPLYFORBML_UNKNOWN_DECISION');
        _logger.$logger.info('checkout_fpti', {
            'ppc_status': 'bmlUnknownDecision'
        });
        this.checkoutSession.creditOffer = false;
        this.checkoutSession.showDeclinePopup = true;
        _uiRouter.$state.go(this.reviewUrl);
    };

    BMLStateHandler.prototype.handleAppStatusApproved = function handleAppStatusApproved(result) {
        _logger.$logger.info('APPLYFORBML_ACTION_BMLSUCCESS');
        _logger.$logger.info('checkout_fpti', {
            'ppc_status': 'bmlSuccess'
        });
        this.checkoutSession.fundingOptions.action('update', {
            resultModel: this.checkoutSession,
            data: {
                planId: this.bml.financial_instrument_id
            },
            success: $.proxy(function (successResult) {
                _uiRouter.$state.go(this.reviewUrl);
            }, this),
            contingencies: {
                DEFAULT: function DEFAULT(name) {
                    _uiRouter.$state.go(this.reviewUrl);
                }
            }
        });
    };

    BMLStateHandler.prototype.handleAppStatusPendingCompletion = function handleAppStatusPendingCompletion(result) {
        _logger.$logger.info('checkout_fpti', {
            'ppc_status': 'completeBmlApply'
        });
        this.completeApplication(result.application_id);
    };

    BMLStateHandler.prototype.handleAppStatusNeedSignature = function handleAppStatusNeedSignature(result) {
        _logger.$logger.info('APPLYFORBML_NEED_SIGNATURE');
        this.bml.application_id = result.application_id;
        _logger.$logger.info('checkout_fpti', {
            'ppc_status': 'needSignature'
        });
        _uiRouter.$state.go('^.bmlsignature');
    };

    BMLStateHandler.prototype.handleAppStatusDeclined = function handleAppStatusDeclined(result) {

        _logger.$logger.info('APPLYFORBML_ACTION_BMLDECLINEHARD');
        _logger.$logger.info('checkout_fpti', {
            'ppc_status': 'creditDeclineHard'
        });
        this.bml.application_status = 'DECLINED';
        this.checkoutSession.creditOffer = false;
        this.checkoutSession.showDeclinePopup = true;

        _uiRouter.$state.go(this.reviewUrl);
    };

    BMLStateHandler.prototype.handleAppStatusSoftDeclined = function handleAppStatusSoftDeclined(result) {

        this.bml.bmlSoftDeclineCtr = (this.bml.bmlSoftDeclineCtr || 0) + 1;
        if (this.bml.bmlSoftDeclineCtr < MAX_SOFT_DECLINES) {
            _logger.$logger.info('APPLYFORBML_ACTION_BMLDECLINESOFT');
            _uiRouter.$state.go('^.bmlapply');
        } else {
            _logger.$logger.info('checkout_fpti', {
                'ppc_status': 'bmlMaxAttempts'
            });
            _logger.$logger.info('APPLYFORBML_ACTION_BMLMAXATTEMPTS');
            this.bml.application_status = 'DECLINED';
            this.checkoutSession.creditOffer = false;
            this.checkoutSession.showDeclinePopup = true;

            _uiRouter.$state.go(this.reviewUrl);
        }
    };

    BMLStateHandler.prototype.handleAppStatusFundingInsExist = function handleAppStatusFundingInsExist(result) {
        _logger.$logger.info('APPLYFORBML_ACTION_BMLDECLINELINKEDTODIFFMEMBER');
        _logger.$logger.info('checkout_fpti', {
            'ppc_status': 'bmlDeclineLinkedToDiffMember'
        });
        this.checkoutSession.creditOffer = false;
        this.checkoutSession.showDeclinePopup = true;
        _uiRouter.$state.go(this.reviewUrl);
    };

    BMLStateHandler.prototype.handleAppStatusFullApplyRequired = function handleAppStatusFullApplyRequired(result) {
        _logger.$logger.info('APPLYFORBML_FULLAPPLYREQUIRED');
        _logger.$logger.info('checkout_fpti', {
            'ppc_status': 'fullApplyRequired'
        });
        this.checkoutSession.creditOffer = false;
        this.bml.fullApplyRequired = true;
        this.checkoutSession.showDeclinePopup = true;

        _uiRouter.$state.go(this.reviewUrl);
    };

    BMLStateHandler.prototype.handleBmlTransitions = function handleBmlTransitions(result) {
        var handler = this.handlers[result.application_status];
        if (!handler) {
            throw new Error('no registered handler for bml transition for application status ' + result.application_status);
        }
        return $.proxy(handler, this, result)();
    };

    BMLStateHandler.prototype.completeApplication = function completeApplication(application_id) {

        this.bmlComplete.application_id = application_id;
        this.bmlComplete.action('complete', {

            success: $.proxy(function (result) {
                _logger.$logger.info('COMPLETEBMLAPPLY_ACTION_BMLSUCCESS');
                var bml = this.bml;

                // Update the application_status & financial_instrument_id in bml model
                bml.setProperties({
                    financial_instrument_id: result.financial_instrument_id,
                    application_status: result.application_status
                });

                if (bml.phoneChanged && result && result.user_info && result.user_info.phones && result.user_info.phones.length > 0 && result.user_info.phones[0].id) {

                    var newPhoneVO = {
                        op: 'add',
                        path: '/payer_info',
                        value: {
                            phone: this.bmlApply.personalInformation.phone.telephone
                        }
                    };
                    this.patchPhone.save({
                        data: {
                            patch: newPhoneVO
                        },
                        success: $.proxy(function () {
                            delete bml.phoneChanged;
                            this.handleBmlTransitions(result);
                        }, this),
                        contingencies: {
                            DEFAULT: $.proxy(function handleContingency(name, contingency) {
                                _logger.$logger.info('BMLPATCHPHONE_CONTINGENCY', name);
                                this.handleBmlTransitions(result);
                            }, this)
                        }
                    });
                } else {
                    this.handleBmlTransitions(result);
                }
            }, this)
        });
    };

    BMLStateHandler.prototype.getDefaultBillingAddress = function getDefaultBillingAddress(billingAddresses) {
        var defaultBillingAddress = billingAddresses && billingAddresses.addresses;
        defaultBillingAddress = defaultBillingAddress.map(function (address, index, array) {
            if (address && address['default'] === true) {
                return address;
            }
        });

        defaultBillingAddress = defaultBillingAddress.length > 0 && defaultBillingAddress[0];
        return defaultBillingAddress;
    };

    BMLStateHandler.prototype.applyBML = function applyBML() {

        var defaultBillingAddress = this.getDefaultBillingAddress(this.billingAddresses);

        this.bml.action('apply', {
            data: {
                flow: {
                    nape: this.bml.nape,
                    fullApplyRequired: this.bml.fullApplyRequired
                },
                payer: {
                    email: this.checkoutSession.payer.email,
                    id: this.checkoutSession.payer.id,
                    phone: this.bmlApply.personalInformation.phone.telephone,
                    phone_type: this.bmlApply.personalInformation.phone.phoneType
                },
                billing_address: {
                    line1: defaultBillingAddress.line1,
                    line2: defaultBillingAddress.line2,
                    city: defaultBillingAddress.city,
                    state: defaultBillingAddress.state,
                    postal_code: defaultBillingAddress.postal_code,
                    country: defaultBillingAddress.country,
                    id: defaultBillingAddress.id
                },
                payment_info: {
                    total_transaction_amount: {
                        value: this.purchase.amounts.total.amount,
                        currency: this.purchase.amounts.total.currency_code
                    },
                    recipient: {
                        id: this.merchantId,
                        total_amount: {
                            value: this.purchase.amounts.total.amount,
                            currency: this.purchase.amounts.total.currency_code
                        },
                        business_name: this.merchant.brand_name,
                        type: 'PAYPAL_CORE',
                        multi_seller_indicator: false,
                        country_code: this.merchant.merchant_country
                    },
                    shipping_address: {
                        id: this.checkoutSession.shipping.id,
                        name: this.checkoutSession.shipping.name,
                        line1: this.checkoutSession.shipping.line1,
                        line2: this.checkoutSession.shipping.line2,
                        city: this.checkoutSession.shipping.city,
                        state: this.checkoutSession.shipping.state,
                        country_code: this.checkoutSession.shipping.country,
                        postal_code: this.checkoutSession.shipping.postal_code,
                        'default': this.checkoutSession.shipping['default']
                    },
                    name: {
                        first_name: this.auth.first_name,
                        last_name: this.auth.last_name
                    },
                    item_info: this.purchase.items
                },
                dobSsn: {
                    dobMonth: this.bmlApply.personalInformation.month,
                    dobDay: this.bmlApply.personalInformation.day,
                    dobYear: this.bmlApply.personalInformation.year,
                    nationalId: this.bmlApply.personalInformation.natId
                }
            },

            resultModel: this.bml,

            success: $.proxy(function (result) {
                this.handleBmlTransitions(result);
            }, this),

            contingencies: {
                DEFAULT: $.proxy(function handleContingency(name, contingency) {
                    this.bml.contingency = name;
                    this.checkoutSession.creditOffer = false;
                    this.checkoutSession.showDeclinePopup = true;
                    _uiRouter.$state.go(this.reviewUrl);
                }, this)
            }
        });
    };
    return BMLStateHandler;
}).directive('xoBmlDisplay', function () {
    return {
        template: _template2['default'],
        scope: {
            reviewUrl: '=?'
        },
        controller: ['$scope', function ($scope) {
            if (!_angular.$rootScope.bml && !_angular.$rootScope.bmlApply) {
                $scope.bml = new _bml.$BMLModel();
                $scope.bmlApply = new _bml.$ApplyForBMLModel();
            } else {
                $scope.bml = _angular.$rootScope.bml;
                $scope.bmlApply = _angular.$rootScope.bmlApply;
            }
            $scope.bmlComplete = new _bml.$BMLApplicationModel();
            _uiRouter.$state.go('^.bmlapply');
        }]
    };
});

_angular.$rootScope;

_uiRouter.$state;

_logger.$logger;

_bml.$BMLModel;

_bml.$ApplyForBMLModel;

_bml.$BMLApplicationModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-credit-components/src/bml-display", "../node_modules/xo-credit-components/src/bml-display/directive.js", __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-credit-components/src/bml-display/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/bml-display/xo-bml-apply/route.js");

__webpack_require__("../node_modules/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/route.js");

__webpack_require__("../node_modules/xo-credit-components/src/bml-display/xo-bml-signature/route.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$BMLDisplay', function () {
    return _squid.$ComponentRoute.extend('BmlDisplay', {
        name: 'bmldisplay',
        directive: 'xo-bml-display',
        trackingData: {
            fptiState: 'ppc_display',
            buzname: {
                'fullpage': {
                    'pagename': '%::ppc_display',
                    'pagename2': '%::ppc_display:member:hermes:',
                    'version': 'member:%:'
                }
            }
        },
        titleContent: 'applyForBml.bmlApplyHeadline',
        children: [{
            name: '$BmlApplyRoute'
        }, {
            name: '$BmlTermsAndConditionsRoute'
        }, {
            name: '$BmlSignatureRoute'
        }]
    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-credit-components/src/bml-display", "../node_modules/xo-credit-components/src/bml-display/route.js"))

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/template.html":
/***/ (function(module, exports) {

module.exports = "<div ui-view>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/xo-bml-apply/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

__webpack_require__("../node_modules/xo-form-components/src/dob-nationalid/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInput/directive.js");

var _index = __webpack_require__("../node_modules/xo-models/src/address/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

__webpack_require__("../node_modules/xo-models/src/bml/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _index4 = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _index5 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

var _directive = __webpack_require__("../node_modules/xo-credit-components/src/bml-display/directive.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/bml-display/xo-bml-apply/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoBmlApplyPage', function () {
    return {
        template: _template2['default'],
        controller: ['$scope', '$element', function ($scope, $element) {
            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance(),
                payee: _index2.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
                billingAddresses: _index4.$BillingAddressesModel.instance(),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
                checkoutSession: _index2.$CheckoutSessionModel.instance(_angular.$rootScope.token),
                checkoutCart: _index2.$CheckoutCartModel.instance(_angular.$rootScope.token),
                creditOptions: _index3.$CreditInstallmentModel.instance(_angular.$rootScope.token)
            }).then(function () {
                var defaultBillingAddress = $scope.billingAddresses && $scope.billingAddresses.addresses;

                defaultBillingAddress = defaultBillingAddress.map(function (address, index, array) {
                    if (address && address['default'] === true) {
                        return address;
                    }
                });
                defaultBillingAddress = defaultBillingAddress.length > 0 && defaultBillingAddress[0];

                if (defaultBillingAddress) {
                    $scope.bml.action('napeLookUp', {
                        data: {
                            payer: $scope.checkoutSession.payer,
                            billing_address: {
                                country: defaultBillingAddress.country,
                                line1: defaultBillingAddress.line1,
                                line2: defaultBillingAddress.line2,
                                city: defaultBillingAddress.city,
                                state: defaultBillingAddress.state,
                                postal_code: defaultBillingAddress.postal_code
                            }
                        },
                        success: function success(result) {
                            if (result && result.account_exists === true) {
                                $scope.bml.nape = 'napePotential';
                                $scope.bml.fullApplyRequired = false;
                            }
                        },
                        contingencies: {
                            DEFAULT: function DEFAULT() {
                                // add a log here
                            }
                        }
                    });
                }

                if ($scope.billingAddresses && $scope.billingAddresses.addresses && $scope.billingAddresses.addresses.length > 0) {
                    $scope.billingAddresses.addresses.forEach(function (address) {
                        if (address['default']) {
                            $scope.address = billingAddressObject(address); // eslint-disable-line no-use-before-define
                            $scope.previousDefaultBillingAddress = address;
                        }
                    });
                }

                var bmlData = {
                    reviewUrl: $scope.$parent.reviewUrl,
                    bml: $scope.$parent.bml,
                    bmlApply: $scope.$parent.bmlApply,
                    bmlComplete: $scope.$parent.bmlComplete,
                    checkoutSession: $scope.checkoutSession,
                    auth: $scope.auth,
                    purchase: $scope.checkoutCart.purchase,
                    patchPhone: $scope.patchPhoneModel,
                    billingAddresses: $scope.billingAddresses,
                    merchant: $scope.checkoutAppData.merchant,
                    merchantId: $scope.payee.merchant.id
                };

                $scope.bmlStateHandler = new _directive.$BMLStateHandler(bmlData);

                if ($scope.checkoutSession.payer) {
                    $scope.bmlApply.personalInformation.phone.telephone = $scope.checkoutSession.payer.phone;
                    $scope.bmlApply.personalInformation.phone.phoneType = 'MOBILE';
                    // Set mobile as default to prevent unknown type.
                } else {
                    $scope.bmlFlags.PhoneAdd = true;
                }
            });

            var $el = $($element);

            function handleDobValidation() {
                var $fields = $('#dobSelect .dropdown select');

                $fields.addClass('backendError');
                if (window.scrollTo) {
                    window.scrollTo(0, 0);
                }
            }

            function triggerNextState() {
                _logger.$logger.info('APPLYFORBML_VIEW_SUBMIT');
                if ($scope.bml.nape === 'napePotential') {
                    $scope.bmlStateHandler.applyBML();
                } else {
                    $scope.checkoutSession.message = null;
                    $scope.bmlStateHandler.termsAndCondition();
                }
            }

            function isUserInputtedAddress(address) {
                return address.id === '0';
            }

            function handleValidation(res) {
                if (res && res.fields && res.fields.length) {
                    res.fields.forEach(function (field) {
                        if (field.field) {
                            var $field = $($el.find('[name="' + field.field + '"]'));
                            $field.addClass('backendError');
                        }
                    });
                }

                $scope.checkoutSession.message = {
                    type: 'error',
                    msgKeys: ['genericError.incontextGenericPageError']
                };

                if (window.scrollTo) {
                    window.scrollTo(0, 0);
                }
            }

            function handlePhoneValidation() {
                var $field = $('.telephone');

                $field.addClass('backendError');
                if (window.scrollTo) {
                    window.scrollTo(0, 0);
                }
            }

            function billingAddressObject(address) {
                return new _index4.$BillingAddressModel({
                    line1: address.line1,
                    line2: address.line2,
                    city: address.city,
                    state: address.state,
                    postal_code: address.postal_code,
                    country: $scope.countryCode,
                    full_address: address.full_address,
                    id: '0'
                });
            }

            $scope.showPhone = function () {
                return $scope.checkoutSession.payer.phone && $scope.checkoutSession.payer.phone_type === 'WORK';
            };
            $scope.patchPhoneModel = new _index5.$PatchPhoneModel();
            $scope.patchPhoneModel.token = $scope.token;
            $scope.init = function () {
                $scope.checkoutSession.message = null;
                $scope.previousDefaultBillingAddress = {};
                $scope.bmlFlags = {};
                $scope.address = {};
                $scope.token = _angular.$rootScope.token;
                $scope.countryCode = _squid.$locale.country;
                $scope.validateAddress = new _index.$ValidateAddressModel();
                $scope.validatePhoneModel = new _index5.$ValidatePhoneModel();
                $scope.validatePhoneModel.token = $scope.token;
                $scope.bmlFlags.billingAddressUpdated = false;
                $scope.bmlFlags.AddressAdd = false;
                $scope.bmlFlags.AddressDisplay = true;
                $scope.bmlFlags.PhoneAdd = false;
                $scope.bmlFlags.ChangeLink = true;
                $scope.billingAddressUpdated = false;

                $('.paypalHeaderWrapper').addClass('paypalCredit');
                $('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
                $('.paypalHeader').addClass('span14');
                $('.paypalHeader').removeClass('span24');

                if ($scope.bml && $scope.bml.application_status === 'SOFT_DECLINED') {
                    $scope.checkoutSession.message = {
                        type: 'warning',
                        msgKeys: ['applyForBml.bmlDeclineSoft']
                    };
                }
                _logger.$logger.info('APPLYFORBML_VIEW_RENDER');
            };

            $scope.redirectToReview = function () {
                $scope.bmlStateHandler.payInFullRedirect();
            };

            $scope.onContinue = function () {
                if ($scope.validateLegalAge()) {
                    if ($scope.bmlFlags.billingAddressUpdated) {
                        $scope.validateBillingAddress();
                    } else {
                        triggerNextState();
                    }
                }
            };

            $scope.validateLegalAge = function () {
                var dobMonth = $scope.bmlApply.personalInformation.month,
                    dobDay = $scope.bmlApply.personalInformation.day,
                    dobYear = $scope.bmlApply.personalInformation.year,
                    currentDate = new Date(),
                    currentMonth = currentDate.getMonth() + 1,
                    currentDay = currentDate.getDate(),
                    currentYear = currentDate.getFullYear(),
                    largestDOBYear = currentYear - 18; // Legal Age is 18

                var isLegal = dobYear < largestDOBYear || dobYear === largestDOBYear && dobMonth < currentMonth || // eslint-disable-line no-extra-parens
                dobYear === largestDOBYear && dobMonth === currentMonth && dobDay <= currentDay; // eslint-disable-line no-extra-parens

                if (!isLegal) {
                    handleDobValidation();
                }

                return isLegal;
            };

            $scope.changeAddress = function () {
                $scope.bmlFlags.billingAddressUpdated = true;
                $scope.bml.phoneChanged = true;
                $scope.bmlFlags.AddressAdd = true;
                $scope.bmlFlags.AddressDisplay = false;
                $scope.bmlFlags.PhoneAdd = true;
                $scope.bmlFlags.ChangeLink = false;
            };

            $scope.changePlan = function () {
                _uiRouter.$state.go('checkout.chooseCreditOffer');
            };

            $scope.validateBillingAddress = function () {
                var newBilling = billingAddressObject($scope.address);
                newBilling['default'] = true;
                $scope.previousDefaultBillingAddress['default'] = false;
                $scope.validatePhoneModel.save({
                    data: {
                        telephone: $scope.bmlApply.personalInformation.phone.telephone,
                        phoneType: $scope.bmlApply.personalInformation.phone.phoneType
                    },
                    success: function success(result) {

                        if (result) {
                            newBilling.save({
                                data: $scope.billingAddress,

                                success: function success() {
                                    $scope.updateBillingAddress(newBilling);
                                },

                                validation: function validation(res) {
                                    handleValidation(res);
                                }
                            });
                        } else {
                            handlePhoneValidation(result);
                        }
                    },
                    validation: function validation(result) {
                        handlePhoneValidation(result);
                    }
                });
            };

            $scope.updateBillingAddress = function (newBillingAddress) {
                var addresses = $scope.billingAddresses.addresses;
                if (!isUserInputtedAddress(addresses[0])) {
                    addresses.unshift(newBillingAddress);
                } else {
                    addresses[0] = newBillingAddress;
                }
                triggerNextState();
            };

            $scope.init();
        }]
    };
});

_angular.$rootScope;

_squid.$locale;

_squid.$populate;

_uiRouter.$state;

_logger.$logger;

_index.$ValidateAddressModel;

_auth.$AuthModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutPayeeModel;

_index2.$CheckoutSessionModel;

_index3.$CreditInstallmentModel;

_index4.$BillingAddressesModel;

_index4.$BillingAddressModel;

_index5.$PatchPhoneModel;

_index5.$ValidatePhoneModel;

_directive.$BMLStateHandler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/xo-bml-apply/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-credit-components/src/bml-display/xo-bml-apply/directive.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$BmlApplyRoute', function () {

    return _squid.$ComponentRoute.extend('BmlApplyRoute', {

        name: 'bmlapply',
        trackingData: {
            fptiState: 'ppc_apply',
            buzname: {
                'fullpage': {
                    'pagename': '%::ppc_apply',
                    'pagename2': '%::ppc_apply:member:hermes:',
                    'version': 'member:%:'
                }
            }
        },
        directive: 'xo-bml-apply-page',
        titleContent: 'applyForBml.bmlApplyHeadline',

        children: []

    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-credit-components/src/bml-display/xo-bml-apply", "../node_modules/xo-credit-components/src/bml-display/xo-bml-apply/route.js"))

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/xo-bml-apply/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"signupbml\" id=\"signupbml\" content>\n    <xo-title title-txt=\"{{content('signupBml.title')}}\" class=\"accessAid\"></xo-title>\n    <div class=\"row-fluid justMember\">\n        <div class=\"span14 trayInner\">\n\n            <div class=\"title\">\n                <xo-message message=\"checkoutSession.message\"></xo-message>\n            </div>\n\n            <!--Title-->\n            <div id=\"title\">\n                <h2 class=\"beta\">{{ content('applyForBml.bmlApplyHeadlineShort') }}</h2>\n                <p>{{ content('applyForBml.bmlApplyWithPayPal') }}</p>\n            </div>\n\n            <form id=\"userInfoForm\" name=\"userInfoForm\" ng-submit=\"userInfoForm.$valid && onContinue()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n\n                <!--Installment information-->\n                <div class=\"bmlRow\" ng-if=\"creditOptions.creditType\">\n                    <div class=\"billingAddressRow\">\n                        <h4 class=\"noBottom gamma sameLine\">{{ content('chooseCreditOption.paymentPlan') }}</h4>\n                        <a id=\"changePlanLink\" class=\"changeBillingAddress sameLine\" ng-click=\"changePlan()\">{{ content('common.change') }}</a>\n                    </div>\n\n                    <div class=\"installmentInfo\" ng-if=\"creditOptions.creditType==='INST'\">\n                        <p class=\"billingName\" ng-bind-html=\"htmlContent('chooseCreditOption.selectedOfferText1',{term:creditOptions.term, monthlyPayment: creditOptions.monthlyPayment})\"></p>\n                        <p class=\"installmentDescription\" ng-bind-html=\"htmlContent('chooseCreditOption.selectedOfferText2',{apr:creditOptions.apr, interest: creditOptions.totalInterest, totalPayment: creditOptions.totalPayment})\"></p>\n                    </div>\n\n                    <div class=\"installmentInfo\" ng-if=\"creditOptions.creditType==='SAC'\">\n                        <p class=\"billingName\" ng-bind-html=\"htmlContent('applyForBml.bmlSACOfferDetail')\"></p>\n                    </div>\n                </div>\n\n                <!--Personal information-->\n                <div class=\"bmlRow\">\n                    <h4 class=\"piHeight gamma\">{{ content('applyForBml.personalInfo') }}\n                        <a class=\"verifyHelp\" id=\"verifyHelp\"></a>\n\n                        <xo-tooltip trigger=\"#verifyHelp\" show-event=\"click\">\n                            {{ content('applyForBml.ssnToolTip') }}\n                        </xo-tooltip>\n                    </h4>\n\n                    <div class=\"dobNatlIdGroup\">\n                        <xo-dob-nationalid pi=\"bmlApply.personalInformation\"></xo-dob-nationalid>\n                    </div>\n                </div>\n\n\n                <!--Billing Address-->\n                <div class=\"bmlRow\">\n                    <div class=\"billingAddressRow\">\n                        <h4 class=\"noBottom gamma sameLine\">{{ content('applyForBml.bmlApplyBillingAddress') }}</h4>\n                        <a id=\"changeAddressLink\" class=\"changeBillingAddress sameLine\" ng-show=\"bmlFlags.ChangeLink\" ng-click=\"changeAddress()\">{{ content('common.change') }}</a>\n                    </div>\n\n                    <div id=\"bmlGivenName\">\n                        <p class=\"billingName\">{{auth.first_name}}&nbsp{{auth.last_name}}</p>\n                    </div>\n\n                    <div id=\"bmlAddressDisplay\" class=\"billingAddressRow\" ng-show=\"bmlFlags.AddressDisplay\">\n                        <xo-address-display address=address country-code=countryCode></xo-address-display>\n                        <div id=\"bmlBillingPhone\" class=\"bmlBillingPhone adr\">{{bmlApply.personalInformation.phone.telephone}}</div>\n                    </div>\n\n                    <div id=\"bmlAddressAdd\" class=\"bmlMargin\" ng-show=\"bmlFlags.AddressAdd\">\n                        <xo-add-address country=countryCode address=\"address\" token=\"token\"></xo-add-address>\n                    </div>\n\n                    <div id=\"addPhone\" class=\"addPhone\" ng-show=\"bmlFlags.PhoneAdd\">\n                        <xo-phone-input token=\"token\" exclude=\"WORK\" phone=\"bmlApply.personalInformation.phone\"></xo-phone-input>\n                    </div>\n\n                </div>\n\n                <!--Agree and Continue-->\n                <p class=\"bmlSeeTerms\" bind-html-compile=\"htmlContent('applyForBml.bmlApplyESign')\"></p>\n\n                <div class=\"buttons\">\n                    <input type=\"submit\" track-submit='bml_apply' id=\"bmlAgreeAndContinue\" name=\"bmlAgreeAndContinue\"\n                           value=\"{{content('applyForBml.bmlApplyTermsSubmit')}}\" class=\"btn full\" ng-click=\"validated=true\" />\n                </div>\n\n            </form>\n\n            <div class=\"bmlMargin\" id=\"bmlBottomText\">\n                <p class=\"bmlSeeTerms sameLine\">{{ content('applyForBml.notInterestedNoInstallments') }}</p>\n                <p class=\"bmlSeeTerms sameLine payInFullLink\" ng-bind-html=\"htmlContent('applyForBml.payInFull')\"\n                   ng-click=\"redirectToReview()\"></p>\n            </div>\n\n            <div id=\"bmlLender\">\n                <p class=\"bmlSeeTerms\">{{ content('base.bmlLender') }}</p>\n            </div>\n\n        </div>\n\n        <div class=\"span10 trayInner\" id=\"bmlApplyEdu\">\n            <h2 class=\"gamma\">{{ content('applyForBml.bmlApplyEduTitle') }}</h2>\n            <ul>\n                <li>{{ content('applyForBml.bmlApplyEduBullet1') }}</li>\n                <li>{{ content('applyForBml.bmlApplyEduBullet2') }}</li>\n                <li>{{ content('applyForBml.bmlApplyEduBullet3') }}</li>\n            </ul>\n            <p>{{ content('applyForBml.bmlApplyInterestTerms') }}</p>\n        </div>\n    </div>\n    <div ui-view></div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/xo-bml-popup/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _bml = __webpack_require__("../node_modules/xo-models/src/bml/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/bml-display/xo-bml-popup/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoBmlPopup', function () {
    return {
        template: _template2['default'],
        controller: ['$scope', function ($scope) {
            (0, _squid.$populate)($scope, {
                checkoutSession: _index.$CheckoutSessionModel.instance(_angular.$rootScope.token)
            }).then(function () {
                if ($scope.checkoutSession.showDeclinePopup) {
                    if (!_angular.$rootScope.bml) {
                        _angular.$rootScope.bml = new _bml.$BMLModel();
                    }
                    if (!$scope.bml) {
                        $scope.bml = _angular.$rootScope.bml;
                    }

                    $scope.bml.preferenceCheck = false;
                    $scope.bml.showModal = true;
                    $scope.bml.showModalBackdrop = true;

                    if ($scope.bml.applicationStatus() || $scope.bml.contingency) {
                        $scope.bml.showModalBackdrop = true;
                    }
                }
            });

            $scope.bmlSetPreferrence = function () {
                if ($scope.bml.preferenceCheck) {
                    $scope.bml.action('preference', {
                        data: {
                            financial_instrument_id: $scope.bml.financial_instrument_id
                        },
                        success: function success() {
                            _logger.$logger.info('COMPLETEBMLAPPLY_PREFERRED');
                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['memberReview.bmlPreferredConfirmation']
                            };
                        }
                    });
                } else {
                    $scope.checkoutSession.message = {
                        type: 'success',
                        msgKeys: ['paymentMethod.paymentMethodUpdated']
                    };
                }
                $scope.bml.showModal = false;
            };

            $scope.bmlClickContinue = function ($event) {
                $event.preventDefault();
                $scope.bml.showModalBackdrop = false;
                $scope.bml.showModal = false;
            };
        }]
    };
});

_angular.$rootScope;

_squid.$populate;

_logger.$logger;

_bml.$BMLModel;

_index.$CheckoutSessionModel;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/xo-bml-popup/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"xoBmlPopup\" content>\n    <!-- BML Decision -->\n    <div ng-if=\"bml.application_status !== undefined || bml.contingency\">\n        <div ng-show=\"bml.showModal\" id=\"bmlModal\" style=\"display:block;\" class=\"modal bmlModal\" aria-labelledby=\"modal-title\" role=\"alertdialog\" tabindex=\"-1\">\n\n            <div ng-show=\"bml.showModalBackdrop\" class=\"modal-backdrop\"></div>\n\n            <div class=\"modal-wrap\">\n\n                <div ng-switch=\"bml.application_status == 'APPROVED' || bml.application_status == 'PENDING_COMPLETION_STATUS'\">\n                    <div ng-switch-when=\"true\">\n                        <span class=\"bmlLogoVert\"></span>\n                        <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('memberReview.bmlSuccessHeader') }}</h2>\n\n                        <div ng-if=\"bml.nape == 'napePositive'\">\n                            <p>{{ content('memberReview.bmlNapeLinkSuccess')}}</p>\n                        </div>\n                        <div ng-if=\"bml.nape !== 'napePositive' && bml.credit_line.value == 0\">\n                            <p>{{ content('memberReview.bmlApprovalMessage') }}</p>\n                        </div>\n                        <div ng-if=\"bml.nape !== 'napePositive' && bml.credit_line.value > 0\">\n                            <p ng-bind-html=\"htmlContent('memberReview.bmlSuccessMessage', {creditLine: bml.credit_line.value})\"></p>\n                            <p>{{ content('memberReview.bmlSuccessMessageSend', {email: bml.user_info.email_address}) }}</p>\n                        </div>\n\n                        <form method=\"post\" name=\"confirm\" ng-submit=\"bmlSetPreferrence()\">\n                            <div class=\"checkbox\">\n                                <input type=\"checkbox\" ng-model=\"bml.preferenceCheck\" name=\"bmlPreferred\" id=\"bmlPreferredCheckbox\" class=\"chkbx\">\n                                <label for=\"bmlPreferredCheckbox\" class=\"chkbxLabel\">{{ content('memberReview.bmlSetPreferred')}}</label>\n                            </div>\n                            <input class=\"btn btn-submit full\" type=\"submit\" value=\"{{ content('memberReview.bmlContinue')}}\">\n                        </form>\n\n                    </div>\n                    <div ng-switch-default>\n                        <div ng-switch=\"bml.application_status\">\n                            <!-- bmlMaxAttempts -->\n                            <div ng-switch-when=\"SOFT_DECLINED\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('memberReview.bmlSorry')}}</h2>\n                                <p>{{ content('bmlDeclined.hardDeclineMsg')}}</p>\n                            </div>\n                            <!-- bmlDeclineLinkedToDiffMember -->\n                            <div ng-switch-when=\"FUNDING_INSTRUMENT_ASSOCIATED_WITH_DIFFERENT_MEMBER\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.bmlAcctLinkedHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.bmlAcctLinkedMsg')}}</p>\n                            </div>\n                            <!-- creditDeclineHard -->\n                            <div ng-switch-when=\"DECLINED\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.hardDeclineHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.hardDeclineMsg')}}</p>\n                            </div>\n                            <!-- ??? creditPaymentNotAllowed -->\n                            <div ng-switch-when=\"CREDIT_PAYMENT_NOT_ALLOWED\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.creditNotAllowedHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.creditNotAllowedMsg')}}</p>\n                            </div>\n                            <!-- ??? creditEligibilityDeclined -->\n                            <div ng-switch-when=\"CREDIT_ELIGIBILITY_DECLINE\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.creditEligibilityDeniedHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.creditEligibilityDeniedMsg')}}</p>\n                            </div>\n                            <!-- ??? declineOtherCreditInstrumentExists -->\n                            <div ng-switch-when=\"FP_DECLINED_DUE_TO_CREDIT_IN_WALLET_RULE\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.declineOtherCreditInstrumentExistsHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.declineOtherCreditInstrumentExistsLine1')}}</p>\n                                <p>{{ content('bmlDeclined.declineOtherCreditInstrumentExistsLine2\" merchantName=\"{bmlResult.merchantFullName}')}}</p>\n                            </div>\n                            <!-- systemError, bmlGenericError, invalidError -->\n                            <div ng-switch-default> <!-- ng-switch-when=\"UNKNOWN_DECISION\" -->\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.systemErrorHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.systemErrorMsg')}}</p>\n                            </div>\n                        </div>\n\n                        <!--\n                         && bml.application_status == 'APPROVED' || bml.application_status == 'PENDING_COMPLETION_STATUS'\n                        -->\n                        <div ng-if=\"bml.application_status !== undefined || bml.contingency\" >\n                            <div ng-if=\"locale.countryCode === 'DE'\">\n                                <p class=\"cancelUrl\">\n                                    <a href=\"{{cancel}}\" role=\"button\" class=\"btn full\">{{ content('common.returnToCart') }}</a>\n                                </p>\n                            </div>\n                            <div ng-if=\"locale.countryCode !== 'DE'\">\n                                <input class=\"btn btn-submit full buttonGroup button-spacing\" type=\"button\" id=\"continueBml\" value=\"{{ content('common.payWithPayPal') }}\" ng-click=\"bmlClickContinue($event)\" />\n                                <a href=\"{{cancel}}\" role=\"button\" class=\"btn btn-secondary full buttonGroup\" id=\"cancelLink\">\n                                    {{ merchant ? content('common.bmlCancelButtonLabel', { merchantName: merchant }) : content('common.cancelAndReturnToMerchant') }}\n                                </a>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <!-- BML Decision -->\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/xo-bml-signature/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/bml-display/xo-bml-signature/template.html");

var _template2 = _interopRequireDefault(_template);

var _bml = __webpack_require__("../node_modules/xo-models/src/bml/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoBmlSignaturePage', function () {
    return {
        template: _template2['default'],
        controller: ['$scope', function ($scope) {
            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance()
            }).then(function () {
                $scope.init = function () {
                    $('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
                    $('.paypalHeaderWrapper').addClass('paypalCredit');
                    $('.paypalHeader').removeClass('span14');
                    $('.paypalHeader').addClass('span24');
                    $('.paypalHeader').addClass('headerBar');
                    $scope.token = _angular.$rootScope.token;
                    $scope.bmlSign = new _bml.$BMLApplicationModel();
                };

                $scope.onSubmit = function () {
                    var application_id = $scope.bml.application_id;
                    $scope.bmlSign.application_id = application_id;
                    $scope.bmlSign.action('sign', {
                        resultModel: $scope.bml,
                        success: function success(result) {
                            _uiRouter.$state.go('checkout.review');
                        }
                    });
                };

                $scope.redirectToReview = function () {
                    _uiRouter.$state.go('checkout.review');
                };

                $scope.init();
            });
        }]
    };
});

_angular.$rootScope;

_squid.$populate;

_uiRouter.$state;

_auth.$AuthModel;

_bml.$BMLApplicationModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/xo-bml-signature/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-credit-components/src/bml-display/xo-bml-signature/directive.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$BmlSignatureRoute', function () {
    return _squid.$ComponentRoute.extend('BmlSignatureRoute', {

        name: 'bmlsignature',
        trackingData: {
            fptiState: 'ppc_signature',
            buzname: {
                'fullpage': {
                    'pagename': '%::ppc_signature',
                    'pagename2': '%::ppc_signature:member:hermes:',
                    'version': 'member:%:'
                }
            }
        },
        titleContent: 'consumerCreditInfo.applicationApprovedMessage',
        directive: 'xo-bml-signature-page',

        children: []

    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-credit-components/src/bml-display/xo-bml-signature", "../node_modules/xo-credit-components/src/bml-display/xo-bml-signature/route.js"))

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/xo-bml-signature/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"bmlSignature\" id=\"bmlSignature\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\">\n            <xo-message message=\"errorMessage\"></xo-message>\n            <xo-title title-txt=\"{{content('consumerCreditInfo.applicationApprovedMessage')}}\"></xo-title>\n            <form name=\"bmlSignatureForm\" class=\"proceed\" content novalidate=\"novalidate\" autocomplete=\"off\" ng-submit=\"bmlSignatureForm.$valid && onSubmit()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n                <p class=\"content\">{{content('consumerCreditInfo.reviewSecciMessage')}}</p>\n\n                <div class=\"agree checkbox legal\" ng-class=\"{error: validated && !bmlSignatureForm.$valid}\">\n                    <input ng-model=\"fields.agree\" type=\"checkbox\" name=\"agree\" id=\"agree\" data-error-text=\"{{content('eConsent.eConsentError')}}\" xo-error-tooltip xo-validation='{\n                        \"validator\": \"isChecked\",\n                        \"options\": {\n                            \"el\": \"#agree\"\n                        }\n                    }' />\n                    <label id=\"confirmationMessage\" class=\"noBottom\" for=\"agree\" ng-bind-html=\"htmlContent('consumerCreditInfo.secciReadConfirmationMessage')\"></label>\n                </div>\n                <div class=\"buttons\">\n                    <input track-submit='bml_signature' type=\"submit\" value=\"{{content('common.continueLabel')}}\"\n                           class=\"btn full\" ng-click=\"validated=true\" />\n                </div>\n\n                <div class=\"bmlMargin\" id=\"bmlBottomText\">\n                    <p class=\"bmlSeeTerms sameLine\">{{ content('applyForBml.notInterestedNoInstallments') }}</p>\n                    <p class=\"bmlSeeTerms sameLine\" ng-bind-html=\"htmlContent('applyForBml.payInFull')\" ng-click=\"redirectToReview()\"></p>\n                </div>\n            </form>\n        </div>\n        <div class=\"span10 bmlMargin\">\n            <xo-value-props type=\"signature\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/template.html");

var _template2 = _interopRequireDefault(_template);

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _user = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _directive = __webpack_require__("../node_modules/xo-credit-components/src/bml-display/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoBmlTermsAndConditionsPage', function () {
    var linkFn = function linkFn(scope, element, attrs) {
        var $agreeButton = $('#bmlAgreeToTerms');

        var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent',
            eventer = window[eventMethod],
            data,
            messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';

        // Browsers that support postMessage
        if (window.postMessage) {
            /**
             * Event to listen for post messages sent from PayPal popup window.
             * Data from PayPal will contains return url and the localised content.
             */
            eventer(messageEvent, function (event) {
                data = angular.fromJson(event.data);
                if (data.action === 'scroll') {

                    if (data.toEnd && !scope.isMobile) {
                        scope.scrollComplete();
                    }
                } else if (data.action === 'setHeight' && scope.isMobile) {
                    $('.bmlTermsBody iframe').css('height', data.height + 20 + 'px');
                }
            }, false);
        }

        $agreeButton.click(function (event) {
            event.preventDefault();
            scope.handleAgreeToTermsClick();
        });
    };

    return {
        template: _template2['default'],
        link: linkFn,
        controller: ['$scope', function ($scope) {
            if ($scope.$parent && $scope.$parent.bml) {
                $scope.bml = $scope.$parent.bml;
                $scope.bmlApply = $scope.$parent.bmlApply;
                $scope.bmlComplete = $scope.$parent.bmlComplete;
            }

            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance(),
                payee: _index2.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
                billingAddresses: _fi.$BillingAddressesModel.instance(),
                checkoutCart: _index2.$CheckoutCartModel.instance(_angular.$rootScope.token),
                checkoutSession: _index2.$CheckoutSessionModel.instance(_angular.$rootScope.token),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token)
            }).then(function () {
                $scope.patchPhoneModel = new _user.$PatchPhoneModel();
                $scope.patchPhoneModel.token = $scope.token;

                if ($scope.$parent && $scope.$parent.bml) {
                    var bmlData = {
                        reviewUrl: $scope.$parent.reviewUrl,
                        bml: $scope.bml,
                        bmlApply: $scope.bmlApply,
                        bmlComplete: $scope.bmlComplete,
                        checkoutSession: $scope.checkoutSession,
                        auth: $scope.auth,
                        purchase: $scope.checkoutCart.purchase,
                        patchPhone: $scope.patchPhoneModel,
                        billingAddresses: $scope.billingAddresses,
                        merchant: $scope.checkoutAppData.merchant,
                        merchantId: $scope.payee.merchant.id
                    };

                    $scope.bmlStateHandler = new _directive.$BMLStateHandler(bmlData);
                }
            });

            $scope.init = function () {
                $scope.token = _angular.$rootScope.token;
                $('.paypalHeaderWrapper').addClass('paypalCreditTnc');
                $('.paypalHeader').removeClass('span14');
                $('.paypalHeader').addClass('span24');
                $('.paypalHeader').addClass('headerBar');
                $('.footerWrapper').addClass('hide');
                $scope.isMobile = _index.$DeviceInfo.isMobile();
                $scope.isMiniBrowser = _angular.$rootScope.miniBrowser;
                $scope.bmlFlags = {
                    bmlFooterShow: true,
                    full: true,
                    xoFooter: true,
                    enableFooter: true,
                    showConfirmationModal: false,
                    showModalBackdrop: true
                };

                if (window.scrollTo) {
                    window.scrollTo(0, 0);
                }
                _logger.$logger.info('TERMSNCONDITIONS_VIEW_RENDER');
            };

            $scope.handleAgreeToTermsClick = function () {
                this.showConfirmationModal();
                _logger.$logger.info('bmlAgreeToTerms', {});
            };

            $scope.showConfirmationModal = function (show) {
                show = angular.isUndefined(show) ? true : show;
                $scope.bmlFlags.showConfirmationModal = show;
            };

            $scope.agreeToTermsConfirmation = function (event) {
                event.preventDefault();

                _logger.$logger.info('bmlConfirmAgreeToTermsPopup', {});
                this.showConfirmationModal(false);
                this.onContinue();
            };

            $scope.cancelApplication = function (event) {
                event.preventDefault();
                _logger.$logger.info('bmlCancelApplication', {});
                $scope.bmlStateHandler.payInFullRedirect();
            };

            // when the esc key is pressed
            $('html').on('keyup', function (ev) {
                if (ev.which === 27) {
                    $scope.showConfirmationModal(false);
                }
            });

            $scope.onContinue = function () {
                _logger.$logger.info('BMLTERMSNCONDITIONS_VIEW_SUBMIT');
                $scope.bmlStateHandler.applyBML();
            };

            $scope.init();
        }]
    };
});

_angular.$rootScope;

_squid.$populate;

_logger.$logger;

_index.$DeviceInfo;

_auth.$AuthModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutPayeeModel;

_index2.$CheckoutSessionModel;

_fi.$BillingAddressesModel;

_user.$PatchPhoneModel;

_directive.$BMLStateHandler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/directive.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$BmlTermsAndConditionsRoute', function () {

    return _squid.$ComponentRoute.extend('BmlTermsAndConditionsRoute', {

        name: 'bmltermsandconditions',
        trackingData: {
            fptiState: 'ppc_termsandconditions',
            buzname: {
                'fullpage': {
                    'pagename': '%::ppc_termsandconditions',
                    'pagename2': '%::ppc_termsandconditions:member:hermes:',
                    'version': 'member:%:'
                }
            }
        },
        directive: 'xo-bml-terms-and-conditions-page',
        titleContent: 'applyForBml.bmlApplyHeadline',

        children: []

    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions", "../node_modules/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/route.js"))

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"bmlTermsAndConditions\" id=\"bmlTermsAndConditions\" content>\n\n    <div ng-show=\"bmlFlags.showConfirmationModal\" id=\"creditConfirmation\" class=\"modal bmlModal\" role=\"alertdialog\" tabindex=\"-1\">\n\n        <div ng-show=\"bmlFlags.showModalBackdrop\" class=\"modal-backdrop\"></div>\n\n        <div class=\"modal-wrap\">\n\n            <div class=\"paypalHeaderWrapper paypalCredit\">\n                <div class=\"logo\">\n                    <span class=\"accessAid\">{{content('applyForBml.payPalCredit')}}</span>\n                </div>\n                <a class=\"close\" href=\"#\" ng-click=\"showConfirmationModal(false)\">\n                    {{content('applyForBml.close')}}\n                </a>\n            </div>\n\n            <div class=\"confirmationPopupContent\">\n                <h2>{{content('applyForBml.justToConfirm')}}</h2>\n                <ul>\n                    <li>\n                        {{content('applyForBml.confirmationPopupListItem1')}}\n                    </li>\n                    <li>\n                        {{content('applyForBml.confirmationPopupListItem2', { email: auth.email })}}\n                    </li>\n                </ul>\n                <form id=\"confirmAgreeToTerms\">\n                    <input ng-click=\"agreeToTermsConfirmation($event)\" id=\"confirmAgreeToTermsSubmit\"\n                        class=\"btn btn-submit full\" type=\"submit\" value=\"{{content('applyForBml.agreeApply')}}\">\n                </form>\n            </div>\n            <div class=\"cancelApplicationBlock\">\n                <a ng-click=\"cancelApplication($event)\" id=\"cancelCreditApplication\" href=\"#\">\n                    {{content('applyForBml.cancelApplication')}}\n                </a>\n            </div>\n        </div>\n    </div>\n\n\n    <xo-title title-txt=\"{{content('signupBml.title')}}\" class=\"accessAid\"></xo-title>\n    <div class=\"row-fluid justMember\">\n        <div class=\"trayInner\">\n            <xo-message message=\"checkoutSession.message\"></xo-message>\n\n            <div class=\"bmlTermsHeader\">\n                <h2 class=\"gamma zeta bmlTermsHead\">{{ content('applyForBml.agreementTermsTitle') }}</h2>\n                <p class=\"printContent\">\n                    <a href=\"https://www.paypalobjects.com/webstatic/checkout/hermes/html/PayPalCreditTerms_print.html\" xo-popup class=popup target=\"_blank\">\n                       <span ng-if= \"!isMobile\" >{{ content('applyForBml.printCopy') }} </span>\n                        <span ng-if=\"isMobile\">{{ content('applyForBml.download') }}</span>\n                    </a>\n                </p>\n            </div>\n\n            <div class=\"span24 trayInner\">\n\n                <div class=\"bmlTermsInnerWrap\">\n                    <div class=\"bmlTermsBody\" tabindex=\"-1\">\n                        <iframe id= \"tncFrame\" src=\"https://www.paypalobjects.com/webstatic/checkout/hermes/html/PayPalCreditTerms_v2.html\"></iframe>\n                   </div>\n                </div>\n\n                <div class=\"bmlTermsFooter buttons\"\n                     ng-class=\"{'bmlTermsFooter buttons bmlFooterShow': bmlFlags.bmlFooterShow ,\n                                'bmlTermsFooter buttons enabled' : bmlFlags.enableFooter,\n                                'bmlTermsFooter buttons': !bmlFlags.bmlFooterShow || !bmlFlags.enableFooter}\">\n                    <div class=\"proceed\">\n                        <button id=\"bmlAgreeToTerms\" track-submit='ppc_agree_terms' class=\"btn bmlAgreeToTerms\"\n                                name=\"bmlAgreeApply\">{{content('applyForBml.agreeApply')}}</button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div ui-view></div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/choose-credit-offer/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _directive = __webpack_require__("../node_modules/xo-page-components/src/header/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/choose-credit-offer/faq/directive.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/choose-credit-offer/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-credit-components/src/choose-credit-offer/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoChooseCreditOfferDirective', {
    tag: 'xo-choose-credit-offer',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                auth: _auth.$AuthModel.instance().retrieve()['catch'](_angular.noop),
                checkoutCart: _index2.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve({
                    params: {
                        fundingSource: _squid.$util.param('fundingSource')
                    }
                })['catch'](_angular.noop),
                payee: _index2.$CheckoutPayeeModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                creditOptions: _index.$CreditInstallmentModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                flowEligibility: _index2.$FlowEligibilityModel.instance(this.props.token).retrieve()['catch'](_angular.noop)
            };
        },
        experiments: function experiments() {
            var experiments = [];
            var returnValue = {};

            if (_squid.$locale.country === 'GB') {
                experiments.push((0, _squid.$pxp)('xo_hermesnodeweb_gb_ppc_acquisitionbanner', { 'ctx.COUNTRY': _squid.$locale.country }, 'xo_hermesnodeweb_gb_ppc_representative_example_treatment1', false, true).then(function (res) {
                    var treatmentName = res && res.treatment_name;

                    _logger.$logger.info('checkout_fpti', {
                        'xo_hermesnodeweb_gb_ppc_acquisitionbanner': treatmentName ? 'xo_hermesnodeweb_gb_ppc_representative_example_treatment1' : 'xo_hermesnodeweb_gb_ppc_representative_example_control'
                    });
                    returnValue.representativeExampleTreatment = treatmentName || false;
                })['catch'](_angular.noop));
            }

            experiments.push((0, _squid.$pxp)('xo_hermesnodeweb_ppc_cyco_force_locale', { 'ctx.COUNTRY': _squid.$locale.country }, 'xo_hermesnodeweb_ppc_cyco_force_locale_treatment', false, true).then(function (res) {
                var treatmentName = res && res.treatment_name;

                _logger.$logger.info('checkout_fpti', {
                    'xo_hermesnodeweb_ppc_cyco_force_locale': treatmentName ? 'xo_hermesnodeweb_ppc_cyco_force_locale_treatment' : 'xo_hermesnodeweb_ppc_cyco_force_control'
                });
                returnValue.cycoOverrideLocaleTreatment = treatmentName || false;
            })['catch'](_angular.noop));

            return _angular.$q.all(experiments).then(function () {
                return returnValue;
            });
        },
        locale: function locale() {
            var merchantCountry = this.checkoutAppData.get('merchant.merchant_country');
            var buyerCountry = _squid.$locale.country;
            var prevBuyerCountry = _squid.$locale.country;
            var prevBuyerLanguage = _squid.$locale.lang;

            return {
                merchantCountry: merchantCountry,
                buyerCountry: buyerCountry,
                prevBuyerCountry: prevBuyerCountry,
                prevBuyerLanguage: prevBuyerLanguage
            };
        }
    },
    actions: {
        redirectToReview: function redirectToReview() {
            $('body').removeClass('CYCOPage');
            _directive.$SetHeaderText.setText('');
            this.creditDataModel.payInFull = true;
            if (!this.models.auth.logged_in) {
                _uiRouter.$state.go('checkout.login');
            } else {
                _uiRouter.$state.go('checkout.review');
            }
        },
        toggleSacOffer: function toggleSacOffer(isExtended) {
            this.sacExtended = isExtended ? false : true;
        },
        toggleInstallmentOffer: function toggleInstallmentOffer(isExtended) {
            this.installmentExtended = isExtended ? false : true;
        },
        toggleFAQ: function toggleFAQ(index) {
            this.faqExtended[index] = !this.faqExtended[index];
        },
        toggleAllFAQ: function toggleAllFAQ() {
            this.allFaqExtended = !this.allFaqExtended;
            var newState = false; // closed

            if (this.allFaqExtended) {
                this.toggleText = (0, _squid.$renderContent)('FAQ.closeAllSections');
                newState = true; // opened
            } else {
                this.toggleText = (0, _squid.$renderContent)('FAQ.openAllSections');
                newState = false; // closed
            }

            for (var i in this.faqExtended) {
                this.faqExtended[i] = newState;
            }
        },
        getCreditFinancingCodes: function getCreditFinancingCodes() {
            var sacOffer = this.offers.getNiOffer();
            var financingCodes = '';

            if (this.creditOffers && this.installmentCount) {
                this.creditOffers.installment_options.forEach(function (installment) {
                    financingCodes += installment.financingCode;
                    financingCodes += ',';
                });
            }

            if (sacOffer) {
                financingCodes += sacOffer.financingCode;
            }

            return financingCodes;
        },
        getInstallmentContent: function getInstallmentContent() {
            var contentKey = 'chooseCreditOption.singleInstallmentDescription';

            if (this.installmentCount > 1) {
                if (this.creditOffers.installment_options.find(function (installment) {
                    return installment.apr === '0.00';
                })) {
                    contentKey = 'chooseCreditOption.installmentDescriptionAprZero';
                } else {
                    contentKey = 'chooseCreditOption.installmentDescription2';
                }
            }
            return contentKey;
        },
        handleRedirect: function handleRedirect() {
            var creditMemberType = this.isCreditInWallet ? 'existingMember' : 'newMember';
            var isBuyerSet = this.fundingInstruments;
            var isSignUpFlow = this.creditDataModel.isCreditSignup();
            var isChangeInstallment = this.creditDataModel.isChangeStatus();

            $('body').removeClass('CYCOPage');
            _directive.$SetHeaderText.setText('');

            if (isBuyerSet && creditMemberType === 'newMember' || isSignUpFlow && isChangeInstallment || this.locale.buyerCountry === 'DE') {
                _uiRouter.$state.go('checkout.redirectToCape', {}, { location: false });
            } else if (creditMemberType === 'existingMember') {
                _uiRouter.$state.go('checkout.review');
            } else {
                _uiRouter.$state.go('checkout.login');
            }
        },
        onSelect: function onSelect(index) {
            var _this = this;

            if (index === 'CORE') {
                if (this.models.creditOptions && this.models.creditOptions.creditType) {
                    delete this.models.creditOptions.creditType;
                }
                _logger.$logger.info('checkout_fpti', { 'credit_type': 'CORE' });
                this.actions.handleRedirect();
            } else {
                var isPPCReuse = this.isCreditInWallet;
                var selectedOffer = index === 'SAC' ? this.creditOffers.sac_options : this.creditOffers.installment_options[index];
                var param = {
                    'financing_code': selectedOffer.financingCode,
                    'apr': selectedOffer.apr,
                    'term': selectedOffer.term,
                    'credit_type': selectedOffer.creditType,
                    'paypal_subsidy': selectedOffer.paypalSubsidy,
                    'credit_installment_integration_type': this.models.checkoutAppData.isSecondButton() ? 'SECOND_BUTTON' : undefined
                };

                if (index !== 'SAC') {
                    param.monthly_percentage_rate = selectedOffer.monthlyPercentageRate;
                    param.total_cost = selectedOffer.totalPayment.value;
                    param.total_interest = selectedOffer.totalInterest.value;
                    param.monthly_payment = selectedOffer.monthlyPayment.value;
                    param.currency = selectedOffer.monthlyPayment.currency;
                }

                return this.models.creditOptions.action('select', {
                    data: param,
                    success: function success() {
                        _logger.$logger.info('checkout_fpti', {
                            'is_ppc_reuse': isPPCReuse ? '1' : '0',
                            'credit_type': selectedOffer.creditType,
                            'financing_code_selected': selectedOffer.financingCode
                        });
                        _this.actions.handleRedirect();
                    }
                });
            }
        }
    },
    lifecycle: {
        enter: function enter() {
            this.checkoutAppData = _index2.$CheckoutAppDataModel.instance(this.props.token);
            this.checkoutCart = _index2.$CheckoutCartModel.instance(this.props.token);
            this.checkoutSession = _index2.$CheckoutSessionModel.instance(this.props.token);
            this.creditDataModel = _index.$CreditDataModel.instance(this.props.token);
            this.faqExtended = [false, false, false];
            this.allFaqExtended = false;
            $('.paypalHeaderWrapper').addClass('paypalCredit');
            $('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
            $('body').addClass('CYCOPage');
            _directive.$SetHeaderText.setText('chooseCreditOption.offerHeading');
        },
        populate: function populate() {
            var _this2 = this;

            var self = this;
            var MIN_AMOUNT = '$99';

            this.offers = new _index.$CreditInstallmentOptionsModel({
                id: this.props.token,
                payee: this.models.payee,
                checkoutCart: this.models.checkoutCart,
                checkoutAppData: this.models.checkoutAppData,
                isMemberCredit: true
            });

            // Override buyer country to match merchant country
            // https://engineering.paypalcorp.com/confluence/display/MICA/Locale+Issues+on+2nd+Button
            // TODO: Once the experiment is fully ramped, this block can be moved into the resolve().locale() function
            if (this.experiments.cycoOverrideLocaleTreatment) {
                if (this.checkoutAppData.is_second_button_txn) {
                    if (
                    // Check that the merchant country is supported
                    this.locale.merchantCountry && _squid.$config.supportedCountries[this.locale.merchantCountry] && _squid.$config.creditEligibleCountries.indexOf(this.locale.merchantCountry) !== -1) {
                        this.locale.buyerCountry = this.locale.merchantCountry;
                    } else if (
                    // Check that the buyer country is supported
                    _squid.$config.supportedCountries[this.locale.buyerCountry] && _squid.$config.creditEligibleCountries.indexOf(this.locale.buyerCountry) !== -1) {
                        _logger.$logger.info('cyco_overriding_locale_unsupported_merchant', {
                            buyerCountry: this.locale.buyerCountry,
                            merchantCountry: this.locale.merchantCountry
                        });
                    } else {
                        // Fallback to US because no supported country can be determined
                        _logger.$logger.warn('cyco_overriding_locale_fallback', {
                            buyerCountry: this.locale.prevBuyerCountry,
                            buyerLanguage: this.locale.prevBuyerLanguage,
                            merchantCountry: this.locale.merchantCountry
                        });
                        this.locale.buyerCountry = 'US';
                    }

                    var supportedLanguages = _squid.$config.supportedCountries[this.locale.buyerCountry];
                    var lang = void 0;

                    // If the buyer's language exists in the merchant's country, use that, otherwise use default
                    if (supportedLanguages.indexOf(this.locale.prevBuyerLanguage) !== -1) {
                        lang = this.locale.prevBuyerLanguage;
                    } else {
                        lang = supportedLanguages[0];
                    }

                    _logger.$logger.info('cyco_overriding_locale_success', {
                        prevBuyerCountry: this.locale.prevBuyerCountry,
                        prevBuyerLanguage: this.locale.prevBuyerLanguage,
                        newBuyerCountry: this.locale.buyerCountry,
                        newBuyerLanguage: lang,
                        merchantCountry: this.locale.merchantCountry
                    });

                    // Calling .change here instead of .chooseCountry because we don't want to store the
                    // locale - we want to persist the locale through to the login page, where the locale
                    // can be chosen after the user logs in
                    _squid.$locale.change(this.locale.merchantCountry, lang);
                }
            } else {
                // Control
                this.locale.buyerCountry = this.locale.merchantCountry;
            }

            this.isBillingNoPurchase = this.checkoutCart.isBillingNoPurchase();

            if (this.isBillingNoPurchase) {
                this.fundingInstruments = this.checkoutSession.get('futurePaymentInstruments');
            } else {
                this.fundingInstruments = this.checkoutSession.get('fundingOptions.instruments');
            }

            if (this.models.auth.logged_in && this.fundingInstruments) {
                this.checkoutSession.retrieve();
            }

            if (this.isBillingNoPurchase) {
                this.isCreditInWallet = this.checkoutSession.get('futurePayment.isCreditInWallet');
            } else {
                this.isCreditInWallet = this.fundingInstruments && _squid.$util.some(this.fundingInstruments, function (fi) {
                    return fi.name === 'BILL_ME_LATER';
                });
            }

            this.toggleText = (0, _squid.$renderContent)('FAQ.openAllSections');

            // Use templateVars when the content is required to fill in the properties from locale files.
            this.templateVars = {
                merchantName: this.models.checkoutAppData.get('merchant.brand_name'),
                amount: this.checkoutCart.get('purchase.amounts.total.amount_formatted'),
                minAmount: MIN_AMOUNT,
                seeTermsUrl: undefined
            };

            // Call SSOT to determine installment options
            this.offers.save({
                cache: true,
                success: function success() {
                    _this2.creditOffers = _this2.offers.getInstallmentOffers();
                    _this2.installmentCount = _this2.offers.getInstallmentCount();
                },
                error: function error(_error) {
                    _logger.$logger.info('CYCO: ssot call returned error: ' + _error);
                    return _angular.$q.reject(_error);
                },
                contingencies: {
                    DEFAULT: function DEFAULT(name, err) {
                        _logger.$logger.info('CYCO: ssot call returned contingency: ' + name);
                        return _angular.$q.reject(err);
                    }
                }
            }).then(function (results) {
                _this2.installmentsPresent = _this2.offers.getInstallmentOptionsPresent();

                // Logging when Both BA and EZP enabled
                if (_this2.models.checkoutCart.isBilling() && _this2.installmentsPresent) {
                    _logger.$logger.info('CYCO: Merchant ' + _this2.templateVars.merchantName + ' in ' + _this2.locale.merchantCountry + ' has both BA and EZP enabled');
                }

                _this2.installmentCount = _this2.offers.getInstallmentCount();
                _this2.templateVars.seeTermsUrl = _this2.creditOffers ? (0, _squid.$feature)('creditOfferSeeTermsUrl') + _this2.creditOffers.terms_param : undefined;

                if (_this2.creditOffers) {
                    _logger.$logger.info('checkout_fpti', {
                        'financing_code_offered': _this2.actions.getCreditFinancingCodes()
                    });
                }
                _this2.installmentContentKey = _this2.actions.getInstallmentContent();

                /**
                 * installmentSectionExtendedByDefault: Only applicable to GB and DE, this variable is true when by deafult
                 * we want installments section to be extended.
                 **/
                _this2.installmentSectionExtendedByDefault = (_this2.locale.buyerCountry === 'GB' || _this2.locale.buyerCountry === 'DE') && _this2.installmentsPresent && _this2.models.checkoutAppData.is_second_button_txn;

                /**
                 * showInstallmentOfferOnly: Only applicable to GB and DE, this variable is true when installments
                 * are available and its second button flow.
                 * Intention behind it is to not confuse user when merchant is willing to provide installments.
                 * Product/business is reviewing this and we might start showing both NI and INST in this case.
                 **/
                _this2.showInstallmentOfferOnly = (_this2.locale.buyerCountry === 'GB' || _this2.locale.buyerCountry === 'DE') && _this2.installmentsPresent && _this2.models.checkoutAppData.is_second_button_txn;

                /**
                 * showNIOfferOnly:
                 * US: showNIOfferOnly will always be false for US. In US there is no scenario to show only NI/SAC offer
                 * on CYCO. If its just NI/SAC offer for user, then CYCO page should not be shown in US.
                 * GB: showNIOfferOnly is true in GB when only NI offer is available. In this case, user is shown only NI
                 * offer on CYCO. This is just to show all the details again to user. Product/Business are
                 * exploring this scenario to probably skip showing CYCO in this case.
                 **/
                _this2.showNIOfferOnly = false;
                if ((_this2.locale.buyerCountry === 'GB' || _this2.locale.buyerCountry === 'DE') && _this2.installmentsPresent && !_this2.models.checkoutAppData.is_second_button_txn && !(_this2.checkoutSession && _this2.checkoutSession.creditInstallmentOffer)) {
                    _this2.showNIOfferOnly = true;
                }

                /**
                 * showNoInterestSection:
                 * US: This should always be true for US.
                 * GB 1st button: This should be always true for 1st button scenarios.
                 * GB 2nd button: This should be false when installments are available, true otherwise.
                 * GB BA Flows: There is no merchant with both BA and INST configured. If that happens,
                 * there should be a story to update code as desired.
                 **/
                _this2.showNoInterestSection = _this2.locale.buyerCountry === 'GB' || _this2.locale.buyerCountry === 'DE' ? !_this2.showInstallmentOfferOnly : _this2.creditOffers && _this2.creditOffers.sac_options;

                // For converting SAC content to NI in US for Asset light
                // this.showNIInsteadOfSACInUS = this.locale.buyerCountry === 'US' && this.creditOffers.sac_options
                // && (this.creditOffers.sac_options.creditType === 'NI');

                // Dynamic APR in installment offer description
                var minOfferedAPR = 100;
                _this2.templateVars.minOfferedAPR = '0';
                if (_this2.installmentsPresent) {
                    _this2.creditOffers.installment_options.forEach(function (offer, key) {
                        var apr = parseFloat(offer.apr);

                        if (isNaN(apr)) {
                            this.incorrectAPR = true;
                        } else {
                            minOfferedAPR = apr < minOfferedAPR ? apr : minOfferedAPR;
                        }
                    });
                    _this2.templateVars.minOfferedAPR = String(minOfferedAPR);
                }
            })['catch'](function (error) {
                // if PPC 2nd button, redirect to generic error
                // else (if 1st button), redirect to review
                if (_this2.models.checkoutAppData.is_second_button_txn) {
                    _uiRouter.$state.go('checkout.genericError');
                } else {
                    _this2.checkoutSession.message = {
                        type: 'warning',
                        msgKeys: ['paymentMethod.cycoSsotWarning']
                    };
                    return self.actions.redirectToReview();
                }
            });

            // populate the representative example treatment
            if (this.experiments.representativeExampleTreatment) {
                this.representativeExampleTreatment = this.experiments.representativeExampleTreatment;
            }
        }
    }

});


_uiRouter.$state;

_angular.$q;

_angular.noop;

_logger.$logger;

_auth.$AuthModel;

_squid.$Component;

_squid.$locale;

_squid.$pxp;

_squid.$util;

_squid.$feature;

_squid.$renderContent;

_squid.$config;

_index.$CreditInstallmentModel;

_index.$CreditDataModel;

_index2.$CheckoutSessionModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutPayeeModel;

_index2.$CheckoutAppDataModel;

_index2.$FlowEligibilityModel;

_index.$CreditInstallmentOptionsModel;

_directive.$SetHeaderText;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-credit-components/src/choose-credit-offer/faq/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-credit-components/src/choose-credit-offer/faq/template.html"), __webpack_require__("../node_modules/xo-models/src/checkout/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid, template) {
    squid.module('xo-faq.directive', ['squid', 'xomodel.checkout']).directive('xoFaq', function () {
        return {
            template: template
        };
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-credit-components/src/choose-credit-offer/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ChooseCreditOfferRoute = undefined;

__webpack_require__("../node_modules/xo-credit-components/src/choose-credit-offer/directive.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $ChooseCreditOfferRoute = exports.$ChooseCreditOfferRoute = _squid.$ComponentRoute.extend('$ChooseCreditOfferRoute', {

    path: 'chooseCreditOffer',
    directive: 'xo-choose-credit-offer',
    titleContent: 'chooseCreditOffer.choose',
    trackingData: {
        fptiState: 'choose_credit_offer',
        buzname: {
            'fullpage': {
                'pagename': '%::choose_credit_offer',
                'pagename2': '%::choose_credit_offer:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    auth: false,
    children: []
});

angular.value("$ChooseCreditOfferRoute", $ChooseCreditOfferRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/choose-credit-offer/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-credit-components/src/choose-credit-offer/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"creditoffer\" id=\"creditoffer\" content>\n    <div class=\"row-fluid\">\n\n        <div class=\"trayInner\">\n            <!--Title-->\n            <div ng-if=\"locale.buyerCountry === 'US'\" id=\"title\">\n                <h2 class=\"beta cycoHeader\">{{ content('chooseCreditOption.USOfferHeading')}}</h2>\n                <p class=\"theta mainDescription\"\n                ng-bind-html=\"htmlContent('chooseCreditOption.USOfferDescription', {merchantName: templateVars.merchantName})\"></p>\n            </div>\n\n            <div ng-if=\"locale.buyerCountry === 'GB'\" id=\"title\">\n                <h2 class=\"beta cycoHeader\">{{ content('chooseCreditOption.UKOfferHeading')}}</h2>\n                <p class=\"theta mainDescription\"\n                   ng-bind-html=\"htmlContent('chooseCreditOption.UKOfferDescription', {merchantName: templateVars.merchantName})\"></p>\n            </div>\n\n            <div class=\"sacOfferWrapper\" ng-if=\"showNIOfferOnly\">\n                <div id=\"sacOnlyOffer\" class=\"extendedSacCtaWrap pointer\" ng-click=\"actions.handleRedirect()\">\n                    <div class=\"trayInner\">\n                        <div class = \"extendedOfferContent\">\n                            <p class=\"offerTitle\" ng-if=\"creditOffers.sac_options\">{{content('chooseCreditOption.NIOnlyHeading')}}</p>\n                            <p class=\"offerTitle\" ng-if=\"!creditOffers.sac_options\">{{content('chooseCreditOption.noOfferHeading')}}</p>\n                            <p class=\"ukOfferDescription\" ng-if=\"creditOffers.sac_options\">{{content('chooseCreditOption.NIOnlyDescription')}}</p>\n                            <p class=\"ukOfferDescription\" ng-if=\"!creditOffers.sac_options\">{{content('chooseCreditOption.noOfferDescription')}}</p>\n                        </div>\n\n                        <div class=\"chooseOffer buttons\">\n                            <input type=\"submit\" value=\"{{content('chooseCreditOption.chooseOfferBtn')}}\" class=\"btn\"/>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div ng-class=\"{reverseOrder:locale.buyerCountry === 'GB'}\" ng-if=\"!showNIOfferOnly\">\n                <div class=\"sacOfferWrapper\" ng-if=\"showNoInterestSection\">\n                    <div id=\"sacOffer\" class=\"sacCtaWrap pointer\" ng-class=\"{extended:sacExtended}\"\n                         track-link=\"more_info_sac\" ng-click=\"actions.toggleSacOffer(sacExtended)\">\n                        <div class=\"trayInner\">\n                            <p ng-if=\"!creditOffers.sac_options  && locale.buyerCountry === 'GB'\" class=\"offerTitle\">{{content('chooseCreditOption.UKNoOfferHeading')}}</p>\n                            <p ng-if=\"creditOffers.sac_options && locale.buyerCountry === 'GB'\" class=\"offerTitle\">{{content('chooseCreditOption.UKNIHeading')}}</p>\n                            <p ng-if=\"locale.buyerCountry === 'US'\" class=\"offerTitle\">{{content('chooseCreditOption.USNIHeading')}}</p>\n                            <a link-button class=\"moreInfoLink sacLink\"\n                               ng-class=\"{noMargin:!creditOffers.sac_options}\"\n                               ng-if=\"!sacExtended\">{{ content('chooseCreditOption.moreInfo') }}\n                                <span class=\"frontArrow down\"></span>\n                            </a>\n                            <a link-button class=\"moreInfoLink\"\n                               ng-if=\"sacExtended\"  ng-class=\"{noMargin:!creditOffers.sac_options}\">{{ content('chooseCreditOption.close') }}\n                                <span class=\"frontArrow up\"></span>\n                            </a>\n                            <p ng-if=\"creditOffers.sac_options && locale.buyerCountry === 'GB'\" class=\"offerSmallText\">{{content('chooseCreditOption.UKNIDescription')}}</p>\n                            <p ng-if=\"creditOffers.sac_options && locale.buyerCountry === 'US'\" class=\"offerSmallText\">{{content('chooseCreditOption.USNIDescription')}}</p>\n                        </div>\n                    </div>\n                    <div id=\"extendedSacOffer\" class=\"extendedSacCtaWrap pointer\" ng-if=\"sacExtended\"\n                         ng-click=\"creditOffers.sac_options ? actions.onSelect('SAC') : actions.onSelect('CORE')\">\n                        <div class=\"seeTermsWrap\" ng-if=\"locale.buyerCountry === 'DE'\">\n                            <p class=\"terms\" ng-bind-html=\"htmlContent('chooseCreditOption.seeTermsSAC')\"></p>\n                        </div>\n                        <div class=\"trayInner\">\n                            <div class=\"extendedOfferContent\">\n                                <p class= \"ukOfferDescription\" ng-if=\"!creditOffers.sac_options  && locale.buyerCountry === 'GB'\">{{content('chooseCreditOption.UKNoOfferNote1')}}</p>\n                                <p class= \"ukOfferDescription\" ng-if=\"creditOffers.sac_options && locale.buyerCountry === 'GB'\">{{content('chooseCreditOption.UKNINote1')}}</p>\n                                <p class= \"ukOfferDescription\" ng-if=\"creditOffers.sac_options && locale.buyerCountry === 'US'\">{{content('chooseCreditOption.USNINote1')}}</p>\n                                <p ng-if=\"locale.buyerCountry !== 'US'\">{{content('chooseCreditOption.sacNote2')}}</p>\n                                <p class=\"terms\" ng-if=\"creditOffers.sac_options && locale.buyerCountry === 'US'\" ng-bind-html=\"htmlContent('chooseCreditOption.USNISeeTerms')\"></p>\n                            </div>\n                            <div class=\"chooseOffer buttons\" ng-if=\"creditOffers.sac_options\">\n                                <input id=\"sacOfferButton\" type=\"submit\" track-submit='choose_sac'\n                                       value=\"{{content('chooseCreditOption.chooseOfferBtn')}}\" class=\"btn\"/>\n                                <p ng-if=\"locale.buyerCountry === 'DE'\" class=\"smallText\"\n                                   ng-bind-html=\"htmlContent('chooseCreditOption.minimumAmt', {minAmount:templateVars.minAmount})\"></p>\n                            </div>\n                            <div ng-if=\"!creditOffers.sac_options\" class=\"chooseOffer buttons\">\n                                <input id=\"coreOfferButton\" type=\"submit\" track-submit='choose_core'\n                                       value=\"{{content('chooseCreditOption.chooseOfferBtn')}}\" class=\"btn\"/>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n\n                <div class=\"installmentOfferWrapper\" ng-if=\"creditOffers.installment_options\">\n                    <div id=\"installmentOffer\" class=\"installmentCtaWrap\"\n                         ng-class=\"{extended: (installmentExtended || installmentSectionExtendedByDefault), pointer: true}\"\n                         track-link=\"more_info_installment\" ng-click=\"actions.toggleInstallmentOffer(installmentExtended)\">\n                        <div class=\"trayInner\">\n                            <p class=\"offerTitle\" ng-if=\"(locale.buyerCountry === 'GB')\" ng-bind-html=\"htmlContent('chooseCreditOption.UKInstallmentHeading', {amount:templateVars.amount})\"></p>\n                            <p class=\"offerTitle\" ng-if=\"(locale.buyerCountry === 'DE')\" ng-bind-html=\"htmlContent('chooseCreditOption.DEInstallmentHeading', {amount:templateVars.amount})\"></p>\n                            <p class=\"offerTitle\" ng-if=\"(locale.buyerCountry === 'US' && !incorrectAPR)\" ng-bind-html=\"htmlContent('chooseCreditOption.USInstallmentHeadingWithAPR', {apr:templateVars.minOfferedAPR})\"></p>\n                            <p class=\"offerTitle\" ng-if=\"(locale.buyerCountry === 'US' && incorrectAPR)\">{{content('chooseCreditOption.USInstallmentHeadingNoAPR')}}</p>\n\n                            <div class=\"expandableLinks\" ng-if=\"!installmentSectionExtendedByDefault\">\n                                <a link-button ng-if=\"installmentCount === 1 && !installmentExtended\"\n                                   class=\"moreInfoLink\">\n                                        {{ content('chooseCreditOption.moreInfo') }}\n                                    <span class=\"frontArrow down\"></span>\n                                </a>\n                                <a link-button ng-if=\"installmentCount > 1 && !installmentExtended\"\n                                   class=\"moreInfoLink\">\n                                        {{ content('chooseCreditOption.seeAllPlans') }}\n                                    <span class=\"frontArrow down\"></span>\n                                </a>\n                                <a link-button class=\"moreInfoLink\"\n                                   ng-if=\"installmentExtended || installmentSectionExtendedByDefault\">\n                                        {{ content('chooseCreditOption.close') }}\n                                    <span class=\"frontArrow up\"></span>\n                                </a>\n                            </div>\n                            <p class=\"offerSmallText\" ng-if=\"(locale.buyerCountry !== 'US')\"\n                               data-ng-bind-html=\"htmlContent(installmentContentKey,{monthlyPayment: creditOffers.installment_options[installmentCount -1].monthlyPayment.formattedAmt, term:creditOffers.installment_options[installmentCount -1].term , apr: creditOffers.installment_options[installmentCount -1].apr})\"></p>\n                            <p class=\"offerSmallText\" ng-if=\"(locale.buyerCountry === 'US')\">{{content('chooseCreditOption.USInstallmentDescription')}}</p>\n                        </div>\n                    </div>\n                    <div id=\"extendedInstallmentOffer\" class=\"extendedInstallmentCtaWrap\" ng-if=\"installmentExtended || installmentSectionExtendedByDefault\">\n                        <div class=\"seeTermsWrap\" ng-if=\"installmentExtended && locale.buyerCountry !== 'GB' \">\n                            <p class=\"terms\"\n                               ng-bind-html=\"htmlContent('chooseCreditOption.seeTermsInstallment', {seeTermsUrl:templateVars.seeTermsUrl})\"></p>\n                        </div>\n                        <div class=\"row-fluid gceOffers\">\n                            <div class=\"span24\">\n                                <ul class=\"trayInner trayInnerDefault installmentOptionsB row-fluid\">\n                                    <li class=\"offer span6 pointer\" ng-repeat=\"installment in creditOffers.installment_options track by $index\"\n                                        ng-click=\"actions.onSelect($index)\" track-submit='choose_installment'>\n                                        <form>\n                                            <div ng-if=\"(locale.buyerCountry !== 'GB' && locale.buyerCountry !== 'DE')\"class=\"installmentPlanDetails\">\n                                                <ul class=\"subSections\">\n                                                    <li class=\"offerHeading1\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueMonths',{term: installment.term})\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valuePerMonth',{ monthlyPayment: installment.monthlyPayment.formattedAmt})\"></li>\n                                                </ul>\n                                                <ul class=\"subSections\">\n                                                    <li class=\"theta\" ng-bind-html=\"\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueAPR',{apr: installment.apr})\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueInterest', { interest: installment.totalInterest.formattedAmt})\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueEveryMonth', {term: installment.term})\"></li>\n                                                </ul>\n                                                <ul class=\"subSections\">\n                                                    <li class=\"theta\">\n                                                        {{content('chooseCreditOption.valueTotalPayment')}}\n                                                    </li>\n                                                    <li class=\"theta\">\n                                                        <strong>{{installment.totalPayment.formattedAmt}}</strong></li>\n                                                    <li class=\"terms\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.seeTerms')\"></li>\n                                                </ul>\n                                            </div>\n                                            <div ng-if=\"(locale.buyerCountry === 'GB' || locale.buyerCountry === 'DE')\" class=\"installmentPlanDetails\">\n                                                <ul class=\"subSections\">\n                                                    <li class=\"offerHeading1\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valuePerMonth',{ monthlyPayment: installment.monthlyPayment.formattedAmt})\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueMonths',{term: installment.term})\"></li>\n                                                </ul>\n                                                <ul class=\"subSections\">\n                                                    <li class=\"theta\" ng-bind-html=\"\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.promotionalRate')\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueAPR',{apr: installment.apr})\"></li>\n                                                </ul>\n                                                <ul class=\"subSections\">\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.interestRate')\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueInterest', { interest: installment.totalInterest.formattedAmt})\"></li>\n                                                </ul>\n                                                <ul class=\"subSections\">\n                                                    <li class=\"theta\">\n                                                        {{content('chooseCreditOption.valueTotalPayment')}}\n                                                    </li>\n                                                    <li class=\"theta\">\n                                                        <strong>{{installment.totalPayment.formattedAmt}}</strong></li>\n                                                    <li class=\"terms\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.seeTerms')\"></li>\n                                                </ul>\n                                            </div>\n\n                                            <div class=\"buttons\">\n                                                <input id=\"chooseInstallment\" type=\"submit\" track-submit='choose_installment'\n                                                       value=\"{{content('chooseCreditOption.chooseOfferBtn')}}\"\n                                                       class=\"btn\"/>\n                                                <p ng-if=\"locale.buyerCountry !== 'GB'\" class=\"smallText\"\n                                                   ng-bind-html=\"htmlContent('chooseCreditOption.minimumAmt', {minAmount:installment.minimumAmount})\"></p>\n                                            </div>\n\n                                        </form>\n                                    </li>\n                                </ul>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n            </div>\n\n            <div class=\"bmlMargin\" id=\"bmlBottomText\">\n                <!-- US Credit Content -->\n                <p class=\"sameLine payInFullText\" ng-if=\"locale.buyerCountry === 'US'\" ng-bind-html=\"htmlContent('chooseCreditOption.USPayInFullText')\"></p>\n                <a link-button class=\"payInFullLink sameLine\" ng-if=\"locale.buyerCountry === 'US'\" ng-bind-html=\"htmlContent('chooseCreditOption.USPayInFullLink')\"\n                   ng-click=\"actions.redirectToReview()\"></a>\n\n                <!-- UK Credit Content -->\n                <p class=\"sameLine payInFullText\" ng-if=\"locale.buyerCountry === 'GB'\" ng-bind-html=\"htmlContent('chooseCreditOption.UKPayInFullText')\"></p>\n                <a link-button class=\"payInFullLink sameLine\" ng-if=\"locale.buyerCountry === 'GB'\" ng-bind-html=\"htmlContent('chooseCreditOption.UKPayInFullLink')\"\n                   ng-click=\"actions.redirectToReview()\"></a>\n            </div>\n\n            <div id=\"xoCreditExampleUk\" ng-if=\"locale.buyerCountry === 'GB'\">\n                <div ng-class=\"{'representativeExampleControl': !representativeExampleTreatment, 'representativeExampleTreatment': representativeExampleTreatment}\">\n                <div class=\"creditWorks\">\n                <p class=\"creditWorksTitle\">{{content('chooseCreditOption.creditSampleHeader')}}</p>\n                <p class=\"creditWorksDescription\">{{content('chooseCreditOption.creditSamplePara')}}</p>\n                </div>\n                <p class=\"bmlLender\">{{content('chooseCreditOption.representativeEx')}}</p>\n                <p class=\"bmlLender representativeExHeader\">{{content('chooseCreditOption.representativeExHeader')}}</p>\n                <ul class=\"trayInner trayInnerDefault representativeEx row-fluid\">\n                    <li class=\"span6\">\n                        <p class=\"representativeExKey\">{{content('chooseCreditOption.purchaseRate')}}</p>\n                        <p class=\"representativeExampleAPRAmount\">{{content('chooseCreditOption.purchaseRateValue')}}</p>\n                    </li>\n                    <li class=\"span6\">\n                        <p class=\"representativeExKey\">{{content('chooseCreditOption.representativeAPR')}}</p>\n                        <p class=\"representativeExampleAPRAmount\">{{content('chooseCreditOption.representativeAPRValue')}}</p>\n                    </li>\n                    <li class=\"span6 last\">\n                        <p class=\"representativeExKey\">{{content('chooseCreditOption.exCreditLimit')}}</p>\n                        <p class=\"representativeExampleAPRAmount\">{{content('chooseCreditOption.exCreditLimitValue')}}</p>\n                    </li>\n                </ul>\n\n                <p class=\"faq\" ng-bind-html=\"htmlContent('chooseCreditOption.faqLink')\"></p>\n                </div>\n            </div>\n\n            <xo-faq ng-if=\"locale.buyerCountry === 'DE'\"></xo-faq>\n\n            <div id=\"bmlLender\">\n                <p ng-if=\"!isCreditInWallet && locale.buyerCountry === 'US'\" class=\"sameLine bmlLender\">{{content('chooseCreditOption.USLenderDisclaimerText')}}</p>\n                <p ng-if=\"locale.buyerCountry === 'GB' && creditOffers.installment_options\" class=\"sameLine bmlLender\">{{content('chooseCreditOption.UKLenderDisclaimerTextInst')}}</p>\n                <p ng-if=\"(locale.buyerCountry === 'GB' && !creditOffers.installment_options)\" class=\"sameLine bmlLender\">{{content('chooseCreditOption.UKLenderDisclaimerTextNonInst')}}</p>\n            </div>\n        </div>\n    </div>\n    <div ui-view></div>\n    <div ng-if=\"locale.buyerCountry === 'DE'\" class=\"poweredBy\">\n        <div class=\"text\">{{ content('chooseCreditOption.poweredBy')}}</div>\n        <span class=\"poweredByFooterWrapper\">\n                <span id=\"paypalLogo\" class=\"logo\"></span>\n            </span>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/offer/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _xoMORSCreditBannerUtils = __webpack_require__("../node_modules/xo-models/src/marketingoffer/lib/xoMORSCreditBannerUtils.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _pxp = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/pxp.js");

var _marketingoffer = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/offer/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ACQ_Banner_Type = 'acquisition';

angular.module().directive('xoOffer', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            promotion: '=?',
            bmlaction: '=?',
            installment: '=?',
            selectedmethod: '=?',
            reusetext: '=?',
            radio: '=?',
            parentContext: '=?'
        },
        controller: ['$scope', function ($scope) {
            var isCreditInWallet = void 0;
            var isRedirectFromCape = void 0;
            var bypassGbCycoTreatment = false;
            var discoverMessageError = null;

            var BANNER_TYPES = {
                'PASSIVE': 'PASSIVE',
                'PROMINENT': 'PROMINENT'
            };
            var USE_CASE = {
                'REUSE': 'REUSE',
                'ACQUISITION': 'ACQUISITION'
            };
            var CREDIT_TYPE = {
                'CORE': 'CORE',
                'SAC': 'SAC',
                'NI': 'NI',
                'EZP': 'EZP',
                'BA': 'BA'
            };

            // track interstitials
            var CREDIT_BANNER_DISPLAY_COUNT_MAX = 1;
            var CREDIT_BANNER_DISPLAY_COUNT_KEY = 'credit_banner_display_count_key';
            $scope.locale = _squid.$locale;

            $scope.isNewMember = function () {
                var newMember = $scope.parentContext && $scope.parentContext.newMember;
                if (!newMember) {
                    return false;
                }

                return newMember.variant === 'one_page' || newMember.variant === 'design_2' || newMember.variant === 'design_3';
            };

            // Returns false to use existing logic, true to hide the banner.
            var isNewMemberDecisionToHideBanner = function isNewMemberDecisionToHideBanner() {
                if (!$scope.isNewMember()) {
                    return false;
                }

                // If we get to this point, it means it is new member traffic.
                // Hide banner when useCEPDEcision is set to false.
                var newMember = $scope.parentContext && $scope.parentContext.newMember;

                if (newMember.useCEPDecision) {
                    return !newMember.creditOffer;
                } else {
                    return true;
                }
            };

            var buildCreditOfferFptiObject = function buildCreditOfferFptiObject(query) {
                var Device = '';

                if (!_index.$DeviceInfo.isDevice()) {
                    Device = 'Desktop';
                } else if (_index.$DeviceInfo.isTablet()) {
                    Device = 'Tablet';
                } else {
                    Device = 'Mobile';
                }
                var defaultValues = {
                    'buyer_country': _squid.$locale.country,
                    'locale': _squid.$locale.lang,
                    'context_id': _angular.$rootScope.token,
                    'context_type': 'EC-Token',
                    'device_type': Device,
                    'from': 'PERSONALIZATION',
                    'to': 'PERSONALIZATION_CREDIT',
                    'banner_type': query.PresentmentStyle + '-' + query.PresentmentType
                };
                var creditOfferFptiMapObject = {
                    'VisaActive': 'visa_active',
                    'MerchantUpstreamPresentment': 'merchant_presented_banner',
                    'Product': 'product_identifier',
                    'OfferCategory': 'offer_category',
                    'OfferType': 'credit_offer_type',
                    'OfferTextTemplate': 'credit_offer_text',
                    'incentiveOfferProgramId': 'incentive_offer_program_id',
                    'incentiveOfferValue': 'incentive_offer_value',
                    'CartAmountVisible': 'cart_show_amt',
                    'NumberOfFIs': 'funding_instrument_count',
                    'Propensity': 'model_propensity',
                    'Approvability': 'credit_user_approvability',
                    'campaignId': 'caid'
                };
                var queryValues = {};

                for (var key in creditOfferFptiMapObject) {
                    if (query[key] !== null && typeof query[key] !== 'undefined') {
                        queryValues[creditOfferFptiMapObject[key]] = query[key];
                    }
                }

                return Object.assign({}, defaultValues, queryValues);
            };

            var buildPSMonitoringObject = function buildPSMonitoringObject(message, err) {
                var psMonitorObject = { 'token': _angular.$rootScope.token };
                if (err) {
                    psMonitorObject.m_err = err;
                } else {
                    psMonitorObject.msgClass = message.PresentmentStyle + '_' + message.PresentmentType;
                    psMonitorObject.message = message.OfferType;
                    psMonitorObject.m_udf1 = message.OfferCategory;
                    psMonitorObject.m_udf2 = message.VisaActive;
                    psMonitorObject.m_udf3 = message.MerchantUpstreamPresentment;
                    psMonitorObject.m_inptype = !!message.incentiveOfferProgramId;
                }
                psMonitorObject.m_prod_type = $scope.showPassiveBanner;
                psMonitorObject.m_trdtype = $scope.showIncentiveBanner;
                psMonitorObject.m_event = $scope.banner.offerType;
                psMonitorObject.m_chnl = 'Desktop';
                if (_index.$DeviceInfo.isDevice()) {
                    psMonitorObject.m_chnl = _index.$DeviceInfo.isTablet() ? 'Tablet' : 'Mobile';
                }
                return psMonitorObject;
            };

            var hideBannerForNewMember = isNewMemberDecisionToHideBanner();

            var getDefaultBanner = function getDefaultBanner(bannerType, useCase, creditType, amount, termsLink) {
                _logger.$logger.info('getDefaultBanner(): bannerType(' + bannerType + '), useCase(' + useCase + '), creditType(' + creditType + ')');
                if (bannerType === BANNER_TYPES.PROMINENT) {
                    if (useCase === USE_CASE.ACQUISITION) {
                        if (creditType === CREDIT_TYPE.CORE || creditType === CREDIT_TYPE.BA && amount) {
                            return {
                                bodyText: $scope.htmlContent('offers.assetLite.bmlOfferSmallTitleWithAmount', { cartAmount: amount }),
                                ctaText: $scope.htmlContent('offers.bmlOfferBtn'),
                                termsText: $scope.htmlContent('offers.subjectToApproval'),
                                termsLink: termsLink,
                                termsLinkText: $scope.htmlContent('offers.seeTermsText')
                            };
                        } else if ((!amount || amount === '') && creditType === CREDIT_TYPE.BA) {
                            return {
                                bodyText: $scope.htmlContent('offers.assetLite.bmlOfferTitleWithAmountZero'),
                                ctaText: $scope.htmlContent('offers.bmlOfferBtn'),
                                termsText: $scope.htmlContent('offers.subjectToApproval'),
                                termsLink: termsLink,
                                termsLinkText: $scope.htmlContent('offers.seeTermsText')
                            };
                        } else if (creditType === CREDIT_TYPE.NI) {
                            return {
                                bodyText: $scope.htmlContent('offers.assetLite.bmlOfferLargeTitleWithAmount', { cartAmount: amount }),
                                ctaText: $scope.htmlContent('offers.bmlOfferBtn'),
                                termsText: $scope.htmlContent('offers.subjectToApproval'),
                                termsLink: termsLink,
                                termsLinkText: $scope.htmlContent('offers.seeTermsText')
                            };
                        } else if (creditType === CREDIT_TYPE.EZP) {
                            return {
                                bodyText: $scope.htmlContent('offers.assetLite.bmlOfferEZPTitleWithAmount', { cartAmount: amount }),
                                ctaText: $scope.htmlContent('offers.bmlOfferBtn'),
                                termsText: $scope.htmlContent('offers.subjectToApproval')
                            };
                        }
                    } else if (useCase === USE_CASE.REUSE) {
                        if (creditType === CREDIT_TYPE.CORE || creditType === CREDIT_TYPE.BA && amount) {
                            return {
                                bodyText: $scope.htmlContent('offers.bmlExistingOfferTitle'),
                                bodyText2: $scope.htmlContent('offers.assetLite.bmlExistingOfferSmall', { cartAmount: amount }),
                                ctaText: $scope.htmlContent('offers.bmlOfferReuseCta'),
                                termsLink: termsLink,
                                termsLinkText: $scope.htmlContent('offers.seeTermsText')
                            };
                        } else if ((!amount || amount === '') && creditType === CREDIT_TYPE.BA) {
                            return {
                                bodyText: $scope.htmlContent('offers.bmlExistingOfferTitle'),
                                bodyText2: $scope.htmlContent('offers.assetLite.bmlExistingOfferSmallDetails', { cartAmount: amount }),
                                ctaText: $scope.htmlContent('offers.bmlOfferReuseCta'),
                                termsLink: termsLink,
                                termsLinkText: $scope.htmlContent('offers.seeTermsText')
                            };
                        } else if (creditType === CREDIT_TYPE.NI) {
                            return {
                                bodyText: $scope.htmlContent('offers.bmlExistingOfferTitle'),
                                bodyText2: $scope.htmlContent('offers.assetLite.bmlExistingOfferLarge', { cartAmount: amount }),
                                ctaText: $scope.htmlContent('offers.bmlOfferReuseCta'),
                                termsLink: termsLink,
                                termsLinkText: $scope.htmlContent('offers.seeTermsText')
                            };
                        } else if (creditType === CREDIT_TYPE.EZP) {
                            return {
                                bodyText: $scope.htmlContent('offers.bmlExistingOfferTitle'),
                                bodyText2: $scope.htmlContent('offers.assetLite.bmlExistingOfferEZP', { cartAmount: amount }),
                                ctaText: $scope.htmlContent('offers.assetLite.cycoOfferBtn')
                            };
                        }
                    }
                } else if (useCase === USE_CASE.ACQUISITION) {
                    if (creditType === CREDIT_TYPE.CORE || creditType === CREDIT_TYPE.BA && amount) {
                        return {
                            bodyText: $scope.htmlContent('offers.assetLite.bmlOfferPassiveDetails', { cartAmount: amount }),
                            ctaText: $scope.htmlContent('offers.bmlOfferPassiveCta'),
                            termsText: $scope.htmlContent('offers.subjectToApproval'),
                            termsLink: termsLink,
                            termsLinkText: $scope.htmlContent('offers.seeTermsText')
                        };
                    } else if ((!amount || amount === '') && creditType === CREDIT_TYPE.BA) {
                        return {
                            bodyText: $scope.htmlContent('offers.assetLite.bmlOfferTitleWithAmountZero'),
                            ctaText: $scope.htmlContent('offers.bmlOfferPassiveCta'),
                            termsText: $scope.htmlContent('offers.subjectToApproval'),
                            termsLink: termsLink,
                            termsLinkText: $scope.htmlContent('offers.seeTermsText')
                        };
                    } else if (creditType === CREDIT_TYPE.NI) {
                        return {
                            bodyText: $scope.htmlContent('offers.assetLite.bmlOfferPassiveDetails', { cartAmount: amount }),
                            ctaText: $scope.htmlContent('offers.bmlOfferPassiveCta'),
                            termsText: $scope.htmlContent('offers.subjectToApproval'),
                            termsLink: termsLink,
                            termsLinkText: $scope.htmlContent('offers.seeTermsText')
                        };
                    } else if (creditType === CREDIT_TYPE.EZP) {
                        return {
                            bodyText: $scope.htmlContent('offers.assetLite.bmlOfferPassiveEZPDetails', { cartAmount: amount }),
                            ctaText: $scope.htmlContent('offers.bmlOfferPassiveEZPCta'),
                            termsText: $scope.htmlContent('offers.subjectToApproval')
                        };
                    }
                }
            };

            var getReuseOfferInfo = function getReuseOfferInfo(creditType, termsLink, amount) {
                _logger.$logger.info('getReuseOfferInfo(): creditType(' + creditType + ')');
                if (!amount || amount === '') {
                    return {
                        bodyText: $scope.htmlContent('offers.assetLite.bmlExistingOfferAmountZeroDetails', { cartAmount: amount }),
                        termsLink: termsLink,
                        termsLinkText: $scope.htmlContent('offers.seeTermsText') + '.'
                    };
                } else if (creditType === CREDIT_TYPE.CORE || creditType === CREDIT_TYPE.BA) {
                    return {
                        bodyText: $scope.htmlContent('offers.assetLite.bmlExistingOfferSmallDetails', { cartAmount: amount }),
                        termsLink: termsLink,
                        termsLinkText: $scope.htmlContent('offers.seeTermsText') + '.'
                    };
                } else if (creditType === CREDIT_TYPE.NI) {
                    return {
                        bodyText: $scope.htmlContent('offers.assetLite.bmlExistingOfferLargeDetails', { cartAmount: amount }),
                        termsLink: termsLink,
                        termsLinkText: $scope.htmlContent('offers.seeTermsText') + '.'
                    };
                } else if (creditType === CREDIT_TYPE.EZP) {
                    return {
                        bodyText: $scope.htmlContent('offers.assetLite.bmlExistingOfferEZPDetails', { cartAmount: amount })
                    };
                }
            };

            var isCreditTxnLowerThanThreshold = function isCreditTxnLowerThanThreshold() {
                var transactionAmount = $scope.getTransactionAmount();
                var largeEligibleAmount = _index2.$CreditOptionsModel.largeEligibleAmount[_squid.$locale.country];

                _logger.$logger.info('transactionAmount_sacEligibleAmount', {
                    transactionAmount: transactionAmount,
                    largeEligibleAmount: largeEligibleAmount
                });
                return transactionAmount < largeEligibleAmount;
            };

            var getCreditType = function getCreditType() {
                // Check if there is an offer already selected
                // This is the scenario where user has EZP but selects SAC or NI
                var instModel = _index3.$CreditInstallmentModel.instance($scope.token);
                var creditType = void 0;
                var resolution = void 0;

                if ($scope.isBillingNoPurchase) {
                    creditType = CREDIT_TYPE.BA;
                    resolution = 'BA_NOP';
                } else if (instModel && instModel.creditType === CREDIT_TYPE.SAC) {
                    creditType = CREDIT_TYPE.SAC;
                    resolution = 'SAC_SELECTED';
                } else if (instModel && instModel.creditType === CREDIT_TYPE.NI) {
                    creditType = CREDIT_TYPE.NI;
                    resolution = 'NI_SELECTED';
                } else if ($scope.banner && $scope.banner.offerType) {
                    // Check MORS offer type
                    creditType = $scope.banner.offerType;
                    resolution = 'MORS';
                } else if ($scope.installmentOptionsPresent) {
                    // Check SSOT response + installment eligibility
                    creditType = CREDIT_TYPE.EZP;
                    resolution = 'SSOT_INST';
                } else if ($scope.largeOfferType) {
                    // Check SSOT response
                    creditType = $scope.largeOfferType;
                    resolution = 'SSOT_LARGE_OFFER';
                } else if (!isCreditTxnLowerThanThreshold()) {
                    creditType = CREDIT_TYPE.NI;
                    resolution = 'CART_NI';
                } else {
                    creditType = CREDIT_TYPE.CORE;
                    resolution = 'CART_CORE';
                }

                return {
                    creditType: creditType,
                    resolution: resolution
                };
            };

            var incrementTreatmentBannerDisplayedCount = function incrementTreatmentBannerDisplayedCount(localStorageKey) {
                _logger.$logger.info('Inside incrementTreatmentBannerDisplayedCount');
                if (_squid.$util.localStorageEnabled()) {
                    var public_device_key = 'public_device_test';
                    var credit_banner_displayed_count = void 0;
                    var publicDeviceTest = localStorage.getItem(public_device_key);

                    if (publicDeviceTest !== 'true') {
                        // don't overuse localStorage as there is a size limit
                        credit_banner_displayed_count = localStorage.getItem(localStorageKey) || 0;
                        _logger.$logger.info('incrementTreatmentBannerDisplayedCount: credit_banner_displayed_count' + credit_banner_displayed_count);
                        credit_banner_displayed_count++;
                        localStorage.setItem(localStorageKey, credit_banner_displayed_count.toString());
                        _logger.$logger.info('incrementTreatmentBannerDisplayedCount: credit_banner_displayed_count' + credit_banner_displayed_count);
                    }
                }
            };

            var isTreatmentCapped = function isTreatmentCapped(result, maxCount) {
                _logger.$logger.info('Inside isTreatmentCapped');
                if (_squid.$util.localStorageEnabled()) {
                    var public_device_key = 'public_device_test';
                    var credit_banner_displayed_count = void 0;
                    var publicDeviceTest = localStorage.getItem(public_device_key);

                    if (publicDeviceTest === 'true') {
                        // don't overuse localStorage as there is a size limit
                        localStorage.removeItem(CREDIT_BANNER_DISPLAY_COUNT_KEY);
                    } else {
                        credit_banner_displayed_count = localStorage.getItem(CREDIT_BANNER_DISPLAY_COUNT_KEY) || 0;
                        _logger.$logger.info('isTreatmentCapped: credit_banner_displayed_count' + credit_banner_displayed_count);
                        if (angular.isNumber(maxCount) && maxCount <= credit_banner_displayed_count) {
                            _logger.$logger.info('Banner/interstitial treatment is capped');
                            return true;
                        }
                    }
                }

                return false;
            };

            var isTreatmentIneligible = function isTreatmentIneligible(result, maxCount, localStorageKey) {
                if (CREDIT_TYPE.EZP === getCreditType().creditType) {
                    _logger.$logger.info('INST available');
                    $scope.creditBannerTreatment = 0;
                    $scope.showCreditBannerControl = true;
                    _logger.$logger.info('Returning to control since its installments');
                    return true;
                }

                if (isTreatmentCapped(result, maxCount, localStorageKey)) {
                    return true;
                }

                return false;
            };

            var shouldSetInterstitial = function shouldSetInterstitial(result) {
                if (isCreditTxnLowerThanThreshold() || isTreatmentIneligible(result, CREDIT_BANNER_DISPLAY_COUNT_MAX, CREDIT_BANNER_DISPLAY_COUNT_KEY)) {
                    _logger.$logger.info('setInterstitial: returning false (should not show interstitial)');
                    return false;
                }
                var isMobileOrTablet = _index.$DeviceInfo.isDevice();

                if (isMobileOrTablet) {
                    _logger.$logger.info('setInterstitial: returning false for mobile devices');
                    return false;
                }

                _logger.$logger.info('setInterstitial: treatment is eligible and not capped');
                incrementTreatmentBannerDisplayedCount(CREDIT_BANNER_DISPLAY_COUNT_KEY);
                return true;
            };

            var getInterstitialContent = function getInterstitialContent(params) {
                if (params.showDynamic) {
                    $scope.creditOfferModel.fireInterstitialBeacon();
                    return $scope.creditOfferModel.getInterstitialContent();
                } else {
                    var interstitialContent = {};
                    interstitialContent.messageId = 'JS-NI-Interstitial';
                    interstitialContent.bodyText = 'No Interest if paid in full in 6 months for your purchase of ' + params.cart_amount;
                    interstitialContent.bodyText2 = 'This offer is always available for purchases of $99+';
                    interstitialContent.termsText = 'Subject to credit approval.';
                    interstitialContent.termsText2 = 'Interest will be charged to your account from the purchase date if ' + 'the balance is not paid in full within 6 months. Minimum monthly ' + 'payments required.';
                    interstitialContent.termsLink = 'https://www.billmelater.com/cm/paypal/landers/18ppcTERMS.html';
                    interstitialContent.termsLinkText = 'See terms';
                    interstitialContent.ctaText = 'Apply Now';
                    return interstitialContent;
                }
            };

            var showInterstitial = function showInterstitial() {
                _logger.$logger.info('acq_banner', {
                    'from': 'xo_review',
                    'to': 'prepare_banner_interstitial'
                });

                if ($scope.creditOfferModel && $scope.creditOfferModel.isRamped && $scope.creditOfferModel.hasInterstitialMessage()) {
                    var interstitialMessage = Object.assign({}, $scope.creditOfferModel.getInterstitialMessage().content.json, { campaignId: $scope.creditOfferModel.getInterstitialMessage().id });

                    _logger.$logger.info('checkout_fpti', buildCreditOfferFptiObject(interstitialMessage));
                    _logger.$logger.createCalRootTxn(buildPSMonitoringObject(interstitialMessage, null), 'hermes_personalization');
                }

                var interstitialParams = {
                    cart_amount: $scope.checkoutCart.get('purchase.amounts.total.amount_formatted', ''),
                    showDynamic: $scope.creditOfferModel && $scope.creditOfferModel.isRamped && $scope.creditOfferModel.hasInterstitialMessage()
                };

                return _uiRouter.$state.go('checkout.bannerInterstitial', {
                    creditInterstitialTreatment: $scope.creditInterstitialTreatment,
                    banner: getInterstitialContent(interstitialParams)
                }, {
                    location: false
                });
            };

            var renderBanner = function renderBanner() {
                (0, _squid.$populate)($scope, {
                    auth: _auth.$AuthModel.instance(),
                    checkoutSession: _index2.$CheckoutSessionModel.instance($scope.token),
                    checkoutCart: _index2.$CheckoutCartModel.instance($scope.token),
                    checkoutAppData: _index2.$CheckoutAppDataModel.instance($scope.token),
                    payee: _index2.$CheckoutPayeeModel.instance($scope.token)
                }).then(function () {
                    $scope.creditData = _index3.$CreditDataModel.instance($scope.token);
                }).then(function () {
                    var merchantId = $scope.payee.getId();
                    var country = _squid.$locale.country;

                    // Exit early for non UK countries
                    if (country !== 'GB') {
                        return _angular.$q.when();
                    }

                    // pxp for banner ramp in UK
                    return (0, _squid.$pxp)('xo_hermes_cape_migration_UK', {
                        'ctx.COUNTRY': _squid.$locale.country,
                        'ctx.merchantID': merchantId,
                        'uid': merchantId
                    }, 'xo_cape_migration_UK.*', false, true).then(function (result) {
                        if (result && result.treatment_name === 'xo_cape_migration_UK_test') {
                            $scope.isUKBannerEligible = true;
                        }
                        return _angular.$q.when();
                    });
                }).then(function () {
                    // https://github.paypal.com/Checkout/xo-credit-components/pull/212#discussion_r1069996
                    // TODO: If 2nd button test requires this PXP, move this logic to the model
                    if (_squid.$locale.country === 'GB') {
                        return (0, _squid.$pxp)('xo_hermesnodeweb_gb_ppc_bypass_cyco', { 'ctx.COUNTRY': _squid.$locale.country }, 'xo_hermesnodeweb_gb_ppc_bypass_cyco.*', false, true).then(function (result) {
                            if (result) {
                                if (result.treatment_name === 'xo_hermesnodeweb_gb_ppc_bypass_cyco_treatment') {
                                    bypassGbCycoTreatment = true;
                                    _logger.$logger.info('bypass_cyco_treatment');
                                } else {
                                    _logger.$logger.info('bypass_cyco_control');
                                }

                                _logger.$logger.info('checkout_fpti', {
                                    xo_hermesnodeweb_gb_ppc_bypass_cyco: result.treatment_name
                                });
                            }
                            return _angular.$q.when();
                        });
                    }
                }).then(function () {
                    $scope.placementCode = '210004';
                    $scope.presentation_types = ['PayPalCreditCheckout'];
                    $scope.pu_type = 'PERSONAL';
                    var morsCallFailed = false;
                    var ssotCallFailed = false;

                    /** --------------------------------------------------
                     ** Populate credit offers and $scope.showBml
                     ** -------------------------------------------------- */
                    $scope.creditOffer = $scope.checkoutSession.creditOffer;
                    $scope.creditOfferIntensity = 0;
                    _logger.$logger.info('creditOffer: ' + $scope.creditOffer);
                    $scope.buyerCountry = _squid.$locale.country;

                    var isCoreSACEligible = $scope.creditOffer;
                    isRedirectFromCape = $scope.creditData.isRedirectFromCape();

                    $scope.isBillingNoPurchase = $scope.checkoutCart.isBillingNoPurchase();
                    if ($scope.isBillingNoPurchase) {
                        isCreditInWallet = $scope.checkoutSession.get('futurePayment.isCreditInWallet');
                    } else {
                        var plans = $scope.checkoutSession.get('fundingOptions.plans');
                        isCreditInWallet = _squid.$util.find(plans, function (fi) {
                            return fi && fi.primaryFs && fi.primaryFs.name === 'BILL_ME_LATER';
                        });
                    }

                    $scope.checkIfSelectFiDisplayedBanner = function (showBanner) {
                        var current = _uiRouter.$state.current;


                        if (showBanner && current.name === 'checkout.selectFi') {
                            _angular.$rootScope.hideBanner = true;
                        } else if (_angular.$rootScope.hideBanner) {
                            showBanner = false;
                        }
                        return showBanner;
                    };

                    // Banner for US installments and for all banners in UK
                    var showBannerRules = function showBannerRules() {
                        if (_squid.$locale.country === 'GB') {
                            $scope.offerTypeKey = $scope.installmentOptionsPresent && !$scope.checkoutCart.isBilling() ? 'offers.bmlInstallmentTitle' : $scope.isBmlOfferSmallOrLarge(ACQ_Banner_Type);
                            // FPTI tracking
                            _logger.$logger.info('isUkBannerEligible ' + $scope.isUKBannerEligible);

                            if ($scope.isUKBannerEligible && !isCreditInWallet && !isRedirectFromCape && (isCoreSACEligible || $scope.checkoutSession.creditInstallmentOffer)) {
                                // UK banner eligible for credit test group
                                _logger.$logger.info('checkout_fpti', {
                                    'banner_type': 'test_ACQUISITION'
                                });
                            } else if (!$scope.isUKBannerEligible && !isCreditInWallet && !isRedirectFromCape && (isCoreSACEligible || $scope.checkoutSession.creditInstallmentOffer)) {
                                // UK banner eligible for credit control group (will not see banner)
                                _logger.$logger.info('checkout_fpti', {
                                    'banner_type': 'control_ACQUISITION'
                                });
                            }

                            if ($scope.checkoutCart.isBilling()) {
                                return $scope.showUKBanner && !isRedirectFromCape && (isCoreSACEligible || $scope.checkoutSession.creditInstallmentOffer) && !isCreditInWallet;
                            } else if ($scope.showUKBanner && !isCreditInWallet && !isRedirectFromCape && (isCoreSACEligible || $scope.checkoutSession.creditInstallmentOffer)) {
                                return true;
                            } else {
                                return false;
                            }
                        } else {
                            return !isCreditInWallet && $scope.installmentOptionsPresent && !isRedirectFromCape;
                        }
                    };

                    // Logic to determine is CYCO is shown in acquisiton and reuse
                    // Warning: This value is being stored and used in other Hermes components (such as xo-review)
                    var showCYCORules = function showCYCORules() {
                        var commonRules = isCreditInWallet && $scope.checkoutSession.creditInstallmentOffer && $scope.installmentOptionsPresent;

                        if (_squid.$locale.country === 'GB') {
                            return $scope.showUKBanner && commonRules;
                        } else {
                            return commonRules;
                        }
                    };

                    /**
                     * This function is to determine that the offer is large offer (transaction amount >= 99) or
                     * smaller (transaction amount < 99) to display appropriate text on ui
                     * @returns bmlExistingSmall/LargeOffer
                     */
                    $scope.isBmlOfferSmallOrLarge = function (bannerType) {
                        var key = void 0;

                        if ($scope.isBmlOfferLarge()) {
                            key = bannerType === ACQ_Banner_Type ? 'offers.bmlOfferLargeTitle' : 'offers.bmlExistingOfferLarge';
                        } else {
                            key = bannerType === ACQ_Banner_Type ? 'offers.bmlOfferSmallTitle' : 'offers.bmlExistingOfferSmall';
                        }
                        return key;
                    };

                    // small refactor of isBmlOfferSmallOrLarge() function
                    $scope.isBmlOfferLarge = function () {
                        var transactionAmount = $scope.getTransactionAmount();
                        var sacEligibleAmount = _index2.$CreditOptionsModel.sacEligibleAmount[_squid.$locale.country];

                        return transactionAmount >= sacEligibleAmount;
                    };

                    $scope.getTransactionAmount = function () {
                        var transactionAmount = $scope.checkoutCart.get('purchase.amounts.total.amount');

                        return parseFloat(transactionAmount) || 0;
                    };

                    if ($scope.buyerCountry === 'US' && $scope.creditOffer) {
                        if ($scope.isBmlOfferLarge()) {
                            $scope.creditOfferIntensity = 1;
                        } else {
                            $scope.creditOfferIntensity = 2;
                        }
                        $scope.installment.creditOfferIntensity = $scope.creditOfferIntensity;
                    }

                    var executeSsotCall = function executeSsotCall(silent) {
                        _logger.$logger.info('executeSsotCall');

                        if ((0, _squid.$feature)('creditInstallmentOffers') && $scope.checkoutAppData.merchant.merchant_country === _squid.$locale.country && !$scope.isBillingNoPurchase) {
                            var offers = new _index3.$CreditInstallmentOptionsModel({
                                id: $scope.token,
                                payee: $scope.payee,
                                checkoutCart: $scope.checkoutCart,
                                checkoutAppData: $scope.checkoutAppData,
                                isMemberCredit: true
                            });

                            var processInstallmentResponse = function processInstallmentResponse(result) {
                                $scope.installmentOptionsPresent = $scope.installment.installmentOptionsPresent = offers.getInstallmentOptionsPresent();
                                $scope.installmentCount = offers.getInstallmentCount();
                                $scope.creditOffers = offers.getInstallmentOffers();
                                $scope.showUKBanner = _squid.$locale.country === 'GB' && ($scope.checkoutAppData.is_second_button_txn || $scope.isUKBannerEligible);
                                $scope.largeOfferType = offers.getNiOfferPresent();

                                if ($scope.buyerCountry === 'US') {
                                    $scope.installment.showBanner = hideBannerForNewMember ? false : $scope.checkIfSelectFiDisplayedBanner(showBannerRules());
                                    $scope.installment.showWalletBanner = showBannerRules();
                                } else {
                                    $scope.installment.showBanner = showBannerRules();
                                }
                                $scope.installment.showCYCO = showCYCORules();
                                $scope.showCYCO = $scope.installment.showCYCO; // this is being used in the template for pink banner UK link content
                                var hideSacBanner = $scope.installment.showBanner || isRedirectFromCape || _squid.$locale.country === 'GB';
                                $scope.showBml = hideSacBanner ? false : isCoreSACEligible;

                                // Logging when Both BA and EZP enabled.
                                if ($scope.checkoutCart.isBilling() && $scope.installmentOptionsPresent && $scope.offerTypeKey === 'offers.bmlInstallmentTitle') {
                                    _logger.$logger.info('RYI SSOT call: Merchant ' + $scope.checkoutAppData.get('merchant.brand_name', 'merchant_name_not_found') + ' has both BA and EZP enabled');
                                }
                            };

                            return offers.save({
                                silent: silent,
                                cache: true,
                                params: {
                                    txnAmount: ($scope.checkoutCart.get('purchase.amounts.total.amount', 0) * 100).toFixed(0)
                                },
                                success: function success(result) {
                                    _logger.$logger.info('executeSsotCall succeeded');
                                    processInstallmentResponse(result);
                                },
                                error: function error(err) {
                                    _logger.$logger.error('executeSsotCall error', { error: err });
                                    ssotCallFailed = true;
                                },
                                contingencies: {
                                    DEFAULT: function DEFAULT() {
                                        return _logger.$logger.info('GET_INSTALLMENT_CONTINGENCY');
                                    }
                                }
                            });
                        } else {
                            return (0, _angular.$q)(function (resolve) {
                                var hideSacBanner = isRedirectFromCape || _squid.$locale.country === 'GB';

                                $scope.showBml = hideSacBanner ? false : isCoreSACEligible;
                                $scope.showUKBanner = _squid.$locale.country === 'GB' && ($scope.checkoutAppData.is_second_button_txn || $scope.isUKBannerEligible);
                                $scope.installment.showBanner = showBannerRules();

                                if ($scope.checkoutCart.isBilling()) {
                                    _logger.$logger.info('RYI no SSOT call for this BA flow, Merchant ' + $scope.checkoutAppData.get('merchant.brand_name', 'merchant_name_not_found'));
                                }
                                resolve();
                            });
                        }
                    };

                    /** --------------------------------------------------
                     ** Call MORS for banner
                     ** -------------------------------------------------- */
                    $scope.creditTerms = _squid.$config.urls.creditTerms;
                    $scope.creditReuseTerms = _squid.$config.urls.creditReuseTerms;

                    // TODO Once the Asset Lite ramp is complete, change the config credit terms urls in hermesnodeweb config.json
                    $scope.creditTerms = 'https://www.paypal.com/ppclander';
                    $scope.creditReuseTerms = 'https://www.paypal.com/ppclander';

                    var mapDefaultToBanner = function mapDefaultToBanner(creditReuseTerms, creditTerms) {
                        $scope.useFallbackBanner = true;
                        $scope.showPassiveBanner = !isCreditInWallet;
                        var creditTypeModel = getCreditType();

                        _logger.$logger.info('mapDefaultToBanner(): creditType(' + creditTypeModel.creditType + '), resolution(' + creditTypeModel.resolution + ')');
                        $scope.banner = getDefaultBanner($scope.showPassiveBanner ? BANNER_TYPES.PASSIVE : BANNER_TYPES.PROMINENT, isCreditInWallet ? USE_CASE.REUSE : USE_CASE.ACQUISITION, creditTypeModel.creditType, $scope.checkoutCart.get('purchase.amounts.total.amount_formatted', ''), isCreditInWallet ? creditReuseTerms : creditTerms);
                    };

                    var mapReuseText = function mapReuseText(creditReuseTerms) {
                        var creditTypeModel = getCreditType();

                        _logger.$logger.info('mapReuseText(): creditType(' + creditTypeModel.creditType + '), resolution(' + creditTypeModel.resolution + ')');
                        $scope.reuseOfferInfo = getReuseOfferInfo(creditTypeModel.creditType, creditReuseTerms, $scope.checkoutCart.get('purchase.amounts.total.amount_formatted', ''));
                    };

                    var shouldCallMors = _squid.$locale.country === 'US' && $scope.placementCode && (
                    // creditOffer checks acquisition eligibility; isCreditInWallet checks reuse
                    $scope.checkoutSession.creditOffer || isCreditInWallet);

                    // Shared function to create application context
                    var getApplicationContext = function getApplicationContext() {
                        return [{
                            name: 'transaction_amount',
                            value: ($scope.checkoutCart.get('purchase.amounts.total.amount', 0) * 100).toFixed(0)
                        }, {
                            name: 'transaction_currency',
                            value: $scope.checkoutCart.get('purchase.amounts.total.currency_code', '')
                        }, {
                            name: 'ppc_in_wallet',
                            value: !!isCreditInWallet
                        }, {
                            name: 'ppc_default_fi',
                            value: $scope.checkoutSession.get('plan.paypal_credit')
                        }, {
                            name: 'is_mobile',
                            value: _index.$DeviceInfo.isDevice()
                        }, {
                            name: 'installments_not_allowed',
                            value: !$scope.checkoutSession.creditInstallmentOffer || $scope.checkoutCart.isBilling()
                        }, {
                            name: 'is_ba_rt_no_purchase',
                            value: $scope.checkoutCart.isBillingNoPurchase() && !$scope.checkoutCart.get('purchase.amounts.total.currency_code', '')
                        }];
                    };

                    var executeMorsDiscoverMessagesCall = function executeMorsDiscoverMessagesCall(silent, useContentInBanner) {
                        var morsCacheId = $scope.checkoutSession.id + '-' + $scope.placementCode + '-' + !!isCreditInWallet + '-' + getCreditType($scope.creditOfferIntensity, $scope.installmentOptionsPresent, $scope.isBillingNoPurchase);
                        var application_context = getApplicationContext();

                        $scope.creditOfferModel = new _marketingoffer.$CreditOfferModel({
                            id: $scope.token,
                            locale: _squid.$locale,
                            payer: $scope.checkoutSession.payer.id || '',
                            payee: $scope.payee.merchant.id || '',
                            touchpoint: 'PPC_HERMES_RYI',
                            message_count: 10,
                            isRamped: useContentInBanner,
                            application_context: application_context
                        });

                        return $scope.creditOfferModel.save({
                            silent: silent,
                            cache: true,
                            params: $scope.creditOfferModel.getCacheKey(),
                            data: $scope.creditOfferModel.serialize(),
                            success: function success(result) {
                                _logger.$logger.info('discover_messages_response', result);
                                var ad = {};
                                var recommendationFound = false;

                                if (result && result.touchpoint_messages) {
                                    $scope.recommendedMessage = {};
                                    var bannerContent = this.model.getBannerMessage() ? this.model.getBannerMessage().content : null;

                                    if (bannerContent) {
                                        recommendationFound = true;
                                        ad = bannerContent.json;

                                        // PresentmentStyle from Personalization Studio should be mapped to MessageType in campaign studio
                                        ad.MessageType = ad.PresentmentStyle;
                                        // OfferType from Personaliation Studio should be mapped to offertype
                                        ad.offertype = ad.OfferType;

                                        // Credit Incentive fields
                                        if (ad['Incentive-OfferProgramId']) {
                                            ad.incentiveOfferProgramId = ad['Incentive-OfferProgramId'];
                                            ad.incentiveOfferValue = ad['Incentive-OfferValue'];
                                            ad.incentiveOfferCurrencyCode = ad['Incentive-OfferCurrencyCode'];
                                            ad.incentiveOfferProgramCode = ad['Incentive-OfferProgramCode'];
                                        }

                                        var trackingDetails = this.model.getBannerMessage().tracking_details;

                                        if (trackingDetails) {
                                            ad.impressionUrl = trackingDetails.impression_url;
                                            ad.clickUrl = trackingDetails.click_url;
                                        }

                                        // Message id is used for fpti tracking.
                                        ad.campaignId = this.model.getBannerMessage().id;
                                        ad.buyItemId = ad.campaignId;
                                        ad.placementCode = this.model.getTouchpointCode();
                                        $scope.recommendedMessage = ad;
                                    }
                                }

                                // cache recommended message only if it's ramped
                                if (useContentInBanner) {
                                    if (recommendationFound) {
                                        morsCallFailed = false;
                                        $scope.ad = $scope.recommendedMessage;
                                        _angular.$rootScope.MORS[morsCacheId] = $scope.ad;
                                        $scope.banner = _xoMORSCreditBannerUtils.$xoMORSCreditBannerUtils.mapResponseToCreditBanner($scope.ad, false);
                                    } else {
                                        _logger.$logger.info('MORS_recommended_message_not_found_credit');
                                        _angular.$rootScope.MORS[morsCacheId] = null;
                                        morsCallFailed = true;
                                        discoverMessageError = 'MORS_recommended_message_empty';
                                    }
                                }
                            },
                            error: function error(_error) {
                                _logger.$logger.error('MORS_api_failure_credit', { error: _error });

                                // Only recognize morsCallFailed if it's ramped
                                if (useContentInBanner) {
                                    _angular.$rootScope.MORS[morsCacheId] = null;
                                    morsCallFailed = true;
                                    discoverMessageError = 'MORS_call_' + _error.message;
                                }
                            },
                            contingencies: {
                                DEFAULT: function DEFAULT(name) {
                                    _logger.$logger.error('MORS_api_contingency_credit', { contingency: name });

                                    if (useContentInBanner) {
                                        _angular.$rootScope.MORS[morsCacheId] = null;
                                        morsCallFailed = true;
                                        discoverMessageError = 'MORS_api_contingency_credit_' + name;
                                    }
                                }
                            }
                        });
                    };

                    var compareAdObjects = function compareAdObjects(base, compare) {
                        _logger.$logger.info('Comparing ad objects', { base_ad: base, recommended_message: compare });
                        var diff = [];
                        var keysToIgnore = ['campaignId', 'buyItemId', 'placementCode', 'impressionUrl', 'clickUrl', 'client_elapsed', 'req_elapsed'];

                        if (!base) {
                            diff.push('base_ad is not present');
                        } else if (!compare) {
                            diff.push('recommended_message is not present');
                        } else {
                            Object.keys(base).forEach(function (key) {
                                if (keysToIgnore.indexOf(key) === -1 && (!compare[key] || compare[key] !== base[key])) {
                                    diff.push({
                                        key: key,
                                        expected: base[key],
                                        actual: compare[key]
                                    });
                                }
                            });
                        }

                        if (diff.length !== 0) {
                            _logger.$logger.warn('recommended_message_warning', diff);
                        }
                    };

                    var executeMorsCall = function executeMorsCall(silent) {
                        var morsCacheId = $scope.checkoutSession.id + '-' + $scope.placementCode + '-' + !!isCreditInWallet;
                        var walletInstruments = []; // Get wallet instruments

                        if (isCreditInWallet) {
                            walletInstruments.push({
                                financial_instrument_type: 'FI_PAYPAL_CREDIT',
                                financial_instrument_product_type: 'PI_TYPE_CREDIT_TXN_CARD_BML',
                                preferred: isCreditInWallet.isPreferred,
                                out_of_wallet: false
                            });
                        }

                        var marketingOfferModel = new _marketingoffer.$MarketingOfferModel(_xoMORSCreditBannerUtils.$xoMORSCreditBannerUtils.getMorsParametersForCreditBanner($scope));

                        return marketingOfferModel.save({
                            silent: silent,
                            params: {
                                cacheToken: morsCacheId,
                                txnAmount: ($scope.checkoutCart.get('purchase.amounts.total.amount', 0) * 100).toFixed(0)
                            },
                            // Ignore all errors from this api, by passing transientError as true
                            transientError: true,
                            cache: true,
                            success: function success(result) {
                                _logger.$logger.info('MORS_response', result);
                                if (marketingOfferModel.isAdFound()) {
                                    $scope.ad = marketingOfferModel.getTargetAd();
                                    $scope.showPassiveBanner = $scope.ad['MessageType'] !== 'Prominent';
                                    $scope.showIncentiveBanner = $scope.ad['incentiveOfferProgramId'] !== undefined;
                                    $scope.banner = _xoMORSCreditBannerUtils.$xoMORSCreditBannerUtils.mapResponseToCreditBanner($scope.ad, $scope.showPassiveBanner);
                                    $scope.base_ad = $scope.ad;
                                    _angular.$rootScope.MORS[morsCacheId] = $scope.ad;
                                } else {
                                    _logger.$logger.info('MORS_ad_not_found_credit');
                                    morsCallFailed = true;
                                }
                            },
                            error: function error(err) {
                                _logger.$logger.error('MORS_api_failure_credit', { error: err });
                                _angular.$rootScope.MORS[morsCacheId] = null;
                                morsCallFailed = true;
                            }
                        });
                    };

                    var handlePersonalizationPXPResult = function handlePersonalizationPXPResult(result) {
                        _angular.$rootScope.MORS = _angular.$rootScope.MORS || {};
                        $scope.banner = {};
                        switch (result && result.treatment_name) {
                            case 'xo_hermesnodeweb_us_ppc_personalization_treatment1':
                                // Shadow only
                                //  1. Call Mors search-ads & discover-messages
                                //  2. Compare response from search-ads and discover-message and log warning if they differ
                                //  3. Render banner with response from search-ads
                                _logger.$logger.info('Personalization: Shadow only');
                                return _angular.$q.all([executeMorsCall(true), executeMorsDiscoverMessagesCall(true, false)]).then(function () {
                                    return compareAdObjects($scope.base_ad, $scope.recommendedMessage);
                                });
                            case 'xo_hermesnodeweb_us_ppc_personalization_treatment2':
                                // Shadow and Ramp
                                //  1. Call mors search-ads & discover-messages
                                //  2. Compare response from search-ads and discover-messages and log warning if they differ
                                //  3. Render banner with response from discover-messages
                                _logger.$logger.info('Personalization: Shadow and Ramp');
                                return _angular.$q.all([executeMorsCall(true), executeMorsDiscoverMessagesCall(true, true)]).then(function () {
                                    return compareAdObjects($scope.base_ad, $scope.recommendedMessage);
                                });
                            case 'xo_hermesnodeweb_us_ppc_personalization_treatment3':
                                // Ramp only
                                //  1. call mors discover-messages
                                //  2. Render banner with response from discover-messages
                                _logger.$logger.info('Personalization: Ramp only');
                                return executeMorsDiscoverMessagesCall(true, true);
                            default:
                                // Should catch traffic on control or any unexpected treatment
                                //  1. Call mors search-ads
                                //  2. Render banner with response from search-ads
                                return executeMorsCall(true);
                        }
                    };

                    // TODO: Move PXP into contry sepefic directive during refactoring
                    var runPxpExperiment = function runPxpExperiment(experimentName, pxpPattern, resultKey, handler) {
                        if (_angular.$rootScope[resultKey]) {
                            return handler(_angular.$rootScope[resultKey]);
                        } else if (_app.$PXPBlacklist.isMerchantBlacklisted($scope.payee.merchant.id)) {
                            // Skip pxp and will default to control
                            return handler();
                        } else {
                            // Call PXP
                            return (0, _squid.$pxp)(experimentName, { 'ctx.COUNTRY': _squid.$locale.country }, pxpPattern, false, true).then(function (result) {
                                _angular.$rootScope[resultKey] = result;
                                return handler(result);
                            });
                        }
                    };

                    // Don't make SSOT call if MORS is being called, unless it fails
                    if (shouldCallMors) {
                        return _angular.$q.when().then(function () {
                            return runPxpExperiment('xo_hermesnodeweb_us_ppc_personalization', 'xo_hermesnodeweb_us_ppc_personalization.*', 'creditPersonalizationPXPResult', handlePersonalizationPXPResult);
                        })['finally'](function () {
                            if (morsCallFailed) {
                                return executeSsotCall(true)['finally'](function () {
                                    if (ssotCallFailed) {
                                        _logger.$logger.info('SSOT call failed; cannot determine EZP');
                                    }

                                    mapReuseText($scope.creditReuseTerms);
                                    mapDefaultToBanner($scope.creditReuseTerms, $scope.creditTerms);
                                });
                            } else {
                                // Process installment response separately
                                $scope.showBml = !isRedirectFromCape && isCoreSACEligible;
                                $scope.installmentOptionsPresent = $scope.installment.installmentOptionsPresent = $scope.banner.offerType === CREDIT_TYPE.EZP;

                                var showInstBanner = $scope.installmentOptionsPresent && !isCreditInWallet && !isRedirectFromCape;

                                $scope.installment.showBanner = hideBannerForNewMember ? false : $scope.checkIfSelectFiDisplayedBanner(showInstBanner);
                                $scope.installment.showWalletBanner = showInstBanner;
                                $scope.installment.showCYCO = isCreditInWallet && $scope.checkoutSession.creditInstallmentOffer && $scope.banner.offerType === CREDIT_TYPE.EZP;
                                mapReuseText($scope.creditReuseTerms);

                                // Logging when Both BA and EZP enabled.
                                if ($scope.checkoutCart.isBilling() && $scope.installmentOptionsPresent) {
                                    _logger.$logger.info('RYI MORS call: Merchant ' + $scope.checkoutAppData.get('merchant.brand_name', 'merchant_name_not_found') + ' has both BA and EZP enabled');
                                }
                            }
                        });
                    } else {
                        return executeSsotCall(false);
                    }
                }).then(function () {
                    var country = _squid.$locale.country;

                    // Exit early for non UK countries
                    if (country !== 'GB') {
                        return _angular.$q.when();
                    }

                    return _angular.$q.when().then(function () {
                        return (0, _squid.$pxp)('xo_hermesnodeweb_gb_ppc_acquisitionbanner', { 'ctx.COUNTRY': _squid.$locale.country }, 'xo_hermesnodeweb_gb_ppc_representative_example_treatment1', false, true).then(function (result) {
                            // note: we are pre-fetching the representative_example pxp
                            var treatmentName = result && result.treatment_name;
                            $scope.representativeExampleTreatment = treatmentName;
                        });
                    });
                }).then(function () {
                    var handleInterstitialTreatment = function handleInterstitialTreatment(result) {
                        var treatmentName = 'xo_hermesnodeweb_us_ryi_ppc_ppcacquisition_interstitial_treatment_1';
                        var treatmentVariant = 1;

                        $scope.creditInterstitialTreatment = null;
                        if (result && result.treatment_name === treatmentName) {
                            $scope.creditInterstitialTreatment = treatmentVariant;
                            _logger.$logger.info('Showing "' + treatmentName + '"');
                            $scope.isRedirectingToInterstitial = true;
                            showInterstitial();
                        }
                        _logger.$logger.info('checkout_fpti', {
                            'ppc_acq_interstitial_variant_displayed': $scope.isRedirectingToInterstitial ? treatmentVariant : 0
                        });
                        return result;
                    };

                    var handleBannerTreatment = function handleBannerTreatment(result) {
                        $scope.creditBannerTreatment = 0;
                        switch (result && result.treatment_name) {
                            case 'xo_hermesnodeweb_us_ryi_ppc_acq_treatment2':
                                _logger.$logger.info('Showing xo_hermesnodeweb_us_ryi_ppc_acq_treatment2');
                                $scope.creditBannerTreatment = 2;
                                $scope.showPPCAcquisitionGradientBanner = true;
                                // TODO if this is the winning variant, integrate new URL with MORS instead of hard coding
                                $scope.banner.logo = 'https://www.paypalobjects.com/webstatic/credit/img/pp_credit_logo_white@2x.png';
                                break;
                            case 'xo_hermesnodeweb_us_ryi_ppc_acq_control':
                            default:
                                $scope.creditBannerTreatment = 0;
                                $scope.showCreditBannerControl = true;
                                break;
                        }
                        _logger.$logger.info('checkout_fpti', {
                            'ppc_acq_banner_variant_displayed': $scope.creditBannerTreatment
                        });
                        // TODO: Should return $q.when() to prevent a race condition
                        return result;
                    };

                    // TODO: Move into country specific directives during refactor
                    var runPxpExperiment = function runPxpExperiment(experimentName, pxpPattern, resultKey, initializeBannerTreatment, handler) {
                        // US814332 HERMES-OPTIMIZE: Acquisition banner test
                        if (!hideBannerForNewMember && $scope.showBml && _squid.$locale.country === 'US' && !$scope.isRedirectingToInterstitial && $scope.showPassiveBanner !== undefined && !$scope.showPassiveBanner && ($scope.creditOfferModel && $scope.creditOfferModel.isRamped || !$scope.isBillingNoPurchase)) {
                            if (initializeBannerTreatment) {
                                $scope.creditBannerTreatment = 0;
                            }

                            if ($scope.isNewMember()) {
                                $scope.showCreditBannerControl = true;
                                return _angular.$q.when();
                            } else if (_angular.$rootScope[resultKey]) {
                                return handler(_angular.$rootScope[resultKey]);
                            } else if (_app.$PXPBlacklist.isMerchantBlacklisted($scope.payee.merchant.id)) {
                                // skip pxp and assume control
                                return handler();
                            } else if (experimentName === 'xo_hermesnodeweb_us_ryi_ppc_ppcacquisitionbanner_v2') {
                                // Bypass PXP call - force the winning treatment
                                return handler({ treatment_name: 'xo_hermesnodeweb_us_ryi_ppc_acq_treatment2' });
                            } else {
                                // Call PXP
                                return (0, _squid.$pxp)(experimentName, { 'ctx.COUNTRY': _squid.$locale.country }, pxpPattern, false, true).then(function (result) {
                                    _angular.$rootScope[resultKey] = result;
                                    return handler(result);
                                });
                            }
                        }
                    };

                    $scope.isRedirectingToInterstitial = false;
                    return _angular.$q.when().then(function () {
                        if ($scope.creditOfferModel && $scope.creditOfferModel.isRamped) {
                            // This means that we're getting our content from
                            // the new /message-recommendations API
                            if ($scope.creditOfferModel.hasInterstitialMessage() && !isTreatmentCapped(null, CREDIT_BANNER_DISPLAY_COUNT_MAX)) {
                                incrementTreatmentBannerDisplayedCount(CREDIT_BANNER_DISPLAY_COUNT_KEY);
                                return runPxpExperiment('xo_hermesnodeweb_us_ryi_ppc_ppcacquisition_interstitial', 'xo_hermesnodeweb_us_ryi_ppc_ppcacquisition_interstitial.*', 'creditInterstitialPXPResult', false, handleInterstitialTreatment);
                            }
                        } else if (shouldSetInterstitial()) {
                            return runPxpExperiment('xo_hermesnodeweb_us_ryi_ppc_ppcacquisition_interstitial', 'xo_hermesnodeweb_us_ryi_ppc_ppcacquisition_interstitial.*', 'creditInterstitialPXPResult', false, handleInterstitialTreatment);
                        }
                    }).then(function () {
                        return runPxpExperiment('xo_hermesnodeweb_us_ryi_ppc_ppcacquisitionbanner_v2', 'xo_hermesnodeweb_us_ryi_ppc_acq.*', 'creditBannerPXPResult', true, handleBannerTreatment);
                    });
                }).then(function () {
                    // Add all reuse banner experience here.
                    /**
                     * Returns true if the buyer has a installment plan to use for this payment.
                     * @returns boolean true if there is a installment plan(there can be other offers like sac with installments). false if not.
                     */
                    $scope.isEZP = function () {
                        return CREDIT_TYPE.EZP === getCreditType().creditType;
                    };

                    /**
                     * Only show PPC Reuse banner if:
                     * Country is US or UK & Credit is not default AND There is credit in wallet AND pxp variant has banner
                     **/
                    $scope.showReuseBanner = function () {
                        // FPTI tracking
                        if (!$scope.fptiTrigger && _squid.$locale.country === 'GB') {
                            if ($scope.showReuseBannerFlag) {
                                // UK reuse banner eligible for credit test group (will see banner)
                                _logger.$logger.info('checkout_fpti', {
                                    'banner_type': 'test_REUSE'
                                });
                                $scope.fptiTrigger = true;
                            } else {
                                // UK reuse banner eligible for credit control (will not see banner)
                                _logger.$logger.info('checkout_fpti', {
                                    'banner_type': 'control_REUSE'
                                });
                                $scope.fptiTrigger = true;
                            }
                        }

                        if (!$scope.usCreditBannerFptiFired && $scope.usReusePXPLoaded && $scope.buyerCountry === 'US') {
                            $scope.usCreditBannerFptiFired = true;

                            if ($scope.showReuseBannerFlag) {
                                if ($scope.ad) {
                                    _logger.$logger.info('checkout_fpti', {
                                        'banner_type': USE_CASE.REUSE + '_' + $scope.ad['MessageType'] + '_MORS',
                                        'caid': $scope.ad['campaignId']
                                    });
                                    _logger.$logger.info('MORS_ad_displayed_credit_' + USE_CASE.REUSE + '_' + $scope.ad['MessageType']);
                                    _marketingoffer.$fireMORSBeacon.fireBeacon($scope.ad.impressionUrl);
                                    _angular.$rootScope.$broadcast('MORSDisplayed', {
                                        clickUrl: $scope.ad.clickUrl,
                                        placementId: $scope.placementCode
                                    });
                                } else {
                                    _logger.$logger.info('checkout_fpti', {
                                        'banner_type': USE_CASE.REUSE + '_' + BANNER_TYPES.PASSIVE + '_MORSfallback'
                                    });
                                    _logger.$logger.info('MORS_fallback_ad_displayed_credit_' + USE_CASE.REUSE + '_' + BANNER_TYPES.PASSIVE);
                                }
                            } else {
                                _logger.$logger.info('checkout_fpti', { 'banner_type': 'reuse_banner_not_shown' });
                            }
                        }
                        return $scope.showReuseBannerFlag;
                    };

                    // The default plan is at different places in session for billing agreements without purchase and other use cases.
                    // for billing agreement without purchase, it is set at futurePayment.isCreditInWallet.
                    // for other usecases it is set at fundingOptions.plans.
                    var isCreditInWalletForBAWithoutPurchase = $scope.checkoutSession.get('futurePayment.isCreditInWallet');

                    // For billing agreement without purchase, show banner if the user has credit in wallet, but is not the sticky fi.
                    // for others, show banner if the use has credit in wallet and the default plan is not credit.
                    var creditInWalletButNotDefault = true;

                    if ($scope.isBillingNoPurchase) {
                        var stickyFi = $scope.checkoutSession.getSelectedStickyInstrument();

                        creditInWalletButNotDefault = isCreditInWalletForBAWithoutPurchase && !(stickyFi.type === 'BILL_ME_LATER');
                    } else {
                        $scope.isCreditDefault = $scope.checkoutSession.get('plan.paypal_credit');
                        creditInWalletButNotDefault = isCreditInWallet && !$scope.isCreditDefault;
                    }

                    $scope.showPPCLogo = true;
                    // Start by saying no to banner and update to true when necessary.
                    $scope.showReuseBannerFlag = false;
                    // This is used by reuse usecase as well as acq usecase.
                    $scope.installment.showCreditExample = $scope.showUKBanner && (creditInWalletButNotDefault || $scope.installment.showBanner || $scope.creditOffer);

                    // Early exits for use cases where re-use banners are not applicable.
                    // We only show reuse banners to GB and US users today.
                    if (_squid.$locale.country !== 'GB' && _squid.$locale.country !== 'US') {
                        return _angular.$q.when();
                    }

                    // We do not show banners for new members
                    if (hideBannerForNewMember) {
                        return _angular.$q.when();
                    }

                    if (_squid.$locale.country === 'GB') {
                        if (($scope.showUKBanner && !isRedirectFromCape || $scope.checkoutCart.isBillingNoPurchase()) && creditInWalletButNotDefault) {
                            $scope.reuseOfferTypeKey = $scope.installmentOptionsPresent && !$scope.checkoutCart.isBilling() ? 'offers.bmlExistingOfferInstallment' : $scope.isBmlOfferSmallOrLarge();
                            $scope.showReuseBannerFlag = true;
                        } else {
                            $scope.showReuseBannerFlag = false;
                        }
                        return _angular.$q.when();
                    } else if (_squid.$locale.country === 'US') {
                        var showBanner = false;

                        if (creditInWalletButNotDefault && !(isRedirectFromCape && isCreditInWallet)) {
                            showBanner = true;
                        }

                        showBanner = $scope.checkIfSelectFiDisplayedBanner(showBanner);
                        if (showBanner === true) {
                            // pxp for banner ramp in US
                            return (0, _squid.$pxp)('xo_hermesnodeweb_us_ryi_ppc_reuse_banner', { 'ctx.COUNTRY': _squid.$locale.country }, 'xo_hermesnodeweb_us_ryi_ppc_reuse_banner.*', false, true).then(function (result) {
                                $scope.usReusePXPLoaded = true;
                                if (result && result.treatment_name === 'xo_hermesnodeweb_us_ryi_ppc_reuse_banner_none') {
                                    $scope.showReuseBannerFlag = false;
                                } else {
                                    $scope.showReuseBannerFlag = true;
                                }
                                return _angular.$q.when();
                            });
                        } else {
                            $scope.showReuseBannerFlag = false;
                            return _angular.$q.when();
                        }
                    }
                }).then(function () {
                    $scope.selectExistingBml = function () {
                        if ($scope.ad) {
                            _marketingoffer.$fireMORSBeacon.fireBeacon($scope.ad.clickUrl);
                        }

                        if ($scope.isBillingNoPurchase) {
                            var fpList = $scope.checkoutSession.get('futurePaymentInstruments');
                            var bml = fpList.find(function (fp) {
                                return fp.type === 'BILL_ME_LATER';
                            });

                            return $scope.checkoutSession.action('setStickyFI', {
                                data: {
                                    instrument_id: bml.instrument_id
                                },
                                success: function success() {
                                    $scope.showReuseBannerFlag = false;
                                    $scope.checkoutSession.message = {
                                        type: 'success',
                                        msgKeys: ['paymentMethod.paymentMethodUpdated']
                                    };
                                    _uiRouter.$state.go('checkout.review');
                                }
                            });
                        } else {
                            var fiList = $scope.checkoutSession.get('fundingOptions.instruments');
                            var fundingSource = _squid.$util.find(fiList, function (fi) {
                                return fi.name === 'BILL_ME_LATER';
                            });

                            return $scope.checkoutSession.fundingOptions.action('select', {
                                resultModel: $scope.checkoutSession,
                                data: {
                                    planId: fundingSource.planId
                                },
                                success: function success(result) {
                                    $scope.showReuseBannerFlag = false;
                                    // Update selectedmethod if provided, to reflect in multipleFi on RYI choice variant
                                    if ($scope.selectedmethod) {
                                        $scope.selectedmethod.index = 0;
                                        $scope.selectedmethod.planId = $scope.checkoutSession.get('plan.sources')[0].id;
                                    }

                                    if (result) {
                                        // Update the installments to support the user selecting a card that does not support installments.
                                        $scope.checkoutSession.installments = result.installments;
                                    }
                                    if (fundingSource.type === 'CREDIT' && $scope.installment.showCYCO) {
                                        _uiRouter.$state.go('checkout.chooseCreditOffer');
                                    } else {
                                        if (!fundingSource.selected) {
                                            $scope.checkoutSession.message = {
                                                type: 'success',
                                                msgKeys: ['paymentMethod.paymentMethodUpdated']
                                            };
                                            if ($scope.checkoutSession.selectedInstallmentData && !$scope.checkoutSession.selectedInstallmentData.preventChange) {
                                                // Resetting selected installment data, if installment change is not explicitly prohibited.
                                                $scope.checkoutSession.selectedInstallmentData = undefined;
                                            }
                                        }
                                        _uiRouter.$state.go('checkout.review');
                                    }
                                }
                            });
                        }
                    };

                    $scope.getBmlOfferTitle = function (suffix, data) {
                        if ($scope.creditOfferIntensity === 1) {
                            return $scope.htmlContent('offers.bmlOfferLargeTitle' + suffix, data);
                        } else if ($scope.creditOfferIntensity === 2) {
                            return $scope.htmlContent('offers.bmlOfferSmallTitle' + suffix, data);
                        } else {
                            return '';
                        }
                    };

                    if ($scope.buyerCountry === 'US') {
                        $scope.bmlOfferTitle = $scope.getTransactionAmount() === 0 ? $scope.htmlContent('offers.bmlOfferTitleWithAmountZero') : $scope.getBmlOfferTitle('WithAmount', {
                            cartAmount: $scope.checkoutCart.get('purchase.amounts.total.amount_formatted', '')
                        });

                        // US766704: for use in xo-wallet
                        $scope.installment.bmlOfferTitle = $scope.bmlOfferTitle;
                    }

                    $scope.showAcquisitionBanner = function () {
                        var showBanner = void 0;

                        showBanner = $scope.showBml && $scope.buyerCountry !== 'GB';

                        // Combine acquisition banner and installment banner logic
                        // TODO: Refactor all of this after control is removed - there needs to be clear separation between
                        // countries, and installment acquisition banner logic should be in this function
                        showBanner = showBanner || $scope.installment.showBanner;
                        showBanner = hideBannerForNewMember ? false : $scope.checkIfSelectFiDisplayedBanner(showBanner);

                        if ($scope.installment.showPPCAcquisitionRadioButton && !$scope.radio) {
                            showBanner = false;
                        }

                        if (!$scope.usCreditBannerFptiFired && showBanner && $scope.banner && $scope.buyerCountry === 'US') {
                            $scope.usCreditBannerFptiFired = true;

                            if ($scope.ad) {
                                _logger.$logger.info('checkout_fpti', {
                                    'banner_type': USE_CASE.ACQUISITION + '_' + $scope.ad['MessageType'] + '_MORS',
                                    'caid': $scope.ad['campaignId']
                                });
                                _logger.$logger.info('MORS_ad_displayed_credit_' + USE_CASE.ACQUISITION + '_' + $scope.ad['MessageType']);
                                _marketingoffer.$fireMORSBeacon.fireBeacon($scope.ad.impressionUrl);
                                _angular.$rootScope.$broadcast('MORSDisplayed', {
                                    clickUrl: $scope.ad.clickUrl,
                                    placementId: $scope.placementCode
                                });
                            } else {
                                _logger.$logger.info('checkout_fpti', {
                                    'banner_type': USE_CASE.ACQUISITION + '_' + BANNER_TYPES.PASSIVE + '_MORSfallback'
                                });
                                _logger.$logger.info('MORS_fallback_ad_displayed_credit_' + USE_CASE.ACQUISITION + '_' + BANNER_TYPES.PASSIVE);
                            }
                        }

                        return showBanner;
                    };

                    $scope.bml = function () {
                        if ($scope.ad) {
                            _marketingoffer.$fireMORSBeacon.fireBeacon($scope.ad.clickUrl);
                        }

                        if ($scope.installment.showBanner && (!bypassGbCycoTreatment || // Control
                        bypassGbCycoTreatment && $scope.installmentOptionsPresent // Treatment
                        )) {
                            _uiRouter.$state.go('checkout.chooseCreditOffer');
                        } else {
                            _uiRouter.$state.go('checkout.redirectToCape', {}, { location: false });
                        }
                    };

                    $scope.addPlcc = function () {
                        $scope.promotion.type = 'plcc';
                        _uiRouter.$state.go('checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard');
                    };

                    $scope.showPlcc = $scope.checkoutSession.plccOffer;
                }).then(function () {
                    // we only show the xo-offer-top-banner in certain scenarios
                    // based on pxp: xo_hermesnodeweb_us_ryi_ppc_ppcacquisitionbanner_v2
                    if ([3, 4, 5].indexOf($scope.creditBannerTreatment) > -1) {
                        // we listen for the following $emit() call in:
                        // xo-credit-components/src/xo-offer-top-banner/directive.js
                        _angular.$rootScope.$emit('setOfferTopBanner', {
                            creditBannerTreatment: $scope.creditBannerTreatment,
                            banner: $scope.banner,
                            bml: $scope.bml
                        });
                    }
                    if (!$scope.fptiCreditBannerTrigger && $scope.buyerCountry === 'US' && ($scope.showReuseBanner() || $scope.showAcquisitionBanner())) {

                        $scope.fptiCreditBannerTrigger = true;
                        var isBalanceCoveringPurchase = false;

                        if (!$scope.isBillingNoPurchase) {
                            var plans = $scope.checkoutSession.get('fundingOptions.plans');

                            isBalanceCoveringPurchase = _squid.$util.find(plans, function (fi) {
                                return fi && fi.primaryFs && !fi.secondaryFIs && fi.primaryFs.name === 'BALANCE';
                            });
                        }

                        var fundingInstruments = void 0;

                        if ($scope.isBillingNoPurchase) {
                            fundingInstruments = $scope.checkoutSession.get('futurePaymentInstruments');
                        } else {
                            fundingInstruments = $scope.checkoutSession.get('fundingOptions.instruments');
                        }
                        // here we are calculating the number of FIs that are applicable for this transaction.
                        // Balance counts as a standalone FI only if it covers the full txn amount.
                        var fiApplicableForThisTransaction = 0;

                        if (fundingInstruments && fundingInstruments.length > 0) {
                            fundingInstruments.forEach(function (fundingOption, index) {
                                if (fundingOption.type !== 'BALANCE' || isBalanceCoveringPurchase) {
                                    fiApplicableForThisTransaction++;
                                }
                            });
                        }
                        var userAction = $scope.checkoutAppData.useraction();
                        var noLineItemDetails = !(userAction && userAction.toLowerCase() === 'commit') && $scope.checkoutCart.get('purchase.items.length', 0) <= 0;

                        (0, _pxp.$pxpCartAmt)($scope.checkoutAppData.get('merchant.merchant_country'), $scope.payee.get('merchant.id'), noLineItemDetails, $scope.checkoutCart.isPurchase()).then(function (showAmount) {
                            if ($scope.creditOfferModel && $scope.creditOfferModel.isRamped) {
                                var BannerMessage = Object.assign({}, $scope.recommendedMessage, { CartAmountVisible: showAmount }, { NumberOfFIs: fiApplicableForThisTransaction });

                                _logger.$logger.info('checkout_fpti', buildCreditOfferFptiObject(BannerMessage));
                                _logger.$logger.createCalRootTxn(buildPSMonitoringObject(BannerMessage, discoverMessageError), 'hermes_personalization');
                            } else {
                                _logger.$logger.info('checkout_fpti', {
                                    'cart_show_amt': showAmount,
                                    'funding_options_instruments': fiApplicableForThisTransaction
                                });
                            }
                        });
                    }
                });
            };

            renderBanner();
            $scope.$watch('checkoutCart.grossTotalAmount', function () {
                var newVal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var oldVal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                if (!newVal.value || !oldVal.value || !newVal.currency || !oldVal.currency) {
                    return;
                }

                var hasNewValue = newVal.value !== oldVal.value;
                var hasNewCurrency = newVal.currency !== oldVal.currency;

                if (hasNewValue || hasNewCurrency) {
                    return renderBanner();
                }
            }, true);
        }]
    };
});

_uiRouter.$state;

_angular.$q;

_angular.$rootScope;

_logger.$logger;

_squid.$config;

_squid.$feature;

_squid.$locale;

_squid.$populate;

_squid.$pxp;

_squid.$util;

_index.$DeviceInfo;

_xoMORSCreditBannerUtils.$xoMORSCreditBannerUtils;

_app.$PXPBlacklist;

_auth.$AuthModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutCartModel;

_index2.$CreditOptionsModel;

_index2.$CheckoutPayeeModel;

_index2.$CheckoutSessionModel;

_pxp.$pxpCartAmt;

_marketingoffer.$MarketingOfferModel;

_marketingoffer.$CreditOfferModel;

_marketingoffer.$fireMORSBeacon;

_index3.$CreditInstallmentModel;

_index3.$CreditDataModel;

_index3.$CreditInstallmentOptionsModel;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/offer/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"offerForm\" action=\"#\" method=\"POST\" class=\"offer\"  content>\n\n    <input type=\"hidden\" id=\"bmlMessageId\" value=\"{{banner.messageId}}\"/>\n\n    <div id=\"bmlReuseOfferInfo\" ng-if=\"reusetext\">\n        <span class=\"offerInfo ng-binding ng-scope\" ng-bind-html=\"reuseOfferInfo.bodyText\"></span>\n        <span class=\"seeTermsLink ng-scope\">\n            <a href='{{reuseOfferInfo.termsLink}}'\n               class='popup bmlTermsLink' target='_blank'\n               xo-popup>{{reuseOfferInfo.termsLinkText}}</a>\n        </span>\n        <span ng-if=\"isEZP()\" class=\"bmlChangeLink\">\n            <a track-link=\"reuse_offer_banner_MORS\" link-button ng-click=\"selectExistingBml()\" class=\"proceed\"\n                ng-bind-html=\"banner.ctaText\"></a>\n        </span>\n    </div>\n\n    <div ng-if=\"!reusetext\">\n\n        <!-- US banners -->\n\n        <div ng-if=\"buyerCountry === 'US'\">\n\n            <!-- Acquisition radio button -->\n            <div id=\"bmlAcqOfferRadio\" class=\"payWithOption radioBanner passiveBanner creditBanner\"\n                 ng-if=\"showPPCAcquisitionRadioButton && banner.bodyText && showAcquisitionBanner()\">\n                <div class=\"payWithOptionBody\">\n                    <div class=\"payWithOptionIcon\" track-link=\"acquisition_offer_banner_MORS\" role=\"button\">\n                        <span class=\"fsIcon BILL_ME_LATER\" ng-if=\"useFallbackBanner\"></span>\n                        <img ng-src=\"{{banner.logo}}\" ng-if=\"!useFallbackBanner\" alt=\"{{htmlContent('paymentMethod.billmelater')}}\" />\n                    </div>\n                    <div class=\"payWithOptionContent\">\n                        <!-- TODO If this treatment is the winner, integrate Cta content with MORS instead of hard coding -->\n                        <div><span class=\"name proceed\" ng-bind-html=\"htmlContent('offers.bmlOfferPassiveCta')\"></span></div>\n                        <div><span class=\"payWithOptionDetails\" ng-bind-html=\"banner.bodyText\"></span></div>\n                        <div>\n                            <span class=\"payWithOptionTerms\" ng-bind-html=\"banner.termsText\"></span>\n                            <a href=\"{{banner.termsLink}}\"\n                               class=\"popup payWithOptionTermsLink\"\n                               target='_blank'\n                               ng-bind-html=\"banner.termsLinkText\"\n                               track-link=\"acquisition_offer_banner_MORS_terms_link\"></a>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <!-- Acquisition passive banner -->\n            <div id=\"bmlAcqOfferPassive\" class=\"payWithOption passiveBanner creditBanner\"\n                 ng-if=\"showPassiveBanner && banner.bodyText && showAcquisitionBanner()\">\n                <span class=\"plusicon\" ng-click=\"bml()\" track-link=\"acquisition_offer_banner_MORS\" role=\"button\" tabindex=\"-1\"></span>\n                <div class=\"payWithOptionBody\">\n                    <div class=\"payWithOptionIcon\" ng-click=\"bml()\" track-link=\"acquisition_offer_banner_MORS\" role=\"button\" tabindex=\"-1\">\n                        <span class=\"fsIcon BILL_ME_LATER\" ng-if=\"useFallbackBanner\"></span>\n                        <img ng-src=\"{{banner.logo}}\" ng-if=\"!useFallbackBanner\" alt=\"{{htmlContent('paymentMethod.billmelater')}}\" />\n                    </div>\n                    <div class=\"payWithOptionContent\">\n                        <div><a href=\"#\" ng-click=\"bml()\" class=\"name proceed\" ng-bind-html=\"banner.ctaText\" track-link=\"acquisition_offer_banner_MORS\"></a></div>\n                        <div><span class=\"payWithOptionDetails\" ng-bind-html=\"banner.bodyText\"></span></div>\n                        <div>\n                            <span class=\"payWithOptionTerms\" ng-bind-html=\"banner.termsText\"></span>\n                            <a href=\"{{banner.termsLink}}\"\n                               class=\"popup payWithOptionTermsLink\"\n                               target='_blank'\n                               ng-bind-html=\"banner.termsLinkText\"\n                               track-link=\"acquisition_offer_banner_MORS_terms_link\"></a>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <!-- Acquisition prominent banner -->\n            <div id=\"bmlAcqOfferProminent\" class=\"prominentBanner creditBanner\" ng-if=\"!showPassiveBanner &&\n            (showCreditBannerControl || showPPCAcquisitionGradientBanner) && banner.bodyText && showAcquisitionBanner()\">\n                <div class=\"prominentBannerSeparator\" ng-if=\"!isNewMember()\">\n                    <span class=\"prominentBannerSeparatorLine\"></span>\n                    <span class=\"prominentBannerSeparatorWord\" ng-bind-html=\"htmlContent('offers.or')\"></span>\n                </div>\n                <div ng-class=\"{'bmlCtaWrap': true, 'purpleBlueGradient': showPPCAcquisitionGradientBanner}\">\n                    <span class=\"bmlApplyLink\">\n                        <a href=\"#\" ng-click=\"bml()\" class=\"proceed\" ng-bind-html=\"banner.ctaText\" track-link=\"acquisition_offer_banner_MORS\"></a>\n                    </span>\n                    <div class=\"acquisitionBannerLeft\">\n                        <div class=\"prominentBannerIcon\">\n                            <span class=\"creditIcon\" ng-if=\"useFallbackBanner\"></span>\n                            <img ng-src=\"{{banner.logo}}\" ng-if=\"!useFallbackBanner\" alt=\"{{htmlContent('paymentMethod.billmelater')}}\"/>\n                        </div>\n                    </div>\n                    <div class=\"acquisitionBannerRight\">\n                        <p class=\"bmlOfferTitle\" ng-class=\"{'strongBmlOfferTitle': showIncentiveBanner}\" ng-bind-html=\"banner.bodyText\"></p>\n                        <p id=\"bmlOfferTitleSecRow\" ng-if=\"showIncentiveBanner\" class=\"bmlOfferTitle\" ng-bind-html=\"banner.bodyText2\"></p>\n                        <p class=\"bmlSeeTerms offerSmallText\">\n                            <span class=\"seeTermsLink ng-scope\" ng-bind-html=\"banner.termsText\"></span>\n                            <a href='{{banner.termsLink}}'\n                                class='popup bmlTermsLink'\n                                target='_blank'\n                                ng-bind-html=\"banner.termsLinkText\"\n                                track-link=\"acquisition_offer_banner_MORS_terms_link\"\n                                xo-popup></a>\n                        </p>\n                    </div>\n                    <div class=\"clearfix\"></div>\n                </div>\n            </div>\n\n            <!-- Reuse banner (always prominent) -->\n            <div id=\"bmlExistingOfferProminent\" class=\"prominentBanner creditBanner\" ng-if=\"banner.bodyText && showReuseBanner()\">\n                <div class=\"prominentBannerSeparator\">\n                    <span class=\"prominentBannerSeparatorLine\"></span>\n                    <span class=\"prominentBannerSeparatorWord\" ng-bind-html=\"htmlContent('offers.or')\"></span>\n                </div>\n                <div class=\"bmlCtaWrap\">\n                    <div class=\"prominentBannerIcon\">\n                        <span class=\"creditIcon\" ng-if=\"useFallbackBanner\"></span>\n                        <img ng-src=\"{{banner.logo}}\" ng-if=\"!useFallbackBanner\" alt=\"{{htmlContent('paymentMethod.billmelater')}}\" />\n                    </div>\n                    <span class=\"bmlChangeLink bmlChangeLinkInBanner\">\n                        <a track-link=\"reuse_offer_banner_MORS\" link-button ng-click=\"selectExistingBml()\" class=\"proceed\"\n                           ng-bind-html=\"banner.ctaText\"></a>\n                    </span>\n                    <p class=\"bmlExistingOfferTitle\" ng-bind-html=\"banner.bodyText\"></p>\n\n                    <p class=\"bmlSeeTerms offerSmallText\">\n                        <span class=\"clearfix bmlExistingOfferText\"\n                              ng-bind-html=\"banner.bodyText2\"></span>\n                        <span class=\"seeTermsLink ng-scope\">\n                            <a href='{{creditReuseTerms}}'\n                               class='popup bmlTermsLink'\n                               target='_blank'\n                               ng-bind-html=\"banner.termsLinkText\"\n                               track-link=\"reuse_offer_banner_MORS_terms_link\"\n                               xo-popup></a>\n                        </span>\n                    </p>\n                </div>\n            </div>\n        </div>\n\n        <!-- // End US banners -->\n\n        <!-- UK banners -->\n\n        <div ng-if=\"buyerCountry === 'GB'\">\n\n            <div id=\"installmentOffer\" class=\"bmlCtaWrap prominentBanner creditBanner purpleBannerUK\"\n                 ng-if=\"installment.showBanner && !showPPCAcquisitionRadioButton\">\n                <div class=\"trayInner\">\n                    <div class=\"acquisitionBannerLeft\">\n                        <div class=\"prominentBannerIcon\">\n                            <img ng-src=\"https://www.paypalobjects.com/webstatic/credit/img/pp_credit_logo_white@2x.png\" alt=\"{{htmlContent('paymentMethod.billmelater')}}\" />\n                        </div>\n                    </div>\n                    <div class=\"clearfix\"></div>\n                    <span track-click=\"acquisition_offer_banner\" class=\"cycoApplyLink proceed apply_uk_credit\" ng-click=\"bml()\">{{content('offers.bmlOfferBtn')}}</span>\n                    <div class=\"offerText\">\n                        <p ng-if=\"offerTypeKey\"\n                            ng-bind-html=\"htmlContent(offerTypeKey,{monthlyPayment: creditOffers.installment_options[installmentCount -1].monthlyPayment.formattedAmt, term:creditOffers.installment_options[installmentCount -1].term,\n                        cartAmount:checkoutCart.get('purchase.amounts.total.amount_formatted')})\"></p>\n                        <p ng-if=\"!offerTypeKey || checkoutCart.isBilling()\"\n                            ng-bind-html=\"htmlContent('offers.bmlOfferNoCart')\"></p>\n                    </div>\n                </div>\n            </div>\n\n            <!-- Reuse banner -->\n            <div id=\"bmlExistingOffer\" class=\"bmlCtaWrap prominentBanner creditBanner\" ng-if=\"showReuseBanner()\">\n                <div class=\"trayInner\">\n                    <div class=\"creditIcon\"/>\n                    <p class=\"bmlExistingOfferTitle\" ng-bind-html=\"htmlContent('offers.bmlExistingOfferTitle')\"></p>\n\n                    <span class=\"bmlChangeLink bmlChangeLinkInBanner\">\n                        <a track-link=\"reuse_offer_banner\" link-button ng-click=\"selectExistingBml()\" class=\"proceed\">{{content('offers.select')}}</a>\n                    </span>\n\n                    <p class=\"bmlSeeTerms offerSmallText\">\n                        <span class=\"clearfix bmlExistingOfferText\"\n                              ng-bind-html=\"htmlContent(reuseOfferTypeKey,{monthlyPayment: creditOffers.installment_options[installmentCount -1].monthlyPayment.formattedAmt, term:creditOffers.installment_options[installmentCount -1].term})\"></span>\n                    </p>\n\n                </div>\n            </div>\n        </div>\n\n        <!-- // End UK banners -->\n\n        <div id=\"plccOffer\" class=\"bmlCtaWrap\" ng-if=\"showPlcc\">\n            <div class=\"trayInner\">\n                <div class=\"plccOfferHeader\">\n                    <img class=\"plccIcon\" ng-src=\"{{promotion.logoUrl}}\"/>\n                    <p class=\"headerText\"> {{ content('offers.plccCardOfferHeader',{ merchantName:promotion.name}) }}</p>\n                    <span class=\"plccAddNowLink\">\n                        <a link-button ng-click=\"addPlcc()\" class=\"proceed\">{{content('offers.plccAddNowLink')}}</a>\n                    </span>\n                    <p class=\"plccOfferDesc\">{{ content('offers.plccCardOfferDesc',{merchantName:promotion.name}) }}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/offer/xo-credit-example-uk/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/offer/xo-credit-example-uk/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-credit-components/src/offer/xo-credit-example-uk/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCreditExampleUkDirective', {
    tag: 'xo-credit-example-uk',
    template: _template2['default'],
    resolve: {
        experiments: function experiments() {
            return (0, _squid.$pxp)('xo_hermesnodeweb_gb_ppc_acquisitionbanner', { 'ctx.COUNTRY': _squid.$locale.country }, 'xo_hermesnodeweb_gb_ppc_representative_example_treatment1', false, true).then(function (result) {
                var treatmentName = result && result.treatment_name;

                _logger.$logger.info('checkout_fpti', { 'xo_hermesnodeweb_gb_ppc_acquisitionbanner': treatmentName ? 'xo_hermesnodeweb_gb_ppc_representative_example_treatment1' : 'xo_hermesnodeweb_gb_ppc_representative_example_control' });
                return {
                    representativeExampleTreatment: treatmentName || false
                };
            })['catch'](_angular.noop);
        }
    },
    lifecycle: {
        populate: function populate() {
            // populate the representative example treatemnt
            if (this.experiments.representativeExampleTreatment) {
                this.representativeExampleTreatment = this.experiments.representativeExampleTreatment;
            }
        }
    }
});


_angular.noop;

_logger.$logger;

_squid.$Component;

_squid.$pxp;

_squid.$locale;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-credit-components/src/offer/xo-credit-example-uk/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-credit-components/src/offer/xo-credit-example-uk/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"xoCreditExampleUk\" action=\"#\" method=\"POST\" content>\n    <div ng-class=\"{'representativeExampleTreatment': representativeExampleTreatment}\">\n    <p class=\"disclaimer reviewMsg bmlLender\">{{content('chooseCreditOption.representativeEx')}}</p>\n    <p class=\"disclaimer reviewMsg bmlLender\">{{content('chooseCreditOption.representativeExHeader')}}</p>\n    <table class=\"trayInner trayInnerDefault representativeEx row-fluid\">\n        <tr class=\"span6\">\n            <td class=\"representativeExKey\">{{content('chooseCreditOption.purchaseRate')}}</td>\n            <td class=\"representativeExampleAPRAmount\">{{content('chooseCreditOption.purchaseRateValue')}}</td>\n        </tr>\n        <tr class=\"span6\">\n            <td class=\"representativeExKey\">{{content('chooseCreditOption.representativeAPR')}}</td>\n            <td class=\"representativeExampleAPRAmount\">{{content('chooseCreditOption.representativeAPRValue')}}</td>\n        </tr>\n        <tr class=\"span6 last\">\n            <td class=\"representativeExKey\">{{content('chooseCreditOption.exCreditLimit')}}</td>\n            <td class=\"representativeExampleAPRAmount\">{{content('chooseCreditOption.exCreditLimitValue')}}</td>\n        </tr>\n    </table>\n    <p class=\"disclaimer reviewMsg bmlLender\">{{content('chooseCreditOption.terms')}}</p>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/pay-with-credit/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/pay-with-credit/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoPayWithCredit', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            token: '=?',
            doneFn: '=?'
        },
        controller: ['$scope', function ($scope) {
            var stateName = 'gce_pay_with_credit';

            (0, _squid.$populate)($scope, {
                checkoutCart: _index.$CheckoutCartModel.instance($scope.token),
                checkoutSession: _index.$CheckoutSessionModel.instance($scope.token)
            }).then(function () {
                // For US and GB if txn amount is >= 99 or 150 resp show pay with credit option if credit in
                // wallet and is not the current funding option

                // required to avoid looging every digest cycle.
                // TODO: remove this when debounce is fixed for logger
                var offerShown = false;

                $scope.showPayWithCredit = function () {
                    if (!$scope.checkoutCart.get('purchase.amounts.total.amount')) {
                        offerShown = false;
                        return false;
                    }

                    var amount = parseFloat($scope.checkoutCart.purchase.amounts.total.amount);
                    var minAmount = _angular.$window.config.minCreditAmtNoInterest[_squid.$locale.country];
                    var hasCredit = $scope.checkoutSession.fundingOptions.hasCredit();
                    var fundingSource = $scope.checkoutSession.plan.sources;
                    var showOffer = _squid.$config.features.DEFAULT.showPayWithCreditOffer && !$scope.checkoutSession.plccOffer;

                    if (showOffer && minAmount && amount >= minAmount && hasCredit) {
                        for (var i in fundingSource) {
                            if (fundingSource[i].type === 'BILL_ME_LATER') {
                                offerShown = false;
                                return false;
                            }
                        }
                        if (!offerShown) {
                            _logger.$logger.info(stateName + '_offer_shown');
                        }
                        offerShown = true;
                        return true;
                    }
                    offerShown = false;
                    return false;
                };

                $scope.onSubmit = function () {
                    _logger.$logger.info(stateName + '_offer_clicked');
                    $scope.checkoutSession.message = null;

                    var instruments = $scope.checkoutSession && $scope.checkoutSession.fundingOptions && $scope.checkoutSession.fundingOptions.instruments;
                    var creditPlanId = void 0;

                    for (var i in instruments) {
                        if (instruments[i].type === 'CREDIT' && instruments[i].name === 'BILL_ME_LATER') {
                            creditPlanId = instruments[i].planId;
                        }
                    }

                    if (!creditPlanId) {
                        _logger.$logger.info(stateName + '_credit_planid_not_found');
                        return;
                    }

                    return $scope.checkoutSession.fundingOptions.action('select', {
                        resultModel: $scope.checkoutSession,
                        data: {
                            planId: creditPlanId
                        },
                        success: function success() {
                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['paymentMethod.paymentMethodUpdated']
                            };
                            _logger.$logger.info(stateName + '_success');
                        }
                    });
                };
            });
        }]
    };
});

_angular.$window;

_logger.$logger;

_squid.$config;

_squid.$locale;

_squid.$populate;

_index.$CheckoutCartModel;

_index.$CheckoutSessionModel;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/pay-with-credit/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"pay-with-credit\" class=\"bmlCtaWrap\" ng-if=\"showPayWithCredit()\" content>\n    <div class=\"trayInner trayInnerDefault\">\n        <div class=\"decreasedWidth noBottom\">\n            <p>{{ content('memberReview.switchToBml') }}</p>\n            <span class=\"disclaimer\" bind-html-compile=\"htmlContent('offers.seeBmlTerms')\"></span>\n        </div>\n        <a href=\"\" track-submit class=\"button-as-link edits\" ng-click=\"onSubmit()\">{{ content('common.select') }}</a>\n    </div>\n</div>\t"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/redirect-to-cape/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/redirect-to-cape/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoRedirectToCapeDirective', {
    tag: 'xo-redirect-to-cape',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutAppData: _index3.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                auth: _auth.$AuthModel.instance().retrieve()['catch'](_angular.noop),
                checkoutCart: _index3.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutPayee: _index3.$CheckoutPayeeModel.instance(this.props.token).retrieve()['catch'](_angular.noop)
            };
        },
        experiments: function experiments() {
            return (0, _squid.$pxp)('xo_hermesnodeweb_ppc_cyco_force_locale', { 'ctx.COUNTRY': _squid.$locale.country }, 'xo_hermesnodeweb_ppc_cyco_force_locale_treatment', false, true).then(function (res) {
                var treatmentName = res && res.treatment_name;

                _logger.$logger.info('checkout_fpti', {
                    'xo_hermesnodeweb_ppc_cyco_force_locale': treatmentName ? 'xo_hermesnodeweb_ppc_cyco_force_locale_treatment' : 'xo_hermesnodeweb_ppc_cyco_force_control'
                });
                return {
                    cycoOverrideLocaleTreatment: treatmentName || false
                };
            })['catch'](_angular.noop);
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this = this;

            // eslint-disable-line max-statements
            var navigation = window.performance && window.performance.navigation || {};

            if (navigation.type === 2) {
                _logger.$logger.info('CAPE_redirect_on_history_traversal');
            }
            function getMORSCreditIncentiveCampaign(MORSCampaigns) {
                var creditIncentiveCampaign = null;

                Object.keys(MORSCampaigns).forEach(function (key) {
                    // A "credit incentive" campaign is one that contains
                    // the "incentiveOfferProgramId" property
                    if (MORSCampaigns[key] && MORSCampaigns[key].hasOwnProperty('incentiveOfferProgramId')) {
                        creditIncentiveCampaign = MORSCampaigns[key];
                    }
                });
                return creditIncentiveCampaign;
            }

            function createAuditData(creditIncentiveCampaign) {
                // As per credit.CommonComponentsSpecification/v2/credit_incentive_offer_info.json
                // specification
                var messages = [{
                    'credit_incentive_offer_descriptor': 'PID-' + creditIncentiveCampaign.placementCode,
                    'credit_incentive_offer_value': creditIncentiveCampaign.buyItemId
                }];

                // If there is an incentiveOfferProgramCode that comes back from MORS,
                // add it to the list of messages
                // (In addition to the PID-<placementCode> item)

                if (creditIncentiveCampaign.incentiveOfferProgramCode) {
                    messages.push({
                        'credit_incentive_offer_descriptor': 'incentive_offer_program_code',
                        'credit_incentive_offer_value': creditIncentiveCampaign.incentiveOfferProgramCode
                    });
                }

                return {
                    'credit_incentive_offer_messages': messages
                };
            }

            function createCreditIncentiveContextData(creditIncentiveCampaign) {
                return {
                    incentive_offer_program_id: creditIncentiveCampaign.incentiveOfferProgramId,
                    incentive_offer_value: creditIncentiveCampaign.incentiveOfferValue,
                    incentive_offer_currency_code: creditIncentiveCampaign.incentiveOfferCurrencyCode,
                    offer_text_1: creditIncentiveCampaign.OfferText1,
                    offer_text_2: creditIncentiveCampaign.OfferText2,
                    terms_link: creditIncentiveCampaign.TermsLink,
                    terms_link_text: creditIncentiveCampaign.TermsLinkText,
                    terms_text: creditIncentiveCampaign.TermsText,
                    buy_item_id: creditIncentiveCampaign.buyItemId,
                    audit_data: createAuditData(creditIncentiveCampaign)
                };
            }

            this.creditDataModel = _index2.$CreditDataModel.instance(this.props.token);
            var url = 'https://' + window.location.host + _squid.$config.urls.baseUrl;
            var returnUrl = _squid.$util.buildURL(url, { token: this.props.token });
            var transactionType = this.models.checkoutAppData.is_second_button_txn ? 'SECOND_BUTTON' : 'HERMES';
            var isSignupFlow = this.models.auth.logged_in ? 'false' : 'true';
            var isRP = this.models.checkoutCart.get('billing.type') === 'RECURRING_PAYMENTS';
            var trafficSourceContent = '';
            var pageContext = 'Full-context';
            var flow = this.models.checkoutAppData.is_second_button_txn ? 'CHECKOUT_CREDIT_BUTTON' : 'CHECKOUT';

            if (_angular.$rootScope.miniBrowser) {
                pageContext = 'Mb-context';
            } else if (_angular.$rootScope.isIFrame) {
                pageContext = 'In-context';
            }

            if (this.models.checkoutCart.isBillingNoPurchase()) {
                if (isRP) {
                    trafficSourceContent = 'BA_RP_WITHOUT_PURCHASE';
                } else {
                    trafficSourceContent = 'BA_RT_WITHOUT_PURCHASE';
                }
            } else if (this.models.checkoutCart.isBillingPurchase()) {
                if (isRP) {
                    trafficSourceContent = 'BA_RP_WITH_PURCHASE';
                } else {
                    trafficSourceContent = 'BA_RT_WITH_PURCHASE';
                }
            }

            var capeData = {
                'flow_attributes': {
                    'channel': _index.$DeviceInfo.isMobile() ? 'MOBILE' : 'WEB',
                    'flow': flow,
                    'primary_actor': 'PAYPAL',
                    'tracking_id': this.props.token,
                    'business_case_variation': transactionType,
                    'credit_application_traffic_source': trafficSourceContent
                },
                'locale': _squid.$locale.lang + '_' + _squid.$locale.country,
                'cart_id': this.props.token,
                'fraudnet_id': this.props.token,
                'context-type': pageContext,
                'cal_correlation_id': _model.$CalDataModel.getCalCorrId(),
                'return_uris': {
                    'normal_return_uri': returnUrl + '&success=true',
                    'system_error_uri': returnUrl + '&success=false&isInternalServiceError=true',
                    'return_to_login_uri': returnUrl,
                    'full_pay_uri': this.models.auth.logged_in ? returnUrl + '&success=false' : undefined,
                    'cancel_uri': this.models.checkoutAppData.urls.cancel_url,
                    'change_installments_uri': returnUrl + '&changeStatus=changeInstallment&creditSignup=' + isSignupFlow
                }
            };

            if (this.$root.MORS) {
                // There are MORS campaigns
                // Check to see if there are any "credit incentive" campaigns
                // which we need to notify CAPE of
                var creditIncentiveCampaign = getMORSCreditIncentiveCampaign(this.$root.MORS);

                if (creditIncentiveCampaign) {
                    capeData.credit_incentive = createCreditIncentiveContextData(creditIncentiveCampaign);
                }
            }

            var data = {
                creditData: capeData,
                newUserSignup: isSignupFlow
            };

            return this.creditDataModel.action('createCreditKey', {
                data: data,
                success: function success(res) {
                    var merchantCountry = _this.models.checkoutAppData.get('merchant.merchant_country');
                    var useMerchantCountry = false;

                    // For 2nd button and non-logged-in users -
                    // use the merchant_country as the flow when redirecting to CAPE
                    if (_this.experiments.cycoOverrideLocaleTreatment && !_this.models.auth.logged_in && _this.models.checkoutAppData.is_second_button_txn) {
                        // If merchant country is unsupported, fallback to the buyer country (which in turn falls back to US)
                        if (!merchantCountry || _squid.$config.creditEligibleCountries.indexOf(merchantCountry) === -1) {
                            _logger.$logger.info('CAPE_use_buyer_country=' + _squid.$locale.country + ', for_locale_country=' + _squid.$locale.country + ', for_locale_lang=' + _squid.$locale.lang);
                        } else {
                            useMerchantCountry = true;
                            _logger.$logger.info('CAPE_use_merchant_country=' + merchantCountry + ', for_locale_country=' + _squid.$locale.country + ', for_locale_lang=' + _squid.$locale.lang);
                        }
                    }

                    var capeUrl = (0, _squid.$feature)('capeUrl', undefined, useMerchantCountry && merchantCountry) + res.capeKey + '&token=' + _this.props.token;

                    if (_this.creditDataModel.isChangeStatus()) {
                        capeUrl += '&status=changeInstallment';
                    }
                    _this.creditDataModel.setCapeRedirectUri(capeUrl);

                    var purchaseUnits = _this.models.checkoutCart && _this.models.checkoutCart.purchaseUnits;
                    var purchaseUnit = _angular2['default'].isArray(purchaseUnits) && purchaseUnits[0];
                    var currency = purchaseUnit && purchaseUnit.amount && purchaseUnit.amount.currency;

                    _logger.$logger.info('CAPE_locale_logging', {
                        brand_name: _this.models.checkoutAppData.get('merchant.brand_name'),
                        merchant_id: _this.models.checkoutPayee.getId(),
                        merchant_country: merchantCountry,
                        merchant_locale: _this.models.checkoutAppData.get('merchant.merchant_locale'),
                        merchant_display_id: _this.models.checkoutAppData.get('merchant.merchant_display_id'),
                        currency: currency,
                        user_locale: _squid.$locale.getLocaleCode()
                    });

                    _squid.$util.redirect(capeUrl);
                }
            });
        }
    }
});


_logger.$logger;

_auth.$AuthModel;

_model.$CalDataModel;

_index.$DeviceInfo;

_index2.$CreditDataModel;

_squid.$Component;

_squid.$util;

_squid.$config;

_squid.$locale;

_squid.$feature;

_squid.$pxp;

_index3.$CheckoutAppDataModel;

_index3.$CheckoutCartModel;

_index3.$CheckoutPayeeModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-credit-components/src/redirect-to-cape/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$RedirectToCapeRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-credit-components/src/redirect-to-cape/directive.js");

var $RedirectToCapeRoute = exports.$RedirectToCapeRoute = _squid.$ComponentRoute.extend('$RedirectToCapeRoute', {
    path: 'redirectToCape',
    directive: 'xo-redirect-to-cape',
    titleContent: 'redirectToCape',
    trackingData: {
        fptiState: 'redirect-to-cape',
        buzname: {
            'fullpage': {
                'pagename': '%::redirect-to-cape',
                'pagename2': '%::redirect-to-cape:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    loginRequired: true,
    auth: false,
    children: []
});

angular.value("$RedirectToCapeRoute", $RedirectToCapeRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/redirect-to-cape/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"capeRedirect\">\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-offer-top-banner/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/xo-offer-top-banner/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoOfferTopBanner', {
    tag: 'xo-offer-top-banner',
    template: _template2['default'],
    controller: ['$scope', function ($scope) {
        $scope.isTopBannerVisible = false;
        $scope.offerTopBanner = {};

        // this data comes from an $emit() call in:
        // xo-credit-components/src/offer/directive.js
        var unbind = _angular.$rootScope.$on('setOfferTopBanner', function (event, data) {
            $scope.offerTopBanner = data;
            $scope.isTopBannerVisible = true;
        });

        $scope.$on('$destroy', unbind);
    }]
});


_squid.$Component;

_angular.$rootScope;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-offer-top-banner/template.html":
/***/ (function(module, exports) {

module.exports = "<div\n  ng-if=\"isTopBannerVisible\"\n  class=\"\n    xo-offer-top-banner-container\n    xo-offer-top-banner-treatment-{{offerTopBanner.creditBannerTreatment}}\n  \"\n>\n  <div class=\"banner-container\">\n    <img\n      src=\"https://www.paypalobjects.com/webstatic/credit/img/PPClogo_banner.png\"\n      width=\"52\"\n    />\n    <div class=\"body-text\">\n      <span ng-bind-html=\"offerTopBanner.banner.bodyText\"></span>\n    </div>\n    <div>\n      <a\n        href=\"#\"\n        class=\"apply-btn\"\n        ng-click=\"offerTopBanner.bml()\"\n        ng-bind-html=\"offerTopBanner.banner.ctaText\"\n      >\n      </a>\n    </div>\n    <div class=\"terms-container\">\n      <span ng-bind-html=\"offerTopBanner.banner.termsText\"></span>\n      <a\n        href=\"{{offerTopBanner.banner.termsLink}}\"\n        class=\"popup bmlTermsLink\"\n        target=\"_blank\"\n        xo-popup\n        track-link=\"acquisition_offer_banner_MORS_terms_link\"\n        ng-bind-html=\"offerTopBanner.banner.termsLinkText\"\n      >\n      </a>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-device-info/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$DeviceInfo', function () {
    var userAgent = _angular.$window.navigator.userAgent;
    var standalone = _angular.$window.navigator.standalone;
    var DEVICE_PATTERN = /iPod|iPhone|iPad|Android|BlackBerry|BB10|Palm|CriOS|IEMobile|Windows Phone OS|webOS|Symbian|silk|Kindle|Opera Mini|mobile/i;
    var TABLET_PATTERN = /ip(a|ro)d|silk|xoom|playbook|tablet|kindle|Nexus 7|GT-P10|SC-01C|SHW-M180S|SM-T320|SGH-T849|SCH-I800|SHW-M180L|SPH-P100|SGH-I987|zt180|HTC( Flyer|_Flyer)|Sprint ATP51|ViewPad7|pandigital(sprnova|nova)|Ideos S7|Dell Streak 7|Advent Vega|A101IT|A70BHT|MID7015|Next2|nook|FOLIO|MB511.*RUTEM|Mac OS.*Silk/i;
    var IOS_PATTERN = /iP(hone|od|ad)/i;

    function getIntegrationContext(integrationKey) {
        // additonal context sent via partners in regards to integration
        var integrationContext = _squid.$meta.integrationCTX || {};

        return integrationContext[integrationKey];
    }

    // Supports iOS and Android. Updated / more accurate method of detecting webviews
    function isWebView() {
        var logEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var ua = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : userAgent;

        var ios = /iphone|ipod|ipad/i.test(ua);
        var android = /Android/i.test(ua);

        if (ios) {
            // Unfortunately no perfectly reliable way, this will detect some 3rd party browsers as ui webview
            // Major browsers: chrome, safari, firefox, uc browser, puffin, are detected reliably.
            var ios_uiwebview = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ua);

            if (!standalone && ios_uiwebview && !isSafariViewController()) {
                // uiwebview
                logWebView('iOS');
                return true;
            }
        } else if (android) {
            // not iOS, Android platform handling
            // Whitelist for x-requested-with header values for web view detection
            var allowedXRequestedWithRegexMap = {
                ajax: /XMLHttpRequest/i,
                baiduBrowser: /com.baidu.browser.inter/i,
                operaMini: /com.opera.mini.native/i,
                maxthon: /com.mx.browser/i,
                litterPenguinBrowser: /com.explore.web.browser/i
            };
            var xRequestedWithHeaderVal = _squid.$meta.requestHeaders['x-requested-with'];

            if (xRequestedWithHeaderVal) {
                // check if x-requested-with header val is in whitelist
                for (var key in allowedXRequestedWithRegexMap) {
                    if (allowedXRequestedWithRegexMap.hasOwnProperty(key)) {
                        if (allowedXRequestedWithRegexMap[key].test(xRequestedWithHeaderVal)) {
                            return false;
                        }
                    }
                }
                logWebView('Android');
                return true;
            }
        }

        return false;

        function logWebView(device) {
            if (!logEnabled) {
                return;
            }
            // cal log
            _logger.$logger.info('WebView :: ' + device);
        }
    }

    /**
     * Check if the given the user-agent string is belongs to a device.
     */
    function isDevice() {
        if (_angular2['default'].isString(userAgent)) {
            return DEVICE_PATTERN.test(userAgent) || TABLET_PATTERN.test(userAgent);
        }

        return false;
    }

    /**
     * Check if the given the user-agent string is belongs to a tablet.
     */
    function isTablet() {
        if (_angular2['default'].isString(userAgent)) {
            return TABLET_PATTERN.test(userAgent);
        }

        return false;
    }

    /**
     * Check if the given the user-agent string is belongs to a mobile
     */
    function isMobile() {
        return isDevice(userAgent) && !isTablet(userAgent);
    }

    /**
     * Get the mobile platform value given the user-agent string.
     */
    function getDevicePlatform() {
        if (_angular2['default'].isString(userAgent)) {
            var matched = userAgent.match(/iPod|iPhone|iPad|Android|BlackBerry|Windows Phone OS|webOS|Symbian|mobile/g);

            if (matched && matched.length > 0) {
                return matched[0];
            }
        }
    }

    /**
     * Check if the give user agent is from an app.
     */
    function isApp(uaString) {
        userAgent = uaString || userAgent;

        if (DEVICE_PATTERN.test(userAgent) || TABLET_PATTERN.test(userAgent)) {
            if (getDevicePlatform(userAgent) === 'Android') {
                return (/Version\/\d.\d/i.test(userAgent)
                );
            }

            return (/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)|PLAYSTATION|iPadApp/i.test(userAgent)
            );
        }

        return false;
    }

    function isSafariViewController() {
        if (getIntegrationContext('brainTreeIntegration') === 'SFVC') {
            return true;
        }
        if (_angular2['default'].isString(userAgent)) {
            var ios = /iphone|ipod|ipad/i.test(userAgent);

            return ios && _angular.$window.indexedDB && isApp();
        } else {
            return false;
        }
    }

    /**
     * Get the device capabilities
     */
    function getCapabilities() {
        var capabilities = {};
        var device = DEVICE_PATTERN.test(userAgent);
        var tablet = TABLET_PATTERN.test(userAgent);
        var app = isApp(userAgent);

        if (_angular2['default'].isString(userAgent)) {
            capabilities.isWireless = device || tablet;
            capabilities.isTablet = tablet;
            capabilities.isMobile = device && !tablet;
            capabilities.isDesktop = !device;
            capabilities.isApp = app;
        }
        return capabilities;
    }

    /**
     * Get various AppIntegrationType
     */
    function getAppIntegrationType() {
        var app_int_type = void 0;

        if (isDevice()) {
            if (isApp()) {
                if (isSafariViewController()) {
                    app_int_type = 'SFVC';
                } else {
                    app_int_type = 'WebView';
                }
            } else {
                app_int_type = 'Browser';
            }
        }
        return app_int_type;
    }

    function isSafariiOSBrowserView() {
        var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userAgent;

        var ios = IOS_PATTERN.test(ua);
        var safari = /safari/i.test(ua);
        var isIOSApp = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ua);
        var isChromeOnIOS = /(.*?CriOS)/i.test(ua);
        var isFirefoxOnIOS = /(.*?FxiOS)/i.test(ua);
        var isSafariBrowserOnly = safari && !isChromeOnIOS && !isFirefoxOnIOS;

        return ios && !standalone && isSafariBrowserOnly && !isIOSApp;
    }

    function getiOSVersion() {
        var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userAgent;

        var ios = IOS_PATTERN.test(ua);

        if (ios) {
            var version = ua.match(/OS (\d+)_(\d+)/);
            return [parseInt(version[1], 10), parseInt(version[2], 10)];
        }
        return false;
    }

    return {
        isDevice: isDevice,
        isTablet: isTablet,
        isMobile: isMobile,
        isApp: isApp,
        isSafariViewController: isSafariViewController,
        getCapabilities: getCapabilities,
        getAppIntegrationType: getAppIntegrationType,
        isWebView: isWebView,
        isSafariiOSBrowserView: isSafariiOSBrowserView,
        getiOSVersion: getiOSVersion
    };
});

_squid.$meta;

_logger.$logger;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-device-info/dist", "../node_modules/xo-device-info/dist/index.js"))

/***/ }),

/***/ "../node_modules/xo-form-components/src/add-tax-id/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/add-tax-id/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddTaxId', function () {
    return {
        scope: {
            token: '=?',
            finish: '=?'
        },
        template: _template2['default'],

        controller: ['$scope', '$element', function ($scope, $element) {

            function thenFunction() {
                var taxIdType = 'CPF';
                if ($scope.checkoutSession.errorData && $scope.checkoutSession.errorData.cause === 'NEED_BUSINESS_TAX_INFO_TO_PAY') {
                    taxIdType = 'CNPJ';
                }
                var issuer = 'BR_' + taxIdType;
                $scope.subType = taxIdType;

                $scope.userInfo = _index2.$UserInfoModel.instance($scope.token);

                $scope.onSubmit = function () {
                    // Scrub the formatting when invoking the backend services.
                    var unformatted = ($scope.taxId || '').replace(/[^0-9]+/g, '');
                    var data = {
                        newDocId: {
                            type: 'TAX_ID',
                            subType: $scope.subType,
                            issuerCountry: 'BR',
                            issuer: issuer,
                            value: unformatted,
                            collectionPoint: 'UNKNOWN',
                            placeOfIssue: 'BR'
                        }
                    };

                    $scope.userInfo.action('addTaxId', {
                        data: data,

                        success: function success() {
                            var checkoutSession = _index.$CheckoutSessionModel.instance($scope.token);
                            var checkoutCart = _index.$CheckoutCartModel.instance($scope.token);
                            return checkoutSession.action('create', {
                                data: {
                                    baToken: checkoutCart.billing && checkoutCart.billing.ba_token
                                },
                                success: function success() {
                                    // Clear the errors if create checkout session was successful
                                    $scope.checkoutSession.errorData = undefined;
                                    $scope.finish();
                                }
                            });
                        },

                        validation: function validation(validationData) {
                            var $el = $($element);
                            var $field = $($el.find('[name="' + validationData.field + '"]'));
                            $field.addClass('backendError');
                            $field.attr('aria-invalid', true);
                            $field.focus();
                        }
                    });
                };

                $scope.changeTaxId = function (newValue) {
                    var unformatted = (newValue || '').replace(/[^0-9]+/g, '');
                    var formatted = '';
                    var i = 0;

                    // For CPF we will format the output with dots and dashes like this:
                    // 999.999.999-99
                    if ($scope.subType === 'CPF') {
                        for (i = 0; i < unformatted.length; i++) {
                            if (i === 3 || i === 6) {
                                formatted = formatted + '.';
                            }
                            if (i === 9) {
                                formatted = formatted + '-';
                            }
                            formatted = formatted + unformatted.charAt(i);
                        }
                        $scope.taxId = formatted;
                        // For CNPJ we will format the output with dots, dashes, and slashes like this:
                        // 99.999.999/9999-99
                    } else if ($scope.subType === 'CNPJ') {
                        for (i = 0; i < unformatted.length; i++) {
                            if (i === 2 || i === 5) {
                                formatted = formatted + '.';
                            } else if (i === 8) {
                                formatted = formatted + '/';
                            } else if (i === 12) {
                                formatted = formatted + '-';
                            }
                            formatted = formatted + unformatted.charAt(i);
                        }
                        $scope.taxId = formatted;
                    } else {
                        $scope.taxId = unformatted;
                    }
                };
            }

            (0, _squid.$populate)($scope, {
                checkoutSession: _index.$CheckoutSessionModel.instance($scope.token)
            }).then(thenFunction());
        }]
    };
});

_squid.$populate;

_index.$CheckoutCartModel;

_index.$CheckoutSessionModel;

_index2.$UserInfoModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-form-components/src/add-tax-id/template.html":
/***/ (function(module, exports) {

module.exports = "<form id=\"taxIdForm\" name=\"taxIdForm\" class=\"taxIdForm\" content novalidate>\n    <div class=\"trayInner trayInnerDefault\">\n        <div ng-if=\"subType === 'CNPJ'\">\n            <h3 class=\"gamma noHead\">{{ content('addTaxId.addTaxIdCNPJ') }}</h3>\n            <p>{{ content('addTaxId.noteCNPJ') }}</p>\n\n            <div class=\"inputField confidential\" floating-label>\n                <input id=\"taxId\" name=\"taxId\" maxlength=\"18\" ng-model=\"$parent.taxId\"\n                       xo-error-tooltip required placeholder=\"{{ content('common.taxIdCNPJ_length') }}\"\n                       data-error-key=\"validation.validCNPJ\" ng-change=\"changeTaxId(taxId)\" />\n                <label for=\"taxId\">{{ content('addTaxId.cnpj') }}</label>\n            </div>\n        </div>\n\n        <div ng-if=\"subType === 'CPF'\">\n            <h3 class=\"gamma noHead\">{{ content('addTaxId.addTaxId') }}</h3>\n            <p>{{ content('addTaxId.note') }}</p>\n\n            <div class=\"inputField confidential\" floating-label>\n                <input id=\"taxId\" name=\"taxId\" maxlength=\"14\" ng-model=\"$parent.taxId\"\n                       xo-error-tooltip required placeholder=\"{{ content('common.taxId_length') }}\"\n                       data-error-key=\"validation.validCPF\" ng-change=\"changeTaxId(taxId)\" />\n                <label for=\"taxId\">{{ content('addTaxId.cpf') }}</label>\n            </div>\n        </div>\n\n        <div class=\"buttons\">\n            <input track-submit type=\"submit\" id=\"proceedButton\" value=\"{{ content('addTaxId.save') }}\" class=\"btn full btn-large\" validate-submit=\"onSubmit()\" />\n        </div>\n    </div>\n</form>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/dob-input/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/dob-input/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('dobValidation', function () {
    return {
        require: 'ngModel',
        link: function link(scope, element, attr, ctrl) {

            // init scope vars
            // age - above 18 yrs
            // validDate - months <= 12 and day <= 31 or based on month
            scope.isValidDate = true;
            scope.isValidAge = true;
            scope.isValid = false;
            scope.dobToolTip = 'hide';

            function isValidDate(year, month, day) {
                // dates like 02/31 33/33 should return false
                var date = new Date(year, month, day);

                var fullYear = date.getFullYear();
                var dateMonth = date.getMonth();
                var dateDay = date.getDate();

                // If birth year is in the future or before 1900, dob is invalid
                var now = new Date();
                if (fullYear > now.getFullYear() || fullYear < 1900) {
                    return false;
                }

                if (fullYear === parseInt(year, 10) && dateMonth === parseInt(month, 10) && dateDay === parseInt(day, 10)) {
                    return true;
                }
                return false;
            }

            function isOfLegalAge(birthDate) {
                // user should be of exact 18 years of age or older
                var tempDate = new Date(birthDate.getFullYear() + 18, birthDate.getMonth(), birthDate.getDate());
                return tempDate <= new Date().setHours(0, 0, 0, 0);
            }

            /**
             * Parses input value to set corresponding day, month, year values for scope
             * @param {String} inputVal - the value to be parsed
             */
            function parseDob(inputVal) {
                var day;
                var month;
                var year;

                var sep = scope.dateSeparator();
                var partsArr = inputVal.split(sep);
                var first = partsArr[0];
                var sec = partsArr[1];
                var third = partsArr[2];

                if (scope.dateFormat() === 'DMY') {
                    day = first;
                    month = sec;
                    year = third;
                } else if (scope.dateFormat() === 'YMD') {
                    year = first;
                    month = sec;
                    day = third;
                } else {
                    month = first;
                    day = sec;
                    year = third;
                }

                // Validate only on entering the last digit of the dob
                var dayLen = ('' + day).length;
                var monLen = ('' + month).length;
                var yrLen = ('' + year).length;
                var validDay = dayLen === 1 || dayLen === 2;
                var validMon = monLen === 1 || monLen === 2;
                var validYr = yrLen === 4;
                var requirement = validDay && validMon && validYr;

                if (requirement) {
                    scope.isValidDate = isValidDate(year, month - 1, day);

                    scope.isValidAge = isOfLegalAge(new Date(year, month - 1, day));
                    scope.isValid = scope.isValidDate && scope.isValidAge;
                    scope.dobToolTip = scope.isValid ? 'hide' : 'show';

                    scope.user.dob_day = day;
                    scope.user.dob_month = month;
                    scope.user.dob_year = year;
                } else {
                    scope.isValid = false;
                }

                ctrl.$setValidity('dobText', scope.isValid);

                return inputVal;
            }

            /**
             * Validates the inputted DOB value
             * @param {string} ngModelValue - the to-be mutated input value
             * onComplete for mask listener - called when user copy/pastes DOB into the field
             */
            scope.dobValidator = function dobValidator(ngModelValue) {
                var input = element;
                var dateMask = scope.dateMask();
                input.mask(dateMask, {
                    translation: {
                        'Z': {
                            pattern: /[0-9]/, optional: true
                        },
                        '0': {
                            pattern: /[0-9]/, optional: false
                        }
                    },
                    onComplete: function onComplete(val) {
                        ngModelValue = val;
                        return parseDob(ngModelValue);
                    }
                });

                return parseDob(ngModelValue);
            };

            scope.dobTester = function dobTester(val) {
                return parseDob(val);
            };

            ctrl.$parsers.push(scope.dobValidator);
        }
    };
}).directive('xoDobInput', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            user: '=?'
        },
        controller: ['$scope', function ($scope) {

            // To support additional date separators, simply add separator to getDateSeparators function
            var DateManager = {
                dateSeparator: undefined,
                dateFormat: undefined,
                griffinDateEntry: undefined,

                _init_: function _init_() {
                    this.griffinDateEntry = _squid.$locale.metadata.dateEntry;
                    this.dateSeparator = this.getDateSeparator(this.griffinDateEntry);
                    this.dateFormat = undefined;
                    this.dateFormat = this.getDateFormat();
                    this.dateRegex = this.getDateRegex();
                    // dob validator depends on dateFormat function in $scope, so context is bound.
                    $scope.dateFormat = this.getDateFormat.bind(this);
                    $scope.dateSeparator = this.getDateSeparator.bind(this, this.griffinDateEntry);
                    $scope.dateMask = this.getDateMask.bind(this, this.dateSeparator);
                    this.getDobNumericCheck();
                },
                getDateFormat: function getDateFormat() {
                    // cache date format value, must be unset on init
                    if (this.dateFormat) {
                        return this.dateFormat;
                    }

                    var griffinDateFormat = _squid.$locale.metadata.dateFormat.toUpperCase();
                    var dateFormatComponents = griffinDateFormat.split(this.dateSeparator);

                    // Trim the white space in griffin dateFormat
                    // Eg: SK dateFormat is MM. DD. YYYY - here we need to strip spaces
                    dateFormatComponents = dateFormatComponents.map(function (str) {
                        return str.trim();
                    });

                    var dIdx = dateFormatComponents.indexOf('DD'),
                        mIdx = dateFormatComponents.indexOf('MM');

                    var formatComponentMap = this.getFormatComponentIdxMappings();
                    if (formatComponentMap['DMY'].day === dIdx && formatComponentMap['DMY'].month === mIdx) {
                        return 'DMY';
                    } else if (formatComponentMap['MDY'].day === dIdx && formatComponentMap['MDY'].month === mIdx) {
                        return 'MDY';
                    }
                    return 'YMD';
                },
                setDobTextPlaceHolder: function setDobTextPlaceHolder() {
                    $scope.dobTextPlaceholder = this.griffinDateEntry.toUpperCase();
                },
                dobTextKeyupHandler: function dobTextKeyupHandler(event) {
                    this.updateDobBindings(true);
                },
                getDobNumericCheck: function getDobNumericCheck() {
                    return (0, _squid.$pxp)('xo_xoon_numeric_keypad_expirydob', { 'ctx.COUNTRY': _squid.$locale.country }, 'xo_xoon_numeric_keypad_expirydob_test').then(function (result) {
                        if (result) {
                            $scope.dobTextInputType = 'tel';
                        }
                    });
                },
                /**
                 * Absolutely makes sure that dob input doesn't contain bad characters.
                 * Called on any chatacter input AND on locale change.
                 */
                updateDobBindings: function updateDobBindings(change) {
                    var cleanedDob = ($scope.dob.value || '').replace(this.dateRegex, '');
                    $scope.dob.value = cleanedDob;

                    // This way, our dob value is always formatted correctly.
                    if (change) {
                        $scope.dob.value = $('#dobText').val();
                    }
                },
                // Dynamically construct regex to only include date separator supported by country and nondigits
                getDateRegex: function getDateRegex() {
                    var escapedRegexChars = ['.', '$', '^', '{', '[', '(', '|', ')', '*', '+', '?', '\\'];
                    var sep = this.dateSeparator;
                    var assembledRegex = '[^0-9' + (escapedRegexChars.indexOf(sep) !== -1 ? '\\' + sep : sep) + ']';
                    return new RegExp(assembledRegex, 'gi');
                },
                getDateMask: function getDateMask(dateSeparator) {
                    var dateFormat = this.dateFormat;
                    if (dateFormat === 'DMY' || dateFormat === 'MDY') {
                        return '0Z' + dateSeparator + '0Z' + dateSeparator + '0000';
                    }

                    return '0000' + dateSeparator + '0Z' + dateSeparator + '0Z';
                },
                getDateSeparator: function getDateSeparator(dateEntry) {
                    var ret = '';
                    this.getDateSeparators().forEach(function (ele, iter) {
                        // eslint-disable-line
                        if (dateEntry.indexOf(ele) !== -1) {
                            ret = ele;
                        }
                    });
                    return ret;
                },
                // To add any additional date separators, simply add them to the returned array.
                getDateSeparators: function getDateSeparators() {
                    return ['-', '.', '/'];
                },
                // Handles changes in date component order or date separator change.
                updateDateInputForFormat: function updateDateInputForFormat(oldFormat, newFormat, oldSeparator) {
                    var curDateVal = $scope.dob.value || '';

                    // Clear dob input if date is incomplete so user can see updated placeholder
                    if (curDateVal.length < 8) {
                        $scope.dob.value = '';
                        return;
                    }

                    var formatComponentIdxMappings = this.getFormatComponentIdxMappings(),
                        oldFormatIdxMapping = formatComponentIdxMappings[oldFormat],
                        newFormatIdxMapping = formatComponentIdxMappings[newFormat];
                    var oldDateComponents = curDateVal.split(oldSeparator),
                        newDateComponents = ['', '', ''];

                    newDateComponents[newFormatIdxMapping.day] = oldDateComponents[oldFormatIdxMapping.day];
                    newDateComponents[newFormatIdxMapping.month] = oldDateComponents[oldFormatIdxMapping.month];
                    newDateComponents[newFormatIdxMapping.year] = oldDateComponents[oldFormatIdxMapping.year];
                    $scope.dob.value = newDateComponents.join(this.dateSeparator);
                },
                getFormatComponentIdxMappings: function getFormatComponentIdxMappings() {
                    return {
                        'DMY': {
                            'day': 0,
                            'month': 1,
                            'year': 2
                        },
                        'MDY': {
                            'day': 1,
                            'month': 0,
                            'year': 2
                        },
                        'YMD': {
                            'day': 2,
                            'month': 1,
                            'year': 0
                        }
                    };
                },
                prefillFetchedDob: function prefillFetchedDob() {
                    if ($scope.user && $scope.user.dob_day && $scope.user.dob_month && $scope.user.dob_year) {
                        if (!$scope.dob) {
                            $scope.dob = {};
                        }

                        if (this.dateFormat === 'DMY') {
                            $scope.dob.value = $scope.user.dob_day + this.dateSeparator + $scope.user.dob_month + this.dateSeparator + $scope.user.dob_year;
                        } else if (this.dateFormat === 'YMD') {
                            $scope.dob.value = $scope.user.dob_year + this.dateSeparator + $scope.user.dob_month + this.dateSeparator + $scope.user.dob_day;
                        } else {
                            $scope.dob.value = $scope.user.dob_month + this.dateSeparator + $scope.user.dob_day + this.dateSeparator + $scope.user.dob_year;
                        }
                    } else {
                        $scope.dob = {
                            value: ''
                        };
                    }
                }
            };

            DateManager._init_();
            DateManager.setDobTextPlaceHolder();
            DateManager.prefillFetchedDob();

            $scope.onDobTextKeyup = function (event) {
                DateManager.dobTextKeyupHandler(event);
            };

            $scope.$on('localeChange', function () {
                var oldDateFormat = DateManager.dateFormat;
                var oldSeparator = DateManager.dateSeparator;
                DateManager._init_();
                DateManager.updateDateInputForFormat(oldDateFormat, DateManager.dateFormat, oldSeparator);
                DateManager.updateDobBindings(false);
                DateManager.setDobTextPlaceHolder();
            });
        }]
    };
});

_squid.$locale;

_squid.$pxp;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-form-components/src/dob-input/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"dobComp\" class=\"dobbank\" ng-class=\"{dobTXT: dobInputType()==='TXT'}\" content>\n    <div class=\"dobField full inputField last-child\" floating-label directionality>\n        <input ng-model=\"dob.value\"\n               name=\"dobText\"\n               id=\"dobText\"\n               value=\"\"\n               maxlength=\"10\"\n               autocapitalize=\"off\"\n               aria-required=\"true\"\n               autocomplete=\"off\"\n               placeholder=\"{{ dobTextPlaceholder }}\"\n               xo-error-tooltip\n               dob-validation\n               ng-keyup=\"onDobTextKeyup($event)\"\n               aria-describedby=\"dobHelp\"\n               type=\"{{ dobTextInputType }}\"\n               required />\n        <div ng-class=\"dobToolTip\">\n            <xo-tooltip trigger=\"#dobText\" show-event=\"keyup\" ng-class=\"dobToolTip\" id=\"dobToolTip\">\n                <div class=\"tip tipDesc dobToolTip\">\n                  <p class=\"tipInfoText restriction active\" ng-if=\"!isValidDate\">{{ content('scripts.validDate') }}</p>\n                  <p class=\"tipInfoText restriction active\" ng-if=\"isValidDate && !isValidAge\">{{ content('scripts.legalAge') }}</p>\n                </div>\n            </xo-tooltip>\n        </div>\n        <span id=\"dobHelp\" class=\"accessAid\">{{ dobTextPlaceholder }}</span>\n        <label id=\"dobLabel\" for=\"dobText\">{{ content('signup.accountCreationGuest.dobLabel') }}</label>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/dob-nationalid/directive.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/dob-nationalid/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoDobNationalid', function () {
    var padNumber = function padNumber(num) {
        return num.toString().replace(/^(\d)$/, '0$1');
    };
    /**
     * Create an array from a start and end number.
     * @param  {Number} start
     * @param  {Number} end
     * @return {Array}
     */
    var getRange = function getRange(start, end) {
        var arr = [];
        // decide how this array shall be sorted
        if (start < end) {
            for (; start <= end; start++) {
                arr.push(padNumber(start));
            }
        } else {
            for (; start >= end; start--) {
                arr.push(padNumber(start));
            }
        }
        return arr;
    };

    return {
        template: _template2['default'],
        scope: {
            pi: '=?'
        },

        controller: ['$scope', function ($scope) {

            $scope.init = function () {
                var thisYear = new Date().getFullYear();
                $scope.days = getRange(1, 31);
                $scope.months = getRange(1, 12);
                $scope.years = getRange(thisYear - 18, thisYear - 110);
            };
            $scope.init();
        }]
    };
});

/***/ }),

/***/ "../node_modules/xo-form-components/src/dob-nationalid/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"dobNationalId\" class=\"dobNatlIdGroup fieldGroup clearfix\" content>\n\n    <div id=\"dobSelect\" class=\"dob bankField restricted\">\n        <fieldset>\n            <legend class=\"fieldLegend\" for=\"dob\">{{content('applyForBml.bmlApplyDateOfBirth')}}</legend>\n\n            <div class=\"dropdown fidobMonth inputField\" floating-label-dropdown>\n                <select xo-dropdown name=\"dobMonth\" ng-model=\"pi.month\" id=\"dobMonth\" aria-label=\"{{content('applyForBml.bmlApplyMonth')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyMM')}}</option>\n                    <option ng-repeat=\"month in months track by $index\" value=\"{{month}}\" ng-selected=\"pi.month === '{{month}}'\">{{month}}</option>\n                </select>\n                <label for=\"dobMonth\">\n                    {{content('applyForBml.bmlApplyMM')}}\n                </label>\n            </div>\n\n            <div class=\"dropdown fidobDay inputField\" floating-label-dropdown>\n                <select xo-dropdown name=\"dobDay\" ng-model=\"pi.day\" id=\"dobDay\" aria-label=\"{{content('applyForBml.bmlApplyDay')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyDD')}}</option>\n                    <option ng-repeat=\"day in days track by $index\" value=\"{{day}}\" ng-selected=\"pi.day === '{{day}}'\">{{day}}</option>\n                </select>\n                <label for=\"dobDay\">\n                    {{content('applyForBml.bmlApplyDD')}}\n                </label>\n            </div>\n\n            <div class=\"dropdown fidobYear inputField\" floating-label-dropdown>\n                <select xo-dropdown name=\"dobYear\" ng-model=\"pi.year\" id=\"dobYear\" aria-label=\"{{content('applyForBml.bmlApplyYear')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyYYYY')}}</option>\n                    <option ng-repeat=\"year in years track by $index\" value=\"{{year}}\" ng-selected=\"pi.year === '{{year}}'\">{{year}}</option>\n                </select>\n                <label for=\"dobYear\">\n                    {{content('applyForBml.bmlApplyYYYY')}}\n                </label>\n            </div>\n\n        </fieldset>\n    </div>\n\n    <div class=\"inputField confidential nationalId\" floating-label>\n        <input ng-model=\"pi.natId\" name=\"nationalId\" id=\"nationalId\" value=\"\" pattern=\"\\d{4}\" maxlength=\"4\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" placeholder=\"{{ content('applyForBml.lastFour') }}\" xo-error-tooltip required />\n        <label for=\"nationalId\">{{ content('applyForBml.bmlApplyLast4SSN') }}</label>\n        <xo-tooltip trigger=\"#nationalId\" show-event=\"click\">\n            {{ content('applyForBml.bmlApplyToolTipSSN') }}\n        </xo-tooltip>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/emailInput/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-validation/dist/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/emailInput/styles.less");

var _template = __webpack_require__("../node_modules/xo-form-components/src/emailInput/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('xoEmailInput', {
    tag: 'xo-email-input',
    template: _template2['default'],
    props: {
        user: {
            type: 'var',
            required: false
        },
        disabled: {
            type: 'var',
            required: false
        },
        hideHelper: {
            type: 'var', // flow: Optional string, if "signup" then use the Signup tooltip
            required: false
        },
        flags: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            this.flags = this.flags ? this.flags : {};
        }
    }
});


_squid.$Component;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-form-components/src/emailInput/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-form-components/src/emailInput/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"inputField emailField confidential\" content floating-label directionality>\n    <input ng-model=\"user.email\" id=\"email\" name=\"email\" type=\"email\" value=\"\" autocapitalize=\"off\"\n           aria-required=\"false\" xo-validation='{ \"validator\": \"validEmail\" }' autocomplete=\"off\"\n           data-error-key='email.invalid'\n           ng-disabled=\"disabled\" xo-error-tooltip required />\n    <div class=\"emailHelper\" ng-if=\"!hideHelper\">\n        <a id=\"verifyHelp\"\n           class=\"verifyHelp\"\n           aria-label=\"{{ content('email.whyTooltip') }}\"\n           href=\"javascript:void(0)\">\n        </a>\n    </div>\n    <label for=\"email\">\n        {{ content('index.EmailLabel') }}\n    </label>\n    <xo-tooltip trigger=\"#verifyHelp\" ng-switch=\"flags.mode\" ng-if=\"!hideHelper\">\n        <div id=\"emailToolTipText\" class=\"tip tipDesc emailToolTip\">\n            <span data-type=\"signup_email_tooltip\" ng-switch-when=\"signup\">\n                {{ content('common.emailHelper') }}\n            </span>\n            <span data-type=\"guest_email_tooltip\" ng-switch-default>\n                {{ content('common.emailTooltipGuest') }}\n            </span>\n        </div>\n    </xo-tooltip>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/language-options/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports.VALID_DIRECTION = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/language-options/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var VALID_DIRECTION = exports.VALID_DIRECTION = ['top', 'bottom'];
var isValidDirection = function isValidDirection(n) {
    return VALID_DIRECTION.includes(n);
};


angular.module().directive('xoLanguageOptions', function () {
    return {
        template: _template2['default'],

        scope: {
            direction: '@?'
        },

        controller: ['$scope', function ($scope) {
            $scope.direction = isValidDirection($scope.direction) ? $scope.direction : 'bottom';
            $scope.showLanguages = false;

            function setLanguageVars() {
                $scope.localeModel = _squid.$locale;
                $scope.currentLanguage = $scope.localeModel.lang;
                $scope.currentCountry = $scope.localeModel.country;
                $scope.languageList = $scope.localeModel.metadata.languageLabel;
                $scope.supportedLanguages = _squid.$config.supportedCountries[$scope.currentCountry];
                $scope.hasMultipleLanguages = $scope.supportedLanguages && $scope.supportedLanguages.length > 1 ? true : false;
            }

            $scope.selectLanguage = function (language) {
                $scope.currentLanguage = language;
                _squid.$locale.chooseLang(language);
            };

            $scope.toggle = function ($event) {
                if ($event) {
                    $event.preventDefault();
                }

                $scope.showLanguages = !$scope.showLanguages;
            };

            setLanguageVars();

            // Reset locale properties for languageToggle
            $scope.$on('localeChange', function () {
                setLanguageVars();
            });

            // "clickBody" is an artifical event broadcast by the xo-checkout component (essentially document.click)
            $scope.$on('clickBody', function ($event, target) {
                if ($(target).parents('.languageToggleDisplay div').length === 0) {
                    $scope.showLanguages = false;
                    $scope.$apply();
                }
            });
        }]
    };
});

_squid.$config;

_squid.$locale;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-form-components/src/language-options/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"languageToggleDisplay\" content feature=\"languageToggle\" ng-if=\"hasMultipleLanguages\">\n    <div>\n        <a id=\"clickLanguageToggle\" lang=\"{{ currentLanguage }}\" aria-expanded=\"{{showLanguages}}\" aria-label=\"{{ content('languages.label', {language: languageList[currentLanguage]}) }}\" ng-click=\"toggle()\" select-button focus-when=\"!showLanguages\" focused-once-before><span class=\"displayText\">{{languageList[currentLanguage]}}</span><span class=\"changeLanguage\" ng-class=\"{expand:showLanguages}\"></span></a>\n    </div>\n    <div id=\"langDropdownBlock\" ng-show=\"showLanguages\" class=\"{{ direction }}\">\n        <div class=\"arrow\"></div>\n        <div ng-click=\"toggle()\">\n            <ul aria-labelledby=\"clickLanguageToggle\" select-box=\"showLanguages && supportedLanguages\" select-cancel=\"toggle()\">\n                <li role=\"presentation\" ng-repeat=\"lang in supportedLanguages track by $index\" lang=\"{{ lang }}\">\n                    <a track-link=\"language_change\" class=\"submit\" ng-click=\"selectLanguage(lang)\" link-button select-option=\"lang == currentLanguage\" focus-when=\"showLanguages && lang == currentLanguage\">{{languageList[lang]}}</a>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/name-input/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/floating-label/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/prefix-attrs-with/directive.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/name-input/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoNameInput', {
    tag: 'xo-name-input',

    template: _template2['default'],

    props: {
        attrPrefix: {
            required: false,
            type: 'var'
        },
        country: {
            required: false,
            type: 'str'
        },
        user: {
            required: false,
            type: 'var'
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.locale = _squid.$locale;
            this.metadata = _squid.$MetadataModel.create();

            var handleCountryChange = function handleCountryChange() {
                _this.metadata.choose(_this.country || _squid.$locale.country, _squid.$locale.lang);
            };

            this.$watch('country', handleCountryChange);
        }
    }
});


_squid.$Component;

_squid.$locale;

_squid.$MetadataModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-form-components/src/name-input/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"fieldGroup name clearfix\" ng-class=\"country || locale.country\" content>\n    <div ng-if=\"metadata.nameEntry.layout\" ng-repeat=\"layoutItem in metadata.nameEntry.layout track by $index\">\n        <!-- First name -->\n        <div ng-if=\"layoutItem.$ === 'givenName'\">\n            <div class=\"inputField half confidential\" ng-class=\"{'last-child': $last}\" data-test-id=\"first-name-container\" floating-label disable-autoblur directionality>\n                <input ng-model=\"user.first_name\"\n                        id=\"firstName\"\n                        name=\"firstName\"\n                        prefix-attrs-with=\"{{attrPrefix}}\"\n                        value=\"\"\n                        pattern=\"(?!^\\d+$)^.+$\"\n                        autocapitalize=\"off\"\n                        aria-required=\"false\"\n                        autocomplete=\"off\"\n                        maxlength=\"100\"\n                        xo-error-tooltip\n                        ng-required=\"{{layoutItem.required}}\"\n                        data-test-id=\"user.first_name\" />\n                <label for=\"firstName\" prefix-attrs-with=\"{{attrPrefix}}\">\n                    {{content('common.firstName')}}\n                </label>\n            </div>\n        </div>\n\n        <!-- Last name -->\n        <div ng-if=\"layoutItem.$ === 'surname'\">\n            <div class=\"inputField half confidential\" ng-class=\"{'last-child': $last}\" data-test-id=\"last-name-container\" floating-label directionality>\n                <input ng-model=\"user.last_name\"\n                        id=\"lastName\"\n                        name=\"lastName\"\n                        prefix-attrs-with=\"{{attrPrefix}}\"\n                        value=\"\"\n                        pattern=\"(?!^\\d+$)^.+$\"\n                        autocapitalize=\"off\"\n                        aria-required=\"false\"\n                        autocomplete=\"off\"\n                        maxlength=\"100\"\n                        xo-error-tooltip\n                        ng-required=\"{{layoutItem.required}}\"\n                        data-test-id=\"user.last_name\" />\n                <label for=\"lastName\" prefix-attrs-with=\"{{attrPrefix}}\">\n                    {{content('common.lastName')}}\n                </label>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if=\"!metadata.nameEntry.layout\">\n        <!-- First name -->\n        <div class=\"inputField half confidential\" floating-label disable-autoblur directionality>\n            <input ng-model=\"user.first_name\"\n                    id=\"firstName\"\n                    name=\"firstName\"\n                    prefix-attrs-with=\"{{attrPrefix}}\"\n                    value=\"\"\n                    pattern=\"(?!^\\d+$)^.+$\"\n                    autocapitalize=\"off\"\n                    aria-required=\"false\"\n                    autocomplete=\"off\"\n                    maxlength=\"100\"\n                    xo-error-tooltip\n                    ng-required=\"true\"\n                    data-test-id=\"user.first_name\" />\n            <label for=\"firstName\" prefix-attrs-with=\"{{attrPrefix}}\">\n                {{content('common.firstName')}}\n            </label>\n        </div>\n\n        <!-- Last name -->\n        <div class=\"inputField half confidential last-child\" floating-label directionality>\n            <input ng-model=\"user.last_name\"\n                    id=\"lastName\"\n                    name=\"lastName\"\n                    prefix-attrs-with=\"{{attrPrefix}}\"\n                    value=\"\"\n                    pattern=\"(?!^\\d+$)^.+$\"\n                    autocapitalize=\"off\"\n                    aria-required=\"false\"\n                    autocomplete=\"off\"\n                    maxlength=\"100\"\n                    xo-error-tooltip\n                    ng-required=\"true\"\n                    data-test-id=\"user.last_name\" />\n            <label for=\"lastName\" prefix-attrs-with=\"{{attrPrefix}}\">\n                {{content('common.lastName')}}\n            </label>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/national-id-input/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename, $) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/dob-input/directive.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/national-id-input/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().directive('brIdValidations', function () {
    return {
        require: 'ngModel',

        link: function link(scope, element, attr, ctrl) {
            scope.cpfValidator = function cpfValidator(ngModelValue) {
                var value = ngModelValue.replace(/[^0-9]/gi, '');
                var len = value.length;

                if (len !== 11) {
                    ctrl.$setValidity('nationalId', false);
                    return ngModelValue;
                }

                var x = value.match(/\b(\d)\1+\b/);

                if (x) {
                    ctrl.$setValidity('nationalId', false);
                    return ngModelValue;
                }

                var v1 = 0;
                var v2 = 0;
                var dv1;
                var dv2;
                var i;
                var j;

                for (i = 0, j = 10; i < 9, j > 1; i++, j--) {
                    // eslint-disable-line no-sequences
                    v1 += j * +value[i];
                }

                v1 = v1 % 11;
                dv1 = 11 - v1 < 10 ? 11 - v1 : 0;

                for (i = 0, j = 11; i < 9, j > 2; i++, j--) {
                    // eslint-disable-line no-sequences
                    v2 += j * +value[i];
                }

                v2 += dv1 * 2;
                v2 = v2 % 11;
                dv2 = 11 - v2 < 10 ? 11 - v2 : 0;

                scope.isValid = dv1 === parseInt(value[9], 10) && dv2 === parseInt(value[10], 10);

                ctrl.$setValidity('nationalId', scope.isValid);

                return ngModelValue;
            };

            ctrl.$parsers.push(scope.cpfValidator);
        }
    };
}).directive('sgIdValidations', function () {
    return {
        require: 'ngModel',

        link: function link(scope, element, attr, ctrl) {
            scope.nricFinValidator = function nricFinValidator(ngModelValue) {
                var idType = scope.$parent.nationalIdModel.nationalId.type;
                if (idType === 'NATIONAL_ID') {
                    scope.isValid = false;

                    // Valid if first char is "S", "T", "F" or "G" and the rest 7 are digits followed by a letter.
                    if (ngModelValue.match(/^[SFTG]\d{7}[A-Z]$/)) {
                        scope.isValid = true;
                    }
                } else {
                    scope.isValid = true;
                }
                ctrl.$setValidity('nationalId', scope.isValid);
                return ngModelValue;
            };
            ctrl.$parsers.push(scope.nricFinValidator);
        }
    };
}).directive('ruIdValidations', function () {
    return {
        require: 'ngModel',

        link: function link(scope, element, attr, ctrl) {

            function validateSNILSChunk(sum, checksum) {
                if (sum < 100 && sum === checksum) {
                    return true;
                } else if ((sum === 100 || sum === 101) && checksum === 0) {
                    return true;
                } else if (sum > 101) {
                    var remainder = sum % 101;
                    return validateSNILSChunk(remainder, checksum);
                }

                return false;
            }

            function validateSNILS(value) {
                if (value.length === 11) {
                    if (Number(value) > 1001998) {
                        var snilsNumber = value.substring(0, 9);
                        var checksum = Number(value.substring(9));
                        var sum = 0;
                        var multiplier = 1;

                        for (var i = snilsNumber.length - 1; i >= 0; i--) {
                            sum = sum + Number(snilsNumber.charAt(i)) * multiplier;
                            multiplier++;
                        }

                        return validateSNILSChunk(sum, checksum);
                    }

                    return true;
                }

                return false;
            }

            function validateINNChecksum(value, factor, valueLength, match) {
                var n;
                var sumn = 0;
                for (var i = 0; i < valueLength; i++) {
                    sumn = sumn + Number(value[i]) * Number(factor[i]);
                }
                n = sumn % 11;
                n = n === 10 ? 0 : n;

                if (n !== Number(match)) {
                    return false;
                }

                return true;
            }

            function validateINN(value) {
                if (value.length === 12) {
                    var factor = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8];

                    if (!validateINNChecksum(value, factor, value.length - 2, value[10])) {
                        return false;
                    }

                    factor.unshift(3);

                    if (!validateINNChecksum(value, factor, value.length - 1, value[11])) {
                        return false;
                    }

                    return true;
                }

                return false;
            }

            function validateOMS(value) {
                if (value.length >= 11 && value.length <= 16) {
                    return true;
                }

                return false;
            }

            scope.idValidator = function idValidator(ngModelValue) {
                var value = ngModelValue.replace(/[^0-9]/gi, '');
                var secondaryType = scope.nationalIdModel.secondaryIdType;

                if (secondaryType === 'SNILS') {
                    scope.isValid = validateSNILS(value);
                } else if (secondaryType === 'INN') {
                    scope.isValid = validateINN(value);
                } else if (secondaryType === 'OMS') {
                    scope.isValid = validateOMS(value);
                }

                ctrl.$setValidity('secondaryId', scope.isValid);

                return ngModelValue;
            };

            ctrl.$parsers.push(scope.idValidator);
        }
    };
}).directive('xoNationalIdInput', function () {
    return {
        template: _template2['default'],
        scope: {
            user: '=?',
            country: '@?'
        },

        link: function link(scope, element, attr) {
            var passportMask = '0000000000';

            element.on('keyup', function (event) {
                if (scope.user.countryOfResidence === 'RU') {
                    $('#nationalId').mask(passportMask, {
                        'translation': {
                            0: { pattern: /[0-9]/ }
                        }
                    });
                } else {
                    $('#nationalId').unmask(passportMask);
                }
            });
        },

        controller: ['$scope', '$NationalIdModel', function ($scope, $NationalIdModel) {

            $scope.nationalIdModel = $NationalIdModel.instance(_angular.$rootScope.token);
            $scope.checkoutCart = _index.$CheckoutCartModel.instance(_angular.$rootScope.token);
            $scope.user = $scope.user || {};
            $scope.user.countryOfResidence = $scope.user.countryOfResidence || $scope.country;
            $scope.formattedValues = {};
            $scope.showNationalIdFields = false;

            if ($scope.checkoutCart.payer && $scope.checkoutCart.payer.tax_id) {
                $scope.nationalIdModel.nationalId.value = $scope.checkoutCart.payer.tax_id;
            }

            $scope.countryChanged = function () {
                if ($scope.user.countryOfResidence === 'RU') {
                    $scope.showNationalIdFields = true;
                    $scope.minLengthNatId = 10;
                    $scope.maxLengthNatId = 10;
                } else {
                    $scope.showNationalIdFields = false;
                    $scope.minLengthNatId = 6;
                    $scope.maxLengthNatId = 15;
                }
            };

            $scope.cpfMasking = function (newValue) {
                if (newValue) {
                    var unformatted = newValue.replace(/[^0-9]/gi, '');
                    var formatted = [['', unformatted.slice(0, 3)], ['.', unformatted.slice(3, 6)], ['.', unformatted.slice(6, 9)], ['-', unformatted.slice(9)]].map(function (x) {
                        return x[1] && x[0] + x[1] || '';
                    }).join('');

                    $scope.formattedValues.nationalId = formatted;
                    $scope.nationalIdModel.nationalId.value = unformatted;
                } else {
                    $scope.nationalIdModel.nationalId.value = '';
                }
            };

            $scope.secondaryIdFormatting = function () {
                var $el = $('#idValue');

                if ($scope.nationalIdModel.secondaryIdType === 'SNILS' && $el.length > 0) {
                    var unformatted = $el.val().replace(/[^0-9]/gi, '');
                    var formatted = [['', unformatted.slice(0, 3)], ['-', unformatted.slice(3, 6)], ['-', unformatted.slice(6, 9)], [' ', unformatted.slice(9)]].map(function (x) {
                        return x[1] && x[0] + x[1] || '';
                    }).join('');

                    $scope.nationalIdModel.secondaryIdValue = formatted;
                }
            };

            $scope.secondaryIdChange = function () {
                var currentSecondaryId = $scope.secondaryIds[$scope.nationalIdModel.secondaryIdType];

                $scope.nationalIdModel.secondaryIdValue = '';
                $scope.maxLength = currentSecondaryId.length;
                $scope.minLength = currentSecondaryId.minlength ? currentSecondaryId.minlength : currentSecondaryId.length;

                $scope.maskCharLength = currentSecondaryId.maskCharLength ? currentSecondaryId.maskCharLength : 0;
            };

            $scope.sgIdChange = function () {
                $scope.nationalIdModel.nationalId.value = '';
            };

            function setLocalizedNatIDLabels() {
                $scope.nationalIds = {
                    'PASSPORT': { name: 'PASSPORT_NUMBER', value: _squid.$locale.content.addTaxId.passport }
                };

                // National ID is not shown for South Korea
                if (_squid.$locale.country !== 'KR') {
                    $scope.nationalIds.NATID = { name: 'NATIONAL_ID', value: _squid.$locale.content.addTaxId.natid };
                }

                // ID type change from “Driver’s License” to “TEMPORARY_NATIONAL_ID” for HK only,
                // other countries show "Driver’s License" in th national ID drop down
                if (_squid.$locale.country === 'HK' && (0, _squid.$feature)('driverLicenseToTempNationalID', false, _squid.$locale.country)) {
                    $scope.nationalIds.TNID = { name: 'TEMPORARY_NATIONAL_ID', value: _squid.$locale.content.addTaxId.tnid };
                } else {
                    $scope.nationalIds.DL = { name: 'DRIVERS_LICENSE', value: _squid.$locale.content.addTaxId.dl };
                }
            }

            function setLocalizedRUContent() {
                $scope.countries = _squid.$locale.metadata.territory;
                $scope.secondaryIds = {
                    'INN': { name: 'INN', value: _squid.$locale.content.addTaxId.INN, length: 12 },
                    'SNILS': { name: 'SNILS', value: _squid.$locale.content.addTaxId.SNILS, length: 14, maskCharLength: 3 },
                    'OMS': { name: 'OMS', value: _squid.$locale.content.addTaxId.OMS, length: 16, minlength: 11 }
                };
            }

            if (_squid.$locale.country === 'BR') {
                $scope.nationalIdModel.nationalId.type = 'TAX_ID';
                $scope.nationalIdModel.nationalId.subType = 'CPF';

                $scope.cpfMasking($scope.nationalIdModel.nationalId.value);
            } else if ($scope.country === 'RU') {
                setLocalizedRUContent();
                $scope.nationalIdModel.nationalId.type = 'PASSPORT';
                $scope.nationalIdModel.nationalId.subType = '';
                $scope.user.nativeName = $scope.user.nativeName || {};

                if (!$scope.nationalIdModel.secondaryIdType) {
                    $scope.nationalIdModel.secondaryIdType = $scope.secondaryIds.INN.name;
                }

                $scope.secondaryIdChange();

                $scope.countryChanged();
            } else if ($scope.country === 'KR') {
                $scope.nationalIds = {
                    'PASSPORT': { name: 'PASSPORT_NUMBER', value: _squid.$locale.content.addTaxId.passport },
                    'DL': { name: 'DRIVERS_LICENSE', value: _squid.$locale.content.addTaxId.dl }
                };
                $scope.nationalIdModel.nationalId.type = 'PASSPORT_NUMBER';
                $scope.nationalIdModel.nationalId.subType = '';
            } else {
                // Default behaviour - set to 3pl countries
                setLocalizedNatIDLabels();
                $scope.nationalIdModel.nationalId.type = 'NATIONAL_ID';
                $scope.nationalIdModel.nationalId.subType = '';
            }

            $scope.$on('contentChange', function () {
                setLocalizedNatIDLabels();

                if ($scope.country === 'RU') {
                    setLocalizedRUContent();
                }
            });
        }]
    };
}).factory('$NationalIdModel', function () {

    return _squid.$Model.extend('NationalIdModel', {

        init: function init() {
            this._super.init.apply(this);
            this.nationalId = this.nationalId || {};
        },

        serialize: function serialize() {
            return this.nationalId;
        }
    });
});

_angular.$rootScope;

_squid.$feature;

_squid.$locale;

_squid.$Model;

_index.$CheckoutCartModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-form-components/src/national-id-input", "../node_modules/xo-form-components/src/national-id-input/directive.js", __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-form-components/src/national-id-input/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"nationalIdFields\" class=\"clearfix\" content>\n    <div class=\"bankField restricted\">\n        <div ng-switch=\"country\">\n            <div ng-switch-when=\"SG\">\n                <div class=\"dropdown nationalID fidobDay inputField\" floating-label-dropdown>\n                    <select xo-dropdown name=\"idType\"\n                            ng-model=\"nationalIdModel.nationalId.type\"\n                            id=\"idType\"\n                            ng-change=\"sgIdChange()\"\n                            aria-required=\"true\">\n                        <option ng-repeat=\"items in nationalIds track by $index\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.nationalId.type === '{{items.name}}'\">{{items.value}}</option>\n                    </select>\n                    <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n                </div>\n\n                <div class=\"inputField nationalIDValue\" floating-label directionality>\n                    <input ng-model=\"nationalIdModel.nationalId.value\"\n                           name=\"idValue\"\n                           id=\"idValue\"\n                           class=\"additionalIDBox\"\n                           value=\"\"\n                           autocapitalize=\"off\"\n                           aria-required=\"true\"\n                           autocomplete=\"off\"\n                           valid-letters=\"data.validLetters\"\n                           sg-id-validations\n                           required/>\n                    <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n                </div>\n            </div>\n\n            <div ng-switch-when=\"BR\">\n\n                <div class=\"inputField confidential nationalId\" floating-label directionality>\n                    <input ng-model=\"formattedValues.nationalId\"\n                           name=\"nationalId\"\n                           id=\"nationalId\"\n                           value=\"\"\n                           autocapitalize=\"off\"\n                           aria-required=\"true\"\n                           autocomplete=\"off\"\n                           xo-error-tooltip\n                           br-id-validations\n                           maxlength=\"14\"\n                           ng-change=\"cpfMasking(formattedValues.nationalId)\"\n                           required/>\n                    <label for=\"nationalId\">{{content('addTaxId.cpf')}}</label>\n                </div>\n\n            </div>\n\n            <div ng-switch-when=\"KR\">\n\n                <div class=\"dropdown nationalID fidobDay inputField\" floating-label-dropdown>\n                    <select xo-dropdown name=\"idType\"\n                            ng-model=\"nationalIdModel.nationalId.type\"\n                            id=\"idType\"\n                            aria-required=\"false\">\n                        <option ng-repeat=\"items in nationalIds track by $index\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.nationalId.type === '{{items.name}}'\">{{items.value}}</option>\n                    </select>\n                    <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n                </div>\n\n                <div class=\"inputField nationalIDValue\" floating-label directionality>\n                    <input ng-model=\"nationalIdModel.nationalId.value\"\n                           name=\"idValue\"\n                           id=\"idValue\"\n                           class=\"additionalIDBox\"\n                           value=\"\"\n                           autocapitalize=\"off\"\n                           aria-required=\"false\"\n                           autocomplete=\"off\"/>\n                    <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n                </div>\n\n            </div>\n\n            <div ng-switch-when=\"RU\">\n\n                <div class=\"nationalId\">\n                    <div class=\"dropdown confidential country clearfix inputField\" floating-label-dropdown>\n                        <select xo-dropdown name=\"country\" ng-model=\"user.countryOfResidence\" id=\"country\"\n                                        aria-labelledby=\"countryLabel\" ng-change=\"countryChanged()\" xo-error-tooltip required>\n                            <option ng-repeat=\"country in countries track by $index\" value=\"{{country.code}}\" ng-selected=\"user.countryOfResidence === country.code\">{{country.name}}</option>\n                        </select>\n                        <label for=\"country\" id=\"countryLabel\">{{content('common.country')}}</label>\n                    </div>\n\n                    <div ng-if=\"showNationalIdFields\">\n                        <xo-name-input user=\"user.nativeName\"></xo-name-input>\n\n                        <div class=\"inputField confidential full\" floating-label directionality>\n                            <input ng-model=\"user.nativeName.middle_name\"\n                                   name=\"middleName\"\n                                   id=\"middleName\"\n                                   value=\"\"\n                                   autocapitalize=\"off\"\n                                   aria-required=\"true\"\n                                   autocomplete=\"off\"\n                                   required />\n                            <label for=\"middleName\" id=\"middleNameLabel\">{{content('common.middleName')}}</label>\n                        </div>\n                    </div>\n\n                    <div class=\"inputField full\" floating-label directionality>\n                        <input ng-model=\"nationalIdModel.nationalId.value\"\n                                name=\"nationalId\"\n                                id=\"nationalId\"\n                                value=\"\"\n                                autocapitalize=\"off\"\n                                aria-required=\"true\"\n                                autocomplete=\"off\"\n                                minlength=\"{{minLengthNatId}}\"\n                                maxlength=\"{{maxLengthNatId}}\"\n                                placeholder=\"{{user.countryOfResidence === 'RU' && content('addTaxId.passportRU') || content('addTaxId.passportEN')}}\"\n                                xo-validation='{\"validator\": \"validRUPassport\"}'\n                                xo-error-tooltip\n                                required />\n\n                        <label for=\"nationalId\">{{content('addTaxId.passport')}}</label>\n                    </div>\n\n                    <xo-dob-input user=\"user\"></xo-dob-input>\n\n                    <div ng-if=\"showNationalIdFields\">\n                        <legend class=\"fieldLegend\" for=\"additionalId\">{{content('addTaxId.additionalInfo')}}\n                            <div class=\"additionalIdHelper\">\n                                <a href=\"#\" id=\"verifyHelpAdditionalId\" alt=\"Why do we need this\" class=\"verifyHelp\"></a>\n                            </div>\n                            <div class=\"lineSpacing\">\n                                <xo-tooltip trigger=\"#verifyHelpAdditionalId\">\n                                    <div class=\"tip tipDesc\">\n                                        {{content('addTaxId.additionalInfoNote')}}\n                                    </div>\n                                </xo-tooltip>\n                            </div>\n                        </legend>\n\n                        <div id=\"additionalId\">\n                            <div class=\"dropdown inputField\" floating-label-dropdown>\n                                <select xo-dropdown name=\"idType\"\n                                        ng-model=\"nationalIdModel.secondaryIdType\"\n                                        id=\"idType\"\n                                        aria-label=\"{{ content('signup.accountCreationGuest.dobDay') }}\"\n                                        ng-change=\"secondaryIdChange()\"\n                                        aria-required=\"true\">\n                                    <option ng-repeat=\"items in secondaryIds track by $index\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.secondaryIdType === '{{items.name}}'\">{{items.value}}</option>\n                                </select>\n                                <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n                            </div>\n\n                            <div class=\"inputField\" floating-label directionality>\n                                <input ng-model=\"nationalIdModel.secondaryIdValue\"\n                                       name=\"idValue\"\n                                       id=\"idValue\"\n                                       value=\"\"\n                                       maxlength=\"{{maxLength}}\"\n                                       minlength=\"{{minLength}}\"\n                                       autocapitalize=\"off\"\n                                       aria-required=\"true\"\n                                       autocomplete=\"off\"\n                                       placeholder=\"{{(maxLength - maskCharLength)}} {{content('addTaxId.digits')}}\"\n                                       required\n                                       ru-id-validations\n                                       ng-change=\"secondaryIdFormatting()\"/>\n                                <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div ng-switch-default>\n              <div class=\"dropdown nationalID fidobDay inputField\" floating-label-dropdown>\n                  <select xo-dropdown name=\"idType\"\n                          ng-model=\"nationalIdModel.nationalId.type\"\n                          id=\"idType\"\n                          aria-required=\"true\">\n                      <option ng-repeat=\"items in nationalIds track by $index\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.nationalId.type === '{{items.name}}'\">{{items.value}}</option>\n                  </select>\n                  <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n              </div>\n\n              <div class=\"inputField nationalIDValue\" floating-label directionality>\n                  <input ng-model=\"nationalIdModel.nationalId.value\"\n                         name=\"idValue\"\n                         id=\"idValue\"\n                         class=\"additionalIDBox\"\n                         value=\"\"\n                         autocapitalize=\"off\"\n                         aria-required=\"true\"\n                         autocomplete=\"off\"\n                         required/>\n                  <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n              </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

__webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInput/directive.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/phone/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddPhone', function () {
    return {
        template: _template2['default'],
        scope: {},
        controller: ['$scope', function ($scope) {

            $scope.showPhoneDisclosure = (0, _squid.$featureCountries)('showPhoneDisclosure').indexOf(_squid.$locale.country) > -1;
            $scope.phoneConsent = (0, _squid.$feature)('phoneConsent');
            $scope.consentContentKey = $scope.phoneConsent ? 'addPhone.phoneConsent' : 'addPhone.phoneDisclosure';
            $scope.errorMessage = {
                msgKeys: ['addPhone.addPhoneNumberConsent'],
                type: 'info'
            };

            $scope.userInfo = _index2.$UserInfoModel.instance(_angular.$rootScope.token);
            $scope.phone = {};

            var CONTENT_KEY = {
                INVALID_PHONE_NUMBER: 'validPhone'
            };

            var CONTENT_MAPPING = {
                numberError: CONTENT_KEY.INVALID_PHONE_NUMBER,
                typeError: CONTENT_KEY.INVALID_PHONE_NUMBER
            };

            var populateErrorMessage = function populateErrorMessage(name) {
                var contentKey = CONTENT_MAPPING[name];
                var msg = contentKey ? _squid.$locale.content.get('scripts.' + contentKey) : 'unresolved content for login error ' + name;

                $scope.errorMessage = {
                    msgs: [msg],
                    type: 'error'
                };
            };

            var validationErrorHandler = {
                numberError: populateErrorMessage,
                typeError: populateErrorMessage
            };

            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance()
            }).then(function () {

                $scope.logout = function () {
                    _logger.$logger.info('not_you_logout');
                    $scope.auth.action('logout').then(function () {
                        _uiRouter.$state.go('checkout.login');
                    });
                };

                $scope.showNotYou = $scope.auth.is_auth_api_call && _squid.$util.param('source') !== 'consumerApp' && $scope.logout;

                $scope.onSubmit = function () {
                    if ($scope.phoneConsent) {
                        $scope.phone.consent = {
                            agreed: true,
                            contentId: _squid.$locale.country + ':' + _squid.$locale.lang + ':' + $scope.consentContentKey + ':' + (0, _squid.$contentVersion)()
                        };
                    }
                    $scope.userInfo.action('addPhone', {

                        data: $scope.phone,

                        success: function success(data) {
                            return _index.$CheckoutSessionModel.instance(_angular.$rootScope.token).action('create', {
                                success: function success() {
                                    _uiRouter.$state.go('checkout.review');
                                }
                            });
                        },

                        contingencies: {
                            NEED_CREDIT_CARD: function NEED_CREDIT_CARD() {
                                _angular.$location.path('/checkout/addCard');
                            },

                            EXPIRED_CREDIT_CARD: function EXPIRED_CREDIT_CARD() {
                                _angular.$location.path('/checkout/updateCard');
                            }
                        },

                        validation: function validation(data) {
                            angular.forEach(data, function (value, key) {
                                validationErrorHandler[key](key);
                            });
                        }
                    });
                };
            });
        }]
    };
});

_angular.$rootScope;

_angular.$location;

_squid.$feature;

_squid.$locale;

_squid.$populate;

_squid.$util;

_squid.$featureCountries;

_squid.$contentVersion;

_uiRouter.$state;

_logger.$logger;

_auth.$AuthModel;

_index.$CheckoutSessionModel;

_index2.$UserInfoModel;

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/lib/territoriesByCode.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
    return {
        'AC': {
            'status': 'reserved',
            'phoneCountryCode': '247',
            'showCountryCodeList': false
        },
        'AD': {
            'status': 'assigned',
            'phoneCountryCode': '376',
            'showCountryCodeList': false
        },
        'AE': {
            'status': 'assigned',
            'phoneCountryCode': '971',
            'showCountryCodeList': false
        },
        'AF': {
            'status': 'assigned',
            'phoneCountryCode': '93',
            'showCountryCodeList': false
        },
        'AG': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'AI': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'AL': {
            'status': 'assigned',
            'phoneCountryCode': '355',
            'showCountryCodeList': false
        },
        'AM': {
            'status': 'assigned',
            'phoneCountryCode': '374',
            'showCountryCodeList': false
        },
        'AN': {
            'status': 'assigned',
            'phoneCountryCode': '599',
            'showCountryCodeList': false
        },
        'AO': {
            'status': 'assigned',
            'phoneCountryCode': '244',
            'showCountryCodeList': false
        },
        'AQ': {
            'status': 'assigned',
            'phoneCountryCode': '672',
            'showCountryCodeList': false
        },
        'AR': {
            'status': 'assigned',
            'phoneCountryCode': '54',
            'showCountryCodeList': false
        },
        'AS': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'AT': {
            'status': 'assigned',
            'phoneCountryCode': '43',
            'showCountryCodeList': true
        },
        'AU': {
            'status': 'assigned',
            'phoneCountryCode': '61',
            'showCountryCodeList': true
        },
        'AW': {
            'status': 'assigned',
            'phoneCountryCode': '297',
            'showCountryCodeList': false
        },
        'AZ': {
            'status': 'assigned',
            'phoneCountryCode': '994',
            'showCountryCodeList': false
        },
        'BA': {
            'status': 'assigned',
            'phoneCountryCode': '387',
            'showCountryCodeList': false
        },
        'BB': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'BD': {
            'status': 'assigned',
            'phoneCountryCode': '880',
            'showCountryCodeList': false
        },
        'BE': {
            'status': 'assigned',
            'phoneCountryCode': '32',
            'showCountryCodeList': true
        },
        'BF': {
            'status': 'assigned',
            'phoneCountryCode': '226',
            'showCountryCodeList': false
        },
        'BG': {
            'status': 'assigned',
            'phoneCountryCode': '359',
            'showCountryCodeList': false
        },
        'BH': {
            'status': 'assigned',
            'phoneCountryCode': '973',
            'showCountryCodeList': false
        },
        'BI': {
            'status': 'assigned',
            'phoneCountryCode': '257',
            'showCountryCodeList': false
        },
        'BJ': {
            'status': 'assigned',
            'phoneCountryCode': '229',
            'showCountryCodeList': false
        },
        'BL': {
            'status': 'assigned',
            'phoneCountryCode': '590',
            'showCountryCodeList': false
        },
        'BM': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'BN': {
            'status': 'assigned',
            'phoneCountryCode': '673',
            'showCountryCodeList': false
        },
        'BO': {
            'status': 'assigned',
            'phoneCountryCode': '591',
            'showCountryCodeList': false
        },
        'BQ': {
            'status': 'assigned',
            'phoneCountryCode': '599',
            'showCountryCodeList': false
        },
        'BR': {
            'status': 'assigned',
            'phoneCountryCode': '55',
            'showCountryCodeList': false
        },
        'BS': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'BT': {
            'status': 'assigned',
            'phoneCountryCode': '975',
            'showCountryCodeList': false
        },
        'BV': {
            'status': 'assigned'
        },
        'BW': {
            'status': 'assigned',
            'phoneCountryCode': '267',
            'showCountryCodeList': false
        },
        'BY': {
            'status': 'assigned',
            'phoneCountryCode': '375',
            'showCountryCodeList': false
        },
        'BZ': {
            'status': 'assigned',
            'phoneCountryCode': '501',
            'showCountryCodeList': false
        },
        'C2': {
            'status': 'assigned',
            'phoneCountryCode': '86',
            'showCountryCodeList': false
        },
        'CA': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'CC': {
            'status': 'assigned',
            'phoneCountryCode': '61',
            'showCountryCodeList': false
        },
        'CD': {
            'status': 'assigned',
            'phoneCountryCode': '243',
            'showCountryCodeList': false
        },
        'CF': {
            'status': 'assigned',
            'phoneCountryCode': '236',
            'showCountryCodeList': false
        },
        'CG': {
            'status': 'assigned',
            'phoneCountryCode': '242',
            'showCountryCodeList': false
        },
        'CH': {
            'status': 'assigned',
            'phoneCountryCode': '41',
            'showCountryCodeList': true
        },
        'CI': {
            'status': 'assigned',
            'phoneCountryCode': '225',
            'showCountryCodeList': false
        },
        'CK': {
            'status': 'assigned',
            'phoneCountryCode': '682',
            'showCountryCodeList': false
        },
        'CL': {
            'status': 'assigned',
            'phoneCountryCode': '56',
            'showCountryCodeList': false
        },
        'CM': {
            'status': 'assigned',
            'phoneCountryCode': '237',
            'showCountryCodeList': false
        },
        'CN': {
            'status': 'assigned',
            'phoneCountryCode': '86',
            'showCountryCodeList': false
        },
        'CO': {
            'status': 'assigned',
            'phoneCountryCode': '57',
            'showCountryCodeList': false
        },
        'CR': {
            'status': 'assigned',
            'phoneCountryCode': '506',
            'showCountryCodeList': false
        },
        'CU': {
            'status': 'assigned',
            'phoneCountryCode': '53',
            'showCountryCodeList': false
        },
        'CV': {
            'status': 'assigned',
            'phoneCountryCode': '238',
            'showCountryCodeList': false
        },
        'CW': {
            'status': 'assigned',
            'phoneCountryCode': '599',
            'showCountryCodeList': false
        },
        'CX': {
            'status': 'assigned',
            'phoneCountryCode': '61',
            'showCountryCodeList': false
        },
        'CY': {
            'status': 'assigned',
            'phoneCountryCode': '357',
            'showCountryCodeList': false
        },
        'CZ': {
            'status': 'assigned',
            'phoneCountryCode': '420',
            'showCountryCodeList': false
        },
        'DE': {
            'status': 'assigned',
            'phoneCountryCode': '49',
            'showCountryCodeList': false
        },
        'DJ': {
            'status': 'assigned',
            'phoneCountryCode': '253',
            'showCountryCodeList': false
        },
        'DK': {
            'status': 'assigned',
            'phoneCountryCode': '45',
            'showCountryCodeList': true
        },
        'DM': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'DO': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'DZ': {
            'status': 'assigned',
            'phoneCountryCode': '213',
            'showCountryCodeList': false
        },
        'EC': {
            'status': 'assigned',
            'phoneCountryCode': '593',
            'showCountryCodeList': false
        },
        'EE': {
            'status': 'assigned',
            'phoneCountryCode': '372',
            'showCountryCodeList': false
        },
        'EG': {
            'status': 'assigned',
            'phoneCountryCode': '20',
            'showCountryCodeList': false
        },
        'EH': {
            'status': 'assigned',
            'phoneCountryCode': '212',
            'showCountryCodeList': false
        },
        'ER': {
            'status': 'assigned',
            'phoneCountryCode': '291',
            'showCountryCodeList': false
        },
        'ES': {
            'status': 'assigned',
            'phoneCountryCode': '34',
            'showCountryCodeList': false
        },
        'ET': {
            'status': 'assigned',
            'phoneCountryCode': '251',
            'showCountryCodeList': false
        },
        'FI': {
            'status': 'assigned',
            'phoneCountryCode': '358',
            'showCountryCodeList': false
        },
        'FJ': {
            'status': 'assigned',
            'phoneCountryCode': '679',
            'showCountryCodeList': false
        },
        'FK': {
            'status': 'assigned',
            'phoneCountryCode': '500',
            'showCountryCodeList': false
        },
        'FM': {
            'status': 'assigned',
            'phoneCountryCode': '691',
            'showCountryCodeList': false
        },
        'FO': {
            'status': 'assigned',
            'phoneCountryCode': '298',
            'showCountryCodeList': false
        },
        'FR': {
            'status': 'assigned',
            'phoneCountryCode': '33',
            'showCountryCodeList': false
        },
        'GA': {
            'status': 'assigned',
            'phoneCountryCode': '241',
            'showCountryCodeList': false
        },
        'GB': {
            'status': 'assigned',
            'phoneCountryCode': '44',
            'showCountryCodeList': false
        },
        'GD': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'GE': {
            'status': 'assigned',
            'phoneCountryCode': '995',
            'showCountryCodeList': false
        },
        'GF': {
            'status': 'assigned',
            'phoneCountryCode': '594',
            'showCountryCodeList': false
        },
        'GG': {
            'status': 'assigned',
            'phoneCountryCode': '44',
            'showCountryCodeList': false
        },
        'GH': {
            'status': 'assigned',
            'phoneCountryCode': '233',
            'showCountryCodeList': false
        },
        'GI': {
            'status': 'assigned',
            'phoneCountryCode': '350',
            'showCountryCodeList': false
        },
        'GL': {
            'status': 'assigned',
            'phoneCountryCode': '299',
            'showCountryCodeList': false
        },
        'GM': {
            'status': 'assigned',
            'phoneCountryCode': '220',
            'showCountryCodeList': false
        },
        'GN': {
            'status': 'assigned',
            'phoneCountryCode': '224',
            'showCountryCodeList': false
        },
        'GP': {
            'status': 'assigned',
            'phoneCountryCode': '590',
            'showCountryCodeList': false
        },
        'GQ': {
            'status': 'assigned',
            'phoneCountryCode': '240',
            'showCountryCodeList': false
        },
        'GR': {
            'status': 'assigned',
            'phoneCountryCode': '30',
            'showCountryCodeList': false
        },
        'GS': {
            'status': 'assigned',
            'phoneCountryCode': '500',
            'showCountryCodeList': false
        },
        'GT': {
            'status': 'assigned',
            'phoneCountryCode': '502',
            'showCountryCodeList': false
        },
        'GU': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'GW': {
            'status': 'assigned',
            'phoneCountryCode': '245',
            'showCountryCodeList': false
        },
        'GY': {
            'status': 'assigned',
            'phoneCountryCode': '592',
            'showCountryCodeList': false
        },
        'HK': {
            'status': 'assigned',
            'phoneCountryCode': '852',
            'showCountryCodeList': true
        },
        'HM': {
            'status': 'assigned'
        },
        'HN': {
            'status': 'assigned',
            'phoneCountryCode': '504',
            'showCountryCodeList': false
        },
        'HR': {
            'status': 'assigned',
            'phoneCountryCode': '385',
            'showCountryCodeList': false
        },
        'HT': {
            'status': 'assigned',
            'phoneCountryCode': '509',
            'showCountryCodeList': false
        },
        'HU': {
            'status': 'assigned',
            'phoneCountryCode': '36',
            'showCountryCodeList': false
        },
        'ID': {
            'status': 'assigned',
            'phoneCountryCode': '62',
            'showCountryCodeList': false
        },
        'IE': {
            'status': 'assigned',
            'phoneCountryCode': '353',
            'showCountryCodeList': false
        },
        'IL': {
            'status': 'assigned',
            'phoneCountryCode': '972',
            'showCountryCodeList': false
        },
        'IM': {
            'status': 'assigned',
            'phoneCountryCode': '44',
            'showCountryCodeList': false
        },
        'IN': {
            'status': 'assigned',
            'phoneCountryCode': '91',
            'showCountryCodeList': false
        },
        'IO': {
            'status': 'assigned',
            'phoneCountryCode': '246',
            'showCountryCodeList': false
        },
        'IQ': {
            'status': 'assigned',
            'phoneCountryCode': '964',
            'showCountryCodeList': false
        },
        'IR': {
            'status': 'assigned',
            'phoneCountryCode': '98',
            'showCountryCodeList': false
        },
        'IS': {
            'status': 'assigned',
            'phoneCountryCode': '354',
            'showCountryCodeList': false
        },
        'IT': {
            'status': 'assigned',
            'phoneCountryCode': '39',
            'showCountryCodeList': false
        },
        'JE': {
            'status': 'assigned',
            'phoneCountryCode': '44',
            'showCountryCodeList': false
        },
        'JM': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'JO': {
            'status': 'assigned',
            'phoneCountryCode': '962',
            'showCountryCodeList': false
        },
        'JP': {
            'status': 'assigned',
            'phoneCountryCode': '81',
            'showCountryCodeList': false
        },
        'KE': {
            'status': 'assigned',
            'phoneCountryCode': '254',
            'showCountryCodeList': false
        },
        'KG': {
            'status': 'assigned',
            'phoneCountryCode': '996',
            'showCountryCodeList': false
        },
        'KH': {
            'status': 'assigned',
            'phoneCountryCode': '855',
            'showCountryCodeList': false
        },
        'KI': {
            'status': 'assigned',
            'phoneCountryCode': '686',
            'showCountryCodeList': false
        },
        'KM': {
            'status': 'assigned',
            'phoneCountryCode': '269',
            'showCountryCodeList': false
        },
        'KN': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'KP': {
            'status': 'assigned',
            'phoneCountryCode': '850',
            'showCountryCodeList': false
        },
        'KR': {
            'status': 'assigned',
            'phoneCountryCode': '82',
            'showCountryCodeList': false
        },
        'KW': {
            'status': 'assigned',
            'phoneCountryCode': '965',
            'showCountryCodeList': false
        },
        'KY': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'KZ': {
            'status': 'assigned',
            'phoneCountryCode': '7',
            'showCountryCodeList': false
        },
        'LA': {
            'status': 'assigned',
            'phoneCountryCode': '856',
            'showCountryCodeList': true
        },
        'LB': {
            'status': 'assigned',
            'phoneCountryCode': '961',
            'showCountryCodeList': false
        },
        'LC': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'LI': {
            'status': 'assigned',
            'phoneCountryCode': '423',
            'showCountryCodeList': false
        },
        'LK': {
            'status': 'assigned',
            'phoneCountryCode': '94',
            'showCountryCodeList': false
        },
        'LR': {
            'status': 'assigned',
            'phoneCountryCode': '231',
            'showCountryCodeList': false
        },
        'LS': {
            'status': 'assigned',
            'phoneCountryCode': '266',
            'showCountryCodeList': false
        },
        'LT': {
            'status': 'assigned',
            'phoneCountryCode': '370',
            'showCountryCodeList': false
        },
        'LU': {
            'status': 'assigned',
            'phoneCountryCode': '352',
            'showCountryCodeList': false
        },
        'LV': {
            'status': 'assigned',
            'phoneCountryCode': '371',
            'showCountryCodeList': false
        },
        'LY': {
            'status': 'assigned',
            'phoneCountryCode': '218',
            'showCountryCodeList': false
        },
        'MA': {
            'status': 'assigned',
            'phoneCountryCode': '212',
            'showCountryCodeList': false
        },
        'MC': {
            'status': 'assigned',
            'phoneCountryCode': '377',
            'showCountryCodeList': false
        },
        'MD': {
            'status': 'assigned',
            'phoneCountryCode': '373',
            'showCountryCodeList': false
        },
        'ME': {
            'status': 'assigned',
            'phoneCountryCode': '382',
            'showCountryCodeList': false
        },
        'MF': {
            'status': 'assigned',
            'phoneCountryCode': '590',
            'showCountryCodeList': false
        },
        'MG': {
            'status': 'assigned',
            'phoneCountryCode': '261',
            'showCountryCodeList': false
        },
        'MH': {
            'status': 'assigned',
            'phoneCountryCode': '692',
            'showCountryCodeList': false
        },
        'MK': {
            'status': 'assigned',
            'phoneCountryCode': '389',
            'showCountryCodeList': false
        },
        'ML': {
            'status': 'assigned',
            'phoneCountryCode': '223',
            'showCountryCodeList': false
        },
        'MM': {
            'status': 'assigned',
            'phoneCountryCode': '95',
            'showCountryCodeList': false
        },
        'MN': {
            'status': 'assigned',
            'phoneCountryCode': '976',
            'showCountryCodeList': false
        },
        'MO': {
            'status': 'assigned',
            'phoneCountryCode': '853',
            'showCountryCodeList': false
        },
        'MP': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'MQ': {
            'status': 'assigned',
            'phoneCountryCode': '596',
            'showCountryCodeList': false
        },
        'MR': {
            'status': 'assigned',
            'phoneCountryCode': '222',
            'showCountryCodeList': false
        },
        'MS': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'MT': {
            'status': 'assigned',
            'phoneCountryCode': '356',
            'showCountryCodeList': false
        },
        'MU': {
            'status': 'assigned',
            'phoneCountryCode': '230',
            'showCountryCodeList': false
        },
        'MV': {
            'status': 'assigned',
            'phoneCountryCode': '960',
            'showCountryCodeList': false
        },
        'MW': {
            'status': 'assigned',
            'phoneCountryCode': '265',
            'showCountryCodeList': false
        },
        'MX': {
            'status': 'assigned',
            'phoneCountryCode': '52',
            'showCountryCodeList': false
        },
        'MY': {
            'status': 'assigned',
            'phoneCountryCode': '60',
            'showCountryCodeList': false
        },
        'MZ': {
            'status': 'assigned',
            'phoneCountryCode': '258',
            'showCountryCodeList': false
        },
        'NA': {
            'status': 'assigned',
            'phoneCountryCode': '264',
            'showCountryCodeList': false
        },
        'NC': {
            'status': 'assigned',
            'phoneCountryCode': '687',
            'showCountryCodeList': false
        },
        'NE': {
            'status': 'assigned',
            'phoneCountryCode': '227',
            'showCountryCodeList': false
        },
        'NF': {
            'status': 'assigned',
            'phoneCountryCode': '672',
            'showCountryCodeList': false
        },
        'NG': {
            'status': 'assigned',
            'phoneCountryCode': '234',
            'showCountryCodeList': false
        },
        'NI': {
            'status': 'assigned',
            'phoneCountryCode': '505',
            'showCountryCodeList': false
        },
        'NL': {
            'status': 'assigned',
            'phoneCountryCode': '31',
            'showCountryCodeList': true
        },
        'NO': {
            'status': 'assigned',
            'phoneCountryCode': '47',
            'showCountryCodeList': true
        },
        'NP': {
            'status': 'assigned',
            'phoneCountryCode': '977',
            'showCountryCodeList': false
        },
        'NR': {
            'status': 'assigned',
            'phoneCountryCode': '674',
            'showCountryCodeList': false
        },
        'NU': {
            'status': 'assigned',
            'phoneCountryCode': '683',
            'showCountryCodeList': false
        },
        'NZ': {
            'status': 'assigned',
            'phoneCountryCode': '64',
            'showCountryCodeList': false
        },
        'OM': {
            'status': 'assigned',
            'phoneCountryCode': '968',
            'showCountryCodeList': false
        },
        'PA': {
            'status': 'assigned',
            'phoneCountryCode': '507',
            'showCountryCodeList': false
        },
        'PE': {
            'status': 'assigned',
            'phoneCountryCode': '51',
            'showCountryCodeList': false
        },
        'PF': {
            'status': 'assigned',
            'phoneCountryCode': '689',
            'showCountryCodeList': false
        },
        'PG': {
            'status': 'assigned',
            'phoneCountryCode': '675',
            'showCountryCodeList': false
        },
        'PH': {
            'status': 'assigned',
            'phoneCountryCode': '63',
            'showCountryCodeList': false
        },
        'PK': {
            'status': 'assigned',
            'phoneCountryCode': '92',
            'showCountryCodeList': false
        },
        'PL': {
            'status': 'assigned',
            'phoneCountryCode': '48',
            'showCountryCodeList': true
        },
        'PM': {
            'status': 'assigned',
            'phoneCountryCode': '508',
            'showCountryCodeList': false
        },
        'PN': {
            'status': 'assigned',
            'phoneCountryCode': '870',
            'showCountryCodeList': false
        },
        'PR': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'PS': {
            'status': 'assigned',
            'phoneCountryCode': '970',
            'showCountryCodeList': false
        },
        'PT': {
            'status': 'assigned',
            'phoneCountryCode': '351',
            'showCountryCodeList': false
        },
        'PW': {
            'status': 'assigned',
            'phoneCountryCode': '680',
            'showCountryCodeList': false
        },
        'PY': {
            'status': 'assigned',
            'phoneCountryCode': '595',
            'showCountryCodeList': false
        },
        'QA': {
            'status': 'assigned',
            'phoneCountryCode': '974',
            'showCountryCodeList': false
        },
        'RE': {
            'status': 'assigned',
            'phoneCountryCode': '262',
            'showCountryCodeList': false
        },
        'RO': {
            'status': 'assigned',
            'phoneCountryCode': '40',
            'showCountryCodeList': false
        },
        'RS': {
            'status': 'assigned',
            'phoneCountryCode': '381',
            'showCountryCodeList': false
        },
        'RU': {
            'status': 'assigned',
            'phoneCountryCode': '7',
            'showCountryCodeList': false
        },
        'RW': {
            'status': 'assigned',
            'phoneCountryCode': '250',
            'showCountryCodeList': false
        },
        'SA': {
            'status': 'assigned',
            'phoneCountryCode': '966',
            'showCountryCodeList': false
        },
        'SB': {
            'status': 'assigned',
            'phoneCountryCode': '677',
            'showCountryCodeList': false
        },
        'SC': {
            'status': 'assigned',
            'phoneCountryCode': '248',
            'showCountryCodeList': false
        },
        'SD': {
            'status': 'assigned',
            'phoneCountryCode': '249',
            'showCountryCodeList': false
        },
        'SE': {
            'status': 'assigned',
            'phoneCountryCode': '46',
            'showCountryCodeList': true
        },
        'SG': {
            'status': 'assigned',
            'phoneCountryCode': '65',
            'showCountryCodeList': true
        },
        'SH': {
            'status': 'assigned',
            'phoneCountryCode': '290',
            'showCountryCodeList': false
        },
        'SI': {
            'status': 'assigned',
            'phoneCountryCode': '386',
            'showCountryCodeList': false
        },
        'SJ': {
            'status': 'assigned',
            'phoneCountryCode': '47',
            'showCountryCodeList': false
        },
        'SK': {
            'status': 'assigned',
            'phoneCountryCode': '421',
            'showCountryCodeList': false
        },
        'SL': {
            'status': 'assigned',
            'phoneCountryCode': '232',
            'showCountryCodeList': false
        },
        'SM': {
            'status': 'assigned',
            'phoneCountryCode': '378',
            'showCountryCodeList': false
        },
        'SN': {
            'status': 'assigned',
            'phoneCountryCode': '221',
            'showCountryCodeList': false
        },
        'SO': {
            'status': 'assigned',
            'phoneCountryCode': '252',
            'showCountryCodeList': false
        },
        'SR': {
            'status': 'assigned',
            'phoneCountryCode': '597',
            'showCountryCodeList': false
        },
        'SS': {
            'status': 'assigned',
            'phoneCountryCode': '211',
            'showCountryCodeList': false
        },
        'ST': {
            'status': 'assigned',
            'phoneCountryCode': '239',
            'showCountryCodeList': false
        },
        'SV': {
            'status': 'assigned',
            'phoneCountryCode': '503',
            'showCountryCodeList': false
        },
        'SX': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'SY': {
            'status': 'assigned',
            'phoneCountryCode': '963',
            'showCountryCodeList': false
        },
        'SZ': {
            'status': 'assigned',
            'phoneCountryCode': '268',
            'showCountryCodeList': false
        },
        'TC': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'TD': {
            'status': 'assigned',
            'phoneCountryCode': '235',
            'showCountryCodeList': false
        },
        'TF': {
            'status': 'assigned',
            'phoneCountryCode': '262',
            'showCountryCodeList': false
        },
        'TG': {
            'status': 'assigned',
            'phoneCountryCode': '228',
            'showCountryCodeList': false
        },
        'TH': {
            'status': 'assigned',
            'phoneCountryCode': '66',
            'showCountryCodeList': false
        },
        'TJ': {
            'status': 'assigned',
            'phoneCountryCode': '992',
            'showCountryCodeList': false
        },
        'TK': {
            'status': 'assigned',
            'phoneCountryCode': '690',
            'showCountryCodeList': false
        },
        'TL': {
            'status': 'assigned',
            'phoneCountryCode': '670',
            'showCountryCodeList': false
        },
        'TM': {
            'status': 'assigned',
            'phoneCountryCode': '993',
            'showCountryCodeList': false
        },
        'TN': {
            'status': 'assigned',
            'phoneCountryCode': '216',
            'showCountryCodeList': false
        },
        'TO': {
            'status': 'assigned',
            'phoneCountryCode': '676',
            'showCountryCodeList': false
        },
        'TR': {
            'status': 'assigned',
            'phoneCountryCode': '90',
            'showCountryCodeList': true
        },
        'TT': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'TV': {
            'status': 'assigned',
            'phoneCountryCode': '688',
            'showCountryCodeList': false
        },
        'TW': {
            'status': 'assigned',
            'phoneCountryCode': '886',
            'showCountryCodeList': true
        },
        'TZ': {
            'status': 'assigned',
            'phoneCountryCode': '255',
            'showCountryCodeList': false
        },
        'UA': {
            'status': 'assigned',
            'phoneCountryCode': '380',
            'showCountryCodeList': false
        },
        'UG': {
            'status': 'assigned',
            'phoneCountryCode': '256',
            'showCountryCodeList': false
        },
        'UM': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'US': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false,
            'hideInOtherCountries': true
        },
        'UY': {
            'status': 'assigned',
            'phoneCountryCode': '598',
            'showCountryCodeList': false
        },
        'UZ': {
            'status': 'assigned',
            'phoneCountryCode': '998',
            'showCountryCodeList': false
        },
        'VA': {
            'status': 'assigned',
            'phoneCountryCode': '39',
            'showCountryCodeList': false
        },
        'VC': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'VE': {
            'status': 'assigned',
            'phoneCountryCode': '58',
            'showCountryCodeList': false
        },
        'VG': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'VI': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'VN': {
            'status': 'assigned',
            'phoneCountryCode': '84',
            'showCountryCodeList': false
        },
        'VU': {
            'status': 'assigned',
            'phoneCountryCode': '678',
            'showCountryCodeList': false
        },
        'WF': {
            'status': 'assigned',
            'phoneCountryCode': '681',
            'showCountryCodeList': false
        },
        'WS': {
            'status': 'assigned',
            'phoneCountryCode': '685',
            'showCountryCodeList': false
        },
        'YE': {
            'status': 'assigned',
            'phoneCountryCode': '967',
            'showCountryCodeList': false
        },
        'YT': {
            'status': 'assigned',
            'phoneCountryCode': '262',
            'showCountryCodeList': false
        },
        'ZA': {
            'status': 'assigned',
            'phoneCountryCode': '27',
            'showCountryCodeList': false
        },
        'ZM': {
            'status': 'assigned',
            'phoneCountryCode': '260',
            'showCountryCodeList': false
        },
        'ZW': {
            'status': 'assigned',
            'phoneCountryCode': '263',
            'showCountryCodeList': false
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInput/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/phone/phoneInput/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInputB/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInputA/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoPhoneInput', {
    tag: 'xo-phone-input',
    template: _template2['default'],

    props: {
        phone: {
            type: 'var',
            reqiured: false
        },

        showPhoneType: {
            type: 'var',
            optional: true,
            'default': true
        },

        hideWork: {
            type: 'var',
            optional: true,
            'default': false
        },

        token: {
            type: 'var',
            optional: true
        },

        exclude: {
            type: 'var',
            optional: true
        },

        hidePhoneType: {
            type: 'var',
            optional: true,
            'default': false
        },

        country: {
            type: 'var',
            optional: true
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            var getTreatment = function getTreatment() {

                if ((0, _squid.$feature)('showNewPhoneDesign', false, _squid.$locale.country)) {
                    return true;
                }

                var throttle = void 0;

                if (_squid.$config['newPhoneDesignThrottle']) {

                    throttle = _squid.$config['newPhoneDesignThrottle']['DEFAULT'];

                    if (_squid.$config['newPhoneDesignThrottle'][_squid.$locale.country] >= 0) {
                        throttle = _squid.$config['newPhoneDesignThrottle'][_squid.$locale.country];
                    }
                }

                var id = _squid.$locale.country + _angular.$rootScope.token;
                return throttle !== undefined && (0, _squid.$experiment)('new_phone_design_exp', throttle, id, {}) ? true : false;
            };

            this.treatment = getTreatment();

            this.$watch('showPhoneType', function () {
                _this.hidePhoneType = _this.showPhoneType === false;
            }, true);
        }
    }

});


_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_squid.$experiment;

_squid.$config;

_squid.$feature;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInput/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-phone-input-a ng-if=\"!treatment\" token=\"token\" phone=\"phone\"\n                  show-phone-type=\"showPhoneType\" exclude=\"exclude\" country=\"country\"></xo-phone-input-a>\n<xo-phone-input-b ng-if=\"treatment\" phone=\"phone\" hide-phone-type=\"hidePhoneType\" show-phone-type=\"showPhoneType\"\n                  hide-work=\"hideWork\"></xo-phone-input-b>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInputA/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/floating-label/directive.js");

var _territoriesByCode = __webpack_require__("../node_modules/xo-form-components/src/phone/lib/territoriesByCode.js");

var _territoriesByCode2 = _interopRequireDefault(_territoriesByCode);

__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInputA/styles.less");

var _template = __webpack_require__("../node_modules/xo-form-components/src/phone/phoneInputA/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoPhoneInputA', function () {
    return {
        template: _template2['default'],
        scope: {
            phone: '=?',
            showPhoneType: '=?',
            exclude: '@?',
            country: '=?'
        },

        link: function link(scope, element, attr, controller) {
            element.on('keyup', function (event) {
                element.find('.telephone').mask(scope.mask, {
                    'translation': {
                        0: { pattern: /[0-9]/ }
                    }
                });
            });
        },

        controller: ['$scope', function ($scope) {
            $scope.locale = _squid.$locale;
            $scope.IntDialingCodes = _territoriesByCode2['default'];
            $scope.defaultCountryPhoneCode = _territoriesByCode2['default'][_squid.$locale.country];
            $scope.showPhoneType = (0, _squid.$feature)('phoneType', true, $scope.country) && $scope.showPhoneType !== false;

            // dont display countries that are tagged with hideInOtherCountries flag in territoriesByCode.js.
            // if localeCountry and dropdown country are same ignore hideInOtherCountries and display the countrycode.
            $scope.hideCountry = function (dropdownCountry, hideInOtherCountries) {
                return _squid.$locale.country !== dropdownCountry && hideInOtherCountries;
            };

            $scope.phone = $scope.phone || {};
            $scope.phone.phoneType = $scope.phone.phoneType || 'Mobile';
            $scope.phone.IntDialingCountryCode = $scope.defaultCountryPhoneCode.phoneCountryCode;

            angular.extend($scope.phone, {
                phoneCountryCode: _squid.$locale.country
            });

            function getPhoneMask(phoneType, phoneEntry) {
                var defaultMask = '0000000000000000';
                var masks = phoneEntry && phoneEntry.masks;
                var mobileMask = masks && masks.MOBILE ? masks.MOBILE : defaultMask;
                var fixedLineMask = masks && masks.FIXED_LINE ? masks.FIXED_LINE : defaultMask;
                return phoneType === 'Mobile' ? mobileMask : fixedLineMask;
            }

            function getPhonePattern(phoneEntry) {
                var defaultPattern = '^[0-9]+$';
                var patterns = phoneEntry && phoneEntry.patterns;
                // less stric regex validation in place for now, just use general regex to match mobile AND fixed-line formats
                // for now we use less strict regex validation because we are not ready for this more strict validation
                if (patterns) {
                    return patterns.GENERAL ? patterns.GENERAL : defaultPattern;
                }
                return defaultPattern;

                // more strict regex validaiton based on phone type is found commented below
                // var ret;
                // switch ($scope.phone.phoneType) {
                //     case 'Mobile':
                //         ret = patterns.MOBILE;
                //         break;
                //     case 'Home':
                //     case 'Work':
                //         ret = patterns.FIXED_LINE;
                //         break;
                //     default:
                //         ret = patterns.GENERAL;
                //         break;
                // }
                // return ret ? ret : defaultPattern;
            }

            function populatePhoneMetadata() {
                if (!$scope.metadata || $scope.metadata.country !== _squid.$locale.metadata.country) {
                    $scope.metadata = angular.copy(_squid.$locale.metadata);
                }
                var phoneEntry = $scope.metadata.phoneEntry;
                $scope.mask = getPhoneMask($scope.phone.phoneType, phoneEntry);
                $scope.pattern = getPhonePattern(phoneEntry);
            }

            populatePhoneMetadata();

            // Reset the phone number mask from according to the phone type
            $scope.phoneTypeChanged = function () {
                $scope.mask = getPhoneMask($scope.phone.phoneType, $scope.metadata.phoneEntry);
                $scope.pattern = getPhonePattern($scope.metadata.phoneEntry);
                $('.telephone').mask($scope.mask);
            };

            $scope.$watch('phone.phoneCountryCode', function (newValue) {
                $scope.phone.IntDialingCountryCode = _territoriesByCode2['default'][newValue].phoneCountryCode;
            });

            $scope.$on('localeChange', function () {
                $scope.defaultCountryPhoneCode = _territoriesByCode2['default'][_squid.$locale.country];
                $scope.phone.phoneCountryCode = _squid.$locale.country;
                if (!$scope.metadata || $scope.metadata.country !== _squid.$locale.metadata.country) {
                    populatePhoneMetadata();
                    $('.telephone').mask($scope.mask);
                }
            });

            $scope.$watch('country', function (newVal) {
                if (newVal) {
                    $scope.defaultCountryPhoneCode = _territoriesByCode2['default'][$scope.country];
                    $scope.phone.phoneCountryCode = $scope.country;

                    if (!$scope.metadata || $scope.metadata.country !== $scope.country) {

                        $scope.metadata = _squid.$MetadataModel.create();
                        $scope.metadata.choose($scope.country, _squid.$locale.lang).then(function () {

                            var phoneEntry = $scope.metadata.phoneEntry;
                            $scope.mask = getPhoneMask($scope.phone.phoneType, phoneEntry);
                            $scope.pattern = getPhonePattern(phoneEntry);

                            $('.telephone').mask($scope.mask);
                        });
                    }
                }
            });

            $scope.showWork = $scope.exclude === 'WORK';
        }]
    };
});

_squid.$feature;

_squid.$locale;

_squid.$MetadataModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInputA/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInputA/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"row-fluid fieldGroup clearfix\" ng-class=\"{countryCodeSelect: defaultCountryPhoneCode.showCountryCodeList === true}\" content>\n    <div id=\"phoneTypeContainer\" class=\"phoneTypeContainer dropdown confidential inputField half\" ng-cloak\n         ng-if=\"showPhoneType === true\" ng-class=\"{'rtlPhoneType': locale.metadata.directionality === 'rtl'}\"\n         floating-label-dropdown>\n        <select xo-dropdown ng-model=\"phone.phoneType\" name=\"phoneType\" id=\"phoneType\" ng-change=\"phoneTypeChanged()\" xo-error-tooltip>\n            <option value=\"Mobile\" selected=\"\">{{content('common.mobile')}}</option>\n            <option value=\"Home\">{{content('common.home')}}</option>\n            <option ng-if=\"!showWork\" value=\"Work\">{{content('common.work')}}</option>\n        </select>\n        <label for=\"phoneType\" id=\"phoneTypeLabel\">{{content('common.phoneType')}}</label>\n    </div>\n\n    <div id=\"phoneCodeContainer\" class=\"phoneCodeContainer dropdown confidential half last-child inputField\" ng-cloak\n         ng-if=\"defaultCountryPhoneCode.showCountryCodeList\" floating-label-dropdown>\n        <select xo-dropdown ng-model=\"phone.phoneCountryCode\" name=\"phoneCountryCode\" id=\"phoneCountryCode\" aria-required=\"true\" xo-error-tooltip required>\n            <option ng-repeat=\"(key, value) in IntDialingCodes track by $index\" value=\"{{key}}\" ng-if=\"!hideCountry(key, value.hideInOtherCountries)\" ng-selected=\"phone.phoneCountryCode === key\">{{value.phoneCountryCode}} ({{key}})</option>\n        </select>\n        <label for=\"phoneCountryCode\" id=\"phoneCodeLabel\">{{content('common.phoneCountryCode')}}</label>\n    </div>\n\n    <div class=\"inputField confidential last-child\"\n         ng-class=\"{'half': showPhoneType || defaultCountryPhoneCode.showCountryCodeList, 'telephoneField': showPhoneType,\n         'telephoneFieldFull': !showPhoneType, 'rtlPhoneField': locale.metadata.directionality === 'rtl',\n         singleLineMobile: !showPhoneType && !defaultCountryPhoneCode.showCountryCodeList}\" floating-label directionality >\n\n        <input id=\"telephone\"\n               class=\"telephone\"\n               type=\"tel\"\n               ng-model=\"phone.telephone\"\n               name=\"telephone\"\n               value=\"\"\n               autocapitalize=\"off\"\n               autocomplete=\"off\"\n               aria-required=\"true\"\n               country-code=\"phone.phoneCountryCode\"\n               phone-pattern=\"{{pattern}}\"\n               xo-validation='{\"validator\": \"validPhone\"}'\n               data-error-key=\"validation.validPhone\"\n               maxlength=\"{{mask.length}}\"\n               required\n               xo-error-tooltip />\n        <label for=\"telephone\" class=\"focus\">{{content('common.phone')}}</label>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInputB/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/phone/phoneInputB/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInputB/styles.less");

__webpack_require__("../node_modules/xo-jquery-mask-plugin/dist/jquery.mask.min.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var MOBILE = 'Mobile';
var KEYS = {
    ENTER: 13,
    UP: 38,
    DOWN: 40,
    TAB: 9,
    ESC: 27,
    A: 65,
    Z: 90,
    SPACE: 32
};

var query = '';
var queryTimer = null;

exports['default'] = _squid.$Component.extend('$xoPhoneInputB', {
    tag: 'xo-phone-input-b',
    template: _template2['default'],

    props: {
        phone: {
            type: 'var',
            required: false
        },

        hidePhoneType: {
            type: 'var',
            required: false
        },

        hideWork: {
            type: 'var',
            required: false,
            'default': false
        }
    },

    actions: {

        // return the phonePattern
        getPhonePattern: function getPhonePattern(phoneEntry) {
            var DEFAULT_PATTERN = '^[0-9]+$';
            var patterns = phoneEntry && phoneEntry.patterns;
            // less strict regex validation in place for now, just use general regex to match mobile AND fixed-line
            // formats
            // for now we use less strict regex validation because we are not ready for this more strict validation
            return patterns && patterns.GENERAL ? patterns.GENERAL : DEFAULT_PATTERN;
        },


        // return phoneMask based on phone Type
        getPhoneMask: function getPhoneMask(phoneType, phoneEntry) {
            var DEFAULT_MASK = '0000000000000000';
            var masks = phoneEntry && phoneEntry.masks;

            if (phoneType === MOBILE) {
                return masks && masks.MOBILE ? masks.MOBILE : DEFAULT_MASK;
            } else {
                return masks && masks.FIXED_LINE ? masks.FIXED_LINE : DEFAULT_MASK;
            }
        },


        // set the phone number mask and pattern
        updatePhoneMaskAndPattern: function updatePhoneMaskAndPattern() {
            var country = this.metadata.localization.country;
            // If phoneCountry does not match the country the metadata is from then
            // we set phoneEntry to a falsey value so the default pattern and mask are
            // used for the phone input.

            var phoneEntry = this.phoneCountry === country && this.metadata.phoneEntry;

            this.mask = this.actions.getPhoneMask(this.phone.phoneType, phoneEntry);
            this.pattern = this.actions.getPhonePattern(phoneEntry);
            this.actions.applyMaskOnPhoneInput();
        },
        getPhoneDialingCode: function getPhoneDialingCode(territory, state) {
            var overrides = this.metadata.regionalOverrides;

            if (state && overrides && overrides.hasOwnProperty(state) && overrides[state].props.internationalDialingCode) {
                return overrides[state].props.internationalDialingCode;
            }

            return territory.internationalDialingCode;
        },


        // fetch the passed country's international dialing code
        updateDialingCodeAndCountry: function updateDialingCodeAndCountry() {
            var territory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var state = arguments[1];

            this.phoneCountry = territory.code;
            this.phone.IntDialingCountryCode = this.actions.getPhoneDialingCode(territory, state);
            (0, _jquery2['default'])('.fixedCode').text('+' + this.phone.IntDialingCountryCode);
        },


        /* if user chooses a different dialing code -
         -. fetch the new country's metadata
         -. update phone Country and dialing code
         -. update the phone number mask and pattern (no explicit call as it happens when metadata updates)
         -. close the dropdown if open
         */
        updatePhoneFieldMetadata: function updatePhoneFieldMetadata() {
            var territory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var state = arguments[1];

            // create a local copy of metadata (only happens on initial load)
            if (!this.metadata) {
                this.metadata = _squid.$MetadataModel.instance(0, {
                    'noBroadcast': true
                });
            }

            this.metadata.choose(territory.code);

            this.actions.updateDialingCodeAndCountry(territory, state);
            // Whenever metadata is updated that is promise returns then the metadata listener will update the mask
            // and pattern so not calling it here. Moving on...

            // close the dropdown if open
            if (this.listVisible) {
                this.actions.collapseListAndFocusOnParent();
            }

            _logger.$logger.info('phone_country_code_updated', {
                territory: territory.code
            });
        },
        getTerritoryDataFromMetadata: function getTerritoryDataFromMetadata(country) {
            return _squid.$util.find(this.dialingCodeList, function (_ref) {
                var code = _ref.code;
                return code === country;
            });
        },


        // set the stage on first load or on locale change
        init: function init(country) {
            this.hidePhoneType = this.hidePhoneType || (0, _squid.$feature)('hidePhoneType', false, country);

            this.showDialingCodeContainer = (0, _squid.$feature)('showDialingCodeContainer', false, country);

            this.listVisible = false;

            // default the phone type to Mobile if not specified
            // Note: this.phone is not optional
            this.phone = this.phone || {};

            this.phone.phoneType = this.phone.phoneType || 'Mobile';

            // populate the dialing code list/options
            var _$locale$metadata = _squid.$locale.metadata,
                _$locale$metadata$ter = _$locale$metadata.territory,
                territory = _$locale$metadata$ter === undefined ? [] : _$locale$metadata$ter,
                _$locale$metadata$add = _$locale$metadata.additionalDialingCodes,
                additionalDialingCodes = _$locale$metadata$add === undefined ? [] : _$locale$metadata$add;
            var _$config$dialingCodeB = _squid.$config.dialingCodeBlacklist,
                dialingCodeBlacklist = _$config$dialingCodeB === undefined ? [] : _$config$dialingCodeB;

            // Merge dialing codes from supported countries with dialing codes from
            // assigned countries and then filtering countries that are blacklisted

            this.dialingCodeList = territory.concat(additionalDialingCodes).filter(function (_ref2) {
                var code = _ref2.code;
                return !dialingCodeBlacklist.includes(code);
            }).sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
            var territoryData = this.actions.getTerritoryDataFromMetadata(this.phone.phoneCountry || country);

            this.actions.updatePhoneFieldMetadata(territoryData);
        },


        // helper to show the options list and focus on the selected phone country option
        expandList: function expandList() {
            (0, _jquery2['default'])('.country-list').show();
            this.listVisible = true;
            (0, _jquery2['default'])('.country-list .country.selected').focus();
        },


        // helper to collapse the options
        collapseList: function collapseList() {
            this.listVisible = false;
            (0, _jquery2['default'])('.country-list').hide();
        },


        // helper to collapse the options and xfer focus back to the parent dropdown
        collapseListAndFocusOnParent: function collapseListAndFocusOnParent() {
            this.actions.collapseList();
            (0, _jquery2['default'])('#dialingCodeContainer div.selected-flag').focus();
        },


        // helper to toggle the dropdown list
        toggleList: function toggleList() {
            if (this.listVisible) {
                this.actions.collapseListAndFocusOnParent();
            } else {
                this.actions.expandList();
            }
        },


        // remove highlighting from other list items and highlight the given item
        highlightListItem: function highlightListItem(listItem) {
            (0, _jquery2['default'])('li.country').removeClass('highlight');
            listItem.addClass('highlight');
            listItem.focus();
        },

        // select the given item and update the phone field metadata
        selectListItem: function selectListItem(listItem) {
            var country = listItem.attr('data-country-code');
            var territory = this.actions.getTerritoryDataFromMetadata(country);

            this.actions.updatePhoneFieldMetadata(territory);
        },

        // find the first list item whose name starts with the query string
        searchForCountry: function searchForCountry(queryString) {
            for (var i = 0; i < this.dialingCodeList.length; i++) {
                if (this.actions.startsWith(this.dialingCodeList[i].name, queryString)) {

                    var listItem = (0, _jquery2['default'])('.country-list').find('[data-country-code="' + this.dialingCodeList[i].code + '"]');
                    // update highlighting and scroll
                    this.actions.highlightListItem(listItem);
                    break;
                }
            }
        },

        // check if (uppercase) string a starts with string b
        startsWith: function startsWith(a, b) {
            return a.substr(0, b.length).toUpperCase() === b;
        },

        // When Switching between double Byte -> Single Byte character
        // angular model is not properly updated by jquery-mask (PPPLMER-52127)
        // re-update the model with entered value.
        updateAngularModel: function updateAngularModel() {
            if (this.phone.ispreFill) {
                // We set the flag to false once the prefill is completed.
                // This helps to update angular model properly upon next keyUp()
                this.phone.ispreFill = false;
            } else {
                this.phone.telephone = this.$element.find('.telephone').val();
            }
        },

        // format the phone number
        applyMaskOnPhoneInput: function applyMaskOnPhoneInput() {
            // If `this.mask` is `undefined` and we try to mask this field
            // jQuery mask will throw a type error when it tries to access
            // `mask.length` during a for loop.
            if (!this.mask) {
                return;
            }

            this.actions.updateAngularModel();

            this.$element.find('.telephone').mask(this.mask, {
                'translation': {
                    0: { pattern: /[0-9]/ }
                }
            });
        },

        // highlight the event target
        handleListMouseover: function handleListMouseover($event) {
            this.actions.highlightListItem((0, _jquery2['default'])($event.target));
        },

        // expand the list when down arrow is pressed
        handleKeyboardInputForDropdown: function handleKeyboardInputForDropdown($event) {

            var key = $event.which;
            if (key === KEYS.DOWN || key === KEYS.UP || key === KEYS.SPACE) {
                $event.stopPropagation();
                $event.preventDefault();
                this.actions.expandList();
            } else {
                this.actions.collapseList();
            }
        },

        /*
         navigating list using the keyboard
         up, down, esc, enter and letter keys
         */
        handleKeyboardInputForList: function handleKeyboardInputForList($event) {
            var $listItems = (0, _jquery2['default'])('li.country');
            var key = $event.which;
            var $selected = (0, _jquery2['default'])($event.target);
            var $current = void 0;

            $event.stopPropagation();
            $event.preventDefault();

            // if user types in an input, focus on the first country starting with that query
            // upper case letters (since keyup/keydown only return upper case letters)
            if (key >= KEYS.A && key <= KEYS.Z) {
                if (queryTimer) {
                    _angular.$timeout.cancel(queryTimer);
                }

                query += String.fromCharCode(key);
                this.actions.searchForCountry(query);

                queryTimer = (0, _angular.$timeout)(function () {
                    query = '';
                }, 1e3);

                return;
            }

            // ignore other keys
            if (key !== KEYS.DOWN && key !== KEYS.UP && key !== KEYS.ENTER && key !== KEYS.ESC) {
                return;
            }

            // select the the new phone country when user hits enter
            if (key === KEYS.ENTER) {
                this.actions.selectListItem($selected);
                return;
            }

            // close the list if escape is pressed
            if (key === KEYS.ESC) {
                this.actions.collapseListAndFocusOnParent();
                return;
            }

            // highlight the next/prev element when arrow key is pressed
            if (key === KEYS.DOWN) // Down key
                {
                    if (!$selected.length || $selected.is(':last-child')) {
                        $current = $listItems.eq(0);
                    } else {
                        $current = $selected.next();
                    }
                }

            // Up key
            if (key === KEYS.UP) {
                if (!$selected.length || $selected.is(':first-child')) {
                    $current = $listItems.last();
                } else {
                    $current = $selected.prev();
                }
            }

            this.actions.highlightListItem($current);
        }
    },

    lifecycle: {
        enter: function enter() {
            this.actions.init(_squid.$locale.country);
        },
        populate: function populate() {
            var _this = this;

            this.$on('localeChange', function () {
                _this.actions.init(_squid.$locale.country);
            });

            // update the phone mask and pattern when metadata is changed
            this.$watch('metadata', function () {
                _this.actions.updatePhoneMaskAndPattern();
            }, true);

            // update the mask when .telephone val changes either programatically or via user action
            this.$watch('this.phone.telephone', function (newVal) {
                if (newVal) {
                    _this.$element.find('.telephone').val(newVal).trigger('input');
                }
            }, true);

            var addressChangeEvent = _angular.$rootScope.$on('billingAddressStateChange', function (e, address) {
                var territory = _this.actions.getTerritoryDataFromMetadata(_this.metadata.country);
                _this.actions.updatePhoneFieldMetadata(territory, address.state);
            });

            this.$on('$destroy', addressChangeEvent);

            // hide the dropdown list if a click occurs anywhere else on the page
            (0, _jquery2['default'])('*').on('click', function (event) {
                if (!(0, _jquery2['default'])('#dialingCodeContainer div.selected-flag').is((0, _jquery2['default'])(event.target))) {
                    _this.actions.collapseList();
                }
            });
        }
    }
});


_angular.$rootScope;

_angular.$timeout;

_squid.$Component;

_squid.$locale;

_squid.$feature;

_squid.$util;

_squid.$MetadataModel;

_squid.$config;

_logger.$logger;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInputB/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInputB/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"row-fluid fieldGroup clearfix\" content>\n    <div ng-if=\"hidePhoneType !== true\"\n         id=\"phoneTypeContainer\"\n         class=\"phoneTypeContainer dropdown confidential inputField half\"\n         ng-class=\"{'rtlPhoneType': locale.metadata.directionality === 'rtl', 'dialCodeVisible': showDialingCodeContainer}\"\n         ng-cloak\n         floating-label-dropdown >\n\n        <select xo-dropdown\n                ng-model=\"phone.phoneType\"\n                name=\"phoneType\"\n                id=\"phoneType\"\n                ng-change=\"actions.updatePhoneMaskAndPattern()\"\n                xo-error-tooltip>\n            <option value=\"Mobile\" selected=\"\">{{content('common.mobile')}}</option>\n            <option value=\"Home\">{{content('common.home')}}</option>\n            <option ng-if=\"!hideWork\" value=\"Work\">{{content('common.work')}}</option>\n        </select>\n\n        <label for=\"phoneType\" id=\"phoneTypeLabel\">{{content('common.phoneType')}}</label>\n    </div>\n\n\n    <div ng-if=\"showDialingCodeContainer\"\n         id=\"dialingCodeContainer\"\n         class=\"dialingCodeContainer dropdown confidential half last-child inputField intl-tel-input\"\n         ng-cloak\n         floating-label-dropdown>\n\n        <div class=\"flag-dropdown\">\n            <div tabindex=\"0\"\n                 class=\"selected-flag\"\n                 title=\"{{ phoneCountry + ' +'+this.phone.IntDialingCountryCode }}\"\n                 ng-keydown=\"actions.handleKeyboardInputForDropdown($event)\"\n                 ng-click=\"actions.toggleList()\">\n                <div class=\"iti-flag {{ phoneCountry | lowercase }}\" style=\"pointer-events: none\"></div>\n                <div class=\"arrow\" style=\"pointer-events: none\"></div>\n            </div>\n\n            <ul class=\"country-list hide\">\n                <li ng-repeat=\"(key, value) in dialingCodeList track by $index\"\n                    tabindex=\"-1\"\n                    class=\"country\"\n                    data-country-code=\"{{ value.code }}\"\n                    ng-class=\"{'selected': value.code === phoneCountry}\"\n                    ng-click=\"actions.updatePhoneFieldMetadata(value)\"\n                    ng-keydown=\"actions.handleKeyboardInputForList($event)\"\n                    ng-mouseover=\"actions.handleListMouseover($event)\">\n\n                    <div class=\"flag\" style=\"pointer-events: none\">\n                        <div class=\"iti-flag {{ value.code | lowercase }}\"/>\n                    </div>\n\n                    <span class=\"country-name\" style=\"pointer-events: none\">{{ value.name }}</span>\n\n                    <span class=\"dial-code\" style=\"pointer-events: none\">+{{ value.internationalDialingCode }}</span>\n                </li>\n            </ul>\n        </div>\n\n        <label for=\"phoneCountryCode\" id=\"phoneCodeLabel\" class=\"focus accessAid\">{{content('common.phoneCountryCode')}}</label>\n    </div>\n\n\n    <div id=\"phoneNumberContainer\"\n         class=\"inputField confidential last-child phoneNumber\"\n         ng-class=\"{'half': !hidePhoneType,\n            'telephoneField': !hidePhoneType,\n            'telephoneFieldFull': hidePhoneType,\n            'rtlPhoneField': locale.metadata.directionality === 'rtl',\n            'dialCodeVisible': showDialingCodeContainer,\n            'singleLineMobile' : hidePhoneType}\"\n         floating-label\n         directionality >\n\n        <span class=\"fixedCode ltrOverride\" id=\"countryTelephoneCode\">+{{ phone.IntDialingCountryCode }}</span>\n        <input id=\"telephone\"\n               class=\"telephone\"\n               ng-class=\"{'digit1' : phone.IntDialingCountryCode.length === 1, 'digit2' : phone.IntDialingCountryCode.length === 2, 'digit3' : phone.IntDialingCountryCode.length === 3, 'digit4' : phone.IntDialingCountryCode.length === 4 }\"\n               type=\"tel\"\n               ng-model=\"phone.telephone\"\n               name=\"telephone\"\n               value=\"\"\n               data-mask=\"{{mask}}\"\n               ng-change=\"actions.applyMaskOnPhoneInput()\"\n               autocapitalize=\"off\"\n               autocomplete=\"off\"\n               aria-required=\"true\"\n               aria-labelledby=\"telephoneLabel countryTelephoneCode\"\n               country-code=\"phone.phoneCountryCode\"\n               xo-validation='{\"validator\": \"validPhone\"}'\n               data-error-key=\"validation.validPhone\"\n               maxlength=\"{{mask.length}}\"\n               ng-keyup=\"actions.applyMaskOnPhoneInput()\"\n               required\n               xo-error-tooltip />\n        <label for=\"telephone\" class=\"focus\" id=\"telephoneLabel\">{{content('common.phone')}}</label>\n    </div>\n\n\n</div>\n\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

__webpack_require__("../node_modules/xo-form-components/src/phone/directive.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$AddPhoneRoute', function () {

    return _squid.$ComponentRoute.extend('AddPhoneRoute', {

        name: 'addPhone',

        directive: 'xo-add-phone',

        titleContent: 'addPhone.addPhoneNumber',

        query: ['message'],

        trackingData: {
            templateName: 'addPhone.dust',
            fptiState: 'add_phone',
            pageGoal: 'Add Phone',
            buzname: {
                'fullpage': {
                    'pagename': '%::fullpage-add-phone',
                    'pagename2': '%::fullpage-add-phone:member:hermes:',
                    'version': 'member:%:'
                    // More page qualifiers come here...
                } }
        },

        loginRequired: true,

        children: []
    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-form-components/src/phone", "../node_modules/xo-form-components/src/phone/route.js"))

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"addPhone\" id=\"addPhone\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\">\n            <xo-message message=\"errorMessage\"></xo-message>\n            <p class=\"userEmail\" id=\"reviewUserInfo\" ng-if=\"showNotYou\">\n                {{ content('creditcard.hi', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                <span>\n                    <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout()\">{{ content('memberReview.notYou')}}</a>\n                </span>\n            </p>\n            <xo-title title-txt=\"{{content('addPhone.addPhoneNumber')}}\"></xo-title>\n            <form name=\"addPhoneForm\" class=\"proceed\" content autocomplete=\"off\" ng-submit=\"addPhoneForm.$valid && onSubmit()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n\n                <xo-phone-input phone=\"phone\"></xo-phone-input>\n                <p class=\"disclaimer\" id=\"phoneDisclosure\" ng-if=\"showPhoneDisclosure\">\n                    <span data-ng-bind-html=\"htmlContent(consentContentKey)\"></span>\n                </p>\n                <input track-submit type=\"submit\" value=\"{{showPhoneDisclosure ? content('addPhone.agreeContinue') : content('common.continueLabel') }}\" class=\"btn full\" ng-click=\"validated=true\" />\n            </form>\n        </div>\n        <div class=\"span10\">\n            <xo-value-props type=\"login\" title=\"{{content('login.propHead')}}\" text-content=\"login.propVal\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/select-shipping-country/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/select-shipping-country/template.html");

var _template2 = _interopRequireDefault(_template);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoSelectShippingCountry', {
    tag: 'xo-select-shipping-country',
    template: _template2['default'],
    props: {
        shippingAddress: {
            type: 'var',
            required: false
        },
        disableChangeShippingCountry: {
            type: 'var',
            required: false
        }
    },
    actions: {
        // Return the country list, with the selected address country at the top
        getList: function getList(address) {
            var defaultCountryCode = address && address.country || _squid.$locale.country;
            var countryList = _squid.$locale.metadata.territory;
            var isDefaultCountry = function isDefaultCountry(country) {
                return country.code === defaultCountryCode;
            };
            var defaultCountry = _squid.$util.find(countryList, isDefaultCountry);
            var res = countryList.filter(function (country) {
                return !isDefaultCountry(country);
            });

            res.unshift(defaultCountry);

            return res;
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.countryList = this.actions.getList(this.props.shippingAddress);

            this.$on('metadataChange', function () {
                _this.countryList = _this.actions.getList(_this.props.shippingAddress);
            });
        }
    }
});


_squid.$Component;

_squid.$locale;

_squid.$util;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-form-components/src/select-shipping-country/template.html":
/***/ (function(module, exports) {

module.exports = "<span id=\"selectShippingCountry\" feature=\"changeShippingCountry\">\n    <div class=\"dropdown confidential country clearfix inputField\"\n         ng-class=\"{'disabled': props.disableChangeShippingCountry}\" content floating-label-dropdown>\n        <select xo-dropdown name=\"country\" ng-model=\"props.shippingAddress.country\" ng-options=\"country.code as country.name for country in countryList\" id=\"country\" xo-error-tooltip required ng-disabled=\"props.disableChangeShippingCountry\">\n        </select>\n        <label for=\"country\" id=\"countryLabel\">{{ content('common.country') }}</label>\n    </div>\n</span>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/select-shipping-method/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/shippingMethod/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/select-shipping-method/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/cart/lib/ui.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Import the decodeEntities angular filter

var callbackShippingOptions = void 0,
    fallbackShippingOptions = void 0,
    callbackInsuranceOffered = void 0;
var defaultFallbackOptionIndex = void 0;

exports['default'] = _squid.$Component.extend('$xoSelectShippingMethod', {
    tag: 'xo-select-shipping-method',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        },
        showShippingAddress: {
            type: 'var',
            required: false
        },
        errorHandlerHelper: {
            type: 'var',
            required: false
        },
        instantUpdateFeature: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            return {
                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                checkoutCart: _index2.$CheckoutCartModel.instance(this.props.token).retrieve(),
                checkoutPayee: _index2.$CheckoutPayeeModel.instance(this.props.token).retrieve(),
                checkoutShippingAddresses: _index2.$CheckoutShippingAddressesModel.instance(this.props.token).retrieve(),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve()
            };
        }
    },

    actions: {
        closeModal: function closeModal() {
            this.showModal = false;
        },
        openModal: function openModal() {
            this.showModal = true;
        },
        continueHandler: function continueHandler() {

            /**
             * Function responsible to patch Cart for
             * 1. Buyer select's a new shipping method.
             * 2. Buyer chooses to opt for insurance or chooses not to.
             */
            if (this.selectedMethod.current.index !== this.selectedMethod.previous.index || this.selectedMethod.current.insuranceSelected !== this.selectedMethod.previous.insuranceSelected) {

                var selectedMethodCharges = void 0,
                    taxAmtApplied = void 0,
                    insurance = void 0;
                selectedMethodCharges = this.response.charges[this.selectedMethod.current.index];
                taxAmtApplied = this.getTax(selectedMethodCharges);
                insurance = this.getInsurance(selectedMethodCharges);
                this.shippingAmtApplied = this.safeConvert(selectedMethodCharges.shipping_charge.shipping_amount.value);
                if (this.isInstantUpdateFlow) {
                    this.selectedMethod.showInsuranceAmount = this.selectedMethod.current.insuranceSelected;
                    this.insuranceApplied = insurance;
                    this.updateSelectedExternalCallbackOption(this.response.shipping_options_source, this.selectedMethod.previous.index, this.selectedMethod.current.index);
                    this.selectedMethod.previous.insuranceSelected = this.selectedMethod.current.insuranceSelected;
                }
                this.updateShippingTaxCharge(this.shippingAmtApplied, taxAmtApplied, selectedMethodCharges.shipping_charge.shipping_method_type, insurance);
                this.selectedShippingMethod = selectedMethodCharges.shipping_charge.shipping_method;
                this.selectedMethod.previous.index = this.selectedMethod.current.index;
            }

            this.actions.closeModal();
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.selectedMethod = {
                current: {
                    index: 0,
                    insuranceSelected: false
                },
                previous: {
                    index: 0,
                    insuranceSelected: false
                },
                insuranceAvailable: false,
                showInsuranceAmount: false
            };

            // Initialization
            this.showModal = false;
            this.shippingInfoDisplay = 'noHighlight';
            this.addressChanged = false;

            var timer = void 0;
            this.previousCosts = {};

            // Function used to format amount based on currency code
            this.formatAmount = function (amount) {
                if (amount && amount.value) {
                    var amountToBeFormatted = (parseInt(amount.value.toString(), 10) / 100).toFixed(2);
                    if (amountToBeFormatted) {
                        return (0, _squid.formatCurrency)(amountToBeFormatted, _this.currencyCode);
                    }
                }
            };

            this.uncheckInsuranceCheckbox = function () {
                _this.selectedMethod.current.insuranceSelected = false;
            };

            this.showInsurance = function (selectedIndex) {
                return Number(_this.selectedMethod.current.index) === selectedIndex;
            };

            // Function to check if is insurance is offered for a shipping charge
            this.isInsuranceOfferedInCharge = function (charge) {
                return charge.shipping_charge.offer_insurance_option;
            };

            var responseHasShippingCharges = function responseHasShippingCharges() {
                if (_this.response.charges.length === 0) {
                    return false;
                }
                return !!_this.response.charges[0].shipping_charge;
            };

            var responseHasTaxCharges = function responseHasTaxCharges() {
                if (_this.response.charges.length === 0) {
                    return false;
                }
                return !!_this.response.charges[0].tax;
            };

            this.safeConvert = function (value) {
                value = Number(value);
                if (isNaN(value)) {
                    throw new Error(value + ' cannot be divided');
                }
                return value / 100;
            };

            /*
             This function is responsible to update the previously selected external callback option to newly selected one.
             */
            this.updateSelectedExternalCallbackOption = function (optionsSource, prevIndex, index) {
                if (optionsSource === 'CALLBACK' && callbackShippingOptions) {
                    if (!isNaN(prevIndex)) {
                        callbackShippingOptions[prevIndex].is_selected = false;
                    }
                    callbackShippingOptions[index].is_selected = true;
                } else if (optionsSource === 'FALLBACK' && fallbackShippingOptions) {
                    if (!isNaN(prevIndex)) {
                        fallbackShippingOptions[prevIndex].is_selected = false;
                    }
                    fallbackShippingOptions[index].is_selected = true;
                }
            };

            var highlight = function highlight(duration) {
                _this.shippingInfoDisplay = 'highlight';
                if (timer) {
                    _angular.$timeout.cancel(timer);
                }
                timer = (0, _angular.$timeout)(function () {
                    _this.shippingInfoDisplay = 'noHighlight';
                }, duration);
            };

            this.getTax = function (charge) {
                var tax = void 0;
                if (!_this.isInstantUpdateFlow && (_this.isBuyNow || _this.isCartUpload) && _this.cartAmounts.taxAmt >= 0) {
                    tax = _this.cartAmounts.taxAmt;
                }
                // tax calculation
                else {
                        charge = charge || responseHasTaxCharges() && _this.response.charges[0];
                        if (charge && charge.tax && charge.tax.total_tax) {
                            tax = _this.safeConvert(charge.tax.total_tax.value);
                        }
                    }
                return tax;
            };

            /**
             * Function to return the insurance from shipping charge.
             * 1. By default return insurance amount from the charge.
             * 2. In case insurance is offered and is not chosen , do not return the insurance amount.
             * @param charge - shipping charge
             * @param index - index of the shipping charge
             */
            this.getInsurance = function (charge) {
                if (charge && charge.shipping_charge && charge.shipping_charge.insurance_amount) {
                    if (charge.shipping_charge.offer_insurance_option && !_this.selectedMethod.current.insuranceSelected) {
                        return;
                    }
                    return _this.safeConvert(charge.shipping_charge.insurance_amount.value);
                }
            };

            var updatePreviousCosts = function updatePreviousCosts() {
                _this.previousCosts = {};
                if (_this.models.checkoutCart.purchase.amounts.shipping) {
                    _this.previousCosts.shippingAmount = _this.models.checkoutCart.purchase.amounts.shipping.amount;
                }
                if (_this.models.checkoutCart.purchase.amounts.tax) {
                    _this.previousCosts.taxAmount = _this.models.checkoutCart.purchase.amounts.tax.amount;
                }
            };

            var hasShippingCostChanged = function hasShippingCostChanged(newShipping) {
                if (newShipping !== undefined) {
                    return newShipping.amount !== _this.previousCosts.shippingAmount;
                }
                return newShipping !== _this.previousCosts.shippingAmount;
            };

            var hasTaxCostChanged = function hasTaxCostChanged(newTax) {
                if (newTax !== undefined) {
                    return newTax.amount !== _this.previousCosts.taxAmount;
                }
                return newTax !== _this.previousCosts.taxAmount;
            };

            var setToolTipMessage = function setToolTipMessage() {
                _this.models.checkoutSession.message.msgKeys = hasShippingCostChanged(_this.models.checkoutCart.purchase.amounts.shipping) || hasTaxCostChanged(_this.models.checkoutCart.purchase.amounts.tax) ? ['smallToolTip.addressShippingChargesUpdated'] : ['smallToolTip.onlyAddressUpdated'];
            };

            var addExternalCallBackOptionsToPatchRequest = function addExternalCallBackOptionsToPatchRequest(patchEntities) {
                var externalCallbackOptions = _this.models.checkoutCart.purchaseUnits[0].external_callback_options;
                if (_this.response.shipping_options_source === 'CALLBACK') {
                    externalCallbackOptions.callback_shipping_options = callbackShippingOptions;
                    externalCallbackOptions.callback_insurance_option_offered = callbackInsuranceOffered;
                } else if (_this.response.shipping_options_source === 'FALLBACK') {
                    externalCallbackOptions.fallback_shipping_options = fallbackShippingOptions;
                }
                patchEntities.push({
                    field: 'externalCallbackOptions',
                    value: externalCallbackOptions
                });
            };

            var populatePatchShippingDetails = function populatePatchShippingDetails(patchEntities, shipMethod) {
                if (_this.isInstantUpdateFlow) {
                    addExternalCallBackOptionsToPatchRequest(patchEntities);
                } else {
                    patchEntities.push({
                        field: 'shippingMethod',
                        value: shipMethod ? _this.shippingMethods.getShippingMethodId(shipMethod) : ''
                    });
                }
            };

            var populatePatchAmountDetails = function populatePatchAmountDetails(patchableAmountEntities, constantAmountEntities, decimalDigits, amounts) {
                var newTotal = _this.cartAmounts.total;
                Object.keys(patchableAmountEntities).forEach(function (key) {
                    var detail = patchableAmountEntities[key];
                    if (!isNaN(detail.value)) {
                        detail.value = Number(detail.value);
                        amounts.details[key] = detail.value.toFixed(decimalDigits);
                    } else {
                        detail.value = 0;
                    }
                    newTotal += detail.valueInCart ? detail.value - detail.valueInCart : detail.value;
                });
                amounts.total = newTotal.toFixed(decimalDigits);
                Object.keys(constantAmountEntities).forEach(function (key) {
                    var detail = constantAmountEntities[key];
                    if (detail.valueInCart !== undefined) {
                        amounts.details[key] = detail.valueInCart.toFixed(decimalDigits);
                    }
                });
            };

            // Generates the request body to be used for patch Cart
            var getPatchReqData = function getPatchReqData(shippingAmt, taxAmt, shipMethod, insuranceAmt) {
                // 1. amount values in the cart,
                // 2. shipping method (only in case of non instant update flows)
                // 3. external_callback_options (only in case of instant update flows)

                var currencyDigits = _squid.$locale.metadata && _squid.$locale.metadata.currency && _squid.$locale.metadata.currency.digits;
                var decimalDigits = currencyDigits && currencyDigits[_this.currencyCode];
                if (isNaN(decimalDigits)) {
                    decimalDigits = 2;
                }
                var patchEntities = [];
                var amounts = {
                    'currency': _this.currencyCode,
                    'details': {
                        'subtotal': _this.cartAmounts.subTotal.toFixed(decimalDigits)
                    }
                };
                var patchableAmountEntities = {
                    shipping: {
                        value: shippingAmt,
                        valueInCart: _this.cartAmounts.shippingAmt
                    },
                    tax: {
                        value: taxAmt,
                        valueInCart: _this.cartAmounts.taxAmt
                    },
                    insurance: {
                        value: insuranceAmt,
                        valueInCart: _this.cartAmounts.insuranceAmt
                    }
                };

                // amount details which are not affected by SnT response,
                // but still need to get included in the patch request if initially present
                var constantAmountEntities = {
                    handling_fee: {
                        valueInCart: _this.cartAmounts.handlingAmt
                    },
                    shipping_discount: {
                        valueInCart: _this.cartAmounts.shippingDiscountAmt
                    },
                    discount: {
                        valueInCart: _this.cartAmounts.discountAmt
                    }
                };
                populatePatchAmountDetails(patchableAmountEntities, constantAmountEntities, decimalDigits, amounts);

                patchEntities.push({
                    field: 'purchaseAmount',
                    value: amounts
                });

                populatePatchShippingDetails(patchEntities, shipMethod);

                return {
                    id: _this.token,
                    patchEntities: patchEntities
                };
            };

            this.updateShippingTaxCharge = function (shippingAmt, taxAmt, shipMethod, insurance) {
                _this.models.checkoutCart.action('patchCartData', {
                    data: getPatchReqData(shippingAmt, taxAmt, shipMethod, insurance),
                    success: function success(result) {
                        _this.models.checkoutSession.invalidate();
                        (0, _squid.$populate)(_this, {
                            checkoutSession: _index2.$CheckoutSessionModel.instance(_this.token)
                        }).then(function () {
                            // update checkout cart model with item information
                            // this is for displaying additional item information in cart
                            // any modification here need check in xo-page-component-> cart directive also
                            _this.models.checkoutCart.get('purchase.items', []).forEach(function addDetails(item) {
                                item.details = {};

                                if (item.quantity > 1) {
                                    item.details.price = item.price.amount;
                                    item.details.quantity = (0, _squid.formatQuantity)(item.quantity);
                                }

                                if (item.description) {
                                    if (!item.name) {
                                        item.name = item.description;
                                    } else {
                                        item.details.description = item.description;
                                    }
                                }

                                // move options to detail section
                                if (item.item_option_selections) {
                                    item.details.hasSelections = true;
                                    item.details.item_option_selections = item.item_option_selections;
                                }

                                if (item.sku) {
                                    item.details.sku = item.sku;
                                }

                                item.hasDetails = Object.keys(item.details).length > 0;
                                item.details.hasMore = item.hasDetails || item.details.hasSelections;
                            });
                        }).then(function () {
                            highlight(4000);
                            if (_this.addressChanged) {
                                setToolTipMessage();
                                _this.addressChanged = false;
                            }
                            updatePreviousCosts();
                        });
                    }
                });
            };

            var populateCallbackShippingOptions = function populateCallbackShippingOptions() {
                var charges = _this.response && _this.response.charges;
                if (charges) {
                    callbackShippingOptions = charges.map(function (charge, index) {
                        var shippingCharge = charge.shipping_charge;
                        var taxCharge = charge.tax;
                        var option = {};
                        if (shippingCharge) {
                            option = {
                                method: shippingCharge.shipping_method,
                                amount: {
                                    value: _this.safeConvert(shippingCharge.shipping_amount.value),
                                    currency: shippingCharge.shipping_amount.currency_code
                                },
                                is_default: shippingCharge.default_method,
                                is_selected: false
                            };
                            if (shippingCharge.insurance_amount) {
                                option.insurance = {
                                    value: _this.safeConvert(shippingCharge.insurance_amount.value),
                                    currency: shippingCharge.insurance_amount.currency_code
                                };
                                callbackInsuranceOffered = shippingCharge.offer_insurance_option;
                            }
                            if (taxCharge) {
                                option.tax = {
                                    value: _this.safeConvert(taxCharge.total_tax.value),
                                    currency: taxCharge.total_tax.currency_code
                                };
                            }
                        }
                        return option;
                    });
                }
            };

            var setDefaultShippingMethod = function setDefaultShippingMethod() {
                _this.showShippingOptions = true;
                var chargesElement = void 0,
                    methodType = void 0,
                    taxAmtApplied = void 0,
                    insurance = void 0;
                for (var i = 0; i < _this.response.charges.length; i++) {
                    chargesElement = _this.response.charges[i];
                    if (chargesElement.shipping_charge.default_method) {
                        _this.selectedMethod.current.index = i;
                        _this.selectedMethod.previous.index = i;
                        insurance = _this.getInsurance(chargesElement);
                        if (_this.isInstantUpdateFlow) {
                            _this.updateSelectedExternalCallbackOption(_this.response.shipping_options_source, _this.selectedMethod.previous.index, _this.selectedMethod.current.index);
                        }
                        _this.selectedShippingMethod = chargesElement.shipping_charge.shipping_method;
                        methodType = chargesElement.shipping_charge.shipping_method_type;
                        _this.shippingAmtApplied = _this.safeConvert(chargesElement.shipping_charge.shipping_amount.value);

                        taxAmtApplied = _this.getTax(chargesElement);

                        insurance = _this.getInsurance(chargesElement);

                        break;
                    }
                }
                _this.updateShippingTaxCharge(_this.shippingAmtApplied, taxAmtApplied, methodType, insurance);
            };

            var isPatchCartRequired = function isPatchCartRequired(applicableShippingAmt, applicableTaxAmt) {
                return applicableShippingAmt !== _this.previousCosts.shippingAmount || applicableTaxAmt !== _this.previousCosts.taxAmount;
            };

            // Find the charges of the default option and patch cart with corresponding values.
            var updateShippingTaxChargeWithDefaultOption = function updateShippingTaxChargeWithDefaultOption() {
                var defaultOption = void 0,
                    shippingAmt = void 0,
                    taxAmt = void 0,
                    insuranceAmt = void 0,
                    methodType = void 0;
                if (_this.response.shipping_options_source === 'FALLBACK' && !isNaN(defaultFallbackOptionIndex)) {
                    defaultOption = fallbackShippingOptions[defaultFallbackOptionIndex];
                }
                if (defaultOption) {
                    shippingAmt = defaultOption.amount && defaultOption.amount.value;
                    taxAmt = defaultOption.tax && defaultOption.tax.value;
                    insuranceAmt = defaultOption.insurance && defaultOption.insurance.value;
                    methodType = defaultOption.shipping_method_type || 'DEFAULT';
                }
                _this.updateShippingTaxCharge(shippingAmt, taxAmt, methodType, insuranceAmt);
            };

            /**
             Function to enable the link to select insurance's by the user if offered in charges
             */
            var enableUserToChooseInsuranceOptionsIfAvailable = function enableUserToChooseInsuranceOptionsIfAvailable() {
                var charges = _this.response && _this.response.charges;
                if (!charges) {
                    return;
                }
                for (var i = 0; i < charges.length; i++) {
                    if (_this.isInsuranceOfferedInCharge(charges[i])) {
                        _this.selectedMethod.insuranceAvailable = true;
                        _this.selectedMethod.showInsuranceAmount = false;
                        break;
                    }
                }
            };

            /*  Function which is responsible to process shipping tax response
             Use cases
             ---------
             1. (i) WPS: If response has shipping charges and shipping options are to be shown, set default shipping method else patch cart
             with shipping amount returned.
             (ii)Instant Update: If the shipping region is unsupported, display error message. Otherwise the above behavior applies.
             2. If no_shipping = 1
             (i) WPS:  If profile_override = true , apply shipping from button if it is not empty.
             (ii) Instant Update: Do not display the shipping options. Apply the default fallback(or callback) shipping option charges.
             3. Apply tax if applicable.
             */
            var processShippingAndTaxResponse = function processShippingAndTaxResponse() {

                var applicableShippingAmt = void 0,
                    applicableTaxAmt = void 0;

                if (_this.isInstantUpdateFlow) {
                    if (!_this.response.shipping_region_supported) {
                        _this.errorHandlerHelper.addPageError('shippingMethod.shippingRegionUnsupported', { merchant: _this.nonEmptyMerchantDisplayName });
                        _this.instantUpdateFeature.shippingRegionSupported = false;
                    }

                    if (_this.response.shipping_options_source === 'CALLBACK') {
                        populateCallbackShippingOptions();
                    }

                    enableUserToChooseInsuranceOptionsIfAvailable();

                    // no_shipping = 0
                    if (_this.showShippingAddress) {
                        if (responseHasShippingCharges()) {
                            setDefaultShippingMethod();
                        }
                    }
                    // no_shipping=1 in case of instant update api , hide the overlay, shipping and tax from default fallback or callback options should be applied
                    else {
                            _this.showShippingOptions = false;
                            updateShippingTaxChargeWithDefaultOption();
                        }
                    return;
                }

                // shipping calculation
                if (_this.showShippingAddress) {
                    if (responseHasShippingCharges()) {
                        if (_this.response.show_shipping_options) {
                            setDefaultShippingMethod(); // setDefaultShippingMethod takes care of both shipping and tax
                            return;
                        } else if (_this.response.charges[0].shipping_charge.shipping_amount) {
                            // if no shipping options , try to get the shipping amount if returned from SNTService
                            applicableShippingAmt = _this.safeConvert(_this.response.charges[0].shipping_charge.shipping_amount.value);
                        }
                    }
                }
                // when not instant update flow , no_shipping is 1, shipping is applied only when override is true and shipping is passed in button
                else if (_this.response.profile_override_allowed) {
                        if (_this.cartAmounts.shippingAmt !== undefined) {
                            applicableShippingAmt = _this.cartAmounts.shippingAmt;
                        }
                    }

                applicableTaxAmt = _this.getTax();

                if (isPatchCartRequired(applicableShippingAmt, applicableTaxAmt)) {
                    _this.updateShippingTaxCharge(applicableShippingAmt, applicableTaxAmt);
                }
            };

            var clearFallbackOptionsSelectionFlags = function clearFallbackOptionsSelectionFlags() {
                for (var i = 0; i < fallbackShippingOptions.length; i++) {
                    fallbackShippingOptions[i].is_selected = false;
                }
            };

            this.getShippingMethods = function () {
                _this.showShippingOptions = false;
                _this.selectedShippingMethod = '';
                _this.shippingAmtApplied = 0;
                _this.insuranceAmountOffered = 0;
                _this.response = {};

                // when no_shipping = 1, checkoutSession,shipping is undefined. Primary address is considered for SnT as per legacy
                var shippingAddress = _this.models.checkoutSession.shipping ? _this.models.checkoutSession.getShippingAddressMinimalDetails() : _this.models.checkoutShippingAddresses.getPrimaryShippingAddress();

                var sntRequest = {
                    'address': shippingAddress,
                    'cart_weight': _this.cartWeight,
                    'cart_handling': { value: _this.cartAmounts.handlingAmt, currency_code: _this.currencyCode },
                    'discount': _this.cartDiscount,
                    'item_list': _this.models.checkoutCart.purchase.items,
                    'tax_on_shipping_required': _this.showShippingAddress, //    tax on shipping is not applicable when no_shipping is 1
                    'merchant_id': _this.models.checkoutPayee.merchant.id,
                    'locale': _squid.$locale.content.lang + '_' + _squid.$locale.chosenCountry,
                    'currency_code': _this.currencyCode,
                    'id': _this.token
                };

                if (_this.isInstantUpdateFlow) {
                    _this.selectedMethod = {
                        current: {
                            index: 0,
                            insuranceSelected: false
                        },
                        previous: {
                            index: 0,
                            insuranceSelected: false
                        },
                        insuranceAvailable: false,
                        showInsuranceAmount: false
                    };
                    callbackShippingOptions = [];
                    callbackInsuranceOffered = false;
                    clearFallbackOptionsSelectionFlags();
                    _this.instantUpdateFeature.shippingRegionSupported = true;
                    _this.errorHandlerHelper.clearPageErrors();

                    if (_this.models.checkoutCart.purchaseUnits && _this.models.checkoutCart.purchaseUnits[0]) {
                        sntRequest.external_callback_options = _this.models.checkoutCart.purchaseUnits[0].external_callback_options;
                    }
                }

                _this.shippingMethods = new _index.$ShippingMethodModel(sntRequest);

                _logger.$logger.info('calculate_shipping_charges_call');
                _this.shippingMethods.save({
                    data: _this.shippingMethods,
                    success: function success(result) {
                        _this.response = result;
                        processShippingAndTaxResponse();
                    }
                });
            };
        },
        populate: function populate() {
            var _this2 = this;

            var set = function set(key, value) {
                if (value) {
                    _this2.cartAmounts[key] = Number(value.amount);
                }
            };

            function hasAddressChanged(newValue, oldValue, isInstantUpdateFlow) {
                // only these values determine if the shiptax service needs to be called again
                var countryZipStateCityChanged = newValue.country !== oldValue.country || newValue.state !== oldValue.state || newValue.city !== oldValue.city || newValue.postal_code !== oldValue.postal_code;

                if (!countryZipStateCityChanged && isInstantUpdateFlow) {
                    // For instant update flow any change of address variable must trigger a call to shiptax
                    var anyAddressFieldChanged = newValue.line1 !== oldValue.line1 || newValue.line2 !== oldValue.line2;
                    return anyAddressFieldChanged;
                }

                return countryZipStateCityChanged;
            }

            this.currencyCode = this.models.checkoutCart.purchase.amounts.total.currency_code;

            var appDataFlags = this.models.checkoutAppData && this.models.checkoutAppData.flags;

            // We need merchantDisplayName to be non empty and if merchant_name or brand_name is undefined
            // then we need the value of merchantDisplayName to be 'The merchant' as it is the first word
            // in page level error below (look for place where nonEmptyMerchantDisplayName var is used)
            this.nonEmptyMerchantDisplayName = this.models.checkoutAppData && this.models.checkoutAppData.getMerchantDisplayName({
                nonEmptyReturnValue: true,
                isSentenceBeginning: true
            });

            this.isBuyNow = appDataFlags && appDataFlags.is_buy_now_flow;

            this.isCartUpload = appDataFlags && appDataFlags.is_cart_upload_flow;

            this.isInstantUpdateFlow = this.models.checkoutCart && this.models.checkoutCart.instantUpdateIntegration;

            if (this.isInstantUpdateFlow) {
                fallbackShippingOptions = this.models.checkoutCart.purchaseUnits[0].external_callback_options.fallback_shipping_options;
                if (fallbackShippingOptions) {
                    defaultFallbackOptionIndex = _squid.$util.findIndex(fallbackShippingOptions, function (option) {
                        return option.is_default;
                    });
                }
            }

            this.cartAmounts = {};
            set('shippingAmt', this.models.checkoutCart.purchase.amounts.shipping);
            set('taxAmt', this.models.checkoutCart.purchase.amounts.tax);
            set('subTotal', this.models.checkoutCart.purchase.amounts.subtotal);
            set('total', this.models.checkoutCart.purchase.amounts.total);
            set('handlingAmt', this.models.checkoutCart.purchase.amounts.handling_fee);
            set('insuranceAmt', this.models.checkoutCart.purchase.amounts.insurance);
            set('shippingDiscountAmt', this.models.checkoutCart.purchase.amounts.shipping_discount);
            set('discountAmt', this.models.checkoutCart.purchase.amounts.discount);
            this.previousCosts = {
                shippingAmount: this.models.checkoutCart.purchase.amounts.shipping ? Number(this.models.checkoutCart.purchase.amounts.shipping.amount) : undefined,
                taxAmount: this.models.checkoutCart.purchase.amounts.tax ? Number(this.models.checkoutCart.purchase.amounts.tax.amount) : undefined
            };

            if (this.models.checkoutCart.cartWeight) {
                this.cartWeight = {};
                if (this.models.checkoutCart.cartWeight.value) {
                    this.cartWeight.value = Number(this.models.checkoutCart.cartWeight.value).toFixed(2);
                }
                this.cartWeight.unit = this.models.checkoutCart.cartWeight.unit;
            }

            if (this.models.checkoutCart.purchase.amounts.discount) {
                this.cartDiscount = {
                    value: Number(this.models.checkoutCart.purchase.amounts.discount.amount).toFixed(2),
                    currency_code: this.currencyCode
                };
            }

            if (this.showShippingAddress) {
                this.$watch('this.models.checkoutSession.shipping', function (newValue, oldValue) {
                    if (hasAddressChanged(newValue, oldValue, _this2.isInstantUpdateFlow)) {
                        _this2.addressChanged = true;
                        _this2.getShippingMethods();
                    }
                });
            }
            this.getShippingMethods();
        }
    }
});


_angular.$timeout;

_squid.$Component;

_squid.$locale;

_squid.$populate;

_squid.$util;

_squid.formatCurrency;

_squid.formatQuantity;

_index.$ShippingMethodModel;

_index2.$CheckoutSessionModel;

_index2.$CheckoutPayeeModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutShippingAddressesModel;

_index2.$CheckoutAppDataModel;

_logger.$logger;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-form-components/src/select-shipping-method/template.html":
/***/ (function(module, exports) {

module.exports = "<span id=\"selectShippingMethod\" content>\n    <div id=\"selectShippingMethodContainer\" ng-if=\"showShippingOptions\">\n        <div id=\"storePickUpDetails\" ng-if=\"models.checkoutCart.isShippingMethodStorePickUp()\">\n            <hr class=\"lightHR\">\n            <div class=\"shipTo\">{{ content('shippingMethod.shipTo') }}</div>\n            <div class=\"storeLocation\" >{{ content('shippingMethod.storeLocation') }}</div>\n            <p class=\"storeLocationInfo\">{{ content('shippingMethod.storeLocationInfo') }}</p>\n        </div>\n        <div id=\"shippingInformation\">\n            <div id=\"methodCharges\" ng-class=\"shippingInfoDisplay\">\n                <span class=\"shippingText\">{{ content('shippingMethod.shipping') }}:</span>\n            <span>\n                <a id=\"shippingMethodCharge\" class=changeShippingMethod link-button aria-label=\"{{ content('shippingMethod.selectMethod')}}\"\n                    ng-click=\"actions.openModal()\" focus-when=\"!showModal\" focused-once-before>\n                    <span class=\"selectedShippingMethod\">{{selectedShippingMethod | decodeEntities}} - </span>\n                    <format-currency class=\"formatCurrency\" code=\"currencyCode\" amount=\"shippingAmtApplied\"></format-currency>\n                </a>\n            </span>\n            </div>\n            <div id=\"insuranceInfo\" ng-if=\"selectedMethod.insuranceAvailable\" ng-class=\"shippingInfoDisplay\">\n                <span class=\"insuranceText\">{{ content('shippingMethod.shippingInsurance') }}:</span>\n            <span>\n                <a id=\"insuranceNoneApplied\" ng-if=\"!selectedMethod.showInsuranceAmount\" class=changeInsurance href=\"#\" aria-label=\"{{ content('shippingMethod.insuranceNoneSelected') }}\" ng-click=\"actions.openModal()\">\n                    <span class=\"noInsuranceOption\"> {{ content('shippingMethod.insuranceNoneSelected')}}</span>\n                </a>\n                <a id=\"insuranceAmtOffered\" ng-if=\"selectedMethod.showInsuranceAmount\" class=changeInsurance href=\"#\" aria-label=\"{{ content('shippingMethod.shippingInsurance') }}\" ng-click=\"actions.openModal()\">\n                    <format-currency class=\"formatCurrency\" code=\"currencyCode\" amount=\"insuranceApplied\"></format-currency>\n                </a>\n            </span>\n            </div>\n        </div>\n        <xo-modal show=showModal show-close-button=\"true\" on-close=\"actions.closeModal\">\n            <div class=\"shippingMethodsContainer\">\n                <div>\n                    <div class=\"shippingOptions\">\n                        <span class=\"shippingHeader\" id=\"shippingHeader1\">{{ content('shippingMethod.selectMethod') }}</span>\n                        <span class=\"gamma\" id=\"shippingHeader2\">{{ content('shippingMethod.merchantOptions') }}</span>\n                        <br>\n                        <div>\n                            <div ng-repeat=\"charge in response.charges track by $index\">\n                                <div class=\"row-fluid radioButton\">\n                                    <input type=\"radio\" name=\"shippingMethodRadioButton\" id=\"{{$index}}\" value=\"{{$index}}\" ng-model=\"selectedMethod.current.index\" ng-change=\"isInstantUpdateFlow && uncheckInsuranceCheckbox()\"/>\n                                    <label class=\"noBottom\" for=\"{{$index}}\">\n                                            <span class=\"methodContents\">\n                                        <span>\n                                            <span>\n                                                <span class=\"methodName\">\n                                                    {{charge.shipping_charge.shipping_method | decodeEntities}} -\n                                                </span>\n                                                <span class=\"shippingCharge\">\n                                                    <format-currency class=\"formatCurrency\" code=\"currencyCode\" amount=\"charge.shipping_charge.shipping_amount.value / 100\"></format-currency>\n                                                </span>\n                                            </span>\n                                            <span class=\"deliveryTime\">\n                                                {{charge.shipping_charge.delivery_time}}\n                                            </span>\n                                            <span class=\"description animate-show\" ng-if=\"shippingMethods.isStorePickUp(charge.shipping_charge.shipping_method_type)\" ng-show=\"selectedMethod.current.index == $index\">\n                                                {{ content('shippingMethod.storeLocationInfo') }}\n                                            </span>\n                                        </span>\n                                        <span ng-if=\"charge.shipping_charge.offer_insurance_option\" ng-show=\"showInsurance($index)\" class=\"insuranceOfferedInOption checkbox\">\n                                            <input ng-model=\"selectedMethod.current.insuranceSelected\" type=\"checkbox\" id=\"insurance\" value=\"false\">\n                                            <label for=\"insurance\" ng-bind-html=\"htmlContent('shippingMethod.addShippingInsurance', { amount: formatAmount(charge.shipping_charge.insurance_amount) })\"></label>\n                                        </span>\n                                    </span>\n                                    </label>\n                                </div>\n                                <hr class=\"hr\" ng-if=\"!$last\">\n                            </div>\n                        </div>\n                        <input id=\"confirmShippingMethod\" type=\"button\" class=\"confirmation btn\" value=\"{{ content('shippingMethod.continue') }}\" ng-click=\"actions.continueHandler()\">\n                    </div>\n                </div>\n            </div>\n            <div class=\"logo\"></div>\n        </xo-modal>\n    </div>\n</span>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/travel-rule/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

var _utilFunctions = __webpack_require__("../node_modules/xo-form-components/src/travel-rule/utilFunctions.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/travel-rule/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-form-components/src/travel-rule/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Component.extend('xoTravelRule', {
    tag: 'xo-travel-rule',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        },
        finish: {
            type: 'var',
            required: false
        },
        onUserInfoSuccess: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            return {
                checkoutSession: _index2.$CheckoutSessionModel.instance(this.token).retrieve()
            };
        }
    },

    actions: {
        submit: function submit() {
            var _this = this;

            var data = {};

            if (this.needPayerGovtId) {
                var chosenIdDetails = this.idTypes.find((0, _utilFunctions.findChosenId)(this.idData.type));

                // Scrub the formatting when invoking the backend services.
                var unformatted = (this.idData.value || '').replace(/[^0-9a-zA-Z]+/g, '');

                data.newDocId = {
                    type: chosenIdDetails.idType,
                    subType: chosenIdDetails.idSubtype,
                    issuerCountry: this.idData.country,
                    issuer: chosenIdDetails.idIssuer,
                    value: unformatted,
                    collectionPoint: 'UNKNOWN',
                    placeOfIssue: this.idData.country
                };
            }

            if (this.needPayerAddress) {
                var address = this.address;


                data.newAddress = {
                    address1: address.line1,
                    address2: address.line2,
                    city: address.city,
                    state: address.state,
                    zip: address.postal_code,
                    iso_country: 'US'
                };
            }

            var onUserInfoSuccess = this.onUserInfoSuccess || function () {
                var checkoutCart = _index2.$CheckoutCartModel.instance(_this.token);

                return _this.models.checkoutSession.action('create', {
                    data: {
                        baToken: checkoutCart.billing && checkoutCart.billing.ba_token
                    },
                    success: function success() {
                        // Clear the errors if create checkout session was successful
                        _this.models.checkoutSession.errorData = undefined;
                        _this.finish();
                    }
                });
            };

            this.userInfo.action('governmentId-address', {
                data: data,

                success: onUserInfoSuccess,

                validation: function validation(validationData) {
                    var $field = _this.$element.find('#data');

                    $field.addClass('backendError');
                    $field.attr('aria-invalid', true);
                    $field.focus();
                }
            });
        }
    },

    lifecycle: {
        populate: function populate() {
            var _this2 = this;

            var country = _index.$locale.getCountryCodeISO();

            this.country = country;
            this.address = { country: country };
            this.countryList = _index.$locale.metadata.territory;
            this.idTypes = (0, _utilFunctions.getIdTypes)(_index.$locale.content);
            this.idData = (0, _utilFunctions.getIdData)();

            this.idTypeChanged = function () {
                _this2.idData.country = 'US';
            };

            var checkoutSession = _index2.$CheckoutSessionModel.instance(this.token);
            var payerDetailsTypes = checkoutSession.get('errorData.resolution.data', []);

            if (payerDetailsTypes.includes('GOVERNMENT_ID')) {
                this.needPayerGovtId = true;
            }

            if (payerDetailsTypes.includes('STREET_ADDRESS')) {
                this.needPayerAddress = true;
            }

            this.userInfo = _index3.$UserInfoModel.instance(this.token);
        }
    }
});
// This component probably shouldn't be in xo-form-components, as xo-address-components depends on xo-form-components
// If below is included, the tests will error due to duplicate xo-form-components being loaded.
// import 'xo-address-components/src/add-address/directive';

_index.$Component;

_index.$locale;

_index2.$CheckoutSessionModel;

_index2.$CheckoutCartModel;

_index3.$UserInfoModel;

_utilFunctions.findChosenId;

_utilFunctions.getIdData;

_utilFunctions.getIdTypes;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-form-components/src/travel-rule/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-form-components/src/travel-rule/template.html":
/***/ (function(module, exports) {

module.exports = "<form id=\"travelRuleForm\" name=\"travelRuleForm\" class=\"travelRuleForm\" content novalidate>\n    <div class=\"trayInner trayInnerDefault\">\n        <h3 class=\"gamma noHead\">{{ content('travelRule.travelRule') }}</h3>\n        <p>{{ content('travelRule.note') }}</p>\n\n        <div ng-if=\"needPayerGovtId\" class=\"govtId\">\n            <div class=\"dropdown idType inputField\" floating-label-dropdown>\n                <select xo-dropdown\n                        name=\"idType\"\n                        ng-model=\"idData.type\"\n                        id=\"idType\"\n                        ng-change=\"idTypeChanged()\"\n                        aria-required=\"true\">\n                    <option ng-repeat=\"item in idTypes track by $index\" value=\"{{item.name}}\" ng-selected=\"idData.type === '{{item.name}}'\">{{item.value}}</option>\n                </select>\n                <label for=\"idType\">{{content('travelRule.idType')}}</label>\n            </div>\n            <div></div>\n            <div class=\"inputField confidential\"\n                ng-switch on=\"idData.type\">\n                <div class=\"animate-switch\" ng-switch-when=\"SSN\">\n                    <input id=\"data\" name=\"data\" maxlength=\"14\" ng-model=\"idData.value\"\n                       xo-error-tooltip required placeholder=\"{{ content('travelRule.ssnPlaceholder') }}\"/>\n                </div>\n                <div class=\"animate-switch\" ng-switch-when=\"TaxID\">\n                    <label for=\"data\" class=\"nolap\">{{ content('travelRule.taxIdDesc') }}</label>\n                    <input id=\"data\" name=\"data\" maxlength=\"14\" ng-model=\"idData.value\"\n                       xo-error-tooltip required placeholder=\"{{ content('travelRule.taxIdPlaceholder') }}\"/>\n                </div>\n                <div class=\"animate-switch\" ng-switch-when=\"EmployerID\">\n                    <label for=\"data\" class=\"nolap\">{{ content('travelRule.employerIdDesc') }}</label>\n                    <input id=\"data\" name=\"data\" maxlength=\"14\" ng-model=\"idData.value\"\n                       xo-error-tooltip required placeholder=\"{{ content('travelRule.employerIdPlaceHolder') }}\"/>\n                </div>\n                <div class=\"animate-switch\" ng-switch-when=\"Passport\">\n                    <label for=\"data\" class=\"nolap\">{{ content('travelRule.passportDesc') }}</label>\n                    <input id=\"data\" name=\"data\" maxlength=\"14\" ng-model=\"idData.value\"\n                       xo-error-tooltip required placeholder=\"{{ content('travelRule.passportPlaceholder') }}\"/>\n                    <div class=\"dropdown confidential country clearfix inputField\" content floating-label-dropdown>\n                        <select xo-dropdown name=\"passportCountry\" ng-model=\"idData.country\" ng-options=\"country.code as country.name for country in countryList\" id=\"passportCountry\" aria-labelledby=\"countryLabel\" xo-error-tooltip required>\n                        </select>\n                    </div>\n                </div>\n                <div class=\"animate-switch\" ng-switch-when=\"AlienNumber\">\n                    <label for=\"data\" class=\"nolap\">{{ content('travelRule.aNumberDesc') }}</label>\n                    <input id=\"data\" name=\"data\" maxlength=\"14\" ng-model=\"idData.value\"\n                       xo-error-tooltip required placeholder=\"{{ content('travelRule.aNumberPlaceholder') }}\"/>\n                </div>\n            </div>\n        </div>\n\n        <div ng-if=\"needPayerAddress\" class=\"address\">\n            <p>{{ content('travelRule.pleaseEnterStreetAddress') }}</p>\n            <xo-add-address country=\"country\" address=\"address\" token=\"token\"></xo-add-address>\n        </div>\n\n        <div class=\"buttons\">\n            <input track-submit type=\"submit\" id=\"proceedButton\" value=\"{{ content('travelRule.payButton') }}\" class=\"btn full btn-large\" validate-submit=\"actions.submit()\" />\n        </div>\n    </div>\n</form>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/travel-rule/utilFunctions.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var findChosenId = exports.findChosenId = function findChosenId(id) {
    return function () {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            name = _ref.name;

        return name === id;
    };
};

var getIdTypes = exports.getIdTypes = function getIdTypes(content) {
    return [{
        name: 'SSN',
        value: content.get('travelRule.ssnDropdownLabel'),
        idType: 'TAX_ID',
        idSubtype: 'SSN',
        idIssuer: 'US_SSN'
    }, {
        name: 'TaxID',
        value: content.get('travelRule.taxIdDropdownLabel'),
        idType: 'TAX_ID',
        idSubtype: 'ITIN',
        idIssuer: 'US_ITIN'
    }, {
        name: 'EmployerID',
        value: content.get('travelRule.employerIdDropdownLabel'),
        idType: 'TAX_ID',
        idSubtype: 'TIN',
        idIssuer: 'US_TIN'
    }, {
        name: 'Passport',
        value: content.get('travelRule.passportDropdownLabel'),
        idType: 'PASSPORT',
        idIssuer: 'PASSPORT'
    }, {
        name: 'AlienNumber',
        value: content.get('travelRule.aNumberDropdownLabel'),
        idType: 'IMMGT_ID',
        idIssuer: 'IMMIGRATION'
    }];
};

var getIdData = exports.getIdData = function getIdData() {
    return {
        type: 'SSN',
        value: '',
        country: 'US'
    };
};

/***/ }),

/***/ "../node_modules/xo-form-components/src/zipcode/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/prefix-attrs-with/directive.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/zipcode/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoZipcode', {
    tag: 'xo-zipcode',

    template: _template2['default'],

    props: {
        address: {
            reqiured: false,
            type: 'var'
        },
        attrPrefix: {
            required: false,
            type: 'var'
        },
        country: {
            required: false,
            type: 'str'
        },
        doneFn: {
            required: false,
            type: 'var'
        },
        keyPressFn: {
            required: false,
            type: 'var'
        },
        maxLength: {
            required: false,
            type: 'var'
        },
        postalCodeLabel: {
            required: false,
            type: 'var'
        },
        zipEntry: {
            required: false,
            type: 'var'
        },
        zipErrorKey: {
            required: false,
            type: 'str'
        },
        zipLabel: {
            required: false,
            type: 'str'
        },
        zipRequired: {
            reqiured: false,
            type: 'var'
        }
    },

    lifecycle: {
        enter: function enter() {
            this.formatRegex = undefined;
            this.inputParams = (0, _squid.$feature)('zipcodeInputParams', undefined, this.country);

            if (this.inputParams) {
                this.minLength = this.inputParams.minLength;
                this.maxLength = this.inputParams.maxLength;

                if (this.inputParams.formatPattern) {
                    this.formatRegex = new RegExp(this.inputParams.formatPattern, 'g');
                }
            }

            this.formatZipWithDash = function (zipcode, index) {
                if (zipcode.length > index) {
                    zipcode = zipcode.slice(0, index) + '-' + zipcode.slice(index);
                }

                return zipcode;
            };
        }
    },

    actions: {
        changeZip: function changeZip(zipcode) {
            if (zipcode) {

                if (this.formatRegex) {
                    zipcode = zipcode.replace(this.formatRegex, '');
                }

                if (this.inputParams && this.inputParams.formatZip) {
                    zipcode = this.formatZipWithDash(zipcode, this.inputParams.minLength);
                }

                this.address.postal_code = zipcode;
            }
        },
        doneFunction: function doneFunction() {
            if (this.doneFn) {
                this.doneFn();
            }
        },
        keyPressHandler: function keyPressHandler(event) {
            if (this.keyPressFn) {
                this.keyPressFn(event);
            }
        }
    }
});


_squid.$Component;

_squid.$feature;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-form-components/src/zipcode/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"zipField\" data-test-id=\"zipField\" class=\"inputField confidential postalCode\" prefix-attrs-with=\"{{attrPrefix}}\" floating-label directionality content>\n    <input type=\"text\" name=\"postalCode\" id=\"postalCode\" ng-model=\"address.postal_code\" data-test-id=\"address.postal_code\"\n       autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" ng-change=\"actions.changeZip(address.postal_code)\" xo-validation='{\"validator\": \"validZip\"}'\n       minlength=\"{{minLength}}\" maxlength=\"{{maxLength}}\" ng-blur=\"actions.doneFunction()\" ng-keypress=\"actions.keyPressHandler($event)\"\n       data-error-key=\"{{zipErrorKey}}\" xo-error-tooltip ng-required=\"{{zipRequired}}\" prefix-attrs-with=\"{{attrPrefix}}\"/>\n    <label for=\"postalCode\" id=\"postalCodeLabel\" data-test-id=\"postalCodeLabel\" prefix-attrs-with=\"{{attrPrefix}}\">{{ zipLabel }}</label>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/create-password/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

__webpack_require__("../node_modules/xo-login-components/src/create-password/styles.less");

var _template = __webpack_require__("../node_modules/xo-login-components/src/create-password/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CONTENT_KEY_MAP = {
    ADD_CARD: {
        benefitsKey: 'passwordRecovery.stepUpBenefits',
        reasonKey: 'passwordRecovery.stepUpAddCard'
    },
    ADD_SHIPPING: {
        benefitsKey: 'passwordRecovery.stepUpBenefits',
        reasonKey: 'passwordRecovery.stepUpAddShipping'
    },
    APPLY_PPC: {
        benefitsKey: 'passwordRecovery.stepUpApplyPPCBenefits',
        reasonKey: 'passwordRecovery.stepUpApplyPPC'
    },
    GENERIC: {
        benefitsKey: 'passwordRecovery.stepUpGenericBenefits',
        reasonKey: 'passwordRecovery.stepUpGeneric'
    },
    NEW_PHONE: {
        reasonKey: 'passwordRecovery.stepUpNewPhone'
    },
    NEED_US_ADDRESS: {
        reasonKey: 'passwordRecovery.stepUpNeedUSAddress'
    },
    CARD_EXPIRED: {
        reasonKey: 'passwordRecovery.stepUpCardExpired'
    },
    MERCHANT_NOT_ACCEPT_AMEX: {
        reasonKey: 'passwordRecovery.stepUpMerchantNotAcceptAmex'
    },
    NEED_CREDIT_CARD: {
        reasonKey: 'passwordRecovery.stepUpContigencyAddCard'
    },
    PAYER_AUTHENTICATION_REQUIRED: {
        reasonKey: 'passwordRecovery.stepUpNewAddress'
    },
    BILLING_AGREEMENTS: {
        reasonKey: 'passwordRecovery.stepUpBillingAgreements'
    },
    GENERIC_CONTINGENCY: {
        reasonKey: 'passwordRecovery.stepUpContigencyGeneric'
    }
};

exports['default'] = _squid.$Component.extend('$xoPasswordRecoveryLandingDirective', {
    tag: 'xo-create-password',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        onContinue: {
            type: 'var',
            required: false
        },
        onCancel: {
            type: 'var',
            required: false
        },
        reason: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.contingencyName = this.reason && _squid.$util.camelToCapsUnderscore(this.reason) || 'GENERIC';
            this.getReasonKey = function () {
                return (CONTENT_KEY_MAP[_this.contingencyName] || CONTENT_KEY_MAP['GENERIC']).reasonKey;
            };

            this.getBenefitsKey = function () {
                return (CONTENT_KEY_MAP[_this.contingencyName] || CONTENT_KEY_MAP['GENERIC']).benefitsKey;
            };
            this.onSubmit = function () {
                _logger.$logger.info('checkout_fpti', {
                    from: 'quick_security_check',
                    to: 'process_quick_security_check'
                });
                _this.onContinue();
            };
        }
    }
});


_squid.$Component;

_squid.$util;

_logger.$logger;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-login-components/src/create-password/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-login-components/src/create-password/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"createPassword\" content>\n    <div class=\"heading\">{{content('passwordRecovery.quickSecurityCheck')}}</div>\n\n    <div class=\"msg\">{{content(getReasonKey())}}</div>\n\n    <div class=\"msg\">{{content(getBenefitsKey())}}</div>\n\n    <button class=\"btn full continueBtn\" ng-click=\"onSubmit()\">{{content('common.continueLabel')}}</button>\n    <div ng-if=\"onCancel\" class=\"cancelLink\"><a ng-click=\"onCancel($event)\">{{content('common.cancel')}}</a></div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/dolphin/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _utils = __webpack_require__("../node_modules/xo-login-components/src/dolphin/utils.js");

var _template = __webpack_require__("../node_modules/xo-login-components/src/dolphin/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-login-components/src/dolphin/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend({
    tag: 'xo-dolphin',
    template: _template2['default'],
    hasUserClosedTheBanner: false,
    isPhoneConfirmed: false,
    // prevent iframe timer from executing overlay has loaded in any scenario (error or success)
    hasOverlayLoaded: false,
    isTimerRunning: false,
    timerDuration: 10000,
    actions: {
        startTimer: function startTimer() {
            var _this = this;

            _logger.$logger.info('xoDolphin_startTimer');
            // Set a 10 second timer to check if UL has loaded or not
            this.isTimerRunning = true;
            (0, _angular.$timeout)(function () {
                if (!_this.hasOverlayLoaded && _this.isTimerRunning) {
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'show_banner',
                        'to': 'overlay_timeout',
                        'context_id': _angular.$rootScope.token
                    });
                    _this.isTimerRunning = false;
                }
            }, this.timerDuration);
        },
        closeBanner: function closeBanner() {
            this.showBanner = false;
            this.hasUserClosedTheBanner = true;
            _logger.$logger.info(_utils.flowName, {
                'from': 'show_banner',
                'to': 'close_banner',
                'context_id': _angular.$rootScope.token
            });
        },
        openOverlay: function openOverlay() {
            var _this2 = this;

            this.showOverlay = true;
            var onPostMessagesHandler = function onPostMessagesHandler(postMessage) {
                if (!angular.isObject(postMessage)) {
                    try {
                        postMessage = JSON.parse(postMessage);
                    } catch (e) {
                        _logger.$logger.info('xoDolphin_jsonParseFailed');
                    }
                }

                if (!postMessage || !postMessage.data || !postMessage.data.event) {
                    _logger.$logger.info('xoDolphin_invalidPostMessage');
                    return;
                }

                if (postMessage.data.event === 'phoneConfirmationLoaded') {
                    _this2.hasOverlayLoaded = true;
                    _angular.$rootScope.$emit('loaded');
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'show_banner',
                        'to': 'overlay_loaded',
                        'context_id': _angular.$rootScope.token
                    });
                }

                if (postMessage.data.event === 'phoneConfirmationCompleted') {
                    _this2.isPhoneConfirmed = true;
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'show_banner',
                        'to': 'successfully_confirmed',
                        'context_id': _angular.$rootScope.token
                    });
                    _this2.actions.closeOverlay();
                }

                if (postMessage.data.event === 'phoneConfirmationError') {
                    _this2.hasOverlayLoaded = true;
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'show_banner',
                        'to': 'generic_error',
                        'context_id': _angular.$rootScope.token
                    });
                    _this2.actions.closeOverlay();
                }

                if (postMessage.data.event === 'notNowClicked') {
                    _this2.hasOverlayLoaded = true;
                    _this2.actions.closeOverlay();
                }
            };
            (0, _angular.$timeout)(function () {
                _logger.$logger.info(_utils.flowName, {
                    'from': 'show_banner',
                    'to': 'show_overlay',
                    'context_id': _angular.$rootScope.token
                });

                _this2.$element.addClass('overlayOpen').promise().then(function () {
                    // Note: A second timeout is added here to avoid a race condition where the DOM is not yet available
                    // for the inject script to pick a targetElement for injecting the iframe.
                    (0, _angular.$timeout)(function () {
                        var variant = _this2.toastParams && _this2.toastParams.variant;
                        var options = (0, _utils.getInjectULBaseObject)(variant);
                        options.onPostMessage = onPostMessagesHandler;
                        if (!options.targetElement) {
                            _logger.$logger.info('xoDolphin_missingTargetElement');
                        }
                        if (window.PAYPAL && window.PAYPAL.unifiedLogin && options.targetElement) {
                            _logger.$logger.info('xoDolphin_injectIframe');
                            window.PAYPAL.unifiedLogin.inject(options);
                            _this2.actions.startTimer();
                        }
                    });
                });
            });
        },
        closeOverlay: function closeOverlay() {
            var _this3 = this;

            this.$element.removeClass('overlayOpen');
            this.isTimerRunning = false;
            _logger.$logger.info(_utils.flowName, {
                'from': 'show_banner',
                'to': 'overlay_closed',
                'context_id': _angular.$rootScope.token
            });
            (0, _angular.$timeout)(function () {
                _logger.$logger.info('xoDolphin_hideOverlay');
                _this3.showOverlay = false;
                _this3.hasOverlayLoaded = false;
            }, 300);
        }
    },
    lifecycle: {
        enter: function enter() {
            var ulToast = _squid.$util.param('ulToast') || _squid.$util.param('ulToastWpsDone');
            this.toastParams = ulToast && _utils.variantParams[ulToast];
        },
        populate: function populate() {
            var _this4 = this;

            if (!this.toastParams) {
                _logger.$logger.info('Missing or invalid toast param!');
                return;
            }

            this.showBanner = !this.toastParams.autoTriggeredOverlay;
            this.bannerContent = this.toastParams.messageKey;
            this.successContent = this.toastParams.successKey;
            this.autoTriggeredOverlay = this.toastParams.autoTriggeredOverlay;
            this.variant = this.toastParams.variant;
            // DeviceInfo doesnt seem to have isDesktop, hence just avoiding the mobile use case
            this.fixedBanner = _index.$DeviceInfo.isMobile() ? '' : 'dolphinBannerFixed';

            _logger.$logger.info(_utils.flowName, {
                'from': 'show_banner',
                'to': this.toastParams.transitionName,
                'banner_type': this.toastParams.bannerType,
                'context_id': _angular.$rootScope.token
            });

            // Cannot use `$apply` as we need to wait for the entire digest cycle to complete
            (0, _angular.$timeout)(function () {
                if (_this4.autoTriggeredOverlay) {
                    _this4.actions.openOverlay();
                }
                angular.element('#confirmPhoneBtn').on('click', function () {
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'show_banner',
                        'to': 'click_link',
                        'context_id': _angular.$rootScope.token
                    });
                    _this4.actions.openOverlay();
                });
            }, this.autoTriggeredOverlay ? 1800 : 0); // Add a delay to open the overlay in case of auto trigger experiment
        }
    }
});


_angular.$rootScope;

_angular.$timeout;

_squid.$Component;

_squid.$util;

_logger.$logger;

_index.$DeviceInfo;

_utils.getInjectULBaseObject;

_utils.flowName;

_utils.variantParams;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-login-components/src/dolphin/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-login-components/src/dolphin/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"dolphinContainer\" ng-if=\"showBanner\">\n    <section class=\"dolphinBanner {{ fixedBanner }}\" content>\n        <div class=\"dolphinBannerContent {{ variant }}\" ng-if=\"!isPhoneConfirmed\" ng-bind-html=\"htmlContent(bannerContent)\"></div>\n        <div class=\"dolphinBannerContent\" ng-if=\"isPhoneConfirmed\">\n            <span class=\"dolphinBannerSuccessIcon\"></span>\n            <span class=\"dolphinBannerSuccessContent\">{{ content(successContent) }}</p>\n        </div>\n        <div ng-if=\"!autoTriggeredOverlay\" class=\"dolphinBannerCloseIcon\" ng-click=\"actions.closeBanner()\"></div>\n    </section>\n</div>\n<section ng-if=\"showOverlay\" class=\"pageOverlay\">\n    <div ng-if=\"!autoTriggeredOverlay\" class=\"overlayMask\"></div>\n    <div ng-if=\"autoTriggeredOverlay\" class=\"overlayAutoTriggerMask\"></div>\n    <div class=\"overlayWrapper\">\n        <div class=\"overlayContainer\">\n            <div class=\"aside\">\n                <a class=\"close\" href=\"#\" ng-click=\"actions.closeOverlay()\"></a>\n                <div id=\"injectedULPhoneConfirmation\"></div>\n            </div>\n            <div class=\"pushLogo\"></div>\n        </div>\n        <div class=\"logo\"></div>\n    </div>\n</section>\n\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/dolphin/utils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getDolphinEligibility = exports.variantParams = exports.flowName = exports.getInjectULBaseObject = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _eligibility = __webpack_require__("../node_modules/xo-models/src/eligibility/index.js");

var getCreditInterstitialEligibility = function getCreditInterstitialEligibility() {
    // TODO: Refactor the usage of PXP result stored in rootScope once Credit team make a change to this
    var creditInterstitialPXPResult = _angular.$rootScope['creditInterstitialPXPResult'];
    var creditInterstitialControl = 'xo_hermesnodeweb_us_ryi_ppc_ppcacquisition_interstitial_control';
    // If there is a value && it is not Control, then it's any of the treatments
    return creditInterstitialPXPResult && creditInterstitialPXPResult !== creditInterstitialControl;
};

var getInjectULBaseObject = exports.getInjectULBaseObject = function getInjectULBaseObject(variant) {
    var options = {
        config: {
            name: 'PPFrameRedirect',
            height: 577
        },
        queryParams: {
            intent: variant === 'add3' || variant === 'confirm3' ? 'xoAutoTrigger' : 'xoToast',
            flowId: _angular.$rootScope.token,
            'country.x': _squid.$locale.country,
            'locale.x': _squid.$locale.getLocaleCode()
        },
        iframePathname: '/signin/phone-confirmation',
        targetElement: document.getElementById('injectedULPhoneConfirmation')
    };

    return options;
};

var flowName = exports.flowName = 'ul_dolphin';

// A simple object to map all the properties specific to a particular variant
// Not creating a function & abstracting common things for the sake of simplicity
// Once the performance is measured, only 1 of the 4 variants will be left behind
// and this object will have only 2 props again.
// A variant prop is added to define the class name in the template
// The query param's value is not used directly to avoid XSS
var variantParams = exports.variantParams = {
    confirm: {
        messageKey: 'login.confirmPhone',
        successKey: 'login.confirmPhoneSuccess',
        transitionName: 'confirm_phone',
        bannerType: 'short_text_link',
        // `variant` uses a hardcoded value for th ulToast query param
        // it is used later in the flow from here instead of the query param
        variant: 'confirm'
    },
    confirm1: {
        messageKey: 'login.confirmPhoneWithButton',
        successKey: 'login.confirmPhoneSuccess',
        transitionName: 'confirm_phone',
        bannerType: 'short_text_button',
        variant: 'confirm1'
    },
    confirm2: {
        messageKey: 'login.confirmPhoneLongWithButton',
        successKey: 'login.confirmPhoneSuccess',
        transitionName: 'confirm_phone',
        bannerType: 'long_text_button',
        variant: 'confirm2'
    },
    confirm3: {
        // There is no messageKey in this variant
        successKey: 'login.confirmPhoneSuccess',
        transitionName: 'confirm_phone',
        bannerType: 'auto_trigger',
        variant: 'confirm3',
        autoTriggeredOverlay: true
    },
    add: {
        messageKey: 'login.addPhone',
        successKey: 'login.addPhoneSuccess',
        transitionName: 'add_phone',
        bannerType: 'short_text_link',
        variant: 'add'
    },
    add1: {
        messageKey: 'login.addPhoneWithButton',
        successKey: 'login.addPhoneSuccess',
        transitionName: 'add_phone',
        bannerType: 'short_text_button',
        variant: 'add1'
    },
    add2: {
        messageKey: 'login.addPhoneLongWithButton',
        successKey: 'login.addPhoneSuccess',
        transitionName: 'add_phone',
        bannerType: 'long_text_button',
        variant: 'add2'
    },
    add3: {
        // There is no messageKey in this variant
        successKey: 'login.addPhoneSuccess',
        transitionName: 'add_phone',
        bannerType: 'auto_trigger',
        variant: 'add3',
        autoTriggeredOverlay: true
    }
};

var getDolphinEligibility = exports.getDolphinEligibility = function getDolphinEligibility(stateName) {
    var isReviewOrFi = /checkout\.review|checkout\.selectFi/.test(stateName) && _squid.$util.param('ulToast');

    if (!isReviewOrFi) {
        _logger.$logger.info(flowName, {
            'from': 'dolphin_elg_chk',
            'to': 'process_dolphin_elg_chk',
            'eligibility_reason': 'not_ryp',
            'context_id': _angular.$rootScope.token
        });
        return _squid.$promise.resolve();
    }

    return _eligibility.$stickyCTA.instance().getEligibility()
    // Dolphin can be enabled only in case sticky & credit interstitial are not eligibile
    .then(function (isStickyEligible) {
        var eligibilityReason = 'no_sticky_or_credit';
        var isCreditInsterstialEligible = getCreditInterstitialEligibility();

        if (isCreditInsterstialEligible) {
            eligibilityReason = 'has_credit_interstitial';
        }

        if (isStickyEligible) {
            eligibilityReason = 'has_sticky';
        }

        _logger.$logger.info(flowName, {
            'from': 'dolphin_elg_chk',
            'to': 'process_dolphin_elg_chk',
            'eligibility_reason': eligibilityReason,
            'context_id': _angular.$rootScope.token
        });

        return !isStickyEligible && !isCreditInsterstialEligible;
    });
};

_angular.$rootScope;

_squid.$locale;

_squid.$promise;

_squid.$util;

_logger.$logger;

_eligibility.$stickyCTA;

/***/ }),

/***/ "../node_modules/xo-login-components/src/fullpage-onetouch-upsell/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

__webpack_require__("../node_modules/ul-inline/dist/inject.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

var _kmliUpsell = __webpack_require__("../node_modules/xo-login-components/src/onetouch-interstitial/kmliUpsell.js");

var _template = __webpack_require__("../node_modules/xo-login-components/src/fullpage-onetouch-upsell/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoFullpageOnetouchUpsell', function () {

    return {
        template: _template2['default'],
        scope: {
            token: '=?'
        },
        controller: ['$scope', function ($scope) {
            $scope.locale = _squid.$LocaleModel.instance();
            $scope.disableCloseButton = _index.$DeviceInfo.isDevice();
            var ulMeta = _squid.$config.ulMeta || {};
            var PAYPAL = window.PAYPAL || {};
            var ulTimeOutValue = 5000;
            var ulTimeoutPromise = null;
            var styleSet = false;

            var fptiData = _kmliUpsell.$KmliUpsell.getFPTIAttributes();

            function deInitStyles() {
                $('#paypalLogo').show();
                $('.footer').show();
                $('.paypalHeaderWrapper.span14').attr('style', '');
                $('.row-fluid.paypalHeaderWrapper').show();
            }

            function closeInterstitial() {
                deInitStyles();
                _uiRouter.$state.go('checkout.review');
            }

            function failureHandler(reason) {
                _logger.$logger.info('KMLI_UPSELL_error_' + reason);
                closeInterstitial();
            }

            var startTimerTS;
            function startTimer(tag) {
                startTimerTS = Date.now();
                _logger.$logger.info('KMLI_UPSELL_START_TIMER_' + tag, {
                    startTime: startTimerTS
                });

                _logger.$logger.info('checkout_fpti', {
                    'from': 'Interstitial_Timer',
                    'to': 'prepare_' + tag
                });

                ulTimeoutPromise = (0, _angular.$timeout)(function () {
                    var stop_time = Date.now();
                    var time_taken = stop_time - startTimerTS;
                    _logger.$logger.info('checkout_fpti', {
                        'from': 'Interstitial_Timer',
                        'to': 'process_timeout',
                        'int_error_code': 'ULLOGIN_TIMEOUT',
                        'int_error_description': 'ULLOGIN_TIMEOUT',
                        'error_source': 'unifiedloginnodeweb',
                        'error_type': 'soft_decline',
                        'page_load_time': time_taken
                    });
                    failureHandler('timedout');
                    _angular.$rootScope.$emit('loaded');
                }, ulTimeOutValue);
            }

            function stopTimer(tag) {
                var stopTimerTS = Date.now();
                var timeTaken = stopTimerTS - startTimerTS;
                _logger.$logger.info('KMLI_UPSELL_STOP_TIMER_' + tag, {
                    stopTimer: stopTimerTS,
                    page_load_time: timeTaken
                });

                _logger.$logger.info('checkout_fpti', {
                    'from': 'Interstitial_Timer',
                    'to': 'process_' + tag,
                    'page_load_time': timeTaken
                });

                if (ulTimeoutPromise) {
                    _angular.$timeout.cancel(ulTimeoutPromise);
                }
            }

            function logSubmit(data) {
                var fptiPayload = {
                    'from': fptiData.stateName,
                    'to': 'process' + fptiData.transInfix + 'optin'
                };
                if (data && data.errorCode) {
                    angular.extend(fptiPayload, {
                        'int_error_code': data.errorCode,
                        'error_type': 'hard_decline',
                        'error_source': 'unifiedloginnodeweb'
                    });
                }
                _logger.$logger.info('checkout_fpti', fptiPayload);
            }

            $scope.$on('$locationChangeStart', function (event, next, current) {
                if (styleSet) {
                    deInitStyles();
                }
            });

            $scope.hideModal = function (event) {
                if (event) {
                    event.preventDefault();
                }

                _logger.$logger.info('checkout_fpti', {
                    'from': fptiData.stateName,
                    'to': 'process' + fptiData.transInfix + 'decline',
                    'click_source': 'close_button'
                });

                closeInterstitial();
            };

            var ulEventHandlers = {
                'oneTouchInterstitialOptInLoaded': function oneTouchInterstitialOptInLoaded(data) {
                    stopTimer(data.event);
                    _angular.$rootScope.$emit('loaded');
                    $('#paypalLogo').hide();
                    $('.footer').hide();
                    $('.paypalHeaderWrapper.span14').attr('style', 'border:none;');
                    $('.row-fluid.paypalHeaderWrapper').hide();
                    styleSet = true;
                },
                'oneTouchInterstitialOptInAttempted': function oneTouchInterstitialOptInAttempted(data) {
                    _angular.$rootScope.$emit('loading');
                    startTimer(data.event);
                },
                'oneTouchInterstitialOptInSuccess': function oneTouchInterstitialOptInSuccess(data) {
                    stopTimer(data.event);
                    _angular.$rootScope.$emit('loaded');
                    logSubmit();
                    closeInterstitial(data);
                },
                'oneTouchInterstitialOptInFailed': function oneTouchInterstitialOptInFailed(data) {
                    stopTimer(data.event);
                    _angular.$rootScope.$emit('loaded');
                    logSubmit({ errorCode: data.event });
                    closeInterstitial(data);
                },
                'oneTouchInterstitialOptInNotAuthorized': function oneTouchInterstitialOptInNotAuthorized(data) {
                    stopTimer(data.event);
                    logSubmit({ errorCode: data.event });
                    _angular.$rootScope.$emit('loaded');
                    closeInterstitial(data);
                },
                'oneTouchInterstitialOptInNotNowClicked': function oneTouchInterstitialOptInNotNowClicked(data) {
                    _logger.$logger.info('checkout_fpti', {
                        'from': fptiData.stateName,
                        'to': 'process' + fptiData.transInfix + 'decline',
                        'click_source': 'not_now_link'
                    });
                    closeInterstitial(data);
                }
            };

            function postMessageHandler(response) {
                (0, _angular.$timeout)(function () {
                    _logger.$logger.info('ul_postmessaged_received', response);
                    var data = response.data || response.error;
                    var eventId = data && data.event;
                    if (eventId) {
                        _logger.$logger.debug('KMLI_UPSELL_' + eventId, response);
                        var handler = ulEventHandlers[eventId];
                        if (handler) {
                            handler(data);
                        }
                    }
                });
            }

            function loadOneTouchUpsell() {
                _angular.$rootScope.$emit('loading');
                var options = {
                    targetElement: document.getElementById('injectedOneTouchInterstitial'),
                    queryParams: {
                        'stsRedirectUri': ulMeta.stsReturnUrl,
                        'country.x': $scope.locale.country,
                        'locale.x': $scope.locale.getLocaleCode(),
                        'flowId': $scope.token,
                        'correlationId': _model.$CalDataModel.getCalCorrId(),
                        'flowName': 'checkout'
                    },
                    iframePathname: '/signin/activate-one-touch',
                    onPostMessage: postMessageHandler
                };

                angular.extend(options.queryParams, _kmliUpsell.$KmliUpsell.getOptions());

                if (_squid.$config.deploy.isLocal()) {
                    options.origin = 'https://' + _squid.$meta.stage;
                }

                if (PAYPAL && PAYPAL.unifiedLogin) {
                    startTimer('initializeUpsell');
                    PAYPAL.unifiedLogin.inject(options);
                } else {
                    failureHandler('PAYPAL.unifiedLogin_undefined');
                }
            }

            loadOneTouchUpsell();
        }]
    };
});

_angular.$rootScope;

_angular.$timeout;

_squid.$config;

_squid.$LocaleModel;

_squid.$meta;

_uiRouter.$state;

_logger.$logger;

_index.$DeviceInfo;

_model.$CalDataModel;

_kmliUpsell.$KmliUpsell;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-login-components/src/fullpage-onetouch-upsell/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$FullpageOnetouchUpsellRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-login-components/src/fullpage-onetouch-upsell/directive.js");

var $FullpageOnetouchUpsellRoute = exports.$FullpageOnetouchUpsellRoute = _squid.$ComponentRoute.extend('FullpageOnetouchUpsellRoute', {
    name: 'FullpageOnetouchUpsell',
    directive: 'xo-fullpage-onetouch-upsell',
    trackingData: {
        fptiState: 'fullpage-onetouch-upsell',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-onetouch-upsell',
                'pagename2': '%::fullpage-onetouch-upsell:member:hermes:',
                'version': 'member:%:'
            }
        }
    },

    children: []
});

angular.value("$FullpageOnetouchUpsellRoute", $FullpageOnetouchUpsellRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-login-components/src/fullpage-onetouch-upsell/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"aside\">\n    <a class=\"close\" href=\"#\" title=\"Close\" ng-click=\"hideModal($event)\"></a>\n    <div id=\"injectedOneTouchInterstitial\">\n    </div>\n</div>\n<div class=\"pushLogo\"></div>\n<div class=\"logo\"></div>\n\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/login-overlay/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-login-components/src/create-password/directive.js");

__webpack_require__("../node_modules/xo-login-components/src/login/handler/directive.js");

__webpack_require__("../node_modules/xo-login-components/src/password-recovery/directive.js");

var _template = __webpack_require__("../node_modules/xo-login-components/src/login-overlay/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoLoginOverlay', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            stateInfo: '=?',
            modalCallback: '=?'
        },
        controller: ['$scope', '$element', function ($scope, $element) {
            $scope.autoLogin = false;
            $scope.ulEligibility = true;
            $scope.auth = _auth.$AuthModel.instance();

            var stateInfo = {};
            var subFlowTitles = {
                addCard: 'loginAddCard',
                bank: 'loginAddBank',
                addShipping: 'loginAddAddress',
                deleteShipping: 'loginDeleteAddress',
                confirmUpop: 'loginConfirmUpop',
                redirectToCape: 'loginApplyCredit',
                sepaAgreement: 'riskyLoginSepa',
                DEFAULT: 'loginTitle'
            };

            function getFptiStateName() {
                if ($scope.createPassword) {
                    return 'quick_security_check';
                } else if ($scope.passwordRecovery) {
                    return 'password_recovery';
                } else {
                    return 'LOGIN_STEP_UP_AUTH';
                }
            }

            /**
             * Use iframe for risky login use case.
             *
             * @param {any} event: name of the event.
             * @param {any} data: state and contextual data
             */
            var doRiskyLoginViaIframe = function doRiskyLoginViaIframe(event, data) {
                _logger.$logger.debug('doRiskyLoginViaIframe');
                $scope.showOverlay = true;

                $('#wrapper #spinner').hide();

                stateInfo = data;

                var subFlowName = (stateInfo.newState || '').replace(/^.*\./, '');

                if (subFlowName) {
                    $scope.subFlowName = subFlowName;
                    $scope.subFlowTitleKey = 'login.' + subFlowTitles[subFlowName] || subFlowTitles.DEFAULT;
                }

                $scope.createPassword = (0, _squid.$feature)('pomaPasswordRecovery') && $scope.auth.password_less;
                $scope.passwordRecovery = false;
                if ($scope.createPassword) {
                    _logger.$logger.info('checkout_fpti', {
                        from: getFptiStateName(),
                        to: 'prepare_quick_security_check'
                    });
                } else {
                    _logger.$logger.info('checkout_fpti', {
                        from: getFptiStateName(),
                        to: 'prepare_login_step_up_AUTH'
                    });
                }

                (0, _angular.$timeout)(function () {
                    $element.addClass('overlayOpen');
                });
            };

            /**
             * Do a full page redirect to ul as landing for risky login use case.
             *
             * @param {any} event: name of the event.
             * @param {any} data: state and contextual data
             */
            var doRiskyLoginViaFullpageRedirect = function doRiskyLoginViaFullpageRedirect(event, data) {
                _logger.$logger.debug('doRiskyLoginViaFullpageRedirect');
                stateInfo = data;
                var subFlowName = (stateInfo.newState || '').replace(/^.*\./, '');
                var subFlowTitleKey = subFlowName && subFlowTitles[subFlowName] || subFlowTitles.DEFAULT;

                return $scope.auth.redirectToLogin('insufficientPermission', {
                    ulClientKey: subFlowTitleKey
                });
            };

            /**
             * Decide to do fullpage or iframe risky login.
             *
             * @param {any} event: name of the event.
             * @param {any} data: state and contextual data
             */
            var doRiskyLogin = function doRiskyLogin(event, data) {
                _logger.$logger.debug('doRiskyLogin');
                if (_squid.$config.fullPageRiskyLogin) {
                    return doRiskyLoginViaFullpageRedirect(event, data);
                } else {
                    return doRiskyLoginViaIframe(event, data);
                }
            };

            var cancelInsufficientPermission = _angular.$rootScope.$on('$insufficientPermission', doRiskyLogin);

            $scope.$on('$destroy', cancelInsufficientPermission);

            var hideOverlay = function hideOverlay() {
                $('#wrapper #spinner').attr('style', '');
                $element.removeClass('overlayOpen');
                return (0, _angular.$timeout)(function () {
                    $scope.showOverlay = false;
                }, 300);
            };

            function logCancel() {
                _logger.$logger.info('checkout_fpti', {
                    from: getFptiStateName(),
                    to: 'process_user_cancel'
                });
            }

            $scope.hideModal = function (event) {
                event.preventDefault();
                logCancel();
                hideOverlay();
                _uiRouter.$state.go(stateInfo.oldState);
            };

            $scope.onCreatePassword = function () {
                _angular.$rootScope.$emit('loading');
                $scope.passwordRecovery = true;
            };

            $scope.onPasswordRecoveryReady = function () {
                _angular.$rootScope.$emit('loaded');
                $scope.createPassword = false;
            };

            $scope.onCompletePasswordRecovery = function () {
                $scope.passwordRecovery = false;
            };

            $scope.onPasswordRecovery = function () {
                $scope.auth.password_less = false;
            };

            $scope.onSuccess = function () {
                var checkoutSession = _index.$CheckoutSessionModel.instance($scope.token);
                var checkoutCart = _index.$CheckoutCartModel.instance(_angular.$rootScope.token);
                return checkoutSession.action('create', {
                    data: {
                        baToken: checkoutCart.billing && checkoutCart.billing.ba_token
                    },
                    success: function success() {
                        if (stateInfo.pageOnOverlay) {
                            _uiRouter.$state.go(stateInfo.newState, { fromLoginOverlay: true });
                            $scope.showOverlay = false;
                        } else {
                            hideOverlay().then(function () {
                                _uiRouter.$state.go(stateInfo.newState);
                            });
                        }

                        _logger.$logger.info('checkout_fpti', {
                            from: getFptiStateName(),
                            to: 'process_login_step_up_AUTH'
                        });
                    }
                })['finally'](function () {
                    hideOverlay();
                });
            };
        }]
    };
});

_angular.$rootScope;

_angular.$timeout;

_squid.$config;

_squid.$feature;

_uiRouter.$state;

_logger.$logger;

_auth.$AuthModel;

_index.$CheckoutCartModel;

_index.$CheckoutSessionModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-login-components/src/login-overlay/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"showOverlay\" class=\"pageOverlay\" ng-class=\"{mobile: isDevice}\">\n    <div class=\"overlayMask\"></div>\n    <div class=\"overlayWrapper\">\n        <div class=\"overlayContainer\">\n            <xo-spinner></xo-spinner>\n            <div class=\"aside\">\n                <a class=\"close\" href=\"#\" ng-click=\"hideModal($event)\"></a>\n                <section class=\"login\" id=\"login\">\n                    <xo-login-handler ng-if=\"!passwordRecovery && !createPassword\" token=token auto-login=\"autoLogin\" success-callback=\"onSuccess\" ul-eligibility=\"ulEligibility\" sub-flow-title-key=\"subFlowTitleKey\" hideloginpp=\"true\"></xo-login-handler>\n                    <xo-create-password ng-if=\"createPassword\" token=\"token\" reason=\"subFlowName\" on-continue=\"onCreatePassword\" on-cancel=\"hideModal\"></xo-create-password>\n                    <xo-password-recovery ng-if=\"passwordRecovery\" token=\"token\" on-password-recovery=\"onPasswordRecovery\" on-load=\"onPasswordRecoveryReady\" on-continue=\"onCompletePasswordRecovery\" on-cancel=\"onCancel\"></xo-password-recovery>\n                </section>\n            </div>\n            <div class=\"pushLogo\"></div>\n        </div>\n        <div class=\"logo\"></div>\n    </div>\n</div>\n\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/login/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _dist = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _credit = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _user = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/popup/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

var _fn = __webpack_require__("../node_modules/xo-login-components/src/login/fn.js");

var _template = __webpack_require__("../node_modules/xo-login-components/src/login/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoLogin', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            doneFn: '=?',
            errorFn: '=?',
            clientId: '=?',
            redirectUri: '=?',
            scope: '=?',
            autoLogin: '=?',
            apsIntegration: '=?',
            batch: '=?',
            loginSubmit: '=?'
        },
        controller: ['$scope', '$element', function ($scope, $element) {
            $scope.locale = _squid.$locale;
            var lang = _squid.$locale.lang ? _squid.$locale.lang : 'en';
            var country = _squid.$locale.country ? _squid.$locale.country : 'US';
            var localeNVP = 'locale.x=' + lang.toLowerCase() + '_' + country.toUpperCase();
            var forgotPasswordUrl = 'https://www.paypal.com/' + country.toLowerCase() + '/webapps/accountrecovery/passwordrecovery?' + localeNVP;
            var legacyForgotPasswordUrl = 'https://www.paypal.com/' + country.toLowerCase() + '/merchantpaymentweb?cmd=_account-recovery&from=PayPal&' + localeNVP;
            var checkoutInputData = _user.$CheckoutInputDataModel.instance(_angular.$rootScope.token);
            var creditData = _credit.$CreditDataModel.instance(_angular.$rootScope.token);
            var apsRemMe = $scope.apsIntegration === 'apsIntegrationRM';
            var $passwordField = $element.find('[ng-model="auth.password"]');
            var fptiStateName = $scope.apsIntegration ? 'LOGIN_APS' : 'LOGIN';

            $scope.forgotPasswordUrl = (0, _squid.$feature)('newForgotPasswordSupported') ? forgotPasswordUrl : legacyForgotPasswordUrl;
            _fn.$fn.sendTypingSpeedPayload('Hermes');

            /* ******** Here goes the Remember User controls *************************** */

            // Show the RM consent section when
            // 1. feature is ON
            // 2. when its not a contingency flow
            // 3. eBay doesn't want to hide it explicitly

            if (checkoutInputData.rmEnabled(Boolean(_squid.$config.rememberMeFeatureEnabled)) && !checkoutInputData.hideRM()) {
                fptiStateName = 'LOGIN_RM';
                $scope.rememberMe = 'nonKmli';
            } else if (apsRemMe) {
                $scope.rememberMe = 'kmli';
            }
            $scope.rememberMeChkBox = {
                // Leave the consent box un-ticked by default
                agreed: false
            };

            // Show the RM details only if user clicks on 'learn more' link or clicks on Checkbox
            $scope.showRmMore = false;

            // Expand details when RM check-box is ticked and Remember the user
            $scope.toggleRMDetails = function () {
                $scope.showRmMore = $scope.rememberMeChkBox.agreed;
            };

            function setRememberUser() {
                if (checkoutInputData.rmEnabled(Boolean(_squid.$config.rememberMeFeatureEnabled))) {
                    if (checkoutInputData.hideRM() === 'true') {
                        // Feature is ON but consent box is hidden since hideRM param is true
                        // Do not remember user in this case
                        $scope.auth.rememberUser = false;
                    } else {
                        // RM is enabled and consent box displayed on login page
                        // Remember the user based on the consent of user
                        $scope.auth.rememberUser = $scope.rememberMeChkBox.agreed ? true : false;
                    }
                } else {
                    // Feature is wired off
                    // If RM is not enabled that means the control is with eBay and we should retain current behavior by remembering the user
                    $scope.auth.rememberUser = true;
                }
            }

            /* ************ Remember User Ends *************************************** */

            function showLoadingMessage() {
                _angular.$rootScope.$emit('loadingMessage', _squid.$locale.content.get(creditData.isRedirectFromCape() || creditData.isChangeStatus() ? 'base.processing' : 'base.loggingIn'));
            }

            function loginAction() {
                showLoadingMessage();
                var loginInput = {
                    user: {
                        email: $scope.auth.email,
                        password: $scope.auth.password
                    }
                };

                if ($scope.clientId) {
                    loginInput.client = {
                        redirect_uri: _squid.$config.app_redirect_uri,
                        client_id: _squid.$config.app_clientId || '',
                        target_client_id: _squid.$util.param('fromLipp') === 'true' ? $scope.clientId : _squid.$util.base64Decode($scope.clientId), // eslint-disable-line block-scoped-var,no-undef
                        scope: $scope.scope,
                        response_type: 'token id_token',
                        skip_oauth: false,
                        skip_consent: true
                    };
                } else if ($scope.apsIntegration) {
                    loginInput.client = {
                        remember_me: Boolean(apsRemMe && $scope.rememberMeChkBox.agreed)
                    };
                    loginInput.fastLogin = true;
                }

                // updated the product to decide the entry point
                loginInput.product = _angular.$rootScope.wps ? 'wps' : 'ec';

                // if risk_correlation_id (fraudNetId) is present in cart, then include it to req
                loginInput.fraudnet_id = $scope.checkoutCart.supplementary && $scope.checkoutCart.supplementary.risk_correlation_id;

                // add token (cart-id) in context for RL
                var adsClientContextData = { context_type: 'Cart-ID', context_id: $scope.token };

                loginInput['ads-client-context-data'] = adsClientContextData;
                $scope.auth.action('login', {
                    data: loginInput,
                    headers: {
                        'x-pp-ads-client-context-data': JSON.stringify(adsClientContextData)
                    },
                    success: function success(result) {
                        var transition_name = $scope.rememberMeChkBox.agreed ? 'process_login_rm' : 'process_login';

                        _logger.$logger.info('checkout_fpti', {
                            'from': fptiStateName,
                            'to': transition_name
                        });

                        if (window.xprops && window.xprops.onAuth && $scope.auth.access_token) {
                            return window.xprops.onAuth({
                                accessToken: $scope.auth.access_token
                            }).then(function () {
                                return $scope.doneFn($scope.auth);
                            });
                        }
                        return $scope.doneFn($scope.auth);
                    },

                    contingencies: {
                        DEFAULT: function DEFAULT(name, contingency) {
                            var transition_name = $scope.rememberMeChkBox.agreed ? 'process_login_rm' : 'process_login';
                            var error_source = $scope.apsIntegration ? 'aps' : 'userauth';

                            _logger.$logger.info('checkout_fpti', {
                                'from': fptiStateName,
                                'to': transition_name,
                                'int_error_description': contingency && contingency.message,
                                'error_type': 'soft_decline',
                                'error_source': error_source
                            });
                            $scope.auth.password = '';
                            $passwordField.focus();
                            return $scope.errorFn(name, contingency);
                        }
                    }
                });
            }

            $scope.$on('$destroy', function () {
                $scope.auth.password = '';
            });

            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance(),
                checkoutCart: _index.$CheckoutCartModel.instance($scope.token)
            }).then(function () {
                if ($scope.auth.loggedIn()) {
                    if ($scope.autoLogin) {
                        showLoadingMessage();
                        if ($scope.auth.remembered) {
                            _logger.$logger.info('REMEMBERED_ACTIVE_SESSION');
                        } else {
                            _logger.$logger.info('ACTIVE_SESSION');
                        }
                        return $scope.doneFn($scope.auth);
                    }
                } else if ($scope.checkoutCart.payer && $scope.checkoutCart.payer.email && !$scope.auth.timed_out) {
                    $scope.auth.email = $scope.checkoutCart.payer.email;
                }
                var transition_name = void 0;

                if (apsRemMe) {
                    transition_name = 'prepare_login_rm';
                } else if (creditData.isCreditTxn()) {
                    transition_name = 'prepare_login_ppc';
                } else {
                    transition_name = 'prepare_login';
                }

                var app_int_type = _dist.$DeviceInfo.getAppIntegrationType();

                _logger.$logger.info('checkout_fpti', {
                    'from': fptiStateName,
                    'to': transition_name,
                    'app_int_type': app_int_type
                });
                $scope.onSubmit = function () {
                    setRememberUser();
                    loginAction();
                };
            });
        }]
    };
});

_angular.$rootScope;

_logger.$logger;

_auth.$AuthModel;

_dist.$DeviceInfo;

_credit.$CreditDataModel;

_user.$CheckoutInputDataModel;

_index.$CheckoutCartModel;

_squid.$config;

_squid.$feature;

_squid.$locale;

_squid.$populate;

_squid.$util;

_fn.$fn;

/***/ }),

/***/ "../node_modules/xo-login-components/src/login/fn.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$fn', function () {
    var fncls = 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99';
    var fnCorrId;
    var fraudnetConfig = _squid.$config.fraudnet;
    var token = _angular.$rootScope.token || _squid.$meta.token;

    if (_squid.$meta.baToken) {
        _logger.$logger.info('BEAM_In_Hermes_Checkout');
        fnCorrId = _squid.$meta.baToken;
    } else if (_angular.$rootScope.fraudNetId) {
        fnCorrId = _angular.$rootScope.fraudNetId;
    } else {
        fnCorrId = _angular.$rootScope.token || _squid.$meta.token;
    }

    var options = {
        fnSessionId: fnCorrId,
        sourceId: fraudnetConfig && fraudnetConfig.sourceId || 'HERMES_SIGNIN',
        allowsCustomEvent: typeof CustomEvent !== 'undefined' && _angular2['default'].isFunction(CustomEvent)
    };

    function init() {

        _logger.$logger.info('FN_contexts', {
            'token': token,
            'fnSessionId': options.fnSessionId
        });

        // Todo: remove the conditional logic after all the boxes picked up latest config.
        if (_angular2['default'].isString(_squid.$config.urls.fraudnetUrl)) {
            options.fnUrl = _squid.$config.urls.fraudnetUrl;
        } else {
            options.fnUrl = _squid.$config.urls.fraudnetUrl && _squid.$config.urls.fraudnetUrl.passive;
        }

        _logger.$logger.info('FN_Initialised', {
            'allowsCustomEvent': options.allowsCustomEvent
        });
    }

    var enableFraudnet = function enableFraudnet() {
        var userAgent = _angular.$window.navigator.userAgent;

        // Disable for web view
        if (_index.$DeviceInfo.isApp()) {
            if (_angular.$window.enableFraudNetForMobileWebView) {
                _logger.$logger.info('Enable_FN_MobileApp_PXP_Decision');
                return true;
            }

            _logger.$logger.info('Disable_FN_Mobileapp');
            return false;
        } else if (userAgent.indexOf('EtsyInc') > -1) {
            _logger.$logger.info('Disable_FN_Etsy');
            return false;
        }
        _logger.$logger.info('Enable_FN');
        return true;
    };

    function injectScript(fnUrl) {
        var script = document.createElement('script');
        script.id = 'js-sync';
        script.src = fnUrl;
        document.body.appendChild(script);
    }

    function injectIframe(beaconOptions) {
        var iframe = document.createElement('iframe');
        var dom;
        var doc;
        var where;

        iframe.src = 'about:blank'; // eslint-disable-line no-script-url
        iframe.title = '';
        iframe.role = 'presentation';
        (iframe.frameElement || iframe).style.cssText = 'width: 0; height: 0; border: 0; display: none;';

        where = document.getElementsByTagName('script');
        where = where[where.length - 1];
        where.parentNode.insertBefore(iframe, where);

        try {
            doc = iframe.contentWindow.document;
        } catch (e) {
            dom = document.domain;
            iframe.src = 'javascript:var d=document.open();d.domain="' + dom + '";void(0);'; // eslint-disable-line no-script-url
            doc = iframe.contentWindow.document;
        }

        doc.open()._l = function () {
            var js = this.createElement('script');
            if (dom) {
                this.domain = dom;
            }
            js.id = 'js-iframe-async';
            js.src = beaconOptions.fnUrl;
            this.body.appendChild(js);
        };
        function listener() {
            doc._l();
        }
        if (iframe.addEventListener) {
            iframe.addEventListener('load', listener, false);
        } else if (iframe.attachEvent) {
            iframe.attachEvent('onload', listener);
        } else {
            doc.write('<body onload="document._l();">');
        }
        doc.close();
    }

    function _injectConfig(configOptions) {
        var script = document.getElementById('fconfig');

        if (script) {
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        }

        script = document.createElement('script');
        script.id = 'fconfig';
        script.type = 'application/json';
        script.setAttribute('fncls', fncls);

        script.text = '{"f": "' + configOptions.fnSessionId + '", "s": "' + configOptions.sourceId + '", "cb": "fnCallback"}';
        document.body.appendChild(script);
    }

    /**
     * Loads the fraudnet beacons (triggers 2 image beacons to c.paypal.com and c6.paypal.com)
     *
     * Integration pattern ripped from the Fraudnet Integration guide:
     * https://confluence.paypal.com/display/RiskDataAcquisition/FraudNet+Client+System+Integration+Guide+3.0#FraudNetClientSystemIntegrationGuide3.0-IntegrationCode
     */
    function _loadBeacon(beaconOptions) {
        if (_index.$DeviceInfo.isApp() && _angular.$window.enableFraudNetForMobileWebView) {
            injectScript(beaconOptions.fnUrl);
        } else {
            injectIframe(beaconOptions);
        }
    }

    function trigger(scope) {

        var fnLoaded = !!_angular.$rootScope.fnLoaded;

        if (fnLoaded) {
            return false;
        }
        _logger.$logger.info('Trigger_FN');

        if (options.fnUrl) {
            if (enableFraudnet()) {
                _angular.$window.fnCallback = function () {
                    if (scope) {
                        scope.$emit('fnCallback');
                    }
                };
                _injectConfig(options);
                _loadBeacon(options);
                _angular.$rootScope.fnLoaded = true;
                return true;
            }
        }
        return false;
    }

    /**
     * send a payload to fraudnet for analysing typing speed
     * @param type
     */
    function sendTypingSpeedPayload(type) {

        var tsLoadPayload = {
            'detail': {
                'type': type
            }
        };

        if (type === 'Hermes') {
            tsLoadPayload.detail['fields'] = ['username', 'password'];
        }
        if (type === 'HermesUL') {
            tsLoadPayload.detail['frame'] = 'injectedUl';
            tsLoadPayload.detail['fields'] = ['email', 'password'];
        }

        if (type) {
            var event;
            if (options.allowsCustomEvent) {
                // document.createEvent deprecated
                _logger.$logger.info('fn_CustomEvent_type1');
                event = new CustomEvent('tsLoad', tsLoadPayload);
            } else {
                // IE does not support CustomEvent constructor
                try {
                    _logger.$logger.info('fn_CustomEvent_type2');
                    event = window.document.createEvent('CustomEvent');
                    event.initCustomEvent('tsLoad', true, true, tsLoadPayload.detail);
                } catch (err) {
                    _logger.$logger.info('fn_CustomEvent_None', {
                        'error': err
                    });
                }
            }
            if (event) {
                window.document.dispatchEvent(event);
                _logger.$logger.info('Dispatched_FN_TS_Payload_' + type);
            }
        }
    }

    return {
        init: init,
        trigger: trigger,
        sendTypingSpeedPayload: sendTypingSpeedPayload
    };
});

_squid.$config;

_squid.$meta;

_angular.$rootScope;

_angular.$window;

_logger.$logger;

_index.$DeviceInfo;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-login-components/src/login", "../node_modules/xo-login-components/src/login/fn.js"))

/***/ }),

/***/ "../node_modules/xo-login-components/src/login/handler/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _props = __webpack_require__("../node_modules/xo-login-components/src/login/props.js");

var _template = __webpack_require__("../node_modules/xo-login-components/src/login/handler/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-login-components/src/unified-login/directive.js");

__webpack_require__("../node_modules/xo-login-components/src/login/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoLoginHandler', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            successCallback: '=?',
            contingencyCallback: '=?',
            autoLogin: '=?',
            ulEligibility: '=?',
            subFlowTitleKey: '=?',
            apsIntegration: '=?',
            batch: '=?',
            loginSubmit: '=?',
            logout: '=?',
            preAuth: '=?',
            hideloginpp: '=?',
            flowcontext: '=?',
            hideTitle: '=?'
        },

        controller: ['$scope', function ($scope) {
            // Login Contingency Handling
            var CONTENT_KEY = {
                INVALID_EMAIL_PASSWORD: 'invalidEmailPasswordPageError',
                ACCOUNT_LOCKED: 'accountLockedPageError',
                ACCOUNT_CLOSED: 'accountLockedPageError',
                INVALID_PHONE: 'invalidPhone',
                INVALID_PIN: 'invalidPin',
                INVALID_ACCESS_TOKEN: 'invalidAccessToken',
                TIMED_OUT: 'loginStatusTimedOut',
                CANNOT_PAY_SELF: 'cannotPaySelf',
                RISK_DECLINE: 'riskDeclinePageError',
                LOGIN_ADD_PHONE: 'loginAddPhone',
                LOGIN_PREFILLED_SHIPPING_ADDRESS: 'loginMerchantPassedAddress',
                LOGIN_CONTINGENCY: 'loginContingency',
                LOGIN_REACTIVATE: 'checkOneTouch',
                LOGIN_LEAVECHECKED: 'leaveOneTouchChecked',
                LOGIN_OT_GENERIC_ERROR: 'reactivateOneTouch',
                VENMO_GENERIC_ERROR: 'venmoGenericError'
            };

            var CONTENT_MAPPING = {
                INVALID_USER: { content: CONTENT_KEY.INVALID_EMAIL_PASSWORD, type: 'error' },
                INVALID_PHONE_PIN: { content: CONTENT_KEY.INVALID_PIN, type: 'error' },
                INVALID_ACCESS_TOKEN: { content: CONTENT_KEY.INVALID_ACCESS_TOKEN, type: 'error' },
                LOCKED_USER: { content: CONTENT_KEY.ACCOUNT_LOCKED, type: 'error' },
                ACCOUNT_LOCKED: { content: CONTENT_KEY.ACCOUNT_LOCKED, type: 'error' },
                CLOSED_USER: { content: CONTENT_KEY.ACCOUNT_CLOSED, type: 'error' },
                TIMED_OUT: { content: CONTENT_KEY.TIMED_OUT, type: 'error' },
                CANNOT_PAY_SELF: { content: CONTENT_KEY.CANNOT_PAY_SELF, type: 'error' },
                RISK_DECLINE: { content: CONTENT_KEY.RISK_DECLINE, type: 'error' },
                addPhone: { content: CONTENT_KEY.LOGIN_ADD_PHONE, type: 'error' },
                PAYER_AUTHENTICATION_REQUIRED: {
                    content: CONTENT_KEY.LOGIN_PREFILLED_SHIPPING_ADDRESS,
                    type: 'info'
                },
                LOGIN_CONTINGENCY: { content: CONTENT_KEY.LOGIN_CONTINGENCY, type: 'error' },
                ONETOUCH_REACTIVATE: { content: CONTENT_KEY.LOGIN_REACTIVATE, type: 'warning' },
                ONETOUCH_LEAVECHECKED: { content: CONTENT_KEY.LOGIN_LEAVECHECKED, type: 'warning' },
                ONETOUCH_GENERIC_ERROR: { content: CONTENT_KEY.LOGIN_OT_GENERIC_ERROR, type: 'warning' },
                VENMO_ERROR: { content: CONTENT_KEY.VENMO_GENERIC_ERROR, type: 'error' }
            };

            function populateMessage(name, type) {
                var contentKey = CONTENT_MAPPING[name];
                if (contentKey) {
                    $scope.message = {
                        msgKeys: ['login.' + contentKey.content],
                        type: type || contentKey.type
                    };
                } else {
                    _logger.$logger.debug('unresolved content for login ' + type + ' message ' + name + ' in xo-login page');
                }
            }

            function handleAuthChallengeFailure(urlParams) {
                if (urlParams.acRedirect === '2fa') {
                    var userLocale = urlParams['locale.test'];

                    if (userLocale) {
                        _squid.$locale.chosenLang = _squid.$localeHelper.normalizeLocale(userLocale).language;
                    }

                    if (urlParams.ulMethod === 'phone') {
                        _logger.$logger.debug('2FA_RETURNED_FAILED_PHONE');
                        populateMessage('INVALID_PHONE_PIN', 'error');
                    } else {
                        _logger.$logger.debug('2FA_RETURNED_FAILED_EMAIL');
                        populateMessage('INVALID_USER', 'error');
                    }
                } else if (urlParams.acRedirect === 'loginato') {
                    _logger.$logger.debug('LOGIN_ATO_RETURNED_FAILED');
                    _uiRouter.$state.go('checkout.genericError', { code: 'RESTRICTED_USER' });
                } else if (urlParams.acRedirect === 'safe') {
                    _logger.$logger.debug('SAFE_RETURNED_FAILED');
                    _uiRouter.$state.go('checkout.genericError', { code: 'RESTRICTED_USER' });
                }
            }

            function handleAuthChallengeSuccess(urlParams) {
                switch (urlParams.acRedirect) {
                    case '2fa':
                        _logger.$logger.debug('2FA_RETURNED_SUCCESS');
                        break;
                    case 'loginato':
                        _logger.$logger.debug('LOGIN_ATO_RETURNED_SUCCESS');
                        break;
                    case 'safe':
                        _logger.$logger.debug('SAFE_RETURNED_SUCCESS');
                        break;
                    default:
                    // do nothing
                }
                $scope.auth.is_auth_api_call = !urlParams.acRedirect;
            }

            $scope.onComplete = function (auth) {
                // Dont show the login contingency message once poma password recovery is enabled.
                if (!(0, _squid.$feature)('pomaPasswordRecovery') && $scope.auth.password_less && $scope.checkoutCart.isBilling()) {
                    populateMessage('LOGIN_CONTINGENCY', 'info');
                }

                if (_angular.$rootScope.contingency && _angular.$rootScope.contingency.message) {
                    populateMessage(_angular.$rootScope.contingency.message, 'error');
                } else {
                    if (!_squid.$util.param('langTgl')) {
                        //  for UL Landing
                        _squid.$locale.choose(auth.country, auth.language, false);
                    }
                    $scope.successCallback();
                }
            };

            // Make country and lang available to htmlContent for dynamically generating content
            $scope.locale = _squid.$locale;

            if (_uiRouter.$stateParams.targetPage) {
                if (_props.$loginProps.inList(_uiRouter.$stateParams.targetPage) && (0, _squid.$feature)('riskyLoginContingency')) {
                    var riskyLoginInfo = _props.$loginProps.mapInfo(_uiRouter.$stateParams.targetPage);
                    $scope.subFlowTitleKey = riskyLoginInfo.title;
                    $scope.contingencyDesc = riskyLoginInfo.subtitle;
                    $scope.hideloginpp = true;
                    $scope.postlogout = function () {
                        delete $scope.subFlowTitleKey;

                        if ($scope.contingencyDesc) {
                            delete $scope.contingencyDesc;
                        }

                        delete $scope.hideloginpp;
                        $scope.showLanguageDropdown = (0, _squid.$feature)('languageToggle');
                        $scope.logout();
                    };
                } else {
                    var errMessage = CONTENT_MAPPING[_uiRouter.$stateParams.targetPage] ? _uiRouter.$stateParams.targetPage : 'LOGIN_CONTINGENCY';
                    var type = errMessage.type ? errMessage.type : 'info';
                    populateMessage(errMessage, type);
                }
            }

            if (_auth.$AuthModel.instance().meta.invalidated) {
                populateMessage('TIMED_OUT', 'error');
            } else if (_auth.$AuthModel.instance().meta.selfPay) {
                populateMessage('CANNOT_PAY_SELF', 'error');
                _auth.$AuthModel.instance().meta.selfPay = false;
            }

            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance(),
                checkoutCart: _index.$CheckoutCartModel.instance($scope.token).retrieve()
            }).then(function () {
                // Land on create password info page in case poma user was routed to login, after the
                // initial login/auth.
                if ((0, _squid.$feature)('pomaPasswordRecovery') && $scope.auth.password_less && !$scope.autoLogin) {
                    _uiRouter.$state.go('checkout.createPassword', { targetPage: _uiRouter.$stateParams.targetPage });
                    return;
                }

                var ULCallbacks = {
                    showErrorMessages: function showErrorMessages(errorCase) {
                        populateMessage(errorCase);
                        (0, _angular.$timeout)(function () {
                            $scope.$digest(); // eslint-disable-line angular/ng_no_digest
                        });
                    },
                    toggleUnifiedLogin: function toggleUnifiedLogin(value) {
                        $scope.ulEligibility = value;
                        $scope.apsIntegration = true;
                        _angular.$rootScope.continueLoadingForUL = value;
                        (0, _angular.$timeout)(function () {
                            $scope.$digest(); // eslint-disable-line angular/ng_no_digest
                        });
                    }
                };

                // redirect to UL if config says true and we have targetPage
                if (_squid.$config.fullPageRiskyLogin && _uiRouter.$stateParams.targetPage) {
                    _logger.$logger.debug('doRiskyLoginViaRedirectToUL');
                    // delete scope variables to avoid UL iframe execution
                    delete $scope.ulEligibility;
                    delete $scope.apsIntegration;

                    var subFlowTitleKey = $scope.subFlowTitleKey && $scope.subFlowTitleKey.split('.')[1];

                    return $scope.auth.redirectToLogin('insufficientPermission', {
                        ulClientKey: subFlowTitleKey
                    });
                } else {
                    _logger.$logger.debug('doRiskyLoginViaiFrameInHermes');
                    $scope.ULCallback = function (name, value) {
                        var callback = ULCallbacks[name];
                        if (callback) {
                            callback(value);
                        }
                    };
                }

                if ($scope.auth.timed_out) {
                    populateMessage('TIMED_OUT', 'error');
                }

                if (!$scope.subFlowTitleKey) {
                    $scope.showLanguageDropdown = (0, _squid.$feature)('languageToggle');
                }

                var urlParams = _squid.$util.params();

                if (urlParams.acRedirect) {
                    // Returning from auth challenge
                    if (urlParams.failedBecause) {
                        handleAuthChallengeFailure(urlParams);
                    } else {
                        handleAuthChallengeSuccess(urlParams);
                    }
                }

                var getErrorDesc = function getErrorDesc(msg) {
                    return decodeURIComponent(msg);
                };

                var getErrorType = function getErrorType(msg) {
                    var errorNum = decodeURIComponent(msg).match(/\d+/g); // to extract the error type from the error msg
                    return errorNum ? errorNum : '';
                };

                var mapCodeToError = function mapCodeToError(code) {

                    var errorMap = {
                        '82016': 'RISK',
                        '82017': 'COMPLIANCE'
                    };

                    return errorMap[code];
                };

                if (_uiRouter.$stateParams.venmoError) {

                    if (_uiRouter.$stateParams.errorCode) {

                        var errorSource = mapCodeToError(_uiRouter.$stateParams.errorCode);
                        if (errorSource) {
                            _logger.$logger.info('checkout_fpti', {
                                from: 'VENMO_ENTRYPOINT',
                                to: 'process_checkout_login',
                                'int_error_code': _uiRouter.$stateParams.errorCode,
                                'int_error_description': _uiRouter.$stateParams.errorMessage ? getErrorDesc(_uiRouter.$stateParams.errorMessage) : '',
                                'error_type': _uiRouter.$stateParams.errorMessage ? getErrorType(_uiRouter.$stateParams.errorMessage) : '',
                                'error_source': errorSource
                            });
                        }
                    }

                    populateMessage('VENMO_ERROR', 'error');
                }

                var handleContingency = {
                    // Errors - Show Page Level Error
                    INVALID_USER: populateMessage,
                    LOCKED_USER: populateMessage,
                    ACCOUNT_LOCKED: populateMessage,
                    CLOSED_USER: populateMessage,
                    ONETOUCH_REACTIVATE: populateMessage,
                    ONETOUCH_LEAVECHECKED: populateMessage

                };

                $scope.onContingency = function (name, contingency, type) {
                    // eslint-disable-line no-shadow

                    _squid.$locale.choose($scope.auth.country, $scope.auth.language, false);

                    if (!handleContingency[name]) {
                        return $scope.contingencyCallback(name, contingency);
                    }

                    var message_type = type || 'error';
                    return handleContingency[name](name, message_type);
                };
            });
        }]
    };
});

_angular.$rootScope;

_angular.$timeout;

_squid.$config;

_squid.$feature;

_squid.$locale;

_squid.$localeHelper;

_squid.$populate;

_squid.$util;

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_auth.$AuthModel;

_index.$CheckoutCartModel;

_props.$loginProps;

/***/ }),

/***/ "../node_modules/xo-login-components/src/login/handler/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"login\" id=\"loginSection\" content>\n    <xo-message message=\"message\"></xo-message>\n    <div class=\"pr row-fluid\" ng-class=\"{hasError: message}\" ng-hide=\"hideTitle\">\n        <xo-title class=\"xoTitle\" title-txt=\"{{content(subFlowTitleKey ? subFlowTitleKey : 'login.loginTitle')}}\" ng-class=\"{span17: showLanguageDropdown, riskyTitle: subFlowTitleKey}\"></xo-title>\n        <xo-language-options class=\"span7\" ng-if=\"showLanguageDropdown\"></xo-language-options>\n    </div>\n    <div class=\"inline-prop\" unless-feature=\"propValue\" ng-hide=\"hideloginpp\">\n        <p ng-bind-html=\"htmlContent('login.propValAlt', {country: locale.country, lang: locale.lang})\")>\n    </div>\n    <div class=\"inline-prop\" ng-show= \"contingencyDesc\" ng-class=\"{riskySubtitle: contingencyDesc}\">\n        <p ng-bind-html=\"htmlContent(contingencyDesc, {country: locale.country, lang: locale.lang})\")>\n    </div>\n    <xo-login ng-if=\"!ulEligibility\" token=token auth=auth done-fn=\"onComplete\" error-fn=\"onContingency\" auto-login=\"autoLogin\" aps-integration=\"apsIntegration\" batch=\"batch\" login-submit=\"loginSubmit\"></xo-login>\n    <xo-unified-login ng-if=\"ulEligibility\" token=token error-fn=\"onContingency\" parent-callback=\"ULCallback\" pre-auth=\"preAuth\" post-auth=\"onComplete\" auto-login=\"autoLogin\" flowcontext=\"flowcontext\" login-submit=\"loginSubmit\" logout-callback=\"postlogout\" ></xo-unified-login>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/login/kmliEligibility.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$KmliEligibility = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var scope = { eligibility: {} };
var ulMeta = _squid.$config.ulMeta || {};

var getPXPList = function getPXPList(country) {
    // returns a list of Pxp's that needs to be executed
    var countryCTX = { 'ctx.COUNTRY': country };
    var pxpExpId = ulMeta.pxpExpId;
    var pxpList = [(0, _squid.$pxp)(pxpExpId, countryCTX, 'xo_hermes_ul_timeout_treatment.*', false, true), (0, _squid.$pxp)(pxpExpId, countryCTX, 'xo_hermes_ul_preload_treatment', false, true)];

    return pxpList;
};

var routingReason = function routingReason() {
    // Check for conditions that deviates from the PXP eligibility
    // Reasons that deviates from control to treatment
    var isRememberedUser = scope.auth.refreshToken();

    if (scope.kmli === true) {
        return 'kmliMandated';
    } else if (isRememberedUser) {
        return 'rememberedUser';
    } else if (_squid.$util.param('ul') === '2') {
        return 'ulParam';
    } else if (_squid.$meta.corp && ulMeta.allowKMLIForInternalIP) {
        var merchantCountry = scope.checkoutAppData.merchant.merchant_country;

        if ((0, _squid.$feature)('enableOneTouchInternalIP', false, merchantCountry)) {
            return 'internalIP';
        }
    } else if (ulMeta.enableOneTouchByDefault) {
        return 'oneTouchByDefault';
    }
};

var compatibility = function compatibility(reasons) {
    // Check for compatibility/environment issues which impacts UL/KMLI overall
    // This should override previous decisions
    if (_index.$DeviceInfo.isApp()) {
        scope.kmliEligibility = false;
        reasons.push('Webview');
    } else if (!_squid.$util.cookiesEnabled()) {
        scope.kmliEligibility = false;
        reasons.push('cookiesDisabled');
    } else if (scope.auth.ota) {
        scope.kmliEligibility = false;
        reasons.push('otaDevice');
    }

    if (scope.forcedLogin === true) {
        scope.kmliEligibility = false;
        reasons.push('forcedLogin');
    }
    if (scope.logoutCallback) {
        scope.kmliEligibility = true;
        reasons.push('riskyLoginContingency');
    }
};

var isULpreload = function isULpreload(preloadULTreatments) {
    // const userAgent = $window.navigator.userAgent;
    // const isIE = !!userAgent.match(/MSIE|trident|edge/i);
    var isTreatment = Boolean(preloadULTreatments && preloadULTreatments.treatment_name);
    var forceUlss = _squid.$util.param('_ulss') === 'true';
    var preloadUL = forceUlss || isTreatment;

    return preloadUL;
};

var isUlAsLanding = function isUlAsLanding() {
    // markes
    var forceUlAsLanding = _squid.$util.param('ul') === 'landing';
    var ulAsLandingParam = _squid.$util.param('ulReturn') === 'true';

    // tried Ul as landing -> failed -> used iframe
    var failedAttempt = _squid.$util.param('lndgFailedBecause'); // eslint-disable-line no-unused-vars


    return forceUlAsLanding || ulAsLandingParam;
};

var getTimeoutLimit = function getTimeoutLimit(pxpTimeoutTrt) {
    var ulTimeoutLimit = void 0;
    var timeoutTrtFact = pxpTimeoutTrt && angular.isArray(pxpTimeoutTrt.factors);
    var pxpTimeoutVal = timeoutTrtFact && pxpTimeoutTrt.factors[0] && pxpTimeoutTrt.factors[0].value;

    if (pxpTimeoutVal) {
        ulTimeoutLimit = pxpTimeoutVal;
        _logger.$logger.info('pxp_timeout_treatment', { ulTimeoutLimit: ulTimeoutLimit });
    }
    return ulTimeoutLimit;
};

var $KmliEligibility = exports.$KmliEligibility = {
    init: function init(params) {
        if (scope.eligibility.treatment) {
            // do not init twice
            return _angular.$q.resolve(scope.eligibility);
        }
        _logger.$logger.debug('kmliEligibility_init');
        scope.forcedLogin = params && params.forcedLogin;
        scope.logoutCallback = params && params.logoutCallback;

        return (0, _squid.$populate)(scope, {
            auth: _auth.$AuthModel.instance(),
            checkoutAppData: _index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
            checkoutCart: _index2.$CheckoutCartModel.instance(_angular.$rootScope.token)
        }).then(function () {
            var country = scope.checkoutAppData.merchant.merchant_country;

            return _angular.$q.all(getPXPList(country)).then(function (result) {
                scope.eligibility.ulTimeoutLimit = getTimeoutLimit(result[0]);
                scope.eligibility.preloadUL = isULpreload(result[1]);
                scope.eligibility.safeEligibility = true;
                scope.eligibility.ulAsLanding = isUlAsLanding();
            });
        }).then(function () {
            // STEP1: kmli pxp ramped to 100%, so always kmli eligible
            scope.kmliEligibility = true;

            // STEP2: Push the eligible reasons from routingReason check.
            var reasons = []; // Reasons that deviates from control to treatment

            reasons.push('pxpFullyRamped');

            var reason = routingReason();

            if (reason) {
                scope.kmliEligibility = true;
                reasons.push(reason);
            }

            // STEP3: Check for compatibility/environment issues which impacts UL/KMLI overall
            compatibility(reasons);

            var routing_reason = reasons[reasons.length - 1];

            scope.eligibility.treatment = true;
            scope.eligibility.routingReason = routing_reason;
            scope.eligibility.deviatingReasons = reasons;
            scope.eligibility.kmliEligibility = scope.kmliEligibility;

            // STEP4: Instrument deterministically whether KMLI is shown to the user or not
            _logger.$logger.debug(scope.kmliEligibility ? 'KMLI_ELIGIBLE_USER' : 'KMLI_INELIGIBLE_USER', { userGroup: reasons, routing_reason: routing_reason });
            _logger.$logger.info('checkout_fpti', {
                'from': 'KMLI_ELG_CHK',
                'to': 'process_kmli_elg_chk',
                routing_reason: routing_reason
            });
            return scope.eligibility;
        });
    },
    eligible: function eligible() {
        return scope.eligibility;
    }
};

angular.value("$KmliEligibility", $KmliEligibility);
_angular.$q;

_angular.$rootScope;

_squid.$config;

_squid.$feature;

_squid.$meta;

_squid.$populate;

_squid.$pxp;

_squid.$util;

_logger.$logger;

_index.$DeviceInfo;

_auth.$AuthModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutCartModel;

/***/ }),

/***/ "../node_modules/xo-login-components/src/login/props.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var RISKY_LOGIN_TITLE = {
    ECONSENT_REQUIRED: '',
    ELV_DECLINE: '',
    EXPIRED_CREDIT_CARD: 'login.riskyLoginUpdateCard',
    INSTANT_FUNDING_SOURCE_UPSELL_NEEDED: '',
    NEED_CREDIT_CARD: 'login.riskyLoginAddCard',
    NEED_CREDIT_CARD_OR_BANK_ACCOUNT: 'login.riskyLoginAddFi',
    NEED_CONFIRMED_CARD: '',
    NEED_AUTHENTICATED_CARD: 'login.riskyLoginUpdateCard',
    NEED_SHIPPING_ADDRESS: 'login.riskyLoginAddShipping',
    PHONE_NUMBER_REQUIRED: 'login.riskyLoginAddPhone',
    PAYER_AUTHENTICATION_REQUIRED: 'login.riskyLoginShippingPassed',
    SEPA_MANDATE_ACCEPTANCE_NEEDED: 'login.riskyLoginSepa',
    TAX_ID_REQUIRED: ''
};
var RISKY_LOGIN_SUBTITLE = {
    EXPIRED_CREDIT_CARD: 'login.riskyLoginExpiredCardST',
    NEED_SHIPPING_ADDRESS: 'login.riskyLoginAddShippingST',
    PHONE_NUMBER_REQUIRED: 'login.riskyLoginAddPhoneST',
    SEPA_MANDATE_ACCEPTANCE_NEEDED: 'login.riskyLoginSepaST',
    PAYER_AUTHENTICATION_REQUIRED: 'login.riskyLoginShippingPassedST'
};

var $loginProps = exports.$loginProps = {
    mapInfo: function mapInfo(contingency) {
        var contingencyTitle = RISKY_LOGIN_TITLE[contingency] ? RISKY_LOGIN_TITLE[contingency] : 'login.loginContingency';
        var contingencySubTitle = RISKY_LOGIN_SUBTITLE[contingency];

        return { title: contingencyTitle, subtitle: contingencySubTitle };
    },

    inList: function inList(contingency) {
        return RISKY_LOGIN_TITLE.hasOwnProperty(contingency);
    }
};

angular.value("$loginProps", $loginProps);

/***/ }),

/***/ "../node_modules/xo-login-components/src/login/template.html":
/***/ (function(module, exports) {

module.exports = "<form name=\"loginForm\" class=\"proceed\" content novalidate=\"novalidate\" autocomplete=\"off\">\n    <div class=\"inputField emailField confidential\">\n        <label for=\"username\" class=\"focus accessAid\">\n            {{ content('index.EmailLabel') }}\n        </label>\n        <input ng-model=\"auth.email\" id=\"username\" name=\"username\" type=\"email\" ng-readonly=\"auth.emailReadOnly\" value=\"\"\n               autocapitalize=\"off\" aria-required=\"false\" autocomplete=\"off\" placeholder=\"{{ content('index.EmailLabel') }}\" data-error-key=\"email.invalid\" xo-error-tooltip required autofocus/>\n    </div>\n\n    <div class=\"inputField passwordField confidential\">\n        <label for=\"password\" class=\"focus accessAid\">\n            {{ content('login.passwordLabel') }}\n        </label>\n        <input ng-model=\"auth.password\" id=\"password\" name=\"password\" type=\"password\" value=\"\" aria-required=\"true\" autocapitalize=\"off\" autocomplete=\"off\" placeholder=\"{{ content('login.passwordLabel') }}\" xo-error-tooltip required>\n    </div>\n\n    <div ng-switch class=\"checkbox\" id=\"rmSection\" on=\"rememberMe\">\n        <div ng-switch-when=\"nonKmli\" class=\"secondary\">\n            <input ng-model=\"rememberMeChkBox.agreed\" type=\"checkbox\" id=\"agree\" ng-click=\"toggleRMDetails()\"/>\n            <label for=\"agree\">\n                {{content('rememberMe.remember')}}\n                <a ng-click=\"showRmMore=!showRmMore\">\n                    <span ng-bind=\"showRmMore ? content('rememberMe.close'): content('rememberMe.more')\"></span>\n                </a>\n            </label>\n            <ul id=\"rmLearnMore\" ng-show=\"showRmMore\">\n                <li>{{ content('rememberMe.skipLogin') }}</li>\n                <li>{{ content('rememberMe.toCancel') }}</li>\n                <li>{{ content('rememberMe.protectAccounts') }}</li>\n            </ul>\n        </div>\n        <div ng-switch-when=\"kmli\">\n            <input ng-model=\"rememberMeChkBox.agreed\" type=\"checkbox\" id=\"agree\">\n            <label for=\"agree\" ng-bind=\"content('login.keepMeLoggedIn')\" class=\"kmliCheckboxLabel\"></label>\n            <div class=\"signupbml kmliHelpIcon\">\n                <a href=\"#\" id=\"verifyHelp\" class=\"verifyHelp\"><img alt=\"{{ content('login.kmliTooltipTitle') }}\" /></a>\n            </div>\n        </div>\n    </div>\n\n    <xo-tooltip trigger=\"#verifyHelp\" display-inline=\"true\">\n        <div class=\"keepMeLoginTerms\" id=\"keepMeLoginTerms\">\n            <p>{{ content('login.kmliTooltipLine1') }}</p>\n            <p>{{ content('login.kmliTooltipLine2') }}</p>\n            <p>{{ content('login.kmliTooltipLine3') }}</p>\n        </div>\n    </xo-tooltip>\n\n    <input track-submit type=\"submit\" value=\"{{ content('login.loginBtn') }}\" class=\"btn full loginBtn\" validate-submit=\"onSubmit()\" />\n\n    <div class=\"center mt10 secondary\" id=\"forgotPasswordSection\">\n        <a href=\"{{forgotPasswordUrl}}\" id=\"forgot_password_link\" target=\"_blank\" class=\"smallPopup\" xo-popup>\n            {{ content('common.forgotYourPassword') }}</a>\n    </div>\n</form>\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/onetouch-interstitial/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

var _kmliUpsell = __webpack_require__("../node_modules/xo-login-components/src/onetouch-interstitial/kmliUpsell.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _ui = __webpack_require__("../node_modules/xo-ui-components/src/accessibility/ui.js");

var _ui2 = _interopRequireDefault(_ui);

var _ul = __webpack_require__("../node_modules/xo-login-components/src/unified-login/ul.js");

var _template = __webpack_require__("../node_modules/xo-login-components/src/onetouch-interstitial/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoOnetouchUpsell', function () {

    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            onComplete: '=?',
            disableCloseButton: '=?',
            ignoreBgClicks: '=?'
        },
        controller: ['$scope', '$element', function ($scope, $element) {
            $scope.oneTouchFlowName = _uiRouter.$stateParams.oneTouchFlowName;
            $scope.modalActive = false;
            $scope.locale = _squid.$LocaleModel.instance();
            $scope.disableCloseButton = $scope.disableCloseButton || _index.$DeviceInfo.isDevice();
            $scope.upsellOptInDisplayed = false;
            var ulMeta = _squid.$config.ulMeta || {};
            var PAYPAL = window.PAYPAL || {};
            var ulTimeOutValue = 5000;
            var ulTimeoutPromise = null;

            var fptiData = _kmliUpsell.$KmliUpsell.getFPTIAttributes();

            if (!$scope.onComplete) {
                $scope.onComplete = function (params) {
                    _auth.$AuthModel.instance().retrieve().then(function (auth) {
                        auth.isKmliSet = params && params.isKmliSet;
                        _uiRouter.$state.go('checkout.review');
                    });
                };
            }

            _kmliUpsell.$KmliUpsell.eligible().then(function (eligibility) {
                if (eligibility && eligibility.interstitial && eligibility.interstitial.color) {
                    $scope.color = eligibility.interstitial.color;
                    $scope.showUpsellBanner = eligibility.banner;
                }
            });

            function closeInterstitial(params) {
                $('#wrapper > xo-spinner').attr('style', '');
                $('body').removeClass('kmliUpsellActive');
                $element.removeClass('upsellOpen');
                $scope.onComplete(params);
            }

            function failureHandler(reason) {
                _logger.$logger.info('KMLI_UPSELL_error_' + reason);
                closeInterstitial();
            }

            var startTimerTS;
            function startTimer(tag) {
                startTimerTS = Date.now();
                _logger.$logger.info('KMLI_UPSELL_START_TIMER_' + tag, {
                    startTime: startTimerTS
                });

                _logger.$logger.info('checkout_fpti', {
                    'from': 'Interstitial_Timer',
                    'to': 'prepare_' + tag
                });

                ulTimeoutPromise = (0, _angular.$timeout)(function () {
                    var stop_time = Date.now();
                    var time_taken = stop_time - startTimerTS;
                    _logger.$logger.info('checkout_fpti', {
                        'from': 'Interstitial_Timer',
                        'to': 'process_timeout',
                        'int_error_code': 'ULLOGIN_TIMEOUT',
                        'int_error_description': 'ULLOGIN_TIMEOUT',
                        'error_source': 'unifiedloginnodeweb',
                        'error_type': 'soft_decline',
                        'page_load_time': time_taken
                    });
                    failureHandler('timedout');
                    _angular.$rootScope.$emit('loaded');
                }, ulTimeOutValue);
            }

            function stopTimer(tag) {
                var stopTimerTS = Date.now();
                var timeTaken = stopTimerTS - startTimerTS;
                _logger.$logger.info('KMLI_UPSELL_STOP_TIMER_' + tag, {
                    stopTimer: stopTimerTS,
                    page_load_time: timeTaken
                });

                _logger.$logger.info('checkout_fpti', {
                    'from': 'Interstitial_Timer',
                    'to': 'process_' + tag,
                    'page_load_time': timeTaken
                });

                if (ulTimeoutPromise) {
                    _angular.$timeout.cancel(ulTimeoutPromise);
                }
            }

            function logSubmit(data) {
                var fptiPayload = {
                    'from': fptiData.stateName,
                    'to': 'process' + fptiData.transInfix + 'optin'
                };
                if (data && data.errorCode) {
                    angular.extend(fptiPayload, {
                        'int_error_code': data.errorCode,
                        'error_type': 'hard_decline',
                        'error_source': 'unifiedloginnodeweb'
                    });
                }
                _logger.$logger.info('checkout_fpti', fptiPayload);
            }

            $scope.hideModal = function (event) {
                if (event) {
                    event.preventDefault();
                } else if ($scope.ignoreBgClicks) {
                    return;
                }

                _logger.$logger.info('checkout_fpti', {
                    'from': fptiData.stateName,
                    'to': 'process' + fptiData.transInfix + 'decline',
                    'click_source': 'close_button'
                });

                closeInterstitial();
            };

            var ulEventHandlers = {
                'oneTouchInterstitialOptInLoaded': function oneTouchInterstitialOptInLoaded(data) {
                    stopTimer(data.event);
                    _angular.$rootScope.$emit('loaded');
                    $('#wrapper > xo-spinner').hide();
                    $('body').addClass('kmliUpsellActive');

                    // CSS transition to open upsell modal and set modal to trap focus after open
                    (0, _angular.$timeout)(function () {
                        $element.addClass('upsellOpen');
                        $element.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
                            $scope.$apply(function () {
                                $scope.modalActive = true;
                                // Focus Continue button in iframe
                                $('#injectedOneTouchInterstitial').focus();

                                var escHandler = function escHandler(event) {
                                    if (event.keyCode === _ui2['default'].KEYS.ESC) {
                                        $scope.hideModal();
                                    }
                                };

                                // Add handler to iframe document, as events do not propagate past the iframe
                                $element.find('iframe').contents().on('keydown', escHandler);
                                $element.on('keydown', escHandler);
                            });
                        });
                    });
                },
                'oneTouchInterstitialOptInAttempted': function oneTouchInterstitialOptInAttempted(data) {
                    _angular.$rootScope.$emit('loading');
                    startTimer(data.event);
                },
                'oneTouchInterstitialOptInSuccess': function oneTouchInterstitialOptInSuccess(data) {
                    stopTimer(data.event);
                    _angular.$rootScope.$emit('loaded');
                    logSubmit();
                    closeInterstitial(data);
                },
                'oneTouchInterstitialOptInFailed': function oneTouchInterstitialOptInFailed(data) {
                    stopTimer(data.event);
                    _angular.$rootScope.$emit('loaded');
                    logSubmit({ errorCode: data.event });
                    closeInterstitial(data);
                },
                'oneTouchInterstitialOptInNotAuthorized': function oneTouchInterstitialOptInNotAuthorized(data) {
                    stopTimer(data.event);
                    logSubmit({ errorCode: data.event });
                    _angular.$rootScope.$emit('loaded');
                    closeInterstitial(data);
                },
                'oneTouchInterstitialOptInNotNowClicked': function oneTouchInterstitialOptInNotNowClicked(data) {
                    _logger.$logger.info('checkout_fpti', {
                        'from': fptiData.stateName,
                        'to': 'process' + fptiData.transInfix + 'decline',
                        'click_source': 'not_now_link'
                    });
                    closeInterstitial(data);
                }
            };

            function postMessageHandler(response) {
                (0, _angular.$timeout)(function () {
                    _logger.$logger.info('ul_postmessaged_received', response);
                    var data = response.data || response.error;
                    var eventId = data && data.event;
                    if (eventId) {
                        _logger.$logger.debug('KMLI_UPSELL_' + eventId, response);
                        var handler = ulEventHandlers[eventId];
                        if (handler) {
                            handler(data);
                        }
                    }
                });
            }

            function upsellOptInDisplayed() {
                return _auth.$AuthModel.instance().retrieve().then(function (auth) {
                    if (auth.upsellOptInDisplayed) {
                        $scope.upsellOptInDisplayed = true;
                    }
                });
            }

            function loadOneTouchUpsell() {
                // eslint-disable-line no-unused-vars
                upsellOptInDisplayed().then(function () {
                    // If the optin upsell is already displayed, no need to display again.
                    if ($scope.upsellOptInDisplayed) {
                        $scope.onComplete();
                    } else {
                        _angular.$rootScope.$emit('loading');

                        var options = {
                            targetElement: document.getElementById('injectedOneTouchInterstitial'),
                            queryParams: {
                                'stsRedirectUri': ulMeta.stsReturnUrl,
                                'country.x': $scope.locale.country,
                                'locale.x': $scope.locale.getLocaleCode(),
                                'flowId': $scope.token,
                                'correlationId': _model.$CalDataModel.getCalCorrId(),
                                'flowName': $scope.oneTouchFlowName
                            },
                            iframePathname: '/signin/activate-one-touch',
                            onPostMessage: postMessageHandler
                        };

                        angular.extend(options.queryParams, _kmliUpsell.$KmliUpsell.getOptions());

                        if (_squid.$config.deploy.isLocal()) {
                            if (_squid.$meta.stage) {
                                options.origin = 'https://' + _squid.$meta.stage;
                            } else {
                                // if no stage url shows up then use any backup url for origin
                                options.origin = _squid.$config.onboarding.url.split('/webapps/')[0];
                            }
                        }

                        if (PAYPAL && PAYPAL.unifiedLogin) {
                            startTimer('initializeUpsell');
                            PAYPAL.unifiedLogin.inject(options);
                        } else {
                            failureHandler('PAYPAL.unifiedLogin_undefined');
                        }
                    }
                });
            }

            (0, _angular.$timeout)(function () {
                $element.addClass('upsellOpen');
            });

            $scope.optinOneTouch = function () {
                var flowName = 'checkoutInterstitial'; // login interstitial flow
                var fptiPayload = {
                    stateName: fptiData.stateName,
                    transInfix: 'process' + fptiData.transInfix + 'optin'
                };
                var silent = true;
                return _ul.$ul.optInToOneTouch($scope.token, _squid.$locale.country, _squid.$locale.getLocaleCode(), silent, fptiPayload, flowName).then(closeInterstitial({ isKmliSet: true }))['catch'](function (err) {
                    closeInterstitial({
                        isKmliSet: false,
                        error: err
                    });
                });
            };
        }]
    };
});

_angular.$rootScope;

_angular.$timeout;

_squid.$config;

_squid.$locale;

_squid.$LocaleModel;

_squid.$meta;

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_index.$DeviceInfo;

_model.$CalDataModel;

_kmliUpsell.$KmliUpsell;

_auth.$AuthModel;

_ul.$ul;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-login-components/src/onetouch-interstitial/kmliUpsell.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$KmliUpsell = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _newMember = __webpack_require__("../node_modules/xo-models/src/newMember/index.js");

var _kmliEligibility = __webpack_require__("../node_modules/xo-login-components/src/login/kmliEligibility.js");

// Model Retrived
var idToken = void 0;
// models

var successfulLogin = void 0;
var isOneTouched = void 0;
var upsellOptInDisplayed = void 0; // eslint-disable-line no-unused-vars
var kmliEligible = void 0;
var walletTokenization = void 0;
var preloadUL = void 0;
var lastUpsellVersion = void 0; // eslint-disable-line no-unused-vars
var showReactivationInterstitial = void 0;
var kmliChecked = void 0; // Passed in init
var expPromise = void 0; // Promisified experience data
var scope = {};

var getKmliContentKey = function getKmliContentKey() {
    // NOTE: `xo_hermesnode_kmli_upsell` has been removed
    // and currently it's always returned `xo_hermesnode_kmli_content_t1`
    scope.oneTouchContentVersion = 1;
    return _angular.$q.resolve();
};

// Determine if the NMJ experience the user has is ineligible
var getIsNmj = function getIsNmj() {
    return _newMember.$NewMemberEligibility.instance().isNmj(scope.token);
};

var resolveEligibilityConditions = function resolveEligibilityConditions(params) {
    idToken = Boolean(scope.auth.idTokenPresent);
    successfulLogin = scope.auth.loggedIn();
    isOneTouched = scope.auth.loggedIn() && scope.auth.refreshToken();
    walletTokenization = scope.checkoutCart.isWalletTokenization() || scope.auth.remembered_partner_assertion; // android pay, apple pay, etc
    kmliChecked = Boolean(params.isKmliSet); // may not be OT but user has already opted in
    upsellOptInDisplayed = Boolean(scope.auth.upsellOptInDisplayed);
    lastUpsellVersion = scope.auth.ryiOptIn && scope.auth.ryiOptIn.interstitialDisplayed;
    showReactivationInterstitial = Boolean(params.showReactivationInterstitial);
    _logger.$logger.debug('kmliUpsell_resolveEligibilityConditions', { params: params });

    if (walletTokenization || preloadUL || scope.oneTouchContentVersion !== '3') {
        // do not trigger pxp for walletTokenization, ulpreload
        // Interstitial is only eligibile when the contentKey is set to treatment 3
        _logger.$logger.debug('kmliUpsell_init_ineligible');
    }
    return _angular.$q.resolve();
};

var $KmliUpsell = exports.$KmliUpsell = {
    init: function init(params) {
        scope.token = _angular.$rootScope.token;

        if (expPromise) {
            return; // do not init twice
        }
        _logger.$logger.debug('kmliUpsell_init', params);
        expPromise = _kmliEligibility.$KmliEligibility.init().then(function (KmliEligibility) {
            kmliEligible = Boolean(KmliEligibility.kmliEligibility) && !params.jwtBasedAssertion;
            preloadUL = Boolean(KmliEligibility.preloadUL);
            return (0, _squid.$populate)(scope, {
                auth: _auth.$AuthModel.instance(),
                checkoutCart: _index.$CheckoutCartModel.instance(scope.token),
                checkoutAppData: _index.$CheckoutAppDataModel.instance(scope.token)
            });
        }).then(getKmliContentKey).then(function () {
            return resolveEligibilityConditions(params);
        });
    },
    // This should be called after checkout session is populated
    // Any data depending on the checkout session should be resolved here
    eligible: function eligible() {
        var eligibility = {};

        if (!expPromise) {
            _logger.$logger.debug('kmliUpsell_init_not_executed');
            return _angular.$q.resolve(eligibility);
        }
        return _angular.$q.all([expPromise, getIsNmj()]).then(function (result) {
            var experience = result[0];
            var isNmj = result[1];
            var eligibilityCriteria = {
                pxp: experience,
                profile_country: (0, _squid.$feature)('ryiOptIn'),
                isNotNmj: !isNmj
            };

            _logger.$logger.debug('kmliUpsell_eligiblityCheck', { eligibilityCriteria: eligibilityCriteria });

            var ineligibleReasons = _squid.$util.filter(Object.keys(eligibilityCriteria), function (key) {
                return !eligibilityCriteria[key];
            });
            var upsellFeatureEnabled = ineligibleReasons.length === 0;
            var regularLogin = kmliEligible && idToken;
            var autoLoginEnabled = isOneTouched || kmliChecked || scope.auth.remembered;

            eligibility.banner = upsellFeatureEnabled && (0, _squid.$feature)('optinToggle') && Boolean(isOneTouched || regularLogin);

            eligibility.interstitial = {
                eligible: upsellFeatureEnabled && !autoLoginEnabled && experience && experience.name && (experience.name.slice(-1) === '1' || experience.name.slice(-1) === '3') // use only treatment 1,3 for interstitial
                && experience.version,
                type: showReactivationInterstitial ? 'reactivation' : successfulLogin ? 'member' : '', // eslint-disable-line no-nested-ternary
                color: experience && experience.color,
                pxpVersion: experience && experience.pxpVersion
            };

            var elgStr = 'interstitial-' + eligibility.interstitial.eligible + '&toggle-';

            _logger.$logger.info('ryi_optin', {
                'from': 'ryi_optin_elg_chk',
                'to': 'process_ryi_optin_elg_chk',
                'eligibility_reason': upsellFeatureEnabled ? elgStr + 'eligible' : elgStr + 'ineligible_' + ineligibleReasons.join()
            });
            _logger.$logger.debug('kmliUpsell_eligibility', {
                eligibility: eligibility,
                experience: experience,
                cases: {
                    activeOT: isOneTouched,
                    regularLogin: regularLogin,
                    feature: upsellFeatureEnabled
                }
            });
            return eligibility;
        });
    },
    getOptions: function getOptions() {
        if (showReactivationInterstitial) {
            return {
                flowName: 'expiredUpsell'
            };
        }
    },
    getFPTIAttributes: function getFPTIAttributes() {
        if (showReactivationInterstitial) {
            return {
                stateName: 'KMLI_reactivation',
                transInfix: '_kmli_reactivation_'
            };
        } else {
            return {
                stateName: 'KMLI_UPSELL',
                transInfix: '_kmli_upsell_'
            };
        }
    }
};

angular.value("$KmliUpsell", $KmliUpsell);
_angular.$q;

_angular.$rootScope;

_squid.$feature;

_squid.$populate;

_squid.$util;

_logger.$logger;

_auth.$AuthModel;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_newMember.$NewMemberEligibility;

_kmliEligibility.$KmliEligibility;

/***/ }),

/***/ "../node_modules/xo-login-components/src/onetouch-interstitial/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$OneTouchUpsellRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-login-components/src/onetouch-interstitial/directive.js");

var $OneTouchUpsellRoute = exports.$OneTouchUpsellRoute = _squid.$ComponentRoute.extend('OneTouchUpsellRoute', {
    name: 'oneTouchUpsell',
    directive: 'xo-onetouch-upsell',
    trackingData: {
        fptiState: 'onetouch-upsell',
        buzname: {
            'fullpage': {
                'pagename': '%::onetouch-upsell',
                'pagename2': '%::onetouch-upsell:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    query: ['oneTouchFlowName'],
    children: []
});
angular.value("$OneTouchUpsellRoute", $OneTouchUpsellRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-login-components/src/onetouch-interstitial/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"kmliUpsell\" ng-class=\"{mobile: isDevice}\" content>\n    <div class=\"upsellMask_white\"></div>\n    <div class=\"upsellWrapper\" ng-class=\"{whiteWithBlur: color === 'white' , blackWithBlur: color === 'black'}\" simple-modal=\"modalActive\" modal-cancel=\"hideModal()\">\n        <div class=\"upsellContainer\">\n            <div ng-if=\"showUpsellBanner\" class=\"fill\"></div>\n            <div class=\"aside\">\n                <a class=\"close\" href=\"#\" title=\"Close\" ng-click=\"hideModal($event)\" ng-hide=\"disableCloseButton\" aria-label=\"{{content('common.back')}}\"></a>\n                <section class=\"login\" id=\"login\">\n                    <div class=\"promoHeading\" ng-bind-html=\"content('oneTouchUpsell.promoHeading')\"></div>\n                    <div class=\"promo\">\n                        <div class=\"icon password\"></div>\n                        <div class=\"text\" ng-bind-html=\"content('oneTouchUpsell.promoText1')\"></div>\n                    </div>\n                    <div class=\"promo\">\n                        <div class=\"icon merchants\"></div>\n                        <div class=\"text\" ng-bind-html=\"content('oneTouchUpsell.promoText2')\"></div>\n                    </div>\n                    <div class=\"promo\">\n                        <div class=\"icon secure\"></div>\n                        <div class=\"text\" ng-bind-html=\"content('oneTouchUpsell.promoText3')\"></div>\n                    </div>\n                    <div class=\"buttons\">\n                        <input type=\"button\" value=\"{{content('common.activate')}}\" class=\"btn full\" ng-click=\"optinOneTouch()\">\n                        <div class=\"cancel\">\n                            <a href=\"#\" prevent-default ng-click=\"hideModal($event)\">{{content('common.noThanks')}}</a>\n                        </div>\n                    </div>\n                </section>\n            </div>\n            <div class=\"pushLogo\"></div>\n        </div>\n        <div class=\"logo\" id=\"pp_min_logo\"></div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/password-recovery-overlay/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _template = __webpack_require__("../node_modules/xo-login-components/src/password-recovery-overlay/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoPasswordRecoveryOverlayDirective', {
    tag: 'xo-password-recovery-overlay',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        cancel: {
            type: 'var',
            required: false
        },
        success: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            var auth = _auth.$AuthModel.instance();

            _angular.$rootScope.$emit('loading');

            var hideOverlay = function hideOverlay(callback) {
                $('#wrapper #spinner').attr('style', '');
                _this.$element.removeClass('overlayOpen');
                (0, _angular.$timeout)(function () {
                    return callback();
                }, 300);
            };

            this.hideModal = function (event) {
                event.preventDefault();
                hideOverlay(auth.password_less ? _this.cancel : _this.success);
            };

            this.onPasswordRecoveryReady = function () {
                (0, _angular.$timeout)(function () {
                    _angular.$rootScope.$emit('loaded');
                    _this.$element.addClass('overlayOpen');
                });
            };

            this.onContinue = function () {
                hideOverlay(_this.success);
            };

            this.onPasswordRecovery = function () {
                auth.password_less = false;
            };
        }
    }
});


_squid.$Component;

_angular.$rootScope;

_angular.$timeout;

_auth.$AuthModel;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-login-components/src/password-recovery-overlay/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("../node_modules/xo-login-components/src/password-recovery-overlay/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Route.extend('$xoPasswordRecoveryOverlayRoute', {
    path: 'passwordRecovery',
    directive: _directive2['default'],
    trackingData: {
        fptiState: 'password_recovery'
    },
    children: []
});


_squid.$Route;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-login-components/src/password-recovery-overlay/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"pwrOverlay\" ng-class=\"{mobile: isDevice}\">\n    <div class=\"overlayMask\"></div>\n    <div class=\"overlayWrapper\">\n        <div class=\"overlayContainer\">\n            <xo-spinner></xo-spinner>\n            <div class=\"aside\">\n                <a track-link=\"user_cancel\" class=\"close\" href=\"#\" ng-click=\"hideModal($event)\"></a>\n                <section id=\"pwrOverlay\">\n                    <xo-password-recovery token=\"token\" on-password-recovery=\"onPasswordRecovery\" on-load=\"onPasswordRecoveryReady\" on-continue=\"onContinue\"></xo-password-recovery>\n                </section>\n            </div>\n            <div class=\"pushLogo\"></div>\n        </div>\n        <div class=\"logo\"></div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/password-recovery/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-login-components/src/password-recovery/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoPasswordRecoveryDirective', {
    tag: 'xo-password-recovery',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        onContinue: {
            type: 'var',
            required: false
        },
        onPasswordRecovery: {
            type: 'var',
            required: false
        },
        onLoad: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            var PAYPAL = window.PAYPAL;

            this.loaded = false;
            var postMessageHandler = function postMessageHandler(response) {
                (0, _angular.$timeout)(function () {
                    switch (response.event) {
                        case 'render':
                            if (response.pageName === 'authflow/password-recovery/done') {
                                _this.onPasswordRecovery();
                                _logger.$logger.info('checkout_fpti', {
                                    from: 'password_recovery',
                                    to: 'process_password_recovery'
                                });
                            } else if (response.pageName === 'authflow/password-recovery') {
                                _this.onLoad();
                                _this.loaded = true;
                                _logger.$logger.info('checkout_fpti', {
                                    from: 'password_recovery',
                                    to: 'prepare_password_recovery'
                                });
                            } else {
                                // Do nothing
                            }
                            break;
                        case 'passwordSetSuccess':
                            _this.onContinue();
                            break;
                        default:
                            break;
                    }
                });
            };

            this.loadPasswordRecoveryFlow = function () {
                var isHermesInsideIframe = _squid.$util.isIFrame();

                if (isHermesInsideIframe) {
                    _logger.$logger.info('MERCHANT_IFRAME_INTEGRATION');
                }
                var options = {
                    targetElement: document.getElementById('injectedPasswordRecovery'),
                    xhrRequest: isHermesInsideIframe,
                    iframePathname: '/authflow/password-recovery',
                    caller: 'secondaryIframe',
                    queryParams: {
                        'country.x': _squid.$locale.country,
                        'locale.x': _squid.$locale.getLocaleCode(),
                        'contextId': _this.token,
                        'correlationId': _model.$CalDataModel.getCalCorrId()
                    },
                    onPostMessage: postMessageHandler
                };

                if (_squid.$config.deploy.isLocal()) {
                    options.origin = 'https://' + _squid.$meta.stage;
                }

                if (PAYPAL && PAYPAL.unifiedLogin) {
                    PAYPAL.unifiedLogin.inject(options);
                }
            };

            (0, _angular.$timeout)(this.loadPasswordRecoveryFlow);
        }
    }
});


_squid.$Component;

_squid.$config;

_squid.$locale;

_squid.$meta;

_squid.$util;

_model.$CalDataModel;

_angular.$timeout;

_logger.$logger;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-login-components/src/password-recovery/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"injectedPasswordRecovery\" ng-show=\"loaded\">\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/unified-login/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _fpti = __webpack_require__("../node_modules/xo-tracking/dist/fpti.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

var _fn = __webpack_require__("../node_modules/xo-login-components/src/login/fn.js");

var _kmliEligibility = __webpack_require__("../node_modules/xo-login-components/src/login/kmliEligibility.js");

var _kmliUpsell = __webpack_require__("../node_modules/xo-login-components/src/onetouch-interstitial/kmliUpsell.js");

var _template = __webpack_require__("../node_modules/xo-login-components/src/unified-login/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoUnifiedLogin', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            redirectUri: '=?',
            parentCallback: '=?',
            doneFn: '=?',
            errorFn: '=?',
            autoLogin: '=?',
            promptlogin: '=?',
            logoutCallback: '=?',
            kmli: '=?',
            preAuth: '=?',
            postAuth: '=?',
            flowcontext: '=?'
        },
        controller: ['$scope', function ($scope) {
            var ulClientRedirect = _squid.$util.param('ulClientRedirect') || '';
            var redirect_reason_timeout = 'timeout';
            var PAYPAL = window.PAYPAL || {};
            var failureReasons = {
                timeout: 'TIMEDOUT',
                error: 'INTERNALERROR',
                blacklistedDevice: 'PLATFORM_NOT_SUPPORTED',
                fallback: 'FALLBACK'
            };
            var enteringTime = Date.now();
            var loginAttemptedMethod = '';
            var userSelectedLanguage = '';

            _logger.$logger.debug('ENTERING_LOADING_UL_IFRAME', { enteringTime: enteringTime });
            $scope.locale = _squid.$LocaleModel.instance();
            $scope.forcedLogin = !$scope.autoLogin; // change to true during forcedLogin scenario

            if (_uiRouter.$stateParams.source === 'NOT_YOU' || _uiRouter.$stateParams.source === 'FRESH_START') {
                $scope.forcedLogin = false;
            }

            var ulTimeoutLimit = 35000;
            var ulTimeoutPromise = null;
            var loadCnt = 0;

            if (ulClientRedirect === redirect_reason_timeout) {
                _logger.$logger.info('ulClientRedirect_timeout');
            }

            function setLoading(tag, isRT) {
                _angular.$rootScope.$emit('loading');
                if (isRT && !$scope.auth.loggedIn()) {
                    _angular.$rootScope.$emit('loadingMessage', {
                        heading: _squid.$locale.content.get('base.loggingIn'),
                        subHeading: _squid.$locale.content.get('login.rmSubHeading')
                    });
                }
                loadCnt++;
                _logger.$logger.debug('setLoading by ' + tag + ' cnt ' + loadCnt);
            }

            function setLoaded(tag) {
                if (loadCnt > 0) {
                    _angular.$rootScope.$emit('loaded');
                    loadCnt--;
                } else {
                    _logger.$logger.error('loadCnt_zero');
                }
                _logger.$logger.debug('setLoaded by ' + tag + ' cnt ' + loadCnt);
            }

            function fallback(product, reason, params) {
                throw new _squid.$FallbackError({
                    product: product || 'ux',
                    reason: reason,
                    params: params
                });
            }

            function appLoginHandler(status) {
                _logger.$logger.debug('ULLOGIN_' + status);
                _logger.$logger.info('checkout_fpti', { 'from': 'LOGIN', 'to': 'prepare_login' });
                fallback('ux', 'ul_server_error');
            }

            var startTimerTS = void 0;

            function startTimer(tag) {
                startTimerTS = Date.now();
                _logger.$logger.debug('startTimer by ' + tag, {
                    startTime: startTimerTS
                });
                _logger.$logger.info('checkout_fpti', {
                    'from': 'UL_Timer',
                    'to': 'prepare_' + tag
                });

                ulTimeoutPromise = (0, _angular.$timeout)(function () {
                    _logger.$logger.error('load_ul_timeout');
                    var stop_time = Date.now();
                    var time_taken = stop_time - startTimerTS;

                    _logger.$logger.info('checkout_fpti', {
                        'from': 'UL_Timer',
                        'to': 'process_timeout',
                        'int_error_code': 'ULLOGIN_TIMEOUT',
                        'int_error_description': 'ULLOGIN_TIMEOUT',
                        'error_source': 'unifiedloginnodeweb',
                        'error_type': 'soft_decline',
                        'page_load_time': time_taken
                    });
                    if (!_squid.$config.disableUlTimeout) {
                        fallback('ux', 'ul_load_timeout');
                    } else {
                        // remove after ulAsLanding risky login
                        var isRememberedUser = $scope.auth && $scope.auth.remembered;

                        // remove after ulAsLanding starts to support tokenexchange
                        var isTokenExchange = $scope.auth && $scope.auth.refreshToken() && !$scope.auth.accessToken();
                        // Do trigger for remebered user
                        // Do not trigger if already triggered before
                        // Do not trigger for RT to AT case
                        if (!ulClientRedirect && !isRememberedUser && !isTokenExchange) {
                            $scope.auth.redirectToLogin(redirect_reason_timeout);
                        }
                    }
                }, ulTimeoutLimit);
            }

            function stopTimer(tag, keepLoading) {
                var stopTimerTS = Date.now();
                var timeTaken = stopTimerTS - startTimerTS;

                _logger.$logger.debug('stopTimer by ' + tag, {
                    stopTimer: stopTimerTS,
                    page_load_time: timeTaken
                });

                _logger.$logger.info('checkout_fpti', {
                    'from': 'UL_Timer',
                    'to': 'process_' + tag,
                    'page_load_time': timeTaken
                });

                if (!keepLoading) {
                    setLoaded('stopTimer');
                }

                if (ulTimeoutPromise) {
                    _angular.$timeout.cancel(ulTimeoutPromise);
                }
            }

            function logFptiData(fptiData, eventName) {
                var errorDescription = void 0;

                switch (eventName) {
                    case '2fa':
                        errorDescription = '2fa_required';
                        break;
                    case 'safeRequired':
                        errorDescription = 'SAFE_required';
                        break;
                    case 'stepupRequired':
                        errorDescription = 'Login_ATO_required';
                        break;
                    default:
                    // nothing to do here
                }
                _logger.$logger.info('checkout_fpti', {
                    'from': fptiData.fptiState,
                    'to': fptiData.fptiTransition,
                    'int_error_code': eventName,
                    'int_error_description': errorDescription,
                    'error_type': 'soft_decline',
                    'error_source': 'unifiedloginnodeweb'
                });
            }

            function buildRedirectURL(contingencyUrl, eventName) {
                var authChallengeUrl = contingencyUrl;
                var paramIndex = authChallengeUrl.indexOf('?');
                var urlParams = _squid.$util.params(authChallengeUrl.substring(paramIndex + 1));

                urlParams.returnUri = _squid.$config.ulMeta.authChallengeReturnUri;
                if (userSelectedLanguage) {
                    urlParams['locale.x'] = _squid.$locale.getLocaleCode();
                    urlParams['state'] += '&locale.test=' + _squid.$locale.getLocaleCode();
                }
                switch (eventName) {
                    case '2fa':
                        urlParams['state'] += '&acRedirect=2fa&ulMethod=' + loginAttemptedMethod;
                        break;
                    case 'safeRequired':
                        urlParams['state'] += '&acRedirect=safe';
                        break;
                    case 'stepupRequired':
                        urlParams['state'] += '&acRedirect=loginato';
                        break;
                    default:
                    // nothing to do here
                }
                var redirectUrl = _squid.$util.buildURL(authChallengeUrl.substring(0, paramIndex), urlParams);

                return redirectUrl;
            }

            if (!_squid.$config.ulMeta) {
                _logger.$logger.error('config_no_ulMeta');
            }

            var ulMeta = _squid.$config.ulMeta || {};

            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance(),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance($scope.token),
                checkoutCart: _index2.$CheckoutCartModel.instance($scope.token)
            }).then(function () {
                // if remebered user then update spinner text
                var isRememberedUser = $scope.auth.refreshToken();

                setLoading('loadUL', isRememberedUser);

                return _kmliEligibility.$KmliEligibility.init({
                    forcedLogin: $scope.forcedLogin,
                    logoutCallback: $scope.logoutCallback
                });
            }).then(function (eligibility) {
                ulTimeoutLimit = eligibility.ulTimeoutLimit ? eligibility.ulTimeoutLimit : ulTimeoutLimit;
                $scope.preloadUL = eligibility.preloadUL;
                $scope.safeEligibility = eligibility.safeEligibility;
                $scope.kmliEligibility = eligibility.kmliEligibility;

                if ($scope.preloadUL) {
                    _logger.$logger.debug('ULSS_CLIENT_PRELOAD_TREATMENT');
                    return (0, _squid.$populate)($scope, { ulSource: _auth.$ULoginModel.instance() });
                }

                if (!$scope.checkoutCart.isWalletTokenization() && !$scope.preloadUL) {
                    $scope.ryiOptin = false;
                }
                return _angular.$q.resolve(true);
            }).then(function () {
                var rememberMe = !$scope.auth.refreshToken() ? false : $scope.kmliEligibility; // UL needs 'rememberMe=true' for RT exchange
                var app_int_type = _index.$DeviceInfo.getAppIntegrationType();

                if ($scope.auth.refreshToken() && !$scope.forcedLogin) {
                    _logger.$logger.info('checkout_fpti', {
                        'from': 'LOGIN_UL_RM',
                        'to': 'prepare_login_ul_RM',
                        app_int_type: app_int_type
                    });
                }

                function getPostLoginFpti(data) {
                    var result = void 0;

                    if (data.event === 'tokenExchanged') {
                        // This is either OneTouch or JWT (Partner Integration).
                        if (data.authorizationToken === 'jwt_token') {
                            result = { fptiState: 'LOGIN_UL_JWT', fptiTransition: 'process_UL_JWT' };
                        } else {
                            result = { fptiState: 'LOGIN_UL_RM', fptiTransition: 'process_RT_AT_exch' };
                        }
                    } else {
                        var fptiTransitionName = data.keepMeLoggedIn === true ? 'process_login_UL_RM' : 'process_login_UL';
                        var ULState = rememberMe === true ? 'LOGIN_UL_RM' : 'LOGIN_UL';

                        result = { fptiState: ULState, fptiTransition: fptiTransitionName };
                    }

                    return result;
                }

                var cancelLocaleChange = void 0;

                function loginComplete(data) {
                    var jwtBasedAssertion = data.event === 'tokenExchanged' && data.authorizationToken === 'jwt_token';
                    var rtExchanged = data.event === 'tokenExchanged' && data.authorizationToken !== 'jwt_token';

                    _squid.$promise.run(function () {
                        // eslint-disable-line
                        $scope.auth.stepupAuthRequired = false;

                        stopTimer('loginComplete');

                        if (cancelLocaleChange) {
                            cancelLocaleChange();
                        }

                        $scope.auth.isKmliSet = data.keepMeLoggedIn || rtExchanged;
                        $scope.auth.rtExchanged = rtExchanged;

                        var fptiData = getPostLoginFpti(data);

                        _logger.$logger.info('checkout_fpti', {
                            'from': fptiData.fptiState,
                            'to': fptiData.fptiTransition
                        });

                        if (window.xprops && window.xprops.onAuth && data && data.accessToken) {
                            return window.xprops.onAuth({
                                accessToken: data.accessToken
                            });
                        }
                    }).then(function () {
                        var upsellEligibilityData = { ulData: data };

                        // Doesn't exist in risky login case
                        if ($scope.preAuth) {
                            // Fires off eligibility + econsent + xosession in batch mode
                            $scope.preAuth();
                        }

                        if (data.event === 'tokenExchanged') {
                            if ((0, _squid.$feature)('rmSpinnerText') && !jwtBasedAssertion) {
                                _angular.$rootScope.$emit('loadingMessage', {
                                    heading: _squid.$locale.content.get('base.planning'),
                                    subHeading: _squid.$locale.content.get('login.rmSubHeading')
                                });
                            } else {
                                _angular.$rootScope.$emit('loadingMessage', _squid.$locale.content.get('base.planning'));
                            }
                        }

                        return $scope.auth.reload({
                            resultModel: $scope.auth,
                            headers: {
                                'x-paypal-internal-euat': data.accessToken
                            },
                            batch: {
                                name: 'setbuyer',
                                id: 'securityCtx',
                                dependencies: []
                            },
                            success: function success() {
                                $scope.auth.is_auth_api_call = data.event === 'tokenExchanged';
                                angular.extend(upsellEligibilityData, {
                                    buyerCountry: $scope.auth.country,
                                    jwtBasedAssertion: jwtBasedAssertion,
                                    showReactivationInterstitial: $scope.showReactivationInterstitial
                                });
                                _kmliUpsell.$KmliUpsell.init(upsellEligibilityData);
                                $scope.postAuth($scope.auth);
                            },
                            contingencies: {
                                DEFAULT: function DEFAULT(name, contingency) {
                                    $scope.auth.password = '';
                                    $scope.errorFn(name, contingency);
                                }
                            }
                        });
                    });
                }

                var ulEventHandlers = {
                    'loginRendered': function loginRendered(data) {
                        var loadingCompletedTime = Date.now();

                        _logger.$logger.debug('ULLOGIN_FRAME_LOADED_SUCCESSFULLY', {
                            page_load_time: loadingCompletedTime - enteringTime
                        });

                        // Check if this is triggered by JWT assertion failure.
                        // If so, do FPTI instrumentation.
                        if (data.authorizationType === 'token' && data.authorizationToken === 'jwt_token') {
                            _logger.$logger.info('checkout_fpti', {
                                'from': 'LOGIN_UL_JWT',
                                'to': 'process_UL_JWT',
                                'int_error_code': 'unknown',
                                'int_error_description': 'JWT assertion failed',
                                'error_source': 'unifiedloginnodeweb',
                                'error_type': 'soft_decline'
                            });
                        }
                    },
                    'loginFullyLoaded': function loginFullyLoaded(data) {
                        stopTimer(data.event);

                        if ($scope.notYou) {
                            _angular.$rootScope.$emit('loaded');
                            delete $scope.notYou;
                            _logger.$logger.info('checkout_fpti', {
                                'from': 'LOGIN_UL_RM',
                                'to': 'prepare_login_ul'
                            });
                            _fn.$fn.sendTypingSpeedPayload('HermesUL');
                            return $scope.logoutCallback();
                        }

                        if (!_uiRouter.$state.current.trackingData) {
                            _uiRouter.$state.current.trackingData = { fptiState: 'ulLoginDefault' };
                        }
                        _uiRouter.$state.current.trackingData.pageQualifier = 'ulLogin';

                        var loadingCompletedTime = Date.now();
                        var timeTaken = loadingCompletedTime - enteringTime;

                        _logger.$logger.debug('ULLOGIN_LOADED_SUCCESSFULLY', {
                            page_load_time: timeTaken
                        });

                        if ($scope.preLoadedSource) {
                            _logger.$logger.debug('ULSS_CLIENT_LOADED_SUCCESSFULLY', {
                                page_load_time: timeTaken
                            });
                        }

                        var ULState = rememberMe === true && !$scope.logoutCallback ? 'LOGIN_UL_RM' : 'LOGIN_UL';

                        _logger.$logger.info('checkout_fpti', {
                            'from': ULState,
                            'to': 'prepare_iframe',
                            'page_load_time': timeTaken
                        });

                        var payload = {
                            'from': ULState,
                            'to': 'prepare_login_ul',
                            'app_int_type': app_int_type
                        };

                        if (_uiRouter.$stateParams.targetPage) {
                            angular.extend(payload, { 'int_error_code': _uiRouter.$stateParams.targetPage });
                        }

                        _logger.$logger.info('checkout_fpti', payload);
                        _fn.$fn.sendTypingSpeedPayload('HermesUL');
                        _logger.$logger.flush();
                    },
                    'loginEmailPasswordAttempted': function loginEmailPasswordAttempted() {
                        loginAttemptedMethod = 'email';
                    },
                    'loginPhonePinAttempted': function loginPhonePinAttempted() {
                        loginAttemptedMethod = 'phone';
                    },
                    'loginAttempted': function loginAttempted(data) {
                        setLoading(data.event);
                        _angular.$rootScope.$emit('loadingMessage', _squid.$locale.content.get('base.loggingIn'));
                        if (rememberMe === true) {
                            var kmliStatus = data.keepMeLoggedIn === true ? 'KMLI_CHECKED' : 'KMLI_UNCHECKED';

                            _logger.$logger.debug(kmliStatus);
                        }
                        startTimer(data.event);
                    },
                    'loginSuccess': loginComplete,
                    'tokenExchanged': function tokenExchanged(data) {
                        _logger.$logger.info('TOKEN_EXCHANGED', {
                            authorizationType: data.authorizationType,
                            authorizationToken: data.authorizationToken || ''
                        });
                        loginComplete(data);
                    },
                    'notYouLinkClicked': function notYouLinkClicked(data) {
                        _angular.$rootScope.$emit('loading');
                        $scope.notYou = true;
                        _logger.$logger.info('checkout_fpti', {
                            from: 'LOGIN_UL',
                            to: 'login_with_diff_user'
                        });
                        startTimer(data.event);
                    },
                    '2fa': function fa(data) {
                        stopTimer(data.event);
                        var fptidata = getPostLoginFpti(data);

                        logFptiData(fptidata, data.event);
                        if (data.contingencyUrl) {
                            _logger.$logger.debug('ULLOGIN_TWO_FA_AUTH_REDIRECT');
                            var authChallengeRedirectUrl = buildRedirectURL(data.contingencyUrl, data.event);

                            _squid.$util.redirect(authChallengeRedirectUrl);
                        } else {
                            _logger.$logger.debug('ULLOGIN_TWO_FA_GENERIC_ERROR');
                            _uiRouter.$state.go('checkout.genericError', { code: 'DEFAULT' });
                        }
                    },
                    'safeRequired': function safeRequired(data) {
                        stopTimer(data.event);
                        var fptidata = getPostLoginFpti(data);

                        logFptiData(fptidata, data.event);
                        if ($scope.safeEligibility && data.contingencyUrl) {
                            if (data.authorizationType && data.authorizationType === 'token') {
                                // for remembered user redirect to login instead of SAFE APP
                                _logger.$logger.debug('LOGIN_REDIRECTION_SAFE_RM_USER');
                                _uiRouter.$state.go('checkout.login', { targetPage: 'LOGIN_CONTINGENCY' });
                            }
                            _logger.$logger.debug('ULSAFE_REDIRECTION');
                            var authChallengeRedirectUrl = buildRedirectURL(data.contingencyUrl, data.event);

                            _squid.$util.redirect(authChallengeRedirectUrl);
                        } else {
                            _logger.$logger.debug('ULSAFE_GENERIC_ERROR');
                            _uiRouter.$state.go('checkout.genericError', { code: 'RESTRICTED_USER' });
                        }
                    },
                    'serverError': function serverError(data) {
                        stopTimer(data.event);
                        var error_code = 'INVALID_USER';
                        var error = {
                            type: 'pageError',
                            code: 500
                        };

                        // internalServerError, code: 500, take user to hermes login, no need for error message
                        switch (data.reason) {
                            case 'serverValidationError':
                                if (data.authorizationType === 'token') {
                                    error_code = 'ONETOUCH_GENERIC_ERROR';
                                    error.msg = _squid.$locale.content.get('login.reactivateOneTouch');
                                } else if (loginAttemptedMethod === 'phone') {
                                    error_code = 'INVALID_PHONE_PIN';
                                    error.msg = _squid.$locale.content.get('login.invalidPin');
                                } else {
                                    error.msg = _squid.$locale.content.get('login.invalidEmailPasswordPageError');
                                }
                                break;
                            case 'invalidUser':
                                if (data.authorizationType === 'token') {
                                    error_code = 'ONETOUCH_GENERIC_ERROR';
                                    error.msg = _squid.$locale.content.get('login.reactivateOneTouch');
                                }
                                break;
                            case 'internalServerError':
                                if (data.authorizationType === 'token') {
                                    error_code = 'ONETOUCH_GENERIC_ERROR';
                                    error.msg = _squid.$locale.content.get('login.reactivateOneTouch');
                                } else {
                                    error.msg = _squid.$locale.content.get('login.invalidEmailPasswordPageError');
                                }
                                _fpti.$fpti.setupDataString(_uiRouter.$state.current, error);
                                return appLoginHandler(failureReasons.error);
                            case 'accountTemporaryLocked':
                            case 'accountPermanentlyLocked':
                                error.code = data.code;
                                error.msg = _squid.$locale.content.get('login.accountLockedPageError');
                                error_code = 'ACCOUNT_LOCKED';
                                break;
                            case 'riskDecline':
                                error.code = data.code;
                                if (data.authorizationType === 'token') {
                                    error_code = 'ONETOUCH_GENERIC_ERROR';
                                    error.msg = _squid.$locale.content.get('login.reactivateOneTouch');
                                } else {
                                    error.msg = _squid.$locale.content.get('login.riskDeclinePageError');
                                    error_code = 'RISK_DECLINE';
                                }
                                break;
                            default:
                            // Do nothing
                        }
                        var fptidata = getPostLoginFpti(data);

                        _logger.$logger.info('checkout_fpti', {
                            'from': fptidata.fptiState,
                            'to': fptidata.fptiTransition,
                            'int_error_code': data.code,
                            'int_error_description': data.reason,
                            'error_type': 'soft_decline',
                            'error_source': 'unifiedloginnodeweb'
                        });
                        _fpti.$fpti.setupDataString(_uiRouter.$state.current, error);
                        $scope.parentCallback('showErrorMessages', error_code);
                    },
                    'client_validation_error': function client_validation_error(data) {
                        var error = {
                            type: 'pageError',
                            msg: _squid.$locale.content.get('login.invalidEmailPasswordPageError')
                        };
                        var fptidata = getPostLoginFpti(data);

                        _logger.$logger.info('checkout_fpti', {
                            'from': fptidata.fptiState,
                            'to': fptidata.fptiTransition,
                            'int_error_code': data.event,
                            'int_error_description': 'invalid_credentials',
                            'error_type': 'soft_decline',
                            'error_source': 'unifiedloginnodeweb'
                        });
                        _fpti.$fpti.setupDataString(_uiRouter.$state.current, error);
                    },
                    'stepupRequired': function stepupRequired(data) {
                        stopTimer(data.event);
                        var fptidata = getPostLoginFpti(data);

                        logFptiData(fptidata, data.event);

                        if (data.authorizationType && data.authorizationType === 'token') {
                            // for remembered user redirect to login instead of AuthChallenge APP
                            _logger.$logger.debug('LOGIN_ATO_RM_USER');

                            // doing nothing, ul will render the login page, we need to show warning on top though
                            var error_code = 'ONETOUCH_GENERIC_ERROR';
                        } else if (data.contingencyUrl) {
                            _logger.$logger.debug('LOGIN_ATO_USER');
                            var authChallengeRedirectUrl = buildRedirectURL(data.contingencyUrl, data.event);

                            _squid.$util.redirect(authChallengeRedirectUrl);
                        } else {
                            _logger.$logger.debug('LOGIN_ATO_GENERIC_ERROR');
                            _uiRouter.$state.go('checkout.genericError', { code: 'RESTRICTED_USER' });
                        }
                        // to show error message on login page
                        $scope.parentCallback('showErrorMessages', error_code); // eslint-disable-line block-scoped-var
                    },
                    'captcha': function captcha(data) {
                        var fptiData = getPostLoginFpti(data);

                        _logger.$logger.info('checkout_fpti', {
                            'from': fptiData.fptiState,
                            'to': 'prepare_captcha'
                        });
                    },
                    'bodyClick': function bodyClick() {
                        _angular.$rootScope.$broadcast('clickBody');
                    },
                    'expiredRefreshToken': function expiredRefreshToken(data) {
                        var treatment = data.treatment;

                        _logger.$logger.info('EXPIRED_RT_' + treatment);
                        _logger.$logger.info('checkout_fpti', {
                            'from': 'LOGIN_UL_RM',
                            'to': 'process_RT_AT_exch',
                            'int_error_code': 'expired_RT_Token',
                            'int_error_desc': treatment,
                            'error_source': 'unifiedloginnodeweb',
                            'error_type': 'soft_decline'
                        });

                        switch (treatment) {
                            case 'showInterstitial':
                                $scope.showReactivationInterstitial = true;
                                break;

                            case 'checkboxPreselectedWithNotification':
                                $scope.errorFn('ONETOUCH_LEAVECHECKED', {}, 'warning');
                                break;

                            case 'checkboxNotPreselectedWithNotification':
                                $scope.errorFn('ONETOUCH_REACTIVATE', {}, 'warning');
                                break;

                            case 'expiredRefreshTokenControl':
                                break;

                            default:
                                break;
                        }
                    }
                };

                function postMessageHandler(response) {
                    (0, _angular.$timeout)(function () {
                        _logger.$logger.info('ul_postmessaged_received', response);
                        var data = response.data || response.error;
                        var eventId = data && data.event;

                        if (eventId) {
                            _logger.$logger.debug('ULLOGIN_' + eventId, response);
                            var handler = ulEventHandlers[eventId];

                            if (handler) {
                                handler(data);
                            }
                        }
                    });
                }

                function loadUnifiedLogin(iframeCopy) {
                    var queryString = _squid.$util.queryStringSplice(_squid.$util.queryString(), {
                        'flow': '1-P',
                        'token': $scope.token
                    }, ['cmd']);
                    var isHermesInsideIframe = _squid.$util.isIFrame();

                    if (isHermesInsideIframe) {
                        _logger.$logger.info('MERCHANT_IFRAME_INTEGRATION');
                    }

                    var options = {
                        targetElement: document.getElementById('injectedUnifiedLogin'),
                        xhrRequest: isHermesInsideIframe,
                        queryParams: {
                            'stsRedirectUri': ulMeta.stsReturnUrl,
                            'country.x': $scope.locale.country,
                            'locale.x': $scope.locale.getLocaleCode(),
                            'returnUri': ulMeta.ulReturnUri,
                            'state': queryString,
                            'flowId': $scope.token,
                            'correlationId': _model.$CalDataModel.getCalCorrId()
                        },
                        config: {
                            title: 'PayPal - ' + _squid.$locale.content.get('common.login')
                        },
                        onPostMessage: postMessageHandler
                    };

                    if (_squid.$meta.baToken) {
                        angular.extend(options.queryParams, { 'fn_dt': _squid.$meta.baToken });
                    }

                    if ($scope.forcedLogin) {
                        angular.extend(options.queryParams, { 'prompt': 'login' });
                    }

                    if ($scope.logoutCallback) {
                        angular.extend(options.queryParams, { 'showNotYou': true });
                    }

                    if (_uiRouter.$stateParams.source !== 'NOT_YOU') {
                        $scope.flowcontext = $scope.checkoutCart.flow_context;
                    } else {
                        $scope.flowcontext = $scope.checkoutCart.flow_context_without_email;
                    }

                    if ($scope.flowcontext) {
                        angular.extend(options.queryParams, { 'flowContextData': $scope.flowcontext });
                    }

                    if (_squid.$config.deploy.isLocal()) {
                        options.origin = 'https://' + _squid.$meta.stage;
                        if (!_squid.$meta.stage) {
                            // if no stage url shows up then use any backup url for origin
                            var backupURL = _squid.$config.onboarding.url.split('/webapps/')[0];
                            options.origin = backupURL;
                        }
                    }

                    // preload only for first time login attempts
                    if ($scope.preloadUL && $scope.ulSource && $scope.ulSource.src && !$scope.forcedLogin && _uiRouter.$stateParams.source !== 'NOT_YOU' && !userSelectedLanguage && rememberMe) {
                        _logger.$logger.debug('ULSS_CLIENT_PRELOAD_INJECT');
                        $scope.preLoadedSource = true;
                        options.preLoadedSource = decodeURI($scope.ulSource.src);
                    }

                    function ulInvoke() {
                        if (PAYPAL && PAYPAL.unifiedLogin) {
                            startTimer('ulInvoke');
                            if (!iframeCopy) {
                                PAYPAL.unifiedLogin.inject(options);
                            } else {
                                PAYPAL.unifiedLogin.copyPasteIframe({
                                    targetElement: document.getElementById('injectedUnifiedLogin'),
                                    onPostMessage: postMessageHandler
                                });
                            }
                        } else {
                            return appLoginHandler(failureReasons.fallback);
                        }
                    }

                    var jwtToken = _squid.$util.param('jwtToken');

                    if (jwtToken) {
                        options.queryParams.jwtToken = jwtToken;
                    }

                    if (rememberMe === true) {
                        options.queryParams.rememberMe = true;
                        // NOTE: `xo_hermesnode_kmli_upsell` has been ramped to 100%
                        // and it's always return `xo_hermesnode_kmli_content_t1`
                        options.queryParams.rememberMeContent = 1;
                    }
                    return ulInvoke();
                }

                var cancelAllLoaded = _angular.$rootScope.$on('allLoaded', function () {
                    cancelLocaleChange = $scope.$on('localeChange', function () {
                        userSelectedLanguage = _squid.$locale.lang;
                        setLoading('localeChange');
                        loadUnifiedLogin();
                    });
                    cancelAllLoaded();
                });

                $scope.$on('$destroy', cancelAllLoaded);
                loadUnifiedLogin(ulMeta.iframeCopy);
            });
        }]
    };
});

_angular.$q;

_angular.$rootScope;

_angular.$timeout;

_squid.$config;

_squid.$FallbackError;

_squid.$feature;

_squid.$locale;

_squid.$LocaleModel;

_squid.$meta;

_squid.$populate;

_squid.$util;

_squid.$promise;

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_index.$DeviceInfo;

_auth.$AuthModel;

_auth.$ULoginModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutCartModel;

_fpti.$fpti;

_model.$CalDataModel;

_fn.$fn;

_kmliEligibility.$KmliEligibility;

_kmliUpsell.$KmliUpsell;

/***/ }),

/***/ "../node_modules/xo-login-components/src/unified-login/template.html":
/***/ (function(module, exports) {

module.exports = "<div>\n    <input id=\"email\" name=\"login_email\" type=\"email\" value=\"\" autocomplete=\"off\" placeholder=\"Email\" style=\"display:none\">\n    <input id=\"password\" name=\"login_password\" type=\"password\" value=\"\" placeholder=\"Password\" style=\"display:none\">\n    <div id=\"injectedUnifiedLogin\">\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/unified-login/ul.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ul = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

__webpack_require__("../node_modules/ul-inline/dist/inject.js");

/**
 * Created by upigilam on 4/8/16.
 * UL handler is to exchange ST to RT exchanges.
 */

var $ul = exports.$ul = {

    optInToOneTouch: function optInToOneTouch(token, locale_country, locale_code, silent, fptiData, flowName) {

        return (0, _angular.$q)(function (resolve, reject) {

            var PAYPAL = window.PAYPAL || {};
            var ulTimeOutValue = 10000;
            var ulTimeoutPromise = null;

            function logSubmit(data) {
                var fptiPayload = {
                    'from': fptiData && fptiData.stateName ? fptiData.stateName : 'poma_page',
                    'to': fptiData && fptiData.transInfix ? fptiData.transInfix : 'process_kmli_optin'
                };
                if (data && data.errorCode) {
                    angular.extend(fptiPayload, {
                        'int_error_code': data.errorCode,
                        'error_type': 'hard_decline',
                        'error_source': 'unifiedloginnodeweb'
                    });
                }
                _logger.$logger.info('checkout_fpti', fptiPayload);
            }

            function failureHandler(reason) {
                logSubmit({ errorCode: reason });
                _logger.$logger.info('UL_Loading_error_' + reason);
                return reject(new Error('UL_Loading_error_' + reason));
            }

            function startTimer(tag) {
                _logger.$logger.info('UL_START_TIMER_' + tag);
                ulTimeoutPromise = (0, _angular.$timeout)(function () {
                    failureHandler('timed_out');
                    if (!silent) {
                        _angular.$rootScope.$emit('loaded');
                    }
                }, ulTimeOutValue);
            }

            function stopTimer(tag) {
                if (!silent) {
                    _angular.$rootScope.$emit('loaded');
                }
                _logger.$logger.info('UL_STOP_TIMER_' + tag);

                if (ulTimeoutPromise) {
                    _angular.$timeout.cancel(ulTimeoutPromise);
                    ulTimeoutPromise = null;
                }
            }

            var ulEventHandlers = {
                'oneTouchInterstitialOptInLoaded': function oneTouchInterstitialOptInLoaded(data) {
                    // Don't start or stop timer. Flow should not get block even the post messages is not returned from UL
                },
                'oneTouchInterstitialOptInAttempted': function oneTouchInterstitialOptInAttempted(data) {
                    // Don't start or stop timer. Flow should not get block even the post messages is not returned from UL
                },
                'oneTouchInterstitialOptInSuccess': function oneTouchInterstitialOptInSuccess(data) {
                    stopTimer(data.event);
                    logSubmit();
                    // UL will drop RT cookie and respond oneTouchInterstitialOptInSuccess postmessage.
                    _auth.$AuthModel.instance().retrieve().then(function (auth) {
                        auth.refresh_token = true;
                    });
                    return resolve();
                },
                'oneTouchInterstitialOptInFailed': function oneTouchInterstitialOptInFailed(data) {
                    stopTimer(data.event);
                    failureHandler(data.event);
                },
                'oneTouchInterstitialOptInNotAuthorized': function oneTouchInterstitialOptInNotAuthorized(data) {
                    // removing the element - ulTargetAttribute from DOM, to avoid any other accidental
                    // actions on the element which is causing excess spinners later.
                    var child = document.getElementById('ulTargetAttribute');
                    child.parentNode.removeChild(child);
                    stopTimer(data.event);
                    failureHandler(data.event);
                }
            };

            function postMessageHandler(response) {
                (0, _angular.$timeout)(function () {
                    _logger.$logger.info('ul_postmessaged_received', response);
                    var data = response.data || response.error;
                    var eventId = data && data.event;
                    if (eventId) {
                        _logger.$logger.debug('UL' + eventId, response);
                        var handler = ulEventHandlers[eventId];
                        if (handler) {
                            handler(data);
                        }
                    }
                });
            }

            function loadOneTouchUpsell() {
                if (!silent) {
                    _angular.$rootScope.$emit('loading');
                }

                var ulTargetAttribute = document.createElement('div');
                ulTargetAttribute.setAttribute('id', 'ulTargetAttribute');

                // setting display to None leading FireFox hiding all the ul elements due to which body click doesn't work
                // ulTargetAttribute.style.display = "None";

                // Making 0px, it works for FF, Chrome, Safari
                ulTargetAttribute.style.width = '0px';
                ulTargetAttribute.style.margin = '0px';
                ulTargetAttribute.style.height = '0px';
                ulTargetAttribute.style.padding = '0px';

                document.body.appendChild(ulTargetAttribute);

                var options = {
                    targetElement: document.getElementById('ulTargetAttribute'),
                    queryParams: {
                        'country.x': locale_country,
                        'locale.x': locale_code,
                        'flowId': token,
                        'correlationId': _model.$CalDataModel.getCalCorrId(),
                        'flowName': flowName ? flowName : 'checkoutOnlyMember' // default is poma flow
                    },
                    iframePathname: '/signin/activate-one-touch',
                    onPostMessage: postMessageHandler
                };

                if (_config.$config.deploy.isLocal()) {
                    if (_config.$meta.stage) {
                        options.origin = 'https://' + _config.$meta.stage;
                    } else {
                        // if no stage url shows up then use any backup url for origin
                        options.origin = _config.$config.urls.onboarding.split('/webapps/')[0];
                    }
                }

                if (PAYPAL && PAYPAL.unifiedLogin) {
                    startTimer('initializeUl');
                    PAYPAL.unifiedLogin.inject(options);
                } else {
                    failureHandler('PAYPAL.unifiedLogin_undefined');
                }
            }

            loadOneTouchUpsell();
        });
    }
};

// Loads unifiedLogin key on to PAYPAL window object


angular.value("$ul", $ul);
_angular.$rootScope;

_angular.$q;

_angular.$timeout;

_logger.$logger;

_config.$config;

_config.$meta;

_model.$CalDataModel;

_auth.$AuthModel;

/***/ }),

/***/ "../node_modules/xo-member-components/src/backup-label/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoBackupLabel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/backup-label/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-member-components/src/backup-label/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoBackupLabel = exports.$xoBackupLabel = _squid.$Component.extend('$xoBackupLabel', {
    tag: 'xo-backup-label',
    template: _template2['default'],
    props: {
        plan: {
            type: 'var',
            required: false
        },
        hasMask: {
            type: 'var',
            required: false
        }
    }
});

angular.value("$xoBackupLabel", $xoBackupLabel);
_squid.$Component;

/***/ }),

/***/ "../node_modules/xo-member-components/src/backup-label/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/backup-label/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"backupFi\" class=\"backupContainer\" ng-class=\"{ hasMask: hasMask }\" content>\n    {{plan.backup.name}}\n    <span ng-if=\"!plan.isAuthRequired\">\n        <span ng-if=\"!props.hasMask\">x-{{plan.backup.last4}} {{ content('paymentMethod.backup') }}</span>\n        <span ng-if=\"props.hasMask\"><span class=\"cardMask\"><span/><span/><span/><span/></span>{{plan.backup.last4}} {{ content('paymentMethod.backup') }}</span>\n    </span>\n</div>"

/***/ }),

/***/ "../node_modules/xo-member-components/src/billing-address/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/billing-address/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-member-components/src/billing-address/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(0, _squid.$registerDirective)('xo-billing-address', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            editUri: '=?'
        },
        lifecycle: {
            enter: function enter() {
                _logger.$logger.info('xo-billing-address_enter');
            }
        },
        controller: ['$scope', function ($scope) {
            var getBillingAddress = function getBillingAddress(cardId) {
                return (0, _squid.$populate)($scope, {
                    cardInfo: _fi.$CardInfoModel.instance(cardId)
                }).then(function () {
                    return $scope.cardInfo && $scope.cardInfo.billingAddress;
                });
            };

            var updateScopeData = function updateScopeData(checkoutSession) {
                $scope.selectedCardId = $scope.checkoutSession.plan.sources[0].instrument_id;
                return getBillingAddress($scope.selectedCardId).then(function (address) {
                    $scope.address = address;
                    $scope.line3 = address.city + ', ' + address.state + ' ' + address.postal_code;
                });
            };

            (0, _squid.$populate)($scope, {
                checkoutSession: _checkout.$CheckoutSessionModel.instance($scope.token)
            }).then(function () {
                $scope.header = _squid.$locale.content.get('addCard.billingAddress');
                $scope.updateType = _squid.$locale.content.get('common.edit');
                return updateScopeData($scope.checkoutSession);
            }); // populate

            $scope.$watchCollection('checkoutSession', function (newVal) {
                if (newVal) {
                    // Clear the cached CardInfo so we can get the latest associated Billing Address
                    if ($scope.cardInfo) {
                        $scope.cardInfo.invalidate();
                    }
                }
                return updateScopeData($scope.checkoutSession);
            });
        }]
    };
});

_squid.$locale;

_squid.$populate;

_squid.$registerDirective;

_logger.$logger;

_checkout.$CheckoutSessionModel;

_fi.$CardInfoModel;

/***/ }),

/***/ "../node_modules/xo-member-components/src/billing-address/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/billing-address/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"billing-address-wrapper\" ng-model=\"checkoutSession\">\n    <div class=\"box-header\">\n        <div class=\"headerText\">{{header}}</div>\n    </div>\n    <div class=\"box-body\">\n        <span>{{address.line1}},</span>\n        <span ng-if=\"address.line2\">{{address.line2}},</span>\n        <span>{{line3}}</span>\n        <a track-link=\"edit_billing_address\" ui-sref=\"checkout.payWithCard.sidebar.sidebarUpdateCard.addCardFlow.addCard({planId: selectedCardId})\" class=\"addCardLink\" role=\"button\">\n            {{updateType}}\n        </a>\n\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/card-backup/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _fiMeta = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _fiMeta2 = _interopRequireDefault(_fiMeta);

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/card-backup/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-member-components/src/card-backup/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * xo-card-backup
 * Render a dropdown for user to select their backup instrument in case their card
 * gets declined
 * @params {String} token - token for models
 */
exports['default'] = _squid.$Component.extend('$CardBackupComponent', {
    tag: 'xo-card-backup',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        // Since selected method means the user might have something different selected compared to the checkout session,
        // might need to have this passed in to filter out the plan
        selectedmethod: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                fiMeta: _fiMeta2['default'].instance(this.props.token).fetch()
            };
        }
    },
    actions: {
        getAllowedBackups: function getAllowedBackups() {
            var planList = this.models.checkoutSession.getPlanList() || [];
            var currentPlanId = this.props.selectedmethod ? this.props.selectedmethod.planId : planList[0].planId;

            return planList.filter(function (a) {
                return a.planId !== currentPlanId && a.primaryFs && a.primaryFs.type === 'CARD' && a.secondaryFIs === false;
            });
        },
        renderCover: function renderCover() {
            var backup = this.models.checkoutSession.cardBackup.getPlan();

            if (!backup) {
                return (0, _squid.$renderContent)('paymentMethod.chooseBackup');
            } else {
                return this.actions.renderOption(backup) + ' ' + (0, _squid.$renderContent)('paymentMethod.backup');
            }
        },
        renderOption: function renderOption(plan) {
            return this.models.fiMeta.getName(plan.primaryFs) + ' x-' + plan.primaryFs.lastDigits;
        },
        selectBackup: function selectBackup(plan) {
            var _this = this;

            var selectedmethodPlan = this.props.selectedmethod ? (this.models.checkoutSession.getPlanList() || []).find(function (p) {
                return p.planId === _this.props.selectedmethod.planId;
            }) : null;

            this.models.checkoutSession.cardBackup.setPlan(plan, selectedmethodPlan);
            this.actions.toggleDropdown();
        },
        toggleDropdown: function toggleDropdown() {
            var _this2 = this;

            this.showDropdown = !this.showDropdown;

            if (this.showDropdown) {
                (0, _angular.$timeout)(function () {
                    return _this2.actions.showDropdownUI();
                });
            }
        },

        // UI change - the box is right aligned, but need to position it so that
        // it doesn't overflow on the left
        showDropdownUI: function showDropdownUI(open) {
            var position = this.$element.find('.card-backup-dropdown').position();

            this.$element.find('.card-backup-options').css({
                right: position && position.left < 0 ? position.left : 0,
                visibility: 'visible'
            });
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this3 = this;

            // Close the dropdown if focus leaves the menu
            _angular.$document.on('focusin.cardBackup', function (event) {
                if (_this3.showDropdown && !_this3.$element[0].contains(event.target)) {
                    _this3.showDropdown = false;
                }
            });
        },
        exit: function exit() {
            // Clean up the dropdown handler
            _angular.$document.off('focusin.cardBackup');
        }
    }
});


_angular.$document;

_angular.$timeout;

_squid.$Component;

_squid.$renderContent;

_checkout.$CheckoutSessionModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-member-components/src/card-backup/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/card-backup/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"card-backup\" content>\n    <div class=\"card-backup-head\">\n        <span class=\"common-icon info\"></span>\n        <a ng-click=\"actions.toggleDropdown()\"\n            class=\"card-backup-cover link-dotted\"\n            href=\"#\" select-button aria-expanded=\"{{showDropdown}}\" focus-when=\"!showDropdown\" focused-once-before>\n            {{actions.renderCover()}}\n            <span class=\"card-backup-expand common-icon expand\"></span>\n        </a>\n        <div ng-if=\"showDropdown\" class=\"card-backup-dropdown\" tabindex=\"-1\" select-box select-cancel=\"actions.toggleDropdown()\" form-autofocus>\n            <div class=\"arrow-top\"></div>\n            <div class=\"card-backup-options\">\n                <li ng-repeat=\"plan in actions.getAllowedBackups() track by $index\"\n                    class=\"card-backup-option secondary\">\n                    <a href=\"#\" link-button\n                        ng-click=\"actions.selectBackup(plan)\">\n                        {{actions.renderOption(plan)}}\n                    </a>\n                    <span ng-if=\"models.checkoutSession.cardBackup.getPlan() === plan\"\n                        class=\"common-icon check-blue\">\n                    </span>\n                </li>\n                <li class=\"card-backup-option secondary\">\n                    <a href=\"#\" link-button\n                        ng-click=\"actions.selectBackup(null)\">\n                        {{content('paymentMethod.noBackup')}}\n                    </a>\n                    <span ng-if=\"!models.checkoutSession.cardBackup.getPlan()\"\n                        class=\"common-icon check-blue\">\n                    </span>\n                </li>\n            </div>\n        </div>\n    </div>\n    <div class=\"card-backup-info secondary\">\n        {{content('paymentMethod.cardBackupDescription')}}\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/give-at-checkout/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _marketingoffer = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");

var _factory = __webpack_require__("../node_modules/xo-member-components/src/give-at-checkout/factory.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/give-at-checkout/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-member-components/src/give-at-checkout/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoDonate', {
    tag: 'xo-donate',
    template: _template2['default'],
    props: {
        merchantName: {
            type: 'str',
            required: false
        }
    },
    actions: {
        showConsent: function showConsent() {
            this.showConsentBox = !this.showConsentBox;
            if (this.showConsentBox) {
                if (this.tracking && this.tracking.click_url) {
                    _marketingoffer.$fireMORSBeacon.fireBeacon(this.tracking.click_url);
                }
            }
            _factory.$GiveAtCheckoutFactory.set({ donateCheckboxSelected: this.showConsentBox });
        }
    },
    lifecycle: {
        enter: function enter() {
            this.showConsentBox = false;
        },
        populate: function populate() {
            this.charity = _factory.$GiveAtCheckoutFactory.get().charity;
            if (this.charity) {
                this.formattedAmount = (0, _squid.formatCurrency)(this.charity.amount, this.charity.currency, false, 'Currency');
            }
            this.tracking = _factory.$GiveAtCheckoutFactory.get().tracking;
        }
    }
});


_squid.$Component;

_squid.formatCurrency;

_marketingoffer.$fireMORSBeacon;

_factory.$GiveAtCheckoutFactory;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-member-components/src/give-at-checkout/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _marketingoffer = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");

function parseMessage(mors) {
    if (!(mors && mors.data)) {
        return {};
    }
    var touchpoints = mors.data.touchpoint_messages || [];

    if (Array.isArray(touchpoints) && touchpoints.length > 0) {
        var messages = touchpoints[0].messages || [];

        var chosen = messages.filter(function (message) {
            return message.content && message.content.json && message.content.json.model_score;
        }).reduce(function (prev, curr) {
            return prev && prev.content.json.model_score > curr.content.json.model_score ? prev : curr;
        }, undefined);
        if (chosen) {
            var charity = chosen.content.json;
            var tracking = chosen.tracking_details;

            if (charity) {
                return { charity: charity, tracking: tracking };
            }
        }
    }
    return {};
}

function parseUserType(charity) {
    if (charity && charity.user_type) {
        return charity.user_type;
    }
    var DONOR_MODELS = ['0', '1'];
    if (charity && charity.model_id) {
        return DONOR_MODELS.indexOf(charity.model_id) >= 0 ? 'DONOR' : 'NONDONOR';
    }
}

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$GiveAtCheckoutFactory', function () {
    var state = {
        donateCheckboxSelected: false,
        eligible: false,
        charity: undefined,
        tracking: undefined
    };

    var get = function get() {
        return state;
    };
    var set = function set(data) {
        return _squid.$util.extend(state, data);
    };

    var decideEligibility = function decideEligibility() {
        var models = {};

        return (0, _squid.$populate)(models, {
            checkoutCart: _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token),
            checkoutAppData: _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
            checkoutSession: _checkout.$CheckoutSessionModel.instance(_angular.$rootScope.token),
            payee: _checkout.$CheckoutPayeeModel.instance(_angular.$rootScope.token)
        }).then(function () {
            return _marketingoffer.$MessageDiscoverModel.instance().save({
                silent: true,
                data: {
                    'country_code': _squid.$locale.getCountryCodeISO(),
                    'language': _squid.$locale.getLocaleCode(),
                    'identity_context': [{
                        'type': 'PAYER_ID',
                        'value': models.checkoutSession.get('payer.id')
                    }, {
                        'type': 'MERCHANT_PAYER_ID',
                        'value': models.payee && models.payee.merchant && models.payee.merchant.id
                    }],
                    'recommendation_context': {
                        'touchpoint_details': [{
                            'code': 'hermes_gac_touchpoint',
                            'message_count': -1
                        }]
                    }
                },
                error: function error(err) {
                    return _squid.$promise.reject(err);
                }
            });
        }).then(function (mors) {
            var _parseMessage = parseMessage(mors),
                charity = _parseMessage.charity,
                tracking = _parseMessage.tracking;

            if (charity) {
                state.charity = charity;
                state.tracking = tracking;
                _logger.$logger.info('mors_eligibility', {
                    eligible: !!charity
                });
                if (state.tracking && state.tracking.impression_url) {
                    _marketingoffer.$fireMORSBeacon.fireBeacon(state.tracking.impression_url);
                }
                return charity;
            }
        }).then(function (charity) {
            if (!charity) {
                return;
            }
            var userType = parseUserType(charity);
            if (userType) {
                var paymentAction = models.checkoutCart && models.checkoutCart.get('payment_action');
                var currencyCode = models.checkoutCart && models.checkoutCart.get('purchase.amounts.total.currency_code');
                var buyerCountry = _squid.$locale.country;
                var merchantId = models.payee && models.payee.getId();
                var merchantCountry = models.checkoutAppData && models.checkoutAppData.get('merchant.merchant_country');
                var billingAgreement = models.checkoutCart && models.checkoutCart.isBilling();
                var isWPSflow = models.checkoutAppData && !!models.checkoutAppData.is_wps_flow();
                var buyerID = models.checkoutSession.get('payer.id');
                var isMobile = _index.$DeviceInfo.isMobile();
                var isCorp = _squid.$meta.corp;

                _logger.$logger.info('gac_pxpContext', {
                    userType: userType,
                    currencyCode: currencyCode,
                    paymentAction: paymentAction,
                    merchantCountry: merchantCountry,
                    buyerCountry: buyerCountry,
                    billingAgreement: billingAgreement,
                    isWPSflow: isWPSflow,
                    buyerID: buyerID,
                    isMobile: isMobile,
                    isCorp: isCorp
                });

                var pageName = 'xo_hermes_gac';
                var pxpTreatment = userType === 'DONOR' ? 'xo_hermes_gac_treatment' : 'xo_hermes_gac_nondonor_treatment';
                return (0, _squid.$pxp)(pageName, {
                    'uid': buyerID,
                    'ctx.userType': userType,
                    'ctx.currencyCode': currencyCode,
                    'ctx.paymentAction': paymentAction,
                    'ctx.merchantId': merchantId,
                    'ctx.merchantCountry': merchantCountry,
                    'ctx.buyerCountry': buyerCountry,
                    'ctx.isBillingAgreement': billingAgreement,
                    'ctx.isWpsFlow': isWPSflow,
                    'ctx.isMobile': isMobile,
                    'ctx.isCorp': isCorp
                }, pxpTreatment, false, true);
            }
        }).then(function (pxp) {
            if (pxp) {
                var pxpResult = !!pxp;

                _logger.$logger.info('gac_pxpResult', {
                    pxp: pxpResult
                });
                state.eligible = pxpResult;
            } else {
                state.eligible = false;
            }
        })['catch'](function (err) {
            _logger.$logger.error('gac_eligibility', err);
            state.eligible = false;
            return state.eligible;
        });
    };

    return {
        get: get,
        set: set,
        decideEligibility: decideEligibility
    };
});

_angular.$rootScope;

_logger.$logger;

_index.$DeviceInfo;

_squid.$util;

_squid.$pxp;

_squid.$populate;

_squid.$promise;

_squid.$locale;

_squid.$meta;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutPayeeModel;

_marketingoffer.$MessageDiscoverModel;

_marketingoffer.$fireMORSBeacon;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-member-components/src/give-at-checkout", "../node_modules/xo-member-components/src/give-at-checkout/factory.js"))

/***/ }),

/***/ "../node_modules/xo-member-components/src/give-at-checkout/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/give-at-checkout/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"give-at-checkout\" content>\n    <div class=\"prominentGacSeparator\">\n        <span class=\"prominentGacSeparatorLine\"></span>\n    </div>\n    <div class=\"donate checkbox\">\n        <input type=\"checkbox\" class=\"donateCheckbox\" name=\"donate\" id=\"donate\" data-test-id=\"donate-checkbox\" ng-click=\"actions.showConsent()\"/>\n        <label data-test-id=\"donate-label\" class=\"donate-label\" for=\"donate\">\n            <div data-test-id=\"charity-logo\" class=\"charity-logo\"  ng-style=\"{ background: 'url(' + charity.logo_url + ') center center / contain no-repeat' }\"></div>\n            <div class=\"charity-content\">\n                <p class=\"charity-name\">{{content('donate.label', { amount: formattedAmount, charityName: charity.name})}}</p>\n                <p ng-if=\"charity.promo_message\" class=\"promo-msg\">{{ charity.promo_message }}</p>\n            </div>\n        </label>\n    </div>\n    <div class=\"donate-consent\" ng-if=\"showConsentBox\">\n        <p class=\"title\">\n            {{content('donate.consentLine1', { merchant: merchantName })}}\n        </p>\n        <p class=\"content\">\n            {{content('donate.consentLine2')}}\n        </p>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/msb-offer/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoMsbOffer = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/msb-offer/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-member-components/src/msb-offer/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Component for rendering Merchant specific balance on the review page for multi fi
 * It renders on top of the list of the FI's
 * As far as we know - there can only be 1 msb applied per plan
 * and so each should have "incentive" attached
*/
var $xoMsbOffer = exports.$xoMsbOffer = _squid.$Component.extend('$xoMsbOffer', {
    tag: 'xo-msb-offer',
    template: _template2['default'],
    props: {
        /**
         * incentive field from FI object
         */
        msb: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            var msb = this.props.msb;


            this.amount = (0, _squid.formatCurrency)(msb.amount.value, msb.amount.currency);
            this.minPurchaseAmount = msb.minPurchaseAmount;
        }
    }
});

angular.value("$xoMsbOffer", $xoMsbOffer);
_squid.$Component;

_squid.formatCurrency;

/***/ }),

/***/ "../node_modules/xo-member-components/src/msb-offer/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/msb-offer/template.html":
/***/ (function(module, exports) {

module.exports = "<div content>\n    <div class=\"msbOfferContainer\">\n        <div class=\"wrapper\">\n            <span class=\"fsIcon INCENTIVE\"></span>\n            <div class=\"fsdetails\">\n                <span class=\"name\">\n                    {{ content('paymentMethod.msbOffer') }}\n                </span>\n\n                <div class=\"msbHelpText secondary\">\n                    {{ content('paymentMethod.msbHelpText', {amount: amount})}}\n\n                    <a class=\"msbDetails\" id=\"msbOfferTooltipId\" link-button>{{ content('paymentMethod.msbDetails')}}</a>\n                </div>\n\n            </div>\n\n        </div>\n    </div>\n    <xo-tooltip trigger=\"#msbOfferTooltipId\" show-event=\"click\" hide-event=\"click\" ng-click=\"$event.stopPropagation()\">\n        <div class=\"tip tipDesc\">\n            <h4>{{ content('paymentMethod.msbToolTipOffer') }}</h4>\n            <div class=\"msbToolTipDescription\">\n                <p ng-if=\"minPurchaseAmount\">\n                    {{ content('paymentMethod.msbToolTipText', {amount: amount, minimumPurchase: minPurchaseAmount}) }}\n                </p>\n                <p ng-if=\"!minPurchaseAmount\">\n                    {{ content('paymentMethod.msbToolTipText2', {amount: amount}) }}\n                </p>\n            </div>\n        </div>\n    </xo-tooltip>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/no-balance/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoNoBalance = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _factory = __webpack_require__("../node_modules/xo-member-components/src/no-balance/factory.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/no-balance/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-member-components/src/no-balance/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Banner with text messages that user have pending (not claimed yet) balance available,
 * but needs to go through verification steps on 8ball
 *
 * Used in the following pages:
 * 1. review page - hermesnodeweb/public/pages/xo-review
 * 2. add card contingency page - hermesnodeweb/public/pages/xo-add-card
 */
var $xoNoBalance = exports.$xoNoBalance = _squid.$Component.extend('$xoNoBalance', {
    tag: 'xo-no-balance-banner',
    template: _template2['default'],
    actions: {
        /**
         * event when clicking on info icon to show secondary message
         */
        onShowSecondaryMsg: function onShowSecondaryMsg($event) {
            $event.preventDefault();
            this.showSecondaryMsg = true;
            _logger.$logger.info('no_balance', {
                from: 'no_balance',
                to: 'no_balance_click_info'
            });
        }
    },
    lifecycle: {
        enter: function enter() {
            var _$NoBalanceFactory$ge = _factory.$NoBalanceFactory.get(),
                showMsgWithAmount = _$NoBalanceFactory$ge.showMsgWithAmount,
                pendingBalances = _$NoBalanceFactory$ge.pendingBalances;

            if (showMsgWithAmount) {
                var balance1 = pendingBalances[0],
                    balance2 = pendingBalances[1];


                if (pendingBalances.length === 1) {
                    this.msg = (0, _squid.$renderContent)('noBalance.primaryMsgWithAmt', { amt: (0, _squid.formatCurrency)(balance1.value, balance1.currency) });
                } else {
                    this.msg = (0, _squid.$renderContent)('noBalance.primaryMsgWithMultiAmt', {
                        amt1: (0, _squid.formatCurrency)(balance1.value, balance1.currency),
                        amt2: (0, _squid.formatCurrency)(balance2.value, balance2.currency)
                    });
                }
            } else {
                this.msg = (0, _squid.$renderContent)('noBalance.primaryMsg');
            }
        }
    }
});

angular.value("$xoNoBalance", $xoNoBalance);
_squid.$Component;

_squid.$renderContent;

_squid.formatCurrency;

_logger.$logger;

_factory.$NoBalanceFactory;

/***/ }),

/***/ "../node_modules/xo-member-components/src/no-balance/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _wallet = __webpack_require__("../node_modules/xo-models/src/wallet/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

/**
 * Money Waiting (no balance) factory
 * story with details - https://rally1.rallydev.com/#/42145958143/detail/userstory/243026109436
 */

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$NoBalanceFactory', function () {

    /**
     * eligible - to show / hide xo-no-balance component
     * showMsgWithAmount - to show / hide message with amount
     * pendingBalances - list of pending(non claimed yet) balances amounts
     * isAlreadyShown - was banner already shown or not
     */
    var state = {
        eligible: false,
        showMsgWithAmount: false,
        pendingBalances: undefined,
        isAlreadyShown: false
    };

    var get = function get() {
        return state;
    };
    var set = function set(data) {
        return _squid.$util.extend(state, data);
    };

    /**
     * call "No Balance" pxp:
     * stage url - https://engineering.paypalcorp.com/pxptoolstage/configuration?exptId=5007
     * xo_hermes_nobalance_treatment1 - for showing message without amount
     * xo_hermes_nobalance_treatment2 - for showing message with amount
    */
    var getPxp = function getPxp() {
        return (0, _squid.$pxp)('xo_hermes_nobalance', 'xo_hermes_nobalance_treatment(1|2)', undefined, false, true);
    };

    /**
     * Decide to show / hide message with amount / amounts
     * @param {Object} pxpResult - pxp result
     * @param {Object} pendingBalances - array of pending (non claimed yet) balances
     */
    var shouldShowMsgWithAmount = function shouldShowMsgWithAmount(_ref) {
        var pxpResult = _ref.pxpResult,
            pendingBalances = _ref.pendingBalances;

        return pendingBalances.length > 0 && pxpResult && pxpResult.treatment_name === 'xo_hermes_nobalance_treatment2';
    };

    /**
     * req.user has noBalance flag in case there is pending balance availaible which is getting mapped to auth model
     * mapping - https://github.paypal.com/Checkout/xo-hercules/blob/master/apis/auth/outputMapper.js
     */
    var hasUserPendingBalance = function hasUserPendingBalance() {
        return _auth.$AuthModel.instance().no_balance;
    };

    /**
     * Mark as already shown, for example:
     * if user doesn't have any FI -> user will see "no balance" banner on Add Card Page.
     * And so after user adds cart successfully -> we should not show banner on review page
     */
    var markAsAlreadyShown = function markAsAlreadyShown() {
        state.isAlreadyShown = true;
        state.eligible = false;
    };

    /**
     * experiment is eligible in the following cases:
     * 1. user has `no_balance` flag as `true` - means there is pending balance that user can claim, but need to go through verification first on 8ball
     * 2. user has less than 3 balance accounts
     * 3. pxp returns treatment1 or treatment2
     */
    var decideEligibility = function decideEligibility() {
        if (state.isAlreadyShown) {
            return _squid.$promise.resolve({});
        }

        var isUserWithPendingBalance = hasUserPendingBalance();

        return _wallet.$WalletModel.instance(_angular.$rootScope.token).retrieve().then(function (wallet) {
            var pendingBalances = wallet.getAmountsOfBalances();
            var isNoBalanceEligible = isUserWithPendingBalance && pendingBalances.length > 0 && pendingBalances.length < 3;

            var balance1 = pendingBalances[0],
                balance2 = pendingBalances[1];


            _logger.$logger.info('no_balance', {
                from: 'no_balance',
                to: 'no_balance_eligibility',
                number_of_balances: pendingBalances.length,
                no_balance_eligible: isNoBalanceEligible,
                balance_amount1: balance1 && balance1.value,
                balance_currency1: balance1 && balance1.currency,
                balance_amount2: balance2 && balance2.value,
                balance_currency2: balance2 && balance2.currency
            });

            if (!isNoBalanceEligible) {
                return _squid.$promise.resolve({});
            }

            return getPxp().then(function (pxpResult) {
                state.eligible = !!pxpResult;
                if (state.eligible) {
                    state.pendingBalances = pendingBalances;
                    state.showMsgWithAmount = shouldShowMsgWithAmount({ pxpResult: pxpResult, pendingBalances: pendingBalances });
                }
                return state;
            });
        });
    };

    return {
        get: get,
        set: set,
        markAsAlreadyShown: markAsAlreadyShown,
        decideEligibility: decideEligibility
    };
});

_squid.$util;

_squid.$pxp;

_squid.$promise;

_logger.$logger;

_wallet.$WalletModel;

_auth.$AuthModel;

_angular.$rootScope;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-member-components/src/no-balance", "../node_modules/xo-member-components/src/no-balance/factory.js"))

/***/ }),

/***/ "../node_modules/xo-member-components/src/no-balance/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/no-balance/template.html":
/***/ (function(module, exports) {

module.exports = "<div content class=\"noBalanceContainer\">\n    <div class=\"primaryMsgWrapper\">\n        <a ng-click=\"actions.onShowSecondaryMsg($event)\" class=\"questionMark\"></a>\n        <div class=\"primaryMsg\">{{ msg }}</div>\n    </div>\n    <div ng-if=\"showSecondaryMsg\" class=\"secondaryMsg\">{{ content('noBalance.secondaryMsg') }}</div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/preferred-checkbox/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/preferred-checkbox/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-member-components/src/preferred-checkbox/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend({
    tag: 'xo-preferred-checkbox',
    template: _template2['default'],
    props: {
        makeFiPreferred: {
            type: 'var',
            required: false
        },
        plan: {
            type: 'var',
            required: false
        },
        cardart: {
            type: 'var',
            required: false
        }
    },
    actions: {
        toggleModel: function toggleModel() {
            if (this.props.makeFiPreferred.selected) {
                this.props.makeFiPreferred.planId = this.props.plan.planId;
                this.props.makeFiPreferred.fiId = this.props.plan.primaryFs.type === 'BALANCE' ? this.props.plan.primaryFs.type : // Balance doesn't have an instrument id
                this.props.plan.primaryFs.id;
            }
        }
    },
    lifecycle: {
        enter: function enter() {
            _logger.$logger.info('checkout_fpti', { 'pref_fi_option_shown': '1' });
        }
    }
});


_squid.$Component;

_logger.$logger;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-member-components/src/preferred-checkbox/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$PreferredCheckboxFactory', function () {
    var state = {
        eligible: false
    };

    /**
     * call pxp to determint if we should show preferred checkbox in case of single fi
    */
    var getSinglePreferredCheckboxPxp = function getSinglePreferredCheckboxPxp() {
        return (0, _squid.$pxp)('xo_hermes_single_preffered_checkbox', 'xo_hermes_single_preffered_checkbox_treatment', undefined, false, true).then(function (pxpRes) {
            return !!pxpRes;
        });
    };

    /**
     * check choice eligibility based on:
     * 1. pxp
     * 2. is billing or not
     */
    var getChoicePreferredCheckboxEligibility = function getChoicePreferredCheckboxEligibility(checkoutCart) {
        return _index.$ChoiceEligibility.instance().getVariant(_angular.$rootScope.token).then(function (variant) {
            var checkboxVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.preferredCheckbox || [];

            return checkboxVariants.indexOf(variant) !== -1 && !checkoutCart.isBilling();
        });
    };

    /**
     * eligible if:
     *
     * 1. choice eligibility is successfull
     * 2. number of plans >= 1
     *
     * If there is only 1 plan, xo_hermes_single_preffered_checkbox pxp (https://engineering.paypalcorp.com/pxptoolstage/configuration?exptId=5480&version=1)
     * must return treatment
     *
    */
    var decideEligibility = function decideEligibility(_ref) {
        var plans = _ref.plans,
            checkoutCart = _ref.checkoutCart;

        if (!plans || plans.length === 0) {
            state.eligible = false;
            return;
        }

        return getChoicePreferredCheckboxEligibility(checkoutCart).then(function (choiceEligibility) {
            if (!choiceEligibility) {
                state.eligible = false;
                return;
            }

            if (plans.length > 1) {
                state.eligible = true;
                return;
            }

            return getSinglePreferredCheckboxPxp().then(function (pxpResult) {
                _logger.$logger.info('single_fi_preferred_checkbox_eligibility', {
                    pxp: pxpResult
                });
                state.eligible = pxpResult;
            });
        });
    };

    var isSinglePreferredCheckboxEligible = function isSinglePreferredCheckboxEligible(_ref2) {
        var plans = _ref2.plans;

        return plans && plans.length > 0 && state.eligible;
    };

    var showPreferredCheckbox = function showPreferredCheckbox(plan, fundingOptions) {
        return (plan.primaryFs.id || plan.primaryFs.type === 'BALANCE') && !fundingOptions.isPreferred(plan);
    };

    return {
        isSinglePreferredCheckboxEligible: isSinglePreferredCheckboxEligible,
        decideEligibility: decideEligibility,
        showPreferredCheckbox: showPreferredCheckbox
    };
});

_squid.$pxp;

_squid.$config;

_logger.$logger;

_index.$ChoiceEligibility;

_angular.$rootScope;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-member-components/src/preferred-checkbox", "../node_modules/xo-member-components/src/preferred-checkbox/factory.js"))

/***/ }),

/***/ "../node_modules/xo-member-components/src/preferred-checkbox/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/preferred-checkbox/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"checkboxFiPreferred sCheckbox checkbox {{plan.primaryFs.name}}\" ng-class=\"{cardart: cardart}\" content>\n    <input type=\"checkbox\" ng-model=\"makeFiPreferred.selected\" name=\"makeFiPreferred\" id=\"makeFiPreferred\" ng-change=\"actions.toggleModel()\" aria-describedby=\"backupFi\">\n    <label for=\"makeFiPreferred\">{{\n    \tcontent(\n    \t\t'memberReview.prefer_' + plan.primaryFs.type,\n    \t\t{ name: content('fsMappings.'+ plan.primaryFs.name) }\n    \t)\n\t}}</label>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-address/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

__webpack_require__("../node_modules/xo-address-components/src/address-display/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/review-address/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend({
    tag: 'xo-review-address',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        makeAddrPreferred: {
            type: 'var',
            required: false
        },
        countryCode: {
            type: 'str',
            required: false
        },
        storePickUpSelected: {
            type: 'var',
            required: false
        },
        nmjExperience: {
            type: 'var',
            required: false
        },
        hideShipToHeader: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                auth: _index2.$AuthModel.instance().retrieve()['catch'](_angular.noop)
            };
        }
    },
    actions: {
        gotoShipping: function gotoShipping() {
            if (this.models.checkoutAppData.flags.allow_change_shipping) {
                _uiRouter.$state.go('checkout.review.sidebar.shipping');
            } else {
                this.cannotChangeShippingInfoMessages = true;
            }
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            var updateMakePreferredFlag = function updateMakePreferredFlag(flag) {
                if (_this.makeAddrPreferred) {
                    // Update the makeAddrPreferred.shown flag, for the caller to know about it.
                    _this.makeAddrPreferred.shown = flag;
                }
                return flag;
            };

            /**
             * Decision on whether to show Make Preferred Checkbox
             * @returns {boolean}
             */
            this.isMakePreferred = function () {
                if (_this.models.auth.remembered) {
                    return updateMakePreferredFlag(false);
                }

                if (_this.isPreferredShippingEnabled && !_this.models.checkoutSession.get('shipping.preferred_address') && !_this.models.checkoutSession.get('shipping.s2s_address')) {
                    return updateMakePreferredFlag(true);
                }
                return updateMakePreferredFlag(false);
            };
        },
        populate: function populate() {
            // countryCode is not available, hence we use the shipping.county to retrieve the feature flag.
            var shipping = this.models.checkoutSession && this.models.checkoutSession.shipping || {};

            this.isPreferredShippingEnabled = (0, _squid.$feature)('preferredShipping', false, shipping.country);
            this.isNmj = this.props.nmjExperience && (this.props.nmjExperience.one_page || this.props.nmjExperience.design_2 || this.props.nmjExperience.design_3);
        }
    }
});


_angular.noop;

_uiRouter.$state;

_squid.$Component;

_squid.$feature;

_index.$CheckoutAppDataModel;

_index.$CheckoutSessionModel;

_index2.$AuthModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-address/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"shippingForm\" class=\"shipping asideView\" content>\n    <div class=\"trayInner trayInnerDefault\">\n        <div id=\"shippingAddress\">\n            <div ng-class=\"{editable:models.checkoutAppData.flags.allow_change_shipping}\" focusable=\"!cannotChangeShippingInfoMessages\" class=\"focusable\" select-button disable-role ng-click=\"actions.gotoShipping()\">\n                <h2 ng-show=\"!(storePickUpSelected || hideShipToHeader)\" class=\"noBottom gamma\">{{ content('shippingAddress.shipTo') }}</h2>\n                <div ng-show=\"storePickUpSelected\">\n                    <h2 class=\"noBottom gamma\">{{ content('shippingAddress.yourAddress') }}</h2>\n                    <span class=\"merchantReq\">{{ content('shippingAddress.merchantReq') }}</span>\n                </div>\n                <div class=\"addressDisplay\">\n                    <div ng-if='!(nmjExperience && (nmjExperience.design_2 || nmjExperience.design_3))'>\n                        <span class=\"given-name\" data-test-id=\"fullName\">{{models.checkoutSession.shipping.name}}</span>\n                        <span class=\"family-name\"></span>\n                        <xo-address-display address=models.checkoutSession.shipping country-code=countryCode></xo-address-display>\n                    </div>\n                    <div ng-if='nmjExperience && (nmjExperience.design_2 || nmjExperience.design_3)'>\n                        <span class=\"dropPin\" id=\"dropPin\"></span>\n                        <div class=\"nameAddress\">\n                            <span class=\"given-name\" data-test-id=\"fullName\">{{models.checkoutSession.shipping.name}}</span>\n                            <xo-address-display class=\"\" address=models.checkoutSession.shipping country-code=countryCode></xo-address-display>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <a ng-show='!isNmj' class=\"edits changeShipping ng-class:{disabled:cannotChangeShippingInfoMessages}\" data-test-id=\"shipToChangeLink\" select-button focusable=\"!cannotChangeShippingInfoMessages\" ng-click=\"actions.gotoShipping()\" aria-label=\"{{ content('shippingAddress.label') }}\" focus-when-state=\"checkout.review.sidebar.shipping\" transitions-to=\"checkout.review\">\n                {{ content('common.change') }}\n                <span class=\"frontArrow goTray ng-scope ng-class:{disabled:cannotChangeShippingInfoMessages}\"></span>\n            </a>\n        </div>\n    </div>\n    <div id=\"infoMessages\" class=\"msgPage msg-info shipNotification\" ng-if=\"cannotChangeShippingInfoMessages\">\n        <span class=\"icon\"></span>\n        <ul>\n            <li ng-if=\"models.checkoutAppData.useraction() === 'commit'\" focus-when=\"cannotChangeShippingInfoMessages\" tabindex=\"-1\">\n                {{ content('memberReview.cannotChangeShippingMsgUserActionCommit', {merchantName: models.checkoutAppData.merchant.brand_name, merchantName2: models.checkoutAppData.merchant.brand_name}) }}\n            </li>\n            <li ng-if=\"models.checkoutAppData.useraction() !== 'commit'\" focus-when=\"cannotChangeShippingInfoMessages\" tabindex=\"-1\">\n                {{ content('memberReview.cannotChangeShippingMsg', {merchantName: models.checkoutAppData.merchant.brand_name, merchantName2: models.checkoutAppData.merchant.brand_name}) }}\n            </li>\n        </ul>\n    </div>\n</div>\n\n<div class=\"reviewPreferredShipping sCheckbox checkbox\" ng-if=\"isMakePreferred()\">\n    <input type=\"checkbox\" ng-model=\"makeAddrPreferred.selected\" name=\"makePreferred\" id=\"makePreferred\" />\n    <label for=\"makePreferred\">{{ content('memberReview.makePreferredShipping') }}</label>\n</div>\n\n<div ng-if=\"isNmj\" class=\"multipleShipping addShipping\">\n    <a track-link=\"change_shipping\" ng-click=\"actions.gotoShipping()\" class=\"addAddressLink\" id=\"addAddressLink\" data-test-id=\"shipToChangeLink\" role=\"button\">\n        <span class=\"plusicon\"></span>\n        <p class=\"addOption\">\n            <span class=\"name\">{{content('addShipping.switchAddress')}}</span>\n        </p>\n    </a>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-paywith/directive.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/xo-wallet-components/src/add-card/cvv/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/cardicon/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/fi-panel/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/experience/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/pay-with-credit/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/offer/directive.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

__webpack_require__("../node_modules/xo-member-components/src/billing-address/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/card-backup/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/preferred-checkbox/directive.js");

var _pxp = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/pxp.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _index2 = _interopRequireDefault(_index);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

__webpack_require__("../node_modules/xo-member-components/src/show-more-fi/directive.js");

var _factory = __webpack_require__("../node_modules/xo-member-components/src/show-more-fi/factory.js");

var _factory2 = __webpack_require__("../node_modules/xo-member-components/src/preferred-checkbox/factory.js");

var _factory3 = __webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/factory.js");

__webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/directive.js");

var _factory4 = __webpack_require__("../node_modules/xo-member-components/src/review-paywith/factory.js");

__webpack_require__("../node_modules/xo-member-components/src/msb-offer/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/backup-label/directive.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/review-paywith/template.html");

var _template2 = _interopRequireDefault(_template);

var _factory5 = __webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion/factory.js");

__webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion-overlay/directive.js");

var _experiments = __webpack_require__("../node_modules/xo-models/src/experiments/index.js");

var Experiments = _interopRequireWildcard(_experiments);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// billing address display
// PPC offer banner
// <xo-tooltip>
var ADD_CARD_URLS = {
    SIDEBAR_DEFAULT: {
        route: 'checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard',
        label: 'fundingInstruments.addNewCard'
    },
    SIDEBAR_ADDCARD_WITH_ADDBANK: {
        route: 'checkout.review.sidebar.sidebarAddNew.bank.add',
        label: 'common.addNew'
    }
}; // <pay-with-credit>
// accessibility directives
// <xo-cvv>


(0, _angular.$registerDirective)('xo-review-paywith', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            token: '=?',
            showBmlPopup: '=?',
            installmentNotSelected: '=?',
            payButtonText: '=?',
            installment: '=?',
            padToggleFeature: '=?',
            selectedmethod: '=?',
            makeFiPreferred: '=?',
            selectFiVariant: '=?',
            nmjExperience: '=?',
            creditParentContext: '=?',
            choiceBalanceCheckboxState: '=?'
        },
        controller: ['$scope', function ($scope) {
            $scope.locale = _squid.$locale;
            $scope.formatCurrency = _squid.formatCurrency;
            $scope.nmjMultiPage = $scope.nmjExperience && $scope.nmjExperience.multiPage;
            $scope.showMoreFiFactory = _factory.$ShowMoreFiFactory;
            $scope.smartAuthFactory = _factory4.$SmartAuthFactory;
            $scope.currencyConversionFactory = _factory5.$CurrencyConversionFactory;
            $scope.isCountryDE = _squid.$locale.country === 'DE';

            // check for feature enabled in config/inc/ui.json for AU country
            // this feature is there only in country AU as of June 29th, 2015
            $scope.showUachFeatureDiscalimer = false;

            /**
             * isMultiFiPadEligible
             * Used to determine if we should combine plans to be able to show
             * a PAD toggle checkbox instead of 2 plans
             *
             * padToggleEnabled is used to control ramp per country using a combination of pxp
             * and a feature flag
             *
             * If the coutnry is included on the list of countires that should look at the pxp config
             * we check the pxp and then the feature flag to check if its enabled,
             *
             * If the country its not included in the list of countries that should check pxp
             * we just use the feature flag.
             *
             */
            var isMultiFiPadEligible = function isMultiFiPadEligible() {
                return $scope.isPadToggleFeatureApplicable() && $scope.padToggleEnabled;
            };

            var setPadStatus = function setPadStatus(state) {
                $scope.padToggleFeature.checkboxEnabled = state;
            };

            var getPadStatus = function getPadStatus() {
                return $scope.padToggleFeature.checkboxEnabled;
            };

            var getMultiFiPadCheckboxState = function getMultiFiPadCheckboxState(id) {
                return $scope.padToggleFeature.multiFiCheckboxStates[id];
            };

            // used for multiFi DE
            // update pad status which is used to show/hide "Pay after 14 Days" label as a text on a blue Pay button
            var setPadStatusForMultiFi = function setPadStatusForMultiFi(plan) {
                if ($scope.checkoutSession.fundingOptions.isPAD(plan) || $scope.checkoutSession.fundingOptions.isIACH(plan)) {
                    setPadStatus(getMultiFiPadCheckboxState(plan.primaryFs.id));
                } else {
                    setPadStatus(false);
                }
            };

            // TODO: remove after PAPS fix
            $scope.balanceWithRewards = function (fi) {
                return _factory3.$RewardsCheckboxFactory.hideAmount(fi);
            };

            $scope.hasRewards = function (plan) {
                return _factory3.$RewardsCheckboxFactory.isRewardsPlan(plan);
            };

            $scope.getRewardsContent = function (plan) {
                // Need a content mapper because content experience
                // changes based on type of rewards in plan.
                var contentKeys = _factory3.$RewardsCheckboxFactory.getContentKeys(plan);

                return contentKeys || {};
            };

            $scope.isSelected = function (plan) {
                if (!plan) {
                    return false;
                }
                var getID = function getID(obj) {
                    return obj.planId || obj.id;
                };
                var selection = $scope.selectedmethod ? $scope.selectedmethod : $scope.checkoutSession.plan;
                var result = getID(plan) === getID(selection);
                // When the user is on RYI after selectFI
                // selection logic is maintained by the session
                // and not by radio button clicks on $scope.selectedmethod
                return result;
            };

            $scope.$on('$destroy', function () {
                return _factory3.$RewardsCheckboxFactory.destroy();
            });

            $scope.showChangeFI = function () {
                return $scope.canChangeFI && !$scope.selectedmethod && !$scope.nmjExperience;
            };

            $scope.showCreditPlacement = function (fs) {
                return fs && !fs.is_pinless_debit && fs.name === 'PayPal Credit' || fs.primaryFs && fs.primaryFs.name === 'BILL_ME_LATER';
            };

            $scope.isPadToggleFeatureApplicable = function () {
                return $scope.padToggleEnabled && $scope.padToggleFeature.applicable;
            };

            // for PAD eligible get combined plans
            $scope.getSortedPlans = function () {
                if (isMultiFiPadEligible()) {
                    return $scope.checkoutSession.fundingOptions.getPadAndIachCombinedPlans();
                } else {
                    return $scope.checkoutSession.getPlanList();
                }
            };

            $scope.showMultiFiPadToggle = function (plan) {
                var padToggle = false;

                if (isMultiFiPadEligible() && $scope.checkoutSession.fundingOptions.isPadToggleApplicableForFS(plan.planId) && plan.planId === $scope.selectedmethod.planId) {
                    padToggle = true;
                    setPadStatusForMultiFi(plan);
                }
                return padToggle;
            };

            $scope.showPadLabelForPadEligibleCountries = function (plan) {
                return $scope.checkoutSession.fundingOptions.isPAD(plan) || $scope.checkoutSession.fundingOptions.isIACHWithPad(plan) && $scope.padToggleEnabled && plan.planId !== $scope.selectedmethod.planId;
            };

            $scope.isUSGambling = function () {
                // US Only Real Money Gaming
                var isUSBuyer = _squid.$locale.country === 'US';
                var isUSmerchant = $scope.checkoutAppData && $scope.checkoutAppData.merchant && $scope.checkoutAppData.merchant.merchant_country === 'US';

                return $scope.payee && $scope.payee.isGambling() && isUSBuyer && isUSmerchant;
            };

            // get add card link state to display different versions based on country
            $scope.getAddCardLink = function () {
                var linkObj = ADD_CARD_URLS.SIDEBAR_DEFAULT;

                if ((0, _squid.$feature)('addBank')) {
                    linkObj = ADD_CARD_URLS.SIDEBAR_ADDCARD_WITH_ADDBANK;
                }

                var state = {
                    show: $scope.selectedmethod && !$scope.nmjExperience && !$scope.isUSGambling(),
                    route: linkObj.route,
                    label: $scope.content(linkObj.label)
                };

                return state;
            };

            var populateModels = function populateModels() {
                _index2['default'].instance($scope.token).fetch();
                return (0, _squid.$populate)($scope, {
                    checkoutAppData: _checkout.$CheckoutAppDataModel.instance($scope.token),
                    checkoutCart: _checkout.$CheckoutCartModel.instance($scope.token),
                    checkoutSession: _checkout.$CheckoutSessionModel.instance($scope.token),
                    payee: _checkout.$CheckoutPayeeModel.instance($scope.token)
                });
            };

            var setShowAmount = function setShowAmount() {
                // Non-AU merchants are subjected to PXP test when user action is not commit and line item details
                // are not available and purchase amount is not zero.
                var userAction = $scope.checkoutAppData.useraction();
                var noLineItemDetails = !(userAction && userAction.toLowerCase() === 'commit') && $scope.checkoutCart.get('purchase.items.length', 0) === 0;

                return (0, _pxp.$pxpCartAmt)($scope.checkoutAppData.get('merchant.merchant_country'), $scope.payee.get('merchant.id', ''), noLineItemDetails, $scope.checkoutCart.isPurchase()).then(function (showAmount) {
                    $scope.showAmt = $scope.checkoutCart.get('payment_action') !== 'authorize' && showAmount;
                });
            };

            var setNegativeBalanceData = function setNegativeBalanceData() {
                var negBals = $scope.checkoutSession && $scope.checkoutSession.negBals;

                // re-order multiple currencies when first balance has different currency
                if (negBals && negBals[0].currency_code !== $scope.checkoutCart.purchase.amounts.currency_code) {
                    negBals = negBals.reverse();
                }
                $scope.negBals = negBals;
            };

            var setShowBillingAddress = function setShowBillingAddress() {
                if (!$scope.nmjMultiPage) {
                    return;
                }
                // only show billing address if the selected instrument is a Credit Card
                var selectedInstrument = $scope.checkoutSession.plan.sources && $scope.checkoutSession.plan.sources[0];

                if (selectedInstrument && selectedInstrument.type === 'PAYMENT_CARD') {
                    $scope.showBillingAddress = true;
                }
            };

            var setCurrencyConversionExperiment = function setCurrencyConversionExperiment() {
                var plan = $scope.checkoutSession.plan;

                var callCurrencyConversionPXP = plan.hasConversion() && (0, _squid.$feature)('showConversionOverlay');
                var conversion = plan.conversion;


                if (conversion) {
                    $scope.toTargetCurrency = conversion.to_amount_forex + ' ' + conversion.to_code;
                    $scope.fromUnitCurrency = '1 ' + conversion.from_code;
                }

                // The following if block is the condition to call the currency conversion PXP,
                // remove it after Nov 11th 2018, as one of the treatment has been ramped to 100% on Oct 12th.
                if (callCurrencyConversionPXP) {
                    return _factory5.$CurrencyConversionFactory.fetchPXPTreatments();
                }
            };

            var setMultiFiPadCheckboxState = function setMultiFiPadCheckboxState(id, state) {
                $scope.padToggleFeature.multiFiCheckboxStates[id] = state;
            };

            $scope.getPadStatus = getPadStatus;

            var logFptiForPadToggle = function logFptiForPadToggle(status) {
                _logger.$logger.info('checkout_fpti', {
                    'pad_toggle_status': 'padToggle' + status
                });
            };

            // for PAD checking the corresponding IACH bank is preferred or not
            // only MEFT and IACH subtypes can have isPreferred as true
            $scope.showPreferredLabelForMultiFi = function (plan) {
                var preferred = $scope.checkoutSession.fundingOptions.isPreferred(plan);

                return $scope.makeFiPreferred && preferred && !$scope.checkoutSession.fundingOptions.isMEFT(plan);
            };

            $scope.showPreferredLabelForSingleFi = function (fs) {
                var plans = $scope.checkoutSession.get('fundingOptions.plans') || [];
                var filteredPlans = plans.filter(function (plan) {
                    return plan.planId === fs.id;
                });

                if (filteredPlans.length > 0) {
                    return $scope.checkoutSession.fundingOptions.isPreferred(filteredPlans[0]) && $scope.showPreferredLabel;
                } else {
                    return false;
                }
            };

            // show / hide preferred checkbox for multi fi use case
            $scope.showPreferredCheckboxForMultiFi = function (plan) {
                var preferred = $scope.checkoutSession.fundingOptions.isPreferred(plan);

                return $scope.makeFiPreferred && plan.planId === $scope.selectedmethod.planId && !preferred;
            };

            // Decide whether multiple FI or single FI section should be shown, based on choice experiment criteria
            var initPadToggleFeatureParams = function initPadToggleFeatureParams() {
                $scope.padToggleFeature.applicable = $scope.checkoutSession.fundingOptions.isPadToggleApplicable();
                setPadStatus($scope.padToggleFeature.applicable && $scope.checkoutSession.plan.isPAD() ? true : false);
                var sortedPlans = $scope.getSortedPlans();

                // sortedPlans (fundingOptions.plans) is undefined for BA no purchase case
                if (sortedPlans) {
                    sortedPlans.forEach(function (plan) {
                        if ($scope.checkoutSession.fundingOptions.isPAD(plan)) {
                            setMultiFiPadCheckboxState(plan.primaryFs.id, true);
                        }
                    });
                }
                $scope.padToggleFeature.defaultPlan = $scope.checkoutSession.plan.isPAD();
            };

            // Decide whether multiple FI or single FI section should be shown, based on choice experiment criteria
            $scope.showMultipleFi = function () {
                var length = $scope.selectedmethod && $scope.getSortedPlans() && $scope.getSortedPlans().length || 0;

                // If the PPC Acquisition Banner experiment is treatment 1, add banner as an "FI"
                if ($scope.installment && $scope.installment.showPPCAcquisitionRadioButton) {
                    length++;
                }

                return length > 1;
            };

            var setPadToggleEligbiility = function setPadToggleEligbiility() {
                if ($scope.checkoutSession.fundingOptions.isPadToggleApplicable()) {
                    return Experiments.padToggleFeatureSupported().then(function (result) {
                        $scope.padToggleEnabled = result;
                    });
                } else {
                    $scope.padToggleEnabled = false;
                }
            };

            return populateModels().then(function () {
                var sortedPlans = $scope.getSortedPlans();

                return _angular.$q.all([setShowAmount(), setNegativeBalanceData(), setShowBillingAddress(), setCurrencyConversionExperiment(), _factory.$ShowMoreFiFactory.decideEligibility({
                    plans: sortedPlans
                }), _factory2.$PreferredCheckboxFactory.decideEligibility({
                    plans: sortedPlans,
                    checkoutCart: $scope.checkoutCart
                }), setPadToggleEligbiility(), _factory3.$RewardsCheckboxFactory.buildCache()]).then(function () {
                    if (sortedPlans) {
                        _factory.$ShowMoreFiFactory.init(sortedPlans);
                    }

                    var plans = $scope.checkoutSession.get('fundingOptions.plans');
                    var merchant = $scope.checkoutAppData.merchant;

                    $scope.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;

                    // add FPTI tracking for CVV field
                    var cvvData = $scope.checkoutSession.cvvData;

                    if (cvvData && !cvvData.lastAddedCard) {
                        _logger.$logger.info('checkout_fpti', {
                            'iscvvshown': 'true'
                        });
                    }

                    $scope.sacEligible = function (fsType) {
                        if (fsType !== 'BILL_ME_LATER') {
                            return false;
                        }

                        var total = $scope.checkoutCart.get('purchase.amounts.total');

                        if (total && !$scope.installment.showCYCO && parseFloat(total.amount) >= _checkout.$CreditOptionsModel.sacEligibleAmount[_squid.$locale.country]) {
                            return true;
                        }
                    };

                    var isBilling = $scope.checkoutCart.isBilling();
                    var isBillingNoPurchase = $scope.checkoutCart.isBillingNoPurchase();
                    var disableStickyForMerchant = _squid.$config.disableMerchantForStickyBA.indexOf($scope.payee.merchant.id) > -1;
                    var stickyInstrument = $scope.checkoutSession.getSelectedStickyInstrument();
                    var isWpsSubscription = $scope.checkoutAppData.is_wps_subscription_flow();

                    // Hide 'change' link for sticky disabled merchants
                    $scope.showPayMerchantWithPayPal = isBillingNoPurchase && (disableStickyForMerchant || !stickyInstrument);

                    // Hide 'Pay With' header for NMJ multiple step experience
                    $scope.showPayWithText = !$scope.nmjMultiPage && !$scope.showPayMerchantWithPayPal;
                    $scope.showPreferredLabel = $scope.selectFiVariant && $scope.makeFiPreferred && $scope.checkoutSession.getPlanList() && $scope.checkoutSession.getPlanList().length > 1;

                    var checkoutPlan = $scope.checkoutSession.plan;

                    $scope.canChangeFI = true;
                    if ($scope.showPayMerchantWithPayPal || checkoutPlan.isMSB() || $scope.nmjMultiPage) {
                        $scope.canChangeFI = false;
                    } else if (checkoutPlan.isBalance() && !(0, _squid.$feature)('choiceExperiment')) {
                        // Show the change link always for US, where planning is finished ramping choice.
                        // For other countries, keep old checks until we're sure planning has ramped choice changes there.
                        $scope.canChangeFI = $scope.checkoutSession.plan.hasConversion() || $scope.checkoutSession.fundingOptions.hasECheck() || $scope.checkoutSession.fundingOptions.hasCredit() || Boolean($scope.checkoutSession.getDisallowedPreferred()) || Boolean($scope.checkoutSession.fundingOptions.getPreferred());
                    }

                    $scope.hasMultipleBalances = plans && plans.filter(function (p) {
                        return p.primaryFs.type === 'BALANCE';
                    }).length > 1;

                    $scope.gotoWallet = function () {
                        // For choice variant, go to manage wallet instead. Always available
                        if ($scope.selectedmethod) {
                            return _uiRouter.$state.go('checkout.review.sidebar.sidebarManageWallet');
                        }

                        if ($scope.canChangeFI) {
                            return _uiRouter.$state.go('checkout.review.sidebar.wallet', { padToggleFeature: $scope.padToggleFeature });
                        }
                    };

                    $scope.bmlSeeTerms = function () {
                        $scope.showBmlPopup();
                    };

                    var currentPlanId = $scope.checkoutSession.plan.id;

                    $scope.isSplitPaymentWithBalanceAndIachPlan = false;

                    if ($scope.padToggleEnabled) {
                        initPadToggleFeatureParams();
                    }

                    // page section changes to show pad toggle tooltip properly
                    if ($scope.padToggleEnabled && $scope.padToggleFeature.applicable) {
                        var checkoutPageSection = angular.element(document.getElementById('sliding-area'));

                        checkoutPageSection.css('overflow', 'visible');
                    }

                    $scope.showPadToggle = function () {
                        var padToggle = false;

                        if ($scope.padToggleEnabled && $scope.padToggleFeature.applicable) {
                            var padToggleForFS = $scope.checkoutSession.fundingOptions.isPadToggleApplicableForFS($scope.checkoutSession.plan.id);
                            var isPadPlan = $scope.checkoutSession.plan.isPAD();

                            $scope.isIachPlan = $scope.checkoutSession.plan.isIACH();
                            if ($scope.isIachPlan && !$scope.isSplitPaymentWithBalanceAndIachPlan) {
                                $scope.isSplitPaymentWithBalanceAndIachPlan = $scope.checkoutSession.plan.isSplitPaymentWithBalanceAndIach();
                            }

                            $scope.padToggleFeature.showCheckbox = padToggleForFS && (isPadPlan || $scope.isIachPlan);

                            if (!padToggleForFS) {
                                setPadStatus(false);
                                currentPlanId = $scope.checkoutSession.plan.id;
                            } else if (currentPlanId !== $scope.checkoutSession.plan.id && !isPadPlan) {
                                setPadStatus(false);
                                currentPlanId = $scope.checkoutSession.plan.id;
                            } else if (currentPlanId !== $scope.checkoutSession.plan.id && isPadPlan) {
                                setPadStatus(true);
                                currentPlanId = $scope.checkoutSession.plan.id;
                            }

                            if ($scope.padToggleFeature.showCheckbox) {
                                padToggle = true;

                                // padToggle is false when split balance and `choice` balance checkbox is selected by user
                                var checkboxBalanceChecked = $scope.choiceBalanceCheckboxState && $scope.choiceBalanceCheckboxState.checkbox;

                                if ($scope.isSplitPaymentWithBalanceAndIachPlan && checkboxBalanceChecked) {
                                    padToggle = false;
                                }
                            }
                        }
                        return padToggle;
                    };

                    $scope.getPadFsContent = function (fs) {
                        return $scope.isPadToggleFeatureApplicable() ? $scope.content('paymentMethod.padToggleFs', { bank: fs.name, last4: fs.last4 }) : $scope.content('paymentMethod.padFs', { bank: fs.name, date: fs.hop_date, last4: fs.last4 });
                    };

                    $scope.updatePlan = function (planId) {
                        currentPlanId = planId;

                        $scope.checkoutSession.fundingOptions.action('select', {
                            data: {
                                planId: planId
                            },
                            success: function success(result) {
                                $scope.checkoutSession.populate(result);
                                if (result) {
                                    // Update the installments to support the user selecting a card that does not support installments.
                                    $scope.checkoutSession.installments = result.installments;
                                }
                            }
                        });
                    };

                    function getBankInstrumentId() {
                        var instrumentId = void 0;

                        if ($scope.isSplitPaymentWithBalanceAndIachPlan) {
                            var iachSource = $scope.checkoutSession.plan.sources.find(function (source) {
                                return source.type === 'BANK_ACCOUNT' && source.sub_type === 'INSTANT_TRANSFER';
                            });

                            instrumentId = iachSource && iachSource.instrument_id;
                        } else if ($scope.isIachPlan) {
                            instrumentId = $scope.checkoutSession.plan.sources[0].instrument_id;
                        }
                        return instrumentId;
                    }

                    $scope.multiFiPadToggleCheckboxEvent = function (plan) {
                        setPadStatusForMultiFi(plan);

                        // if pad checkbox is checked for the selected plan
                        if (getMultiFiPadCheckboxState(plan.primaryFs.id)) {
                            logFptiForPadToggle('On');
                        } else {
                            logFptiForPadToggle('Off');
                        }
                    };

                    $scope.padToggleCheckboxEvent = function () {
                        var planId = void 0;

                        // For choice multi FI experience, we want to keep this in sync since this is read on clicking 'Continue' in RYI page
                        // Skip the rest of it though. Doesn't apply for the multiFi variant
                        if ($scope.selectedmethod) {
                            var plan = $scope.checkoutSession.fundingOptions.plans[0];

                            $scope.padToggleFeature.multiFiCheckboxStates[plan.primaryFs.id] = getPadStatus();
                            return $scope.multiFiPadToggleCheckboxEvent(plan);
                        }

                        // if getPadStatus() === true, that means we're currently selecting a PAD plan
                        if (getPadStatus()) {
                            var bankInstrumentId = getBankInstrumentId();

                            planId = $scope.checkoutSession.fundingOptions.getBankPadPlanIdByInstrumentId(bankInstrumentId, 'IACH');
                            logFptiForPadToggle('On');
                        } else {
                            // otherwise we have to find the corresponding IACH plan
                            var padInstrumentId = $scope.checkoutSession.plan.sources[0].instrument_id;

                            planId = $scope.checkoutSession.fundingOptions.getBankPadPlanIdByInstrumentId(padInstrumentId, 'PAD');

                            // when a user intentionally un-check the PayPal balance from choice view
                            var isChoiceBalanceUnchecked = $scope.choiceBalanceCheckboxState.checkbox !== undefined && $scope.choiceBalanceCheckboxState.checkbox === false;

                            if (isChoiceBalanceUnchecked) {
                                // find a IACH plan without a balance
                                var iachPlanWithoutBalance = $scope.checkoutSession.fundingOptions.plans.find(function (p) {
                                    return (p.primaryFs && p.primaryFs.id) === padInstrumentId && $scope.checkoutSession.fundingOptions.isIACH(p) && !p.secondaryFIs;
                                });

                                if (iachPlanWithoutBalance) {
                                    planId = iachPlanWithoutBalance.planId;
                                }
                            }
                            logFptiForPadToggle('Off');
                        }

                        return $scope.updatePlan(planId);
                    };

                    var processAllLoadedPadToggle = function processAllLoadedPadToggle() {
                        if ($scope.padToggleEnabled && $scope.showPadToggle()) {
                            // To remove focus from checkbox so that focus style is not applied
                            if (getPadStatus()) {
                                var section = document.querySelector('#padToggleHelp');

                                if (section) {
                                    section.focus();
                                    section.blur();
                                }
                            }
                            // fpti logging
                            if (!$scope.padToggleFeature.fptiLogged) {
                                if (getPadStatus()) {
                                    _logger.$logger.info('pad_toggle_on_feature_shown');
                                    logFptiForPadToggle('OnShown');
                                } else {
                                    _logger.$logger.info('pad_toggle_off_feature_shown');
                                    logFptiForPadToggle('OffShown');
                                }

                                $scope.padToggleFeature.fptiLogged = true;
                            }
                        }
                    };

                    var handleAllLoadedForPadToggle = _angular.$rootScope.$on('allLoaded', processAllLoadedPadToggle);

                    $scope.$on('$destroy', handleAllLoadedForPadToggle);

                    var stickyEligible = isBilling && !disableStickyForMerchant;

                    // save sticky decision - to be used in the app and other components
                    _squid.$config.features.DEFAULT.enableStickyFunding = stickyEligible;
                    $scope.getPlanList = function (n) {
                        // with purchase - always use plan
                        var sources = $scope.checkoutSession.plan.sources || [];
                        var planList = stickyEligible && isBillingNoPurchase ? $scope.checkoutSession.getSelectedStickyInstrument() && [$scope.checkoutSession.getSelectedStickyInstrument()] : sources.filter(function (instrument) {
                            return instrument.type !== 'REWARDS';
                        });

                        $scope.showUachFeatureDiscalimer = false;

                        // required to display direct debit agreement to AU buyers with unconfirmed bank as payment mode
                        angular.forEach(planList, function (plan) {
                            // display uach - direct debit agreement for AU as of July 1st, 2015
                            if (plan && plan.type === 'BANK_ACCOUNT' && plan.unconfirmed_bank && (0, _squid.$feature)('directDebitAgreement', false, plan.country_code)) {
                                $scope.showUachFeatureDiscalimer = true;
                            }
                        });

                        if (!n) {
                            return planList;
                        } else {
                            return planList.slice(0, n);
                        }
                    };

                    $scope.showBackupPlan = function (plan) {
                        return plan.backup && !(stickyEligible && isBillingNoPurchase);
                    };

                    var isRP = void 0;

                    if (isBilling) {
                        isRP = $scope.checkoutCart.billing.type === 'RECURRING_PAYMENTS';
                    }
                    $scope.showRpBaText = isRP || isWpsSubscription;

                    // Show expanded Variant of Text
                    $scope.showExpandedText = function () {
                        $scope.isExpandedAgreementText = true;
                    };

                    if (_squid.$locale.country === 'US') {
                        $scope.isExpandedAgreementText = true;
                    }

                    $scope.getBAContent = function () {
                        var consentCode = $scope.checkoutCart.billing.consent_code;
                        var useraction = $scope.checkoutAppData.useraction() === 'commit' ? 'Pay' : 'Continue';
                        var stickyFI = $scope.checkoutSession.getSelectedStickyInstrument();
                        var stickyOrNoStickyText = stickyEligible && stickyFI ? 'FiSticky' : 'NoFiSticky';
                        var expandedOrCollapsedText = $scope.isExpandedAgreementText === true ? 'Expanded' : 'Collapsed';
                        var isIndiaDomestic = _squid.$locale.country === 'IN' && _squid.$locale.country === $scope.checkoutAppData.get('merchant.merchant_country', 'US');
                        var indiaDomestic = isIndiaDomestic ? 'Domestic' : '';
                        var contentKey = void 0;

                        if (consentCode) {
                            contentKey = 'enterpriseAgreement.' + consentCode + (stickyEligible && stickyFI ? '' : 'No') + 'FiStickyConsent';
                        } else {
                            contentKey = 'billingAgreement.';

                            $scope.isCIB = $scope.checkoutCart.billing.type === 'CHANNEL_INITIATED_BILLING';

                            if ($scope.isCIB) {
                                contentKey += 'memberAgreementCib' + stickyOrNoStickyText + useraction + expandedOrCollapsedText;
                            } else {
                                contentKey += 'memberAgreement' + stickyOrNoStickyText + indiaDomestic + useraction;
                            }
                        }
                        return contentKey;
                    };

                    $scope.getRPContent = function () {
                        var contentKey = 'billingAgreement.';
                        var useraction = $scope.checkoutAppData.useraction() === 'commit' ? 'Pay' : 'Continue';

                        if (stickyEligible && $scope.checkoutSession.getSelectedStickyInstrument()) {
                            contentKey += 'rpAgreementFiSticky' + useraction;
                        } else {
                            contentKey += 'rpAgreementNoFiSticky' + useraction;
                        }
                        return contentKey;
                    };

                    $scope.getStickyFiName = function () {
                        var selectedStickyInstrument = $scope.checkoutSession.getSelectedStickyInstrument();

                        return stickyEligible && selectedStickyInstrument && selectedStickyInstrument.name;
                    };

                    $scope.getStickyFiLast4 = function () {
                        var selectedStickyInstrument = $scope.checkoutSession.getSelectedStickyInstrument();

                        return stickyEligible && selectedStickyInstrument && selectedStickyInstrument.last4 && 'x-' + selectedStickyInstrument.last4;
                    };

                    // Choice Experiment
                    // Preferred checkbox for single FI variants should only be shown if:
                    $scope.showSinglePreferred = function () {
                        return _factory2.$PreferredCheckboxFactory.isSinglePreferredCheckboxEligible({ plans: $scope.getSortedPlans() });
                    };

                    $scope.showPreferredCheckbox = function (plan) {
                        return _factory2.$PreferredCheckboxFactory.showPreferredCheckbox(plan, $scope.checkoutSession.fundingOptions);
                    };

                    // Update selectedmethod to call update on checkout session later
                    $scope.updateFS = function (fundingsource, index) {
                        $scope.selectedmethod.planId = fundingsource.planId;
                        $scope.selectedmethod.index = index;

                        if ($scope.makeFiPreferred) {
                            $scope.makeFiPreferred.selected = false;
                        }

                        $scope.checkoutSession.cardBackup.resetIfDoesNotApply(fundingsource);
                        setPadStatusForMultiFi(fundingsource);
                    };

                    $scope.isBillingNoCards = function () {
                        if ($scope.checkoutCart.isBillingNoPurchase()) {
                            var emptyPlan = $scope.checkoutSession.futurePaymentInstruments && $scope.checkoutSession.futurePaymentInstruments.length === 0;

                            if ($scope.checkoutAppData.flags.allow_billing_agreement_without_bufs && emptyPlan) {
                                $scope.canChangeFI = false;
                                $scope.showEmptyPlanHeader = true;
                                _logger.$logger.info('BA_nocards_toggle_on_and_empty_plan');
                                return true;
                            }
                        }
                        return false;
                    };

                    $scope.showPPCAcquisitionRadioButton = function () {
                        return $scope.installment && $scope.installment.showPPCAcquisitionRadioButton;
                    };

                    $scope.selectApplyForPPC = function () {
                        return $scope.updateFS({
                            planId: 'applyForPPCRadio'
                        });
                    };

                    $scope.showConversionOptions = function () {
                        if (_factory5.$CurrencyConversionFactory.getConversionOverlayFlag()) {
                            _angular.$rootScope.$broadcast('$showConversionOverlay');
                        } else {
                            return _uiRouter.$state.go('checkout.review.sidebar.currencyConversion');
                        }
                    };
                });
            });
        }]
    };
});

_logger.$logger;

_pxp.$pxpCartAmt;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutSessionModel;

_checkout.$CreditOptionsModel;

_checkout.$CheckoutPayeeModel;

_squid.formatCurrency;

_squid.$config;

_squid.$feature;

_squid.$populate;

_squid.$locale;

_uiRouter.$state;

_angular.$registerDirective;

_angular.$rootScope;

_angular.$q;

_factory.$ShowMoreFiFactory;

_factory2.$PreferredCheckboxFactory;

_factory3.$RewardsCheckboxFactory;

_factory4.$SmartAuthFactory;

_factory5.$CurrencyConversionFactory;

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-paywith/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$SmartAuthFactory', function () {

    var isAuthRequired = function isAuthRequired(fs) {
        return fs.constraint;
    };

    var getConstraintAmount = function getConstraintAmount(fs) {
        var constraint = fs.constraint;
        return (0, _squid.formatCurrency)(constraint.amount.value, constraint.amount.currency, false);
    };

    return {
        isAuthRequired: isAuthRequired,
        getConstraintAmount: getConstraintAmount
    };
});
_squid.formatCurrency;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-member-components/src/review-paywith", "../node_modules/xo-member-components/src/review-paywith/factory.js"))

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-paywith/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"paywith asideView\" content>\n    <div class=\"trayInner trayInnerDefault\" ng-class=\"{installments:(checkoutSession.installments.length > 1)}\">\n        <div id=\"paymentMethod\">\n            <div ng-click=\"gotoWallet()\" ng-if=\"!showMultipleFi() && !isBillingNoCards()\" focusable=\"canChangeFI || selectedmethod\" ng-class=\"{editable:canChangeFI || selectedmethod}\" class=\"focusable singleFi\">\n                <h2 class=\"noBottom paymentsHeader zeta\">\n                    <span ng-if=\"isPadToggleFeatureApplicable()\">\n                        {{ content('paymentMethod.payWith') }}\n                    </span>\n                    <span ng-if=\"!isPadToggleFeatureApplicable()\">\n                        <span ng-if=\"checkoutSession.plan.isPAD()\">\n                        {{ content('paymentMethod.payAfter') }}\n                        </span>\n                        <span ng-if=\"!checkoutSession.plan.isPAD()\">\n                            <span ng-if=\"showPayMerchantWithPayPal\">\n                                {{ content('paymentMethod.payMerchantWithPayPal', {merchantName: merchant}) }}\n                            </span>\n                            <span ng-if=\"showPayWithText\">\n                                {{ content('paymentMethod.payWith') }}\n                            </span>\n                        </span>\n                    </span>\n                </h2>\n                <experience flag='!cardart' class='noCardArt'>\n                    <ul class=\"charges\" data-test-id=\"fundingInstruments\">\n                        <li ng-repeat=\"fs in getPlanList() track by $index\" class=\"clearfix fs\" data-test-id=\"listedFIElement\" ng-if=\"fs.amount.doubleValue !== 0\">\n                            <div ng-class=\"['method', fs.type, fs.sub_type, fs.card_type]\">\n                                <!-- xo-fi-icon fi=\"fs\" class-name=\"fsIcons\"></xo-fi-icon -->\n                                <span class=\"fsIcons\" ng-if=\"!fs.is_pinless_debit\"></span>\n                                <span class=\"pinlessGlyphIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"fs.is_pinless_debit\"></span>\n                                <span class=\"name\">\n                                    <span ng-if=\"fs.type === 'PPCREDIT'\">\n                                        {{ content('paymentMethod.billmelater') }}\n                                    </span>\n                                    <span ng-if=\"fs.sub_type === 'DELAYED_TRANSFER' && !isPadToggleFeatureApplicable()\" ng-bind-html=\"htmlContent('paymentMethod.padFs', {bank: fs.name, date: fs.hop_date, last4: fs.last4})\">\n                                    </span>\n                                    <span ng-if=\"fs.sub_type === 'DELAYED_TRANSFER' && isPadToggleFeatureApplicable()\" ng-bind-html=\"htmlContent('paymentMethod.padToggleFs', {bank: fs.name, last4: fs.last4})\">\n                                    </span>\n                                    <span ng-if=\"fs.type === 'INCENTIVE'\">\n                                        {{ content('paymentMethod.msbOffer') }}\n                                    </span>\n                                    <span class=\"forceRTL\" data-test-id=\"balanceFI\" ng-if=\"fs.type === 'BALANCE'\">\n                                        {{ content('paymentMethod.paypalBalance') }}\n                                    </span>\n                                    <span ng-if=\"fs.type === 'PAYPAL_EXTRAS_MASTERCARD'\">\n                                        {{ content('fsMappings.PAYPAL_EXTRAS_MASTERCARD') }}\n                                    </span>\n                                    <span ng-if=\"fs.type !== 'PPCREDIT' && fs.type !== 'INCENTIVE' && fs.type !== 'BALANCE' && fs.sub_type !== 'DELAYED_TRANSFER' && fs.type !== 'PAYPAL_EXTRAS_MASTERCARD'\">\n                                        <span class=\"fsNamePinlessDebit\" ng-if=\"fs.is_pinless_debit\">\n                                            {{ content('paymentMethod.pinlessDebit') }}\n                                        </span>\n                                        <span class=\"fsname\" ng-if=\"!fs.is_pinless_debit\">\n                                            {{fs.name}}\n                                        </span>\n                                        <span ng-if=\"fs.type === 'ECHECK'\">{{ content('paymentMethod.eCheck') }}</span>\n                                        <span class=\"fsLastDigitsPinlessDebit\" ng-if=\"fs.is_pinless_debit\">\n                                            {{fs.last4 ? 'x-' + fs.last4 : ''}}\n                                        </span>\n                                        <span class=\"fslastdigits\" ng-if=\"!fs.is_pinless_debit\">\n                                            {{fs.last4 ? 'x-' + fs.last4 : ''}}\n                                        </span>\n                                        <span ng-if=\"countryCode === 'DE'\">\n                                            <span ng-if=\"fs.sub_type === 'MEFT'\">\n                                                {{ content('paymentMethod.meft') }}\n                                            </span>\n                                            <span ng-if=\"fs.sub_type === 'IACH'\">\n                                                {{ content('paymentMethod.iach') }}\n                                            </span>\n                                            <span ng-if=\"fs.sub_type === 'INSTANT_TRANSFER' && fs.type === 'BANK'\">\n                                                {{ content('paymentMethod.instantTransfer') }}\n                                            </span>\n                                        </span>\n                                    </span>\n                                    <span ng-if=\"showPreferredLabelForSingleFi(fs)\" class=\"preferredLabel\">\n                                        <br>\n                                        {{ content('memberReview.preferred') }}\n                                    </span>\n                                </span>\n                                <div class=\"rewardsAvailableLabel\" ng-if=\"hasRewards(checkoutSession.plan)\">\n                                    <div ng-if=\"!isSelected(checkoutSession.plan)\">\n                                        <span ng-bind-html=\"getRewardsContent(checkoutSession.plan).secondLineText\"></span>\n                                    </div>\n                                    <div ng-if=\"isSelected(checkoutSession.plan)\">\n                                        <span ng-bind-html=\"getRewardsContent(checkoutSession.plan).rewardsAvailble\"></span>\n                                    </div>\n                                </div>\n                                <span ng-if=\"showCreditPlacement(fs)\">\n                                    <xo-offer token=\"token\" promotion=\"promotion\"\n                                                bmlaction=\"bmlaction\" installment=\"installment\"\n                                                selectedmethod=\"selectedmethod\" reusetext=\"true\" parent-context=\"creditParentContext\">\n                                    </xo-offer>\n                                </span>\n                                <p class=\"msbHelpText secondary\" ng-if=\"fs.type === 'INCENTIVE'\">\n                                    {{ content('paymentMethod.msbHelpText', {amount: formatCurrency(fs.amount.amount, fs.amount.currency_code)})}}\n\n                                    <a class=\"msbDetails\" id=\"msb_{{$index}}\" link-button>{{ content('paymentMethod.msbDetails')}}</a>\n                                </p>\n\n                                <xo-tooltip ng-if=\"fs.type === 'INCENTIVE'\" trigger=\"#msb_{{$index}}\" show-event=\"click\" hide-event=\"mouseleave\" ng-click=\"$event.stopPropagation()\">\n                                    <div class=\"tip tipDesc\">\n                                        <h4>{{ content('paymentMethod.msbToolTipOffer') }}</h4>\n                                        <div class=\"msbToolTipDescription\">\n                                            <p ng-if=\"fs.minPurchaseAmount\">\n                                                {{ content('paymentMethod.msbToolTipText', {amount: formatCurrency(fs.amount.amount, fs.amount.currency_code), minimumPurchase:fs.minPurchaseAmount})\n                                                }}\n                                            </p>\n                                            <p ng-if=\"!fs.minPurchaseAmount\">\n                                                {{ content('paymentMethod.msbToolTipText2', {amount: formatCurrency(fs.amount.amount, fs.amount.currency_code)}) }}\n                                            </p>\n                                            <p>\n                                            </p>\n                                        </div>\n                                    </div>\n                                </xo-tooltip>\n\n                                <xo-tooltip class=\"tip tipHint padHelpToolTip\" ng-if=\"fs.sub_type === 'DELAYED_TRANSFER'\"\n                                            trigger=\"#padHelp\" show-event=\"mouseover\" hide-event=\"mouseleave\">\n                                    <div class=\"tipText tipHintText\">\n                                        <p class=\"padHeader\">\n                                            {{content('paymentMethod.padHelpTxt')}}\n                                        </p>\n                                        <ul class=\"bul\">\n                                            <li>\n                                                <span ng-bind-html=\"htmlContent('paymentMethod.padHelpTxtList1', {date: fs.hop_date, country: locale.country, lang: locale.lang})\"></span>\n                                            </li>\n                                            <li>\n                                                <span ng-bind-html=\"htmlContent('paymentMethod.padHelpTxtList2', {country: locale.country, lang: locale.lang})\"></span>\n                                            </li>\n                                            <li>\n                                                <span ng-bind-html=\"htmlContent('paymentMethod.padHelpTxtList3')\"></span>\n                                            </li>\n                                        </ul>\n                                        <p>\n                                            <span ng-bind-html=\"htmlContent('paymentMethod.padTnc', {country: locale.country, lang: locale.lang})\"></span>\n                                        </p>\n                                    </div>\n                                </xo-tooltip>\n                            </div>\n                            <span ng-if=\"showAmt && !(checkoutSession.installments.length > 1)\" class=\"methodAmount\">\n                                <span class=\"amountFormatted\"><format-currency code=\"fs.amount.currency_code\" amount=\"fs.amount.amount\"></format-currency></span>\n                            </span>\n                            <div ng-if=\"smartAuthFactory.isAuthRequired(fs)\" class=\"smartauthbanner\">\n                                <div class=\"smartauthinfobanner\"><span class=\"smartauthinfologo\" ></span></div>\n                                <div class=\"smartauthtext\" ng-bind-html=\"htmlContent('billingAgreement.smartDollarAuthText', {amountInPayerCurrency: smartAuthFactory.getConstraintAmount(fs)})\"></div>\n                            </div>\n                        </li>\n                        <li class=\"singleFiBackupComponent\" ng-if=\"showBackupPlan(checkoutSession.plan)\">\n                            <xo-backup-label plan=\"checkoutSession.plan\"></xo-backup-label>\n                        </li>\n                        <li ng-if=\"showSinglePreferred() && showPreferredCheckbox(checkoutSession.fundingOptions.plans[0])\" stop-propagation tabindex=\"-1\">\n                            <xo-preferred-checkbox\n                                make-fi-preferred=\"makeFiPreferred\"\n                                plan=\"checkoutSession.fundingOptions.plans[0]\"\n                                cardart=\"false\">\n                            </xo-preferred-checkbox>\n                        </li>\n                        <li stop-propagation\n                            ng-if=\"hasRewards(checkoutSession.fundingOptions.plans[0])\">\n                            <!-- Choice use case -->\n                            <xo-rewards-checkbox\n                                plan=\"checkoutSession.fundingOptions.plans[0]\"\n                                selectedmethod= \"selectedmethod\"\n                                cardart=\"false\">\n                            </xo-rewards-checkbox>\n                        </li>\n                        <li ng-if=\"(checkoutSession.installments.length > 1)\" ng-click=\"$event.stopPropagation()\">\n                            <a ui-sref=\"checkout.review.sidebar.installmentOptions\" ng-init=\"installments = checkoutSession.plan.installments\" class=\"getInstallments btn btn-secondary\" ng-class=\"{getInstallmentsError: installmentNotSelected && !checkoutSession.selectedInstallmentData}\">\n                                <span ng-if=\"checkoutSession.selectedInstallmentData\">{{checkoutSession.selectedInstallmentData.term}}X {{content('paymentMethod.of')}} {{checkoutSession.selectedInstallmentData.monthly_payment.formatted_value}}</span>\n                                <span ng-if=\"!checkoutSession.selectedInstallmentData\">{{content('paymentMethod.changeInstallmentLink') }}</span>\n                                <span class=\"raq\"></span>\n                            </a>\n                        </li>\n                        <li ng-repeat=\"fs in checkoutSession.plan.sources track by $index\" class=\"clearfix\" ng-if=\"fs.sub_type === 'ECHECK' || (countryCode === 'AU' && fs.sub_type === 'DELAYED_TRANSFER')\">\n                            <span class=\"disclaimer\" ng-if=\"fs.sub_type === 'ECHECK'\">\n                                {{ content('paymentMethod.eCheckDescription') }}\n                            </span>\n                            <span class=\"disclaimer\" ng-if=\"countryCode === 'AU' && fs.sub_type === 'DELAYED_TRANSFER'\">\n                                <a id=\"pad_details\">{{ content('paymentMethod.payAfterDeliveryDetails') }}</a>\n                                <xo-tooltip trigger=\"#pad_details\" on-events=\"click\">\n                                    <div class=\"tip tipDesc\">\n                                        {{ content('paymentMethod.padHelpTxt', {date: fs.HOPDate}) }}\n                                        {{ content('paymentMethod.padHelpTxtList') }}\n                                    </div>\n                                </xo-tooltip>\n                            </span>\n                        </li>\n                        <li ng-if=\"showAmt && negBals\" class=\"nbr-line fsicon-margin\">\n                            <span ng-bind-html=\"content('memberReview.nbrMerchantCut', { merchantName: merchant })\"></span>&rlm;:\n                            <span class=\"nbr-amt ltrOverride\">\n                                <format-currency code=\"checkoutCart.purchase.amounts.total.currency_code\" amount=\"checkoutCart.purchase.amounts.total.amount\"></format-currency>\n                            </span>\n                        </li>\n                        <li ng-if=\"showAmt\" ng-repeat=\"nb in negBals track by $index\" class=\"nbr-line fsicon-margin\">\n                            {{ content('memberReview.nbrPaypalCut') }}:\n                            <span class=\"nbr-amt ltrOverride\">\n                                <format-currency code=\"nb.currency_code\" amount=\"nb.amount\"></format-currency>\n                            </span>\n                        </li>\n                        <li ng-if=\"checkoutSession.cvvData && !checkoutSession.cvvData.lastAddedCard\" class=\"clearfix reviewEnterCvvContainer\" ng-click=\"$event.stopPropagation()\" tabindex=\"-1\">\n                            <div class=\"reviewEnterCvv\">\n                                <span class=\"enterCvvPrompt\">{{ content('memberReview.enterCSC') }}</span>\n                                <xo-cvv card=\"checkoutSession.cvvData\" show-label=\"false\"></xo-cvv>\n                            </div>\n                        </li>\n\n                        <li id=\"currencyConversion\" class=\"conversion\" ng-if=\"checkoutSession.plan.conversion\" ng-click=\"$event.stopPropagation()\"\n                            tabindex=\"-1\">\n                            <div ng-if=\"checkoutSession.plan.conversion.paypal\">\n                                <span class=\"conversionRateLabel\">{{content('currencyOptions.paypalRate')}}</span>\n                                <span class=\"conversionRate\">{{content('paymentMethod.conversionRate', {currencyFrom: fromUnitCurrency, currencyTo: toTargetCurrency})}}</span>\n                            </div>\n                            <div ng-if=\"!checkoutSession.plan.conversion.paypal\" class=\"conversionIssuerDisclaimer\">\n                                {{content('currencyOptions.issuerFeesDisclaimer')}}\n                            </div>\n                            <a id=\"conversionLink\" ng-if=\"checkoutSession.plan.conversion.changeable\" ng-click=\"showConversionOptions()\"\n                                focus-when-state=\"checkout.review.sidebar.currencyConversion\" transitions-to=\"checkout.review\"\n                                ng-bind=\"content('currencyOptions.viewConversion')\">\n                            </a>\n                        </li>\n                    </ul>\n                </experience>\n                <experience flag='cardart' class='cardArt'>\n                    <div class=\"charges\">\n                        <li ng-repeat=\"fs in getPlanList() track by $index\" class=\"clearfix fs\" ng-if=\"fs.amount.doubleValue !== 0\">\n                            <xo-fi-panel fi=\"fs\"\n                                show-amount=\"showAmt && !(checkoutSession.installments.length > 1) && !balanceWithRewards(fs)\"\n                                name-override=\"fs.sub_type === 'DELAYED_TRANSFER' && getPadFsContent(fs)\"\n                                >\n                                <div class=\"rewardsAvailableLabel\" ng-if=\"hasRewards(checkoutSession.plan)\">\n                                    <div ng-if=\"!isSelected(checkoutSession.plan)\">\n                                        <span ng-bind-html=\"getRewardsContent(checkoutSession.plan).secondLineText\"></span>\n                                    </div>\n                                    <div ng-if=\"isSelected(checkoutSession.plan)\">\n                                        <span ng-bind-html=\"getRewardsContent(checkoutSession.plan).rewardsAvailble\"></span>\n                                    </div>\n                                </div>\n                                <span ng-if=\"showCreditPlacement(fs)\">\n                                    <xo-offer token=\"token\" promotion=\"promotion\"\n                                                bmlaction=\"bmlaction\" installment=\"installment\"\n                                                selectedmethod=\"selectedmethod\" reusetext=\"true\" parent-context=\"creditParentContext\">\n                                    </xo-offer>\n                                </span>\n                                <p class=\"msbHelpText secondary\" ng-if=\"fs.type === 'INCENTIVE'\">\n                                    {{ content('paymentMethod.msbHelpText', {amount: formatCurrency(fs.amount.amount, fs.amount.currency_code)})}}\n\n                                    <a class=\"msbDetails\" id=\"msb_{{$index}}\" link-button>{{ content('paymentMethod.msbDetails')}}</a>\n                                </p>\n\n                                <xo-backup-label\n                                    ng-if=\"fs.type === 'BANK_ACCOUNT' && showBackupPlan(checkoutSession.plan)\"\n                                    plan=\"checkoutSession.plan\"\n                                    has-mask=\"true\"\n                                    >\n                                </xo-backup-label>\n\n                                <div ng-if=\"fs.is_preferred && makeFiPreferred\">\n                                    <span class=\"preferredLabel\">{{ content('memberReview.preferred') }}</span>\n                                </div>\n                            </xo-fi-panel>\n                            <xo-tooltip ng-if=\"fs.type === 'INCENTIVE'\" trigger=\"#msb_{{$index}}\" show-event=\"click\" hide-event=\"click\" ng-click=\"$event.stopPropagation()\">\n                                <div class=\"tip tipDesc\">\n                                    <h4>{{ content('paymentMethod.msbToolTipOffer') }}</h4>\n                                    <div class=\"msbToolTipDescription\">\n                                        <p ng-if=\"fs.minPurchaseAmount\">\n                                            {{ content('paymentMethod.msbToolTipText', {amount: formatCurrency(fs.amount.amount, fs.amount.currency_code), minimumPurchase:fs.minPurchaseAmount}) }}\n                                        </p>\n                                        <p ng-if=\"!fs.minPurchaseAmount\">\n                                            {{ content('paymentMethod.msbToolTipText2', {amount: formatCurrency(fs.amount.amount, fs.amount.currency_code)}) }}\n                                        </p>\n                                        <p>\n                                        </p>\n                                    </div>\n                                </div>\n                            </xo-tooltip>\n                            <xo-tooltip class=\"tip tipHint padHelpToolTip\" ng-if=\"fs.sub_type === 'DELAYED_TRANSFER'\"\n                                        trigger=\"#padHelp\" show-event=\"mouseover\" hide-event=\"mouseleave\">\n                                <div class=\"tipText tipHintText\">\n                                    <p class=\"padHeader\">\n                                        {{content('paymentMethod.padHelpTxt')}}\n                                    </p>\n                                    <ul class=\"bul\">\n                                        <li>\n                                            <span ng-bind-html=\"htmlContent('paymentMethod.padHelpTxtList1', {date: fs.hop_date, country: locale.country, lang: locale.lang})\"></span>\n                                        </li>\n                                        <li>\n                                            <span ng-bind-html=\"htmlContent('paymentMethod.padHelpTxtList2', {country: locale.country, lang: locale.lang})\"></span>\n                                        </li>\n                                        <li>\n                                            <span ng-bind-html=\"htmlContent('paymentMethod.padHelpTxtList3')\"></span>\n                                        </li>\n                                    </ul>\n                                    <p>\n                                        <span ng-bind-html=\"htmlContent('paymentMethod.padTnc', {country: locale.country, lang: locale.lang})\"></span>\n                                    </p>\n                                </div>\n                            </xo-tooltip>\n                            <div ng-if=\"smartAuthFactory.isAuthRequired(fs)\" class=\"smartauthbanner\">\n                                <div class=\"smartauthinfobanner\"><span class=\"smartauthinfologo\" ></span></div>\n                                <div class=\"smartauthtext\" ng-bind-html=\"htmlContent('billingAgreement.smartDollarAuthText', {amountInPayerCurrency: smartAuthFactory.getConstraintAmount(fs)})\"></div>\n                            </div>\n                        </li>\n                        <div ng-if=\"showSinglePreferred() && showPreferredCheckbox(checkoutSession.fundingOptions.plans[0])\" stop-propagation tabindex=\"-1\">\n                            <xo-preferred-checkbox\n                                make-fi-preferred=\"makeFiPreferred\"\n                                plan=\"checkoutSession.fundingOptions.plans[0]\"\n                                cardart=\"true\">\n                            </xo-preferred-checkbox>\n                        </div>\n                        <xo-rewards-checkbox stop-propagation\n                                             ng-if=\"hasRewards(checkoutSession.fundingOptions.plans[0])\"\n                                             plan=\"checkoutSession.fundingOptions.plans[0]\"\n                                             selectedmethod= \"selectedmethod\"\n                                             cardart=\"true\">\n                        </xo-rewards-checkbox>\n                        <div ng-if=\"(checkoutSession.installments.length > 1)\" ng-click=\"$event.stopPropagation()\">\n                            <div ng-if=\"!installmentNotSelected || checkoutSession.selectedInstallmentData\">\n                                <a ui-sref=\"checkout.review.sidebar.installmentOptions\" ng-init=\"installments = checkoutSession.plan.installments\" class=\"getInstallments btn btn-secondary\">\n                                    <span ng-if=\"checkoutSession.selectedInstallmentData\">{{checkoutSession.selectedInstallmentData.term}}X {{content('paymentMethod.of')}} {{checkoutSession.selectedInstallmentData.monthly_payment.formatted_value}}</span>\n                                    <span ng-if=\"!checkoutSession.selectedInstallmentData\">{{content('paymentMethod.changeInstallmentLink') }}</span>\n                                    <span class=\"raq\"></span>\n                                </a>\n                            </div>\n\n                            <div ng-if=\"installmentNotSelected && !checkoutSession.selectedInstallmentData\">\n                                <a ui-sref=\"checkout.review.sidebar.installmentOptions\" ng-init=\"installments = checkoutSession.plan.installments\" class=\"getInstallmentsError btn btn-secondary\">\n                                    {{content('paymentMethod.changeInstallmentLink') }}\n                                    <span class=\"raq\"></span>\n                                </a>\n                            </div>\n                        </div>\n                        <li ng-if=\"showAmt && negBals\" class=\"nbr-line fsicon-margin\">\n                            <span ng-bind-html=\"content('memberReview.nbrMerchantCut', { merchantName: merchant })\"></span>:\n                            <span class=\"nbr-amt ltrOverride\">\n                                <format-currency code=\"checkoutCart.purchase.amounts.total.currency_code\" amount=\"checkoutCart.purchase.amounts.total.amount\"></format-currency>\n                            </span>\n                        </li>\n                        <li ng-if=\"showAmt\" ng-repeat=\"nb in negBals track by $index\" class=\"nbr-line fsicon-margin\">\n                            {{ content('memberReview.nbrPaypalCut') }}:\n                            <span class=\"nbr-amt ltrOverride\">\n                                <format-currency code=\"nb.currency_code\" amount=\"nb.amount\"></format-currency>\n                            </span>\n                        </li>\n                        <li ng-if=\"checkoutSession.cvvData && !checkoutSession.cvvData.lastAddedCard\" class=\"clearfix reviewEnterCvvContainer\" ng-click=\"$event.stopPropagation()\" tabindex=\"-1\">\n                            <div class=\"reviewEnterCvv\">\n                                <span class=\"enterCvvPrompt\">{{ content('memberReview.enterCSC') }}</span>\n                                <xo-cvv card=\"checkoutSession.cvvData\" show-label=\"false\"></xo-cvv>\n                            </div>\n                        </li>\n\n                        <div id=\"currencyConversion\" class=\"conversion\" ng-if=\"checkoutSession.plan.conversion\" ng-click=\"$event.stopPropagation()\"\n                            tabindex=\"-1\">\n                            <div ng-if=\"checkoutSession.plan.conversion.paypal\">\n                                <span class=\"conversionRateLabel\">{{content('currencyOptions.paypalRate')}}</span>\n                                <span class=\"conversionRate\">{{content('paymentMethod.conversionRate', {currencyFrom: fromUnitCurrency, currencyTo: toTargetCurrency})}}</span>\n                            </div>\n                            <div ng-if=\"!checkoutSession.plan.conversion.paypal\" class=\"conversionIssuerDisclaimer\">\n                                {{content('currencyOptions.issuerFeesDisclaimer')}}\n                            </div>\n                            <a id=\"conversionLink\" ng-if=\"checkoutSession.plan.conversion.changeable\" ng-click=\"showConversionOptions()\"\n                                focus-when-state=\"checkout.review.sidebar.currencyConversion\" transitions-to=\"checkout.review\"\n                                ng-bind=\"content('currencyOptions.viewConversion')\">\n                            </a>\n                        </div>\n                    </div>\n                </experience>\n            </div>\n\n            <div ng-if=\"showMultipleFi()\" ng-class=\"{editable:canChangeFI}\" class=\"multipleFi focusable\">\n                <h2 class=\"noBottom paymentsHeader zeta\">\n                    <span ng-if=\"checkoutSession.plan.isPAD() && !padToggleEnabled\">\n                        {{ content('paymentMethod.payAfter') }}\n                    </span>\n                    <span ng-if=\"!checkoutSession.plan.isPAD() || padToggleEnabled\">\n                        <span ng-if=\"showPayMerchantWithPayPal\">\n                            {{ content('paymentMethod.payMerchantWithPayPal', {merchantName: merchant}) }}\n                        </span>\n                        <span ng-if=\"showPayWithText\">\n                            {{ content('paymentMethod.payWith') }}\n                        </span>\n                    </span>\n                </h2>\n\n                <div ng-if=\"checkoutSession.fundingOptions.getMsbByPlanId(selectedmethod.planId)\" class=\"msbOffer\">\n                    <xo-msb-offer msb=\"checkoutSession.fundingOptions.getMsbByPlanId(selectedmethod.planId)\"></xo-msb-offer>\n                </div>\n\n                <ul class=\"charges\" data-test-id=\"fundingInstruments\">\n                        <!--List of Plans-->\n                    <li ng-hide=\"showMoreFiFactory.shouldHideFiEntry($index)\" role=\"presentation\" class=\"fundingsource\" data-test-id=\"listedFIElement\" ng-repeat=\"plan in getSortedPlans() track by plan.planId\">\n                        <experience flag='!cardart'>\n                            <div class=\"row-fluid radioButton\">\n                                <input type=\"radio\" id=\"{{plan.planId}}\" name=\"selectedFI\" data-test-id=\"selectFIRadioButton\" value=\"{{plan.planId}}\" ng-model=\"selectedmethod.planId\" ng-click=\"updateFS(plan, $index)\"\n                                    ng-keydown=\"showMoreFiFactory.selectFiOnKeyDown($event, $index)\" />\n                                <label class=\"noBottom multiFiLabelContainer\" for=\"{{plan.planId}}\">\n                                    <div ng-if=\"plan.secondaryFIs && plan.secondaryFIs.length && plan.primaryFs.subtype !== 'PAD'\">\n                                        <div class=\"fsdetails\" ng-class=\"[plan.secondaryFIs[0].type]\">\n                                            <span class=\"fsIcon\" ng-class=\"[plan.secondaryFIs[0].type, plan.secondaryFIs[0].name]\"></span>\n                                            <span class=\"fsName\">{{content('fsMappings.'+ plan.secondaryFIs[0].name) || plan.secondaryFIs[0].name}}</span>\n                                            <span class=\"colon\" ng-if=\"plan.secondaryFIs.length === 1\">: </span>\n                                            <span class=\"amount\" ng-if=\"plan.secondaryFIs.length === 1 && plan.secondaryFIs[0].amount\">{{plan.secondaryFIs[0].amount.amount_formatted}}</span>\n                                        </div>\n                                    </div>\n                                    <div ng-class=\"{singleInstrumentContainer: !plan.secondaryFIs}\">\n                                        <span class=\"fsIcon pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"plan.primaryFs.isPinlessDebit\"></span>\n                                        <span class=\"fsIcon\" ng-class=\"[plan.primaryFs.type, plan.primaryFs.name]\" ng-if=\"!plan.primaryFs.isPinlessDebit\"></span>\n                                        <div class=\"fsdetails\" ng-class=\"[plan.primaryFs.type]\">\n                                            <div ng-switch=\"plan.primaryFs.subtype\">\n                                                <div class=\"fundingContainerPAD\" ng-switch-when=\"PAD\">\n                                                    <div ng-if=\"!padToggleEnabled\">\n                                                        <span class=\"subtype\">{{content('fundingInstruments.pad')}}</span>\n                                                        <br>\n                                                    </div>\n                                                    <span class=\"name\">{{content('fsMappings.'+plan.primaryFs.name) || plan.primaryFs.name}}</span>\n                                                    <span class=\"lastdigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}</span>\n                                                    <div class=\"iachMeftLabel\" ng-if=\"isCountryDE\">{{content('fundingInstruments.iach')}}</div>\n                                                </div>\n                                                <div ng-switch-default>\n                                                    <span class=\"fsName\" data-test-id=\"primaryFsName\" ng-if=\"plan.primaryFs.isPinlessDebit\">{{content('fsMappings.PINLESSDEBIT')}}</span>\n                                                    <!--<span class=\"fsName\" ng-if=\"!plan.primaryFs.isPinlessDebit\" ng-bind-html=\"content('fsMappings.'+plan.primaryFs.name) || (plan.primaryFs.name + '&#8207;').toString()\"></span>-->\n                                                    <span class=\"fsName\" data-test-id=\"primaryFsName\" ng-if=\"!plan.primaryFs.isPinlessDebit\">{{content('fsMappings.'+plan.primaryFs.name) || (plan.primaryFs.name)}} &rlm;</span>\n                                                    <span class=\"lastdigits\" data-test-id=\"primaryFsDigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}</span>\n                                                    <div class=\"iachMeftLabel\" ng-if=\"isCountryDE && plan.primaryFs.subtype === 'MEFT'\">{{content('fundingInstruments.meft')}}</div>\n                                                    <div class=\"iachMeftLabel\" ng-if=\"isCountryDE && plan.primaryFs.subtype === 'IACH'\">{{content('fundingInstruments.iach')}}</div>\n                                                    <span class=\"colon\" ng-if=\"plan.secondaryFIs.length === 1\">: </span>\n                                                </div>\n                                            </div>\n                                            <div class=\"rewardsAvailableLabel\" ng-if=\"hasRewards(plan)\">\n                                                <div ng-if=\"!isSelected(plan)\">\n                                                    <span ng-bind-html=\"getRewardsContent(plan).secondLineText\"></span>\n                                                </div>\n                                                <div ng-if=\"isSelected(plan)\">\n                                                    <span ng-bind-html=\"getRewardsContent(plan).rewardsAvailble\"></span>\n                                                </div>\n                                            </div>\n                                            <div ng-if=\"showPreferredLabelForMultiFi(plan)\">\n                                                <span class=\"preferredLabel\">{{ content('memberReview.preferred') }}</span>\n                                            </div>\n                                            <div class=\"padLabel\" ng-if=\"showPadLabelForPadEligibleCountries(plan)\">\n                                                <span ng-if=\"plan.planId !== selectedmethod.planId\">\n                                                    <span>{{content('memberReview.padLabel_2')}}</span>\n                                                </span>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </label>\n                            </div>\n                            <div class=\"fsSubdetails\">\n                                <span ng-if=\"showCreditPlacement(plan)\">\n                                    <xo-offer token=\"token\" promotion=\"promotion\"\n                                              bmlaction=\"bmlaction\" installment=\"installment\"\n                                              selectedmethod=\"selectedmethod\" reusetext=\"true\" parent-context=\"creditParentContext\">\n                                    </xo-offer>\n                                </span>\n                                <xo-preferred-checkbox\n                                    ng-if=\"showPreferredCheckboxForMultiFi(plan) && showPreferredCheckbox(plan)\"\n                                    make-fi-preferred=\"makeFiPreferred\"\n                                    plan=\"plan\"\n                                    cardart=\"false\">\n                                </xo-preferred-checkbox>\n                                <xo-rewards-checkbox\n                                    ng-if=\"hasRewards(plan)\"\n                                    plan=\"plan\"\n                                    selectedmethod= \"selectedmethod\"\n                                    cardart=\"false\">\n                                </xo-rewards-checkbox>\n                                <div class=\"multiFiBackupComponent\"\n                                    ng-if=\"plan.planId === selectedmethod.planId && showBackupPlan(plan)\">\n                                    <xo-backup-label\n                                        plan=\"plan\">\n                                    </xo-backup-label>\n                                </div>\n                                <div ng-if=\"plan.primaryFs.subtype === 'ECHECK'\" class=\"disclaimer\">\n                                    {{ content('paymentMethod.eCheckDescription') }}\n                                </div>\n\n                                <div class=\"padToggle padToggleMultiFi sCheckbox checkbox\" ng-if=\"showMultiFiPadToggle(plan)\">\n                                    <input type=\"checkbox\" ng-checked=\"padToggleFeature.multiFiCheckboxStates[plan.primaryFs.id]\" ng-change=\"multiFiPadToggleCheckboxEvent(plan)\" ng-model=\"padToggleFeature.multiFiCheckboxStates[plan.primaryFs.id]\" id=\"padToggle\" name=\"padToggle\"\n                                            ng-true-value=\"true\" ng-false-value=\"false\"/>\n                                            <label for=\"padToggle\" id=\"padToggleLabel\" class=\"padToggleSectionTitle\">{{ content('paymentMethod.padToggleTitle') }}</label>\n                                    <div id=\"padToggleOnSection\" class=\"padToggleSection\" ng-if=\"padToggleFeature.multiFiCheckboxStates[plan.primaryFs.id]\">\n                                        <p id=\"padToggleOnText\" class=\"padToggleSectionOnInfoText\">\n                                            <span ng-bind-html=\"htmlContent('paymentMethod.padToggleOnInfoText', {date: checkoutSession.fundingOptions.getPadPlanHopDate(plan), lang: locale.lang, country: locale.country})\"></span>\n                                        </p>\n                                        <xo-tooltip ng-if=\"padToggleFeature.multiFiCheckboxStates[plan.primaryFs.id]\" trigger=\"#padToggleHelp strong\" show-event=\"mouseover\" hide-event=\"mouseleave\">\n                                            <div class=\"padToggleHelpToolTip\">\n                                                <p class=\"padToggleHelpToolTipHeader\">\n                                                    {{content('paymentMethod.padToggleHelpTooltipHeader')}}\n                                                </p>\n                                                <p class=\"padToggleHelpToolTipText\">\n                                                    <span ng-bind-html=\"htmlContent('paymentMethod.padToggleHelpTooltipText', {lang: locale.lang, country: locale.country})\"></span>\n                                                </p>\n                                            </div>\n                                        </xo-tooltip>\n                                    </div>\n                                    <div class=\"padToggleSection\" ng-if=\"!padToggleFeature.multiFiCheckboxStates[plan.primaryFs.id]\">\n                                        <p class=\"padToggleSectionOffInfoText\">\n                                            <span ng-bind-html=\"htmlContent('paymentMethod.padToggleOffInfoText', {lang: locale.lang, country: locale.country})\"></span>\n                                        </p>\n                                        <xo-tooltip trigger=\"#padToggleHelp strong\" show-event=\"mouseover\" hide-event=\"mouseleave\">\n                                            <div class=\"padToggleHelpToolTip\">\n                                                <p class=\"padToggleHelpToolTipHeader\">\n                                                    {{content('paymentMethod.padToggleHelpTooltipHeader')}}\n                                                </p>\n                                                <p class=\"padToggleHelpToolTipText\">\n                                                    <span ng-bind-html=\"htmlContent('paymentMethod.padToggleHelpTooltipText', {lang: locale.lang, country: locale.country})\"></span>\n                                                </p>\n                                            </div>\n                                        </xo-tooltip>\n                                    </div>\n                                </div>\n                            </div>\n                        </experience>\n                        <experience flag='cardart'>\n                            <div class=\"row-fluid radioButton fsPanelRadioWrapper\">\n                                <input type=\"radio\" id=\"{{plan.planId}}\" name=\"selectedFI\" data-test-id=\"selectFIRadioButton\" value=\"{{plan.planId}}\" ng-model=\"selectedmethod.planId\" ng-click=\"updateFS(plan, $index)\"\n                                ng-keydown=\"showMoreFiFactory.selectFiOnKeyDown($event, $index)\" />\n                                <label class=\"noBottom\" for=\"{{plan.planId}}\">\n                                    <div class=\"positionDecoupler\">\n                                        <xo-fi-panel fi=\"plan.primaryFs\"\n                                            show-currency-code=\"plan.primaryFs.type === 'BALANCE' && hasMultipleBalances\"\n                                        >\n                                            <div class=\"rewardsAvailableLabel\" ng-if=\"hasRewards(plan)\">\n                                                <div ng-if=\"!isSelected(plan)\">\n                                                    <span ng-bind-html=\"getRewardsContent(plan).secondLineText\"></span>\n                                                </div>\n                                                <div ng-if=\"isSelected(plan)\">\n                                                    <span ng-bind-html=\"getRewardsContent(plan).rewardsAvailble\"></span>\n                                                </div>\n                                            </div>\n                                            <span ng-if=\"showCreditPlacement(plan)\">\n                                                <xo-offer token=\"token\" promotion=\"promotion\"\n                                                            bmlaction=\"bmlaction\" installment=\"installment\"\n                                                            selectedmethod=\"selectedmethod\" reusetext=\"true\"\n                                                            parent-context=\"creditParentContext\">\n                                                </xo-offer>\n                                            </span>\n                                            <xo-preferred-checkbox\n                                                ng-if=\"makeFiPreferred && plan.planId === selectedmethod.planId && showPreferredCheckbox(plan)\"\n                                                make-fi-preferred=\"makeFiPreferred\"\n                                                plan=\"plan\"\n                                                cardart=\"true\">\n                                            </xo-preferred-checkbox>\n\n                                            <xo-backup-label\n                                                ng-if=\"plan.planId === selectedmethod.planId && showBackupPlan(plan)\"\n                                                plan=\"plan\"\n                                                has-mask=\"true\"\n                                                >\n                                            </xo-backup-label>\n\n                                            <div ng-if=\"plan.primaryFs.subtype === 'ECHECK'\" class=\"disclaimer\">\n                                                {{ content('paymentMethod.eCheckDescription') }}\n                                            </div>\n                                            <div ng-if=\"plan.primaryFs.isPreferred && makeFiPreferred\">\n                                                <span class=\"preferredLabel\">{{ content('memberReview.preferred') }}</span>\n                                            </div>\n                                            <div>\n                                                <xo-rewards-checkbox\n                                                    ng-if=\"hasRewards(plan)\"\n                                                    plan=\"plan\"\n                                                    selectedmethod= \"selectedmethod\"\n                                                    cardart=\"true\">\n                                                </xo-rewards-checkbox>\n                                            </div>\n                                        </xo-fi-panel>\n                                    </div>\n                                </label>\n                            </div>\n                        </experience>\n                    </li>\n                    <li role=\"presentation\" class=\"fundingsource\" ng-if=\"showPPCAcquisitionRadioButton()\">\n                        <div class=\"row-fluid radioButton\">\n                            <input type=\"radio\" id=\"applyForPPCRadio\" name=\"selectedFI\" value=\"applyForPPCRadio\" ng-click=\"selectApplyForPPC()\"/>\n                            <label class=\"noBottom\" for=\"applyForPPCRadio\">\n                                <xo-offer token=\"token\" promotion=\"promotion\" bmlaction=\"bmlaction\" installment=\"installment\"\n                                    selectedmethod=\"selectedmethod\" radio=\"true\" parent-context=\"creditParentContext\">\n                                </xo-offer>\n                            </label>\n                        </div>\n                    </li>\n                </ul>\n            </div>\n\n            <xo-show-more-fi-link ng-if=\"showMoreFiFactory.isFiNeverExpanded()\"></xo-show-more-fi-link>\n\n            <div ng-if=\"checkoutSession.cardBackup.isAllowed()\">\n                <xo-card-backup token=\"token\" selectedmethod=\"selectedmethod\"></xo-card-backup>\n            </div>\n\n            <!-- Show billing address associated to the selected card-->\n            <div ng-if=\"showBillingAddress\" class=\"charges\" ng-model=\"checkoutSession\">\n                <div id=\"billingAddressDisplay\">\n                    <xo-billing-address token=\"token\" edit-uri=\"\"></xo-billing-address>\n                </div>\n            </div>\n\n            <div class=\"padToggle sCheckbox checkbox\" ng-if=\"showPadToggle() && !showMultipleFi()\">\n                <input type=\"checkbox\" ng-checked=\"getPadStatus()\" ng-change=\"padToggleCheckboxEvent()\" ng-model=\"padToggleFeature.checkboxEnabled\" id=\"padToggle\" name=\"padToggle\"\n                        ng-true-value=\"true\" ng-false-value=\"false\"/>\n                <label for=\"padToggle\" id=\"padToggleLabel\" class=\"padToggleSectionTitle\">{{ content('paymentMethod.padToggleTitle') }}</label>\n                <div id=\"padToggleOnSection\" class=\"padToggleSection\" ng-if=\"getPadStatus()\">\n                    <p id=\"padToggleOnText\" class=\"padToggleSectionOnInfoText\">\n                        <span ng-bind-html=\"htmlContent('paymentMethod.padToggleOnInfoText', {date: checkoutSession.plan.sources[0].hop_date, lang: locale.lang, country: locale.country})\"></span>\n                    </p>\n                    <xo-tooltip ng-if=\"getPadStatus()\" trigger=\"#padToggleHelp strong\" show-event=\"mouseover\" hide-event=\"mouseleave\">\n                        <div class=\"padToggleHelpToolTip\">\n                            <p class=\"padToggleHelpToolTipHeader\">\n                                {{content('paymentMethod.padToggleHelpTooltipHeader')}}\n                            </p>\n                            <p class=\"padToggleHelpToolTipText\">\n                                <span ng-bind-html=\"htmlContent('paymentMethod.padToggleHelpTooltipText', {lang: locale.lang, country: locale.country})\"></span>\n                            </p>\n                        </div>\n                    </xo-tooltip>\n                    <div class=\"padToggleSectionOnBalanceText\" ng-if=\"isSplitPaymentWithBalanceAndIachPlan\">\n                        <div>\n                            <span class=\"balanceMsgIcon\"/>\n                        </div>\n                        <div class=\"balanceMsg\">\n                            <span ng-bind-html=\"htmlContent('paymentMethod.padToggleOnBalanceText')\"/>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"padToggleSection\" ng-if=\"!getPadStatus()\">\n                    <p class=\"padToggleSectionOffInfoText\">\n                        <span ng-bind-html=\"htmlContent('paymentMethod.padToggleOffInfoText', {lang: locale.lang, country: locale.country})\"></span>\n                    </p>\n                    <xo-tooltip trigger=\"#padToggleHelp strong\" show-event=\"mouseover\" hide-event=\"mouseleave\">\n                        <div class=\"padToggleHelpToolTip\">\n                            <p class=\"padToggleHelpToolTipHeader\">\n                                {{content('paymentMethod.padToggleHelpTooltipHeader')}}\n                            </p>\n                            <p class=\"padToggleHelpToolTipText\">\n                                <span ng-bind-html=\"htmlContent('paymentMethod.padToggleHelpTooltipText', {lang: locale.lang, country: locale.country})\"></span>\n                            </p>\n                        </div>\n                    </xo-tooltip>\n                </div>\n            </div>\n\n            <div ng-if=\"getAddCardLink().show\" class=\"multipleFi addCard\">\n                <a track-link=\"add_card\" ui-sref=\"{{getAddCardLink().route}}\" class=\"addCardLink\" role=\"button\" data-test-id=\"addCardLink\">\n                    <span class=\"plusicon\"></span>\n                    <p class=\"addOption\">\n                        <span class=\"name\">{{getAddCardLink().label}}</span>\n                    </p>\n                </a>\n            </div>\n\n            <!-- For single step nmj, openup wallet page in the sidebar against the review page -->\n            <div ng-if=\"nmjExperience && !nmjExperience.multiPage\" class=\"multipleFi switchCard\">\n                <a track-link=\"view_wallet\" ui-sref=\"checkout.review.sidebar.wallet\" class=\"addCardLink\" role=\"button\" data-test-id=\"walletLink\">\n                    <span class=\"plusicon\"></span>\n                    <p class=\"addOption\">\n                        <span class=\"name\">{{content('addCard.switchCard')}}</span>\n                    </p>\n                </a>\n            </div>\n\n            <!-- For multi step nmj, openup add card page in the sidebar against the pay-with-card page -->\n            <div ng-if=\"nmjExperience && nmjExperience.multiPage\" class=\"multipleFi switchCard\">\n                <a track-link=\"add_card\" ui-sref=\"checkout.payWithCard.sidebar.sidebarAddCard.addCardFlow.addCard\" class=\"addCardLink\" role=\"button\" data-test-id=\"addCardLink\">\n                    <span class=\"plusicon\"></span>\n                    <p class=\"addOption\">\n                        <span class=\"name\">{{content('addCard.switchCard')}}</span>\n                    </p>\n                </a>\n            </div>\n\n            <h2 class=\"noBottom paymentsHeader zeta\" ng-if=\"showEmptyPlanHeader\">\n                <span>\n                    {{ content('paymentMethod.emptyPlanHeader') }}\n                </span>\n            </h2>\n            <div class=\"cibBillingTxt secondary\" ng-if=\"checkoutCart.isBilling() && isCIB && !showRpBaText\">\n                <span class=\"cibTextBox\" data-test-id=\"BAContent\" data-ng-bind-html=\"htmlContent(getBAContent(), { merchantName: merchant,\n                    partner: merchant, fiName: getStickyFiName(), fiFormatLast4: getStickyFiLast4(), country: locale.country, lang: locale.lang})\">\n                </span>\n                <span data-test-id=\"CIBShowMore\" ng-if=\"!isExpandedAgreementText\">...\n                <a href=\"javascript:void(0);\" class=\"textLink\"\n                    ng-click=\"showExpandedText()\"\n                    onclick=\"return false;\">{{content('billingAgreement.memberAgreementCibShowMore')}}</a>\n                    </span>\n            </div>\n\n            <p id=\"baAgreement\" data-test-id=\"baAgreement\"  class=\"billingTxt secondary\" ng-if=\"checkoutCart.isBilling() && !isCIB && !showRpBaText\">\n                <span data-test-id=\"BAContent\" data-ng-bind-html=\"htmlContent(getBAContent(), { merchantName: merchant, fiName: getStickyFiName(), fiFormatLast4: getStickyFiLast4(), country: locale.country, lang: locale.lang})\"></span>\n            </p>\n\n            <p id=\"rpAgreement\" class=\"billingTxt secondary\" ng-if=\"checkoutCart.isBilling() && showRpBaText\">\n                <span data-test-id=\"BAContent\" data-ng-bind-html=\"htmlContent(getRPContent(), { merchantName: merchant, fiName: getStickyFiName(), fiFormatLast4: getStickyFiLast4(), country: locale.country, lang: locale.lang})\"></span>\n            </p>\n\n            <div class=\"payWithCredit\">\n                <xo-pay-with-credit token=\"token\"></xo-pay-with-credit>\n            </div>\n\n            <!-- AU only direct debit agreement message for a AU buyer with unconfirmed bank -->\n            <p bind-html-compile=\"htmlContent('paymentMethod.directDebitAgreement', { payButtonText: payButtonText })\" ng-if=\"showUachFeatureDiscalimer\"\n                class=\"disclaimer directDebitAgreement\"></p>\n\n            <a ng-if=\"showChangeFI()\" ui-sref=\"checkout.review.sidebar.wallet\" class=\"edits changePayment\"\n                select-button aria-label=\"{{ content('paymentMethod.label') }}\" focus-when-state=\"checkout.review.sidebar.wallet\" transitions-to=\"checkout.review\">\n                {{ locale.country === 'BR' ? content('common.changePayment') : content('common.change') }}\n                <span class=\"frontArrow goTray\"></span>\n            </a>\n\n            <a ng-if=\"selectedmethod && !nmjExperience\" ui-sref=\"checkout.review.sidebar.sidebarManageWallet\" class=\"edits changePayment\"\n                select-button focus-when-state=\"checkout.review.sidebar.sidebarManageWallet\" transitions-to=\"checkout.review\">\n                {{ content('asideHeader.manage') }}\n                <span class=\"frontArrow goTray\"></span>\n            </a>\n        </div>\n    </div>\n</div>\n<div id=\"bfx-overlay\">\n    <xo-currency-conversion-overlay token=\"token\" ng-if=\"checkoutSession.plan.conversion\"></xo-currency-conversion-overlay>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-shipping-options/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-address-components/src/address-display/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/review-address/directive.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/review-shipping-options/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-member-components/src/review-shipping-options/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var SHIPPING_TYPE_LABEL_MAPPING = {
    SHIP_TO_STORE: {
        PICKUP_IN_STORE: 'shipping.pickupInStore',
        STORE_PICKUP: 'shipping.storePickup',
        PICKUP_OPTION: 'shipping.pickupOption',
        COLLECTION: 'shipping.collection',
        EXPRESS_PICKUP: 'shipping.expressPickup',
        CLICK_COLLECT: 'shipping.clickCollect',
        SHIP_TO_STORE: 'shipping.shipToStore',
        COLLECT_PLUS: 'shipping.collectPlus',
        PICKUP_FROM_STORE: 'shipping.pickupFromStore',
        FREE_NEXT_DAY_STORE_DELIVERY: 'shipping.freeNextDayStoreDelivery',
        BUY_AND_COLLECT: 'shipping.buyAndCollect',
        SHIP_TO_LOCKER: 'shipping.shipToLocker'
    },
    SHIP_TO_HOME: {
        SHIP_TO_HOME: 'shipping.shipToHome',
        OVERNIGHT: 'shipping.overnightShipping', // testing multiple methods ....
        TWO_THREE_DAYS: 'shipping.twoThreeDaysShipping' // testing multiple methods ....
    }
};

var SHIPPING_TYPE_MAPPING = {
    SHIP_TO_HOME: 'shipping.shipHome',
    SHIP_TO_STORE: 'shipping.shipStore'
};

var SHIPPING_TYPE = {
    SHIP_TO_HOME: 'SHIP_TO_HOME',
    SHIP_TO_STORE: 'SHIP_TO_STORE'
};

var TAB_STATE = {
    SHIP: 'ship',
    PICKUP: 'pickup'
};

exports['default'] = _squid.$Component.extend('$xoReviewShippingOptionsComponent', {
    tag: 'xo-review-shipping-options',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        methods: {
            type: 'var',
            required: true
        },
        shippingChangeFeature: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()['catch'](_angular.noop)
            };
        }
    },

    actions: {
        gotoShipping: function gotoShipping() {
            // action defined to either take you to view your shipping option selection or explain why you can't change this address
            if (this.models.checkoutAppData.flags.allow_change_shipping || this.shippingMethods && this.shippingMethods.length === 0) {
                _uiRouter.$state.go('checkout.review.sidebar.shipping');
            } else {
                this.cannotChangeShippingInfoMessages = true;
            }
        },
        setStateTo: function setStateTo(state) {
            this.state = state;

            if (state === TAB_STATE.SHIP) {
                // resetting the Pick Up methods since we're transitioning to the Shipping Tab
                this.selectedPickupMethod = undefined;
                if (this.shippingMethods && this.shippingMethods.length === 1) {

                    this.actions.selectShippingMethod(this.shippingMethods[0]);
                    return;
                }
            }

            if (state === TAB_STATE.PICKUP) {
                // resetting the Shipping methods since we're transitioning to the Pick Up Tab
                this.selectedShippingMethod = undefined;
                if (this.pickupMethods && this.pickupMethods.length === 1) {

                    this.actions.selectShippingMethod(this.pickupMethods[0]);
                    return;
                }
            }
            /*
                if none of these, then it means that the buyer has multiple choices in the next tab and we can't make any assumptions
                so we'll unselect them by storing undefined in our cache.
             */
            window.xprops.supplement.addPaymentDetails(this.models.checkoutAppData.get('payment_id'), undefined);
        },


        /*
            selects a Shipping Method and saves it in our incontext checkout.js caching in-script.
         */
        selectShippingMethod: function selectShippingMethod(selected) {
            var _this = this;

            var callCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            var _ref = this.props.methods.filter(function (method) {
                // eslint-disable-line array-callback-return
                if (method.id === selected.id) {
                    return method;
                }
            }) || [],
                shippingMethod = _ref[0];

            if (shippingMethod.type === SHIPPING_TYPE.SHIP_TO_HOME) {
                // assigning to selectedShippingMethod for rendering
                this.selectedShippingMethod = selected;
            }

            if (shippingMethod.type === SHIPPING_TYPE.SHIP_TO_STORE) {
                // assigning to selectedPickupMethod for rendering
                this.selectedPickupMethod = selected;
            }

            // we store it under selected_shipping_method for get/execute calls in jsv4
            var shippingOption = {
                selected_shipping_method: shippingMethod
            };

            if (window.xprops && window.xprops.supplement && window.xprops.supplement.addPaymentDetails) {
                var addedPaymentDetails = window.xprops.supplement.addPaymentDetails(this.models.checkoutAppData.get('payment_id'), shippingOption);
                if (addedPaymentDetails) {
                    addedPaymentDetails.then(function () {
                        if (_this.shippingChangeFeature && _this.shippingChangeFeature.callOnShippingChange && callCallback) {
                            _this.shippingChangeFeature.callOnShippingChange();
                        }
                    });
                }
            }
        },
        clickPickupDropdown: function clickPickupDropdown($event) {
            if ($event) {
                $event.stopPropagation();
            }
            this.isPickupDropdownActive = !this.isPickupDropdownActive;
        },
        clickShippingDropdown: function clickShippingDropdown($event) {
            if ($event) {
                $event.stopPropagation();
            }
            this.isShippingDropdownActive = !this.isShippingDropdownActive;
        },

        /*
         Helper to map shipping methods passed by the props and
         select only the ones that fit the 'type'.
          Returns typed shipping methods with shippingType and
         shippingLabel containing their localized content
         */
        mapShippingMethodsByType: function mapShippingMethodsByType(shippingMethods, type) {
            if (shippingMethods) {

                var typedShippingMethods = shippingMethods.filter(function (shippingMethod) {
                    return SHIPPING_TYPE[shippingMethod.type] === type;
                });

                if (typedShippingMethods.length > 0) {
                    return typedShippingMethods.map(function (shippingMethod) {
                        return {
                            id: shippingMethod.id,
                            shippingType: SHIPPING_TYPE_MAPPING[shippingMethod.type],
                            shippingLabel: SHIPPING_TYPE_LABEL_MAPPING[shippingMethod.type][shippingMethod.label]
                        };
                    });
                }
            }
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this2 = this;

            // Tab State between 'ship' and 'pickup'
            this.state = TAB_STATE.SHIP;
            // Dropdown active flag
            this.isPickupDropdownActive = false;
            this.isShippingDropdownActive = false;

            // selectedShippingMethod contains the buyer's current selection
            this.selectedShippingMethod; // eslint-disable-line no-unused-expressions
            this.selectedPickupMethod; // eslint-disable-line no-unused-expressions

            // map JSV4 shipping methods
            this.pickupMethods = this.actions.mapShippingMethodsByType(this.props.methods, SHIPPING_TYPE.SHIP_TO_STORE);
            this.shippingMethods = this.actions.mapShippingMethodsByType(this.props.methods, SHIPPING_TYPE.SHIP_TO_HOME);

            this.isShipping = function () {
                return _this2.state === TAB_STATE.SHIP;
            };
            this.isPickup = function () {
                return _this2.state === TAB_STATE.PICKUP;
            };

            // We'll render dual tabs ONLY when there are TWO Shipping types sent by the merchant
            this.renderTabs = function () {
                return Boolean(_this2.pickupMethods && _this2.shippingMethods);
            };

            // Find the right header to render
            this.choosePageHeader = function () {
                if (_this2.renderTabs()) {
                    return (0, _squid.$renderContent)('shipping.orderChoiceLabel');
                } else if (_this2.shippingMethods) {
                    _this2.actions.setStateTo(TAB_STATE.SHIP);
                    return (0, _squid.$renderContent)('shipping.ShipOnlyHeader');
                } else {
                    _this2.actions.setStateTo(TAB_STATE.PICKUP);
                    return (0, _squid.$renderContent)('shipping.PickupOnlyHeader');
                }
            };
            // when clicking outside the dropdown
            var self = this;
            this.$on('clickBody', function () {
                self.isPickupDropdownActive = false;
                self.isShippingDropdownActive = false;
            });
        },
        populate: function populate() {
            // If there's only one choice from the start, we'll select it
            if (this.isShipping()) {
                if (this.shippingMethods && this.shippingMethods.length === 1) {
                    this.actions.selectShippingMethod(this.shippingMethods[0], false);
                }
            } else if (this.pickupMethods && this.pickupMethods.length === 1) {
                this.actions.selectShippingMethod(this.pickupMethods[0], false);
            }
        }
    }
});


_angular.noop;

_uiRouter.$state;

_squid.$Component;

_squid.$renderContent;

_index.$CheckoutAppDataModel;

_index.$CheckoutSessionModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-shipping-options/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-shipping-options/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"shippingForm\" class=\"shippingForm shipping asideView\" content>\n    <div class=\"trayInner trayInnerDefault\">\n\n        <h4 class=\"noBottom paymentsHeader zeta\" ng-bind-html=\"choosePageHeader()\"></h4>\n\n        <!--Tab selection for Shipping or Pick up options, only render when multiple Shipping Option types passed by merchant-->\n        <div ng-if=\"renderTabs()\" class=\"tabContainer\">\n            <div class=\"tab\" ng-class=\"{ active: isShipping() }\" ng-click=\"actions.setStateTo('ship')\" ng-bind-html=\"content('shipping.shipItTab')\"></div>\n            <div class=\"tab\" ng-class=\"{ active: isPickup() }\" ng-click=\"actions.setStateTo('pickup')\" ng-bind-html=\"content('shipping.pickItUp')\"></div>\n        </div>\n\n        <div ng-if=\"!renderTabs()\" class=\"spacing\"></div>\n\n        <!-- Shipping Tab -->\n        <div ng-if=\"isShipping()\" ng-class=\"{editable:models.checkoutAppData.flags.allow_change_shipping}\" focusable=\"!cannotChangeShippingInfoMessages\" class=\"focusable\" select-button ng-click=\"actions.gotoShipping()\">\n\n\n            <!--Address display section-->\n            <div id=\"shippingAddress\" class=\"address\">\n                <span class=\"given-name\" data-test-id=\"fullName\">{{models.checkoutSession.shipping.name}}</span>\n                <xo-address-display token=\"token\" address=models.checkoutSession.shipping ></xo-address-display>\n                <a class=\"edits changeShipping ng-class:{disabled:cannotChangeShippingInfoMessages}\" data-test-id=\"shipToChangeLink\" select-button focusable=\"!cannotChangeShippingInfoMessages\" ng-click=\"actions.gotoShipping()\" aria-label=\"{{ content('shippingAddress.label') }}\" focus-when-state=\"checkout.review.sidebar.shipping\" transitions-to=\"checkout.review\">\n                    {{ content('common.change') }}\n                    <span class=\"frontArrow goTray ng-scope ng-class:{disabled:cannotChangeShippingInfoMessages}\"></span>\n                </a>\n            </div>\n\n            <!--Shipping methods display-->\n            <div ng-if=\"shippingMethods && shippingMethods.length > 1\" class=\"dropdownContainer\" ng-class=\"{ active: isShippingDropdownActive }\" ng-click=\"actions.clickShippingDropdown($event)\" tabindex=\"1\">\n                <div ng-if=\"!selectedShippingMethod\" class=\"soft\" ng-bind-html=\"content('shipping.selectShippingMethod')\"></div>\n\n                <div ng-if=\"selectedShippingMethod\" class=\"display\">\n                    <label class=\"selectedType\" ng-bind-html=\"content(selectedShippingMethod.shippingType)\"></label>\n                    <span ng-bind-html=\"content(selectedShippingMethod.shippingLabel)\"></span>\n                </div>\n\n                <ul class=\"dropdown\">\n                    <li ng-repeat=\"shippingMethod in shippingMethods track by $index\" ng-click=\"actions.selectShippingMethod(shippingMethod)\">\n                        <span ng-bind-html=\"content(shippingMethod.shippingLabel)\"></span>\n                    </li>\n                </ul>\n\n            </div>\n        </div>\n\n        <!-- Pick Up Tab -->\n        <div ng-if=\"isPickup()\" class=\"pickupSelection\">\n            <!--Rendering pickup details content-->\n            <div class=\"inline\">\n                <span ng-bind-html=\"content('shipping.pickupDetails')\"></span>\n            </div>\n\n            <!--Rendering when pickup methods are > 1-->\n            <div ng-if=\"pickupMethods && pickupMethods.length > 1\" class=\"dropdownContainer\" ng-class=\"{ active: isPickupDropdownActive }\" ng-click=\"actions.clickPickupDropdown($event)\" tabindex=\"1\">\n                <div ng-if=\"!selectedPickupMethod\" class=\"soft\" ng-bind-html=\"content('shipping.selectPickUpLocation')\"></div>\n\n                <div ng-if=\"selectedPickupMethod\" class=\"display\">\n                    <label class=\"selectedType\" ng-bind-html=\"content(selectedPickupMethod.shippingType)\"></label>\n                    <span ng-bind-html=\"content(selectedPickupMethod.shippingLabel)\"></span>\n                </div>\n\n                <ul class=\"dropdown\">\n                    <li ng-repeat=\"pickupMethod in pickupMethods track by $index\" ng-click=\"actions.selectShippingMethod(pickupMethod)\">\n                        <span ng-bind-html=\"content(pickupMethod.shippingLabel)\"></span>\n                    </li>\n                </ul>\n            </div>\n        </div>\n\n\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-topup/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/review-topup/styles.less");

var _template = __webpack_require__("../node_modules/xo-member-components/src/review-topup/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('xoReviewTopup', {
    tag: 'xo-review-topup',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        flags: {
            // flags.sepaAgree is set to true when the Sepa Mandate checkbox is checked by user
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            var checkoutCart = _checkout.$CheckoutCartModel.instance(this.props.token);
            var auth = _auth.$AuthModel.instance();
            return {
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                walletPreferences: _fi.$WalletPreferences.instance(this.props.token).retrieve()['catch'](_angular.noop),
                tokenizedFundingCapabilitiesModel: _app.$TokenizedFundingCapabilitiesModel.instance(this.props.token).retrieve({
                    params: {
                        tokenizedWalletToken: checkoutCart.tokenizedWalletToken,
                        country: auth.country
                    }
                })['catch'](_angular.noop)
            };
        }
    },
    actions: {
        gotoTopupFunding: function gotoTopupFunding() {
            _uiRouter.$state.go('checkout.review.sidepage.topupFunding');
        },
        closeModal: function closeModal() {
            this.showSepaModal = false;
        },
        openModal: function openModal() {
            this.showSepaModal = true;
        },

        /**
         * This function is refered in the signupTerms.agreeSepaTermsV2 content which has a link to open the Sepa page.
         */
        openSepa: function openSepa() {
            var sepaModel = _fi.$SepaModel.instance();
            this.sepa = {};
            var that = this;
            sepaModel.action('sepaDirectMandate', {
                resultModel: this.sepa,
                data: {
                    bank: {
                        id: this.models.checkoutSession.sepa_mandate.bankId
                    }
                },
                success: function success() {
                    that.actions.openModal();
                }
            });
        }
    },
    lifecycle: {
        enter: function enter() {
            this.showSepaModal = false;
            this.formatCurrency = _squid.formatCurrency;
            this.instrumentIconId = function (name) {
                return _fi.$WalletInstrumentNameMapping.instance().getInstrumentNameNormalized(name);
            };
        },
        populate: function populate() {
            var _this = this;

            /**
             * Identify the preferred fs from the matching instrument_id
             */
            this.identifyPreferred = function (preferred, userSelectedFundingSource, fundingSources) {
                if (!preferred || !preferred.instrument_id) {
                    // Preferred does not have an instrument_id, hence pick the userSelectedFundingSource
                    return userSelectedFundingSource;
                } else if (!preferred.name) {
                    // Preferred has an instrument_id but does not have the full details, so map the corresponding element
                    return _squid.$util.find(fundingSources, function (fs) {
                        return fs.instrument_id === preferred.instrument_id;
                    });
                }
                return preferred;
            };

            /**
             * PatchXO api call for tokenization flows
             */
            this.tokenizationPatchXO = function (instrumentId) {
                return _this.models.checkoutSession.action('setTopupFI', {
                    data: {
                        instrument_id: instrumentId
                    }
                });
            };

            var _models = this.models,
                checkoutSession = _models.checkoutSession,
                walletPreferences = _models.walletPreferences,
                tokenizedFundingCapabilitiesModel = _models.tokenizedFundingCapabilitiesModel;
            var topupFundingSources = checkoutSession.topupFundingSources,
                futurePaymentInstruments = checkoutSession.futurePaymentInstruments;
            // Topup does not have userSelectedFundingSource during the initial CreateXO api call

            var userSelectedFundingSource = checkoutSession.userSelectedFundingSource || topupFundingSources && topupFundingSources[0] || {};

            // Set the FI preferred currency
            walletPreferences.currency = tokenizedFundingCapabilitiesModel.getCurrency();

            if (tokenizedFundingCapabilitiesModel.isTopupEnabled()) {
                // Reset the users walletPreferences.direct to an empty object in an Topup flow.
                walletPreferences.direct = {};
                // Identify the preferred topup instrument
                walletPreferences.topup.fundingSource = this.identifyPreferred(walletPreferences.topup.fundingSource, userSelectedFundingSource, topupFundingSources);

                // topup amount is fixed to single value
                walletPreferences.topup.amount = _squid.$config.topup.topupAmounts[0];
                walletPreferences.topup.currency = _squid.$config.topup.currency;
            } else if (tokenizedFundingCapabilitiesModel.isDirectFundingEnabled()) {
                // Reset the users walletPreferences.topup to an empty object in an Direct funding flow.
                walletPreferences.topup = {};
                // futurePaymentInstruments could have balance in it
                walletPreferences.direct.fundingSource = this.identifyPreferred(walletPreferences.direct.fundingSource, userSelectedFundingSource, futurePaymentInstruments);
            }

            if (walletPreferences.getPreferred().instrument_id !== userSelectedFundingSource.instrument_id && userSelectedFundingSource.instrument_id !== null) {
                /**
                 * instrumet_id not in sync with XO, hence make a patchXO api call.
                 * Use Case:
                 * When there are 2 banks (B1, B2) in the user account, and the user had linked his PayPal account in his Google wallet, with B2 as the preferred instrument.
                 * User then tries to link his PayPal account in a different Google wallet.
                 * - PAPS CreateXO api always returns the 1st direct funding instrument (i.e. B1) as the userSelectedFundingSource, and the contingency would be resolved for it.
                 * - But wallet preference for the user will return B2.
                 * - Since we need to show B2 to the user, we will update PAPS with B2 using the PatchXO api call.
                 */
                this.tokenizationPatchXO(walletPreferences.getPreferred().instrument_id);
            }

            if (tokenizedFundingCapabilitiesModel.isTopupEnabled()) {
                this.fundingLabel = (0, _squid.$renderContent)('review.topupFundingLabel');
            } else {
                this.fundingLabel = (0, _squid.$renderContent)('review.paymentMethod');
            }

            /**
             * Checks whether Sepa manadate agreement needs to be shown to the user or not
             */
            this.isSepaMandateRequired = function () {
                if (this.models.checkoutSession.sepa_mandate) {
                    return true;
                }
            };
        }
    }
});


_angular.noop;

_uiRouter.$state;

_squid.$Component;

_squid.$config;

_squid.formatCurrency;

_squid.$util;

_squid.$renderContent;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutCartModel;

_fi.$WalletPreferences;

_fi.$WalletInstrumentNameMapping;

_fi.$SepaModel;

_app.$TokenizedFundingCapabilitiesModel;

_auth.$AuthModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-topup/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-topup/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"reviewTopup\" ng-class=\"{reviewDirectFunding: models.tokenizedFundingCapabilitiesModel.isDirectFundingEnabled()}\" content>\n    <div class=\"topupAmountContainer listItem\" ng-if=\"models.tokenizedFundingCapabilitiesModel.isTopupEnabled() && models.walletPreferences.topup.amount && models.walletPreferences.topup.currency\">\n        <span class=\"label\">{{content('review.topupAmountLabel')}}</span>\n        <format-currency class=\"listItemValue\" code=\"models.walletPreferences.topup.currency\"\n                         amount=\"models.walletPreferences.topup.amount\"\n                         currency-style=\"Currency\"></format-currency>\n    </div>\n    <div class=\"clearfix topupFundingContainer listItem\" ng-click=\"actions.gotoTopupFunding()\">\n        <div>\n            <span class=\"label\" >{{ fundingLabel }}</span>\n            <div class=\"listItemValue\">\n                <span class=\"walletIcons\" ng-class=\"[models.walletPreferences.getPreferred().type,\n                                                    instrumentIconId(models.walletPreferences.getPreferred().name),\n                                                    models.walletPreferences.getPreferred().card_type]\"></span>\n\n                <span ng-if=\"models.tokenizedFundingCapabilitiesModel.isTopupEnabled()\">\n                    <!-- Show the card name and last4 digits in the same line -->\n                    <span class=\"fsname\">{{models.walletPreferences.getPreferred().name}}</span>\n                    <span class=\"fsLast4\">&nbsp;x-{{models.walletPreferences.getPreferred().last4}}</span>\n                </span>\n                <span ng-if=\"models.tokenizedFundingCapabilitiesModel.isDirectFundingEnabled()\" class=\"fsname\">\n                    <!-- Show the bank name and last4 digits in different lines -->\n                    <div class=\"bankname\">{{models.walletPreferences.getPreferred().name}}</div>\n                    <div>••••{{models.walletPreferences.getPreferred().last4}}</div>\n                </span>\n\n                <a ui-sref=\"checkout.review.sidepage.topupFunding\" class=\"edits changePayment\" select-button focus-when-state=\"checkout.review.sidepage.topupFunding\" transitions-to=\"checkout.review\">\n                    <span class=\"frontArrow goTray\"></span>\n                </a>\n            </div>\n        </div>\n        <div class=\"listItemDisclaimer\" ng-if=\"models.tokenizedFundingCapabilitiesModel.isTopupEnabled()\">\n            <span class=\"disclaimer\">{{content('review.topupFundingSourceInfo')}}</span>\n        </div>\n    </div>\n    <div class=\"row-fluid inputField checkbox legal sepaTerms\" ng-if=\"isSepaMandateRequired()\">\n        <input ng-model=\"flags.sepaAgree\" type=\"checkbox\" name=\"sepaAgree\" id=\"sepaAgree\"/>\n        <label class=\"noBottom agreeTerms\" for=\"sepaAgree\" bind-html-compile=\"htmlContent('sepa.agreeSepaTerms')\"></label>\n    </div>\n\n    <xo-modal show=showSepaModal show-close-button=\"true\" on-close=\"actions.closeModal\">\n        <section id=\"sepaMandateContingency\" class=\"sepaMandate\" content>\n            <div class=\"row-fluid\">\n                <div class=\"centerTray\">\n                    <div class=\"trayInner trayInnerDefault loggingIn\">\n                            <h2 class=\"zeta\">{{content('directDebitAgreement.ddFullAgreementTitle')}}</h2>\n                            <p>{{content('DEMemberGuest.ddAgreementPara1')}}</p>\n                            <div class=\"row-fluid sepaInfo\">\n                                <div class=\"span\">\n                                    <strong>{{content('DEMemberGuest.accountCarrier')}}</strong>\n                                    <p>\n                                        <span>{{sepa.user.name}}</span>\n                                        <br/>{{sepa.user.address.line1}}\n                                        <br/>{{sepa.user.address.line2}}\n                                        <br/> {{sepa.user.address.city}}, {{sepa.user.address.postal_code}}\n                                        <br/>{{sepa.user.address.country}}\n                                    </p>\n                                </div>\n                                <div class=\"span bankDetails\">\n                                    <p>\n                                        <strong>{{content('DEMemberGuest.IBAN')}}</strong>\n                                    </p>\n                                    {{sepa.bank.iban_number}}\n                                    <p class=\"marginTop\">\n                                        <strong>{{content('DEMemberGuest.bankName')}}</strong>\n                                    </p>\n                                    {{sepa.bank.bank_name}}\n                                    <p class=\"marginTop\">\n                                        <strong>{{content('DEMemberGuest.bic')}}</strong>\n                                    </p>\n                                    {{sepa.bank.bic}}\n                                </div>\n                            </div>\n\n                            <input track-submit id=\"sepaSubmit\" type=\"submit\" value=\"{{ content('header.close') }}\" class=\"btn full\" ng-click=\"actions.closeModal()\" />\n\n                            <div id=\"paypalLogo\" class=\"miniLogo\"><span class=\"accessAid\">{{ content('base.payPal') }}</span></div>\n                    </div>\n                </div>\n            </div>\n        </section>\n    </xo-modal>\n</section>\n\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/rewards-checkbox/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

__webpack_require__("../node_modules/xo-angular-ui-utils/ui-utils.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");

var _choice = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

var _factory = __webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/factory.js");

var _utils = __webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/utils.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// eslint-disable-line no-unused-vars
// for ui-validate directive
exports['default'] = _squid.$Component.extend({
    tag: 'xo-rewards-checkbox',
    template: _template2['default'],
    props: {
        selectedmethod: {
            type: 'var',
            required: false
        },
        plan: {
            type: 'var',
            required: false
        },
        cardart: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _checkout.$CheckoutSessionModel.instance(_angular.$rootScope.token).retrieve()['catch'](_angular.noop),
                checkoutCart: _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token).retrieve()['catch'](_angular.noop),
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve()['catch'](_angular.noop),
                choiceVariant: _choice.$ChoiceEligibility.instance().getVariant(_angular.$rootScope.token)
            };
        }
    },
    actions: {
        open: function open() {
            this.rewards.interstitialValue = this.rewards.value; // Set initial value to be the same as regular
            this.showOverlay = true;
            var rewardsAssociatedIds = this.rewards.rewardsPayload.rewardsAssociatedIds || {};

            _logger.$logger.info('pay_with_rewards', {
                'from': 'UPDATE_REWARDS_INTERSTITIAL',
                'to': 'prepare_update_rewards_amount',
                'rewards_type': this.contentkeys.issuerName,
                'fi_id': rewardsAssociatedIds.cardID
            });
        },
        close: function close() {
            this.showOverlay = false;
            var rewardsAssociatedIds = this.rewards.rewardsPayload.rewardsAssociatedIds || {};
            _logger.$logger.info('pay_with_rewards', {
                'from': 'UPDATE_REWARDS_INTERSTITIAL',
                'to': 'process_cancellation',
                'rewards_type': this.contentkeys.issuerName,
                'fi_id': rewardsAssociatedIds.cardID
            });
        },
        toggle: function toggle() {
            var rewardsAssociatedIds = this.rewards.rewardsPayload.rewardsAssociatedIds || {};
            if (this.state.selected) {
                _factory.$RewardsCheckboxFactory.setCheckboxSelectionForPlan({
                    selected: true,
                    plan: this.plan,
                    selectedmethod: this.selectedmethod,
                    isReplan: false
                });
                _logger.$logger.info('pay_with_rewards', {
                    'from': 'FUNDING_OPTION_SELECTION',
                    'to': 'process_funding_option_selection',
                    'rewards_type': this.contentkeys.issuerName,
                    'fi_id': rewardsAssociatedIds.cardID
                });
            } else {
                // set done to false if user disables checkbox
                this.done = false;
                _factory.$RewardsCheckboxFactory.setCheckboxSelectionForPlan({
                    selected: false,
                    plan: this.plan,
                    selectedmethod: this.selectedmethod,
                    isReplan: false
                });
            }
        },
        submit: function submit() {
            var _this = this;

            _logger.$logger.info('PayWithRewards_interstitial_submit');
            var loaded = this.rewards && this.rewards.rewardsPayload && this.rewards.rewardsPayload.rewardsAssociatedIds && this.rewards.value;

            if (!loaded) {
                // should not actually be needed
                return false;
            }

            if (!_factory.$RewardsCheckboxFactory.isRewardsTypeChangeable(this.rewards.rewardsPayload.issuerDetails.rewardsType)) {
                this.showOverlay = false;
                return;
            }

            var ctx = this.getContext();
            var rewardsAssociatedIds = this.rewards.rewardsPayload.rewardsAssociatedIds || {};
            var value = this.rewards.interstitialValue;

            _factory.$RewardsCheckboxFactory.submitRewards(this.models.checkoutSession, ctx.currency_code, rewardsAssociatedIds.planID, rewardsAssociatedIds.rewardsID, value).then(function (data) {
                var isFail = typeof data === 'boolean' && data === false;
                var iRewardsPlan = _this.models.checkoutSession.plan.sources.length > 1; // TODO: maybe a better way to de this check ?

                _this.state.selected = !isFail && iRewardsPlan;
                if (!isFail) {
                    _this.rewards.value = _this.rewards.interstitialValue;

                    _factory.$RewardsCheckboxFactory.setCheckboxSelectionForPlan({
                        selected: true,
                        plan: _this.plan,
                        selectedmethod: _this.selectedmethod,
                        isReplan: true
                    });
                    _logger.$logger.info('pay_with_rewards', {
                        'from': 'UPDATE_REWARDS_INTERSTITIAL',
                        'to': 'process_update_rewards_amount',
                        'rewards_type': ctx.issuerData.issuerName,
                        'rewards_amt': value,
                        'fi_id': rewardsAssociatedIds.cardID
                    });
                }
                _this.done = _this.done || !isFail; // TODO: check if already selected ?
            })['finally'](function () {
                // TODO: error handler
                _this.showOverlay = false;
            });
        }
    },
    lifecycle: {
        enter: function enter() {
            this.state = {
                selected: false
            };
            this.done = false;
            this.rewards = this.rewards || {
                // TODO: remove after moving logic to use selectedmethod
                // as opposed to separate var
                // placeholder var until cleanup/removal
                value: '',
                interstitialValue: '',
                planid: '',
                rewardsPayload: {},
                type: ''
            };
            this.form_error = false;

            _factory.$RewardsCheckboxFactory.setCheckboxSelectionForPlan({
                selected: false,
                plan: this.plan,
                selectedmethod: this.selectedmethod,
                isReplan: false
            });
        },
        populate: function populate() {
            this.showOverlay = false;
            this.plan = this.plan || this.props.plan || this.models.checkoutSession.plan;
            // TODO: Consider a mapper of sorts here for the payload
            this.rewards.rewardsPayload = _factory.$RewardsCheckboxFactory.getRewardDetails(this.plan);
            this.contentkeys = _factory.$RewardsCheckboxFactory.getContentKeys(this.plan, this.rewards.rewardsPayload);
            this.rewards.type = this.contentkeys.type; // type is a predefined key // recheck later

            var rewardsPayload = this.rewards && this.rewards.rewardsPayload && this.rewards.rewardsPayload.rewardsPayload || {};

            this.rewards.value = this.rewards.interstitialValue = (0, _utils.getInitialRewardsValue)(this.models, rewardsPayload);
            this.fullOverlay = this.rewards.type === 'statement-credit';
        }
    },
    controller: ['$scope', function ($scope) {

        $scope.getContext = function () {
            var ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            // TODO: first destructor and then get rid of it
            // need to refactor base payload first
            var rewardsDetails = $scope.rewards && $scope.rewards.rewardsPayload || {};
            var issuerData = rewardsDetails && rewardsDetails.issuerDetails || {};
            var constraint = rewardsDetails && rewardsDetails.rewardsPayload && rewardsDetails.rewardsPayload.rewards_constraint;
            var currency_code = $scope.models.checkoutCart.purchase && $scope.models.checkoutCart.purchase.amounts && $scope.models.checkoutCart.purchase.amounts.total.currency_code;
            return _squid.$util.extend({
                issuerData: issuerData, constraint: constraint, currency_code: currency_code,
                rewards_type: issuerData.rewardsType,
                conversion_metadata: rewardsDetails.rewardsPayload && rewardsDetails.rewardsPayload.conversion_metadata
            }, ctx);
        };

        $scope.showCheckbox = function () {
            var result = _factory.$RewardsCheckboxFactory.showCheckbox($scope.plan, $scope.selectedmethod, $scope.models.choiceVariant);

            return result;
        };

        $scope.valueValidator = function (data) {
            /**
             * Cases:
             * 1) less than max usable
             * 2) less than equal to cart
             * 3) should be a number
             * 4) 2 digit decimal place
             * 5) should be greater than min value
             */
            var constraint = $scope.getContext().constraint;

            if (!constraint || !constraint.maximum_usable) {
                // safe check to see if constraint is populated
                return true;
            }
            var rawValue = data || $scope.rewards && $scope.rewards.interstitialValue;
            var value = (0, _utils.toNumber)(rawValue);
            var maxUsable = (0, _utils.toNumber)(constraint.maximum_usable.value);
            $scope.minAllowed = (0, _utils.toNumber)(constraint.minimum_spend.value);
            var cartAmount = (0, _utils.toNumber)($scope.models.checkoutCart.purchase.amounts.total.amount, 2);
            var exists = value && maxUsable;
            var hasMax2DigitDecimal = /^\d+(\.\d{1,2})?$/i;
            var errorMap = [['default', !exists], ['default', isNaN(value)], ['default', !hasMax2DigitDecimal.test(rawValue)], ['minimum', value < $scope.minAllowed], ['moreThanAvailable', value > maxUsable && value <= cartAmount], ['moreThanPurchase', value > cartAmount]];
            var errorList = errorMap.find(function (testcase) {
                return testcase[1];
            });

            if (errorList) {
                // TODO: Make into debug or remove once rewards is stable.
                _logger.$logger.info('PayWithRewards_client_validation_error_' + errorList[0]);
            }
            $scope.form_error = errorList && errorList[0] || false;
            return !$scope.form_error;
        };

        $scope.useAmountContent = function () {
            /**
             * Final interstitial value to checkbox.
             *
             * cashback : currency -> currency
             * points : currency -> reward(currency)
             * miles : currency -> reward(currency)
             * statement-credit : currency -> currency
             */
            var ctx = $scope.getContext();
            var currency_symbol = (0, _squid.getCurrencySymbol)(ctx.currency_code);

            // inputType === 'currency' (cashback, chase)
            var rewardAmount = (0, _utils.toCommaSeparatedString)($scope.rewards.value, $scope.getContext({
                conversion_type: 'REWARDS_TO_AMOUNT'
            }));
            var currencyAmount = '';

            // inputType === 'rewards' (points, miles)
            if ((0, _utils.conversionDetails)(ctx.issuerData.rewardsType).inputType === 'rewards') {
                rewardAmount = (0, _utils.convert)('AMOUNT_TO_REWARDS', $scope.rewards.value, ctx, true);
                currencyAmount = (0, _utils.toCommaSeparatedString)($scope.rewards.value, $scope.getContext({
                    conversion_type: 'REWARDS_TO_AMOUNT'
                }));
            }

            return (0, _squid.$renderContent)('rewards.useAmount.' + ctx.issuerData.contentKey, {
                rewardAmount: rewardAmount,
                currency_symbol: currency_symbol,
                currencyAmount: currencyAmount
            });
        };

        $scope.formOutputContent = function () {
            var ctx = $scope.getContext();
            var rewardPoints = (0, _utils.convert)('AMOUNT_TO_REWARDS', $scope.rewards.interstitialValue, ctx, true);

            return (0, _squid.$renderContent)('rewards.formResultLabel.' + ctx.issuerData.contentKey, {
                rewardPoints: rewardPoints
            });
        };
    }]
});


_squid.$Component;

_squid.$renderContent;

_squid.getCurrencySymbol;

_squid.$util;

_logger.$logger;

_angular.$rootScope;

_angular.noop;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_choice.$ChoiceEligibility;

_factory.$RewardsCheckboxFactory;

_utils.toNumber;

_utils.toCommaSeparatedString;

_utils.getInitialRewardsValue;

_utils.convert;

_utils.conversionDetails;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-member-components/src/rewards-checkbox/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _utils = __webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/utils.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

// eslint-disable-line no-unused-vars

/**
 * TODO: Somehow try to move some of this constant
 * mapping logic to some facade layer.
 */
var REWARD_CODE_MAPPINGS = {
    'DLR': {
        issuerName: 'discover',
        rewardsType: 'cashback',
        contentKey: 'discover.cashback'
    },
    'MIL': {
        issuerName: 'discover',
        rewardsType: 'miles',
        contentKey: 'discover.miles'
    },
    'TYP': {
        issuerName: 'citi',
        rewardsType: 'points',
        contentKey: 'citi'
    },
    'LPTS': {
        issuerName: 'chase',
        rewardsType: 'statement-credit',
        contentKey: 'chase'
    },
    'WPTS': {
        issuerName: 'chase',
        rewardsType: 'statement-credit',
        contentKey: 'chase'
    },
    'USD': {
        issuerName: 'chase',
        rewardsType: 'statement-credit',
        contentKey: 'chase'
    },
    'MLS': {
        issuerName: 'chase',
        rewardsType: 'statement-credit',
        contentKey: 'chase'
    },
    'DEFAULT': {
        // This should never really be used.
        issuerName: 'default',
        rewardsType: 'points',
        contentKey: 'default'
    }
};

/**
 *  Given a rewards instrument
 *  Returns all ids and keys we need to link rewards
 *  to different plans and instruments
 *
 * @param {*} instrument
 * @returns
 */
var rewardsAssociatedIds = function rewardsAssociatedIds(instrument) {
    var rewardsPayload = instrument.rewards || {};
    var related_card = rewardsPayload && rewardsPayload.related_card;
    var cardID = related_card && related_card.id;
    var rewardsID = instrument.id;
    var planID = instrument.planId;

    return {
        rewardsID: rewardsID,
        cardID: cardID,
        planID: planID
    };
};

/**
 * Returns all issuer related info required to render
 * custom experience for different reward programs
 *
 * @param {*} instrument
 * @returns
 */
var issuerDetails = function issuerDetails(instrument) {
    var rewardsPayload = instrument.rewards || {};
    var available_incentive = rewardsPayload && rewardsPayload.available_incentive;
    var rewards_currency_code = available_incentive.rewards_code || '';
    var issuerData = available_incentive && REWARD_CODE_MAPPINGS[rewards_currency_code];
    var issuerName = issuerData.issuerName,
        rewardsType = issuerData.rewardsType,
        contentKey = issuerData.contentKey;

    var rewardPoints = available_incentive && available_incentive.value;
    var rewardMonetaryValue = available_incentive && available_incentive.monetary_value && available_incentive.monetary_value.value;

    // Convert strings to numeric values
    rewardPoints = (0, _utils.toNumber)(rewardPoints);
    rewardMonetaryValue = (0, _utils.toNumber)(rewardMonetaryValue);

    return {
        rewards_currency_code: rewards_currency_code,
        rewardPoints: rewardPoints,
        rewardMonetaryValue: rewardMonetaryValue,
        rewardsType: rewardsType,
        issuerName: issuerName,
        contentKey: contentKey
    };
};

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$RewardsCheckboxFactory', function () {

    var rewardsCache = {};
    var models = {};
    var cancelSessionWatcher = void 0; // holds the deactivator function

    var checkboxSelection = {
        planId: null,
        rewardsChosenPlan: null
    };

    var buildCache = function buildCache() {
        /**
         * TODO:
         * Consider developing a focus around fi as opposed to plans
         * once you proved stability in rewards move it out and expand to
         * all FI not just rewards. The case we need to confirm is plan refreshes.
         * 1) If we are starting a cache then how does cache management work with the
         * different plan refresh cases?
         * 2) How can we leverage the xo-models cache infrastructure ?
        */
        var isFeatureEnabled = (0, _squid.$feature)('payWithRewards');
        if (isFeatureEnabled && !cancelSessionWatcher) {
            cancelSessionWatcher = _squid.$event.on('checkoutSessionChange', function (event) {
                // For SNT in WPS there is a plan refresh upon RYI render.
                refreshCache();
            });
        }

        (0, _squid.$populate)(models, {
            checkoutSession: _checkout.$CheckoutSessionModel.instance(_angular.$rootScope.token)
        }).then(function () {
            var _models$checkoutSessi = models.checkoutSession.fundingOptions.instruments,
                instruments = _models$checkoutSessi === undefined ? [] : _models$checkoutSessi;


            if (isFeatureEnabled) {
                _squid.$util.forEach(instruments, function (instrument) {
                    var payload = {};

                    if (instrument.type === 'REWARDS') {
                        payload.rewardsAssociatedIds = rewardsAssociatedIds(instrument);
                        payload.issuerDetails = issuerDetails(instrument);
                        payload.rewardsPayload = instrument.rewards || {};
                        // TODO: DO we still need to hold on to raw payload ?
                        // move to store only whats needed approach
                        var cardID = payload.rewardsAssociatedIds.cardID; // set focus on card as opposed to rewards/plans

                        rewardsCache[cardID] = payload;
                        _logger.$logger.info('PayWithRewards_instrument_check', {
                            'fi_id': cardID
                        });
                    }
                });
            }
        })['finally'](function () {
            // instrumentation here
        });
    };

    var refreshCache = function refreshCache() {
        // TODO: Consider this when handling
        // plan refresh use case
        rewardsCache = {};
        buildCache();
    };

    var destroy = function destroy() {
        if (cancelSessionWatcher) {
            cancelSessionWatcher();
        }
    };

    /**
     * Checks to see if the current session
     * has any rewards FI in any plan.
     *
     * @returns Boolean
     */
    var rewardsFound = function rewardsFound() {
        return Object.keys(rewardsCache).length > 0;
    };

    /**
     * Returns a string representing rewards fi's
     * with issuer name.
     * Sample: "CC-T2RX5VBELRL7C_discover:CC-ZKQBGHWZQECYJ:chase"
     *
     * @returns String
     */
    var toString = function toString() {
        var result = '';
        _squid.$util.forEach(rewardsCache, function (instrument, instrument_id) {
            var issuerData = instrument.issuerDetails;
            var issuerName = issuerData.issuerName;
            if (instrument_id && issuerName) {
                result = result ? result + ':' + instrument_id + '_' + issuerName : instrument_id + '_' + issuerName;
            }
        });
        return result;
    };

    /**
     * Checks if the FI has a rewards
     * instrument attached
     *
     * @param {*} fi
     * @returns
     */
    var isRewardsFi = function isRewardsFi(fi) {
        // const isCard = fi.type === 'CARD';
        var result = Boolean(rewardsCache[fi.instrument_id]);

        return result;
    };

    /**
     * Checks if the primary FI associated
     * with the plan has rewards
     *
     * @param {*} plan
     * @returns
     */
    var isRewardsPlan = function isRewardsPlan(plan) {
        var fi = (0, _utils.getPrimaryFI)(plan);
        var isBalanceSelected = (0, _utils.isPayPalBalanceSelected)(plan);
        var isRewards = isRewardsFi(fi);
        // balance and rewards are incompatible
        // if balance then do not use rewards
        // Should we check for balance as part of isRewards check
        // or separate?

        return isRewards && !isBalanceSelected;
    };

    /**
     * Returns if the rewards has a changeable amount, based on the provided type
     */
    var isRewardsTypeChangeable = function isRewardsTypeChangeable(type) {
        return type !== 'statement-credit';
    };

    var getRewardDetails = function getRewardDetails(plan) {
        var fi = (0, _utils.getPrimaryFI)(plan);
        var result = isRewardsFi(fi) && rewardsCache[fi.instrument_id];

        return result;
    };

    var getRewardsPlanFromFi = function getRewardsPlanFromFi(fi) {
        var fiDetails = rewardsCache[fi.instrument_id] || {};
        var planID = fiDetails.rewardsAssociatedIds && fiDetails.rewardsAssociatedIds.planID;

        return (0, _utils.getPlanFromId)(planID);
    };

    var ifRewardsThenUpdatePlan = function ifRewardsThenUpdatePlan(currentPlanId, selectedmethod, checkoutSession) {

        // Given an Id
        // get plan object.
        // check if plan object contains rewards

        // ------------------------------------
        // -----> handle these before the plan comes into this function
        // check if plan is selected (2 cases)
        // 1st check if plan is user selected
        // --- We need this to give precedence to checkbox which wont trigger replan
        // 2nd check if plan is session selected
        // -- if we have a replan or initial plan already selecting rewards then honor it.
        // ------------------------------------
        var isRewardsChosen = selectedmethod ? selectedmethod.rewardsChosenPlan : // multiple FI selection
        checkboxSelection.rewardsChosenPlan; // single FI selection
        var selectedPlan = (0, _utils.getPlanFromId)(checkoutSession, selectedmethod ? selectedmethod.planId : currentPlanId);
        var rewardsEligible = isRewardsPlan(selectedPlan);

        if (!rewardsEligible) {
            return currentPlanId;
        }

        var result = (0, _utils.matchPlanFromConstraints)({
            checkoutSession: checkoutSession,
            instrumentId: (0, _utils.getInstrumentID)(selectedPlan),
            // For now, we never want balance with this method.
            balance: false,
            rewards: isRewardsChosen
        });

        return result && (0, _utils.getPlanID)(result);
    };

    var showCheckbox = function showCheckbox(plan, fiSelectionContext, choiceVariant) {
        var isChoiceVariant = Boolean(choiceVariant === '6');
        var isMultiFi = Boolean(plan && plan.primaryFs); // TODO: fails for selectFI use case
        var usingPayPalBalance = Boolean(plan && plan.secondaryFIs);
        var uiSelectedPlanId = plan && (0, _utils.getPlanID)(plan);
        var clickSelectedPlanId = fiSelectionContext && fiSelectionContext.planId;
        // Differentiating between uiSelection vs clickSelection to avoid the case
        // when this function gets triggered due to digest while the user has clicked
        // on a different fi. Do not show checkbox for this case. Would cause flickering.
        var isRewards = isRewardsPlan(plan);
        var disregardClickSelection = isChoiceVariant || !isMultiFi;
        var isSelected = uiSelectedPlanId && uiSelectedPlanId === clickSelectedPlanId || disregardClickSelection;

        var result = isSelected && isRewards && !usingPayPalBalance;
        return result;
    };

    /**
     * When session has balance and
     * fi has rewards then hide amount.
     * TODO: consider removing this after PAPS fix
     *
     * @param {*} fi
     * @returns
     */
    var hideAmount = function hideAmount(fi) {
        if (!fi) {
            return false;
        }
        var isRewards = isRewardsFi(fi);
        var _models$checkoutSessi2 = models.checkoutSession,
            checkoutSession = _models$checkoutSessi2 === undefined ? {} : _models$checkoutSessi2;
        var _checkoutSession$fund = checkoutSession.fundingOptions.instruments,
            instruments = _checkoutSession$fund === undefined ? [] : _checkoutSession$fund;

        var sessionHasBalance = instruments.some(function (instrument) {
            return instrument.type === 'BALANCE';
        });

        return isRewards && sessionHasBalance;
    };

    var setCheckboxSelectionForPlan = function setCheckboxSelectionForPlan(_ref) {
        var selected = _ref.selected,
            plan = _ref.plan,
            selectedmethod = _ref.selectedmethod,
            isReplan = _ref.isReplan;

        if (selectedmethod) {
            if (selected) {
                (0, _utils.setSelectedPlan)(plan, selectedmethod, isReplan);
            } else {
                (0, _utils.clearSelectedPlan)(plan, selectedmethod);
            }
        } else {
            var planId = (0, _utils.getPlanID)(plan);

            checkboxSelection.planId = planId;
            checkboxSelection.rewardsChosenPlan = selected ? planId : null;
        }
    };

    var getContentKeys = function getContentKeys(plan, rewardsPayload) {
        var fi = (0, _utils.getPrimaryFI)(plan);
        var last4Digits = fi && fi.lastDigits;
        var rewardsDetails = rewardsPayload || getRewardDetails(plan);
        var issuerData = rewardsDetails && rewardsDetails.issuerDetails || {};
        var currency_code = fi && fi.amount && fi.amount.currency_code;
        var rewardPoints = (0, _utils.toCommaSeparatedString)(issuerData.rewardPoints, {
            conversion_metadata: rewardsDetails.conversion_metadata,
            conversion_type: 'AMOUNT_TO_REWARDS',
            rewards_type: issuerData.rewardsType,
            currency_code: currency_code
        });
        var rewardMonetaryValue = (0, _utils.toCommaSeparatedString)(issuerData.rewardMonetaryValue, {
            conversion_metadata: rewardsDetails.conversion_metadata,
            conversion_type: 'REWARDS_TO_AMOUNT',
            rewards_type: issuerData.rewardsType,
            currency_code: currency_code
        });
        var currency_symbol = (0, _squid.getCurrencySymbol)(currency_code);
        var getString = function getString(key) {
            return (0, _squid.$renderContent)(key + '.' + issuerData.contentKey, {
                issuerName: issuerData.issuerName,
                last4Digits: last4Digits,
                rewardPoints: rewardPoints,
                rewardAmount: rewardMonetaryValue,
                currency_symbol: currency_symbol
            });
        };
        var map = {
            header: getString('rewards.header'),
            rewardsAvailble: getString('rewards.rewardsAvailble'),
            subText: getString('rewards.subText'),
            policy: getString('rewards.policy'),
            secondLineText: getString('rewards.secondLineText'),
            chargeAmount: getString('rewards.chargeAmount'),
            changeAmount: getString('rewards.changeAmount'),
            formInputLabel: getString('rewards.formInputLabel'),
            formResultLabel: getString('rewards.formResultLabel'),
            // TODO: use dynamic amount
            // useAmount:$renderContent(`rewards.useAmount.${issuerData.contentKey}`, {
            //     rewardAmount: '919191',
            //     currencyUnit: '$',
            //     currencyAmount: '9999'
            // }),
            enterValidAmount: (0, _squid.$renderContent)('rewards.enterValidAmount.default'),
            type: issuerData.rewardsType,
            overlayButton: (0, _squid.$renderContent)(isRewardsTypeChangeable(issuerData.rewardsType) ? 'common.save' : 'common.OK'),
            issuerName: issuerData.issuerName,
            value: {
                rewardPoints: rewardPoints, // Amount in rewards
                rewardAmount: rewardMonetaryValue // Amount in currency
            }
        };

        return map;
    };

    /**
     * Do a select call and an update call in sequence.
     * Consider batching this later
     *
     * @param {*} checkoutSession
     * @param {*} currency_code
     * @param {*} planID
     * @param {*} rewardsID
     * @param {*} value
     * @returns
     */
    var submitRewards = function submitRewards(checkoutSession, currency_code, planID, rewardsID, value) {
        var payload = {
            type: 'REWARDS',
            value: value,
            currency: currency_code,
            id: rewardsID
        };

        var errorHandler = function errorHandler(name, err, action, type) {
            // TODO: Get rid of this or discuss better handling with product
            // Do we really need 2 handlers? once we have decided the kind of errors
            // that get thrown then pick one type of handler contingency or error

            checkoutSession.message = {
                type: 'error',
                msgKeys: ['paymentMethod.cycoSsotWarning']
            };
            _logger.$logger.info('pay_with_rewards', {
                'from': 'UPDATE_REWARDS_INTERSTITIAL',
                'to': 'process_planning_response',
                'int_error_code': err,
                'int_error_description': action + '-' + type,
                'error_source': 'paymentapiplatformserv'
            });
            return _squid.$promise.reject(err);
        };

        return checkoutSession.fundingOptions.action('select', {
            resultModel: checkoutSession,
            data: {
                planId: planID
            },
            success: function success(result) {
                checkoutSession.populate(result);
            },
            contingencies: {
                DEFAULT: function DEFAULT(name, err) {
                    return errorHandler(name, err, 'select', 'contingency');
                }
            },
            error: function error(name, err) {
                return errorHandler(name, err, 'select', 'error');
            }
        }).then(function () {
            return checkoutSession.fundingOptions.action('patch', {
                resultModel: checkoutSession,
                data: payload,
                success: function success(result) {
                    checkoutSession.message = {
                        type: 'success',
                        msgKeys: ['paymentMethod.paymentMethodUpdated']
                    };
                },
                contingencies: {
                    DEFAULT: function DEFAULT(name, err) {
                        return errorHandler(name, err, 'patch', 'contingency');
                    }
                },
                error: function error(name, err) {
                    return errorHandler(name, err, 'patch', 'error');
                }

            });
        });
    };

    return {
        buildCache: buildCache,
        refreshCache: refreshCache,
        destroy: destroy,
        rewardsFound: rewardsFound,
        toString: toString,
        isRewardsPlan: isRewardsPlan,
        isRewardsFi: isRewardsFi,
        isRewardsTypeChangeable: isRewardsTypeChangeable,
        getRewardsPlanFromFi: getRewardsPlanFromFi,
        getRewardDetails: getRewardDetails,
        getContentKeys: getContentKeys,
        showCheckbox: showCheckbox,
        hideAmount: hideAmount,
        setCheckboxSelectionForPlan: setCheckboxSelectionForPlan,
        ifRewardsThenUpdatePlan: ifRewardsThenUpdatePlan,
        submitRewards: submitRewards
    };
});

_squid.$util;

_squid.$renderContent;

_squid.$populate;

_squid.$feature;

_squid.$promise;

_squid.$event;

_squid.getCurrencySymbol;

_angular.$rootScope;

_checkout.$CheckoutSessionModel;

_utils.getPlanID;

_utils.getInstrumentID;

_utils.getPrimaryFI;

_utils.getPlanFromId;

_utils.toNumber;

_utils.toCommaSeparatedString;

_utils.isPayPalBalanceSelected;

_utils.setSelectedPlan;

_utils.clearSelectedPlan;

_utils.matchPlanFromConstraints;

_logger.$logger;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-member-components/src/rewards-checkbox", "../node_modules/xo-member-components/src/rewards-checkbox/factory.js"))

/***/ }),

/***/ "../node_modules/xo-member-components/src/rewards-checkbox/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/rewards-checkbox/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"showCheckbox()\" class=\"sCheckbox checkbox\" content>\n    <div class=\"postSelection checkboxPayWithRewards\" ng-class=\"{cardart: cardart, singleFi: singleFi}\">\n        <input type=\"checkbox\" ng-model=\"state.selected\" name=\"rewardsSelection\" id=\"rewardsSelection\" ng-change=\"actions.toggle()\" data-test-id=\"rewards-checkbox\">\n        <label for=\"rewardsSelection\">\n            <span ng-bind-html=\"useAmountContent()\"></span>\n            <a ng-click=\"actions.open()\" link-button class=\"changeAmount\" data-test-id=\"rewards-change-amount\">\n                {{contentkeys.changeAmount}}\n            </a>\n        </label>\n        <div class=\"remainderDisclosure\" ng-if=\"(state.selected || done)\">\n            {{contentkeys.chargeAmount}}\n        </div>\n    </div>\n    <section class=\"rewards-overlay\" ng-class=\"{ 'full-overlay': fullOverlay }\">\n        <xo-modal show=\"showOverlay\"\n                on-close=\"actions.close\"\n                show-close-button=\"true\"\n                enable-close-on-escape=\"true\"\n                override-default-container=\"true\">\n            <div id=\"rewardsInterstitial\" data-test-id=\"rewards-overlay\">\n                <span ng-class=\"{chasePay: rewards.type==='statement-credit'}\">\n                    <h2 class=\"rewardsHeader alpha\">\n                        <span ng-bind-html=\"contentkeys.header\"></span>\n                    </h2>\n                    <div class=\"rewardsAvailble\">\n                        <span ng-bind-html=\"contentkeys.rewardsAvailble\"></span>\n                    </div>\n                </span>\n\n                <div class=\"rewardsForms\">\n                    <div ng-if=\"rewards.type && rewards.type!=='statement-credit'\"\n                        class=\"{{rewards.type}}\">\n                        <!-- TODO: find a better way instead of mapping type directly to class -->\n                        <!-- ng-class=\"{{rewards.type}}\" is not class=\"points\" -->\n\n                        <span class='leftSide'>\n                            <span class='currencyUnit' ng-bind-html=\"contentkeys.formInputLabel\"></span>\n                            <input class='Field' value=\"\"\n                                ng-model=\"rewards.interstitialValue\"\n                                ui-validate=\"'valueValidator($value)'\"\n                                data-test-id=\"rewards-change-input\"\n                                />\n                        </span>\n                        <span class='rightSide'>\n                            <span class='equalSign' ng-if=\"rewards.type!=='cashback'\">=</span>\n                            <span class='rewardUnit' ng-bind-html=\"formOutputContent()\"></span>\n                        </span>\n                    </div>\n                    <div class=\"formText\"\n                         ng-class=\"{subText: rewards.type!=='', fullText: rewards.type===''}\">\n                        <div ng-class=\"{formError: form_error}\"\n                            ng-switch=\"form_error\">\n                            <div ng-switch-when=\"false\"> {{contentkeys.subText}}</div>\n                            <div ng-switch-when=\"default\"> {{content('rewards.enterValidAmount.default')}}</div>\n                            <div ng-switch-when=\"minimum\"> {{content('rewards.enterValidAmount.minimum', { value: minAllowed })}}</div>\n                            <div ng-switch-when=\"moreThanAvailable\"> {{content('rewards.enterValidAmount.moreThanAvailable')}}</div>\n                            <div ng-switch-when=\"moreThanPurchase\"> {{content('rewards.enterValidAmount.moreThanPurchase')}}</div>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"rewardsFooter\">\n                    <div class=\"disclaimer\">\n                        <span ng-bind-html=\"contentkeys.policy\"></span>\n                    </div>\n                    <div id=\"button\" class=\"buttons submit\">\n                        <input track-submit\n                            type=\"submit\"\n                            ng-value=\"contentkeys.overlayButton\"\n                            class=\"btn full confirmButton continueButton\"\n                            ng-disabled=\"form_error\"\n                            ng-click=\"actions.submit()\"\n                            data-test-id=\"rewards-change-submit\"\n                            />\n                    </div>\n                </div>\n            </div>\n        </xo-modal>\n    </section>\n</div>\n    \n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/rewards-checkbox/utils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.matchPlanFromConstraints = exports.getSelectedPlan = exports.isPayPalBalanceSelected = exports.getInitialRewardsValue = exports.getPlanFromId = exports.getPrimaryFI = exports.clearSelectedPlan = exports.setSelectedPlan = exports.isPayNow = exports.convert = exports.convertValue = exports.toCommaSeparatedString = exports.toNumber = exports.sanitizeNumber = exports.conversionDetails = exports.getInstrumentID = exports.getPlanID = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

// eslint-disable-line no-unused-vars

/**
 *  fundingOptions has plan.planId
 *  checkoutSession has plan.id
 *
 * @param {*} plan
 */
var getPlanID = exports.getPlanID = function getPlanID(plan) {
    if (!plan) {
        return plan;
    }
    return plan.planId || plan.id;
};

/**
 * getInstrumentId
 * @param {Object} plan Any type of plan
 * @retursn {String} Instrument ID of primary fs
 */
var getInstrumentID = exports.getInstrumentID = function getInstrumentID(plan) {
    return plan.sources ? plan.sources[plan.sources.length - 1].instrument_id : plan.primaryFs.id;
};

/**
 * Returns an object containing input
 * and output details about the conversion
 *
 * @param {*} rewards_type
 * @param {*} conversion_type
 * @returns {}
 */
var conversionDetails = exports.conversionDetails = function conversionDetails(rewards_type, conversion_type) {
    var result = {};

    if (rewards_type) {
        var rewardsInCurrency = rewards_type === 'cashback'
        // TODO: Consider replacing rewardsInCurrency with monetary flag from PSS.
        // As of now not receiving it from PAPS.
        ;

        result.inputType = rewardsInCurrency ? 'currency' : 'rewards';
        if (conversion_type) {
            var useCurrency = conversion_type === 'REWARDS_TO_AMOUNT' || rewardsInCurrency && conversion_type === 'AMOUNT_TO_REWARDS';

            result.outputType = useCurrency ? 'currency' : 'rewards';
            result.skipConversion = result.inputType === result.outputType;
        }
    }
    return result;
};

/**
 * sanatizes undefined, NAN numbers
 * does rounding and limits
 *
 * @param {*} value
 * @param {*} limit
 * @param {*} rounding
 * @returns
 */
var sanitizeNumber = exports.sanitizeNumber = function sanitizeNumber(value, limit, rounding) {
    var isString = value && typeof value === 'string';
    var hasComma = isString && value.indexOf(',') >= 0;

    if (!value || hasComma) {
        /** 
         * Avoid accidental double sanitization
         * TODO: figure out how to prevent double 
         * sanitization in the first place
        */
        return !value ? '0' : value;
    }

    var num = Number(value);
    num = isNaN(num) || !num ? 0 : num;
    num = rounding === 1 ? Math.round(num) : num;
    num = limit ? num.toFixed(limit) : num;
    num = isString ? num : Number(num);
    /** 
     * if you get a string return a string
     * required for 1.20 or decimal/currency use case
     * since toFixed return a string
    */

    return num;
};

/**
 * Given a string return a number
 *
 * @param {*} str
 * @param {number} [limit=2]
 * @param {number} [rounding=0]
 * @returns
 */
var toNumber = exports.toNumber = function toNumber(value) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var rounding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    var num = typeof value === 'string' ? parseFloat(value) : value;

    return sanitizeNumber(num, limit, rounding);
};

/**
 * extract the required decimal precision from rewards
 *
 * @param {*} conversion_metadata
 * @param {*} key
 * @returns
 */
var getPrecision = function getPrecision(conversion_metadata, key) {
    var decimal_precision = {};

    _squid.$util.forEach(conversion_metadata.decimal_precisions, function (ele) {
        decimal_precision[ele.conversion_type] = toNumber(ele.length, 0);
    });
    return decimal_precision[key] || 0;
};

/**
 * extract the required rounding details from rewards
 *
 * @param {*} conversion_metadata
 * @param {*} key
 * @returns
 */
var getRounding = function getRounding(conversion_metadata, key) {
    var rounding_modes = {};
    var mapper = {
        'UNNECESSARY': 0,
        'HALF_UP': 1
        // More may be added over time
    };
    _squid.$util.forEach(conversion_metadata.rounding_modes, function (ele) {
        rounding_modes[ele.conversion_type] = ele.value;
    });
    var value = rounding_modes[key] || 'UNNECESSARY';

    return mapper[value];
};

var toCommaSeparatedString = exports.toCommaSeparatedString = function toCommaSeparatedString(value) {
    var ctx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!value) {
        return '';
    }
    var currency_code = ctx.currency_code,
        _ctx$conversion_metad = ctx.conversion_metadata,
        conversion_metadata = _ctx$conversion_metad === undefined ? {} : _ctx$conversion_metad,
        conversion_type = ctx.conversion_type,
        rewards_type = ctx.rewards_type;

    var locale_code = _squid.$locale.lang + '-' + _squid.$locale.country;
    var useCurrency = conversionDetails(rewards_type, conversion_type).outputType === 'currency';
    var precision = getPrecision(conversion_metadata, conversion_type);
    var rounding = getRounding(conversion_metadata, conversion_type);
    var num = toNumber(value, '', rounding);
    var result = '';

    if (useCurrency) {
        result = (0, _squid.formatCurrency)(value, currency_code, false, 'AmountOnlyStyle');
        result = sanitizeNumber(result, 2, 0);
    } else {
        result = num.toLocaleString(locale_code, {
            useGrouping: true, // may only need for certain countries.
            minimumFractionDigits: precision
        });
        result = sanitizeNumber(result);
    }

    return result;
};

/**
 * Conversion math logic.
 * use precision and rounding from the rewards payload
 * to preform conversion to & from rewards
 *
 * @param {*} amount
 * @param {*} conversion_type
 * @param {*} conversionData
 * @returns
 */
var convertValue = exports.convertValue = function convertValue(amount, conversion_type, conversionData) {
    var result = '';

    if (!amount || !conversion_type || !conversionData) {
        return result;
    }
    var precision = getPrecision(conversionData, conversion_type);
    var rounding = getRounding(conversionData, conversion_type);
    // Use 4 decimal places or more for factor multiplication.
    // We need this to maintain decimal precision during calculation.
    var factor = toNumber(conversionData.conversion_factor, 4);

    // convert from rewards to points and vice-versa
    result = conversion_type === 'AMOUNT_TO_REWARDS' ? amount * 1.0 / factor : amount * factor;
    // Choose final precision based on downstream requirements
    var res = toNumber(result, precision, rounding);

    return res;
};

/**
 * Conversion business logic.
 * It decides when to convert and when not to and
 * finally returns the appropriate formated value.
 *
 * @param {*} conversion_type
 * @param {*} amount
 * @param {*} [ctx={}]
 * @returns
 */
var convert = exports.convert = function convert(conversion_type, amount) {
    var ctx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var force = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    if (!amount || !conversion_type) {
        return '';
    }
    var _ctx$conversion_metad2 = ctx.conversion_metadata,
        conversion_metadata = _ctx$conversion_metad2 === undefined ? {} : _ctx$conversion_metad2,
        _ctx$issuerData = ctx.issuerData,
        issuerData = _ctx$issuerData === undefined ? {} : _ctx$issuerData,
        currency_code = ctx.currency_code;

    var skip = !force && conversionDetails(issuerData.rewardsType, conversion_type).skipConversion;
    var converted = skip ? toNumber(amount) : convertValue(amount, conversion_type, conversion_metadata);

    converted = toCommaSeparatedString(converted, {
        rewards_type: issuerData.rewardsType,
        conversion_metadata: conversion_metadata,
        conversion_type: conversion_type,
        currency_code: currency_code
    });
    return converted;
};

/**
 * Checks for paynow vs continue usecase
 * TODO: expand and move logic to $CheckoutAppDataModel
 *
 * @param {*} checkoutAppData
 * @returns Boolean
 */
var isPayNow = exports.isPayNow = function isPayNow(checkoutAppData) {
    var isWPS = checkoutAppData.is_wps_flow();
    var userAction = checkoutAppData.useraction();

    return !!(!isWPS && userAction === 'commit');
};

/**
 * UI related operations to be performed on select.
 *
 * @param {*} plan
 * @param {*} selectedmethod
 * @param {*} isReplan
 */
var setSelectedPlan = exports.setSelectedPlan = function setSelectedPlan(plan, selectedmethod, isReplan) {
    // use applyAsync in order to wait for all plans to be updated and etc.
    // Wait for the radio buttons to have all the latest plan ids in its scope
    if (selectedmethod) {
        _angular.$rootScope.$applyAsync(function () {
            selectedmethod.planId = getPlanID(plan); // force UI selected method to use non-reward plan.
            selectedmethod.index = isReplan ? 0 : selectedmethod.index; // reset index on replan
            selectedmethod.rewardsChosenPlan = getPlanID(plan);
        });
    }
};

/**
 * UI related operations to be performed on de-select.
 *
 * @param {*} plan
 * @param {*} selectedmethod
 */
var clearSelectedPlan = exports.clearSelectedPlan = function clearSelectedPlan(plan, selectedmethod) {
    var hasPlanSelected = selectedmethod && selectedmethod.rewardsChosenPlan === getPlanID(plan);

    if (hasPlanSelected) {
        delete selectedmethod.rewardsChosenPlan;
    }
};

/**
 * Returns the primaryFI for multi-fi use case
 * else returns the first FI for single FI use case
 *
 * @param {*} plan
 * @returns {*} fiPayload
 */
var getPrimaryFI = exports.getPrimaryFI = function getPrimaryFI(plan) {
    // TODO: return '' instead of {}
    if (!plan || !getPlanID(plan)) {
        return {};
    }
    var firstPlanFi = plan && plan.sources && plan.sources[plan.sources.length - 1];
    var fi = plan && plan.primaryFs || firstPlanFi || {};

    fi.instrument_id = fi.instrument_id || fi.id;
    return fi;
};

/**
 *  Given a planId it returns a complete plan object
 *
 * @param {*} checkoutSession
 * @param {*} planId
 * @returns
 */
var getPlanFromId = exports.getPlanFromId = function getPlanFromId(checkoutSession, planId) {
    var matchingPlans = _squid.$util.filter(checkoutSession.fundingOptions.plans, function (plan) {
        if (getPlanID(plan) === planId) {
            return plan;
        }
    });

    return matchingPlans && matchingPlans.length > 0 ? matchingPlans[0] : '';
};

/**
 * Returns the initial value to use considering
 * cart amount and rewards availability
 *
 * @param {*} models
 * @param {*} rewardsPayload
 * @returns
 */
var getInitialRewardsValue = exports.getInitialRewardsValue = function getInitialRewardsValue(models, rewardsPayload) {
    // TODO: Consider relying only on PAPS amount for initial value.
    // It would help with page refresh use case.
    var constraint = rewardsPayload.rewards_constraint;
    var grossTotal = toNumber(models.checkoutCart.purchase.amounts.total.amount, 2);
    if (!constraint.maximum_usable) {
        return grossTotal;
    }
    var maximumUsuableRewards = toNumber(constraint.maximum_usable.value);
    var initialValue = grossTotal < maximumUsuableRewards ? grossTotal : maximumUsuableRewards;

    return initialValue;
};

/**
 *  Checks if the plan has PayPal balance in it
 *
 * @param {*} plan
 */
var isPayPalBalanceSelected = exports.isPayPalBalanceSelected = function isPayPalBalanceSelected() {
    var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // TODO: should default initialize to {} or error handle ?
    var sources = plan.sources || plan.secondaryFIs || [];

    return sources.some(function (source) {
        return source.type === 'BALANCE';
    });
};

/**
 * Return the current selected plan id.
 * Prioritize clickSelectedPlanID
 * over sessionSelectedPlanID
 *
 * @param {*} selectedmethod
 * @param {*} checkoutSession
 * @returns {*} planID
 */
var getSelectedPlan = exports.getSelectedPlan = function getSelectedPlan(selectedmethod, checkoutSession) {
    var clickSelectedPlanID = selectedmethod && selectedmethod.planId;
    var sessionSelectedPlan = checkoutSession && checkoutSession.plan || {};
    var sessionSelectedPlanID = getPlanID(sessionSelectedPlan);
    var selectionID = selectedmethod ? clickSelectedPlanID // Radio checkbox selection
    : sessionSelectedPlanID; // selectFI use-case, session selection

    return selectionID;
};

/**
 * Given some contraints and a checkoutSession, return the plan that matches exactly
 * TODO: HANDLE BALANCE PROPERLY
 * @param {String} instrumentId
 * @param {String} balance The currency code of the balance to be used
 * @param {Boolean} rewards Whether to use the rewards plan or not
 * @returns {String} planId of the plan to select
 */
var matchPlanFromConstraints = exports.matchPlanFromConstraints = function matchPlanFromConstraints(_ref) {
    var instrumentId = _ref.instrumentId,
        balance = _ref.balance,
        rewards = _ref.rewards,
        checkoutSession = _ref.checkoutSession;

    return checkoutSession.get('fundingOptions.plans', []).find(function (plan) {
        var idMatches = plan.primaryFs.id === instrumentId;
        var planHasBalance = plan.secondaryFIs && plan.secondaryFIs.length;
        var balanceMatches = balance && planHasBalance || !balance && !planHasBalance;
        var rewardsMatches = rewards && plan.rewards || !rewards && !plan.rewards;

        if (!idMatches || !balanceMatches || !rewardsMatches) {
            return false;
        }

        return plan;
    });
};

_angular.$rootScope;

_squid.$util;

_squid.$locale;

_squid.formatCurrency;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/add-shipping/directive.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/xo-member-components/src/select-shipping/shipping-address/directive.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/select-shipping/add-shipping/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddShipping', function () {
    return {
        template: _template2['default'],
        scope: {
            auth: '=?',
            token: '=?',
            doneFn: '=?',
            sidebar: '=?',
            update: '=?',
            renderBillingAddCheckbox: '=?',
            shippingChangeFeature: '=?',
            backUri: '=?'
        },
        controller: function controller() {}
    };
});

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/add-shipping/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$AddShippingRoute = undefined;

__webpack_require__("../node_modules/xo-member-components/src/select-shipping/add-shipping/directive.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-address-components/src/address-normalization/route.js");

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/select-shipping/shipping-address/directive.js");

var $AddShippingRoute = exports.$AddShippingRoute = _squid.$ComponentRoute.extend('$AddShippingRoute', {
    name: 'addShipping',
    directive: 'xo-add-shipping',
    titleContent: 'addShipping.addAddress',
    trackingData: {
        fptiState: 'add_shipping',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-shipping-address',
                'pagename2': '%::fullpage-add-shipping-address:member:hermes:tray',
                'version': 'member:%:tray'
            }
        }
    },
    loginRequired: true,
    children: [{
        name: '$AddressNormalizationRoute',
        attributes: {
            id: 'token',
            sidebar: 'sidebar',
            address: 'address',
            'done-fn': 'uponNormalization'
        }
    }]
});

angular.value("$AddShippingRoute", $AddShippingRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/add-shipping/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-shipping-address token=\"token\" done-fn=\"doneFn\" sidebar=\"sidebar\" shipping-change-feature=\"shippingChangeFeature\" render-billing-add-checkbox=\"renderBillingAddCheckbox\" back-uri=\"backUri\" done-uri=\"backUri\"></xo-shipping-address>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/delete-shipping/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

__webpack_require__("../node_modules/xo-address-components/src/address-display/directive.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-tray-height/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/select-shipping/delete-shipping/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoDeleteShipping', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            sidebar: '=?'
        },
        controller: ['$scope', function ($scope) {
            var contingencyMapping = {
                RISK_CHECK_FAILED: 'deleteShipping.genericError',
                ADDRESS_ALREADY_REMOVED: 'deleteShipping.genericError',
                ADDRESS_CANNOT_REMOVE_PRIMARY: 'deleteShipping.primaryOrBillingAddress',
                ADDRESS_CANNOT_REMOVE_BILLING: 'deleteShipping.primaryOrBillingAddress',
                ADDRESS_CANNOT_REMOVE_SELECTED: 'deleteShipping.selectedAddress',
                ACCOUNT_NEGATIVE_BALANCE: 'deleteShipping.genericError',
                ADDRESS_CANNOT_REMOVE: 'deleteShipping.genericError'
            };

            function isPrimaryOrSelected(address) {
                return address.primary_address || address.default_address;
            }

            function removeAddress(address) {
                $('#deleteShipping .address' + address.idx).addClass('collapse');
                (0, _angular.$timeout)(function () {
                    $scope.checkoutShippingAddresses.addresses = $scope.checkoutShippingAddresses.addresses.filter(function (item) {
                        return item.id !== address.id;
                    });
                    $scope.$broadcast('addressUpdated');
                }, 600);
            }

            (0, _squid.$populate)($scope, {
                checkoutShippingAddresses: _index.$CheckoutShippingAddressesModel.instance($scope.token)
            }).then(function () {
                $scope.checkoutShippingAddresses.addresses.forEach(function (address, index) {
                    address.showDelete = address.isDeletable = !isPrimaryOrSelected(address);
                    address.idx = index;
                });
                $scope.$broadcast('addressUpdated');
            });

            $scope.backUrl = 'checkout.review.sidebar.shipping';

            // Return on modal cancel
            $scope.goBack = function () {
                _uiRouter.$state.go($scope.backUrl);
            };

            // Needed the three variables for animating buttons slide in/out
            $scope.onDelete = function (address) {
                address.showConfirm = true;
                $scope.checkoutShippingAddresses.addresses.forEach(function (item) {
                    if (item.deleteClicked) {
                        $('#deleteShipping .address' + item.idx + ' .address').removeClass('slide');
                        $('#deleteShipping .address' + item.idx + ' .confirm').removeClass('slidein');
                        item.showDelete = true;
                        (0, _angular.$timeout)(function () {
                            item.deleteClicked = false;
                            item.showConfirm = false;
                            $('#deleteShipping .address' + item.idx + ' .delete:not(.confirm)').removeClass('slideOut');
                        }, 500);
                    }
                });

                address.deleteClicked = true;
                $('#deleteShipping .address' + address.idx + ' .delete:not(.confirm)').addClass('slideOut');
                (0, _angular.$timeout)(function () {
                    $('#deleteShipping .address' + address.idx + ' .confirm').addClass('slidein');
                    $('#deleteShipping .address' + address.idx + ' .address').addClass('slide');
                    address.showDelete = false;
                });
                // Focus the confirm link when it comes into view after the css animation
                (0, _angular.$timeout)(function () {
                    $('#deleteShipping .address' + address.idx + ' .confirmBtn').focus();
                }, 500);
            };

            $scope.showDelete = function (address) {
                return address.isDeletable && address.showDelete;
            };

            $scope.showConfirmDelete = function (address) {
                return address.isDeletable && address.showConfirm;
            };

            $scope.showInfoMsgIcon = function (address) {
                return isPrimaryOrSelected(address);
            };

            $scope.toggleInfoMessage = function (address) {
                if (address.default_address) {
                    address.contingencyInfoMsgKey = contingencyMapping.ADDRESS_CANNOT_REMOVE_SELECTED;
                } else if (address.primary_address) {
                    address.contingencyInfoMsgKey = contingencyMapping.ADDRESS_CANNOT_REMOVE_PRIMARY;
                }
                // Toggle the info message
                (0, _angular.$timeout)(function () {
                    var msg = angular.element('#deleteShipping .address' + address.idx + ' .msg-inline');
                    // eslint-disable-next-line no-unused-expressions
                    if (msg.hasClass('expand')) {
                        msg.removeClass('expand');
                        address.contingencyInfoMsgKey = '';
                    } else {
                        msg.addClass('expand');
                    }
                });
            };

            $scope.onConfirmDelete = function (address) {
                return address.action('delete', {
                    success: function success() {
                        return removeAddress(address);
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(name) {
                            if (name === 'ADDRESS_ALREADY_REMOVED') {
                                removeAddress(address);
                                return;
                            }

                            address.isDeletable = false;
                            address.contingencyErrorMsgKey = contingencyMapping[name] || contingencyMapping.ADDRESS_CANNOT_REMOVE;
                            $('#deleteShipping .address' + address.idx + ' .address').removeClass('slide');
                            $('#deleteShipping .address' + address.idx + ' .address').addClass('slideFast');
                            (0, _angular.$timeout)(function () {
                                $('#deleteShipping .address' + address.idx + ' .msg-inline').addClass('expand');
                            }, 500);
                        }
                    }
                });
            };

            // Provide watch value for modal-box and select-box to recalculate keyboard behavior based on number of infoMsgIcons and confirmLinks
            $scope.numModalElements = function () {
                if (!$scope.checkoutShippingAddresses.addresses) {
                    return 0;
                }
                // Track messages by index, if they have flags active, seeing which flags they have active
                return $scope.checkoutShippingAddresses.addresses.reduce(function (sum, address, index) {
                    var item = $scope.showInfoMsgIcon(address) || $scope.showConfirmDelete(address) ? index + 1 : 0;

                    return sum + item;
                }, 0);
            };
        }]
    };
});

_angular.$timeout;

_squid.$populate;

_uiRouter.$state;

_index.$CheckoutShippingAddressesModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/delete-shipping/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$DeleteShippingRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-member-components/src/select-shipping/delete-shipping/directive.js");

var $DeleteShippingRoute = exports.$DeleteShippingRoute = _squid.$ComponentRoute.extend('$DeleteShippingRoute', {
    name: 'deleteShipping',
    directive: 'xo-delete-shipping',
    titleContent: 'asideHeader.deleteShipping',
    trackingData: {
        fptiState: 'delete_shipping',
        buzname: {
            'fullpage': {
                'pagename': '%::delete_shipping',
                'pagename2': '%::delete_shipping:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    loginRequired: true,
    children: []
});

angular.value("$DeleteShippingRoute", $DeleteShippingRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/delete-shipping/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-class=\"{'aside': sidebar, 'fullpage': !sidebar}\" id=\"deleteShipping\" modal-box=\"numModalElements()\" modal-cancel=\"goBack()\">\n        <xo-aside-header heading='asideHeader.deleteShipping' back-url=\"{{backUrl}}\"></xo-aside-header>\n\n        <div class=\"asideContent showAll\" xo-tray-height content>\n            <ul class=\"items\" focus-when focus-refresh-on=\"'addressUpdated'\">\n                <li ng-repeat=\"address in checkoutShippingAddresses.addresses track by $index\" role=\"presentation\" class=\"item address{{address.idx}}\">\n                    <div class=\"itemInner\">\n                        <div class=\"address\" ng-class=\"{'notDeletable': !address.isDeletable}\">\n                            <span class=\"display fullName\">{{address.recipient_name}}</span>\n                            <xo-address-display address=address country-code=countryCode show-preferred=\"true\"></xo-address-display>\n                        </div>\n                        <div>\n                            <span class=\"msgIcon\"\n                               ng-if=\"showInfoMsgIcon(address)\"\n                               ng-click=\"toggleInfoMessage(address)\"\n                               aria-label=\"{{'More Info for ' + address.line1 +'...'}}\"\n                               aria-expanded=\"{{address.contingencyInfoMsgKey ? true : false}}\">\n                            </span>\n                        </div>\n                        <div ng-if=\"address.isDeletable\">\n                            <div class=\"delete\" ng-if=\"showDelete(address)\">\n                                <a track-link=\"address_delete\"\n                                   href=\"\"\n                                   ng-click=\"onDelete(address)\"\n                                   class=\"deleteBtn\"\n                                   aria-label=\"{{content('deleteShipping.delete') +' address: '+ address.line1 +'...'}}\">\n                                    <span>{{content('deleteShipping.delete')}}</span>\n                                </a>\n                            </div>\n                            <div class=\"delete confirm\" ng-if=\"showConfirmDelete(address)\">\n                                <a track-link=\"address_delete_confirm\"\n                                   href=\"\" ng-click=\"onConfirmDelete(address)\"\n                                   class=\"confirmBtn focusableIcon\"\n                                   aria-label=\"{{content('deleteShipping.confirm') +' address delete: '+ address.line1 +'...'}}\">\n                                    <span>{{content('deleteShipping.confirm')}}</span>\n                                </a>\n                            </div>\n                        </div>\n                        <div class=\"msg-inline\" ng-if=\"address.contingencyInfoMsgKey\">\n                            <div class=\"msg-inlineInner\" tabindex=\"-1\" focus-when=\"address.contingencyInfoMsgKey\">\n                                <span>{{content(address.contingencyInfoMsgKey)}}</span>\n                            </div>\n                        </div>\n                        <div class=\"msg-inline msg-error\" ng-if=\"address.contingencyErrorMsgKey\">\n                            <div class=\"msg-inlineInner\" tabindex=\"-1\" focus-when=\"address.contingencyErrorMsgKey\">\n                                <span class=\"icon\"></span>\n                                <div class=\"content\">{{content(address.contingencyErrorMsgKey)}}</div>\n                            </div>\n                        </div>\n                    </div>\n                </li>\n            </ul>\n        </div>\n    </div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/xo-member-components/src/select-shipping/select-shipping/directive.js"), __webpack_require__("../node_modules/xo-member-components/src/select-shipping/add-shipping/directive.js"), __webpack_require__("../node_modules/xo-member-components/src/select-shipping/delete-shipping/directive.js"), __webpack_require__("../node_modules/xo-member-components/src/select-shipping/update-shipping/directive.js"), __webpack_require__("../node_modules/xo-member-components/src/select-shipping/shipping-address/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/select-shipping/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-address-components/src/address-display/directive.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-tray-height/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/select-shipping/select-shipping/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoSelectShipping', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            doneFn: '=?',
            backUri: '=?',
            shippingChangeFeature: '=?'
        },
        controller: ['$scope', function ($scope) {
            (0, _squid.$populate)($scope, {
                checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token),
                checkoutSession: _index.$CheckoutSessionModel.instance($scope.token),
                checkoutShippingAddresses: _index.$CheckoutShippingAddressesModel.create($scope.token)
            }).then(function () {
                // Do not remove error message in review page when user does not change shipping address
                if (!($scope.checkoutSession.get('message.type') === 'error')) {
                    $scope.checkoutSession.message = null;
                }
                $scope.deleteShipping = function () {
                    if ($scope.backUri === 'checkout.shipTo') {
                        return false;
                    }
                    return $scope.checkoutShippingAddresses.addresses.some(function (address) {
                        return !(address.primary_address || address.default_address);
                    });
                };
            });

            $scope.onSelect = function (address) {
                if (!address.disable_for_transaction) {
                    address.action('select', {
                        resultModel: $scope.checkoutSession,
                        success: function success(result) {
                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['smallToolTip.addressUpdated']
                            };
                            $scope.checkoutShippingAddresses.invalidate();

                            if ($scope.shippingChangeFeature && $scope.shippingChangeFeature.callOnShippingChange) {
                                $scope.shippingChangeFeature.callOnShippingChange(function () {
                                    $scope.doneFn(address);
                                });
                            } else {
                                $scope.doneFn(address);
                            }
                        }
                    });
                }
            };

            $scope.locale = _squid.$locale;
            $scope.addLink = function () {
                if ($scope.backUri === 'checkout.shipTo') {
                    return 'checkout.shipTo.sidebar.addShipping';
                }
                return 'checkout.review.sidebar.addShipping';
            };

            // Construct message object for block non-domestic shipping alert
            var merchantCountry = $scope.checkoutAppData.get('merchant.merchant_country', 'US');
            var countryName = (0, _squid.$renderContent)('countryList.' + merchantCountry);
            var infoMessage = (0, _squid.$renderContent)('selectShipping.blockNonDomesticShippingInfo', {
                shippingCountry: countryName
            });

            $scope.blkNonDomesticShippingMsg = {
                msgs: [infoMessage],
                type: 'desc'
            };
        }]
    };
});

_squid.$locale;

_squid.$populate;

_squid.$renderContent;

_index.$CheckoutAppDataModel;

_index.$CheckoutSessionModel;

_index.$CheckoutShippingAddressesModel;

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/select-shipping/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"aside\" id=\"selectShipping\" content modal-box modal-refresh-on=\"'populated'\" modal-cancel=\"doneFn()\">\n    <xo-aside-header ng-if=\"deleteShipping()\" hdrtype='tall' heading='asideHeader.selectShipping'\n                     sub-header-left-link='checkout.review.sidebar.addShipping'\n                     sub-header-left=\"asideHeader.add\"\n                     sub-header-left-icon=\"true\"\n                     sub-header-right-link='checkout.review.sidebar.deleteShipping'\n                     sub-header-right=\"asideHeader.delete\"\n                     sub-header-right-icon=\"true\"></xo-aside-header>\n\n    <xo-aside-header hdrtype='tall' heading='asideHeader.selectShipping'\n                     ng-if=\"!deleteShipping()\"\n                     back-url=\"{{backUri}}\"\n                     sub-header-left-link=\"{{addLink()}}\"\n                     sub-header-left=\"asideHeader.add\"\n                     sub-header-left-icon=\"true\"></xo-aside-header>\n\n    <div class=\"asideContent showAll\" xo-tray-height>\n        <ul class=\"items\" select-box=\"checkoutShippingAddresses.addresses\" select-allow-tab-escape>\n            <li ng-repeat=\"address in checkoutShippingAddresses.addresses track by $index\"\n                role=\"presentation\"\n                class=\"address trayInner trayInnerDefault\"\n                ng-class=\"{selectable: !address.default_address, disabled: address.disable_for_transaction}\">\n\n                <xo-message ng-if=\"address.disable_for_transaction\" message=\"blkNonDomesticShippingMsg\"\n                            class=\"shippingBlk\"></xo-message>\n\n                <a track-submit href=\"\" ng-click=\"onSelect(address)\" class=\"shippingBlk\" select-option=\"address.default_address\" focus-when=\"address.default_address\" role=\"option\" ng-attr-aria-selected=\"{{ address.default_address ? 'true' : undefined }}\">\n                    <span class=\"display fullName\">{{address.recipient_name}}</span>\n                    <xo-address-display address=address country-code=countryCode\n                                        show-preferred=\"true\"></xo-address-display>\n                    <span class=\"checkIcon\" ng-if=\"address.default_address\">\n                        <span class=\"accessAid\" ng-if=\"locale.lang === 'en'\">Selected</span>\n                    </span>\n                </a>\n            </li>\n        </ul>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/shipping-address/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

__webpack_require__("../node_modules/xo-form-components/src/select-shipping-country/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/zipcode/directive.js");

var _index = __webpack_require__("../node_modules/xo-models/src/address/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-tray-height/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/select-shipping/shipping-address/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoShippingAddress', function () {
    return {
        template: _template2['default'],
        scope: {
            auth: '=?',
            token: '=?',
            doneFn: '=?',
            sidebar: '=?',
            update: '=?',
            renderBillingAddCheckbox: '=?',
            backUri: '=?',
            doneUri: '=?',
            shippingChangeFeature: '=?'
        },
        controller: ['$scope', '$element', function ($scope, $element) {
            if (!$scope.sidebar) {
                $scope.pageTitle = (0, _squid.$renderContent)('addShipping.addAddress');
            }
            $scope.backUri = $scope.backUri || 'checkout.review.sidebar.shipping';
            $scope.heading = $scope.update ? 'addressNormalization.update' : 'asideHeader.addShipping';
            $scope.buttonLabel = function () {
                if (!$scope.sidebar || $scope.address.country === 'BR' && !$scope.prefilled) {
                    return (0, _squid.$renderContent)('common.continueLabel');
                } else {
                    return (0, _squid.$renderContent)('common.save');
                }
            };
            $scope.address = {
                country: _squid.$locale.getCountryCodeISO()
            };
            $scope.isShipping = true;
            $scope.normalize = function () {
                return (0, _squid.$feature)('shippingAddressNormalization') && $scope.address.country === _squid.$locale.country // Should be domestic address
                && !$scope.normalized;
            };

            $scope.showshipping = true;
            $scope.country = _squid.$locale.country;
            $scope.recipient = {
                first_name: '',
                last_name: ''
            };

            var $el = $($element);

            function focusFirstError() {
                $el.find('form').find('.backendError, .ng-invalid').first().focus();
            }

            (0, _squid.$populate)($scope, {
                checkoutAppData: _index2.$CheckoutAppDataModel.instance($scope.token),
                checkoutSession: _index2.$CheckoutSessionModel.instance($scope.token)
            }).then(function () {
                var merchantCountry = $scope.checkoutAppData.get('merchant.merchant_country', 'US');
                var contingencyPrefilledAddress = void 0;

                if ((0, _squid.$feature)('supportBlockNonDomesticShipping', false, merchantCountry)) {

                    $scope.disableChangeShippingCountry = $scope.checkoutAppData.get('flags.block_non_domestic_shipping', false);

                    if ($scope.disableChangeShippingCountry) {

                        $scope.address.country = merchantCountry;

                        contingencyPrefilledAddress = $scope.checkoutSession.get('errorData.resolution.data', null);
                        if (!$scope.sidebar && contingencyPrefilledAddress) {
                            angular.extend($scope.address, {
                                line1: contingencyPrefilledAddress.line1,
                                line2: contingencyPrefilledAddress.line2,
                                city: contingencyPrefilledAddress.city,
                                state: contingencyPrefilledAddress.state,
                                postal_code: contingencyPrefilledAddress.postal_code
                            });
                        }

                        _logger.$logger.info('member_block_non_domestic_shipping', {
                            block_non_domestic_shipping: $scope.disableChangeShippingCountry,
                            sidebar: $scope.sidebar
                        });

                        var countryName = (0, _squid.$renderContent)('shippingCountry.' + merchantCountry);
                        var infoMessage = (0, _squid.$renderContent)('largeScreenPayment.blockNonDomesticShippingAlert', {
                            shippingCountry: countryName
                        });

                        $scope.message = {
                            msgs: [infoMessage],
                            type: 'warning'
                        };
                    }
                }

                $scope.prefill = function () {
                    $scope.prefillAddress = new _index.$PrefillAddressModel({
                        id: $scope.token,
                        address: {
                            country: _squid.$locale.country,
                            postal_code: $scope.address.postal_code
                        }
                    });

                    $scope.prefillAddress.save({
                        data: $scope.prefillAddress,
                        success: function success(result) {
                            if (result) {
                                $scope.address = result;
                            }
                            $scope.prefilled = true;
                            $scope.address.first_name = $scope.recipient.first_name;
                            $scope.address.last_name = $scope.recipient.last_name;

                            (0, _angular.$timeout)(function () {
                                var value = $scope.address.state;
                                var $option = $el.find('[value="' + value + '"]');

                                $option.prop('selected', 'selected');
                                $option.trigger('change');

                                value = $option.attr('label');
                                focusFirstError();
                            }, 1000);
                        }
                    });
                };

                if ($scope.update) {
                    if ($scope.checkoutSession.shipping.name) {
                        var name = $scope.checkoutSession.shipping.name.trim();
                        var index = name.indexOf(' ');

                        $scope.recipient.first_name = name.substr(0, index);
                        $scope.recipient.last_name = name.substr(index + 1);
                    }
                    $scope.address.postal_code = $scope.checkoutSession.get('shipping.postal_code', '');
                    $scope.prefill();
                }

                function handleValidation(res) {
                    if (res && res.fields && res.fields.length) {
                        res.fields.forEach(function (field) {
                            if (field.field) {
                                var $field = $($el.find('[ng-model="address.' + field.field + '"]'));

                                if ($field.length === 0 && field.field === 'zip') {
                                    $field = $($el.find('[ng-model="address.postal_code"], [ng-model="zipCode"]'));
                                }
                                $field.addClass('backendError');
                                $field.attr('aria-invalid', true);
                            }
                        });
                        focusFirstError();
                    }
                }

                $scope.cancelFn = function () {
                    _uiRouter.$state.go('checkout.review.sidebar.shipping');
                };

                $scope.onSubmit = function () {
                    if ($scope.address.country === 'BR' && $scope.address.country === _squid.$locale.country && !$scope.prefilled) {
                        return $scope.prefill();
                    }

                    if ($scope.normalize()) {
                        $scope.showshipping = false;
                        _uiRouter.$state.go('.addressNormalization');
                    } else {
                        $scope.submitAddress();
                    }
                };

                $scope.removeValidation = function () {
                    $el.find('form').removeClass('validated');
                };

                function prefilledAddressUnchanged(prefilledAddress, addressToSubmit) {

                    function lowercaseEquals(str1, str2) {
                        return angular.lowercase(str1) === angular.lowercase(str2);
                    }

                    return lowercaseEquals(prefilledAddress.recipient_name, addressToSubmit.recipient_name) && lowercaseEquals(prefilledAddress.line1, addressToSubmit.line1) && lowercaseEquals(prefilledAddress.line2, addressToSubmit.line2) && lowercaseEquals(prefilledAddress.city, addressToSubmit.city) && lowercaseEquals(prefilledAddress.state, addressToSubmit.state) && lowercaseEquals(prefilledAddress.postal_code, addressToSubmit.postal_code) && lowercaseEquals(prefilledAddress.country_code, addressToSubmit.country);
                }

                function callOnShippingChange(callback) {
                    if ($scope.shippingChangeFeature && $scope.shippingChangeFeature.callOnShippingChange) {
                        $scope.shippingChangeFeature.callOnShippingChange(callback);
                    } else {
                        callback();
                    }
                }

                function updateAddress(payload) {
                    $scope.checkoutSession.shipping.action('update', {
                        data: payload,
                        resultModel: $scope.checkoutSession,
                        success: function success(result) {
                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['smallToolTip.addressAdded']
                            };

                            callOnShippingChange(function () {
                                return $scope.doneFn(result);
                            });
                        },
                        validation: function validation(res) {
                            handleValidation(res);
                        }
                    });
                }

                function addAddress(payload) {
                    // make sure this param is not passed as behavior from symphony is erratic.
                    delete payload.address_id;
                    $scope.shippingAddress = _index2.$ShippingAddressModel.create($scope.token, payload);
                    $scope.shippingAddress.save({
                        data: payload,
                        resultModel: $scope.checkoutSession,
                        success: function success(result) {
                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['smallToolTip.addressAdded']
                            };

                            callOnShippingChange(function () {
                                return $scope.doneFn($scope.address.isBA ? payload : null);
                            });
                        },
                        validation: function validation(res) {
                            handleValidation(res);
                        },
                        contingencies: {
                            'SHIPPING_ADDRESS_INVALID': function SHIPPING_ADDRESS_INVALID() {
                                $scope.message = {
                                    type: 'error',
                                    msgKeys: ['shippingAddress.errorInfo']
                                };
                            }
                        }
                    });
                }

                $scope.submitAddress = function () {
                    if ($scope.address.preferred_address) {
                        _logger.$logger.info('addAddrPreferred.selected', {});
                    }

                    var country = $scope.address.country;
                    // keep this for compatibility
                    var recipient_name = $scope.address.first_name + ' ' + $scope.address.last_name;

                    if ((0, _squid.$feature)('nameFormat', country, country) === 'LastFirst') {
                        recipient_name = $scope.address.last_name + ' ' + $scope.address.first_name;
                    }

                    var data = {
                        recipient_name: recipient_name,
                        first_name: $scope.address.first_name,
                        last_name: $scope.address.last_name,
                        line1: $scope.address.line1,
                        line2: $scope.address.line2,
                        city: $scope.address.city,
                        state: $scope.address.state,
                        postal_code: $scope.address.postal_code,
                        country: country,
                        normalization_status: $scope.address.normalization_status,
                        preferred_address: $scope.address.preferred_address,
                        default_address: true
                    };

                    if (contingencyPrefilledAddress && prefilledAddressUnchanged(contingencyPrefilledAddress, data)) {
                        data.address_id = contingencyPrefilledAddress.id;
                    }
                    // Update is used for the address normalization flow.
                    data.address_id = data.address_id ? data.address_id : $scope.checkoutSession.get('shipping.id');
                    if ($scope.update && data.address_id) {
                        updateAddress(data);
                    } else {
                        addAddress(data);
                    }
                };

                $scope.uponNormalization = function (normalizedAddress, isBack) {
                    if (isBack) {
                        $scope.normalized = false;
                        $scope.showshipping = true;
                        _uiRouter.$state.go('^');
                    } else {
                        $scope.address = normalizedAddress;
                        $scope.normalized = true;
                        $scope.address.first_name = $scope.recipient.first_name;
                        $scope.address.last_name = $scope.recipient.last_name;
                        $scope.submitAddress();
                    }
                };
            });
        }]
    };
});

_angular.$timeout;

_squid.$feature;

_squid.$locale;

_squid.$populate;

_squid.$renderContent;

_uiRouter.$state;

_logger.$logger;

_index.$PrefillAddressModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutSessionModel;

_index2.$ShippingAddressModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/shipping-address/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-class=\"{'aside': sidebar, 'fullpage': !sidebar}\" id=\"addShipping\" modal-box modal-refresh-on=\"'metadataChange'\" modal-cancel=\"cancelFn()\">\n    <div ng-if=\"showshipping\">\n    <xo-aside-header ng-if=\"sidebar\" back-url=\"{{backUri}}\" heading=\"{{heading}}\"></xo-aside-header>\n\n    <div class=\"container\" ng-class=\"{'asideContent': sidebar}\" xo-tray-height>\n\n        <xo-message ng-if=\"message\" message=\"message\"></xo-message>\n        <h1 class=\"gamma\" ng-if=\"pageTitle\">{{ pageTitle }}</h1>\n\n        <div ng-if=\"update\" content>\n            <p class=\"theta\">{{ content('addressNormalization.updateIntro') }}</p>\n        </div>\n\n            <form id=\"shippingAddressForm\" name=\"shippingAddressForm\" class=\"asideView addressForm\"\n                  content novalidate form-autofocus>\n\n                <div ng-if=\"!update\">\n                    <xo-select-shipping-country shipping-address=\"address\"\n                                                disable-change-shipping-country=\"disableChangeShippingCountry\"\n                                                token=\"token\" ng-click=\"removeValidation()\"></xo-select-shipping-country>\n                </div>\n\n                <div ng-if=\"prefilled || address.country!=='BR'\">\n                    <xo-add-address country=\"address.country\" address=\"address\" is-shipping=\"true\"\n                                    token=\"token\" render-billing-add-checkbox=\"renderBillingAddCheckbox\"></xo-add-address>\n                </div>\n\n                <div ng-if=\"!prefilled && address.country==='BR'\">\n                    <xo-name-input user=\"recipient\"></xo-name-input>\n                    <xo-zipcode country=\"{{address.country}}\" address=\"address\" zip-label=\"{{content('common.cep')}}\"\n                                zip-error-key=\"common.valueInvalid\"></xo-zipcode>\n                </div>\n                <div class=\"buttons\">\n                    <input track-submit type=\"submit\" id=\"proceedButton\" data-test-id=\"saveShippingAddr\"\n                           type=\"submit\" value=\"{{buttonLabel()}}\" class=\"btn full\"  validate-submit=\"onSubmit()\"/>\n                </div>\n\n            </form>\n        </div>\n\n    </div>\n    <div ui-view></div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/update-shipping/directive.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/xo-member-components/src/select-shipping/shipping-address/directive.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/select-shipping/update-shipping/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoUpdateShipping', function () {
    return {
        template: _template2['default'],
        scope: {
            auth: '=?',
            token: '=?',
            doneFn: '=?',
            sidebar: '=?'
        },
        controller: function controller() {}
    };
});

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/update-shipping/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$UpdateShippingRoute = undefined;

__webpack_require__("../node_modules/xo-member-components/src/select-shipping/update-shipping/directive.js");

__webpack_require__("../node_modules/xo-address-components/src/address-normalization/route.js");

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/select-shipping/shipping-address/directive.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $UpdateShippingRoute = exports.$UpdateShippingRoute = _squid.$ComponentRoute.extend('$UpdateShippingRoute', {
    name: 'updateShipping',
    directive: 'xo-update-shipping',
    titleContent: 'addShipping.addAddress',
    trackingData: {
        fptiState: 'update_shipping',
        buzname: {
            'fullpage': {
                'pagename': '%::update_shipping',
                'pagename2': '%::update_shipping:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    loginRequired: true,
    children: [{
        name: '$AddressNormalizationRoute',
        attributes: {
            id: 'token',
            sidebar: 'sidebar',
            address: 'address',
            'done-fn': 'uponNormalization'
        }
    }]
});

angular.value("$UpdateShippingRoute", $UpdateShippingRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/update-shipping/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-shipping-address token=\"token\" done-fn=\"doneFn\" sidebar=\"sidebar\" update=\"true\"></xo-shipping-address>"

/***/ }),

/***/ "../node_modules/xo-member-components/src/show-more-fi/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoShowMoreFiLink = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

__webpack_require__("../node_modules/xo-ui-components/src/link/directive.js");

var _factory = __webpack_require__("../node_modules/xo-member-components/src/show-more-fi/factory.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/show-more-fi/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoShowMoreFiLink = exports.$xoShowMoreFiLink = _squid.$Component.extend('$xoShowMoreFiLink', {
    tag: 'xo-show-more-fi-link',
    template: _template2['default'],
    actions: {
        showMore: function showMore() {
            _factory.$ShowMoreFiFactory.set({ isShowMoreBtnClicked: true });
            _logger.$logger.info('checkout_fpti', {
                from: '3fi',
                to: 'process_3fi'
            });
        }
    },
    lifecycle: {
        enter: function enter() {}
    }
});

angular.value("$xoShowMoreFiLink", $xoShowMoreFiLink);
_squid.$Component;

_logger.$logger;

_factory.$ShowMoreFiFactory;

/***/ }),

/***/ "../node_modules/xo-member-components/src/show-more-fi/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _ui = __webpack_require__("../node_modules/xo-ui-components/src/accessibility/ui.js");

var _index = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$ShowMoreFiFactory', function () {
    var state = {
        isTooManyFi: false,
        isShowMoreBtnClicked: false,
        eligible: false
    };

    var get = function get() {
        return state;
    };
    var set = function set(data) {
        return _squid.$util.extend(state, data);
    };

    // max number of FI to be shown by default
    // if user has <= 4 -- all 4 FI will be shown
    // if user has > 4 -- 3 FI will be shown
    var MAX_FI_NUMBER = 4;

    // condition to determine if there are too many FI's
    // to hide them and display "Show More" link
    var isTooManyFi = function isTooManyFi() {
        var planList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        return planList.length > MAX_FI_NUMBER;
    };

    // get pxp result
    var getPxp = function getPxp() {
        return (0, _squid.$pxp)('xo_hermes_3fi', 'xo_hermes_3fi_treatment', undefined, false, true).then(function (pxpRes) {
            return !!pxpRes;
        });
    };

    // when logout -> reset flag
    _angular.$rootScope.$on('logout', function (event, args) {
        state.isShowMoreBtnClicked = false;
    });

    // returns true if:
    // 1) there are too many FI's
    // 2) "Show more" link was not clicked yet
    var isFiNeverExpanded = function isFiNeverExpanded() {
        return !state.isShowMoreBtnClicked && state.isTooManyFi;
    };

    var init = function init(planList) {
        if (!state.eligible) {
            return;
        }
        state.isTooManyFi = isTooManyFi(planList);
        if (isFiNeverExpanded()) {
            _logger.$logger.info('checkout_fpti', {
                from: '3fi',
                to: 'prepare_3fi'
            });
        }
    };

    // eligible if:
    // 1. multi fi
    // 2. 3fi pxp returns treatment
    var decideEligibility = function decideEligibility(_ref) {
        var plans = _ref.plans;

        if (!isTooManyFi(plans)) {
            return;
        }

        return _index.$ChoiceEligibility.instance().getVariant(_angular.$rootScope.token).then(function (variant) {
            var multipleFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.multipleFi || [];

            if (multipleFiVariants.indexOf(variant) !== -1) {
                return getPxp().then(function (pxpResult) {
                    _logger.$logger.info('3fi_eligibility', {
                        pxp: pxpResult
                    });
                    state.eligible = pxpResult;
                });
            }
        });
    };

    // used to show / hide individual fi entry of the plan list
    // index - selected radio box index starting from 0
    var shouldHideFiEntry = function shouldHideFiEntry(index) {
        return isFiNeverExpanded() && index + 1 > MAX_FI_NUMBER - 1;
    };

    // event handler for accessibility
    // if current index is 0 and user press UP - expand FI's
    // if current index is one which goes before the last visible one
    var selectFiOnKeyDown = function selectFiOnKeyDown(event, index) {
        if (index === 0 && event.keyCode === _ui.KEYS.UP || index + 1 >= MAX_FI_NUMBER - 2 && event.keyCode === _ui.KEYS.DOWN) {
            state.isShowMoreBtnClicked = true;
        }
    };

    return {
        get: get,
        set: set,
        init: init,
        isFiNeverExpanded: isFiNeverExpanded,
        decideEligibility: decideEligibility,
        shouldHideFiEntry: shouldHideFiEntry,
        selectFiOnKeyDown: selectFiOnKeyDown
    };
});

_angular.$rootScope;

_squid.$util;

_squid.$pxp;

_squid.$config;

_logger.$logger;

_ui.KEYS;

_index.$ChoiceEligibility;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-member-components/src/show-more-fi", "../node_modules/xo-member-components/src/show-more-fi/factory.js"))

/***/ }),

/***/ "../node_modules/xo-member-components/src/show-more-fi/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-link content label=\"{{ content('common.showMoreFi') }}\" on-click=\"actions.showMore\" left-icon=\"caret-down\"></xo-link>"

/***/ }),

/***/ "../node_modules/xo-models/src/address/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ValidateAddressModel = exports.$PrefillAddressModel = exports.$AddressNormalizationModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $AddressNormalizationModel = exports.$AddressNormalizationModel = _squid.$Model.extend('$AddressNormalizationModel', {
    api: new _squid.$Api({
        uri: '/api/address/normalize'
    })
});

var $PrefillAddressModel = exports.$PrefillAddressModel = _squid.$Model.extend('$PrefillAddressModel', {
    api: new _squid.$Api({
        uri: '/api/address/prefill'
    })
});

var $ValidateAddressModel = exports.$ValidateAddressModel = _squid.$Model.extend('$ValidateAddressModel', {
    api: new _squid.$Api({
        uri: '/api/address/validate'
    })
});

angular.value("$AddressNormalizationModel", $AddressNormalizationModel);
angular.value("$PrefillAddressModel", $PrefillAddressModel);
angular.value("$ValidateAddressModel", $ValidateAddressModel);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/app/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$PXPBlacklist = exports.$TokenizedWalletMsbOfferModel = exports.$TokenizedWalletPinModel = exports.$TokenizedFundingCapabilitiesModel = exports.$TokenizedWalletInfoModel = exports.$TokenizedWalletEligibilityModel = exports.$MessengerIntegrationDataModel = exports.$AppDataModel = exports.$LocaleConfigModel = exports.$PXPModel = undefined;

var _brandNames, _msbDisclaimerLinks;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $PXPModel = exports.$PXPModel = _squid.$Model.extend('$PXPModel', {
    api: new _squid.$Api({
        uri: '/api/pxp/:id'
    })
});

var $LocaleConfigModel = exports.$LocaleConfigModel = _squid.$Model.extend('$LocaleConfigModel', {
    api: new _squid.$Api({
        uri: '/api/localeConfig'
    })
});

var $AppDataModel = exports.$AppDataModel = _squid.$Model.extend('$AppDataModel', {
    api: new _squid.$Api({
        uri: '/api/app'
    }),

    isMobile: function isMobile() {
        return this.platform === 'mobile';
    }
});

var $MessengerIntegrationDataModel = exports.$MessengerIntegrationDataModel = _squid.$Model.extend('$MessengerIntegrationDataModel', {
    api: new _squid.$Api({
        uri: '/api/messenger'
    })
});

var $TokenizedWalletEligibilityModel = exports.$TokenizedWalletEligibilityModel = _squid.$Model.extend('$TokenizedWalletEligibilityModel', {
    api: new _squid.$Api({
        uri: '/api/eligibility/tokenizedWallet/:id'
    }),

    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called

    isEligible: function isEligible() {
        return this.eligible;
    }
});

var subjectTypes = {
    SAMSUNG_PAY: 'Samsung',
    ANDROID_PAY: 'google'
};

var brandNames = (_brandNames = {}, _brandNames[subjectTypes.SAMSUNG_PAY] = 'Samsung Pay', _brandNames[subjectTypes.ANDROID_PAY] = 'Google Pay', _brandNames);

/**
 * disclaimer links used on the *pay review page
 */
var disclaimerLinks = function disclaimerLinks(country) {
    var _ref;

    return _ref = {}, _ref[subjectTypes.SAMSUNG_PAY] = 'https://www.paypal.com/' + country + '/webapps/mpp/ua/ppsamsungpay-tnc', _ref[subjectTypes.ANDROID_PAY] = 'https://www.paypal.com/' + country + '/webapps/mpp/ua/ppandroidpay-tnc', _ref;
};

// disclaimer links used on Msb offer popup
var msbDisclaimerLinks = (_msbDisclaimerLinks = {}, _msbDisclaimerLinks[subjectTypes.SAMSUNG_PAY] = 'https://www.paypal.com/us/smarthelp/article/samsung-pay-terms-and-conditions-faq3863', _msbDisclaimerLinks[subjectTypes.ANDROID_PAY] = 'https://www.paypal.com/us/smarthelp/article/google-pay-terms-and-conditions-faq3862', _msbDisclaimerLinks);

/**
 * this model populates data from tokenized wallet mayfly object
 * (see xo-hermes-app/apis/tokenizedWalletInfo) which contains:
 *
 * - wallet_id (used for both Samsung Pay and Android Pay)
 * - external_device_id (used for Samsung Pay only)
 * - subject (used for both Samsung Pay and Android Pay)
 *
 * Note: model is being populated in xo-preload on the server (see config.json)
 */

var $TokenizedWalletInfoModel = exports.$TokenizedWalletInfoModel = _squid.$Model.extend('$TokenizedWalletInfoModel', {

    api: new _squid.$Api({
        uri: '/api/info/tokenizedWallet/:id'
    }),

    isAndroidPay: function isAndroidPay() {
        return this.subject === subjectTypes.ANDROID_PAY;
    },

    isSamsungPay: function isSamsungPay() {
        return this.subject === subjectTypes.SAMSUNG_PAY;
    },

    getSubject: function getSubject() {
        return this.subject || subjectTypes.ANDROID_PAY;
    },

    // until we use mayfly for android pay - fallback to Android Pay
    brandName: function brandName() {
        return brandNames[this.subject] || brandNames[subjectTypes.ANDROID_PAY];
    },

    // until we use mayfly for android pay - fallback to Android Pay
    getDisclaimerLink: function getDisclaimerLink() {
        var country = _squid.$locale.country.toLowerCase();

        return disclaimerLinks(country)[this.subject] || disclaimerLinks(country)[subjectTypes.ANDROID_PAY];
    },

    // get Msb terms and conditions link based on the subject
    getMsbDisclaimerLink: function getMsbDisclaimerLink() {
        return msbDisclaimerLinks[this.subject] || msbDisclaimerLinks[subjectTypes.ANDROID_PAY];
    }
});

var $TokenizedFundingCapabilitiesModel = exports.$TokenizedFundingCapabilitiesModel = _squid.$Model.extend('$TokenizedFundingCapabilitiesModel', {
    api: new _squid.$Api({
        uri: '/api/capabilities/tokenizedWallet/:id'
    }),
    invalidateOnLogout: true,

    isDirectFundingEnabled: function isDirectFundingEnabled() {
        return this.directFundingEnabled;
    },

    isTopupEnabled: function isTopupEnabled() {
        return this.topupFundingEnabled;
    },
    getProductName: function getProductName() {
        return this.name;
    },

    getCurrency: function getCurrency() {
        return this.issuingCurrency;
    },

    getContingencies: function getContingencies() {
        return this.contingencies;
    },

    getTopupAmountChoices: function getTopupAmountChoices() {
        return this.topUpAmountChoices;
    }
});

var $TokenizedWalletPinModel = exports.$TokenizedWalletPinModel = _squid.$Model.extend('$TokenizedWalletPinModel', {
    api: new _squid.$Api({
        uri: '/api/pin/tokenizedWallet/:id'
    }),

    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called

    getPinOrigin: function getPinOrigin() {
        return this.pinOrigin;
    },
    getSuggestedPin: function getSuggestedPin() {
        return this.suggestedPin;
    },
    getSuggestedKey: function getSuggestedKey() {
        return this.suggestedKey;
    },
    getPinId: function getPinId() {
        return this.pinId;
    },
    isPinIdPresent: function isPinIdPresent() {
        return !!this.pinId;
    },
    isSetupEligible: function isSetupEligible() {
        return this.pinOrigin === 'UNSET' || this.pinOrigin === 'SYSTEM';
    }
});

var $TokenizedWalletMsbOfferModel = exports.$TokenizedWalletMsbOfferModel = _squid.$Model.extend('$TokenizedWalletMsbOfferModel', {
    api: new _squid.$Api({
        uri: '/api/msb/tokenizedWallet/:id'
    }),
    invalidateOnLogout: true
});

var $PXPBlacklist = exports.$PXPBlacklist = {
    isMerchantBlacklisted: function isMerchantBlacklisted(merchantId) {
        return _squid.$config.pxpBlacklist && _squid.$config.pxpBlacklist.merchant && _squid.$config.pxpBlacklist.merchant.indexOf(merchantId) !== -1;
    }
};

angular.value("$PXPModel", $PXPModel);
angular.value("$LocaleConfigModel", $LocaleConfigModel);
angular.value("$AppDataModel", $AppDataModel);
angular.value("$MessengerIntegrationDataModel", $MessengerIntegrationDataModel);
angular.value("$TokenizedWalletEligibilityModel", $TokenizedWalletEligibilityModel);
angular.value("$TokenizedWalletInfoModel", $TokenizedWalletInfoModel);
angular.value("$TokenizedFundingCapabilitiesModel", $TokenizedFundingCapabilitiesModel);
angular.value("$TokenizedWalletPinModel", $TokenizedWalletPinModel);
angular.value("$TokenizedWalletMsbOfferModel", $TokenizedWalletMsbOfferModel);
angular.value("$PXPBlacklist", $PXPBlacklist);
_squid.$config;

_squid.$locale;

_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/auth/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ULoginModel = exports.$AuthModel = exports.$AuthApi = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var $AuthApi = exports.$AuthApi = _squid.$Model.extend('$AuthApi', {
    api: new _squid.$Api({
        uri: '/api/auth',
        postAttempts: 3
    })
});

var $AuthModel = exports.$AuthModel = _squid.$Model.extend('$AuthModel', {
    api: new _squid.$Api({
        uri: '/api/auth',
        postAttempts: 3
    }),

    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called

    loggedIn: function loggedIn() {
        return this.logged_in;
    },

    visitorId: function visitorId() {
        return this.visitor_id;
    },

    accessToken: function accessToken() {
        return this.access_token;
    },

    accessTokenPresent: function accessTokenPresent() {
        return this.access_token_present;
    },

    refreshToken: function refreshToken() {
        return this.refresh_token;
    },

    rememberedOT: function rememberedOT() {
        return this.remembered && this.remembered_device_token;
    },

    isSessionTimeout: function isSessionTimeout() {
        return this.meta && this.meta.invalidated;
    },

    clearCookies: function clearCookies() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return this.action('clearCookies', { data: data });
    },

    showNotYou: function showNotYou() {
        var isAuthApiCall = this.is_auth_api_call;
        var isConsumerApp = _squid.$util.param('source') === 'consumerApp';
        var redirectToHermesOn3DSDecline = _squid.$util.param('redirectToHermesOn3DSDecline');
        var isUlReturnLoggedIn = _squid.$util.param('ulReturn') && this.auth_state === 'LOGGEDIN';

        // for Tokenized Venice integraion (Google Pay Venice / Samsung Pay Venice) - `not you` link should be hidden.
        // `TokenizedWalletInfoModel` is always populated in xo-preload (even for error cases - it will be just empty)
        // so we don't need to retrieve the model
        var tokenizedWalletInfo = _app.$TokenizedWalletInfoModel.instance(_angular.$rootScope.token);
        var isNotVeniceTokenizedIntegration = function isNotVeniceTokenizedIntegration() {
            return !tokenizedWalletInfo || tokenizedWalletInfo && !tokenizedWalletInfo.is_venice_integration;
        };

        // disallow_login_switch is used for Google Pay - acount linking to hide "not you" button (see xo-hercules/auth/outputMapper)
        return isAuthApiCall && !isConsumerApp && !redirectToHermesOn3DSDecline && !isUlReturnLoggedIn && !this.disallow_login_switch && isNotVeniceTokenizedIntegration();
    },

    logout: function logout() {
        _squid.$Model.bulkInvalidate('invalidateOnLogout');
        _angular.$rootScope.$broadcast('logout');
        return this.action('logout');
    },

    /**
     * Perform a logout and then redirect.
     * @param reason - used to log reason why a redirect was trigged.
     */
    logoutAndRedirect: function logoutAndRedirect() {
        var _this = this;

        var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'logout';

        return this.logout().then(function () {
            return _this.redirectToLogin(reason);
        });
    },

    // redirect to UL as landing through xo-landing-router
    // so first it hits hermes app and then redirects to UL
    redirectToLogin: function redirectToLogin(reason, ctx) {
        if (!reason) {
            return false;
        }
        // current query parameters
        var qs = _squid.$util.queryString() || '';
        var params = { 'ulClientRedirect': reason };

        params = _squid.$util.extend(params, ctx); // update params with context that may be sent

        // insert "ulClientRedirect" param and remove "ul", "ulReturn"
        var updatedQs = _squid.$util.queryStringSplice(qs, params, ['ul', 'ulReturn']);

        // base url should not be hardcoded to "/webapps/hermes" due to other use cases such as
        // 1. * Pay (Android Pay / Samsung Pay) -- uses /agreements/setup to exchange BA token to EC token
        var ulAsLandingUrl = _squid.$util.paypalURL('' + window.location.pathname + updatedQs);

        _logger.$logger.info('redirecting_to_ulAsLanding');
        return _squid.$util.redirect(ulAsLandingUrl);
    }

});

var $ULoginModel = exports.$ULoginModel = _squid.$Model.extend('$ULoginModel', {
    api: new _squid.$Api({
        uri: '/api/auth/ulogin',
        postAttempts: 1,
        cache: false
    })
});

angular.value("$AuthApi", $AuthApi);
angular.value("$AuthModel", $AuthModel);
angular.value("$ULoginModel", $ULoginModel);
_angular.$rootScope;

_squid.$Model;

_squid.$Api;

_squid.$util;

_logger.$logger;

_app.$TokenizedWalletInfoModel;

/***/ }),

/***/ "../node_modules/xo-models/src/bml/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$BMLApplicationModel = exports.$BMLModel = exports.$ApplyForBMLModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $ApplyForBMLModel = exports.$ApplyForBMLModel = _squid.$Model.extend('$ApplyForBMLModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/cart',
        cache: true
    }),

    personalInformation: {
        day: '',
        month: '',
        year: '',
        natId: '',
        phone: {
            telephone: '',
            phoneType: ''
        }
    },

    billingAdrress: {
        phoneType: '',
        phoneNumber: ''
    }
});

var $BMLModel = exports.$BMLModel = _squid.$Model.extend('$BMLModel', {
    api: new _squid.$Api({
        uri: '/api/bml',
        cache: false
    }),

    applicationStatus: function applicationStatus() {
        return this.application_status;
    },

    applicationId: function applicationId() {
        return this.application_id;
    }
});

var $BMLApplicationModel = exports.$BMLApplicationModel = _squid.$Model.extend('$BMLApplicationModel', {
    api: new _squid.$Api({
        uri: '/api/bml/:application_id',
        cache: false
    })
});

angular.value("$ApplyForBMLModel", $ApplyForBMLModel);
angular.value("$BMLModel", $BMLModel);
angular.value("$BMLApplicationModel", $BMLApplicationModel);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/checkout/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$CheckoutSessionModel = exports.$CardBackupModel = exports.$CheckoutPlanModel = exports.$CheckoutShippingAddressesModel = exports.$CreditOptionsModel = exports.$CheckoutPayeeModel = exports.$ShippingAddressModel = exports.$CheckoutShippingAddressModel = exports.$FlowEligibilityModel = exports.$InstallmentOptionsModel = exports.serializeInstallmentsOptionsData = exports.$FundingOptionsModel = exports.$FundingSourceModel = exports.$CheckoutAppDataModel = exports.$CheckoutCartModel = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _processorDecline = __webpack_require__("../node_modules/xo-models/src/processorDecline/index.js");

var $CheckoutCartModel = exports.$CheckoutCartModel = _squid.$Model.extend('$CheckoutCartModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/cart',
        cache: true
    }),

    isPurchase: function isPurchase() {
        return Boolean(this.purchase);
    },

    getCartCurrencyCode: function getCartCurrencyCode() {
        return _squid.$util.getProperty(this, 'purchase.amounts.total.currency_code');
    },

    // NOTE returns undefined if this is not a purchase or there is some other error
    getPurchaseAmount: function getPurchaseAmount() {
        if (!this.isPurchase()) {
            return;
        }
        var purchaseAmount = _squid.$util.getProperty(this, 'purchase.amounts.total.amount');
        var purchaseAmountFloat = parseFloat(purchaseAmount);

        return purchaseAmountFloat || undefined;
    },

    isBilling: function isBilling() {
        return Boolean(this.billing);
    },

    getBaToken: function getBaToken() {
        return this.isBilling() && this.billing.ba_token;
    },

    isBillingPurchase: function isBillingPurchase() {
        return this.isPurchase() && this.isBilling();
    },

    isBillingNoPurchase: function isBillingNoPurchase() {
        return this.isBilling() && !this.isPurchase();
    },

    getBillingDescription: function getBillingDescription() {
        return this.billing && this.billing.description;
    },

    isMultiSellerPurchase: function isMultiSellerPurchase() {
        return this.purchaseUnits && this.purchaseUnits.length > 1;
    },

    isShippingMethodStorePickUp: function isShippingMethodStorePickUp() {
        return this.isPurchase() && (this.purchase.shipping_method === '29' || this.purchase.shipping_method === '21');
    },

    isWalletTokenization: function isWalletTokenization() {
        return this.isBilling() && this.billing.intent === 'TOKENIZED_WALLET';
    },

    getExternalCallbackOptions: function getExternalCallbackOptions() {
        return this.purchaseUnits && this.purchaseUnits[0] && this.purchaseUnits[0].external_callback_options;
    }
});

var $CheckoutAppDataModel = exports.$CheckoutAppDataModel = _squid.$Model.extend('$CheckoutAppDataModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/appData'
    }),

    useraction: function useraction() {
        // user_action from session takes precedence over CGI param.
        var incontext_integration = window.xchild && window.xchild.props.commit ? 'commit' : false;
        var rest_integration = this.flags && this.flags.user_action === 'PAY' ? 'commit' : false;

        return rest_integration || incontext_integration || _squid.$util.param('useraction');
    },

    is_wps_flow: function is_wps_flow() {
        return this.flags && this.flags.is_wps_flow;
    },

    is_snt_supported: function is_snt_supported() {
        return this.flags && this.flags.is_snt_supported;
    },

    doec_on_approve: function doec_on_approve() {
        return this.flags && this.flags.doec_on_approve;
    },

    is_wps_subscription_flow: function is_wps_subscription_flow() {
        return this.flags && this.flags.is_wps_subscription_flow;
    },

    /*
     * Returns a string or undefined value
     * nonEmptyReturnValue - if true, then always return non empty string
     * isSentenceBeginning - if true, and merchant brand_name and merchant_name is undefined
     *              then returns 'The merchant'. If false, returns 'the merchant'
     * NOTE: We should not return merchant_email for any reason as it is a PII
     */
    getMerchantDisplayName: function getMerchantDisplayName() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            nonEmptyReturnValue = _ref.nonEmptyReturnValue,
            isSentenceBeginning = _ref.isSentenceBeginning,
            getContent = _ref.getContent;

        var merchantName = this.merchant.brand_name || this.merchant.merchant_name;

        if (nonEmptyReturnValue) {
            var contentKey = isSentenceBeginning ? 'common.Themerchant' : 'common.themerchant';
            var merchantAltName = getContent ? getContent(contentKey) : _squid.$locale.content.get(contentKey);

            return merchantName || merchantAltName;
        }

        return merchantName;
    },

    isInvoiceFlow: function isInvoiceFlow() {
        return Boolean(this.flags && this.flags.is_invoice_flow);
    },


    // Returns true if flow should be treated as a second button (PP Credit) transaction
    isSecondButton: function isSecondButton() {
        return this.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';
    }
});

var $FundingSourceModel = exports.$FundingSourceModel = _squid.$Model.extend('$FundingSourceModel', {

    formatLast4: function formatLast4() {
        var last4;

        if (this.last4) {
            last4 = this.last4;

            if (!this.parent.isAuthRequired) {
                last4 = 'x-' + last4;
            }
        }

        return last4;
    }
});

var $FundingOptionsModel = exports.$FundingOptionsModel = _squid.$Model.extend('$FundingOptionsModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/fundingOptions',
        postAttempts: 2
    }),

    eachPlan: function eachPlan(method, context) {
        angular.forEach(this.plans, method, this);
    },

    hasECheck: function hasECheck() {
        var _instruments = this.instruments,
            instruments = _instruments === undefined ? [] : _instruments;


        return instruments.some(function (instr) {
            return instr.type === 'ECHECK' || instr.subtype === 'ECHECK';
        });
    },

    hasCredit: function hasCredit() {
        var _instruments2 = this.instruments,
            instruments = _instruments2 === undefined ? [] : _instruments2;


        return instruments.some(function (instrument) {
            return instrument.type === 'CREDIT';
        });
    },

    getBankPlanIdByInstrumentId: function getBankPlanIdByInstrumentId(id, subType) {
        var fundingInstrument = _squid.$util.find(this.plans, function (plan) {
            return plan.primaryFs && plan.primaryFs.type === 'BANK' && plan.primaryFs.id === id && plan.primaryFs.subtype === subType;
        });

        return fundingInstrument && fundingInstrument.planId;
    },

    // get IACH and PAD banks combined by plan.primaryFs.id
    // order matters, so if IACH comes first then PAD is filtered and vise versa
    getPadAndIachCombinedPlans: function getPadAndIachCombinedPlans() {
        var _this = this;

        var plans = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.plans;

        if (!plans) {
            return [];
        }
        var planIds = {};

        plans.forEach(function (plan) {
            var planId = plan.planId,
                primaryFs = plan.primaryFs;


            if (_this.isIACH(plan) && !planIds[planId]) {
                planIds[primaryFs.padPlanId] = true;
            }
            if (_this.isPAD(plan) && !planIds[planId]) {
                planIds[primaryFs.iachPlanId] = true;
            }
        });

        return plans.filter(function (plan) {
            return !planIds[plan.planId];
        });
    },

    // get plan by planId
    getPlanByPlanId: function getPlanByPlanId(id) {
        var plan = _squid.$util.find(this.plans, function (p) {
            return p.primaryFs && p.planId === id;
        });

        return plan;
    },

    getPlanSubType: function getPlanSubType() {
        var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _plan$primaryFs = plan.primaryFs;
        _plan$primaryFs = _plan$primaryFs === undefined ? {} : _plan$primaryFs;
        var subtype = _plan$primaryFs.subtype;


        return subtype;
    },


    // is plan PAD bank (bank is charged after some delay)
    isPAD: function isPAD(plan) {
        return this.getPlanSubType(plan) === 'PAD';
    },


    // is plan IACH bank (instant transfer)
    isIACH: function isIACH(plan) {
        return this.getPlanSubType(plan) === 'IACH';
    },


    // is plan MEFT bank
    isMEFT: function isMEFT(plan) {
        return this.getPlanSubType(plan) === 'MEFT';
    },


    // is plan IACH bank (instant transfer)
    isIACHWithPad: function isIACHWithPad(plan) {
        return this.isIACH(plan) && plan.primaryFs.padPlanId;
    },

    // get PAD hop date (when bank will be charged) based on selected plan and PAD toggle state
    getPadPlanHopDate: function getPadPlanHopDate(plan) {
        if (this.isIACH(plan)) {
            var padPlan = this.getPlanByPlanId(plan.primaryFs.padPlanId);

            if (padPlan) {
                return padPlan.primaryFs.hop_date;
            }
        } else {
            return plan.primaryFs.hop_date;
        }
    },

    // get PAD or IACH plan id based on selected plan and PAD toggle state
    getPadOrIachPlanIdBySelectedPlan: function getPadOrIachPlanIdBySelectedPlan(_ref2) {
        var plan = _ref2.plan,
            isPadToggleSelected = _ref2.isPadToggleSelected;

        if (!plan || !plan.primaryFs) {
            return;
        }

        var _plan$primaryFs2 = plan.primaryFs,
            padPlanId = _plan$primaryFs2.padPlanId,
            iachPlanId = _plan$primaryFs2.iachPlanId,
            planId = plan.planId;


        if (isPadToggleSelected) {
            return this.isPAD(plan) ? planId : padPlanId;
        } else {
            return this.isIACH(plan) ? planId : iachPlanId;
        }
    },

    onPopulate: function onPopulate() {
        var self = this;

        angular.forEach(this.plans, function (plan) {
            if (plan.primaryFs && plan.primaryFs.type === 'BANK' && (plan.primaryFs.subtype === 'IACH' || plan.primaryFs.subtype === 'PAD')) {
                Object.defineProperty(plan.primaryFs, plan.primaryFs.subtype === 'IACH' ? 'padPlanId' : 'iachPlanId', {
                    enumerable: true,
                    configurable: false,
                    writeable: false,
                    value: self.getBankPlanIdByInstrumentId(plan.primaryFs.id, plan.primaryFs.subtype === 'IACH' ? 'PAD' : 'IACH')
                });
            }
        });
    },

    getBankPadPlanIdByInstrumentId: function getBankPadPlanIdByInstrumentId(fsId, fsSubtype) {
        var bankPadPlan = _squid.$util.find(this.plans, function () {
            var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _plan$primaryFs3 = plan.primaryFs;
            _plan$primaryFs3 = _plan$primaryFs3 === undefined ? {} : _plan$primaryFs3;
            var id = _plan$primaryFs3.id,
                type = _plan$primaryFs3.type,
                subtype = _plan$primaryFs3.subtype;


            return id === fsId && type === 'BANK' && subtype === fsSubtype;
        });

        if (!bankPadPlan) {
            return;
        }

        var _bankPadPlan$primaryF = bankPadPlan.primaryFs;
        _bankPadPlan$primaryF = _bankPadPlan$primaryF === undefined ? {} : _bankPadPlan$primaryF;
        var subtype = _bankPadPlan$primaryF.subtype,
            padPlanId = _bankPadPlan$primaryF.padPlanId,
            iachPlanId = _bankPadPlan$primaryF.iachPlanId;


        return subtype === 'IACH' ? padPlanId : iachPlanId;
    },


    isPadToggleApplicable: function isPadToggleApplicable() {
        var padToggleApplicable = false;

        this.eachPlan(function (plan) {
            if (!padToggleApplicable && plan.primaryFs && plan.primaryFs.type === 'BANK') {
                if (plan.primaryFs.subtype === 'IACH' && plan.primaryFs.hasOwnProperty('padPlanId')) {
                    padToggleApplicable = plan.primaryFs.padPlanId ? true : false;
                } else if (plan.primaryFs.subtype === 'PAD' && plan.primaryFs.hasOwnProperty('iachPlanId')) {
                    padToggleApplicable = plan.primaryFs.iachPlanId ? true : false;
                }
            }
        }, this);

        return padToggleApplicable;
    },

    isPadToggleApplicableForFS: function isPadToggleApplicableForFS(planId) {
        var padToggleApplicable = false;
        var selectedPlan = _squid.$util.find(this.plans, function (plan) {
            return plan.planId === planId;
        });

        if (selectedPlan && selectedPlan.primaryFs && selectedPlan.primaryFs.type === 'BANK' && (selectedPlan.primaryFs.subtype === 'IACH' && selectedPlan.primaryFs.padPlanId || selectedPlan.primaryFs.subtype === 'PAD' && selectedPlan.primaryFs.iachPlanId)) {
            padToggleApplicable = true;
        }

        return padToggleApplicable;
    },

    getPreferred: function getPreferred() {
        var _this2 = this;

        return _squid.$util.find(this.plans, function (plan) {
            return _this2.isPreferred(plan);
        });
    },

    isPreferred: function isPreferred() {
        var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (this.isPAD(plan)) {
            // if the current plan is PAD -> find corresponding IACH plan to see if it's preferred
            var iachPlan = this.getPlanByPlanId(plan.primaryFs.iachPlanId) || {};
            var _iachPlan$primaryFs = iachPlan.primaryFs;
            _iachPlan$primaryFs = _iachPlan$primaryFs === undefined ? {} : _iachPlan$primaryFs;

            var _iachPlan$primaryFs$i = _iachPlan$primaryFs.isPreferred,
                _isPreferred = _iachPlan$primaryFs$i === undefined ? false : _iachPlan$primaryFs$i;

            return _isPreferred;
        }

        var _plan$primaryFs4 = plan.primaryFs;
        _plan$primaryFs4 = _plan$primaryFs4 === undefined ? {} : _plan$primaryFs4;
        var _plan$primaryFs4$isPr = _plan$primaryFs4.isPreferred,
            isPreferred = _plan$primaryFs4$isPr === undefined ? false : _plan$primaryFs4$isPr;


        return isPreferred;
    },

    // get Merchant specific balance by plan id
    getMsbByPlanId: function getMsbByPlanId(planId) {
        var plan = this.getPlanByPlanId(planId);

        return plan && plan.incentive;
    },

    /**
     * Avoid plans that are not meant for display on the UI.
     * - Hide Rewards
     */
    getDisplayPlans: function getDisplayPlans() {
        // return type should be undefined in no plans
        // for billing agreement use case
        return this.plans ? this.plans.filter(function (plan) {
            return !plan.rewards;
        }) : this.plans;
    },
    /**
     * Avoid instruments that are not meant for display on the UI.
     * - Hide Rewards
     */
    getDisplayInstruments: function getDisplayInstruments() {
        var _instruments3 = this.instruments,
            instruments = _instruments3 === undefined ? [] : _instruments3;


        return instruments.filter(function (instrument) {
            return instrument.type !== 'REWARDS';
        });
    }
});

// Map the data needed for the installmentsOptions endpoint
var serializeInstallmentsOptionsData = exports.serializeInstallmentsOptionsData = function serializeInstallmentsOptionsData(_ref3) {
    var merchant_country = _ref3.checkoutAppData.merchant.merchant_country,
        checkoutCart = _ref3.checkoutCart,
        country = _ref3.country,
        id = _ref3.payee.merchant.id,
        isMemberCredit = _ref3.isMemberCredit,
        cc = _ref3.cc;

    var payload = {
        checkoutAppData: {
            merchant: {
                merchant_country: merchant_country
            }
        },
        checkoutCart: {},
        country: country,
        payee: {
            merchant: {
                id: id
            }
        },
        isMemberCredit: isMemberCredit,
        cc: cc
    };

    if (checkoutCart.purchase && checkoutCart.purchase.amounts) {
        var _checkoutCart$purchas = checkoutCart.purchase.amounts.total,
            amount = _checkoutCart$purchas.amount,
            currency_code = _checkoutCart$purchas.currency_code;


        payload.checkoutCart.purchase = {
            amounts: {
                total: {
                    amount: amount,
                    currency_code: currency_code
                }
            }
        };
    }

    return payload;
};

var $InstallmentOptionsModel = exports.$InstallmentOptionsModel = _squid.$Model.extend('$InstallmentOptionsModel', {

    api: new _squid.$Api({
        uri: '/api/checkout/:id/installmentOptions/',
        postAttempts: 2
    }),

    save: function save(options) {
        options.data = serializeInstallmentsOptionsData(options.data);

        return this._super.save.call(this, options);
    }
});

var $FlowEligibilityModel = exports.$FlowEligibilityModel = _squid.$Model.extend('$FlowEligibilityModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/flowEligibility'
    })
});

var $CheckoutShippingAddressModel = exports.$CheckoutShippingAddressModel = _squid.$Model.extend('$CheckoutShippingAddressModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:parent.id/shipping/:id'
    })
});

var $ShippingAddressModel = exports.$ShippingAddressModel = _squid.$Model.extend('$ShippingAddressModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/shipping/add'
    }),

    serialize: function serialize() {
        return {
            first_name: this.first_name,
            last_name: this.last_name,
            recipient_name: this.recipient_name,
            line1: this.line1,
            line2: this.line2,
            city: this.city,
            state: this.state,
            postal_code: this.postal_code,
            country: this.country
        };
    }
});

var $CheckoutPayeeModel = exports.$CheckoutPayeeModel = _squid.$Model.extend('$CheckoutPayeeModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/payee'
    }),

    getId: function getId() {
        return this.merchant && this.merchant.id;
    },

    isGambling: function isGambling() {
        return this.merchant && this.merchant.isGambling;
    },

    isOnBaNoStickyList: function isOnBaNoStickyList() {
        var merchantId = this.getId();

        return merchantId && _squid.$config.disableMerchantForStickyBA && _squid.$config.disableMerchantForStickyBA.indexOf(merchantId) > -1;
    }
});

var creditOptionsModel = {
    largeEligibleAmount: {
        US: 99,
        GB: 150
    }
};

// keeping sacEligibleAmount available for backwards compat, largeEligibleAmount preferred
creditOptionsModel.sacEligibleAmount = creditOptionsModel.largeEligibleAmount;

var $CreditOptionsModel = exports.$CreditOptionsModel = creditOptionsModel;

var $CheckoutShippingAddressesModel = exports.$CheckoutShippingAddressesModel = _squid.$Model.extend('$CheckoutShippingAddressesModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/shipping'
    }),

    onPopulate: function onPopulate() {
        this.addresses = this.children($CheckoutShippingAddressModel, this.addresses);
    },

    getPreferredShippingAddress: function getPreferredShippingAddress() {
        var preferredAddress = {};

        if (this.addresses) {
            var i = void 0;
            var address = void 0;

            for (i = 0; i < this.addresses.length; i++) {
                address = this.addresses[i];

                if (address && address.preferred_address) {
                    preferredAddress = {
                        'line1': address.line1,
                        'line2': address.line2,
                        'city': address.city,
                        'state': address.state,
                        'postal_code': address.postal_code,
                        'country_code': address.country_code
                    };

                    break;
                }
            }
        }
        return preferredAddress;
    },

    getPrimaryShippingAddress: function getPrimaryShippingAddress() {
        var primaryAddress = {};

        if (this.addresses) {
            var i = void 0;
            var address = void 0;

            for (i = 0; i < this.addresses.length; i++) {
                address = this.addresses[i];

                if (address && address.primary_address) {
                    primaryAddress = {
                        'line1': address.line1,
                        'line2': address.line2,
                        'city': address.city,
                        'state': address.state,
                        'postal_code': address.postal_code,
                        'country_code': address.country_code
                    };

                    break;
                }
            }
        }
        return primaryAddress;
    }
});

var $CheckoutPlanModel = exports.$CheckoutPlanModel = _squid.$Model.extend('$CheckoutPlanModel', {

    onPopulate: function onPopulate() {
        this.sources = this.children($FundingSourceModel, this.sources);
    },

    eachSource: function eachSource(method, context) {
        angular.forEach(this.sources, method, this);
    },

    hasFundingMethodType: function hasFundingMethodType(name) {
        var found = false;

        this.eachSource(function (source) {
            if (source.type === name) {
                found = true;
            }
        }, this);

        return found;
    },

    hasFundingMethodSubType: function hasFundingMethodSubType(name) {
        var found = false;

        this.eachSource(function (source) {
            if (source.sub_type === name) {
                found = true;
            }
        }, this);

        return found;
    },

    isPAD: function isPAD() {
        return this.hasFundingMethodSubType('DELAYED_TRANSFER');
    },

    isIACH: function isIACH() {
        var found = false;

        this.eachSource(function (source) {
            if (source.type === 'BANK_ACCOUNT' && source.sub_type === 'INSTANT_TRANSFER') {
                found = true;
            }
        }, this);

        return found;
    },

    isSplitBalance: function isSplitBalance() {
        return this.sources && this.sources.length > 1 && this.hasFundingMethodType('BALANCE');
    },

    isSplitPaymentWithBalanceAndIach: function isSplitPaymentWithBalanceAndIach() {
        return this.isSplitBalance() && this.isIACH();
    },

    isMSB: function isMSB() {
        return this.sources && this.sources.length === 1 && this.sources[0].type === 'INCENTIVE';
    },

    isBalance: function isBalance() {
        return this.sources && this.sources.length === 1 && this.sources[0].type === 'BALANCE';
    },

    hasConversion: function hasConversion() {
        return this.conversion !== null && _typeof(this.conversion) === 'object';
    }
});

var $CardBackupModel = exports.$CardBackupModel = _squid.$Model.extend('$CardBackupModel', {
    onPopulate: function onPopulate() {
        if (!this.get('parent.meta.populated')) {
            return;
        }

        // If plan IDs change, we need to reevaluate the correct backup plan id
        this.resetIfDoesNotApply();
        this.reevaluateEligibility();
    },


    /**
     * getCardBackupInstrument
     * Get the user's last selection for card backup, if still eligible
     * @returns {Object|undefined} the plan of the user's last selection, or undefined otherwise
     */
    getPlan: function getPlan() {
        if (!this.isAllowed()) {
            return;
        }

        return this.plan;
    },


    /**
     * setCardBackupInstrument
     * Save the user's selection for backup. Tied to the currently selected plan
     * @param {Object} plan - the plan to use as the backup
     * @param {Object} [forPlan] - if needed, the plan to compare against. prefer not to pass it in
     */
    setPlan: function setPlan(plan, forPlan) {
        this.plan = plan;
        this.forPlan = forPlan || this.getCheckoutSessionPlan();
    },
    isAllowed: function isAllowed() {
        var _forPlan = this.forPlan;
        _forPlan = _forPlan === undefined ? {} : _forPlan;
        var _forPlan$primaryFs = _forPlan.primaryFs;
        _forPlan$primaryFs = _forPlan$primaryFs === undefined ? {} : _forPlan$primaryFs;
        var type = _forPlan$primaryFs.type,
            secondaryFIs = _forPlan.secondaryFIs;


        if (type !== 'CARD' || secondaryFIs !== false) {
            return false;
        }
        return this.allowCardBackup;
    },
    getCheckoutSessionPlan: function getCheckoutSessionPlan() {
        return this.get('parent.fundingOptions.plans.0');
    },
    reevaluateEligibility: function reevaluateEligibility() {
        var _this3 = this;

        (0, _processorDecline.getProcessorDeclineRetryEligibility)(this.id, this.parent).then(function (eligibility) {
            _this3.allowCardBackup = eligibility;

            return eligibility;
        });
    },
    reset: function reset(forPlan) {
        this.setPlan(undefined, forPlan);
    },

    /**
     * resetIfDoesNotApply
     * resets the selected backup for card if no longer valid based on user's choice
     * matches the plan ID if still valid but plan IDs change
     * @param {String} [plan] - current checkout session funding options plan user has selected
     */
    resetIfDoesNotApply: function resetIfDoesNotApply(plan) {
        if (!plan) {
            plan = this.getCheckoutSessionPlan();
        }

        var getKey = function getKey(p) {
            return p && p.primaryFs && p.primaryFs.id;
        };
        var planKey = getKey(plan);
        var forKey = getKey(this.forPlan);

        if (!planKey || planKey !== forKey) {
            return this.reset(plan);
        }

        // Since planIds may change, if backup is still valid then find the new plan
        var plans = this.get('parent.fundingOptions.plans') || [];
        var currentPlanKey = getKey(this.plan);
        var newPlan = currentPlanKey && plans.find(function (p) {
            return getKey(p) === currentPlanKey;
        });

        // If, for whatever reason, the old instrument isn't in the new plans, we'll reset
        if (currentPlanKey && !newPlan) {
            return this.reset(plan);
        }

        this.forPlan = plan;
        this.plan = newPlan;
    }
});

var $CheckoutSessionModel = exports.$CheckoutSessionModel = _squid.$Model.extend('$CheckoutSessionModel', {

    api: new _squid.$Api({
        uri: '/api/checkout/:id/session',
        postAttempts: 2
    }),

    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called
    smartDollarAuthFailed: false, // initial value for smartDollar authorization check

    onPopulate: function onPopulate() {
        this.plan = new $CheckoutPlanModel(this.plan);
        this.shipping = this.child($CheckoutShippingAddressModel, this.shipping);
        this.fundingOptions = this.child($FundingOptionsModel, this.fundingOptions);

        // Reevaluate the eligibility for allowing backup with cards. This can
        // change when the checkout session is updated
        this.cardBackup = this.child($CardBackupModel, this.cardBackup || {});
        _squid.$event.emit('checkoutSessionChange'); // emit a session change event for apps to react accordingly
    },

    /**
     * Finds the plan in billing cases that the user is intending to use as the sticky FI.
     * @return {Object} the instrument representation from futurePaymentInstruments
     */
    getSelectedStickyInstrument: function getSelectedStickyInstrument() {
        // This method doesn't apply for non-billing cases
        if (!this.futurePaymentInstruments) {
            return;
        }

        // For BA no purchase cases (no plan), use either
        // 1. selectedFuturePaymentInstrument (we've made and persisted a selection)
        // 2. first of futurePaymentInstruments (we haven't made a selection and need to save it later)
        if (!(this.plan && this.plan.sources)) {
            return this.selectedFuturePaymentInstrument || this.futurePaymentInstruments[0];
        }

        // Otherwise, if we have a plan list (ie. this is a purchase case),
        // we'll always want to take the currently selected plan,
        // as selectedFuturePaymentInstrument may not be updated to the user's current plan
        var selectedInstrumentId = _squid.$util.some(this.plan.sources, function (fi) {
            return fi.instrument_id ? fi.instrument_id : undefined;
        });

        var stickyInstrument = _squid.$util.find(this.futurePaymentInstruments, function (fi) {
            return fi.instrument_id === selectedInstrumentId;
        });

        return stickyInstrument;
    },

    getPlanList: function getPlanList() {
        // Only show plans that need to be shown.
        return this.fundingOptions && this.fundingOptions.getDisplayPlans();
    },

    // returns true if more than one plan uses BALANCE as the primary FI
    isMultipleBalancePlan: function isMultipleBalancePlan() {
        var matchingBalancePlans = 0;

        return this.fundingOptions && this.fundingOptions.plans && this.fundingOptions.plans.some(function (plan) {
            // if BALANCE is the primary FI...
            if (plan.primaryFs.name === 'BALANCE') {
                // increment number of balance plans found
                matchingBalancePlans++;
            }
            // exit once we have more than one balance plan
            return matchingBalancePlans > 1;
        });
    },

    getDisallowedInstruments: function getDisallowedInstruments() {
        return this.fundingOptions && this.fundingOptions.disallowedInstruments;
    },

    getDisallowedPreferred: function getDisallowedPreferred() {
        var disallowedInstrument = this.getDisallowedInstruments();

        // find only the disallowed instrument that has been marked as preferred.
        disallowedInstrument = disallowedInstrument && _squid.$util.find(disallowedInstrument, function (fi) {
            return fi.isPreferred;
        });

        // if the disallowed instrument is in the plan list (in the case that the instrument has a BUF)
        // we do not show it in the disallowed section.
        var isDisallowedInstrumentInPlanList = disallowedInstrument && _squid.$util.some(this.getPlanList(), function (plan) {
            var instrumentID = plan.primaryFs && plan.primaryFs.id;

            if (instrumentID && disallowedInstrument.id) {
                return instrumentID === disallowedInstrument.id;
            } else {
                return false;
            }
        });

        return !isDisallowedInstrumentInPlanList && disallowedInstrument;
    },

    expiredInstruments: function expiredInstruments() {
        var expiredInstruments = [];
        var disallowedPreferred = this.getDisallowedPreferred();
        var disallowedInstruments = this.getDisallowedInstruments();

        if (disallowedPreferred) {
            expiredInstruments.push(disallowedPreferred);
        }

        _squid.$util.forEach(disallowedInstruments, function (instrument) {
            if (instrument.type === 'CARD' && !instrument.isPreferred && instrument.declineReason === 'unsupportedDueToExpiration') {
                expiredInstruments.push(instrument);
            }
        });

        return expiredInstruments;
    },

    preferredExpiredInstruments: function preferredExpiredInstruments() {
        var disallowedPreferred = this.getDisallowedPreferred();

        if (disallowedPreferred && disallowedPreferred.type === 'CARD' && disallowedPreferred.isPreferred && disallowedPreferred.declineReason === 'unsupportedDueToExpiration') {
            return true;
        }

        return false;
    },

    getShippingAddressMinimalDetails: function getShippingAddressMinimalDetails() {
        return {
            'line1': this.shipping.line1,
            'line2': this.shipping.line2,
            'city': this.shipping.city,
            'state': this.shipping.state,
            'postal_code': this.shipping.postal_code,
            'country_code': this.shipping.country
        };
    }

});

angular.value("$CheckoutCartModel", $CheckoutCartModel);
angular.value("$CheckoutAppDataModel", $CheckoutAppDataModel);
angular.value("$FundingSourceModel", $FundingSourceModel);
angular.value("$FundingOptionsModel", $FundingOptionsModel);
angular.value("serializeInstallmentsOptionsData", serializeInstallmentsOptionsData);
angular.value("$InstallmentOptionsModel", $InstallmentOptionsModel);
angular.value("$FlowEligibilityModel", $FlowEligibilityModel);
angular.value("$CheckoutShippingAddressModel", $CheckoutShippingAddressModel);
angular.value("$ShippingAddressModel", $ShippingAddressModel);
angular.value("$CheckoutPayeeModel", $CheckoutPayeeModel);
angular.value("$CreditOptionsModel", $CreditOptionsModel);
angular.value("$CheckoutShippingAddressesModel", $CheckoutShippingAddressesModel);
angular.value("$CheckoutPlanModel", $CheckoutPlanModel);
angular.value("$CardBackupModel", $CardBackupModel);
angular.value("$CheckoutSessionModel", $CheckoutSessionModel);
_squid.$Class;

_squid.$Model;

_squid.$Api;

_squid.$util;

_squid.$config;

_squid.$locale;

_squid.$event;

_processorDecline.getProcessorDeclineRetryEligibility;

/***/ }),

/***/ "../node_modules/xo-models/src/checkoutIncentive/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$GetPSBOffersModel = exports.$GetOfferProgramModel = exports.$CreateOfferModel = exports.$EvaluateCheckoutOfferEligibilityModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $EvaluateCheckoutOfferEligibilityModel = exports.$EvaluateCheckoutOfferEligibilityModel = _squid.$Model.extend('$EvaluateCheckoutOfferEligibilityModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/offers/evaluate-eligibility',
        postAttempts: 1
    }),

    isEligible: function isEligible() {
        return Boolean(this.eligible);
    },
    getCurrencyCode: function getCurrencyCode() {
        return this.currency_code;
    },
    getOfferProgramCode: function getOfferProgramCode() {
        return this.offer_program_code;
    },
    getOfferProgramID: function getOfferProgramID() {
        return this.offer_program_id;
    },


    // This is of the form $5.00
    getOfferValue: function getOfferValue() {
        return this.offer_value;
    }
});

var $CreateOfferModel = exports.$CreateOfferModel = _squid.$Model.extend('$CreateOfferModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/offers/new',
        postAttempts: 1
    }),

    createdOffer: function createdOffer() {
        return Boolean(this.offer_id);
    },
    getOfferAmountLowestDenom: function getOfferAmountLowestDenom() {
        if (!this.createdOffer() || !this.computation_rules) {
            return;
        }

        return _squid.$util.getProperty(this.computation_rules[0], 'offer_value.value');
    },
    getTxnMinimumLowestDenom: function getTxnMinimumLowestDenom() {
        if (!this.createdOffer()) {
            return;
        }

        return _squid.$util.getProperty(this, 'offer_program_info.applicability_rule.cart_rule.min_cart_total');
    }
});

var $GetOfferProgramModel = exports.$GetOfferProgramModel = _squid.$Model.extend('$GetOfferProgramModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/offers/program'
    }),

    getOfferCurrencyCode: function getOfferCurrencyCode() {
        return _squid.$util.getProperty(this, 'currency_code');
    },


    // NOTE this is in the lowest denominator of the currency
    // For example, $5.00 USD would be returned as 500
    getOfferValueLowestDenom: function getOfferValueLowestDenom() {
        return _squid.$util.getProperty(this.computation_rules[0], 'offer_value.value') || 0;
    },
    getMinCartTotalLowestDenom: function getMinCartTotalLowestDenom() {
        return _squid.$util.getProperty(this, 'applicability_rule.cart_rule.min_cart_total') || 0;
    },
    isUserInApplicableCountry: function isUserInApplicableCountry(userCountry) {
        if (!userCountry) {
            return false;
        }

        var applicableCountries = _squid.$util.getProperty(this, 'applicability_rule.user_rule.user_countries') || [];

        return applicableCountries ? applicableCountries.indexOf(userCountry) >= 0 : false;
    }
});

var $GetPSBOffersModel = exports.$GetPSBOffersModel = _squid.$Model.extend('$GetPSBOffersModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/offers/offers'
    }),

    // If an offer is returned in the resource_list, it is active; in this
    // case we do not want to give the user another incentive
    hasActiveOffer: function hasActiveOffer() {
        return Boolean(this.resource_list && this.resource_list.length);
    },


    // Check if the user has an offer belonging to this specific offer program
    hasActiveCheckoutIncentive: function hasActiveCheckoutIncentive(offer_program_id) {
        return offer_program_id && this.hasActiveOffer() && this.resource_list.some(function (offer) {
            return offer.offer_program_id === offer_program_id;
        });
    },


    // Check if the user has an offer with the passed in redemption code
    // NOTE this is necessary because planning does not return which program
    // an incentive is from if the incentive is being used in the transaction.
    // The only identifier is the redemption code
    hasOfferWithRedemptionCode: function hasOfferWithRedemptionCode(redemption_code) {
        return redemption_code && this.hasActiveOffer() && this.resource_list.some(function (offer) {
            return offer.redemption_code === redemption_code;
        });
    }
});

angular.value("$EvaluateCheckoutOfferEligibilityModel", $EvaluateCheckoutOfferEligibilityModel);
angular.value("$CreateOfferModel", $CreateOfferModel);
angular.value("$GetOfferProgramModel", $GetOfferProgramModel);
angular.value("$GetPSBOffersModel", $GetPSBOffersModel);
_squid.$Model;

_squid.$Api;

_squid.$util;

/***/ }),

/***/ "../node_modules/xo-models/src/choice/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ChoiceEligibility = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _experiments = __webpack_require__("../node_modules/xo-models/src/experiments/index.js");

var Experiments = _interopRequireWildcard(_experiments);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

// Variants:
// control
// 5 - If any choice treatment, do 5 unless 5 is ineligible
// 6 - If any choice treatment, do 6 if 5 is ineligible and 6 is eligible

var checkPPCInstallments = function checkPPCInstallments(token, _ref) {
    var checkoutSessionModel = _ref.checkoutSessionModel,
        checkoutPayeeModel = _ref.checkoutPayeeModel,
        checkoutCartModel = _ref.checkoutCartModel,
        checkoutAppDataModel = _ref.checkoutAppDataModel;

    // Check for installments - has credit in wallet, has credit offer in checkout session, and has installment options
    if (checkoutSessionModel.fundingOptions.hasCredit() && checkoutSessionModel.creditInstallmentOffer && (0, _squid.$feature)('creditInstallmentOffers')) {
        var installmentOptions = _checkout.$InstallmentOptionsModel.instance(token);

        return installmentOptions.save({
            cache: true, // Cache response for selectFi page or wherever needed
            data: {
                payee: checkoutPayeeModel,
                checkoutCart: checkoutCartModel,
                checkoutAppData: checkoutAppDataModel,
                isMemberCredit: true
            },
            success: function success(result) {
                var offers = result.installments && result.installments[0];
                var hasInstallments = offers && offers.installment_options && offers.installment_options.length;

                return hasInstallments;
            },
            contingencies: {
                DEFAULT: function DEFAULT(message) {
                    // Assume is eligible if contingency
                    _logger.$logger.info('installments_contingency', {
                        message: message
                    });
                    return false;
                }
            },
            error: function error(err) {
                _logger.$logger.info('installments_error', err);
                return false;
            }
        });
    } else {
        return _squid.$promise.resolve(false);
    }
};

// Main logic to decide choice eligibility
var decideEligibility = function decideEligibility(token, _ref2) {
    var authModel = _ref2.authModel,
        checkoutCartModel = _ref2.checkoutCartModel,
        checkoutSessionModel = _ref2.checkoutSessionModel,
        checkoutAppDataModel = _ref2.checkoutAppDataModel,
        checkoutPayeeModel = _ref2.checkoutPayeeModel;
    var fundingOptions = checkoutSessionModel.fundingOptions;

    var plans = checkoutSessionModel.get('fundingOptions.plans');

    // Reasons for a transaction to be ineligible:
    //  - Doesn't meet pxp
    //  - is billing
    //  - is split balance
    //  - balance covers full transaction but does not have preferred set
    //  - has PAD
    //  - is second button
    //  - is not US
    //  - has currency conversion
    //  - is not a merchant account
    //  - is a Third Party transaction (Venmo, Baidu, etc...)

    // Check to see if any plans include split balance
    var splitBalance = plans && plans.some(function (option) {
        return option.primaryFs && option.secondaryFIs;
    });
    var billing = checkoutCartModel.isBilling();
    var PAD = plans && plans.some(function (option) {
        return option.primaryFs && option.primaryFs.subtype === 'PAD';
    });
    var secondButton = checkoutAppDataModel.is_second_button_txn;
    var hasMerchantCountryChoice = (0, _squid.$feature)('choiceExperiment', false, checkoutAppDataModel.merchant.merchant_country);
    var fullBalance = plans && plans.some(function (option) {
        return option.primaryFs && option.primaryFs.type === 'BALANCE';
    });
    var hasPreferred = fundingOptions && fundingOptions.getPreferred();
    var isNotMerchantAccount = authModel.account_type !== 2;
    var isNotAndroidPay = !checkoutCartModel.isWalletTokenization();
    var isNotFbBaFlow = !_squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
    var isThirdPartyWalletTransaction = _thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(token);
    var isNotGambling = !checkoutPayeeModel.isGambling();
    var isNotBaDisableStickyForMerchant = !(checkoutCartModel.isBillingNoPurchase() && checkoutPayeeModel.isOnBaNoStickyList());
    var involvedCurrencies = {};

    if (checkoutCartModel.get('purchase.amounts.total.currency_code') && plans) {
        involvedCurrencies[checkoutCartModel.purchase.amounts.total.currency_code] = 1;
        plans.forEach(function (option) {
            involvedCurrencies[option.primaryFs.amount.currency_code] = 1;
        });
    }

    var singleCurrency = Object.keys(involvedCurrencies).length <= 1;

    var choiceVariantsName = 'xo_hermes_choice_variant(?:_preferred_newusers)?_treatment_?(.*)';

    // checking if pad is to avoid calls to PXP
    var padToggleFeatureCheck = PAD ? Experiments.padToggleFeatureSupported() : _squid.$promise.resolve(false);

    // Check the global preferred experiment and the choice variant.
    // User must pass the global preferred experiment to be eligible to see a variant
    // Forced pxp call in case logged in user is different
    var _$config$choiceExperi = _squid.$config.choiceExperiment;
    _$config$choiceExperi = _$config$choiceExperi === undefined ? {} : _$config$choiceExperi;
    var _$config$choiceExperi2 = _$config$choiceExperi.stillInPxpRampCountries,
        stillInPxpRampCountries = _$config$choiceExperi2 === undefined ? [] : _$config$choiceExperi2,
        _$config$choiceExperi3 = _$config$choiceExperi.ignored;
    _$config$choiceExperi3 = _$config$choiceExperi3 === undefined ? {} : _$config$choiceExperi3;
    var _$config$choiceExperi4 = _$config$choiceExperi3.multipleFi,
        multipleFiIgnored = _$config$choiceExperi4 === undefined ? [] : _$config$choiceExperi4,
        _$config$choiceExperi5 = _$config$choiceExperi3.selectFi,
        selectFiIgnored = _$config$choiceExperi5 === undefined ? [] : _$config$choiceExperi5;


    var getPxp = function getPxp() {
        return stillInPxpRampCountries.indexOf(_squid.$locale.country) === -1 ? 'already_ramped' : (0, _squid.$pxp)('xo_hermes_choice_variant', {}, choiceVariantsName, true, true);
    };

    return _squid.$promise.all([getPxp(), padToggleFeatureCheck]).then(function (_ref3) {
        var choiceVariant = _ref3[0],
            isPadToggleFeatureSupported = _ref3[1];

        // Check transaction eligibility
        var eligibilityCriteria = {
            pxpVariant: choiceVariant,
            noBilling: !billing,
            noSplitBalance: !splitBalance,
            balanceWithPreferred: !(fullBalance && !hasPreferred),
            noPAD: !PAD || isPadToggleFeatureSupported,
            noSecondButton: !secondButton,
            hasMerchantCountryChoice: hasMerchantCountryChoice,
            singleCurrency: singleCurrency,
            noMerchant: isNotMerchantAccount,
            noAndroidPay: isNotAndroidPay,
            isNotFbBaFlow: isNotFbBaFlow,
            noThirdPartyWalletTransactions: !isThirdPartyWalletTransaction,
            isNotGambling: isNotGambling,
            isNotBaDisableStickyForMerchant: isNotBaDisableStickyForMerchant
        };
        // First check to see if transaction is eligible for choice at all.
        // Base eligibility check follows the selectFi eligibility
        var choiceIneligibleReasons = Object.keys(eligibilityCriteria).filter(function (key) {
            return selectFiIgnored.indexOf(key) === -1 && !eligibilityCriteria[key];
        });
        var transactionEligible = choiceIneligibleReasons.length === 0;

        if (!transactionEligible) {
            _logger.$logger.info('choice_experiment_ineligible', {
                failed: choiceIneligibleReasons.join()
            });

            _logger.$logger.info('checkout_fpti', {
                from: 'CHOICE_ELG_CHK',
                to: 'process_choice_elg_chk',
                eligibility_reason: 'pxp_control-' + choiceIneligibleReasons.join()
            });

            return 'control';
        }

        // If eligible for choice, check if transaction is eligible for multipleFi variant
        return checkPPCInstallments(token, {
            checkoutCartModel: checkoutCartModel,
            checkoutSessionModel: checkoutSessionModel,
            checkoutAppDataModel: checkoutAppDataModel,
            checkoutPayeeModel: checkoutPayeeModel
        }).then(function (hasPPCInstallments) {
            var validCountryForMultipleFi =
            // IN requires CVV collection, multipleFi variant does not have yet
            _squid.$locale.country !== 'IN';
            var hasInstallments = plans && plans.some(function (plan) {
                return plan.installments;
            });

            var multipleFiEligibility = (0, _angular.extend)({
                // Have not built method to select PPC installments for multipleFi
                creditInstallments: !hasPPCInstallments,
                validCountryForMultipleFi: validCountryForMultipleFi,
                noInstallments: !hasInstallments
            }, eligibilityCriteria);
            var multipleFiIneligibleReasons = Object.keys(multipleFiEligibility).filter(function (criteria) {
                return multipleFiIgnored.indexOf(criteria) === -1 && !multipleFiEligibility[criteria];
            }).join();
            var multipleFiEligible = multipleFiIneligibleReasons.length === 0;

            if (!multipleFiEligible) {
                _logger.$logger.info('choice_experiment_var5_ineligible', {
                    failed: multipleFiIneligibleReasons
                });

                _logger.$logger.info('checkout_fpti', {
                    from: 'CHOICE_ELG_CHK',
                    to: 'process_choice_elg_chk',
                    eligibility_reason: 'pxp_6-' + multipleFiIneligibleReasons
                });

                return '6';
            }

            _logger.$logger.info('choice_experiment_eligible', {
                variant: '5'
            });

            _logger.$logger.info('checkout_fpti', {
                from: 'CHOICE_ELG_CHK',
                to: 'process_choice_elg_chk',
                eligibility_reason: 'pxp_treatment'
            });

            return '5';
        });
    });
};

var promiseControl = _squid.$promise.resolve('control');

var $ChoiceEligibility = exports.$ChoiceEligibility = _squid.$Model.extend('$ChoiceEligibility', {
    getVariant: function getVariant(token) {
        var _this = this;

        if (!(0, _squid.$feature)('choiceExperiment')) {
            return promiseControl;
        }

        var models = {};

        return (0, _squid.$populate)(models, {
            authModel: _auth.$AuthModel.instance(),
            checkoutCartModel: _checkout.$CheckoutCartModel.instance(token),
            checkoutPayeeModel: _checkout.$CheckoutPayeeModel.instance(token),
            checkoutSessionModel: _checkout.$CheckoutSessionModel.instance(token),
            checkoutAppDataModel: _checkout.$CheckoutAppDataModel.instance(token)
        }).then(function () {
            // If user logged in is the same, we don't need the pxp call so we can skip the decision making logic
            if (_this.variant && models.authModel.buyer_id === _this.buyerId) {
                return _this.variant;
            }

            _this.variant = decideEligibility(token, models);
            _this.buyerId = models.authModel.buyer_id;

            return _this.variant;
        });
    }
});

angular.value("$ChoiceEligibility", $ChoiceEligibility);
_angular.extend;

_squid.$Model;

_squid.$pxp;

_squid.$promise;

_squid.$populate;

_squid.$config;

_squid.$feature;

_squid.$integration;

_squid.$locale;

_logger.$logger;

_auth.$AuthModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutAppDataModel;

_checkout.$InstallmentOptionsModel;

_thirdPartyInfo.thirdPartyExperience;

/***/ }),

/***/ "../node_modules/xo-models/src/credit/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$CreditInstallmentOptionsModel = exports.$CreditInstallmentModel = exports.$CreditDataModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var $CreditDataModel = exports.$CreditDataModel = _squid.$Model.extend('$CreditDataModel', {
    init: function init() {
        this._super.init.apply(this);
        this.setProperties({
            flow_type: _squid.$util.param('flow'),
            cape_key: _squid.$util.param('key'),
            cape_success: _squid.$util.param('success'),
            credit_signup: _squid.$util.param('creditSignup'),
            userAction: _squid.$util.param('action'),
            merchantAction: _squid.$util.param('merchantAction'),
            credit_login_failure: false,
            cape_service_error: _squid.$util.param('isInternalServiceError'),
            cape_redirect_uri: '',
            change_installment: _squid.$util.param('changeStatus'),
            nextState: ''
        });
    },

    api: new _squid.$Api({
        uri: '/api/credit/:id/creditData',
        postAttempts: 2
    }),

    isCreditSignup: function isCreditSignup() {
        return this.credit_signup && this.credit_signup === 'true';
    },

    setCapeRedirectUri: function setCapeRedirectUri(input) {
        this.cape_redirect_uri = input;
    },

    getCapeRedirectUri: function getCapeRedirectUri() {
        return this.cape_redirect_uri;
    },

    getMerchantAction: function getMerchantAction() {
        return this.merchantAction || '';
    },

    setCreditSignup: function setCreditSignup(input) {
        this.credit_signup = input;
    },

    getCapeKey: function getCapeKey() {
        return this.cape_key;
    },

    getFlow: function getFlow() {
        if (this.userAction === 'addCredit') {
            return 'credit';
        }
        return this.flow_type;
    },
    setFlow: function setFlow(flowType) {
        this.flow_type = flowType;
    },

    setNextState: function setNextState(nextState) {
        this.nextState = nextState;
    },

    isCapeSuccess: function isCapeSuccess() {
        return this.cape_success && this.cape_success === 'true';
    },

    isCreditTxn: function isCreditTxn() {
        return this.flow_type && this.flow_type === 'credit' || this.userAction && this.userAction === 'addCredit';
    },

    setCreditLoginFailure: function setCreditLoginFailure(input) {
        this.credit_login_failure = input;
    },

    getCreditLoginFailure: function getCreditLoginFailure() {
        return this.credit_login_failure;
    },

    isCapeReturn: function isCapeReturn() {
        return this.flow_type && this.flow_type === 'capeReturn';
    },

    isCapeInternalServiceError: function isCapeInternalServiceError() {
        return this.cape_service_error && this.cape_service_error === 'true';
    },

    getNextState: function getNextState() {
        return this.nextState;
    },

    isChangeStatus: function isChangeStatus() {
        return this.change_installment === 'changeInstallment';
    },

    isRedirectFromCape: function isRedirectFromCape() {
        return Boolean(this.cape_key && this.cape_success === 'true' || _squid.$util.param('applyCredit'));
    }
});

var $CreditInstallmentModel = exports.$CreditInstallmentModel = _squid.$Model.extend('$CreditInstallmentModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/creditOptions/'
    })
});

var $CreditInstallmentOptionsModel = exports.$CreditInstallmentOptionsModel = _squid.$Model.extend('$CreditInstallmentOptionsModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/installmentOptions/',
        postAttempts: 2
    }),

    init: function init() {
        this.setProperties({
            installmentOffers: [],
            installmentCount: 0,
            installmentOptionsPresent: false,
            niOffer: [],
            niOfferPresent: false
        });
        this.meta = {
            populated: false
        };
    },

    onPopulate: function onPopulate() {
        if (this.installments && this.installments[0]) {
            this.storeInstallments();
        } else {
            _logger.$logger.log('No installments offer');
        }
    },

    storeInstallments: function storeInstallments() {

        this.installmentOffers = this.installments && this.installments[0];
        this.installmentCount = this.installmentOffers.installment_options && this.installmentOffers.installment_options.length;
        this.installmentOptionsPresent = this.installmentCount > 0;
        this.niOfferPresent = this.installmentOffers.sac_options && this.installmentOffers.sac_options.creditType;
        this.niOffer = this.niOfferPresent && this.installmentOffers.sac_options;
    },

    getCacheKey: function getCacheKey() {
        var cacheKey = {};

        if (this.cacheParam) {
            this.cacheParam.forEach(function (element) {
                if (typeof element.value !== 'undefined') {
                    cacheKey[element.name] = element.value.toString();
                }
            });
        }
        return cacheKey;
    },

    getInstallmentOptionsPresent: function getInstallmentOptionsPresent() {
        return this.installmentOptionsPresent;
    },

    getInstallmentOffers: function getInstallmentOffers() {
        return this.installmentOffers;
    },

    getInstallmentCount: function getInstallmentCount() {
        return this.installmentCount;
    },

    getNiOffer: function getNiOffer() {
        return this.niOffer;
    },

    getNiOfferPresent: function getNiOfferPresent() {
        return this.niOfferPresent;
    },

    serialize: function serialize() {
        var data = {
            payee: this.payee,
            checkoutCart: this.checkoutCart,
            checkoutAppData: this.checkoutAppData,
            isMemberCredit: true
        };

        return (0, _checkout.serializeInstallmentsOptionsData)(data);
    },
    save: function save(options) {
        options.data = this.serialize();

        return this._super.save.call(this, options);
    }
});

angular.value("$CreditDataModel", $CreditDataModel);
angular.value("$CreditInstallmentModel", $CreditInstallmentModel);
angular.value("$CreditInstallmentOptionsModel", $CreditInstallmentOptionsModel);
_squid.$Model;

_squid.$Api;

_squid.$util;

_logger.$logger;

_checkout.serializeInstallmentsOptionsData;

/***/ }),

/***/ "../node_modules/xo-models/src/donation/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$GiveAtCheckoutModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $GiveAtCheckoutModel = exports.$GiveAtCheckoutModel = _squid.$Model.extend('$GiveAtCheckoutModel', {
    api: new _squid.$Api({
        uri: '/api/donation',
        postAttempts: 2
    })
});

angular.value("$GiveAtCheckoutModel", $GiveAtCheckoutModel);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/eligibility/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$stickyCTA = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _gdprCookieBanner = __webpack_require__("../node_modules/xo-models/src/gdprCookieBanner/index.js");

var checkEligibility = function checkEligibility() {
    var token = _angular.$rootScope.token;
    var models = {};

    return _squid.$promise.all([(0, _squid.$populate)(models, {
        checkoutCartModel: _checkout.$CheckoutCartModel.instance(token),
        checkoutSessionModel: _checkout.$CheckoutSessionModel.instance(token),
        checkoutAppDataModel: _checkout.$CheckoutAppDataModel.instance(token)
    }), _gdprCookieBanner.$GDPRCookieBannerModel.instance().hasBanner()]).then(function () {
        // Device Checks
        var userAgent = _angular.$window.navigator.userAgent;
        var isIE = !!userAgent.match(/MSIE|trident|edge/i);
        var isMobile = _index.$DeviceInfo.isMobile();
        var miniBrowser = _angular.$rootScope.miniBrowser;
        var isValidTraffic = isMobile || miniBrowser;
        var isSmallScreen = _angular.$window.innerWidth <= 600;

        // Flow Checks
        var billing = models.checkoutCartModel.isBilling();
        var invoice = models.checkoutAppDataModel.get('flags.is_invoice_flow');
        var upop = models.checkoutSessionModel.unconfirmed_upop;
        var gpdr = _gdprCookieBanner.$GDPRCookieBannerModel.instance().shown();

        // Feature checks
        var eligibleCountry = (0, _squid.$feature)('stickyCTA');

        var decision = isValidTraffic && eligibleCountry && isSmallScreen && !billing && !invoice && !upop && !isIE && !gpdr;

        _logger.$logger.info('xoStickyCta_eligibility', {
            isMobile: isMobile,
            miniBrowser: miniBrowser,
            isValidTraffic: isValidTraffic,
            isSmallScreen: isSmallScreen,
            isIE: isIE,
            upop: upop,
            invoice: invoice,
            gpdr: gpdr,
            billing: billing,
            eligibleCountry: eligibleCountry,
            decision: decision
        });

        return decision;
    });
};

var checkPxp = function checkPxp() {
    var _$CheckoutAppDataMode = _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
        merchant = _$CheckoutAppDataMode.merchant;

    var country = merchant && merchant.merchant_country;

    return (0, _squid.$pxp)('xo_hermesnode_config', { 'ctx.COUNTRY': country }, 'xo_hermesnode_sticky_cta_(.*)', false, true).then(function (treatment) {
        if (treatment) {
            var test = /xo_hermesnode_sticky_cta_(.*)/g;
            var name = treatment && treatment.treatment_name;
            var treatmentTest = test.exec(name);
            var treatmentName = treatmentTest.length > 1 && treatmentTest[1];

            _logger.$logger.info('xoStickyCta_pxp', { name: name });
            return treatmentName;
        }
        return '';
    });
};

var mapper = function mapper(eligibility, treatment) {
    var variant = {
        'treatmentA': 'bottom',
        'treatmentB': 'top',
        'control': '',
        'DEFAULT': ''
    };
    var result = variant[treatment] || variant.DEFAULT;

    _logger.$logger.info('xoStickyCta_mapper', { result: result });
    return result;
};

/**
 * To be replaced by $EligibilityClass.
 * Following new EligibilityClass pattern.
*/
var $stickyCTA = exports.$stickyCTA = _squid.$Model.extend('$stickyCTA', {
    getEligibility: function getEligibility() {
        return checkEligibility().then(function (eligibility) {
            if (eligibility) {
                return checkPxp().then(function (treatment) {
                    return mapper(eligibility, treatment);
                });
            } else {
                return '';
            }
        });
    }
});

angular.value("$stickyCTA", $stickyCTA);
_angular.$rootScope;

_angular.$window;

_logger.$logger;

_squid.$Model;

_squid.$populate;

_squid.$pxp;

_squid.$feature;

_squid.$promise;

_index.$DeviceInfo;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutAppDataModel;

_gdprCookieBanner.$GDPRCookieBannerModel;

/***/ }),

/***/ "../node_modules/xo-models/src/experiments/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.padToggleWalletSupported = exports.padToggleFeatureSupported = exports.PAD_CHECKBOX_SUPPORTED_PXP_ENABLED_COUNTRIES = exports.PAD_CHECKBOX_SUPPORTED_VALID_TREATMENTS = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var PAD_CHECKBOX_SUPPORTED_VALID_TREATMENTS = exports.PAD_CHECKBOX_SUPPORTED_VALID_TREATMENTS = ['xo_hermesnode_pad_2_ui_rollout'];
var PAD_CHECKBOX_SUPPORTED_PXP_ENABLED_COUNTRIES = exports.PAD_CHECKBOX_SUPPORTED_PXP_ENABLED_COUNTRIES = ['AU'];

/*
    * Returns the feature configuration
    *
    * If the country its part of the countries in the list of pxp enabled countries
    * we will check first if the treatment its enabled before calling the feature.
    *
    * if the treatment its not enabled we will return false for this feature.
    *
    * otherwise we will just return whatever is configured on the feature
*/
var _getPad2Feature = function _getPad2Feature(feature) {
    var country = _squid.$locale.country;


    if (PAD_CHECKBOX_SUPPORTED_PXP_ENABLED_COUNTRIES.includes(country)) {
        // if the contry is AU we want to check that the experiment its enabled before returning the config values
        return (0, _squid.$pxp)('xo_hermesnode_pad_2_ui_' + country, PAD_CHECKBOX_SUPPORTED_VALID_TREATMENTS.join('|'), undefined, false, true).then(function (pxpResponse) {
            // If the pxp has a valid treatment then enable based on the configs
            // this will enable to enable/disable the new pad experience with an experiment and configs
            if (pxpResponse) {
                return (0, _squid.$feature)(feature, false, country);
            }
            return false;
        });
    }
    return _squid.$promise.resolve((0, _squid.$feature)(feature, false, country));
};

var padToggleFeatureSupported = exports.padToggleFeatureSupported = function padToggleFeatureSupported() {
    return _getPad2Feature('padToggleFeatureSupported');
};

var padToggleWalletSupported = exports.padToggleWalletSupported = function padToggleWalletSupported() {
    return _getPad2Feature('padToggleWalletSupported');
};

_squid.$feature;

_squid.$locale;

_squid.$pxp;

_squid.$promise;

/***/ }),

/***/ "../node_modules/xo-models/src/fi/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$CardInfoModel = exports.$WalletInstrumentNameMapping = exports.$WalletPreferences = exports.$ResolveOTP = exports.$Resolve3DS = exports.$CardTypeFromBinModel = exports.$BillingAddressesModel = exports.$CurrencyConversionModel = exports.$BillingAddressModel = exports.$AddBillingAddressModel = exports.$DeleteCardModel = exports.$SepaModel = exports.$PreferredFi = exports.$AddBankModel = exports.$BankModel = exports.$CardTypesModel = exports.$UnavailableCardModel = exports.$AddCardModel = exports.$CardModel = undefined;

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var BILLING_ADDRESS_FORMAT = {
    DEFAULT: {
        ',': ', ',
        ' ': ' '
    },
    IL: {
        he: {
            ',': '‏, ‏',
            ' ': '‏ ‏'
        }
    }
};

var $CardModel = exports.$CardModel = _squid.$Model.extend('$CardModel', {
    serialize: function serialize() {
        return {
            type: this.type,
            number: this.number.replace(/[^\d]+/g, ''),
            security_code: this.security_code,
            expiry_month: this.expiry_month && _squid.$util.pad(this.expiry_month, 2),
            expiry_year: this.expiry_year,
            issue_number: this.issue_number ? this.issue_number : undefined,
            start_month: this.start_month ? _squid.$util.pad(this.start_month, 2) : undefined,
            start_year: this.start_year ? this.start_year : undefined
        };
    },

    last4: function last4() {
        var cardNumber = this.number;

        return cardNumber.substr(cardNumber.length - 4);
    },

    isExisting: function isExisting() {
        return this.number && Boolean(this.number.match(/^xxxx-xxxx-xxxx-[\d]{4}$/));
    }
});

var $AddCardModel = exports.$AddCardModel = _squid.$Model.extend('$AddCardModel', {
    api: new _squid.$Api({
        uri: '/api/fi/card/:id?'
    }),

    init: function init() {
        this._super.init.apply(this);
        this.card = new $CardModel();
    },

    serialize: function serialize() {
        var id = this.address.id && this.address.id !== '0' ? this.address.id : undefined;

        return {
            cardType: this.cardType ? this.cardType : 'creditCard',
            sponsor_id: this.sponsor_id,
            preference: this.preference,
            user: this.user,
            card: this.card.serialize(),
            address: id ? {
                id: id
            } : this.address.serialize()
        };
    },

    clearId: function clearId() {
        delete this.id;
    }
});

var $UnavailableCardModel = exports.$UnavailableCardModel = _squid.$Model.extend('$UnavailableCardModel', {
    api: new _squid.$Api({
        uri: '/api/fi/unavailable/card?addFIContingency'
    })
});

var $CardTypesModel = exports.$CardTypesModel = _squid.$Model.extend('$CardTypesModel', {
    api: new _squid.$Api({
        uri: '/api/fi/card/types?country=:country&token=:token'
    }),

    retrieve: function retrieve() {
        return this._super.retrieve.apply(this, arguments).then(function (result) {
            this.disallowedCards = (0, _squid.$feature)('disallowedCards', undefined, this.country);
            // override disallowed cards with card types config list based on country
            if (this.disallowedCards) {
                result.disallowed = this.disallowedCards.cardTypes;
            }
            return result;
        });
    },

    supportedNames: function supportedNames() {
        if (typeof this.allowed === 'undefined') {
            return;
        }

        return this.allowed.map(function (type) {
            return _squid.$locale.content.cardTypes[type];
        });
    },

    unsupportedNames: function unsupportedNames() {
        if (typeof this.disallowed === 'undefined') {
            return;
        }

        return this.disallowed.map(function (type) {
            return _squid.$locale.content.cardTypes[type];
        });
    }
});

var $BankModel = exports.$BankModel = _squid.$Model.extend('$BankModel', {
    init: function init() {
        this._super.init.apply(this);
        this.bank_account_number = '';
        this.bank_routing_number = '';
        this.iban_number = '';
    },

    serialize: function serialize() {
        var data = {};

        if (this.bank_account_number) {
            data.bank_account_number = this.bank_account_number;
        }
        if (this.bank_routing_number) {
            data.bank_routing_number = this.bank_routing_number;
        }
        if (this.iban_number) {
            data.iban_number = this.iban_number.replace(/\s/g, '').toUpperCase();
        }
        return data;
    }
});

var $AddBankModel = exports.$AddBankModel = _squid.$Model.extend('$AddBankModel', {
    api: new _squid.$Api({
        uri: '/api/fi/bank'
    }),

    init: function init() {
        this._super.init.apply(this);
        this.user = this.user || {
            first_name: '',
            dob_day: '',
            dob_month: '',
            dob_year: '',
            currency_code: '',
            country: ''
        };
        this.bank = this.bank || new $BankModel();
        this.address = this.address || {};
        this.creditorDetails = this.creditorDetails || {};
        this.fiDetails = this.fiDetails || {};
    },

    getBankData: function getBankData() {
        var data = {};

        // Set user info
        data.user = this.user;

        // Set bank info
        var bank = {};

        this.bank = this.bank || {};

        if (this.candidate_id) {
            data.candidate_id = this.candidate_id;
        }

        if (this.bank.bank_account_number) {
            bank.bank_account_number = this.bank.bank_account_number;
        }

        if (this.bank.bank_routing_number) {
            bank.bank_routing_number = this.bank.bank_routing_number;
        }

        if (this.bank.iban_number) {
            bank.iban_number = this.bank.iban_number.replace(/\s/g, '');
        }
        data.bank = bank;

        // Set address info
        if (this.address) {
            data.address = {
                line1: this.address.line1,
                line2: this.address.line2,
                city: this.address.city,
                country: this.address.country,
                postal_code: this.address.postal_code
            };
        }

        return data;
    }
});

var $PreferredFi = exports.$PreferredFi = _squid.$Model.extend('$PreferredFi', {
    api: new _squid.$Api({
        uri: '/api/fi/preferred'
    }),

    init: function init() {
        this._super.init.apply(this);

        // Get the type of device to send to FI for logging
        function getUiChannel() {
            var capabilities = _index.$DeviceInfo.getCapabilities();

            if (capabilities.isTablet) {
                return 'Tablet';
            } else if (capabilities.isMobile) {
                return 'Mobile';
            } else if (capabilities.isDesktop) {
                return 'Desktop';
            } else if (capabilities.isApp) {
                return 'App';
            } else {
                return null;
            }
        }

        this.uiChannel = getUiChannel();
    },

    serialize: function serialize() {
        return {
            preferred: this.preferred,
            uiChannel: this.uiChannel
        };
    }
});

var $SepaModel = exports.$SepaModel = _squid.$Model.extend('$SepaModel', {
    api: new _squid.$Api({
        uri: '/api/fi/bank'
    })
});

var $DeleteCardModel = exports.$DeleteCardModel = _squid.$Model.extend('$DeleteCardModel', {
    api: new _squid.$Api({
        uri: '/api/fi/card/:id/delete'
    })
});

var $AddBillingAddressModel = exports.$AddBillingAddressModel = _squid.$Model.extend('$AddBillingAddressModel', {
    api: new _squid.$Api({
        uri: '/api/fi/:instrumentid/addbillingaddress'
    })
});

var $BillingAddressModel = exports.$BillingAddressModel = _squid.$Model.extend('$BillingAddressModel', {
    api: new _squid.$Api({
        uri: '/api/fi/billingaddress/validate'
    }),

    format: function format() {

        var langConfig = (BILLING_ADDRESS_FORMAT[_squid.$locale.country] || {})[_squid.$locale.lang] || {};

        var comma = angular.isUndefined(langConfig[',']) ? BILLING_ADDRESS_FORMAT['DEFAULT'][','] : langConfig[','];
        var space = angular.isUndefined(langConfig[' ']) ? BILLING_ADDRESS_FORMAT['DEFAULT'][' '] : langConfig[' '];

        return _squid.$util.filter([this.line1, this.line2, this.city, this.state, this.country]).join(comma) + space + _squid.$util.filter([this.postal_code]);
    },

    serialize: function serialize() {
        return {
            line1: this.line1 && this.line1.trim(),
            line2: this.line2 && this.line2.trim(),
            city: this.city && this.city.trim(),
            state: this.state && this.state.trim(),
            postal_code: this.postal_code && this.postal_code.trim(),
            normalization_status: this.normalization_status,
            country: this.country
        };
    }
});

var $CurrencyConversionModel = exports.$CurrencyConversionModel = _squid.$Model.extend('$CurrencyConversionModel', {
    api: new _squid.$Api({
        uri: '/api/fi/currencyConversion'
    })
});

var $BillingAddressesModel = exports.$BillingAddressesModel = _squid.$Model.extend('$BillingAddressesModel', {
    api: new _squid.$Api({
        uri: '/api/fi/billingaddress'
    }),

    onPopulate: function onPopulate() {
        this.addresses = this.children($BillingAddressModel, this.addresses);
    }
});

var $CardTypeFromBinModel = exports.$CardTypeFromBinModel = _squid.$Model.extend('$CardTypeFromBinModel', {
    api: new _squid.$Api({
        uri: '/api/fi/cardTypeFromBin'
    })
});

var $Resolve3DS = exports.$Resolve3DS = _squid.$Model.extend('$Resolve3DS', {
    api: new _squid.$Api({
        uri: '/api/fi/3ds/:id'
    })
});

var $ResolveOTP = exports.$ResolveOTP = _squid.$Model.extend('$ResolveOTP', {
    api: new _squid.$Api({
        uri: '/api/fi/otp/:id'
    })
});

var $WalletPreferences = exports.$WalletPreferences = _squid.$Model.extend('$WalletPreferences', {
    api: new _squid.$Api({
        uri: '/api/fi/wallet/preferences'
    }),

    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called

    init: function init() {
        this._super.init.apply(this);
        this.topup = {};
        this.direct = {};
    },

    serialize: function serialize() {
        var data = {};

        if (this.topup.amount) {
            var _topup = this.topup,
                amount = _topup.amount,
                _topup$fundingSource = _topup.fundingSource;
            _topup$fundingSource = _topup$fundingSource === undefined ? {} : _topup$fundingSource;
            var instrument_id = _topup$fundingSource.instrument_id;

            // Set the Topup funding instrument in the wallet preference api, which will be used by future Topup transactions

            data.topup = {
                amount: amount,
                instrument_id: instrument_id,
                autoload_minimum_threshold: _squid.$config.topup.autoload_minimum_threshold
            };
        } else {
            var _direct$fundingSource = this.direct.fundingSource;
            _direct$fundingSource = _direct$fundingSource === undefined ? {} : _direct$fundingSource;
            var _instrument_id = _direct$fundingSource.instrument_id;

            // Set the Direct funding instrument in the wallet preference api, which will be used by future Direct funding transactions

            data.direct = {
                instrument_id: _instrument_id,
                currency_code: this.currency
            };
        }
        return data;
    },

    /**
        * Return the preferred topup/direct fundingsource.
        * Originally values of topup & direct are from the FI wallet preferences api, which gets assigned during the init() call.
        * Values can be changed in the Review and the Wallet pages.
        */
    getPreferred: function getPreferred() {
        if (this.topup.fundingSource && this.topup.fundingSource.instrument_id) {
            // xo-hermes-fi will always return topup.fundingSource even when there is no preferred topup instrument, hence making the additional check here.
            return this.topup.fundingSource;
        } else {
            return this.direct.fundingSource || {};
        }
    }
});

var $WalletInstrumentNameMapping = exports.$WalletInstrumentNameMapping = _squid.$Model.extend('$WalletInstrumentNameMapping', {
    init: function init() {
        this._super.init.apply(this);
        this.INSTRUMENT_MAP = {
            AMSOUTH: /AMSOUTH,/,
            BOFA: /BANK OF AMERICA/,
            CAPITAL: /CAPITAL/,
            CHASE: /CHASE/,
            CITI: /CITIBANK/,
            FIFTHTHIRD: /FIFTH THIRD BANK/,
            HUNTINGTON: /HUNTINGTON/,
            INGDIRECT: /ING DIRECT/,
            NATIONALCITY: /NATIONAL CITY/,
            PNC: /PNC/,
            REGIONS: /REGIONS/,
            SUNTRUST: /SUNTRUST/,
            TDWATERHOUSE: /TD WATERHOUSE/,
            USAA: /USAA/,
            USBANK: /US BANK/,
            VISA: /VISA/,
            WAMUTUAL: /WASHINGTON MUTUAL/,
            WELLSFARGO: /WELLS FARGO/
        };
        this.INSTRUMENT_NAMES = Object.keys(this.INSTRUMENT_MAP);
    },

    getInstrumentNameNormalized: function getInstrumentNameNormalized(fsName) {
        var _this = this;

        if (!fsName) {
            return;
        }

        fsName = fsName.toUpperCase();

        return _squid.$util.find(this.INSTRUMENT_NAMES, function (instName) {
            if (_this.INSTRUMENT_MAP[instName].test(fsName)) {
                return true;
            }
            return false;
        });
    }
});

var $CardInfoModel = exports.$CardInfoModel = _squid.$Model.extend('$CardInfoModel', {
    api: new _squid.$Api({
        uri: '/api/fi/card/:id'
    })
});

angular.value("$CardModel", $CardModel);
angular.value("$AddCardModel", $AddCardModel);
angular.value("$UnavailableCardModel", $UnavailableCardModel);
angular.value("$CardTypesModel", $CardTypesModel);
angular.value("$BankModel", $BankModel);
angular.value("$AddBankModel", $AddBankModel);
angular.value("$PreferredFi", $PreferredFi);
angular.value("$SepaModel", $SepaModel);
angular.value("$DeleteCardModel", $DeleteCardModel);
angular.value("$AddBillingAddressModel", $AddBillingAddressModel);
angular.value("$BillingAddressModel", $BillingAddressModel);
angular.value("$CurrencyConversionModel", $CurrencyConversionModel);
angular.value("$BillingAddressesModel", $BillingAddressesModel);
angular.value("$CardTypeFromBinModel", $CardTypeFromBinModel);
angular.value("$Resolve3DS", $Resolve3DS);
angular.value("$ResolveOTP", $ResolveOTP);
angular.value("$WalletPreferences", $WalletPreferences);
angular.value("$WalletInstrumentNameMapping", $WalletInstrumentNameMapping);
angular.value("$CardInfoModel", $CardInfoModel);
_index.$DeviceInfo;

_squid.$Model;

_squid.$Api;

_squid.$util;

_squid.$config;

_squid.$feature;

_squid.$locale;

/***/ }),

/***/ "../node_modules/xo-models/src/fi/lib/constants.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var issuerDeclineExperimentMap = exports.issuerDeclineExperimentMap = {
    Trmt_xo_hermesnodeweb_issuer_decline_1: {
        member: 'payment.processorDeclineIssuerMember',
        memberNoIssuer: 'payment.processorDeclineIssuerMemberNoIssuer',
        guest: 'payment.processorDeclineIssuerGuest',
        guestNoIssuer: 'payment.processorDeclineIssuerGuestNoIssuer',
        type: 'info'
    }
};

/***/ }),

/***/ "../node_modules/xo-models/src/fi/lib/fiApis.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$fiApis = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var $fiApis = exports.$fiApis = {
    patchCvv: function patchCvv(checkoutSession) {
        var cvvData = checkoutSession.get('cvvData');

        if (cvvData) {
            return checkoutSession.action('patchCvv', {
                data: {
                    id: cvvData.id,
                    cvv: cvvData.security_code,
                    type: cvvData.type,
                    number: cvvData.number
                }
            });
        }

        return _angular.$q.when();
    }
};

angular.value("$fiApis", $fiApis);
_angular.$q;

/***/ }),

/***/ "../node_modules/xo-models/src/fi/lib/fiMessages.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _constants = __webpack_require__("../node_modules/xo-models/src/fi/lib/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$fiMessages', function () {
    var xoonRedirectExperimentMap = {
        xo_hermes_addcard_msg_xoon_redirect_retry_control: {
            msgKey: 'creditcard.noFIContingency',
            type: 'info',
            showDetails: false
        },
        xo_hermes_addcard_msg_xoon_redirect_retry_bgr_orange: {
            msgKey: 'creditcard.noFIContingency',
            type: 'warning',
            showDetails: false
        },
        xo_hermes_addcard_msg_xoon_redirect_retry_without_details: {
            msgKey: 'addFiError.declinedRetry',
            type: 'warning',
            showDetails: false
        },
        xo_hermes_addcard_msg_xoon_redirect_retry_with_details: {
            msgKey: 'addFiError.declinedRetryWithCardDetails',
            type: 'warning',
            showDetails: true
        },
        xo_hermes_addcard_msg_xoon_redirect_retry_with_avs_details: {
            msgKey: 'addFiError.declinedRetryWithCardDetails',
            type: 'warning',
            showDetails: true
        },
        xo_hermes_addcard_msg_xoon_redirect_noretry_control: {
            msgKey: 'creditcard.noFIContingency',
            type: 'info',
            showDetails: false
        },
        xo_hermes_addcard_msg_xoon_redirect_noretry_bgr_orange: {
            msgKey: 'creditcard.noFIContingency',
            type: 'warning',
            showDetails: false
        },
        xo_hermes_addcard_msg_xoon_redirect_noretry_without_details: {
            msgKey: 'addFiError.declinedNoRetry',
            type: 'warning',
            showDetails: false
        },
        xo_hermes_addcard_msg_xoon_redirect_noretry_with_details: {
            msgKey: 'addFiError.declinedNoRetryWithCardDetails',
            type: 'warning',
            showDetails: true
        },
        xo_hermes_addcard_msg_xoon_redirect_noretry_with_avs_details: {
            msgKey: 'addFiError.declinedNoRetryWithCardDetails',
            type: 'warning',
            showDetails: true
        },
        xo_hermes_addcard_msg_xoon_redirect_avs_control: {
            msgKey: 'creditcard.noFIContingency',
            type: 'info',
            showDetails: false
        },
        xo_hermes_addcard_msg_xoon_redirect_avs_dropdown: {
            msgKey: 'addFiError.declinedWithBilling',
            type: 'warning',
            showDetails: true
        },
        xo_hermes_addcard_msg_xoon_redirect_avs_address_box: {
            msgKey: 'addFiError.declinedWithBilling',
            type: 'warning',
            showDetails: true
        }
    };

    function getContentKeys(hasFi) {
        if (hasFi) {
            return {
                member: 'payment.processorDeclineMember',
                generic: 'payment.processorDeclineMemberGeneric',
                buyerCredit: 'payment.processorDeclineMemberBuyerCredit'
            };
        } else {
            return {
                member: 'payment.processorDeclineMemberNoFI',
                generic: 'payment.processorDeclineMemberNoFIGeneric',
                buyerCredit: 'payment.processorDeclineMemberBuyerCreditNoFI'
            };
        }
    }

    // Temporary solution until PAPS returns CCID in the declined instrument
    var getIssuerName = function getIssuerName(_ref) {
        var _ref$instrument = _ref.instrument,
            instrument = _ref$instrument === undefined ? {} : _ref$instrument,
            _ref$disallowedInstru = _ref.disallowedInstruments,
            disallowedInstruments = _ref$disallowedInstru === undefined ? [] : _ref$disallowedInstru,
            _ref$cardAccounts = _ref.cardAccounts,
            cardAccounts = _ref$cardAccounts === undefined ? [] : _ref$cardAccounts;

        var last4 = instrument && instrument.last4 ? instrument.last4 : '';
        var search = disallowedInstruments.find(function (disallowedInstrument) {
            return disallowedInstrument.lastDigits === last4;
        });

        if (search) {
            var id = search.id;

            var cardAccount = cardAccounts.find(function (card) {
                return card.id.replace('-', '') === id;
            });

            if (cardAccount) {
                // Will need to eventually deprecate to the Wallet Model to manage this
                var issuerName = cardAccount.issuer && cardAccount.issuer.filtered_issuer_name ? cardAccount.issuer.filtered_issuer_name : '';

                return issuerName;
            }
        }
        return '';
    };

    function processorDeclinedMsg(checkoutSession, hasFi) {
        var experiment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var authSession = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        var wallet = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

        var declinedInstruments = checkoutSession.get('declinedInstruments', []);

        if (_angular2['default'].isArray(declinedInstruments) && declinedInstruments.length) {
            var msg = void 0;
            var type = 'warning';
            var instrument = declinedInstruments[0];
            var contentKeys = getContentKeys(hasFi);

            if (instrument.type === 'PAYMENT_CARD') {
                if (instrument.card_type && instrument.last4) {
                    _logger.$logger.info('processor_decline', { hasFi: hasFi, message: 'member' });
                    var experimentMap = _constants.issuerDeclineExperimentMap[experiment];

                    if (experimentMap && authSession && wallet) {
                        var card_accounts = wallet.card_accounts;

                        var disallowedInstruments = checkoutSession.get('fundingOptions.disallowedInstruments', []);
                        var issuer = getIssuerName({
                            instrument: instrument,
                            disallowedInstruments: disallowedInstruments,
                            cardAccounts: card_accounts
                        });

                        if (issuer) {
                            type = experimentMap.type;
                            msg = (0, _squid.$renderContent)(experimentMap.member, {
                                name: authSession.first_name,
                                type: instrument.card_type,
                                issuer: issuer,
                                number: instrument.last4
                            });
                        } else {
                            type = experimentMap.type;
                            msg = (0, _squid.$renderContent)(experimentMap.memberNoIssuer, {
                                name: authSession.first_name,
                                type: instrument.card_type,
                                number: instrument.last4
                            });
                        }
                    } else {
                        msg = (0, _squid.$renderContent)(contentKeys.member, {
                            type: instrument.card_type,
                            number: instrument.last4
                        });
                    }
                } else {
                    _logger.$logger.info('processor_decline', { hasFi: hasFi, message: 'generic' });
                    msg = (0, _squid.$renderContent)(contentKeys.generic);
                }
            } else {
                _logger.$logger.info('processor_decline', { hasFi: hasFi, message: 'buyerCredit' });
                msg = (0, _squid.$renderContent)(contentKeys.buyerCredit);
            }

            checkoutSession.set('declinedInstruments', null);

            return {
                type: type,
                msg: msg
            };
        }
    }

    function getXoonRedirectAddCardMsg(unavailableCard, experiment) {
        var experimentMap = xoonRedirectExperimentMap[experiment];

        if (!unavailableCard) {
            _logger.$logger.info(experiment + '_card_empty');
            return {
                type: 'info',
                msg: (0, _squid.$renderContent)('creditcard.noFIContingency')
            };
        }

        var msg = (0, _squid.$renderContent)(experimentMap['msgKey']);
        var type = experimentMap['type'];
        var showDetails = experimentMap['showDetails'];

        if (showDetails) {
            var cardType = (0, _squid.$renderContent)('cardTypes.' + unavailableCard.cardType);
            var lastDigits = unavailableCard.lastDigits;

            if (cardType && cardType.toString() && lastDigits) {
                msg = (0, _squid.$renderContent)(experimentMap['msgKey'], {
                    cardType: cardType,
                    last4: lastDigits
                });
            } else {
                msg = (0, _squid.$renderContent)('creditcard.noFIContingency');
                type = 'info';
                _logger.$logger.info(experiment + '_detail_missing');
            }
        }

        _logger.$logger.info(experiment, { type: unavailableCard.cardType, msgType: type, msgRendered: msg ? true : false });
        return {
            type: type ? type : 'info',
            msg: msg ? msg : (0, _squid.$renderContent)('creditcard.noFIContingency')
        };
    }

    function getAddCardControlMsg(checkoutSession) {
        var disallowedInstruments = checkoutSession.get('fundingOptions.disallowedInstruments', []);

        if (disallowedInstruments && disallowedInstruments.length === 1) {
            _logger.$logger.info('checkout_fpti', {
                'int_error_description': 'single_disallowed_FI_addcard_control_msg'
            });
        } else if (disallowedInstruments && disallowedInstruments.length > 1) {
            _logger.$logger.info('checkout_fpti', {
                'int_error_description': 'multi_disallowed_FI_addcard_control_msg'
            });
        } else {
            _logger.$logger.info('checkout_fpti', {
                'int_error_description': 'has_no_disallowed_FI_addcard_control_msg'
            });
        }

        return {
            msg: (0, _squid.$renderContent)('creditcard.noFIContingency'),
            type: 'info'
        };
    }

    function getAddCardMsg(unavailableCard, experiment, checkoutSession) {
        var xoonRedirectAddCardMsgExp = xoonRedirectExperimentMap[experiment];

        if (xoonRedirectAddCardMsgExp) {
            return getXoonRedirectAddCardMsg(unavailableCard, experiment);
        }
        return getAddCardControlMsg(checkoutSession);
    }

    function getAddCardTreatmentMsg(checkoutSession) {
        var msg = void 0;
        var type = void 0;
        var title = void 0;
        var cardList = void 0;
        var lastCard = void 0;
        var disallowedInstruments = checkoutSession.get('fundingOptions.disallowedInstruments', []);
        disallowedInstruments = disallowedInstruments.filter(function (instrument) {
            return instrument.type && instrument.type !== 'REWARDS' && instrument.type !== 'BALANCE';
        });

        if (disallowedInstruments && disallowedInstruments.length === 1) {
            cardList = disallowedInstruments[0].lastDigits ? disallowedInstruments[0].name + '-' + disallowedInstruments[0].lastDigits : disallowedInstruments[0].name;
            _logger.$logger.info('checkout_fpti', {
                'int_error_description': 'single_disallowed_FI_addcard_msg'
            });
            msg = (0, _squid.$renderContent)('creditcard.hasSingleDisallowedFi', { cardList: cardList });
            type = 'normal';
            title = (0, _squid.$renderContent)('creditcard.hasDisallowedAddCardTitle');
        } else if (disallowedInstruments && disallowedInstruments.length > 1) {
            cardList = '';

            for (var i = 0; i < disallowedInstruments.length; i++) {
                if (i === disallowedInstruments.length - 1) {
                    lastCard = disallowedInstruments[i].lastDigits ? disallowedInstruments[i].name + '-' + disallowedInstruments[i].lastDigits : disallowedInstruments[i].name;
                } else if (i === disallowedInstruments.length - 2) {
                    cardList += disallowedInstruments[i].lastDigits ? disallowedInstruments[i].name + '-' + disallowedInstruments[i].lastDigits : disallowedInstruments[i].name;
                } else {
                    cardList += disallowedInstruments[i].lastDigits ? disallowedInstruments[i].name + '-' + disallowedInstruments[i].lastDigits + ', ' : disallowedInstruments[i].name + ', ';
                }
            }

            _logger.$logger.info('checkout_fpti', {
                'int_error_description': 'multi_disallowed_FI_addcard_msg'
            });
            msg = (0, _squid.$renderContent)('creditcard.hasMultipleDisallowedFi', { cardList: cardList, lastCard: lastCard });
            type = 'normal';
            title = (0, _squid.$renderContent)('creditcard.hasDisallowedAddCardTitle');
        } else {
            _logger.$logger.info('checkout_fpti', {
                'int_error_description': 'has_no_FI_addcard_msg'
            });
            msg = (0, _squid.$renderContent)('creditcard.hasNoDisallowedFi');
            type = 'normal';
            title = (0, _squid.$renderContent)('creditcard.noDisallowedAddCardTitle');
        }

        return {
            msg: msg,
            type: type,
            title: title
        };
    }

    // User with only banks in disallowed list with message indicating the same
    function getAddBankTreatmentMsg() {
        return {
            msg: (0, _squid.$renderContent)('bank.disallowedAddCard'),
            type: 'normal'
        };
    }

    // Add card contingency for the case where card fails preauth; Show message which indicates that card failed pre-auth
    function getPreAuthTreatmentMsg() {
        var preAuthDisallowed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var disallowedInstrument = preAuthDisallowed[0];


        return {
            msg: (0, _squid.$renderContent)('creditCard.preAuthNoIssuer', {
                cardType: disallowedInstrument && disallowedInstrument.name || '',
                last4: disallowedInstrument && disallowedInstrument.lastDigits || 'xxxx'
            }),
            type: 'info'
        };
    }

    function getGamblingMsg() {
        return {
            type: 'error',
            msg: (0, _squid.$renderContent)('creditcard.noEligibleFI')
        };
    }

    return {
        processorDeclinedMsg: processorDeclinedMsg,
        getGamblingMsg: getGamblingMsg,
        getAddCardTreatmentMsg: getAddCardTreatmentMsg,
        getAddCardControlMsg: getAddCardControlMsg,
        getAddCardMsg: getAddCardMsg,
        getAddBankTreatmentMsg: getAddBankTreatmentMsg,
        getPreAuthTreatmentMsg: getPreAuthTreatmentMsg
    };
});

_squid.$renderContent;

_logger.$logger;

_constants.issuerDeclineExperimentMap;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-models/src/fi/lib", "../node_modules/xo-models/src/fi/lib/fiMessages.js"))

/***/ }),

/***/ "../node_modules/xo-models/src/fiMeta/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _wallet = __webpack_require__("../node_modules/xo-models/src/wallet/index.js");

var _dist = __webpack_require__("../node_modules/squid/dist/index.js");

var PADSUBTYPE = 'DELAYED_TRANSFER';
var MEFTSUBTYPE = 'MEFT';
var IACHSUBTYPE = 'IACH';
var ECHECKSUBTYPE = 'ECHECK';

// any mappings to normalize fi name
var NAME_MAPPINGS = {
    'MERCHANT_SPECIFIC_BALANCE': 'INCENTIVE'
};

// eslint-disable-next-line no-confusing-arrow
var allFis = function allFis(plan) {
    return plan.secondaryFIs ? [plan.primaryFs].concat(plan.secondaryFIs) : [plan.primaryFs];
};

var isSubType = function isSubType(subtype) {
    return function (fi) {
        return fi.subtype === subtype || fi.sub_type === subtype;
    };
};

var capFirst = function capFirst(product) {
    return product && product.charAt(0).toUpperCase() + product.slice(1).toLowerCase();
};

exports['default'] = _squid.$Model.extend('$FiMetaModel', {
    invalidateOnLogout: true,

    onInvalidate: function onInvalidate() {
        if (this.session) {
            delete this.session;
        }
        if (this.wallet) {
            delete this.wallet;
        }
    },
    fetch: function fetch() {
        var _this = this;

        if (_squid.$config.disableCardArt) {
            return _squid.$promise.resolve(this);
        } else {
            return _squid.$promise.all({
                session: _checkout.$CheckoutSessionModel.instance(this.id).retrieve(),
                wallet: _wallet.$WalletModel.instance(this.id).retrieve()
            }).then(function (r) {
                return _squid.$util.extend(_this, r);
            });
        }
    },


    // pxp apply for user
    cardArtEnabled: function cardArtEnabled() {
        return this.wallet && this.wallet.cardArtEnabled;
    },
    getCardArt: function getCardArt(fi) {
        return this.wallet && this.cardArtEnabled() && this.wallet.getCardArt(fi);
    },
    plans: function plans() {
        return this.session.fundingOptions.plans;
    },
    hasPadPlan: function hasPadPlan() {
        return this.plans().map(allFis).some(function (fis) {
            return fis.some(isSubType(PADSUBTYPE));
        });
    },
    type: function type(fi) {
        if (fi.type === 'CREDIT' || fi.type === 'BILL_ME_LATER') {
            return 'CREDIT';
        } else {
            return fi.type;
        }
    },
    getName: function getName(fi) {
        if (fi.isPinlessDebit || fi.is_pinless_debit) {
            return (0, _dist.$renderContent)('fsMappings.PINLESSDEBIT');
        }

        // Normalize fs name for content key lookup
        var name = NAME_MAPPINGS[fi.name] || fi.name;

        return this.wallet && this.wallet.getCustomName(fi) || (0, _dist.$renderContent)('fsMappings.' + name).toString() || name;
    },
    getAmount: function getAmount(fi) {
        return fi.amount;
    },
    getCurrencyCode: function getCurrencyCode(fi) {
        return fi.amount.currency_code;
    },
    getAllCurrencyCodes: function getAllCurrencyCodes(plan) {
        return allFis(plan).map(this.getCurrencyCode);
    },
    getCardMask: function getCardMask(fi) {
        var mask = this.wallet && this.wallet.getCardMask(fi);

        if (!mask.before) {
            mask.before = capFirst(fi.productClass);
        }
        if (!mask.after) {
            mask.after = fi.lastDigits || fi.last4;
        }
        return mask;
    },
    isPinlessDebit: function isPinlessDebit(fi) {
        return fi.is_pinless_debit || fi.isPinlessDebit;
    },
    isPad: function isPad(fi) {
        return isSubType(PADSUBTYPE)(fi) || isSubType('PAD')(fi);
    },
    isMeft: function isMeft(fi) {
        return isSubType(MEFTSUBTYPE)(fi);
    },
    isIach: function isIach(fi) {
        return isSubType(IACHSUBTYPE)(fi);
    },
    isEcheck: function isEcheck(fi) {
        return isSubType(ECHECKSUBTYPE)(fi);
    },
    getEditDisallowedContentKey: function getEditDisallowedContentKey(fi) {
        if (!fi) {
            return;
        }
        if (fi.editDisallowedMsg) {
            return 'wallet.' + fi.editDisallowedMsg;
        } else if (this.wallet.isLinkedCard(fi)) {
            return 'wallet.editDisallowedPayment';
        }
    }
});


_squid.$Model;

_squid.$promise;

_squid.$util;

_squid.$config;

_checkout.$CheckoutSessionModel;

_wallet.$WalletModel;

_dist.$renderContent;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-models/src/gdprCookieBanner/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$GDPRCookieBannerModel = exports.isGdprValid = exports.testGdprBannerCookie = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var testGdprBannerCookie = exports.testGdprBannerCookie = function testGdprBannerCookie(cookies) {
    return (/(^|;\s*)cookie_prefs=/.test(cookies)
    );
};

var isGdprValid = exports.isGdprValid = function isGdprValid() {
    if (_squid.$util.param('forceGDPR')) {
        return true;
    }

    var country = _squid.$locale.country;

    return _squid.$util.getProperty(_squid.$config, 'GDPR.cookieBanner', { 'default': false }) && _squid.$util.getProperty(_squid.$config, 'GDPR.countries', { 'default': [] }).indexOf(country) > -1;
};

var $GDPRCookieBannerModel = exports.$GDPRCookieBannerModel = _squid.$Model.extend('$GDPRCookieBannerModel', {
    api: new _squid.$Api({
        uri: '/api/cookieBanner'
    }),

    /**
     * Handles the logic for when to fetch the banner and when to return
     * Don't repeat the call for same country
     * Don't return the banner if not PXP check
     * @returns {Promise} resolves an object
     */
    getBanner: function getBanner() {
        var _this = this;

        // API is cached on country. Return current result if already present
        if (this.lastResult && this.lastCountry === _squid.$locale.country && this.lastLang === _squid.$locale.lang) {
            return this.lastResult;
        }

        // Invalidate the model to make a fresh call
        this.invalidate();

        // Log if the user has cookie indicating a previous interaction with the cookie banner
        if (testGdprBannerCookie(document.cookie)) {
            _logger.$logger.info('checkout_fpti', {
                from: 'GDPR_banner',
                to: 'GDPR_banner_has_cookie'
            });
        }

        // Cache the result promise and params
        this.lastCountry = _squid.$locale.country;
        this.lastLang = _squid.$locale.lang;
        this.lastResult = this.retrieve().then(function (res) {
            var html = res.html,
                css = res.css,
                js = res.js;


            if (!html || !js || !css) {
                _logger.$logger.info('gdpr_response_missing_props', {
                    html: !!html,
                    js: !!js,
                    css: !!css
                });
                _this.reset();
                return;
            }

            _logger.$logger.info('checkout_fpti', {
                from: 'GDPR_banner',
                to: 'GDPR_banner_shown'
            });

            return { html: html, css: css, js: js };
        });

        return this.lastResult;
    },
    reset: function reset() {
        this.html = '';
        this.css = '';
        this.js = '';
    },
    shown: function shown() {
        return !!this.html;
    },

    // Check if a banner was shown in the flow.
    // SOME EDGE CASES:
    //   Will not update when the user clicks to accept the banner, and it closes
    //   Will update if retrieve is called with a new country and blank data is returned
    hasBanner: function hasBanner() {
        var _this2 = this;

        // check config flag
        // check if already populated
        // make call again and let regular logic populate html
        // return boolean

        if (!isGdprValid()) {
            return _squid.$promise.resolve(false);
        }
        if (this.html) {
            return _squid.$promise.resolve(this.shown());
        }
        return this.getBanner().then(function () {
            return _this2.shown();
        });
    }
});

angular.value("testGdprBannerCookie", testGdprBannerCookie);
angular.value("isGdprValid", isGdprValid);
angular.value("$GDPRCookieBannerModel", $GDPRCookieBannerModel);
_squid.$Model;

_squid.$Api;

_squid.$locale;

_squid.$config;

_squid.$util;

_squid.$promise;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-models/src/inventory/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$InventoryModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $InventoryModel = exports.$InventoryModel = _squid.$Model.extend('$InventoryModel', {
    api: new _squid.$Api({
        uri: '/api/catalog/:id/item/',
        postAttempts: 2,
        cache: true
    }),

    setInvetoryItems: function setInvetoryItems(inventoryItems) {
        this.inventoryItems = inventoryItems;
    },

    getInventoryItems: function getInventoryItems() {
        return this.inventoryItems;
    }
});

angular.value("$InventoryModel", $InventoryModel);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/marketingoffer/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$CreditOfferModel = exports.$MemberSegmentModel = exports.$fireMORSBeacon = exports.$MessageDiscoverModel = exports.$MarketingOfferModel = undefined;

var _uuid = __webpack_require__("../node_modules/node-uuid/uuid.js");

var _uuid2 = _interopRequireDefault(_uuid);

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $MarketingOfferModel = exports.$MarketingOfferModel = _squid.$Model.extend('$MarketingOfferModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/offer/search-ads',
        postAttempts: 1,
        cache: true
    }),
    init: function init() {
        this.setProperties({ ads: [] });
        this.meta = { populated: false };
    },
    onPopulate: function onPopulate() {
        var _this = this;

        if (this.targetPlacements && this.targetPlacements[0]) {
            var targetAd = this.ads.find(function (ad) {
                return ad.valid && ad.campaign.adunit_id === _this.targetPlacements[0].placement_code;
            });

            this.ad = undefined;
            if (targetAd) {
                var ad = {};
                var nvpContent = targetAd && targetAd.content && targetAd.content.nvp;

                nvpContent.forEach(function (obj) {
                    ad[obj.name] = obj.value;
                });
                ad['impressionUrl'] = targetAd && targetAd.tracking && targetAd.tracking.impression_url;
                ad['clickUrl'] = targetAd && targetAd.tracking && targetAd.tracking.click_url;
                ad['campaignId'] = targetAd && targetAd.campaign && targetAd.campaign.campaign_id;
                ad['buyItemId'] = targetAd && targetAd.campaign && targetAd.campaign.buy_item_id;
                ad['placementCode'] = targetAd && targetAd.campaign && targetAd.campaign.adunit_id;
                this.ad = ad;
            }
        }
    },
    getCacheKey: function getCacheKey() {
        var cacheKey = {};

        if (this.cacheParam) {
            this.cacheParam.forEach(function (element) {
                if (typeof element.value !== 'undefined') {
                    cacheKey[element.name] = element.value.toString();
                }
            });
        }
        return cacheKey;
    },
    serialize: function serialize() {
        return {
            'site': this.site,
            'locale': this.locale,
            'si': this.si,
            'visit_id': _uuid2['default'].v4(),
            'page': this.page,
            'epu': this.payer,
            'pu_type': this.puType || 'ANONYMOUS',
            'country_code': this.countryCode,
            'payment_context': {
                'total_transaction_amount': this.totalTransactionAmount,
                'total_shipping_amount': this.totalShippingAmount,
                'business_case': 'NONE',
                'business_case_variation': '',
                'validate_existing_offer': 'false',
                'payment_units': [{
                    'transaction_amount': this.totalTransactionAmount,
                    'transaction_id': '',
                    'encrypted_transaction_id': '',
                    'activity_id': '',
                    'payee': {
                        'pu_type': 'BUSINESS',
                        'country_code': this.countryCode,
                        'epu': this.payee,
                        'pu': ''
                    }
                }]
            },
            'target_placements': this.targetPlacements,
            'wallet_instruments': this.walletInstruments,
            'addl_property_installments_not_allowed': this.installmentsNotAllowed
        };
    },
    getTargetAd: function getTargetAd() {
        return this.ad;
    },
    isAdFound: function isAdFound() {
        if (this.ad) {
            for (var property in this.ad) {
                if (this.ad.hasOwnProperty(property)) {
                    return true;
                }
            }
        }
        return false;
    }
});

var $MessageDiscoverModel = exports.$MessageDiscoverModel = _squid.$Model.extend('$MessageDiscoverModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/offer/discover-messages',
        postAttempts: 1
    })
});

var $fireMORSBeacon = exports.$fireMORSBeacon = {
    fireBeacon: function fireBeacon(uri) {
        var img = document.createElement('img');

        img.setAttribute('src', uri);
        document.body.appendChild(img);
        return;
    }
};

var $MemberSegmentModel = exports.$MemberSegmentModel = _squid.$Model.extend('$MemberSegmentModel', {
    api: new _squid.$Api({
        uri: '/api/segment/memberSegment',
        postAttempts: 1
    }),
    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called
    getMemberSegment: function getMemberSegment() {
        return this.memberSegment;
    },
    getCreditOffer: function getCreditOffer() {
        return this.creditOffer;
    },
    isNewMember: function isNewMember() {
        return this.memberSegment === 'NEW_MEMBER' || this.memberSegment === 'YOUNG_MEMBER';
    },
    isExistingMember: function isExistingMember() {
        return this.memberSegment === 'EXISTING_MEMBER';
    },
    // Member Segments that are eligble for the New Experience
    isEligibleForExperimentation: function isEligibleForExperimentation() {
        var eligibleMemberSegments = _squid.$config.memberSegments;

        return eligibleMemberSegments.indexOf(this.memberSegment) > -1;
    }
});

var $CreditOfferModel = exports.$CreditOfferModel = $MessageDiscoverModel.extend('$CreditOfferModel', {
    init: function init() {
        this.setProperties({
            bannerMessages: [],
            interstitialMessages: []
        });
    },
    populate: function populate(result) {
        var _this2 = this;

        if (result && result.touchpoint_messages) {
            var touchpoint_messages = result.touchpoint_messages.find(function (element) {
                return element.touchpoint_code === _this2.touchpoint;
            });

            this.storeMessages(touchpoint_messages);
        }
    },
    storeMessages: function storeMessages(touchpoint_messages) {
        if (touchpoint_messages) {
            this.viewName = touchpoint_messages.view_name;

            if (touchpoint_messages.messages) {
                var messages = touchpoint_messages.messages;

                for (var i = 0; i < touchpoint_messages.messages.length; i++) {
                    var presentmentType = messages[i].content.json.PresentmentType;

                    if (presentmentType === 'Banner') {
                        this.bannerMessages.push(messages[i]);
                    } else if (presentmentType === 'Interstitial') {
                        this.interstitialMessages.push(messages[i]);
                    }
                }
            }
        }
    },
    getBannerCount: function getBannerCount() {
        return this.bannerMessages.length;
    },
    hasBannerMessage: function hasBannerMessage() {
        return this.getBannerCount() > 0;
    },
    getInterstitialCount: function getInterstitialCount() {
        return this.interstitialMessages.length;
    },
    hasInterstitialMessage: function hasInterstitialMessage() {
        return this.getInterstitialCount() > 0;
    },
    getTouchpointCode: function getTouchpointCode() {
        return this.touchpoint;
    },
    getBannerMessage: function getBannerMessage(i) {
        i = !i ? 0 : i;

        if (this.getBannerCount() > i) {
            return this.bannerMessages[i];
        }
        return null;
    },
    getInterstitialMessage: function getInterstitialMessage(i) {
        i = !i ? 0 : i;

        if (this.getInterstitialCount() > i) {
            return this.interstitialMessages[i];
        }
        return null;
    },
    getInterstitialContent: function getInterstitialContent() {
        var interstitialContent = {};

        if (this.hasInterstitialMessage()) {
            var interstitialMessage = this.getInterstitialMessage().content.json;

            _logger.$logger.info('interstitial content', interstitialMessage);
            interstitialContent.messageId = 'PS-' + interstitialMessage['MessageDescription'];
            interstitialContent.bodyText = interstitialMessage['HeadlineText'];
            interstitialContent.bodyText2 = interstitialMessage['TaglineText'];
            interstitialContent.termsText = interstitialMessage['TermsText'];
            interstitialContent.termsText2 = interstitialMessage['TermsText2'];
            interstitialContent.termsLink = interstitialMessage['TermsLink'];
            interstitialContent.termsLinkText = interstitialMessage['TermsLinkText'];
            interstitialContent.ctaText = interstitialMessage['CTAText'];
        }
        return interstitialContent;
    },
    fireInterstitialBeacon: function fireInterstitialBeacon() {
        if (this.hasInterstitialMessage()) {
            var impressionUrl = this.getInterstitialMessage().tracking_details.impression_url;

            _logger.$logger.info('interstitial impressionUrl', impressionUrl);
            $fireMORSBeacon.fireBeacon(impressionUrl);
        }
    },
    getCacheKey: function getCacheKey() {
        var cacheKey = {};

        if (this.application_context) {
            this.application_context.forEach(function (element) {
                if (typeof element.value !== 'undefined') {
                    cacheKey[element.name] = element.value.toString();
                }
            });
        }
        return cacheKey;
    },
    serialize: function serialize() {
        return {
            'country_code': this.locale.country,
            'language': this.locale.lang + '_' + this.locale.country,
            'identity_context': [{
                'type': 'PAYER_ID',
                'value': this.payer
            }, {
                'type': 'MERCHANT_PAYER_ID',
                'value': this.payee
            }],
            'recommendation_context': {
                'view_names': this.view_names ? this.view_names : [],
                'touchpoint_details': [{
                    'code': this.touchpoint,
                    'message_count': this.message_count ? this.message_count : 1
                }]
            },
            'application_context': this.application_context
        };
    }
});

angular.value("$MarketingOfferModel", $MarketingOfferModel);
angular.value("$MessageDiscoverModel", $MessageDiscoverModel);
angular.value("$fireMORSBeacon", $fireMORSBeacon);
angular.value("$MemberSegmentModel", $MemberSegmentModel);
angular.value("$CreditOfferModel", $CreditOfferModel);
_logger.$logger;

_squid.$Model;

_squid.$Api;

_squid.$config;

/***/ }),

/***/ "../node_modules/xo-models/src/marketingoffer/lib/xoMORSCreditBannerUtils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoMORSCreditBannerUtils = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var $xoMORSCreditBannerUtils = exports.$xoMORSCreditBannerUtils = {
    getMorsParametersForCreditBanner: function getMorsParametersForCreditBanner(scope) {
        _logger.$logger.debug('xoMORSCreditBannerUtils: Composing MORS parameters for credit banner');
        var isCreditInWallet = false;

        if (scope.isBillingNoPurchase) {
            isCreditInWallet = scope.checkoutSession.get('futurePayment.isCreditInWallet');
        } else {
            var plans = scope.checkoutSession.get('fundingOptions.plans', []);

            if (plans) {
                isCreditInWallet = plans.find(function (fi) {
                    return fi && fi.primaryFs && fi.primaryFs.name === 'BILL_ME_LATER';
                });
            }
        }

        var morsCacheId = scope.checkoutSession.id + '-' + scope.placementCode + '-' + !!isCreditInWallet;
        var walletInstruments = [];

        if (isCreditInWallet) {
            walletInstruments.push({
                financial_instrument_type: 'FI_PAYPAL_CREDIT',
                financial_instrument_product_type: 'PI_TYPE_CREDIT_TXN_CARD_BML',
                preferred: isCreditInWallet.isPreferred,
                out_of_wallet: false
            });
        }

        return {
            countryCode: scope.locale.country,
            cache: true,
            cacheParam: [{ name: 'cacheToken', value: morsCacheId }, { name: 'txnAmount', value: (scope.checkoutCart.get('purchase.amounts.total.amount', 0) * 100).toFixed(0) }],
            page: 'HERMES_RYI_PAGE',
            site: 'HERMES_RYI_PAGE',
            puType: scope.pu_type,
            totalTransactionAmount: {
                'currency_code': scope.checkoutCart.get('purchase.amounts.total.currency_code', ''),
                'value': (scope.checkoutCart.get('purchase.amounts.total.amount', 0) * 100).toFixed(0)
            },
            totalShippingAmount: {
                'currency_code': scope.checkoutCart.get('purchase.amounts.total.currency_code', ''),
                'value': (scope.checkoutCart.get('purchase.amounts.shipping.amount', 0) * 100).toFixed(0)
            },
            payee: scope.payee.merchant.id || '',
            payer: scope.checkoutSession.payer.id || '',
            si: scope.checkoutSession.id || '',
            targetPlacements: [{
                'placement_code': scope.placementCode || '',
                'presentation_types': scope.presentation_types || ''
            }],
            walletInstruments: walletInstruments,
            installmentsNotAllowed: !scope.checkoutSession.creditInstallmentOffer
        };
    },
    mapResponseToCreditBanner: function mapResponseToCreditBanner(ad, shouldShowPassiveBanner) {
        var banner = {};

        banner.offerType = this.morsOfferTypeToCreditType(ad['offertype']);
        banner.logo = ad['Logo'];
        banner.termsText = this.formatBannerField(ad['TermsText']);
        banner.termsLink = ad['TermsLink'];
        banner.termsLinkText = ad['TermsLinkText'];
        if (!shouldShowPassiveBanner) {
            banner.bodyText = this.formatBannerField(ad['OfferText1']);
            banner.bodyText2 = this.formatBannerField(ad['OfferText2']);
            banner.ctaText = this.formatBannerField(ad['CTAText']);
        } else {
            banner.ctaText = this.formatBannerField(ad['OfferText1']);
            banner.bodyText = this.formatBannerField(ad['OfferText2']);
        }
        return banner;
    },
    formatBannerField: function formatBannerField(content) {
        if (angular.isString(content)) {
            // Ensure "PayPal Credit" does not wrap
            content = _angular.$sce.trustAsHtml(content.replace(/PayPal Credit/g, '<span class="nowrap">PayPal Credit</span>'));
        }
        return content;
    },
    morsOfferTypeToCreditType: function morsOfferTypeToCreditType(morsOfferType) {
        var CREDIT_TYPE = {
            'CORE': 'CORE',
            'SAC': 'SAC',
            'NI': 'NI',
            'EZP': 'EZP',
            'BA': 'BA'
        };

        switch (morsOfferType) {
            case 'CORE':
                return CREDIT_TYPE.CORE;
            case 'SAC':
                return CREDIT_TYPE.SAC;
            case 'NI':
                return CREDIT_TYPE.NI;
            case 'PALA':
                return CREDIT_TYPE.EZP;
            default:
                _logger.$logger.warn('unknown_credit_type');
                return;
        }
    }
};

angular.value("$xoMORSCreditBannerUtils", $xoMORSCreditBannerUtils);
_angular.$sce;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-models/src/newMember/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$NewMemberEligibility = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _shippingMethod = __webpack_require__("../node_modules/xo-models/src/shippingMethod/index.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _marketingoffer = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var control = 'control';
var ineligible = 'ineligible';
var one_page = 'one_page';
var design_2 = 'design_2';
var design_3 = 'design_3';

var TREATMENT_PATTERNS = {
    CONTROL: /xo_hermes_\w*_member_control/,
    ONE_PAGE: /xo_hermes_\w*_member_treatment_1/,
    DESIGN_2: /xo_hermes_\w*_member_treatment_3/,
    DESIGN_3: /xo_hermes_\w*_member_treatment_4/
};

var mapTreatment = function mapTreatment(treatment) {
    if (!treatment) {
        return;
    }

    if (TREATMENT_PATTERNS.ONE_PAGE.test(treatment)) {
        return one_page;
    }

    if (TREATMENT_PATTERNS.DESIGN_2.test(treatment)) {
        return design_2;
    }

    if (TREATMENT_PATTERNS.DESIGN_3.test(treatment)) {
        return design_3;
    }
};

var getSegmentParameters = function getSegmentParameters(token) {
    var models = {};

    return (0, _squid.$populate)(models, {
        checkoutAppDataModel: _checkout.$CheckoutAppDataModel.instance(token),
        checkoutPayeeModel: _checkout.$CheckoutPayeeModel.instance(token),
        checkoutCartModel: _checkout.$CheckoutCartModel.instance(token)
    }).then(function () {
        var data = {
            page: 'HERMES_RYI_PAGE',
            site: 'HERMES_RYI_PAGE',
            locale: _squid.$locale.lang + '_' + _squid.$locale.country,
            puType: 'PERSONAL',
            visit_id: token,
            si: token,
            payment_context: {
                business_case: 'NONE',
                business_case_variation: '',
                validate_existing_offer: 'false',
                total_transaction_amount: {
                    currency_code: models.checkoutCartModel.get('purchase.amounts.total.currency_code', ''),
                    value: Math.round(models.checkoutCartModel.get('purchase.amounts.total.amount', 0) * 100)
                },
                total_shipping_amount: {
                    currency_code: models.checkoutCartModel.get('purchase.amounts.total.currency_code', ''),
                    value: Math.round(models.checkoutCartModel.get('purchase.amounts.shipping.amount', 0) * 100)
                },
                payment_units: [{
                    transaction_amount: {
                        currency_code: models.checkoutCartModel.get('purchase.amounts.total.currency_code', ''),
                        value: Math.round(models.checkoutCartModel.get('purchase.amounts.total.amount', 0) * 100)
                    },
                    transaction_id: '',
                    encrypted_transaction_id: '',
                    activity_id: '',
                    payee: {
                        pu_type: 'BUSINESS',
                        country_code: models.checkoutAppDataModel.get('merchant.merchant_country') || '',
                        epu: models.checkoutPayeeModel.merchant.id || '',
                        pu: ''
                    }
                }]
            },
            target_placements: [{
                placement_code: '210005',
                presentation_types: ['decision']
            }]
        };

        return data;
    });
};

var isMemberSegmentEligible = function isMemberSegmentEligible(token) {
    var memberSegmentModel = _marketingoffer.$MemberSegmentModel.instance();
    var memberSegment = memberSegmentModel.getMemberSegment();

    if (memberSegment !== undefined) {
        return _squid.$promise.resolve(memberSegmentModel.isEligibleForExperimentation());
    }

    return getSegmentParameters(token).then(function (data) {
        memberSegmentModel.invalidate();
        return memberSegmentModel.save({
            silent: true,
            data: data,
            contingencies: {
                DEFAULT: function DEFAULT(name, err) {
                    return;
                }
            }
        }).then(function () {
            return memberSegmentModel.isEligibleForExperimentation();
        })['catch'](function () {
            return false;
        });
    });
};

var eligibility = function eligibility(token, _ref) {
    var authModel = _ref.authModel,
        checkoutSessionModel = _ref.checkoutSessionModel,
        checkoutAppDataModel = _ref.checkoutAppDataModel,
        checkoutCartModel = _ref.checkoutCartModel,
        checkoutPayeeModel = _ref.checkoutPayeeModel,
        shippingRuleSummaryModel = _ref.shippingRuleSummaryModel;
    var plan = checkoutSessionModel.plan,
        negBalances = checkoutSessionModel.negBalances;

    var plans = checkoutSessionModel.get('fundingOptions.plans');

    // Ineligible reasons:
    // - multiple plans
    // - negative balance
    // - billing agreement
    // - third Party wallet (Baidu, Venmo, etc..)
    // - shipping and tax
    // - second button
    // - Android Pay
    // - Gambling
    // - Default funding source is not card
    var isMultiplePlans = plans && plans.length > 1;
    var isNegativeBalance = negBalances && negBalances.length !== 0;
    var isBilling = checkoutCartModel.isBilling();
    var isThirdParty = _thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(token);
    var isShippingRulesEnabled = shippingRuleSummaryModel.isSnTEnabled;
    var isSecondButton = checkoutAppDataModel.is_second_button_txn;
    var isAPay = checkoutCartModel.isWalletTokenization();
    var isGambling = checkoutPayeeModel.isGambling();
    var isHideShipping = checkoutAppDataModel.flags.hide_shipping_address || !checkoutAppDataModel.flags.shipping_address_required;

    // Default funding source needs to be card for now.
    var isSupportedDefaultFundingSource = plan && plan.sources && plan.sources.length === 1 && plan.sources[0].type === 'PAYMENT_CARD';

    var eligibilityCriteria = {
        noMultiplePlans: !isMultiplePlans,
        noNegativeBalance: !isNegativeBalance,
        noBilling: !isBilling,
        noThirdParty: !isThirdParty,
        noSnT: !isShippingRulesEnabled,
        noSecondButton: !isSecondButton,
        noAPay: !isAPay,
        noGambling: !isGambling,
        noSupportedDefaultFundingSource: isSupportedDefaultFundingSource,
        noHideShipping: !isHideShipping
    };

    var ineligibleReasons = Object.keys(eligibilityCriteria).filter(function (key) {
        return !eligibilityCriteria[key];
    });
    var transactionEligible = ineligibleReasons.length === 0;

    if (!transactionEligible) {
        var reasons = ineligibleReasons.join(':');

        _logger.$logger.info('checkout_ftpi', {
            from: 'new_member_eligibility',
            to: 'process_new_member_eligibility',
            eligibility_reason: reasons
        });
        for (var _iterator = ineligibleReasons, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref2 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref2 = _i.value;
            }

            var reason = _ref2;

            _logger.$logger.info('new_member_experience_ineligible_' + reason);
        }
        return _squid.$promise.resolve(ineligible);
    }

    // Check member segment
    return isMemberSegmentEligible(token).then(function (eligibleMember) {
        if (!eligibleMember) {
            _logger.$logger.info('new_member_experience_ineligible_member_segment');
            return ineligible;
        }

        // if merchant is on blacklist...
        if (_app.$PXPBlacklist.isMerchantBlacklisted(checkoutPayeeModel.get('merchant.id'))) {
            _logger.$logger.info('new_member_experience_ineligible_merchant_blacklisted');
            return control;
        }

        var memberSegmentModel = _marketingoffer.$MemberSegmentModel.instance();
        var memberSegment = memberSegmentModel.getMemberSegment();

        _logger.$logger.info('new_member_experience_eligible_' + memberSegment);

        return (0, _squid.$pxp)('xo_hermes_new_member_journey', {
            'uid': authModel.buyer_id,
            'ctx.COUNTRY': authModel.country,
            'ctx.SEGMENT': memberSegment }, 'xo_hermes_(\\w*)_member_treatment_(\\d)|xo_hermes_(\\w*)_member_control', false, true).then(function (t) {
            if (t) {
                var r = mapTreatment(t.treatment_name);

                return r || control;
            } else {
                return control;
            }
        });
    });
};

var snt = function snt(models, token) {
    if (_squid.$integration.getConfig('SHOW_SHIPPING_METHOD')) {
        return (0, _squid.$populate)(models, {
            shippingRuleSummaryModel: _shippingMethod.$ShippingRuleSummaryModel.instance(token).retrieve({
                params: {
                    merchant_id: models.checkoutPayeeModel.get('merchant.id'),
                    currency_code: models.checkoutCartModel.get('purchase.amounts.total.currency_code')
                }
            })
        });
    } else {
        models.shippingRuleSummaryModel = {};
        return _squid.$promise.resolve();
    }
};

var $NewMemberEligibility = exports.$NewMemberEligibility = _squid.$Model.extend('$NewMemberEligibility', {
    getVariant: function getVariant(token) {
        var _this = this;

        if (!(0, _squid.$feature)('newMemberExperience')) {
            return _squid.$promise.resolve(ineligible);
        }

        if (_squid.$meta.corp) {
            var nmexp = _squid.$util.param('nmj_exp');

            if (nmexp === '1') {
                return _squid.$promise.resolve(one_page);
            } else if (nmexp === '2') {
                return _squid.$promise.resolve(design_2);
            } else if (nmexp === '3') {
                return _squid.$promise.resolve(design_3);
            } else if (nmexp === '0') {
                return _squid.$promise.resolve(control);
            }
        }

        var models = {};

        return (0, _squid.$populate)(models, {
            authModel: _auth.$AuthModel.instance(),
            checkoutSessionModel: _checkout.$CheckoutSessionModel.instance(token),
            checkoutAppDataModel: _checkout.$CheckoutAppDataModel.instance(token),
            checkoutPayeeModel: _checkout.$CheckoutPayeeModel.instance(token),
            checkoutCartModel: _checkout.$CheckoutCartModel.instance(token)
        }).then(function () {
            return snt(models, token);
        }).then(function () {
            // Rerun eligibility if user has changed.
            if (_this.variant && models.authModel.buyer_id === _this.buyerId) {
                return _this.variant;
            }

            _this.buyerId = models.authModel.buyer_id;
            return eligibility(token, models).then(function (variant) {
                _this.variant = variant;
                return variant;
            });
        });
    },

    isNmj: function isNmj(token) {
        return this.getVariant(token).then(function (variant) {
            if (variant && (variant === 'one_page' || variant === 'design_2' || variant === 'design_3')) {
                return true;
            } else {
                return false;
            }
        });
    },

    nmjShowGreyHeader: function nmjShowGreyHeader(token) {
        return this.getVariant(token).then(function (variant) {
            if (variant && (variant === 'design_2' || variant === 'design_3')) {
                return true;
            } else {
                return false;
            }
        });
    },

    getMemberSegmentParameters: function getMemberSegmentParameters(token) {
        return getSegmentParameters(token);
    }
});

angular.value("$NewMemberEligibility", $NewMemberEligibility);
_squid.$Model;

_squid.$promise;

_squid.$populate;

_squid.$feature;

_squid.$pxp;

_squid.$locale;

_squid.$meta;

_squid.$util;

_squid.$integration;

_logger.$logger;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutPayeeModel;

_shippingMethod.$ShippingRuleSummaryModel;

_app.$PXPBlacklist;

_marketingoffer.$MemberSegmentModel;

_thirdPartyInfo.thirdPartyExperience;

_auth.$AuthModel;

/***/ }),

/***/ "../node_modules/xo-models/src/processorDecline/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getProcessorDeclineRetryEligibility = getProcessorDeclineRetryEligibility;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var INELIGIBLE = _squid.$promise.resolve(false);
var lastBuyerId = null;

// Check eligibility for processor decline retry feature
// First checks if feature eligibility is met, then PXP eligibility is met
function getProcessorDeclineRetryEligibility(token, checkoutSession) {
    if (!(0, _squid.$feature)('cardBackup')) {
        return INELIGIBLE;
    }

    // TODO: Refactor the eligibility rules to a set of common rules
    var models = {};

    return (0, _squid.$populate)(models, {
        auth: _auth.$AuthModel.instance(),
        checkoutCart: _checkout.$CheckoutCartModel.instance(token),
        checkoutPayee: _checkout.$CheckoutPayeeModel.instance(token),
        checkoutAppData: _checkout.$CheckoutAppDataModel.instance(token)
    }).then(function () {
        var checkoutCart = models.checkoutCart,
            checkoutPayee = models.checkoutPayee,
            checkoutAppData = models.checkoutAppData;

        var plans = checkoutSession.get('fundingOptions.plans', []);
        var moreThanOneCard = plans.filter(function (fi) {
            return fi.primaryFs.type === 'CARD';
        }).length < 2;

        // exclude rewards from the eligibility list
        var hasRewards = plans.filter(function (fi) {
            return fi && fi.rewards !== undefined;
        }).length > 0;

        // See https://engineering.paypalcorp.com/confluence/display/HellsKitchen/Hermes+Processor+Decline+Retry for eligibility reasons
        var isGambling = checkoutPayee.isGambling();
        var isBilling = checkoutCart.isBilling();
        // We're only sure that Sale transactions will go onto the new payments stack, for now
        var isNotSale = checkoutCart.get('payment_action') !== 'sale';
        var isThirdParty = _thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(token);
        // Exclude all WPS products
        var isWpsOrInvoice = checkoutAppData.get('flags.is_wps_flow') || checkoutAppData.get('flags.is_invoice_flow');
        // We will need to confirm functionality for this before we can enable for this feature
        var isMultiSellerPurchase = checkoutCart.isMultiSellerPurchase();
        var hasInstallments = checkoutSession.installments && checkoutSession.installments.length > 1;
        var involvedCurrencies = plans.reduce(function (currencies, plan) {
            currencies[plan.primaryFs.amount.currency_code] = 1;
            return currencies;
        }, {});
        // Buyer promo email routing through checkoutserv, downstream does not support
        var hasBuyerPromoEmail = checkoutAppData.get('flags.display_buyer_email_promotional_opt_in');

        if (checkoutCart.get('purchase.amounts.total.currency_code')) {
            involvedCurrencies[checkoutCart.purchase.amounts.total.currency_code] = 1;
        }

        var ineligibilityCriteria = {
            isGambling: isGambling,
            moreThanOneCard: moreThanOneCard,
            hasRewards: hasRewards,
            isBilling: isBilling,
            isNotSale: isNotSale,
            isThirdParty: isThirdParty,
            isWpsOrInvoice: isWpsOrInvoice,
            isMultiSellerPurchase: isMultiSellerPurchase,
            hasInstallments: hasInstallments,
            currencyConversion: Object.keys(involvedCurrencies).length > 1,
            hasBuyerPromoEmail: hasBuyerPromoEmail
        };
        var ineligibleReasons = Object.keys(ineligibilityCriteria).filter(function (key) {
            return ineligibilityCriteria[key];
        });
        var eligible = ineligibleReasons.length === 0;

        // Logging for FPTI
        _logger.$logger.info('checkout_fpti', {
            from: 'processor_decline_retry',
            // This logs whether user is eligible by Hermes criteria
            to: 'processor_decline_retry_' + (eligible ? 'eligible' : 'ineligible')
        });

        if (!eligible) {
            // This logs the overall result of the eligibility check
            _logger.$logger.info('processor_decline_retry_ineligible', {
                reasons: ineligibleReasons.join()
            });
        }

        return eligible;
    }).then(function (featureEligible) {
        // BuyerId is needed to make sure pxp is reloaded if a new user logs in.
        // Refactor: Make this a common pxp model that is invalidated on logout
        var buyerId = models.auth.buyerId;

        var sameBuyer = buyerId === lastBuyerId;

        lastBuyerId = buyerId;

        if (!featureEligible) {
            return false;
        }

        // Only run the PXP if the feature is eligible, as requested from analytics
        return (0, _squid.$pxp)('xo_hermes_processor_decline_retry', {}, 'xo_hermes_processor_decline_retry_treatment', sameBuyer ? false : true, true).then(function (pxpRes) {
            if (!pxpRes) {
                _logger.$logger.info('processor_decline_retry_ineligible', {
                    pxpIneligible: true
                });
            }

            return !!pxpRes;
        });
    }).then(function (eligibleWithPxp) {
        if (eligibleWithPxp) {
            _logger.$logger.info('processor_decline_retry_eligible');
        }
        return eligibleWithPxp;
    });
}

_squid.$feature;

_squid.$populate;

_squid.$promise;

_squid.$pxp;

_logger.$logger;

_thirdPartyInfo.thirdPartyExperience;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutAppDataModel;

_auth.$AuthModel;

/***/ }),

/***/ "../node_modules/xo-models/src/profilemanagement/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$MerchantPreferenceModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $MerchantPreferenceModel = exports.$MerchantPreferenceModel = _squid.$Model.extend('$MerchantPreferenceModel', {
    init: function init() {
        this._super.init.apply(this);

        this.setProperties({
            rm: _squid.$util.param('rm'), // Return Method
            return_url: _squid.$util.param('return'),
            auto_return: {
                enabled: false
            },
            pdt: {
                enabled: false
            }
        });
    },


    api: new _squid.$Api({
        baseURI: _squid.$config.urls.baseUrl,
        uri: '/api/profilemanagement/:id/getMerchantPreferences'
    }),

    autoReturn: function autoReturn() {
        return this.auto_return.enabled;
    },
    pdtEnabled: function pdtEnabled() {
        return this.pdt && this.pdt.enabled;
    },
    returnUrl: function returnUrl() {
        return this.return_url || this.auto_return.url;
    },


    /**
     * 0 – redirect using GET method ( default behavior )
     * 1 – redirect using the GET method, but no payment variables are included
     * 2 – redirect using the POST method, and include all payment variables
     */
    returnMethod: function returnMethod() {
        if (this.rm === '2') {
            return this.pdtEnabled() ? 'GET' : 'POST';
        }

        return 'GET';
    },
    returnMethodSupported: function returnMethodSupported() {
        return this.returnMethod() === 'GET';
    },


    /**
     * Determines if payment details need to be sent back to the merchant.
     * @returns {boolean}
     */
    postPaymentData: function postPaymentData() {
        return this.rm === '2' && !this.pdtEnabled() && this.returnUrl();
    },


    // charset of merchant having in profile
    charSet: function charSet() {
        return this.charset;
    }
});

angular.value("$MerchantPreferenceModel", $MerchantPreferenceModel);
_squid.$Model;

_squid.$Api;

_squid.$config;

_squid.$util;

/***/ }),

/***/ "../node_modules/xo-models/src/shippingMethod/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ShippingRuleSummaryModel = exports.$ShippingMethodModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $ShippingMethodModel = exports.$ShippingMethodModel = _squid.$Model.extend('$ShippingMethodModel', {
    api: new _squid.$Api({
        uri: '/api/shippingtax/charges'
    }),

    getShippingMethodId: function getShippingMethodId(shippingMethodType) {
        var shippingMethodsMap = {
            DEFAULT: '0',
            AIR_SERVICE: '1',
            ECONOMY: '2',
            EXPEDITED_AIR_SERVICE: '3',
            EXPEDITED_FLAT_RATE_SHIPPING: '4',
            EXPRESS: '5',
            EXPRESS_DOMESTIC: '6',
            FREE_SHIPPING: '7',
            GROUND: '8',
            GLOBAL_PRIORITY: '9',
            INTERNATIONAL_ECONOMY: '10',
            INTERNATIONAL_EXPEDITED: '11',
            INTERNATIONAL_EXPRESS: '12',
            INTERNATIONAL_EXPRESS_AIR: '13',
            INTERNATIONAL_PRIORITY_AIR: '14',
            NEXT_DAY: '15',
            NEXT_DAY_AIR: '16',
            NEXT_DAY_AIR_ECONOMY: '17',
            ONE_DAY_SHIPPING: '18',
            OVERNIGHT: '19',
            OVERNIGHT_FLAT_RATE_SHIPPING: '20',
            PICKUP: '21',
            PRIORITY: '22',
            RUSH_DELIVERY: '23',
            STANDARD_DOMESTIC: '24',
            STANDARD_EXPEDITED: '25',
            STANDARD_FLAT_RATE_SHIPPING: '26',
            STANDARD_INTERNATIONAL: '27',
            STANDARD_SHIPPING: '28',
            STORE_PICKUP: '29',
            TWO_DAY_SHIPPING: '30',
            WORLDWIDE_SHIPPING: '31',
            TWO_DAY_AIR: '32'
        };

        return shippingMethodsMap[shippingMethodType];
    },

    isStorePickUp: function isStorePickUp(shipping_method_type) {
        return shipping_method_type === 'STORE_PICKUP' || shipping_method_type === 'PICKUP';
    }
});

var $ShippingRuleSummaryModel = exports.$ShippingRuleSummaryModel = _squid.$Model.extend('$ShippingRuleSummaryModel', {
    api: new _squid.$Api({
        uri: '/api/shippingtax/:id/rulesSummary'
    })
});

angular.value("$ShippingMethodModel", $ShippingMethodModel);
angular.value("$ShippingRuleSummaryModel", $ShippingRuleSummaryModel);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/shoppingcart/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ShoppingCartModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $ShoppingCartModel = exports.$ShoppingCartModel = _squid.$Model.extend('$ShoppingCartModel', {
    api: new _squid.$Api({
        uri: '/api/shoppingcart/:id',
        postAttempts: 2,
        cache: false
    })
});

angular.value("$ShoppingCartModel", $ShoppingCartModel);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/subscription/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SubscriptionModel = exports.$CreateBAModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $CreateBAModel = exports.$CreateBAModel = _squid.$Model.extend('$CreateBAModel', {
    api: new _squid.$Api({
        uri: '/api/billagmt',
        postAttempts: 3
    })
});

var $SubscriptionModel = exports.$SubscriptionModel = _squid.$Model.extend('$SubscriptionModel', {
    api: new _squid.$Api({
        uri: '/api/billagmt/:id',
        postAttempts: 3,
        cache: true
    })
});

angular.value("$CreateBAModel", $CreateBAModel);
angular.value("$SubscriptionModel", $SubscriptionModel);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/thirdPartyWallet/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ThirdPartyOnboard = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $ThirdPartyOnboard = exports.$ThirdPartyOnboard = _squid.$Model.extend('$ThirdPartyOnboard', {
    api: new _squid.$Api({
        uri: '/api/third-party',
        cache: true
    })
});

angular.value("$ThirdPartyOnboard", $ThirdPartyOnboard);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/user/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$AuthConsentModel = exports.$UserPhotoModel = exports.$EConsentModel = exports.$WaxUserModel = exports.$PatchPhoneModel = exports.$AddKYCModel = exports.$ValidatePhoneModel = exports.$UserInfoModel = exports.$CheckoutInputDataModel = exports.$CheckoutClientDataModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $CheckoutClientDataModel = exports.$CheckoutClientDataModel = _squid.$Model.extend('$CheckoutClientDataModel', {
    api: new _squid.$Api({
        uri: '/api/user/:id/clientData'
    }),

    merchantIdentityData: function merchantIdentityData() {
        return {
            email: this.email,
            brand_name: this.display_name,
            logo_uri: this.logo_uri,
            identity_uri: this.identity_uri
        };
    },

    validateClient: function validateClient() {
        if (this.partner_id && this.identity_uri) {
            return {
                success: true
            };
        } else {
            return {
                success: false,
                error: 'invalid_client'
            };
        }
    },
    validateRedirectUri: function validateRedirectUri(redirectUrl) {
        if (this.identity_uri && this.identity_uri.indexOf(redirectUrl) > -1) {
            return {
                success: true
            };
        } else {
            return {
                success: false,
                error: 'invalid_redirect_url'
            };
        }
    }
});

var ACTION = {
    login: 'login',
    resolve: 'resolve',
    addCard: 'addCard',
    addBank: 'addBank',
    changeCurrencyConv: 'changeCurrencyConv',
    signup: 'signup',
    mandate: 'mandate',
    addCredit: 'addCredit',
    ulReturn: 'ulReturn',
    creditReturn: 'creditReturn',
    guestCurrencyConversion: 'guestCurrencyConversion',
    guestAuthentication: 'guestAuthentication',
    compliance: 'compliance'
};

var $CheckoutInputDataModel = exports.$CheckoutInputDataModel = _squid.$Model.extend('$CheckoutInputDataModel', {
    init: function init() {
        this._super.init.apply(this);
        this.setProperties({
            client_id: _squid.$util.param('client_id'),
            action: _squid.$util.param('action'),
            redirect_uri: _squid.$util.param('redirect_uri'),
            scope: _squid.$util.param('scope'),
            state: _squid.$util.param('state'),
            flow: _squid.$util.param('flow'),
            payer_id: _squid.$util.param('payer_id'),
            mandate_reference_number: _squid.$util.param('mandate_reference_number'),
            funding_option_id: _squid.$util.param('funding_option_id'),
            locale: _squid.$util.param('locale'),
            logout: _squid.$util.param('logout'),
            refresh_parent: _squid.$util.param('refresh_parent'),
            escape_hatch: _squid.$util.param('escape_hatch'),
            failedBecause: _squid.$util.param('failedBecause'),
            redirectReferrer: _squid.$util.param('redirectReferrer'),
            id_token: _squid.$util.param('prox_id'),
            nonce: _squid.$util.param('nonce'),
            hide_rm: _squid.$util.param('hideRM'),
            payloadEnc: _squid.$util.param('payloadEnc'),
            xcancel: _squid.$util.param('x-cancel'),
            xsuccess: _squid.$util.param('x-success')
        });
    },

    api: new _squid.$Api({
        baseURI: _squid.$config.urls.baseUrl,
        uri: '/api/user/:id/payerId'
    }),

    isEbayTxn: function isEbayTxn() {
        return Boolean(this.client_id);
    },

    validAction: function validAction() {
        var actions = {
            login: 'login',
            resolve: 'resolve',
            addCard: 'addCard',
            addBank: 'addBank',
            changeCurrencyConv: 'changeCurrencyConv',
            signup: 'signup',
            mandate: 'mandate',
            addCredit: 'addCredit',
            ulReturn: 'ulReturn',
            creditReturn: 'creditReturn',
            guestCurrencyConversion: 'guestCurrencyConversion',
            guestAuthentication: 'guestAuthentication',
            compliance: 'compliance'
        };

        return actions.hasOwnProperty(this.action);
    },

    showRYP: function showRYP() {
        return !this.isEbayTxn();
    },

    requiresOAuth: function requiresOAuth() {
        return this.action === ACTION.login || this.action === ACTION.signup;
    },

    requiresRedirectUri: function requiresRedirectUri() {
        return this.action === ACTION.mandate || !this.requiresOAuth();
    },

    validRedirectUri: function validRedirectUri() {
        if (this.requiresRedirectUri()) {
            return Boolean(this.redirect_uri);
        }
        return true;
    },

    validate: function validate() {
        var error;
        var success = true;

        if (this.isEbayTxn()) {
            if (!this.validAction()) {
                success = false;
                error = 'invalid_action';
            } else if (!this.validRedirectUri()) {
                success = false;
                error = 'invalid_redirect_uri';
            }
        }

        return {
            success: success,
            error: error
        };
    },

    errorUrl: function errorUrl(err, errorDesc) {
        var url = this.redirect_uri;

        url += url && url.indexOf('?') < 0 ? '?' : '&';
        url += 'state=' + encodeURIComponent(this.state);

        if (err) {
            url += '&error=' + err;
        }
        if (errorDesc) {
            url += '&error_description=' + errorDesc;
        }

        return url;
    },

    successUrl: function successUrl(code) {
        var url = this.redirect_uri;

        url += url && url.indexOf('?') < 0 ? '?' : '&';
        url += 'state=' + encodeURIComponent(this.state);

        url += '&code=' + code;

        return url;
    },

    rmEnabled: function rmEnabled(featureEnabled) {
        return featureEnabled && this.action === ACTION.login;
    },

    hideRM: function hideRM() {
        return angular.isDefined(this.hide_rm) ? this.hide_rm.toLowerCase() === 'true' : false;
    }
});

var $UserInfoModel = exports.$UserInfoModel = _squid.$Model.extend('$UserInfoModel', {
    api: new _squid.$Api({
        uri: '/api/user/:id/session'
    })
});

var $ValidatePhoneModel = exports.$ValidatePhoneModel = _squid.$Model.extend('$ValidatePhoneModel', {
    api: new _squid.$Api({
        uri: '/api/user/:token/session/validatePhone',
        cache: false
    })
});

var $AddKYCModel = exports.$AddKYCModel = _squid.$Model.extend('$AddKYCModel', {
    api: new _squid.$Api({
        uri: '/api/user/:token/session/addKYC'
    })
});

var $PatchPhoneModel = exports.$PatchPhoneModel = _squid.$Model.extend('$PatchPhoneModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:token/session/patch',
        cache: false
    })
});

var $WaxUserModel = exports.$WaxUserModel = _squid.$Model.extend('$WaxUserModel', {
    api: new _squid.$Api({
        uri: '/api/user/:id/waxUser'
    })
});

var $EConsentModel = exports.$EConsentModel = _squid.$Model.extend('$EConsentModel', {
    api: new _squid.$Api({
        uri: '/api/user/eConsent'
    }),

    invalidateOnLogout: true // invalidate this model when auth.logout() gets called
});

var $UserPhotoModel = exports.$UserPhotoModel = _squid.$Model.extend('$UserPhotoModel', {
    api: new _squid.$Api({
        baseURI: _squid.$config.urls.baseUrl,
        uri: 'api/user/photo'
    }),

    invalidateOnLogout: true // invalidate this model when auth.logout() gets called
});

var $AuthConsentModel = exports.$AuthConsentModel = _squid.$Model.extend('$AuthConsentModel', {
    api: new _squid.$Api({
        uri: '/api/user/authConsent'
    })
});

angular.value("$CheckoutClientDataModel", $CheckoutClientDataModel);
angular.value("$CheckoutInputDataModel", $CheckoutInputDataModel);
angular.value("$UserInfoModel", $UserInfoModel);
angular.value("$ValidatePhoneModel", $ValidatePhoneModel);
angular.value("$AddKYCModel", $AddKYCModel);
angular.value("$PatchPhoneModel", $PatchPhoneModel);
angular.value("$WaxUserModel", $WaxUserModel);
angular.value("$EConsentModel", $EConsentModel);
angular.value("$UserPhotoModel", $UserPhotoModel);
angular.value("$AuthConsentModel", $AuthConsentModel);
_squid.$Model;

_squid.$Api;

_squid.$util;

_squid.$config;

/***/ }),

/***/ "../node_modules/xo-models/src/wallet/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$WalletModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _instrument = __webpack_require__("../node_modules/xo-models/src/wallet/instrument.js");

// ID https://engineering.paypalcorp.com/confluence/display/PayPalMediaService/Image+Request+Metadata+Data
var imageSizeId = '0';

var normalize = function normalize(instId) {
    return instId && instId.replace(/-/g, '');
};

var imageTypes = ['png', 'jpg', 'gif', 'bmp'];
var imageType = function imageType(mimeType) {
    return _squid.$util.find(imageTypes, function (t) {
        return mimeType.indexOf(t) !== -1;
    }) || 'png';
};

// Network types to check for linked cards
var NETWORK_TYPES = {
    CHASE: 'CHASENET'
};

function capFirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

function getLinkedCapability(cardData) {
    return cardData.fs.capabilities.find(function (cap) {
        return cap.name === 'TOKEN';
    });
}

var $WalletModel = exports.$WalletModel = _squid.$Model.extend('$WalletModel', {
    invalidateOnLogout: true,
    api: new _squid.$Api({
        uri: '/api/fi/wallet/wallet'
    }),

    getId: function getId(fs) {
        return normalize(fs.instrument_id || fs.id);
    },

    getCardMask: function getCardMask(fs) {
        var rep = this.getWalletRepresentation(fs);

        if (!rep) {
            return { mask: true };
        }

        var selector = rep.type === 'card' ? 'product_class' : 'type';
        var renderedType = void 0;

        if (rep.fs[selector] === 'UNKNOWN' || !rep.fs[selector]) {
            renderedType = '';
        } else {
            renderedType = capFirst(rep.fs[selector]) + ' ';
        }

        return {
            before: renderedType,
            mask: true,
            after: rep.fs.last_nchars || rep.fs.last_nchars_card_number || ''
        };
    },

    /**
     * Returns the wallet API data for a FI given a funding source from the checkoutSession model
     * @returns {Instrument|BankInstrument|null}
     */
    getWalletRepresentation: function getWalletRepresentation(fs) {
        // Balance does not have an ID, so we search for this first
        if (fs.type === 'BALANCE') {
            var currency = fs.amount && fs.amount.currency_code;

            var bal = _squid.$util.find(this.balance_accounts, function (b) {
                return b.currency_code === currency;
            });

            return bal ? new _instrument.Instrument({
                type: 'balance',
                fs: bal
            }) : null;
        }

        // Otherwise, search other types that have IDs
        var id = this.getId(fs);

        return this.getById(id);
    },


    /**
     * Returns the wallet API data for a FI based on the id provided
     * @returns {Instrument|BankInstrument|null} - the model of the FI, if found
     */
    getById: function getById(id) {
        if (!id) {
            return null;
        }

        return this.getCardById(id) || this.getBankById(id) || null;
    },


    /**
     * Return the wallet API data for a FI of a card id provided
     * @returns {Instrument}
     */
    getCardById: function getCardById(id) {
        var card = _squid.$util.find(this.card_accounts, function (c) {
            return normalize(c.id) === id;
        });

        return card && new _instrument.Instrument({
            type: 'card',
            fs: card
        });
    },


    /**
     * Return the wallet API data for a FI of a bank id provided
     * @returns {BankInstrument}
     */
    getBankById: function getBankById(id) {
        var bank = _squid.$util.find(this.bank_accounts, function (b) {
            return normalize(b.id) === id;
        });

        return bank && new _instrument.BankInstrument({
            type: 'bank',
            fs: bank
        });
    },


    getCustomName: function getCustomName(fs) {
        var rep = this.getWalletRepresentation(fs);

        if (!rep) {
            return false;
        }

        return rep.type === 'card' && rep.fs.issuer && rep.fs.issuer.issuer_product_description;
    },

    getCardArt: function getCardArt(fs) {
        try {
            var cardId = this.getId(fs);
            var card = this.getCardById(cardId);
            var primary_content = card.fs.card_art_details.card_art.primary_content;

            var base = primary_content.base_cdn_link_path || primary_content.base_cdnlink_path;

            var path = base + imageSizeId + '.' + imageType(primary_content.original_mime_type);

            return path;
        } catch (e) {
            return null;
        }
    },

    /**
     * retrieve list of total balances (each currency is a separate balance account)
     * Notes:
     * 1. Skip balances with '0' amount
     * 2. Since wallet returns amount in "cents" - convert it to "dollars".
     *    For us it's safe to divide by 100 as PayPal doesn't support currencies with more than 2 decimal points.
     *    For those currencies with no decimal points - wallet adds two zeros, e.g
     *        in case of JPY - 1 JPY will be sent as 100 to the response
     */
    getAmountsOfBalances: function getAmountsOfBalances() {
        var balances = [];

        this.get('balance_accounts', []).forEach(function (balanceAccount) {
            var _balanceAccount$sub_b = balanceAccount.sub_balances.find(function (subBalance) {
                return subBalance.type === 'TOTAL_BALANCE';
            }),
                amount = _balanceAccount$sub_b.amount;

            if (amount.value !== '0') {
                balances.push({
                    value: Number(amount.value) / 100,
                    currency: amount.currency
                });
            }
        });

        return balances;
    },

    isLinkedCard: function isLinkedCard(fi) {
        var id = this.getId(fi);
        var card = this.getCardById(id);
        var hasLinkedCapability = card && !!getLinkedCapability(card);

        return hasLinkedCapability;
    },


    /**
     * Check if the given CI passed is a ChasePay linked card, which means it was added by linking to their Chase account
     */
    isChaseLinkedCard: function isChaseLinkedCard(fi) {
        var id = this.getId(fi);
        var card = this.getCardById(id);
        var linkedCapability = card && getLinkedCapability(card);

        if (!linkedCapability) {
            return false;
        }

        return linkedCapability.network_contingencies.some(function (networkInfo) {
            return networkInfo.network === NETWORK_TYPES.CHASE;
        });
    }
});

angular.value("$WalletModel", $WalletModel);
_squid.$Model;

_squid.$Api;

_squid.$util;

_instrument.Instrument;

_instrument.BankInstrument;

/***/ }),

/***/ "../node_modules/xo-models/src/wallet/instrument.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.BankInstrument = exports.Instrument = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

/*
 * Base model for wallet instrument data, to be used as a fallback if more specific
 * model does not exist
 */
var Instrument = exports.Instrument = _squid.$Class.extend('Instrument', {
    getName: _squid.$util.noop,
    getLastChars: _squid.$util.noop
});

var BankInstrument = exports.BankInstrument = Instrument.extend({
    getName: function getName() {
        return this.get('fs.issuer.name');
    },
    getLastChars: function getLastChars() {
        return this.get('fs.last_nchars');
    }
});

_squid.$util;

_squid.$Class;

/***/ }),

/***/ "../node_modules/xo-page-components/src/aside-header/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _template = __webpack_require__("../node_modules/xo-page-components/src/aside-header/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().directive('xoAsideHeader', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            hdrtype: '@?',
            heading: '@?',
            subHead: '@?',
            addLink: '@?',
            backUrl: '@?',
            closeUrl: '@?',
            hidex: '@?',
            headerLeftLink: '=?',
            headerLeft: '@?',
            headerLeftIcon: '@?',
            headerRightLink: '=?',
            headerRight: '@?',
            headerRightIcon: '@?',
            subHeaderLeftLink: '@?',
            subHeaderLeft: '@?',
            subHeaderLeftIcon: '@?',
            subHeaderRightLink: '@?',
            subHeaderRight: '@?',
            subHeaderRightIcon: '@?',
            showDualFi: '=?'
        },
        controller: ['$scope', '$element', function ($scope, $element) {
            (0, _angular.$timeout)(function () {
                $element.find('.header').focus();
            });

            if (_angular2['default'].isUndefined($scope.closeUrl)) {
                $scope.closeUrl = 'checkout.review';
            }

            if ($scope.addLink) {
                $scope.subHeaderRight = 'asideHeader.add';
                $scope.subHeaderRightLink = $scope.addLink;
            }

            $scope.onClickLink = function (event, target, showDualFi) {
                event.preventDefault();

                if (showDualFi) {
                    $scope.showFiOptions = true;
                } else if (_angular2['default'].isFunction(target)) {
                    target();
                } else {
                    _uiRouter.$state.go(target);
                }
            };
        }]
    };
});

_uiRouter.$state;

/***/ }),

/***/ "../node_modules/xo-page-components/src/aside-header/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"header noButtons\" tabindex=\"-1\" ng-class=\"[hdrtype]\" content>\n    <div class=\"primaryHeader\">\n        <h1 class=\"asideAlpha walletHeading noHead noBottom alpha\">{{ content(heading) }}</h1>\n        <a link-button ui-sref=\"{{backUrl}}\" class=\"backArrow focusableIcon goTray\" ng-if=\"backUrl\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n        <a link-button ng-click=\"onClickLink($event, headerLeftLink)\" class=\"left\" ng-if=\"headerLeftLink\">\n            <span ng-if=\"headerLeftIcon\" class=\"leftIcon\"></span>\n            <span class=\"accessAid\">{{ content(headerLeft) }}</span>\n        </a>\n        <a link-button ui-sref=\"{{closeUrl}}\" class=\"close focusableIcon\" ng-if=\"!backUrl && !hidex\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n        <a link-button ng-click=\"onClickLink($event, headerRightLink)\" class=\"right focusableIcon\" ng-if=\"headerRightLink\">\n            <span ng-if=\"headerRightIcon\" class=\"rightIcon\"></span>\n            <span class=\"accessAid\">{{ content(headerRight) }}</span>\n        </a>\n    </div>\n\n    <div class=\"subHeader\" ng-class=\"{'addOptions': !subHeaderLeftLink}\" ng-if=\"subHeaderLeftLink || subHeaderRightLink\">\n        <h2 class=\"subheading gamma\" ng-if=\"!subHeaderLeftLink\">{{ content(subHead) }}</h2>\n        <a link-button ui-sref=\"{{subHeaderLeftLink}}\" ng-click=\"onClickLink($event, subHeaderLeftLink, showDualFi)\" ng-if=\"subHeaderLeftLink\" id=\"leftLink\" class=\"left\" data-test-id=\"sideBarAddLink\">\n            <span ng-if=\"subHeaderLeftIcon\" class=\"leftIcon\"></span>\n            <span class=\"leftText\">{{ content(subHeaderLeft) }}</span>\n        </a>\n        <a link-button ui-sref=\"{{subHeaderRightLink}}\" ng-class=\"{'addLink': !subHeaderLeftLink}\"  ng-click=\"onClickLink($event, subHeaderRightLink)\" ng-if=\"subHeaderRightLink\" id=\"rightLink\" class=\"right\">\n            <span ng-if=\"subHeaderRightIcon\" class=\"rightIcon\"></span>\n            <span class=\"rightText\">{{ content(subHeaderRight) }}</span>\n        </a>\n    </div>\n</div>\n<div class=\"fundingInstrumentList\" id=\"fundingInstrumentList\" ng-if=\"showFiOptions\">\n    <ul>\n        <li class=\"bank\">\n            <a link-button ui-sref=\"checkout.review.sidebar.sidebarAddBank.bank.add\" id=\"addBank\" class=\"submit\">\n                <span class=\"icon\"></span>\n                <span class=\"description\">{{ content('DEMemberGuest.addBank')}}</span>\n            </a>\n        </li>\n        <li class=\"cards\">\n            <a link-button ui-sref=\"checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard\" id=\"addCC\" class=\"submit\">\n                <span class=\"icon\"></span>\n                <span class=\"description\">{{ content('DEMemberGuest.addCC')}}</span>\n            </a>\n        </li>\n    </ul>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/cartWrapper/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/cart/cartWrapper/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('cartWrapper', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            showAmt: '=?',
            showArrow: '=?',
            token: '=?'
        },
        controller: ['$scope', function ($scope) {
            _squid.$util.assert($scope.token, 'Expected token');

            (0, _squid.$populate)($scope, {
                checkoutCart: _index.$CheckoutCartModel.instance($scope.token)
            });
        }]
    };
});

_squid.$populate;

_squid.$util;

_index.$CheckoutCartModel;

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/cartWrapper/template.html":
/***/ (function(module, exports) {

module.exports = "<span class=\"totalWrapper clearfix\" id=\"totalWrapper\" content>\n    <span id=\"transactionCart\" ng-class=\"{hasItems:showArrow}\">\n        <span class=\"cartIcon\" aria-label=\"{{ content('base.shoppingCart') }}\"></span>\n        <span ng-if=\"showAmt\">\n            <format-currency class=\"formatCurrency\" code=\"checkoutCart.purchase.amounts.total.currency_code\"\n                             amount=\"checkoutCart.purchase.amounts.total.amount\"></format-currency>\n        </span>\n        <span ng-if=\"showArrow\" class=\"arrow\" aria-label=\"{{ content('common.show') }}\"/>\n    </span>\n</span>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/cartWrapper/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/itemDetails/directive.js");

var _showCartDecision = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/showCartDecision.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/lib/ui.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/subscription/directive.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/cart/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoCart', function () {
    return {
        template: _template2['default'],
        restrict: 'E',

        scope: {
            showCartTotal: '=?',
            renderCartContainer: '=?',
            token: '=?'
        },

        controller: ['$scope', function ($scope) {

            _squid.$util.assert($scope.token, 'Expected token');

            (0, _squid.$populate)($scope, {
                checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token),
                checkoutCart: _index.$CheckoutCartModel.instance($scope.token),
                payee: _index.$CheckoutPayeeModel.instance($scope.token)
            }).then(function loadCartData() {

                var emptyCart = $scope.checkoutCart.get('purchase.items.length', 0) <= 0;
                var cartDesc = $scope.checkoutCart.get('purchase.description');

                $scope.note = $scope.checkoutCart.get('note');

                // resolve string in descriptions array since the only element may be `null`
                // TODO: fix backend to return a string, to avoid this conditional
                if (cartDesc && angular.isString(cartDesc[0])) {
                    cartDesc = cartDesc[0];
                } else {
                    cartDesc = '';
                }

                $scope.desc = cartDesc;
                $scope.hasItems = !$scope.renderCartContainer && !emptyCart;
                var showCartDetails = !$scope.checkoutAppData.flags.hide_cart_details;
                var notMultiSellerPurchase = !$scope.checkoutCart.isMultiSellerPurchase();
                // Always Render minicart for wps subscription .
                var wpsSubscription = $scope.checkoutAppData.is_wps_subscription_flow();

                $scope.showArrow = wpsSubscription || showCartDetails && (cartDesc || $scope.hasItems || $scope.note) && notMultiSellerPurchase;

                // add details to render to the checkoutCart items
                $scope.checkoutCart.get('purchase.items', []).forEach(function addDetails(item) {
                    item.details = {};

                    if (item.quantity > 1) {
                        item.details.price = item.price.amount;
                        item.details.quantity = (0, _squid.formatQuantity)(item.quantity);
                    }

                    if (item.description) {
                        if (!item.name) {
                            item.name = item.description;
                        } else {
                            item.details.description = item.description;
                        }
                    }

                    // move options to detail section
                    if (item.item_option_selections) {
                        item.details.hasSelections = true;
                        item.details.item_option_selections = item.item_option_selections;
                    }

                    if (item.sku) {
                        item.details.sku = item.sku;
                    }

                    item.hasDetails = Object.keys(item.details).length > 0;
                    item.details.hasMore = item.hasDetails || item.details.hasSelections;
                });

                // Mapping of field name as recieved by API to corresponding property key
                $scope.amountHeaders = {
                    'total': 'header.total',
                    'subtotal': 'header.itemTotal',
                    'tax': 'header.tax',
                    'shipping': 'header.shipping',
                    'insurance': 'header.insurance',
                    'handling_fee': 'header.handling',
                    'shipping_discount': 'header.shippingDiscount',
                    'description': 'header.description',
                    'discount': 'header.discount'
                };

                // Non-AU merchants are subjected to PXP test when user action is not commit and line item details
                // are not available and purchase amount is not zero.
                var userAction = $scope.userAction = $scope.checkoutAppData.useraction();
                var noLineItemDetails = !(userAction && userAction.toLowerCase() === 'commit') && emptyCart;

                var purchase = $scope.checkoutCart.purchase;
                var total = purchase && purchase.amounts && purchase.amounts.total;

                return (0, _showCartDecision.showCartDecision)($scope.checkoutAppData.is_wps_subscription_flow(), total, $scope.checkoutAppData.get('merchant.merchant_country'), $scope.payee.get('merchant.id', ''), noLineItemDetails, $scope.checkoutCart.isPurchase()).then(function (result) {
                    $scope.showAmt = result.showAmt;
                    $scope.showCartSubTotal = result.showCartSubTotal;
                    $scope.showAmountInCartIcon = result.showAmountInCartIcon;
                });
            }).then(function handleCartOpenClose() {
                // the cart is only automatically open under the following criteria:
                // 1. the cart has a 'note to buyer' ($scope.note is defined)
                // 2. the cart was not previously automatically opened before
                // 3. the state has transitioned to checkout.review or checkout.guest
                function decideShowCart(currentState) {
                    var falsePositive = /^checkout\.(selectFi)$/.test(currentState) && /^checkout\.(review|guest)$/.test($scope.openedAlready);
                    var notOpened = !$scope.openedAlready && /^checkout\.(review|guest)$/.test(currentState);
                    var canShow = notOpened || falsePositive;

                    if ($scope.note && canShow) {
                        $scope.openedAlready = currentState; // may have been undefined before
                        return true;
                    }

                    return false;
                }

                $scope.showCartItem = function (breakdown) {
                    return breakdown.field_name !== 'total' && Number(breakdown.amount) !== 0;
                };

                $scope.showCart = decideShowCart(_uiRouter.$state.current.name);

                // TODO: Must we really couple this so tightly with the state transition names?
                var openCartListener = _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState) {
                    $scope.showCart = decideShowCart(toState.name);
                });

                $scope.$on('$destroy', openCartListener); // see http://stackoverflow.com/a/27016855 on why $destroy

                $scope.toggleCart = function ($event) {
                    $scope.showCart = !$scope.showCart;
                    $event.preventDefault();
                };

                $scope.closeCart = function ($event) {
                    $scope.showCart = false;
                    // for accessible autofocus on cart toggle link button
                    $scope.$broadcast('cart-closed');
                    if ($event) {
                        $event.preventDefault();
                    }
                };

                $scope.$on('clickBody', function ($event, target) {
                    if ($scope.showCart && $(target).parents('.cartContainer').length === 0) {
                        $scope.closeCart($event);
                        $scope.$apply();
                    }
                });

                // this listener / broadcast allows accessibility components to scan and focus inside the cart
                // when the cart is displayed
                $scope.$watch('showCart', function (showCart) {
                    if (showCart) {
                        $scope.$broadcast('cart-updated');
                    }
                });
            }).then(function handleEllipsisIssues() {
                // NOTE: the scattered broadcasts of "cart-updated" events are mostly
                // to allow the accessibility directives modal-box and focus-when to
                // know when to recalculate keyboard behavior / focus
                $scope.toolongTracker = {};

                // this function is invoked by the onEllipsis directive that tracks
                // if the item name won't fit within the restricted space.
                $scope.toolong = function (idx) {
                    $scope.toolongTracker[idx] = true;
                    $scope.$broadcast('cart-updated');
                };

                $scope.showMore = function (idx, type) {
                    // there are 2 types of more, "floating" when the name is too long
                    // and "inline" when the name can fit, but there are additional details.
                    //
                    // Show a more if the item
                    // 1. has an expanded state
                    // 2. is not already expanded
                    // 3. if it is appropriate to show that type.
                    var itemIsTooLong = $scope.toolongTracker[idx];
                    var isAppropriateType = itemIsTooLong && type === 'floating' || !itemIsTooLong && type === 'inline';

                    return $scope.hasExpandedState(idx) && !$scope.isExpanded(idx) && isAppropriateType;
                };

                $scope.expandedIndex = -1; // initially, none of the line items are expanded
                $scope.isExpanded = function isExpanded(idx) {
                    return idx === $scope.expandedIndex;
                };
                $scope.hasExpandedState = function hasExpandedState(idx) {
                    // A line item is exandable if
                    // 1. the name cannot fit in one line ($scope.toolongTracker) and/or
                    // 2. there are details (attached to purchase.items in the cart)
                    // 3. there is item number (sku) in the item
                    var item = $scope.checkoutCart.get('purchase.items', [])[idx] || {};
                    var nameTooLong = $scope.toolongTracker[idx];

                    return nameTooLong || item.hasDetails || item.sku;
                };
                $scope.expand = function expand(idx) {
                    $scope.expandedIndex = idx;
                    $scope.$broadcast('cart-updated');
                };
                $scope.collapse = function collapse() {
                    $scope.expandedIndex = -1;
                    $scope.$broadcast('cart-updated');
                };

                $scope.$emit('dataLoaded');
            });
        }]
    };
});

_angular.$rootScope;

_squid.$populate;

_squid.$util;

_squid.formatQuantity;

_uiRouter.$state;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_showCartDecision.showCartDecision;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/itemDetails/directive.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/cart/itemDetails/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('itemDetails', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            details: '=?',
            sku: '=?',
            currencyCode: '=?',
            onClickLess: '&?'
        },
        controller: function controller() {/* dumb component */}
    };
});

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/itemDetails/template.html":
/***/ (function(module, exports) {

module.exports = "<!-- this directive requires\n  * visible boolean\n  * details object (with .price, .quantity, .description,\n  * possible .item_option_selections)\n  * currency-code string\n  * possible sku (item number)\n  * on-click-less - function invocation expression\n-->\n<ul focusable content class=\"itemDetails\">\n  <li ng-if=\"details.sku\">\n      <span>\n          <strong>{{ content('header.itemNumber') }}</strong> <span class=\"item-number\">{{ details.sku }}</span>\n      </span>\n  </li>\n  <li ng-if=\"details.price\">{{ content('header.price') }}\n    <format-currency code=\"currencyCode\" amount=\"details.price\"></format-currency>\n  </li>\n  <li ng-if=\"details.quantity\">{{ content('header.quantity') }} <span class=\"item-quantity\">{{ details.quantity }}</span></li>\n  <li ng-if=\"details.hasMore\">\n    <div ng-if=\"details.hasSelections\" class=\"item-selections\">\n      <span class=\"item-selection\" ng-repeat=\"selection in details.item_option_selections track by $index\">\n        <strong class=\"item-selection-name\">{{ selection.name }}:</strong>\n        <span class=\"item-selection-value\">{{ selection.select }}</span>\n      </span>\n    </div>\n\n    <div ng-if=\"details.description\">\n      <strong class=\"item-selection-name\">{{ content('header.description') }}</strong> <span class=\"item-description\">{{ details.description }}</span>\n    </div>\n  </li>\n</ul>\n<a class=\"less\" link-button=\"content('header.srLess')\" ng-click=\"onClickLess()\">{{ content('header.less') }}</a>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/lib/decode_entities.js":
/***/ (function(module, exports) {



/**
 * Takes a string with HTML entities within and renders it as the unicode
 * characters they represent. This is done by leveraging the browser to
 * perform this transformation internally. InnerText is chosen as the output
 * so as to kill any HTML itself that was supplied.
 *
 * @param {Element} element any HTML element supporting innerText and
 * innerHTML. Preferably one not connected to the DOM or visible in any way.
 * @param {String} input a String containing HTML entities that need to be
 * decoded and HTML stripped.
 * @return {String} the same string with HTML tags removed and entities
 * decoded.
 */

exports.__esModule = true;
exports.decodeEntities = decodeEntities;
exports['default'] = decodeEntitiesAngularFilter;
function decodeEntities(element, input) {
    // Escape opening tags on vulnerable tags
    input = input.replace(/<(\/?)(html|script|body|meta|style|img|iframe|svg|link)/ig, '&lt;$1$2');
    element.innerHTML = input;
    return element.textContent || element.innerText;
}

function decodeEntitiesAngularFilter() {
    // A constant key that can be used to find the element
    var ENTITY_ELEM = '__xpc_entitydecoder__';

    // Create the element if this is the first time this is called
    if (!window[ENTITY_ELEM]) {
        window[ENTITY_ELEM] = document.createElement('p');
    }

    // Retrieve the converter element rather than create one every
    // time. Angular may call this filter many times repeatedly and
    // we should make a small effort to optimize the process
    var converter = window[ENTITY_ELEM];

    /**
     * Takes a string with HTML entities within and renders it as the unicode
     * characters they represent. This is done by leveraging the browser to
     * perform this transformation internally. InnerText is chosen as the output
     * so as to kill any HTML itself that was supplied.
     *
     * @param {String} input a String containing HTML entities that need to be
     * decoded and HTML stripped.
     * @return {String} the same string with HTML tags removed and entities
     * decoded.
     */
    return decodeEntities.bind(null, converter);
}

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/lib/pxp.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$pxpCartAmt', function () {
    return function (merchantCountry, merchantId, noLineItemDetails, isPurchase) {
        if (merchantCountry !== 'AU' && noLineItemDetails && isPurchase) {
            var pageName = 'xo_hermes_no_line_item_details';
            var showAmtBlacklistTreatment = 'xo_hermes_no_line_items_show_amount_blacklist_test_group';
            var showAmtTreatment = 'xo_hermes_no_line_items_show_amount_test_group';

            return _angular.$q.all([(0, _squid.$pxp)(pageName, {
                'ctx.merchantID': merchantId,
                uid: merchantId
            }, showAmtBlacklistTreatment, false, true), (0, _squid.$pxp)(pageName, {
                'ctx.merchantID': merchantId,
                uid: merchantId
            }, showAmtTreatment, false, true)]).then(function (results) {
                var showAmtBlacklist = results[0];
                var showAmt = results[1];

                if (showAmtBlacklist && showAmtBlacklist.treatment_name === showAmtBlacklistTreatment) {
                    return true;
                }

                if (showAmt && showAmt.treatment_name === showAmtTreatment) {
                    return true;
                }

                return false; // default to hide
            });
        }

        return _angular.$q.when(!noLineItemDetails && isPurchase);
    };
});

_squid.$pxp;

_angular.$q;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-page-components/src/cart/lib", "../node_modules/xo-page-components/src/cart/lib/pxp.js"))

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/lib/showCartDecision.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.showCartDecision = showCartDecision;

var _pxp = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/pxp.js");

function showCartDecision(isWpsSubscriptionFlow, total, merchantCountry, merchantId, noLineItemDetails, isPurchase) {
    return (0, _pxp.$pxpCartAmt)(merchantCountry, merchantId, noLineItemDetails, isPurchase).then(function (showAmount) {
        // Show cart subtotal if there is a total amount
        // Do not show subtotal for wps subscription flow.
        // Show amount in cart icon only if showAmount is truthy and total amount is not zero
        return {
            showAmt: showAmount,
            showCartSubTotal: showAmount && total && !isWpsSubscriptionFlow,
            showAmountInCartIcon: showAmount && +total.amount !== 0
        };
    });
}

_pxp.$pxpCartAmt;

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/lib/ui.js":
/***/ (function(module, exports, __webpack_require__) {



var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _decode_entities = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/decode_entities.js");

var _decode_entities2 = _interopRequireDefault(_decode_entities);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Register entity decoding filter in Angular
_angular.$filterProvider.register('decodeEntities', _decode_entities2['default']);

// if an element has an ellipsis text-overflow in effect (it must already have
// the appropriate css styling) then invoke the function that is passed to the directive
function getVisibleWidth(elem) {
    var elemRect = elem.getBoundingClientRect();

    // cross browser, returns decimals for ultra-precision
    return elemRect.right - elemRect.left;
}

function getNaturalWidth(elem) {
    var old = {
        overflow: elem.style.overflow,
        width: elem.style.width,
        display: elem.style.display
    };
    var result = void 0;

    elem.style.overflow = 'visible';
    elem.style.width = 'auto';
    elem.style.display = 'inline-block';
    result = getVisibleWidth(elem);
    elem.style.overflow = old.overflow;
    elem.style.width = old.width;
    elem.style.display = old.display;

    return result;
}

// pre-determine approach to reading styles
var getStyle = _angular.$window.getComputedStyle ? function (elem, style) {
    return _angular.$window.getComputedStyle(elem)[style];
} // modern browsers
: function (elem, style) {
    return elem.currentStyle[style];
}; // IE

function hasEllipsis(elem) {
    var overflowHidden = getStyle(elem, 'overflow') === 'hidden';
    var textOverflowEllipsis = getStyle(elem, 'text-overflow') === 'ellipsis';
    var whiteSpaceNowrap = getStyle(elem, 'white-space') === 'nowrap';

    if (overflowHidden && textOverflowEllipsis && whiteSpaceNowrap) {
        return getVisibleWidth(elem) < getNaturalWidth(elem);
    }

    return false;
}

(0, _squid.$registerDirective)('onEllipsis', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            function invokeSubscriber() {
                (0, _angular.$parse)(attrs.onEllipsis)(scope);
                scope.$apply();
            }

            (0, _angular.$timeout)(function () {
                if (hasEllipsis(element[0])) {
                    invokeSubscriber();
                }
            });
        }
    };
});

// Makes an element examine the outerHeight of its siblings
// and the max-height of its parent, then sets a max-height for itself
// so that everything fits within the limits of the parent. Note that it assumes
// no other sibling also has dynamic-maxheight.
(0, _squid.$registerDirective)('dynamicMaxheight', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            function resizeContainer() {
                var $element = (0, _jquery2['default'])(element);
                var parentHeight = parseFloat(getStyle($element.parent()[0], 'max-height'));
                var siblings = $element.siblings().filter(function () {
                    var pos = getStyle((0, _jquery2['default'])(this)[0], 'position');

                    return pos !== 'fixed' && pos !== 'absolute';
                }).map(function getOuterHeights() {
                    return (0, _jquery2['default'])(this).outerHeight();
                });
                var siblingsHeight = 0;
                var i = void 0;

                for (i = 0; i < siblings.length; i += 1) {
                    siblingsHeight += siblings[i];
                }

                var spaceAvailable = parentHeight - siblingsHeight;

                if (!isNaN(spaceAvailable)) {
                    $element.css('max-height', spaceAvailable + 'px');
                }
            }

            // if an expression is provided, it is used as an event to listen for and recalculate the height
            if (attrs.dynamicMaxheight) {
                scope.$on((0, _angular.$parse)(attrs.dynamicMaxheight)(scope), resizeContainer);
            }

            (0, _angular.$timeout)(resizeContainer);
        }
    };
});

_squid.$registerDirective;

_angular.$parse;

_angular.$timeout;

_angular.$filterProvider;

_angular.$window;

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscription/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/subscription/index.js");

var _subscriptionTerms = __webpack_require__("../node_modules/xo-page-components/src/subscription-terms/index.js");

var _subscriptionTerms2 = _interopRequireDefault(_subscriptionTerms);

var _template = __webpack_require__("../node_modules/xo-page-components/src/cart/subscription/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/cart/subscription/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$subscription', {
    tag: 'subscription',
    template: _template2['default'],
    props: {
        baToken: {
            type: 'var',
            optional: false
        },
        merchantId: {
            type: 'var',
            optional: false
        }
    },
    resolve: {
        models: function models() {
            return {
                subscriptionData: _index.$SubscriptionModel.instance(this.baToken).retrieve({
                    params: {
                        merchant_id: this.merchantId
                    }
                })['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this = this;

            this.itemName = _subscriptionTerms2['default'].getItemName(this.models.subscriptionData);
            this.itemOptions = _subscriptionTerms2['default'].getItemOptions(this.models.subscriptionData);

            this.getFirstAmount = function () {
                return _subscriptionTerms2['default'].getFormattedFirstAmount(_this.models.subscriptionData);
            };

            this.getTermsText = function () {
                return _subscriptionTerms2['default'].getTermsText(_this.models.subscriptionData);
            };
        }
    }
});


_angular.noop;

_squid.$Component;

_index.$SubscriptionModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscription/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscription/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"subscriptionTerms\" content>\n    <div role=\"grid\" class=\"minicart\">\n        <div class=\"subscriptionDetails\" role=\"gridcell\">\n\n            <h4 class=\"heading\">{{content('wpsSubscription.message.subscriptionDetails')}}:</h4>\n            <div class=\"content\">\n\n                <span class=\"item-name\">{{itemName}}</span>\n                <div class=\"item-option\">\n                    <div ng-repeat=\"option in itemOptions track by $index\">{{option.name}}:\n                        {{option.selection}}\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"subs-terms-text\" role=\"gridcell\">\n            <h4 class=\"heading\">{{content('wpsSubscription.message.terms')}}:\n            </h4>\n            <div class=\"content\">\n                <span class=\"term-line\" ng-repeat=\"term in getTermsText() track by $index\">{{term}}</span>\n            </div>\n        </div>\n        <div class=\"firstAmount\" role=\"gridcell\">\n            <h4 class=\"heading\">{{content('wpsSubscription.message.firstAmount')}}</h4>\n            <div ng-bind-html=\"getFirstAmount()\" class=\"content\"></div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"cartContainer\" content ng-if=\"showAmt || showArrow\">\n    <div class=\"transactionDetailsContainer\" ng-class=\"{cart:showCart, hasAmount:showAmt}\">\n\n        <a href=\"#transactionCartDetails\"\n           class=\"transactionDetails scTrack:hermes-cartExpanded\"\n           aria-controls=\"transctionCartDetails\" aria-haspopup=\"true\"\n           role=\"button\" ng-click=\"toggleCart($event)\"\n           focus-when focus-refresh-on=\"'cart-closed'\" ng-if=\"showArrow\">\n            <cart-wrapper ng-if=\"showArrow\" show-amt=\"showAmountInCartIcon\" show-arrow=\"showArrow\" token=\"token\"></cart-wrapper>\n        </a>\n\n        <cart-wrapper ng-if=\"!showArrow\" show-amt=\"showAmountInCartIcon\" show-arrow=\"showArrow\"\n                      token=\"token\"></cart-wrapper>\n\n        <div class=\"transctionCartDetails\" id=\"transctionCartDetails\" modal-box modal-refresh-on=\"'cart-updated'\" modal-cancel=\"closeCart()\" aria-hidden=\"{{ !showArrow }}\" ng-if=\"showArrow\">\n            <div class=\"details\" role=\"document\" focus-when focus-refresh-on=\"'cart-updated'\" focus-element=\"expandedIndex === -1 ? 'a.more': '.itemNameContainer.expanded'\">\n\n                <a id=\"closeCart\" link-button=\"content('header.close')\" class=\"actions focusableIcon\" ng-click=\"closeCart($event)\" ></a>\n\n                <div>\n                    <h2 ng-if=\"checkoutAppData.merchant\" class=\"merchantName\" ng-class=\"{merchantTitle: showAmt && (note || desc)}\" id=\"merchantName\">\n                        <span ng-if=\"note\">{{ content('header.noteFromMerchant', {merchant: checkoutAppData.merchant.brand_name}) }}</span>\n                        <span ng-if=\"!note\">{{ checkoutAppData.merchant.brand_name }}</span>\n                    </h2>\n                    <p ng-if=\"note || desc\"class=\"note\" ng-class=\"{ noteHighlighted: desc || !showAmt }\">\n                        <span ng-if=\"note\">{{ note | decodeEntities }}</span>\n                        <span ng-if=\"!note\">{{ desc | decodeEntities }}</span>\n                    </p>\n                </div>\n\n                <subscription ng-if=\"checkoutAppData.is_wps_subscription_flow()\"\n                              ba-token=\"checkoutCart.getBaToken()\" merchant-id=\"payee.getId()\"></subscription>\n\n\n                <div ng-if=\"!checkoutAppData.is_wps_subscription_flow()\" dynamic-maxheight=\"'cart-updated'\" class=\"scrollable-middle\">\n                    <ul class=\"detail-items\" ng-if=\"hasItems\">\n                        <li ng-repeat=\"item in checkoutCart.purchase.items track by $index\" class=\"items\">\n\n                            <div focusable class=\"itemNameContainer\" ng-class=\"{expanded: isExpanded($index)}\">\n                                <a class=\"more\" link-button=\"content('header.srMore')\" ng-show=\"showMore($index, 'floating')\" ng-click=\"expand($index)\">{{ content('header.more') }}</a>\n                                <span on-ellipsis=\"toolong($index)\" title=\"{{ item.name }}\" class=\"itemName\">{{ item.name }} <a class=\"less\" link-button=\"content('header.srLess')\" ng-show=\"isExpanded($index) && !item.hasDetails\" ng-click=\"collapse()\">{{ content('header.less') }}</a><a class=\"more inline-more\" link-button=\"content('header.srMore')\" ng-show=\"showMore($index, 'inline')\" ng-click=\"expand($index)\">{{ content('header.more') }}</a></span>\n                            </div>\n                            <span class=\"itemPrice\">\n                                <format-currency code=\"item.amount.currency_code\" amount=\"item.amount.amount\"></format-currency>\n                            </span>\n                            <item-details ng-show=\"isExpanded($index) && item.hasDetails\" currency-code=\"item.amount.currency_code\" details=\"item.details\" on-click-less=\"collapse()\">\n                        </li>\n                    </ul>\n\n                    <ul class=\"detail-extras\" ng-if=\"showAmt && hasItems\">\n                        <li class=\"detail-breakdown\" ng-if=\"checkoutCart.purchase.amounts\">\n                            <li ng-repeat=\"breakdown in checkoutCart.purchase.amounts track by $index\" class=\"amounts\" ng-if=\"showCartItem(breakdown)\">\n                                <span class=\"itemNameContainer\">{{ content(amountHeaders[breakdown.field_name]) }}</span>\n                                <span class=\"itemPrice\">\n                                    <format-currency code=\"breakdown.currency_code\" amount=\"breakdown.amount\"></format-currency>\n                                </span>\n                            </li>\n                        </li>\n                    </ul>\n                </div>\n\n                <div class=\"subTotal\" ng-if=\"showCartSubTotal\">\n                    <span class=\"itemNameContainer\">{{ userAction === 'commit' || showCartTotal === true ? content('header.total') : content('header.subTotal') }}</span>\n                    <span class=\"itemPrice\">\n                        <format-currency code=\"checkoutCart.purchase.amounts.total.currency_code\"\n                                         amount=\"checkoutCart.purchase.amounts.total.amount\"></format-currency>\n                    </span>\n                </div>\n\n            </div>\n            <div class=\"pointer\"> </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/constants/fbMessenger.js":
/***/ (function(module, exports) {



/* Constants for FB messenger related components */
module.exports = {
    OVERRIDE_FBPP_REPEAT_FLAG: 'override_fbpp_repeat',
    OVERRIDE_FBPP_MOBILE_FLAG: 'override_fbpp_mobile',
    FB_BA_SHOWN_FLAG: 'is_xo_wps_fb_messenger_plugin_match_withba_shown',
    MOBILE_CHANNEL: 'MOBILE',
    WEB_CHANNEL: 'WEB',
    FB_USER_API_MOBILE_URL: 'https://m.facebook.com/paypal/user_identifier',
    FB_USER_API_URL: 'https://www.facebook.com/paypal/user_identifier',
    FB_PROD_APP_ID: '1084613224964631',
    FB_PROD_PAGE_ID: {
        US: '55982004572',
        AU: '171522459698178',
        CA: '164660263560926',
        GB: '167465479930420',
        HK: '575224445931086',
        JP: '252040838174046',
        NZ: '171522459698178',
        PH: '1895483750701842',
        SG: '1405303076421245',
        IL: '369238992488',
        CZ: '199396843578121',
        DE: '109838022384872',
        AT: '109838022384872',
        CH: '109838022384872',
        FR: '124143236317',
        IT: '198366693576785',
        BR: '170288122998781',
        ES: '244240615638886',
        MX: '42433532610',
        ZA: '388473619362',
        NL: '105370782861413',
        DK: '133211860117553',
        SE: '121404111292725',
        RU: '275216545856555',
        PL: '244706038980513',
        NO: '304581546592510',
        GR: '704200349634422',
        IN: '347199669139259',
        AE: '402374783229274',
        BH: '402374783229274',
        DZ: '402374783229274',
        EG: '402374783229274',
        JO: '402374783229274',
        KW: '402374783229274',
        MA: '402374783229274',
        OM: '402374783229274',
        QA: '402374783229274',
        SA: '402374783229274',
        TN: '402374783229274',
        YE: '402374783229274',
        AR: '474276366001351',
        CL: '474276366001351',
        CO: '474276366001351',
        CR: '474276366001351',
        DO: '474276366001351',
        EC: '474276366001351',
        PE: '474276366001351',
        UY: '474276366001351',
        VE: '474276366001351'
    },
    FB_TEST_PAGE_ID: '676472402496128',
    PRECHECKED_COUNTRIES: ['US', 'AU', 'HK', 'JP', 'NZ', 'PH', 'SG', 'ZA'],
    PXP_MESSENGER_EXPT: 'xo_wps_fb_messenger_plugin',
    PXP_SHOW_MESSENGER_PLUGIN_TREATMENT: 'xo_wps_fb_messenger_plugin_1_treatment',
    PXP_MESSENGER_IN: 'xo_wps_fb_messenger_plugin_IN',
    PXP_MESSENGER_PLUGIN_TREATMENT_IN: 'xo_wps_fb_messenger_plugin_IN_treatment'
};

/***/ }),

/***/ "../node_modules/xo-page-components/src/done/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _profilemanagement = __webpack_require__("../node_modules/xo-models/src/profilemanagement/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _fbMessenger = __webpack_require__("../node_modules/xo-page-components/src/constants/fbMessenger.js");

var _fbMessenger2 = _interopRequireDefault(_fbMessenger);

var _index3 = __webpack_require__("../node_modules/xo-page-components/src/utils/index.js");

var _index4 = _interopRequireDefault(_index3);

var _template = __webpack_require__("../node_modules/xo-page-components/src/done/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-login-components/src/dolphin/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var AUTORETURN_TIMEOUT = 5000;
// If the user returns into checkout, it causes errors since the checkout
// session is not what we'd expect it to look like. Rather than proofing our
// code against this, we will attempt to prevent navigation instead.
// Any valid routes should be added here
var WHITELISTED_ROUTES = ['checkout.end'];

(0, _angular.$registerDirective)('xo-done', function () {
    return {
        template: _template2['default'],
        controller: ['$scope', function ($scope) {
            $scope.isGuestSignup = _angular.$rootScope.mode && _angular.$rootScope.mode === 'signup';
            $scope.locale = _squid.$locale;

            function addPageMessage(code) {
                var CONTENT_KEY_MAPPING = {
                    NO_UPGRADE: 'accountUpgradeFailed'
                };

                if (code && CONTENT_KEY_MAPPING[code]) {
                    $scope.errorMessage = {
                        msgs: [_squid.$locale.content.get('done.' + CONTENT_KEY_MAPPING[code])],
                        type: 'warning'
                    };
                }
            }

            function isThirdPartyFlow() {
                return _thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(_angular.$rootScope.token);
            }

            (0, _squid.$populate)($scope, {
                checkoutAppData: _index2.$CheckoutAppDataModel.instance($scope.token),
                checkoutSession: _index2.$CheckoutSessionModel.instance($scope.token),
                checkoutCart: _index2.$CheckoutCartModel.instance($scope.token),
                payee: _index2.$CheckoutPayeeModel.instance($scope.token)
            }).then(function () {
                // We need merchant display name (which can be undefined) to display in
                // merchant details section of the page
                $scope.merchantDisplayName = $scope.checkoutAppData.getMerchantDisplayName();
                // We need non empty value for merchantDisplayName in #merchant-text tag
                $scope.nonEmptyMerchantDisplayName = $scope.checkoutAppData.getMerchantDisplayName({
                    nonEmptyReturnValue: true
                });

                return (0, _squid.$populate)($scope, {
                    merchantPreferenceModel: _profilemanagement.$MerchantPreferenceModel.instance($scope.payee.merchant.id)
                }).then(function () {
                    // Show auto return page when feature is enabled by merchant and txn
                    $scope.isAutoReturn = $scope.merchantPreferenceModel.autoReturn();
                    _logger.$logger.info('wps_autoreturn_' + ($scope.isAutoReturn ? 'enabled' : 'disabled'), {
                        return_url: $scope.checkoutAppData.urls.return_url || 'not_available',
                        autoreturn_url: $scope.merchantPreferenceModel.returnUrl() || 'not_available'
                    });

                    // Set content key based on device
                    $scope.autoReturnContentKey = _index.$DeviceInfo.isMobile() || _index.$DeviceInfo.isTablet() ? 'done.autoReturnStatement' : 'done.autoReturnStatementWeb';
                    $scope.guestSignupKey = $scope.isGuestSignup ? 'done.paymentGuest' : 'done.payment';

                    if (_uiRouter.$stateParams.code) {
                        addPageMessage(_uiRouter.$stateParams.code);
                    }
                    var amount = $scope.checkoutSession.transactionDetails.amount.total;
                    var code = $scope.checkoutSession.transactionDetails.amount.currency;

                    $scope.formattedAmount = (0, _squid.formatCurrency)(amount, code);
                    var itemList = $scope.checkoutSession.itemsList;

                    itemList.forEach(function (item) {
                        item.quantity = (0, _squid.formatQuantity)(item.quantity);
                    });
                });
            }).then(function () {
                var pxpContext = _index4['default'].getMessengerPXPContext();

                _logger.$logger.info('pxp_xo_wps_fb_messenger_plugin ', pxpContext);

                // Skipping FB messenger experience if Venmo flow detected as this is only for PayPal users
                // Also not loading if merchant auto return is enabled

                if (!$scope.isAutoReturn && !isThirdPartyFlow()) {
                    if (_index4['default'].isDolphinEligibleOnWpsDone(_uiRouter.$state.current && _uiRouter.$state.current.name)) {
                        _logger.$logger.info('ul_dolphin', {
                            'from': 'dolphin_elg_chk',
                            'to': 'process_dolphin_elg_chk',
                            'eligibility_reason': 'wps_done_flow',
                            'context_id': _angular.$rootScope.token
                        });
                        $scope.isDolphinEligibleOnWpsDone = true;
                    } else {
                        _squid.$promise.all([(0, _squid.$pxp)(_fbMessenger2['default'].PXP_MESSENGER_EXPT, pxpContext, _fbMessenger2['default'].PXP_SHOW_MESSENGER_PLUGIN_TREATMENT, false, true), (0, _squid.$pxp)(_fbMessenger2['default'].PXP_MESSENGER_IN, pxpContext, _fbMessenger2['default'].PXP_MESSENGER_PLUGIN_TREATMENT_IN, false, true)]).then(function () {
                            var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                            var country = _squid.$locale.country;
                            var _$scope$checkoutSessi = $scope.checkoutSession.payer;
                            _$scope$checkoutSessi = _$scope$checkoutSessi === undefined ? {} : _$scope$checkoutSessi;
                            var payerId = _$scope$checkoutSessi.id;


                            _logger.$logger.info('Messenger_done_page_PXP_RESULT', results);

                            var _results$ = results[0];
                            _results$ = _results$ === undefined ? {} : _results$;
                            var treatment_name = _results$.treatment_name,
                                _results$2 = results[1];
                            _results$2 = _results$2 === undefined ? {} : _results$2;
                            var in_treatment_name = _results$2.treatment_name;


                            if (treatment_name === _fbMessenger2['default'].PXP_SHOW_MESSENGER_PLUGIN_TREATMENT || in_treatment_name === _fbMessenger2['default'].PXP_MESSENGER_PLUGIN_TREATMENT_IN) {
                                _logger.$logger.info('messenger_done_page_test_traffic');
                                _logger.$logger.info('checkout_fpti', {
                                    buyer_country: country,
                                    buyer_id: payerId,
                                    design: 'fbmessenger',
                                    from: 'XO_SUCCESS',
                                    eligibility_reason: 'messenger_treatment'
                                });
                                $scope.pxpMessengerIntegrationEnabled = false;
                            } else {
                                _logger.$logger.info('messenger_done_page_control_traffic');
                                _logger.$logger.info('checkout_fpti', {
                                    buyer_country: country,
                                    buyer_id: payerId,
                                    design: 'fbmessenger',
                                    from: 'XO_SUCCESS',
                                    eligibility_reason: 'messenger_control'
                                });
                                $scope.pxpMessengerIntegrationEnabled = false;
                            }
                        });
                    }
                }

                (0, _jquery2['default'])('#outerWrapper').addClass('xo-done');

                $scope.expansion = false;
                $scope.toggle = function () {
                    if ($scope.expansion === false) {
                        $scope.maxHeight = document.getElementsByClassName('details-expand')[0].scrollHeight + 'px';
                        $scope.expansion = true;
                    } else {
                        $scope.expansion = false;
                    }
                    return $scope.expansion;
                };

                $scope.autoReturnStatementClick = function (event) {
                    event.preventDefault();
                    if (event.target && event.target.nodeName === 'A') {
                        _logger.$logger.info('autoreturn_statement_clicked');
                        $scope.returnToMerchant();
                    }
                };

                if ($scope.isAutoReturn) {
                    _logger.$logger.info('autoreturn_to_merchant');
                    (0, _angular.$timeout)($scope.returnToMerchant, AUTORETURN_TIMEOUT);
                }
            });

            $scope.$on('localeChange', function () {
                if (_uiRouter.$stateParams.code) {
                    addPageMessage(_uiRouter.$stateParams.code);
                }
            });

            $scope.returnToMerchant = function () {
                _logger.$logger.info('return_to_merchant_clicked');
                return _uiRouter.$state.go('checkout.end');
            };

            var onExitListeners = function onExitListeners() {
                var removeClassListener = _angular.$rootScope.$on('$stateChangeSuccess', function (event, newState, newParams, oldState) {
                    if (oldState.name === 'checkout.done') {
                        (0, _jquery2['default'])('#outerWrapper').removeClass('xo-done');
                    }
                });
                var preventBackListener = _angular.$rootScope.$on('$stateChangeStart', function (event, newState) {
                    if (!~WHITELISTED_ROUTES.indexOf(newState.name)) {
                        _logger.$logger.info('done_page_prevent_routing', {
                            to: newState.name
                        });
                        event.preventDefault();
                        preventBackListener();

                        return _uiRouter.$state.go('checkout.genericError', {
                            code: 'PAYMENT_ALREADY_DONE'
                        });
                    }
                });

                return function () {
                    removeClassListener();
                    preventBackListener();
                };
            };

            $scope.$on('$destroy', onExitListeners());
        }]
    };
});

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_index.$DeviceInfo;

_angular.$registerDirective;

_angular.$rootScope;

_angular.$timeout;

_squid.$locale;

_squid.$populate;

_squid.$promise;

_squid.$pxp;

_squid.formatCurrency;

_squid.formatQuantity;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutPayeeModel;

_index2.$CheckoutSessionModel;

_profilemanagement.$MerchantPreferenceModel;

_thirdPartyInfo.thirdPartyExperience;

/***/ }),

/***/ "../node_modules/xo-page-components/src/done/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$DoneRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-page-components/src/done/directive.js");

var $DoneRoute = exports.$DoneRoute = _squid.$ComponentRoute.extend('DoneRoute', {
    name: 'done',
    directive: 'xo-done',
    titleContent: 'done.paymentCompleted',
    query: ['code'],
    trackingData: {
        fptiState: 'done_page',
        templateName: 'memberDone.dust',
        pageGoal: 'Payment Done Receipt',
        trackStateExit: true,
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-done',
                'pagename2': '%::fullpage-done:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    children: []
});

angular.value("$DoneRoute", $DoneRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-page-components/src/done/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"xo-done-content\" content>\n    <xo-dolphin ng-if=\"isDolphinEligibleOnWpsDone\"></xo-dolphin>\n    <div ng-click=\"toggle()\" class=\"splash-receipt\" tabindex=\"-1\">\n        <div class=\"receipt basics\">\n            <div class=\"done\" id=\"circle\"></div>\n            <div id=\"paid-text\" bind-html-compile=\"htmlContent(guestSignupKey, {amt: formattedAmount})\"/>\n            <div id=\"merchant-text\">{{ content('done.payment_target', { merchantName: nonEmptyMerchantDisplayName }) }}</div>\n            <a id=\"details-text\" link-button href=\"#\" aria-expanded=\"{{expansion}}\">{{content('paymentMethod.msbDetails')}}</a>\n        </div>\n        <div class=\"details-expand\" ng-class=\"{ expansion : expansion}\" ng-style=\"expansion && {'max-height': maxHeight}\"\n            tabindex=\"-1\" focus-when=\"expansion\">\n            <div class=\"grouping\" ng-repeat=\"item in checkoutSession.itemsList track by $index\">\n                <div class=\"row\">\n                    <span class=\"ltrOverride\" directionality><span ng-if=\"item.quantity\">{{item.quantity}} x </span>{{item.name}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\" amount=\"item.price\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"item.sku\" class=\"item-number-container\">\n                    <span>\n                        <strong>{{ content('header.itemNumber') }}</strong> <span class=\"item-number\">{{ item.sku }}</span>\n                    </span>\n                </div>\n                <div ng-if=\"item.item_option_selections\" class=\"item-selections\">\n                    <span class=\"item-selection\" ng-repeat=\"selection in item.item_option_selections track by $index\">\n                        <strong class=\"item-selection-name\">{{ selection.name }}:</strong>\n                        <span class=\"item-selection-value\">{{ selection.select }}</span>\n                    </span>\n                </div>\n            </div>\n            <div class=\"grouping\">\n                <div ng-if=\"checkoutSession.transactionDetails.amount.subtotal\" class=\"row\">\n                    <span>{{content('header.subTotal')}}</span>\n                     <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.subtotal\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.tax\" class=\"row\">\n                    <span>{{content('header.tax')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.tax\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.shipping\" class=\"row\">\n                    <span>{{content('header.shipping')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.shipping\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.insurance\" class=\"row\">\n                    <span>{{content('header.insurance')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.insurance\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.handling_fee\" class=\"row\">\n                    <span>{{content('header.handling')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.handling_fee\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.discount\" class=\"row\">\n                    <span>{{content('header.discount')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.discount\">\n                        </format-currency>\n                    </span>\n                </div>\n            </div>\n            <div class=\"row totalAmount\">\n                <b>\n                    <span>{{content('base.totalLabel')}}</span>\n                <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.total\">\n                        </format-currency>\n                    </span>\n                </b>\n            </div>\n        </div>\n        <div id=\"details-button\">\n            <span ng-hide=\"!expansion\" class=\"arrow collapse\"></span>\n            <span ng-hide=\"expansion\" class=\"arrow expand\"></span>\n        </div>\n    </div>\n    <div class=\"essentials\" ng-if=\"checkoutSession.transactionDetails.reason_code === 'REGULATORY_REVIEW'\">\n        <div class=\"alert\" role=\"alert\">\n            {{content('done.temporarily_pending')}}\n        </div>\n    </div>\n    <div class=\"essentials\" ng-if=\"!isAutoReturn\">\n        <xo-message message=\"errorMessage\"></xo-message>\n\n        <div id=\"messenger-ba-integration\" ng-if=\"pxpMessengerIntegrationEnabled\">\n          <div id=\"messenger-ba-integration-content\" style=\"display:none\">\n            <div class=\"text\">{{ content('messenger.integration') }}</div>\n          </div>\n          <div id=\"ba-integration-content\" style=\"display:none\">\n            <div class=\"receipt title\">{{ content('messenger.linkedTitle') }}</div>\n            <div class=\"text\">{{ content('messenger.linkedSubtitle') }}</div>\n          </div>\n          <div id=\"stm-upsell-content\" class=\"text\">{{ content('messenger.upsell') }}</div>\n          <xo-messenger-plugin plugin-type=\"STM\" token=\"token\"></xo-messenger-plugin>\n        </div>\n\n        <h2 ng-if=\"checkoutSession.plan.sources.length > 0\" class=\"receipt title\">{{content('done.paidWith')}}</h2>\n        <div ng-repeat=\"item in checkoutSession.plan.sources track by $index\">\n            <div class=\"row clearfix\">\n                <span class=\"money-source\">{{content('fsMappings.'+item.type) || item.name}} <span ng-if=\"item.last4\">x-</span>{{item.last4}}</span>\n                <span class='amount'>\n                        <format-currency code=\"item.amount.currency_code\"\n                                         amount=\"item.amount.amount\">\n                        </format-currency>\n                </span>\n            </div>\n        </div>\n        <div ng-if=\"checkoutSession.transactionDetails.soft_descriptor\" class=\"secondary receipt statement\">{{content('done.transactionInformation', {merchantName: checkoutSession.transactionDetails.soft_descriptor})}}\n        </div>\n        <h2 ng-if=\"checkoutSession.shipping\" class=\"receipt title\">{{content('done.shippedTo')}}</h2>\n        <div class=\"text\" ng-if=\"!checkoutCart.isShippingMethodStorePickUp()\">\n            <div ng-if=\"checkoutSession.shipping.name\">{{checkoutSession.shipping.name}}</div>\n            <ul class=\"multilineAddressList\">\n                <li ng-repeat=\"item in checkoutSession.shipping.full_address_multiline track by $index\" directionality-text=\"item\">{{item}}</li>\n            </ul>\n            <div><span>{{content('countryList.'+checkoutSession.shipping.country)}}</span></div>\n        </div>\n        <div class=\"text\" ng-if=\"checkoutCart.isShippingMethodStorePickUp()\">\n            <div class=\"storeLocation\" >{{ content('shippingMethod.storeLocation') }}</div>\n            <p class=\"storeLocationInfo\">{{ content('shippingMethod.storeLocationInfo') }}</p>\n        </div>\n        <h2 class=\"receipt title\">{{content('done.purchaseDetails')}}</h2>\n        <div id=\"receiptNumber\"> {{content('done.receiptNumber')}} {{checkoutSession.transactionDetails.receipt_id}}</div>\n        <div class=\"text\">\n            <div>{{content('done.confirmation')}}</div>\n            <div id=\"buyerEmail\">{{checkoutSession.payer.email}}</div>\n        </div>\n\n        <div ng-if=\"merchantDisplayName || checkoutAppData.merchant.phone\">\n            <h2 text-align=\"left\" class=\"receipt title\">{{content('done.merchantDetails')}}</h2>\n            <div class=\"text\" id=\"merchantInfoSection\">\n                <div ng-if=\"merchantDisplayName\"><span directionality-text=\"merchantDisplayName\">{{ merchantDisplayName }}</span></div>\n                <div ng-if=\"checkoutAppData.merchant.phone\">{{checkoutAppData.merchant.phone}}</div>\n            </div>\n        </div>\n\n        <div ng-if=\"checkoutAppData.urls.return_url\" id=\"button\" class=\"buttons reviewButton\">\n            <input track-submit type=\"submit\" value=\"{{content('common.returnToDefaultMerchant')}}\" id=\"merchantReturnBtn\"\n                   class=\"btn btn-secondary full submit receipt ng-binding ng-scope\" ng-click=\"returnToMerchant()\" />\n        </div>\n    </div>\n    <div class=\"essentials autoReturnSection\" ng-if=\"isAutoReturn\">\n        <div>{{content('done.paymentCompleted')}}</div>\n        <div ng-click=\"autoReturnStatementClick($event)\" data-test-id=\"autoreturn-link\" bind-html-compile=\"htmlContent(autoReturnContentKey, {merchantName: checkoutAppData.merchant.brand_name, autoReturnUrl: checkoutAppData.urls.return_url})\"/>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

__webpack_require__("../node_modules/xo-form-components/src/language-options/directive.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index4 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _index5 = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/escape-hatch/escapeHatch/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");

var _footerMap = __webpack_require__("../node_modules/xo-page-components/src/footer/footerMap.js");

var _footerMap2 = _interopRequireDefault(_footerMap);

var _opinionlab = __webpack_require__("../node_modules/xo-page-components/src/footer/opinionlab.js");

var _opinionlab2 = _interopRequireDefault(_opinionlab);

var _template = __webpack_require__("../node_modules/xo-page-components/src/footer/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoFooter', function () {
    return {
        template: _template2['default'],
        restrict: 'EA',
        scope: {
            token: '=?',
            escapeHatchIncontext: '=?',
            cancel: '@?',
            merchant: '@?',
            languageSwitch: '=?',
            showVenmoLegalLinks: '=?'
        },
        controller: ['$scope', function ($scope) {
            $scope.isIFrame = _squid.$util.isIFrame();
            if ($scope.escapeHatchIncontext) {
                $scope.showEscapeHatch = $scope.isIFrame;
            }
            $scope.locale = _squid.$locale;
            $scope.proxSignUpFlow = _index4.$CheckoutInputDataModel.instance($scope.token).isEbayTxn();
            $scope.year = new Date().getFullYear();

            $scope.isApac = function () {
                return _squid.$config.apacCountries && _squid.$config.apacCountries.indexOf($scope.locale.country) > -1;
            };

            // Determine if country belongs to a region to serve correct footer links
            var getRegion = function getRegion(country) {
                var regions = _squid.$config.regions;
                for (var region in regions) {
                    if (regions[region].indexOf(country) > -1) {
                        return region;
                    }
                }
                return false;
            };

            function isDESecondButtonFlow() {
                return $scope.locale.country === 'DE' && $scope.checkoutAppData && $scope.checkoutAppData.is_second_button_txn;
            }

            $scope.footerLinks = function () {
                if ($scope.isApac()) {
                    return _footerMap2['default'].APAC;
                }

                // It is a product requirement that for the DE CYCO page, Hermes only show the footer links
                // that were available in Aries
                if (isDESecondButtonFlow()) {
                    return _footerMap2['default']['DESecondButton'];
                }

                return _footerMap2['default'][$scope.locale.country] || _footerMap2['default'][getRegion($scope.locale.country)] || _footerMap2['default'].DEFAULT;
            };

            $scope.showPolicyInfo = function () {
                return $scope.isApac() || $scope.locale.country === 'AU';
            };

            $scope.cancelRedirect = function ($event) {
                $event.preventDefault();

                var cancelUri = $scope.cancel;
                var redirectUri;

                if (window.xprops && window.xprops.onCancel && !cancelUri) {
                    return window.xprops.onCancel({
                        orderID: $scope.token
                    });
                }

                // "redirect_uri" as a query param overrides the cancel url in the checkout session
                if (_squid.$integration.getConfig('REDIRECT_QUERY_PARAM')) {
                    redirectUri = _squid.$util.param('redirect_uri');

                    cancelUri = _squid.$util.buildURL(redirectUri, {
                        opType: 'cancel',
                        return_uri: $scope.cancel,
                        token: $scope.token
                    });
                }

                _index5.$ReturnToMerchant.goTo(cancelUri);
            };

            $scope.isIndiaLegalEntity = function () {
                // for PayPal India domestic launch legal entity should be 84
                // update footer with indian policy for this case
                return $scope.auth && $scope.auth.logged_in && $scope.auth.legalEntity === 84 || $scope.locale.country === 'IN';
            };

            if ($scope.token) {
                (0, _squid.$populate)($scope, {
                    checkoutAppData: _index3.$CheckoutAppDataModel.instance($scope.token),
                    checkoutPayee: _index3.$CheckoutPayeeModel.instance($scope.token),
                    auth: _index2.$AuthModel.instance()
                }).then(function () {
                    var payee = $scope.checkoutPayee;

                    if (payee && payee.merchant && payee.merchant.id) {
                        var hcl = _squid.$config.hideCancelLinkForMerchant;

                        var shouldHide = hcl && hcl.indexOf(payee.merchant.id) !== -1;
                        if (shouldHide) {
                            $scope.hideCancel = true;
                        }
                    }
                    $scope.cancel = $scope.checkoutAppData.urls.cancel_url;
                    $scope.merchant = $scope.checkoutAppData.getMerchantDisplayName();
                });
            }

            var cancelShowModal = _angular.$rootScope.$on('showModal', function (event, config) {
                $scope.popupUrl = config && config.popupUrl;
                $scope.show = true;
                $scope.$digest(); // eslint-disable-line angular/ng_no_digest
            });

            $scope.$on('$destroy', cancelShowModal);

            $scope.showOL = function showOL(event) {
                event.preventDefault();

                var placeholder = 'main:ec:hermes';
                var page = _uiRouter.$state.current.get('trackingData.buzname.fullpage.pagename2', 'unknown').replace('%', placeholder);
                var data = {
                    opVars: {
                        rlogId: _angular.$window.meta.rlogId || '',
                        page: page || window.location.hash,
                        csci: 'Unknown',
                        calc: _angular.$window.meta.correlationId,
                        custId: 'Unknown',
                        merchantId: 'Unknown',
                        token: $scope.token || 'Unknown'
                    },
                    locale: {
                        country: _squid.$locale.country,
                        languageCode: _squid.$locale.lang + '_' + _squid.$locale.country
                    }
                };

                (0, _opinionlab2['default'])(data);
            };

            $scope.showFeedback = function () {
                return !_index.$DeviceInfo.isDevice() && !isDESecondButtonFlow();
            };

            $scope.hideReturnCancelUrl = function () {
                if (window.xprops && window.xprops.onCancel) {
                    return false;
                }

                if (!$scope.cancel) {
                    return true;
                }

                if (_uiRouter.$state.current && _uiRouter.$state.current.name === 'checkout.done') {
                    return true;
                }

                return false;
            };

            $scope.showVenmoLinks = function () {
                // if on payWithSelection State, always show it, else we choose whatever 'checkout' directive says.
                if (_uiRouter.$state.current && _uiRouter.$state.current.name === 'checkout.payWithSelection') {
                    return true;
                }
                return !!$scope.showVenmoLegalLinks;
            };

            $scope.showPaypalLinks = function () {
                // will force Paypal Links if on payWithSelection state. Hide paypal links if we explicitly request venmo Links
                if (_uiRouter.$state.current && _uiRouter.$state.current.name === 'checkout.payWithSelection') {
                    return true;
                }
                return !$scope.showVenmoLegalLinks;
            };
        }]
    };
});

_uiRouter.$state;

_angular.$window;

_angular.$rootScope;

_squid.$config;

_squid.$util;

_squid.$locale;

_squid.$populate;

_squid.$integration;

_index.$DeviceInfo;

_index2.$AuthModel;

_index3.$CheckoutAppDataModel;

_index3.$CheckoutPayeeModel;

_index4.$CheckoutInputDataModel;

_index5.$ReturnToMerchant;

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/footerMap.js":
/***/ (function(module, exports, __webpack_require__) {



!(module.exports = {
    CA: [{
        id: 'policy',
        content: 'footer.policiesCA'
    }, {
        id: 'terms',
        content: 'footer.termsCA'
    }, {
        id: 'privacy',
        content: 'footer.privacyCA'
    }],

    BE: [{
        id: 'legal',
        content: 'footer.legal'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    DE: [{
        id: 'imprint',
        content: 'footer.DEImprint'
    }, {
        id: 'legal',
        content: 'footer.DELegal'
    }, {
        id: 'privacy',
        content: 'footer.DEPrivacy'
    }, {
        id: 'paymentdesc',
        content: 'footer.DEKeyPaymentDesc'
    }],

    ES: [{
        id: 'legal',
        content: 'footer.legal'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    FR: [{
        id: 'legal',
        content: 'footer.FRLegal'
    }, {
        id: 'useragreement',
        content: 'footer.FRUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.FRPrivacy'
    }],

    IT: [{
        id: 'legal',
        content: 'footer.legal'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    NL: [{
        id: 'legal',
        content: 'footer.legal'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    IE: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'useragreement',
        content: 'footer.userAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    APAC: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'useragreement',
        content: 'footer.userAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    EMEA: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'useragreement',
        content: 'footer.userAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    EM: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'useragreement',
        content: 'footer.userAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    LATAM: [{
        id: 'help',
        content: 'footer.help'
    }, {
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    AU: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    AT: [{
        id: 'imprint',
        content: 'footer.ATImprint'
    }, {
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    CH: [{
        id: 'imprint',
        content: 'footer.CHImprint'
    }, {
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    DK: [{
        id: 'useragreement',
        content: 'footer.DKUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    SE: [{
        id: 'useragreement',
        content: 'footer.SEUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    PL: [{
        id: 'useragreement',
        content: 'footer.PLUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    NO: [{
        id: 'useragreement',
        content: 'footer.NOUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    TR: [{
        id: 'useragreement',
        content: 'footer.TRUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    BR: [{
        id: 'help',
        content: 'footer.help'
    }, {
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    MX: [{
        id: 'help',
        content: 'footer.help'
    }, {
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    RU: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    DESecondButton: [{
        id: 'imprint',
        content: 'footer.DEImprint'
    }, {
        id: 'privacy',
        content: 'footer.DEPrivacy'
    }],

    DEFAULT: [{
        id: 'policy',
        content: 'footer.policies',
        venmoContent: 'footer.venmo_policies'
    }, {
        id: 'terms',
        content: 'footer.terms',
        venmoContent: 'footer.venmo_terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy',
        venmoContent: 'footer.venmo_privacy'
    }]
});

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/opinionlab.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {

    var _doc = document;
    var _w = window;
    var _tm = new Date().getTime();
    var _sH = screen.height;
    var _ht = escape(_w.location.href); // eslint-disable-line block-scoped-var,no-undef
    var _hr = escape(_doc.referrer); // eslint-disable-line block-scoped-var,no-undef
    var _sW = screen.width;

    function popUp(opinionlabURL) {
        _w.open(opinionlabURL, 'comments', 'width=535,height=192' + ',screenX=' + (_sW - 535) / 2 + ',screenY=' + (_sH - 192) / 2 + ',top=' + (_sH - 192) / 2 + ',left=' + (_sW - 535) / 2 + ',resizable=yes' + ',copyhistory=yes' + ',scrollbars=no');
    }

    function updateCustomVars(data) {

        var opVars = data.opVars;
        var locale = data.locale;

        _ht = 'https://' + locale.country + '.paypal.com/' + locale.languageCode + '/00/' + escape(opVars.page.replace(/\s|\//g, '_')) + '.page'; // eslint-disable-line block-scoped-var,no-undef

        var customVar = (opVars.rlogId || opVars.calc) + '|' + opVars.csci + '|' + opVars.page + '|' + locale.country + '|' + locale.languageCode + '|' + opVars.custId + '|' + opVars.merchantId + '|' + opVars.token + '|' + 'Unknown';
        return customVar;
    }

    function _fC(_u) {
        var _sp = '%3A\\/\\/';
        var _rp = '%3A//';
        var _aT = _sp + ',\\/,\\.,-,_,' + _rp + ',%2F,%2E,%2D,%5F';
        var _aA = _aT.split(',');

        for (var i = 0; i < 5; i++) {
            eval('_u=_u.replace(/' + _aA[i] + '/g,_aA[i+5])'); // eslint-disable-line no-eval
        }
        return _u;
    }

    return function (locale) {

        var custom_var = updateCustomVars(locale);

        var opinionlabURL = 'https://secure.opinionlab.com/ccc01/comment_card.asp?' + 'time1=' + _tm + '&time2=' + new Date().getTime() + '&prev=' + _fC(_hr) + '&referer=' + _fC(_ht) + '&height=' + _sH + '&width=' + _sW + '&custom_var=' + custom_var;
        popUp(opinionlabURL);
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/template.html":
/***/ (function(module, exports) {

module.exports = "<footer content>\n    <div class=\"footer clearfix commonFooter\" ng-class=\"{APAC: isApac()}\">\n        <p ng-if=\"!hideCancel\" id=\"defaultCancelLink\" class=\"cancelUrl\">\n            <a track-link=\"cancel_and_return_to_merchant\" href=\"{{cancel || '#'}}\" ng-click=\"cancelRedirect($event)\" role=\"button\" id=\"cancelLink\" ng-hide=\"hideReturnCancelUrl()\">\n               <span ng-bind-html=\"merchant ? content('base.cancelUrl', { merchantName: merchant, modelName: 'merchant' }) : content('common.cancelAndReturnToMerchant')\"></span>\n            </a>\n        </p>\n\n        <div class=\"footerWrapper\">\n            <ul class=\"footerLinks\" ng-if=\"showPaypalLinks()\">\n                <li ng-repeat=\"link in footerLinks() track by $index\" id =\"footer_{{link.id}}\" bind-html-compile=\"htmlContent(link.content, {country: locale.country.toLowerCase(), lang: locale.lang})\"></li>\n                <li ng-if=\"showFeedback()\"><a href=\"#\" id=\"footer_sfLink\" ng-click=\"showOL($event)\">{{content('OpinionLab.SiteFeedback')}}</a></li>\n            </ul>\n            <ul class=\"footerLinks\" ng-if=\"showVenmoLinks()\">\n                <li ng-repeat=\"link in footerLinks() track by $index\" id =\"venmoFooter_{{link.id}}\" bind-html-compile=\"htmlContent(link.venmoContent, {country: locale.country.toLowerCase(), lang: locale.lang})\"></li>\n                <li ng-if=\"showFeedback()\"></li>\n            </ul>\n            <p class=\"copyright\">\n                {{ content('footer.copyright', {year: year}) }}\n                <span class=\"secureIcon\"></span>\n                <span class=\"accessAid\">{{ content('memberReview.propHead') }}</span>\n            </p>\n\n            <xo-language-options direction=\"top\" ng-if=\"languageSwitch && languageSwitch.show\"></xo-language-options>\n        </div>\n\n        <div class=\"policyInfoWrapper\" ng-if=\"showPolicyInfo()\">\n            <p class=\"moreInfo\" ng-if=\"isIndiaLegalEntity()\" ng-bind-html=\"htmlContent('footer.4plpolicyInformation', {country: locale.country})\"> </p>\n            <p class=\"moreInfo\" ng-if=\"!isIndiaLegalEntity()\" ng-bind-html=\"htmlContent('footer.policyInformation', {country: locale.country})\"> </p>\n            <p class=\"moreCopyRight\" ng-if=\"locale.country === 'AU'\">{{ content('footer.moreCopyright', {year: year}) }}</P>\n        </div>\n\n    </div>\n    <xo-modal>\n        <p>{{ content('footer.openLinks') }}</p>\n        <p class=\"popLink\">{{popupUrl}}</p>\n        <input class=\"btn btn-submit full\" type=\"button\" ng-click=\"hideModal()\" value=\"{{ content('footer.okBtn') }}\">\n    </xo-modal>\n</footer>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/gdprCookieBanner/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$gdprCookieBannerComponent = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _gdprCookieBanner = __webpack_require__("../node_modules/xo-models/src/gdprCookieBanner/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/gdprCookieBanner/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/gdprCookieBanner/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * General Data Protection Regulation (GDPR) defines standards on how personal data is collected, processed, transferred and disposed.
 * Affected Countries: All "GDPR" countries: Please check config.json for country list.
 * Wiki: https://github.paypal.com/Checkout-R/xoonboardingnodeweb/wiki/GDPR:-Feature,-Integration-documentation
 */
var $gdprCookieBannerComponent = exports.$gdprCookieBannerComponent = _squid.$Component.extend('$gdprCookieBanner', {
    tag: 'xo-gdpr-cookie-banner',
    template: _template2['default'],
    actions: {
        // Fetch the GDPR banner, append to DOM if available
        refreshGDPR: function refreshGDPR() {
            var _this = this;

            var gdprModel = _gdprCookieBanner.$GDPRCookieBannerModel.instance();

            return gdprModel.getBanner().then(function () {
                var banner = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                // Run cleanup once we know the result, to prevent screen flash
                _this.actions.cleanup();

                var html = banner.html,
                    css = banner.css,
                    js = banner.js;


                if (!html || !css || !js) {
                    return;
                }

                var div = angular.element(html);
                var style = angular.element(css);
                var script = angular.element(js);

                var el = _this.$element.find('#gdpr-cookie-banner-outerwrap');

                el.append(style);
                el.append(div);
                el.append(script);

                if (!(0, _angular.isFunction)(window.bindGdprEvents)) {
                    _logger.$logger.error('gdpr_banner_bindGdprEvents_not_defined');
                    return;
                }

                // TODO: Remove this class add when cookie banner script is fixed to add this class properly
                angular.element(document.body).addClass('gdprCookieBanner-acceptedAll');

                window.bindGdprEvents();
            });
        },

        // Clear out the banner container to remove the old elements
        cleanup: function cleanup() {
            var el = this.$element.find('#gdpr-cookie-banner-outerwrap');

            el.empty();
        }
    },

    lifecycle: {
        populate: function populate() {
            var _this2 = this;

            this.actions.refreshGDPR();

            // On "localeChange" we are re-fetching data.
            this.$on('localeChange', function () {
                _this2.actions.refreshGDPR();
            });
        }
    }
});

angular.value("$gdprCookieBannerComponent", $gdprCookieBannerComponent);
_squid.$Component;

_angular.isFunction;

_gdprCookieBanner.$GDPRCookieBannerModel;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-page-components/src/gdprCookieBanner/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/gdprCookieBanner/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"gdpr-cookie-banner-outerwrap\"></div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/header/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SetHeaderText = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/escape-hatch/closeFrame/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/language-options/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/directive.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/header/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/header/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoHeader', function () {
    return {
        template: _template2['default'],
        scope: {
            showCartTotal: '=?',
            renderCartContainer: '=?',
            token: '=?',
            isUnbranded: '=?',
            unbrandedTitle: '=?',
            unbrandedSubTitle: '=?',
            languageSwitch: '=?',
            redirectiframe: '=?',
            redirectLightbox: '=?',
            isVenmoFlow: '=?'
        },
        controller: ['$scope', function ($scope) {
            var _ref = window.xprops || {},
                _ref$experience = _ref.experience,
                experience = _ref$experience === undefined ? { facebook: false } : _ref$experience;

            $scope.isFacebookBAIntegration = experience.facebook;
            $scope.isMessengerBAIntegration = _squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
            $scope.isMobile = _index.$DeviceInfo.isMobile() || _index.$DeviceInfo.isTablet();
            $scope.title = (0, _squid.$renderContent)($scope.unbrandedTitle);
            $scope.subTitle = (0, _squid.$renderContent)($scope.unbrandedSubTitle);
            $SetHeaderText.subscribe($scope, function (event, text) {
                $scope.unbrandedTitle = text;
                $scope.title = (0, _squid.$renderContent)($scope.unbrandedTitle);
            });
        }]
    };
});

var headerText = '';
var $SetHeaderText = exports.$SetHeaderText = {
    setText: function setText(text) {
        headerText = text;
        _angular.$rootScope.$emit('update_header_text', text);
    },
    getText: function getText() {
        return headerText;
    },
    subscribe: function subscribe($scope, callback) {
        var handler = _angular.$rootScope.$on('update_header_text', callback);
        $scope.$on('$destroy', handler);
    }
};

angular.value("$SetHeaderText", $SetHeaderText);
_angular.$rootScope;

_squid.$integration;

_squid.$renderContent;

_index.$DeviceInfo;

/***/ }),

/***/ "../node_modules/xo-page-components/src/header/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/header/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"row-fluid paypalHeaderWrapper\" ng-class=\"{ 'langDropdown': languageSwitch && languageSwitch.show }\" content>\n    <div class=\"span14 clearfix paypalHeader\">\n        <div id=\"mobileMerchantHeader\">\n            <xo-merchant-header token=\"token\" disable-id=\"true\"></xo-merchant-header>\n        </div>\n        <span class=\"pageTitle\" ng-if=\"unbrandedTitle\">{{title}}</span>\n        <div ng-if=\"!isMessengerBAIntegration && !isUnbranded && !isVenmoFlow\" id=\"paypalLogo\" class=\"logo\"><span class=\"accessAid\">{{ content('base.payPal') }}</span></div>\n        <div ng-if=\"!isMessengerBAIntegration && !isUnbranded && isVenmoFlow\" class=\"venmoLogo\"><span class=\"accessAid\">Venmo Checkout</span></div>\n        <div ng-if=\"isFacebookBAIntegration\" class=\"ng-scope facebookPayPalHeader\">\n            <img ng-src=\"https://www.paypalobjects.com/images/shared/paypal_monogram_logo.png\" class=\"facebookPayPalHeader-logo\" alt=\"PayPal\">\n            <span class=\"facebookPayPalHeader-plus\">+</span>\n            <img ng-src=\"https://www.paypalobjects.com/images/shared/facebook_logo.svg\" class=\"facebookPayPalHeader-logo\" alt=\"Facebook\">\n        </div>\n        <div ng-if=\"!isFacebookBAIntegration && isMessengerBAIntegration\">\n            <div ng-if=\"isMobile\">\n                <img ng-src=\"https://www.paypalobjects.com/images/checkout/hermes/PP_Messenger_mobile_logo_lockup_2x.png\" class=\"messengerLogo\" width=\"50%\" height=\"50%\" alt=\"PayPal and Messenger\">\n            </div>\n            <div ng-if=\"!isMobile\">\n                <img ng-src=\"https://www.paypalobjects.com/images/checkout/hermes/PP_Messenger_logo_lockup_2x.png\" class=\"messengerLogo\" width=\"50%\" height=\"50%\" alt=\"PayPal and Messenger\">\n            </div>\n        </div>\n        <xo-cart token=\"token\" show-cart-total=\"showCartTotal\" render-cart-container=\"renderCartContainer\"></xo-cart>\n\n        <xo-language-options ng-if=\"languageSwitch && languageSwitch.show\"></xo-language-options>\n\n        <div class=\"subTitle\" ng-if=\"unbrandedSubTitle\">{{subTitle}}</div>\n        <xo-close-frame redirectiframe=\"redirectiframe\" redirect-lightbox=\"redirectLightbox\"></xo-close-frame>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/marketingOffers/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/marketingOffers/template.html");

var _template2 = _interopRequireDefault(_template);

var _marketingoffer = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoMarketingOffers', function () {
    return {
        template: _template2['default'],
        scope: {
            placementCode: '=?',
            titleTxtProperty: '=?',
            subtitleProperty: '=?',
            token: '=?',
            pageName: '=?',
            backgroundImage: '=?',
            xoTitleTag: '@?',
            xoTitleClass: '@?'
        },
        controller: ['$scope', '$element', '$sce', function ($scope, $element, $sce) {
            var morsOfferFlag = $scope.placementCode === '202003' && (0, _squid.$feature)('morsValuePropOffers');
            var populateObj = void 0;

            if (morsOfferFlag) {
                populateObj = {
                    checkoutCart: _index.$CheckoutCartModel.instance($scope.token),
                    checkoutSession: _index.$CheckoutSessionModel.instance($scope.token),
                    payee: _index.$CheckoutPayeeModel.instance($scope.token),
                    auth: _auth.$AuthModel.instance()
                };
            } else {
                populateObj = {
                    checkoutCart: _index.$CheckoutCartModel.instance($scope.token)
                };
            }
            (0, _squid.$populate)($scope, populateObj).then(function () {
                $scope.locale = _squid.$locale;
                $scope.token = _angular.$rootScope.token;
                function setDefaultValues() {
                    $scope.ad = {
                        Title: (0, _squid.$renderContent)($scope.titleTxtProperty),
                        Body: (0, _squid.$renderContent)($scope.subtitleProperty),
                        backgroundImage: $scope.backgroundImage
                    };
                }

                $scope.$watch('ad.backgroundImage', function (imageUrl) {
                    if (imageUrl) {
                        var url = imageUrl;
                        var propImg = angular.element($element[0].querySelector('div.prop-img'));
                        var isRetina = window && window.matchMedia && window.matchMedia('(-webkit-min-device-pixel-ratio: 2), ' + '(min--moz-device-pixel-ratio: 2), ' + '(-o-min-device-pixel-ratio: 2/1),' + '(min-device-pixel-ratio: 2),' + '(min-resolution: 192dpi), ' + '(min-resolution: 2dppx)').matches;

                        if (isRetina && url) {
                            var index = url.lastIndexOf('.'); // index at which file extension start
                            url = url.substring(0, index) + '_2x' + url.substring(index, url.length);
                            propImg.css({
                                'background-image': 'url(' + url + ')',
                                'height': '150px',
                                'margin-top': '0px'
                            });
                        } else {
                            propImg.css({
                                'background-image': 'url(' + url + ')',
                                'height': '150px',
                                'margin-top': '0px'
                            });
                        }
                    }
                });

                if ($scope.placementCode === '202002') {
                    $scope.pu_type = 'ANONYMOUS';
                    $scope.presentation_types = ['CompositeText'];
                    $scope.pxpInfo = {
                        name: 'xo_xoon_hermes_mors',
                        pattern: '(xo_xoon_hermes_mors_)(.*)',
                        treatment: 'xo_xoon_hermes_mors_treatment'
                    };
                } else if ($scope.placementCode === '202003') {
                    $scope.className = 'props';
                    $scope.pu_type = 'PERSONAL';
                    $scope.presentation_types = ['GenericComposite'];
                    $scope.pxpInfo = {
                        name: 'xo_mors_hermes_placements_ryi',
                        pattern: '(xo_mors_hermes_placements_ryi_)(.*)',
                        treatment: 'xo_mors_hermes_placements_ryi_treatment'
                    };
                } else {
                    setDefaultValues();
                }

                //  serve ads only if pxp is true, country is US and lang is en
                if (_squid.$locale.country === 'US' && _squid.$locale.lang === 'en' && $scope.placementCode && (0, _squid.$feature)('morsValuePropOffers')) {
                    $scope.marketingOfferData = new _marketingoffer.$MarketingOfferModel({
                        countryCode: $scope.locale.country,
                        page: $scope.pageName,
                        puType: $scope.pu_type,
                        locale: _squid.$locale.lang + '_' + _squid.$locale.country,
                        totalTransactionAmount: {
                            'currency_code': $scope.checkoutCart.get('purchase.amounts.total.currency_code', ''),
                            // Round the calculation to eliminate Floating point Rounding Error (69.99 * 100 === 6998.999999999999)
                            // http://docs.oracle.com/cd/E19957-01/806-3568/ncg_goldberg.html
                            'value': Math.round($scope.checkoutCart.get('purchase.amounts.total.amount', 0) * 100)
                        },
                        totalShippingAmount: {
                            'currency_code': $scope.checkoutCart.get('purchase.amounts.total.currency_code', ''),
                            // Round the calculation to eliminate Floating point Rounding Error (69.99 * 100 === 6998.999999999999)
                            // http://docs.oracle.com/cd/E19957-01/806-3568/ncg_goldberg.html
                            'value': Math.round($scope.checkoutCart.get('purchase.amounts.shipping.amount', 0) * 100)
                        },
                        payee: morsOfferFlag ? $scope.payee.merchant.id : '',
                        payer: morsOfferFlag ? $scope.checkoutSession.payer.id : '',
                        si: morsOfferFlag ? $scope.checkoutSession.id : '',
                        visitor_id: morsOfferFlag ? $scope.auth.visitor_id : '',
                        targetPlacements: [{
                            'placement_code': $scope.placementCode,
                            'presentation_types': $scope.presentation_types
                        }]
                    });
                    (0, _squid.$pxp)($scope.pxpInfo.name, { 'ctx.COUNTRY': _squid.$locale.country }, $scope.pxpInfo.pattern, false, true).then(function (res) {

                        _logger.$logger.info('MO treatment: ' + (res ? res.treatment_name : '[no pxp response!]'));
                        if (res && res.treatment_name === $scope.pxpInfo.treatment) {

                            return _marketingoffer.$MarketingOfferModel.instance($scope.token).save({
                                silent: true,
                                data: $scope.marketingOfferData.serialize(),
                                // Ignore all errors from this api, by passing transientError as true
                                transientError: true,
                                success: function success(result) {
                                    var ads_arr = result && result.ads || [];
                                    var adFound = false;

                                    // MORS could serve multiple ads for a given page. Iterate to get the
                                    // correct one based on the ad placement_id
                                    ads_arr.forEach(function (ad) {
                                        var adunit_id = ad.campaign.adunit_id;

                                        if (adunit_id.toString() === $scope.placementCode.toString() && ad.valid) {
                                            adFound = true;
                                            $scope.ad = {};
                                            var content = ad.content.nvp;
                                            content.forEach(function (obj) {
                                                $scope.ad[obj.name] = obj.value;
                                            });
                                            $scope.ad['impressionUrl'] = ad.tracking.impression_url;
                                            $scope.ad['clickUrl'] = ad.tracking.click_url;
                                        }
                                    });

                                    if (adFound) {
                                        $scope.ad.Body = $sce.trustAsHtml($scope.ad.Body);
                                        // $scope.ad.Title does not need to be assigned. for 202001, 202002,
                                        // and 202003 placement_ids as this will already be assigned.

                                        // notify MORS of successful rendering by firing the impressionurl
                                        // beacon and by setting the click url to be fired for future
                                        // conversion.
                                        // setting the placement_id helps to differentiate between multiple ads
                                        // displayed on the same page

                                        _logger.$logger.info('MORS_ad_displayed');
                                        _marketingoffer.$fireMORSBeacon.fireBeacon($scope.ad.impressionUrl);

                                        _angular.$rootScope.$broadcast('MORSDisplayed', {
                                            clickUrl: $scope.ad.clickUrl,
                                            placementId: $scope.placementCode
                                        });
                                    } else {
                                        _logger.$logger.info('MORS_ad_not_found');
                                        setDefaultValues();
                                        _angular.$rootScope.$broadcast('MORSNotDisplayed');
                                    }
                                },

                                error: function error(err) {
                                    setDefaultValues();
                                    _logger.$logger.error('MORS_api_failure', { error: err });
                                }
                            });
                        } else {
                            setDefaultValues();
                            _angular.$rootScope.$broadcast('MORSNotDisplayed');
                        }
                    });
                } else {
                    setDefaultValues();
                    _angular.$rootScope.$broadcast('MORSNotDisplayed');
                }
                $scope.$on('localeChange', function () {
                    setDefaultValues();
                });
            });
        }]
    };
});

_angular.$rootScope;

_squid.$feature;

_squid.$locale;

_squid.$populate;

_squid.$pxp;

_squid.$renderContent;

_logger.$logger;

_auth.$AuthModel;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_index.$CheckoutSessionModel;

_marketingoffer.$MarketingOfferModel;

_marketingoffer.$fireMORSBeacon;

/***/ }),

/***/ "../node_modules/xo-page-components/src/marketingOffers/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"marketingOffers {{className}}\" content >\n    <div ng-if=\"ad.backgroundImage\" class=\"prop-img\"></div>\n    <xo-title title-txt=\"{{ ad.Title }}\" tag-name=\"{{ xoTitleTag }}\" class-name=\"{{ xoTitleClass }}\"></xo-title>\n    <p class=\"subTitle\" ng-bind-html=\"ad.Body\"></p>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/merchant-header/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/merchant-header/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoMerchantHeaderDirective', {
    tag: 'xo-merchant-header',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        merchant: {
            type: 'var',
            required: false
        },
        disableId: {
            type: 'str',
            required: false
        }
    },
    resolve: {
        models: function models() {
            if (this.props.token) {
                return {
                    checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](_angular.noop)
                };
            }
        }
    },
    lifecycle: {
        populate: function populate() {
            var _ref = this.models || {},
                checkoutAppData = _ref.checkoutAppData;

            if (checkoutAppData) {
                // get Merchant display name - can be undefined in which case we have an empty header
                this.merchantDisplayName = checkoutAppData.getMerchantDisplayName();

                if (this.props.token && !_index2.$CheckoutInputDataModel.instance(this.props.token).isEbayTxn()) {
                    this.merchant = checkoutAppData.merchant;
                }
            }
        }
    }
});


(0, _squid.$registerDirective)('xoMerchantImageResize', function () {
    return {
        restrict: 'A',
        link: function link(scope, element) {
            element.bind('load', function () {
                var MAX_WIDTH = 780;
                var MAX_HEIGHT = 90;

                if (this.width > MAX_WIDTH) {
                    var ratio = MAX_WIDTH / this.width;
                    var height = this.height * ratio;

                    this.width = MAX_WIDTH;
                    this.height = height > MAX_HEIGHT ? MAX_HEIGHT : height;
                }
            });
        }
    };
});

_angular.noop;

_squid.$Component;

_squid.$registerDirective;

_index.$CheckoutAppDataModel;

_index2.$CheckoutInputDataModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-page-components/src/merchant-header/template.html":
/***/ (function(module, exports) {

module.exports = "<header role=\"banner\">\n    <div ng-attr-id=\"{{ props.disableId ? '' : 'header' }}\" class=\"merchantHeader clearfix\">\n        <div class=\"headerWrapper\">\n            <span class=\"merchantName\" directionality-text=\"merchantDisplayName || merchant.brand_name\" ng-if=\"!(merchant.logo_url || merchant.imageUrl)\">\n                {{ merchantDisplayName || merchant.brand_name }}\n         \t</span>\n            <img ng-src=\"{{merchant.logo_url || merchant.imageUrl}}\" alt=\"{{ merchantDisplayName || merchant.brand_name}}\" ng-if=\"merchant.logo_url || merchant.imageUrl\" xo-merchant-image-resize/>\n        </div>\n    </div>\n</header>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/messenger-plugin/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uuid = __webpack_require__("../node_modules/node-uuid/uuid.js");

var _uuid2 = _interopRequireDefault(_uuid);

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/messenger-plugin/template.html");

var _template2 = _interopRequireDefault(_template);

var _fbMessenger = __webpack_require__("../node_modules/xo-page-components/src/constants/fbMessenger.js");

var _fbMessenger2 = _interopRequireDefault(_fbMessenger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoMessengerPluginDirective', {
    tag: 'xo-messenger-plugin',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        pluginType: {
            type: 'str',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                messengerIntegration: _index3.$MessengerIntegrationDataModel.instance().retrieve()['catch'](_angular.noop)
            };
        }
    },

    lifecycle: {
        populate: function populate() {
            var _this = this;

            var isMobile = _index.$DeviceInfo.isMobile() || _index.$DeviceInfo.isTablet();
            var lang = _squid.$locale.lang,
                country = _squid.$locale.country;
            var _props = this.props,
                pluginType = _props.pluginType,
                token = _props.token;
            var _models = this.models,
                _models$checkoutSessi = _models.checkoutSession,
                checkoutSession = _models$checkoutSessi === undefined ? {} : _models$checkoutSessi,
                _models$messengerInte = _models.messengerIntegration,
                messengerIntegration = _models$messengerInte === undefined ? {} : _models$messengerInte;

            // BA was offered to user or not

            var fbBAShownFlag = _squid.$util.localStorageEnabled() && window.localStorage.getItem(_fbMessenger2['default'].FB_BA_SHOWN_FLAG);

            // Added following flags to override usual behaviour to enable internal testing by FB and PYPL teams

            var _ref = window.xprops || {},
                _ref$experience = _ref.experience;

            _ref$experience = _ref$experience === undefined ? {} : _ref$experience;
            var override_fbpp_repeat = _ref$experience.override_fbpp_repeat;

            var overrideRepeatUserFlag = _squid.$util.param(_fbMessenger2['default'].OVERRIDE_FBPP_REPEAT_FLAG) || override_fbpp_repeat;

            var isChatEnabled = messengerIntegration.isChatEnabled,
                emailHash = messengerIntegration.emailHash,
                nameHash = messengerIntegration.nameHash,
                dataRefJWT = messengerIntegration.dataRefJWT;
            var _checkoutSession$paye = checkoutSession.payer;
            _checkoutSession$paye = _checkoutSession$paye === undefined ? {} : _checkoutSession$paye;
            var payerId = _checkoutSession$paye.id,
                _checkoutSession$tran = checkoutSession.transactionDetails,
                transactionDetails = _checkoutSession$tran === undefined ? {} : _checkoutSession$tran;

            var txnId = transactionDetails.receipt_id || transactionDetails.id || '';

            _logger.$logger.info('Messenger_plugin_props', { pluginType: pluginType, isMobile: isMobile });
            _logger.$logger.info('Messenger_plugin_data', messengerIntegration);

            // if 'isChatEnabled' variable is enabled, it means that user has already onboarded to
            // the messenger feature, so don't trigger messenger onboarding for that user again
            if (!overrideRepeatUserFlag && (isChatEnabled || fbBAShownFlag === 'true' && pluginType === 'STM')) {
                _logger.$logger.info('UNP_chat_prefernce_is_already_enabled');
                _logger.$logger.info('checkout_fpti', {
                    buyer_country: country,
                    buyer_id: payerId,
                    design: 'fbmessenger',
                    from: 'XO_REVIEW',
                    to: 'process_XO_success',
                    eligibility_reason: 'chat_pref_enabled'
                });
                (0, _jquery2['default'])('.fb-send-to-messenger').hide();
                (0, _jquery2['default'])('#stm-upsell-content').hide();
                return;
            }

            // set all the needed props for the template to render (basically anything attached to `this`)
            // Messenger plugin – comparare this user ID hash with FB user
            this.identityMatchVal = JSON.stringify({
                email_hash: emailHash,
                name_hash: nameHash
            });
            this.dataRefVal = dataRefJWT + '_txnID_' + txnId + '_plugin_' + pluginType + '_token_' + token + '_locale_' + lang + '_' + country;
            this.originVal = window.location.origin;
            this.pageIdVal = _squid.$config.deploy.isLive() ? _fbMessenger2['default'].FB_PROD_PAGE_ID[country] : _fbMessenger2['default'].FB_TEST_PAGE_ID;

            if (pluginType === 'CHECKBOX') {
                this.uuidVal = payerId + '_' + _uuid2['default'].v1(); // the `user_ref`, which includes the user's payer ID
                this.isPrechecked = _fbMessenger2['default'].PRECHECKED_COUNTRIES.includes(country);
                if (_squid.$util.sessionStorageEnabled()) {
                    window.sessionStorage.setItem('checkboxUUIDVal', this.uuidVal);
                }
            }

            // load the correct SDK based on the user's locale
            // it'll fallback to en_US if the locale isn't supported by facebook
            _squid.$dom.loadScript('facebook-jssdk', 'https://www.paypalobjects.com/fbjs/' + lang + '_' + country + '/sdk.js').then(function () {
                if (window.FB) {
                    _this.fbAsyncInit();

                    // NOTE: uncomment to test on stage and localhost
                    // this.cbSTMPlugin({
                    //     event: 'identity_match',
                    //     ref: this.dataRefVal,
                    //     result: 'match'
                    // });
                }
            })['catch'](function (err) {
                // just log that script is not loaded
                // messenger is an optional service which should not block payment done page rendering
                return _logger.$logger.info('fb_messenger_load_script_error', { error: err && err.message });
            });

            this.cbSTMPlugin = function (evt) {
                if (pluginType === 'STM') {
                    if (evt.event === 'rendered') {
                        _logger.$logger.info('STM_plugin_rendered');
                        _logger.$logger.info('checkout_fpti', {
                            buyer_country: country,
                            buyer_id: payerId,
                            design: 'fbmessenger',
                            from: 'XO_REVIEW',
                            to: 'process_rendering_plugin',
                            eligibility_reason: 'plugin_rendered'
                        });
                    }

                    if (evt.event === 'identity_match' && evt.result === 'match') {
                        _logger.$logger.info('FBPP_ID_match');
                        _logger.$logger.info('checkout_fpti', {
                            buyer_country: country,
                            buyer_id: payerId,
                            design: 'fbmessenger',
                            from: 'XO_REVIEW',
                            to: 'process_identity_matching',
                            eligibility_reason: 'identity_matched'
                        });

                        _this.dataRefVal = evt.ref;

                        _jquery2['default'].ajax({
                            url: isMobile ? _fbMessenger2['default'].FB_USER_API_MOBILE_URL : _fbMessenger2['default'].FB_USER_API_URL,
                            xhrFields: { withCredentials: true }
                        }).always(function () {
                            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                                _ref2$responseText = _ref2.responseText,
                                responseText = _ref2$responseText === undefined ? '' : _ref2$responseText;

                            var json = responseText.substring(responseText.indexOf('{'));
                            var data = JSON.parse(json);

                            _logger.$logger.info('callFBToGetBAToken_call', data);
                            messengerIntegration.action('callFBToGetBAToken', {
                                data: { userIdentifier: data.user_identifier },
                                success: function success() {
                                    var getBAResponse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                    var isSuccessful = getBAResponse.success,
                                        batoken = getBAResponse.batoken;

                                    if (isSuccessful) {
                                        _logger.$logger.info('BAToken_from_FB', {
                                            batoken: batoken
                                        });

                                        var fbBAToken = batoken;
                                        var xoJSData = void 0;

                                        if (_squid.$config.deploy.isLocal()) {
                                            xoJSData = {
                                                'data-env': 'local',
                                                'data-stage': 'msmaster',
                                                'data-no-bridge': ''
                                            };

                                            // Generate new FB Channel BA and update while testing, BA gets invalidated in few hours
                                            fbBAToken = 'BA-5UD039368V581733E';
                                        } else if (_squid.$config.deploy.isStage() || _squid.$config.deploy.isSandbox()) {
                                            xoJSData = {
                                                'data-env': 'sandbox',
                                                'data-no-bridge': ''
                                            };
                                        } else {
                                            xoJSData = {
                                                'data-env': 'production',
                                                'data-no-bridge': ''
                                            };
                                        }

                                        var launchBAFlow = function launchBAFlow() {
                                            _logger.$logger.info('Launch_BA_flow_with_token', { fbBAToken: fbBAToken });
                                            _logger.$logger.info('checkout_fpti', {
                                                buyer_country: country,
                                                buyer_id: payerId,
                                                design: 'fbmessenger',
                                                from: 'XO_REVIEW',
                                                to: 'prepare_billing_agreement',
                                                eligibility_reason: 'identity_matched',
                                                click_source: 'pay_now',
                                                ba_token: fbBAToken
                                            });

                                            window.paypal.Checkout.contexts.iframe = true;
                                            if (_squid.$util.localStorageEnabled()) {
                                                window.localStorage.setItem(_fbMessenger2['default'].FB_BA_SHOWN_FLAG, 'true');
                                            }
                                            window.paypal.Checkout.render({
                                                experience: {
                                                    messenger: true,
                                                    override_fbpp_repeat: overrideRepeatUserFlag
                                                },
                                                payment: function payment() {
                                                    return fbBAToken;
                                                },

                                                onAuthorize: function onAuthorize() {
                                                    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                                                        baToken = _ref3.billingToken;

                                                    _logger.$logger.info('User_accepted_FB_BA');

                                                    var isUnchecked = _squid.$util.sessionStorageEnabled() && window.sessionStorage.getItem('checkboxPluginState') === 'unchecked';
                                                    var eligibility_reason = isUnchecked ? 'checkbox_plugin_unchecked' : 'checkbox_plugin_checked';
                                                    if (isUnchecked) {
                                                        _logger.$logger.info('user_not_accepted_messenger_notifications');
                                                        (0, _jquery2['default'])('.fb-send-to-messenger').hide();
                                                        (0, _jquery2['default'])('#stm-upsell-content').hide();
                                                        (0, _jquery2['default'])('#ba-integration-content').show();
                                                    } else {
                                                        _logger.$logger.info('user_accepted_checkbox_messenger_notifications');
                                                        (0, _jquery2['default'])('.fb-send-to-messenger').hide();
                                                        (0, _jquery2['default'])('#stm-upsell-content').hide();
                                                        (0, _jquery2['default'])('#messenger-ba-integration-content').show();
                                                    }
                                                    _logger.$logger.info('checkout_fpti', {
                                                        buyer_country: country,
                                                        buyer_id: payerId,
                                                        design: 'fbmessenger',
                                                        from: 'BILLING_AGREEMENT',
                                                        to: 'process_billing_agreement',
                                                        eligibility_reason: eligibility_reason,
                                                        click_source: 'agree_continue',
                                                        ba_token: fbBAToken
                                                    });

                                                    _this.confirmCheckboxPluginOptIn();
                                                    messengerIntegration.action('notifyFBOntBAAuthorize', {
                                                        data: { baToken: baToken },
                                                        success: function success() {
                                                            var authorizeResponse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                                                            if (authorizeResponse.success) {
                                                                _logger.$logger.info('notifyFBOntBAAuthorize_call_success!');
                                                            } else {
                                                                _logger.$logger.info('notifyFBOntBAAuthorize_call_failure!');
                                                                _logger.$logger.info('checkout_fpti', {
                                                                    buyer_country: country,
                                                                    buyer_id: payerId,
                                                                    design: 'fbmessenger',
                                                                    int_error_code: '500',
                                                                    int_error_description: JSON.stringify(authorizeResponse),
                                                                    error_type: 'failure',
                                                                    error_source: 'notifyFBOntBAAuthorize'
                                                                });
                                                            }
                                                        }
                                                    });

                                                    _logger.$logger.info('checkout_fpti', {
                                                        buyer_country: country,
                                                        buyer_id: payerId,
                                                        design: 'fbmessenger',
                                                        from: 'BILLING_AGREEMENT',
                                                        to: 'prepare_billing_agreement_success',
                                                        eligibility_reason: eligibility_reason,
                                                        click_source: 'return_to_merchant',
                                                        ba_token: fbBAToken
                                                    });
                                                }
                                            });
                                        };
                                        if (window.paypal) {
                                            _logger.$logger.info('xo_JS_is_already_present');
                                            launchBAFlow();
                                        } else {
                                            _squid.$dom.loadScript('xo-js', 'https://www.paypalobjects.com/api/checkout.js', 0, xoJSData).then(function () {
                                                _logger.$logger.info('xo_JS_got_loaded');
                                                launchBAFlow();
                                            });
                                        }
                                    } else {
                                        _logger.$logger.info('callFBToGetBAToken_call_failure!');
                                        _logger.$logger.info('checkout_fpti', {
                                            buyer_country: country,
                                            buyer_id: payerId,
                                            design: 'fbmessenger',
                                            int_error_code: '500',
                                            int_error_description: JSON.stringify(getBAResponse),
                                            error_type: 'failure',
                                            error_source: 'callFBToGetBAToken'
                                        });
                                    }
                                }
                            });
                        });
                    } else if (evt.event === 'identity_match' && evt.result === 'no_match') {
                        _logger.$logger.info('No_FBPP_ID_match');
                        _logger.$logger.info('checkout_fpti', {
                            buyer_country: country,
                            buyer_id: payerId,
                            design: 'fbmessenger',
                            from: 'XO_REVIEW',
                            to: 'process_XO_success',
                            eligibility_reason: 'identity_not_matched',
                            click_source: 'pay_now'
                        });
                    } else if (evt.event === 'identity_match' && evt.result === 'no_logged_in_user') {
                        _logger.$logger.info('No_loggedin_FBPP_ID_match');
                        _logger.$logger.info('checkout_fpti', {
                            buyer_country: country,
                            buyer_id: payerId,
                            design: 'fbmessenger',
                            from: 'XO_REVIEW',
                            to: 'process_XO_success',
                            eligibility_reason: 'logged_out',
                            click_source: 'pay_now'
                        });
                    } else if (evt.event === 'identity_match' && evt.result === 'failure') {
                        _logger.$logger.info('Fail_FBPP_ID_match');
                        _logger.$logger.info('checkout_fpti', {
                            buyer_country: country,
                            buyer_id: payerId,
                            design: 'fbmessenger',
                            int_error_code: '500',
                            int_error_description: JSON.stringify(evt),
                            error_type: 'failure',
                            error_source: 'identity_match'
                        });
                    } else if (evt.event === 'clicked') {
                        _logger.$logger.info('user_accepted_STM_messenger_notifications');
                    }
                }
            };

            this.fbAsyncInit = function () {
                _logger.$logger.info('Initializing_FB_scripts');
                window.FB.init({
                    appId: _fbMessenger2['default'].FB_PROD_APP_ID,
                    xfbml: true,
                    version: 'v2.11'
                });

                // Subscribe to STM
                window.FB.Event.subscribe('send_to_messenger', _this.cbSTMPlugin);

                // Subscribe to CHECKBOX
                window.FB.Event.subscribe('messenger_checkbox', function (evt) {
                    _logger.$logger.info('messenger_checkbox_event', evt);
                    if (evt.event === 'checkbox') {
                        if (_squid.$util.sessionStorageEnabled()) {
                            window.sessionStorage.setItem('checkboxPluginState', evt.state);
                        }
                        _logger.$logger.info('checkbox_plugin_state_' + evt.state);
                    }
                });
            };

            this.confirmCheckboxPluginOptIn = function () {
                _logger.$logger.info('MessengerCheckboxPluginUserConfirmation_event_to_fb', {
                    uuidVal: _squid.$util.sessionStorageEnabled() && window.sessionStorage.getItem('checkboxUUIDVal') || '',
                    pageIdVal: _this.pageIdVal,
                    dataRefVal: _this.dataRefVal
                });
                window.FB.AppEvents.logEvent('MessengerCheckboxUserConfirmation', null, {
                    page_id: _this.pageIdVal,
                    app_id: _fbMessenger2['default'].FB_PROD_APP_ID,
                    ref: _this.dataRefVal,
                    user_ref: _squid.$util.sessionStorageEnabled() && window.sessionStorage.getItem('checkboxUUIDVal') || ''
                });
            };
        },
        exit: function exit() {
            _logger.$logger.info('Messenger_plugin_EXIT_event');
        }
    }
});


_angular.noop;

_logger.$logger;

_squid.$Component;

_squid.$dom;

_squid.$util;

_squid.$config;

_squid.$locale;

_index.$DeviceInfo;

_index2.$CheckoutSessionModel;

_index3.$MessengerIntegrationDataModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-page-components/src/messenger-plugin/template.html":
/***/ (function(module, exports) {

module.exports = "<messenger-plugin content>\n\t<div id=\"messenger-plugin\" ng-value=\"props.pluginType\">\n\n\t\t<div class=\"fb-send-to-messenger\" origin=\"{{originVal}}\" identity_match=\"{{identityMatchVal}}\" messenger_app_id=1084613224964631\n\t\t\tpage_id={{pageIdVal}} data-ref=\"{{dataRefVal}}\" color=\"blue\" size=\"xlarge\" ng-if=\"(props.pluginType == 'STM')\">\n\t\t</div>\n\n\t\t<div class=\"fb-messenger-checkbox\" origin=\"{{originVal}}\" page_id={{pageIdVal}} messenger_app_id=1084613224964631\n\t\t\tpixel_id=329481497393670 ref=\"{{dataRefVal}}\" user_ref=\"{{uuidVal}}\" prechecked=\"{{isPrechecked}}\" allow_login=\"true\" size=\"xlarge\"\n\t\t\tng-if=\"(props.pluginType == 'CHECKBOX')\">\n\t\t</div>\n\n\t</div>\n</messenger-plugin>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/notYou/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoNotYouComponent = undefined;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/notYou/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/notYou/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoNotYouComponent = exports.$xoNotYouComponent = _squid.$Component.extend('$xoNotYou', {
    tag: 'xo-not-you',
    template: _template2['default'],
    resolve: {
        models: function models() {
            return {
                auth: _auth.$AuthModel.instance().retrieve(),
                appData: _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve(),
                cart: _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token).retrieve()
            };
        }
    },
    actions: {
        onClick: function onClick() {
            if (_thirdPartyInfo.thirdPartyInfo.isVenmoEligible()) {
                this.actions.preferToPayWithVenmo();
                return;
            }
            this.actions.logout();
        },
        preferToPayWithVenmo: function preferToPayWithVenmo() {
            _logger.$logger.info('click_prefer_to_pay_with_venmo');
            _uiRouter.$state.go('checkout.payWithSelection', {}, { location: false });
        },
        logout: function logout() {
            var _this = this;

            _logger.$logger.info('not_you_logout');
            if (window.xchild && _squid.$util.isIFrame() && window.paypal && !window.paypal.isWebView()) {
                window.xchild.hide();

                var url = window.location.href.split('#')[0];
                var xprops = _squid.$util.extend({}, window.xprops);

                xprops.url = url;
                xprops.payment = function () {
                    return _this.models.auth.logout().then(function () {
                        return _angular.$rootScope.token;
                    });
                };

                return window.ppxo.Checkout.renderPopupTo(window.xchild.getParentRenderWindow(), xprops);
            }

            this.models.auth.logoutAndRedirect('NOT_YOU');
        }
    },
    lifecycle: {
        populate: function populate() {
            var getMessage = function getMessage() {
                if (_thirdPartyInfo.thirdPartyInfo.isVenmoEligible() && !_thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(_angular.$rootScope.token)) {
                    return _squid.$locale.content.get('memberReview.preferToPayWithVenmo');
                }

                return _squid.$locale.content.get('memberReview.notYou');
            };

            this.message = getMessage();
            this.token = _angular.$rootScope.token;
        }
    }
});

angular.value("$xoNotYouComponent", $xoNotYouComponent);
_uiRouter.$state;

_angular.$rootScope;

_logger.$logger;

_auth.$AuthModel;

_squid.$Component;

_squid.$util;

_squid.$locale;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_thirdPartyInfo.thirdPartyInfo;

_thirdPartyInfo.thirdPartyExperience;

/***/ }),

/***/ "../node_modules/xo-page-components/src/notYou/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/notYou/template.html":
/***/ (function(module, exports) {

module.exports = "<a content track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"actions.onClick()\">{{ this.message }}</a>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/returnParams/index.js":
/***/ (function(module, exports, __webpack_require__) {



var addValidParam = __webpack_require__("../node_modules/xo-page-components/src/utils/index.js").addValidParam;

function returnWPSParams(checkoutCart, checkoutSession, returnToMerchantMethod, is_cart_upload_flow) {
    var params = {};
    var customData = checkoutCart.get('purchase.custom');

    if (returnToMerchantMethod === 'POST') {
        // TODO: find out why we get postbackData as undefined
        // UPDATE: couldn't reproduce an issue on the stage for now
        if (checkoutSession.postbackData) {
            params = checkoutSession.postbackData;
        }
    } else {
        var transactionDetail = checkoutSession.transactionDetails;

        if (transactionDetail) {
            addValidParam(params, 'tx', transactionDetail.id);
            addValidParam(params, 'st', transactionDetail.state);

            if (transactionDetail.amount) {
                addValidParam(params, 'amt', transactionDetail.amount.total);
                addValidParam(params, 'cc', transactionDetail.amount.currency);
            }
        }

        // Cart uploads can have more than one item so we don't add any in return URL
        if (!is_cart_upload_flow) {
            var itemDetail = checkoutSession.get('itemsList.0');
            if (itemDetail) {
                addValidParam(params, 'item_name', itemDetail.name);
                addValidParam(params, 'item_number', itemDetail.sku);
            }
        }

        addValidParam(params, 'cm', customData);
    }
    return params;
}

/**
 * this API function is used by hermesnodeweb/public/pages/xo-end and xoonboardingnodeweb/public/pages/xo-end
 * Create params to return back to the merchant after clicking on "Return to merchant" on the Done page.
 * buy-now and cart-upload params are slightly different: given cart-upload might have multiple items,
 * please refer https://github.paypal.com/NodeXOShared/xo-hermes-checkout/blob/master/apis/session/postBackDataMapper.js
 * to know more details about post back data

 * @param {Object (angular model)} cart model
 * @param {Object (angular model)} session model
 * @param {String} http method, either "POST" or "GET"
 * @param {String} feature type (WPS only for now)
 * @param {Boolean} flag that indicates if it's a cart upload or not
 * @returns {object} params to pass back to the merchant
*/
module.exports = {
    $returnParams: function $returnParams(checkoutCart, checkoutSession, returnToMerchantMethod, feature, is_cart_upload_flow) {
        if (feature === 'WPS') {
            return returnWPSParams(checkoutCart, checkoutSession, returnToMerchantMethod, is_cart_upload_flow);
        }
        return {};
    }
};

/***/ }),

/***/ "../node_modules/xo-page-components/src/subscription-terms/index.js":
/***/ (function(module, exports, __webpack_require__) {



var _subscriptionTerms = __webpack_require__("../node_modules/xo-page-components/src/subscription-terms/subscriptionTerms.js");

var _subscriptionTerms2 = _interopRequireDefault(_subscriptionTerms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = {
    getFirstAmount: _subscriptionTerms2['default'].getFirstAmount,
    getFormattedFirstAmount: _subscriptionTerms2['default'].getFormattedFirstAmount,
    getItemOptions: _subscriptionTerms2['default'].getItemOptions,
    getItemName: _subscriptionTerms2['default'].getItemName,
    getCurrencyCode: _subscriptionTerms2['default'].getCurrencyCode,
    getTermsText: _subscriptionTerms2['default'].getTermsText,
    getEffectiveDate: _subscriptionTerms2['default'].getEffectiveDate
};

/***/ }),

/***/ "../node_modules/xo-page-components/src/subscription-terms/subscriptionTerms.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var BILL_PERIOD_DAY = 'DAY';
var BILL_PERIOD_WEEK = 'WEEK';
var BILL_PERIOD_MONTH = 'MONTH';
var BILL_PERIOD_YEAR = 'YEAR';
var TRIAL_SUBSCRIPTION = 'TRIAL';
var REGULAR_SUBSCRIPTION = 'REGULAR';
var INFINITE_CYCLES = 'INFINITE';

/**
 * Plural time unit
 *  True: time unit will be one of: days, weeks, months, years
 *  False: time unit will be one of: day, week, month, year
 * @type {boolean}
 */
var pluralTimeUnit = false;

/**
 * If a statement has hasPriorTerm=true , then the statement will begin with "Then"
 *  e.g. Then 2$ for next 4 months
 *  otherwise statement will be
 *  2$ for next 4 months
 * @type {boolean}
 */
var hasPriorTerm = false;

/**
 * Returns a localized text from given key and props
 * @param key
 * @param props
 */
function localizedContent(key, props) {
    return _squid.Content.get(key, props) && _squid.Content.get(key, props).toString();
}

/**
 * Computes the singular or plural form for time unit
 * @param billPeriod
 * @returns {string}
 */
function computeTimeUnit(billPeriod) {
    var timeUnit = void 0;

    switch (billPeriod) {
        case BILL_PERIOD_DAY:
            timeUnit = pluralTimeUnit ? 'days' : 'day';
            break;
        case BILL_PERIOD_WEEK:
            timeUnit = pluralTimeUnit ? 'weeks' : 'week';
            break;
        case BILL_PERIOD_MONTH:
            timeUnit = pluralTimeUnit ? 'months' : 'month';
            break;
        case BILL_PERIOD_YEAR:
            timeUnit = pluralTimeUnit ? 'years' : 'year';
            break;
        default:
            timeUnit = '';
    }

    return localizedContent('wpsSubscription.label.' + timeUnit);
}

/**
 * Format amount
 * @param amount
 * @param currencyCode
 * @returns {string} A formatted amount string with currency code or free if 0
 */
function computeAmount(amount, currencyCode) {
    if (amount === 0) {
        return localizedContent('wpsSubscription.label.free');
    } else {
        return (0, _squid.formatCurrency)(amount, currencyCode, false);
    }
}

/**
 * This method computes first trial key
 * @returns {string} Content Key for 1st trial, which must be prepended by wpsSubscription.message
 */
function computeFirstTrialKey() {
    if (pluralTimeUnit) {
        // {amount} for the first {timePeriod} {timeUnit}
        return 'firstTrialPeriod.plural';
    } else {
        // {amount} for the first {timeUnit}
        return 'firstTrialPeriod.singular';
    }
}

/**
 * This method computes content key for 2nd trial
 * @returns {string} Content Key for 2nd trial, which must be prepended by wpsSubscription.message
 */
function computeSecondTrialKey() {
    if (pluralTimeUnit) {
        // Then {amount} for the next {timePeriod} {timeUnit}
        return 'secondTrialPeriod.plural';
    } else {
        // Then {amount} for the next {timeUnit}
        return 'secondTrialPeriod.singular';
    }
}

/**
 * Computes and returns content key for regular subscription
 * There can be 12 variations of regular subscription content
 * @param totalCycles
 * @returns {string}  Content Key for 2nd trial, which must be prepended by wpsSubscription.message
 */
function computeRegularSubscriptionKey(totalCycles) {
    var key = 'regularSubscriptionPeriod';

    if (hasPriorTerm) {
        // Content starts with Then {amount} for ......
        key += '.withPriorTerms';
    } else {
        // Content does NOT starts with Then
        key += '.noPriorTerms';
    }

    if (pluralTimeUnit) {
        // Content has: {amount} for each 2 days/weeks/months/years
        key += '.plural';
    } else {
        // Content has: {amount} for each day/week/month/year
        key += '.singular';
    }

    switch (+totalCycles) {
        case 0:
        case 1:
            // Text will look like $20.00 USD for the next 2 months
            // Content does NOT end with: for 3 installments
            key += '.nonRecurring';
            break;
        case Infinity:
            // Content ends with: for each 2 months OR for each month
            // Content will look like $30.00 USD for each week
            key += '.recurringInfinite';
            break;
        default:
            // Content ends with: for 3 installments
            // Content will look like $100.00 USD for each 2 months, for 3 installments
            key += '.recurring';
    }
    return key;
}

/**
 * Prepares and returns an individual term text string
 * @param subscriptionTerms
 * @param index
 * @param currencyCode
 * @returns {string}
 */
function prepareIndividualTermText(subscriptionTerms, index, currencyCode) {
    var amount = +subscriptionTerms[index].amount,
        billPeriod = subscriptionTerms[index].billPeriod,
        periodType = subscriptionTerms[index].periodType,
        billFrequency = +subscriptionTerms[index].billFrequency,
        totalCycles = +subscriptionTerms[index].totalCycles;
    var contentKey = void 0;
    hasPriorTerm = index > 0;
    pluralTimeUnit = billFrequency > 1;

    if (periodType === TRIAL_SUBSCRIPTION) {
        if (index === 0) {
            // First Trial
            contentKey = computeFirstTrialKey();
        } else if (index === 1) {
            // Second Trial
            contentKey = computeSecondTrialKey();
        }
    } else if (periodType === REGULAR_SUBSCRIPTION) {
        contentKey = computeRegularSubscriptionKey(totalCycles);
    }
    contentKey = 'wpsSubscription.message.' + contentKey;
    var templatePlaceholderData = {
        amount: computeAmount(amount, currencyCode),
        timePeriod: billFrequency,
        timeUnit: computeTimeUnit(billPeriod),
        installmentCount: totalCycles
    };

    return localizedContent(contentKey, templatePlaceholderData);
}

function mapBaResponse(baResponseData) {
    var mappedSubscriptionDetails = {};
    var plan = baResponseData && baResponseData.plan;
    var allTerms = plan && plan.payment_definitions;
    var mappedTerms = [];
    var firstTrialAmount = null;
    var regularAmount = void 0;
    mappedSubscriptionDetails.currencyCode = plan && plan.currency_code;

    if (allTerms) {
        allTerms.forEach(function (eachTerm) {
            var totalCycles = eachTerm.duration === INFINITE_CYCLES ? Infinity : eachTerm.cycles;
            var eachMappedTerm = {
                amount: eachTerm.amount && eachTerm.amount.value / 100,
                billPeriod: eachTerm.frequency,
                periodType: eachTerm.type,
                billFrequency: eachTerm.frequency_interval,
                totalCycles: totalCycles
            };
            if (eachTerm.type === TRIAL_SUBSCRIPTION && eachTerm.index === '1') {
                firstTrialAmount = eachMappedTerm.amount;
            } else if (eachTerm.type === REGULAR_SUBSCRIPTION) {
                regularAmount = eachMappedTerm.amount;
            }
            mappedTerms.push(eachMappedTerm);
        });

        // firstTrialAmount can be zero for free trial, null for no trial
        // and valid value if there is trial amount
        mappedSubscriptionDetails.firstAmount = firstTrialAmount !== null ? firstTrialAmount : regularAmount;
        mappedSubscriptionDetails.subscriptionTerms = mappedTerms;
    }

    return mappedSubscriptionDetails;
}

/**
 * Prepare and return a subscription terms
 * @param baResponseData
 * @returns {Object} Containing Subscription Terms Text
 */
function getTermsText(baResponseData) {
    var subscriptionDetails = mapBaResponse(baResponseData);
    var subscriptionTerms = subscriptionDetails.subscriptionTerms;
    var currencyCode = subscriptionDetails.currencyCode;
    var termTextList = [];

    for (var i = 0, len = subscriptionTerms.length; i < len; i++) {
        termTextList.push(prepareIndividualTermText(subscriptionTerms, i, currencyCode));
    }
    return termTextList;
}

/**
 * Returns a un formatted first amount from ba response
 */
function getFirstAmount(baResponseData) {
    var subscriptionDetails = mapBaResponse(baResponseData);

    return subscriptionDetails.firstAmount;
}

/**
 * Returns the currency code
 */
function getCurrencyCode(baResponseData) {
    var plan = baResponseData && baResponseData.plan;

    return plan && plan.currency_code;
}

/**
 * Returns a formatted first amount from ba response data
 */
function getFormattedFirstAmount(baResponseData) {
    var amount = getFirstAmount(baResponseData);
    var currencyCode = getCurrencyCode(baResponseData);

    return (0, _squid.formatCurrency)(amount, currencyCode, false);
}

/**
 * Retrieve item details
 */
function getItemOptions(baResponseData) {
    var itemDetails = baResponseData && baResponseData.items && baResponseData.items[0];

    return itemDetails.options;
}

/**
 * Retrieve item name
 */
function getItemName(baResponseData) {
    var itemDetails = baResponseData && baResponseData.items && baResponseData.items[0];

    return itemDetails.name;
}

function getEffectiveDate(baResponseData) {
    return baResponseData && baResponseData.effective_date;
}

module.exports = {
    getFirstAmount: getFirstAmount,
    getFormattedFirstAmount: getFormattedFirstAmount,
    getItemOptions: getItemOptions,
    getItemName: getItemName,
    getCurrencyCode: getCurrencyCode,
    getTermsText: getTermsText,
    getEffectiveDate: getEffectiveDate
};

_squid.formatCurrency;

_squid.Content;

/***/ }),

/***/ "../node_modules/xo-page-components/src/utils/index.js":
/***/ (function(module, exports, __webpack_require__) {



var _fbMessenger = __webpack_require__("../node_modules/xo-page-components/src/constants/fbMessenger.js");

var _fbMessenger2 = _interopRequireDefault(_fbMessenger);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = {
    /**
     * add non empty key, value to the object
     * @param {Object} object where to add new key, value
     * @param {String} key
     * @param {Any type} value, can not be empty
     * @returns {void}
     */
    addValidParam: function addValidParam(obj, key, val) {
        if (!obj) {
            return;
        }
        if (typeof key === 'string' && key && val !== undefined && val !== null) {
            obj[key] = val;
        }
    },

    // Get PXP context for Messenger feature
    getMessengerPXPContext: function getMessengerPXPContext() {
        var isMobile = _index.$DeviceInfo.isMobile() || _index.$DeviceInfo.isTablet();
        var overrideMobileUserFlag = _squid.$util.param(_fbMessenger2['default'].OVERRIDE_FBPP_MOBILE_FLAG);
        var channelVal = isMobile ? _fbMessenger2['default'].MOBILE_CHANNEL : _fbMessenger2['default'].WEB_CHANNEL;
        var pxpContext = {
            'ctx.COUNTRY': _squid.$locale.country,
            'ctx.CHANNEL': overrideMobileUserFlag ? _fbMessenger2['default'].WEB_CHANNEL : channelVal,
            'ctx.LANGUAGE': _squid.$locale.lang + '_' + _squid.$locale.country
        };

        return pxpContext;
    },

    isDolphinEligibleOnWpsDone: function isDolphinEligibleOnWpsDone(stateName) {
        return (/checkout\.done/.test(stateName) && !!_squid.$util.param('ulToastWpsDone')
        );
    }
}; /* eslint-disable angular/typecheck-string */


_squid.$util;

_squid.$locale;

_index.$DeviceInfo;

/***/ }),

/***/ "../node_modules/xo-page-components/src/value-props/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-page-components/src/value-props/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, template) {
    squid.module('xo-value-props.directive', ['squid']).directive('xoValueProps', function () {
        return {
            template: template,
            restrict: 'E',
            scope: {
                type: '@?',
                title: '@?',
                text: '@?',
                textContent: '@?',
                imageUrl: '@?'
            },
            link: function link(scope, element, attrs) {
                if (angular.isString(attrs.imageUrl)) {
                    // Only do this when image-url is defined so that we do not affect default behavior. These image-url
                    // are configured through pxp tool for factor based experiments, hence they should all should adhere
                    // to standard size i.e. 150X150 pixels.
                    attrs.$observe('imageUrl', function (imageUrl) {
                        var url = imageUrl;
                        var propImg = angular.element(element[0].querySelector('div.prop-img'));
                        var isRetina = window && window.matchMedia && window.matchMedia('(-webkit-min-device-pixel-ratio: 2), ' + '(min--moz-device-pixel-ratio: 2), ' + '(-o-min-device-pixel-ratio: 2/1),' + '(min-device-pixel-ratio: 2),' + '(min-resolution: 192dpi), ' + '(min-resolution: 2dppx)').matches;

                        if (isRetina) {
                            var index = url.lastIndexOf('.'); // index at which file extension start
                            url = url.substring(0, index) + '_2x' + url.substring(index, url.length);
                            propImg.css({
                                'background-image': 'url(' + url + ')',
                                'height': '150px',
                                'background-size': '150px 150px',
                                'margin-top': '0px'
                            });
                        } else {
                            propImg.css({
                                'background-image': 'url(' + url + ')',
                                'height': '150px',
                                'margin-top': '0px'
                            });
                        }
                    });
                }
            }
        };
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-return-to-merchant/dist/formatReturnContent.js":
/***/ (function(module, exports) {



exports.__esModule = true;
exports.formatReturnContent = formatReturnContent;
var MAX_MERCHANT_NAME_LENGTH = exports.MAX_MERCHANT_NAME_LENGTH = 15;

function formatReturnContent($renderContent, merchantName) {
    if (merchantName && merchantName.length < MAX_MERCHANT_NAME_LENGTH) {
        return $renderContent('common.returnToMerchant', { merchantName: merchantName });
    }

    return $renderContent('common.returnToDefaultMerchant');
}

/***/ }),

/***/ "../node_modules/xo-return-to-merchant/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _util = __webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");

Object.defineProperty(exports, '$ReturnToMerchant', {
  enumerable: true,
  get: function get() {
    return _util.$ReturnToMerchant;
  }
});

var _formatReturnContent = __webpack_require__("../node_modules/xo-return-to-merchant/dist/formatReturnContent.js");

Object.defineProperty(exports, 'formatReturnContent', {
  enumerable: true,
  get: function get() {
    return _formatReturnContent.formatReturnContent;
  }
});
Object.defineProperty(exports, 'MAX_MERCHANT_NAME_LENGTH', {
  enumerable: true,
  get: function get() {
    return _formatReturnContent.MAX_MERCHANT_NAME_LENGTH;
  }
});

/***/ }),

/***/ "../node_modules/xo-return-to-merchant/dist/util.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ReturnToMerchant = undefined;
exports.goTo = goTo;
exports.postToMerchant = postToMerchant;
exports.postTo = postTo;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function goTo(url, forceRedirect) {
    if (!url) {
        return;
    }

    _logger.$logger.info(url.indexOf('PayerID') > -1 ? 'return_to_merchant' : 'cancel_to_merchant', {
        url: url
    });

    // if V4 in-context integration, we'll terminate and call the close handler.
    if (window.xchild) {
        _logger.$logger.done();
        _angular.$rootScope.$emit('loading');

        var paymentToken = _angular.$rootScope.token;
        var cart = _index2.$CheckoutCartModel.instance(paymentToken);
        var appData = _index2.$CheckoutAppDataModel.instance(paymentToken);
        var orderID = paymentToken;
        var intent = cart.payment_action;
        var billingToken = cart.billing && cart.billing.ba_token;
        var paymentID = appData.payment_id;
        var cancelUrl = url;

        return window.xprops.onCancel({
            paymentToken: paymentToken,
            billingToken: billingToken,
            orderID: orderID,
            paymentID: paymentID,
            intent: intent,
            cancelUrl: cancelUrl
        });
    }

    var isHTTPUrl = Boolean(url.indexOf('http') === 0 || url.indexOf('www') === 0);
    var showPaymentSuccess = Boolean(_index.$DeviceInfo.isDevice() && !isHTTPUrl);

    if (showPaymentSuccess) {
        _logger.$logger.info('redirect', {
            url: url
        });
        _angular.$window.onunload = _angular.$window.onbeforeunload = function () {// eslint-disable no-empty-function
        };

        // wait until state change is done and then redirect
        // for some reason, in case of webview (invoice flow) and code split
        // when user is redirecting to the return url - dynamic chunk fails to load
        // which triggers reload of the previous page
        return _uiRouter.$state.go('checkout.genericMessage', {
            code: 'PAYMENT_SUCCESS'
        })['catch'](function (err) {
            _logger.$logger.info('app_redirect_to_merchant_generic_message_error', {
                error: err && err.message
            });
        })['finally'](function () {
            _angular.$window.location = url;
        });
    }

    if (forceRedirect) {
        _squid.$util.redirect(url);
    } else {
        var isVZeroIframe = Boolean(_angular.$rootScope.partnerIntegration) && _squid.$util.isIFrame();

        if (isVZeroIframe) {
            _squid.$util.redirect(url, { redirectImmediateParent: true });
        }

        // If we are not in minibrowser, do a hard redirect
        else if (_angular.$rootScope.partnerIntegration || !_angular.$rootScope.miniBrowser && !_squid.$util.isIFrame()) {
                _squid.$util.redirect(url);
            } else {

                // Construct a message to send to the parent
                var result = this.postToMerchant({
                    operation: 'return_to_merchant',
                    returnUrl: url,
                    updateParent: true
                });

                // Otherwise we have no choice but to return to the merchant
                if (!result) {
                    _squid.$util.redirect(url);
                }
            }
    }

    var userStatus = function userStatus() {
        _logger.$logger.info('redirected_user_still_on_page_second_checkpoint');
    };

    (0, _angular.$timeout)(function () {
        _logger.$logger.info('redirected_user_still_on_page_first_checkpoint');
        (0, _angular.$timeout)(userStatus, 10000);
    }, 10000);
}

function postToMerchant(msg) {

    try {
        msg = _angular2['default'].toJson(msg, 0);

        // If we are not in IE, attempt to send a postMessage
        if (_angular.$window.opener && (_angular.$window.navigator.userAgent.match(/edge/i) || _angular.$window.opener.postMessage && !_angular.$window.navigator.userAgent.match(/msie|trident/i))) {
            _angular.$window.opener.postMessage(msg, '*');
            _logger.$logger.info('minibrowser_postmessage');
            return true;
        }
        // Otherwise, attempt to send a message through the iframe bridge
        var bridge = _angular.$window.opener && _angular.$window.opener.frames && _angular.$window.opener.frames.length && _angular.$window.opener.frames.PayPalBridge;

        if (bridge && bridge.returnToParent) {
            bridge.returnToParent(msg);
            _logger.$logger.info('minibrowser_bridgemessage');
            return true;
        }

        _logger.$logger.warn('minibrowser_nopostback');
    } catch (err) {
        _logger.$logger.error('minibrowser_postback_error', {
            error: err.stack || err.toString()
        });
    }

    return false;
}

function postTo(url, msg) {
    var form = document.createElement('form');

    form.method = 'POST';
    form.action = url;
    form.className = 'hide';

    for (var key in msg) {
        var input = document.createElement('input');

        input.name = key;
        input.value = msg[key];
        form.appendChild(input);
    }

    _angular.$window.document.body.appendChild(form);
    form.submit();
    _logger.$logger.info('web_postmessage');
    return true;
}

var $ReturnToMerchant = exports.$ReturnToMerchant = {
    goTo: goTo,
    postToMerchant: postToMerchant,
    postTo: postTo
};

_angular2['default'].value("goTo", goTo);
_angular2['default'].value("postToMerchant", postToMerchant);
_angular2['default'].value("postTo", postTo);
_angular2['default'].value("$ReturnToMerchant", $ReturnToMerchant);
_index.$DeviceInfo;

_logger.$logger;

_uiRouter.$state;

_squid.$util;

_index2.$CheckoutCartModel;

_index2.$CheckoutAppDataModel;

/***/ }),

/***/ "../node_modules/xo-shipping-change/src/factory.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ShippingChangeFactory = $ShippingChangeFactory;

var _util = __webpack_require__("../node_modules/xo-shipping-change/src/util.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function $ShippingChangeFactory(token, checkoutAppData, checkoutSession, checkoutCart) {
    return {
        getCartTotal: function getCartTotal() {
            return (0, _util.getCartTotal)(checkoutCart);
        },
        getPayload: function getPayload() {
            return checkoutSession.retrieve().then(function () {
                var shipping = checkoutSession.get('shipping');
                var paymentID = checkoutAppData.get('payment_id');
                var payerID = checkoutSession.get('payer.id');

                var amounts = _squid.$util.map(checkoutCart.get('purchase.amounts'), function (_ref) {
                    var amount = _ref.amount,
                        currency_code = _ref.currency_code;

                    return { amount: amount, currency_code: currency_code };
                });

                return (0, _util.getPayload)(token, paymentID, payerID, shipping, amounts);
            });
        },
        updateCart: function updateCart() {
            return (0, _util.updateCart)(checkoutSession, checkoutCart);
        },
        callOnShippingChange: function callOnShippingChange(payload) {
            var allowChangeShipping = checkoutAppData.get('flags.allow_change_shipping', false);

            if (!allowChangeShipping) {
                return (0, _squid.$promise)({
                    cartHasChanged: false,
                    rejected: false
                });
            }

            return (0, _util.callOnShippingChange)(payload, checkoutCart, checkoutSession);
        }
    };
}

angular.value("$ShippingChangeFactory", $ShippingChangeFactory);
_util.getCartTotal;

_util.getPayload;

_util.updateCart;

_util.callOnShippingChange;

_squid.$util;

_squid.$promise;

/***/ }),

/***/ "../node_modules/xo-shipping-change/src/util.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getCartTotal = getCartTotal;
exports.getPayload = getPayload;
exports.updateCart = updateCart;
exports.callOnShippingChange = callOnShippingChange;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function getCartTotal(cart) {
    return {
        currency: cart.get('purchase.amounts.total.currency_code'),
        value: cart.get('purchase.amounts.total.amount')
    };
}

function getPayload(token, paymentID, payerID) {
    var shipping = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var amounts = arguments[4];
    var city = shipping.city,
        state = shipping.state,
        country = shipping.country,
        postal_code = shipping.postal_code;


    var shippingChangePayload = {
        paymentID: paymentID,
        payerID: payerID,
        token: token,
        city: city,
        state: state,
        country: country,
        postal_code: postal_code,
        amounts: amounts
    };

    var checkForIxoPaymentOptions = function checkForIxoPaymentOptions() {
        if (!window.xprops || !window.xprops.supplement || !window.xprops.supplement.getPaymentOptions) {
            return (0, _squid.$promise)();
        }

        return window.xprops.supplement.getPaymentOptions(shippingChangePayload.paymentID).then(function (payment) {
            if (payment && payment.payer && payment.payer.shipping_options) {
                return (0, _squid.$promise)(payment.payer.shipping_options);
            }
        });
    };

    var checkForIxoPaymentDetails = function checkForIxoPaymentDetails() {
        if (!window.xprops || !window.xprops.supplement || !window.xprops.supplement.getPaymentDetails) {
            return (0, _squid.$promise)();
        }

        return window.xprops.supplement.getPaymentDetails(shippingChangePayload.paymentID).then(function (payment) {
            if (payment && payment.selected_shipping_method) {
                return (0, _squid.$promise)(payment.selected_shipping_method);
            }
        });
    };

    return checkForIxoPaymentOptions().then(function (shippingOptions) {
        shippingChangePayload.shipping_options = shippingOptions;
    }).then(checkForIxoPaymentDetails).then(function (selectedShippingMethod) {
        shippingChangePayload.selected_shipping_method = selectedShippingMethod;
    }).then(function () {
        return shippingChangePayload;
    });
}

function updateCart(session, cart) {
    session.invalidate();

    cart.invalidate();
    cart.api.cache = false;

    return _squid.$promise.all([session.reload(), cart.reload()]).then(function () {
        return getCartTotal(cart);
    });
}

function callOnShippingChange(payload, cart, session) {

    var rejected = false;

    var shippingChangeActions = {
        reject: function reject() {
            rejected = true;
        }
    };

    var cartTotal = getCartTotal(cart);

    return window.xprops.onShippingChange(payload, shippingChangeActions).then(function () {
        return updateCart(session, cart);
    }).then(function (total) {
        var newCartTotal = getCartTotal(cart);
        var cartHasChanged = cartTotal.currency !== newCartTotal.currency || cartTotal.value !== newCartTotal.value;

        return { cartHasChanged: cartHasChanged, rejected: rejected };
    });
}

_squid.$promise;

/***/ }),

/***/ "../node_modules/xo-styles/dist/lib/toggle.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/review-paywith-baidu/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-third-party-components/src/review-paywith-baidu/styles.less");

var _template = __webpack_require__("../node_modules/xo-third-party-components/src/review-paywith-baidu/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoReviewPayWithBaiduComponent', {
    tag: 'xo-review-paywith-baidu',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            optional: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.token).retrieve()['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        populate: function populate() {
            var checkoutSession = this.models.checkoutSession;


            this.showAmt = true;
            this.defaultFs = checkoutSession.get('plan.sources');
        }
    }
});


_angular.noop;

_squid.$Component;

_checkout.$CheckoutSessionModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/review-paywith-baidu/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/review-paywith-baidu/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"paywith asideView pwBaidu\" content>\n    <div class=\"trayInner trayInnerDefault\" >\n        <div id=\"paymentMethod\">\n\n            <h4 class=\"noBottom paymentsHeader zeta\">\n                <span>\n                    {{ content('paymentMethod.payWith') }}\n                </span>\n            </h4>\n            <div class=\"charges\">\n                <div ng-repeat=\"fs in defaultFs\" class=\"clearfix fs\">\n                    <div ng-class=\"['method', 'EXTERNAL_WALLET']\">\n                        <span class=\"fsIcons\" ng-if=\"!fs.is_pinless_debit\"></span>\n                        <span class=\"pinlessGlyphIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"fs.is_pinless_debit\"></span>\n                         <span class=\"name\" ng-if=\"fs.type === 'EXTERNAL_WALLET'\">\n                             {{ content('paymentMethod.baiduWallet') }}\n                         </span>\n                    </div>\n                    <span ng-if=\"showAmt\" class=\"methodAmount\">\n                        <span class=\"amountFormatted\"><format-currency code=\"fs.amount.currency_code\" amount=\"fs.amount.amount\"></format-currency></span>\n                    </span>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/review-paywith-venmo/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _venmoModels = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-models/index.js");

var _pxp = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/pxp.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-third-party-components/src/review-paywith-venmo/styles.less");

var _template = __webpack_require__("../node_modules/xo-third-party-components/src/review-paywith-venmo/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCheckoutComponent', {
    tag: 'xo-review-paywith-venmo',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            optional: false
        }
    },
    resolve: {
        models: function models() {
            return {
                venmo: _venmoModels.$VenmoOnboardModel.instance(this.token).retrieve()['catch'](_angular.noop),
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.token).retrieve()['catch'](_angular.noop),
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(this.token).retrieve()['catch'](_angular.noop),
                checkoutCart: _checkout.$CheckoutCartModel.instance(this.token).retrieve()['catch'](_angular.noop),
                payee: _checkout.$CheckoutPayeeModel.instance(this.token).retrieve()['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this = this;

            var _models = this.models,
                payee = _models.payee,
                venmo = _models.venmo,
                checkoutCart = _models.checkoutCart,
                checkoutAppData = _models.checkoutAppData,
                checkoutSession = _models.checkoutSession;

            this.intentNotSale = checkoutCart.get('payment_action') !== 'sale';
            var getAmount = function getAmount() {
                return checkoutSession.get('plan.sources.0.amount');
            };
            var mapperFS = {
                BALANCE: function BALANCE(fs) {
                    return {
                        type: fs.funding_mode,
                        amount: getAmount()
                    };
                },
                PAYMENT_CARD: function PAYMENT_CARD(fs) {
                    return {
                        type: fs.funding_mode,
                        card_type: fs.payment_card.type,
                        sub_type: 'INSTANT_TRANSFER',
                        name: fs.payment_card.type,
                        last4: fs.payment_card.number,
                        amount: getAmount()
                    };
                },
                BANK_ACCOUNT: function BANK_ACCOUNT(fs) {
                    return {
                        type: fs.funding_mode,
                        sub_type: 'INSTANT_TRANSFER',
                        name: fs.bank_account.bank_name,
                        last4: fs.bank_account.account_number,
                        amount: getAmount()
                    };
                }
            };

            function determineShowAmt() {
                var userAction = checkoutAppData.useraction();
                var noLineItemDetails = !(userAction && userAction.toLowerCase() === 'commit') && checkoutCart.get('purchase.items.length') === 0;

                return (0, _pxp.$pxpCartAmt)(checkoutAppData.get('merchant.merchant_country'), payee.get('merchant.id'), noLineItemDetails, checkoutCart.isPurchase()).then(function (showAmount) {
                    return checkoutCart.get('payment_action') !== 'authorize' && showAmount;
                });
            }

            function getPlanList() {
                var defaultFS = venmo.get('funding_sources.default_option');

                if (defaultFS && defaultFS.funding_mode && mapperFS[defaultFS.funding_mode]) {
                    return [mapperFS[defaultFS.funding_mode](defaultFS)];
                } else {
                    return checkoutSession.get('plan.sources');
                }
            }

            function getBackup() {
                var backup = venmo.get('funding_sources.alternate_option');

                if (backup && backup.funding_mode && mapperFS[backup.funding_mode]) {
                    return mapperFS[backup.funding_mode](backup);
                }
            }

            this.venmoUser = '@' + venmo.get('username');
            determineShowAmt().then(function (shouldShowAmt) {
                _this.showAmt = shouldShowAmt;
            });
            this.defaultFs = getPlanList();
            this.backupFs = getBackup();
        }
    }
});


_angular.noop;

_squid.$Component;

_venmoModels.$VenmoOnboardModel;

_pxp.$pxpCartAmt;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutPayeeModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/review-paywith-venmo/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/review-paywith-venmo/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"paywith asideView pwVenmo\" content>\n    <div class=\"trayInner trayInnerDefault\" >\n        <div id=\"paymentMethod\">\n\n            <h4 class=\"noBottom paymentsHeader zeta\">\n                <span>\n                    {{ content('paymentMethod.payWith') }}\n                </span>\n            </h4>\n            <ul class=\"charges\">\n                <li ng-repeat=\"fs in defaultFs\" class=\"clearfix fs\">\n                    <div ng-class=\"['method', 'BALANCE']\">\n                        <span class=\"fsIcons\" ng-if=\"!fs.is_pinless_debit\"></span>\n                        <span class=\"pinlessGlyphIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"fs.is_pinless_debit\"></span>\n                         <span class=\"name\" ng-if=\"fs.type === 'BALANCE'\">\n                             {{ content('paymentMethod.venmoBalance') }}\n                         </span>\n                        <span class=\"name\" ng-if=\"fs.type !== 'BALANCE'\">\n                            <span class=\"fsname\" ng-if=\"!fs.is_pinless_debit\">\n                                {{fs.name}}\n                            </span>\n                            <span class=\"fslastdigits\" ng-if=\"!fs.is_pinless_debit\">\n                                {{fs.last4 ? 'x-' + fs.last4 : ''}}\n                            </span>\n                        </span>\n                    </div>\n                    <span ng-if=\"showAmt\" class=\"methodAmount\">\n                        <span class=\"amountFormatted\"><format-currency code=\"fs.amount.currency_code\" amount=\"fs.amount.amount\"></format-currency></span>\n                    </span>\n                    <span class=\"venmoUsername\">\n                        {{venmoUser}}\n                    </span>\n                </li>\n            </ul>\n\n            <div ng-if=\"backupFs\" class=\"backup\">\n                <p><span ng-if=\"intentNotSale\">{{content('paymentMethod.venmoMerchantDisclosure')}} </span>{{content('paymentMethod.venmoBackupFS', {name: backupFs.name, last4: backupFs.last4}) }}</p>\n            </div>\n\n            <div ng-if=\"!backupFs\" class=\"backup\">\n                <p><span ng-if=\"intentNotSale\">{{content('paymentMethod.venmoMerchantDisclosure')}} </span>{{content('paymentMethod.venmoBalanceInfo')}}</p>\n            </div>\n\n            <div class=\"lineBreak\"></div>\n\n            <div class=\"venmoReceipt\">\n                <p>{{content('paymentMethod.venmoReceipt')}}</p>\n            </div>\n\n            <div class=\"learnMore\">\n                <p bind-html-compile=\"htmlContent('paymentMethod.venmoLearnMore')\"></p>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/thirdParty-info/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.thirdPartyExperience = exports.venmoExperience = exports.thirdPartyInfo = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _sessionStorage = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/sessionStorage.js");

var _sessionStorage2 = _interopRequireDefault(_sessionStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// TODO: Check how the cookie should be read/set (through meta? if read on server side)
var PWV_COOKIE = 'pwv';

var readCookie = function readCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');

    for (var i = 0, len = ca.length; i < len; i++) {
        var c = ca[i];

        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
};

var thirdPartyInfo = exports.thirdPartyInfo = {
    /**
     * @name isThirdPartyEligible
     * @returns {Promise}
     */
    isThirdPartyEligible: function isThirdPartyEligible() {
        var _this = this;

        return this.isBaiduEligible().then(function (baiduEligibility) {
            return _this.isVenmoEligible() || baiduEligibility;
        });
    },


    /**
     * @name isBaiduEligible
     * @returns {Promise}
     */
    isBaiduEligible: function isBaiduEligible() {
        return _checkout.$FlowEligibilityModel.instance(_angular.$rootScope.token, {
            params: {
                geolocation: _squid.$meta.geolocation
            }
        }).retrieve().then(function (eligibility) {
            _logger.$logger.info('baidu_eligibility', eligibility);
            return eligibility.baiduWallet;
        });
    },


    /**
     * @name isVenmoEligible
     * @description Handler to call to determine if user can use Venmo
     * @returns {Boolean}
     */
    isVenmoEligible: function isVenmoEligible() {
        var appData = _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token);
        var cart = _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token);
        var merchantCountry = appData.get('merchant.merchant_country');
        var isProcessorDeclined = appData.get('flags.processor_declined');
        var isInvoice = appData.get('flags.is_invoice_flow');
        var isBillingAgreement = cart.isBilling();
        var isMobile = _index.$DeviceInfo.isDevice();
        var isVenmoCookie = this.isVenmoCookiePresent();
        var isSFAuthenticationSession = _squid.$util.param('bt_int_type') === '2';
        var isMSPTransaction = cart.isMultiSellerPurchase();
        var eligibilityParams = {
            isMobile: isMobile,
            isVenmoCookie: isVenmoCookie,
            isNotInvoice: !isInvoice,
            isNotProcessorDeclined: !isProcessorDeclined,
            isNotBillingAgreement: !isBillingAgreement,
            isUSMerchant: merchantCountry === 'US',
            isNotSFAuthenticationSession: !isSFAuthenticationSession,
            isNotMSPTransaction: !isMSPTransaction
        };

        var venmoEligibility = Object.keys(eligibilityParams).filter(function (param) {
            return !eligibilityParams[param];
        });
        venmoEligibility = venmoEligibility && venmoEligibility.length > 0 ? 'ineligible:' + venmoEligibility.join() : 'eligible';

        _logger.$logger.info('venmo_eligibility', venmoEligibility);

        _logger.$logger.info('checkout_fpti', {
            'is_venmo_cookie': isVenmoCookie ? '1' : '0',
            'eligibility_reason': venmoEligibility
        });

        return Boolean(venmoEligibility === 'eligible');
    },


    /**
     * @name isVenmoCookiePresent
     * @returns {Boolean}
     */
    isVenmoCookiePresent: function isVenmoCookiePresent() {
        var cookieValue = readCookie(PWV_COOKIE);

        return Boolean(cookieValue);
    },


    /**
     * @name buildVenmoURL
     * @description Build the venmo URL scheme
     * @returns {String}
     */
    buildVenmoURL: function buildVenmoURL() {
        // SCHEME needs to change according to old or new experience
        // const linkType = venmoUrlSchemeType();
        var SCHEME = _squid.$config.urls && _squid.$config.urls.venmoAppSwitchURL['universal'];
        var VENMO_ROUTE = '#/checkout/venmo';
        var LOGIN_ROUTE = '#/checkout/login?venmoError=true';
        var cartModel = _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token);
        var params = (0, _angular.$httpParamSerializer)({
            'x-success': _angular.$location.absUrl().replace(/#.*$/, VENMO_ROUTE),
            'x-failure': _angular.$location.absUrl().replace(/#.*$/, LOGIN_ROUTE),
            'ua': _angular.$window.navigator.userAgent,
            'merchant_id': _checkout.$CheckoutPayeeModel.instance(_angular.$rootScope.token).getId(),
            'token': _angular.$rootScope.token,
            'total': cartModel.purchase.amounts.total.amount,
            'currency': cartModel.purchase.amounts.total.currency_code,
            'intent': cartModel.payment_action
        });

        return SCHEME + '?' + params;
    }
};

var venmoExperienceKey = 'VENMO_EXPERIENCE';

// Get whether a token is marked as Venmo experience.
var venmoExperience = exports.venmoExperience = {
    set: function set(token) {
        var sessionStorage = (0, _sessionStorage2['default'])();

        sessionStorage.setItem(venmoExperienceKey, token);
    },
    get: function get(token) {
        var auth = _auth.$AuthModel.instance();
        var sessionStorage = (0, _sessionStorage2['default'])();

        if (auth.logged_in && auth.guest && // Check if Venmo guest account logged in
        sessionStorage.getItem(venmoExperienceKey) === token) {
            return true;
        } else {
            this.set(null);
            return false;
        }
    }
};

var allowedThirdPartyExperiences = {
    VENMO: 'VENMO_EXPERIENCE',
    BAIDU: 'BAIDU_EXPERIENCE'
};

var THIRD_PARTY_NAMESPSACE = 'THIRD_PARTY_EXPERIENCE';

var thirdPartyExperience = exports.thirdPartyExperience = {
    setAsVenmoExperience: function setAsVenmoExperience(token) {
        var _JSON$stringify;

        var sessionStorage = (0, _sessionStorage2['default'])();
        var payload = JSON.stringify((_JSON$stringify = {}, _JSON$stringify[token] = allowedThirdPartyExperiences['VENMO'], _JSON$stringify));

        sessionStorage.setItem(THIRD_PARTY_NAMESPSACE, payload);
    },
    setAsBaiduExperience: function setAsBaiduExperience(token) {
        var _JSON$stringify2;

        var sessionStorage = (0, _sessionStorage2['default'])();
        var payload = JSON.stringify((_JSON$stringify2 = {}, _JSON$stringify2[token] = allowedThirdPartyExperiences['BAIDU'], _JSON$stringify2));

        sessionStorage.setItem(THIRD_PARTY_NAMESPSACE, payload);
    },
    isThirdPartyExperience: function isThirdPartyExperience(token) {
        var availableExperiences = [];

        for (var key in allowedThirdPartyExperiences) {
            availableExperiences.push(allowedThirdPartyExperiences[key]);
        }

        var currentExperience = this.getExperience(token);

        return Boolean(availableExperiences.indexOf(currentExperience) > -1);
    },
    getExperience: function getExperience(token) {
        var auth = _auth.$AuthModel.instance();
        var sessionStorage = (0, _sessionStorage2['default'])();

        // if logged in, and guest, we return the experience if any
        if (auth.logged_in && auth.guest && sessionStorage.getItem(THIRD_PARTY_NAMESPSACE)) {
            var payload = JSON.parse(sessionStorage.getItem(THIRD_PARTY_NAMESPSACE) || '');

            return payload && payload[token] || 'MEMBER_EXPERIENCE';
        } else {
            // If not logged in, we reset the third party experience
            this.resetThirdPartyExperience();
            return 'MEMBER_EXPERIENCE';
        }
    },
    resetThirdPartyExperience: function resetThirdPartyExperience() {
        var sessionStorage = (0, _sessionStorage2['default'])();

        sessionStorage.removeItem(THIRD_PARTY_NAMESPSACE);
    }
};

_squid.$config;

_squid.$util;

_squid.$meta;

_logger.$logger;

_auth.$AuthModel;

_index.$DeviceInfo;

_angular.$rootScope;

_angular.$window;

_angular.$location;

_angular.$httpParamSerializer;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_checkout.$FlowEligibilityModel;

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/thirdParty-info/sessionStorage.js":
/***/ (function(module, exports) {



exports.__esModule = true;
exports['default'] = getSessionStorage;
var store = {};

// Polyfill for sessionStorage if not available. Simple variable store

function getSessionStorage() {
    try {

        window['sessionStorage'].setItem('__feature_test__', '0');
        window['sessionStorage'].removeItem('__feature_test__');
        return window.sessionStorage;
    } catch (err) {
        return {
            getItem: function getItem(key) {
                if (arguments < 1) {
                    throw new Error('1 argument required');
                }
                return store[key];
            },
            setItem: function setItem(key, val) {
                if (arguments < 2) {
                    throw new Error('2 arguments required');
                }
                store[key] = val;
            },
            removeItem: function removeItem(key) {

                delete store[key];
            }
        };
    }
}
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/venmo-billing/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _venmoModels = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-models/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

var _template = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-billing/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-third-party-components/src/venmo-billing/style.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$VenmoAddBilling', {
    tag: 'venmo-add-billing',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            optional: false
        },
        sidebar: {
            type: 'var',
            optional: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.token).retrieve()['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        enter: function enter() {
            this.country = _squid.$locale.getCountryCodeISO();
            this.billing = true;
            this.address = this.address || { country: this.country };
        },
        populate: function populate() {
            var $el = (0, _jquery2['default'])(this.$element);
            var handleValidation = function handleValidation(res) {
                if (res && res.fields && res.fields.length) {
                    res.fields.forEach(function (field) {
                        if (field.field) {
                            var $field = (0, _jquery2['default'])($el.find('[name="' + field.field + '"]'));

                            if ($field.length === 0 && field.field === 'zip') {
                                $field = (0, _jquery2['default'])($el.find('[ng-model="address.postal_code"], [ng-model="zipCode"]'));
                            }
                            $field.addClass('backendError');
                            $field.attr('aria-invalid', true);
                        }
                    });
                }

                $el.find('form').find('.backendError, .ng-invalid').first().focus();
            };

            this.done = function () {
                this.goto('checkout.review');
            };

            this.error = function () {
                this.goto('checkout.login', { venmoError: true });
            };

            this.onSubmit = function () {
                this.validateAddress();
            };

            this.validateAddress = function () {
                var self = this;
                var newBilling = new _index.$BillingAddressModel({
                    line1: this.address.line1,
                    line2: this.address.line2,
                    city: this.address.city,
                    state: this.address.state,
                    postal_code: this.address.postal_code,
                    country: this.country,
                    id: '0'
                });

                newBilling.save({
                    success: function success() {
                        if (self && self.models && self.models.checkoutSession && self.models.checkoutSession.plan && self.models.checkoutSession.plan.sources && self.models.checkoutSession.plan.sources['0'] && self.models.checkoutSession.plan.sources['0'].instrument_id) {
                            var instrumentID = self.models.checkoutSession.plan.sources['0'].instrument_id;

                            self.saveBillingAddressAndReturn(instrumentID);
                        } else {
                            self.error();
                        }
                    },
                    validation: function validation(res) {
                        handleValidation(res);
                    },
                    error: function error(err) {
                        _logger.$logger.error('venmoBillingAddressValidateError', err);
                        self.error();
                    }
                });
            };

            this.saveBillingAddressAndReturn = function (instrumentID) {
                var self = this;
                var add = {
                    newAddress: {
                        address1: this.address.line1,
                        address2: this.address.line2,
                        city: this.address.city,
                        state: this.address.state,
                        zip: this.address.postal_code,
                        isoCountry: this.country
                    }
                };
                var billingAddress = new _index.$AddBillingAddressModel({ instrumentid: instrumentID });

                billingAddress.save({
                    data: add,
                    success: function success() {
                        _logger.$logger.info(['venmo-billing directive', 'Billing Address', 'added'].join('::'));
                        // Fix: Need to have a better solution
                        _logger.$logger.info(['venmo-billing directive', 'Calling checkout session again'].join('::'));

                        var sessionModel = _checkout.$CheckoutSessionModel.instance(self.token);
                        var cartModel = _checkout.$CheckoutCartModel.instance(self.token);
                        var venmoOnboardModel = _venmoModels.$VenmoOnboardModel.instance(self.token);

                        sessionModel.action('create', {
                            data: {
                                fraudnet_id: cartModel.supplementary && cartModel.supplementary.risk_correlation_id,
                                baToken: cartModel.billing && cartModel.billing.ba_token,
                                user_selected_funding_source: {
                                    dcvv: venmoOnboardModel.dcvv,
                                    product_name: 'VENMO_US_PPMERCHANT_SINGLEUSETOKEN'
                                },
                                is_skip_gfo: true
                            },
                            success: function success() {
                                self.done();
                            }
                        });
                    },
                    validation: function validation(err) {
                        _logger.$logger.error('venmoBillingAddressValidationError', err);
                        self.error();
                    },
                    error: function error(err) {
                        _logger.$logger.error('venmoAddBillingAddressError', err);
                        self.error();
                    }
                });
            };
        }
    }
});


_angular.noop;

_squid.$Component;

_squid.$locale;

_logger.$logger;

_venmoModels.$VenmoOnboardModel;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutCartModel;

_index.$BillingAddressModel;

_index.$AddBillingAddressModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/venmo-billing/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-billing/directive.js");

var _directive2 = _interopRequireDefault(_directive);

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Route.extend('$VenmoAddBillingRoute', {
    path: 'addBilling',
    directive: _directive2['default'],
    titleContent: 'addBillingAddress.title',

    trackingData: {
        fptiState: 'edit_billing'
    },
    loginRequired: true
});


_squid.$Route;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/venmo-billing/style.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/venmo-billing/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"addBillingAddress\" ng-if=\"billing\" modal-box=\"address\">\n\n\n    <h1 class=\"gamma addBillingTitle\" ng-if=\"!sidebar && !debitCardFlow\">{{ content('addBillingAddress.title') }}</h1>\n\n    <form id=\"billingAddressForm\" name=\"billingAddressForm\" class=\"asideView addressForm\" content form-autofocus novalidate>\n        <div class=\"trayInner container\">\n            <div class=\"clearfix\">\n                <xo-add-address country=\"country\" address=\"address\" token=\"token\"></xo-add-address>\n            </div>\n\n            <div class=\"buttons clearfix\">\n                <input track-submit  type=\"submit\" id=\"proceedButton-venmoBA\" value=\"{{ content('common.save') }}\" class=\"btn\" ng-class=\"{full:sidebar}\" validate-submit=\"onSubmit()\" />\n            </div>\n        </div>\n    </form>\n</div>\n<div ui-view></div>\n"

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/venmo-models/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$VenmoOnboardModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $VenmoOnboardModel = exports.$VenmoOnboardModel = _squid.$Model.extend('$VenmoOnboardModel', {
    api: new _squid.$Api({
        uri: '/api/venmo/onboard'
    })
});

angular.value("$VenmoOnboardModel", $VenmoOnboardModel);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-title/dist/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _template = __webpack_require__("../node_modules/xo-title/dist/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().directive('xoTitle', [function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            titleTxt: '@?',
            className: '@?',
            tagName: '@?'
        },
        link: function link($scope, $element) {
            if ($scope.tagName) {
                var newEl = document.createElement($scope.tagName || 'h1');

                newEl.className = $scope.className || 'alpha';
                newEl.textContent = '{{ titleTxt }}';
                (0, _angular.$compile)(newEl)($scope);
                $element.empty().append(newEl);
            }
        }
    };
}]);

/***/ }),

/***/ "../node_modules/xo-title/dist/template.html":
/***/ (function(module, exports) {

module.exports = "<h1 class=\"alpha\">\n    {{ titleTxt }}\n</h1>\n"

/***/ }),

/***/ "../node_modules/xo-tracking/dist/builder.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$FptiBuilder', function () {
    /**
     *  Build the front-end FPTI event from three data sources
     *      1. the per-product configuration
     *      2. the buzname defined per-route
     *      3. the additional attributes that only available at a specific checkpoint
     *
     */

    return _squid.$Class.extend('FptiBuilder', {

        resolvePageQualifier: function resolvePageQualifier(trackingData) {
            // The pages can populated pageQualifier to override the default one
            this.pageQualifier = trackingData && trackingData.pageQualifier ? trackingData.pageQualifier
            // because 'fullpage' has been widely embedded into routes
            // we had better to keep it as a place holder
            : 'fullpage'; // update later if it's in-context
        },

        build: function build() {

            if (!this.trackingData && !this.error) {
                // do nothing if neither page nor error tracking
                return this;
            }

            this.resolvePageQualifier(this.trackingData);

            this._dataObj = new _model.$FptiDataModel().decorate('base', this.baseData).decorate('buzname', this.trackingData, this.pageQualifier, undefined, this.productOverride).decorate('templateName', this.trackingData, this.pageQualifier).decorate('pageGoal', this.trackingData.pageGoal).decorate('ecToken', this.trackingData.token).decorate('correlationId', (0, _squid.$getLatestCorrelationID)()).decorate('uuid', _model.$CalDataModel.getUUID()).decorate('fieldError', this.error).decorate('pageError', this.error).decorate('pageStartTime', new Date().getTime()).decorate('pxptrackingdata', this.trackingData.pxpData).decorate('transition_time', this.transition_time).decorate('cust', this.cust).decorate('dc', this.dc).decorate('az', this.az).decorate('comp', this.comp).getDataObject(this.isInContext);

            return this;
        },

        toString: function toString() {
            var dataAry = [];

            _angular2['default'].forEach(this._dataObj, function (v, k) {
                dataAry.push(k + '=' + v);
            });

            return dataAry.join('&');
        }
    });
});

_squid.$getLatestCorrelationID;

_squid.$Class;

_model.$FptiDataModel;

_model.$CalDataModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-tracking/dist", "../node_modules/xo-tracking/dist/builder.js"))

/***/ }),

/***/ "../node_modules/xo-tracking/dist/button.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$ButtonTrackingService', function () {
    var _beaconUrl = 'https://www.paypalobjects.com/en_US/i/scr/btn_tracking_pixel.gif?teal=null&Id=null&ru=null';
    var _beaconParams = ['fltk', 'calc', 'page', 'xe', 'xt'];
    var _alreadyFired = false;

    function _strToElements(str) {
        var elements = {};

        if (str && str.length) {
            str.split('&').forEach(function (param) {
                var nvp = param.split('=');

                elements[nvp[0]] = nvp[1];
            });
        }
        return elements;
    }

    function _fireButtonTrackingBeacon(elements) {
        var url = _beaconUrl;
        var xoData = {};

        function buildParam(param, value) {
            var p = '&' + param + '=' + (value ? value : 'null');

            return p;
        }

        function getGUIID(ts) {
            return _strToElements(ts).vr;
        }

        function addToDocument(uri) {
            var img = document.createElement('img');

            img.setAttribute('src', uri);
            document.body.appendChild(img);
        }

        // Get some params from FPTI data.
        _beaconParams.forEach(function (param) {
            url += buildParam(param, elements[param]);
        });

        // Build the rest of the params.
        url += buildParam('fpti', getGUIID(_squid.$cookies && _squid.$cookies.ts));
        url += buildParam('WWW_AKA_MVT_BUTTONS', _squid.$cookies && _squid.$cookies.WWW_AKA_MVT_BUTTONS);
        url += buildParam('WWW_AKA_MVT_ID', _squid.$cookies && _squid.$cookies.WWW_AKA_MVT_ID);
        url += buildParam('ip', _squid.$meta && _squid.$meta.ipaddress);

        if (_angular.$rootScope.token) {
            (0, _squid.$populate)(xoData, {
                payee: _index.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
                appData: _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token)
            }).then(function () {
                url += buildParam('mrid', xoData.payee && xoData.payee.getId());
                url += buildParam('calf', xoData.appData && xoData.appData.flow_id);
                addToDocument(url);
            });
        } else {
            url += buildParam('mrid', null);
            url += buildParam('calf', null);
            addToDocument(url);
        }
    }

    return {
        fireBeacon: function fireBeacon(fptiData) {
            if (!_alreadyFired && fptiData) {
                var elements = _strToElements(fptiData);

                // Fire the beacon if this is a page render.
                if (elements.page) {
                    _alreadyFired = true;
                    return _fireButtonTrackingBeacon(elements);
                }
            }
        },
        resetAlreadyFired: function resetAlreadyFired() {
            _alreadyFired = false;
        }
    };
});

_angular.$rootScope;

_squid.$meta;

_squid.$cookies;

_squid.$populate;

_index.$CheckoutAppDataModel;

_index.$CheckoutPayeeModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-tracking/dist", "../node_modules/xo-tracking/dist/button.js"))

/***/ }),

/***/ "../node_modules/xo-tracking/dist/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module('tracking.directive', ['ui.router']).directive('trackSubmit', function () {
    return {
        restrict: 'AE',
        link: function link($scope, element, attr) {
            element.on('mousedown', function (event) {
                var transition = attr && attr.trackSubmit;
                var trackSubmit = {
                    currentRoute: _uiRouter.$state.current,
                    transition: transition,
                    errors: []
                };

                _angular2['default'].forEach($('input.ng-invalid, select.ng-invalid'), function (el) {
                    var elem = $(el);
                    var elementId = elem.attr('id');
                    var elementName = elem.attr('name');
                    var errorKey = elem.attr('data-error-key');
                    var errorText = elem.has('required') ? 'required' : 'no error key';
                    var fieldName = elementId ? elementId : elementName;

                    if (!fieldName) {
                        var elementModel = elem.attr('ng-model');

                        fieldName = elementModel ? elementModel : 'unnamed-field';
                    }

                    trackSubmit.errors.push({
                        fieldName: fieldName,
                        errorMessage: errorKey ? errorKey : errorText
                    });
                });

                _angular.$rootScope.$broadcast('trackSubmit', trackSubmit);
            });
        }
    };
}).directive('trackLink', function () {
    return {
        restrict: 'AE',
        link: function link($scope, element, attr) {
            element.on('mousedown', function (event) {
                var state = attr && attr.trackLink;

                if (state) {
                    var trackLink = {
                        currentRoute: _uiRouter.$state.current,
                        transition: state
                    };

                    _angular.$rootScope.$broadcast('trackLink', trackLink);
                }
            });
        }
    };
}).directive('trackClick', function () {
    return {
        restrict: 'AE',
        link: function link($scope, element, attr) {
            element.on('click', function (event) {
                var state = attr && attr.trackClick;

                if (state) {
                    var trackClick = {
                        currentRoute: _uiRouter.$state.current,
                        transition: state
                    };
                    _angular.$rootScope.$broadcast('trackClick', trackClick);
                }
            });
        }
    };
}).directive('trackInput', function () {
    /*
    * Track an input tag with track-input attribute
    * you can use the value of track-input attribute as
    * a tracking attr Eg.: track-input="xo_guest_yes"
    */
    return {
        restrict: 'AE',
        link: function link($scope, element, attr) {
            element.on('click', function (event) {
                var state = void 0;

                if (event.target.type === 'checkbox') {
                    if (event.target.checked) {
                        state = attr && attr.trackInput + '_CHECKED';
                    } else {
                        state = attr && attr.trackInput + '_UNCHECKED';
                    }
                } else {
                    state = attr && attr.trackInput;
                }

                var trackInput = {
                    currentRoute: _uiRouter.$state.current,
                    page: 'main:ec:hermes::fullpage-billing:guest:aries:'
                };

                if (state) {
                    trackInput.transition = state;
                }

                _angular.$rootScope.$broadcast('trackInput', trackInput);
            });
        }
    };
});

_uiRouter.$state;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-tracking/dist/fpti.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _builder = __webpack_require__("../node_modules/xo-tracking/dist/builder.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$fpti', function () {
    var _beaconUrl = void 0;

    // Logic to switch between production/staging urls. This way we don't pollute live logs,
    // and we are able to test on stage using the fpti log viewing tool.
    if (_squid.$config.deploy.isLocal() || _squid.$config.deploy.isStage()) {
        _beaconUrl = 'https://tracking.qa.paypal.com/webapps/tracking/ts'; // stage url
    } else {
        _beaconUrl = _squid.$config.urls && _squid.$config.urls.fptiBeaconUrl;
    }

    return {
        // Get all the tracking data defined at the page level
        getPageTrackingData: function getPageTrackingData(route) {
            route = route || {};

            var trackingData = route.trackingData || {};
            var routeParent = route.parent;

            trackingData.token = _angular.$rootScope.token;

            while (routeParent) {
                trackingData = _angular2['default'].merge({}, routeParent.trackingData || {}, trackingData);
                routeParent = routeParent.parent;
            }
            return trackingData;
        },

        setupDataString: function setupDataString(route, err, data) {
            var trackingData = this.getPageTrackingData(route);
            var PAYPAL = window && window.PAYPAL;

            var fptiData = void 0;

            if (PAYPAL && typeof PAYPAL.analytics !== 'undefined') {
                PAYPAL.core = PAYPAL.core || {};

                var payload = {
                    baseData: window.meta.fpti,
                    trackingData: trackingData,
                    error: err,
                    isInContext: _angular.$rootScope.miniBrowser
                };

                _angular2['default'].extend(payload, data || {});
                fptiData = new _builder.$FptiBuilder(payload).build().toString();

                // FPTI client side tracking only if we have template
                if (route && route.template && _angular2['default'].isFunction(PAYPAL.analytics.setup)) {
                    PAYPAL.core.pta = PAYPAL.analytics.setup({
                        data: fptiData,
                        url: _beaconUrl
                    });
                }
            }
            return fptiData;
        }
    };
}).factory('$fptiError', function () {
    function stringifyErrorMessage(msg) {
        return encodeURIComponent(_angular2['default'].isString(msg) ? msg.split('\n').slice(0, 2).join('@') // Get the first two lines of stack
        : (_angular2['default'].toJson(msg) || 'undefined').substring(0, 128));
    }

    return _squid.$Error.extend({
        construct: function construct(err) {
            if (!err) {
                return;
            }
            this.type = err.type;
            this.field = err.field;
            this.msg = stringifyErrorMessage(err.message || err.error);
            this.code = err.code || err.cause;
        }
    });
});

_squid.$config;

_squid.$Error;

_builder.$FptiBuilder;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-tracking/dist", "../node_modules/xo-tracking/dist/fpti.js"))

/***/ }),

/***/ "../node_modules/xo-tracking/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * xo-tracking encapsulates all the details about instrumentation
 * and only register event listeners during bootstrap
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/xo-tracking/dist/listener.js"), __webpack_require__("../node_modules/xo-tracking/dist/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular) {

    // Declare the dependency to register the listeners
    return angular.module('tracking', ['tracking.listener', 'tracking.directive']);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-tracking/dist/listener.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, console) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _index = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

var _builder = __webpack_require__("../node_modules/xo-tracking/dist/builder.js");

var _button = __webpack_require__("../node_modules/xo-tracking/dist/button.js");

var _fpti = __webpack_require__("../node_modules/xo-tracking/dist/fpti.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().run(function () {
    // eslint-disable-line max-statements
    var token = window.meta.token;
    // logAppName is the appname from meta.js. if the logAppName is not defined, default it to 'appNameNotDefined'.
    var appName = _squid.$meta.logAppName || 'appNameNotDefined';
    var addTrackingData = function addTrackingData(object) {
        return _squid.$util.extend(object, {
            dc: _squid.$meta.dc,
            az: _squid.$meta.az,
            cust: _index.$AuthModel.instance().buyer_id || '',
            comp: appName
        });
    };
    var cplSettings = _squid.$config.enableCPL;
    var passesCplThrottle = cplSettings && (typeof cplSettings.throttle === 'undefined' || (0, _squid.$experiment)('cpl_tracking', cplSettings.throttle, token));
    var cplEnabled = passesCplThrottle || _squid.$util.params().forceEnableCPL;

    function logTransition(state) {
        return !(state.trackingData && state.trackingData.suppressTransitionLog);
    }

    function logStateExit(state) {
        return state.trackingData && state.trackingData.trackStateExit;
    }

    function getBeaconUrl() {
        // Logic to switch between production/staging urls. This way we don't pollute live logs,
        // and we are able to test on stage using the fpti log viewing tool.
        return _squid.$config.deploy.isLocal() || _squid.$config.deploy.isStage() ? 'https://tracking.qa.paypal.com/webapps/tracking/ts' // stage url
        : _squid.$config.urls && _squid.$config.urls.fptiBeaconUrl;
    }

    /*
    * Triggers pa.js recordClick with custom parameters
    */
    function fptiCustomRecordClick(route, customData) {
        var analyticsInstance, fptiData, fptiDataObj;
        var PAYPAL = window.PAYPAL;

        if (PAYPAL && typeof PAYPAL.analytics !== 'undefined') {
            PAYPAL.core = PAYPAL.core || {};

            analyticsInstance = new PAYPAL.analytics.Analytics();

            fptiData = new _builder.$FptiBuilder({
                trackingData: route.trackingData,
                isInContext: _angular.$rootScope.miniBrowser,
                comp: appName
                // ... Other flow data pass-in here to resolve page qualifier
            }).build();

            // Grab the fpti data object and extend with custom params
            // The fpti data obj should include pxp params as well
            fptiDataObj = fptiData._dataObj;
            $.extend(fptiDataObj, customData);

            analyticsInstance.setRequestData(fptiDataObj);
            analyticsInstance.recordClick({
                url: getBeaconUrl()
            });
        }
    }

    _angular.$rootScope.$on('trackInput', function (event, trackInput) {
        if (!trackInput) {
            return;
        }
        var customData = {
            link: trackInput && trackInput.transition,
            page: trackInput && trackInput.page
        };

        fptiCustomRecordClick(trackInput.currentRoute, customData);
    });

    _angular.$rootScope.$on('trackClick', function (event, trackClick) {
        if (!trackClick) {
            return;
        }
        var customData = {
            link: trackClick && trackClick.transition
        };

        fptiCustomRecordClick(trackClick.currentRoute, customData);
    });

    _angular.$rootScope.$on('trackSubmit', function (event, trackSubmit) {
        if (!trackSubmit) {
            return;
        }
        var currentRoute = trackSubmit && trackSubmit.currentRoute;
        var routeName = currentRoute ? currentRoute.name : 'noRoute';

        _logger.$logger.info('track_submit', {
            route_name: routeName
            // ID stuff here later
        });

        if (logTransition(currentRoute)) {
            routeName = routeName.replace(/\./g, '_');
            var state = currentRoute.trackingData && currentRoute.trackingData.fptiState || routeName;
            var transition = trackSubmit.transition || state;

            _logger.$logger.info(routeName + '_exit', {
                fptiState: state,
                fptiTransition: transition
            });
        }

        if (trackSubmit.errors && trackSubmit.errors.length) {
            var fptiFieldErrors = JSON.stringify(trackSubmit.errors);

            _logger.$logger.info('checkout_fpti', {
                form_field_errors: fptiFieldErrors
            });
        }

        var errors = trackSubmit.errors;

        if (_angular2['default'].isArray(errors)) {
            errors.forEach(function (err) {
                _logger.$logger.debug('track_submit_error', err);
                if (_fpti.$fpti) {
                    _fpti.$fpti.setupDataString(currentRoute, new _fpti.$fptiError({
                        type: 'fieldError',
                        field: err.fieldName,
                        code: err.errorMessage
                    }));
                }
            });

            if (errors.length) {
                _logger.$logger.flush(true);
            }
        }
    });

    _angular.$rootScope.$on('unhandled_error', function (event, exception) {
        if (_fpti.$fpti) {
            _fpti.$fpti.setupDataString(exception.currentRoute, new _fpti.$fptiError({
                type: 'pageError',
                message: exception.message,
                code: exception.cause
            }));
        }
    });

    _angular.$rootScope.$on('trackLink', function (event, trackLink) {
        if (!trackLink) {
            return;
        }

        var currentRoute = trackLink.currentRoute;
        var routeName = (currentRoute ? currentRoute.name : 'noRoute').replace(/\./g, '_');
        var state = currentRoute.trackingData && currentRoute.trackingData.fptiState || routeName;

        _logger.$logger.info(routeName + '_exit', {
            fptiState: state,
            fptiTransition: trackLink.transition
        });
    });

    _angular.$rootScope.$on('$transition', function (event, data) {
        (0, _angular.$timeout)(function () {
            if (_fpti.$fpti) {
                var fptiData = _fpti.$fpti.setupDataString(data.toState, null, addTrackingData({
                    transition_time: data.duration
                }));

                // This seems to conflict with CPL data, so don't fire if CPL
                if (!cplEnabled) {
                    // Fire and forget button tracking beacon.
                    _button.$ButtonTrackingService.fireBeacon(fptiData);
                }
            }
        });
    });

    _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
        var from = fromState && fromState.name.replace(/\./g, '_');
        var to = toState && toState.name.replace(/\./g, '_');

        if (from && logTransition(fromState) && logStateExit(fromState)) {
            var trackingData = fromState.trackingData && fromState.trackingData || {};

            _logger.$logger.info(from + '_exit', { fptiState: trackingData.fptiState || from, fptiTransition: trackingData.fptiState || from });
        }

        _logger.$logger.info('state_change', {
            from: from || 'start',
            to: to || 'end'
        });

        // Generate a new CAL correlation_id to be shared until next flow transition (only for view states)
        if (toState.template) {
            _model.$CalDataModel.generateMetaIds();
        }

        _angular.$rootScope.currentState = to;

        if (to && logTransition(toState)) {
            _logger.$logger.info(to + '_enter', { fptiState: toState.trackingData && toState.trackingData.fptiState || to });
        }
    });

    _angular.$rootScope.$on('page_loaded', function (event, from, to) {
        if (from !== 'checkout_init') {
            return;
        }
        var key = _model.$FptiConstants.stateName[to] || 'review';
        var landing_page = _model.$FptiConstants.landing_page[key];

        _logger.$logger.info('landing_page', {
            'from': landing_page,
            'to': 'process_page_loaded',
            fpti_landing_page: landing_page
        });
    });

    _angular.$rootScope.$on('page_reloaded', function () {
        _logger.$logger.flush(true);
        _model.$CalDataModel.generateMetaIds();
    });

    _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState) {
        var to = toState.name.replace(/\./g, '_');

        if (toState.hasResolver && to) {
            _logger.$logger.info(to + '_load');
        } else if (to) {
            _logger.$logger.info(to + '_rendering');
        }
    });

    _angular.$rootScope.$on('addrDiff', function (event, addrDiff) {
        if (!addrDiff) {
            return;
        }
        _logger.$logger.info('checkout_fpti' + addrDiff);
    });

    function getHash(url) {
        if (!url || !~url.indexOf('#')) {
            // eslint-disable-line no-bitwise
            return;
        }

        url = url.split('#');
        return url[url.length - 1];
    }

    var oldHash = window.location.hash;

    window.addEventListener('hashchange', function (event) {
        _logger.$logger.info('hashchange', {
            from: getHash(event.oldURL || oldHash),
            to: getHash(event.newURL || window.location.hash)
        });
        oldHash = window.location.hash;
    });

    $(document).on('click', function (event) {
        if (event && event.target && event.target.tagName) {
            var name = event.target.tagName.toLowerCase();

            if (event.target.id) {
                name += '#' + event.target.id;
            } else if (event.target.attributes && event.target.attributes['ng-model']) {
                name += ':' + event.target.attributes['ng-model'].value;
            } else if (event.target.className) {
                name += '.' + event.target.className.split(' ').join('.');
            }

            _logger.$logger.info('click', { el: name });
        }
    });

    if (cplEnabled) {
        window.fptiserverurl = getBeaconUrl();

        var firstInvocation = true;
        var trackPageStart = function trackPageStart() {
            if (firstInvocation) {
                firstInvocation = false;
                return;
            }
            try {
                window.PAYPAL.analytics.startCPLTracking();
            } catch (e) {
                console.log('error starting cpl tracking ' + e);
            }
        };

        var firstDone = true;
        var trackDone = function trackDone(beaconData) {
            window.PAYPAL.analytics.endCPLTracking({
                pageData: addTrackingData(beaconData),
                inferStart: firstDone
            });
            firstDone = false;
        };

        var currentRoute = null;

        _angular.$rootScope.$on('startLoad', function () {
            return trackPageStart();
        });
        _angular.$rootScope.$on('$stateChangeSuccess', function (e, route) {
            currentRoute = route;
        });

        _angular.$rootScope.$on('allLoaded', function () {
            try {
                var buildParams = {
                    productOverride: window.fptiProductOverride,
                    trackingData: _fpti.$fpti.getPageTrackingData(currentRoute)
                };
                var legacyFptiData = new _builder.$FptiBuilder(buildParams).build()._dataObj;
                var product = window.fptiProductOverride || 'ec';

                legacyFptiData.pgrp = 'main:' + product + ':hermes';
                legacyFptiData.flid = token;
                trackDone(legacyFptiData);
            } catch (e) {
                console.log('error tracking CPL data ' + e);
            }
        });
    }
});

_index.$AuthModel;

_squid.$util;

_squid.$meta;

_squid.$config;

_squid.$experiment;

_logger.$logger;

_model.$CalDataModel;

_model.$FptiConstants;

_builder.$FptiBuilder;

_button.$ButtonTrackingService;

_fpti.$fpti;

_fpti.$fptiError;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/xo-tracking/dist/model.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uuid = __webpack_require__("../node_modules/node-uuid/uuid.js");

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular); /* eslint-disable angular/di */


_angular2['default'].module().constant('$FptiConstants', {
    // The prototype of buzname data object
    buznameMap: {
        flowgatename: {
            placeHolder: '',
            fptiKey: 'fltp'
        },
        'flowname': {
            placeHolder: 'ec:hermes:',
            fptiKey: 'flnm'
        },
        'hier1': {
            placeHolder: 'main_ec_hermes_',
            fptiKey: 'shir'
        },
        'inout': {
            placeHolder: 'inout',
            fptiKey: 'lgin'
        },
        'pagename': {
            placeHolder: 'main:ec:hermes',
            fptiKey: 'pgrp'
        },
        'pagename2': {
            placeHolder: 'main:ec:hermes',
            fptiKey: 'page'
        },
        'version': {
            placeHolder: 'hermes',
            fptiKey: 'vers'
        }
    },
    // Full list of FPTI keys indexed by readable names
    // This mapping can also be served as default decorator
    fptiKeys: {
        'businessType': 'bztp',
        'correlationId': 'calc', // CalDataModel
        'cust': 'cust',
        'errorCode': 'eccd',
        'fieldError': 'erfd',
        'flowgatename': 'fltp', // buzname
        'flowname': 'flnm', // buzname
        'loggedIn': 'lgin', // buzname
        'merchantId': 'mrid',
        'merchantType': 'mbtp',
        'pageError': 'erpg',
        'pageGoal': 'goal', // route
        'pageGroup': 'pgrp', // buzname
        'pageName': 'page', // buzname
        'pageQualifer': 'qual', // buzname
        'pageStartTime': 'pgst', // FptiBuilder
        'pageTechnologyFlag': 'pgtf', // productConfig
        'paymentFlowId': 'pfid',
        'rLogId': 'teal',
        'sessionId': 'fpti',
        'siteHierarchy': 'shir', // buzname
        'sourceCi': 's', // productConfig
        'tealeaf': 'teal',
        'templateName': 'tmpl', // route
        'transition_time': 'transition_time',
        'uuid': 'csci', // CalDataModel
        'version': 'vers', // buzname
        'visitorId': 'vid',
        'ecToken': 'fltk', // metadata
        'pxpExpSelected': 'xe',
        'pxpTreatementSelected': 'xt',
        'pxpQualifiedTreatment': 'qt',
        'pxpContextId': 'qc',
        'dc': 'dc',
        'az': 'az',
        'comp': 'comp'
    },
    landing_page: {
        login: 'LOGIN',
        econsent: 'eConsent',
        review: 'Review',
        error_page: 'error_page',
        add_card: 'add_card',
        add_bank: 'add_bank',
        billing: 'billing',
        done_page: 'done_page',
        shoppingCart: 'shoppingCart',
        emptyCart: 'emptyCart',
        soldout: 'soldout',
        openButton: 'openButton'
    },
    stateName: {
        checkout_login: 'login',
        checkout_genericError: 'error_page',
        checkout_fastlogin: 'login',
        checkout_econsent: 'econsent',
        checkout_review: 'review',
        checkout_pageAddCard_addCardFlow_addCard: 'add_card',
        checkout_updateCard_addCardFlow_addCard: 'add_card',
        checkout_pageAddFi_bank_add: 'add_bank',
        guest: 'billing',
        checkout_done: 'done_page',
        checkout_guest: 'billing',
        checkout_signup: 'billing',
        guestupgrade_genericError: 'error_page',
        checkout_multistepsignup_multistepsignupaddcard: 'billing',
        checkout_shoppingCart: 'shoppingCart',
        checkout_emptyCart: 'emptyCart',
        checkout_soldout: 'soldout',
        checkout_openButton: 'openButton'
    }
}).factory('$FptiDataModel', ['$FptiConstants', function ($FptiConstants) {
    var productConfig = {};

    // TODO to read from config.json
    productConfig[$FptiConstants.fptiKeys.sourceCi] = 'ci';
    productConfig[$FptiConstants.fptiKeys.pageTechnologyFlag] = 'NodeJS';

    /**
     * Utilizing Decorator pattern to allow defining additional logic for specific keys
     */
    return _squid.$Class.extend('FptiDataModel', {
        init: function init() {
            this._dataObj = _angular2['default'].extend({}, productConfig);
            this._decoratorList = [];
        },
        decorators: {
            buzname: function buzname(trackingData, pageQualifier, isInContext, productOverride) {
                if (!trackingData) {
                    return;
                }

                var buzname = trackingData.buzname;

                if (!buzname) {
                    return;
                }

                var buznameDiff = buzname[pageQualifier];

                if (!buznameDiff) {
                    return;
                }

                var dataObj = this._dataObj;
                var buznameMap = $FptiConstants.buznameMap;
                // read app specific place holder from config
                var placeHolderConfig = _squid.$config && _squid.$config.fpti && _squid.$config.fpti.buznameEntryPlaceHolder;

                Object.keys(buznameMap).forEach(function (key) {
                    var buznameEntry = buznameMap[key];
                    var fptiKey = buznameEntry.fptiKey;
                    var placeHolder = buznameEntry.placeHolder;

                    if (buznameDiff[key]) {
                        if (placeHolderConfig && placeHolderConfig[key]) {
                            placeHolder = placeHolderConfig[key];
                        }

                        if (productOverride) {
                            var _placeHolder$split = placeHolder.split(':'),
                                main = _placeHolder$split[0],
                                hermes = _placeHolder$split[2];

                            placeHolder = main + ':' + productOverride + ':' + hermes;
                        }

                        dataObj[fptiKey] = buznameDiff[key].replace('%', placeHolder);
                    } else {
                        dataObj[fptiKey] = placeHolder;
                    }
                });
                dataObj[$FptiConstants.fptiKeys.pageQualifer] = pageQualifier;
            },

            base: function base(_base) {
                if (_base) {
                    for (var key in _base) {
                        if (!this._dataObj[key]) {
                            this._dataObj[key] = _base[key];
                        }
                    }
                }
            },

            locale: function locale(_locale) {
                if (_locale && _locale.country) {
                    this._dataObj[$FptiConstants.fptiKeys.locale] = _locale.country;
                }
            },

            pxptrackingdata: function pxptrackingdata(pxpData) {
                var qt = [];
                var qc = [];
                var xe = [];
                var xt = [];

                _squid.$util.some(pxpData, function (trackInfo) {
                    var match = trackInfo && trackInfo.tracking_tags && trackInfo.tracking_tags.match('\\bqt=([^;]+);');

                    if (match) {
                        qt.push(match[1]);
                    }

                    match = trackInfo && trackInfo.tracking_tags && trackInfo.tracking_tags.match('\\bqc=([^;]+);');
                    if (match) {
                        qc.push(match[1]);
                    }

                    _squid.$util.some(trackInfo.treatments, function (treatment) {
                        xe.push(treatment.experiment_id);
                        xt.push(treatment.treatment_id);
                    });
                });

                this._dataObj[$FptiConstants.fptiKeys.pxpQualifiedTreatment] = qt.join(',');
                this._dataObj[$FptiConstants.fptiKeys.pxpContextId] = qc.join(',');
                this._dataObj[$FptiConstants.fptiKeys.pxpExpSelected] = xe.join(',');
                this._dataObj[$FptiConstants.fptiKeys.pxpTreatementSelected] = xt.join(',');
            },

            templateName: function templateName(trackingData, pageQualifier, isInContext) {
                if (trackingData && trackingData.templateName) {
                    var templateName = (trackingData.templateName || '') + (pageQualifier ? ':' + pageQualifier : '');

                    this._dataObj[$FptiConstants.fptiKeys.templateName] = templateName;
                }
            },

            fieldError: function fieldError(err) {
                if (err && err.type === 'fieldError') {
                    this._dataObj[$FptiConstants.fptiKeys.fieldError] = err.field;
                    this._dataObj[$FptiConstants.fptiKeys.errorCode] = err.code;
                }
            },

            pageError: function pageError(err) {
                if (err && err.type === 'pageError') {

                    this._dataObj[$FptiConstants.fptiKeys.pageError] = err.msg;
                    this._dataObj[$FptiConstants.fptiKeys.errorCode] = err.code;
                }
            }

        },
        decorate: function decorate(name) {
            this._decoratorList.push({
                name: name,
                params: Array.prototype.slice.call(arguments, 1)
            });
            return this;
        },
        getDataObject: function getDataObject(isInContext) {
            var i;
            var decorator;

            for (i = 0; i < this._decoratorList.length; i++) {
                decorator = this._decoratorList[i];
                if (!decorator) {
                    continue;
                }
                var name = decorator.name;
                var params = decorator.params;

                if (_angular2['default'].isFunction(this.decorators[name])) {
                    // Invoke the decorator and pass in the parameter list
                    this.decorators[name].apply(this, params);
                } else {
                    var fptiKey = $FptiConstants.fptiKeys[name];

                    // If the fptiKey is defined and value is present, add the k-v pair
                    if (fptiKey && params && params.length > 0) {
                        this._dataObj[fptiKey] = params[0];
                    }
                }
            }

            // 'fullpage' was widely used as default key in page routs definition
            // finally replace it here if it's incontext
            var dataObj = this._dataObj;

            if (isInContext) {
                Object.keys(dataObj).forEach(function (k) {
                    if (_angular2['default'].isString(dataObj[k])) {
                        // some values can be number
                        dataObj[k] = dataObj[k].replace('fullpage', 'incontext');
                    }
                });
            }

            return this._dataObj;
        }
    });
}]).factory('$CalDataModel', function () {
    var uuid_v4_mask = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    var uuid_v1_mask = 'XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX';

    function _generateCorrelationId() {
        var uidRandomArr = (_uuid2['default'].v4() || uuid_v4_mask).split('-');
        var uidTime = (_uuid2['default'].v1() || uuid_v1_mask).split('-');

        return uidTime[0] + uidRandomArr[0].substr(0, 5);
    }

    function _generateUUID() {
        return (_uuid2['default'].v4() || uuid_v4_mask).replace(/-/g, '');
    }

    var CalModel = _squid.$Model.extend({
        _calCorrId: _generateCorrelationId(),
        _uuid: _generateUUID(),

        generateCalCorrId: function generateCalCorrId() {
            this._calCorrId = _generateCorrelationId();
        },
        generateUUID: function generateUUID() {
            this._uuid = _generateUUID();
        },
        generateMetaIds: function generateMetaIds() {
            this.generateCalCorrId();
            this.generateUUID();
        },

        getCalCorrId: function getCalCorrId() {
            return this._calCorrId;
        },

        getUUID: function getUUID() {
            return this._uuid;
        }
    });

    return new CalModel();
});

_squid.$Model;

_squid.$Class;

_squid.$util;

_squid.$config;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-tracking/dist", "../node_modules/xo-tracking/dist/model.js"))

/***/ }),

/***/ "../node_modules/xo-tray-height/dist/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

/** Name:  Tray height helper */
angular.module().directive('xoTrayHeight', function () {
    return {
        restrict: 'A',
        link: function link($scope, element, attrs) {
            // Check to see if we can use the safer full height approach
            // or if we need to fallback to calculating the height using
            // math and relying on the "right" timing.
            var topClass = 'xo-sidebar-wrapper';
            var topSelector = '.' + topClass;
            var topElem = document.querySelector(topSelector);
            var inScope = topElem && topElem.querySelector('[xo-tray-height]');
            var useNewFlow = topElem && inScope;

            /**
             * NOTE:
             * The following code, despite being the "new" flow, is still
             * a stopgap solution until such time as the markup and or
             * CSS undergo an overhaul. It relies on the more stable
             * cascading relative/absolute positioning and 100% height
             * *and* the fact that the code is an instance of xo-tray-height
             * within the xo-sidebar-wrapper.
             */
            function calculate() {
                var curElem = element[0];

                while (!~curElem.className.indexOf(topClass)) {
                    var style = getComputedStyle(curElem, null);

                    if (style.position !== 'absolute') {
                        curElem.style.position = 'relative';
                    }
                    curElem.style.height = '100%';
                    curElem = curElem.parentNode;
                }
            }

            /**
             * NOTE:
             * The following DEPRECATED version of the calculate method
             * relies on calculating the heights using math. This heavy
             * handed approach is fine if it is called at the right times
             * and often enough; however, this criteria is hard to achieve.
             *
             * A markup and styles overhaul is recommended to do away with
             * both of these methods.
             */
            function deprecatedCalculate() {
                // DEPRECATED
                _logger.$logger.warn('xo-tray-height-fallback', {
                    message: 'Using the fallback sidebar height calculation. ' + 'height may not be 100%. You should not be here!'
                });
                var height;
                var headerHeight;
                var mainHeight;
                var trayMinheight = 400;
                var asideContentHeight;
                var $aside = $(element).parents('aside:visible');
                var $asideContent = $aside.find('.asideContent');

                if (!$aside || !$asideContent) {
                    return;
                }

                // Updates the tray height to the section height
                headerHeight = $aside.find('.header').outerHeight(true);
                mainHeight = $('#main').outerHeight(true);

                height = mainHeight - headerHeight;
                asideContentHeight = $asideContent.outerHeight(true);
                if ($scope.miniBrowser) {
                    $aside.find('.aside').css('height', '534px');
                    var minHeight = 534 - headerHeight;

                    $asideContent.css('height', minHeight);
                } else if (asideContentHeight > height) {
                    $asideContent.css('height', height);
                    $aside.find('aside:visible').addClass('hasScroll');
                } else {
                    height = height > trayMinheight ? height : trayMinheight;
                    $asideContent.css('height', height);
                    $aside.removeClass('hasScroll');
                }
            }

            if (useNewFlow) {
                calculate();
            } else {
                (0, _angular.$timeout)(deprecatedCalculate, 1);

                $scope.$on('SidebarError', function () {
                    deprecatedCalculate();
                });
            }
        }
    };
});

/* grab the logger so we can warn about being in the fallback mode */


_angular.$timeout;

_logger.$logger;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/accessibility/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _ui = __webpack_require__("../node_modules/xo-ui-components/src/accessibility/ui.js");

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Adds role='button' and tabindex='0' to anchor elements
// so that it is keyboard navigable and recognized by screen
// readers as a button.
//
// As anchors without href do not fire their click event
// automatically on a Space or ENTER key, this directive forces
// that functionality.
//
// If something is assigned to the link-button attribute, then
// it is used as an aria-label.
(0, _squid.$registerDirective)('link-button', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var ariaLabel = (0, _angular.$parse)(attrs.linkButton)(scope);
            var $element = (0, _jquery2['default'])(element);

            $element.attr('role', 'button');
            $element.attr('tabindex', '0');
            if (ariaLabel) {
                $element.attr('aria-label', ariaLabel);
            }
            $element.on('keydown', function (event) {
                // do nothing if there is an alt or ctrl key as well
                if (!(event.altKey || event.ctrlKey)) {
                    switch (event.keyCode) {
                        case _ui.KEYS.SPACE:
                        case _ui.KEYS.ENTER:
                            element[0].click();
                            return false;
                        default:
                            break;
                    }
                }
                return true;
            });
        }
    };
});

// this directive gives an element characteristics of a native
// select element in terms of keyboard navigation. It becomes reachable
// via the tab key, reflects screenreader characteristics and
// can be activated by any of the DOWN, SPACE or ENTER KEYS.
(0, _squid.$registerDirective)('select-button', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var $element = (0, _jquery2['default'])(element);
            if (!attrs.hasOwnProperty('disableRole')) {
                $element.attr('role', 'button');
            }

            $element.attr('aria-haspopup', 'true').attr('tabindex', '0').on('keydown', function (event) {
                // do nothing if there is an alt or ctrl key as well
                if (!(event.altKey || event.ctrlKey)) {
                    switch (event.keyCode) {
                        case _ui.KEYS.DOWN:
                        case _ui.KEYS.SPACE:
                        case _ui.KEYS.ENTER:
                            element[0].click();
                            return false;
                        default:
                            break;
                    }
                }
                return true;
            });
        }
    };
});

// this directive makes a container with links act as if it were a select dropdown
// in terms of keyboard accessibility. The following characteristics are implemented:
//
// * UP/RIGHT and DOWN/lEFT KEYS navigate through the options.
// * ESC cancels and closes the dropdown
// * SPACE or ENTER select an option
// * You cannot TAB out of a dropdown until you select or cancel
//
// in addition, the following extra characteristics are implemented
//
// * The TAB (and SHIFT-TAB) key will also function to move between options
// * Upon reaching the end of the list, the focus will shift back to the first item, and vice versa
//
// How to use:
// 1. The select-cancel attribute is an agnostic expression to implement the cancel / back mechanic.
//    The expression is run whenever the ESC key is pressed.
// 2. The select-allow-tab-escape attribute can be added alongside the select-box attribute to allow
//    tabs to escape the select-box element.
(0, _squid.$registerDirective)('select-box', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var allowTabEscape = (0, _angular.isDefined)(attrs.selectAllowTabEscape);

            function escapeToggle() {
                if (attrs.selectCancel) {
                    (0, _angular.$parse)(attrs.selectCancel)(scope);
                    scope.$apply();
                }
            }

            element.attr('role', 'menu');

            element.on('keydown.selectBox', function (event) {
                var $allTabbable = (0, _ui.findAll)(element, _ui.tabbable);
                var $origin = (0, _jquery2['default'])(event.target);

                if (!(event.altKey || event.ctrlKey)) {
                    var index = $allTabbable.index($origin);

                    switch (event.keyCode) {
                        case _ui.KEYS.TAB:
                            if (allowTabEscape && (index === 0 && event.shiftKey || index === $allTabbable.length && !event.shiftKey)) {
                                // Enable default behavior to escape select-box
                                escapeToggle();
                                break;
                            } else if (event.shiftKey) {
                                index = (index - 1 + $allTabbable.length) % $allTabbable.length;
                            } else {
                                index = (index + 1) % $allTabbable.length;
                            }
                            $allTabbable.eq(index).focus();
                            event.preventDefault();
                            break;
                        case _ui.KEYS.DOWN:
                        case _ui.KEYS.RIGHT:
                            index = (index + 1) % $allTabbable.length;
                            $allTabbable.eq(index).focus();
                            event.preventDefault();
                            break;
                        case _ui.KEYS.UP:
                        case _ui.KEYS.LEFT:
                            index = (index - 1 + $allTabbable.length) % $allTabbable.length;
                            $allTabbable.eq(index).focus();
                            event.preventDefault();
                            break;
                        case _ui.KEYS.SPACE:
                        case _ui.KEYS.ENTER:
                            $origin.click();
                            event.preventDefault();
                            break;
                        case _ui.KEYS.ESC:
                            escapeToggle();
                            break;
                        default:
                            break;
                    }
                }
            });
        }
    };
});

// similar to select-box, this directive restrains tabbing within a container
// to the container itself.
//
// 1. modal-cancel is the equivalent of select-cancel from select-box, and
// should define a cancellation / ESC function.
(0, _squid.$registerDirective)('modal-box', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            function escapeToggle() {
                (0, _angular.$parse)(attrs.modalCancel)(scope);
                scope.$apply();
            }

            // Gets the index of the element that should be focused after pressing Tab
            function getNextIndex($element, $elements, shift) {
                if (shift) {
                    return ($elements.index($element) - 1 + $elements.length) % $elements.length;
                } else {
                    return ($elements.index($element) + 1) % $elements.length;
                }
            }

            if ((0, _angular.$parse)(attrs.modalBox)(scope) !== false) {
                element.on('keydown.modalBox', function (event) {
                    var $allTabbable = (0, _ui.findAll)(element, _ui.tabbable);
                    var $origin = (0, _jquery2['default'])(event.target);

                    if (!(event.altKey || event.ctrlKey)) {
                        switch (event.keyCode) {
                            case _ui.KEYS.TAB:
                                var index = getNextIndex($origin, $allTabbable, event.shiftKey);
                                $allTabbable.eq(index).focus();
                                event.preventDefault();
                                event.stopPropagation();
                                break;
                            case _ui.KEYS.ESC:
                                escapeToggle();
                                event.preventDefault();
                                event.stopPropagation();
                                break;
                            default:
                                break;
                        }
                    }
                });
            }
        }
    };
});

// A simple version of modal that doesn't rely on controlling keyboard behavior
// as strictly. Should be used in cases where tab items are not as easily accessible
// via JS (ie. iframes)
// Redirects focus to container when focusin event fired on element not in container
(0, _squid.$registerDirective)('simple-modal', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            element.attr('tabindex', '-1');

            var cancelFn;
            if (attrs.modalCancel) {
                cancelFn = function cancelFn() {
                    (0, _angular.$parse)(attrs.modalCancel)(scope);
                    scope.$apply();
                };
            }

            function registerModal() {
                (0, _jquery2['default'])(document).on('focusin.simple-modal', function (event) {
                    if (!element[0].contains(event.target)) {
                        event.stopPropagation();
                        element.focus();
                    }
                });
                if (cancelFn) {
                    (0, _jquery2['default'])(document).on('click.simple-modal', function (event) {
                        if (!element[0].contains(event.target)) {
                            deregisterModal();
                            cancelFn();
                        }
                    });
                }
            }

            function deregisterModal() {
                (0, _jquery2['default'])(document).off('focusin.simple-modal');
                (0, _jquery2['default'])(document).off('click.simple-modal');
            }

            // Watch the expression provided to simpleModal and add modal behavior when
            // expression result changes to truthy
            if ((0, _angular.isDefined)(element.attr('simpleModal'))) {
                scope.$watch(attrs['simpleModal'], function (newVal) {
                    if (newVal) {
                        registerModal();
                    } else {
                        deregisterModal();
                    }
                });
            } else {
                registerModal();
            }

            scope.$on('$destroy', deregisterModal);
        }
    };
});

// this directive gives an element characteristics of a native
// option element in terms of aria attributes. It must be used
// as a child of a selectBox for proper keyboard behavior as it
// disables default tabbing behavior.
//
// The expression provided to the directive is used to set the
// aria-selected attribute when the expression evaluates to true.
(0, _squid.$registerDirective)('select-option', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            (0, _jquery2['default'])(element).attr('role', 'menuitem');
            if ((0, _angular.$parse)(attrs.selectOption)(scope)) {
                (0, _jquery2['default'])(element).attr('aria-selected', 'true');
            }
        }
    };
});

// adapted from http://stackoverflow.com/a/24416690
// This directive makes the element focused when the expression
// provided _changes_ to true.
//
// In order to avoid conflicts with autofocus when a page first loads,
// adding the focused-once-before attribute will enable the expression
// only if it has been focused on before.
//
// * if the element itself is not focusable, then it will locate the first focusable
// element within it.
// * if the additional attribute focus-element is provided, it is wrapped
// as a jQuery element (could be selector string or actual element) and focused on
// it will be parsed when the focus-when attribute is true
// * if the attribute focus-on is provided, then the focus-when attribute is ignored and
// the directive listens to the event specified by focus-on
(0, _squid.$registerDirective)('focus-when', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {

            function locateAndFocus(active) {
                (0, _angular.$timeout)(function () {
                    if (active) {
                        // deal with figuring out which element to focus on
                        var $elementToFocus = (0, _jquery2['default'])(); // start with "monad" to make life easier
                        var directiveElementFocusable = (0, _ui.focusable)(element[0]);

                        // this works by fallthrough. it will try each one
                        // in succession until an element is found
                        if (attrs.focusElement) {
                            // scenario 1 - specific element provided
                            $elementToFocus = (0, _ui.filterAll)((0, _angular.$parse)(attrs.focusElement)(scope), _ui.focusable);
                        }

                        if ($elementToFocus.length === 0 && !directiveElementFocusable) {
                            // scenario 2 - element with directive is not focusable
                            $elementToFocus = (0, _ui.findAll)(element, _ui.focusable);
                        }

                        // default / scenario 3 - no valid targets specified or found
                        if ($elementToFocus.length === 0) {
                            $elementToFocus = (0, _jquery2['default'])(element);
                        }

                        $elementToFocus.first().focus();
                    }
                });
            }

            var active = true;

            if ('focusedOnceBefore' in attrs) {
                active = false;
                (0, _jquery2['default'])(element).on('focus', function () {
                    active = true;
                });
            }

            if (attrs.focusRefreshOn) {
                scope.$on((0, _angular.$parse)(attrs.focusRefreshOn)(scope), function () {
                    locateAndFocus(active);
                });
            } else {
                scope.$watch(attrs.focusWhen, function (val) {
                    locateAndFocus(active && val);
                });
            }
        }
    };
});

// angularUI router specific - listens to a specific transition
// defined in two attributes, focusWhenState (this directive) and TransitionsTo
var FOCUS_EVENT_NAME = 'accessible-focus';
(0, _squid.$registerDirective)('focus-when-state', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var startState = attrs.focusWhenState;
            var endState = attrs.transitionsTo;
            var transitionMessage = startState + ' > ' + endState;
            var unregisterEventFn = _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                if (fromState.name === startState && toState.name === endState) {
                    scope.$broadcast(FOCUS_EVENT_NAME, transitionMessage);
                }
            });

            scope.$on(FOCUS_EVENT_NAME, function (event, message) {
                if (message === transitionMessage) {
                    (0, _angular.$timeout)(function () {
                        return element[0].focus();
                    });
                }
            });

            // see http://stackoverflow.com/a/27016855
            scope.$on('$destroy', unregisterEventFn);
        }
    };
});

// Listens for the next state transition and focuses an element provided by selector
// Use with links where focus is needed to return to a specific element after the transition
(0, _squid.$registerDirective)('focus-after-transition', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            element.on('click', function () {
                var focusSelector = attrs['focusAfterTransition'];
                var cancel = _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                    cancel();
                    (0, _angular.$timeout)(function () {
                        (0, _jquery2['default'])(focusSelector).focus();
                    });
                });
            });
        }
    };
});

// focuses on the first focusable element on a container containing form elements
(0, _squid.$registerDirective)('form-autofocus', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            // wait for the entire DOM to settle down first
            (0, _angular.$timeout)(function () {
                var $allFocusable = (0, _ui.findAll)(element, _ui.focusable);
                if ($allFocusable.length > 0) {
                    $allFocusable.first().focus();
                }
            });
        }
    };
});

// Change element to be focusable and tabbable or unfocusable if it is
// not typically a focusable element by removing the tabindex attribute.
(0, _squid.$registerDirective)('focusable', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            function setFocusable(value) {
                if (value) {
                    element.attr('tabindex', 0);
                } else {
                    element.removeAttr('tabindex');
                }
            }

            if (attrs.focusable) {
                scope.$watch(attrs.focusable, function (newVal) {
                    if (newVal) {
                        setFocusable(true);
                    } else {
                        setFocusable(false);
                    }
                });
            } else {
                setFocusable(true);
            }
        }
    };
});

_squid.$registerDirective;

_angular.$parse;

_angular.$timeout;

_angular.$rootScope;

_angular.isDefined;

_ui.KEYS;

_ui.focusable;

_ui.tabbable;

_ui.findAll;

_ui.filterAll;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/accessibility/ui.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.filterAll = exports.findAll = exports.tabbable = exports.focusable = exports.visible = exports.KEYS = undefined;

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var KEYS = {
    TAB: 0x09,
    ENTER: 0x0D,
    ESC: 0x1B,
    SPACE: 0x20,
    LEFT: 0x25,
    UP: 0x26,
    RIGHT: 0x27,
    DOWN: 0x28
};

function visible(element) {
    return _jquery2['default'].expr.filters.visible(element) && !(0, _jquery2['default'])(element).parents().addBack().filter(function () {
        return _jquery2['default'].css(this, 'visibility') === 'hidden';
    }).length;
}

// ripped from http://stackoverflow.com/a/7668761
/* istanbul ignore next */
function focusable(element) {
    var nodeName = element.nodeName.toLowerCase();
    var isTabIndexNotNaN = !isNaN(_jquery2['default'].attr(element, 'tabindex'));
    var map;
    var mapName;
    var img;

    if (nodeName === 'area') {
        map = element.parentNode;
        mapName = map.name;
        if (!element.href || !mapName || map.nodeName.toLowerCase() !== 'map') {
            return false;
        }
        img = (0, _jquery2['default'])('img[usemap=#' + mapName + ']')[0];
        return !!img && visible(img);
    }
    return (/^(input|select|textarea|button|object)$/.test(nodeName) ? // eslint-disable-line no-nested-ternary
    !element.disabled : nodeName === 'a' ? element.href || isTabIndexNotNaN : isTabIndexNotNaN) &&
    // the element and all of its ancestors must be visible
    visible(element);
}

/* istanbul ignore next */
function tabbable(element) {
    var tabIndex = _jquery2['default'].attr(element, 'tabindex');
    var isTabIndexNaN = isNaN(tabIndex);

    return (isTabIndexNaN || tabIndex >= 0) && focusable(element);
}

function filterAll(elements, filterFn) {
    return (0, _jquery2['default'])(elements).filter(function () {
        return filterFn(this);
    });
}

function findAll(container, filterFn) {
    return filterAll((0, _jquery2['default'])(container).find('*'), filterFn);
}

exports.KEYS = KEYS;
exports.visible = visible;
exports.focusable = focusable;
exports.tabbable = tabbable;
exports.findAll = findAll;
exports.filterAll = filterAll;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/address-box/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/address-box/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/address-box/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(0, _squid.$registerDirective)('xo-address-box', function () {
    return {
        template: _template2['default'],
        scope: {
            header: '=?',
            fullname: '=?',
            addresses: '=?',
            changeFn: '=?'
        },
        lifecycle: {
            enter: function enter() {
                _logger.$logger.info('xo-address-box_enter');
            }
        },
        controller: ['$scope', function ($scope) {
            var addressList = $scope.addresses && $scope.addresses.addresses || [];

            $scope.address = addressList[0] || {};
            $scope.line3 = $scope.address.city + ', ' + $scope.address.state + ' ' + $scope.address.postal_code;
            $scope.updateType = addressList.length > 1 ? _squid.$locale.content.get('common.change') : _squid.$locale.content.get('common.edit');
            $scope.updateFn = function () {
                return $scope.changeFn($scope.updateType);
            };
            $scope.fullname = $scope.fullname;
            if ($scope.fullname) {
                $scope.name = $scope.fullname.first_name + ' ' + $scope.fullname.last_name;
            }
        }]
    };
});

_squid.$registerDirective;

_squid.$locale;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/address-box/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/address-box/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"address-box-wrapper\">\n\n    <div class=\"box-header\">\n        <div class=\"headerText\">{{header}}</div>\n        <div class=\"updateButton\">\n            <a ng-click=\"updateFn()\">{{updateType}}</a>\n        </div>\n    </div>\n    <div class=\"box-body\">\n        <p ng-if=\"name\">{{name}}</p>\n        <p>{{address.line1}}</p>\n        <p>{{address.line2}}</p>\n        <p>{{line3}}</p>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/banner/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/banner/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/banner/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoBanner', {
    tag: 'xo-banner',
    template: _template2['default'],
    transclude: true,
    props: {
        isNmj: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        // Need buyer_id from $AuthModel first to get the URL for the user profile photo
        models: function models() {
            return {
                auth: _auth.$AuthModel.instance().retrieve()
            };
        },
        userPhoto: function userPhoto(resolvers) {
            return resolvers.models.then(function (models) {
                return {
                    photoData: _index.$UserPhotoModel.instance(models.auth.buyer_id).retrieve({
                        params: {
                            'min_size': 45
                        }
                    })['catch'](function (error) {
                        _logger.$logger.info('error_retrieve_user_photo');
                        return {};
                    })
                };
            });
        }
    },
    lifecycle: {
        populate: function populate() {
            var avatarElement = this.$element.find('#banner-picture');
            var auth = this.models.auth;
            var photoData = this.userPhoto.photoData;

            // Currently only showing initials for New Member Journey
            var showInitials = auth.first_name && auth.last_name && this.props.isNmj;

            if (avatarElement && auth.buyer_id) {
                // The "phantom" avatar image is displayed by default via CSS
                // background-image property. If the request for a user's
                // profile photo returns a URL, the background-image property
                // is replaced with that URL.

                // Show user photo for avatar
                if (photoData && photoData.photo_url) {
                    avatarElement.css('background-image', 'url("' + photoData.photo_url + '")');
                    _logger.$logger.info('xoBanner_user');
                }

                // No user photo: show user initials instead of phantom image
                if (!photoData.photo_url && showInitials) {
                    avatarElement.addClass('initials');
                    this.initials = '' + auth.first_name[0] + auth.last_name[0];
                    _logger.$logger.info('xoBanner_initials');
                }
            } else {
                // Leave the phantom avatar as the background image
                _logger.$logger.info('xoBanner_default');
            }
        }
    }
});


_squid.$Component;

_auth.$AuthModel;

_index.$UserPhotoModel;

_logger.$logger;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/banner/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/banner/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"banner-wrapper\">\n    <div id=\"banner-picture\">{{ initials }}</div>\n    <div id=\"banner-content\" ng-transclude></div>\n</div>"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/card-loader/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoCardLoader = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/card-loader/styles.less");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/card-loader/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCardLoader = exports.$xoCardLoader = _squid.$Component.extend('xoCardLoader', {
    tag: 'xo-card-loader',
    template: _template2['default'],
    props: {
        message: {
            type: 'str',
            required: false
        },
        state: {
            type: 'var',
            required: false
        },
        auth: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            this.ellipsis = function () {
                var email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

                var MAX_EMAIL_LEN = 30;
                var MAX_DOMAIN_LEN = 20;
                var MAX_USERNAME_LEN = MAX_EMAIL_LEN - MAX_DOMAIN_LEN;

                if (email.length <= MAX_EMAIL_LEN) {
                    return email;
                }

                var userNameLength = email.indexOf('@');
                var domainLength = email.length - userNameLength;

                if (userNameLength > MAX_USERNAME_LEN && domainLength > MAX_DOMAIN_LEN) {
                    return email.replace(new RegExp('(.{' + (MAX_USERNAME_LEN - 3) + '}).*(@.{' + (MAX_DOMAIN_LEN - 4) + '}).*'), '$1...$2...');
                } else if (userNameLength > MAX_USERNAME_LEN) {
                    return email.replace(new RegExp('(.{' + (MAX_EMAIL_LEN - domainLength - 3) + '}).*(@.*)'), '$1...$2');
                } else {
                    return email.replace(new RegExp('(.{' + (MAX_EMAIL_LEN - 3) + '}).*'), '$1...');
                }
            };
        }
    }
});

angular.value("$xoCardLoader", $xoCardLoader);
_squid.$Component;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/card-loader/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/card-loader/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"virtual_card\">\n    <div id=\"card_header\">\n        <div id=\"card_logo\"></div>\n    </div>\n    <div id=\"card_footer\">\n        <div class=\"card_user\" ng-if=\"auth.loggedIn()\">{{ellipsis(auth.email)}}</div>\n    </div>\n    <div id=\"slider\" class=\"{{state}}\"></div>\n</div>\n<div id=\"virtual_card_message\">{{message}}</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/cardicon/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoFiIcon = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _index2 = _interopRequireDefault(_index);

var _template = __webpack_require__("../node_modules/xo-ui-components/src/cardicon/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoFiIcon = exports.$xoFiIcon = _squid.$Component.extend('xoFiIcon', {
    tag: 'xo-fi-icon',
    wrapperType: 'span',
    template: _template2['default'],
    transclude: true,
    props: {
        fi: {
            type: 'var',
            required: false
        },
        className: {
            type: 'str',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                fiMeta: _index2['default'].instance(_angular.$rootScope.token).fetch()
            };
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this = this;

            var updateCardArt = function updateCardArt() {
                _this.retrievedCardArt = _this.models.fiMeta.getCardArt(_this.props.fi);

                if (_this.retrievedCardArt) {
                    _this.cardStyle = {
                        'background-image': 'url(' + _this.retrievedCardArt + ')',
                        'background-size': 'contain',
                        'background-position': 'initial'
                    };
                }
            };

            this.$watch('props.fi', updateCardArt);
        }
    }
});

angular.value("$xoFiIcon", $xoFiIcon);
_squid.$Component;

_angular.$rootScope;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/cardicon/template.html":
/***/ (function(module, exports) {

module.exports = "<span ng-if=\"retrievedCardArt\">\n    <span class=\"standardCardIcon fsIcon fsIcons img-retina\" ng-class=\"className\" ng-style=\"cardStyle\"></span>\n</span>\n<span ng-if=\"!retrievedCardArt\">\n    <div ng-if=\"models.fiMeta.isPinlessDebit(fi)\" class=\"standardCardIcon pinlessGlyphIcon icon icon-card-half-solid\"></div>\n    <div ng-if=\"!models.fiMeta.isPinlessDebit(fi)\" class=\"standardCardIcon fsIcon fsIcons img-retina\" ng-class=\"[fi.type, fi.card_type, fi.name, className]\" ng-transclude>\n    </div>\n</span>\n\n\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/directionality/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

__webpack_require__("../node_modules/xo-ui-components/src/directionality/styles.less");

/**
 * This directive watches the model and listens to user input to look for arabic/hebrew/right-to-left language
 * unicode chars, then adds dir="rtl" or dir="ltr" attribute to input field
 *
 * Add directionality to the container html div element of a input field.
 * <div directionality><input type=text ng-model="user.name"></div>
 */
(0, _squid.$registerDirective)('directionality', function () {
    return {
        restrict: 'A',
        link: function link(scope, element) {
            var currentWatchDeregister = void 0;
            var input = element.find('input');

            if (!input.length) {
                listenForInputRendered();
                return;
            }

            // If the input has not yet been rendered inside the container, listen for dom node inserted
            // then, if the node inserted is an input, we will use that element and init the directionality
            // listeners. The first input rendered is the one that will be captured by this directive.
            function listenForInputRendered() {
                element.bind('DOMNodeInserted', checkDOMNodeInserted);

                function checkDOMNodeInserted(event) {
                    if (event && event.target && event.target.tagName === 'INPUT') {
                        element.unbind('DOMNodeInserted', checkDOMNodeInserted);
                        input = angular.element(event.target);
                        init();
                    }
                }
            }

            function setDirectionality(value) {
                if (value) {
                    // set directionality to 'rtl' if the value has hebrew/arabic unicode chars.
                    element.toggleClass('ltrOverride', !_squid.$util.hasRTL(value));
                } else {
                    element.toggleClass('ltrOverride', _angular.$document.prop('documentElement').getAttribute('dir') !== 'rtl');
                }
            }

            function jqueryOnKeyupHandler(event) {
                setDirectionality(event.target.value);
            }

            // Reset directionality listeners when we transition from ltr -> rtl locale or vice versa
            function resetDirectionalityListener() {
                // remove directionality listeners that were set on prior locale
                input.unbind('keyup', jqueryOnKeyupHandler);
                if (currentWatchDeregister) {
                    currentWatchDeregister();
                }

                // set new directionality listeners for the current locale if 'rtl'
                if (document.documentElement.getAttribute('dir') === 'rtl') {
                    (0, _angular.$timeout)(function () {
                        // Watch ng-model on input to set directionality if it contains RTL char
                        currentWatchDeregister = scope.$watch(input.attr('ng-model'), function (value) {
                            setDirectionality(value);
                        });
                        // jQuery listener for cases where ng-model is not populated until post validation
                        input.on('keyup', jqueryOnKeyupHandler);
                    });
                }
            }

            function init() {
                resetDirectionalityListener();
                scope.$on('localeChange', function () {
                    resetDirectionalityListener();
                });
            }

            init();
        }
    };
});

/**
 * This directive watches the model for arabic/hebrew/right-to-left language unicode chars, then adds dir="rtl"
 * or dir="ltr" attribute to the html element.
 *
 * Add directionality-text="<<model>>" to the div or span or any element containing text.
 * <span directionality-text="user.name"><{{user.name}}</span>
 */
(0, _squid.$registerDirective)('directionality-text', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            if (document.documentElement.getAttribute('dir') === 'rtl') {
                var $element = $(element);

                (0, _angular.$timeout)(function () {
                    if (attrs.directionalityText) {
                        scope.$watch(attrs.directionalityText, function () {
                            $element.toggleClass('ltrOverride', !_squid.$util.hasRTL((0, _angular.$parse)(attrs.directionalityText)(scope)));
                        });
                    } else {
                        $element.toggleClass('ltrOverride', !_squid.$util.hasRTL(element.text()));
                    }
                });
            }
        }
    };
});

_squid.$util;

_squid.$registerDirective;

_angular.$document;

_angular.$parse;

_angular.$timeout;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/directionality/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/dropdown-multiline/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/jquery/dist/jquery.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, $) {
    squid.module('xo-dropdown-multiline.directive', ['squid']).directive('xoDropdownMultiline', ['$timeout', function ($timeout) {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function link($scope, $select, attrs, ngModel) {
                var isListVisible = false;
                var listCreated = false;

                $select = $($select);

                var $span = $('<span class="custom-select" aria-hidden="true"><div class="arrow"></div><span class="innerContainer"><span></span></span></span>');
                var $container = $('<div class="custom-select-container multiline-select-container" tabindex="0" />');
                var $list = void 0;

                function updateCover() {
                    $timeout(function () {
                        $span.find('span span').html($select.find('[selected]').text().replace(/\\n/gi, '<br>').trim());
                    }, 10);
                }

                function createList($options) {
                    if ($options.length < 2) {
                        return;
                    }

                    function getModel() {
                        var modelName = void 0;
                        var model = void 0;
                        var subParts = void 0;

                        if ($select.attr('ng-options')) {
                            modelName = $select.attr('ng-options').substring($select.attr('ng-options').indexOf('in ') + 3, $select.attr('ng-options').length);
                        } else {
                            var $option = $($select.find('[ng-repeat]')[0]);

                            modelName = $option.attr('ng-repeat').substring($option.attr('ng-repeat').indexOf('in ') + 3, $option.attr('ng-repeat').length);
                        }

                        // This is to handle cases like card.billingAddress
                        if (modelName.indexOf('.') !== -1) {
                            subParts = modelName.split('.');
                            model = $scope;

                            for (var i = 0; i < subParts.length; i++) {
                                model = model[subParts[i]];
                            }
                        } else {
                            // And this is to handle straightforward model names
                            model = $scope[modelName];
                        }

                        return model;
                    }

                    function hideList(event) {
                        $list.hide();
                        $container.append($list);
                        isListVisible = false;
                        $container.removeClass('open');
                    }

                    function positionList() {
                        $list.css('left', $container.offset().left + 'px');
                        $list.css('top', $container.offset().top + $container.height() + 'px');
                        $list.css('width', $container.width() + 'px');
                    }

                    function setFocusOnSelected() {
                        var $selected = $select.find('[selected]');

                        if ($selected.length) {
                            var $item = $list.find('[data-value="' + $selected.attr('value') + '"]');

                            $item.focus();
                        } else {
                            $list.find('li')[0].focus();
                        }
                    }

                    function showList() {
                        $('body').append($list);
                        $container.addClass('open');
                        $list.show();
                        positionList();
                        isListVisible = true;
                        setFocusOnSelected();
                    }

                    function processContainerKeypress(event) {
                        var keyCode = event && event.keyCode;

                        if (keyCode === 13 || keyCode === 40) {
                            // enter or down arrow
                            if (!isListVisible) {
                                showList();
                            } else {
                                hideList();
                                $container.focus();
                            }
                        } else if (keyCode === 27) {
                            // escape
                            if (isListVisible) {
                                hideList();
                                $container.focus();
                            }
                        }
                    }

                    if ($list) {
                        $list.remove();
                    }

                    $list = $('<ul class="multiline-select-list" tabindex="0"></ul>');

                    Array.prototype.forEach.call($options, function (option) {
                        var $option = $(option);
                        var value = $option.attr('value');
                        var text = option.innerHTML.replace(/\\n/gi, '<br>');

                        if (text.indexOf('content(') !== -1) {
                            text = $scope.content(text.substring(text.indexOf('(\'') + 2, text.indexOf('\')')));
                        }

                        var html = '<li tabindex="0"';

                        if (value !== $option.text()) {
                            html = html + ' data-value="' + value + '"';
                        }
                        html = html + '>' + text + '</li>';
                        $list.append($(html));
                    });

                    $container.append($list);
                    $list.hide();

                    $($list.find('li')).click(function (event) {
                        var $target = $(event.target);
                        var value = $target.data('value');

                        if (typeof value !== 'undefined') {
                            $select.find('option').removeAttr('selected');
                            $select.find('option[value="' + value + '"]').attr('selected', 'selected');
                            $select.find('option').removeProp('selected');
                            $select.find('option[value="' + value + '"]').prop('selected', 'selected');
                        } else {
                            value = $target.html().replace(/\/<br\/>/gi, '\\n');
                            $select.val(value);
                        }

                        if ($select.attr('ng-model')) {
                            if ($select.attr('ng-options') || $select.find('[ng-repeat]').length) {
                                /* This parses the 'ng-options' directive and returns the options model.
                                For example: If you have: ng-options='opt as opt.label for opt in options'
                                Here it will parse this attribute and return 'options */
                                var model = getModel();

                                ngModel.$setViewValue(model[value]);
                            } else {
                                ngModel.$setViewValue(value);
                            }
                        }
                        updateCover();
                        hideList();
                    });

                    var $innerContainer = $container.find('.innerContainer');

                    $container.click(function () {
                        if (isListVisible) {
                            hideList();
                            $container.focus();
                        } else {
                            showList();
                        }
                    });

                    $container.keydown(function (event) {
                        return processContainerKeypress(event);
                    });
                    $innerContainer.keydown(function (event) {
                        return processContainerKeypress(event);
                    });

                    $list.find('li').keydown(function (event) {
                        var keyCode = event && event.keyCode;
                        var $target = $(event.target);

                        if (keyCode === 13) {
                            // enter
                            $target.click();
                            event.stopPropagation();
                        } else if (keyCode === 27) {
                            // escape
                            if (isListVisible) {
                                hideList();
                                $container.focus();
                                event.stopPropagation();
                            }
                        } else if (keyCode === 40) {
                            // down arrow
                            if (!$target.is(':last-of-type')) {
                                $target.next().focus();
                                event.preventDefault();
                                event.stopPropagation();
                            }
                        } else if (keyCode === 38) {
                            // up arrow
                            if (!$target.is(':first-of-type')) {
                                $target.prev().focus();
                            }
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    });

                    $(window).resize(function () {
                        if (isListVisible) {
                            positionList();
                        }
                    });

                    $(window).bind('hashchange', function () {
                        if (isListVisible) {
                            hideList();
                        }
                    });

                    $(document).click(function (event) {
                        var $target = $(event.target);

                        if (!($target.is($container) || $.contains($container.get()[0], $target.get()[0])) && isListVisible) {
                            hideList();
                        }
                    });

                    $container.blur(function (event) {
                        // The setTimeout here is to ensure activeElement is set before our function executes
                        $timeout(function () {
                            var $newTarget = $(event.explicitOriginalTarget || document.activeElement);

                            if (!($.contains($container.get()[0], $newTarget.get()[0]) || $.contains($list.get()[0], $newTarget.get()[0]))) {
                                hideList(event);
                            }
                        }, 1);
                    });

                    listCreated = true;
                    updateCover();
                }

                function render() {
                    var options = $select.find('option');

                    if (!listCreated) {
                        createList(options);
                    }
                }

                $select.wrap($container);
                $container = $select.parent();

                // Change class names to enable styling of hover/focus states
                $select.bind('mouseenter focus', function () {
                    return $span.addClass('active');
                });
                // Change class names to enable styling of hover/focus states
                $select.bind('mouseleave blur', function () {
                    return $span.removeClass('active');
                });
                $select.after($span);
                $select.addClass('replaced');
                $select.attr('tabindex', '-1');

                if (attrs['default']) {
                    var defaultOption = document.createElement('option');

                    defaultOption.innerText = attrs['default'];
                    $select.append(defaultOption);
                }

                if ($select.attr('ng-options')) {
                    $scope.$watch(attrs.ngModel, function () {
                        render();
                    });
                } else {
                    $timeout(function () {
                        return $scope.$broadcast('pageRendered');
                    });
                }

                $scope.$on('pageRendered', function () {
                    return render();
                });
            }
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/dropdown/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/jquery/dist/jquery.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, $) {
    $.fn.dropdown = function () {
        console.warn('Dropdown deprecated');
    };
    squid.module('xo-dropdown.directive', ['squid']).directive('xoDropdown', ['$parse', '$window', '$timeout', '$util', '$compile', function ($parse, $window, $timeout, $util, $compile) {
        var userAgent = ($window.navigator || {}).userAgent;
        var isWinOS = Boolean(userAgent.match(/\(win/i));

        return {
            restrict: 'A',
            scope: {
                dropdownTextBindVar: '=?'
            },
            link: function link($scope, $element, attrs) {
                var $parentScope = $scope.$parent;
                var $select = $($element);
                // TODO: This html should be refactored out into a template.
                var $span = $('<span class="custom-select" aria-hidden="true"><span><span></span></span></span>');
                var selectInitialValue = '';
                var ngChange = '';

                $select.parent().addClass('custom-select-container');
                // Change class names to enable styling of hover/focus states
                $select.bind('mouseenter', function () {
                    return $span.addClass('active');
                });
                $select.bind('mouseleave', function () {
                    return $span.removeClass('active');
                });
                // Change class names to enable styling of hover/focus states
                $select.bind('focus', function () {
                    selectInitialValue = $parse(attrs.ngModel)($parentScope);
                    $span.addClass('active');
                });

                function executeSelectChange() {
                    // setTimeout here is to ensure activeElement is set before our function executes
                    $timeout(function () {
                        var val = $parse(attrs.ngModel)($parentScope);

                        if (selectInitialValue !== val) {
                            if (ngChange) {
                                ngChange($parentScope);
                            }
                            selectInitialValue = val;
                        }
                    }, 5);
                }

                if (isWinOS) {
                    if (attrs['ngChange']) {
                        ngChange = $parse(attrs.ngChange);
                        attrs['ngChange'] = '';
                    }

                    $select.bind('blur', function () {
                        executeSelectChange();
                        $span.removeClass('active');
                    });
                    $select.bind('click', function () {
                        return executeSelectChange();
                    });
                } else {
                    $select.bind('blur', function () {
                        return $span.removeClass('active');
                    });
                }

                $select.after($span);
                $select.addClass('replaced');

                if (attrs['default']) {
                    var defaultOption = document.createElement('option');

                    defaultOption.innerText = attrs['default'];
                    $select.append(defaultOption);
                }

                var match = (attrs.ngOptions || '').match(/in ([\w\.]+)/);
                // Text Update Method 1(new): ng-bind on variable passed in directive and that is updated in parent/sibling scope
                if (angular.isDefined($scope.dropdownTextBindVar)) {
                    var selectTextElement = $span.find('span span');

                    if (selectTextElement.length) {
                        $(selectTextElement).attr('ng-bind', 'dropdownTextBindVar');
                        $(selectTextElement).html($compile(selectTextElement[0])($scope));
                    }

                    $scope.$watch('dropdownTextBindVar', function (newVal) {
                        if (document.documentElement.getAttribute('dir') === 'rtl') {
                            $span.toggleClass('ltrOverride', !$util.hasRTL(newVal));
                        }
                    });
                }
                // Text Update Method 2(old): jQuery text update on various conditions (not as reliable for me, ran into timing edge cases)
                else {
                        var updateCover = function updateCover() {
                            $timeout(function () {
                                var text = $select.find(':selected').text().trim();

                                $span.find('span span').text(text);
                                if (document.documentElement.getAttribute('dir') === 'rtl') {
                                    $span.toggleClass('ltrOverride', !$util.hasRTL(text));
                                }
                            }, 5);
                        };

                        $parentScope.$watch(attrs.ngModel, updateCover);
                        $scope.$on('contentChange', updateCover);
                        if (match) {
                            $parentScope.$watch(match[1], updateCover);
                        }
                        // Update cover on arrow key press, for case where menu is not open
                        // but user is interacting with dropdown (eg. Firefox)
                        $select.bind('keyup', function (event) {
                            // Arrow keys are 37 - 40
                            if (event.which >= 37 || event.which <= 40) {
                                updateCover();
                            }
                        });
                    }

                toggleOptionsLTROverride();
                if (match) {
                    $parentScope.$watch(match[1], function (newVal) {
                        toggleOptionsLTROverride();
                    });
                }

                function toggleOptionsLTROverride() {
                    if (document.documentElement.getAttribute('dir') === 'rtl') {
                        $timeout(function () {
                            var options = $select.find('option');

                            for (var i = 0; i < options.length; i++) {
                                $(options.get(i)).toggleClass('ltrOverride', !$util.hasRTL(options.get(i).text));
                            }
                        });
                    }
                }
            }
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/error-tooltip/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angularAria = __webpack_require__("../node_modules/angular-aria/angular-aria.min.js");

// Configure angular aria.
// Note that aria configuration applies globally
_angularAria.$ariaProvider.config({ // eslint-disable-line angular/di
    // Remove bindRoleForClick since we use ngClick for several items that shouldn't be treated as buttons.
    bindRoleForClick: false,

    // Remove ariaInvalid and ariaRequired as we want to handle them ourselves.
    // These attributes should only be set once the form is submitted, to match what
    // visually what we display
    ariaInvalid: false,
    ariaRequired: false,
    // Removing aria-hidden attribute for hidden elements
    ariaHidden: false
});

(0, _squid.$registerDirective)('xo-error-tooltip', function () {
    return {
        restrict: 'A',
        require: ['?^form', '?ngModel'],
        link: function link(scope, element, attrs, ctrls) {
            var formCtrl = ctrls[0],
                modelCtrl = ctrls[1];


            function shouldBeRequired() {
                if (formCtrl) {
                    // If input is a checkbox and has error-text or error-key, show the error text instead of the required text.
                    // error-text is a legacy thing for backward compatibility, we can get rid of this once all teams
                    // adopt error-key in all input tags
                    var showCheckboxRequired = !(element.attr('type') === 'checkbox' && (attrs.errorText || attrs.errorKey));

                    return formCtrl.$submitted && modelCtrl.$error.required && showCheckboxRequired;
                } else {
                    return modelCtrl.$error.required;
                }
            }

            function shouldBeInvalid() {
                if (formCtrl) {
                    return formCtrl.$submitted && modelCtrl.$invalid;
                } else {
                    return modelCtrl.$invalid;
                }
            }

            // Add or remove a string into a space split string (eg. aria-describedby ids, class names)
            function formatSpaceSplitString(str, id, add) {
                var strArray = void 0;

                if (str) {
                    strArray = str.split(' ');
                } else {
                    strArray = [];
                }

                var idIndex = strArray.indexOf(id);

                if (~idIndex && !add) {
                    strArray.splice(idIndex, 1);
                } else if (!~idIndex && add) {
                    strArray.push(id);
                }

                return strArray.join(' ');
            }

            // Add tooltip behavior after DOM settles
            (0, _angular.$timeout)(function () {
                var generateId = function generateId() {
                    return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 7);
                };
                var requiredId = generateId();
                var invalidId = generateId();
                var requiredError = void 0;
                var invalidError = void 0;

                if (attrs.errorKey) {
                    element.addClass('hasErrorTooltipRuleSpecific');
                    invalidError = (0, _angular.$compile)('<div class="errorTooltip errorTooltipRuleSpecific" id="' + invalidId + '">{{content("' + attrs.errorKey + '")}}</div>')(scope);
                    element.after(invalidError);
                } else if (attrs.errorText) {
                    // errorText if case is for backward compatibility, we can get rid of this once
                    // all teams adopt error-key in all input tags for tooltip message display
                    element.addClass('hasErrorTooltipRuleSpecific');
                    invalidError = $('<div class="errorTooltip errorTooltipRuleSpecific" id="' + invalidId + '">' + attrs.errorText + '</div>');
                    element.after(invalidError);
                }

                if (attrs.required || (0, _angular.$parse)(attrs.ngRequired)(scope)) {
                    element.addClass('hasErrorTooltipRequired');
                    requiredError = (0, _angular.$compile)('<div class="errorTooltip errorTooltipRequired" id="' + requiredId + '">{{content("validation.required")}}</div>')(scope);
                    element.after(requiredError);
                    element.removeAttr('aria-required');
                }

                function setAriaAttributes() {
                    var addTooltips = {
                        required: false,
                        invalid: false
                    };

                    // Do not associate "Required" error with aria-describedby
                    // because this should already be read out either by "required"
                    // attribute or "aria-required"=true, and only associate "Invalid"
                    // error if "Required" is not showing to match visuals
                    if (shouldBeRequired()) {
                        addTooltips.required = true;
                    } else if (shouldBeInvalid()) {
                        addTooltips.invalid = true;
                    }

                    var describedby = element.attr('aria-describedby');

                    describedby = formatSpaceSplitString(describedby, requiredId, addTooltips.required);
                    describedby = formatSpaceSplitString(describedby, invalidId, addTooltips.invalid);
                    element.attr('aria-describedby', describedby);
                }

                scope.$watch(shouldBeRequired, function (newVal) {
                    setAriaAttributes();
                });
                scope.$watch(shouldBeInvalid, function (newVal) {
                    element.attr('aria-invalid', newVal);
                    setAriaAttributes();
                });

                // Set scroll so that the error message is in view when element receives focus
                element.on('focus', function (event) {
                    var windowBot = $(window).scrollTop() + $(window).height();
                    var requiredBot = requiredError ? requiredError.offset().top + requiredError.outerHeight() : 0;
                    var invalidBot = invalidError ? invalidError.offset().top + invalidError.outerHeight() : 0;

                    if (windowBot < Math.max(requiredBot, invalidBot)) {
                        $(window).scrollTop(Math.max(requiredBot, invalidBot) - $(window).height());
                    }
                });
            });
        }
    };
});

_squid.$registerDirective;

_angular.$parse;

_angular.$compile;

_angular.$timeout;

_angularAria.$ariaProvider;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/escape-hatch/closeFrame/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _index = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/escape-hatch/closeFrame/template.html"), __webpack_require__("../node_modules/xo-models/src/user/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, template) {

    squid.module('xo-escape-hatch.closeFrame.directive', ['squid', 'xomodel.user']).directive('xoCloseFrame', [function () {
        return {
            template: template,

            restrict: 'E',

            scope: {
                redirectiframe: '=?',
                redirectLightbox: '=?'
            },

            controller: ['$scope', '$rootScope', '$populate', '$CheckoutInputDataModel', '$window', '$CheckoutAppDataModel', '$util', '$injector', '$logger', function ($scope, $rootScope, $populate, $CheckoutInputDataModel, $window, $CheckoutAppDataModel, $util, $injector, $logger) {

                $populate($scope, {
                    checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token)
                }).then(function () {
                    var cancel_url = $scope.checkoutAppData.urls.cancel_url;

                    $scope.checkoutInputData = $CheckoutInputDataModel.instance($scope.token);
                    $scope.isIFrame = $util.isIFrame();

                    $scope.closeFrame = function (event) {
                        event.preventDefault();
                        event.stopPropagation();

                        if (window.xchild) {
                            if (window.xprops.onCancel) {
                                return window.xprops.onCancel({
                                    token: $scope.token,
                                    cancelUrl: cancel_url
                                });
                            } else {
                                return window.xchild.close();
                            }
                        }

                        if ($scope.redirectLightbox) {
                            var result = _index.$ReturnToMerchant.postToMerchant({
                                operation: 'return_to_merchant',
                                returnUrl: cancel_url,
                                updateParent: true
                            });

                            // Otherwise we have no choice but to return to the merchant
                            if (!result) {
                                $util.redirect(cancel_url);
                            }

                            // TODO - Move out helios specific logic. Apps should provide a callback instead.
                        } else if ($scope.redirectiframe) {
                            $window.location.replace(cancel_url);

                            // TODO - Move out helios specific logic. Apps should provide a callback instead.
                        } else {

                            var iFrameFlow = $injector.get('$IFrameFlow');

                            $logger.info('HELIOS_FLOW_FALLBACK'); // overall fallbacks
                            $logger.info('HELIOS_FALLBACK_TO_MERCHANT');
                            $logger.info('HELIOS_FALLBACK_MERCHANT_USER_CANCELLED');

                            var url = $scope.checkoutInputData.errorUrl('user_cancelled');

                            if ($scope.auth && $scope.auth.code) {
                                url += '&code=' + $scope.auth.code;
                            }

                            iFrameFlow.findWindowAndRedirect($scope.checkoutInputData, url);
                        }
                        $scope.$emit('exitFrame');
                    };
                });
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

_index.$ReturnToMerchant;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/escape-hatch/escapeHatch/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/escape-hatch/escapeHatch/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, template) {

    squid.module('xo-escape-hatch.escapeHatch.directive', ['squid']).directive('xoEscapeHatch', [function () {
        return {
            template: template,

            restrict: 'E',

            controller: ['$scope', '$rootScope', '$window', '$util', '$logger', function ($scope, $rootScope, $window, $util, $logger) {
                $scope.isIFrame = $util.isIFrame();
                $scope.closeFrame = function (event) {
                    var url = $window.location.href && $window.location.href.split('#')[0] || '';

                    if (url.indexOf('proxflow') > -1) {
                        url = url.replace('proxflow', 'webapps/helios');
                    }

                    url += url.slice(-1) === '&' ? 'escape_hatch=1' : '&escape_hatch=1';

                    if (url.indexOf('hermes') > -1 || url.indexOf('checkoutnow')) {
                        $logger.info('HERMES_ESCAPE_HATCH_CLICKED');
                    } else {
                        $logger.info('HELIOS_ESCAPE_HATCH_CLICKED');
                    }

                    $window.top.location = url;
                    $scope.$emit('exitFrame');
                };
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/experience/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ExperienceComponent = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/experience/template.html");

var _template2 = _interopRequireDefault(_template);

var _fiMeta = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _fiMeta2 = _interopRequireDefault(_fiMeta);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $ExperienceComponent = exports.$ExperienceComponent = _squid.$Component.extend('ExperienceComponent', {
    tag: 'experience',
    template: _template2['default'],
    transclude: true,
    props: {
        flag: {
            type: 'str',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                // temporary until experience layer develops, which should do all of this logic via flag config (something like `experienceConfig.get('flag')`)
                fiMeta: _fiMeta2['default'].instance(_angular.$rootScope.token).fetch()['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        populate: function populate() {
            var negate = this.props.flag[0] === '!';
            var fiMeta = this.models.fiMeta;

            // lies

            this.renderExperience = fiMeta && fiMeta.cardArtEnabled();

            if (negate) {
                this.renderExperience = !this.renderExperience;
            }
        }
    }
});

angular.value("$ExperienceComponent", $ExperienceComponent);
_squid.$Component;

_angular.$rootScope;

_angular.noop;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/experience/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-style=\"style\">\n    <ng-transclude ng-if=\"renderExperience\"></ng-transclude>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/expired-fi-panel/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/expired-fi-panel/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/expired-fi-panel/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoExpiredFiPanel', {
    tag: 'xo-expired-fi-panel',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        fi: {
            type: 'var',
            required: false
        }
    }
});


_squid.$Component;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/expired-fi-panel/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$ExpiredFiPanelFactory', [function () {

    var disallowedContentMap = {
        'INSTRUMENT_VERIFICATION_FAILED': 'wallet.disallowedDueToPreAuth',
        'unsupportedGeneric': 'wallet.unsupportedDueToRisk',
        'unsupportedByProduct': 'wallet.unsupportedDueToReceiverPreference',
        'unsupportedDueToExpiration': 'wallet.unsupportedDueToExpiration'
    };
    var disallowedExp = {
        resourceName: 'xo_preauth_disallowed_instruments',
        control: 'xo_preauth_disallowed_instruments_control',
        disallowedFi: 'xo_preauth_disallowed_instruments_disallowed_fi',
        preAuth: 'xo_preauth_disallowed_instruments_preauth'
    };

    var getPxpResult = function getPxpResult(models) {
        var schedule = models.cart && models.cart.isBilling() ? 'BILLING' : 'ONE_TIME_PAYMENT';
        var approval_type = models.cart && models.cart.isPurchase() ? 'PURCHASE' : 'NOT_PURCHASE';
        var solution = _squid.$integration.isFlow('WPS') ? 'WEBSITE_PAYMENTS_STANDARD' : 'EXPRESS_CHECKOUT';

        return (0, _squid.$elmo)(disallowedExp.resourceName, { 'ctx.country': _squid.$locale.country, 'ctx.flow': 'HERMES', 'ctx.schedule': schedule, 'ctx.approval_type': approval_type, 'ctx.solution': solution }, disallowedExp.resourceName + '(.*)').then(function (result) {
            return result && result.treatment_name;
        });
    };

    var filterInstrumentsFromDisallowed = function filterInstrumentsFromDisallowed(instrument, fundingOptions) {
        var match = fundingOptions.find(function (fundingInstrument) {
            return fundingInstrument.id === instrument.id;
        });
        return match === undefined;
    };

    var disallowedDueToPreAuth = function disallowedDueToPreAuth(disallowedFi, fundingOptions) {
        return disallowedFi.filter(function (i) {
            return i.declineReason === 'INSTRUMENT_VERIFICATION_FAILED' && i.isPreferred !== true && filterInstrumentsFromDisallowed(i, fundingOptions);
        });
    };

    var disallowedDueToOther = function disallowedDueToOther(disallowedFi, fundingOptions) {
        return disallowedFi.filter(function (i) {
            return i.type && i.type !== 'REWARDS' && i.declineReason !== 'INSTRUMENT_VERIFICATION_FAILED' && i.isPreferred !== true && filterInstrumentsFromDisallowed(i, fundingOptions);
        });
    };

    var mapDisallowedContent = function mapDisallowedContent(disallowed) {
        if (disallowed.type === 'CARD') {
            disallowed.message = disallowedContentMap[disallowed.declineReason] ? disallowedContentMap[disallowed.declineReason] : disallowedContentMap['unsupportedGeneric'];
            return disallowed;
        } else {
            disallowed.message = disallowedContentMap['unsupportedGeneric'];
            return disallowed;
        }
    };

    var getAllInstruments = function getAllInstruments(models) {
        var instruments = [].concat(models.checkoutSession.get('fundingOptions').getDisplayInstruments());

        return getPxpResult(models).then(function (result) {
            if (result === disallowedExp.control) {
                return _squid.$promise.resolve(instruments);
            } else if (result === disallowedExp.disallowedFi || result === disallowedExp.preAuth) {
                var disallowedFi = models.checkoutSession.getDisallowedInstruments();

                if (!disallowedFi) {
                    return _squid.$promise.resolve(instruments);
                }
                var fundingOption = models.checkoutSession.get('fundingOptions.instruments');
                var disallowedPreAuth = disallowedDueToPreAuth(disallowedFi, fundingOption);
                var disallowedPreferred = models.checkoutSession.getDisallowedPreferred();
                var disallowedOther = disallowedDueToOther(disallowedFi, fundingOption);

                if (disallowedPreferred) {
                    instruments.push(mapDisallowedContent(disallowedPreferred));
                }
                if (disallowedPreAuth && disallowedDueToPreAuth.length) {
                    _squid.$util.forEach(disallowedDueToPreAuth, function (instrument) {
                        instruments.push(mapDisallowedContent(instrument));
                    });
                }
                if (disallowedOther && disallowedOther.length) {
                    _squid.$util.forEach(disallowedOther, function (instrument) {
                        instruments.push(mapDisallowedContent(instrument));
                    });
                }
            }
            return _squid.$promise.resolve(instruments);
        });
    };

    return {
        getPxpResult: getPxpResult,
        getAllInstruments: getAllInstruments,
        disallowedExp: disallowedExp
    };
}]);

_squid.$util;

_squid.$locale;

_squid.$promise;

_squid.$elmo;

_squid.$integration;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-ui-components/src/expired-fi-panel", "../node_modules/xo-ui-components/src/expired-fi-panel/factory.js"))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/expired-fi-panel/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/expired-fi-panel/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"disallowedFiPanel\" ng-if=\"fi.declineReason\" content>\n    <span ng-if=\"fi.isPreferred\" class=\"preferredLabel\">{{ content('memberReview.preferred') }}</span>\n    <span class=\"message\">{{ content(fi.message) }}</span>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/expired-message/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/expired-message/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/expired-message/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoExpiredMessage', {
    tag: 'xo-expired-message',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()
            };
        }
    },
    actions: {
        goToManageWallet: function goToManageWallet(fiID) {
            if (fiID) {
                _logger.$logger.info('update_expired_preferred');
                _uiRouter.$state.go('checkout.review.sidebar.sidebarUpdateCard.addCardFlow.addCard', {
                    planId: fiID,
                    doneUri: 'checkout.review'
                });
            } else {
                _logger.$logger.info('manage_expired_cards');
                _uiRouter.$state.go('checkout.review.sidebar.sidebarManageWallet');
            }
        }
    },

    lifecycle: {
        populate: function populate() {
            // if (this.experiments.showPreferredExpiredMsg === 'xo_hermes_preferred_expired_msg_review_page_treatment') {
            //     this.preferredExpired = this.models.checkoutSession.getDisallowedPreferred();
            // }
        }
    }
});


_uiRouter.$state;

_squid.$Component;

_logger.$logger;

_index.$CheckoutSessionModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/expired-message/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/expired-message/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"preferredExpired\" id=\"notifications\" content>\n    <div class=\"msgPage msg-info\">\n        <span class=\"icon\"></span>\n        <ul>\n            <li>\n                <span ng-bind-html=\"htmlContent('creditcard.preferredExpired', {cardType: preferredExpired.displayName, last4:\n                    preferredExpired.lastDigits})\" ></span><span>\n                    <a id=\"updatePreferredExpired\" track-submit=\"update_preferred_expired\" href\n                       ng-click=\"actions.goToManageWallet(preferredExpired.id)\">{{content('creditcard.updateItNow')}}</a></span>\n            </li>\n        </ul>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/fi-panel/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _fiMeta = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _fiMeta2 = _interopRequireDefault(_fiMeta);

var _template = __webpack_require__("../node_modules/xo-ui-components/src/fi-panel/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/fi-panel/styles.less");

__webpack_require__("../node_modules/xo-ui-components/src/cardicon/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Pulling out props to iterate over keys
var PROPS = {
    fi: {
        required: false,
        type: 'var'
    },
    plan: {
        required: false,
        type: 'var'
    },
    // Specifically override name
    nameOverride: {
        required: false,
        type: 'var'
    },
    // Ignore different rendering for PAD
    ignorePad: {
        required: false,
        type: 'var'
    },
    // Dont render extra details
    sparse: {
        required: false,
        type: 'var'
    },
    // Requires fi to be passed in
    showAmount: {
        required: false,
        type: 'var'
    },
    // Requires fi to be passed in
    showCurrencyCode: {
        required: false,
        type: 'var'
    },
    // Requires plan to be passed in
    showAllCurrencyCodes: {
        required: false,
        type: 'var'
    },
    // Since SacEligible is not computable through helper function, pass in as object.
    // Take `contentKey` as a param
    noNoNoSacEligible: {
        required: false,
        type: 'var'
    }
};

exports['default'] = _squid.$Component.extend('xoFiPanel', {
    tag: 'xo-fi-panel',
    template: _template2['default'],
    transclude: true,
    props: PROPS,
    resolve: {
        models: function models() {
            return {
                fiMeta: _fiMeta2['default'].instance(_angular.$rootScope.token).fetch()
            };
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this = this;

            render.call(this);
            // Props on scope is not iterable, so creating a group to watch from the definition
            this.$watchGroup(Object.keys(PROPS).map(function (p) {
                return 'props.' + p;
            }), function () {
                return render.call(_this);
            });
        }
    }
});

// TODO: figure out pad rendering

function render() {
    var _props = this.props,
        fi = _props.fi,
        plan = _props.plan,
        sparse = _props.sparse,
        showAmount = _props.showAmount,
        showCurrencyCode = _props.showCurrencyCode,
        showAllCurrencyCodes = _props.showAllCurrencyCodes,
        nameOverride = _props.nameOverride,
        ignorePad = _props.ignorePad;
    var fiMeta = this.models.fiMeta;


    var type = !fi ? 'BALANCE' : fiMeta.type(fi);

    this.name = nameOverride || fiMeta.getName(fi);

    var amount = void 0;
    var currencyCodes = void 0;
    var sld = {};
    var secondLineType = void 0;

    if (showAmount) {
        amount = fiMeta.getAmount(fi);
    } else if (showAllCurrencyCodes) {
        currencyCodes = fiMeta.getAllCurrencyCodes(plan).join(', ');
    } else if (showCurrencyCode) {
        currencyCodes = fiMeta.getCurrencyCode(fi);
    }

    if (type === 'CREDIT') {
        if (this.props.noNoNoSacEligible) {
            secondLineType = 'credit';
            sld.sacEligible = this.props.noNoNoSacEligible;
        }
    } else if (!nameOverride && fiMeta.isPad(fi) && !ignorePad) {
        secondLineType = 'pad';

        var mask = fiMeta.getCardMask(fi);

        _squid.$util.extend(sld, mask);
    } else if (fi) {
        // Try to render a card mask
        var _mask = fiMeta.getCardMask(fi);

        if (_mask.before || _mask.after) {
            secondLineType = 'mask';
            _squid.$util.extend(sld, _mask);

            if (!sparse) {
                // MEFT/IACH info is only relevant in DE
                if (_squid.$locale.country === 'DE' && fiMeta.isMeft(fi)) {
                    sld.meft = true;
                } else if (_squid.$locale.country === 'DE' && (
                // HACK: when ignorePad name, pretend this is Iach
                fiMeta.isIach(fi) || ignorePad)) {
                    sld.iach = true;
                } else if (fiMeta.isEcheck(fi)) {
                    sld.echeck = true;
                } else if (fiMeta.wallet.isChaseLinkedCard(fi)) {
                    sld.chasePay = true;
                }
            }
        }
    }

    _squid.$util.extend(this, {
        amount: amount,
        currencyCodes: currencyCodes,
        secondLineData: sld,
        secondLineType: secondLineType
    });
}

_angular.$rootScope;

_squid.$Component;

_squid.$util;

_squid.$locale;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/fi-panel/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/fi-panel/template.html":
/***/ (function(module, exports) {

module.exports = "<div angular class=\"fsPanel\" content ng-class=\"[fi.type]\">\n    <div class=\"fsdetails fsPanelLeft\">\n        <xo-fi-icon fi=\"fi\" class-name=\"fsIcon\"></xo-fi-icon>\n    </div>\n    <div class=\"fsPanelRight\">\n        <div ng-class=\"{doubleheight: !secondLineType}\">\n            <span ng-if=\"secondLineType === 'pad'\" class=\"fsPanelName\" data-test-id=\"fiName\">{{content('fundingInstruments.pad')}}</span>\n            <span ng-if=\"secondLineType !== 'pad'\" class=\"fsPanelName\" data-test-id=\"fiName\" ng-bind-html=\"name\"></span>&rlm; <span ng-if=\"currencyCodes\">({{currencyCodes}})</span>\n            <span ng-if=\"amount\" class=\"methodAmount\">\n                <span class=\"amountFormatted\">\n                    <format-currency\n                    code=\"amount.currency_code\"\n                    amount=\"amount.amount\"></format-currency>\n                </span>\n            </span>\n        </div>\n        <div ng-if=\"secondLineType\" class=\"fsPanelSecondLine\">\n            <div ng-switch=\"secondLineType\">\n                <div ng-switch-when=\"credit\" ng-bind-html=\"secondLineData.sacEligible\"></div>\n                <div ng-switch-when=\"pad\">\n                    {{name}}\n                    <span class=\"cardMask\"><span/><span/><span/><span/></span>\n                    {{secondLineData.after}}\n                </div>\n                <div ng-switch-when=\"mask\">\n                    <span ng-if=\"secondLineData.chasePay\" class=\"chasePayLogo\">\n                        <span class=\"fsIcon CHASEPAY\"><span class=\"accessAid\">Chase Pay</span></span> | \n                    </span>\n                    {{secondLineData.before}}\n                    <span class=\"cardMask\"><span/><span/><span/><span/></span>{{secondLineData.after}}\n\n                    <span ng-if=\"secondLineData.meft\">\n                        {{content('fundingInstruments.meft')}}\n                    </span>\n                    <span ng-if=\"secondLineData.iach\">\n                        {{content('fundingInstruments.iach')}}\n                    </span>\n                    <span ng-if=\"secondLineData.echeck\">\n                        {{content('fundingInstruments.eCheck')}}\n                    </span>\n                </div>\n            </div>\n        </div>\n        <div class=\"fsPanelChildren\" ng-transclude></div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/floating-label/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/floating-label/styles.less");

var treatmentType = void 0;
var newLocale = void 0;
var oldLocale = void 0;

function getTreatment() {
    if (treatmentType !== undefined) {
        return treatmentType;
    }
    if ((0, _squid.$feature)('floatingLabels')) {
        return true;
    }
    var token = _angular.$rootScope.token;
    var throttle = _squid.$config['floatingLabelLocales'] && _squid.$config['floatingLabelLocales'][_squid.$locale.country] && _squid.$config['floatingLabelLocales'][_squid.$locale.country][_squid.$locale.lang];
    var id = _squid.$locale.lang + '_' + _squid.$locale.country + token;

    treatmentType = throttle && (0, _squid.$experiment)('floating_label_exp', throttle, id, {}) ? true : false;
    return treatmentType;
}

(0, _squid.$registerDirective)('floating-label', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            scope.$on('localeChange', function () {
                newLocale = _squid.$locale.country + '_' + _squid.$locale.lang;

                if (oldLocale !== newLocale) {
                    treatmentType = undefined;
                    oldLocale = newLocale;
                }
                scope.showFloatingLabels = getTreatment();
            });

            (0, _angular.$timeout)(function () {
                scope.showFloatingLabels = getTreatment();

                scope.$watch('showFloatingLabels', function (val) {
                    // remove else block after experimentation is complete
                    if (val) {
                        element.addClass('floatingLabel');
                        element.removeClass('noFloatingLabel');
                    } else {
                        element.removeClass('floatingLabel');
                        element.addClass('noFloatingLabel');
                    }
                });

                var input = element.find('input');

                if (input.attr('placeholder')) {
                    input.addClass('hasPlaceholder');
                }

                // To hide the placeholder labels for pre-populated input fields
                scope.$watch(input.attr('ng-model'), function (value) {
                    input.toggleClass('focused', !!value);
                });

                // We're using this as an alternative to watching 'ng-model' since this properly triggers the focused CSS property on email input.
                input.on('keyup', function (event) {
                    var val = event.target.value;

                    input.toggleClass('focused', !!val);
                });

                input.on('focus blur click', function (event) {
                    if (scope.showFloatingLabels) {
                        input.toggleClass('focused', event.type === 'focus' || this.value.length > 0);
                    }
                });

                if (!('disableAutoblur' in attrs)) {
                    input.trigger('blur');
                }
            });
        }
    };
});

(0, _squid.$registerDirective)('floating-label-dropdown', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            scope.$on('localeChange', function () {
                newLocale = _squid.$locale.country + '_' + _squid.$locale.lang;

                if (oldLocale !== newLocale) {
                    treatmentType = undefined;
                    oldLocale = newLocale;
                }
                scope.showFloatingLabels = getTreatment();
            });

            (0, _angular.$timeout)(function () {
                scope.showFloatingLabels = getTreatment();
                scope.$watch('showFloatingLabels', function (val) {
                    // remove else block after experimentation is complete
                    if (val) {
                        element.addClass('floatingLabel');
                        element.removeClass('noFloatingLabel');
                    } else {
                        element.removeClass('floatingLabel');
                        element.addClass('noFloatingLabel');
                    }
                });

                var select = element.find('select');
                var label = element.find('label');
                var flSpan = element.find('.custom-select span span');

                select.on('change mouseenter mouseleave blur', function (event) {
                    var value = event.currentTarget.value;

                    select.toggleClass('focused', event.type === 'change' || value.length > 0);
                    flSpan.toggleClass('noValue', value.length < 1);
                    label.toggleClass('hide', value.length < 1);
                }).trigger('mouseleave');
            });
        }
    };
});

_angular.$timeout;

_angular.$rootScope;

_squid.$locale;

_squid.$experiment;

_squid.$config;

_squid.$feature;

_squid.$registerDirective;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/floating-label/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/generic-error/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _index2 = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/banner/directive.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/generic-error/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/generic-error/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TITLE_KEY_MAPPING = {
    BLOCK_NON_DOMESTIC_SHIPPING: 'blockNonDomesticShippingTitle',
    BLOCK_PPC_INELIGIBLE_USER: 'blockPPCIneligibleTitle',
    COMPLIANCE_VIOLATION: 'transactionRefusedTitle',
    DOMESTIC_TRANSACTION_REQUIRED: 'domesticTransactionRequiredTitle',
    GAMER_LOGIN_OUT_OF_COUNTRY: 'sorry',
    GAMER_RESIDENCE_OUT_OF_COUNTRY: 'sorry',
    HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'payerCountryNotAllowedTitleMemberDCF',
    INTERNAL_SERVICE_ERROR: 'transactionRefusedTitle',
    NEGATIVE_BALANCE_TRANSACTION_REFUSED: 'negativeBalanceRefusedTitle',
    PAYEE_ACCOUNT_LOCKED_OR_CLOSED: 'payeeAccountLockedOrClosedTitle',
    PAYER_COUNTRY_NOT_ALLOWED: 'payerCountryNotAllowedTitle',
    PAYER_COUNTRY_NOT_ENABLED: 'payerCountryNotAllowedTitle',
    PAYER_LOGIN_COUNTRY_NOT_ALLOWED: 'payerCountryNotAllowedTitle',
    PAYMENT_PROCESS_ERROR: 'paymentProcessError',
    RETRY: 'sorry',
    SENDING_LIMIT_EXCEEDED: 'genericErrorMessageTitle',
    STUDENT_ACCOUNT: 'studentAccountTitle',
    TRANSACTION_REFUSED: 'transactionRefusedTitle',
    XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'payerCountryNotAllowedTitleSignupDCF',
    CREDIT_CARD_AUTH_FAILED: 'smartDollarAuthFailedMsg'
};

var CONTENT_KEY_MAPPING = {
    ACCOUNT_CANNOT_BE_FETCHED: 'genericError',
    AGREEMENT_ALREADY_CREATED: 'agreementAlreadyCreated',
    // TODO: rename to a common one, e.g TOKENIZED_WALLET_ELIGIBILITY_ERROR later
    ANDROID_PAY_ALREADY_PROVISIONED: 'tokenizedWalletAlreadyProvisioned',
    ANDROID_PAY_ELIGIBILITY_ERROR: 'tokenizedWalletGenericError',
    // end of TODO
    BLOCK_NON_DOMESTIC_SHIPPING: 'blockNonDomesticShippingMessage',
    BLOCK_PPC_INELIGIBLE_USER: 'blockPPCIneligibleMessage',
    COMPLIANCE_VIOLATION: 'complianceViolationMessage',
    DEFAULT_TOKENIZED_WALLET_ERROR: 'tokenizedWalletGenericError',
    DEFAULT: 'genericError',
    DOMESTIC_TRANSACTION_REQUIRED: 'domesticTransactionRequiredMessage',
    DUPLICATE_INVOICE_ID: 'duplicateInvoiceId',
    EINVALIDCSRF_JWT_EXPIRED: 'csrfTokenExpired',
    EXPIRED_SESSION: 'expiredOrTokenNotFoundError',
    GAMER_ACCOUNT_UNVERIFIED: 'accountUnverified',
    GAMER_INELIGIBLE: 'transactionRefusedTitle',
    GAMER_FI_INELIGIBLE: 'fiIneligible',
    GAMER_FI_UNCONFIRMED: 'fiUnconfirmed',
    GAMER_INVALID_ACCOUNT_TYPE: 'invalidAccountType',
    GAMER_LOGIN_OUT_OF_COUNTRY: 'unauthorizedCountryLogin',
    GAMER_NO_VALID_FUNDING_INSTRUMENT: 'fiIneligible',
    GAMER_RESIDENCE_OUT_OF_COUNTRY: 'unauthorizedCountryAccountRegistered',
    GAMING_FUNDING_SOURCE_VALIDATION_FAILED: 'unauthorizedCountryAccountRegistered',
    GUEST_UPGRADE_ERROR: 'guestUpgradeError',
    GUEST_UPGRADE_SESSION_ERROR: 'guestUpgradeSessionError',
    HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'unauthorizedCountryAccountMemberDCF',
    INTERNAL_SERVICE_ERROR: 'transactionRefusedMessage',
    INVALID_RESOURCE_ID: 'expiredOrTokenNotFoundError',
    NEGATIVE_BALANCE_TRANSACTION_REFUSED: 'negativeBalanceRefusedMessage',
    PAYEE_ACCOUNT_LOCKED_OR_CLOSED: 'payeeAccountLockedOrClosed',
    PAYEE_BLOCKED_TRANSACTION: 'paymentDeniedError',
    PAYER_CANNOT_PAY: 'paymentDeniedError',
    PAYER_COUNTRY_NOT_ALLOWED: 'unauthorizedCountryAccountRegistered',
    PAYER_COUNTRY_NOT_ENABLED: 'rpUnauthorizedCountryMessage',
    PAYER_LOGIN_COUNTRY_NOT_ALLOWED: 'unauthorizedCountryLogin',
    PAYMENT_ALREADY_DONE: 'paymentAlreadyCompletedError',
    PAYMENT_DENIED: 'paymentDeniedError',
    PAYMENT_PROCESS_ERROR: 'chooseOtherWayToPay',
    RESTRICTED_USER: 'buyerRestrictedError',
    RETRY: 'thingsNotWorking',
    SENDING_LIMIT_EXCEEDED: 'sendingLimitExceeded',
    STUDENT_ACCOUNT: 'studentAccountMessage',
    TRANSACTION_LIMIT_EXCEEDED: 'transactionLimitExceeded',
    TRANSACTION_REFUSED: 'transactionRefusedMessage',
    CREDIT_CARD_AUTH_FAILED: 'transactionRefusedMessage',
    UNSUPPORTED_COUNTRY: 'unsupportedCountry',
    UNSUPPORTED_DUE_TO_RECEIVER_PREFERENCE: 'unsupportedReceiverPreferences',
    UNSUPPORTED_PAYEE_CURRENCY: 'unsupportedPayeeCurrency',
    XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'unauthorizedCountryAccountSignupDCF'
};

// pass merchantName attribute, if undefined, then suffix 'Default' to key
var renderContentWithMerchantName = function renderContentWithMerchantName(key) {
    var merchantNameFromProps = this.props.merchant;

    // we may not get merchantName as props, look for models also
    var merchantNameFromModels = void 0;
    if (this.models && this.models.checkoutAppData && this.models.checkoutAppData.merchant) {
        var merchant = this.models.checkoutAppData.merchant;

        merchantNameFromModels = merchant.brand_name || merchant.merchant_name;
    }

    var merchantName = merchantNameFromProps || merchantNameFromModels;

    if (merchantName) {
        return (0, _squid.$renderContent)(key, { merchantName: merchantName });
    }

    return (0, _squid.$renderContent)(key + 'Default');
};

var renderContentWithWalletTokenizationName = function renderContentWithWalletTokenizationName(key) {
    var brandName = this.models.tokenizedWalletInfoModel.brandName();

    return (0, _squid.$renderContent)(key, { type: brandName });
};

// handle non-standard merchant error title strings
var TITLE_KEY_HANDLER = {
    DOMESTIC_TRANSACTION_REQUIRED: renderContentWithMerchantName,
    HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName,
    XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName
};

// handle non-standard merchant error content strings
var CONTENT_KEY_HANDLER = {
    AGREEMENT_ALREADY_CREATED: renderContentWithMerchantName,
    ANDROID_PAY_ALREADY_PROVISIONED: renderContentWithWalletTokenizationName,
    DEFAULT_TOKENIZED_WALLET_ERROR: renderContentWithWalletTokenizationName,
    DOMESTIC_TRANSACTION_REQUIRED: renderContentWithMerchantName,
    HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName,
    XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName
};

var SHOW_LOGOUT_LINK_CODES = ['HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF', 'ANDROID_PAY_COUNTRY_NOT_SUPPORTED', 'ANDROID_PAY_ALREADY_PROVISIONED', 'GAMER_INVALID_ACCOUNT_TYPE'];

var HIDE_CANCEL_LINK_CODES = ['PAYER_COUNTRY_NOT_ALLOWED', 'GAMING_FUNDING_SOURCE_VALIDATION_FAILED', 'PAYER_LOGIN_COUNTRY_NOT_ALLOWED'];

var RETRY_LINK = ['EINVALIDCSRF_JWT_EXPIRED', 'GUEST_CHECKOUT_NOT_ALLOWED', 'RETRY'];

var TRANSACTION_REFUSED_BA_TITLE_MSG = {
    BA_NO_PURCHASE: 'transactionRefusedBAnoPurchaseTitle',
    BA_WITH_PURCHASE: 'transactionRefusedBAPurchaseTitle'
};

/* eslint-disable fasec/no-unsafe-regex */
var base64regex = new RegExp('^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$');

exports['default'] = _squid.$Component.extend('$xoGenericErrorComponent', {
    tag: 'xo-generic-error',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        logout: {
            type: 'var',
            required: false
        },
        isUnbranded: {
            type: 'var',
            required: false
        },
        cancelUrl: {
            type: 'str',
            required: false
        },
        merchant: {
            type: 'str',
            required: false
        }
    },
    resolve: {
        models: function models() {
            if (this.props.token) {
                return {
                    checkoutAppData: _index3.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](angular.noop),
                    cart: _index3.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](angular.noop),
                    checkoutPayee: _index3.$CheckoutPayeeModel.instance(this.props.token).retrieve()['catch'](angular.noop),
                    auth: _index.$AuthModel.instance().retrieve()['catch'](angular.noop),
                    tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance(this.props.token).retrieve()['catch'](angular.noop)
                };
            }
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            var cancelPreventStateChange = _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                event.preventDefault();
            });

            this.$on('$destroy', cancelPreventStateChange);

            var self = this;

            // to not break other application's error integration, we'll still support base64 decoded code parameters
            if (_uiRouter.$stateParams.code && base64regex.test(_uiRouter.$stateParams.code)) {
                self.errorCode = _squid.$util.base64Decode(_uiRouter.$stateParams.code);
            } else {
                self.errorCode = _uiRouter.$stateParams.code;
            }

            self.hideCancelLink = HIDE_CANCEL_LINK_CODES.indexOf(self.errorCode) > -1;
            self.retryLink = RETRY_LINK.indexOf(self.errorCode) > -1;

            _angular.$rootScope.allowUnload = true;
            self.cancelLink = self.props.cancelUrl;

            self.cancelRedirect = function ($event) {
                $event.preventDefault();
                var redirectUrl = self.cancelLink;

                if (_angular.$rootScope.partnerIntegration) {
                    _logger.$logger.info('genericerror_partner_integration');
                    redirectUrl = _squid.$util.buildURL(self.cancelLink, { error: 'true' });
                }

                _index2.$ReturnToMerchant.goTo(redirectUrl);
            };

            self.retryCheckout = function ($event) {
                $event.preventDefault();
                _squid.$util.reload();
            };

            self.isMessengerBAIntegration = _squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');

            self.loggingOut = function ($event) {
                $event.preventDefault();
                cancelPreventStateChange();
                self.props.logout();
            };

            (0, _jquery2['default'])('.paypalHeaderWrapper').hide();
            // Cancel link should be shown for "Credit Ineligible" page for DE
            if (self.errorCode !== 'BLOCK_PPC_INELIGIBLE_USER') {
                (0, _jquery2['default'])('#defaultCancelLink').hide();
            }
            (0, _jquery2['default'])('.footerWrapper').addClass('genericError');

            self.$on('$destroy', function (event) {
                (0, _jquery2['default'])('.paypalHeaderWrapper').show();
                if (self.errorCode !== 'BLOCK_PPC_INELIGIBLE_USER') {
                    (0, _jquery2['default'])('#defaultCancelLink').show();
                }
                (0, _jquery2['default'])('.footerWrapper').removeClass('genericError');
            });

            // Returns the title string, based on custom key handler
            self.getTitle = function () {
                var key = self.titleKey;

                if (TITLE_KEY_HANDLER.hasOwnProperty(self.errorCode)) {
                    return TITLE_KEY_HANDLER[self.errorCode].call(_this, key);
                }
                return (0, _squid.$renderContent)(key);
            };

            // Returns the content string, based on custom key handler
            self.getContent = function () {
                var key = self.contentKey;

                if (CONTENT_KEY_HANDLER.hasOwnProperty(self.errorCode)) {
                    return CONTENT_KEY_HANDLER[self.errorCode].call(_this, key);
                }
                return (0, _squid.$renderContent)(key);
            };

            // Returns the cancel button label, based on presence of brand/merchant name
            self.getCancelLabel = function () {
                if (self.walletTokenization) {
                    var brandName = _this.models.tokenizedWalletInfoModel.brandName();

                    return (0, _squid.$renderContent)('common.backToTokenizedWalletB', { type: brandName });
                } else {
                    var merchantName = _this.props.merchant;

                    return (0, _index2.formatReturnContent)(_squid.$renderContent, merchantName);
                }
            };

            this.personalizedBanner = {
                show: false
            };

            _logger.$logger.info('checkout_fpti', {
                landing_page: 'error_page',
                int_error_code: '1',
                int_error_description: _uiRouter.$stateParams.code
            });
        },
        populate: function populate() {
            var _models = this.models,
                checkoutAppData = _models.checkoutAppData,
                checkoutPayee = _models.checkoutPayee,
                cart = _models.cart,
                auth = _models.auth;


            this.walletTokenization = cart && cart.isWalletTokenization();
            this.personalizedBanner.show = auth && auth.rememberedOT() && (0, _squid.$feature)('oneTouchPersonalization');

            if (checkoutAppData) {
                this.cancelLink = checkoutAppData.urls.cancel_url;
            }

            if (checkoutPayee) {
                var merchant = checkoutPayee.merchant;


                if (merchant.id && !this.hideCancelLink) {
                    var hcl = _squid.$config.hideCancelLinkForMerchant;

                    var shouldHide = hcl && hcl.indexOf(merchant.id) !== -1;

                    if (shouldHide) {
                        this.hideCancelLink = true;
                    }
                }
            }

            if (auth) {
                this.showLogoutLink = _squid.$util.param('source') !== 'consumerApp' && this.props.logout && SHOW_LOGOUT_LINK_CODES.indexOf(this.errorCode) > -1 && !auth.disallow_login_switch; // disallow_login_switch is used for Google Pay - acount linking to hide "not you" button (see xo-hercules/auth/outputMapper)

                this.formattedNameInformal = (0, _squid.formatNameInformal)({
                    first_name: auth.first_name,
                    last_name: auth.last_name
                }) || auth.email;
            }

            // Map error code for Android Pay
            if (this.walletTokenization) {
                // For Android Pay, map all errors to generic Android Pay error except for
                // ANDROID_PAY_ALREADY_PROVISIONED
                if (this.errorCode !== 'ANDROID_PAY_ALREADY_PROVISIONED') {
                    this.errorCode = 'DEFAULT_TOKENIZED_WALLET_ERROR';
                }
            }

            var titleKey = this.errorCode && TITLE_KEY_MAPPING[this.errorCode];

            if (titleKey) {
                if (titleKey === 'transactionRefusedTitle' && cart && cart.isBillingNoPurchase()) {
                    this.titleKey = 'genericError.' + TRANSACTION_REFUSED_BA_TITLE_MSG['BA_NO_PURCHASE'];
                } else if (titleKey === 'transactionRefusedTitle' && cart && cart.isBillingPurchase()) {
                    this.titleKey = 'genericError.' + TRANSACTION_REFUSED_BA_TITLE_MSG['BA_WITH_PURCHASE'];
                } else {
                    this.titleKey = 'genericError.' + titleKey;
                }
            }

            var contentKey = this.errorCode && CONTENT_KEY_MAPPING[this.errorCode] || CONTENT_KEY_MAPPING.DEFAULT;
            this.contentKey = 'genericError.' + contentKey;
        }
    }
});


_angular.$rootScope;

_uiRouter.$stateParams;

_logger.$logger;

_index.$AuthModel;

_app.$TokenizedWalletInfoModel;

_index2.$ReturnToMerchant;

_index2.formatReturnContent;

_squid.$Component;

_squid.$util;

_squid.$renderContent;

_squid.$config;

_squid.formatNameInformal;

_squid.$integration;

_squid.$feature;

_index3.$CheckoutAppDataModel;

_index3.$CheckoutCartModel;

_index3.$CheckoutPayeeModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/generic-error/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/generic-error/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"genericError\" content>\n    <div class=\"container\">\n        <div class=\"logo\" ng-if=\"!props.isUnbranded\"></div>\n\n        <xo-banner ng-if=\"personalizedBanner.show && !isMessengerBAIntegration && showLogoutLink\" class=\"banner\">\n            <p class=\"userEmail\" id=\"reviewUserInfo\">\n                {{ content('memberReview.loggedInWithOneTouch', {userName: formattedNameInformal, lastName: models.auth.last_name, firstName: models.auth.first_name}) }}\n                <a track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"loggingOut($event)\">{{ content('memberReview.notYou')}}</a>\n            </p>\n        </xo-banner>\n        <div ng-if=\"!personalizedBanner.show && !isMessengerBAIntegration && showLogoutLink\" class=\"banner\">\n            <p class=\"userEmail\" id=\"reviewUserInfo\">\n                {{ content('creditcard.hi', {userName: formattedNameInformal}) }}\n                <a track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"loggingOut($event)\">{{ content('memberReview.notYou')}}</a>\n            </p>\n        </div>\n\n        <div class=\"title\" ng-if=\"titleKey\">\n            {{ getTitle() }}\n        </div>\n        <div class=\"message\"\n            ng-if=\"contentKey\"\n            ng-bind-html=\"getContent()\">\n        </div>\n        <p class=\"retryLink\" ng-if=\"retryLink\">\n            <a link-button ng-click=\"retryCheckout($event)\" id=\"retryLink\" class=\"btn full\">\n                {{ content('genericError.tryAgain') }}\n            </a>\n        </p>\n        <p class=\"cancelLink\" ng-if=\"cancelLink && !hideCancelLink\">\n            <a href=\"{{cancelLink}}\" ng-click=\"cancelRedirect($event)\" id=\"cancelLink\" ng-class=\"['btn', 'full', {'btn-secondary': retryLink}]\">\n                {{ getCancelLabel() }}\n            </a>\n        </p>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/generic-message/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/generic-message/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, angular, squid, template) {

    return angular.module('xo-generic-message.directive', ['squid']).directive('xoGenericMessage', ['$rootScope', function ($rootScope) {

        return {
            template: template,

            scope: {
                token: '=?'
            },

            controller: ['$scope', '$rootScope', '$stateParams', '$state', '$logger', '$populate', function ($scope, $rootScope, // eslint-disable-line no-shadow
            $stateParams, $state, $logger, $populate) {

                $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                    event.preventDefault();
                });

                $('.paypalHeaderWrapper').hide();
                $('.footerWrapper').addClass('genericMessage');

                var titleKeyMapping = {
                    PAYMENT_SUCCESS: 'paymentSuccessTitle',
                    DEFAULT: 'paymentSuccessTitle'
                };

                $scope.titleKey = 'genericMessage.' + ($stateParams.code && titleKeyMapping[$stateParams.code]) || titleKeyMapping.DEFAULT;

                var contentKeyMapping = {
                    PAYMENT_SUCCESS: 'paymentSuccessMessage',
                    DEFAULT: 'paymentSuccessMessage'
                };
                var contentKey = $stateParams.code && contentKeyMapping[$stateParams.code];

                if (contentKey) {
                    $scope.contentKey = 'genericMessage.' + contentKey;
                }

                $scope.$on('$destroy', function (event) {
                    $('.paypalHeaderWrapper').show();
                    $('.footerWrapper').removeClass('genericMessage');
                });
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/link/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/link/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/link/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoLink', {
    tag: 'xo-link',
    template: _template2['default'],
    props: {
        onClick: {
            type: 'var',
            required: false
        },
        leftIcon: {
            type: 'str',
            required: false
        },
        rightIcon: {
            type: 'str',
            required: false
        },
        goTo: {
            type: 'str',
            required: false
        },
        label: {
            type: 'str',
            required: false
        }
    },

    actions: {
        onClick: function onClick(event) {
            var _props = this.props,
                onClick = _props.onClick,
                goTo = _props.goTo;


            if (onClick) {
                onClick(event);
            }

            if (goTo) {
                _uiRouter.$state.go(goTo);
            }
        }
    }
});


_squid.$Component;

_uiRouter.$state;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/link/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/link/template.html":
/***/ (function(module, exports) {

module.exports = "<a class=\"common-link\" ng-click=\"actions.onClick($event)\" href='' role=\"button\">\n    <span ng-if=\"props.leftIcon\" class=\"icon left-icon {{props.leftIcon}}\"></span><span>{{props.label}}</span><span ng-if=\"props.rightIcon\" class=\"icon right-icon {{props.rightIcon}}\"></span>\n</a>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/message/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/message/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, template) {
    squid.module('xo-message.directive', ['squid']).directive('xoMessage', ['$timeout', '$loader', '$rootScope', function ($timeout, $loader, $rootScope) {
        return {
            scope: {
                message: '=?', // Expected type - {msgs: [], type: "info|error|success|warning"}
                isgreyheader: '=?'
            },
            template: template,
            link: function link(scope, element, attrs) {

                // Hide and show the alerts so that messages can be registered by
                // screen reader even if they are repeats. Uses $timeout to
                // wait for DOM before showing alerts again.
                var toggleAlert = function toggleAlert() {
                    var $alert = element.find('ul');
                    $alert.detach();
                    $timeout(function () {
                        element.find('#pageLevelErrors').append($alert);
                    });
                };

                // Toggle the alert whenever message changes by removing it and reappending it
                // to the DOM. Should fire even if message
                // is changed to the same, as assumes that the message should be reapplied.
                var cancel;
                scope.$watchCollection('message', function () {
                    if ($loader.isLoading() && !cancel) {
                        // If loading, toggle the alert after all loading calls have been made.
                        // This is so that the alert can be read by screen reader after focus
                        cancel = $rootScope.$on('allLoaded', function () {
                            cancel();
                            toggleAlert();

                            cancel = null;
                        });
                    } else {
                        toggleAlert();
                    }
                });

                scope.$on('$destroy', function () {
                    if (cancel) {
                        cancel();
                    }
                });
            }
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/mobile-pin/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/mobile-pin/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/mobile-pin/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// wrapper class which looks like password black dot
var PASSWORD_DOT_CLASS = 'passwordDot';

// wrapper class which looks like an empty grey dot
var DEFAULT_DOT_CLASS = 'defaultDot';

// delay after which input becomes a password dot, so user can see what number was entered for 1 sec
var DELAY = 600;

// back key code
var BACK_KEY = 0x8;

// check if entered pin combination is valid
var isPinValid = function isPinValid(value) {
    var onlyNumbers = /^\d{4}$/i;
    var consecutiveDigits = /^0123|1234|2345|3456|4567|5678|6789$/i;
    var commonPattern = /^0246|1357|2468|3579$/i;
    var repeatingDigits = /^([0-9])\1*$/i;
    return onlyNumbers.test(value) && !consecutiveDigits.test(value) && !commonPattern.test(value) && !repeatingDigits.test(value);
};

// check if entered input value is number before proceeding to the next input
var isKeyValid = function isKeyValid(val) {
    return (/^\d{1}/.test(val)
    );
};

// get wrapper of input element
var getWrapperElement = function getWrapperElement(el) {
    return angular.element(el).parent();
};

/**
 * This component is for setting PIN number for in-store purchases in tokenized flows (e.g Google Pay / Samsung Pay)
 * It's used in Hermes -> pages/xo-pin-setup
 * After Pin is set -> done callback is being called
 * and pin is getting saved in $TokenizedWalletPinModel and on the xo-review page there is POST API call to save it in the database (see '/api/pin/tokenizedWallet/:id')
 */
exports['default'] = _squid.$Component.extend('$xoMobilePin', {
    tag: 'xo-mobile-pin',
    template: _template2['default'],
    props: {
        /**
         * callback function passed from xo-pin-setup page in Hermes
         * which is being called when all 4 pin numbers are set
         * (even after first attempt or if it's a too simple combination)
         *
         */
        done: {
            type: 'var',
            required: false
        }
    },

    actions: {
        /**
         * Every time key is released we need to check if all 4 digits are set and so call done function
         * otherwise move cursor to the right if entered value is a number
         */
        releaseKey: function releaseKey(eventObj) {
            var currID = eventObj && eventObj.currentTarget.id;
            if (eventObj && eventObj.keyCode === BACK_KEY) {
                return;
            }
            var currEle = document.getElementById(currID);
            var currentValue = this.pinvalue[currID];

            if (this.isDone()) {
                currEle.blur();
                var pin = this.getPin();
                this.props.done(pin);
            }
            if (isKeyValid(currentValue)) {
                this.moveCursor(currID, 'right', false);
            }
        },

        /**
         * Every time key is pressed check if it was a back key
         * if yes -> move cursor to the left to the previous input
         */
        pressedKey: function pressedKey(eventObj) {
            var currID = eventObj && eventObj.currentTarget.id;

            if (eventObj && eventObj.keyCode === BACK_KEY) {
                this.moveCursor(currID, 'left', true);
            }
        },

        /**
         * Every time input is focused:
         * 1. reset input value and store value
         * 2. remove password dot class and default dot class from the parent wrapper
         */
        onFocus: function onFocus(eventObj) {
            var currID = eventObj && eventObj.currentTarget.id;
            var currEle = document.getElementById(currID);

            this.pinvalue[currID] = '';
            currEle.value = '';

            getWrapperElement(currEle).removeClass(PASSWORD_DOT_CLASS);
            getWrapperElement(currEle).removeClass(DEFAULT_DOT_CLASS);
        },

        /**
         * Every time input is unfocused:
         * 1. if current value is empty -> add default dot class to the parent wrapper
         * 2. otherwise add password dot class to the parent wrapper with a delay so user can see an entered value
         */
        onBlur: function onBlur(eventObj) {
            var currID = eventObj && eventObj.currentTarget.id;
            var currentValue = eventObj && eventObj.currentTarget.value;
            var currEle = document.getElementById(currID);
            if (!currentValue) {
                getWrapperElement(currEle).addClass(DEFAULT_DOT_CLASS);
            }
            if (!this.doingReset && currentValue) {
                (0, _angular.$timeout)(function () {
                    getWrapperElement(currEle).addClass(PASSWORD_DOT_CLASS);
                    currEle.value = '';
                }, DELAY);
            }
        },

        /**
         * since we have pseudo classes to render password dot / default dot on top of the inout ->
         * make sure element under the dot is focused every time there is a click
         */
        onWrapperClick: function onWrapperClick(eventObj) {
            angular.element(eventObj.currentTarget).find('input').focus();
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            // store of pin values
            this.pinvalue = {};
            this.doingReset = false;
            this.fields = ['field1', 'field2', 'field3', 'field4'];

            // get pin result and check if pin is too simple
            this.getPin = function () {
                var result = { value: '', error: '' };
                _this.fields.forEach(function (fieldName) {
                    result.value = result.value + String(_this.pinvalue[fieldName]);
                });
                result.error = isPinValid(result.value) ? '' : 'pin_too_simple';
                return result;
            };

            // check if all input values are set and valid
            this.isDone = function () {
                return _squid.$util.every(Object.keys(_this.pinvalue), function (key) {
                    var inputVal = _this.pinvalue[key];

                    return isKeyValid(inputVal);
                });
            };

            // move cursor to the left or right based on direction
            this.moveCursor = function (currID, direction, clearCurrent) {
                var currentIndex = _this.fields.indexOf(currID);
                var currEle = document.getElementById(currID);
                if (clearCurrent) {
                    currEle.value = '';
                    _this.pinvalue[currID] = '';
                }

                var nextIndex = void 0;
                if (direction === 'left') {
                    nextIndex = currentIndex > 0 ? currentIndex - 1 : 0;
                }
                if (direction === 'right') {
                    nextIndex = currentIndex < _this.fields.length - 1 ? currentIndex + 1 : _this.fields.length - 1;
                }

                var nextID = _this.fields[nextIndex];
                if (nextID !== currID) {
                    var nextEle = document.getElementById(nextID);
                    nextEle.focus();
                } else {
                    // if user enters value into the last input - unfocus it to prevent entering more
                    currEle.blur();
                }
            };

            // reset all inputs / store and set focus on first element
            this.reset = function () {
                _this.fields.forEach(function (fieldName) {
                    _this.pinvalue[fieldName] = '';
                    var currentElement = document.getElementById(fieldName);

                    getWrapperElement(currentElement).removeClass(PASSWORD_DOT_CLASS);
                    getWrapperElement(currentElement).addClass(DEFAULT_DOT_CLASS);
                });
                // set focus to first elemnt
                var firstInput = document.getElementById(_this.fields[0]);

                if (firstInput) {
                    firstInput.focus();
                }
                _this.doingReset = false;
            };
        },
        populate: function populate() {
            var _this2 = this;

            this.reset();
            this.$on('resetPin', function () {
                _this2.doingReset = true;
                (0, _angular.$timeout)(function () {
                    return _this2.reset();
                }, DELAY);
            });
        }
    }
});


_squid.$Component;

_squid.$util;

_angular.$timeout;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/mobile-pin/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/mobile-pin/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"mobilePin\">\n        <div class=\"numpin-wrapper\" ng-click=\"actions.onWrapperClick($event)\">\n                <input type=\"number\" inputmode=\"numeric\" pattern=\"[0-9]\" maxlength=1 id=\"field1\" autofocus=\"autofocus\" class=\"numpin\" ng-keyup=\"actions.releaseKey($event)\"\n                        ng-keydown=\"actions.pressedKey($event)\" ng-model=\"pinvalue.field1\" ng-blur=\"actions.onBlur($event)\" ng-focus=\"actions.onFocus($event)\"\n                />\n        </div>\n        <div class=\"numpin-wrapper\" ng-click=\"actions.onWrapperClick($event)\">\n                <input type=\"number\" inputmode=\"numeric\" pattern=\"[0-9]\" maxlength=1 id=\"field2\" class=\"numpin\" ng-keyup=\"actions.releaseKey($event)\"\n                        ng-keydown=\"actions.pressedKey($event)\" ng-model=\"pinvalue.field2\" ng-blur=\"actions.onBlur($event)\" ng-focus=\"actions.onFocus($event)\"\n                />\n        </div>\n        <div class=\"numpin-wrapper\" ng-click=\"actions.onWrapperClick($event)\">\n                <input type=\"number\" inputmode=\"numeric\" pattern=\"[0-9]\" maxlength=1 id=\"field3\" class=\"numpin\" ng-keyup=\"actions.releaseKey($event)\"\n                        ng-keydown=\"actions.pressedKey($event)\" ng-model=\"pinvalue.field3\" ng-blur=\"actions.onBlur($event)\" ng-focus=\"actions.onFocus($event)\"\n                />\n        </div>\n        <div class=\"numpin-wrapper\" ng-click=\"actions.onWrapperClick($event)\">\n                <input type=\"number\" inputmode=\"numeric\" pattern=\"[0-9]\" maxlength=1 id=\"field4\" class=\"numpin\" ng-keyup=\"actions.releaseKey($event)\"\n                        ng-keydown=\"actions.pressedKey($event)\" ng-model=\"pinvalue.field4\" ng-blur=\"actions.onBlur($event)\" ng-focus=\"actions.onFocus($event)\"\n                />\n        </div>\n</div>"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/modal/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/modal/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Directives used in the template
(0, _squid.$registerDirective)('xoModal', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
            show: '=?',
            showCloseButton: '=?',
            enableCloseOnEscape: '=?',
            onClose: '=?',
            enableMobileInterstitial: '@?',
            overrideDefaultContainer: '@?' // Boolean to determine if default styling should be applied to container
        },
        controller: ['$scope', function ($scope) {
            $scope.animate = false; // Don't animate until triggered
            $scope.showOverlay = $scope.show;

            var escapeKeyHandler = function escapeKeyHandler($event) {
                if ($event.keyCode === 27) {
                    // Escape key maps to keycode 27
                    $scope.hideModal();
                }
            };

            if ($scope.enableCloseOnEscape) {
                // Handle escape button as close button click
                $(document).bind('keyup', escapeKeyHandler);
            }

            $scope.hideModal = function ($event) {
                if ($event) {
                    $event.preventDefault();
                }

                $scope.show = false;
                $(document).unbind('keyup', escapeKeyHandler);
                if ($scope.onClose) {
                    $scope.onClose();
                }
            };
        }],

        link: function link($scope, elem, attrs) {
            // HACK: without this check, the modal slides down/fades out upon it being rendered
            $scope.$watch('show', function (newVal, oldVal) {
                if (oldVal !== newVal) {
                    // When the show prop changes
                    $scope.animate = true; // Ensure the modal is animated
                }
            });
        }
    };
});

_squid.$registerDirective;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/modal/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-wrapper\" ng-class=\"{'animate': animate}\" ng-show='show' content>\n\t<div class=\"modal-overlay\"></div>\n\t<div class=\"modal-dialog\" ng-class=\"{'mobile-interstitial': enableMobileInterstitial}\" modal-box modal-cancel=\"hideModal()\">\n\t\t<div class=\"modal-content\" ng-class=\"{'modal-default': !overrideDefaultContainer}\" tabindex=\"-1\" focus-when=\"show\">\n\t\t\t<div ng-transclude>\n\t\t\t</div>\n\t\t\t<a link-button ng-if=\"showCloseButton\" ng-click=\"hideModal($event)\" class=\"close\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n\t\t</div>\n\t</div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/popup/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, squid) {

    squid.module('xo-popup.directive', ['squid']).directive('xoPopup', ['$window', '$util', function ($window, $util) {
        return {
            restrict: 'A',

            link: function link(scope, element, attr) {

                element.on('click', function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    var config = {
                        popupUrl: attr.href,
                        popupWindowName: 'popup',
                        width: 835,
                        height: 500,

                        popupWindowFeatures: {
                            location: 1,
                            status: 1,
                            scrollbars: 1,
                            resizable: 1,
                            toolbar: 0,
                            menubar: 0
                        }
                    };

                    scope.trackExternalLink(attr.id || 'external_link');

                    var isOneTouch = $util.param('isOneTouch');

                    if (/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)|PLAYSTATION|iPadApp/i.test($window.navigator.userAgent) && isOneTouch !== '1') {
                        scope.$emit('showModal', config);
                        return false;
                    }

                    if ($(element).hasClass('smallPopup')) {
                        config.width = 385;
                    }

                    var left = 0;
                    var top = 0;

                    if (window.outerWidth) {
                        left = Math.round((window.outerWidth - config.width) / 2) + window.screenX;
                        top = Math.round((window.outerHeight - config.height) / 2) + window.screenY;
                    } else if (window.screen.width) {
                        left = Math.round((window.screen.width - config.width) / 2);
                        top = Math.round((window.screen.height - config.height) / 2);
                    }

                    var features = Object.keys(config.popupWindowFeatures).map(function (k) {
                        return k + '=' + config.popupWindowFeatures[k];
                    }).join(',');

                    // put together WindowFeatures, since, window.open needs it as a string
                    features += ',width=' + config.width + ',height=' + config.height + ',left=' + left + ',top=' + top;

                    var popup = $window.open(config.popupUrl, config.popupWindowName, features);

                    if (popup.focus) {
                        popup.focus();
                    }
                });
            },

            controller: ['$scope', '$logger', function ($scope, $logger) {
                $scope.trackExternalLink = function (linkName) {
                    $logger.info(linkName);
                };
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/prefix-attrs-with/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

exports['default'] = (0, _squid.$registerDirective)('prefix-attrs-with', function () {
    return {
        restrict: 'A',
        link: function link(scope, elem, attrs) {
            var prefix = attrs.prefixAttrsWith;

            if (prefix && prefix.length) {
                ['id', 'for', 'name'].forEach(function (attrName) {
                    var base = attrs[attrName];

                    if (base) {
                        elem.attr(attrName, _squid.$util.dasherizeToCamel(prefix + '-' + base));
                    }
                });
            }
        }
    };
});


_squid.$util;

_squid.$registerDirective;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/spinner-button/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/spinner-button/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, template) {
    return angular.module('xo-spinner-button.directive', []).directive('xoSpinnerButton', [function () {
        return {
            template: template,
            scope: {
                token: '=?',
                track: '@?',
                onClick: '=?',
                buttonText: '@?',
                isProcessing: '=?',
                validate: '=?'
            },
            controller: ['$scope', function ($scope) {

                $scope.submit = function () {
                    if ($scope.onClick) {
                        $scope.onClick();
                    } else {
                        $scope.validate = true;
                    }
                };
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/spinner/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/spinner/template.html"), __webpack_require__("../node_modules/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, squid, template) {

    squid.module('xo-spinner.directive', ['squid', 'beaver']).directive('xoSpinner', [function () {

        return {
            scope: {},
            template: template,
            controller: ['$scope', '$element', '$rootScope', '$locale', '$logger', '$loader', '$timeout', function ($scope, $element, $rootScope, $locale, $logger, $loader, $timeout) {
                var $body = angular.element(document.getElementsByTagName('body'));
                var $priorActiveElement = $();
                var $capturedElement = $();
                var $header = $('header');
                var $slidingArea = $('#main');
                var $footer = $('footer');

                /**
                 * This hides page content from any screen readers.
                 * When the spinner's active, the only thing that should be read out is the "Loading..." text.
                 *
                 * The only crappy thing here is the spinner's nested deep in the content, so please excuse this jQuery crap.
                 * At the very least, let's cache these selectors :|
                 */
                function hidePageContentFromScreenReader(toggle) {
                    $header.attr('aria-disabled', toggle);
                    $slidingArea.attr('aria-disabled', toggle);
                    $footer.attr('aria-disabled', toggle);
                }

                function preventDefault(event) {
                    var _event$target = event.target;
                    _event$target = _event$target === undefined ? {} : _event$target;
                    var targetId = _event$target.id;

                    // Only call preventDefault if the target is not a captcha input.
                    // If the target is a captcha input we don't want to prevent the
                    // user from entering the captcha code.

                    if (targetId !== 'captchaCode') {
                        event.preventDefault();
                    }
                }

                function captureFocus(event) {
                    if (!$element.has(event.target).length) {
                        $capturedElement = $(event.target);
                    }
                }

                function setLoadingMessage(message) {
                    if (angular.isObject(message)) {
                        $scope.message = message.heading;
                        $('#spinnerMessage').css('font-size', '17.5px');
                        $('#spinnerMessage').html(message.heading);
                        $('#spinnerSubHeading').html(message.subHeading);
                    } else {
                        $scope.message = message;
                        $('#spinnerMessage').html(message);
                    }
                }

                function showSpinner() {
                    $scope.loading = true;
                    $logger.info('show_loading_spinner');
                    $body.addClass('loading');

                    // remember what was previously focused
                    $priorActiveElement = $(':focus');

                    $(':input, a').blur();

                    hidePageContentFromScreenReader(true);

                    if ($loader.firstLoad()) {
                        setLoadingMessage($locale.content.get('base.processing'));
                    }

                    // focus on the message so that screen readers will let the user know the page is loading
                    $(document).on('keydown', preventDefault);
                    $(document).on('focusin', captureFocus);
                    $timeout(function () {
                        $('#spinner-message').focus();
                    });
                }

                function hideSpinner() {
                    $scope.loading = false;
                    $logger.info('hide_loading_spinner');
                    $('#preloaderSpinner').hide();
                    $body.removeClass('loading');
                    $(document).off('keydown', preventDefault);
                    $(document).off('focusin', captureFocus);

                    hidePageContentFromScreenReader(false);

                    // Focus captured element if focus was given to an element while spinner was active.
                    if ($capturedElement.length && $(document.body).has($capturedElement).length) {
                        $capturedElement.focus();
                        // Focus element that had focus before if it is still within the document
                    } else if ($priorActiveElement.length && $(document.body).has($priorActiveElement).length) {
                        $priorActiveElement.focus();
                    } else {
                        // If focus is not managed, default to focusing sliding area. Fixes FF and IE bug where tab focus starts from
                        // the element last clicked, rather than top of page.
                        $slidingArea.focus();
                    }
                    $priorActiveElement = $();
                    $capturedElement = $();
                }

                var cancelStartLoad = $rootScope.$on('startLoad', showSpinner);
                var cancelAllLoaded = $rootScope.$on('allLoaded', hideSpinner);

                var cancelSetLoadingMessage = $rootScope.$on('loadingMessage', function (event, text) {
                    setLoadingMessage(text);
                });

                $scope.$on('$destroy', function () {
                    hideSpinner();
                    cancelStartLoad();
                    cancelAllLoaded();
                    cancelSetLoadingMessage();
                });

                if ($loader.isLoading()) {
                    showSpinner();
                }
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/sticky-cta/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/sticky-cta/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/sticky-cta/styles.less");

var _utils = __webpack_require__("../node_modules/xo-ui-components/src/sticky-cta/utils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoStickyCta', {
    tag: 'xo-sticky-cta',
    template: _template2['default'],
    transclude: true,
    props: {
        eligibility: {
            type: 'var',
            required: false
        }
    },
    resolve: {},
    lifecycle: {
        populate: function populate() {
            _logger.$logger.info('xoStickyCta_populate_' + this.eligibility);
            if (!this.eligibility) {
                return;
            }
            var position = this.eligibility;
            var stickyContent = document.getElementById('sticky-content');
            var stickyPlaceholder = document.getElementById('sticky-placeholder-' + position);
            var foundContentDom = Boolean(stickyContent);
            var placeholderIsVisible = (0, _utils.isInViewport)(stickyPlaceholder);

            angular.element(stickyContent).addClass('sticky-' + position + '-off');

            _logger.$logger.info('xoStickyCta_init', {
                foundContentDom: foundContentDom,
                placeholderIsVisible: placeholderIsVisible,
                position: position
            });

            /**
             * TODO: Replace sticky logic with 'position:sticky' only when
             * there is greater browser compatibility. It is more seamless.
             * When using 'position:sticky' revert 'overflow:hidden' else sticky is not possible.
             * angular.element(document.getElementById('sliding-area')).css('overflow', 'inherit');
            */

            /**
             * Current Logic: if the stickyContent DOM is found in html then
             * - if placeholder is visible on screen -> fix the DOM position to its regular position
             * - if placeholder is not visible on screen -> we make the DOM float
            */

            var isFloating = false;

            var bindHandler = function bindHandler(event) {
                isFloating = (0, _utils.stickyHandler)(stickyPlaceholder, stickyContent, {
                    isFloating: isFloating,
                    position: position,
                    currentState: _angular.$rootScope.currentState
                });
            };

            var stateHandler = function stateHandler(event, toState, toParams, fromState) {
                /**
                 * TODO:
                 * try to use something like .trayOpen -> great grand child .sticky via css
                 * this is required for cases when overlay or sidebar is opened.
                */
                var review = 'checkout.review';
                var to = toState && toState.name;
                var from = fromState && fromState.name;

                var conflict = from === to;
                var leaving = !conflict && from === review;
                var entering = !conflict && to === review;

                if (leaving) {
                    isFloating = (0, _utils.stickyHandler)(stickyPlaceholder, stickyContent, {
                        force: 'off',
                        position: position
                    });
                }
                if (entering) {
                    isFloating = (0, _utils.stickyHandler)(stickyPlaceholder, stickyContent, {
                        isFloating: isFloating,
                        position: position,
                        currentState: _angular.$rootScope.currentState
                    });
                }

                _logger.$logger.info('xoStickyCta_stateChangeSuccess', { to: to, from: from, isFloating: isFloating });
            };

            angular.element(_angular.$window).bind('scroll', bindHandler).bind('resize', bindHandler);
            // .bind('orientationchange', bindHandler); // TODO

            var stateChangeListener = _angular.$rootScope.$on('$stateChangeSuccess', stateHandler);

            this.$on('$destroy', function () {
                _logger.$logger.info('xoStickyCta_destroy');
                angular.element(_angular.$window).unbind('scroll', bindHandler) // remove only the handlers used in this element
                // .bind('orientationchange', bindHandler) // TODO
                .unbind('resize', bindHandler); // remove only the handlers used in this element
                stateChangeListener();
            });
        }
    }
});


_squid.$Component;

_logger.$logger;

_angular.$window;

_angular.$rootScope;

_utils.isInViewport;

_utils.stickyHandler;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/sticky-cta/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/sticky-cta/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"sticky-wrapper\">\n    <div id=\"sticky-placeholder-top\"></div>\n    <div id=\"sticky-content\" ng-transclude></div>\n    <div id=\"sticky-placeholder-bottom\"></div>\n</div>"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/sticky-cta/utils.js":
/***/ (function(module, exports) {



exports.__esModule = true;
/**
 * Checks if provided element is currently visible.
 * 
 * @param {any} element: Reference to DOM object
 * @returns {Boolean}
 */
var isInViewport = exports.isInViewport = function isInViewport(element) {
    var bounding = element.getBoundingClientRect();

    return (
        // check if element is bellow top most pixel
        // check if element is on the right of left most pixel
        // check if element is above the lowest pixel on screen
        // check if element is on the left of the right most pixel
        bounding.top >= 0 && bounding.left >= 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) && bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};

/**
 * Make the element provided sticky
 * 
 * @param {any} placeholder: Reference to placeholder DOM object
 * @param {any} element: Reference to DOM object
 * @param {string} position: where the element is located ('top', 'bottom').
 */
var makeSticky = exports.makeSticky = function makeSticky(placeholder, element, position) {
    var elementHeight = element.offsetHeight;

    angular.element(element).addClass('sticky').addClass('sticky-' + position).removeClass('sticky-' + position + '-off');
    angular.element(placeholder).css('height', elementHeight);
    return true;
};

/**
 * Make the element provided fixed to regular location
 * 
 * @param {any} placeholder: Reference to placeholder DOM object
 * @param {any} element: Reference to DOM object
 * @param {string} position: where the element is located ('top', 'bottom').
 */
var removeSticky = exports.removeSticky = function removeSticky(placeholder, element, position) {
    angular.element(element).removeClass('sticky').removeClass('sticky-' + position).addClass('sticky-' + position + '-off');
    angular.element(placeholder).css('height', '');
    return false;
};

/**
 * Decides when to enable or disable sticky effect on DOM
 * 
 * @param {any} stickyPlaceholder: Reference to DOM object
 * @param {any} stickyContent: Reference to DOM object 
 * @param {any} context: context related to current state of DOM
 * @returns {Boolean}: Updated state of DOM
 */
var stickyHandler = exports.stickyHandler = function stickyHandler(stickyPlaceholder, stickyContent, context) {
    var position = context.position,
        force = context.force,
        currentState = context.currentState,
        isFloating = context.isFloating;


    if (force === 'off') {
        return removeSticky(stickyPlaceholder, stickyContent, position);
    }

    var alreadyFloating = isInViewport(stickyPlaceholder) && isFloating;
    var canEnable = !isInViewport(stickyPlaceholder) && !isFloating && currentState === 'checkout_review';

    if (alreadyFloating) {
        return removeSticky(stickyPlaceholder, stickyContent, position);
    } else if (canEnable) {
        return makeSticky(stickyPlaceholder, stickyContent, position);
    } else {
        return isFloating;
    }
};

/***/ }),

/***/ "../node_modules/xo-ui-components/src/tooltip/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/tooltip/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getDefaultShowEvent($el) {
    return $el.is('a') || $el.is('button') ? 'click' : 'focus';
}

// Modify the aria-describedby property to include the id when showing the element so contents are properly read
function addDescribedById($el, id) {
    var describedByIds = $el.attr('aria-describedby') ? $el.attr('aria-describedby').split(' ') : [];

    if (!~describedByIds.indexOf(id)) {
        describedByIds.push(id);
    }

    $el.attr('aria-describedby', describedByIds.join(' '));
}

// Modify the aria-describedby attribute to remove the id when hiding the element so contents are no longer read
function removeDescribedById($el, id) {
    var describedByIds = $el.attr('aria-describedby') || '';

    $el.attr('aria-describedby', describedByIds.split(' ').filter(function (existingId) {
        return existingId !== id;
    }).join(' '));
}

var isMouseTypeEvent = function isMouseTypeEvent(type) {
    return (/mouse/.test(type)
    );
};

function debounceOnMouseTrigger(type, fn) {
    var isMouseType = isMouseTypeEvent(type);

    return function () {
        var _arguments = arguments;

        if (isMouseType) {
            (0, _angular.$timeout)(function () {
                return fn.apply(null, _arguments);
            }, 250);
        } else {
            fn.apply(null, arguments);
        }
    };
}

exports['default'] = _squid.$Component.extend('xoTooltip', {
    tag: 'xo-tooltip',
    template: _template2['default'],
    transclude: true,
    props: {
        trigger: {
            type: 'str',
            required: false
        },
        showEvent: {
            type: 'str',
            required: false
        },
        hideEvent: {
            type: 'str',
            required: false
        },
        displayInline: {
            type: 'var',
            required: false
        },
        align: {
            type: 'str',
            required: false
        }
    },
    lifecycle: {
        populate: function populate() {
            var $element = this.$element,
                trigger = this.trigger;

            var $trigger = $(trigger);
            var toolTip = $element.find('.toolTip');
            var toolTipID = this.toolTipID = 'toolTip_' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 7);
            var isMouseOver = false;

            /**
             * Toggle the show/hide state of the tooltip
             */
            var toggle = function toggle(event) {
                if (toolTip.length && toolTip.is(':visible')) {
                    close(event);
                } else {
                    show(event);
                }
            };

            /**
             * Show the tooltip, if not already shown.
             */
            var show = function show(event) {
                if (event) {
                    event.stopPropagation();
                    event.preventDefault();
                }

                addDescribedById($trigger, toolTipID);

                // Show the tooltip and position the page scroll to include the element on page
                $element.show();
                toolTip.slideDown({
                    progress: function progress() {
                        var windowBot = $(window).scrollTop() + $(window).height();
                        var toolTipBot = toolTip.offset().top + toolTip.outerHeight();
                        if (toolTipBot > windowBot) {
                            $(window).scrollTop(toolTipBot - $(window).height());
                        }
                    }
                });
            };

            /**
             * Hide the tooltip
             */
            var close = function close(event) {
                if (event) {
                    event.stopPropagation();
                    event.preventDefault();
                }

                if (!isMouseOver) {
                    if (toolTip.length && toolTip.is(':visible')) {
                        toolTip.slideUp(100, function () {
                            $element.hide();
                        });
                    } else {
                        $element.hide();
                    }

                    removeDescribedById($trigger, toolTipID);
                }
            };

            /**
             * Setting up the DOM behavior for this component
             */
            // Set defaults for showEvent and hideEvent if not provided
            this.showEvent = this.showEvent || getDefaultShowEvent($element);
            this.hideEvent = this.hideEvent || 'blur';

            var SHOW_EVENT = this.showEvent + '.toolTip';
            var HIDE_EVENT = this.hideEvent + '.toolTip';

            // Initially hide the tooltip
            $element.hide();

            // If tooltip is clicked, don't bubble up and trigger parent handlers
            $element.on('click', function (event) {
                return event.stopPropagation();
            });

            // If the tooltip contains an element with a "close" class, treat it as a close button
            $element.on('click', '.close', close);

            // Track whether the mouse is on the tooltip or not
            $element.on('mouseover', function () {
                isMouseOver = true;
            });
            $element.on('mouseleave', function () {
                isMouseOver = false;
            });

            // Clicking anywhere on the document not on the tooltip will close the tooltip.
            // Event is not passed so that other actions are not prevented
            $(document).on('click.toolTip', function (e) {
                // Needed because when the trigger is clicked, this click handler will also be fired.
                // So without this check the tooltip will open due to the trigger click and then this
                // document event handler would immediately close it
                if (!$trigger.is(e.target)) {
                    close();
                }
            });

            // Register the handlers to show and hide the tooltip
            if (this.showEvent === this.hideEvent) {
                $trigger.on(SHOW_EVENT, toggle);
                $element.on(SHOW_EVENT, toggle);
            } else {
                $trigger.on(SHOW_EVENT, show);
                $trigger.on(HIDE_EVENT, debounceOnMouseTrigger(this.hideEvent, close));
                // Also allow close event to happen on the tooltip itself, for mouse type events
                $element.on(HIDE_EVENT, debounceOnMouseTrigger(this.hideEvent, close));
            }

            // Clean up external listeners on exit
            this.$on('$destroy', function () {
                $(document).off('click.toolTip');
                $trigger.off(SHOW_EVENT);
                $trigger.off(HIDE_EVENT);
                close();
            });
        }
    }
});


_angular.$timeout;

_squid.$Component;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/tooltip/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"toolTip {{align}}\" ng-class=\"{'displayInline': displayInline, 'balloon': !displayInline}\" ng-transclude role=\"tooltip\" id=\"{{toolTipID}}\">\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/user-assist-banner/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoCardLoader = undefined;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _popupHandler = __webpack_require__("../node_modules/xo-ui-components/src/user-assist-banner/popupHandler.js");

var _popupHandler2 = _interopRequireDefault(_popupHandler);

var _template = __webpack_require__("../node_modules/xo-ui-components/src/user-assist-banner/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/user-assist-banner/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCardLoader = exports.$xoCardLoader = _squid.$Component.extend('xoAssistBanner', {
    tag: 'xo-assist-banner',
    template: _template2['default'],
    props: {
        header: {
            type: 'var',
            required: false
        },
        body: {
            type: 'var',
            required: false
        },
        hideHighlight: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            _logger.$logger.info('xo-assist-banner_enter');
        }
    },
    controller: ['$scope', function ($scope) {
        _logger.$logger.info('xo-assist-banner:controller');
        $scope.token = _angular.$rootScope.token;
        $scope.showFeedback = function () {
            return !_index.$DeviceInfo.isDevice();
        };
        $scope.showOL = function (event) {
            event.preventDefault();
            var placeholder = 'main:ec:hermes';
            var page = _uiRouter.$state.current.get('trackingData.buzname.fullpage.pagename2', 'unknown').replace('%', placeholder);
            var data = {
                opVars: {
                    rlogId: _angular.$window.meta.rlogId || '',
                    page: page || window.location.hash,
                    csci: 'Unknown',
                    calc: _angular.$window.meta.correlationId,
                    custId: 'Unknown',
                    merchantId: 'Unknown',
                    token: $scope.token || 'Unknown'
                },
                locale: {
                    country: _squid.$locale.country,
                    languageCode: _squid.$locale.lang + '_' + _squid.$locale.country
                }
            };

            (0, _popupHandler2['default'])(data);
        };
    }]
});

angular.value("$xoCardLoader", $xoCardLoader);
_uiRouter.$state;

_squid.$Component;

_squid.$locale;

_angular.$rootScope;

_angular.$window;

_logger.$logger;

_index.$DeviceInfo;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/user-assist-banner/popupHandler.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {

    var _doc = document;
    var _w = window;
    var _tm = new Date().getTime();
    var _sH = screen.height;
    var _ht = escape(_w.location.href); // eslint-disable-line block-scoped-var,no-undef
    var _hr = escape(_doc.referrer); // eslint-disable-line block-scoped-var,no-undef
    var _sW = screen.width;

    function popUp(opinionlabURL) {
        _w.open(opinionlabURL, 'comments', 'width=535,height=192' + ',screenX=' + (_sW - 535) / 2 + ',screenY=' + (_sH - 192) / 2 + ',top=' + (_sH - 192) / 2 + ',left=' + (_sW - 535) / 2 + ',resizable=yes' + ',copyhistory=yes' + ',scrollbars=no');
    }

    function updateCustomVars(data) {

        var opVars = data.opVars;
        var locale = data.locale;

        _ht = 'https://' + locale.country + '.paypal.com/' + locale.languageCode + '/00/' + escape(opVars.page.replace(/\s|\//g, '_')) + '.page'; // eslint-disable-line block-scoped-var,no-undef

        var customVar = (opVars.rlogId || opVars.calc) + '|' + opVars.csci + '|' + opVars.page + '|' + locale.country + '|' + locale.languageCode + '|' + opVars.custId + '|' + opVars.merchantId + '|' + opVars.token + '|' + 'Unknown';
        return customVar;
    }

    function _fC(_u) {
        var _sp = '%3A\\/\\/';
        var _rp = '%3A//';
        var _aT = _sp + ',\\/,\\.,-,_,' + _rp + ',%2F,%2E,%2D,%5F';
        var _aA = _aT.split(',');

        for (var i = 0; i < 5; i++) {
            eval('_u=_u.replace(/' + _aA[i] + '/g,_aA[i+5])'); // eslint-disable-line no-eval
        }
        return _u;
    }

    return function (locale) {

        var custom_var = updateCustomVars(locale);

        var opinionlabURL = 'https://secure.opinionlab.com/ccc01/comment_card.asp?' + 'time1=' + _tm + '&time2=' + new Date().getTime() + '&prev=' + _fC(_hr) + '&referer=' + _fC(_ht) + '&height=' + _sH + '&width=' + _sW + '&custom_var=' + custom_var;
        popUp(opinionlabURL);
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/user-assist-banner/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/user-assist-banner/template.html":
/***/ (function(module, exports) {

module.exports = "<div content id=\"assist-banner-wrapper\">\n    <div ng-if=\"!hideHighlight\" class=\"banner-highlight-bar\"></div>\n    <div class=\"banner-header\">\n        <p>{{header}}</p>\n    </div>\n    <div class=\"banner-body\">\n        <p ng-bind-html=\"body\"></p>\n    </div>\n    <div class=\"banner-feedback\" ng-if=\"showFeedback()\">\n         <span>{{ content('common.haveFeedback') }}</span>\n         <a href=\"#\" id=\"footer_sfLink\" ng-click=\"showOL($event)\">{{ content('common.letUsKnow') }}</a>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-validation/dist/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().directive('xoValidation', function () {
    return {
        template: '',
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, elem, attr, ngModel) {
            var validationUtil = {
                // because IE8 doesnt have String.prototype.trim()
                trim: function trim(value) {
                    var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

                    return value.replace(rtrim, '');
                },


                /**
                 * Generic function that runs a given input against
                 * a given regular expression
                 *
                 * @param {String} value input to test
                 * @param {String/RegExp} regex Regular expression to test against
                 * @returns {Boolean} matches or does not match given pattern
                 */
                valid: function valid(value, regex) {
                    if (this.empty(value)) {
                        return false;
                    }

                    if (_angular2['default'].isString(regex)) {
                        regex = new RegExp(regex);
                    }

                    return regex ? regex.test(value) : true;
                },


                // returns whether empty or not
                empty: function empty(value) {
                    if (!value) {
                        return true;
                    }

                    // IE8 and below doesn't have native .trim()
                    return !this.trim(value);
                },


                // returns whether alphabetic or not
                alphabetic: function alphabetic(value) {
                    return this.valid(value, /[A-Za-z]+$/);
                },


                // returns whether numeric or not
                numeric: function numeric(value) {
                    var NUMERIC_REGEX = new RegExp('^[0-9]+$');

                    return this.valid(value, NUMERIC_REGEX);
                },
                validBankAccount: function validBankAccount(value) {
                    if (!scope.showIBAN) {
                        return this.numeric(value);
                    }

                    return true;
                },
                validRouting: function validRouting(value) {
                    if (!scope.showIBAN) {
                        return this.valid(value, /^\d{8}$/);
                    }
                    return true;
                },
                validIBANCode: function validIBANCode(value) {
                    if (scope.showIBAN) {
                        value = value && value.replace(/ +/g, '');
                        return this.valid(value, /^([A-Z]){2}\d{2}[A-Z0-9]{1,30}$/);
                    }
                    return true;
                },
                validIBAN: function validIBAN(value) {
                    if (scope.showIBAN) {
                        value = value && value.replace(/ +/g, '');
                        return this.valid(value, /^DE\d{20}$/);
                    }

                    return true;
                },
                validIBANCountry: function validIBANCountry(value) {
                    value = value && value.replace(/ +/g, '');
                    return !this.valid(value, /^([^D0-9][E]|[D][^E0-9]|[^D0-9][^E0-9])\d{2}[A-Z0-9]{1,30}$/i);
                },


                // @Deprecated: This function is deprecated.
                // first two letters are the country code the rest are the bank account numbers max length 32
                validIBANWithValidCountryCode: function validIBANWithValidCountryCode(value) {
                    value = value && value.replace(/ +/g, '');
                    return this.valid(value, /^(AT|BE|CY|EE|FI|FR|DE|EL|IE|IT|LV|LT|LU|MT|MC|NL|PT|SK|SI|ES)\d{3,32}$/i);
                },
                validLast4: function validLast4(value) {
                    // @TODO - Unsafe regular expression, need to fix.
                    var LAST_4 = /^([0-9]{4})?$/; // eslint-disable-line fasec/no-unsafe-regex

                    return this.valid(value, LAST_4);
                },
                validStreet: function validStreet(value) {
                    return this.valid(value, /^([A-Za-z0-9-. ]*)$/);
                },


                // Validating phone format with metadata from griffin
                validPhone: function validPhone(value) {
                    var regex = scope.pattern;

                    /*
                        * User can enter phone format in various manner according to griffin mask
                        * (00) 0000-0000
                        * 00 000 0000
                        * Since the griffin pattern only validates against numbers, need to trim the input
                        * to only validate the numbers
                        */
                    value = value && value.replace(/[^0-9]/gi, '');
                    return this.valid(value, regex);
                },
                validDobYear: function validDobYear(value) {
                    return value !== 'YYYY';
                },
                validDobDay: function validDobDay(value) {
                    return value !== 'DD';
                },
                validDobMonth: function validDobMonth(value) {
                    return value !== 'MM';
                },
                validPoBox: function validPoBox(value) {
                    // @TODO - Unsafe regular expression, need to fix.
                    var boxRE = /\b(((general\s+)?post\s+(office|mail)?)|((g\.?)?p[-\.]?\s?[om][\.-]?))\s?(b(ox|\.)?)?(\s+\d+)\b/i; // eslint-disable-line fasec/no-unsafe-regex

                    if (boxRE.test(value)) {
                        return true;
                    }

                    return false;
                },
                validAddressSansPoBox: function validAddressSansPoBox(value) {
                    var boxRE = /(p[-.]? ?[om]?[-.]? ?|post ?(office|mail)?)? ?b(.|ox)[^,]*\d+/i;
                    var cassRE = /(drawer|locker|bin|firm caller)\s?#?[0-9]+/i;

                    if (boxRE.test(value) || cassRE.test(value)) {
                        return false;
                    }
                    return true;
                },
                validEmailOrPhone: function validEmailOrPhone(value) {
                    if (!value) {
                        return false;
                    }

                    return this.validEmail(value) || this.validPhone(value);
                },
                validEmail: function validEmail(value) {
                    if (!value) {
                        return false;
                    }
                    var trimmedValue = this.trim(value); // Trim leading and trailing whitespace
                    // @TODO - Unsafe regular expression, need to fix.
                    var EMAIL_REGEX = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i; // eslint-disable-line

                    return this.valid(trimmedValue, EMAIL_REGEX) && !this.highAscii(trimmedValue);
                },
                highAscii: function highAscii(value) {
                    var trimmedValue = this.trim(value);
                    // @TODO - Unsafe regular expression, need to fix.
                    var HIGH_ASCII_REGEX = /[^\x00-\x7F]/; // eslint-disable-line no-control-regex

                    return this.valid(trimmedValue, HIGH_ASCII_REGEX);
                },


                // expected format: MM/DD/YYYY
                validDate: function validDate(value) {
                    var re = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
                    var dArr = value.split('/');
                    var d = new Date(value);
                    var isValid = false;

                    if (re.test(value)) {
                        isValid = d.getMonth() + 1 === dArr[0] && d.getDate() === dArr[1] && d.getFullYear() === dArr[2];
                    }

                    return isValid;
                },


                /* Expects value and state. state can be "past" or "future".
                    NOTE: This function validates only month and year, not day!
                    Please use validDate() if you need to validate the whole date. */
                validDateWithoutDay: function validDateWithoutDay(value, options) {
                    // eslint-disable-line max-statements
                    var state = options.state;

                    value = value.replace(/\s/g, '');

                    if (value === '') {
                        return true;
                    }

                    var split = value.split('/');
                    var month = split[0];
                    var year = split[1];
                    var currentYear = parseInt(new Date().getFullYear().toString().substr(2, 2), 10);
                    var currentMonth = parseInt(new Date().getMonth(), 10) + 1;
                    var validYear = true;
                    var validMonth = true;

                    if (value.length < 5) {
                        return false;
                    }

                    if (!this.validDobMonth(month)) {
                        return false;
                    }

                    month = parseInt(month, 10);
                    year = parseInt(year, 10);

                    if (state === 'past') {
                        validYear = year <= currentYear;
                        if (!validYear) {
                            return false;
                        }
                        if (year === currentYear) {
                            validMonth = month <= currentMonth;
                        }
                    } else if (state === 'future') {
                        validYear = year >= currentYear;
                        if (!validYear) {
                            return false;
                        }
                        if (year === currentYear) {
                            validMonth = month >= currentMonth;
                        }
                    }

                    if (!validYear || !validMonth) {
                        return false;
                    }

                    return true;
                },


                // formats to MM/DD/YYYY
                mmddyyyy: function mmddyyyy(day, month, year) {
                    if (year.length < 4) {
                        year = '20' + year;
                    }

                    return this.twoDigits(month) + '/' + this.twoDigits(day) + '/' + this.twoDigits(year);
                },


                // formats to YY-MMM-DDDD
                yyyymmdd: function yyyymmdd(day, month, year) {
                    if (year.length < 4) {
                        year = '20' + year;
                    }

                    return year + '-' + this.twoDigits(month) + '-' + this.twoDigits(day);
                },


                // pads a number to two digits
                twoDigits: function twoDigits(value) {
                    return value < 10 ? '0' + value : '' + value;
                },


                // expects YYYY-MM-DD
                legalAge: function legalAge(value) {
                    if (this.empty(value)) {
                        return false;
                    }

                    var dateParts = value.split('-'); // expecting YYYY-MM-DD
                    var birthDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
                    var yr = 365.25 * 24 * 60 * 60 * 1000; // milliseconds in a year
                    var validBD = new Date(new Date() - 18 * yr);

                    return validBD >= birthDate;
                },
                validZip: function validZip(value, options) {

                    var postalCodeRegex = {
                        // TODO: Once this is removed from the xo-add-address template, we can remove it...
                        GB: /[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}/,
                        /**
                         * Note: These are "nice to have".
                         * Once we add support for these countries, we can remove these.
                         */
                        BA: /^\d{5}$/,
                        CY: /^\d{4}$/,
                        EE: /^\d{5}$/,
                        HR: /^\d{5}$/,
                        LU: /^\d{4}$/,
                        LV: /^\d{4}$/,
                        MT: /^\d{3,4}$/,
                        SI: /^\d{4}$/,
                        SK: /^[0-9]{3}[\s][0-9]{2}$/,
                        NZ: /^\d{4}$/,
                        LT: /^\d{5}$/,
                        BG: /^\d{4}$/,
                        CZ: /^\d{5}$/,
                        GR: /^\d{3}[\s]\d{2}$/,
                        HU: /^\d{4}$/,
                        MX: /^\d{5}$/
                    };

                    var country = options && options.country;
                    var regex = scope.zipEntry && scope.zipEntry.validationPattern || postalCodeRegex[country];
                    var isRequired = scope.zipEntry && scope.zipEntry.required;

                    if (!isRequired && this.empty(value)) {
                        return true;
                    }

                    // If there is no regex, or it's not populated yet...
                    if (!regex || _angular2['default'].isString(regex) && regex.indexOf('validationPattern') > -1) {
                        return !this.empty(value);
                    }

                    value = value && value.toUpperCase();

                    if (_angular2['default'].isString(regex)) {
                        if (regex.charAt(0) !== '^') {
                            regex = '^' + regex;
                        }
                        if (regex.charAt(regex.length - 1) !== '$') {
                            regex += '$';
                        }
                    }

                    return this.valid(value, regex);
                },
                validExpiry: function validExpiry(value, options) {
                    var $monthEl = (0, _jquery2['default'])('[ng-model="card.expiry_month"]');
                    var $yearEl = (0, _jquery2['default'])('[ng-model="card.expiry_year"]');
                    var month = $monthEl.val();
                    var year = $yearEl.val();
                    var isValid = false;
                    var monthElName = 'card.expiry_month';
                    var yearElName = 'card.expiry_year';
                    var cardType = options.cardType;

                    if (month) {
                        month = $monthEl.find('option')[$monthEl.val() * 1 + 1].label;
                    }

                    if (year) {
                        year = $yearEl.find('option')[$yearEl.val() * 1 + 1].label;
                    }

                    if (month && year) {
                        isValid = this.validExpires(month, year);
                    }

                    var formName = $monthEl.closest('form').attr('id');
                    var form = scope[formName] || scope.$parent[formName];
                    var monthFieldName = monthElName;
                    var yearFieldName = yearElName;

                    if (monthFieldName.indexOf('.') !== -1) {
                        monthFieldName = monthFieldName.split('.')[1];
                    }

                    if (yearFieldName.indexOf('.') !== -1) {
                        yearFieldName = yearFieldName.split('.')[1];
                    }

                    var cardsDontNeedExpiry = ['COFIDIS', 'COFINOGA', 'CETELEM'];

                    if (cardType && cardsDontNeedExpiry.indexOf(cardType) !== -1) {
                        isValid = true;
                    }

                    if (form) {
                        form[monthFieldName].$setValidity('validExpiry', isValid);
                        form[yearFieldName].$setValidity('validExpiry', isValid);
                    }

                    return isValid;
                },
                validExpires: function validExpires(month, year) {
                    var date = new Date();
                    var currentYear = parseInt(date.getFullYear().toString().substr(2, 2), 10);
                    var currentMonth;

                    if (year < currentYear) {
                        return false;
                    } else if (year > currentYear) {
                        return this.validDobMonth(month);
                    }

                    // account for display date vs. system date
                    currentMonth = date.getMonth() + 1;
                    return this.validDobMonth(month) && month >= currentMonth;
                },
                startDate: function startDate(value, options) {
                    var valueOptions = {
                        cardType: scope.card.type
                    };

                    valueOptions[elem.attr('id')] = value;

                    return this.setStartDateValidity(valueOptions);
                },


                setExpiryValidity: function setExpiryValidity(options) {
                    if (!options) {
                        return true;
                    }

                    var cardType = options.cardType || '';
                    var expiryValidity = this.validExpiry(null, {
                        cardType: cardType
                    });

                    return expiryValidity;
                },

                // start date validation for Maestro card
                setStartDateValidity: function setStartDateValidity(options) {
                    if (!options) {
                        return true;
                    }

                    var cardType = options.cardType || '';
                    var startDateValidity = true;
                    var $monthEl = (0, _jquery2['default'])('#startmonth');
                    var $yearEl = (0, _jquery2['default'])('#startyear');
                    var month = $monthEl.val();
                    var year = $yearEl.val();

                    if (cardType === 'MAESTRO') {
                        if (!month || !year) {
                            startDateValidity = false;
                        }
                    }

                    var formName = $monthEl.closest('form').attr('id'),
                        form = scope[formName] || scope.$parent[formName];

                    if (form) {
                        form.startmonth.$setValidity('startDate', startDateValidity);
                        form.startyear.$setValidity('startDate', startDateValidity);
                    }

                    return startDateValidity;
                },
                dobField: function dobField(value, options) {
                    var valueOptions = {};
                    var fieldMap = {
                        dobDayCC: 'day',
                        dobMonthCC: 'month',
                        dobYearCC: 'year'
                    };

                    valueOptions.cardType = scope.card.type;
                    valueOptions[fieldMap[elem.attr('id')]] = value;

                    return this.setDOBValidity(valueOptions);
                },
                setDOBValidity: function setDOBValidity(options) {
                    if (!options) {
                        return true;
                    }

                    var dobEnabledCards = ['COFIDIS', 'COFINOGA', 'CETELEM'];
                    var dobValidity = true;

                    var $monthEl = (0, _jquery2['default'])('#dobMonthCC');
                    var $dayEl = (0, _jquery2['default'])('#dobDayCC');
                    var $yearEl = (0, _jquery2['default'])('#dobYearCC');

                    var month = options.month || $monthEl.val();
                    var year = options.year || $yearEl.val();
                    var day = options.day || $dayEl.val();

                    if (month) {
                        month = $monthEl.find('option')[$monthEl.val() * 1 + 1].label;
                    }

                    if (day) {
                        day = $dayEl.find('option')[$dayEl.val() * 1 + 1].label;
                    }

                    if (year) {
                        year = $yearEl.find('option')[$yearEl.val() * 1 + 1].label;
                    }

                    var cardType = options.cardType;

                    if (cardType && dobEnabledCards.indexOf(cardType) !== -1) {
                        if (!month || !year || !day) {
                            dobValidity = false;
                            // invalidate if < 18 y/o.
                        } else if (!this.legalAge(this.yyyymmdd(day, month, year))) {
                            dobValidity = false;
                        } else if (!this.validDate(this.mmddyyyy(day, month, year))) {
                            dobValidity = false;
                        }
                    }

                    var formName = $monthEl.closest('form').attr('id');
                    var form = scope[formName] || scope.$parent[formName];

                    if (form) {
                        form.dobMonthCC.$setValidity('dobField', dobValidity);
                        form.dobDayCC.$setValidity('dobField', dobValidity);
                        form.dobYearCC.$setValidity('dobField', dobValidity);
                    }

                    return dobValidity;
                },
                validName: function validName(value) {
                    return this.valid(value, /^([a-zA-Z,\xC0-\xFF,\u00C0-\u017F\,\-\s\,\'])*$/);
                },
                isChecked: function isChecked(value, options) {
                    // $.is does not exist in $
                    // eslint-disable-line angular/ng_angularelement
                    var $el = (0, _jquery2['default'])(options.el);

                    return $el.is(':checked');
                },
                validRUPassport: function validRUPassport(value, options) {
                    if (scope.user.countryOfResidence === 'RU') {
                        return this.valid(value, /^\d{10}$/);
                    }
                    return true;
                }
            };

            var customValidator = function customValidator(value) {
                var ruleJson = _angular2['default'].fromJson(elem.attr('xo-validation'));
                var validator = ruleJson.validator;
                var options = ruleJson.options;

                ngModel.$setValidity(validator, validationUtil[validator](value, options));

                return value;
            };

            ngModel.$parsers.unshift(customValidator);
            ngModel.$formatters.unshift(customValidator);
        }
    };
});

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/3ds/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _dist = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/3ds/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xo3ds', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            data: '=?',
            onComplete3dsHandler: '=?'
        },
        controller: ['$scope', function ($scope) {
            var resolve3DS = _index2.$Resolve3DS.instance($scope.token);
            var isIos = _dist.$DeviceInfo.getiOSVersion();
            var timeout3DSConfig = _squid.$config.timeout3DS || { 'DEFAULT': 30000 };
            var lightBoxTimeout = isIos && _squid.$locale.country === 'IN' ? 0 : timeout3DSConfig[_squid.$locale.country] || timeout3DSConfig['DEFAULT'];

            $scope.termUrl = '' + window.location.origin + _squid.$config.urls.baseUrl + '/process3DS';
            $scope.data = $scope.data || {};

            function show3DSLightBox() {
                if ($scope.show3DS) {
                    var lightbox = angular.element(document.getElementById('light-box'));
                    lightbox.addClass('open');
                    $scope.show3DS = false;
                    _angular.$rootScope.$emit('loaded');
                }
            }

            function handleInitFailure(message) {
                // Since init3DS call failed. We disable the feature and proceed to checkout.
                _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token).action('updatePaymentExperience', {
                    data: {
                        payment_experience: 'HERMESNODE',
                        '3d_secure_authentication_supported': false
                    },
                    silent: true,
                    transientError: true
                }).then(function () {
                    _logger.$logger.info('checkout_fpti', {
                        from: '3DS_CHALLENGE',
                        to: 'process_3ds_challenge',
                        'int_error_description': message,
                        'error_type': 'soft_decline',
                        'error_source': 'fiLifecycle'
                    });
                    $scope.onComplete3dsHandler('success');
                });
            }

            function init3DSApi() {
                _angular.$rootScope.$emit('loadingMessage', _squid.$locale.content.get('threeDS.processing'));

                return resolve3DS.action('init3DS', {
                    data: {
                        cc_id: $scope.data.cc_id,
                        flow_id: $scope.data.flow_id,
                        merchant_id: $scope.data.merchant_id,
                        merchant_country: $scope.data.merchant_country_code,
                        currency: $scope.data.transaction_amount_currency,
                        transaction_amount: $scope.data.transaction_amount_value
                    },
                    success: function success(response) {
                        if (response.status === 'SUCCESS' && response.acsUrl) {
                            _logger.$logger.info('checkout_fpti', {
                                from: '3DS_CHALLENGE',
                                to: 'prepare_3ds_challenge'
                            });
                            $scope.acsUrl = response.acsUrl;
                            $scope.acsMethod = response.acsMethod || 'POST';
                            $scope.acsPaReq = response.acsPaReq;

                            var form = $('<form/>', {
                                action: $scope.acsUrl,
                                method: $scope.acsMethod,
                                id: 'iFrameForm',
                                target: 'threeDSFrame'
                            });
                            form.append($('<input/>', {
                                type: 'hidden',
                                name: 'TermUrl',
                                value: $scope.termUrl
                            }));
                            form.append($('<input/>', {
                                type: 'hidden',
                                name: 'PaReq',
                                value: $scope.acsPaReq
                            }));
                            $('#lightBoxAcsWrapper').append(form);
                            $('#iFrameForm').submit();

                            // wait for 3DS page to load with a timeout

                            // The $scope.show3DS in the line below is set true when the 3DS modal is eligible to be shown to user when the
                            // bank page loads in its iframe, i.e., after init3DS success
                            $scope.show3DS = true;
                            _angular.$rootScope.$emit('loading');
                            _angular.$rootScope.$emit('loadingMessage', _squid.$locale.content.get('threeDS.processing'));
                            (0, _angular.$timeout)(function () {
                                if ($scope.show3DS) {
                                    _logger.$logger.info('checkout_fpti', {
                                        from: '3DS_CHALLENGE',
                                        to: '3DS_CHALLENGE',
                                        'int_error_description': 'load_3ds_issuer_page_content_timeout',
                                        'error_type': 'soft_decline',
                                        'error_source': 'fiLifecycle'
                                    });
                                }
                                show3DSLightBox();
                            }, lightBoxTimeout);
                        } else {
                            _logger.$logger.info('checkout_fpti', {
                                from: '3DS_CHALLENGE',
                                to: 'process_3ds_challenge',
                                'int_error_description': 'acsUrl_not_presented_on_init',
                                'error_type': 'soft_decline',
                                'error_source': 'fiLifecycle'
                            });

                            // When there is no 3DS challenge page to be shown, we return success to the caller
                            $scope.onComplete3dsHandler('success');
                        }
                    },
                    error: function error() {
                        handleInitFailure('unknown_error_on_init3DS');
                    },
                    validation: function validation() {
                        handleInitFailure('validation_error_on_init3DS');
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT() {
                            handleInitFailure('contingency_presented_on_init3DS');
                        }
                    }
                });
            }

            function complete3DSApi(paRes) {
                return resolve3DS.action('complete3DS', {
                    data: {
                        third_party_response: paRes,
                        cc_id: $scope.data.cc_id,
                        flow_id: $scope.data.flow_id
                    },
                    success: function success(response) {
                        var status = void 0;

                        if (response.status === 'SUCCESS') {
                            status = 'success';

                            _logger.$logger.info('checkout_fpti', {
                                from: '3DS_CHALLENGE',
                                to: 'process_3ds_challenge'
                            });
                        } else {
                            status = 'decline';
                            _logger.$logger.info('checkout_fpti', {
                                from: '3DS_CHALLENGE',
                                to: 'process_3ds_challenge',
                                'int_error_description': 'complete3DS_decline',
                                'error_type': 'soft_decline',
                                'error_source': 'fiLifecycle'
                            });
                        }
                        $scope.onComplete3dsHandler(status);
                    }
                });
            }

            $scope.close3DSFrame = function () {
                _logger.$logger.info('checkout_fpti', {
                    from: '3DS_CHALLENGE',
                    to: 'process_user_close'
                });
                _logger.$logger.flush();

                var lightbox = angular.element(document.getElementById('light-box'));
                lightbox.removeClass('open');

                (0, _angular.$timeout)(function () {
                    var lightboxMask = angular.element(document.getElementById('mask'));

                    lightboxMask.remove();
                    $scope.onComplete3dsHandler('close');
                }, 200);
            };

            init3DSApi();

            $scope.complete3DS = function (paRes) {
                complete3DSApi(paRes);
            };

            _angular.$window.complete3DSFrame = function (paRes) {
                $scope.complete3DS(paRes);
            };

            $scope.on3DSPageLoad = show3DSLightBox;
            _angular.$window.on3DSPageLoad = $scope.on3DSPageLoad;

            // when the esc key is pressed
            $('html').on('keyup', function (ev) {
                if (ev.which === 27) {
                    $scope.close3DSFrame();
                }
            });
        }]
    };
});

_angular.$rootScope;

_angular.$timeout;

_angular.$window;

_squid.$config;

_squid.$locale;

_logger.$logger;

_index.$CheckoutAppDataModel;

_index2.$Resolve3DS;

_dist.$DeviceInfo;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/3ds/template.html":
/***/ (function(module, exports) {

module.exports = "<div content id=\"light-box-3ds\" class=\"light-box-3ds\">\n    <div content id=\"light-box\" class=\"light-box\" ng-class=\"{mobile: isDevice}\">\n        <div id=\"mask\" class=\"light-box mask\"></div>\n        <div class=\"light-box wrapper\">\n\n            <div class=\"light-box-container\">\n                <div class=\"aside\" id=\"lightBoxAcsWrapper\">\n                    <a class=\"close\" ng-click=\"close3DSFrame()\" href=\"#\">&nbsp;</a>\n                    <p class=\"light-box-header\">\n                        {{ content('threeDS.iFrameTitle') }}\n                    </p>\n                    <iframe name=\"threeDSFrame\" src=\"\" class=\"light-box-iframe\" onload=\"on3DSPageLoad()\"></iframe>\n                </div>\n\n                <div class=\"logo\"></div>\n            </div>\n\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-bank/addbank/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-tray-height/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/popup/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-bank/bank-input/directive.js");

var _util = __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/util.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-bank/addbank/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddBank', function () {
    return {
        template: _template2['default'],
        scope: {
            parentCallbacks: '=?',
            errorMessage: '=?',
            bank: '=?',
            sidebar: '=?',
            hideparenthead: '=?',
            message: '=?',
            pageLevel: '=?',
            showSetPreferredFi: '=?',
            showCancel: '=?'
        },
        controller: ['$scope', '$element', function ($scope, $element) {
            $scope.model = $scope.bank || new _index.$AddBankModel({
                id: 123
            });
            $scope.locale = _squid.$locale;
            if ($scope.hideparenthead) {
                $scope.hideparenthead.toggle = false;
            }
            $scope.onSubmit = function () {
                if ($scope.pageLevel) {
                    $scope.pageLevel.message = null;
                }

                var data = $scope.model.getBankData();

                function mapValidationErrors(err) {
                    var fields = err && err.fields || [];

                    fields.forEach(function (fieldError) {
                        if (fieldError && fieldError.property) {
                            fieldError.field = fieldError.property;
                        }
                    });
                    return {
                        fields: fields
                    };
                }

                return $scope.model.action('validate', {
                    data: data,
                    resultModel: {},
                    success: function success(successData) {
                        $scope.model.creditorDetails = successData.creditorDetails;
                        $scope.model.fiDetails = successData.fiDetails;
                        $scope.parentCallbacks.addBankDone($scope.model);
                        if ($scope.showSetPreferredFi && $('#makeFiPreferred').is(':checked')) {
                            $scope.parentCallbacks.setBankPrefer(true);
                        }
                    },
                    contingencies: {
                        VALIDATE_BANK_CONTINGENCY: function VALIDATE_BANK_CONTINGENCY(name, contingencyData) {
                            $scope.errorMessage = _util.$fiErrorUtil.addPageErrors(contingencyData, 'bank');
                            _util.$fiErrorUtil.addFieldErrors(contingencyData, $element, 'model.');
                        }
                    },
                    validation: function validation(res) {
                        return _util.$fiErrorUtil.addFieldErrors(mapValidationErrors(res), $element, 'model.');
                    }
                });
            };

            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance(),
                billingAddresses: _index.$BillingAddressesModel.instance()
            }).then(function () {
                $scope.model.address = $scope.billingAddresses.addresses && $scope.billingAddresses.addresses[0];
                $scope.model.user.first_name = $scope.auth.first_name;
                $scope.model.user.last_name = $scope.auth.last_name;
                $scope.model.user.country = $scope.model.address && $scope.model.address.country;
            });
        }]
    };
});

_squid.$locale;

_squid.$populate;

_auth.$AuthModel;

_index.$AddBankModel;

_index.$BillingAddressesModel;

_util.$fiErrorUtil;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-bank/addbank/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-bank/addbank/directive.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$XOAddBankRoute', function () {
    return _squid.$ComponentRoute.extend('AddRoute', {
        name: 'add',
        titleContent: 'asideHeader.addBank',
        directive: 'xo-add-bank',
        trackingData: {
            fptiState: 'add_bank'
        },
        loginRequired: true,
        children: []
    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-bank/addbank", "../node_modules/xo-wallet-components/src/add-bank/addbank/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-bank/addbank/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-aside-header back-url=\"checkout.review.sidebar.wallet\" heading='asideHeader.addBank' ng-if=\"sidebar && locale.country !== 'DE'\"></xo-aside-header>\n<xo-message message=\"errorMessage\"></xo-message>\n<div class=\"container\" ng-class=\"{asideContent: sidebar}\" xo-tray-height>\n\t<form id=\"bankForm\" name=\"bankForm\" method=\"post\" class=\"asideProceed formSmall\" novalidate=\"novalidate\">\n        <div id=\"bankFields\" class=\"clearfix\" content>\n            <div id=\"name\" class=\"fieldGroup clearfix\">\n                <div class=\"inputField  half confidential firstname\">\n                    <label for=\"firstName\" class=\"focus accessAid\">\n                        {{ content('common.firstName') }}\n                    </label>\n                    <input ng-model=\"model.user.first_name\" name=\"firstName\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" placeholder=\"{{ content('common.firstName') }}\" xo-error-tooltip required />\n                </div>\n\n                <div class=\"inputField half last-child confidential lastname\">\n                    <label for=\"lastName\" class=\"focus accessAid\">\n                        {{ content('common.lastName') }}\n                    </label>\n                    <input ng-readonly=\"model.user.last_name\" ng-model=\"model.user.last_name\" name=\"lastName\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" placeholder=\"{{ content('common.lastName') }}\" xo-error-tooltip required />\n                </div>\n            </div>\n\n            <xo-bank-input user=\"model.user\" bank=\"model.bank\"></xo-bank-input>\n\n            <div ng-if=\"showSetPreferredFi\" id=\"setPreference\">\n                <div class=\"checkbox\">\n                    <input type=\"checkbox\" name=\"makeFiPreferred\" id=\"makeFiPreferred\" />\n                    <label for=\"makeFiPreferred\">{{ content('addCard.makeFiPreferred') }}</label>\n                </div>\n                <div class=\"legal infoTxt\">{{content('addCard.makeFiPreferredLegal')}}\n                    <span id=\"setPreferredFiLearnMore\" bind-html-compile=\"htmlContent('addCard.learnMore')\"></span>\n                </div>\n            </div>\n\n            <p class=\"infoTxt secondary \" data-ng-bind-html=\"htmlContent( 'bank.addBankDisclaimer') \"></p>\n\n            <div class=\"buttons\">\n                <input track-submit id=\"proceedButton\" type=\"submit\" value=\"{{ content('common.continuetext') }}\" class=\"btn full\" validate-submit=\"onSubmit()\" />\n            </div>\n\n            <div class=\"center\" ng-if=\"showCancel\">\n                <a link-button prevent-default href=\"#\" ng-click=\"parentCallbacks.cancel(sidebar ? 'checkout.reivew.sidebar.wallet' : '')\">{{ content('common.cancel') }}</a>\n            </div>\n        </div>\n    </form>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-bank/bank-input/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-bank/bank-input/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoBankInput', function () {
    return {
        template: _template2['default'],
        scope: {
            user: '=?',
            bank: '=?'
        },
        /* auto formatting the user entered IBAN input */
        link: function link(scope, element, attr) {
            var IBANMask = 'AA00 0000 0000 0000 0000 0000 0000 0000 00';

            element.on('keyup', function (event) {

                $('#ibanNumber').mask(IBANMask, {
                    'translation': {
                        0: { pattern: /[A-Za-z0-9]/ }
                    }
                });
            });
        },

        controller: ['$scope', function ($scope) {
            $scope.showIBAN = false;

            var days = [];
            var months = [];
            var years = [];

            var i;
            for (i = 1; i <= 31; i += 1) {
                var d = i < 10 ? '0' + i : i.toString();
                days.push(d);
            }

            for (i = 1; i <= 12; i += 1) {
                var m = i < 10 ? '0' + i : i.toString();
                months.push(m);
            }

            var year = new Date().getFullYear();

            for (i = year - 17; i >= year - 100; i -= 1) {
                years.push(i);
            }

            $scope.days = days;
            $scope.months = months;
            $scope.years = years;

            $scope.toggleIBAN = function () {
                $scope.showIBAN = !$scope.showIBAN;
            };
        }]
    };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-bank/bank-input/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"bankFields\" content>\n    <div class=\"bban\" ng-if=\"!showIBAN\">\n        <p class=\"entryToggleLinks\">{{content('bank.enterBBAN')}}\n            <a class=\"toggle rightLink\" href ng-click=\"toggleIBAN()\">{{content('bank.insteadIBAN')}}</a>\n        </p>\n\n        <div class=\"inputField restricted\">\n            <label for=\"bankAccountNumber\" class=\"accessAid nolap\">\n                {{content('DEMemberGuest.account')}}\n            </label>\n            <input id=\"bankAccountNumber\" name=\"bankAccountNumber\" type=\"text\" value=\"\" ng-model=\"bank.bank_account_number\" placeholder=\"{{content('DEMemberGuest.accountPlaceholder')}}\" autocomplete=\"off\" pattern=\"[0-9]*\" maxlength=\"10\" aria-required=\"true\"\n                   xo-validation='{\n                \"validator\": \"validBankAccount\",\n                \"required\":  \"{{showIBAN}}\"\n            }' data-error-text=\"{{content('scripts.validNumber')}}\" xo-error-tooltip />\n        </div>\n\n        <div class=\"inputField restricted\">\n            <label for=\"blz\" class=\"accessAid nolap\">\n                {{content('DEMemberGuest.sort')}}\n            </label>\n            <input id=\"blz\" name=\"blz\" type=\"text\" value=\"\" ng-model=\"bank.bank_routing_number\" placeholder=\"{{content('DEMemberGuest.sortPlaceholder')}}\" autocomplete=\"off\" pattern=\"[0-9]*\" maxlength=\"8\" aria-required=\"true\"  xo-validation='{\n                \"validator\": \"validRouting\",\n                \"required\":  \"{{showIBAN}}\"\n            }' data-error-text=\"{{content('scripts.validNumber')}}\" xo-error-tooltip />\n        </div>\n    </div>\n    <div class=\"iban\" ng-if=\"showIBAN\">\n        <p class=\"entryToggleLinks\">{{content('bank.enterIBAN')}}\n            <a class=\"toggle rightLink\" href ng-click=\"toggleIBAN()\">{{content('bank.insteadBBAN')}}</a>\n        </p>\n        <div class=\"inputField restricted\">\n            <label for=\"ibanNumber\" class=\"accessAid nolap\">\n                {{content('bank.iban')}}\n            </label>\n            <input id=\"ibanNumber\" name=\"ibanNumber\" type=\"text\" value=\"\" placeholder=\"{{content('bank.IBANPlaceholder')}}\" autocomplete=\"off\" maxlength=\"42\" aria-required=\"true\" ng-model=\"bank.iban_number\"\n            data-error-text=\"{{content('scripts.validIBAN')}}\" xo-error-tooltip />\n        </div>\n    </div>\n\n    <div id=\"dobBank\" class=\"dobbank\">\n        <fieldset>\n            <legend class=\"fieldLegend\" for=\"dob\">{{content('DEMemberGuest.dob')}}</legend>\n\n            <div class=\"dropdown fidobDay\">\n                <select xo-dropdown name=\"dobDay\" ng-model=\"user.dob_day\" id=\"dobDay\" aria-label=\"{{content('applyForBml.bmlApplyDay')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyDD')}}</option>\n                    <option ng-repeat=\"day in days track by $index\" value=\"{{day}}\" ng-selected=\"user.dob_day === '{{day}}'\">{{day}}</option>\n                </select>\n            </div>\n\n            <div class=\"dropdown fidobMonth\">\n                <select xo-dropdown name=\"dobMonth\" ng-model=\"user.dob_month\" id=\"dobMonth\" aria-label=\"{{content('applyForBml.bmlApplyMonth')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyMM')}}</option>\n                    <option ng-repeat=\"month in months track by $index\" value=\"{{month}}\" ng-selected=\"user.dob_month === '{{month}}'\">{{month}}</option>\n                </select>\n            </div>\n            \n            <div class=\"dropdown fidobYear\">\n                <select xo-dropdown name=\"dobYear\" ng-model=\"user.dob_year\" id=\"dobYear\" aria-label=\"{{content('applyForBml.bmlApplyYear')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyYYYY')}}</option>\n                    <option ng-repeat=\"year in years track by $index\" value=\"{{year}}\" ng-selected=\"user.dob_year === '{{year}}'\">{{year}}</option>\n                </select>\n            </div>\n        </fieldset>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-bank/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-bank/template.html");

var _template2 = _interopRequireDefault(_template);

var _util = __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/util.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddBankFlow', function () {
    return {
        template: _template2['default'],

        scope: {
            token: '=?',
            parentCallbacks: '=?',
            sidebar: '=?',
            hideparenthead: '=?',
            pageLevel: '=?',
            showSetPreferredFi: '=?',
            showCancel: '=?'
        },

        controller: ['$scope', '$element', function ($scope, $element) {

            function handleContingency(name, result) {

                $scope.errorMessage = _util.$fiErrorUtil.addPageErrors(result, 'bank');
                _util.$fiErrorUtil.addFieldErrors(result, $element, 'model.');
                _uiRouter.$state.go('^.add');
            }

            function updateFundingOptions() {
                $scope.checkoutSession.fundingOptions.action('update', {

                    resultModel: $scope.checkoutSession,

                    data: {
                        planId: $scope.bankId
                    },
                    success: function success(result) {

                        $scope.checkoutSession.message = {
                            type: 'success',
                            msgKeys: ['paymentMethod.paymentMethodUpdated']
                        };
                        $scope.parentCallbacks.done();
                    },
                    contingencies: {
                        ADD_BANK_CONTINGENCY: handleContingency
                    }

                });
            }

            $scope.setBankPrefer = false;

            $scope.callbacks = {
                addBankDone: function addBankDone(bank) {
                    $scope.bank = bank;
                    _uiRouter.$state.go('^.sepa');
                },
                setBankPrefer: function setBankPrefer(bSetBank) {
                    $scope.setBankPrefer = bSetBank;
                },

                sepaDone: function sepaDone() {

                    (0, _squid.$populate)($scope, {
                        checkoutSession: _index.$CheckoutSessionModel.instance($scope.token),
                        cart: _index.$CheckoutCartModel.instance($scope.token)
                    }).then(function () {

                        $scope.locale = _squid.$locale;

                        var addBankReq = $scope.bank.getBankData();
                        $scope.bank.action('add', {

                            data: addBankReq,

                            resultModel: {},

                            success: function success(data) {

                                $scope.bankId = data.id;

                                // setPreferredFI checkbox is checked
                                if ($scope.setBankPrefer) {

                                    _logger.$logger.info('set_preferredFI_checked');

                                    // set preferred FI before updating
                                    var preferredFi = new _fi.$PreferredFi({
                                        preferred: [$scope.bankId]
                                    });

                                    preferredFi.save({
                                        success: function success() {
                                            _logger.$logger.info('SET_PREFERREDFI_SUCCESS', { preferred: [$scope.bankId] });
                                        },
                                        transientError: true,
                                        error: function error(err) {
                                            // log the error but fails silently because card is added
                                            _logger.$logger.error('SET_PREFERREDFI_ERROR', { error: err });
                                        },
                                        contingencies: {
                                            DEFAULT: function DEFAULT(name, contingency) {
                                                _logger.$logger.info('SET_PREFERREDFI_CONTINGENCY', name);
                                            }
                                        }
                                    });
                                }

                                // Sepa Mandate
                                var sepaStatus = data.sepaStatus;
                                if (sepaStatus === 'AUTHORIZED') {
                                    return updateFundingOptions();
                                }
                                $scope.bank.action('sepaAccept', {

                                    data: {
                                        bank: {
                                            id: data.id
                                        }
                                    },

                                    resultModel: {},

                                    success: updateFundingOptions,
                                    contingencies: {
                                        DEFAULT: handleContingency
                                    }

                                });
                            },

                            contingencies: {
                                ADD_BANK_CONTINGENCY: handleContingency
                            }

                        });
                    });
                },

                cancel: $scope.parentCallbacks.cancel
            };
        }]
    };
});

_squid.$locale;

_squid.$populate;

_uiRouter.$state;

_logger.$logger;

_index.$CheckoutCartModel;

_index.$CheckoutSessionModel;

_util.$fiErrorUtil;

_fi.$PreferredFi;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-bank/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-bank/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-bank/addbank/route.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-bank/sepa/route.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$AddBankFlowRoute', function () {

    return _squid.$ComponentRoute.extend('BankRoute', {
        name: 'bank',
        directive: 'xo-add-bank-flow',
        titleContent: 'asideHeader.addBank',
        children: [{
            name: '$XOAddBankRoute',
            attributes: {
                token: 'token',
                'parent-callbacks': 'callbacks',
                'error-message': 'errorMessage',
                bank: 'bank',
                sidebar: 'sidebar',
                hideparenthead: 'hideparenthead',
                'page-level': 'pageLevel',
                'show-set-preferred-fi': 'showSetPreferredFi',
                'show-cancel': 'showCancel'
            }
        }, {
            name: '$XOSepaRoute',
            attributes: {
                token: 'token',
                'parent-callbacks': 'callbacks',
                model: 'bank',
                sidebar: 'sidebar',
                hideparenthead: 'hideparenthead'
            }
        }]
    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-bank", "../node_modules/xo-wallet-components/src/add-bank/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-bank/sepa/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-bank/sepa/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoSepa', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            parentCallbacks: '=?',
            model: '=?',
            sidebar: '=?',
            hideparenthead: '=?'
        },
        controller: ['$scope', function ($scope) {

            if (!$scope.model) {
                return _uiRouter.$state.go('^.add');
            }

            $('body').addClass('pageSepaMandate');

            $scope.$on('$destroy', function () {
                $('body').removeClass('pageSepaMandate');
            });

            if ($scope.hideparenthead) {
                $scope.hideparenthead.toggle = true;
            }

            function getDate() {
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth() + 1; // January is 0!

                var yyyy = today.getFullYear();
                if (dd < 10) {
                    dd = '0' + dd;
                }
                if (mm < 10) {
                    mm = '0' + mm;
                }
                return dd + '.' + mm + '.' + yyyy;
            }

            $scope.date = getDate();
            $scope.onSubmit = function () {
                $scope.parentCallbacks.sepaDone();
            };
        }],

        link: function link($scope, element, attrs) {
            (0, _angular.$timeout)(function () {
                $(element).find('.asideContent').height($('#main').height() - $('#tray').find('.header').height() + 10);
            }, 10);
        }
    };
});

_angular.$timeout;

_uiRouter.$state;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-bank/sepa/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-bank/sepa/directive.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$XOSepaRoute', function () {

    return _squid.$ComponentRoute.extend('SepaRoute', {

        name: 'sepa',
        directive: 'xo-sepa',
        titleContent: 'DEMemberGuest.sepaTitle',
        trackingData: {
            fptiState: 'sepa_mandate',
            buzname: {
                'fullpage': {
                    'pagename': '%::sepa_mandate',
                    'pagename2': '%::sepa_mandate:member:hermes:',
                    'version': 'member:%:'
                }
            }

        },
        loginRequired: true,
        children: []
    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-bank/sepa", "../node_modules/xo-wallet-components/src/add-bank/sepa/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-bank/sepa/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"aside\" id=\"sepaMandate\">\n<xo-aside-header back-url=\"^.add\" heading='DEMemberGuest.ddAgreementHead' ng-if=\"sidebar\"></xo-aside-header>\n<h1 class=\"gamma noHead\" ng-if=\"!sidebar\">{{ content('DEMemberGuest.ddAgreementHead') }}</h1>\n<div class=\"container\" ng-class=\"{asideContent: sidebar}\" content>\n    <form ng-submit=\"onSubmit()\" id=\"sepaMandateForm\" method=\"post\" class=\"asideProceed formSmall\"\n          novalidate=\"novalidate\">\n            <div class=\"sepaText\">\n                <p>{{ content('DEMemberGuest.ddAgreementPara1') }}</p>\n                <div class=\"sepaDetails\">\n                    <div class=\"span\">\n                        <p>\n                            <span class=\"col1\">{{content('DEMemberGuest.accountCarrier')}} </span>\n                            <span class=\"col2\">\n                                <span>{{model.user.first_name}}</span>\n                                <span>{{model.user.last_name}}</span>\n                                <br/>{{model.address.line1}}\n                                <br/>{{model.address.line2}}\n                                <br/>{{model.address.postal_code}} {{model.address.city}}\n                            </span>\n                        </p>\n                    </div>\n                    <div class=\"span\">\n                        <p>\n                            <span class=\"col1\">{{content('DEMemberGuest.IBAN')}}</span>\n                            <span class=\"col2\">{{model.fiDetails.piDetails.piAccountNumber}}</span>\n                        </p>\n\n                        <p>\n                            <span class=\"col1\">{{content('DEMemberGuest.bankName')}}</span>\n                            <span class=\"col2\">{{model.fiDetails.piDetails.isssuerDetails.name}}</span>\n                        </p>\n\n                        <p>\n                            <span class=\"col1\">{{content('DEMemberGuest.bic')}}</span>\n                            <span class=\"col2\">{{model.fiDetails.piDetails.bic}}</span>\n                        </p>\n                    </div>\n                    <div class=\"span\">\n                        <p>\n                            <span class=\"col1\">{{content('DEMemberGuest.creditor')}}</span>\n                            <span class=\"col2\">\n                                <span>{{model.creditorDetails.creditorName}}</span>\n                                <br/><span class=\"confidential streets street-address\">{{model.creditorDetails.address.address1}}</span>\n                                <br/><span class=\"confidential postal-code\">{{model.creditorDetails.address.zip}}</span>\n                                    <span class=\"confidential locality\">{{model.creditorDetails.address.city}}</span>\n                                    <span class=\"confidential country adr-break\">{{model.creditorDetails.address.isoCountry}}</span>\n\n                            </span>\n                        </p>\n\n                        <p>\n                            <span class=\"col1\">{{content('DEMemberGuest.creditorId')}}</span>\n                            <span class=\"col2 creditorId\">{{model.creditorDetails.creditorId}}</span>\n                        </p>\n                    </div>\n                </div>\n                <p class=\"secondary\">{{content('DEMemberGuest.ddAgreementPara2WithoutLink')}}</p>\n\n                <p class=\"help\">{{date}}, {{model.address.city}}, {{content('DEMemberGuest.country'+model.address.country)}}</p>\n            </div>\n\n                <div class=\"buttons\">\n                    <input id=\"proceedButton\" type=\"submit\" value=\"{{ content('DEMemberGuest.agreeBtn') }}\"\n                           class=\"btn full \" ng-click=\"validated=true \"/>\n                    <a id=\"cancelBtn\" ui-sref=\"^.add\" class=\"btn full btn-secondary goTray\"\n                       role=\"button\">\n                        {{content('DEMemberGuest.cancelBtn')}}\n                    </a>\n                </div>\n\n    </form>\n\n</div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-bank/template.html":
/***/ (function(module, exports) {

module.exports = "<div ui-view></div>"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addCep/directive.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/xo-angular-ui-utils/ui-utils.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-form-components/src/zipcode/directive.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/addCep/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddCep', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            sidebar: '=?',
            prefillAddress: '=?',
            doneFn: '=?'
        },
        controller: ['$scope', function ($scope) {
            $scope.country = _squid.$locale.country;
            $scope.address = {};
            $scope.onSubmit = function () {
                $scope.prefillAddress.address = {
                    country: _squid.$locale.country,
                    postal_code: $scope.address.postal_code
                };
                return $scope.prefillAddress.save({
                    data: $scope.prefillAddress,
                    success: function success(result) {
                        $scope.prefillAddress.address = result;
                        $scope.doneFn();
                    }
                });
            };
        }]
    };
});

_squid.$locale;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addCep/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/addCep/directive.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$AddCepRoute', function () {
    return _squid.$ComponentRoute.extend('AddCepRoute', {
        name: 'addCep',
        directive: 'xo-add-cep',
        titleContent: 'addBillingAddress.title',
        loginRequired: true,
        children: []
    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-card/addCep", "../node_modules/xo-wallet-components/src/add-card/addCep/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addCep/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-aside-header back-url=\"^.addCard\" heading=\"asideHeader.addBillingAddress\" ng-if=\"sidebar\"></xo-aside-header>\n\n<h1 class=\"gamma addBillingTitle\" ng-if=\"!sidebar\">{{ content('addBillingAddress.title') }}</h1>\n\n<form id=\"cepForm\" name=\"cepForm\" class=\"asideView addressForm\" content novalidate>\n    <div class=\"trayInner container\">\n        <xo-zipcode id=\"zipcode\" country=\"{{country}}\" address=\"address\" zip-label=\"{{content('common.cep')}}\"\n                    zip-error-key=\"common.valueInvalid\"></xo-zipcode>\n        <div class=\"buttons\">\n            <input track-submit type=\"submit\" id=\"proceedButton\"\n                   value=\"{{ content('common.continueLabel') }}\" class=\"btn full\" validate-submit=\"onSubmit()\" />\n        </div>\n    </div>\n</form>\n\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addbilling/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

__webpack_require__("../node_modules/xo-angular-ui-utils/ui-utils.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _address = __webpack_require__("../node_modules/xo-models/src/address/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/addbilling/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddBilling', function () {
    return {
        template: _template2['default'],
        scope: {
            auth: '=?',
            token: '=?',
            doneFn: '=?',
            parentCallbacks: '=?',
            sidebar: '=?',
            showmeftsection: '=?',
            hideparenthead: '=?',
            billingaddressupdated: '=?',
            prefillAddress: '=?'
        },
        controller: ['$scope', '$element', function ($scope, $element) {
            var country = _squid.$locale.getCountryCodeISO();

            $scope.billing = true; // to denote its billing address page still
            $scope.normalize = (0, _squid.$feature)('addressNormalization');
            $scope.country = country;
            var $el = $($element);

            if ($scope.showmeftsection) {
                $scope.showmeftsection.toggle = false;
            }

            if ($scope.hideparenthead) {
                $scope.hideparenthead.toggle = true;
            }

            function isUserInputtedAddress(address) {
                return address && address.id === '0';
            }

            // Label fields has having error if needed to, and focus the first error if needed
            function handleValidation(res) {
                if (res && res.fields && res.fields.length) {
                    res.fields.forEach(function (field) {
                        if (field.field) {
                            var $field = $($el.find('[name="' + field.field + '"]'));

                            if ($field.length === 0 && field.field === 'zip') {
                                $field = $($el.find('[ng-model="address.postal_code"], [ng-model="zipCode"]'));
                            }
                            $field.addClass('backendError');
                            $field.attr('aria-invalid', true);
                        }
                    });
                }

                $el.find('form').find('.backendError, .ng-invalid').first().focus();
            }

            var prefilledAddress = $scope.prefillAddress && $scope.prefillAddress.address;

            if (prefilledAddress) {
                $scope.prefilled = true;
            }

            $scope.address = $scope.address || prefilledAddress || { country: country };

            var editFlow = function editFlow() {
                _logger.$logger.info('xo-billing_editFlow_check', {
                    'flow_type': _uiRouter.$stateParams.flow_type
                });
                if (_uiRouter.$stateParams.flow_type === 'edit') {
                    $scope.address = $scope.billingAddresses.addresses[0];
                }
            };

            (0, _squid.$populate)($scope, {
                billingAddresses: _fi.$BillingAddressesModel.instance(),
                flowEligibility: _checkout.$FlowEligibilityModel.instance($scope.token).retrieve({
                    params: {
                        geolocation: _squid.$meta.geolocation,
                        localeCountry: _squid.$locale.country
                    }
                })
            }).then(function () {
                editFlow();
                $scope.debitCardFlow = angular.isArray($scope.flowEligibility.paymentCardProductClass) && $scope.flowEligibility.paymentCardProductClass.length === 1 && $scope.flowEligibility.paymentCardProductClass[0] === 'DEBIT';

                $scope.cancelFn = function () {
                    $scope.done();
                };

                $scope.done = function (target) {
                    var el = $('.tokenization #sidepageAddCard');

                    if (el) {
                        el.removeClass('slideLeft');
                    }
                    target = target || '^.addCard';
                    _uiRouter.$state.go(target);
                };

                $scope.onSubmit = function () {
                    $scope.updateAddress();
                };

                $scope.prefill = function () {
                    $scope.address.country = $scope.country;
                    $scope.prefillAddress = new _address.$PrefillAddressModel({
                        id: $scope.token,
                        address: $scope.address
                    });

                    return $scope.prefillAddress.save({
                        data: $scope.prefillAddress,
                        success: function success(result) {
                            $scope.address = result;
                            $scope.prefilled = true;
                            $scope.showAddressFields = true;

                            (0, _angular.$timeout)(function () {
                                var value = $scope.address && $scope.address.state;
                                var $option = $el.find('[value="' + value + '"]');

                                $option.prop('selected', 'selected');
                                $option.trigger('change');
                                value = $option.attr('label');
                            }, 500);
                        }
                    });
                };

                $scope.updateAddress = function () {
                    var newBilling = new _fi.$BillingAddressModel({
                        line1: $scope.address.line1,
                        line2: $scope.address.line2,
                        city: $scope.address.city,
                        state: $scope.address.state,
                        postal_code: $scope.address.postal_code,
                        normalization_status: $scope.address.normalization_status,
                        country: country,
                        id: '0'
                    });

                    return newBilling.save({
                        data: $scope.billingAddress,
                        success: function success() {
                            if ($scope.normalize) {
                                // set to false so that html related to billing address is hidden when child is shown
                                $scope.billing = false;
                                $scope.address.full_address = newBilling.full_address;
                                _uiRouter.$state.go('.addressNormalization');
                            } else {
                                $scope.updateBillingAddressAndReturn('^.addCard', newBilling);
                            }
                        },
                        validation: function validation(res) {
                            return handleValidation(res);
                        }
                    });
                };

                $scope.uponNormalization = function (normalizedAddress, isBack) {
                    if (isBack) {
                        $scope.billing = true;
                        _uiRouter.$state.go('^');
                    } else {
                        $scope.updateBillingAddressAndReturn('^.^.addCard', normalizedAddress);
                    }
                };

                $scope.updateBillingAddressAndReturn = function (target, address) {
                    var newBillingAddress = void 0;

                    if (address && address instanceof _fi.$BillingAddressModel) {
                        newBillingAddress = address;
                    } else {
                        newBillingAddress = new _fi.$BillingAddressModel({
                            line1: address.line1,
                            line2: address.line2,
                            city: address.city,
                            state: address.state,
                            postal_code: address.postal_code,
                            normalization_status: address.normalization_status,
                            country: address.country || $scope.country,
                            full_address: address.full_address || $scope.address.full_address,
                            id: '0'
                        });
                    }

                    var addresses = $scope.billingAddresses && $scope.billingAddresses.addresses;

                    if (!isUserInputtedAddress(addresses[0])) {
                        addresses.unshift(newBillingAddress);
                    } else {
                        addresses[0] = newBillingAddress;
                    }
                    $scope.billingaddressupdated.value = true;
                    $scope.done(target);
                };

                // page transition after the page is loaded
                var el = $('.tokenization #sidepageAddCard');

                if (el) {
                    el.addClass('slideLeft');
                }
            });
        }]
    };
});

_angular.$timeout;

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_squid.$feature;

_squid.$locale;

_squid.$meta;

_squid.$populate;

_address.$PrefillAddressModel;

_checkout.$FlowEligibilityModel;

_fi.$BillingAddressesModel;

_fi.$BillingAddressModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addbilling/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

__webpack_require__("../node_modules/xo-address-components/src/address-normalization/route.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/addbilling/directive.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$AddBillingRoute', function () {
    return _squid.$ComponentRoute.extend('AddBillingRoute', {
        name: 'addBilling',
        directive: 'xo-add-billing',
        titleContent: 'addBillingAddress.title',
        query: ['flow_type'],
        trackingData: {
            fptiState: 'edit_billing'
        },
        loginRequired: true,
        children: [{
            name: '$AddressNormalizationRoute',
            attributes: {
                id: 'token',
                sidebar: 'sidebar',
                address: 'address',
                'done-fn': 'uponNormalization'
            }
        }]
    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-card/addbilling", "../node_modules/xo-wallet-components/src/add-card/addbilling/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addbilling/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"addBillingAddress\" ng-if=\"billing\" modal-box=\"address\" modal-cancel=\"cancelFn()\">\n    <xo-aside-header heading='asideHeader.addBillingAddress' ng-if=\"debitCardFlow\"\n                     hidex=\"true\"\n                     header-left-link=\"done\"\n                     header-left=\"common.back\"\n                     header-left-icon=\"true\"></xo-aside-header>\n\n    <xo-aside-header back-url=\"^.addCard\" heading=\"asideHeader.addBillingAddress\" ng-if=\"sidebar\"></xo-aside-header>\n\n    <h1 class=\"gamma addBillingTitle\" ng-if=\"!sidebar && !debitCardFlow\">{{ content('addBillingAddress.title') }}</h1>\n\n    <form id=\"billingAddressForm\" name=\"billingAddressForm\" class=\"asideView addressForm\" content form-autofocus novalidate>\n        <div class=\"trayInner container\">\n            <div class=\"clearfix\">\n                <xo-add-address country=\"country\" address=\"address\" token=\"token\"></xo-add-address>\n            </div>\n\n            <div class=\"buttons clearfix\">\n                <a ng-hide=\"sidebar || debitCardFlow\" id=\"backButton\" ui-sref=\"^.addCard\" class=\"btn btn-secondary\" role=\"button\">{{ content('common.back') }}</a>\n                <input ng-if=\"country==='BR' && !prefilled\" type=\"submit\" id=\"proceedButton\" value=\"{{ content('common.continueLabel') }}\" class=\"btn\" ng-class=\"{full:sidebar}\" validate-submit=\"prefill()\" />\n                <input track-submit ng-if=\"country!=='BR' || prefilled\" type=\"submit\" id=\"proceedButton\" value=\"{{ content('common.save') }}\" class=\"btn\" ng-class=\"{full:sidebar}\" validate-submit=\"onSubmit()\" />\n            </div>\n        </div>\n    </form>\n</div>\n<div ui-view></div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addcard/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

__webpack_require__("../node_modules/xo-angular-ui-utils/ui-utils.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _choice = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

var _newMember = __webpack_require__("../node_modules/xo-models/src/newMember/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _checkoutIncentive = __webpack_require__("../node_modules/xo-models/src/checkoutIncentive/index.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/notYou/directive.js");

__webpack_require__("../node_modules/xo-tray-height/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/address-box/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/banner/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/user-assist-banner/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInput/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/creditcard-input/directive.js");

var _util = __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/util.js");

var _cardMetaData = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardMetaData/index.js");

var _factory = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/addcard/factory.js");

var _factory2 = __webpack_require__("../node_modules/xo-member-components/src/no-balance/factory.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/addcard/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/addcard/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddCard', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            done: '=?',
            messagetitle: '=?',
            message: '=?',
            pagetitle: '=?',
            sidebar: '=?',
            showmeftsection: '=?',
            hideparenthead: '=?',
            billingaddressupdated: '=?',
            cardmodel: '=?',
            parentCallbacks: '=?',
            selectedPromotionCardType: '=?',
            promotion: '=?',
            pageLevel: '=?',
            logout: '=?',
            phone: '=?',
            manageCardFlow: '=?',
            showCancel: '=?',
            showSetPreferredFi: '=?',
            onSuccess: '=?',
            backUri: '=?',
            showIncentive: '=?',
            incentiveAmount: '=?'
        },
        controller: ['$scope', '$element', function ($scope, $element) {
            $scope.address_box = {
                changeFn: function changeFn(type) {
                    _logger.$logger.info('xo-address-box_changeFn - ' + type);
                    _uiRouter.$state.go('^.addBilling', {
                        flow_type: 'edit'
                    });
                }
            };

            // Ensure no incentive-related actions are taken unless
            // explicityly passed 'true' from the xo-add-card page
            // Also ensure there are no duplicate titles
            $scope.showIncentive = Boolean($scope.showIncentive);
            var isNoBalanceEligible = _factory2.$NoBalanceFactory.get().eligible;

            $scope.showPageTitle = Boolean($scope.pagetitle && !($scope.isNmjDesign2 || $scope.isNmjDesign3) && !isNoBalanceEligible);
            $scope.showMessageTitle = Boolean($scope.messagetitle);
            $scope.showMessageBanner = !$scope.sidebar && !$scope.showIncentive && !isNoBalanceEligible;
            $scope.showNoBalanceHeaderAndNoFiContingency = isNoBalanceEligible && _uiRouter.$stateParams.message === 'NEED_CREDIT_CARD';

            (0, _squid.$populate)($scope, {
                cart: _index2.$CheckoutCartModel.instance($scope.token),
                auth: _auth.$AuthModel.instance(),
                billingAddresses: _fi.$BillingAddressesModel.instance(),
                checkoutSession: _index2.$CheckoutSessionModel.instance($scope.token).retrieve({
                    contingencies: {
                        NEED_CREDIT_CARD: angular.noop,
                        EXPIRED_CREDIT_CARD: angular.noop
                    }
                }),
                flowEligibility: _index2.$FlowEligibilityModel.instance($scope.token).retrieve({
                    params: {
                        geolocation: _squid.$meta.geolocation,
                        localeCountry: _squid.$locale.country
                    }
                }),
                tokenizedWalletInfoModel: _index.$TokenizedWalletInfoModel.instance($scope.token).retrieve(),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance($scope.token).retrieve()
            }).then(function () {
                if ($scope.auth) {
                    $scope.formattedNameInformal = (0, _squid.formatNameInformal)({
                        first_name: $scope.auth.first_name,
                        last_name: $scope.auth.last_name
                    }) || $scope.auth.email;
                }

                $scope.isIndiaAndBilling = _squid.$locale.country === 'IN' && $scope.cart.isBilling() && $scope.checkoutAppData.get('merchant.merchant_country', 'US') === 'IN';

                _newMember.$NewMemberEligibility.instance().getVariant($scope.token).then(function (variant) {
                    $scope.isNmj = !$scope.sidebar && variant && (variant === 'one_page' || variant === 'design_2' || variant === 'design_3');
                    $scope.isNmjDesign1 = !$scope.sidebar && variant && variant === 'one_page';
                    $scope.isNmjDesign2 = !$scope.sidebar && variant && variant === 'design_2';
                    $scope.isNmjDesign3 = !$scope.sidebar && variant && variant === 'design_3';

                    $scope.isGreyHeader = $scope.isNmjDesign2 || $scope.isNmjDesign3;

                    if ($scope.isGreyHeader && $scope.message && $scope.message.msgs[0] && $scope.message.msgs[0].key === 'creditcard.errorExpiredCard') {
                        $scope.message.msgs = null;
                        $scope.isExpiredCard = true;
                    }

                    if ($scope.isNmj) {
                        // Set Up AddBank Link
                        $scope.disallowedInstruments = $scope.checkoutSession.get('fundingOptions').get('disallowedInstruments');
                        var hasDisallowedBank = $scope.disallowedInstruments && $scope.disallowedInstruments.some(function (fi) {
                            return fi.type === 'BANK';
                        });
                        $scope.showAddBank = (0, _squid.$feature)('enableExternalAddBank') && (!hasDisallowedBank || !$scope.disallowedInstruments);
                        $scope.addBankUri = '/webapps/hermes/add-bank?token=' + $scope.token;
                        _logger.$logger.info('external_addbank_' + ($scope.showAddBank ? 'enabled' : 'disabled'));
                    }

                    if ($scope.isNmjDesign1) {

                        var contentKey = {
                            header: '',
                            body: ''
                        };

                        if ($scope.disallowedInstruments && $scope.disallowedInstruments.length === 1) {
                            contentKey.header = 'addCard.assistHeaderHasDisallowedFi';
                            contentKey.body = 'addCard.assistBodySingleDisallowedFi';
                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_single_disallowed_FI_addcard_msg'
                            });
                        } else if ($scope.disallowedInstruments && $scope.disallowedInstruments.length > 1) {
                            contentKey.header = 'addCard.assistHeaderHasDisallowedFi';
                            contentKey.body = 'addCard.assistBodyMultiDisallowedFi';
                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_multi_disallowed_FI_addcard_msg'
                            });
                        } else {
                            contentKey.header = 'addCard.assistHeader';
                            contentKey.body = 'addCard.assistBody';
                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_has_no_FI_addcard_msg'
                            });
                        }

                        $scope.contentKey = contentKey;
                    }

                    if ($scope.isNmjDesign2 || $scope.isNmjDesign3) {
                        var headerMsg = void 0;
                        var userName = $scope.auth.first_name ? $scope.auth.first_name : $scope.auth.email;

                        if ($scope.isExpiredCard) {
                            headerMsg = (0, _squid.$renderContent)('addCard.nmjHeaderMsgExpiredCard', { userName: userName });

                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_expired_card_addcard_msg'
                            });
                        } else if ($scope.disallowedInstruments && $scope.disallowedInstruments.length === 1 && $scope.showAddBank) {
                            headerMsg = (0, _squid.$renderContent)('addCard.nmjHeaderMsgHasDisallowedShowBankLink', { userName: userName });

                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_single_disallowed_FI_show_addbank_link_addcard_msg'
                            });
                        } else if ($scope.disallowedInstruments && $scope.disallowedInstruments.length === 1 && !$scope.showAddBank) {
                            headerMsg = (0, _squid.$renderContent)('addCard.nmjHeaderMsgHasDisallowedHideBankLink', { userName: userName });

                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_single_disallowed_FI_hide_addbank_link_addcard_msg'
                            });
                        } else if ($scope.disallowedInstruments && $scope.disallowedInstruments.length > 1 && $scope.showAddBank) {
                            headerMsg = (0, _squid.$renderContent)('addCard.nmjHeaderMsgHasMultiDisallowedShowBankLink', { userName: userName });

                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_multi_disallowed_FI_show_addbank_link_addcard_msg'
                            });
                        } else if ($scope.disallowedInstruments && $scope.disallowedInstruments.length > 1 && !$scope.showAddBank) {
                            headerMsg = (0, _squid.$renderContent)('addCard.nmjHeaderMsgHasMultiDisallowedHideBankLink', { userName: userName });

                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_multi_disallowed_FI_hide_addbank_link_addcard_msg'
                            });
                        } else if ($scope.showAddBank) {
                            headerMsg = (0, _squid.$renderContent)('addCard.nmjHeaderMsgNoFiShowAddBank', { userName: userName });

                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_has_no_FI_show_addbank_link_addcard_msg'
                            });
                        } else {
                            headerMsg = (0, _squid.$renderContent)('addCard.nmjHeaderMsgNoFiHideAddBank', { userName: userName });

                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_has_no_FI_hide_addbank_link_addcard_msg'
                            });
                        }
                        $scope.headerMsg = headerMsg;
                    }
                });

                return _choice.$ChoiceEligibility.instance().getVariant($scope.token).then(function (variant) {
                    var multipleFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.multipleFi || [];

                    if (multipleFiVariants.indexOf(variant) !== -1) {
                        $scope.showMultipleFI = true;
                    }
                });
            }).then(function () {

                var logObj = {
                    'from': 'ADD_CARD',
                    'to': 'prepare_ADD_CARD',
                    'context_id': $scope.token
                };

                if ($scope.cart.isWalletTokenization()) {
                    Object.assign(logObj, {
                        'context_type': 'BA-Token',
                        'ba_token': _squid.$meta.baToken
                    });
                }

                _logger.$logger.info('checkout_fpti', logObj);

                $scope.debitCardFlow = angular.isArray($scope.flowEligibility.paymentCardProductClass) && $scope.flowEligibility.paymentCardProductClass.length === 1 && $scope.flowEligibility.paymentCardProductClass[0] === 'DEBIT';

                if ($scope.showmeftsection) {
                    $scope.showmeftsection.toggle = true;
                }

                if ($scope.hideparenthead) {
                    $scope.hideparenthead.toggle = false;
                }

                $scope.manageCardFlow = $scope.sidebar && $scope.cardmodel.card.isExisting();

                var type = $scope.selectedPromotionCardType && $scope.selectedPromotionCardType.type;

                if ($scope.checkoutSession.plccOffer && !type && $scope.promotion) {
                    _uiRouter.$state.go('^.selectCard');
                }

                $scope.showplcc = type === 'plcc';
                $scope.country = _squid.$locale.country;

                $scope.showNotYou = $scope.auth.is_auth_api_call && _squid.$util.param('source') !== 'consumerApp';

                $scope.showHiMsg = Boolean($scope.messagetitle);

                $scope.cardmodel.cardType = 'creditCard';

                if ($scope.checkoutSession.plccOffer && $scope.showplcc) {
                    $scope.cardmodel.cardType = 'privateLabel';
                    $scope.cardmodel.sponsor_id = $scope.checkoutSession.plccOffer.sponsor_id;
                }

                $scope.cardmodel.user = {
                    first_name: $scope.auth.first_name,
                    last_name: $scope.auth.last_name
                };

                $scope.cardmodel.address = $scope.billingAddresses.addresses[0];

                if ($scope.billingaddressupdated.value) {
                    $scope.billingaddressupdated = {
                        msgs: [_squid.$locale.content.get('editCard.newAddressAdded')],
                        type: 'success',
                        value: true
                    };
                }

                $scope.showSidebarBackArrow = $scope.sidebar && !$scope.debitCardFlow && !$scope.checkoutSession.plccOffer && !$scope.cardmodel.card.isExisting();
                $scope.backUri = $scope.backUri || ($scope.showMultipleFI ? 'checkout.review' : 'checkout.review.sidebar.wallet');
                $scope.manageCardFlowBackUri = $scope.backUri || ($scope.showMultipeFI ? 'checkout.review.sidebar.sidebarManageWallet' : 'checkout.review.sidebar.wallet');
                _factory.$AddCardFactory.shouldDisplayAddressBox($scope.isNmjDesign1, $scope.cardmodel, false).then(function (result) {
                    $scope.displayAddressBox = result;
                });

                $scope.gotoBilling = function (address) {
                    if ($scope.pageLevel) {
                        $scope.pageLevel.message = null;
                    }
                    if (!address) {
                        if (_squid.$locale.country === 'BR') {
                            $scope.parentCallbacks.showCep();
                        } else {
                            // page transition
                            var el = $('.tokenization #sidepageAddCard');

                            if (el) {
                                el.addClass('slideLeft');
                            }
                            _uiRouter.$state.go('^.addBilling');
                        }
                    }
                };

                $scope.isCUP = function () {
                    return $scope.cardmodel.card && $scope.cardmodel.card.type && $scope.cardmodel.card.type === 'CUP';
                };

                $scope.isUpdateDebitCard = function () {
                    return _uiRouter.$stateParams.message === 'EXPIRED_DEBIT_CARD';
                };

                $scope.flag = function (field) {
                    return _cardMetaData.$CardMetaData.getMetaData($scope.cardmodel.card, field);
                };

                $scope.buttonText = function () {
                    if ($scope.debitCardFlow) {
                        return 'creditcard.saveBtn';
                    }

                    var contentString = 'creditcard.addBtn';

                    if ($scope.cardmodel.card.isExisting()) {
                        contentString = 'creditcard.updateBtn';
                    } else if ($scope.isCUP()) {
                        contentString = 'creditcard.continuetext';
                    }
                    return contentString;
                };

                $scope.cardTypeChanged = function () {
                    $scope.phone.phoneType = $scope.flag('phoneType');
                };

                function addErrorMessage(contentKey) {
                    if (contentKey) {
                        contentKey = angular.isArray(contentKey) ? contentKey[0] : contentKey;
                        var message = _squid.$locale.content.get('creditcard.' + contentKey);

                        $scope.message.msgs.push(message);
                    }
                }

                function handleContingencies(result, contentBundle, defaultErrorKey, prop) {
                    var errorData = void 0;

                    if (result.errorCodes) {
                        errorData = result;
                    } else {
                        errorData = {
                            errorCodes: result && [result['0']]
                        };
                    }
                    $scope.message = _util.$fiErrorUtil.addPageErrors(errorData, contentBundle, prop, defaultErrorKey);

                    if (window.scrollTo) {
                        window.scrollTo(0, 0);
                    }
                }

                var handleFIContingency = function handleFIContingency(contingency, body) {
                    var contingencyName = body.contingencyName,
                        errorDetails = body.errorDetails;

                    var errorProperty = void 0;
                    var invalidModels = [];
                    var defaultError = 'INTERNAL_ERROR';

                    if ($scope.sidebar) {
                        $scope.$emit('SidebarError');
                    }

                    // for certain contingencies the error message is specific to the type of Checkout flow
                    switch (contingencyName) {
                        case 'CARD_BRAND_NOT_SUPPORTED':
                        case 'CARD_NOT_ALLOWED':
                        case 'CARD_NUMBER_WITH_BAD_BIN':
                        case 'CUP_CARD_NOT_ALLOWED':
                            var flowType = _squid.$config.checkoutFlowType;
                            errorProperty = contingencyName + '_' + flowType;
                            break;
                        case 'VALIDATION_ERROR':
                            defaultError = 'VALIDATION_ERROR_GENERIC';

                            // highlight the fields mentioned in the validation_error response as invalid
                            var _$fiErrorUtil$mapVali = _util.$fiErrorUtil.mapValidationErrorToModel(errorDetails.invalidFields);

                            errorProperty = _$fiErrorUtil$mapVali.errorProperty;
                            invalidModels = _$fiErrorUtil$mapVali.invalidModels;
                            _util.$fiErrorUtil.highlightInvalidFields(invalidModels, $element);
                            break;
                        default:
                            errorProperty = contingencyName;
                            break;
                    }

                    $scope.billingaddressupdated.value = false;
                    $scope.message = _util.$fiErrorUtil.addPageErrorByErrorName('addCardFIErrors', errorProperty, defaultError);

                    var fpti_payload = {
                        'from': 'ADD_CARD',
                        'to': 'process_ADD_CARD',
                        'context_id': $scope.token,
                        'int_error_code': errorProperty,
                        'int_error_description': errorDetails,
                        'error_source': 'filifecycleserv'
                    };

                    if ($scope.cart.isWalletTokenization()) {
                        Object.assign(fpti_payload, {
                            'context_type': 'BA-Token',
                            'ba_token': _squid.$meta.baToken
                        });
                    }

                    _logger.$logger.info('checkout_fpti', fpti_payload);

                    if (window.scrollTo) {
                        window.scrollTo(0, 0);
                    }

                    if (errorDetails && errorDetails.invalidFields && errorDetails.invalidFields[0] === 'BILLING_ADDRESS') {
                        return _factory.$AddCardFactory.shouldDisplayAddressBox($scope.isNmjDesign1, $scope.cardmodel, true).then(function (result) {
                            $scope.displayAddressBox = result;
                        });
                    }
                };

                $scope.cancelFn = function () {
                    // Use callback provided by parent route if there
                    if ($scope.parentCallbacks.cancel) {
                        return $scope.parentCallbacks.cancel();
                    }

                    // For multiple FI variant, route back to review page
                    if ($scope.showMultipleFI) {
                        if ($scope.manageCardFlow) {
                            return _uiRouter.$state.go('checkout.review.sidebar.sidebarManageWallet');
                        }
                        return _uiRouter.$state.go('checkout.review');
                    }

                    if ($scope.sidebar) {
                        if (!$scope.checkoutSession.plccOffer) {
                            return _uiRouter.$state.go('checkout.review.sidebar.wallet');
                        } else {
                            return _uiRouter.$state.go('^.selectCard');
                        }
                    }
                    $scope.done();
                };

                function initiateOTP() {
                    var resolveOTP = new _fi.$ResolveOTP({ id: $scope.cardmodel.id });

                    return resolveOTP.action('init', {
                        data: {
                            phone: {
                                country_code: $scope.phone.IntDialingCountryCode,
                                number: $scope.phone.telephone
                            }
                        },
                        resultModel: {},
                        success: function success() {
                            return _uiRouter.$state.go('.confirmUpop');
                        },
                        error: function error() {
                            return handleContingencies({}, 'confirmUpop', 'declineMessage');
                        },
                        contingencies: {
                            INIT_OTP_CONTINGENCY: function INIT_OTP_CONTINGENCY(name, result) {
                                // prop for last 4 digits of card in error message
                                var prop = {
                                    number: $scope.cardmodel && $scope.cardmodel.card && $scope.cardmodel.card.last4()
                                };

                                handleContingencies(result, 'confirmUpop', 'declineMessage', prop);
                                _util.$fiErrorUtil.addFieldErrors(result, $element);
                            },
                            DEFAULT: function DEFAULT() {
                                return handleContingencies({}, 'confirmUpop', 'declineMessage');
                            }
                        }
                    });
                }

                function handleCheckoutSession(result, isNewCard) {
                    if ($scope.cardmodel && $scope.cardmodel.cardType === 'privateLabel') {
                        delete $scope.checkoutSession.plccOffer;
                    }

                    delete $scope.checkoutSession.errorData;

                    var cardAdded = $scope.cardmodel && $scope.cardmodel.card;
                    var numberAdded = void 0;
                    var cardTypeAdded = void 0;

                    if (cardAdded) {
                        numberAdded = angular.isString(cardAdded.number) && cardAdded.number.replace(/\s/g, '');
                        cardTypeAdded = cardAdded.type;
                    }

                    var last4Added = angular.isString(numberAdded) && numberAdded.substr(numberAdded.length - 4);
                    var cvvData = $scope.checkoutSession && $scope.checkoutSession.cvvData;
                    var last4ToUse = void 0;
                    var cardTypeToUse = void 0;

                    if (cvvData) {
                        last4ToUse = cvvData.number;
                        cardTypeToUse = cvvData.type;
                    }

                    if (last4ToUse === last4Added && cardTypeAdded === cardTypeToUse) {
                        $scope.checkoutSession.set('cvvData.security_code', $scope.cardmodel.get('card.security_code'));
                        $scope.checkoutSession.set('cvvData.lastAddedCard', true);
                    }

                    var updateCardSidebarMessage = (0, _squid.$renderContent)('wallet.cardUpdated', {
                        type: cardTypeAdded,
                        number: last4Added
                    });
                    var updateCardPageMessage = (0, _squid.$renderContent)('smallToolTip.cardUpdated');
                    var addCardMessage = (0, _squid.$renderContent)('smallToolTip.cardAdded');
                    var msgs = [addCardMessage];
                    var createdOffer = Boolean($scope.createOfferModel && $scope.createOfferModel.createdOffer());

                    if (createdOffer) {
                        var createdOfferMessage = (0, _squid.$renderContent)('smallToolTip.incentiveCreated', {
                            incentiveAmount: $scope.incentiveAmount
                        });

                        msgs = [createdOfferMessage];
                    } else if (!isNewCard) {
                        msgs = $scope.manageCardFlow ? [updateCardSidebarMessage] : [updateCardPageMessage];
                    }

                    $scope.checkoutSession.message = {
                        type: 'success',
                        msgs: msgs
                    };
                    // in case user saw No Balance banner and added card successfully - prevent showing the same banner on the review page
                    _factory2.$NoBalanceFactory.markAsAlreadyShown();
                    $scope.done();
                }

                $scope.onSubmit = function () {
                    if ($scope.pageLevel) {
                        $scope.pageLevel.message = null;
                    }
                    var isNewCard = !$scope.cardmodel.card.isExisting();

                    if (isNewCard) {
                        delete $scope.cardmodel.id;
                    }

                    if ($('#plccAgree').is(':checked')) {
                        $scope.cardmodel.preference = true;
                    }

                    // Only initiateOTP needs to be called for unconfirmed CUP contingency. Add card call does not need to be made.
                    if ($scope.isCUP() && $scope.cardmodel.id && ($scope.checkoutSession.get('errorData.cause') === 'NEED_AUTHENTICATED_CARD' || $scope.checkoutSession.get('errorData.cause') === 'EXPIRED_CREDIT_CARD')) {

                        initiateOTP();
                    } else {
                        $scope.cardmodel.save({
                            success: function success() {
                                if ($scope.cart.isWalletTokenization()) {
                                    var fpti_payload = {
                                        'from': 'ADD_DEBIT_CARD',
                                        'to': 'process_ADD_debit_card',
                                        'context_id': $scope.token,
                                        'context_type': 'BA-Token',
                                        'ba_token': _squid.$meta.baToken
                                    };
                                    var handleNotifyChangeContingency = function handleNotifyChangeContingency(name) {
                                        fpti_payload.int_error_desc = name + '_addedButCannotUse';
                                        fpti_payload.error_source = 'paymentapiplatformserv';
                                        fpti_payload.int_error_code = name;
                                        _logger.$logger.info('tokenized_wallet', fpti_payload);
                                        if ($scope.message) {
                                            $scope.message.msgs = [];
                                            $scope.message.type = 'info';
                                        }
                                        addErrorMessage('addedButCannotUse');
                                    };

                                    $scope.checkoutSession.fundingOptions.action('notifyChange', {
                                        resultModel: $scope.checkoutSession,
                                        data: {
                                            planId: $scope.cardmodel.id,
                                            operation: 'ADDED'
                                        },
                                        success: function success(result) {
                                            _logger.$logger.info('tokenized_wallet', fpti_payload);
                                            handleCheckoutSession(result, isNewCard);
                                        },
                                        contingencies: {
                                            TRANSACTION_REFUSED: handleNotifyChangeContingency,
                                            NOTIFY_CHANGE_FUNDING_CONTINGENCY: handleNotifyChangeContingency
                                        }
                                    });
                                } else {
                                    var _fpti_payload = {
                                        'from': 'ADD_CARD',
                                        'to': 'process_ADD_CARD',
                                        'context_id': $scope.token,
                                        'context_type': 'EC-Token'
                                    };

                                    _logger.$logger.info('checkout_fpti', _fpti_payload);

                                    return _angular.$q.when().then(function () {
                                        // setPreferredFI checkbox is checked
                                        if ($scope.showSetPreferredFi && $('#makeFiPreferred').is(':checked')) {
                                            _logger.$logger.info('set_preferredFI_checked');

                                            // set preferred FI before updating
                                            var preferredFi = new _fi.$PreferredFi({
                                                preferred: [$scope.cardmodel.id]
                                            });

                                            return preferredFi.save({
                                                success: function success() {
                                                    _logger.$logger.info('SET_PREFERREDFI_SUCCESS', {
                                                        preferred: [$scope.cardmodel.id]
                                                    });
                                                },
                                                transientError: true,
                                                error: function error(err) {
                                                    return _logger.$logger.error('SET_PREFERREDFI_ERROR', { error: err });
                                                }, // log the error but fails silently because card is added
                                                contingencies: {
                                                    DEFAULT: function DEFAULT(name, contingency) {
                                                        return _logger.$logger.info('SET_PREFERREDFI_CONTINGENCY', name);
                                                    }
                                                }
                                            });
                                        }
                                    }).then(function () {
                                        return (0, _angular.$q)(function (resolve, reject) {
                                            if ($scope.showIncentive) {
                                                var fptiData = {
                                                    from: 'FI_addCardAccount',
                                                    to: 'process_FI_addCardAccount_incentive',
                                                    add_incentive: 0,
                                                    context_id: $scope.token,
                                                    add_incentive_reason: ''
                                                };

                                                (0, _squid.$populate)($scope, {
                                                    evaluateCheckoutOfferEligibilityModel: _checkoutIncentive.$EvaluateCheckoutOfferEligibilityModel.instance().retrieve(),
                                                    getOfferProgramModel: _checkoutIncentive.$GetOfferProgramModel.instance().retrieve()
                                                }).then(function () {
                                                    var createOfferData = {
                                                        payer_id: $scope.auth.buyer_id,
                                                        offer_program_id: $scope.evaluateCheckoutOfferEligibilityModel.getOfferProgramID(),
                                                        value_issued: $scope.getOfferProgramModel.getOfferValueLowestDenom(),
                                                        currency_code: $scope.evaluateCheckoutOfferEligibilityModel.getCurrencyCode()
                                                    };

                                                    $scope.createOfferModel = _checkoutIncentive.$CreateOfferModel.instance();

                                                    return $scope.createOfferModel.save({
                                                        data: createOfferData,
                                                        success: function success() {
                                                            if ($scope.createOfferModel.createdOffer()) {
                                                                fptiData.incentive_added = 1;
                                                                _logger.$logger.info('checkout_fpti', fptiData);
                                                                resolve('Incentive created');
                                                            } else {
                                                                fptiData.add_incentive_reason = 'Offerserv_User_Not_Eligible';
                                                                _logger.$logger.info('checkout_fpti', fptiData);
                                                                resolve('Incentive not created');
                                                            }
                                                        },
                                                        validation: function validation(_validation) {
                                                            fptiData.add_incentive_reason = 'Validation_Error';
                                                            _logger.$logger.info('checkout_fpti', fptiData);
                                                            resolve('Validation error encountered creating incentive');
                                                        },
                                                        contingencies: {
                                                            DEFAULT: function DEFAULT(msg, contingency) {
                                                                fptiData.add_incentive_reason = msg;
                                                                _logger.$logger.info('checkout_fpti', fptiData);
                                                                resolve('Contingency encountered creating incentive');
                                                            }
                                                        },
                                                        error: function error() {
                                                            fptiData.add_incentive_reason = 'Offerserv_Error';
                                                            _logger.$logger.info('checkout_fpti', fptiData);
                                                            resolve('Error encountered creating incentive');
                                                        }
                                                    });
                                                });
                                            } else {
                                                resolve('Not eligible for incentive');
                                            }
                                        });
                                    }).then(function () {
                                        if ($scope.isCUP()) {
                                            initiateOTP();
                                        } else {
                                            return $scope.checkoutSession.fundingOptions.action('update', {
                                                resultModel: $scope.checkoutSession,
                                                data: {
                                                    planId: $scope.cardmodel.id
                                                },
                                                success: function success(result) {
                                                    return handleCheckoutSession(result, isNewCard);
                                                },
                                                contingencies: {
                                                    TRANSACTION_REFUSED: function TRANSACTION_REFUSED(name) {
                                                        $scope.message.msgs = [];
                                                        $scope.message.type = 'info';
                                                        addErrorMessage('addedButCannotUse');
                                                    }
                                                }
                                            });
                                        }
                                    });
                                }
                            },
                            contingencies: {
                                DEFAULT: handleFIContingency
                            },
                            error: function error() {
                                return handleContingencies({}, 'creditcard', 'errorInternalError');
                            }
                        });
                    }
                };
            });
        }]
    };
});

_angular.$q;

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_squid.$config;

_squid.$feature;

_squid.$locale;

_squid.$meta;

_squid.$populate;

_squid.$renderContent;

_squid.$util;

_squid.formatNameInformal;

_auth.$AuthModel;

_choice.$ChoiceEligibility;

_newMember.$NewMemberEligibility;

_index.$TokenizedWalletInfoModel;

_fi.$BillingAddressesModel;

_fi.$PreferredFi;

_fi.$ResolveOTP;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutSessionModel;

_index2.$FlowEligibilityModel;

_checkoutIncentive.$CreateOfferModel;

_checkoutIncentive.$EvaluateCheckoutOfferEligibilityModel;

_checkoutIncentive.$GetOfferProgramModel;

_util.$fiErrorUtil;

_cardMetaData.$CardMetaData;

_factory.$AddCardFactory;

_factory2.$NoBalanceFactory;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addcard/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$AddCardFactory', function () {
    var shouldDisplayAddressBox = function shouldDisplayAddressBox(isNmjDesign1, cardModel, invalidfield) {
        var avsRetry = _squid.$util.param('avsRetry') || invalidfield;
        var redirectFromXoon = _squid.$util.param('redirectToHermes') ? '1' : '0';
        if (!cardModel || !cardModel.address) {
            return _squid.$promise.resolve(false);
        }
        if (isNmjDesign1) {
            return _squid.$promise.resolve(true);
        }
        if (avsRetry) {
            return (0, _squid.$pxp)('xo_hermes_addcard_msg', { 'ctx.COUNTRY': _squid.$locale.country, 'ctx.XOON_REDIRECT': redirectFromXoon, 'ctx.AVS': avsRetry }, 'xo_hermes_addcard_msg_xoon_redirect_avs_address_box').then(function (result) {
                return result && result.treatment_name;
            });
        }
        return _squid.$promise.resolve(false);
    };

    var getAddCardPxpResult = function getAddCardPxpResult() {
        var redirectFromXoon = _squid.$util.param('redirectToHermes') ? '1' : '0';
        var retry = _squid.$util.param('addFIContingency') === 'retry' ? '1' : '0';
        var avsRetry = _squid.$util.param('avsRetry') ? '1' : '0';
        if (_squid.$util.param('avsRetry')) {
            return (0, _squid.$pxp)('xo_hermes_addcard_msg', { 'ctx.COUNTRY': _squid.$locale.country, 'ctx.XOON_REDIRECT': redirectFromXoon, 'ctx.AVS': avsRetry }, '(xo_hermes_addcard_msg_)(.*)').then(function (result) {
                return result;
            });
        } else {
            return (0, _squid.$pxp)('xo_hermes_addcard_msg', { 'ctx.COUNTRY': _squid.$locale.country, 'ctx.XOON_REDIRECT': redirectFromXoon, 'ctx.RETRY': retry, 'ctx.AVS': avsRetry }, '(xo_hermes_addcard_msg_)(.*)').then(function (result) {
                return result;
            });
        }
    };

    var getCheckoutIncentivePxpResult = function getCheckoutIncentivePxpResult() {
        return (0, _squid.$pxp)('xo_hermes_checkout_incentive', {}, '(xo_hermes_checkout_incentive_)(.*)').then(function (result) {
            return result && result.treatment_name;
        });
    };

    return {
        shouldDisplayAddressBox: shouldDisplayAddressBox,
        getAddCardPxpResult: getAddCardPxpResult,
        getCheckoutIncentivePxpResult: getCheckoutIncentivePxpResult
    };
});

_squid.$locale;

_squid.$promise;

_squid.$pxp;

_squid.$util;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-card/addcard", "../node_modules/xo-wallet-components/src/add-card/addcard/factory.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addcard/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _route = __webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/route.js");

var _route2 = _interopRequireDefault(_route);

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/addcard/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$AddCardRoute', function () {
    return _squid.$ComponentRoute.extend('AddCardRoute', {
        name: 'addCard',
        directive: 'xo-add-card',
        titleContent: 'asideHeader.addCard',

        trackingData: {
            fptiState: 'add_or_update_cc'
        },
        loginRequired: true,
        children: [{
            route: _route2['default'],
            attributes: {
                token: 'token',
                phone: 'phone',
                cardmodel: 'cardmodel',
                'on-success': 'onSuccess',
                'show-incentive': 'showIncentive',
                'incentive-amount': 'incentiveAmount'
            }
        }]
    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-card/addcard", "../node_modules/xo-wallet-components/src/add-card/addcard/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addcard/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addcard/template.html":
/***/ (function(module, exports) {

module.exports = "\n<div content modal-box=\"!!sidebar\" modal-cancel=\"cancelFn()\" xo-tray-height class=wallet>\n    <xo-aside-header back-url=\"{{backUri}}\" heading=\"{{isIndiaAndBilling ? 'asideHeader.addCreditCard' : 'asideHeader.addCard'}}\" ng-if=\"showSidebarBackArrow\"></xo-aside-header>\n    <div class=\"header noButtons\" ng-if=\"manageCardFlow\">\n        <h1 class=\"asideAlpha walletHeading noHead noBottom alpha\">{{ content('asideHeader.updateCard', {type: cardmodel.card.name, number: cardmodel.card.lastDigits}) }}</h1>\n        <a link-button ui-sref=\"{{manageCardFlowBackUri}}\" class=\"backArrow goTray\">\n            <span class=\"accessAid\">{{ content('common.back') }}</span>\n        </a>\n    </div>\n    <xo-aside-header back-url=\"^.selectCard\" heading='asideHeader.selectCard' ng-if=\"sidebar && checkoutSession.plccOffer\"></xo-aside-header>\n    <p class=\"userEmail\" id=\"reviewUserInfo\" ng-if=\"showHiMsg\">\n        {{ content('creditcard.hi', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n            <span ng-if=\"showNotYou\">\n                <xo-not-you></xo-not-you>\n            </span>\n    </p>\n    <h1 class=\"gamma\" ng-if=\"messagetitle\">{{ messagetitle }}</h1>\n    <div class=\"reviews\" ng-if=\"isNmjDesign1\">\n        <xo-banner is-nmj=\"isNmjDesign1\" class=\"nmjDesign1Banner\">\n            <p class=\"userEmail\" id=\"reviewUserInfo\">\n                <span ng-if=\"isNmjDesign1\">{{ content('memberReview.hiUser_welcome', {userName: formattedNameInformal}) }}</span>\n                <span ng-if=\"showNotYou\">\n                    <xo-not-you></xo-not-you>\n                </span>\n            </p>\n        </xo-banner>\n        <xo-assist-banner header=\"content(contentKey.header)\" body=\"content(contentKey.body)\">\n        </xo-assist-banner>\n    </div>\n    <div class=\"greyHeader\" ng-if=\"isNmjDesign2 || isNmjDesign3\">\n        <xo-banner is-nmj=\"isNmjDesign2 || isNmjDesign3\">\n            <p class=\"userEmail\" id=\"reviewUserInfo\">\n                <span ng-if=\"isNmjDesign2 || isNmjDesign3\">{{ headerMsg }}</span>\n                <span ng-if=\"showNotYou\" class=\"greyHeaderNotYou\">\n                    <xo-not-you></xo-not-you>\n                </span>\n            </p>\n        </xo-banner>\n    </div>\n    <div ng-if=\"showAddBank && isNmjDesign1\" class=\"addBankLink BANK_ACCOUNT\">\n        <a track-link=\"add_bank\" href=\"{{addBankUri}}\" role=\"button\">\n            <span class=\"fsIcons\"></span>\n            <span class=\"name\">{{ content('addCard.addBank') }}</span>\n        </a>\n    </div>\n\n    <xo-message message=\"message\" isGreyHeader=\"isGreyHeader\" ng-if=\"showMessageBanner\"></xo-message>\n\n    <h1 class=\"gamma\" ng-if=\"showPageTitle\">{{ pagetitle }}</h1>\n\n    <!-- For No balance experiment show Add Card header and No Fi contingency text message instead of the xo-message alert -->\n    <div ng-if=\"showNoBalanceHeaderAndNoFiContingency\">\n        <h1 class=\"alpha noBalanceAddCardHeader\">{{ content('asideHeader.selectCard') }}</h1>\n        <p class=\"noBalanceAddCardMsg\">{{ content('creditcard.noFIContingency') }}</p>\n    </div>\n\n    <div ng-class=\"{true: 'sidebar'}[asideContent]\" xo-tray-height>\n        <form id=\"creditCardForm\" name=\"creditCardForm\" class=\"addCard asideView asideContent\" content form-autofocus novalidate>\n            <div class=\"trayInner container\">\n                <p id=\"addCardDebitCardFlow\" ng-if=\"debitCardFlow && !isUpdateDebitCard()\">\n                    {{ content('addCard.commonAddTopupDebitCard', { type: tokenizedWalletInfoModel.brandName() }) }}\n                </p>\n                <xo-message message=\"message\" ng-if=\"sidebar\"></xo-message>\n                <xo-message id=\"billingAddressUpdatedMsg\" ng-if=\"billingaddressupdated.value\" message=\"billingaddressupdated\"></xo-message>\n                <xo-name-input user=\"cardmodel.user\" country=\"{{country}}\"></xo-name-input>\n\n                <xo-credit-card token=\"token\" card=\"cardmodel.card\" user=\"cardmodel.user\"\n                                selected-promotion-card-type=\"selectedPromotionCardType\"\n                                card-type-changed=\"cardTypeChanged\" promotion=\"promotion\"\n                                manage-card-flow=\"manageCardFlow\"></xo-credit-card>\n\n                <xo-address-box ng-if=\"displayAddressBox\"\n                                header=\"content('addCard.billingAddress')\"\n                                fullname=\"cardmodel.user\"\n                                addresses=\"billingAddresses\"\n                                change-fn=\"address_box.changeFn\">\n                </xo-address-box>\n\n                <div ng-if=\"!displayAddressBox && flag('fields.address')\" id=\"billingAddress\" class=\"dropdown billingAddress confidential\">\n                    <label for=\"billingAddressDropdown\" class=\"billingAddressLabel\">\n                        {{ content(\"addressBook.billingAddress\") }}\n                        <a href=\"\" link-button ng-click=\"gotoBilling()\" class=\"addNewBillingAddress\" data-test-id=\"addBillingLink\" aria-label=\"{{ content('addCard.addNewBillingAddress') }}\">{{ content(\"addressBook.add\") }}</a>\n                    </label>\n                    <div class=\"dropdown billingAddress nullable\">\n                        <select xo-dropdown default=\"{{content('addCard.addNewBillingAddress')}}\" ng-model=\"cardmodel.address\"\n                                ng-change=\"gotoBilling(cardmodel.address)\"\n                                ng-options=\"address.full_address for address in billingAddresses.addresses\"\n                                name=\"billingAddress\" id=\"billingAddressDropdown\" required>\n                        </select>\n                    </div>\n                </div>\n\n                <div ng-if=\"flag('fields.phone')\">\n                    <div class=\"otpVerification\" ng-bind-html=\"htmlContent('confirmUpop.debitInitOtp')\"></div>\n                    <xo-phone-input token=\"token\" show-phone-type=\"false\" phone=\"phone\"></xo-phone-input>\n                </div>\n\n                <div ng-if=\"showAddBank && (isNmjDesign2 || isNmjDesign3)\" class=\"addBankLink BANK_ACCOUNT\">\n                    <a track-link=\"add_bank\" href=\"{{addBankUri}}\" role=\"button\">\n                        <span class=\"fsIcons\"></span>\n                        <span class=\"name\">{{ content('addCard.linkBank') }}</span>\n                        <span class=\"linkBankArrow\"></span>\n                    </a>\n                </div>\n\n                <div ng-if=\"showplcc\">\n                    <div class=\"plccAgree checkbox\">\n                        <input type=\"checkbox\" checked=\"true\" name=\"plccAgree\" id=\"plccAgree\" />\n                        <label class=\"noBottom\" for=\"plccAgree\">{{content('addCard.plccPreferMethod', { merchant: promotion.name})}}</label>\n                    </div>\n                    <div class=\"legal\">{{content('addCard.plccLegal', { merchant: promotion.name})}}</div>\n                </div>\n\n                <div ng-if=\"showSetPreferredFi\">\n                    <div class=\"checkbox\">\n                        <input type=\"checkbox\" name=\"makeFiPreferred\" id=\"makeFiPreferred\" />\n                        <label for=\"makeFiPreferred\">{{ content('addCard.makeFiPreferred') }}</label>\n                    </div>\n                    <div class=\"legal infoTxt\">{{content('addCard.makeFiPreferredLegal')}}\n                        <span id=\"setPreferredFiLearnMore\" bind-html-compile=\"htmlContent('addCard.learnMore')\"></span>\n                    </div>\n                </div>\n\n                <div class=\"buttons\">\n                    <input track-submit=\"{{cardmodel.card.isExisting() ? 'update_cc' : 'add_cc' }}\" type=\"submit\" value=\"{{ content(buttonText()) }}\" id=\"proceedButton\" data-test-id=\"addCardButton\" class=\"btn full\" validate-submit=\"onSubmit()\" />\n                </div>\n\n                <div ng-if=\"showCancel && !(isNmjDesign2 || isNmjDesign3)\" class=\"linkButton\">\n                    <a link-button prevent-default href=\"#\" data-test-id=\"cancelButton\" ng-click=\"parentCallbacks.cancel()\">{{content('common.cancel')}}</a>\n                </div>\n            </div>\n        </form>\n    </div>\n\n    <div ui-view></div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cardExpiry/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports.$xoCardExpiryDirective = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardExpiry/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCardExpiryDirective = exports.$xoCardExpiryDirective = _squid.$Component.extend('$xoCardExpiryDirective', {
    tag: 'xo-card-expiry',
    template: _template2['default'],
    props: {
        expiryMonth: {
            type: 'var',
            required: false
        },
        expiryYear: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            var format = (0, _squid.$feature)('ccExpiryDateFormat', 'MMYY', _squid.$locale.country);
            var regexPattern = format === 'MMYY' ? /(0\d|1[0-2])\/(\d{2})/ : /(0\d|1[0-2])\/(\d{4})/;

            var init = function init() {
                if (_this.expiryMonth && _this.expiryYear) {
                    _this.expiryDate = format === 'MMYY' ? _this.expiryMonth + '/' + _this.expiryYear.substring(2, 4) : _this.expiryMonth + '/' + _this.expiryYear;
                }
            };
            init();
            this.$watch('[expiryMonth, expiryYear]', function (expiryInfo) {
                if (expiryInfo && expiryInfo[0] && expiryInfo[1]) {
                    _this.expiryMonth = expiryInfo[0];
                    _this.expiryYear = expiryInfo[1];
                    init();
                }
            });

            $('#expiry_value').mask(format === 'MMYY' ? '00/00' : '00/0000');

            this.validate = function (expiryDate) {
                if (!expiryDate) {
                    return false;
                }

                var regexMatch = regexPattern.exec(expiryDate);
                if (!regexMatch) {
                    return false;
                }

                var today = new Date();
                var currentYear = today.getFullYear();
                var expMonth = Number(regexMatch[1]);
                var expYear = Number(regexMatch[2]);

                if (format === 'MMYY') {
                    // convert year from YY to YYYY format e.g currentYear = 2017, expYear = 20,
                    // result should be (2020) = (2017 - 17 + 20)
                    expYear = currentYear - currentYear % 100 + expYear;
                }

                var expDate = new Date(expYear, expMonth - 1);

                if (expDate < today) {
                    return false;
                }

                _this.expiryYear = expYear.toString();

                // expiryMonth need to have leading 0 for single digit month
                _this.expiryMonth = expMonth < 10 ? '0' + expMonth : expMonth.toString();

                return true;
            };
        }
    }
});

angular.value("$xoCardExpiryDirective", $xoCardExpiryDirective);
_squid.$Component;

_squid.$locale;

_squid.$feature;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cardExpiry/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"expirationField inputField\" id=\"expirationField\" directionality content>\n    <label class=\"expires\" for=\"expiry_value\">{{ content('creditcard.expiresLabel') }}</label>\n    <div class=\"inputField\" directionality>\n        <input ng-model=\"expiryDate\"\n               name=\"expiry_value\"\n               id=\"expiry_value\"\n               data-test-id=\"ccExpiryInput\"\n               value=\"\"\n               maxlength=\"{{maxlength}}\"\n               autocapitalize=\"off\"\n               aria-describedby=\"expiryHelp\"\n               autocomplete=\"off\"\n               ui-validate=\"'validate($value)'\"\n               placeholder=\"{{content('creditcard.expiresPlaceholder')}}\"\n               data-error-text=\"{{content('validation.validExpirationDate')}}\"\n               xo-error-tooltip\n               required />\n        <span id=\"expiryHelp\" class=\"accessAid\" ng-bind=\"content('creditcard.expiresPlaceholder')\"></span>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cardIssueDate/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports.$xoCardIssueDateDirective = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardIssueDate/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCardIssueDateDirective = exports.$xoCardIssueDateDirective = _squid.$Component.extend('$xoCardIssueDateDirective', {
    tag: 'xo-card-issue-date',
    template: _template2['default'],
    props: {
        issueMonth: {
            type: 'var',
            required: false
        },
        issueYear: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.dateFormat = (0, _squid.$feature)('ccIssueDateDateFormat', 'MMYY', _squid.$locale.country);

            if (this.dateFormat === 'MMYY') {
                this.maxlength = 5;
                this.mask = '99/99';
            } else if (this.dateFormat === 'MMYYYY') {
                this.maxlength = 7;
                this.mask = '99/9999';
            }

            this.formatIssueDate = function (event) {
                var key = event.keyCode || event.charCode;
                var $el = $(event.target);
                var val = $el.val().replace(/[^0-9\/]/gi, '');
                var strokes = val.length;

                // Ignore delete keys
                if (key === 8 || key === 46) {
                    return;
                }

                // after two characters add a slash char
                if (strokes === 2) {
                    val += '/';
                }

                _this.issueDate = val;
                $el.mask(_this.mask);
            };

            var currentYear = new Date().getFullYear();
            var validMonths = _squid.$util.map(_squid.$util.range(1, 13), function (num) {
                return ('0' + num).substr(-2);
            });
            var validYears = _squid.$util.map(_squid.$util.range(currentYear - 10, currentYear + 1), function (y) {
                return y.toString();
            });

            this.validate = function (issueDate) {
                if (!issueDate) {
                    return;
                }

                var month = void 0,
                    year = void 0,
                    unformatted = void 0;
                var isValid = false;

                unformatted = issueDate.replace(/[^0-9]/gi, '');
                if (unformatted.length > 3) {
                    month = unformatted.substring(0, 2);
                    if (_this.dateFormat === 'MMYY') {
                        year = currentYear.toString().substring(0, 2) + unformatted.substring(2, 4);
                    } else if (_this.dateFormat === 'MMYYYY') {
                        year = unformatted.substring(2, 6);
                    }

                    isValid = validMonths.indexOf(month) > -1 && validYears.indexOf(year) > -1;

                    if (isValid) {
                        var date = new Date(year, parseInt(month, 10) - 1);
                        var today = new Date();
                        isValid = date < today;
                    }
                }

                _this.issueYear = year;
                _this.issueMonth = month;

                return isValid;
            };
        }
    }
});

angular.value("$xoCardIssueDateDirective", $xoCardIssueDateDirective);
_squid.$Component;

_squid.$locale;

_squid.$feature;

_squid.$util;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cardIssueDate/template.html":
/***/ (function(module, exports) {

module.exports = "<div content directionality>\n    <input ng-model=\"issueDate\"\n           name=\"issue_date_value\"\n           id=\"issue_date_value\"\n           value=\"\"\n           maxlength=\"{{maxlength}}\"\n           autocapitalize=\"off\"\n           aria-describedby=\"issueHelp\"\n           autocomplete=\"off\"\n           ui-validate=\"'validate($value)'\"\n           ng-keyup=\"formatIssueDate($event)\"\n           placeholder=\"{{content('creditcard.expiresPlaceholder')}}\"\n           data-error-text=\"{{content('validation.validIssueDate')}}\"\n           xo-error-tooltip\n           required />\n    <span id=\"issueHelp\" class=\"accessAid\" ng-bind=\"content('creditcard.expiresPlaceholder')\"></span>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cardMetaData/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports.$CardMetaData = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CARD_META_DATA = {
    DEFAULT: {
        fields: {
            address: true,
            cvv: true,
            dob: false,
            expiry: true,
            issue: false,
            phone: false
        },
        length: {
            cvv: 3,
            min: 16,
            max: 16
        },
        luhn: true,
        phoneType: 'Mobile',
        spaces: '4,8,12'
    },

    PLCC: {
        fields: {
            expiry: false,
            cvv: false,
            address: false
        },
        length: {
            min: 10,
            max: 16
        }
    },

    MAESTRO: {
        pattern: /^(5018|5020|5038|4903|4911|4936|564182|545250|504834|503615|6333|6304|6759|676[1-3]|0604)/,
        length: {
            min: 12,
            max: 19
        },
        spaces: '4,8,12,16'
    },

    SWITCH: {
        pattern: /^(5018|5020|5038|4903|4911|4936|564182|545250|504834|503615|6333|6304|6759|676[1-3]|0604)/,
        fields: {
            issue: true
        },
        length: {
            min: 12,
            max: 19
        },
        spaces: '4,8,12,16'
    },

    DINERSCLUB: {
        pattern: /^(36|38|30[0-5])/,
        length: {
            min: 14,
            max: 14
        }
    },

    DISCOVER: {
        pattern: /^(6011|65|64[4-9]|622|36|38|30[0-5])/,
        length: {
            min: 14
        }
    },

    MASTERCARD: {
        pattern: /^(5[1-5]|2(2(2[1-9]|[3-9]\d)|[3-6]\d\d|7[0-1]\d|720))/
    },

    AMEX: {
        pattern: /^3[47]/,
        length: {
            cvv: 4,
            min: 15,
            max: 15
        },
        spaces: '4,10'
    },

    VISA: {
        pattern: /^4/,
        length: {
            min: 13
        },
        subTypes: {
            QIWI: {
                pattern: /^(428122|489049|469395|446942|462012)/
            }
        }
    },

    JCB: {
        pattern: /^(?:2131|1800|35[0-9]{2})/,
        length: {
            min: 15
        }
    },

    CBNATIONALE: {},

    CETELEM: {
        fields: {
            dob: true
        },
        length: {
            max: 19
        },
        spaces: '4,8,12,16'
    },

    COFIDIS: {
        fields: {
            dob: true,
            expiry: false,
            cvv: false
        },
        length: {
            min: 8,
            max: 9
        },
        spaces: '4,8',
        luhn: false
    },

    COFINOGA: {
        fields: {
            dob: true,
            cvv: false
        },
        length: {
            min: 17,
            max: 17
        },
        spaces: '4,8,12,16'
    },

    ELO: {
        pattern: /^9/,
        length: {
            min: 13
        }
    },

    HIPER: {
        pattern: /^6/,
        length: {
            min: 13
        }
    },

    HIPERCARD: {
        pattern: /^7/,
        length: {
            min: 13
        }
    },

    CUPCREDIT: {
        fields: {
            address: false,
            phone: true
        },
        length: {
            max: 19
        }
    },

    CUPAMEXCREDIT: {
        fields: {
            address: false,
            phone: true
        },
        length: {
            cvv: 4,
            min: 15,
            max: 15
        }
    },

    CUPDEBIT: {
        fields: {
            address: false,
            cvv: false,
            expiry: false,
            phone: true
        },
        length: {
            max: 19
        }
    },

    CUPAMEXDEBIT: {
        fields: {
            address: false,
            cvv: false,
            expiry: false,
            phone: true
        },
        length: {
            min: 15,
            max: 15
        }
    }
};

Object.keys(CARD_META_DATA).forEach(function (key) {
    CARD_META_DATA[key] = $.extend(true, {}, CARD_META_DATA.DEFAULT, CARD_META_DATA[key]);
});

Object.keys(CARD_META_DATA).forEach(function (key) {
    CARD_META_DATA[key].spaces = CARD_META_DATA[key].spaces.split(',').map(Number);
});

function getTypeByPattern(cardMetaData, types, number) {
    var result = void 0;
    types.some(function (type) {
        var metaData = cardMetaData[type];
        if (metaData && metaData.pattern && metaData.pattern.test(number)) {
            result = type;
            return true;
        }
    });
    return result;
}

var $CardMetaData = exports.$CardMetaData = {
    getMetaData: function getMetaData(card, field) {
        var cardType = card && card.type || 'DEFAULT';
        if (cardType === 'CUP') {
            cardType = cardType + (card.dualType ? card.dualType : '');
            cardType = cardType + (['DEBIT', 'DEBITCARD'].indexOf(card.productType) > -1 ? 'DEBIT' : 'CREDIT');
        }
        return _squid.$Class.get(CARD_META_DATA[cardType], field);
    },
    getCardType: function getCardType(types, number) {
        var cardType = {};
        if (_angular2['default'].isArray(types) && number) {
            cardType.type = getTypeByPattern(CARD_META_DATA, types, number);
            var metaData = CARD_META_DATA[cardType.type];
            if (metaData && metaData.subTypes) {
                cardType.subType = getTypeByPattern(metaData.subTypes, types, number);
            }
        }
        return cardType;
    }
};

_angular2['default'].value("$CardMetaData", $CardMetaData);
_squid.$Class;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/creditcard-input/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/name-input/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardExpiry/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardIssueDate/directive.js");

var _cardMetaData = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardMetaData/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/cvv/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/dob/directive.js");

__webpack_require__("../node_modules/xo-angular-ui-utils/ui-utils.min.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/creditcard-input/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('scrollToTop', function () {
    return {
        link: function link(scope, element, attr) {
            $(element).on('focus', function () {
                if ($('#mxCardTitle').is(':visible')) {
                    $('#creditCardForm').scrollTop($(element).offset().top);
                }
            });
        }
    };
}).directive('xoCreditCard', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            token: '=?',
            card: '=?',
            user: '=?',
            selectedPromotionCardType: '=?',
            promotion: '=?',
            cardTypeChanged: '=?',
            cardNumberChanged: '=?',
            manageCardFlow: '=?'
        },
        controller: ['$scope', function ($scope) {
            $scope.cardLengthValid = function (number) {
                if ($scope.card && $scope.card.isExisting()) {
                    return true;
                }

                number = (number || '').replace(/[^0-9]+/g, '');

                return number.length >= $scope.flag('length.min') && number.length <= $scope.flag('length.max');
            };

            $scope.cardLuhnValid = function (input) {
                if (!$scope.flag('luhn')) {
                    return true;
                }

                if ($scope.card && $scope.card.isExisting()) {
                    return true;
                }

                input = (input || '').replace(/[^0-9]+/g, '');

                var numdigits = input.length;
                var parity = numdigits % 2;
                var sum = 0;
                var i = 0;
                var digit = void 0;

                for (; i < numdigits; i++) {
                    digit = parseInt(input.charAt(i), 10);

                    if (i % 2 === parity) {
                        digit *= 2;
                    }

                    if (digit > 9) {
                        digit -= 9;
                    }

                    sum += digit;
                }

                return sum % 10 === 0;
            };

            $scope.cardProductValid = function () {
                return $scope.debitCardFlow ? $scope.card.productType === 'DEBIT' : true;
            };

            $scope.isPlcc = $scope.selectedPromotionCardType && $scope.selectedPromotionCardType.type === 'plcc';

            $scope.flag = function (field) {
                if ($scope.isPlcc && !$scope.card.type) {
                    $scope.card.type = 'PLCC';
                }
                return _cardMetaData.$CardMetaData.getMetaData($scope.card, field);
            };

            $scope.maxLength = function () {
                if ($scope.card && $scope.card.isExisting()) {
                    return 30;
                }

                return $scope.flag('length.max') + $scope.flag('spaces.length');
            };

            (0, _squid.$populate)($scope, {
                flowEligibility: _checkout.$FlowEligibilityModel.instance($scope.token).retrieve({
                    params: {
                        geolocation: _squid.$meta.geolocation,
                        localeCountry: _squid.$locale.country
                    }
                })
            }).then(function () {
                $scope.debitCardFlow = angular.isArray($scope.flowEligibility.paymentCardProductClass) && $scope.flowEligibility.paymentCardProductClass.length === 1 && $scope.flowEligibility.paymentCardProductClass[0] === 'DEBIT';

                $scope.locale = _squid.$locale;
                $scope.country = $scope.locale.country;
                var cardTypeServiceCall = (0, _squid.$feature)('cardTypeServiceCallRequired', false, $scope.country);

                // For APay provisioning flow, we use service call once we have the minimum number of digits
                // for the card.
                $scope.tokenizedWalletCardTypeServiceCall = false;

                var isUnsupportedCard = void 0;
                var lastVerifiedBin = '';
                var lastRequestedBin = void 0; // bin requested to service to fetch card type and pending response.

                $scope.mxDebitCards = ['BANAMEX', 'BANCOARFACA', 'BBVA', 'BANORTE', 'HSBC', 'INBURSA', 'SANTANDER'];

                if ($scope.card && $scope.card.number) {
                    $scope.unformattedCardNumber = ($scope.card.number || '').replace(/[^0-9]+/g, '').slice(0, $scope.maxLength());
                }

                $scope.showMXCardLogos = function () {
                    return _squid.$locale.country === 'MX';
                };

                (0, _squid.$populate)($scope, {
                    cardTypes: _fi.$CardTypesModel.instance($scope.token + ':' + _squid.$locale.country, {
                        token: $scope.token,
                        country: _squid.$locale.country
                    })
                }).then(function () {
                    var scanCardExperimentEligibility = function scanCardExperimentEligibility() {
                        if (!_index.$DeviceInfo.isSafariiOSBrowserView()) {
                            return _squid.$promise.resolve(false);
                        }
                        // Scan credit card feature is only available in iosVersion 8+
                        if (_index.$DeviceInfo.isSafariiOSBrowserView() && _index.$DeviceInfo.getiOSVersion()[0] < 8) {
                            return _squid.$promise.resolve(false);
                        }

                        return (0, _squid.$elmo)('xo_hermes_addcard_camera_icon_member', { 'ctx.COUNTRY': _squid.$locale.country }, 'xo_hermes_addcard_camera_icon_member_show');
                    };

                    scanCardExperimentEligibility().then(function (result) {
                        $scope.showScanCardExperiment = result || false;
                    });

                    $scope.debitCardFlow = angular.isArray($scope.flowEligibility.paymentCardProductClass) && $scope.flowEligibility.paymentCardProductClass.length === 1 && $scope.flowEligibility.paymentCardProductClass[0] === 'DEBIT';
                    var forceDropDown = false;

                    $scope.supportedCardNamesCommaSeparated = $scope.cardTypes.supportedNames().join(', ');

                    $scope.$on('localeChange', function () {
                        $scope.cardTypes = _fi.$CardTypesModel.instance($scope.token + ':' + _squid.$locale.country, {
                            token: $scope.token,
                            country: _squid.$locale.country
                        });

                        $scope.cardTypes.retrieve().then(function () {
                            if ($scope.card.type && $scope.cardTypes.allowed.indexOf($scope.card.type) === -1) {
                                delete $scope.card.type;
                                forceDropDown = false;
                                $scope.changeCardNumber(true);
                            }
                        });

                        $scope.country = _squid.$locale.country;
                    });

                    $scope.cvvShown = function () {
                        if ($scope.card.type === 'CETELEM' && $scope.locale.country === 'FR') {
                            return false;
                        }

                        if ($scope.card.type === 'CUP' && $scope.card.productType === 'DEBITCARD') {
                            return false;
                        }

                        if ($scope.isPlcc && $scope.card.type) {
                            return true;
                        }

                        return $scope.flag('fields.cvv');
                    };

                    $scope.expiryShown = function () {
                        if ($scope.isPlcc && $scope.card.type) {
                            return true;
                        }
                        if ($scope.card.type === 'CUP' && $scope.card.productType === 'DEBITCARD') {
                            return false;
                        }

                        return $scope.flag('fields.expiry');
                    };

                    $scope.enableDropDown = function () {
                        return Boolean(['ES', 'FR', 'GB', 'IT'].indexOf($scope.locale.country) > -1) || forceDropDown;
                    };

                    $scope.showDropDown = function () {
                        if ($scope.enableDropDown()) {
                            return true;
                        }

                        if (!$scope.card.type && $scope.card.number && $scope.card.number.length >= 4 && !(cardTypeServiceCall || $scope.tokenizedWalletCardTypeServiceCall) && !$scope.isPlcc) {
                            return true;
                        }

                        if (!$scope.card.type && $scope.card.number && $scope.card.number.length >= 7 && (cardTypeServiceCall || $scope.tokenizedWalletCardTypeServiceCall) && isUnsupportedCard) {
                            return true;
                        }

                        return false;
                    };

                    $scope.showAcceptedCardLogos = function () {
                        return !$scope.showDropDown() && (0, _squid.$feature)('showAcceptedCardLogos', false, $scope.country);
                    };

                    $scope.getCardTypeByNumber = function (types, number) {
                        if ($scope.isPlcc && number.length > 6 || !$scope.isPlcc) {
                            return _cardMetaData.$CardMetaData.getCardType(types, number);
                        }
                    };

                    function formatCardNumber(number) {
                        var spaces = $scope.flag('spaces');
                        var formatted = [];

                        for (var i = 0; i < number.length; i++) {
                            if (spaces.indexOf(i) > -1) {
                                formatted.push(' ');
                            }

                            formatted.push(number.charAt(i));
                        }

                        number = formatted.join('');
                        return number;
                    }

                    $scope.$watch('card.type', function () {
                        if ($scope.cardTypeChanged) {
                            $scope.cardTypeChanged();
                        }
                    });

                    /**
                     * Hit Callback(unformatted cc no) when user gets out of the cardNumber field.
                     */
                    $scope.ccOnBlur = function () {
                        if ($scope.cardNumberChanged) {
                            $scope.cardNumberChanged($scope.unformattedCardNumber);
                        }
                    };

                    // e.g for a dual brand = ['CUP' ,'VISA'], select VISA or CUP based
                    // on regex defined for card type. If not regex was defined, pick one
                    // of the allowed card type.
                    function selectCardTypeForDualBrands(result) {
                        var dualCardTypes = (0, _squid.$feature)('dualCardTypes', {});
                        var match = void 0;

                        Object.keys(dualCardTypes).some(function (key) {
                            return result.some(function (cardType) {
                                if (cardType.type === key) {
                                    match = key;
                                    return true;
                                }
                            });
                        });

                        if (match) {
                            var regex = new RegExp(dualCardTypes[match]);
                            var selected = _squid.$util.find(result, function (cardType) {
                                if (regex.test(cardType.type)) {
                                    return true;
                                }
                            });

                            if (selected && selected.type === 'CUP') {
                                _squid.$util.some(result, function (cardType) {
                                    if (/^AMEX$/.test(cardType.type)) {
                                        selected.dualType = cardType.type;
                                        return true;
                                    }
                                });
                            }

                            return selected;
                        } else {
                            return _squid.$util.find(result, function (cardType) {
                                return $scope.cardTypes.allowed.indexOf(cardType.type) > -1;
                            });
                        }
                    }

                    function selectCardType(result) {
                        if (angular.isArray(result)) {
                            if (result.length >= 2) {
                                result = selectCardTypeForDualBrands(result);
                            } else {
                                result = result[0];
                            }
                        }

                        return result || {};
                    }

                    function clearCardType() {
                        $scope.card.type = '';
                        $scope.card.dualType = '';
                        $scope.card.productType = '';
                    }

                    function getCardTypeByNumberServiceCall(number) {
                        if (number.length >= 6) {
                            var bin = number;

                            // Don't limit to 6 digits for APay flow as some cards require more than 6 digit
                            // BIN to detect if it is a debit card.
                            if (!$scope.debitCardFlow) {
                                bin = bin.slice(0, 6);
                            }

                            if (lastVerifiedBin) {
                                if (lastVerifiedBin.bin === bin) {
                                    $scope.card.type = lastVerifiedBin.type;
                                    $scope.card.dualType = lastVerifiedBin.dualType;
                                    $scope.card.productType = lastVerifiedBin.productType;
                                    return;
                                }
                                // For APay flow, if product type has been identified,
                                // we don't need to make another call
                                else if ($scope.debitCardFlow && bin.startsWith(lastVerifiedBin.bin) && lastVerifiedBin.productType) {
                                        $scope.card.type = lastVerifiedBin.type;
                                        $scope.card.dualType = lastVerifiedBin.dualType;
                                        $scope.card.productType = lastVerifiedBin.productType;
                                        return;
                                    }
                            }

                            // For APay, if there is a pending request, then do nothing.
                            if (isUnsupportedCard === bin || bin === lastRequestedBin || $scope.debitCardFlow && lastRequestedBin) {
                                return;
                            }

                            lastRequestedBin = bin;

                            _fi.$CardTypeFromBinModel.instance().save({
                                data: {
                                    user_country: $scope.country,
                                    bin: bin
                                },
                                silent: true,
                                success: function success(result) {
                                    result = selectCardType(result);
                                    var type = result.type;
                                    lastRequestedBin = undefined;

                                    var disallowedCard = false;
                                    if ($scope.cardTypes.allowed.indexOf(type) === -1) {
                                        disallowedCard = true;
                                    }

                                    if (disallowedCard) {
                                        clearCardType();
                                        isUnsupportedCard = bin;
                                        $scope.allowedCardsTooltip = true;
                                        return;
                                    }

                                    isUnsupportedCard = undefined;
                                    forceDropDown = false;
                                    if (!$scope.showDropDown()) {
                                        $scope.card.type = type;
                                        $scope.card.dualType = result.dualType;
                                        $scope.card.productType = result.productType;
                                    }

                                    lastVerifiedBin = {
                                        bin: bin,
                                        type: type,
                                        dualType: result.dualType,
                                        productType: result.productType
                                    };

                                    // This logic is to handle copy paste case when all numbers are entered at once
                                    if ($scope.card.type && number.length >= $scope.flag('length.min')) {
                                        if (/android/i.test(navigator.userAgent)) {
                                            return;
                                        }

                                        var ccNumber = ($scope.card.number || '').replace(/[^0-9]+/g, '').slice(0, $scope.maxLength());

                                        if (ccNumber.indexOf(number) >= 0) {
                                            $scope.card.number = formatCardNumber(ccNumber);
                                        }
                                    }

                                    return;
                                },
                                contingencies: {
                                    GET_FI_ISSUER_DETAILS_ERR: function GET_FI_ISSUER_DETAILS_ERR(name, result) {
                                        clearCardType();
                                        isUnsupportedCard = bin;
                                        lastRequestedBin = undefined;
                                    }
                                },
                                error: function error() {
                                    clearCardType();
                                    isUnsupportedCard = bin;
                                    lastRequestedBin = undefined;
                                }
                            });
                        } else {
                            isUnsupportedCard = undefined;
                            lastRequestedBin = undefined;
                            forceDropDown = false;
                            clearCardType();
                        }
                    }

                    $scope.getAllowedCardTypeByNumber = function (number) {
                        return $scope.getCardTypeByNumber($scope.cardTypes.allowed, number);
                    };

                    $scope.getDisallowedCardTypeByNumber = function (number) {
                        return $scope.getCardTypeByNumber($scope.cardTypes.disallowed, number);
                    };

                    $scope.enableAddMode = function () {
                        if ($scope.card.isExisting()) {
                            $scope.card.number = '';
                        }
                    };

                    $scope.changeType = function () {
                        forceDropDown = true;

                        $scope.changeCardNumber(true);

                        // Blank out unsupported fields

                        if (!$scope.flag('fields.expiry')) {
                            delete $scope.card.expiry_month;
                            delete $scope.card.expiry_year;
                        }

                        if (!$scope.flag('fields.issue')) {
                            delete $scope.card.start_month;
                            delete $scope.card.start_year;
                            delete $scope.card.issue_number;
                        }

                        if (!$scope.flag('fields.dob')) {
                            delete $scope.card.dob_day;
                            delete $scope.card.dob_month;
                            delete $scope.card.dob_year;
                        }

                        if (!$scope.flag('fields.cvv')) {
                            delete $scope.card.security_code;
                        }
                    };

                    $scope.changeCardNumber = function (isCardTypeChanged) {
                        // If buyer tries to modify an update card number. We remove the whole string
                        // so buyer can add a card instead.
                        $scope.enableAddMode();
                        $scope.allowedCardsTooltip = false;
                        var regex = /[０-９]/;

                        if ((0, _squid.$feature)('disableFullWidthCharacters') && regex.test($scope.card.number)) {
                            _logger.$logger.info('checkout_fpti', {
                                'is_fullwidth_character': true
                            });
                        }

                        var number = ($scope.card.number || '').replace(/[^0-9]+/g, '').slice(0, $scope.maxLength());
                        var formattedNumber = void 0;

                        $scope.unformattedCardNumber = number;

                        // Attempt to determine the card type
                        var cardType = void 0;

                        if ($scope.debitCardFlow) {
                            if (number.length >= $scope.flag('length.min')) {
                                $scope.tokenizedWalletCardTypeServiceCall = true;
                            } else {
                                $scope.tokenizedWalletCardTypeServiceCall = false;
                                lastVerifiedBin = '';
                            }
                        }

                        if (cardTypeServiceCall || $scope.tokenizedWalletCardTypeServiceCall) {
                            if (!isCardTypeChanged) {
                                getCardTypeByNumberServiceCall(number);
                            }

                            if (isUnsupportedCard) {
                                $scope.allowedCardsTooltip = true;
                            }
                        } else {
                            if (!isCardTypeChanged) {
                                // Hide dropdown and trigger bin matching when the cc number is < 4 digits
                                if (number.length < 4) {
                                    forceDropDown = false;
                                }

                                if (!$scope.enableDropDown()) {
                                    cardType = $scope.getAllowedCardTypeByNumber(number);
                                    $scope.card.type = cardType.type;
                                    $scope.card.subType = cardType.subType;
                                }
                            }

                            if ($scope.isPlcc && $scope.card.type) {
                                $scope.cvvShown();
                                $scope.expiryShown();
                            }

                            if (!$scope.card.type && !$scope.isPlcc && (number.length >= 4 || $scope.getDisallowedCardTypeByNumber(number).type)) {
                                $scope.allowedCardsTooltip = true;
                            }
                        }

                        /*
                        * PPPLMER-1563 commented out to fix this bug
                        if (/android/i.test(navigator.userAgent)) {
                            return;
                        }
                        */
                        // Format the card number
                        formattedNumber = formatCardNumber(number);

                        // If the card is already formatted correctly, we can leave the user to continue in peace.
                        if ($scope.card.number === formattedNumber) {
                            return;
                        }

                        // Wait for the user's input to be reflected on the page (necessary for safari 5 otherwise selectionStart is incorrect)
                        (0, _angular.$timeout)(function () {
                            // re-formatting the number, since the card type may not have resolved before the first call
                            $scope.card.number = formatCardNumber(number);
                            // Save the current cursor positions
                            var ccField = document.getElementById('cc');

                            if (!ccField) {
                                return;
                            }

                            var inputLength = ccField.value.length;
                            var cursorStart = ccField.selectionStart;

                            // Wait for the formatted card to be reflected on the page
                            (0, _angular.$timeout)(function () {
                                // If the cursor was at the end of the input field, keep it at the end
                                if (cursorStart === inputLength) {
                                    ccField.selectionStart = ccField.selectionEnd = ccField.value.length;
                                    // Otherwise place the cursor to the position it was in before we replaced with the formatted number
                                } else {
                                    ccField.selectionStart = ccField.selectionEnd = cursorStart;
                                }
                            });
                        });
                    };
                });
            });
        }]
    };
});

_angular.$timeout;

_squid.$feature;

_squid.$locale;

_squid.$meta;

_squid.$populate;

_squid.$util;

_logger.$logger;

_checkout.$FlowEligibilityModel;

_fi.$CardTypeFromBinModel;

_fi.$CardTypesModel;

_cardMetaData.$CardMetaData;

_index.$DeviceInfo;

_squid.$promise;

_squid.$elmo;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/creditcard-input/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"creditCardInput\" content>\n    <!-- These two hidden fields are added to avoid autofill issue by chome for password and login field -->\n    <input style=\"display:none\">\n    <input type=\"password\" style=\"display:none\">\n\n    <div class=\"cardIconsGroup\" ng-if=\"!debitCardFlow && !manageCardFlow && showAcceptedCardLogos()\">\n        <div class=\"icons\" ng-repeat=\"cardType in cardTypes.allowed track by $index\">\n            <div class=\"cardIcon {{cardType}}\"></div>\n        </div>\n        <div ng-if=\"showScanCardExperiment\" class=\"icons\"><div class=\"secureIcon lockIcon\"></div></div>\n    </div>\n\n    <div class=\"debitAndCreditIconsGroup\" ng-if=\"!debitCardFlow && !manageCardFlow && showMXCardLogos()\">\n        <p id=\"mxCardTitle\" class=\"cardIconTitle\">{{content('creditcard.cardIconTitle')}} </p>\n        <div class=\"cardIconsSection\">\n            <div class=\"mxCardIconGroup\">\n                <div class=\"icons\" ng-repeat=\"cardType in cardTypes.allowed track by $index\">\n                    <div class=\"cardIcon {{cardType}}\"></div>\n                </div>\n            </div>\n            <div ng-if=\"showScanCardExperiment\" class=\"icons\"><div class=\"secureIcon lockIcon\"></div></div>\n            <br>\n            <div class=\"icons\" ng-repeat=\"cardType in mxDebitCards track by $index\">\n                <div class=\"debitcardIcon {{cardType}}\"></div>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if=\"isPlcc\" class=\"plccCardNumberTitle\" >{{content('addCard.plccAddCard', { merchant: promotion.name})}}</div>\n\n    <div class=\"dropdown cardType confidential nullable\" ng-if=\"!manageCardFlow && showDropDown()\">\n        <label for=\"cardType\" id=\"cardTypeLabel\" class=\"accessAid\">{{ content('creditcard.typeLabel') }}</label>\n        <select xo-dropdown name=\"cardType\" ng-model=\"card.type\" ng-change=\"changeType()\" ng-required=\"true\"\n                ng-options=\"cardType as content('cardTypes.' + cardType) for cardType in cardTypes.allowed track by cardType\"\n                id=\"cardType\" aria-labelledby=\"cardTypeLabel\" data-show-card-type=\"false\">\n            <option value=\"\" selected>{{ content('creditcard.typeLabel') }}</option>\n        </select>\n    </div>\n\n    <div ng-if=\"!manageCardFlow\" class=\"inputField confidential cardNumber creditCardField\" directionality>\n        <label for=\"cc\" class=\"focus accessAid\">\n            {{ showScanCardExperiment ? content('creditcard.scanCardNumber') : content('creditcard.cardNumber') }}\n        </label>\n\n        <input type=\"tel\" ui-validate=\"{luhn: 'cardLuhnValid($value)', len: 'cardLengthValid($value)', prodType: 'cardProductValid($value)'}\"\n                ui-validate-watch=\"'card.type'\"\n                ng-model=\"card.number\" name=\"cardNumber\" id=\"cc\" data-test-id=\"ccNumberInput\" value=\"\" ng-change=\"changeCardNumber(false)\"\n                ng-blur=\"ccOnBlur()\"\n                maxlength=\"{{maxLength()}}\" data-number=\"{{unformattedCardNumber}}\"\n                autocapitalize=\"off\" data-country=\"{{ locale.country }}\" autocomplete=\"off\"\n                placeholder=\"{{ showScanCardExperiment ? content('creditcard.scanCardNumber') : content('creditcard.cardNumber') }}\"\n                ng-pattern=\"/.*/\"\n                pattern=\"[0-9]*\"\n                scroll-to-top\n                data-error-text=\"{{content(debitCardFlow ? 'validation.validDebitCard' : 'validation.validCreditCard')}}\" xo-error-tooltip />\n\n        <xo-tooltip trigger=\"#cc\" ng-if=\"allowedCardsTooltip\" show-event=\"keyup\">\n            <div class=\"tip tipDesc tipCreditCard\">\n                {{ !debitCardFlow ? content('creditcard.acceptableCards') : content('creditcard.acceptDebitCardOnly') }}\n                <span class=\"acceptedCards\" ng-if=\"!debitCardFlow\">\n                    {{supportedCardNamesCommaSeparated}}\n                </span>\n            </div>\n        </xo-tooltip>\n\n        <span ng-if=\"card.type\" class=\"creditCard {{card.type}} {{card.subType}}\" aria-label=\"{{card.type}}\" id=\"creditCard\" role=\"img\">{{card.type}}</span>\n        <span ng-if=\"!card.type && showScanCardExperiment\" class=\"cameraIcon\" role=\"img\"></span>\n    </div>\n\n    <!-- Issue no and start date for maestro cards -->\n    <div id=\"cardIssueInfo\" data-cardspecific=\"true\" class=\"fieldGroup clearfix\" ng-if=\"flag('fields.issue')\">\n        <div>\n            <div class=\"startDate inputField invisiField half confidential\">\n                <label class=\"starts nolap\" for=\"startmonth\">{{ content('creditcard.startDate') }}</label>\n                <xo-card-issue-date issue-month=\"card.start_month\" issue-year=\"card.start_year\"></xo-card-issue-date>\n            </div>\n\n            <div class=\"issueNo inputField half last-child confidential last-child\">\n                <input id=\"issueNo\" name=\"issueNo\" placeholder=\"{{content('creditcard.issueNoLabel')}}\" type=\"text\" ng-model=\"card.issue_number\" autocapitalize=\"off\" autocomplete=\"off\" maxlength=\"2\" ng-pattern=\"/^[0-9]+$/\" pattern=\"[0-9]*\"/>\n\n                <xo-tooltip trigger=\"#issueNo\">\n                    <div class=\"tip tipDesc tipIssueNo\">\n                        {{ content('creditcard.issueNoLabelToolTip') }}\n                    </div>\n                </xo-tooltip>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"expiration confidential\" id=\"expiration\" ng-if=\"expiryShown() || cvvShown()\">\n        <xo-card-expiry ng-if=\"expiryShown()\" expiry-month=\"card.expiry_month\" expiry-year=\"card.expiry_year\"></xo-card-expiry>\n        <xo-cvv ng-if=\"cvvShown()\" card=\"card\" show-label=\"true\"></xo-cvv>\n    </div>\n\n    <!-- DOB fields for Country specific cards -->\n    <xo-dob-card-input ng-if=\"flag('fields.dob')\" user=\"user\"></xo-dob-card-input>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cvv/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoCvvDirective = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _cardMetaData = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardMetaData/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cvv/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCvvDirective = exports.$xoCvvDirective = _squid.$Component.extend('$xoCvvDirective', {
    tag: 'xo-cvv',
    template: _template2['default'],

    props: {
        card: {
            type: 'var',
            required: false
        },
        showLabel: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            // A boolean message to update the masking property of cvv when the pre-filling happens
            this.$on('maskCVV', function ($event, isMasked) {
                _this.maskCVV = isMasked;
            });
            this.maskCVV = (0, _squid.$feature)('maskCVV', false, _squid.$locale.country);
            this.cvvLength = function () {
                return _cardMetaData.$CardMetaData.getMetaData(_this.props.card, 'length.cvv');
            };
            this.cvvRequired = function () {
                return _this.props.card.type !== 'MAESTRO' || (0, _squid.$feature)('maestroCvvRequired', false, _squid.$locale.country);
            };
        }
    }
});

angular.value("$xoCvvDirective", $xoCvvDirective);
_squid.$Component;

_squid.$locale;

_squid.$feature;

_cardMetaData.$CardMetaData;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cvv/template.html":
/***/ (function(module, exports) {

module.exports = "<div content class=\"inputField cvvField\" id=\"cvvField\" directionality>\n    <label ng-if=\"showLabel\" class=\"cvv nolap\" for=\"cvv\">{{ content('creditcard.cscLabel') }}</label>\n\n    <div class=\"cvvSecurityCode inputField\" directionality>\n        <input type=\"{{maskCVV ? 'password' : 'tel'}}\" id=\"cvv\" data-test-id=\"ccCvvInput\" name=\"cvv\" ng-model=\"card.security_code\"\n               aria-describedby=\"securityCodeHelp\"\n               ng-pattern=\"/^[0-9]{1,4}$/\" ng-minlength=\"cvvLength()\" maxlength=\"{{cvvLength()}}\"\n               placeholder=\"{{cvvLength() === 3 ? content('creditcard.threeDigits') : content('creditcard.fourDigits')}}\"\n               ng-required=\"cvvRequired()\" ng-class=\"{'four': cvvLength() === 4}\" autocomplete=\"off\"\n               data-error-text=\"{{content('validation.validCSC')}}\" xo-error-tooltip />\n\n        <span id=\"securityCode\" class=\"creditCard\" role=\"img\" ng-class=\"{'four': cvvLength() === 4}\"\n              aria-label=\"{{cvvLength() === 4 ? content('creditcard.cscHelp4Digits') : content('creditcard.cscHelp3Digits')}}\">\n        </span>\n        <span id=\"securityCodeHelp\" class=\"accessAid\" ng-bind=\"cvvLength() === 4 ? content('creditcard.cscHelp4Digits') : content('creditcard.cscHelp3Digits')\"></span>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _index = __webpack_require__("../node_modules/xo-models/src/address/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddCardFlow', function () {
    return {
        template: _template2['default'],

        scope: {
            token: '=?',
            parentCallbacks: '=?',
            messagetitle: '=?',
            message: '=?',
            pagetitle: '=?',
            sidebar: '=?',
            showmeftsection: '=?',
            hideparenthead: '=?',
            promotion: '=?',
            pageLevel: '=?',
            logout: '=?',
            phone: '=?',
            fundingid: '=?',
            showCancel: '=?',
            showSetPreferredFi: '=?',
            onSuccess: '=?',
            backUri: '=?',
            showIncentive: '=?',
            incentiveAmount: '=?'
        },

        controller: ['$scope', function ($scope) {

            $scope.addCCDone = function () {
                $scope.parentCallbacks.finish();
            };

            $scope.callbacks = {
                done: $scope.parentCallbacks.finish,
                cancel: $scope.parentCallbacks.cancel,
                showCep: function showCep() {
                    $scope.prefillAddress = new _index.$PrefillAddressModel({
                        id: $scope.token
                    });

                    _uiRouter.$state.go('^.addCep');
                },

                cardTypeSelected: function cardTypeSelected(type) {
                    $scope.selectedPromotionCardType = {
                        type: type
                    };
                    _uiRouter.$state.go('^.addCard');
                }
            };

            $scope.cepDone = function () {
                _uiRouter.$state.go('^.addBilling');
            };

            $scope.selectedPromotionCardType = {
                type: $scope.promotion && $scope.promotion.type
            };

            if ($scope.promotion) {
                $scope.promotion.type = null;
            }

            $scope.billingaddressupdated = {
                value: false
            };

            $scope.phone = {
                hide_type: true
            };

            $scope.cardmodel = new _index3.$AddCardModel({
                card: new _index3.$CardModel()
            });

            (0, _squid.$populate)($scope, {
                checkoutSession: _index2.$CheckoutSessionModel.instance($scope.token).retrieve({
                    contingencies: {
                        NEED_CREDIT_CARD: angular.noop,
                        EXPIRED_CREDIT_CARD: angular.noop
                    }
                })
            }).then(function () {

                if ($scope.checkoutSession.errorData && $scope.checkoutSession.errorData.resolution) {
                    var card = $scope.checkoutSession.errorData.resolution.data;

                    if (card.fundingId && card.fi && card.fi.type) {
                        $scope.cardmodel.id = card.fundingId;
                        $scope.cardmodel.card = new _index3.$CardModel({
                            number: 'xxxx-xxxx-xxxx-' + card.fi.number,
                            type: card.fi.type.toUpperCase(),
                            productType: card.fi.productType
                        });
                    }
                }
                if ($scope.fundingid) {
                    var fundingSource = _squid.$util.find($scope.checkoutSession.fundingOptions.instruments, function (funding) {
                        if (funding && funding.id === $scope.fundingid) {
                            return funding;
                        }
                    });
                    if (!fundingSource) {
                        fundingSource = _squid.$util.find($scope.checkoutSession.fundingOptions.disallowedInstruments, function (funding) {
                            if (funding && funding.id === $scope.fundingid) {
                                return funding;
                            }
                        });
                    }

                    if (fundingSource) {
                        $scope.cardmodel.id = fundingSource.id;
                        $scope.cardmodel.card = new _index3.$CardModel({
                            number: 'xxxx-xxxx-xxxx-' + fundingSource.lastDigits,
                            lastDigits: fundingSource.lastDigits,
                            type: fundingSource.name.toUpperCase(),
                            name: (0, _squid.$renderContent)('fsMappings.' + fundingSource.name)
                        });
                    }
                }
            });
        }]
    };
});

_squid.$populate;

_squid.$renderContent;

_squid.$util;

_uiRouter.$state;

_index.$PrefillAddressModel;

_index2.$CheckoutSessionModel;

_index3.$AddCardModel;

_index3.$CardModel;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/dob/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/dob/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoDobCardInputDirective', {
    tag: 'xo-dob-card-input',
    template: _template2['default'],

    props: {
        user: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        enter: function enter() {
            function pad() {
                var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;

                return function (num) {
                    return (new Array(length + 1).join('0') + num).substr(-length);
                };
            }

            var year = new Date().getFullYear();
            this.days = _squid.$util.map(_squid.$util.range(1, 32), pad());
            this.months = _squid.$util.map(_squid.$util.range(1, 13), pad());
            this.years = _squid.$util.map(_squid.$util.range(year - 100, year), pad(4)).reverse();
        }
    }
});


_squid.$Component;

_squid.$util;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/dob/template.html":
/***/ (function(module, exports) {

module.exports = "<div content id=\"cardDOB\" class=\"cardDOB inputField invisiField confidential last-child\">\n    <label class=\"dobLabel nolap\" for=\"dobDayCC\">{{ content('creditcard.dob') }}</label>\n\n    <div class=\"dropdown fidobDay nullable\">\n        <select xo-dropdown name=\"dobDayCC\" id=\"dobDayCC\" ng-model=\"user.dob_day\"\n                ng-options=\"day for day in days track by day\" ng-required=\"true\">\n            <option value=\"\">{{ content('applyForBml.bmlApplyDD') }}</option>\n        </select>\n    </div>\n\n    <div class=\"dropdown fidobMonth nullable\">\n        <select xo-dropdown name=\"dobMonthCC\" id=\"dobMonthCC\" ng-model=\"user.dob_month\"\n                ng-options=\"month for month in months track by month\" ng-required=\"true\">\n            <option value=\"\">{{ content('applyForBml.bmlApplyMM') }}</option>\n        </select>\n    </div>\n\n    <div class=\"dropdown fidobYear nullable\">\n        <select xo-dropdown name=\"dobYearCC\" id=\"dobYearCC\" ng-model=\"user.dob_year\"\n                ng-options=\"year for year in years track by year\" ng-required=\"true\">\n            <option value=\"\">{{ content('applyForBml.bmlApplyYYYY') }}</option>\n        </select>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _directive = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardExpiry/directive.js");

Object.keys(_directive).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _directive[key];
    }
  });
});

var _cardMetaData = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardMetaData/index.js");

Object.keys(_cardMetaData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _cardMetaData[key];
    }
  });
});

var _directive2 = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cvv/directive.js");

Object.keys(_directive2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _directive2[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/addcard/route.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/selectcard/route.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/addbilling/route.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/addCep/route.js");

__webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/route.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$AddCardFlowRoute', function () {

    return _squid.$ComponentRoute.extend('CardRoute', {

        name: 'addCardFlow',
        directive: 'xo-add-card-flow',
        titleContent: 'asideHeader.addCard',
        children: [{
            name: '$AddCardRoute',
            attributes: {
                token: 'token',
                cardmodel: 'cardmodel',
                done: 'addCCDone',
                messagetitle: 'messagetitle',
                message: 'message',
                pagetitle: 'pagetitle',
                sidebar: 'sidebar',
                showmeftsection: 'showmeftsection',
                hideparenthead: 'hideparenthead',
                billingaddressupdated: 'billingaddressupdated',
                isupdatecard: 'isupdatecard',
                'parent-callbacks': 'callbacks',
                'selected-promotion-card-type': 'selectedPromotionCardType',
                promotion: 'promotion',
                'page-level': 'pageLevel',
                logout: 'logout',
                phone: 'phone',
                'show-cancel': 'showCancel',
                'show-set-preferred-fi': 'showSetPreferredFi',
                'on-success': 'onSuccess',
                'back-uri': 'backUri',
                'show-incentive': 'showIncentive',
                'incentive-amount': 'incentiveAmount'
            }

        }, {
            name: '$SelectCardRoute',
            attributes: {
                token: 'token',
                'parent-callbacks': 'callbacks',
                message: 'message',
                pagetitle: 'pagetitle',
                sidebar: 'sidebar',
                'selected-promotion-card-type': 'selectedPromotionCardType',
                promotion: 'promotion'
            }
        }, {
            name: '$AddBillingRoute',
            attributes: {
                token: 'token',
                sidebar: 'sidebar',
                showmeftsection: 'showmeftsection',
                'parent-callbacks': 'callbacks',
                hideparenthead: 'hideparenthead',
                billingaddressupdated: 'billingaddressupdated',
                'prefill-address': 'prefillAddress'
            }
        }, {
            name: '$AddCepRoute',
            attributes: {
                token: 'token',
                sidebar: 'sidebar',
                'done-fn': 'cepDone',
                'prefill-address': 'prefillAddress'
            }
        }]
    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-card", "../node_modules/xo-wallet-components/src/add-card/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/selectcard/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/selectcard/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoSelectCard', function () {
    return {
        template: _template2['default'],

        scope: {
            parentCallbacks: '=?',
            token: '=?',
            promotion: '=?'
        },

        controller: ['$scope', function ($scope) {

            (0, _squid.$populate)($scope, {
                checkoutSession: _index.$CheckoutSessionModel.instance($scope.token)
            }).then(function () {
                $scope.selectCardType = function (type) {
                    // card type is either 'cc' or 'plcc'
                    $scope.parentCallbacks.cardTypeSelected(type);
                };
            });
        }]
    };
});

_squid.$populate;

_index.$CheckoutSessionModel;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/selectcard/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/selectcard/directive.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$SelectCardRoute', function () {
    return _squid.$ComponentRoute.extend('SelectCardRoute', {

        name: 'selectCard',
        directive: 'xo-select-card',
        titleContent: 'asideHeader.selectCard',
        children: []
    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-card/selectcard", "../node_modules/xo-wallet-components/src/add-card/selectcard/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/selectcard/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"selectCardType\">\n\t<xo-aside-header hdrtype='tall' heading='asideHeader.selectCard' sub-head='asideHeader.fundingInstrumentsSubHead' back-url=\"checkout.review.sidebar.wallet\"></xo-aside-header>\n\n\t<div class=\"asideContent fundingCards\" id=\"selectFundingType\" content>\n\t\t<div class=\"allCards\">\n\t\t\t<ul class=\"allFundingInstrumentsList clearfix\">\n\n\t\t\t\t<li class=\"fundingsource fs-item\">\n\t\t\t\t\t<a class=\"source\" role=\"button\" ng-click=\"selectCardType('cc')\">\n\t\t\t\t\t\t<span class=\"fsIcon\"></span>\n\t\t\t\t\t\t<p class=\"fsdetails\">\n\t\t\t\t\t\t\t<span class=\"name\">Debit or Credit Card</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<span class=\"forwardIcon\"/>\n\t\t\t\t\t</a>\n\t\t\t\t</li>\n\t\t\t\t<li class=\"fundingsource fs-item\">\n\t\t\t\t\t<a class=\"source\" role=\"button\" ng-click=\"selectCardType('plcc')\">\n\t\t\t\t\t\t<img class=\"plccIcon\" ng-src=\"{{promotion.logoUrl}}\"/>\n\t\t\t\t\t\t<p class=\"fsdetails\">\n\t\t\t\t\t\t\t<span class=\"name\">{{content('addCard.plccAddCard', { merchant: promotion.name})}}</span>\n\t\t\t\t\t\t\t<span class=\"secondary\">{{content('addCard.plccSelectIncentive')}}</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<span class=\"forwardIcon\"/>\n\t\t\t\t\t</a>\n\t\t\t\t</li>\n\n\t\t\t</ul>\n\t\t</div>\n\t</div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/template.html":
/***/ (function(module, exports) {

module.exports = "<div ui-view></div>"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/confirm/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _util = __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/util.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/spinner-button/directive.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/confirm/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var VERIFICATION_CODE_COUNTDOWN_IN_SECS = 180; // 3 minutes
var RESEND_CODE_LINK_TIMEOUT_MILLI_SECS = 60000; // 1 minute
var ONE_MINUTE_IN_SECS = 60;

exports['default'] = _squid.$Component.extend('$xoConfirmOtpDirective', {
    tag: 'xo-confirm-otp',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        phone: {
            type: 'var',
            required: false
        },
        cardmodel: {
            type: 'var',
            required: false
        },
        onSuccess: {
            type: 'var',
            required: false
        },
        message: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve()
            };
        }
    },
    actions: {
        addMessage: function addMessage(type, contentKey) {
            if (contentKey) {
                this.message({
                    msgKeys: [_angular2['default'].isArray(contentKey) ? contentKey[0] : contentKey],
                    type: type || 'error'
                });
            }
        },
        stopConfirmCodeTimer: function stopConfirmCodeTimer() {
            if (this.confirmCodeTimer) {
                _angular.$interval.cancel(this.confirmCodeTimer);
            }
            this.countdown = 0;
        },
        stopResendCodeTimer: function stopResendCodeTimer() {
            if (this.resendCodeTimer) {
                _angular.$timeout.cancel(this.resendCodeTimer);
            }
            this.showResendLink = false;
        },
        updateCountdown: function updateCountdown() {
            if (this.countdown > 0) {
                this.countdown--;
                this.timer = Math.floor(this.countdown / ONE_MINUTE_IN_SECS) + ':' + ('0' + this.countdown % ONE_MINUTE_IN_SECS).slice(-2);
            } else {
                if (!this.isConfirmProcessing) {
                    this.actions.addMessage('warning', 'confirmUpop.codeExpired');
                }
                this.actions.stopConfirmCodeTimer();
                this.actions.stopResendCodeTimer();
            }
        },
        startCountdown: function startCountdown(resetTimer) {
            var _this = this;

            if (resetTimer) {
                this.actions.stopConfirmCodeTimer();
                this.countdown = VERIFICATION_CODE_COUNTDOWN_IN_SECS;
                this.actions.updateCountdown();
                this.confirmCodeTimer = (0, _angular.$interval)(this.actions.updateCountdown, 1000);
            }

            this.actions.stopResendCodeTimer();
            this.showResendLink = false;
            this.resendCodeTimer = (0, _angular.$timeout)(function () {
                _this.showResendLink = true;
            }, RESEND_CODE_LINK_TIMEOUT_MILLI_SECS);
            this.actions.addMessage('success', 'confirmUpop.codeSent');
        },
        processed: function processed() {
            if (!this.countdown && this.isConfirmProcessing) {
                this.actions.addMessage('warning', 'confirmUpop.codeExpired');
            }
            this.isProcessing = this.isConfirmProcessing = false;
        },
        handleContingencies: function handleContingencies() {
            var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var prop = arguments[1];

            var errorData = void 0;
            if (result.errorCodes) {
                errorData = result;
            } else {
                errorData = {
                    errorCodes: [result['0'] || 'ISSUER_DECLINE']
                };
            }

            this.message(_util.$fiErrorUtil.addPageErrors(errorData, 'confirmUpop', prop, 'error'));

            if (window.scrollTo) {
                window.scrollTo(0, 0);
            }
        },
        sendNewCode: function sendNewCode() {
            // reset the code field.
            if (this.cardmodel && this.cardmodel.card) {
                this.cardmodel.card.otp_code = '';
            }
            this.actions.resendCode(true);
        },
        resendCode: function resendCode(resetTimer) {
            var _this2 = this;

            this.isProcessing = true;
            this.resolveOTP.action('init', {
                silent: true,
                data: {
                    phone: {
                        country_code: this.phone.IntDialingCountryCode,
                        number: this.phone.telephone
                    }
                },
                resultModel: {},
                success: function success() {
                    _this2.actions.startCountdown(resetTimer);
                },
                error: function error() {
                    _this2.actions.handleContingencies();
                },
                contingencies: {
                    INIT_OTP_CONTINGENCY: function INIT_OTP_CONTINGENCY(name, result) {
                        // prop for last 4 digits of card in error message
                        var prop = {
                            number: _this2.cardLast4
                        };

                        _this2.actions.handleContingencies(result, prop);
                        _util.$fiErrorUtil.addFieldErrors(result, _this2.$element);
                    },
                    DEFAULT: function DEFAULT() {
                        _this2.actions.handleContingencies();
                    }
                }
            })['finally'](this.actions.processed);
        },
        confirmOTP: function confirmOTP() {
            var _this3 = this;

            this.isProcessing = this.isConfirmProcessing = true;

            this.resolveOTP.action('complete', {
                silent: true,
                data: {
                    code: this.cardmodel.card.otp_code,
                    phone: {
                        country_code: this.phone.IntDialingCountryCode,
                        number: this.phone.telephone
                    },
                    card_data: {
                        expiration_time: {
                            month: this.cardmodel.card.expiry_month,
                            year: this.cardmodel.card.expiry_year
                        },
                        card_verification_code: this.cardmodel.card.security_code
                    }
                },
                success: this.onSuccess,
                error: function error() {
                    _this3.actions.handleContingencies({}, 'confirmUpop');
                    _this3.actions.processed();
                },
                contingencies: {
                    COMPLETE_OTP_CONTINGENCY: function COMPLETE_OTP_CONTINGENCY(name, result) {
                        // prop for last 4 digits of card in error message
                        var prop = {
                            number: _this3.cardLast4
                        };

                        _this3.actions.handleContingencies(result, prop);
                        _util.$fiErrorUtil.addFieldErrors(result, _this3.$element);
                        _this3.actions.processed();
                    }
                }
            })['catch'](function () {
                _this3.actions.handleContingencies();
                _this3.actions.processed();
            });
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this4 = this;

            this.resolveOTP = new _index.$ResolveOTP({ id: this.cardmodel.id });
            this.isProcessing = this.showResendLink = false;
            this.cardLast4 = this.cardmodel.card.number.slice(-4);
            this.phoneLast4 = this.phone && this.phone.telephone && this.phone.telephone.slice(-4);
            this.actions.startCountdown(true);

            this.$watch('isProcessing', function (isProcessing) {
                if (isProcessing) {
                    _this4.$element.addClass('processing');
                } else {
                    _this4.$element.removeClass('processing');
                }
            });
            $('#upopConfirmation .modalContainer').focus();
        }
    }
});


_squid.$Component;

_util.$fiErrorUtil;

_index.$ResolveOTP;

_index2.$CheckoutSessionModel;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/confirm/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"confirmOtp\" content>\n    <div class=\"confirmMsg\" ng-bind-html=\"htmlContent('confirmUpop.verificationCodeMsg', {phoneLastFour: phoneLast4})\"></div>\n\n    <div class=\"timer\">\n        <span class=\"left\">{{content('confirmUpop.timeRemaining')}}</span>\n        <span class=\"timeLeft\">{{timer}} {{content('confirmUpop.minutes')}}</span>\n        <a link-button class=\"resendLink right focusableIcon\" href=\"\" ng-if=\"showResendLink\" ng-click=\"actions.resendCode(false)\">{{content('confirmUpop.resendCode')}}</a>\n    </div>\n\n    <form id=\"otpForm\" name=\"otpForm\" autocomplete=\"off\" ng-submit=\"otpForm.$valid && actions.confirmOTP()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n\n        <div class=\"confirmFields\" ng-show=\"countdown || isConfirmProcessing\">\n            <div class=\"inputField confidential\">\n                <input id=\"otp_code\"\n                       class=\"otp_code\"\n                       type=\"tel\"\n                       ng-model=\"cardmodel.card.otp_code\"\n                       name=\"otp_code\"\n                       value=\"\"\n                       placeholder=\"{{ content('confirmUpop.verificationCodeHint') }}\"\n                       autocapitalize=\"off\"\n                       autocomplete=\"off\"\n                       aria-required=\"false\"\n                       required\n                       scroll-to-top\n                       data-error-text=\"{{ content('confirmUpop.fieldInvalidOTP') }}\"\n                       xo-error-tooltip/>\n\n            </div>\n            <xo-spinner-button track='confirm_otp_code' token=\"token\" validate=\"validated\"\n                               is-processing=\"isProcessing\" button-text=\"common.confirm\"></xo-spinner-button>\n        </div>\n    </form>\n    <div class=\"sendNewOtp\">\n        <xo-spinner-button ng-if=\"!countdown && !isConfirmProcessing\" track='resend_otp_code' token=\"token\" on-click=\"actions.sendNewCode\"\n                           is-processing=\"isProcessing\" button-text=\"confirmUpop.btnResendCode\"></xo-spinner-button>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _addCard = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/init/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/confirm/directive.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/styles.less");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoConfirmUpopDirective', {
    tag: 'xo-confirm-upop',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        phone: {
            type: 'var',
            required: false
        },
        cardmodel: {
            type: 'var',
            required: false
        },
        onSuccess: {
            type: 'var',
            required: false
        },
        onCancel: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()
            };
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            // Card model should be required. However, because this is a route, a user could potentially refresh the page and land on this directive.
            // So, we need to check if parent directive has passed in cardmodel and return if not
            if (!this.cardmodel) {
                _logger.$logger.warn('card_model_missing');
                return this.goto('^'); // Return to parent route
            }

            this.phone = this.props.phone || {};

            var cardNumber = this.cardmodel.card && this.cardmodel.card.number;

            this.cardLast4 = cardNumber && cardNumber.slice(-4);
            this.fromLoginOverlay = _uiRouter.$stateParams.fromLoginOverlay;

            (0, _angular.$timeout)(function () {
                (0, _jquery2['default'])('#upopConfirmation .upopConfirm').addClass('upopOpen');
                if (_this.fromLoginOverlay) {
                    (0, _angular.$timeout)(function () {
                        (0, _jquery2['default'])('#upopConfirmation .modalWrapper').addClass('modalWrapperAnimation');
                    });
                }
            });

            var hideModal = function hideModal() {
                (0, _jquery2['default'])('#upopConfirmation .upopConfirm').removeClass('upopOpen');
            };

            var done = function done(handler, target) {
                hideModal();
                (0, _angular.$timeout)(function () {
                    return handler ? handler() : _this.goto(target);
                }, 200);
            };

            var _success = function _success() {
                done(_this.props.onSuccess, 'checkout.review');
            };

            this.closeModal = function (event) {
                if (event) {
                    event.preventDefault();
                }

                done(_this.props.onCancel, '^');
            };

            this.initSuccess = function () {
                _this.collectOtpInput = false;
            };

            this.confirmed = function () {
                if (_this.props.onSuccess) {
                    return _success();
                }

                return _this.models.checkoutSession.fundingOptions.action('update', {
                    resultModel: _this.models.checkoutSession,
                    silent: true,
                    data: {
                        planId: _this.cardmodel.id
                    },
                    success: function success() {
                        if (_this.models.checkoutSession.cvvData) {
                            _this.models.checkoutSession.set('cvvData.security_code', _this.cardmodel.get('card.security_code'));
                        }
                        var isNewCard = !_this.cardmodel.card.isExisting();
                        var msg = isNewCard ? ['smallToolTip.cardAddedConfirmed'] : ['smallToolTip.cardConfirmed'];

                        _this.models.checkoutSession.message = {
                            type: 'success',
                            msgKeys: msg
                        };
                        _success();
                    },
                    contingencies: {
                        TRANSACTION_REFUSED: function TRANSACTION_REFUSED() {
                            _this.models.checkoutSession.message = {
                                type: 'info',
                                msgKeys: 'creditcard.addedButCannotUse'
                            };
                            _success();
                        }
                    }
                });
            };

            this.flag = function (field) {
                return _addCard.$CardMetaData.getMetaData(_this.cardmodel.card, field);
            };

            this.setMessage = function (message) {
                _this.message = message;
            };

            this.collectOtpInput = this.flag('fields.expiry') && !this.cardmodel.get('card.expiry_month') || this.flag('fields.cvv') && !this.cardmodel.get('card.expiry_month') || this.flag('fields.phone') && !(this.phone && this.phone.telephone);
        }
    }
});


_angular.$timeout;

_squid.$Component;

_uiRouter.$stateParams;

_addCard.$CardMetaData;

_logger.$logger;

_index.$CheckoutSessionModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/init/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _util = __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/util.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/spinner-button/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInput/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardExpiry/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/cvv/directive.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/init/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoInitOtpDirective', {
    tag: 'xo-init-otp',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        phone: {
            type: 'var',
            required: false
        },
        cardmodel: {
            type: 'var',
            required: false
        },
        onSuccess: {
            type: 'var',
            required: false
        },
        flag: {
            type: 'var',
            required: false
        },
        message: {
            type: 'var',
            required: false
        }
    },
    actions: {
        initOtp: function initOtp() {
            var _this = this;

            var handleContingencies = function handleContingencies() {
                var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var prop = arguments[1];

                var errorData = void 0;
                if (result.errorCodes) {
                    errorData = result;
                } else {
                    errorData = {
                        errorCodes: [result['0'] || 'ISSUER_DECLINE']
                    };
                }

                _this.message(_util.$fiErrorUtil.addPageErrors(errorData, 'confirmUpop', prop, 'error'));

                if (window.scrollTo) {
                    window.scrollTo(0, 0);
                }
            };

            this.isProcessing = true;

            var resolveOTP = new _index.$ResolveOTP({ id: this.cardmodel.id });

            resolveOTP.action('init', {
                silent: true,
                data: {
                    phone: {
                        country_code: this.phone.IntDialingCountryCode,
                        number: this.phone.telephone
                    }
                },
                resultModel: {},
                success: function success() {
                    _this.onSuccess();
                },

                error: function error() {
                    handleContingencies();
                },

                contingencies: {
                    INIT_OTP_CONTINGENCY: function INIT_OTP_CONTINGENCY(name, result) {
                        // prop for last 4 digits of card in error message
                        var prop = {
                            number: _this.cardmodel.card.number.slice(-4)
                        };

                        handleContingencies(result, prop);
                        _util.$fiErrorUtil.addFieldErrors(result, _this.$element);
                    },
                    DEFAULT: function DEFAULT() {
                        handleContingencies();
                    }
                }
            })['finally'](function () {
                _this.isProcessing = false;
            });
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this2 = this;

            this.$watch('isProcessing', function (isProcessing) {
                if (isProcessing) {
                    _this2.$element.addClass('processing');
                } else {
                    _this2.$element.removeClass('processing');
                }
            });
            $('#upopConfirmation .modalContainer').focus();
        }
    }
});


_squid.$Component;

_util.$fiErrorUtil;

_index.$ResolveOTP;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/init/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"initOtp\" content>\n    <div class=\"confirmMsg\" ng-bind-html=\"htmlContent(flag('fields.expiry') ? 'confirmUpop.creditInitOtp' : 'confirmUpop.debitInitOtp')\"></div>\n\n    <form id=\"otpForm\" name=\"otpForm\" autocomplete=\"off\" ng-submit=\"otpForm.$valid && actions.initOtp()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n        <div class=\"expiration confidential\" id=\"expiration\" ng-if=\"flag('fields.expiry') || flag('fields.cvv')\">\n            <xo-card-expiry ng-if=\"flag('fields.expiry')\" expiry-month=\"cardmodel.card.expiry_month\" expiry-year=\"cardmodel.card.expiry_year\"></xo-card-expiry>\n            <xo-cvv ng-if=\"flag('fields.cvv')\" card=\"cardmodel.card\" show-label=\"true\"></xo-cvv>\n        </div>\n        <xo-phone-input token=\"token\" ng-if=\"flag('fields.phone')\" show-phone-type=\"false\" phone=\"phone\"></xo-phone-input>\n\n        <xo-spinner-button track='init_otp_code' token=\"token\" validate=\"validated\"\n                           is-processing=\"isProcessing\" button-text=\"confirmUpop.btnsendOtpCode\"></xo-spinner-button>\n    </form>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoConfirmUpopRoute = undefined;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoConfirmUpopRoute = exports.$xoConfirmUpopRoute = _index.$Route.extend('$xoConfirmUpopRoute', {
    path: 'confirmUpop',
    directive: _directive2['default'],
    titleContent: 'confirmUpop.confirm',
    trackingData: {
        fptiState: 'confirm_upop'
    },
    query: ['fromLoginOverlay'],
    loginRequired: true,
    pageOnOverlay: true,
    children: []
});

exports['default'] = $xoConfirmUpopRoute;

angular.value("$xoConfirmUpopRoute", $xoConfirmUpopRoute);
_index.$Route;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"upopConfirmation\">\n    <div class=\"upopConfirm\">\n        <div class=\"modalMask\"></div>\n        <div class=\"modalWrapper\" modal-box modal-cancel=\"closeModal()\" ng-class=\"{'modalWrapperAnimation': !fromLoginOverlay}\">\n            <div class=\"modalContainer\" content tabindex=\"-1\">\n                <a link-button track-submit=\"{{collectOtpInput ? 'close_otp_init' : 'close_otp_confirm'}}\" class=\"close focusableIcon\" href=\"#\" ng-click=\"closeModal($event)\"></a>\n                <xo-message message=\"message\"></xo-message>\n                <div class=\"heading\" ng-bind-html=\"htmlContent('confirmUpop.heading', {acctLastFour: cardLast4})\"></div>\n\n                <xo-init-otp token=\"token\" message=\"setMessage\" phone=\"props.phone\" cardmodel=\"cardmodel\" on-success=\"initSuccess\" flag=\"flag\" ng-if=\"collectOtpInput\"></xo-init-otp>\n                <xo-confirm-otp token=\"token\" message=\"setMessage\" phone=\"props.phone\" cardmodel=\"cardmodel\" on-success=\"confirmed\" ng-if=\"!collectOtpInput\"></xo-confirm-otp>\n                <div class=\"pushlogo\"></div>\n            </div>\n            <div class=\"logo\"></div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/currency-conversion-overlay/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");

var _factory = __webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion/factory.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _utils = __webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion-overlay/utils.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion-overlay/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion-overlay/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCurrencyConversionOverlayDirective', {
    tag: 'xo-currency-conversion-overlay',
    template: _template2['default'],
    props: {
        token: {
            type: 'var'
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                cart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutInputDataModel: _index2.$CheckoutInputDataModel.instance(this.props.token).retrieve()['catch'](_angular.noop)
            };
        }
    },
    actions: {
        onSubmit: function onSubmit() {
            var _this = this;

            var _models = this.models,
                checkoutSession = _models.checkoutSession,
                checkoutInputData = _models.checkoutInputData,
                ppconversion = _models.ppconversion;

            var fundingOptionId = checkoutInputData && checkoutInputData.funding_option_id;
            var plan = checkoutSession.plan;


            this.showOverlay = false;
            var _conversion = this.conversion,
                from_code = _conversion.from_code,
                to_code = _conversion.to_code,
                paypal = _conversion.paypal;

            var selectedConversionType = (0, _utils.mapConversionType)(ppconversion);
            var planConversionType = (0, _utils.mapConversionType)(paypal);

            if (selectedConversionType === planConversionType) {
                (0, _utils.logCurrencyConversion)({ options: {
                        to: 'cancel_currency_conversion',
                        currency_conversion_from_curr: from_code,
                        currency_conversion_to_curr: to_code
                    } });
                // stop
                return;
            }

            var data = {
                conversionType: selectedConversionType,
                planId: fundingOptionId || plan.id
            };

            if (data.planId) {
                checkoutSession.fundingOptions.action('updateConversion', {
                    data: data,
                    success: function success(result) {
                        if (data.planId !== plan.id) {
                            // don't need to reload checkoutSession after updating the conversion of the backup funding option
                            return null;
                        }

                        (0, _utils.logCurrencyConversion)({ options: {
                                to: 'process_currency_conversion',
                                currency_conversion_type: selectedConversionType,
                                is_conversion_shown: 1,
                                currency_conversion_from_curr: _this.conversion.from_code,
                                currency_conversion_to_curr: _this.conversion.to_code
                            } });

                        checkoutSession.reload({
                            success: function success() {
                                // Conversion object needs to be mapped again as checkoutSession is reloaded
                                var plan = checkoutSession.plan; // eslint-disable-line no-shadow
                                // Using let here since the conversion object may get reassigned at line 86 due to certain conditions

                                var _plan$conversion = plan.conversion,
                                    conversion = _plan$conversion === undefined ? {} : _plan$conversion;

                                _this.conversion = conversion;

                                if (!ppconversion) {
                                    if (conversion.paypal) {
                                        _logger.$logger.info('currency_conversion_not_honored');
                                    } else {
                                        // To avoid a situation if the conversion object is not returned in the response
                                        conversion = plan.conversion || {
                                            changeable: true,
                                            paypal: false
                                        };
                                    }

                                    if (!conversion.from || !conversion.to) {
                                        _logger.$logger.info('currency_conversion_rate_missing');
                                    }
                                }
                            }
                        })['catch'](function () {
                            _logger.$logger.error('checkout_session_reload_failed');
                        });
                    }
                })['catch'](function () {
                    _logger.$logger.error('update_conversion_failed');
                });
            }
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this2 = this;

            this.showOverlay = false;

            // Close overlay function
            this.closeOverlay = function () {
                (0, _utils.logCurrencyConversion)({ options: {
                        to: 'cancel_currency_conversion',
                        currency_conversion_from_curr: _this2.conversion.from_code,
                        currency_conversion_to_curr: _this2.conversion.to_code
                    } });
                _this2.showOverlay = false;
            };

            // Event listener to open the overlay
            var showConversionOverlay = _angular.$rootScope.$on('$showConversionOverlay', function () {
                _this2.isConversionOverlayRateContent = _factory.$CurrencyConversionFactory.isConversionOverlayRateContent();
                (0, _utils.logCurrencyConversion)({ options: {
                        to: 'prepare_currency_conversion',
                        currency_conversion_type: _this2.conversion.paypal ? 'PAYPAL' : 'VENDOR',
                        is_conversion_shown: 1,
                        currency_conversion_from_curr: _this2.conversion.from_code,
                        currency_conversion_to_curr: _this2.conversion.to_code
                    } });
                _this2.showOverlay = true;
            });

            this.$on('$destroy', showConversionOverlay);
        },
        populate: function populate() {
            var _models2 = this.models,
                checkoutSession = _models2.checkoutSession,
                cart = _models2.cart;

            this.conversion = checkoutSession.plan.conversion;
            // If there is conversion, populate scope with properties that will be rendered in UI
            if (this.conversion) {
                var conversion = this.conversion;
                this.isConversionOverlayRateContent = false;
                this.models.ppconversion = !!conversion.paypal;
                this.cartAmount = cart.purchase && cart.purchase.amounts.total.amount_formatted_currency;
                this.payPalAmount = conversion.total_converted_amount;
                this.toTargetCurrency = conversion.to_amount_forex + ' ' + conversion.to_code;
                this.fromUnitCurrency = '1 ' + checkoutSession.plan.conversion.from_code;
            }
        }
    }
});


_squid.$Component;

_angular.$rootScope;

_angular.noop;

_index.$CheckoutSessionModel;

_index.$CheckoutCartModel;

_index2.$CheckoutInputDataModel;

_factory.$CurrencyConversionFactory;

_logger.$logger;

_utils.mapConversionType;

_utils.logCurrencyConversion;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/currency-conversion-overlay/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/currency-conversion-overlay/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-modal show=\"showOverlay\" on-close=\"closeOverlay\" show-close-button=\"true\" enable-close-on-escape=\"true\" enable-mobile-interstitial=\"true\" override-default-container=\"true\">\n        <div class=\"logo\"></div>\n        <!-- Rate variation overlay template  -->\n        <div id=\"conversion-overlay\" content ng-if=\"isConversionOverlayRateContent\">\n            <h3>{{content('currencyOptions.bfxConversionHeaderRateInterstitial')}}</h3>\n            <div class=\"radioButton rate\">\n                <input type=\"radio\" ng-model=\"models.ppconversion\" name=\"conversion\" id=\"paypal-conversion\" ng-value=\"true\"/>\n                <label for=\"paypal-conversion\" class=\"text-label left-label\">{{content('currencyOptions.bfxConversionPayPalLabelRate')}}</label>\n                <input type=\"radio\" ng-model=\"models.ppconversion\" name=\"conversion\" id=\"vendor-conversion\" ng-value=\"false\"/>\n                <label for=\"vendor-conversion\" class=\"text-label right-label\">{{content('currencyOptions.bfxConversionIssuerLabelRate')}}</label>\n            </div>\n            <div class=\"total-amount\" ng-if=\"models.ppconversion\">\n                <span>{{content('currencyOptions.bfxConversionPayPalTotal')}}</span>\n                <br>\n                <span class=\"amount\">{{payPalAmount}}</span>\n            </div>\n            <div class=\"total-amount\" ng-if=\"!models.ppconversion\">\n                <span>{{content('currencyOptions.bfxConversionIssuerTotal')}}</span>\n                <br>\n                <span class=\"amount\">{{cartAmount}}</span>\n            </div>\n            <div class=\"paypal-conversion-msg\" ng-if=\"models.ppconversion\">\n                <p class=\"conversion-rate\">\n                    <b>\n                        {{content('currencyOptions.bfxConversionPayPalRate') + ' '}}\n                        <span>{{content('paymentMethod.conversionRate', {currencyFrom: fromUnitCurrency, currencyTo: toTargetCurrency})}}</span>\n                    </b>\n                </p>\n                <p class=\"conversion-text\">{{content('currencyOptions.bfxConversionPayPalSpreadDisclosureMember')}}</p>\n            </div>\n            <div class=\"vendor-conversion-msg\" ng-if=\"!models.ppconversion\">\n                <p>{{content('currencyOptions.bfxConversionIssuerDisclosure')}}</p>\n            </div>\n            <button type=\"button\" class=\"btn full\" ng-click=\"actions.onSubmit()\">\n                {{content('common.continuetext')}}\n            </button>\n        </div>\n\n        <!-- Currency variation overlay template  -->\n        <div id=\"conversion-overlay\" content ng-if=\"!isConversionOverlayRateContent\">\n            <h3>{{content('currencyOptions.bfxConversionHeaderCurrency')}}</h3>\n            <div class=\"radioButton currency\">\n                <input type=\"radio\" ng-model=\"models.ppconversion\" name=\"conversion\" id=\"paypal-conversion\" ng-value=\"true\"/>\n                <label for=\"paypal-conversion\" class=\"text-label left-label\">{{conversion.from_code}}</label>\n                <input type=\"radio\" ng-model=\"models.ppconversion\" name=\"conversion\" id=\"vendor-conversion\" ng-value=\"false\"/>\n                <label for=\"vendor-conversion\" class=\"text-label right-label\">{{conversion.to_code}}</label>\n            </div>\n            <div class=\"total-amount\" ng-if=\"models.ppconversion\">\n                <span>{{content('currencyOptions.bfxConversionPayPalTotal')}}</span>\n                <br>\n                <span class=\"amount\">{{payPalAmount}}</span>\n            </div>\n            <div class=\"total-amount\" ng-if=\"!models.ppconversion\">\n                <span>{{content('currencyOptions.bfxConversionIssuerTotal')}}</span>\n                <br>\n                <span class=\"amount\">{{cartAmount}}</span>\n            </div>\n            <div class=\"paypal-conversion-msg\" ng-if=\"models.ppconversion\">\n                <p class=\"conversion-rate\">\n                    <b>\n                        {{content('currencyOptions.bfxConversionPayPalRate') + ' '}}\n                        <span>{{content('paymentMethod.conversionRate', {currencyFrom: fromUnitCurrency, currencyTo: toTargetCurrency})}}</span>\n                    </b>\n                </p>\n                <p class=\"conversion-text\">{{content('currencyOptions.bfxConversionPayPalSpreadDisclosureMember')}}</p>\n            </div>\n            <div class=\"vendor-conversion-msg\" ng-if=\"!models.ppconversion\">\n                <p>{{content('currencyOptions.bfxConversionIssuerDisclosure')}}</p>\n            </div>\n            <button type=\"button\" class=\"btn full\" ng-click=\"actions.onSubmit()\">\n                {{content('common.payInCurrencyLabel', {currency: models.ppconversion ? conversion.from_code : conversion.to_code})}}\n            </button>\n        </div>\n    </xo-modal>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/currency-conversion-overlay/utils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.logCurrencyConversion = exports.mapConversionType = undefined;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var DEFAULT_LOGGING_OPTIONS = {
    from: 'CURRENCY_CONVERSION'
};

var mapConversionType = exports.mapConversionType = function mapConversionType(type) {
    return type ? 'PAYPAL' : 'VENDOR';
};

var logCurrencyConversion = exports.logCurrencyConversion = function logCurrencyConversion(_ref) {
    var _ref$name = _ref.name,
        name = _ref$name === undefined ? 'currency_conversion' : _ref$name,
        _ref$options = _ref.options,
        options = _ref$options === undefined ? {} : _ref$options;

    // ES lint does not support the spread operator syntax which throws parsing error on its encounter
    var logOptions = Object.assign({}, DEFAULT_LOGGING_OPTIONS, options);
    _logger.$logger.info(name, logOptions);
};
_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/currency-conversion/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

var _factory = __webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion/factory.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCurrencyConversionDirective', {
    tag: 'xo-currency-conversion',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        doneFn: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                cart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()
            };
        },
        conversion: function conversion(resolvers) {
            var _this = this;

            return resolvers.models.then(function (models) {
                var fundingOptionId = _this.checkoutInputData.funding_option_id;

                if (!fundingOptionId || fundingOptionId === models.checkoutSession.plan.id) {
                    return models.checkoutSession.plan.conversion || {};
                }

                return models.checkoutSession.fundingOptions.action('getConversion', {
                    data: {
                        planId: fundingOptionId
                    },
                    success: function success(result) {
                        return result;
                    }
                });
            });
        }
    },

    actions: {
        onSubmit: function onSubmit() {
            var _this2 = this;

            var checkoutSession = this.models.checkoutSession;


            function mapConversionType(type) {
                return type ? 'PAYPAL' : 'VENDOR';
            }

            var selectedConversionType = mapConversionType(this.models.ppconversion);
            var planConversionType = mapConversionType(this.conversion.paypal);

            if (selectedConversionType === planConversionType) {
                this.props.doneFn();
                _logger.$logger.info('currency_conversion', {
                    from: 'CURRENCY_CONVERSION',
                    to: 'cancel_currency_conversion'
                });
                return;
            }

            _logger.$logger.info('currency_conversion', {
                from: 'CURRENCY_CONVERSION',
                to: 'process_currency_conversion',
                conversion_selected: selectedConversionType
            });

            var payload = {
                conversionType: selectedConversionType,
                planId: this.checkoutInputData.funding_option_id || checkoutSession.plan.id
            };

            if (payload.planId) {
                return checkoutSession.fundingOptions.action('updateConversion', {
                    data: payload,
                    success: function success(result) {
                        if (payload.planId !== checkoutSession.plan.id) {
                            // don't need to reload checkoutSession after updating the conversion of the backup funding option
                            return _this2.props.doneFn(result);
                        }
                        return checkoutSession.reload({
                            success: function success() {
                                var conversion = checkoutSession.plan.conversion || {};

                                if (!_this2.models.ppconversion) {
                                    if (conversion.paypal) {
                                        _logger.$logger.info('currency_conversion_not_honored', {
                                            type: _this2.models.ppconversion,
                                            from: conversion.from,
                                            to: conversion.to,
                                            changeable: conversion.changeable
                                        });
                                    } else {
                                        checkoutSession.plan.conversion = checkoutSession.plan.conversion || {
                                            changeable: true,
                                            paypal: false
                                        };

                                        if (!checkoutSession.plan.conversion.from || !checkoutSession.plan.conversion.to) {
                                            _logger.$logger.info('currency_conversion_rate_missing');
                                        }
                                    }
                                }
                                _this2.props.doneFn(result);
                            }
                        });
                    }
                });
            }
        }
    },
    lifecycle: {
        enter: function enter() {
            this.checkoutInputData = _index2.$CheckoutInputDataModel.instance(this.props.token);
        },
        populate: function populate() {
            var _models = this.models,
                checkoutSession = _models.checkoutSession,
                cart = _models.cart;


            this.models.ppconversion = !!this.conversion.paypal;
            this.paypalConversionTotal = _factory.$CurrencyConversionFactory.getPayPalConversionTotal(checkoutSession, this.conversion);
            this.cardIssuerData = _factory.$CurrencyConversionFactory.getCardIssuerData(checkoutSession, this.conversion, cart);
            this.toTargetCurrency = this.conversion.to_amount_forex + ' ' + this.conversion.to_code;
            this.fromUnitCurrency = '1 ' + this.conversion.from_code;

            _logger.$logger.info('currency_conversion', {
                from: 'CURRENCY_CONVERSION',
                to: 'prepare_currency_conversion',
                conversion_type: this.conversion.paypal ? 'PAYPAL' : 'VENDOR',
                is_conversion_shown: 1
            });
        }
    }
});


_squid.$Component;

_logger.$logger;

_index.$CheckoutSessionModel;

_index.$CheckoutCartModel;

_index2.$CheckoutInputDataModel;

_factory.$CurrencyConversionFactory;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/currency-conversion/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$CurrencyConversionFactory', function () {
    var showConversionOverlay = false; // Phase 2 flag that determines to show overlay or sidebar for currency conversion selection
    var showConversionOverlayRateContent = false; // Phase 2 flag that determines rate or currency variant for currency conversion overlay content

    // Call to get PXP treatents
    var fetchPXPTreatments = function fetchPXPTreatments() {
        return (0, _squid.$pxp)('xo_hermes_currency_conversion', 'xo_hermes_curr_conv_.*', undefined, false, true).then(function (result) {
            var treatmentName = result && result.treatment_name;

            showConversionOverlay = treatmentName && treatmentName.indexOf('test\_') > -1;
            showConversionOverlayRateContent = treatmentName && treatmentName.indexOf('test\_rate') > -1;
        });
    };

    /**
     * get content data for card issuer radio box container
     *
     * @param {Object} checkoutSession - $CheckoutSessionModel model
     * @param {Object} conversion - $CheckoutSessionModel conversion obj
     * @param {Object} cartModel - $CheckoutCartModel model
     */
    var getCardIssuerData = function getCardIssuerData(checkoutSession, conversion, cart) {
        var plan = checkoutSession.plan;
        var isSplitBalance = plan.isSplitBalance();
        var showConvertIssuerSplitBalContent = false;
        var disclaimer = void 0;
        var label = void 0;

        if (isSplitBalance) {
            // if there is BALANCE source with the same "currency_code" as "cart total amount"
            // then we should NOT show Split balance content because Planning will not exclude this Balance from the plan after replan
            showConvertIssuerSplitBalContent = !plan.sources.some(function (source) {
                return source.get('type') === 'BALANCE' && source.get('amount.currency_code') === cart.get('purchase.amounts.total.currency_code');
            });
        }

        if (showConvertIssuerSplitBalContent) {
            label = (0, _squid.$renderContent)('currencyOptions.convertIssuerSplitBal');
            disclaimer = (0, _squid.$renderContent)('currencyOptions.issuerFinalAmountSplitBal', {
                amt: cart.get('purchase.amounts.total.amount_formatted_currency')
            });
        } else {
            label = (0, _squid.$renderContent)('currencyOptions.convertIssuer');
            disclaimer = '<b>' + (0, _squid.$renderContent)('currencyOptions.amount') + '</b> ' + (0, _squid.$renderContent)('currencyOptions.issuerFinalAmount');
        }

        return {
            label: label,
            disclaimer: disclaimer
        };
    };

    /**
     * Calculate conversion total only when:
     * 1. for PayPal rate
     * 2. there is only one plan source available (for multi source use cases, e.g Card + Balance we don't want to calc total for now)
     *
     * @param {Object} checkoutSession - $CheckoutSessionModel model
     * @param {Object} conversion - $CheckoutSessionModel conversion obj
     * @returns {String} Returns total formatted amount
     */
    var getPayPalConversionTotal = function getPayPalConversionTotal(checkoutSession, conversion) {
        var sources = checkoutSession.get('plan.sources');

        if (!conversion.paypal || sources && sources.length > 1) {
            return;
        }

        return checkoutSession.get('plan.sources.0.amount.amount_formatted_currency');
    };

    /**
     * Get the currency conversion PXP flag
     * @returns {Boolean} - Flag that confirms PXP treatment to show currency conversion overlay
     */
    var getConversionOverlayFlag = function getConversionOverlayFlag() {
        return showConversionOverlay;
    };

    /**
     * Get the currency conversion overlay content flag to determinte to render right content
     * @returns {Boolean} - Flag that confirms PXP treatment to show currency conversion overlay
     */
    var isConversionOverlayRateContent = function isConversionOverlayRateContent() {
        return showConversionOverlayRateContent;
    };

    return {
        getCardIssuerData: getCardIssuerData,
        getPayPalConversionTotal: getPayPalConversionTotal,
        fetchPXPTreatments: fetchPXPTreatments,
        getConversionOverlayFlag: getConversionOverlayFlag,
        isConversionOverlayRateContent: isConversionOverlayRateContent
    };
});

_squid.$renderContent;

_squid.$pxp;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/currency-conversion", "../node_modules/xo-wallet-components/src/currency-conversion/factory.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/currency-conversion/template.html":
/***/ (function(module, exports) {

module.exports = "<form method=\"post\" class=\"curr_conv asideProceed formSmall\" novalidate=\"novalidate\" ng-submit=\"actions.onSubmit()\" content form-autofocus>\n    <ul class=\"conversionoptions\">\n        <li>\n            <div class=\"radioButton\">\n                <input type=\"radio\" ng-model=\"models.ppconversion\" name=\"ppconversion\" id=\"conversionPayPal\" ng-value=\"true\"/>\n                <label for=\"conversionPayPal\">{{content('currencyOptions.convertPayPal')}}</label>\n            </div>\n            <div class=\"conversion\">\n                <div ng-if=\"conversion.from && conversion.to\" class=\"dccDetails\">\n                    <p>\n                        <span><b>{{content('currencyOptions.exchangeRate')}}</b></span>\n                        <span class=\"conversionRate\">{{content('paymentMethod.conversionRate', {currencyFrom: fromUnitCurrency, currencyTo: toTargetCurrency})}}</span>\n                    </p>\n                    <p ng-if=\"content('currencyOptions.conversionSecondary')\" class=\"conversionFeeDisclaimer\" ng-bind=\"content('currencyOptions.conversionSecondary')\"></p>\n                </div>\n                <p ng-if=\"conversion.date\" class=\"conversionDate\">{{content('currencyOptions.conversionDate', {date: conversion.date})}}</p>\n                <p ng-if=\"paypalConversionTotal\" class=\"conversionAmount\"><b>{{content('currencyOptions.amount')}}</b> {{paypalConversionTotal}}</p>\n                <p ng-if=\"content('currencyOptions.rateDisclaimerPayPal')\" class=\"conversionDisclaimer\">{{content('currencyOptions.rateDisclaimerPayPal')}}</p>\n            </div>\n        </li>\n        <li>\n            <div class=\"radioButton\">\n                <input type=\"radio\" ng-model=\"models.ppconversion\" name=\"ppconversion\" id=\"conversionVendor\" ng-value=\"false\"/>\n                <label for=\"conversionVendor\">{{ cardIssuerData.label }}</label>\n            </div>\n            <div class=\"conversion\">\n                <p bind-html-compile=\"cardIssuerData.disclaimer\"></p>\n                <p ng-if=\"content('currencyOptions.rateDisclaimerIssuer')\" class=\"conversionDisclaimer\">{{content('currencyOptions.rateDisclaimerIssuer')}}</p>\n            </div>\n        </li>\n        <li ng-if=\"content('currencyOptions.rateDisclaimerCommon')\" class=\"commonDisclaimer\">{{content('currencyOptions.rateDisclaimerCommon')}}</li>\n    </ul>\n    <div class=\"buttons\">\n        <input id=\"proceedButton\" type=\"submit\" value=\"{{content('buttons.agree')}}\" class=\"btn full\">\n    </div>\n</form>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/fi-contingency-list/contingencies.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {

    var contingencyList = {
        INSTRUMENT_COUNT_EXCEEDED: 'errorInstrumentCountExceeded',
        INSTRUMENT_COUNT_EXCEEDED_VERIFIED: 'errorInstrumentCountExceeded',
        INSTRUMENT_COUNT_LIMIT_EXCEEDED: 'errorInstrumentCountExceeded',
        INSTRUMENT_COUNT_LIMIT_EXCEEDED_VERIFIED: 'errorInstrumentCountExceeded',
        INSTRUMENT_UNAVAILABLE: 'errorInstrumentUnavailable',
        INSTRUMENT_REFUSED_DUE_TO_MAX_LIMIT: 'errorInstrumentRefused',
        INSTRUMENT_REFUSED_DUE_TO_MAX_SHARED_INSTRUMENT_LIMIT: ['errorInstrumentUnavailable', 'errorInstrumentRefused'],
        INSTRUMENT_SHARING_LIMIT_EXCEEDED: ['errorInstrumentUnavailable', 'errorInstrumentRefused'],
        INSTRUMENT_ALREADY_EXISTS: 'errorInstrumentAlreadyExists',
        INSTRUMENT_BILLING_ADDRESS_NOT_ACCEPTED: 'errorInstrumentBillingAddressNotAccepted',
        BILLING_ADDRESS1: 'errorInstrumentBillingAddressNotAccepted',
        BILLING_CITY: 'errorInstrumentBillingAddressNotAccepted',
        BILLING_COUNTRY: 'errorInstrumentBillingAddressNotAccepted',
        BILLING_DIFFERENT_COUNTRY: ['errorInstrumentBillingAddressUnavailableIntl', 'errorInstrumentBillingAddressNotAccepted'],
        INSTRUMENT_UPDATE_NO_CHANGE: 'errorInstrumentUpdateNoChange',
        INSTRUMENT_DUPLICATE_LIMIT_REACHED: 'errorInstrumentRefused',
        NOT_ELIGIBLE_TO_EDIT_CARD: 'notEligibleToEditCard',
        INTERNAL_ERROR: 'errorInternalError',
        INSTRUMENT_REFUSED: 'errorInstrumentRefused',
        INSTRUMENT_INTERNATIONAL: 'errorIssuerRejectIntl',
        REJECT_REFUSED: ['errorIssuerReject', 'errorInstrumentRefused'],
        PAYPAL_DEBIT_CARD_REFUSED: ['errorPaypalDebitRefused', 'errorGeneral'],
        PAYPAL_CREDIT_CARD_REFUSED: ['errorPaypalCreditRefused', 'errorGeneral'],
        PAYPAL_CARD_REFUSED: ['errorPaypalRefused', 'errorGeneral'],
        EXCESSIVE_REJECTIONS: ['errorExcessiveRejectGuest', 'errorInstrumentRefused'],
        CC_INVALID_CSC: ['errorCheckDigits', 'errorGeneral'],
        INVALID_EXPIRATION_DATE: 'errorInvalidExpirationDate',
        CHECK_DIGITS_NOT_PRESENT: ['errorCheckDigitsNotPresent', 'errorGeneral'],
        REJECT_UNKNOWN: ['errorIssuerReject', 'errorInstrumentRefused'],
        SETTLEMENT_DENIED: 'errorInstrumentRefused',
        MAX_AMOUNT_EXCEEDED: ['errorMaxAmountExceeded', 'errorInstrumentRefused'],
        ISSUER_ERROR: ['errorIssuerDenied', 'errorInstrumentRefused'],
        MISSING_FIELD: ['errorInvalidData', 'errorGeneral'],
        INVALID_PARAMETERS: ['errorInvalidData', 'errorGeneral'],
        INVALID_DATA: ['errorInvalidData', 'errorGeneral'],
        INVALID_ACCOUNT: ['errorInvalidAccount', 'errorGeneral'],
        INVALID_INSTRUMENT_ID: ['errorInvalidAccount', 'errorGeneral'],
        ACCOUNT_RESTRICTED: ['errorAccountRestricted', 'errorGeneral'],
        ISSUER_RESTRICTED: ['errorIssuerReject', 'errorGeneral'],
        ISSUER_REJECTED: ['errorIssuerReject', 'errorGeneral'],
        ADDRESS_MISMATCH: 'errorInstrumentBillingAddressNotMatch',
        CHECK_DIGITS_NOT_PROC: ['errorCheckDigitsNotPresent', 'errorGeneral'],
        CHECK_DIGITS_UNSUPPORTED: ['errorCheckDigits', 'errorGeneral'],
        CHECK_DIGITS_UNAVAILABLE: ['errorCheckDigits', 'errorGeneral'],
        BILL_ADDR_UNAVAILABLE: ['errorInstrumentBillingAddressUnavailable', 'errorInstrumentBillingAddressNotAccepted'],
        BILL_ADDR_UNSUPPORTED: ['errorInstrumentBillingAddressUnsupported', 'errorInstrumentBillingAddressNotAccepted'],
        BILL_ADDR_UNAVAILABLE_GLOBAL: ['errorInstrumentBillingAddressUnavailableIntl', 'errorInstrumentBillingAddressNotAccepted'],
        BILL_ADDR_NOT_ALLOWED: ['errorInstrumentBillingAddressNotAccepted', 'errorAddressNotAllowed'],
        BILL_ADDR_UNAVAILABLE_INTL: ['errorInstrumentBillingAddressUnavailableIntl', 'errorInstrumentBillingAddressNotAccepted'],
        INSTRUMENT_DISABLED: 'errorInstrumentRefused',
        PI_TYPE_NOT_SUPPORTED: 'errorInvalidCCNumberOrType_global',
        REJECT_AMEX_ADULT: ['errorAmexAdult', 'errorGeneral'],
        INVALID_BANK_ROUTING_NUMBER: 'invalidRoutingNumber',
        BANK_ROUTING_NUMBER_IS_EMPTY: 'invalidPINumber',
        INVALID_BANK_ACCOUNT_NUMBER: 'invalidPINumber',
        BANK_ACCOUNT_NUMBER_IS_EMPTY: 'invalidPINumber',
        INVALID_BANK_IBAN: 'invalidPINumber',
        INVALID_IBAN_CODE: 'invalidPINumber',
        INVALID_BANK_IBAN_CONVERSION_ERROR: 'invalidPINumber',
        INVALID_BENEFICIARY_FIRST_NAME: 'errorInvalidFirstName',
        INVALID_BENEFICIARY_NAME: 'errorInvalidFirstName',
        INVALID_BANK_BENEFICIARY_NUMBER: 'errorGeneral',
        INVALID_BANK_ADDRESS: 'errorGeneral',
        INVALID_CARD_NUMBER: 'errorInvalidCCNumberOrType',
        INVALID_CARD_TYPE: 'errorInvalidCCNumberOrType',
        INVALID_SECURITY_CODE: 'errorInvalidCSC',
        INVALID_FIRST_NAME: 'errorInvalidFirstName',
        INVALID_LAST_NAME: 'errorInvalidLastName',
        INVALID_EXPIRY: 'errorInvalidExpirationDate',
        INVALID_PHONE: 'errorInvalidPhone',
        BANK_ADDRESS_IS_EMPTY: 'errorGeneral',
        INVALID_BANK_BRANCH_NUMBER: 'errorGeneral',
        ADD_REFUSED_DUE_TO_EXCEEDING_MAX_DUPLICATE_INSTRUMENT_LIMIT: 'errorInstrumentUnavailable',
        EMPTY_DATA: 'errorGeneral',
        ISSUER_DECLINE: 'errorIssuerReject',
        WRONG_CONFIRMATION_VALUES: 'wrongConfirmationValue',
        CONFIRMATION_RESEND_COUNT_EXCEEDED: 'resendValExceeded',
        FREQUENT_REQUEST_VERIFICATION_CODE: 'frequentVerificationCodeReq',
        TRANSACTION_TIMEOUT: 'transactionTimeout',
        NOT_CONFIRMED: 'notConfirmed',
        CONTACT_CARD_ISSUER_TO_VERIFY: 'issuerVerify',
        CARD_NOT_ACTIVATED_FOR_UPOP: 'cardNotActivatedUpop',
        RESTRICTED_CARD: 'cardRestricted',
        INVALID_ONE_TIME_PASSWORD: 'errorInvalidOtpCode',
        DUPLICATED_TRANSACTION: 'duplicateTransaction'

    };

    return contingencyList;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/fi-contingency-list/util.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename, $) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _contingencies = __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/contingencies.js");

var _contingencies2 = _interopRequireDefault(_contingencies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// FI error fields and xo frontend models map
var FIELD_TO_MODEL_MAPPING = {
    ACTOR: [],
    BILLING_ADDRESS: ['cardmodel.address'],
    BIN: ['card.type', 'card.number'],
    CARD: ['card.type', 'card.number'],
    CUP_CARD: ['card.type', 'card.number'],
    CVV: ['card.security_code'],
    DOB: ['dob.value', 'user.dob_day', 'user.dob_month', 'user.dob_year'],
    EXPIRY: ['expiryDate', 'card.expiry_month', 'card.expiry_year']
};

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$fiErrorUtil', function () {
    return {
        addPageErrors: function addPageErrors(errorData, contentBundle, prop, defaultKey) {
            // error handling for filifecycle and fimanagement.
            if (!errorData.errorCodes) {
                errorData.errorCodes = errorData && [errorData['0']];
            }

            var messages = [];

            if (errorData.errorCodes && errorData.errorCodes.length) {
                errorData.errorCodes.forEach(function (errorCode) {
                    var contentKey = _contingencies2['default'][errorCode] || defaultKey || 'errorGeneral';
                    var message = void 0;

                    if (angular.isArray(contentKey)) {
                        for (var i = 0; i < contentKey.length; i++) {
                            message = (0, _squid.$renderContent)(contentBundle + '.' + contentKey[i], prop);
                            if (message) {
                                break;
                            }
                        }
                    } else {
                        message = (0, _squid.$renderContent)(contentBundle + '.' + contentKey, prop);
                    }
                    messages.push(message);
                });
            } else {
                messages.push((0, _squid.$renderContent)(contentBundle + '.' + 'errorGeneral', prop));
            }

            return {
                msgs: messages,
                type: 'error'
            };
        },

        highlightInvalidFields: function highlightInvalidFields(invalidFields, $element) {
            for (var _iterator = invalidFields, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }

                var model = _ref;

                var $field = $($element).find('[ng-model="' + model + '"]');

                $field.addClass('backendError');
                $field.attr('aria-invalid', true);
            }

            $($element).find('.backendError').first().focus();
        },

        mapValidationErrorToModel: function mapValidationErrorToModel() {
            var invalidFields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            var errorProperty = 'VALIDATION_ERROR_';

            // if there is only one invalid field then fetch the corresponding error message else return the
            // generic validation error message
            if (invalidFields.length === 1) {
                return {
                    invalidModels: FIELD_TO_MODEL_MAPPING[invalidFields[0]],
                    errorProperty: errorProperty + invalidFields[0]
                };
            }
            return {
                invalidModels: [],
                errorProperty: errorProperty + 'GENERIC'
            };
        },

        addPageErrorByErrorName: function addPageErrorByErrorName(contentBundle, prop) {
            var defaultKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'INTERNAL_ERROR';

            var message = (0, _squid.$renderContent)(contentBundle + '.' + prop);

            if (!message || !message.toString()) {
                // log content not found
                _logger.$logger.error('fi_content_missing', {
                    prop: prop
                });
                message = (0, _squid.$renderContent)(contentBundle + '.' + defaultKey);
            }

            return {
                msgs: [message],
                type: 'error'
            };
        },

        /**
         * Highlight the Error Fields by ng-model
         * @param errorData
         * @param element
         * @param modelPrefix
         */
        addFieldErrors: function addFieldErrors(errorData, element, modelPrefix) {
            if (errorData.fields && errorData.fields.length) {
                errorData.fields.forEach(function (field) {
                    var $field = $(element).find('[ng-model="' + (modelPrefix ? modelPrefix : '') + field.field + '"]');

                    $field.addClass('backendError');
                    $field.attr('aria-invalid', true);
                });
            }
            $(element).find('.backendError:first').focus();
        },

        /**
         * Highlight the Error Fields by element name
         * @param errorData
         * @param element
         * @param modelPrefix
         */
        addFieldErrorsByName: function addFieldErrorsByName(errorData, element, modelPrefix) {
            if (errorData.fields && errorData.fields.length) {
                errorData.fields.forEach(function (field) {
                    var fieldName = void 0;

                    if (modelPrefix && field.field && field.field.length > 0) {
                        // Add prefix with CamelCase of field name
                        fieldName = modelPrefix + field.field[0].toUpperCase() + field.field.substring(1);
                    } else {
                        fieldName = field.field;
                    }
                    var $field = $(element).find('[name="' + fieldName + '"]');

                    $field.addClass('backendError');
                    $field.attr('aria-invalid', true);
                });
            }
            $(element).find('.backendError:first').focus();
        }
    };
});

_squid.$renderContent;

_logger.$logger;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/fi-contingency-list", "../node_modules/xo-wallet-components/src/fi-contingency-list/util.js", __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/fi-logos/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/fi-logos/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoFiLogos', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?'
        },
        controller: ['$scope', function ($scope) {
            (0, _squid.$populate)($scope, {
                cardTypes: _fi.$CardTypesModel.instance($scope.token + ':' + _squid.$locale.country, {
                    token: $scope.token,
                    country: _squid.$locale.country
                })
            });
        }]
    };
});

_squid.$locale;

_squid.$populate;

_fi.$CardTypesModel;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/fi-logos/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"fiIconsGroup\">\n    <div class=\"cardIconsGroup\">\n        <div class=\"icons\" ng-repeat=\"cardType in cardTypes.allowed track by $index\">\n            <div class = \"cardIcon {{cardType}}\"></div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/installment-options/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-tray-height/dist/directive.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/installment-options/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoInstallmentOptions', function () {
    return {
        template: _template2['default'],

        scope: {
            token: '=?',
            doneFn: '=?',
            cardNumber: '=?'
        },

        controller: ['$scope', function ($scope) {

            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance()
            }).then(function () {

                if ($scope.auth.logged_in) {

                    // Installment support for authenticated user
                    (0, _squid.$populate)($scope, {
                        checkoutSession: _checkout.$CheckoutSessionModel.instance($scope.token)
                    }).then(function () {
                        $scope.cardInfo = $scope.checkoutSession.plan.sources[0];
                        $scope.installments = $scope.checkoutSession.installments;
                    });
                } else {
                    // Installment support added for not authenticated user, e.g. BR signup flow
                    var installmentsModel = _checkout.$InstallmentOptionsModel.instance($scope.token);

                    installmentsModel.save({
                        data: {
                            cc: $scope.cardNumber,
                            payee: _checkout.$CheckoutPayeeModel.instance($scope.token),
                            checkoutCart: _checkout.$CheckoutCartModel.instance($scope.token),
                            checkoutAppData: _checkout.$CheckoutAppDataModel.instance($scope.token)
                        },

                        success: function success(result) {
                            $scope.cardInfo = result.cardInfo;
                            $scope.installments = result.installment_options;
                        }
                    });
                }
            });

            $scope.onSelect = function (index) {
                var selectedInstallmentData = $scope.installments[index];
                $scope.installmentsModel = _checkout.$InstallmentOptionsModel.instance($scope.token);

                var param = {
                    term: selectedInstallmentData.term,
                    payment_value: selectedInstallmentData.monthly_payment.value,
                    payment_currency: selectedInstallmentData.monthly_payment.currency
                };

                if (selectedInstallmentData.total_cost) {
                    param.total_cost_value = selectedInstallmentData.total_cost.value;
                    param.total_cost_currency = selectedInstallmentData.total_cost.currency;
                }

                if (selectedInstallmentData.discount_amount) {
                    param.discount_value = selectedInstallmentData.discount_amount.value;
                    param.discount_currency = selectedInstallmentData.monthly_payment.currency;
                }

                if (selectedInstallmentData.discount_percentage) {
                    param.discount_percentage = selectedInstallmentData.discount_percentage;
                }

                return $scope.installmentsModel.action('select', {
                    data: param,

                    success: function success(result) {
                        if ($scope.auth.logged_in) {
                            $scope.checkoutSession.selectedInstallmentData = selectedInstallmentData;
                        }
                        $scope.doneFn(result);
                    }
                });
            };
        }]
    };
});

_squid.$populate;

_auth.$AuthModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutSessionModel;

_checkout.$InstallmentOptionsModel;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/installment-options/template.html":
/***/ (function(module, exports) {

module.exports = "<div content class=\"aside installmentOptions\" ng-class=\"{true: 'signupflow'}[!auth.logged_in]\" >\n    <div class=\"cardInfo\" ng-if=\"cardInfo\">\n        <span class=\"ccard {{cardInfo.card_type}}\" id=\"creditCard\" role=\"img\" aria-label=\"{{cardInfo.name}}\"></span> {{cardInfo.name}} x-{{cardInfo.last4}}&nbsp;<span class=\"installmentText\" ng-if=\"installments\">{{content('installments.upto')}}&nbsp;{{installments.length}}x</span>\n    </div>\n    <ul class=\"asideContent items\" ng-if=\"installments\">\n        <li class=\"installment\" ng-repeat=\"installment in installments track by $index\" ng-click=\"onSelect($index)\" track-submit>\n            <div class=\"term\">\n                <span>{{installment.term}}x {{content('installments.of')}}&nbsp;</span>\n            </div>\n            <div class=\"display\">\n                <span>{{installment.monthly_payment.formatted_value}}</span>\n                <div class=\"confidential total\">\n                    <span>{{content('installments.total')}}: {{installment.total}}</span>\n                    <span class=\"save\" ng-if=\"installment.discount_amount\">\n                        {{content('installments.save')}} {{installment.discount_amount.formatted_value}}\n                    </span>\n                </div>\n            </div>\n\n        </li>\n    </ul>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/member-sepa/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/member-sepa/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoMemberSepa', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            parentCallbacks: '=?'
        },
        controller: ['$scope', function ($scope) {
            $scope.sepa = _fi.$SepaModel.instance({ id: 123 });
            $scope.callbacks = {
                sepaAccept: function sepaAccept() {
                    (0, _squid.$populate)($scope, {
                        checkoutAppData: _checkout.$CheckoutAppDataModel.instance($scope.token),
                        checkoutSession: _checkout.$CheckoutSessionModel.instance($scope.token)
                    }).then(function () {
                        return $scope.sepa.action('sepaAccept', {
                            data: {
                                bank: {
                                    id: $scope.sepa.bankId
                                }
                            },
                            success: function success() {
                                $scope.parentCallbacks.success($scope.sepa);
                            }
                        });
                    });
                }
            };
        }]
    };
});

_squid.$populate;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutAppDataModel;

_fi.$SepaModel;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/member-sepa/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/member-sepa/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/member-sepa/sepaAgreement/route.js");

__webpack_require__("../node_modules/xo-wallet-components/src/member-sepa/sepaMandate/route.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$MemberSepaRoute', function () {

    return _squid.$ComponentRoute.extend('MemberSepaRoute', {

        name: 'membersepa',

        directive: 'xo-member-sepa',
        titleContent: 'directDebitAgreement.sepaTitle',

        children: [{
            name: '$XOSepaAgreementRoute',
            attributes: {
                token: 'token',
                sepa: 'sepa',
                'parent-callbacks': 'callbacks'
            }
        }, {
            name: '$XOSepaMandateRoute',
            attributes: {
                token: 'token',
                sepa: 'sepa',
                'parent-callbacks': 'callbacks'
            }
        }]
    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/member-sepa", "../node_modules/xo-wallet-components/src/member-sepa/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/member-sepa/sepaAgreement/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/member-sepa/sepaAgreement/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoSepaAgreement', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            sepa: '=?',
            parentCallbacks: '=?'
        },
        controller: ['$scope', function ($scope) {
            $('body').addClass('pageSepaAgreementContingency');

            $scope.$on('$destroy', function () {
                $('body').removeClass('pageSepaAgreementContingency');
            });

            (0, _squid.$populate)($scope, {
                checkoutSession: _index.$CheckoutSessionModel.instance($scope.token)
            }).then(function () {
                $scope.sepa.bankId = $scope.checkoutSession.sepa_mandate.bankId;
                $scope.sepa.action('sepaDirectMandate', {
                    resultModel: $scope.sepa,
                    data: {
                        bank: {
                            id: $scope.sepa.bankId
                        }
                    },
                    success: function success() {
                        $scope.onSubmit = function () {
                            $scope.parentCallbacks.sepaAccept();
                        };
                    }
                });
            });
        }]
    };
});

_squid.$populate;

_index.$CheckoutSessionModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/member-sepa/sepaAgreement/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

__webpack_require__("../node_modules/xo-wallet-components/src/member-sepa/sepaAgreement/directive.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$XOSepaAgreementRoute', function () {
    return _squid.$ComponentRoute.extend('XOSepaAgreementRoute', {
        name: 'sepaAgreement',

        directive: 'xo-sepa-agreement',
        titleContent: 'directDebitAgreement.sepaTitle',

        trackingData: {
            fptiState: 'sepa_agreement',
            buzname: {
                'fullpage': {
                    'pagename': '%::sepa_agreement',
                    'pagename2': '%::sepa_agreement:member:hermes:',
                    'version': 'member:%:'
                }
            }
        },

        loginRequired: true,

        children: []
    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/member-sepa/sepaAgreement", "../node_modules/xo-wallet-components/src/member-sepa/sepaAgreement/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/member-sepa/sepaAgreement/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"sepaAgreementContingency\" content>\n    <div class=\"row-fluid\">\n        <div class=\"centerTray\">\n            <div class=\"trayInner trayInnerDefault loggingIn\">\n                <form ng-submit=\"onSubmit()\" method=\"post\" class=\"proceed ddAgreementForm\" id=\"payment_form\" novalidate>\n                    <h2 class=\"zeta\">{{content('directDebitAgreement.sepaTitle')}}</h2>\n\n                    <p ng-bind-html =\"content('directDebitAgreement.ddAgreementPara1')\"></p>\n                    <p>\n\n                        <span\n                                bind-html-compile=\"htmlContent('directDebitAgreement.ddAgreementPara2',{bankName:sepa.bank.bank_name, bankNumber:sepa.bank.bank_id, href: '^.sepaMandate'})\">\n                        </span>\n\n                    </p>\n\n                    <div class=\"buttons\">\n                        <input track-submit ng-if=\"model.useraction.commit\" id=\"proceedButton\" type=\"submit\" value=\"{{content('directDebitAgreement.acceptAndPay')}}\"  class=\"btn\" />\n                        <input track-submit ng-if=\"!model.useraction.commit\" id=\"proceedButton\" type=\"submit\" value=\"{{content('directDebitAgreement.acceptAndContinue')}}\" class=\"btn\" />\n                    </div>\n                </form>\n            </div>\n        </div>\n\n    </div>\n</section>\n\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/member-sepa/sepaMandate/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/member-sepa/sepaMandate/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoSepaMandate', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            sepa: '=?',
            parentCallbacks: '=?'
        },
        controller: ['$scope', function ($scope) {
            $('body').addClass('pageSepaMandateContingency');
            $scope.$on('$destroy', function () {
                $('body').removeClass('pageSepaMandateContingency');
            });
            $scope.onSubmit = function () {
                $scope.parentCallbacks.sepaAccept();
            };
        }]
    };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/member-sepa/sepaMandate/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/member-sepa/sepaMandate/directive.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$XOSepaMandateRoute', function () {

    return _squid.$ComponentRoute.extend('XOSepaMandateRoute', {
        name: 'sepaMandate',

        directive: 'xo-sepa-mandate',
        titleContent: 'directDebitAgreement.ddFullAgreementTitle',

        trackingData: {
            fptiState: 'sepa_mandate',
            buzname: {
                'fullpage': {
                    'pagename': '%::sepa_mandate',
                    'pagename2': '%::sepa_mandate:member:hermes:',
                    'version': 'member:%:'
                }
            }
        },

        loginRequired: true,

        children: []
    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/member-sepa/sepaMandate", "../node_modules/xo-wallet-components/src/member-sepa/sepaMandate/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/member-sepa/sepaMandate/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"sepaMandateContingency\" content>\n    <div class=\"row-fluid\">\n        <div class=\"centerTray\">\n            <div class=\"trayInner trayInnerDefault loggingIn\">\n                <form ng-submit=\"onSubmit()\" method=\"post\" class=\"proceed\" id=\"payment_form\" novalidate>\n                    <h2 class=\"zeta\">{{content('directDebitAgreement.ddFullAgreementTitle')}}</h2>\n                    <p>{{content('DEMemberGuest.ddAgreementPara1')}}</p>\n                    <div class=\"row-fluid sepaInfo\">\n                        <div class=\"span\">\n                            <strong>{{content('DEMemberGuest.accountCarrier')}}</strong>\n                            <p>\n                                <span>{{sepa.user.name}}</span>\n                                <br/>{{sepa.user.address.line1}}\n                                <br/>{{sepa.user.address.line2}}\n                                <br/> {{sepa.user.address.city}}, {{sepa.user.address.postal_code}}\n                                <br/>{{sepa.user.address.country}}\n                            </p>\n                        </div>\n                        <div class=\"span bankDetails\">\n                            <p>\n                                <strong>{{content('DEMemberGuest.IBAN')}}</strong>\n                            </p>\n                            {{sepa.bank.iban_number}}\n                            <p class=\"marginTop\">\n                                <strong>{{content('DEMemberGuest.bankName')}}</strong>\n                            </p>\n                            {{sepa.bank.bank_name}}\n                            <p class=\"marginTop\">\n                                <strong>{{content('DEMemberGuest.bic')}}</strong>\n                            </p>\n                            {{sepa.bank.bic}}\n                        </div>\n                        <div class=\"span\">\n                            <p>\n                                <strong>{{content('DEMemberGuest.creditor')}}</strong>\n                            </p>\n                            {{sepa.creditor.name}}\n                            <p></p>\n                            <div class=\"adr\">\n                                <div class=\"confidential streets street-address darker\">\n                                    {{sepa.creditor.address.line1}}\n                                </div>\n\n                            <div class=\"confidential\">\n                                <span class=\"postal-code\">{{sepa.creditor.address.postal_code}}</span>\n                                <span class=\"locality\">{{sepa.creditor.address.country}}</span>\n                            </div>\n                            </div>\n                            <p></p>\n                            <p class=\"marginTop\">\n                                <strong>{{content('DEMemberGuest.creditorId')}}</strong>\n                            </p>\n                            {{sepa.creditor.id}}\n                        </div>\n                    </div>\n                    <p>\n                        <span ng-if=\"model.useraction.commit\" ng-bind-html=\"htmlContent('directDebitAgreement.ddAgreementPara2AcceptPay')\"></span>\n                        <span ng-if=\"!model.useraction.commit\" ng-bind-html=\"htmlContent('directDebitAgreement.ddAgreementPara2AcceptContinue')\"></span>\n                    </p>\n                    <p class=\"dateLocationMarker\">{{sepa.date}},{{sepa.user.address.city}},{{content('countryList.DE')}}</p>\n                    <div class=\"buttons\">\n                        <input track-submit ng-if=\"model.useraction.commit\" id=\"proceedButton\" type=\"submit\" value=\"{{content('directDebitAgreement.acceptAndPay')}}\"  class=\"btn\" />\n                        <input track-submit ng-if=\"!model.useraction.commit\" id=\"proceedButton\" type=\"submit\" value=\"{{content('directDebitAgreement.acceptAndContinue')}}\" class=\"btn\" />\n                    </div>\n                </form>\n            </div>\n        </div>\n\n    </div>\n</section>\n\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/member-sepa/template.html":
/***/ (function(module, exports) {

module.exports = "<ui-view></ui-view>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/topup/topup-amount/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/topup/topup-amount/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-wallet-components/src/topup/topup-amount/styles.less");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoTopupAmountDirective', {
    tag: 'xo-topup-amount',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        success: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            return {
                walletPreferences: _fi.$WalletPreferences.instance(this.props.token).retrieve(),
                tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance(this.props.token).retrieve()
            };
        }
    },

    actions: {
        selectAmount: function selectAmount(amount) {
            this.models.walletPreferences.topup.amount = amount;
            this.success();
        }
    },

    lifecycle: {
        enter: function enter() {
            this.topupAmounts = _squid.$config.topup.topupAmounts;
            this.locale = _squid.$locale;
        },
        populate: function populate() {
            if (this.models.walletPreferences.topup.amount && this.topupAmounts.indexOf(this.models.walletPreferences.topup.amount) === -1) {
                this.topupAmounts.push(this.models.walletPreferences.topup.amount);
                this.topupAmounts.sort(function (a, b) {
                    return parseInt(a, 10) - parseInt(b, 10);
                });
            }
        }
    }
});


_squid.$Component;

_squid.$config;

_squid.$locale;

_fi.$WalletPreferences;

_app.$TokenizedWalletInfoModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/topup/topup-amount/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoTopupAmountRoute = undefined;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("../node_modules/xo-wallet-components/src/topup/topup-amount/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoTopupAmountRoute = exports.$xoTopupAmountRoute = _index.$Route.extend('$xoTopupAmountRoute', {
    path: 'topupAmount',
    directive: _directive2['default'],
    children: []
});

exports['default'] = $xoTopupAmountRoute;

angular.value("$xoTopupAmountRoute", $xoTopupAmountRoute);
_index.$Route;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/topup/topup-amount/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/topup/topup-amount/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"topupAmountList\" class=\"aside\" modal-box content>\n    <xo-aside-header heading='asideHeader.topupAmount'\n                     hidex=\"true\"\n                     header-left=\"common.back\"\n                     header-left-link=\"success\"\n                     header-left-icon=\"true\"></xo-aside-header>\n    <div class=\"content\">\n        <div tabindex=\"-1\" focus-when=\"true\">{{ content(\"topup.commonTopupAmountDesc\", { type: this.models.tokenizedWalletInfoModel.brandName() } ) }}</div>\n        <ul>\n            <li ng-repeat=\"amount in topupAmounts track by $index\">\n                <a class=\"listItem\" ng-click=\"actions.selectAmount(amount)\" focusable>\n                    <format-currency class=\"formatCurrency amount\" code=\"models.walletPreferences.topup.currency\"\n                                     amount=\"amount\"\n                                     currency-style=\"Currency\"></format-currency>\n                    <span class=\"checkIcon\" ng-if=\"amount === models.walletPreferences.topup.amount\">\n                        <span class=\"accessAid\" ng-if=\"locale.lang === 'en'\">Selected</span>\n                    </span>\n                </a>\n            </li>\n        </ul>\n    </div>\n</section>\n\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/topup/topup-funding/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/topup/topup-funding/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-wallet-components/src/topup/topup-funding/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoTopupFundingDirective', {
    tag: 'xo-topup-funding',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        success: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            var checkoutCart = _checkout.$CheckoutCartModel.instance(this.props.token);
            var auth = _auth.$AuthModel.instance();
            return {
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                walletPreferences: _fi.$WalletPreferences.instance(this.props.token).retrieve(),
                tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance(this.props.token).retrieve(),
                tokenizedFundingCapabilitiesModel: _app.$TokenizedFundingCapabilitiesModel.instance(this.props.token).retrieve({
                    params: {
                        tokenizedWalletToken: checkoutCart.tokenizedWalletToken,
                        country: auth.country
                    }
                })
            };
        }
    },

    actions: {
        selectFundingSource: function selectFundingSource(id) {
            var _models = this.models,
                checkoutSession = _models.checkoutSession,
                walletPreferences = _models.walletPreferences,
                tokenizedFundingCapabilitiesModel = _models.tokenizedFundingCapabilitiesModel;

            if (walletPreferences.getPreferred().instrument_id !== id) {
                if (tokenizedFundingCapabilitiesModel.isTopupEnabled()) {
                    // Extract the matching topup instrument_id for a given id
                    walletPreferences.topup.fundingSource = _squid.$util.find(checkoutSession.topupFundingSources, function (fs) {
                        return fs.instrument_id === id;
                    });
                } else {
                    // Extract the matching direct_funding instrument_id for a given id
                    walletPreferences.direct.fundingSource = _squid.$util.find(checkoutSession.futurePaymentInstruments, function (fs) {
                        return fs.instrument_id === id;
                    });
                }

                // PatchXO api call for tokenization flows when instrument is changed from Wallet page
                this.models.checkoutSession.action('setTopupFI', {
                    data: {
                        instrument_id: id
                    }
                });
            }
            this.props.success();
        },
        addCard: function addCard() {
            _uiRouter.$state.go('.sidepageAddCard.addCardFlow.addCard');
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.locale = _squid.$locale;
            this.addCardCallbacks = {
                finish: function finish() {
                    if (_this.models.checkoutSession.selectedTopupFundingSource) {
                        _this.models.walletPreferences.topup.fundingSource = _this.models.checkoutSession.selectedTopupFundingSource;
                    }
                    $('#sidepageAddCard').removeClass('sidepageAddCardOpen');
                    (0, _angular.$timeout)(function () {
                        return _uiRouter.$state.go('checkout.review');
                    }, 300);
                },
                cancel: function cancel() {
                    $('#sidepageAddCard').removeClass('sidepageAddCardOpen');
                    (0, _angular.$timeout)(function () {
                        return _uiRouter.$state.go('^.^.^');
                    }, 300);
                }
            };

            this.instrumentIconId = function (name) {
                return _fi.$WalletInstrumentNameMapping.instance().getInstrumentNameNormalized(name);
            };

            /**
             * Get the list of funding sources to display in the wallet page
             */
            this.fundingSourcesList = function () {
                var _models2 = this.models,
                    tokenizedFundingCapabilitiesModel = _models2.tokenizedFundingCapabilitiesModel,
                    checkoutSession = _models2.checkoutSession;
                var topupFundingSources = checkoutSession.topupFundingSources,
                    futurePaymentInstruments = checkoutSession.futurePaymentInstruments;

                if (tokenizedFundingCapabilitiesModel.isTopupEnabled()) {
                    return topupFundingSources;
                } else {
                    // Filter only the Bank accounts for direct funding
                    return futurePaymentInstruments.filter(function (instrument) {
                        return instrument.type === 'BANK';
                    });
                }
            };
        },

        populate: function populate() {
            $('#topupFundingList').css('height', function () {
                return window.innerHeight || document.documentElement && document.documentElement.clientHeight;
            });
        }
    }
});


_angular.$timeout;

_uiRouter.$state;

_squid.$Component;

_squid.$locale;

_squid.$util;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutCartModel;

_fi.$WalletPreferences;

_fi.$WalletInstrumentNameMapping;

_app.$TokenizedWalletInfoModel;

_app.$TokenizedFundingCapabilitiesModel;

_auth.$AuthModel;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/topup/topup-funding/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoTopupFundingRoute = undefined;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("../node_modules/xo-wallet-components/src/topup/topup-funding/directive.js");

var _directive2 = _interopRequireDefault(_directive);

__webpack_require__("./pages/xo-sidepage-add-card/route.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoTopupFundingRoute = exports.$xoTopupFundingRoute = _index.$Route.extend('$xoTopupFundingRoute', {
    path: 'topupFunding',
    directive: _directive2['default'],
    children: [{
        name: '$SidepageAddCardRoute',
        attributes: {
            token: 'token',
            callbacks: 'addCardCallbacks'
        }
    }]
});

exports['default'] = $xoTopupFundingRoute;

angular.value("$xoTopupFundingRoute", $xoTopupFundingRoute);
_index.$Route;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/topup/topup-funding/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/topup/topup-funding/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"topupFundingList\" class=\"aside\" modal-box content>\n    <xo-aside-header ng-if=\"models.tokenizedFundingCapabilitiesModel.isTopupEnabled()\" heading='asideHeader.topupFunding'\n                     hidex=\"true\"\n                     header-left-link=\"success\"\n                     header-left=\"common.back\"\n                     header-left-icon=\"true\"\n                     header-right=\"fundingInstruments.addDebitCard=\"\n                     header-right-link=\"'checkout.review.sidepage.topupFunding.sidepageAddCard.addCardFlow.addCard'\"\n                     header-right-icon=\"true\"></xo-aside-header>\n\n    <xo-aside-header ng-if=\"!models.tokenizedFundingCapabilitiesModel.isTopupEnabled()\" heading='asideHeader.paymentMethod'\n                     hidex=\"true\"\n                     header-left-link=\"success\"\n                     header-left=\"common.back\"\n                     header-left-icon=\"true\"></xo-aside-header>\n\n    <div class=\"content\">\n        <div tabindex=\"-1\" focus-when=\"true\">{{ content(\"tokenization.chooseOptionToPay\", { type: this.models.tokenizedWalletInfoModel.brandName() }) }}</div>\n        <ul>\n            <li ng-repeat=\"fundingSource in fundingSourcesList() track by $index\" focusable>\n                <a class=\"listItem noLink\" ng-click=\"actions.selectFundingSource(fundingSource.instrument_id)\">\n                    <span class=\"walletIcons\" ng-class=\"[fundingSource.type,\n                                                        instrumentIconId(fundingSource.name),\n                                                        fundingSource.card_type]\"></span>\n                    <div class=\"fsItem\">\n                        <div>{{fundingSource.name}}</div>\n                        <div>••••{{fundingSource.last4}}</div>\n                        <span class=\"checkIcon\" ng-if=\"fundingSource.instrument_id === models.walletPreferences.getPreferred().instrument_id\">\n                        <span class=\"accessAid\" ng-if=\"locale.lang === 'en' && fundingSource.instrument_id === models.walletPreferences.getPreferred().instrument_id\">Selected</span>\n                    </span>\n                    </div>\n                </a>\n            </li>\n            <li ng-if=\"models.tokenizedFundingCapabilitiesModel.isTopupEnabled()\">\n                <a href=\"#\" prevent-default link-button ng-click=\"actions.addCard()\" class=\"submit listItem addccLink\">\n                    <span class=\"icon\"></span>\n                    <span class=\"description\">{{content('fundingInstruments.addDebitCard')}}</span>\n                </a>\n            </li>\n            <li ng-if=\"!models.tokenizedFundingCapabilitiesModel.isTopupEnabled()\">\n                <div class=\"disclaimer\">{{content('tokenization.onlyConfirmedBanksShown', {type: models.tokenizedWalletInfoModel.brandName()} )}}</div>\n            </li>\n        </ul>\n    </div>\n</section>\n<div ui-view></div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/topup/update-pin/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

__webpack_require__("../node_modules/xo-ui-components/src/mobile-pin/directive.js");

var _index = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/topup/update-pin/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-wallet-components/src/topup/update-pin/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoUpdatePinDirective', {
    tag: 'xo-update-pin',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        success: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        enter: function enter() {
            _logger.$logger.info('tokenized_wallet', {
                'from': 'PINSETUP',
                'to': 'PREPARE_PINSETUP'
            });
        }
    },

    controller: function controller($scope) {

        var currentPin = '';
        $scope.madeAttempt = false;
        $scope.pinError = '';
        $scope.pinChanged = false;

        function done(pinValue) {
            _index.$TokenizedWalletPinModel.instance(_angular.$rootScope.token).retrieve().then(function (WalletPinModel) {
                WalletPinModel.userPin = pinValue;
                _logger.$logger.info('tokenized_wallet', {
                    'from': 'PINSETUP',
                    'to': 'PROCESS_PINSETUP'
                });
                (0, _angular.$timeout)(function () {
                    return _uiRouter.$state.go('checkout.review');
                }, 1500);
            });
        }

        $scope.pinComplete = function (result) {

            var value = result && result.value;
            if (result && result.error === 'pin_too_simple') {
                $scope.pinError = 'toEasy';
                $scope.madeAttempt = false;
                currentPin = '';
                $scope.$broadcast('resetPin');
                return;
            }

            $scope.pinChanged = $scope.madeAttempt && currentPin === value;
            $scope.pinError = $scope.madeAttempt && !$scope.pinChanged ? 'missMatch' : '';
            currentPin = $scope.madeAttempt ? '' : value; // reset old pin if already made an attempt
            $scope.madeAttempt = !$scope.madeAttempt; // flip flag

            if (!$scope.pinChanged) {
                $scope.$broadcast('resetPin');
            } else {
                done(value);
            }
        };
    }
});


_angular.$timeout;

_uiRouter.$state;

_squid.$Component;

_logger.$logger;

_index.$TokenizedWalletPinModel;

_angular.$rootScope;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/topup/update-pin/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoUpdatePinRoute = undefined;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("../node_modules/xo-wallet-components/src/topup/update-pin/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoUpdatePinRoute = exports.$xoUpdatePinRoute = _index.$Route.extend('$xoUpdatePinRoute', {
    path: 'updatePin',
    directive: _directive2['default'],
    children: []
});
exports['default'] = $xoUpdatePinRoute;

angular.value("$xoUpdatePinRoute", $xoUpdatePinRoute);
_index.$Route;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/topup/update-pin/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/topup/update-pin/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"updatePin\" class=\"aside\" modal-box content>\n    <xo-aside-header heading='asideHeader.inStorePin'\n                    hidex=\"true\"\n                    header-left=\"common.back\"\n                    header-left-link=\"success\"\n                    header-left-icon=\"true\"></xo-aside-header>\n    <div class=\"pinError\" ng-if=\"pinError\">\n        <div class=\"errorIcon\"></div>\n        <div class=\"errorText\">\n            <span ng-if=\"pinError==='missMatch'\">{{content('review.pinMissMatch')}}</span>\n            <span ng-if=\"pinError==='toEasy'\">{{content('review.pinEasy')}}</span>\n        </div>\n    </div>\n    <div class=\"content\">\n        <div class=\"pinUpdate\" ng-if=\"!pinChanged\">\n            <xo-mobile-pin done=\"pinComplete\"></xo-mobile-pin>\n            <div class=\"subtext\" ng-if=\"!pinMissMatch && !madeAttempt\">{{content('review.pinFirstEntry')}}</div>\n            <div class=\"subtext\" ng-if=\"!pinMissMatch && madeAttempt\">{{content('review.pinSecondEntry')}}</div>\n            <div class=\"subtext\" ng-if=\"pinMissMatch\">{{content('review.pinBadEntry')}}</div>\n            <div class=\"secondarySubtext\">{{content('review.pinSubText')}}</div>\n        </div>\n        <div class=\"pinSuccess\" ng-if=\"pinChanged\">\n            <div class=\"successGif\"></div>\n            <div class=\"successText\">{{content('review.pinChanged')}}</div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-webpack-config/polyfills.js":
/***/ (function(module, exports, __webpack_require__) {

// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__("../node_modules/object-assign/index.js");

// array
__webpack_require__("../node_modules/core-js/fn/array/find.js");
__webpack_require__("../node_modules/core-js/fn/array/includes.js");

// string
__webpack_require__("../node_modules/core-js/fn/string/includes.js");


// object
__webpack_require__("../node_modules/core-js/fn/object/entries.js");
__webpack_require__("../node_modules/core-js/fn/object/values.js");



/***/ }),

/***/ "./css/app.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./js/app.js":
/***/ (function(module, exports, __webpack_require__) {



var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _middleware = __webpack_require__("./js/lib/middleware.js");

var _route = __webpack_require__("./pages/xo-checkout/route.js");

var _route2 = _interopRequireDefault(_route);

__webpack_require__("./css/app.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_logger.$logger.info('app_bootstrap', {
    hash: window.location.hash
});

var xoCheckoutRoute = new _route2['default']();

xoCheckoutRoute.bootstrap('checkout.landing', _middleware.$Middleware);

window.bootstrap = true;

_logger.$logger;

_middleware.$Middleware;

/***/ }),

/***/ "./js/bootstrap.js":
/***/ (function(module, exports, __webpack_require__) {



// set public path for chunks on the fly
// more details - https://webpack.js.org/guides/public-path/#on-the-fly
// without it - webpack doesn't know how to resolve path for assets stored in webpack -> output (.build/js)
// in development: staticUrl will be /webapps/hermes/static in case of Hermes
// in production: staticUrl will be pointing to CDN, e.g https://www.paypalobjects.com/web/res/6e6/9af00bdfc93477f08ba3fe44e9589
__webpack_require__.p = window.meta.staticUrl + '/'; // eslint-disable-line no-undef

window.main = true;

// Angular 1.6.9 adds a `!` as a hash prefix to the url by default.
// This is different behavior than Angular 1.4.7 which didn't add
// a hash prefix. The code snippet below will prevent the hash prefix
// from being added so that after the Angular 1.6.9 upgrade the url
// hash will remain the same.
// Angular 1.4.7: http://.../xoonboarding?token=EC-9CC38595EA0236714#/checkout/signup
// Angular 1.6.9 with out setting the `hashPrefix` to an empty string:
// http://.../xoonboarding?token=EC-9CC38595EA0236714#!/checkout/signup
angular.module('app').config(['$locationProvider', '$compileProvider', function ($locationProvider, $compileProvider) {
    $locationProvider.hashPrefix('');

    // https://github.com/angular/angular.js/blob/master/src/ng/compile.js#L1767
    // If you want to debug an application with angular related information in
    // production environemnt, simply open up your console, and type `angular.reloadWithDebugInfo()`
    // and waits for your current page to reload
    if (true) {
        $compileProvider.debugInfoEnabled(false);
    }
    $compileProvider.cssClassDirectivesEnabled(false); // https://github.com/angular/angular.js/blob/master/src/ng/compile.js#L1892
    $compileProvider.commentDirectivesEnabled(false); // https://github.com/angular/angular.js/blob/master/src/ng/compile.js#L1863
}]);

if (!window.prefetch) {
    window.beacon('info', ['angular_bootstrap_start']);
    angular.bootstrap(document.body, ['app']);
    window.beacon('info', ['angular_bootstrap_end']);
    __webpack_require__("./js/app.js");
}

/***/ }),

/***/ "./js/lib/contingency.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _integration = __webpack_require__("./js/lib/integration.js");

var _miniBrowser = __webpack_require__("./js/lib/miniBrowser.js");

var _index = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$contingencyHandler', function () {
    function showGenericError(code) {
        return function () {
            var encoded = code ? window.btoa(code) : code;

            _uiRouter.$state.go('checkout.genericError', {
                code: encoded
            });
        };
    }

    function route(path) {
        return function () {
            _uiRouter.$state.go(path, { message: arguments[0] });
        };
    }

    function forbidden(err) {
        throw new _squid.$Forbidden(err);
    }

    function fallback(product) {
        return function (err) {
            throw new _squid.$FallbackError({
                reason: err,
                product: product
            });
        };
    }

    function addMissingTokens(urlQuery) {
        var payload = {
            'token': _angular.$rootScope.token || _squid.$meta.token
        };

        if (_squid.$meta.baToken) {
            payload.ba_token = _squid.$meta.baToken;
        }
        return _squid.$util.queryStringSplice(urlQuery, payload);
    }

    function handleStepupAuth(code, authModel, step_up_context) {
        authModel.stepupAuthRequired = true;

        var reasons = {
            VERIFY_USER_IDENTITY: 'step_up_auth_needed',
            PAYER_AUTHENTICATION_REQUIRED: 'login_required'
        };

        if (authModel.remembered) {
            _logger.$logger.debug('PLANNING_STEP_UP_REMEBERED_USER');
            authModel.logout().then(function () {
                _uiRouter.$state.go('checkout.login', {
                    targetPage: 'ONETOUCH_GENERIC_ERROR',
                    source: 'FRESH_START'
                });
            });
        } else if (step_up_context && !_angular2['default'].isObject(step_up_context)) {
            _logger.$logger.debug('PLANNING_STEP_UP_LOGIN_USER_TEST_TRAFFIC');
            var authChallengeNodeUrl = _squid.$config.urls.authChallengeNodeUrl;

            if (_squid.$config.deploy.isLocal() || _squid.$config.deploy.isStage()) {
                var hostname = _squid.$meta.stage ? _squid.$meta.stage : _angular.$location.host();

                authChallengeNodeUrl = authChallengeNodeUrl.replace('www.paypal.com', hostname);
            }

            authChallengeNodeUrl = _squid.$util.buildURL(authChallengeNodeUrl, {
                stepupContext: step_up_context,
                stsReturnUrl: _squid.$config.ulMeta.stsReturnUrl,
                returnUri: _squid.$config.ulMeta.authChallengeReturnUri + addMissingTokens(_angular.$window.location.search) + '&atoSuccess',
                locale: _squid.$locale.lang,
                flowId: 'xo',
                flowContext: 'funding'
            });

            if (authChallengeNodeUrl) {
                _squid.$util.redirect(authChallengeNodeUrl);
            }
        } else {
            _logger.$logger.debug('PLANNING_STEP_UP_LOGIN_USER_CONTROL_TRAFFIC');
            throw new _squid.$FallbackError({
                reason: reasons[code],
                product: 'ux'
            });
        }
    }

    return function (contingency) {
        // Leave a footprint here. The subsequent state where log how it goes..
        _logger.$logger.warn('contingency_handler', contingency);

        return contingency.handle({
            // Route
            ECONSENT_REQUIRED: route('checkout.econsent'),
            TRAVEL_RULE_ID_REQUIRED: route('checkout.travelRule'),
            INSTANT_FUNDING_SOURCE_UPSELL_NEEDED: route('checkout.pageAddCardMeft.addCardFlow.addCard'),
            ELV_DECLINE: route('checkout.pageAddCard.addCardFlow.addCard'),
            NEED_CREDIT_CARD: route('checkout.pageAddCard.addCardFlow.addCard'),
            NEED_CONFIRMED_CARD: route('checkout.pageAddCard.addCardFlow.addCard'),
            NEED_AUTHENTICATED_CARD: route('checkout.updateCard.addCardFlow.addCard'),
            NEED_CREDIT_CARD_OR_BANK_ACCOUNT: route('checkout.pageAddFi.bank.add'),
            EXPIRED_CREDIT_CARD: route('checkout.updateCard.addCardFlow.addCard'),
            NEGATIVE_BALANCE_RECOVERY: route('checkout.negativeBalanceRecovery'),
            PHONE_NUMBER_REQUIRED: route('checkout.addPhone'),
            SEPA_MANDATE_ACCEPTANCE_NEEDED: route('checkout.review'),
            TAX_ID_REQUIRED: route('checkout.addTaxId'),
            NEED_SHIPPING_ADDRESS: route('checkout.pageAddShipping.addShipping'),

            NEED_DEBIT_CARD: route('checkout.pageAddCard.addCardFlow.addCard'),
            EXPIRED_DEBIT_CARD: route('checkout.updateCard.addCardFlow.addCard'),

            PAYER_AUTHENTICATION_REQUIRED: function PAYER_AUTHENTICATION_REQUIRED() {
                _uiRouter.$state.go('checkout.login', {
                    targetPage: 'PAYER_AUTHENTICATION_REQUIRED'
                });
            },

            // Generic Error Pages
            RESTRICTED_USER: showGenericError('RESTRICTED_USER'),
            PAYER_ACCOUNT_RESTRICTED: showGenericError('RESTRICTED_USER'),
            PAYEE_BLOCKED_TRANSACTION: showGenericError('PAYMENT_DENIED'),
            PAYMENT_ALREADY_DONE: showGenericError('PAYMENT_ALREADY_DONE'),
            DUPLICATE_INVOICE_ID: showGenericError('DUPLICATE_INVOICE_ID'),
            PAYMENT_DENIED: showGenericError('PAYMENT_DENIED'),
            PAYEE_ACCOUNT_RESTRICTED: showGenericError('PAYEE_ACCOUNT_LOCKED_OR_CLOSED'),
            INVALID_RESOURCE_ID: showGenericError('INVALID_RESOURCE_ID'),
            EXPIRED_SESSION: showGenericError('EXPIRED_SESSION'),
            PAYER_CANNOT_PAY: showGenericError('PAYER_CANNOT_PAY'),
            TRANSACTION_RECEIVING_LIMIT_EXCEEDED: showGenericError('PAYER_CANNOT_PAY'),
            PAYER_COUNTRY_NOT_ALLOWED: showGenericError('PAYER_COUNTRY_NOT_ALLOWED'),
            PAYER_COUNTRY_NOT_ALLOWED_DCF: showGenericError('HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF'),
            PAYER_COUNTRY_NOT_ENABLED: showGenericError('PAYER_COUNTRY_NOT_ENABLED'),
            PAYER_LOGIN_COUNTRY_NOT_ALLOWED: showGenericError('PAYER_LOGIN_COUNTRY_NOT_ALLOWED'),
            GAMING_FUNDING_SOURCE_VALIDATION_FAILED: showGenericError('GAMING_FUNDING_SOURCE_VALIDATION_FAILED'),
            COMPLIANCE_VIOLATION: showGenericError('COMPLIANCE_VIOLATION'),
            DOMESTIC_TRANSACTION_REQUIRED: showGenericError('DOMESTIC_TRANSACTION_REQUIRED'),
            INTERNAL_SERVICE_ERROR: showGenericError('TRANSACTION_REFUSED'),
            NEGATIVE_BALANCE_TRANSACTION_REFUSED: showGenericError('NEGATIVE_BALANCE_TRANSACTION_REFUSED'),
            ACCOUNT_CANNOT_BE_FETCHED: showGenericError('ACCOUNT_CANNOT_BE_FETCHED'),
            BAD_RESPONSE: showGenericError('DEFAULT'),
            TRANSACTION_REFUSED_LEGACY_FALLBACK: showGenericError('TRANSACTION_REFUSED'),
            RISK_DENIED: showGenericError('TRANSACTION_REFUSED'),
            UNSUPPORTED_COUNTRY: showGenericError('UNSUPPORTED_COUNTRY'),
            AGREEMENT_ALREADY_CREATED: showGenericError('AGREEMENT_ALREADY_CREATED'),
            PAYMENT_NOT_APPROVED_FOR_EXECUTION: showGenericError('DEFAULT'),
            PAYER_ACCOUNT_LOCKED_OR_CLOSED: showGenericError('DEFAULT'),
            WALLET_PREFERENCE_SET_ERROR: showGenericError('DEFAULT'),
            ISSUANCE_PIN_SERVICE_ERROR: showGenericError('DEFAULT'),
            SENDING_LIMIT_EXCEEDED: showGenericError('SENDING_LIMIT_EXCEEDED'),
            PAYEE_ACCOUNT_LOCKED_OR_CLOSED: showGenericError('PAYEE_ACCOUNT_LOCKED_OR_CLOSED'),
            UNSUPPORTED_PAYEE_CURRENCY: showGenericError('UNSUPPORTED_PAYEE_CURRENCY'),
            PAYMENT_CANNOT_BE_INITIATED: showGenericError('DEFAULT'),
            PERMISSION_DENIED: showGenericError('DEFAULT'),
            INVALID_TOKEN: showGenericError('DEFAULT'),
            INVALID_FUNDING_OPTION: showGenericError('DEFAULT'),
            VALIDATION_ERROR: showGenericError('DEFAULT'),
            SHIPPING_ADDRESS_INVALID: showGenericError('DEFAULT'),
            INVALID_ARGUMENT: showGenericError('DEFAULT'),
            CREDIT_PAYMENT_NOT_ALLOWED: showGenericError('DEFAULT'),
            MALFORMED_REQUEST: showGenericError('DEFAULT'),
            TWOFA_INACTIVE: showGenericError('DEFAULT'),
            ERROR: showGenericError('DEFAULT'),
            ISSUER_DECLINE: showGenericError('DEFAULT'),
            UNSUPPORTED_CUP_SECURECARD: showGenericError('DEFAULT'),
            STUDENT_ACCOUNT: showGenericError('STUDENT_ACCOUNT'),
            UAL_ISSUANCE_UPDATE_SCOPE_ERROR: showGenericError('DEFAULT'),
            // Forbidden
            BUYER_NOT_SET: forbidden,

            // Other
            TRANSACTION_REFUSED: function TRANSACTION_REFUSED(message, data) {
                var clearedRT = data.clearedRT;

                if (clearedRT) {
                    _logger.$logger.info('checkout_fpti', {
                        from: 'CONTINGENCY',
                        to: 'process_fallback',
                        routing_reason: 'TRANSACTION_REFUSED'
                    });
                }

                // always go to generic error page, even if logout fails
                _index.$AuthModel.instance().logout()['finally'](showGenericError('TRANSACTION_REFUSED'));
            },

            PAYER_INVALID_FOR_PAYMENT: function PAYER_INVALID_FOR_PAYMENT() {
                // Payer is not same payer checkout session was created for.
                return _index.$AuthModel.instance().logout()['finally'](function () {
                    return _uiRouter.$state.go('checkout.login', {}, {
                        reload: true
                    });
                });
            },

            CANNOT_PAY_SELF: function CANNOT_PAY_SELF() {
                _index.$AuthModel.instance().meta.selfPay = true;
                _angular.$rootScope.contingency = {};
                _angular.$rootScope.contingency.message = 'CANNOT_PAY_SELF';

                return _index.$AuthModel.instance().logout()['finally'](function () {
                    return _uiRouter.$state.go(_uiRouter.$state.current, {}, {
                        reload: true
                    });
                });
            },

            VERIFY_USER_IDENTITY: function VERIFY_USER_IDENTITY(message, data) {
                var clearedRT = data.clearedRT;

                if (clearedRT) {
                    _logger.$logger.info('checkout_fpti', {
                        from: 'CONTINGENCY',
                        to: 'process_fallback',
                        routing_reason: 'VERIFY_USER_IDENTITY'
                    });
                }

                return handleStepupAuth('VERIFY_USER_IDENTITY', _index.$AuthModel.instance(), data.step_up_context);
            },

            LOGIN_CONTINGENCY: function LOGIN_CONTINGENCY() {
                if (_integration.$integration.getConfig('CAN_FRAMEBUST')) {
                    return _miniBrowser.$miniBrowser.frameBust(_angular.$rootScope.token);
                }

                return fallback('ux');
            },

            DEFAULT: function logUnhandledContingency() {
                _logger.$logger.warn('ui_unhandled_contingency_' + this.message);
                throw new _squid.$FallbackError({
                    reason: 'unhandled_contingency',
                    product: 'ux'
                });
            }
        });
    };
});

_uiRouter.$state;

_logger.$logger;

_squid.$config;

_squid.$FallbackError;

_squid.$Forbidden;

_squid.$locale;

_squid.$meta;

_squid.$util;

_integration.$integration;

_miniBrowser.$miniBrowser;

_index.$AuthModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "js/lib", "js/lib/contingency.js"))

/***/ }),

/***/ "./js/lib/cplIntegration.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

try {
    var token = window.meta.token;

    _angular.$q.all([_checkout.$CheckoutAppDataModel.instance(token).retrieve(), _checkout.$CheckoutCartModel.instance(token).retrieve()]).then(function (_ref) {
        var appData = _ref[0],
            cart = _ref[1];

        if (appData.is_wps_flow()) {
            window.fptiProductOverride = 'wps';
        } else if (cart.isBilling()) {
            window.fptiProductOverride = 'billing';
        }
    })['catch'](function (e) {
        console.error(e);
    });
} catch (e) {
    console.error(e);
}

_angular.$q;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "./js/lib/error.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$forbiddenHandler = $forbiddenHandler;
exports.$exceptionHandler = $exceptionHandler;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _fallback = __webpack_require__("./js/lib/fallback.js");

var _contingency = __webpack_require__("./js/lib/contingency.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

// ui-router rejects $state.go promises if the navigation is cancelled.
var uiRouterTransitionErrors = ['transition prevented', 'transition aborted', 'transition superseded'];

function canBeSafelyIgnored(err) {
    return err instanceof _squid.$ShortCircuit || uiRouterTransitionErrors.includes(err.message);
}

function constructEventName(toState, fromState) {
    var from = fromState.name.replace(/\./g, '_') || 'start';
    var to = toState.name.replace(/\./g, '_') || 'end';

    return 'state_change_' + from + '_to_' + to;
}

function constructErrorPayload(_ref) {
    var err = _ref.err,
        message = _ref.message,
        cause = _ref.cause;

    var payload = {
        error: err.stack || err.toString(),
        message: message || err.message,
        cause: cause && cause.toString(),
        state: _uiRouter.$state.current.name,
        url: window.location.toString()
    };

    angular.extend(payload, err.payload || {});

    return payload;
}

function $forbiddenHandler(err) {
    _logger.$logger.warn('forbidden_handler');
    if (!err.transient) {
        _index.$AuthModel.instance().invalidate();

        if (_angular.$rootScope.paymentComplete) {
            throw new _squid.$Contingency('PAYMENT_ALREADY_DONE');
        }

        _uiRouter.$state.go('checkout.login');
    }
}

function handleThirdPartyErrors(err, cause) {
    var errType = (err && err.constructor && err.constructor.name || 'error').toLowerCase();
    var experience = _thirdPartyInfo.thirdPartyExperience.getExperience(_angular.$rootScope.token);
    var errName = 'ui_' + experience.toLowerCase() + '_' + errType;
    var payload = constructErrorPayload({ err: err, cause: cause });

    _logger.$logger.error(errName, payload);
    _index.$AuthModel.instance().logout();
    _thirdPartyInfo.thirdPartyExperience.resetThirdPartyExperience();

    if (experience === 'VENMO_EXPERIENCE') {
        _uiRouter.$state.go('checkout.login', { venmoError: true });
    }

    if (experience === 'BAIDU_EXPERIENCE') {
        _uiRouter.$state.go('checkout.login', { baiduError: true });
    }
}

function isThirdPartyFlow() {
    return _thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(_angular.$rootScope.token);
}

var ERROR_HANDLERS = [{
    type: _squid.$FallbackError,
    handler: _fallback.$fallbackErrorHandler
}, {
    type: _squid.$Contingency,
    handler: _contingency.$contingencyHandler
}, {
    type: _squid.$Forbidden,
    handler: $forbiddenHandler
}];

function $exceptionHandler(err, cause) {
    if (canBeSafelyIgnored(err)) {
        if (err.message) {
            _logger.$logger.info(err.message);
        }
        return true;
    }

    if (_angular.$rootScope.ERROR_STATE) {
        if (_angular.$rootScope.ERROR_PREVENTED) {
            throw err;
        }

        return;
    }

    if (isThirdPartyFlow()) {
        if (err instanceof _squid.$Forbidden) {
            // forbidden errors should take you to login page
            return $forbiddenHandler(err);
        } else {
            return handleThirdPartyErrors(err, cause);
        }
    }

    var handled = _squid.$util.some(ERROR_HANDLERS, function (errorHandler) {
        if (err instanceof errorHandler.type) {
            errorHandler.handler(err);

            return true;
        }
    });

    if (handled) {
        return;
    } else if (!err.transient) {
        _angular.$rootScope.ERROR_STATE = err;
    }

    var errType = (err.constructor.name || 'error').toLowerCase();
    var errName = 'ui_unhandled_' + errType;
    var errMsg = err.message || '';

    if (errMsg.indexOf('infdig') > -1) {
        errName = 'infinite_digest';
    } else if (errMsg.indexOf('inprog') > -1) {
        errName = 'digest_inprog';
    } else if (errMsg.indexOf('badparse') > -1) {
        errName = 'sanitize_badparse';
    } else if (errMsg.match(/^[\w_]+$/)) {
        errName = 'ui_unhandled_' + errMsg;
    }

    if (['ui_unhandled_error', 'ui_unhandled_typeerror'].indexOf(errName) > -1) {
        if (err.stack && err.stack.indexOf('framework') > -1 && err.stack.indexOf('main.js') === -1) {
            errName = 'ui_unhandled_framework_error';
        }
    }

    if (err.transient) {
        errName += '_transient';
    }

    var payload = constructErrorPayload({ err: err, message: errMsg, cause: cause });

    _logger.$logger.error(errName, payload);
    _logger.$logger.error('build_' + _squid.$meta.buildId + '_' + errName, payload); // release vs live traffic separation

    // emit the error object for subscribers like xo-tracking
    var event = _angular.$rootScope.$emit('unhandled_error', {
        err: err,
        route: (_uiRouter.$state || {}).current,
        message: payload.error,
        code: payload.cause
    });

    if (event.defaultPrevented) {
        _angular.$rootScope.ERROR_PREVENTED = true;
        throw err;
    } else if (!err.transient) {
        return (0, _fallback.$fallbackErrorHandler)(new _squid.$FallbackError({
            reason: errName
        }));
    }
}

_angular.$rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, err) {
    // Set prevent default to avoid angular UI router to keep looping back to same state
    event.preventDefault();
    $exceptionHandler(err, constructEventName(toState, fromState));
});

_angular.$rootScope.$on('$windowError', function (event, details) {
    _logger.$logger.error('window_error', details, {
        unique: true
    });
});

angular.value("$forbiddenHandler", $forbiddenHandler);
angular.value("$exceptionHandlerLazy", $exceptionHandler);
_uiRouter.$state;

_angular.$rootScope;

_logger.$logger;

_index.$AuthModel;

_squid.$util;

_squid.$FallbackError;

_squid.$Forbidden;

_squid.$ShortCircuit;

_squid.$Contingency;

_squid.$meta;

_fallback.$fallbackErrorHandler;

_contingency.$contingencyHandler;

_thirdPartyInfo.thirdPartyExperience;

/***/ }),

/***/ "./js/lib/fallback.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _util = __webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");

var _icFallback = __webpack_require__("./js/lib/icFallback.js");

var _integration = __webpack_require__("./js/lib/integration.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$fallbackErrorHandler', function () {
    return function (err) {
        var reason = err && err.reason;
        var entry_point = err && err.entryPoint;
        var params = err && err.params;
        var model = {};
        var product = err && err.product;
        var isWpsSubscription = void 0;

        function getFallbackUrl(urlParams, waType) {
            if (_angular.$rootScope.wps || _angular.$rootScope.invoice) {
                return (0, _squid.$populate)(model, {
                    checkoutAppData: _index.$CheckoutAppDataModel.instance(_squid.$meta.token)
                }).then(function () {
                    // defaulting for now to ensure backward compatibility
                    var base = _squid.$config.urls.fallbackUrl['buyNow'];

                    if (model.checkoutAppData.flags.is_cart_upload_flow || waType === 'CartUpload' || waType === 'AddToCart' || model.checkoutAppData.flags.is_shopping_cart_flow || waType === 'ShoppingCart') {
                        base = _squid.$config.urls.fallbackUrl['cartUpload'];
                    }

                    if (model.checkoutAppData.flags.is_invoice_flow) {
                        urlParams.id = model.checkoutAppData.invoice_id;
                        base = _squid.$config.urls.fallbackUrl['invoice'];
                    }

                    if (isWpsSubscription) {
                        base = _squid.$config.urls.fallbackUrl['wpsSubscription'];
                    }

                    return _squid.$util.paypalURL(base, urlParams);
                });
            } else {
                return _angular.$q.when().then(function () {
                    var base = _squid.$config.urls.fallbackUrl[product];

                    return _squid.$util.paypalURL(base, urlParams);
                });
            }
        }

        function showGenericErrorPage(errorReason) {
            if (_angular.$rootScope.partnerIntegration) {
                _logger.$logger.info('partner_integration_fallback_to_genericErrorPage');
            }

            var code = errorReason || reason;

            code = code ? window.btoa(code) : code;

            _uiRouter.$state.go('checkout.genericError', {
                code: code
            });
        }

        function handleFallbackRedirect(url, wpsParams) {
            if (!_squid.$config.fallbackEnabled && !entry_point) {
                return _logger.$log.warn('Fallback inhibited by config', url);
            }

            if (_squid.$config.deploy.isLocal() && !entry_point) {
                return _logger.$log.warn('Fallback inhibited in local mode.', url);
            }

            _logger.$logger.log(product ? 'info' : 'error', 'fallback', {
                reason: reason,
                product: product,
                entry_point: entry_point,
                error_desc: reason,
                from: _angular.$rootScope.currentState || 'fallback',
                to: product ? 'process_fallback_' + product : 'process_fallback'
            });

            _logger.$logger.info('fallback_reason_' + reason, {
                reason: reason
            });
            _logger.$logger.info('build_' + _squid.$meta.buildId + '_fallback_reason_' + reason); // release vs live traffic separation

            if (window.xchild) {
                if (window.opener) {
                    return (0, _icFallback.$incontextFallback)(window, url);
                }

                return _uiRouter.$state.go('checkout.framebust', { action: 'fallback', url: url });
            }

            _angular.$rootScope.$emit('loading');

            if (product === 'ux') {
                // Otherwise we can make a decision based on whether we're in the minibrowser or not
                return _angular.$rootScope.wps && !_angular.$rootScope.invoice ? _util.$ReturnToMerchant.postTo(url, wpsParams) : _util.$ReturnToMerchant.goTo(url);
            }

            // Safe to always return to Aries
            return _squid.$util.redirect(url);
        }

        function doFallback() {
            _squid.$util.assert(reason, 'expected fallback reason');

            product = product || 'ux';

            var urlParams = params || {};

            _angular2['default'].extend(urlParams, {
                token: _squid.$meta.token,
                fallback: 1,
                reason: reason,
                landing: entry_point,
                useraction: _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token).useraction()
            });

            if (_angular.$rootScope.partnerIntegration) {
                urlParams.incontext = '1';
                urlParams.nolegacy = '1';
            } else if (_angular.$rootScope.miniBrowser) {
                urlParams.incontext = '1';
            }

            var wpsParams = void 0;

            if (_angular.$rootScope.wps) {
                wpsParams = _squid.$util.decodeAndParse(_squid.$meta.xclickParams);
                _logger.$logger.info('wps_fallback', {
                    token: _squid.$meta.token,
                    reason: reason
                });
                _logger.$logger.info('wps_fallback_reason_' + reason, {
                    reason: reason
                });
                _logger.$logger.info('build_' + _squid.$meta.buildId + '_wps_fallback_reason_' + reason); // release vs live traffic separation
            }

            var waType = wpsParams && wpsParams.wa_type;

            return getFallbackUrl(urlParams, waType).then(function (url) {
                // Fallback whitelist error reason in config to determine if we should fallback or instead redirect to generic error page.
                var fallbackWhitelist = _squid.$config.fallbackWhitelist;
                var whitelist = fallbackWhitelist && fallbackWhitelist.whitelisted || [];

                // if error reason not in fallback whitelist, try auto-retry
                if (whitelist && whitelist.indexOf(reason) === -1) {
                    var AUTORELOAD_LIMIT = 1; // can be increased later
                    // get auto reload count from params - if present
                    var autoReloadCount = parseInt(_squid.$util.param('arc'), 10);

                    // if falsy (NaN or 0)...
                    if (!autoReloadCount) {
                        // start at zero
                        autoReloadCount = 0;
                    }
                    // if we haven't reloaded _enough_ yet...
                    if (autoReloadCount < AUTORELOAD_LIMIT) {
                        // bump count
                        autoReloadCount++;
                        _logger.$logger.info('checkout_fpti', {
                            'from': 'error_auto_reload',
                            'to': 'restart_hermes_app',
                            'int_error_code': reason
                        });

                        // pass params, so url is augmented
                        _squid.$util.replace({ arc: autoReloadCount });
                    } else {
                        // If auto reload didn't fix the error - redirect to error page with retry option
                        var RETRY_KEY = 'retry_page_shown';
                        var RETRY_PAGE_LIMIT = 3; // Only show the retry page at most 3 times
                        var timesSeen = Number(sessionStorage.getItem(RETRY_KEY));
                        var destination = 'RETRY';
                        var transition_name = 'show_retry_page';

                        // Reset if there's an invalid value for timesSeen for some reason
                        if (!timesSeen || timesSeen < 0) {
                            timesSeen = 0;
                        }

                        // Only try to go to retry page if we're within retry attempts
                        if (timesSeen < RETRY_PAGE_LIMIT) {
                            timesSeen++;
                            sessionStorage.setItem(RETRY_KEY, timesSeen);
                        } else {
                            destination = 'DEFAULT';
                            transition_name = 'show_error_page';
                        }

                        _logger.$logger.info('checkout_fpti', {
                            'from': 'error_auto_reload',
                            'to': transition_name,
                            'enable_refresh_prompt': reason,
                            'int_error_code': reason
                        });
                        return showGenericErrorPage(destination);
                    }
                } else {
                    _logger.$logger.info('fallback_reason_whitelisted', {
                        reason: reason,
                        product: product
                    });
                    handleFallbackRedirect(url, wpsParams);
                }
            });
        }

        if (product === 'error') {
            _logger.$logger.error(reason, {
                url: window.location.href
            });

            var _$config$urls = _squid.$config.urls,
                baseUrl = _$config$urls.baseUrl,
                errorUrl = _$config$urls.errorUrl;


            return _squid.$util.redirect(baseUrl + errorUrl);
        }

        if (_integration.$integration.getConfig('ERROR_AFTER_PAYMENT') && _angular.$rootScope.paymentComplete) {
            // Do not fallback. UX has no context of hermes token and will result in duplicate payment
            _logger.$logger.info('wps_error_after_payment', {
                reason: reason
            });

            return showGenericErrorPage('PAYMENT_ALREADY_DONE');
        }

        var beamPattern = /^BA-[0-9A-Z]{17}$/;
        var isBeamIntegration = _squid.$meta.baToken && beamPattern.test(_squid.$meta.baToken);
        var cartExchangeFailed = isBeamIntegration && beamPattern.test(_squid.$meta.token);

        if (cartExchangeFailed) {
            product = 'ux';
        }

        // For Beam Integration - always show generic Error when cart exchange fails.
        // On successful Cart Exchange - disable fallback until MPWEB supports BA token support.
        if (product === 'ux' && isBeamIntegration && cartExchangeFailed) {
            return showGenericErrorPage();
        }

        return (0, _squid.$populate)(model, {
            checkoutCart: _index.$CheckoutCartModel.instance(_squid.$meta.token),
            checkoutAppData: _index.$CheckoutAppDataModel.instance(_squid.$meta.token)
        }).then(function () {
            isWpsSubscription = model.checkoutAppData.is_wps_subscription_flow();
            var merchantCountry = model.checkoutAppData.merchant.merchant_country;
            var isSecondButtonTxn = model.checkoutAppData.is_second_button_txn;

            // No fallback for Tokenized_Wallet usecases
            if (model.checkoutCart.isWalletTokenization()) {
                return showGenericErrorPage();
            }

            // No fallback for DE second button transactions
            if (merchantCountry === 'DE' && isSecondButtonTxn) {
                return showGenericErrorPage();
            }

            // Do not fallback if appdata flag dictates no fallback
            if (model.checkoutAppData.flags.disable_legacy_fallback) {
                _logger.$logger.error('fallback_inhibited_for_xo_order_tokens');
                return showGenericErrorPage();
            }

            // V.zero - fallback resize before do actual fallback
            if (product === 'ux' && _angular.$rootScope.partnerIntegration) {
                _logger.$logger.info('partner_integration_fallback_to_UX');
                _angular.$window.resizeTo(screen.availWidth, screen.availHeight);
            }

            // default do fallback (not actually fallback) - check doFallback() to understand it better
            return doFallback();
        })['catch'](showGenericErrorPage);
    };
});

_uiRouter.$state;

_logger.$log;

_logger.$logger;

_squid.$config;

_squid.$meta;

_squid.$populate;

_squid.$util;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_util.$ReturnToMerchant;

_icFallback.$incontextFallback;

_integration.$integration;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "js/lib", "js/lib/fallback.js"))

/***/ }),

/***/ "./js/lib/icFallback.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$incontextFallback = $incontextFallback;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

function $incontextFallback(win, url) {
    _angular.$rootScope.$emit('loading');
    window.onbeforeunload = function () {};
    window.onunload = function () {};

    var parent = window.opener || window.parent;

    if (!window.xprops || !window.xprops.fallback) {
        parent.location = url;
        win.close();
        return;
    }

    try {
        var frame = void 0;

        try {
            if (typeof parent.onLegacyFallback === 'function') {
                frame = parent;
            }
        } catch (err) {
            // pass
        }

        if (!frame) {
            for (var i = 0, ii = parent.frames.length; i < ii; i++) {
                try {
                    if (typeof parent.frames[i].onLegacyFallback === 'function') {
                        frame = parent.frames[i];
                        break;
                    }
                } catch (err) {
                    // pass
                }
            }
        }

        if (!frame) {
            parent.location = url;
            win.close();
            return;
        }

        frame.onLegacyFallback(win);

        window.addEventListener('unload', function () {
            var width = 970;
            var height = 900;
            var left = void 0;
            var top = void 0;

            if (window.outerWidth) {
                left = Math.round((window.outerWidth - width) / 2) + window.screenX;
                top = Math.round((window.outerHeight - height) / 2) + window.screenY;
            } else if (window.screen.width) {
                left = Math.round((window.screen.width - width) / 2);
                top = Math.round((window.screen.height - height) / 2);
            }

            window.resizeTo(width, height);
            window.moveTo(left, top);
        });

        win.location = url;
    } catch (err) {
        parent.location = url;
        win.close();
    }

    window.xprops.fallback(url);
}

angular.value("$incontextFallback", $incontextFallback);
_angular.$rootScope;

/***/ }),

/***/ "./js/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _error = __webpack_require__("./js/lib/error.js");

Object.keys(_error).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _error[key];
    }
  });
});

var _fallback = __webpack_require__("./js/lib/fallback.js");

Object.keys(_fallback).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _fallback[key];
    }
  });
});

var _contingency = __webpack_require__("./js/lib/contingency.js");

Object.keys(_contingency).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _contingency[key];
    }
  });
});

var _metaBuilder = __webpack_require__("./js/lib/metaBuilder.js");

Object.keys(_metaBuilder).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _metaBuilder[key];
    }
  });
});

var _middleware = __webpack_require__("./js/lib/middleware.js");

Object.keys(_middleware).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _middleware[key];
    }
  });
});

var _miniBrowser = __webpack_require__("./js/lib/miniBrowser.js");

Object.keys(_miniBrowser).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _miniBrowser[key];
    }
  });
});

var _security = __webpack_require__("./js/lib/security.js");

Object.keys(_security).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _security[key];
    }
  });
});

var _stateChangeListener = __webpack_require__("./js/lib/stateChangeListener.js");

Object.keys(_stateChangeListener).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _stateChangeListener[key];
    }
  });
});

var _cplIntegration = __webpack_require__("./js/lib/cplIntegration.js");

Object.keys(_cplIntegration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _cplIntegration[key];
    }
  });
});

/***/ }),

/***/ "./js/lib/integration.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$CONTEXT = exports.$integration = exports.$FLOWS = undefined;

var _$DEFAULT, _$CONTEXT$FULLPAGE, _$CONTEXT$LIGHTBOX, _$integration$init;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

Object.defineProperty(exports, '$integration', {
    enumerable: true,
    get: function get() {
        return _squid.$integration;
    }
});
Object.defineProperty(exports, '$CONTEXT', {
    enumerable: true,
    get: function get() {
        return _squid.$CONTEXT;
    }
});
var $FLOWS = exports.$FLOWS = {

    // Regular end-to-end checkout flow with one entry and one exit point
    CHECKOUT: 'CHECKOUT',

    // Partner flow [ TODO: FACTOR THIS OUT ]
    PARTNER: 'PARTNER',

    // Incontext lightbox flow
    INCONTEXT_LIGHTBOX: 'INCONTEXT_LIGHTBOX',

    // Incontext popup flow
    INCONTEXT_POPUP: 'INCONTEXT_POPUP',

    // Native checkout flow
    NATIVE_CHECKOUT: 'NATIVE_CHECKOUT',

    // Messenger Integration flow
    MESSENGER_BA_INTEGRATION: 'MESSENGER_BA_INTEGRATION',

    // WPS flow
    WPS: 'WPS',

    // WPS Subscription flow
    WPS_SUBSCRIPTION: 'WPS_SUBSCRIPTION'
};

_squid.$integration.init($FLOWS.CHECKOUT, (_$integration$init = {}, _$integration$init[_squid.$DEFAULT] = (_$DEFAULT = {

    ALLOW_AUTH: true,
    ALLOW_COLLECT_DATA: true,
    ALLOW_ONETOUCH_TOKEN_EXCHANGE: false,
    ALLOW_PAYER_ID_RETURN_PARAM: true,
    DONE_PAGE: false,
    FALLBACK: true,
    REDIRECT_TOP: true,
    REDIRECT_QUERY_PARAM: false,
    POST_MESSAGE_PARENT: false
}, _$DEFAULT[$FLOWS.PARTNER] = {

    FALLBACK: false,
    REDIRECT_TOP: false,
    POST_MESSAGE_PARENT: false
}, _$DEFAULT[$FLOWS.INCONTEXT_LIGHTBOX] = {

    ALLOW_ONETOUCH_TOKEN_EXCHANGE: true,
    POST_MESSAGE_PARENT: true
}, _$DEFAULT[$FLOWS.INCONTEXT_POPUP] = {

    POST_MESSAGE_PARENT: true
}, _$DEFAULT[$FLOWS.WPS] = {
    ALLOW_PAYER_ID_RETURN_PARAM: false,
    DONE_PAGE: true,
    ERROR_AFTER_PAYMENT: true,
    POPULATE_MERCHANT_PREFERENCES: true,
    RETURN_METHOD_BASED_ON_MERCHANT_PREFS: true,
    RETURN_URL_FROM_MERCHANT_PREFS: true,
    SHOW_PAY_NOW_LABEL_ON_REVIEW: true,
    SHOW_SHIPPING_METHOD: true
}, _$DEFAULT[$FLOWS.WPS_SUBSCRIPTION] = {
    ALLOW_PAYER_ID_RETURN_PARAM: false,
    DONE_PAGE: false,
    ERROR_AFTER_PAYMENT: true,
    POPULATE_MERCHANT_PREFERENCES: true,
    RETURN_METHOD_BASED_ON_MERCHANT_PREFS: true,
    RETURN_URL_FROM_MERCHANT_PREFS: true,
    SHOW_PAY_NOW_LABEL_ON_REVIEW: true,
    SHOW_SHIPPING_METHOD: false
}, _$DEFAULT), _$integration$init[_squid.$CONTEXT.FULLPAGE] = (_$CONTEXT$FULLPAGE = {

    CAN_FRAMEBUST: false,
    CAN_FALLBACK_TO_POPUP: false,
    CAN_CLOSE_SELF: false

}, _$CONTEXT$FULLPAGE[$FLOWS.NATIVE_CHECKOUT] = {
    REDIRECT_QUERY_PARAM: true
}, _$CONTEXT$FULLPAGE[$FLOWS.PARTNER] = {
    REDIRECT_QUERY_PARAM: true
}, _$CONTEXT$FULLPAGE), _$integration$init[_squid.$CONTEXT.LIGHTBOX] = (_$CONTEXT$LIGHTBOX = {

    ALLOW_AUTH: false,
    ALLOW_COLLECT_DATA: false,

    CAN_FRAMEBUST: true,
    CAN_FALLBACK_TO_POPUP: true,
    CAN_CLOSE_SELF: false,

    RETURN_FROM_DATA_COLLECTION_POPUP: false,

    REDIRECT_TOP: false

}, _$CONTEXT$LIGHTBOX[$FLOWS.MESSENGER_BA_INTEGRATION] = {

    IS_MESSENGER_BA_INTEGRATION: true

}, _$CONTEXT$LIGHTBOX[$FLOWS.PARTNER] = {

    ALLOW_AUTH: true,
    ALLOW_COLLECT_DATA: true,
    CAN_FALLBACK_TO_POPUP: false,
    POST_MESSAGE_PARENT: false
}, _$CONTEXT$LIGHTBOX), _$integration$init[_squid.$CONTEXT.POPUP] = {
    ALLOW_AUTH: true,
    ALLOW_COLLECT_DATA: true,

    CAN_FRAMEBUST: true,
    CAN_FALLBACK_TO_POPUP: true,
    CAN_CLOSE_SELF: false
}, _$integration$init));

angular.value("$FLOWS", $FLOWS);
_squid.$integration;

_squid.$DEFAULT;

_squid.$CONTEXT;

/***/ }),

/***/ "./js/lib/metaBuilder.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$metaBuilder = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function buildMeta() {
    return {
        token: _angular.$rootScope.token || _squid.$config.token || _squid.$meta.token || _squid.$util.param('token'),
        calc: _model.$CalDataModel.getCalCorrId(),
        csci: _model.$CalDataModel.getUUID(),
        locale: {
            country: _squid.$locale && _squid.$locale.country,
            language: _squid.$locale && _squid.$locale.lang
        },
        state: 'ui_' + (_angular.$rootScope.currentState || 'checkout_init'),
        app_name: 'hermesnodeweb',
        baToken: _squid.$meta.baToken
    };
}

function buildContext() {
    return {
        locale: {
            country: _squid.$locale && _squid.$locale.country,
            language: _squid.$locale && _squid.$locale.lang
        }
    };
}

_squid.$Api.registerMetaBuilder(buildMeta);

var $metaBuilder = exports.$metaBuilder = {
    build: buildMeta,
    buildContext: buildContext
};

angular.value("$metaBuilder", $metaBuilder);
_angular.$rootScope;

_model.$CalDataModel;

_squid.$util;

_squid.$meta;

_squid.$Api;

_squid.$locale;

_squid.$config;

/***/ }),

/***/ "./js/lib/middleware.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _integration = __webpack_require__("./js/lib/integration.js");

var _miniBrowser = __webpack_require__("./js/lib/miniBrowser.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _fn = __webpack_require__("../node_modules/xo-login-components/src/login/fn.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _credit = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

__webpack_require__("./js/lib/stateChangeListener.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$Middleware', function () {
    return [function angularDebug() {
        window.root = _angular.$rootScope;
        window.injector = _angular2['default'].element(document.body).injector();

        /**
         * Config experiment to overwrite the $apply method and use $eval instead of $apply if it would throw a digest inprog error.
         * This is mainly to address a Firefox bug with angular digest and timeouts, where timeouts can interrupt normal execution flow under certain circumstances
         * Bug described here: https://github.com/angular/angular.js/issues/10083
         *
         * Can remove as a config option if this is a stable change
         */
        if (_squid.$config.safeApply) {
            _logger.$logger.info('overwriting_angular_apply');
            var proto = Object.getPrototypeOf && Object.getPrototypeOf(_angular.$rootScope);

            if (!proto) {
                _logger.$logger.warn('overwriting_angular_apply_failed', {
                    reason: 'failed_to_get_prototype'
                });
            } else {
                var originalApply = proto.$apply;
                // If this gets used so many times, something is probably wrong so use original apply instead
                var skipAttempts = 10;

                proto.$apply = function (fn) {
                    if (skipAttempts && (_angular.$rootScope.$$phase === '$digest' || _angular.$rootScope.$$phase === '$apply')) {
                        skipAttempts--;

                        _logger.$logger.warn('inprog_error_skipped', {
                            stack: new Error().stack
                        });

                        this.$eval(fn);
                    } else {
                        originalApply.call(this, fn);
                    }
                };
            }
        }
    }, function waitForToken() {
        if (_squid.$util.isIFrame() && !_squid.$util.param('token') && !_squid.$meta.token) {
            return (0, _angular.$q)(function (resolve, reject) {
                _logger.$logger.info('await_token');

                window.addEventListener('message', function (event) {
                    var message = JSON.parse(event.data);

                    if (message.operation !== 'pass_token') {
                        return;
                    }

                    var token = message.token;

                    _logger.$logger.info('passed_token', { token: token });
                    _squid.$meta.token = token;

                    var $preloadApi = new _squid.$Api({ uri: 'preload' });

                    $preloadApi.retrieve({
                        params: { token: token }
                    }).then(function (response) {
                        $preloadApi.setTransientCache(response.data);
                        resolve();
                    })['catch'](reject);
                }, false);
            });
        }
    }, function checkToken() {
        var pattern = /^EC-[0-9A-Z]{17}$/;
        var beamPattern = /^BA-[0-9A-Z]{17}$/;
        // wps token are not preceeded with 'EC-'
        var wpsPattern = /^[0-9A-Z]{17}$/;
        var urlToken = (_squid.$util.param('token') || '').trim().slice(0, 20);
        var bodyToken = (_squid.$meta.token || '').trim().slice(0, 20);

        if (pattern.test(urlToken)) {
            _angular.$rootScope.token = urlToken;
        } else if (pattern.test(bodyToken)) {
            _angular.$rootScope.token = bodyToken;
        } else if (wpsPattern.test(urlToken)) {
            _logger.$logger.info('isWpsPattern');
            _angular.$rootScope.token = urlToken;
        } else if (wpsPattern.test(bodyToken)) {
            _logger.$logger.info('isWpsPattern');
            _angular.$rootScope.token = bodyToken;
        } else if (beamPattern.test(urlToken)) {
            _angular.$rootScope.token = urlToken;
            _logger.$logger.info('cart_exchange_failed', {
                token: _angular.$rootScope.token
            });
        } else if (beamPattern.test(bodyToken)) {
            _angular.$rootScope.token = bodyToken;
            _logger.$logger.info('cart_exchange_failed', {
                token: _angular.$rootScope.token
            });
        } else {
            return _angular.$q.reject(new _squid.$FallbackError({
                reason: 'no_token',
                product: 'error'
            }));
        }
    }, function resolveLocale() {
        var models = {};

        return (0, _squid.$populate)(models, {
            appData: _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
            cart: _index3.$CheckoutCartModel.instance(_angular.$rootScope.token)
        })['finally'](function () {
            return _squid.$locale.retrieve({
                params: {
                    ipCountry: _squid.$meta.ipcountry,
                    localeTestUrlParam: _squid.$util.param('locale.test'),
                    checkoutShippingCountry: models.cart.get('purchase.shipping_address.country_code'),
                    merchantCountry: models.appData.get('merchant.merchant_country'),
                    checkoutSessionLocale: models.appData.get('merchant.merchant_locale'),
                    countryParam: _squid.$util.param('country.x'),
                    localeParam: _squid.$util.param('locale.x')
                }
            });
        });
    }, function fraudentInit() {
        return _fn.$fn.init();
    }, function setupIntegration() {
        return _miniBrowser.$miniBrowser.init(_angular.$rootScope.token);
    }, function frameBust() {

        if (!_integration.$integration.getConfig('CAN_FRAMEBUST')) {
            return;
        }

        if (_integration.$integration.getConfig('ALLOW_COLLECT_DATA')) {
            return;
        }

        return _miniBrowser.$miniBrowser.frameBust(_angular.$rootScope.token);
    }, function tokenExchange() {
        if (!_integration.$integration.getConfig('ALLOW_ONETOUCH_TOKEN_EXCHANGE')) {
            return;
        }

        if (_angular.$rootScope.isPartnerIntegration || !_squid.$util.isIFrame()) {
            return;
        }

        var auth = _index2.$AuthModel.instance();

        return auth.retrieve().then(function () {
            if (auth.logged_in || auth.remembered || !auth.refresh_token) {
                return;
            }

            return auth.action('onetouch');
        });
    }, function xcomponent() {
        if (window.xchild) {
            window.paypalCheckout = window.xchild;
        }

        if (window.xprops && window.xprops.init) {
            return _angular.$q.all([_index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve(), _index3.$CheckoutPayeeModel.instance(_angular.$rootScope.token).retrieve()]).then(function (_ref) {
                var checkoutAppData = _ref[0],
                    checkoutPayee = _ref[1];

                return window.xprops.init({
                    paymentToken: _angular.$rootScope.token,
                    merchantID: checkoutPayee.merchant.id,
                    cancelUrl: checkoutAppData.urls.cancel_url
                });
            });
        }
    }, function xcomponentAuth() {
        if (window.xprops && window.xprops.onAuth) {
            var auth = _index2.$AuthModel.instance();

            return auth.retrieve().then(function () {
                if (auth.access_token && (auth.logged_in || auth.remembered)) {
                    return window.xprops.onAuth({
                        accessToken: auth.access_token
                    });
                }
            });
        }
    }, function logPage() {
        _logger.$logger.info('href', {
            href: window.location.href,
            windowName: _angular.$window.name && _angular.$window.name.slice(0, 100)
        });

        var match = document.cookie.toString().match(/ectoken=([^;]+)/);

        if (match && match[1] === _angular.$rootScope.token) {
            _logger.$logger.info('returning_user_same_token');
        } else if (match && match[1] !== _angular.$rootScope.token) {
            _logger.$logger.info('returning_user_diff_token');
        } else {
            _logger.$logger.info('non_returning_user');
        }

        document.cookie = 'ectoken=' + _angular.$rootScope.token + '; expires=Fri, 31 Dec 9999 23:59:59 GMT;';

        if (window.performance && window.performance.navigation && _angular2['default'].isDefined(window.performance.navigation.type)) {
            var navigationType = {
                0: 'regular',
                1: 'reload',
                2: 'back_forward'
            }[window.performance.navigation.type];

            if (navigationType) {
                _logger.$logger.info('navigation_' + navigationType);
            }
        }
    }, function handleTagManager() {
        // ****** Tag Manager Code Start Here ***********
        window.dataLayer = {
            // Two letter country code of the current page's content
            contentCountry: _squid.$locale.country.toLowerCase(),
            // Two letter locale
            contentLanguage: _squid.$locale.lang.toLowerCase()
        };

        var tagManagerUrl = _squid.$config.urls.tagProdUrl;

        // Based on the environment, Tag Manager end point can be changed.
        // For now the local and stage end points are same.
        if (_squid.$config.deploy.isLocal() || _squid.$config.deploy.isStage()) {
            tagManagerUrl = _squid.$config.urls.tagStageUrl;
        }

        // Load bootstrap.js asynchronously
        (function (i, s, o, g, r, a, m) {
            i['tagManagerObject'] = r;
            i[r] = i[r] || function () {
                (i[r].q = i[r].q || []).push(arguments);
            };
            i[r].l = 1 * new Date();
            a = s.createElement(o);
            m = s.getElementsByTagName(o)[0];
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m);
        })(window, document, 'script', tagManagerUrl, 'tagManager');
    }, function logoutGuest() {
        var appData = _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token);

        return _index2.$AuthModel.instance().retrieve().then(function (auth) {
            // For DE 2nd button transactions, guest accounts are allowed on return flow
            if (appData.get('merchant.merchant_country') === 'DE' && (appData.get('is_second_button_txn') || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit')) {
                if (_credit.$CreditDataModel.instance(_angular.$rootScope.token).getCapeKey()) {
                    return;
                } else {
                    return auth.action('logout');
                }
            }

            // if venmo transaction, we'll log the buyer back in by sending them back to the venmo app
            if (_thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(_angular.$rootScope.token)) {
                _thirdPartyInfo.thirdPartyExperience.resetThirdPartyExperience(); // removing token from experience flag
                _logger.$logger.info('venmo_login_retry');
            }

            if (auth.guest) {
                _logger.$logger.info('guest_logout');
                return auth.logoutAndRedirect('guest_logout');
            }
        });
    }, function updatePaymentExperience() {
        _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token).action('updatePaymentExperience', {
            data: {
                payment_experience: 'HERMESNODE',
                payment_experience_form_factor: _miniBrowser.$miniBrowser.isMiniBrowser() ? 'IN_CONTEXT' : 'FULL_PAGE'
            },
            silent: true,
            transientError: true
        });
    }, function checkProcessorDecline() {
        return _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve().then(function (appData) {
            if (appData.flags.processor_declined) {
                _logger.$logger.info('processor_decline_transaction');
                var authModel = _index2.$AuthModel.instance();

                if (authModel.auth_state === 'IDENTIFIED' && !_squid.$util.param('redirectToHermes')) {
                    // guest
                    return (0, _squid.$dispatch)('xoon', {
                        token: _angular.$rootScope.token,
                        hermesXoonRedirect: true
                    }, {
                        fromState: 'checkout_init',
                        toState: 'guest',
                        'locale.x': _squid.$locale.lang + '_' + _squid.$locale.country,
                        'country.x': _squid.$locale.country
                    });
                }

                return;
            }
        });
    }, function logStart() {
        return _squid.$promise.hash({
            isMiniBrowser: _miniBrowser.$miniBrowser.isMiniBrowser(),
            isDirectIntegration: _miniBrowser.$miniBrowser.getDirectIntegration(_angular.$rootScope.token),
            isIframe: _miniBrowser.$miniBrowser.isFramed()
        }).then(function (flags) {
            var app_int_type = _index.$DeviceInfo.getAppIntegrationType();

            _logger.$logger.info('app_start_design', {
                'from': 'client_middleware',
                'to': 'process_app_start_design',
                is_directintegration: flags.isDirectIntegration ? 1 : 0,
                is_incontext: flags.isMiniBrowser || flags.isIframe ? 1 : 0,
                app_int_type: app_int_type
            });
        });
    }, function logPerformance() {
        if (window.enablePerformance) {
            var keys = ['connectEnd', 'connectStart', 'domComplete', 'domContentLoadedEventEnd', 'domContentLoadedEventStart', 'domInteractive', 'domLoading', 'domainLookupEnd', 'domainLookupStart', 'fetchStart', 'loadEventEnd', 'loadEventStart', 'navigationStart', 'redirectEnd', 'redirectStart', 'requestStart', 'responseEnd', 'responseStart', 'secureConnectionStart', 'unloadEventEnd', 'unloadEventStart'];
            var timing = {};

            _angular2['default'].forEach(keys, function (key) {
                timing[key] = parseInt(window.performance.timing[key], 10) || 0;
            });

            var offset = timing.connectEnd - timing.navigationStart;

            if (timing.connectEnd && window.clientStartTime) {
                _angular2['default'].forEach(timing, function (time, name) {
                    if (time && _angular2['default'].isNumber(time)) {
                        _logger.$logger.info('timing_' + name, {
                            client_elapsed: time - timing.connectEnd - (window.clientStartTime - offset),
                            req_elapsed: time - timing.connectEnd
                        });
                    }
                });
            }

            _logger.$logger.info('timing', timing);

            if (window.performance.memory) {
                _logger.$logger.info('memory', window.performance.memory);
            }

            if (window.performance.navigation) {
                _logger.$logger.info('navigation', window.performance.navigation);
            }

            if (window.performance.getEntries) {
                var logged = [];
                var logResources = function logResources() {
                    _angular2['default'].forEach(window.performance.getEntries(), function (resource) {
                        if (!resource || !resource.name) {
                            return;
                        }

                        if (logged.indexOf(resource.name) === -1) {
                            logged.push(resource.name);
                        } else {
                            return;
                        }

                        if (resource.initiatorType) {
                            _logger.$logger.info(resource.initiatorType, resource);
                        }
                    });
                };

                logResources();
                setInterval(logResources, 500);
            }

            if (timing.connectEnd && timing.navigationStart && window.clientStartTime) {
                _logger.$logger.info('js_init', {
                    client_elapsed: 0,
                    req_elapsed: window.clientStartTime - offset
                });
            }
        } else {
            _logger.$logger.info('no_performance_data');
        }
    }, function logAuthState() {
        return _index2.$AuthModel.instance().retrieve().then(function (auth) {
            if (auth.logged_in) {
                _logger.$logger.info('user_logged_in');
            } else if (auth.remembered) {
                _logger.$logger.info('user_remembered');
            } else {
                _logger.$logger.info('user_not_logged_in');
            }
        });
    },

    // check for access token in the hash.
    function checkAccessToken() {
        if (window.xprops && window.xprops.accessToken) {
            return window.xprops.accessToken().then(function (accessToken) {
                _squid.$Api.addHeader('x-paypal-internal-euat', accessToken);
                return _index2.$AuthModel.instance().reload();
            });
        }

        var euat = _squid.$util.param('euat');

        if (euat) {
            var accessToken = euat === '1' ? window.location.hash.substr(2) : euat;

            if (accessToken) {
                _logger.$logger.info(euat === '1' ? 'access_token_from_hash' : 'access_token_from_param', {
                    access_token: accessToken
                });

                /* if (euat === '1') {
                    window.location.hash = '';
                } */

                var authModel = _index2.$AuthModel.instance();

                authModel.access_token = accessToken;

                if (window.xprops && window.xprops.onAuth) {
                    window.xprops.onAuth({ accessToken: accessToken });
                }
            }
        }
    },

    // check for FraudNet for Mobile View
    function enableFraudNetForMobileWebView() {
        if (_index.$DeviceInfo.isApp()) {
            return _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve().then(function (appData) {
                return (0, _squid.$pxp)(_squid.$config.ulMeta.hermesnodePxpConfig, {
                    'ctx.COUNTRY': appData.merchant.merchant_country
                }, 'xo_hermesnode_fraudnet_webview_treatment', false, true).then(function (result) {
                    if (result && result.treatment_name) {
                        _angular.$window.enableFraudNetForMobileWebView = true;
                    }
                });
            });
        }
    },

    // Logs if service workers are enabled
    function isServiceWorkerSupported() {
        if ('serviceWorker' in navigator) {
            _logger.$logger.info('service_worker_supported');
        } else {
            _logger.$logger.info('service_worker_not_supported');
        }
    }, function forceCookiesDisabled() {
        if (_index.$DeviceInfo.isApp()) {
            return _index3.$CheckoutPayeeModel.instance(_angular.$rootScope.token).retrieve().then(function (payee) {
                if (~_squid.$config.forceCookiesDisabled.indexOf(payee.merchant.id)) {
                    _logger.$logger.info('force_cookies_disabled');
                    _squid.$Api.forceCookiesDisabled = true;
                }
            });
        }
    }, function checkFramed() {
        if (_squid.$util.isIFrame()) {
            // Set this as "framed" mode (X icon, escape hatch, etc.)
            document.documentElement.className += ' framed';
        }
    }, function loginViaEuat() {
        // log in user via euat prior to rendering login screen.
        if (_squid.$util.param('euat') === '1') {
            var auth = _index2.$AuthModel.instance();

            if (auth.accessToken() && !auth.loggedIn()) {
                return auth.reload({
                    headers: {
                        'x-paypal-internal-euat': auth.accessToken()
                    },
                    resultModel: auth,
                    success: function success() {
                        return delete auth.access_token;
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(name) {
                            throw new _squid.$FallbackError({
                                reason: name.toLowerCase(),
                                product: 'ux'
                            });
                        }
                    }
                });
            }
        }
    }, function logNetworkInfo() {
        /**
         * These logs are currently in place to test coverage
         * of the network information payload from browsers
         * for checkout traffic.
        */
        var netInfo = navigator && navigator.connection;

        if (netInfo) {
            _logger.$logger.info('networkInfo', {
                type: netInfo.type, // Network type that browser uses
                effectiveType: netInfo.effectiveType, // 2g, 3g, wifi , etc
                downlink: netInfo.downlink, // Effective bandwidth estimate
                downlinkMax: netInfo.downlinkMax, // Upper bound on the downlink speed of the first network hop
                roundTripTime: netInfo.rtt, // Effective round-trip time estimate
                saveData: netInfo.saveData // user has requested a reduced data usage mode
            });

            // To test if network logs can be picked up for runtime dashboards
            _logger.$logger.info('networkInfo_effectiveType_' + netInfo.effectiveType);
            _logger.$logger.info('networkInfo_downlink_' + netInfo.downlink);
            _logger.$logger.info('networkInfo_roundTripTime_' + netInfo.rtt);
        } else {
            _logger.$logger.info('no_networkInfo_found');
        }
    }, function logDeviceInfo() {
        var memory = navigator && navigator.deviceMemory;

        /**
         * .5 -> ~ 512 Mib
         * 1 -> ~ 1024 Mib
         * 2 -> ~ 2048 Mib
         * values: 0.25, 0.5, 1, 2, 4, 8
        */
        if (memory) {
            _logger.$logger.info('memoryInfo_' + memory, { memory: memory });
        } else {
            _logger.$logger.info('no_memoryInfo_found');
        }
    }, function checkForSDK() {
        var isSDKintegration = window.name && (window.name.indexOf('xcomponent__ppcheckout') === 0 || window.name.indexOf('zoid__ppcheckout') === 0 || _squid.$util.param('xcomponent') || _squid.$util.param('zoid'));

        var sdkLoaded = window.paypal && window.xprops && window.paypal.Checkout && window.paypal.Checkout.isChild();

        if (isSDKintegration && !sdkLoaded) {
            throw new Error('Checkout loaded in an SDK integration, but no xprops found. Maybe the sdk script failed to load in the child window.');
        }
    }];
});

_logger.$logger;

_integration.$integration;

_miniBrowser.$miniBrowser;

_squid.$Api;

_squid.$Class;

_squid.$config;

_squid.$dispatch;

_squid.$FallbackError;

_squid.$locale;

_squid.$meta;

_squid.$populate;

_squid.$promise;

_squid.$pxp;

_squid.$util;

_index.$DeviceInfo;

_fn.$fn;

_index2.$AuthModel;

_index3.$CheckoutAppDataModel;

_index3.$CheckoutCartModel;

_index3.$CheckoutPayeeModel;

_credit.$CreditDataModel;

_thirdPartyInfo.thirdPartyExperience;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "js/lib", "js/lib/middleware.js"))

/***/ }),

/***/ "./js/lib/miniBrowser.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$miniBrowser = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _util = __webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");

var _integration = __webpack_require__("./js/lib/integration.js");

var _error = __webpack_require__("./js/lib/error.js");

var _$stateGo = _uiRouter.$state.go;

var logStateNotFoundAndThrow = function logStateNotFoundAndThrow(_ref) {
    var name = _ref.name,
        _ref$logName = _ref.logName,
        logName = _ref$logName === undefined ? '' : _ref$logName;

    _logger.$logger.error('state_not_found' + logName, {
        name: name,
        hash: window.location.hash
    });
    throw new Error('state_not_found' + logName + ': ' + name);
};

_uiRouter.$state.go = function (name, params) {
    var _this = this,
        _arguments = arguments;

    var stateObj = _uiRouter.$state.get(name);

    var stateGo = function stateGo(state) {
        if (!window.xchild) {
            return _$stateGo.apply(_this, _arguments);
        }

        if (!state.loginRequired) {
            return _$stateGo.apply(_this, _arguments);
        }

        // If we're allowed to collect data in this integration, we don't need this functionality
        if (_integration.$integration.getConfig('ALLOW_COLLECT_DATA')) {
            return _$stateGo.apply(_this, _arguments);
        }

        var forceIframe = window.paypal && window.paypal.forceIframe && window.paypal.forceIframe();

        if (forceIframe) {
            return _$stateGo.apply(_this, _arguments);
        }

        // First check our integration supports falling back to a popup
        if (!_integration.$integration.getConfig('CAN_FALLBACK_TO_POPUP')) {
            throw _integration.$integration.error('Can not fallback to popup for data collection');
        }

        window.xchild.hide();

        var url = window.location.href.split('#')[0] + '#/' + state.name.replace(/\./g, '/');
        var xprops = _extends({}, window.xprops);

        xprops.url = url;

        window.ppxo.Checkout.renderPopupTo(window.xchild.getParentRenderWindow(), xprops)['catch'](function (err) {

            if (window.ppxo.PopupOpenError && err instanceof window.ppxo.PopupOpenError) {
                window.xchild.show();

                _logger.$logger.warn('framebust_from_' + name.replace(/[^a-zA-Z0-9]+/g, '_'));

                return _$stateGo.call(_this, 'checkout.framebust', { action: 'open', url: url });
            }

            (0, _error.$exceptionHandler)(err);
        });
    };

    if (stateObj) {
        return stateGo(stateObj);
    } else if (_squid.$meta.codeSplitting) {
        // in case of code split - attempt to load route and then change the state
        return (0, _squid.lazyLoadRoute)(name, params, false)['catch'](function () {
            logStateNotFoundAndThrow({ name: name, logName: '_lazy_loading' });
        }).then(function () {
            stateObj = _uiRouter.$state.get(name);
            return stateGo(stateObj);
        });
    } else {
        logStateNotFoundAndThrow({ name: name });
    }
};

var $miniBrowser = exports.$miniBrowser = {
    flags: {},
    config: {},
    isMiniBrowser: function isMiniBrowser() {
        return window.name && window.name.indexOf('PPFrame') === 0 && _squid.$util.isPopup() || _squid.$util.param('incontext') === '1' || window.xchild && _squid.$util.isPopup();
    },
    isFramed: function isFramed() {
        return _squid.$util.isIFrame();
    },
    getPartnerIntegration: function getPartnerIntegration(token) {
        return _squid.$promise.call(function () {
            if (window.name === 'PPFrameRedirect' || _squid.$util.param('nolegacy') === '1') {
                return true;
            }
            return _checkout.$CheckoutCartModel.instance(token).retrieve().then(function (cart) {
                return Boolean(cart.partnerIntegration);
            });
        });
    },
    getNativeCheckoutIntegration: function getNativeCheckoutIntegration(token) {
        return _squid.$promise.call(function () {
            if (_squid.$util.param('native_xo') === '1') {
                return true;
            }
            return false;
        });
    },
    getMessengerBAIntegration: function getMessengerBAIntegration(token) {
        return _squid.$promise.call(function () {
            if (window.xprops && window.xprops.experience && window.xprops.experience.messenger) {
                _logger.$logger.info('getMessengerBAIntegration == true');
                return true;
            }
            return false;
        });
    },
    getDirectIntegration: function getDirectIntegration(token) {
        return _squid.$promise.call(function () {
            if (_squid.$util.param('incontext')) {
                return true;
            }

            if (this.isMiniBrowser() || this.isFramed()) {
                return true;
            }

            if (window.location.pathname.indexOf('/checkoutnow') > -1 || window.location.pathname.indexOf('/webapps/hermes') > -1) {
                return true;
            }

            return this.getPartnerIntegration(token);
        }.bind(this));
    },
    getWPSIntegration: function getWPSIntegration(token) {
        return _checkout.$CheckoutAppDataModel.instance(token).retrieve().then(function (appData) {
            var isWPS = appData.is_wps_flow();

            // TODO: remove these, we should not use $rootScope
            _angular.$rootScope.invoice = appData.flags.is_invoice_flow;
            _angular.$rootScope.wps = isWPS;

            if (isWPS) {
                _logger.$logger.info('hermes_wps_flow', {
                    token: _angular.$rootScope.token
                });
            } else {
                _logger.$logger.info('hermes_xo_order_flow', {
                    token: _angular.$rootScope.token
                });
            }
            return isWPS;
        });
    },

    getWpsSubscriptionIntegration: function getWpsSubscriptionIntegration(token) {
        return _checkout.$CheckoutAppDataModel.instance(token).retrieve().then(function (appData) {
            return appData.is_wps_subscription_flow();
        });
    },

    getFlags: function getFlags(token) {
        _logger.$logger.info('miniBrowser_getFlags');
        return _squid.$promise.hash({
            isMiniBrowser: this.isMiniBrowser(),
            isFramed: this.isFramed(),
            isPartnerIntegration: this.getPartnerIntegration(token),
            isDirectIntegration: this.getDirectIntegration(token),
            isNativeCheckout: this.getNativeCheckoutIntegration(token),
            isMessengerBAIntegration: this.getMessengerBAIntegration(token),
            isWPSIntegration: this.getWPSIntegration(token),
            isWpsSubscription: this.getWpsSubscriptionIntegration(token)
        }).then(function (flags) {

            // TODO: Remove these, we should not use $rootScope
            _angular.$rootScope.miniBrowser = flags.isMiniBrowser;
            _angular.$rootScope.partnerIntegration = flags.isPartnerIntegration;

            if (flags.isPartnerIntegration && !window.xchild) {
                _integration.$integration.setFlow(_integration.$FLOWS.PARTNER);
            } else if (flags.isFramed) {
                _integration.$integration.setFlow(_integration.$FLOWS.INCONTEXT_LIGHTBOX);
                if (flags.isMessengerBAIntegration) {
                    _integration.$integration.setFlow(_integration.$FLOWS.MESSENGER_BA_INTEGRATION);
                    _logger.$logger.info('$integration.setFlow($FLOWS.MESSENGER_BA_INTEGRATION)');
                }
            } else if (flags.isMiniBrowser) {
                _integration.$integration.setFlow(_integration.$FLOWS.INCONTEXT_POPUP);
            } else if (flags.isNativeCheckout) {
                _integration.$integration.setFlow(_integration.$FLOWS.NATIVE_CHECKOUT);
            } else if (flags.isWpsSubscription) {
                _integration.$integration.setFlow(_integration.$FLOWS.WPS_SUBSCRIPTION);
            } else if (flags.isWPSIntegration) {
                _integration.$integration.setFlow(_integration.$FLOWS.WPS);
            } else {
                _integration.$integration.setFlow(_integration.$FLOWS.CHECKOUT);
            }

            return flags;
        });
    },
    init: function init(token) {
        var _this2 = this;

        _logger.$logger.info('miniBrowser_init');
        return _squid.$promise.sequential([function () {
            return _this2.enableAutoResize();
        }, function () {
            return _this2.getFlags(token);
        }, function () {
            return _this2.logIntegration(token);
        }, function () {
            return _this2.sendPostMessage(token);
        }, function () {
            return _this2.handleWindowOpenerClose();
        }]);
    },
    enableAutoResize: function enableAutoResize() {
        _angular.$rootScope.$on('allLoaded', function () {
            if (window.xchild && window.xchild.enableAutoResize) {
                window.xchild.enableAutoResize();
            }
        });
    },
    logIntegration: function logIntegration(token) {
        _logger.$logger.info('miniBrowser_logIntegration');
        return this.getFlags(token).then(function (flags) {
            var match = window.name.match(/PPFrame(\w+)/);
            var guid = match && match[1];

            if (guid) {
                _logger.$logger.info('integration_guid', {
                    guid: guid
                });
            }

            if (window.xchild || guid) {
                var beacon = new Image();

                beacon.src = '/webapps/hermes/api/logger?event=ppxo_uid_token&uid=' + (window.xprops ? window.xprops.uid : guid) + '&token=' + token;
            }

            _logger.$logger.info(flags.isMiniBrowser ? 'minibrowser_flow' : 'non_minibrowser_flow');
            _logger.$logger.info(flags.isFramed ? 'framed_flow' : 'non_framed_flow');
            _logger.$logger.info(flags.isDirectIntegration ? 'direct_integration_flow' : 'non_direct_integration_flow');
            _logger.$logger.info(flags.isPartnerIntegration ? 'partner_integration_flow' : 'non_partner_integration_flow');
        });
    },

    handleWindowOpenerClose: function handleWindowOpenerClose() {
        _logger.$logger.info('miniBrowser_handleWindowOpenerClose');
        if (_integration.$integration.isContext(_integration.$CONTEXT.POPUP)) {
            var interval = setInterval(function () {
                try {
                    if (!window.opener || window.opener.closed) {
                        clearInterval(interval);
                        _logger.$logger.info('window_opener_closed');
                        // TODO: close this window if opener closed?
                    }
                } catch (err) {
                    // pass
                }
            }, 50);
        }
    },

    sendPostMessage: function sendPostMessage(token) {
        if (window.xchild) {
            return;
        }

        return _squid.$promise.hash({
            isPartnerIntegration: this.getPartnerIntegration(token),
            checkoutAppData: _checkout.$CheckoutAppDataModel.instance(token).retrieve()
        }).then(function (data) {
            if (!_integration.$integration.getConfig('POST_MESSAGE_PARENT')) {
                return;
            }

            var msg = void 0;

            try {
                msg = {
                    operation: 'init',
                    cancelUrl: data.checkoutAppData.urls.cancel_url,
                    landingUrl: window.location.href,
                    secureWindowmsg: _squid.$locale.content.scripts.secureWindowmsg
                };
            } catch (err) {
                return _logger.$logger.error('minibrowser_msg_construction_failed', {
                    error: err
                });
            }

            if (!_util.$ReturnToMerchant.postToMerchant(msg)) {
                _logger.$logger.error('minibrowser_post_failed');
            }
        });
    },
    frameBust: function frameBust(token) {
        return _squid.$promise.hash({
            isFramed: this.isFramed()
        }).then(function (flags) {
            if (!flags.isFramed) {
                return;
            }

            var forceIframe = window.paypal && window.paypal.forceIframe && window.paypal.forceIframe();

            if (forceIframe) {
                return;
            }

            if (window.xchild) {
                _logger.$logger.info('frame_bust_xchild');
                _uiRouter.$state.go('checkout.framebust', { action: 'open', url: window.location.href.split('#')[0] });
            } else {
                _logger.$logger.info('frame_bust');
                _squid.$util.redirect(window.location.href, { frameBust: true });
            }
        });
    }
};

angular.value("$miniBrowser", $miniBrowser);
_uiRouter.$state;

_angular.$rootScope;

_logger.$logger;

_squid.$promise;

_squid.$util;

_squid.$locale;

_squid.$meta;

_squid.lazyLoadRoute;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;

_util.$ReturnToMerchant;

_integration.$integration;

_integration.$FLOWS;

_integration.$CONTEXT;

_error.$exceptionHandler;

/***/ }),

/***/ "./js/lib/security.js":
/***/ (function(module, exports, __webpack_require__) {



var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _index = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().run(function () {
    var errorCount = 0;

    _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        var auth = _index.$AuthModel.instance();

        if (toState.auth !== false && !auth.logged_in) {
            errorCount += 1;
            if (errorCount === 10) {
                _logger.$logger.error('max_state_requires_auth');
            }
            if (errorCount >= 10) {
                return;
            }
            _logger.$logger.warn('state_requires_auth', {
                stateName: toState.name
            });
            event.preventDefault();
            throw new _squid.$Forbidden('state_transition_forbidden', { fromState: fromState, toState: toState });
        }
    });

    (0, _angular.$interval)(function () {
        var auth = _index.$AuthModel.instance();

        if (auth.logged_in) {
            // disallow_login_switch is used for Google Pay - acount linking to hide "not you" button (see xo-hercules/auth/outputMapper) and prevent user to be logged out
            // instead we should show error page
            if (auth.disallow_login_switch) {
                _uiRouter.$state.go('checkout.genericError', {
                    code: 'DEFAULT_TOKENIZED_WALLET_ERROR'
                });
                return;
            }

            auth.reload({ silent: true }).then(function () {
                if (_uiRouter.$state.current.auth !== false && !auth.logged_in) {
                    errorCount += 1;
                    if (errorCount === 10) {
                        _logger.$logger.error('max_state_requires_auth');
                    }
                    if (errorCount >= 10) {
                        return;
                    }
                    _logger.$logger.info('idle_timeout');
                    _logger.$logger.warn('state_requires_auth', {
                        stateName: _uiRouter.$state.current.name
                    });
                    errorCount += 1;
                    throw new _squid.$Forbidden();
                }
            });
        }
    }, 30 * 60 * 1000);

    _squid.$util.idleTimeout(10 * 60 * 60 * 1000);
});

_uiRouter.$state;

_squid.$Forbidden;

_squid.$util;

_logger.$logger;

_index.$AuthModel;

/***/ }),

/***/ "./js/lib/stateChangeListener.js":
/***/ (function(module, exports, __webpack_require__) {



var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().run(function () {
    // Decorate the current state with the transition params
    _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        _uiRouter.$state.toState = toState;
        _uiRouter.$state.toParams = toParams;
        _uiRouter.$state.fromState = fromState;
        _uiRouter.$state.fromParams = fromParams;
    });
});

_uiRouter.$state;

/***/ }),

/***/ "./pages/services/cardart-instrument/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _wallet = __webpack_require__("../node_modules/xo-models/src/wallet/index.js");

/**
 * $CardartInstrument is a resuable Angular factory service.
 * It intends to abstract away common functionalities that are
 * being used in multiple pages or components.
 *
 * Currently, $CardardInstrument is being used at:
 * - xo-review
 * - xo-select-fi
 * - xo-sidebar-manage-wallet
 * - xo-wallet
 */

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$CardArtInstrument', function () {
    var CARD = 'CARD';
    var BALANCE = 'BALANCE';
    var wallet = _wallet.$WalletModel.instance(_squid.$meta.token);

    var isCardArtEnable = function isCardArtEnable(fiMeta) {
        return fiMeta && fiMeta.cardArtEnabled();
    };

    /**
     * @param {Ojbect} instrument A future payment instrument
     * @returns {Object}
     */
    var normalizeFutureInstrument = function normalizeFutureInstrument(instrument) {
        return {
            id: instrument.instrument_id,
            type: instrument.type,
            cardArtUrl: wallet.getCardArt(instrument)
        };
    };

    /**
     * @param {Object} options
     * @param {Object} otpions.primaryFs A primaryFs funding options
     * @returns {Object}
     */
    var normalizeFundingOptions = function normalizeFundingOptions(_ref) {
        var primaryFs = _ref.primaryFs;

        if (!primaryFs) {
            return {};
        }

        return {
            id: primaryFs.id,
            type: primaryFs.type,
            cardArtUrl: wallet.getCardArt(primaryFs)
        };
    };

    /**
     * @typedef {Object} FI
     * @property {String} fi_id
     * @property {String} fi_type
     * @property {String} is_cardart_shown
     * @property {String} eligible
     *
     * @typedef {Object} CardartInstrumentation
     * @property {Array<FI>} fi
     *
     * @param {Object} options
     * @param {Array} options.plans An array of fundingOptions plans or future payment instruments
     * @returns {Object<CardartInstrumentation>}
     */
    var normalizePayload = function normalizePayload(_ref2) {
        var _ref2$plans = _ref2.plans,
            plans = _ref2$plans === undefined ? [] : _ref2$plans;
        return {
            fi: plans.filter(function (plan, index, arr) {
                var id = arr.map(function (item) {
                    return item.id;
                });

                return index === id.indexOf(plan.id) && plan.type !== BALANCE;
            }).map(function (_ref3) {
                var id = _ref3.id,
                    type = _ref3.type,
                    cardArtUrl = _ref3.cardArtUrl;
                return {
                    fi_id: id,
                    fi_type: 'fi_' + (type && type.toLowerCase()),
                    is_cardart_shown: type === CARD && cardArtUrl ? '1' : '0',
                    eligible: type === CARD && cardArtUrl ? 'cardart' : null
                };
            })
        };
    };

    /**
     * @param {Object} options
     * @param {Object} options.checkoutSession $CheckoutSessionModel
     * @returns {Array}
     */
    var getSelectedInstrument = function getSelectedInstrument(_ref4) {
        var checkoutSession = _ref4.checkoutSession;

        return checkoutSession.getSelectedStickyInstrument() ? [checkoutSession.getSelectedStickyInstrument()].map(normalizeFutureInstrument) : [];
    };

    /**
     * CreatePayload creates cardart instrumentation based on the following criteria:
     *
     * - showMultipleFiVariants pxp
     * - showMultipleFiVariants + 3FI pxp
     * - singleFI pxp
     *
     * @param {Object} options
     * @param {Object} options.checkoutSession $CheckoutSessionModel
     * @param {Boolean} options.isBillingNoPurchase $CheckoutCartModel.isBillingNoPurchase()
     * @param {Boolean} options.stickyEligible Default to be false
     * @param {Boolean} options.renderMultipleFi Determines whether to render multiple FIs or not
     * @param {Boolean} options.renderSingleFi Determines whether to render single FI or not
     * @param {Object} options.showMoreFiState ShowMoreFiState to determine whether we renders `Show More` expereience or not.
     * See $ShowMoreFiFactory.get() for details implementation
     * @returns {Object<CardartInstrumentation>}
     */
    var createPayload = function createPayload(_ref5) {
        var checkoutSession = _ref5.checkoutSession,
            isBillingNoPurchase = _ref5.isBillingNoPurchase,
            _ref5$stickyEligible = _ref5.stickyEligible,
            stickyEligible = _ref5$stickyEligible === undefined ? false : _ref5$stickyEligible,
            _ref5$renderMultipleF = _ref5.renderMultipleFi,
            renderMultipleFi = _ref5$renderMultipleF === undefined ? false : _ref5$renderMultipleF,
            _ref5$renderSingleFi = _ref5.renderSingleFi,
            renderSingleFi = _ref5$renderSingleFi === undefined ? false : _ref5$renderSingleFi,
            _ref5$showMoreFiState = _ref5.showMoreFiState,
            showMoreFiState = _ref5$showMoreFiState === undefined ? {
            eligible: false,
            isTooManyFi: false,
            isShowMoreBtnClicked: false
        } : _ref5$showMoreFiState;
        var eligible = showMoreFiState.eligible,
            isTooManyFi = showMoreFiState.isTooManyFi,
            isShowMoreBtnClicked = showMoreFiState.isShowMoreBtnClicked;

        var plans = isBillingNoPurchase ? checkoutSession.get('futurePaymentInstruments', []).map(normalizeFutureInstrument) : (checkoutSession.getPlanList() || []).map(normalizeFundingOptions);

        // when we do decide to render multiple FIs experience
        if (renderMultipleFi) {
            plans = eligible && isTooManyFi // eslint-disable-line no-nested-ternary
            ? isShowMoreBtnClicked ? plans.slice(0) // If `addMore` action has been triggered, we log all FIs
            : plans.slice(0, 3) // otherwise, we only log the first 3FIs
            : plans;
        } else if (renderSingleFi) {
            // Or, render a single FI experience
            // ensure we check if we have a sticky plan
            if (stickyEligible) {
                plans = getSelectedInstrument({ checkoutSession: checkoutSession });
            } else {
                plans = plans.slice(0, 1);
            }
        }

        return normalizePayload({ plans: plans });
    };

    return {
        createPayload: createPayload,
        isCardArtEnable: isCardArtEnable
    };
});

_squid.$meta;

_wallet.$WalletModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/services/cardart-instrument", "pages/services/cardart-instrument/index.js"))

/***/ }),

/***/ "./pages/xo-add-card-meft/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoPageAddCardMeftPageComponent = undefined;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-validation/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

var _template = __webpack_require__("./pages/xo-add-card-meft/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoPageAddCardMeftPageComponent = exports.$xoPageAddCardMeftPageComponent = _squid.$Component.extend('$xoPageAddCardMeftPageComponent', {
    tag: 'xo-page-add-card-meft-page',
    template: _template2['default'],
    controller: ['$scope', function ($scope) {
        $scope.locale = _squid.$locale;
        $scope.token = _angular.$rootScope.token;
        $scope.checkoutAppData = _checkout.$CheckoutAppDataModel.instance($scope.token);
        $scope.showmeftsection = {
            toggle: true
        };
        $scope.billingaddressupdated = {
            value: false
        };
        function populateInfoMessage() {
            var msg = _squid.$locale.content.get('DEMemberGuest.meftDeclinePageErrorMsg');

            $scope.message = {
                msgs: [msg],
                type: 'info'
            };
        }
        populateInfoMessage();

        $scope.useMeft = function () {
            return $scope.checkoutAppData.action('meft', {
                success: function success(result) {
                    // reload checkout session with new meft instrument.
                    _checkout.$CheckoutSessionModel.instance($scope.token).reload();
                    _uiRouter.$state.go('checkout.review');
                }
            });
        };

        $scope.callbacks = {
            finish: function finish() {
                return _uiRouter.$state.go('checkout.review');
            }
        };
    }]
});

angular.value("$xoPageAddCardMeftPageComponent", $xoPageAddCardMeftPageComponent);
_uiRouter.$state;

_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutSessionModel;

/***/ }),

/***/ "./pages/xo-add-card-meft/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$AddCardMeftRoute = undefined;

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/route.js");

__webpack_require__("./pages/xo-add-card-meft/directive.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $AddCardMeftRoute = exports.$AddCardMeftRoute = _squid.$ComponentRoute.extend('$AddCardMeftRoute', {

    path: 'pageAddCardMeft',
    directive: 'xo-page-add-card-meft-page',
    titleContent: 'asideHeader.addCard',
    query: ['message'],
    trackingData: {
        templateName: 'meftDeclineAddCard.dust',
        pageGoal: 'Add Card for MEFT Decline',
        buzname: {
            'fullpage': {
                'pagename': '%:de:meft-addcard',
                'pagename2': '%:de:meft-addcard:member:hermes:',
                'hier1': '%de',
                'version': 'member:%:',
                'flowname': '%de',
                'subfeature2': '%de'
                // More page qualifiers come here...
            } }
    },
    children: [{
        name: '$AddCardFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            pagetitle: 'pagetitle',
            billingaddressupdated: 'billingaddressupdated',
            showmeftsection: 'showmeftsection',
            'parent-callbacks': 'callbacks'
        }
    }]
});

angular.value("$AddCardMeftRoute", $AddCardMeftRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-add-card-meft/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"addCard\" id=\"addCard\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <ui-view></ui-view>\n            <div ng-show=\"showmeftsection.toggle\">\n                <p class=\"useMeftInstead\">{{content ('DEMemberGuest.useMeftInstead')}}</p>\n\n                <div>\n                    <a track-link=\"meft_done\" id=\"submitBtnMeft\" href=\"\" class=\"btn btn-secondary\n                            btn-large full submit\" ng-click=\"useMeft()\"\n                       role=\"button\">{{content ('DEMemberGuest.useMeftBtn')}}</a>\n                </div>\n            </div>\n        </div>\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"addCard\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"addCard\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-add-card/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoPageAddCardPageComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _factory = __webpack_require__("../node_modules/xo-member-components/src/no-balance/factory.js");

var _factory2 = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/addcard/factory.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _choice = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _fiMessages = __webpack_require__("../node_modules/xo-models/src/fi/lib/fiMessages.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _index2 = _interopRequireDefault(_index);

var _newMember = __webpack_require__("../node_modules/xo-models/src/newMember/index.js");

var _checkoutIncentive = __webpack_require__("../node_modules/xo-models/src/checkoutIncentive/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-page-components/src/notYou/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-validation/dist/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/no-balance/directive.js");

var _factory3 = __webpack_require__("../node_modules/xo-ui-components/src/expired-fi-panel/factory.js");

var _template = __webpack_require__("./pages/xo-add-card/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var disallowedExp = _factory3.$ExpiredFiPanelFactory.disallowedExp;
var $xoPageAddCardPageComponent = exports.$xoPageAddCardPageComponent = _squid.$Component.extend('$xoPageAddCardPageComponent', {
    tag: 'xo-page-add-card-page',
    template: _template2['default'],
    scope: {},
    controller: ['$scope', function ($scope) {
        $scope.locale = _squid.$locale;
        $scope.token = _angular.$rootScope.token;
        $scope.showIncentive = false; // Assume we won't show an incentive
        $scope.isProcessorDeclineExperiment = false;
        var models = {};

        $scope.callbacks = {
            finish: function finish() {
                if (models.cart.isWalletTokenization() && models.walletPinModel.isSetupEligible()) {
                    _logger.$logger.debug('pinSetup_required');
                    _uiRouter.$state.go('checkout.pinSetup');
                } else {
                    _uiRouter.$state.go('checkout.review');
                }
            },
            cancel: function cancel(routeTo) {
                var goTo = routeTo || $scope.parentState || '';

                _logger.$logger.debug('xoAddCard_cancel', { goTo: goTo });
                if (goTo) {
                    _uiRouter.$state.go(goTo);
                }
            }
        };

        (0, _squid.$populate)(models, {
            checkoutSession: _checkout.$CheckoutSessionModel.instance($scope.token).retrieve({
                contingencies: {
                    NEED_CREDIT_CARD: angular.noop,
                    EXPIRED_CREDIT_CARD: angular.noop,
                    NEED_DEBIT_CARD: angular.noop,
                    EXPIRED_DEBIT_CARD: angular.noop
                }
            }),
            unavailableCard: _fi.$UnavailableCardModel.instance(),
            payee: _checkout.$CheckoutPayeeModel.instance($scope.token),
            cart: _checkout.$CheckoutCartModel.instance($scope.token),
            auth: _auth.$AuthModel.instance().retrieve(),
            checkoutAppData: _checkout.$CheckoutAppDataModel.instance($scope.token).retrieve(),
            noBalanceFactoryState: _factory.$NoBalanceFactory.decideEligibility(),
            fiMeta: _index2['default'].instance(_angular.$rootScope.token).fetch()['catch'](_angular.noop)
        }).then(function () {
            $scope.noBalanceFactoryState = _factory.$NoBalanceFactory.get();
            // Resolve additional information needed
            var getWalletPinModel = function getWalletPinModel() {
                if (models.cart.isWalletTokenization()) {
                    return (0, _squid.$populate)(models, {
                        walletPinModel: _app.$TokenizedWalletPinModel.instance($scope.token)
                    });
                }
            };

            var getCheckoutIncentiveEligibility = function getCheckoutIncentiveEligibility() {
                return (0, _angular.$q)(function (resolve, reject) {
                    var fptiData = {
                        from: 'FI_addCardAccount',
                        to: 'prepare_FI_addCardAccount',
                        context_id: $scope.token,
                        eligibility_reason: ''
                    };

                    if (models.cart.isWalletTokenization()) {
                        fptiData.eligibility_reason = 'Incentive_Ineligible_Wallet_Tokenization';
                        _logger.$logger.info('checkout_fpti', fptiData);
                        return resolve(false);
                    }

                    if (models.payee.isGambling()) {
                        fptiData.eligibility_reason = 'Incentive_Ineligible_Gambling_Merchant';
                        _logger.$logger.info('checkout_fpti', fptiData);
                        return resolve(false);
                    }

                    var country_code = _squid.$locale.getCountryCodeISO();

                    var offerEligibilityData = {
                        payer_id: models.auth.buyer_id,
                        country_code: country_code,
                        language: _squid.$locale.getLocaleCode(),
                        touchpoint_code: 'CHECKOUT_INCENTIVE' // TODO don't hardcode this?
                    };

                    $scope.evaluateCheckoutOfferEligibilityModel = _checkoutIncentive.$EvaluateCheckoutOfferEligibilityModel.instance();

                    $scope.evaluateCheckoutOfferEligibilityModel.save({
                        data: offerEligibilityData,
                        success: function success() {

                            if (!$scope.evaluateCheckoutOfferEligibilityModel.isEligible()) {
                                fptiData.eligibility_reason = 'Incentive_Ineligible_Not_In_MORS_Segment';
                                _logger.$logger.info('checkout_fpti', fptiData);
                                return resolve(false);
                            }

                            $scope.getOfferProgramModel = _checkoutIncentive.$GetOfferProgramModel.instance();
                            var offer_program_code = $scope.evaluateCheckoutOfferEligibilityModel.getOfferProgramCode();

                            $scope.getOfferProgramModel.retrieve({
                                params: { offer_program_code: offer_program_code },
                                success: function success() {
                                    var offerCurrencyCode = $scope.getOfferProgramModel.getOfferCurrencyCode();
                                    var cartCurrencyCode = models.cart.getCartCurrencyCode();

                                    if (cartCurrencyCode !== offerCurrencyCode) {
                                        fptiData.eligibility_reason = 'Incentive_Ineligible_Cart_Currency_Not_Offer_Currency';
                                        _logger.$logger.info('checkout_fpti', fptiData);
                                        return resolve(false);
                                    }

                                    var txnMinimumLowestDenom = $scope.getOfferProgramModel.getMinCartTotalLowestDenom();
                                    var precisionDigits = _squid.$locale.metadata.currency.digits[offerCurrencyCode];
                                    var txnMinimum = txnMinimumLowestDenom;

                                    if (precisionDigits) {
                                        txnMinimum = (txnMinimumLowestDenom / Math.pow(10, precisionDigits)).toFixed(precisionDigits);
                                    }

                                    var txnAmt = models.cart.getPurchaseAmount();
                                    var isTxnWorthEnough = txnAmt >= txnMinimum;

                                    if (!isTxnWorthEnough) {
                                        fptiData.eligibility_reason = 'Incentive_Ineligible_Transaction_Not_Worth_Enough';
                                        _logger.$logger.info('checkout_fpti', fptiData);
                                        return resolve(false);
                                    }

                                    var isUserInApplicableCountry = $scope.getOfferProgramModel.isUserInApplicableCountry(country_code);

                                    if (!isUserInApplicableCountry) {
                                        fptiData.eligibility_reason = 'Incentive_Ineligible_Country_Ineligible';
                                        _logger.$logger.info('checkout_fpti', fptiData);
                                        return resolve(false);
                                    }

                                    fptiData.eligibility_reason = 'Incentive_Eligible';
                                    _logger.$logger.info('checkout_fpti', fptiData);

                                    var pxpFptiData = {
                                        state_name: 'FI_addCardAccount',
                                        transition_name: 'prepare_FI_addCardAccount_incentive',
                                        incentive_name: ''
                                    };

                                    return _factory2.$AddCardFactory.getCheckoutIncentivePxpResult().then(function (result) {
                                        if (result === 'xo_hermes_checkout_incentive_show') {
                                            pxpFptiData.incentive_name = $scope.getOfferProgramModel.offer_program_code;
                                            _logger.$logger.info('checkout_fpti', pxpFptiData);
                                            return resolve(true);
                                        }

                                        _logger.$logger.info('checkout_fpti', pxpFptiData);
                                        return resolve(false);
                                    })['catch'](function () {
                                        _logger.$logger.info('checkout_fpti', pxpFptiData);
                                        return resolve(false);
                                    });
                                },
                                contingencies: {
                                    DEFAULT: function DEFAULT(msg, contingency) {
                                        fptiData.eligibility_reason = 'Incentive_Ineligible_' + msg;
                                        _logger.$logger.info('checkout_fpti', fptiData);
                                        return resolve(false);
                                    }
                                },
                                error: function error() {
                                    fptiData.eligibility_reason = 'Get_Program_Error';
                                    _logger.$logger.info('checkout_fpti', fptiData);
                                    return resolve(false);
                                }
                            });
                        },
                        contingencies: {
                            DEFAULT: function DEFAULT(msg, contingency) {
                                fptiData.eligibility_reason = 'Incentive_Ineligible_' + msg;
                                _logger.$logger.info('checkout_fpti', fptiData);
                                return resolve(false);
                            }
                        },
                        error: function error() {
                            fptiData.eligibility_reason = 'MORS_Error';
                            _logger.$logger.info('checkout_fpti', fptiData);
                            return resolve(false);
                        }
                    });
                });
            };

            var getHideControlMsg = function getHideControlMsg() {
                return _newMember.$NewMemberEligibility.instance().isNmj($scope.token);
            };

            var getSelectFiVariant = function getSelectFiVariant() {
                return _choice.$ChoiceEligibility.instance().getVariant($scope.token).then(function (variant) {
                    var selectFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.selectFi || [];

                    if (selectFiVariants.indexOf(variant) !== -1) {
                        return true;
                    }

                    return false;
                });
            };

            // Return the reason for disallowed in the wallet, due to preauth or bank
            var checkDeclineReason = function checkDeclineReason() {
                var disallowedInstruments = models.checkoutSession.get('fundingOptions').get('disallowedInstruments');
                var disallowedPreAuth = _squid.$util.filter(disallowedInstruments, function (instrument) {
                    return instrument.declineReason === 'INSTRUMENT_VERIFICATION_FAILED';
                });

                if (!disallowedInstruments) {
                    return;
                }

                if (disallowedPreAuth && disallowedPreAuth.length > 0) {
                    return 'PREAUTH';
                }

                var disallowedNonBankInstruments = _squid.$util.filter(disallowedInstruments, function (disallowedInstrument) {
                    return disallowedInstrument.type !== 'BANK';
                });

                if (disallowedNonBankInstruments && disallowedNonBankInstruments.length >= 1) {
                    return;
                }

                return 'BANK';
            };

            var checkProcessorDeclineIssuerExperiment = function checkProcessorDeclineIssuerExperiment() {
                var declinedInstruments = models.checkoutSession.get('declinedInstruments', []);
                if (declinedInstruments && declinedInstruments.length > 0) {
                    return (0, _squid.$elmo)('xo_hermesnodeweb_issuer_decline', { 'ctx.country': _squid.$locale.country }, 'Trmt_xo_hermesnodeweb_issuer_decline_1').then(function (result) {
                        return result && result.treatment_name;
                    });
                }
                return '';
            };

            return _squid.$promise.hash({
                walletPinModel: getWalletPinModel(),
                hideControlMsg: getHideControlMsg(),
                checkoutIncentiveEligibility: getCheckoutIncentiveEligibility(),
                addCardPxpResult: _factory2.$AddCardFactory.getAddCardPxpResult(),
                selectFiVariant: getSelectFiVariant(),
                checkDeclineReason: checkDeclineReason(),
                addCardContingency: _factory3.$ExpiredFiPanelFactory.getPxpResult(models),
                issuerDeclineTreatment: checkProcessorDeclineIssuerExperiment()

            });
        }).then(function (_ref) {
            var hideControlMsg = _ref.hideControlMsg,
                addCardPxpResult = _ref.addCardPxpResult,
                selectFiVariant = _ref.selectFiVariant,
                checkDeclineReason = _ref.checkDeclineReason,
                checkoutIncentiveEligibility = _ref.checkoutIncentiveEligibility,
                addCardContingency = _ref.addCardContingency,
                issuerDeclineTreatment = _ref.issuerDeclineTreatment;


            var message = void 0;

            // smartDollarAuthFailed is true when smart $x auth check fails on 'authorize'
            if (models.checkoutSession.smartDollarAuthFailed) {
                message = {
                    type: 'error',
                    msg: (0, _squid.$renderContent)('payment.authFailureSingleFI')
                };
            } else {
                if (issuerDeclineTreatment === 'Trmt_xo_hermesnodeweb_issuer_decline_1') {
                    $scope.isProcessorDeclineExperiment = true;
                }
                message = _fiMessages.$fiMessages.processorDeclinedMsg(models.checkoutSession, false, issuerDeclineTreatment, models.auth, models.fiMeta.wallet);
            }

            var getContingencyDeclineMessage = function getContingencyDeclineMessage(declineReason, _ref2) {
                var disallowedInstruments = _ref2.disallowedInstruments;

                switch (declineReason) {
                    case 'BANK':
                        message = _fiMessages.$fiMessages.getAddBankTreatmentMsg();
                        break;
                    case 'PREAUTH':
                        var disallowed = _squid.$util.filter(disallowedInstruments, function (instrument) {
                            return instrument.declineReason === 'INSTRUMENT_VERIFICATION_FAILED';
                        });

                        message = _fiMessages.$fiMessages.getPreAuthTreatmentMsg(disallowed);
                        break;
                    default:
                        message = _fiMessages.$fiMessages.getAddCardTreatmentMsg(models.checkoutSession);
                        break;
                }
            };

            // If no processor decline, get the message when contingency is anything but NEED_DEBIT_CARD
            if (!message && models.checkoutSession.get('errorData.cause') && _uiRouter.$stateParams.message !== 'NEED_DEBIT_CARD') {
                if (models.payee.isGambling()) {
                    message = _fiMessages.$fiMessages.getGamblingMsg();
                } else if (!hideControlMsg && addCardContingency && (addCardContingency === disallowedExp.disallowedFi || addCardContingency === disallowedExp.preAuth)) {
                    getContingencyDeclineMessage(checkDeclineReason, models.checkoutSession.get('fundingOptions'));
                } else {
                    message = _fiMessages.$fiMessages.getAddCardMsg(models.unavailableCard, addCardPxpResult && addCardPxpResult.treatment_name, models.checkoutSession);
                    var noBillingFIContingencyIndia = (0, _squid.$renderContent)('creditcard.noBillingFIContingency');

                    if (models.cart.isBilling() && noBillingFIContingencyIndia && _squid.$locale.country === 'IN' && models.checkoutAppData.get('merchant.merchant_country', 'US') === 'IN') {
                        message.msg = noBillingFIContingencyIndia;
                        message.type = 'info';
                    }
                }
            }

            if (message) {
                $scope.message = {
                    type: message.type,
                    msgs: [message.msg]
                };
                if (message.title) {
                    $scope.messagetitle = _squid.$locale.content.get(message.title.key);
                }
            }

            $scope.cart = models.cart;
            $scope.auth = models.auth;

            // Show this message if this is the first page the user sees (these cases usually have a message).
            // Do not show if entering from another page, like the select-fi page
            if (!hideControlMsg) {
                $scope.showHiMsg = message || !selectFiVariant;
                $scope.showNotYou = $scope.auth && $scope.auth.showNotYou();
            }

            // Render the incentive banner if eligible
            $scope.showIncentive = checkoutIncentiveEligibility;

            if ($scope.showIncentive) {
                // This is of the form '$5.00'
                var offerValue = $scope.evaluateCheckoutOfferEligibilityModel.getOfferValue();

                $scope.incentiveAmount = offerValue;

                var currencyCode = $scope.evaluateCheckoutOfferEligibilityModel.getCurrencyCode();
                var precisionDigits = _squid.$locale.metadata.currency.digits[currencyCode];

                if (precisionDigits) {
                    var decimalDigitsStr = offerValue.substring(offerValue.length - precisionDigits);
                    var areAllDecimalDigitsZeroes = /^0*$/.test(decimalDigitsStr);

                    if (areAllDecimalDigitsZeroes) {
                        // Remove trailing decimals and punctuation
                        $scope.incentiveAmount = offerValue.substring(0, offerValue.length - precisionDigits - 1);
                    }
                }

                // Don't show incentive terms by default
                $scope.showIncentiveTerms = false;

                $scope.toggleShowIncentiveTerms = function () {
                    $scope.showIncentiveTerms = !$scope.showIncentiveTerms;
                };
            }

            // Show selectFi features if no contingency
            if (selectFiVariant && !message) {
                $scope.showCancel = true;
                $scope.parentState = 'checkout.selectFi';
                $scope.pagetitle = _squid.$locale.content.get('addCard.addACard');
            }
        });

        $scope.isAddCardContingency = function () {
            return _uiRouter.$stateParams.message === 'NEED_CREDIT_CARD';
        };

        $scope.isUpdateDebitCard = function () {
            return _uiRouter.$stateParams.message === 'EXPIRED_DEBIT_CARD';
        };
    }]
});

angular.value("$xoPageAddCardPageComponent", $xoPageAddCardPageComponent);
_angular.$q;

_angular.$rootScope;

_angular.noop;

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_squid.$Component;

_squid.$config;

_squid.$locale;

_squid.$populate;

_squid.$promise;

_squid.$renderContent;

_squid.$util;

_squid.$elmo;

_factory.$NoBalanceFactory;

_factory2.$AddCardFactory;

_auth.$AuthModel;

_fi.$UnavailableCardModel;

_choice.$ChoiceEligibility;

_app.$TokenizedWalletPinModel;

_fiMessages.$fiMessages;

_newMember.$NewMemberEligibility;

_checkoutIncentive.$EvaluateCheckoutOfferEligibilityModel;

_checkoutIncentive.$GetOfferProgramModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutSessionModel;

_factory3.$ExpiredFiPanelFactory;

/***/ }),

/***/ "./pages/xo-add-card/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$AddCardPageRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/route.js");

__webpack_require__("./pages/xo-add-card/directive.js");

var $AddCardPageRoute = exports.$AddCardPageRoute = _squid.$ComponentRoute.extend('$AddCardPageRoute', {
    path: 'pageAddCard',
    directive: 'xo-page-add-card-page',
    titleContent: 'asideHeader.addCard',
    query: ['cause', 'message'],
    trackingData: {
        templateName: 'addCard.dust',
        pageGoal: 'Add Card',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-cc',
                'pagename2': '%::fullpage-add-cc:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },
    children: [{
        name: '$AddCardFlowRoute',
        attributes: {
            token: 'token',
            messagetitle: 'messagetitle',
            message: 'message',
            pagetitle: 'pagetitle',
            'parent-callbacks': 'callbacks',
            logout: 'logout',
            'show-cancel': 'showCancel',
            'show-incentive': 'showIncentive',
            'incentive-amount': 'incentiveAmount'
        }
    }]
});

angular.value("$AddCardPageRoute", $AddCardPageRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-add-card/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"addCard\" id=\"addCard\" content>\n    <xo-modal\n        ng-if=\"showIncentive\"\n        id=\"incentive-terms\"\n        show=\"showIncentiveTerms\"\n        show-close-button=\"true\"\n        enable-close-on-escape=\"true\"\n        on-close=\"toggleShowIncentiveTerms\"\n        enable-mobile-interstitial=\"true\">\n\n        <h1 class=\"alpha\">{{ content('checkoutIncentive.termsHeader') }}</h1>\n        <h6>{{ content('checkoutIncentive.termsH1') }}</h6>\n        <p>{{ content('checkoutIncentive.termsP1') }}</p>\n        <h6>{{ content('checkoutIncentive.termsH2') }}</h6>\n        <p>{{ content('checkoutIncentive.termsP2') }}</p>\n        <h6>{{ content('checkoutIncentive.termsH3') }}</h6>\n        <p data-ng-bind-html=\"content('checkoutIncentive.termsP3')\"></p>\n        <h6>{{ content('checkoutIncentive.termsH4') }}</h6>\n        <p>{{ content('checkoutIncentive.termsP4') }}</p>\n        <h6>{{ content('checkoutIncentive.termsH5') }}</h6>\n        <p>{{ content('checkoutIncentive.termsP5') }}</p>\n        <h6>{{ content('checkoutIncentive.termsH6') }}</h6>\n        <p>{{ content('checkoutIncentive.termsP6') }}</p>\n\n        <div class=\"logo\"></div>\n    </xo-modal>\n\n    <div class=\"row-fluid\" ng-if=\"!cart.isWalletTokenization()\">\n        <div class=\"span14\">\n            <xo-no-balance-banner ng-if=\"noBalanceFactoryState.eligible && isAddCardContingency()\"></xo-no-balance-banner>\n            <div ng-if=\"showIncentive\" id=\"incentive\">\n                <p id=\"incentive-greeting\">\n                    {{ content('creditcard.hi', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                    <span ng-if=\"showNotYou\">\n                        <xo-not-you></xo-not-you>\n                    </span>\n                </p>\n                <div id=\"incentive-content\">\n                    <div id=\"incentive-icon\"></div>\n                    <div id=\"incentive-text\">\n                        <p>\n                            <strong>{{ content('checkoutIncentive.header', {incentiveAmount: incentiveAmount}) }}</strong>\n                            <br>\n                            <span>{{ content('checkoutIncentive.body') }}</span>\n                        </p>\n                        <a id=\"incentive-terms-toggle\" href=\"\" link-button ng-click=\"toggleShowIncentiveTerms()\" aria-label=\"{{ content('offers.seeTermsText') }}\">\n                            {{ content('offers.seeTermsText') }}\n                        </a>\n                    </div>\n                </div>\n            </div>\n\n            <p class=\"userEmail\" id=\"reviewUserInfo\" data-test-id=\"addCard-showHiMsg\" ng-if=\"showHiMsg && !showIncentive && !isProcessorDeclineExperiment\">\n                {{ content('creditcard.hi', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                <span ng-if=\"showNotYou\">\n                    <xo-not-you></xo-not-you>\n                </span>\n            </p>\n            <ui-view></ui-view>\n        </div>\n\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"addCard\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"addCard\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n    <div class=\"sidepage noSlide\" modal-box tabindex=\"-1\" ng-if=\"cart.isWalletTokenization()\">\n        <div class=\"aside noSlide\" id=\"sidepageAddCard\" modal-box>\n            <xo-aside-header heading=\"{{isUpdateDebitCard() ? 'asideHeader.updateDebitCard' : 'asideHeader.addDebitCard'}}\"\n                             hidex=\"true\"></xo-aside-header>\n            <div class=\"content\">\n                <ui-view></ui-view>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-add-fi/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoPageAddFiPageComponent = undefined;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _choice = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

var _fiMessages = __webpack_require__("../node_modules/xo-models/src/fi/lib/fiMessages.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-validation/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

var _template = __webpack_require__("./pages/xo-add-fi/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoPageAddFiPageComponent = exports.$xoPageAddFiPageComponent = _squid.$Component.extend('$xoPageAddFiPageComponent', {
    tag: 'xo-page-add-fi-page',
    template: _template2['default'],
    scope: {
        logout: '=?'
    },
    controller: ['$scope', function ($scope) {
        $scope.token = _angular.$rootScope.token;
        $scope.locale = _squid.$locale;
        $scope.billingaddressupdated = {
            value: false
        };
        $scope.hideparenthead = {
            toggle: false
        };
        $scope.title = _squid.$locale.content.get('addCard.addACard');
        $scope.callbacks = {
            finish: function finish() {
                return _uiRouter.$state.go('checkout.review');
            },
            done: function done() {
                return _uiRouter.$state.go('checkout.review');
            },
            cancel: function cancel(routeTo) {
                var destination = routeTo || $scope.parentState || '';

                if (destination) {
                    _uiRouter.$state.go(destination);
                }
            }
        };

        var models = {};

        (0, _squid.$populate)($scope, {
            auth: _auth.$AuthModel.instance(),
            payee: _checkout.$CheckoutPayeeModel.instance($scope.token)
        }).then(function () {
            $scope.logout = function () {
                _logger.$logger.info('not_you_logout');
                $scope.auth.logoutAndRedirect('NOT_YOU');
            };
            $scope.showNotYou = $scope.auth && $scope.auth.showNotYou();

            (0, _squid.$populate)(models, {
                checkoutSession: _checkout.$CheckoutSessionModel.instance($scope.token)
            }).then(function () {
                return (0, _squid.$pxp)('xo_hermes_addcard_msg', { 'ctx.COUNTRY': $scope.locale.country }, 'xo_hermes_addcard_msg_treatment', false, true).then(function (result) {
                    var message = _fiMessages.$fiMessages.processorDeclinedMsg(models.checkoutSession, false);

                    // If no processor decline, retrieve and display the contingency message
                    if (!message && models.checkoutSession.get('errorData.cause')) {
                        if ($scope.payee.isGambling()) {
                            message = _fiMessages.$fiMessages.getGamblingMsg();
                        } else if (result) {
                            message = _fiMessages.$fiMessages.getAddCardTreatmentMsg(models.checkoutSession);
                        } else {
                            message = _fiMessages.$fiMessages.getAddCardControlMsg(models.checkoutSession);
                        }
                    }

                    if (message) {
                        $scope.pageLevel = $scope.pageLevel || {};
                        $scope.pageLevel.message = {
                            type: message.type,
                            msgs: [message.msg]
                        };
                        $scope.showHiMsg = true;
                        if (message.title) {
                            $scope.messagetitle = _squid.$locale.content.get(message.title.key);
                        }
                    }

                    return _choice.$ChoiceEligibility.instance().getVariant($scope.token).then(function (variant) {
                        var selectFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.selectFi || [];
                        var displayCancelButton = selectFiVariants.indexOf(variant) > -1 && !message;

                        // show cancel button if no contingency
                        $scope.showCancel = displayCancelButton;
                        $scope.parentState = 'checkout.selectFi';
                    });
                });
            });
        });
    }]
});

angular.value("$xoPageAddFiPageComponent", $xoPageAddFiPageComponent);
_uiRouter.$state;

_angular.$rootScope;

_logger.$logger;

_squid.$Component;

_squid.$config;

_squid.$locale;

_squid.$populate;

_squid.$pxp;

_auth.$AuthModel;

_choice.$ChoiceEligibility;

_fiMessages.$fiMessages;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutSessionModel;

/***/ }),

/***/ "./pages/xo-add-fi/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$AddFiPageRoute = undefined;

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/route.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-bank/route.js");

__webpack_require__("./pages/xo-add-fi/directive.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $AddFiPageRoute = exports.$AddFiPageRoute = _squid.$ComponentRoute.extend('$AddFiPageRoute', {

    path: 'pageAddFi',

    directive: 'xo-page-add-fi-page',

    query: ['cause', 'message'],

    titleContent: 'addCard.addPaymentMethod',

    trackingData: {
        templateName: 'addFi.dust',
        pageGoal: 'Add Funding Instrument',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-fi',
                'pagename2': '%::fullpage-add-fi:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },

    children: [{
        name: '$AddCardFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            hideparenthead: 'hideparenthead',
            billingaddressupdated: 'billingaddressupdated',
            'parent-callbacks': 'callbacks',
            'page-level': 'pageLevel',
            'show-cancel': 'showCancel'
        }
    }, {
        name: '$AddBankFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            hideparenthead: 'hideparenthead',
            'parent-callbacks': 'callbacks',
            'page-level': 'pageLevel',
            'show-cancel': 'showCancel'
        }
    }]
});

angular.value("$AddFiPageRoute", $AddFiPageRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-add-fi/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"addFi\" id=\"addFi\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <p class=\"userEmail\" id=\"reviewUserInfo\" ng-if=\"showHiMsg\">\n                {{ content('creditcard.hi', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                    <span ng-if=\"showNotYou\">\n                        <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout()\" style=\"font-weight:700;\">{{ content('memberReview.notYou')}}</a>\n                    </span>\n            </p>\n            <div class=\"trayInner trayInnerDefault\">\n                <h1 class=\"gamma noHead\" ng-if=\"!hideparenthead.toggle\">\n                    {{content('addCard.addPaymentMethod')}}\n                </h1>\n                <xo-message message=\"pageLevel.message\"></xo-message>\n                <ul class=\"form-tabs\" id=\"paymentTab\" ng-if=\"!hideparenthead.toggle\">\n                    <li class=\"bank\" ui-sref-active=\"active\">\n                        <a ui-sref=\"checkout.pageAddFi.bank.add\" class=\"bankTab\">{{content('bank.bank')}}</a>\n                    </li>\n                    <li class=\"card\" ui-sref-active=\"active\">\n                        <a ui-sref=\"checkout.pageAddFi.addCardFlow.addCard\" class=\"cardTab\" for=\"cardTab\">{{content('bank.card')}}</a>\n                    </li>\n                </ul>\n                <ui-view></ui-view>\n            </div>\n        </div>\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props  type=\"review\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"review\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-add-national-id/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoAddNationalIdPageComponent = undefined;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _user = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _directive = __webpack_require__("../node_modules/xo-form-components/src/national-id-input/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

var _template = __webpack_require__("./pages/xo-add-national-id/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoAddNationalIdPageComponent = exports.$xoAddNationalIdPageComponent = _squid.$Component.extend('$xoAddNationalIdPageComponent', {
    tag: 'xo-add-national-id-page',
    template: _template2['default'],
    controller: ['$scope', function ($scope) {
        $scope.locale = _squid.$locale;
        $scope.user = {
            country: _squid.$locale.country,
            countryOfResidence: _squid.$locale.country
        };
        $scope.validate = function () {
            $scope.validated = true;
            return true;
        };
        $scope.onContinue = function () {
            $scope.nationalIdModel = _directive.$NationalIdModel.instance(_angular.$rootScope.token);
            $scope.checkoutSession = _checkout.$CheckoutSessionModel.instance(_angular.$rootScope.token);
            $scope.addKYC = new _user.$AddKYCModel({
                token: _angular.$rootScope.token
            });
            $scope.KYCData = {
                nationalIdModel: $scope.nationalIdModel,
                user: $scope.user
            };
            $scope.addKYC.save({
                data: $scope.KYCData,
                success: function success() {
                    return _uiRouter.$state.go('checkout.review');
                },
                contingencies: {
                    DEFAULT: function DEFAULT(err, message) {
                        _logger.$logger.info('add_KYC_contingency', {
                            name: err,
                            message: message
                        });
                    }
                }
            });
        };
    }]
});

angular.value("$xoAddNationalIdPageComponent", $xoAddNationalIdPageComponent);
_uiRouter.$state;

_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_logger.$logger;

_user.$AddKYCModel;

_checkout.$CheckoutSessionModel;

_directive.$NationalIdModel;

/***/ }),

/***/ "./pages/xo-add-national-id/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$AddNationalIdRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("./pages/xo-add-national-id/directive.js");

var $AddNationalIdRoute = exports.$AddNationalIdRoute = _squid.$ComponentRoute.extend('$AddNationalIdRoute', {
    path: 'addNationalId',
    directive: 'xo-add-national-id-page',
    titleContent: 'addTaxId.nationalityUpdate',
    trackingData: {
        fptiState: 'add-national-id',
        buzname: {
            'fullpage': {
                'pagename': '%::add-national-id',
                'pagename2': '%::add-national-id:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    children: []
});

angular.value("$AddNationalIdRoute", $AddNationalIdRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-add-national-id/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"addNationalId\" id=\"addNationalId\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner reviewSections\">\n            <p>\n                {{ content('creditcard.hi', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                <span ng-if=\"auth.is_auth_api_call\">\n                    <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout()\">{{ content('memberReview.notYou')}}</a>\n                </span>\n            </p>\n\n            <div class=\"trayInner trayInnerDefault\">\n                <h1 class=\"gamma noHead\" ng-if=\"!hideparenthead.toggle\">\n                    {{ content( 'addTaxId.nationalityUpdate' ) }}\n                </h1>\n                <p>\n                    {{ content( 'addTaxId.nationalityNote' ) }}\n                </p>\n                <ui-view></ui-view>\n            </div>\n\n            <form id=\"addNationalIdForm\" name=\"addNationalIdForm\" ng-submit=\"addNationalIdForm.$valid && onContinue()\" ng-class=\"{'validated': validated}\" novalidate>\n                <xo-national-id-input country={{locale.country}} user=\"user\"></xo-national-id-input>\n\n                <div class=\"buttons\">\n                    <input track-submit id=\"nationalIdSubmit\" type=\"submit\" value=\"{{ content( 'common.agreeAndContinue' ) }}\" ng-click=\"validate()\" class=\"btn full signupFlowSubmit\"/>\n                </div>\n            </form>\n        </div>\n\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props  type=\"review\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"review\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-add-shipping/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoPageAddShippingPageComponent = undefined;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-validation/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/select-shipping-country/directive.js");

var _template = __webpack_require__("./pages/xo-add-shipping/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoPageAddShippingPageComponent = exports.$xoPageAddShippingPageComponent = _squid.$Component.extend('$xoPageAddShippingPageComponent', {
    tag: 'xo-page-add-shipping-page',
    template: _template2['default'],
    controller: ['$scope', function ($scope) {
        $scope.token = _angular.$rootScope.token;
        $scope.locale = _squid.$locale;
        $scope.sidebar = false;
        $scope.callbacks = {
            done: function done() {
                return _uiRouter.$state.go('checkout.review');
            }
        };

        (0, _squid.$populate)($scope, {
            checkoutAppData: _checkout.$CheckoutAppDataModel.instance($scope.token)
        }).then(function () {
            var merchantCountry = $scope.checkoutAppData.get('merchant.merchant_country', 'US');

            if (!(0, _squid.$feature)('supportBlockNonDomesticShipping', false, merchantCountry)) {
                _uiRouter.$state.go('checkout.review');
            }
        });
    }]
});

angular.value("$xoPageAddShippingPageComponent", $xoPageAddShippingPageComponent);
_uiRouter.$state;

_angular.$rootScope;

_squid.$Component;

_squid.$feature;

_squid.$locale;

_squid.$populate;

_checkout.$CheckoutAppDataModel;

/***/ }),

/***/ "./pages/xo-add-shipping/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$AddShippingPageRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-member-components/src/select-shipping/add-shipping/route.js");

__webpack_require__("./pages/xo-add-shipping/directive.js");

var $AddShippingPageRoute = exports.$AddShippingPageRoute = _squid.$ComponentRoute.extend('$AddShippingPageRoute', {
    path: 'pageAddShipping',
    directive: 'xo-page-add-shipping-page',
    titleContent: 'addShipping.addAddress',
    query: ['message'],
    trackingData: {
        templateName: 'addShipping.dust',
        pageGoal: 'Add Shipping',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-shipping-address-nonXB',
                'pagename2': '%::fullpage-add-shipping-address-nonXB:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },
    children: [{
        name: '$AddShippingRoute',
        attributes: {
            token: 'token',
            'done-fn': 'callbacks.done',
            sidebar: 'sidebar'
        }
    }]
});

angular.value("$AddShippingPageRoute", $AddShippingPageRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-add-shipping/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"addShipping\" id=\"addShipping\" content>\n    <div class=\"row-fluid\">\n\n        <div class=\"span14\">\n            <ui-view></ui-view>\n        </div>\n\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"review\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"review\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-add-tax-id/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/add-tax-id/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

var _template = __webpack_require__("./pages/xo-add-tax-id/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoAddTaxIdPageComponent', {
    tag: 'xo-add-tax-id-page',
    template: _template2['default'],
    lifecycle: {
        enter: function enter() {
            this.locale = _squid.$locale;
            this.token = _angular.$rootScope.token;
            this.finish = function () {
                return _uiRouter.$state.go('checkout.review');
            };
        }
    }
});


_uiRouter.$state;

_angular.$rootScope;

_squid.$Component;

_squid.$locale;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-add-tax-id/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$AddTaxIdRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("./pages/xo-add-tax-id/directive.js");

var $AddTaxIdRoute = exports.$AddTaxIdRoute = _squid.$ComponentRoute.extend('$AddTaxIdRoute', {
    path: 'addTaxId',
    directive: 'xo-add-tax-id-page',
    titleContent: 'addTaxId.addTaxId',
    query: ['message'],
    trackingData: {
        templateName: 'addTaxId.dust',
        pageGoal: 'Add Tax Id',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-tax-id',
                'pagename2': '%::fullpage-add-tax-id:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },
    loginRequired: true,
    children: []
});

angular.value("$AddTaxIdRoute", $AddTaxIdRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-add-tax-id/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"addTaxId\" id=\"addTaxId\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-add-tax-id token=\"token\" finish=\"finish\"></xo-add-tax-id>\n        </div>\n\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"addTaxId\" title=\"{{content('login.propHead')}}\" text-content=\"login.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"addTaxId\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-authorization-message/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("./pages/xo-authorization-message/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoAuthorizationMessageComponent', {
    tag: 'xo-authorization-message',
    template: _template2['default']
});


_squid.$Component;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-authorization-message/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$AuthorizationMessageRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("./pages/xo-authorization-message/directive.js");

var $AuthorizationMessageRoute = exports.$AuthorizationMessageRoute = _squid.$ComponentRoute.extend('$AuthorizationMessageRoute', {
    path: 'authorizationmessage',
    directive: 'xo-authorization-message',
    titleContent: 'authUserLearnMore.authUserTitle',
    trackingData: {
        fptiState: 'authorizationmessage',
        templateName: 'authorizationMessage.dust',
        pageGoal: 'Authorization Message',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-authorizationmessage',
                'pagename2': '%::fullpage-authorizationmessage:member:hermes:',
                'version': 'member:%:'
            }
        }
    }
});

angular.value("$AuthorizationMessageRoute", $AuthorizationMessageRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-authorization-message/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"review\" content id=\"memberReview\" form-autofocus>\n\n    <div class=\"row-fluid justMember\">\n        <div class=\"span14 trayInner reviewSections\">\n            <div id=\"authMsg\" tabindex=\"-1\" modal-box aria-labelledby=\"authUserTitle\" aria-describedby=\"authUserContent1 authUserContent2\">\n                <div id=\"authUserLearnMore\" class=\"trayInner trayInnerDefault\">\n                    <h4 id=\"authUserTitle\" class=\"authUserTitle zeta\">{{content('authUserLearnMore.authUserTitle')}}</h4>\n                    <p id=\"authUserContent1\" class=\"authUserContent\">{{content('authUserLearnMore.authUserContentPara1')}}</p>\n                    <p id=\"authUserContent2\" class=\"authUserContent\">{{content('authUserLearnMore.authUserContentPara2')}}</p>\n                </div>\n                <div class=\"buttons\">\n                    <button class=\"btn authUserBtn full\" ui-sref=\"checkout.review\" focus-after-transition=\".authUserLink\" name=\"authUserBtn\">{{content('authUserLearnMore.ok')}}</button>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-checkout/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _integration = __webpack_require__("./js/lib/integration.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _gdprCookieBanner = __webpack_require__("../node_modules/xo-models/src/gdprCookieBanner/index.js");

var _dist = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _fn = __webpack_require__("../node_modules/xo-login-components/src/login/fn.js");

var _utils = __webpack_require__("../node_modules/xo-login-components/src/dolphin/utils.js");

__webpack_require__("../node_modules/xo-ui-components/src/spinner/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/merchant-header/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/header/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/footer/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/gdprCookieBanner/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-validation/dist/directive.js");

__webpack_require__("../node_modules/xo-login-components/src/login-overlay/directive.js");

__webpack_require__("../node_modules/xo-login-components/src/dolphin/directive.js");

var _template = __webpack_require__("./pages/xo-checkout/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCheckoutComponent', {
    tag: 'xo-checkout',
    template: _template2['default'],
    resolve: {
        pxp: function pxp() {
            var pxp = _squid.$config.purchaseProtectionProp && _squid.$config.purchaseProtectionProp.pxp;

            return {
                purchaseProtectionAlt: (0, _squid.$pxp)(pxp.pgName, pxp.patterns, undefined, false, true)
            };
        }
    },
    controller: function controller() {
        if (_angular.$location.path() === '/checkout') {
            _uiRouter.$state.go('checkout.review');
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.isMessengerBAIntegration = _integration.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
            this.token = _angular.$rootScope.token;
            this.locale = _squid.$locale;
            this.redirectiframe = _angular.$rootScope.partnerIntegration;
            this.redirectLightbox = true;
            this.escapeHatchInContext = !_angular.$rootScope.partnerIntegration;
            this.displayHeader = true;

            this.reviewUrl = 'checkout.review';
            this.isApp = _dist.$DeviceInfo.isApp();

            this.isDolphinEligible = false;

            _angular.$document.bind('click', function (event) {
                _this.$broadcast('clickBody', event.target);
            });

            function rtl() {
                if ((0, _squid.$feature)('rtl')) {
                    _angular.$document.prop('documentElement').setAttribute('dir', _squid.$locale.metadata.directionality);
                }
            }

            this.$on('metadataChange', rtl);
            rtl();

            _fn.$fn.trigger();

            this.isGdprValid = _gdprCookieBanner.isGdprValid;
        },
        populate: function populate() {
            var _this2 = this;

            if (this.pxp.purchaseProtectionAlt) {
                _squid.$config.features.DEFAULT.propValue = false;
            }

            function requiresRiskyLogin(state) {
                var auth = _auth.$AuthModel.instance();

                return state.loginRequired && auth.remembered;
            }

            function displayRiskyLogin(oldState, newState, newParams) {
                if (!_integration.$integration.getConfig('ALLOW_AUTH')) {
                    _logger.$logger.info('login_overlay_suppressed');
                    return;
                }

                var isUserinitiated = oldState.template && !oldState.name.match(/checkout\.login/);

                if (isUserinitiated) {
                    var stateName = newState && newState.name;
                    var subFlowName = stateName && stateName.replace(/^.*\./, '');

                    if (subFlowName === 'sepaAgreement') {
                        _uiRouter.$state.go('checkout.review');
                    }

                    _angular.$rootScope.$broadcast('$insufficientPermission', {
                        oldState: oldState.name,
                        newState: newState.name,
                        pageOnOverlay: newState.pageOnOverlay
                    });
                } else {
                    var auth = _auth.$AuthModel.instance();
                    var cause = newParams && newParams.message ? newParams.message : newState.name.replace(/^.*\./, '');

                    _logger.$logger.info('RISKY_LOGIN_TRANSITION_' + cause);

                    var showPasswordRecovery = (0, _squid.$feature)('pomaPasswordRecovery') && auth.password_less;
                    var transition = showPasswordRecovery ? 'checkout.createPassword' : 'checkout.login';

                    _uiRouter.$state.go(transition, {
                        targetPage: cause,
                        showNotYou: true
                    });
                }
                return false;
            }

            function displayHeader(stateName) {
                // We'll be hiding the header during the third party wallet flow, since the third Party will brand the flow from their end
                return !(stateName === 'checkout.thirdPartyWalletFlow');
            }

            var checkDolphinEligibility = function checkDolphinEligibility(stateName) {
                return (0, _utils.getDolphinEligibility)(stateName).then(function (eligibility) {
                    _this2.isDolphinEligible = eligibility;
                });
            };

            // Check dolphin eligibility for explicit page reload
            checkDolphinEligibility(_uiRouter.$state.current && _uiRouter.$state.current.name);

            var cancelStateChangeEventListener = _angular.$rootScope.$on('$stateChangeStart', function (event, newState, newParams, oldState) {
                // venmo flag
                _this2.showVenmoExperience = _thirdPartyInfo.thirdPartyExperience.getExperience(_this2.token) === 'VENMO_EXPERIENCE';

                if (_this2.showVenmoExperience) {
                    _logger.$logger.info('checkout_fpti', {
                        'is_venmo_branding': '1'
                    });
                }

                _this2.displayHeader = displayHeader(newState && newState.name);

                if (requiresRiskyLogin(newState)) {
                    event.preventDefault();
                    displayRiskyLogin(oldState, newState, newParams);
                }
                checkDolphinEligibility(newState && newState.name);
            });

            this.$on('$destroy', cancelStateChangeEventListener);

            if (requiresRiskyLogin(_uiRouter.$state.current)) {
                displayRiskyLogin(_uiRouter.$state.current, _uiRouter.$state.current);
            }
        }
    }
});


_uiRouter.$state;

_logger.$logger;

_integration.$integration;

_angular.$rootScope;

_angular.$document;

_angular.$location;

_squid.$Component;

_squid.$config;

_squid.$feature;

_squid.$pxp;

_squid.$locale;

_auth.$AuthModel;

_gdprCookieBanner.isGdprValid;

_dist.$DeviceInfo;

_thirdPartyInfo.thirdPartyExperience;

_fn.$fn;

_utils.getDolphinEligibility;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-checkout/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

__webpack_require__("../node_modules/jquery/dist/jquery.min.js");

__webpack_require__("../node_modules/xo-angular-shims-placeholder/dist/angular-shims-placeholder.min.js");

__webpack_require__("./js/lib/index.js");

__webpack_require__("../node_modules/xo-tracking/dist/index.js");

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _middleware = __webpack_require__("./js/lib/middleware.js");

__webpack_require__("./pages/xo-landing/route.js");

__webpack_require__("./pages/xo-login/route.js");

__webpack_require__("./pages/xo-generic-error/route.js");

__webpack_require__("./pages/xo-generic-message/route.js");

__webpack_require__("./pages/xo-select-fi/route.js");

__webpack_require__("./pages/xo-review/route.js");

__webpack_require__("./pages/xo-authorization-message/route.js");

__webpack_require__("./pages/xo-add-card/route.js");

__webpack_require__("./pages/xo-add-fi/route.js");

__webpack_require__("./pages/xo-add-card-meft/route.js");

__webpack_require__("./pages/xo-add-tax-id/route.js");

__webpack_require__("./pages/xo-add-shipping/route.js");

__webpack_require__("./pages/xo-add-national-id/route.js");

__webpack_require__("./pages/xo-update-card/route.js");

__webpack_require__("./pages/xo-eConsent/route.js");

__webpack_require__("./pages/xo-travel-rule/route.js");

__webpack_require__("./pages/xo-nbr/route.js");

__webpack_require__("./pages/xo-framebust/route.js");

__webpack_require__("./pages/xo-sepa/route.js");

__webpack_require__("./pages/xo-pay/index.js");

__webpack_require__("./pages/xo-end/route.js");

__webpack_require__("./pages/xo-de-guest/route.js");

__webpack_require__("../node_modules/xo-login-components/src/fullpage-onetouch-upsell/route.js");

__webpack_require__("../node_modules/xo-login-components/src/onetouch-interstitial/route.js");

__webpack_require__("./pages/xo-create-password/route.js");

__webpack_require__("./pages/xo-tokenization-info/route.js");

__webpack_require__("./pages/xo-pin-setup/route.js");

__webpack_require__("./pages/xo-venmo/route.js");

__webpack_require__("./pages/xo-third-party-wallet/route.js");

__webpack_require__("./pages/xo-third-party-info/route.js");

__webpack_require__("./pages/xo-inventory-soldout/route.js");

__webpack_require__("../node_modules/xo-page-components/src/done/route.js");

__webpack_require__("../node_modules/xo-form-components/src/phone/route.js");

__webpack_require__("../node_modules/xo-credit-components/src/banner-interstitial/route.js");

__webpack_require__("../node_modules/xo-credit-components/src/bml-display/route.js");

__webpack_require__("../node_modules/xo-credit-components/src/choose-credit-offer/route.js");

__webpack_require__("../node_modules/xo-credit-components/src/redirect-to-cape/route.js");

__webpack_require__("./pages/xo-pay-with-selection/route.js");

__webpack_require__("./pages/xo-checkout/directive.js");

/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
exports['default'] = _index.$Route.extend('$xoCheckoutRoute', {
    path: 'checkout',
    directive: 'xo-checkout',
    titleContent: 'base.payPal',
    defaultState: 'checkout.landing',
    middleware: _middleware.$Middleware,
    children: [{
        name: '$LandingRoute'
    }, {
        name: '$LoginRoute',
        attributes: {
            token: 'token'
        }
    }, {
        name: '$PayWithSelectionRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'pages/xo-pay-with-selection/route',
        slug: 'payWithSelection'
    }, {
        name: '$VenmoRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'pages/xo-venmo/route',
        slug: 'venmo'
    }, {

        name: '$BannerInterstitialRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'xo-credit-components/src/banner-interstitial/route',
        slug: 'bannerInterstitial'
    }, {
        name: '$ThirdPartyWalletFlowRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'pages/xo-third-party-wallet/route',
        slug: 'thirdPartyWalletFlow'
    }, {
        name: '$ThirdPartyInfoCollectFlowRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'pages/xo-third-party-info/route',
        slug: 'thirdPartyInfoCollectFlow'
    }, {
        name: '$GenericErrorRoute',
        lazyRoute: 'pages/xo-generic-error/route',
        slug: 'genericError'
    }, {
        name: '$ChooseCreditOfferRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'xo-credit-components/src/choose-credit-offer/route',
        slug: 'chooseCreditOffer'
    }, {
        name: '$RedirectToCapeRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'xo-credit-components/src/redirect-to-cape/route',
        slug: 'redirectToCape'
    }, {
        name: '$GenericMessageRoute',
        lazyRoute: 'pages/xo-generic-message/route',
        slug: 'genericMessage'
    }, {
        name: '$FullpageOnetouchUpsellRoute',
        lazyRoute: 'xo-login-components/src/fullpage-onetouch-upsell/route',
        slug: 'FullpageOnetouchUpsell'
    }, {
        name: '$OneTouchUpsellRoute',
        attributes: {
            'token': 'token'
        },
        lazyRoute: 'xo-login-components/src/onetouch-interstitial/route',
        slug: 'oneTouchUpsell'
    }, {
        name: '$SelectFiRoute',
        props: function props() {
            return { token: this.token };
        },

        lazyRoute: 'pages/xo-select-fi/route',
        slug: 'selectFi'
    }, {
        name: '$ReviewRoute'
    }, {
        name: '$AuthorizationMessageRoute',
        lazyRoute: 'pages/xo-authorization-message/route',
        slug: 'authorizationmessage'
    }, {
        name: '$AddPhoneRoute',
        lazyRoute: 'xo-form-components/src/phone/route',
        slug: 'addPhone'
    }, {
        name: '$AddCardPageRoute',
        lazyRoute: 'pages/xo-add-card/route',
        slug: 'pageAddCard'
    }, {
        name: '$AddFiPageRoute',
        lazyRoute: 'pages/xo-add-fi/route',
        slug: 'pageAddFi'
    }, {
        name: '$xoTokenizationInfoPageRoute',
        props: function props() {
            return { token: this.token };
        },

        lazyRoute: 'pages/xo-tokenization-info/route',
        slug: 'tokenizationInfo'
    }, {
        name: '$xoPinSetupPageRoute',
        props: function props() {
            return { token: this.token };
        },

        lazyRoute: 'pages/xo-pin-setup/route',
        slug: 'pinSetup'
    }, {
        name: '$AddCardMeftRoute',
        lazyRoute: 'pages/xo-add-card-meft/route',
        slug: 'pageAddCardMeft'
    }, {
        name: '$AddTaxIdRoute',
        lazyRoute: 'pages/xo-add-tax-id/route',
        slug: 'addTaxId'
    }, {
        name: '$TravelRuleRoute',
        lazyRoute: 'pages/xo-travel-rule/route',
        slug: 'travelRule'
    }, {
        name: '$AddNationalIdRoute',
        lazyRoute: 'pages/xo-add-national-id/route',
        slug: 'addNationalId'
    }, {
        name: '$UpdateCardPageRoute',
        lazyRoute: 'pages/xo-update-card/route',
        slug: 'updateCard'
    }, {
        name: '$AddShippingPageRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'pages/xo-add-shipping/route',
        slug: 'pageAddShipping'
    }, {
        name: '$xoSoldOutPageRoute',
        lazyRoute: 'pages/xo-inventory-soldout/route',
        slug: 'soldout'
    }, {
        name: '$xoEConsentPageRoute',
        props: function props() {
            var _this = this;

            return {
                token: this.token,
                success: function success() {
                    return _this.goto('this.review');
                }
            };
        },

        lazyRoute: 'pages/xo-eConsent/route',
        slug: 'econsent'

    }, {
        name: '$xoNbrDEPageRoute',
        props: function props() {
            return { token: this.token };
        },

        lazyRoute: 'pages/xo-nbr/route',
        slug: 'negativeBalanceRecovery'

    }, {
        name: '$xoFrameBustRoute',
        lazyRoute: 'pages/xo-framebust/route',
        slug: 'framebust'
    }, {
        name: '$SepaPageRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'pages/xo-sepa/route',
        slug: 'sepapage'
    }, {
        name: '$PayRoute',
        lazyRoute: 'pages/xo-pay/route',
        slug: 'pay'
    }, {
        name: '$EndRoute',
        slug: 'end'
    }, {
        name: '$xoDeGuest',
        lazyRoute: 'pages/xo-de-guest/route',
        slug: 'xoDeGuest'
    }, {
        name: '$BMLDisplay',
        attributes: {
            'review-url': 'reviewUrl'
        },
        lazyRoute: 'xo-credit-components/src/bml-display/route',
        slug: 'bmldisplay'
    }, {
        name: '$DoneRoute',
        lazyRoute: 'xo-page-components/src/done/route',
        slug: 'done'
    }, {
        name: '$xoPageCreatePasswordRoute',
        props: function props() {
            return {
                token: this.token
            };
        },

        lazyRoute: 'pages/xo-create-password/route',
        slug: 'createPassword'
    }]
}); /* dynamic-import */

/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */

/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */

_index.$Route;

_middleware.$Middleware;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-checkout/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"outerWrapper\" ng-class=\"[locale.country, locale.lang, miniBrowser?'minibrowser':'', isApp?'mobileApp':'']\" id=\"outerWrapper\" >\n    <xo-dolphin ng-if=\"isDolphinEligible\"></xo-dolphin>\n    <!-- Messenger BA .. HIDE this -->\n    <xo-merchant-header ng-if=\"!isMessengerBAIntegration\" token=\"token\"></xo-merchant-header>\n    <div id=\"wrapper\" class=\"clearfix\">\n        <div id=\"sliding-area\" tabindex=\"-1\">\n            <div id=\"main\" role=\"main\" tabindex=\"-1\">\n                <xo-header ng-if=\"displayHeader\" is-venmo-flow=\"showVenmoExperience\" token=\"token\" redirectiframe=\"redirectiframe\" redirect-lightbox=\"redirectLightbox\"></xo-header>\n                <div id=\"contents\">\n                    <div ui-view></div>\n                </div>\n            </div>\n        </div>\n        <xo-spinner></xo-spinner>\n    </div>\n    <!-- Messenger BA .. HIDE this -->\n    <xo-footer ng-if=\"!isMessengerBAIntegration\" token=\"token\" escape-hatch-incontext=\"escapeHatchInContext\" show-venmo-legal-links=\"showVenmoExperience\"></xo-footer>\n    <xo-login-overlay  token=\"token\"></xo-login-overlay>\n</div>\n<xo-gdpr-cookie-banner ng-if=\"isGdprValid()\"></xo-gdpr-cookie-banner>\n"

/***/ }),

/***/ "./pages/xo-create-password/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

__webpack_require__("../node_modules/xo-login-components/src/create-password/directive.js");

var _template = __webpack_require__("./pages/xo-create-password/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-create-password/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoPageCreatePasswordDirective', {
    tag: 'xo-page-create-password',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.auth = _auth.$AuthModel.instance();
            this.reason = _uiRouter.$stateParams.targetPage;
            this.onContinue = function () {
                return _this.goto('.passwordRecovery');
            };
            this.logout = function () {
                _logger.$logger.info('not_you_logout');
                _this.auth.logoutAndRedirect('NOT_YOU');
            };
        }
    }
});


_squid.$Component;

_uiRouter.$stateParams;

_auth.$AuthModel;

_logger.$logger;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-create-password/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoPageCreatePasswordRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-create-password/directive.js");

var _directive2 = _interopRequireDefault(_directive);

var _route = __webpack_require__("../node_modules/xo-login-components/src/password-recovery-overlay/route.js");

var _route2 = _interopRequireDefault(_route);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoPageCreatePasswordRoute = exports.$xoPageCreatePasswordRoute = _squid.$Route.extend('$xoPageCreatePasswordRoute', {
    path: 'createPassword',
    directive: _directive2['default'],
    trackingData: {
        fptiState: 'quick_security_check'
    },
    params: {
        targetPage: null
    },
    children: [{
        route: _route2['default'],
        props: function props() {
            var _this = this;

            return {
                token: this.token,
                cancel: function cancel() {
                    return _this.goto('^');
                },
                success: function success() {
                    return _this.goto('checkout.login');
                }
            };
        }
    }]
});

angular.value("$xoPageCreatePasswordRoute", $xoPageCreatePasswordRoute);
_squid.$Route;

/***/ }),

/***/ "./pages/xo-create-password/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-create-password/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"createPasswordPage\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\">\n            <p class=\"userEmail\" id=\"reviewUserInfo\">\n                {{ content('creditcard.hi', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                <span>\n                    <a track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"logout()\">{{ content('memberReview.notYou')}}</a>\n                </span>\n            </p>\n            <xo-create-password token=\"token\" reason=\"reason\" on-continue=\"onContinue\"></xo-create-password>\n        </div>\n        <div class=\"span10\">\n            <xo-value-props type=\"login\" title=\"{{content('login.propHead')}}\" text-content=\"login.propVal\"></xo-value-props>\n        </div>\n    </div>\n    <div ui-view></div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-de-guest/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoDeGuest = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _integration = __webpack_require__("./js/lib/integration.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _credit = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _profilemanagement = __webpack_require__("../node_modules/xo-models/src/profilemanagement/index.js");

var _util = __webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");

var $xoDeGuest = exports.$xoDeGuest = _squid.$ComponentRoute.extend('EndRoute', {
    path: 'xoDeGuest',
    resolve: {
        action: function action() {
            function returnMethod(merchantPreferences) {
                if (_integration.$integration.getConfig('RETURN_METHOD_BASED_ON_MERCHANT_PREFS') && merchantPreferences) {
                    return merchantPreferences.returnMethod();
                } else {
                    return 'GET';
                }
            }

            function returnUrl(checkoutAppData, merchantPreferences) {
                // When "redirect_uri" is passed as a query param
                if (_integration.$integration.getConfig('REDIRECT_QUERY_PARAM')) {
                    return _squid.$util.param('redirect_uri');
                }

                if (_integration.$integration.getConfig('RETURN_URL_FROM_MERCHANT_PREFS') && merchantPreferences) {
                    return checkoutAppData.urls.return_url || merchantPreferences.returnUrl();
                }

                // By default, use return_uri from checkout session
                return checkoutAppData.urls.return_url;
            }

            function returnParams(checkoutCart, checkoutAppData, checkoutSession, returnToMerchantMethod) {
                var params = {};

                params.PayerID = checkoutSession.payer.id;

                var billingData = checkoutCart.billing;

                if (billingData && billingData.ba_token && !checkoutAppData.legacy_billing_integration) {
                    params.ba_token = billingData.ba_token;
                }

                // When "redirect_uri" is passed as a query param
                if (_integration.$integration.getConfig('REDIRECT_QUERY_PARAM')) {
                    params.opType = 'payment';
                    params.return_uri = _squid.$util.buildURL(checkoutAppData.urls.return_url, params);
                    // token needs to be appended here after buildURL, to ensure it's not added twice to return_url
                    params.token = _angular.$rootScope.token;
                }

                return params;
            }

            function getMerchantPreferences(dataModel) {
                if (_integration.$integration.getConfig('POPULATE_MERCHANT_PREFERENCES')) {
                    return (0, _squid.$populate)(dataModel, {
                        merchantPreferences: _profilemanagement.$MerchantPreferenceModel.instance(dataModel.payee.merchant.id)
                    });
                } else {
                    return _angular.$q.when();
                }
            }

            var models = {};
            var capeData = {};

            return (0, _squid.$populate)(models, {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
                checkoutCart: _index.$CheckoutCartModel.instance(_angular.$rootScope.token),
                payee: _index.$CheckoutPayeeModel.instance(_angular.$rootScope.token)
            }).then(function () {
                return getMerchantPreferences(models);
            }).then(function () {
                var creditDataModel = _credit.$CreditDataModel.instance(_angular.$rootScope.token);

                return creditDataModel.action('readCreditKey', {
                    data: {
                        capeKey: creditDataModel.getCapeKey()
                    },
                    success: function success(res) {
                        capeData = res;
                        return (0, _squid.$populate)(models, {
                            creditDataModel: creditDataModel
                        });
                    },
                    contingencies: {
                        DEFAULT: _squid.$promise.reject
                    },
                    error: _squid.$promise.reject
                });
            }).then(function () {
                var financial_instrument_id = capeData.financial_instrument_id.indexOf('BC') !== 0 ? 'BC' + capeData.financial_instrument_id : capeData.financial_instrument_id;
                var checkoutSession = _index.$CheckoutSessionModel.instance(_angular.$rootScope.token);

                return checkoutSession.action('create', {
                    data: {
                        pmode: 'FAST',
                        preselected_fi: financial_instrument_id,
                        ftype: 'GUEST_ACQUISITION'
                    },
                    params: {
                        pmode: 'FAST',
                        preselected_fi: financial_instrument_id,
                        ftype: 'GUEST_ACQUISITION'
                    },
                    success: function success() {
                        return (0, _squid.$populate)(models, {
                            checkoutSession: checkoutSession
                        });
                    },
                    contingencies: {
                        DEFAULT: _squid.$promise.reject
                    },
                    error: _squid.$promise.reject
                });
            }).then(function () {
                var url = returnUrl(models.checkoutAppData, models.merchantPreferences);
                var returnToMerchantMethod = returnMethod(models.merchantPreferences);
                var params = returnParams(models.checkoutCart, models.checkoutAppData, models.checkoutSession, returnToMerchantMethod);

                return models.checkoutSession.action('authorize', {
                    data: {
                        pmode: 'FAST'
                    },
                    success: function success() {
                        if (returnToMerchantMethod === 'POST') {
                            _util.$ReturnToMerchant.postTo(url, params);
                        } else {
                            // if PDT is disabled don't send params in the url
                            if (models.merchantPreferences && !models.merchantPreferences.pdtEnabled()) {
                                return _util.$ReturnToMerchant.goTo(url);
                            }
                            _util.$ReturnToMerchant.goTo(_squid.$util.buildURL(url, params));
                        }
                    },
                    contingencies: {
                        DEFAULT: _squid.$promise.reject
                    },
                    error: _squid.$promise.reject
                });
            })['catch'](function () {
                return 'checkout.genericError';
            });
        }
    }
});

angular.value("$xoDeGuest", $xoDeGuest);
_angular.$q;

_angular.$rootScope;

_integration.$integration;

_squid.$ComponentRoute;

_squid.$populate;

_squid.$promise;

_squid.$util;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_index.$CheckoutSessionModel;

_credit.$CreditDataModel;

_profilemanagement.$MerchantPreferenceModel;

_util.$ReturnToMerchant;

/***/ }),

/***/ "./pages/xo-eConsent/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _index4 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _util = __webpack_require__("./pages/xo-login/util.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

var _template = __webpack_require__("./pages/xo-eConsent/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-eConsent/styles.less");

var _factory = __webpack_require__("./pages/xo-login/tokenized-wallet-loader/factory.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Component.extend('$xoEConsentPageDirective', {
    tag: 'xo-econsent-page',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        success: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token),
                eConsent: _index4.$EConsentModel.instance(),
                checkoutCart: _index2.$CheckoutCartModel.instance(this.props.token).retrieve(),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
                tokenizedWalletEligibility: _index3.$TokenizedWalletEligibilityModel.instance(this.props.token),
                tokenizedWalletPin: _index3.$TokenizedWalletPinModel.instance(this.props.token),
                tokenizedWalletInfoModel: _index3.$TokenizedWalletInfoModel.instance(this.props.token).retrieve(),
                tokenizedWalletMsbOffer: _index3.$TokenizedWalletMsbOfferModel.instance(this.props.token)
            };
        }
    },
    lifecycle: {
        enter: function enter() {
            this.locale = _index.$locale;
        }
    },
    actions: {
        submit: function submit() {
            var _this = this;

            var self = this;
            var fptiData = {
                from: 'CREATE_XO_SESSION',
                to: 'process_create_xo_session'
            };

            var hardErrors = ['RESTRICTED_USER', 'PAYEE_BLOCKED_TRANSACTION', 'PAYMENT_ALREADY_DONE', 'PAYMENT_DENIED', 'PAYEE_ACCOUNT_RESTRICTED', 'INVALID_RESOURCE_ID', 'EXPIRED_SESSION', 'PAYER_COUNTRY_NOT_ALLOWED', 'PAYER_LOGIN_COUNTRY_NOT_ALLOWED', 'GAMING_FUNDING_SOURCE_VALIDATION_FAILED'];

            self.handleSymphonyContingency = function (name, err) {
                // Check if negative case has been previously handled.
                if (!self.dependencyEligibility) {
                    return;
                }

                var errorCode = err.cause || name;

                fptiData.int_error_code = errorCode;
                fptiData.error_source = 'paymentapiplatformserv';
                fptiData.error_type = hardErrors.indexOf(errorCode) > -1 ? 'hard_decline' : 'soft_decline';
                _logger.$logger.info('checkout_fpti', fptiData);
                throw err;
            };

            self.handleSymphonyNoValidTopupFiContingency = function (name, err) {
                // Check if negative case has been previously handled.
                if (!self.dependencyEligibility) {
                    return;
                }

                if (self.models.checkoutCart.isWalletTokenization()) {
                    fptiData.int_error_code = err.cause;
                    fptiData.error_source = 'paymentapiplatformserv';
                    fptiData.error_type = hardErrors.indexOf(err.cause) > -1 ? 'hard_decline' : 'soft_decline';
                    _logger.$logger.info('checkout_fpti', fptiData);

                    self.models.checkoutSession.contingency = name;
                    return _factory.$TokenizedWalledLoaderFactory.goToTokenizationInfoPage();
                } else {
                    self.handleSymphonyContingency(name, err);
                }
            };

            // We use this flag to tell if negative case has been previously handled.
            self.dependencyEligibility = true;

            // We use this flag to decide if we should to review page.
            // Set this to false if the next page is no review page.
            self.proceedToReview = true;

            var isPayPalCredit = self.models.checkoutAppData.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';

            var eConsentBatch = [this.models.eConsent.save({
                batch: {
                    name: 'econsent',
                    id: 'accept'
                }
            }), this.models.checkoutSession.action('create', {
                data: {
                    baToken: this.models.checkoutCart.get('billing.ba_token'),
                    preselected_fi_type: isPayPalCredit ? 'credit' : undefined,
                    clear_installments: true
                },
                success: function success(result) {
                    // Check if negative case has been previously handled.
                    if (!self.dependencyEligibility) {
                        return;
                    }

                    _logger.$logger.info('checkout_fpti', {
                        from: 'CREATE_XO_SESSION',
                        to: 'process_create_xo_session'
                    });

                    // consider negative balance first
                    if (self.models.checkoutSession.negBals) {
                        self.proceedToReview = false;
                        return _uiRouter.$state.go('checkout.negativeBalanceRecovery');
                    }

                    // Handle routing to cape for second button
                    if (isPayPalCredit) {
                        self.proceedToReview = false;
                        return _util.$capeRedirectUtil.handleCapeRouting(result, self.models.checkoutCart, self.props.token);
                    }

                    // Check for tokenized wallet
                    if (self.models.checkoutCart.isWalletTokenization()) {
                        return _factory.$TokenizedWalledLoaderFactory.goToTokenizationInfoPage();
                    }
                },

                contingencies: {
                    NEED_DEBIT_CARD: self.handleSymphonyNoValidTopupFiContingency,
                    EXPIRED_DEBIT_CARD: self.handleSymphonyNoValidTopupFiContingency,
                    DEFAULT: self.handleSymphonyContingency
                },
                batch: {
                    name: 'econsent',
                    id: 'createCheckout',
                    dependencies: self.models.checkoutCart.isWalletTokenization() ? ['accept', 'tokenizedWalletLightEligibility', 'tokenizedWalletPin'] : ['accept']
                }
            })['finally'](function () {
                // selectedInstallmentsData does not come from checkoutSession response from PAPS, so we need to keep track of this state ourselves.
                // We pass clear_installments when calling the checkout session API, so we need to reflect that this is being cleared.
                // See https://engineering.paypalcorp.com/jira/browse/PPPLMER-58580
                delete _this.models.checkoutSession.selectedInstallmentData;
            })];

            if (self.models.checkoutCart.isWalletTokenization()) {
                // Wallet tokenization always goes tokenization info page unless there is an error
                // which is tracked by a separate flag.
                self.proceedToReview = false;

                // these params are coming from Mayfly (see xo-hermes-app/apis/tokenizedWalletInfo)
                var _self$models$tokenize = self.models.tokenizedWalletInfoModel,
                    wallet_id = _self$models$tokenize.wallet_id,
                    external_device_id = _self$models$tokenize.external_device_id,
                    tr_client_id = _self$models$tokenize.tr_client_id,
                    product_name = _self$models$tokenize.product_name;

                var subject = self.models.tokenizedWalletInfoModel.getSubject();

                // TODO: move to TokenizedWalletInfoModel
                var WALLET_BRANDS = {
                    'google': 'APAY',
                    'Samsung': 'SAMSUNGPAY'
                };

                var params = {
                    wallet_brand: WALLET_BRANDS[subject],
                    tenant_id: 'Hermes',
                    wallet_id: wallet_id,
                    external_device_id: external_device_id,
                    subject: subject,
                    tr_client_id: tr_client_id,
                    product_name: product_name
                };

                if (_config.$meta.query && _config.$meta.query.wallet_id) {
                    params.wallet_id = _config.$meta.query.wallet_id;
                }
                if (_config.$meta.query && _config.$meta.query.jwt) {
                    params.jwt = _config.$meta.query.jwt;
                }

                eConsentBatch.push(this.models.tokenizedWalletEligibility.retrieve({
                    params: params,

                    success: function success(result) {
                        if (!result.eligible) {
                            var msg = 'tokenized_wallet_ineligible_for_provisioning';

                            _logger.$logger.info(msg);

                            fptiData.int_error_code = result.reason;
                            fptiData.error_source = 'paymenttokenserv';
                            fptiData.error_type = 'hard_decline';
                            _logger.$logger.info('checkout_fpti', fptiData);

                            self.dependencyEligibility = false;
                            var code = result.reason === 'WALLET_ID_ALREADY_PROVISIONED' ? 'ANDROID_PAY_ALREADY_PROVISIONED' : 'ANDROID_PAY_ELIGIBILITY_ERROR';

                            code = window.btoa(code);
                            return _uiRouter.$state.go('checkout.genericError', {
                                code: code
                            });
                        }
                    },


                    batch: {
                        name: 'econsent',
                        id: 'tokenizedWalletLightEligibility',
                        dependencies: ['accept']
                    }
                }));

                eConsentBatch.push(this.models.tokenizedWalletPin.retrieve({
                    success: function success(result) {
                        if (result.pinId) {
                            _logger.$logger.info('tokenized_wallet_get_pin_set', { pinOrigin: result.pinOrigin, pinId: result.pinId });
                        } else {
                            _logger.$logger.info('tokenized_wallet_get_pin_not_set');
                        }
                    },


                    contingencies: {
                        DEFAULT: function DEFAULT(name, err) {
                            _logger.$logger.info('tokenized_wallet_get_pin_error');
                        }
                    },

                    batch: {
                        name: 'econsent',
                        id: 'tokenizedWalletPin',
                        dependencies: ['accept']
                    }
                }));

                eConsentBatch.push(this.models.tokenizedWalletMsbOffer.retrieve({
                    params: {
                        tokenizedWalletToken: this.models.checkoutCart.tokenizedWalletToken
                    },
                    batch: {
                        name: 'econsent',
                        id: 'tokenizedWalletMsbOffer',
                        dependencies: ['accept']
                    },
                    success: function success(result) {
                        var msg = 'tokenized_wallet_msb_offer';

                        if (result && result.enabled) {
                            _logger.$logger.info(msg + '_enabled', result);
                        } else {
                            _logger.$logger.info(msg + '_disabled');
                        }
                    }
                }));
            }

            return _angular.$q.all(eConsentBatch).then(function () {
                if (self.proceedToReview) {
                    return _this.props.success();
                }
            });
        }
    }
});


_angular.$q;

_logger.$logger;

_index.$Component;

_index.$locale;

_index2.$CheckoutSessionModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutAppDataModel;

_index3.$TokenizedWalletEligibilityModel;

_index3.$TokenizedWalletPinModel;

_index3.$TokenizedWalletInfoModel;

_index3.$TokenizedWalletMsbOfferModel;

_index4.$EConsentModel;

_util.$capeRedirectUtil;

_uiRouter.$state;

_config.$meta;

_squid.$Class;

_factory.$TokenizedWalledLoaderFactory;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-eConsent/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoEConsentPageRoute = undefined;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-eConsent/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoEConsentPageRoute = exports.$xoEConsentPageRoute = _index.$Route.extend('$xoEConsentPageRoute', {

    path: 'econsent',
    directive: _directive2['default'],
    titleContent: 'eConsent.title',

    trackingData: {
        fptiState: 'econsent',
        templateName: 'eConsent.dust',
        pageGoal: 'eConsent',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-econsent',
                'pagename2': '%::fullpage-econsent:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },

    children: []
});

angular.value("$xoEConsentPageRoute", $xoEConsentPageRoute);
_index.$Route;

/***/ }),

/***/ "./pages/xo-eConsent/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-eConsent/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"eConsent\" id=\"eConsent\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\">\n            <xo-message message=\"errorMessage\"></xo-message>\n            <xo-title title-txt=\"{{content('eConsent.title')}}\"></xo-title>\n            <form name=\"eConsentForm\" class=\"proceed\" content novalidate=\"novalidate\" autocomplete=\"off\">\n                <p class=\"content\">{{content('eConsent.consent')}}</p>\n\n                <div class=\"agree checkbox legal\">\n                    <input ng-model=\"fields.agree\" type=\"checkbox\" name=\"agree\" id=\"agree\" data-error-text=\"{{content('eConsent.eConsentError')}}\" xo-error-tooltip required />\n                    <label class=\"noBottom\" for=\"agree\" data-test-id=\"eConsentLabel\" ng-bind-html=\"content('eConsent.agreement')\"></label>\n                </div>\n                <div class=\"buttons\">\n                    <input track-submit type=\"submit\" id=\"submitEConsent\" value=\"{{content('common.agreeAndContinue')}}\" class=\"btn full\" validate-submit=\"actions.submit()\" />\n                </div>\n            </form>\n        </div>\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"review\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"review\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-end/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$EndRoute = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _util = __webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");

var _returnParams = __webpack_require__("../node_modules/xo-page-components/src/returnParams/index.js");

var _profilemanagement = __webpack_require__("../node_modules/xo-models/src/profilemanagement/index.js");

var $EndRoute = exports.$EndRoute = _squid.$ComponentRoute.extend('EndRoute', {
    path: 'end',
    trackingData: {
        fptiState: 'back_to_merchant',
        trackStateExit: true
    },
    resolve: {
        action: function action() {
            function returnMethod(merchantPreferences) {
                if (_squid.$integration.getConfig('RETURN_METHOD_BASED_ON_MERCHANT_PREFS') && merchantPreferences) {
                    return merchantPreferences.returnMethod();
                } else {
                    return 'GET';
                }
            }

            function returnUrl(checkoutAppData, merchantPreferences) {
                var return_uri = checkoutAppData.urls && checkoutAppData.urls.return_url;

                if (checkoutAppData.is_wps_subscription_flow()) {
                    return _squid.$config.urls.wpsSubscriptionReturnUrl;
                }

                // When "redirect_uri" is passed as a query param
                if (_squid.$integration.getConfig('REDIRECT_QUERY_PARAM')) {
                    return _squid.$util.param('redirect_uri') || return_uri;
                }

                if (_squid.$integration.getConfig('RETURN_URL_FROM_MERCHANT_PREFS') && merchantPreferences) {
                    return return_uri || merchantPreferences.returnUrl();
                }

                // By default, use return_uri from checkout session
                return return_uri;
            }

            function returnParams(checkoutCart, checkoutSession, checkoutAppData, returnToMerchantMethod) {
                if (checkoutAppData.is_wps_subscription_flow()) {
                    return {
                        token: _squid.$meta.token,
                        mfid: _squid.$meta.mfid,
                        mode: 'member',
                        'country.x': _squid.$locale.country,
                        'locale.x': _squid.$locale.lang + '_' + _squid.$locale.country
                    };
                }

                var params = {};

                // Don't post PayerID for RT without purchase
                if (_squid.$integration.getConfig('ALLOW_PAYER_ID_RETURN_PARAM') && !checkoutCart.isBillingNoPurchase()) {
                    params.PayerID = checkoutSession.payer.id;
                }

                var billingData = checkoutCart.billing;

                if (billingData && billingData.ba_token && !checkoutAppData.legacy_billing_integration) {
                    params.ba_token = billingData.ba_token;
                }

                if (_squid.$integration.isFlow('WPS')) {
                    var isCartUpload = checkoutAppData.flags.is_cart_upload_flow || checkoutAppData.flags.is_shopping_cart_flow;

                    params = (0, _returnParams.$returnParams)(checkoutCart, checkoutSession, returnToMerchantMethod, 'WPS', isCartUpload);
                }

                // When "redirect_uri" is passed as a query param
                if (_squid.$integration.getConfig('REDIRECT_QUERY_PARAM')) {
                    params.intent = checkoutCart.payment_action;
                    params.opType = 'payment';
                    params.return_uri = _squid.$util.buildURL(checkoutAppData.urls.return_url, params);

                    // token needs to be appended here after buildURL, to ensure it's not added twice to return_url
                    params.token = _angular.$rootScope.token;
                }

                return params;
            }

            function getMerchantPreferences(dataModel) {
                if (_squid.$integration.getConfig('POPULATE_MERCHANT_PREFERENCES')) {
                    return (0, _squid.$populate)(dataModel, {
                        merchantPreferences: _profilemanagement.$MerchantPreferenceModel.instance(dataModel.payee.merchant.id)
                    });
                } else {
                    return _angular.$q.when();
                }
            }

            var models = {};

            return (0, _squid.$populate)(models, {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
                checkoutCart: _index.$CheckoutCartModel.instance(_angular.$rootScope.token),
                checkoutSession: _index.$CheckoutSessionModel.instance(_angular.$rootScope.token),
                payee: _index.$CheckoutPayeeModel.instance(_angular.$rootScope.token)
            }).then(function () {
                return getMerchantPreferences(models);
            }).then(function () {
                var url = returnUrl(models.checkoutAppData, models.merchantPreferences);
                var returnToMerchantMethod = returnMethod(models.merchantPreferences);
                var params = returnParams(models.checkoutCart, models.checkoutSession, models.checkoutAppData, returnToMerchantMethod);

                if (models.checkoutAppData.is_wps_subscription_flow()) {
                    _squid.$util.redirect(_squid.$util.paypalURL(url, params));
                }

                // if V4 in-context integration, we'll call the onAuthorize handler.
                if (window.xchild) {
                    _logger.$logger.done();
                    _angular.$rootScope.$emit('loading');

                    var xparams = {
                        paymentToken: _angular.$rootScope.token,
                        orderID: _angular.$rootScope.token,
                        billingToken: params['ba_token'],
                        payerID: params['PayerID'],
                        paymentID: params['paymentId'] || models.checkoutAppData.payment_id,
                        intent: models.checkoutCart.payment_action
                    };

                    if (url) {
                        xparams.returnUrl = _squid.$util.buildURL(url, params);
                    }
                    return window.xprops.onAuthorize(xparams);
                }

                if (returnToMerchantMethod === 'POST') {
                    _util.$ReturnToMerchant.postTo(url, params);
                } else {
                    // if PDT is disabled don't send params in the url
                    if (models.merchantPreferences && !models.merchantPreferences.pdtEnabled()) {
                        return _util.$ReturnToMerchant.goTo(url);
                    }
                    _util.$ReturnToMerchant.goTo(_squid.$util.buildURL(url, params));
                }

                return _squid.$unresolved;
            });
        }
    }
});

angular.value("$EndRoute", $EndRoute);
_angular.$q;

_angular.$rootScope;

_logger.$logger;

_squid.$meta;

_squid.$util;

_squid.$config;

_squid.$locale;

_squid.$populate;

_squid.$unresolved;

_squid.$integration;

_squid.$ComponentRoute;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_index.$CheckoutSessionModel;

_index.$CheckoutAppDataModel;

_util.$ReturnToMerchant;

_returnParams.$returnParams;

_profilemanagement.$MerchantPreferenceModel;

/***/ }),

/***/ "./pages/xo-framebust/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoFrameBustPageDirective = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getCenterPosition = getCenterPosition;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _icFallback = __webpack_require__("./js/lib/icFallback.js");

var _template = __webpack_require__("./pages/xo-framebust/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-framebust/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getCenterPosition(_ref) {
    var width = _ref.width,
        height = _ref.height;


    var left = void 0;
    var top = void 0;

    if (width) {
        if (window.outerWidth) {
            left = Math.round((window.outerWidth - width) / 2) + window.screenX;
        } else if (window.screen.width) {
            left = Math.round((window.screen.width - width) / 2);
        }
    }

    if (height) {
        if (window.outerHeight) {
            top = Math.round((window.outerHeight - height) / 2) + window.screenY;
        } else if (window.screen.height) {
            top = Math.round((window.screen.height - height) / 2);
        }
    }

    return { left: left, top: top };
}

var $xoFrameBustPageDirective = exports.$xoFrameBustPageDirective = _index.$Component.extend('$xoFrameBustPageDirective', {

    tag: 'xo-framebust-page',
    template: _template2['default'],

    props: {},

    resolve: {},

    actions: {
        submit: function submit() {

            window.xchild.hide();

            var url = decodeURIComponent(_uiRouter.$stateParams.url);

            if (_uiRouter.$stateParams.action === 'open') {

                var xprops = _extends({}, window.xprops);

                xprops.url = url;

                _logger.$logger.warn('framebust_click_to_hermes');

                return window.ppxo.Checkout.renderPopupTo(window.xchild.getParentRenderWindow(), xprops);
            }

            if (_uiRouter.$stateParams.action === 'fallback') {

                _logger.$logger.warn('framebust_click_to_legacy');

                var width = 970;
                var height = 850;

                var _getCenterPosition = getCenterPosition({ width: width, height: height }),
                    left = _getCenterPosition.left,
                    top = _getCenterPosition.top;

                var win = window.open(url, 'hermes_fallback', 'width=' + width + ',height=' + height + ',top=' + top + ',left=' + left);

                (0, _icFallback.$incontextFallback)(win, url);
            }
        }
    }
});

angular.value("getCenterPosition", getCenterPosition);
angular.value("$xoFrameBustPageDirective", $xoFrameBustPageDirective);
_logger.$logger;

_uiRouter.$stateParams;

_index.$Component;

_icFallback.$incontextFallback;

/***/ }),

/***/ "./pages/xo-framebust/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoFrameBustRoute = undefined;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-framebust/directive.js");

var $xoFrameBustRoute = exports.$xoFrameBustRoute = _index.$Route.extend('$xoFrameBustRoute', {

    path: 'framebust',
    directive: _directive.$xoFrameBustPageDirective,

    auth: false,

    query: ['action', 'url'],

    children: []
});

angular.value("$xoFrameBustRoute", $xoFrameBustRoute);
_index.$Route;

_directive.$xoFrameBustPageDirective;

/***/ }),

/***/ "./pages/xo-framebust/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-framebust/template.html":
/***/ (function(module, exports) {

module.exports = "<form content novalidate=\"novalidate\" autocomplete=\"off\">\n    <input type=\"submit\" value=\"{{ content('login.loginBtn') }}\" class=\"btn full loginBtn frameBustBtn\" ng-click=\"actions.submit()\" />\n</form>\n\n\n"

/***/ }),

/***/ "./pages/xo-generic-error/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoGenericErrorPageComponent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/generic-error/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

var _template = __webpack_require__("./pages/xo-generic-error/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoGenericErrorPageComponent = exports.$xoGenericErrorPageComponent = _squid.$Component.extend('$xoGenericErrorPageComponent', {
    tag: 'xo-generic-error-page',
    template: _template2['default'],

    controller: ['$scope', function ($scope) {

        $scope.token = _angular.$rootScope.token;

        var models = {};

        (0, _squid.$populate)(models, {
            auth: _auth.$AuthModel.instance().retrieve()
        }).then(function () {

            $scope.logout = function () {

                if (window.xchild && _squid.$util.isIFrame()) {

                    window.xchild.hide();

                    var url = window.location.href.split('#')[0];

                    var xprops = _extends({}, window.xprops);

                    xprops.url = url;
                    xprops.payment = function () {
                        return models.auth.logout().then(function () {
                            return $scope.token;
                        });
                    };

                    return window.ppxo.Checkout.renderPopupTo(window.xchild.getParentRenderWindow(), xprops);
                }

                models.auth.logoutAndRedirect('GENERIC_ERROR');
            };
        });

        var terminalKey = 'terminal-error-' + $scope.token,
            refreshKey = 'has-seen-error-' + $scope.token;

        if (!_squid.$util.sessionStorageEnabled() || !$scope.token || sessionStorage.getItem(terminalKey)) {
            return renderErrorPage();
        }

        // Google Pay - acount linking: show error page immediately without trying to redirect user to the login screen
        // as it's not allowed for the user to switch accounts in this flow
        if (_auth.$AuthModel.instance() && _auth.$AuthModel.instance().disallow_login_switch) {
            return renderErrorPage();
        }

        // is not a refresh
        if (!sessionStorage.getItem(refreshKey)) {
            sessionStorage.setItem(refreshKey, '1');
            return renderErrorPage();
        }

        // is a refresh
        else {
                _logger.$logger.info('checkout_fpti', {
                    user_refresh: 1
                });

                sessionStorage.removeItem(refreshKey);

                _uiRouter.$state.go('checkout.login')['catch'](function () {
                    return (
                        // don't try to do this again
                        sessionStorage.setItem(terminalKey, '1')
                    );
                });
            }

        function renderErrorPage() {
            // prevent render flicker
            $scope.shouldRender = true;
        }
    }]
});

angular.value("$xoGenericErrorPageComponent", $xoGenericErrorPageComponent);
_angular.$rootScope;

_squid.$Component;

_squid.$populate;

_squid.$util;

_uiRouter.$state;

_logger.$logger;

_auth.$AuthModel;

/***/ }),

/***/ "./pages/xo-generic-error/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$GenericErrorRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("./pages/xo-generic-error/directive.js");

var $GenericErrorRoute = exports.$GenericErrorRoute = _squid.$ComponentRoute.extend('$GenericErrorRoute', {
    path: 'genericError',
    directive: 'xo-generic-error-page',
    titleContent: 'genericError.pleaseTryAgain',
    query: ['code'],
    // need to find these values
    trackingData: {
        fptiState: 'fatal_error',
        templateName: 'genericError.dust',
        pageGoal: 'Generic Error',
        pageQualifier: 'blockNonDomesticShipping',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-generic-error',
                'pagename2': '%::fullpage-generic-error:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    auth: false,
    children: []
});

angular.value("$GenericErrorRoute", $GenericErrorRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-generic-error/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-generic-error ng-if=shouldRender token=token logout=logout></xo-generic-error>\n"

/***/ }),

/***/ "./pages/xo-generic-message/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoGenericMessagePageComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/generic-message/directive.js");

var _template = __webpack_require__("./pages/xo-generic-message/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoGenericMessagePageComponent = exports.$xoGenericMessagePageComponent = _squid.$Component.extend('$xoGenericMessagePageComponent', {
    tag: 'xo-generic-message-page',
    template: _template2['default'],

    controller: ['$scope', function ($scope) {

        $scope.token = _angular.$rootScope.token;

        (0, _jquery2['default'])('#defaultCancelLink').hide();

        _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            event.preventDefault();
        });
    }]
});

angular.value("$xoGenericMessagePageComponent", $xoGenericMessagePageComponent);
_angular.$rootScope;

_squid.$Component;

/***/ }),

/***/ "./pages/xo-generic-message/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$GenericMessageRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("./pages/xo-generic-message/directive.js");

var $GenericMessageRoute = exports.$GenericMessageRoute = _squid.$ComponentRoute.extend('$GenericMessageRoute', {
    path: 'genericMessage',
    directive: 'xo-generic-message-page',
    query: ['code'],
    // need to find these values
    trackingData: {},
    auth: false,
    children: []
});

angular.value("$GenericMessageRoute", $GenericMessageRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-generic-message/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-generic-message token=token></xo-generic-message>\n"

/***/ }),

/***/ "./pages/xo-inventory-soldout/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _util = __webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");

__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");

var _template = __webpack_require__("./pages/xo-inventory-soldout/template.html");

var _template2 = _interopRequireDefault(_template);

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoSoldoutPageDirective', {
    tag: 'xo-soldout-page',
    template: _template2['default'],
    auth: false,

    actions: {
        continueShoppingHandler: function continueShoppingHandler() {
            _util.$ReturnToMerchant.goTo(decodeURIComponent(_uiRouter.$state.params.soldOutUrl), true);
        }
    },
    lifecycle: {
        enter: function enter() {
            this.locale = _squid.$locale;
            angular.element('.paypalHeader').css('display', 'none');
            angular.element('#defaultCancelLink').css('display', 'none');
        },
        populate: function populate() {
            this.item_name = decodeURIComponent(_uiRouter.$state.params.items);
        }
    }

});


_squid.$Component;

_squid.$locale;

_util.$ReturnToMerchant;

_uiRouter.$state;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-inventory-soldout/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoSoldOutPageRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-inventory-soldout/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSoldOutPageRoute = exports.$xoSoldOutPageRoute = _squid.$ComponentRoute.extend('$xoSoldOutPageRoute', {
    path: 'soldout',
    directive: _directive2['default'],
    titleContent: 'soldout.title',
    query: ['items', 'soldOutUrl'],
    auth: false,
    trackingData: {
        fptiState: 'soldout',
        templateName: 'soldout.dust',
        pageGoal: 'soldout page',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-soldout',
                'pagename2': '%::fullpage-soldout:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },
    children: []
});

angular.value("$xoSoldOutPageRoute", $xoSoldOutPageRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-inventory-soldout/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"soldOut\" content>\n    <div id=\"soldouticon\">\n        <div class=\"left_section\"> </div>\n\n        <div class=\"text_lines\">\n            <span id=\"text\">{{content ('soldout.icon')}}</span>\n        </div>\n\n        <div id=\"rightSection\">\n            <span class=\"shape-right\">   </span>\n        </div>\n    </div>\n\n    <div class=\"soldOutMessage\" ng-bind-html=\"htmlContent('soldout.message', {item: item_name})\">\n    </div>\n    <div>\n        <input id= \"Continue-Shopping\" class=\"btn full confirmButton continueButton\" type=\"button\" value=\"{{content ('soldout.continueShoppingButton')}}\" ng-click=\"actions.continueShoppingHandler()\"/>\n\n    </div>\n\n</div>\n"

/***/ }),

/***/ "./pages/xo-landing/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$LandingRoute = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _credit = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _inventory = __webpack_require__("../node_modules/xo-models/src/inventory/index.js");

var $LandingRoute = exports.$LandingRoute = _squid.$ComponentRoute.extend('$LandingRoute', {
    path: 'landing',
    trackingData: {
        fptiState: 'landing',
        trackStateExit: true
    },
    auth: false,
    resolve: {

        action: function action() {

            var models = {};

            return (0, _squid.$populate)(models, {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
                checkoutCart: _index.$CheckoutCartModel.instance(_angular.$rootScope.token),
                auth: _auth.$AuthModel.instance(),
                checkoutPayeeModel: _index.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
                flowEligibility: _index.$FlowEligibilityModel.instance(_angular.$rootScope.token).retrieve({
                    params: {
                        localeCountry: _squid.$locale.country, // We need this till we completely migrate to server side locale resolution
                        braintreeInegration: _squid.$util.param('bt_int_type') === '2' ? 'SFAuthSession' : '',
                        fundingSource: _squid.$util.param('fundingSource')
                    }
                })
            }).then(function () {
                var forced_signup_offered = models.flowEligibility.guest ? 0 : 1;

                _logger.$logger.info('checkout_fpti', { 'from': 'LANDING_PAGE_PARAM', 'forced_signup_offered': forced_signup_offered });

                var landingFlow = function landingFlow() {
                    var merchantCountry = models.checkoutAppData.get('merchant.merchant_country', 'US');
                    var supportBlockNonDomesticShipping = (0, _squid.$feature)('supportBlockNonDomesticShipping', false, merchantCountry);
                    var prefillShippingAddress = models.checkoutCart.get('purchase.shipping_address');
                    var blockNonDomesticShipping = models.checkoutAppData.get('flags.block_non_domestic_shipping');
                    var allowChangeShipping = models.checkoutAppData.get('flags.allow_change_shipping');

                    if (supportBlockNonDomesticShipping && blockNonDomesticShipping) {
                        _logger.$logger.info('block_non_domestic_shipping', {
                            block_non_domestic_shipping: blockNonDomesticShipping,
                            allow_change_shipping: allowChangeShipping,
                            setec_shipping_country_code: prefillShippingAddress
                        });
                    }

                    var shouldBlockBuyer = supportBlockNonDomesticShipping && blockNonDomesticShipping && !allowChangeShipping && prefillShippingAddress && prefillShippingAddress.country_code !== merchantCountry && prefillShippingAddress.country_code !== '';

                    if (shouldBlockBuyer) {
                        return {
                            to: 'checkout.genericError',
                            params: {
                                code: 'BLOCK_NON_DOMESTIC_SHIPPING'
                            }
                        };
                    }

                    var isPayPalCredit = models.checkoutAppData.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';

                    if (isPayPalCredit) {
                        var creditDataModel = _credit.$CreditDataModel.instance(_angular.$rootScope.token);
                        var isCapeReturnKey = creditDataModel.getCapeKey();
                        var offers = new _index2.$CreditInstallmentOptionsModel({
                            id: _angular.$rootScope.token,
                            payee: models.checkoutPayeeModel,
                            checkoutCart: models.checkoutCart,
                            checkoutAppData: models.checkoutAppData,
                            isMemberCredit: true
                        });
                        var isInstallmentEligible = models.flowEligibility && models.flowEligibility.installment;
                        var country = models.checkoutAppData.get('merchant.merchant_country');
                        var installmentOptions = void 0;

                        return offers.save({
                            cache: true,
                            success: function success() {
                                installmentOptions = offers.getInstallmentOptionsPresent();

                                if (isCapeReturnKey) {
                                    if (country === 'DE') {
                                        return 'checkout.xoDeGuest';
                                    }
                                    return 'checkout.login';
                                } else if (country === 'GB' || isInstallmentEligible && installmentOptions) {
                                    _logger.$logger.info('ppc_second_btn_acquisition');
                                    return 'checkout.chooseCreditOffer';
                                } else if (country === 'DE') {

                                    if (installmentOptions) {

                                        return 'checkout.chooseCreditOffer';
                                    } else {

                                        return {
                                            to: 'checkout.genericError',
                                            params: {
                                                code: 'BLOCK_PPC_INELIGIBLE_USER'
                                            }
                                        };
                                    }
                                } else {
                                    _logger.$logger.info('ppc_second_btn_resuse');
                                    return 'checkout.login';
                                }
                            },
                            contingencies: {
                                DEFAULT: function DEFAULT(name, err) {
                                    // Check error message === currencyNotCompatible
                                    return 'checkout.login';
                                }
                            }
                        });
                    }

                    return 'checkout.login';
                };

                var cartHasInventory = models.checkoutCart.get('cartHasInventory');

                if (_squid.$config.enableInventoryWPS && cartHasInventory) {
                    var inventoryModel = _inventory.$InventoryModel.instance(_angular.$rootScope.token);
                    var inventoryInput = {
                        items: models.checkoutCart.get('purchase.items'),
                        merchantId: models.checkoutPayeeModel.getId()
                    };

                    return inventoryModel.action('getInventory', {
                        data: inventoryInput,
                        success: function success(inventoryResponse) {
                            if (inventoryResponse.showSoldoutPage) {
                                return {
                                    to: 'checkout.soldout',
                                    params: {
                                        items: encodeURIComponent(inventoryResponse.soldoutItems),
                                        soldOutUrl: encodeURIComponent(inventoryResponse.soldoutUrl)
                                    }
                                };
                            } else {
                                inventoryModel.setInvetoryItems(inventoryResponse);
                                return landingFlow();
                            }
                        }
                    });
                } else {
                    return landingFlow();
                }
            });
        }
    }
});

angular.value("$LandingRoute", $LandingRoute);
_angular.$rootScope;

_logger.$logger;

_auth.$AuthModel;

_squid.$Class;

_squid.$ComponentRoute;

_squid.$config;

_squid.$feature;

_squid.$locale;

_squid.$populate;

_squid.$util;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_index.$FlowEligibilityModel;

_index.$CheckoutAppDataModel;

_index2.$CreditInstallmentOptionsModel;

_credit.$CreditDataModel;

_inventory.$InventoryModel;

/***/ }),

/***/ "./pages/xo-login/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports.$xoLoginPageComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _integration = __webpack_require__("./js/lib/integration.js");

var _miniBrowser = __webpack_require__("./js/lib/miniBrowser.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _kmliUpsell = __webpack_require__("../node_modules/xo-login-components/src/onetouch-interstitial/kmliUpsell.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index4 = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _marketingoffer = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");

var _newMember = __webpack_require__("../node_modules/xo-models/src/newMember/index.js");

var _user = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _index5 = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/language-options/directive.js");

__webpack_require__("../node_modules/xo-login-components/src/login/handler/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/card-loader/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-login-components/src/unified-login/directive.js");

var _loginEligibility = __webpack_require__("./pages/xo-login/loginEligibility.js");

__webpack_require__("./pages/xo-login/onboarding/directive.js");

var _template = __webpack_require__("./pages/xo-login/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-login/tokenized-wallet-loader/directive.js");

var _factory = __webpack_require__("./pages/xo-login/tokenized-wallet-loader/factory.js");

var _util = __webpack_require__("./pages/xo-login/util.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoLoginPageComponent = exports.$xoLoginPageComponent = _squid.$Component.extend('$xoLoginPageComponent', {
    tag: 'xo-login-page',
    template: _template2['default'],
    scope: {
        token: '=?'
    },
    link: function link() {
        _logger.$logger.info('login_link');
    },
    lifecycle: {
        populate: function populate() {
            var $scope = this;

            (0, _squid.$populate)($scope, {
                checkoutAppData: _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token)
            }).then(function () {
                var country = $scope.checkoutAppData.merchant.merchant_country;

                return (0, _squid.$pxp)('xo_hermesnode_config', { 'ctx.COUNTRY': country }, 'xo_hermesnode_hide_cart_logo_treatment', false, true).then(function (result) {
                    var treatmentName = result && result.treatment_name || '';

                    if (treatmentName) {
                        _logger.$logger.info('xo_hermesnode_hide_cart_logo_treatment');
                        $('.cartContainer').hide();
                        $('.merchantHeader > .headerWrapper').hide();
                    }
                });
            });
        },
        exit: function exit() {
            var $scope = this;

            (0, _squid.$populate)($scope, {
                checkoutAppData: _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token)
            }).then(function () {
                var country = $scope.checkoutAppData.merchant.merchant_country;

                return (0, _squid.$pxp)('xo_hermesnode_config', { 'ctx.COUNTRY': country }, 'xo_hermesnode_hide_cart_logo_treatment', false, true).then(function (result) {
                    var treatmentName = result && result.treatment_name || '';

                    if (treatmentName) {
                        $('.cartContainer').show();
                        $('.merchantHeader > .headerWrapper').show();
                    }
                });
            });
        }
    },
    rootEvents: {
        allLoaded: function allLoaded() {
            if (!_integration.$integration.getConfig('ALLOW_AUTH')) {
                if (_integration.$integration.getConfig('CAN_FRAMEBUST')) {
                    return _miniBrowser.$miniBrowser.frameBust(this.props.token);
                } else {
                    throw _integration.$integration.error('Can not framebust');
                }
            }
        }
    },
    controller: ['$scope', function ($scope) {
        _logger.$logger.info('login_controller');

        var fptiHardErrors = ['RESTRICTED_USER', 'PAYEE_BLOCKED_TRANSACTION', 'PAYMENT_ALREADY_DONE', 'PAYMENT_DENIED', 'PAYEE_ACCOUNT_RESTRICTED', 'INVALID_RESOURCE_ID', 'EXPIRED_SESSION', 'PAYER_COUNTRY_NOT_ALLOWED', 'PAYER_LOGIN_COUNTRY_NOT_ALLOWED', 'GAMING_FUNDING_SOURCE_VALIDATION_FAILED'];

        var memberSegmentMapper = {
            NEW_MEMBER: 'NEW_XO_MEMBER',
            YOUNG_MEMBER: 'YOUNG_XO_MEMBER',
            EXISTING_MEMBER: 'EXISTING_XO_MEMBER'
        };

        var ROUTE_MAPPING = {
            ECONSENT_REQUIRED: 'checkout.econsent'
        };

        $scope.ulEligibility = false;
        $scope.isWalletTokenization = false;

        /* If we detect a back/forward button click to land on the app, do not auto-login. In this case, the buyer
         is attempting to navigate to a specific page, so we should not auto-redirect them.
          This also fixes an issue with users:
         - Authorizing the checkout session
         - Redirecting to the merchant
         - Hitting back and landing on login page
         - Calling create on checkout and overwriting the authorization
         - Hitting forward and landing again on merchant page
         */

        if (window.performance && window.performance.navigation && window.performance.navigation.type === 2) {
            _angular.$rootScope.forceLogin = true;
        }

        if (!_angular.$rootScope.forceLogin) {
            $scope.autoLogin = true;
        }

        _angular.$rootScope.forceLogin = true;
        $scope.hideGuest = _uiRouter.$stateParams.targetPage === 'PAYER_AUTHENTICATION_REQUIRED' || _uiRouter.$stateParams.showNotYou;
        $scope.promptlogin = $scope.hideGuest && !(0, _squid.$feature)('riskyLoginContingency');

        // log statement for mobile webview
        if (_index.$DeviceInfo.isApp()) {
            _logger.$logger.debug('HERMES_IN_MOBILE_WEBVIEW');
        }

        if (!_miniBrowser.$miniBrowser.isMiniBrowser() && _squid.$locale.country === 'BR') {
            var brPxp = _squid.$config.pxpExperiments.BR.xo_br_hermesnode_login_design;

            (0, _squid.$pxpFactors)(brPxp.pgName, brPxp.params, brPxp.pattern).then(function (result) {
                $scope.loginDesignExp = result;
            });
        }

        $scope.onContingency = function (name, contingency) {
            if (!ROUTE_MAPPING[name]) {
                throw new _squid.$FallbackError({
                    reason: name.toLowerCase(),
                    product: 'ux'
                });
            }

            _uiRouter.$state.go(ROUTE_MAPPING[name]);
        };

        $scope.checkoutSession = _index3.$CheckoutSessionModel.instance(_angular.$rootScope.token);
        $scope.eConsent = _user.$EConsentModel.instance(_angular.$rootScope.token);
        $scope.tokenizedWalletEligibility = _index2.$TokenizedWalletEligibilityModel.instance(_angular.$rootScope.token);
        $scope.tokenizedWalletPin = _index2.$TokenizedWalletPinModel.instance(_angular.$rootScope.token);
        $scope.tokenizedWalletMsbOffer = _index2.$TokenizedWalletMsbOfferModel.instance(_angular.$rootScope.token);
        $scope.walletPreferences = _index4.$WalletPreferences.instance(_angular.$rootScope.token);
        $scope.memberSegment = _marketingoffer.$MemberSegmentModel.instance();
        $scope.dependencyEligibility = true;

        var isValidGamingContingencies = function isValidGamingContingencies(err) {
            // Map usRMG specific error cause to EOL message.
            var endOfLineErrorList = ['GAMER_INELIGIBLE', 'GAMER_FI_INELIGIBLE', 'GAMER_FI_UNCONFIRMED', 'GAMER_ACCOUNT_UNVERIFIED', 'GAMER_INVALID_ACCOUNT_TYPE', 'GAMER_LOGIN_OUT_OF_COUNTRY', 'GAMING_INVALID_PAYMENT_FLOW', 'GAMER_RESIDENCE_OUT_OF_COUNTRY', 'GAMER_NO_VALID_FUNDING_INSTRUMENT'];

            return err && err.cause && endOfLineErrorList.indexOf(err.cause) > -1;
        };

        var isUSGambling = function isUSGambling(_ref) {
            var err = _ref.err;

            var isUSBuyer = _squid.$locale.country === 'US';
            var isUSmerchant = $scope.checkoutAppData && $scope.checkoutAppData.get('merchant.merchant_country') === 'US';

            return isUSBuyer && isUSmerchant && $scope.checkoutPayeeModel.isGambling() && isValidGamingContingencies(err);
        };

        // preloading most popular routes where after setbuyer
        // we should keep the balance here to prevent over loading non needed javascript
        // basically the most popular routes should be added here
        var preloadCodeSplitRoutes = function preloadCodeSplitRoutes() {
            if (_squid.$meta.codeSplitting) {
                Promise.all([new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "./pages/xo-select-fi/route.js")), new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "./pages/xo-add-card/route.js"))])['catch'](function (err) {
                    _logger.$logger.info('code_split_setbuyer_routes_preload_failed', {
                        error: err && err.message
                    });
                });
            }
        };

        $scope.setBuyer = function () {
            var fptiData = {
                from: 'CREATE_XO_SESSION',
                to: 'process_create_xo_session'
            };

            function handleContingency(name, err) {
                _logger.$logger.info('[xo login handleContingency]', {
                    name: name,
                    err: err
                });

                // Check if negative case has been previously handled.
                if (!$scope.dependencyEligibility) {
                    return;
                }

                var errorCode = err.cause || name;

                fptiData.int_error_code = errorCode;
                fptiData.error_source = 'paymentapiplatformserv';
                fptiData.error_type = fptiHardErrors.indexOf(errorCode) > -1 ? 'hard_decline' : 'soft_decline';
                _logger.$logger.info('checkout_fpti', fptiData);

                // NOTE: curently `GAMER_INELIGIBLE` is only designed for DE gambling
                // however, this new Contingency is expected to expand to all gambling
                // countries moving forward.
                if (isUSGambling({ err: err }) || errorCode === 'GAMER_INELIGIBLE') {
                    // US gambling buyer & merchant should get EOL
                    // for certain compliance Contingencies
                    return _uiRouter.$state.go('checkout.genericError', {
                        code: errorCode
                    });
                }

                if (name !== 'NEED_AUTHENTICATED_CARD') {
                    throw err;
                }

                // come from guest or have alternate FI options, go to review
                if (_squid.$util.param('redirectToHermesOnUpopCancel') === 'xoon' || err && err.resolution && err.resolution.data && err.resolution.data.alternate_options) {
                    _uiRouter.$state.go('checkout.review');
                } else {
                    // else go to addCard
                    _uiRouter.$state.go('checkout.updateCard.addCardFlow.addCard');
                }
            }

            function handleNoValidTopupFiContingency(name, err) {
                // Check if negative case has been previously handled.
                if (!$scope.dependencyEligibility) {
                    return;
                }
                if ($scope.isWalletTokenization) {
                    fptiData.int_error_code = err.cause;
                    fptiData.error_source = 'paymentapiplatformserv';
                    fptiData.error_type = fptiHardErrors.indexOf(err.cause) > -1 ? 'hard_decline' : 'soft_decline';
                    _logger.$logger.info('checkout_fpti', fptiData);
                    $scope.checkoutSession.contingency = name;

                    _factory.$TokenizedWalledLoaderFactory.goToTokenizationInfoPage();
                } else {
                    handleContingency(name, err);
                }
            }

            _logger.$logger.info('checkout_fpti', {
                from: 'CREATE_XO_SESSION',
                to: 'prepare_create_xo_session'
            });

            $scope.isWalletTokenization = $scope.checkoutCart.isWalletTokenization();

            if ($scope.isWalletTokenization) {
                _angular.$rootScope.$emit('allLoaded');
            }

            $scope.eConsent.retrieve({
                batch: {
                    name: 'setbuyer',
                    silent: $scope.isWalletTokenization,
                    id: 'eConsent',
                    dependencies: []
                },
                contingencies: {
                    ECONSENT_REQUIRED: function ECONSENT_REQUIRED(name, err) {
                        if ($scope.dependencyEligibility) {
                            $scope.dependencyEligibility = false;
                            _logger.$logger.debug('ULLOGIN_ECONSENT_REQUIRED');
                            _uiRouter.$state.go('checkout.econsent');
                        }
                    }
                }
            });

            if ($scope.isWalletTokenization) {
                // these params are coming from Mayfly (see xo-hermes-app/apis/tokenizedWalletInfo)
                var _$scope$tokenizedWall = $scope.tokenizedWalletInfoModel,
                    wallet_id = _$scope$tokenizedWall.wallet_id,
                    external_device_id = _$scope$tokenizedWall.external_device_id,
                    tr_client_id = _$scope$tokenizedWall.tr_client_id,
                    product_name = _$scope$tokenizedWall.product_name;

                var subject = $scope.tokenizedWalletInfoModel.getSubject();

                // TODO: move to TokenizedWalletInfoModel
                var WALLET_BRANDS = {
                    'google': 'APAY',
                    'Samsung': 'SAMSUNGPAY'
                };

                var params = {
                    wallet_brand: WALLET_BRANDS[subject],
                    tenant_id: 'Hermes',
                    wallet_id: wallet_id,
                    external_device_id: external_device_id,
                    subject: subject,
                    tr_client_id: tr_client_id,
                    product_name: product_name
                };

                if (_squid.$meta.query && _squid.$meta.query.wallet_id) {
                    params.wallet_id = _squid.$meta.query.wallet_id;
                }
                if (_squid.$meta.query && _squid.$meta.query.jwt) {
                    params.jwt = _squid.$meta.query.jwt;
                }

                $scope.tokenizedWalletEligibility.retrieve({
                    params: params,
                    batch: {
                        name: 'setbuyer',
                        id: 'tokenizedWalletLightEligibility',
                        silent: $scope.isWalletTokenization,
                        dependencies: ['eConsent']
                    },
                    success: function success(result) {
                        if (!result.eligible) {
                            var msg = 'tokenized_wallet_ineligible_for_provisioning';

                            _logger.$logger.info(msg);

                            if ($scope.dependencyEligibility) {
                                $scope.dependencyEligibility = false;
                                var code = void 0;

                                fptiData.int_error_code = result.reason;
                                fptiData.error_source = 'paymenttokenserv';
                                fptiData.error_type = 'hard_decline';
                                _logger.$logger.info('checkout_fpti', fptiData);

                                switch (result.reason) {
                                    case 'WALLET_ID_ALREADY_PROVISIONED':
                                        code = 'ANDROID_PAY_ALREADY_PROVISIONED';
                                        break;

                                    case 'COUNTRY_NOT_SUPPORTED':
                                        code = 'ANDROID_PAY_COUNTRY_NOT_SUPPORTED';
                                        break;

                                    default:
                                        code = 'ANDROID_PAY_ELIGIBILITY_ERROR';
                                        break;
                                }
                                code = window.btoa(code);

                                _uiRouter.$state.go('checkout.genericError', { code: code });
                            }
                        }
                    }
                });

                $scope.tokenizedWalletPin.retrieve({
                    batch: {
                        name: 'setbuyer',
                        id: 'tokenizedWalletPin',
                        silent: $scope.isWalletTokenization,
                        dependencies: ['eConsent']
                    },
                    success: function success(result) {
                        if (result.pinId) {
                            _logger.$logger.info('tokenized_wallet_get_pin_set', {
                                pinOrigin: result.pinOrigin,
                                pinId: result.pinId
                            });
                        } else {
                            _logger.$logger.info('tokenized_wallet_get_pin_not_set', {
                                pinKey: result.suggestedKey ? result.suggestedKey : 'unavailable'
                            });
                        }
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(name, err) {
                            _logger.$logger.info('tokenized_wallet_get_pin_error');
                            return _uiRouter.$state.go('checkout.genericError', { code: 'DEFAULT' });
                        }
                    }
                });

                $scope.tokenizedWalletMsbOffer.retrieve({
                    params: {
                        tokenizedWalletToken: $scope.checkoutCart.tokenizedWalletToken
                    },
                    batch: {
                        name: 'setbuyer',
                        id: 'tokenizedWalletMsbOffer',
                        silent: $scope.isWalletTokenization,
                        dependencies: ['eConsent']
                    },
                    success: function success(result) {
                        var msg = 'tokenized_wallet_msb_offer';

                        if (result && result.enabled) {
                            _logger.$logger.info(msg + '_enabled', result);
                        } else {
                            _logger.$logger.info(msg + '_disabled');
                        }
                    }
                });
            }

            if (_squid.$config.enableNewMemberDecisioning) {
                _logger.$logger.info('checkout_fpti', {
                    from: 'CEP_decisioning',
                    to: 'prepare_cep_descisioning'
                });

                $scope.memberSegment.save({
                    data: $scope.memberSegmentData,
                    batch: {
                        name: 'setbuyer',
                        id: 'memberSegment',
                        silent: true,
                        dependencies: $scope.ulEligibility ? ['securityCtx'] : []
                    },
                    success: function success(result) {
                        var memberSegment = memberSegmentMapper[result.memberSegment] || result.memberSegment;

                        _logger.$logger.info('cep_member_decisioning_success', {
                            segment: memberSegment,
                            creditOffer: result.creditOffer
                        });
                        _logger.$logger.info('checkout_fpti', {
                            from: 'CEP_decisioning',
                            to: 'process_cep_descisioning',
                            cep_response: memberSegment + ':' + result.creditOffer
                        });
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(name, err) {
                            _logger.$logger.info('cep_member_decisioning_failed');
                            _logger.$logger.info('checkout_fpti', {
                                from: 'CEP_decisioning',
                                to: 'process_cep_descisioning',
                                int_error_code: 'SERVICE_ERROR',
                                error_source: 'marketingofferreadserv',
                                error_type: 'soft_decline'
                            });
                        }
                    }
                });
            }

            var isPayPalCredit = $scope.checkoutAppData.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';

            $scope.checkoutSession.action('create', {
                data: {
                    preselected_fi_type: isPayPalCredit ? 'credit' : undefined,
                    // user_selected_funding_source is referenced by xo-hermes-checkout, where it retrieves the product_name in it and passes it to the CreateXO api.
                    user_selected_funding_source: $scope.userSelectedFundingSource,
                    clear_installments: true
                },
                batch: {
                    name: 'setbuyer',
                    id: 'createCheckoutSession',
                    silent: $scope.isWalletTokenization,
                    dependencies: !$scope.isWalletTokenization ? ['eConsent'] : ['eConsent', 'tokenizedWalletLightEligibility', 'tokenizedWalletPin', 'tokenizedWalletMsbOffer']
                },
                success: function success(result) {
                    fptiData.available_plan_count = $scope.checkoutSession.getPlanList() ? $scope.checkoutSession.getPlanList().length : '0';
                    _logger.$logger.info('checkout_fpti', fptiData);

                    if (!$scope.dependencyEligibility) {
                        return;
                    }

                    if ($scope.auth.password_less && $scope.checkoutCart.isBilling()) {
                        if ((0, _squid.$feature)('pomaPasswordRecovery')) {
                            _uiRouter.$state.go('checkout.createPassword', { targetPage: 'BILLING_AGREEMENTS' });
                        }
                        return;
                    }

                    if (isPayPalCredit) {
                        return _util.$capeRedirectUtil.handleCapeRouting(result, $scope.checkoutCart, _angular.$rootScope.token);
                    }

                    if ($scope.isWalletTokenization) {
                        // no need to check upsell for wallet tokenization flows
                        // just set planDone prop for "<tokenized-wallet-loader>" component
                        $scope.planDone = true;
                        return;
                    }

                    return _kmliUpsell.$KmliUpsell.eligible(_angular.$rootScope.token).then(function (eligibility) {
                        var isEligible = eligibility && eligibility.interstitial ? eligibility.interstitial : {};

                        if (isEligible.eligible) {
                            var stateName = isEligible.type === 'member' ? 'KMLI_UPSELL' : 'KMLI_reactivation';

                            _logger.$logger.info('checkout_fpti', {
                                from: stateName,
                                to: 'prepare_kmli_upsell'
                            });

                            _logger.$logger.info('ryi_optin', {
                                'from': 'OT_Toggle',
                                'to': 'prepare_inter_optin'
                            });
                            return _uiRouter.$state.go('checkout.oneTouchUpsell', { oneTouchFlowName: 'checkout' });
                        }

                        if ($scope.auth.rtExchanged && (0, _squid.$feature)('rmSpinnerText')) {
                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['login.loggedInWithOneTouch']
                            };
                        }

                        if ($scope.checkoutSession.negBals) {
                            return _uiRouter.$state.go('checkout.negativeBalanceRecovery');
                        } else {
                            _uiRouter.$state.go('checkout.review');
                        }
                    });
                },
                contingencies: {
                    // override contingency.js handler with custom logic to support both xoon/hermes flows
                    NEED_DEBIT_CARD: handleNoValidTopupFiContingency,
                    EXPIRED_DEBIT_CARD: handleNoValidTopupFiContingency,
                    DEFAULT: handleContingency
                }
            })['finally'](function () {
                // selectedInstallmentsData does not come from checkoutSession response from PAPS, so we need to keep track of this state ourselves.
                // We pass clear_installments when calling the checkout session API, so we need to reflect that this is being cleared.
                // See https://engineering.paypalcorp.com/jira/browse/PPPLMER-58580
                delete $scope.checkoutSession.selectedInstallmentData;
            });

            preloadCodeSplitRoutes();
        };

        /**
         * This call is made after the buyer is logged in, and before the CreateXO api call.
         * So that we can retrieve the tokenized funding capabilities for the buyer country.
         */
        $scope.getTokenizedFundingCapabilities = function () {
            return _index2.$TokenizedFundingCapabilitiesModel.instance(_angular.$rootScope.token).retrieve({
                params: {
                    tokenizedWalletToken: $scope.checkoutCart.tokenizedWalletToken,
                    country: $scope.auth.country
                }
            }).then(function (result) {
                if (result.isDirectFundingEnabled()) {
                    $scope.userSelectedFundingSource = {
                        product_name: result.getProductName()
                    };
                }
            });
        };

        $scope.preSetBuyerCalls = function () {
            var apiCalls = [];

            if ($scope.checkoutCart.isWalletTokenization()) {
                apiCalls.push($scope.getTokenizedFundingCapabilities());
            }
            return _angular.$q.all(apiCalls);
        };

        // Sorry for the indirection here.  There's postAuth, so "preAuth" compliments it well (easier on the brain)
        $scope.preAuth = function () {
            if ($scope.ulEligibility) {
                // For UL, batch up eConsent, xoSession
                $scope.preSetBuyerCalls().then(function () {
                    return $scope.setBuyer();
                });
            }
        };

        $scope.onSuccess = function () {
            if ($scope.ulEligibility) {
                // If the experiment is enabled, we already have what we need, so /quit.
                return;
            }
            $scope.preSetBuyerCalls().then(function () {
                return $scope.setBuyer();
            });
        };

        (0, _squid.$populate)($scope, {
            flowEligibility: _index3.$FlowEligibilityModel.instance(_angular.$rootScope.token).retrieve({
                params: {
                    geolocation: _squid.$meta.geolocation,
                    localeCountry: _squid.$locale.country, // We need this till we completely migrate to server side locale resolution
                    braintreeInegration: _squid.$util.param('bt_int_type') === '2' ? 'SFAuthSession' : '',
                    fundingSource: _squid.$util.param('fundingSource')
                }
            }),
            auth: _auth.$AuthModel.instance(),
            checkoutAppData: _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
            checkoutCart: _index3.$CheckoutCartModel.instance(_angular.$rootScope.token),
            checkoutPayeeModel: _index3.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
            tokenizedWalletInfoModel: _index2.$TokenizedWalletInfoModel.instance(_angular.$rootScope.token).retrieve()
        }).then(function () {
            return _newMember.$NewMemberEligibility.instance().getMemberSegmentParameters(_angular.$rootScope.token).then(function (data) {
                $scope.memberSegmentData = data;
                // Set flag to indicate all data is loaded
                $scope.populateComplete = true;
                return;
            });
        }).then(function () {
            // If the refresh token is present, the one touch experience must be preserved and the user must not
            // be presented with the venmo experience
            if (!$scope.auth.refresh_token) {
                var merchant_name = $scope.checkoutAppData.merchant.brand_name || $scope.checkoutAppData.merchant.merchant_name || $scope.checkoutAppData.merchant.merchant_email;

                $scope.infoVenmo = {
                    msgs: [(0, _squid.$renderContent)('landing.venmoAvailableSoon', { 'merchant': merchant_name })],
                    type: 'info'
                };

                if (!_uiRouter.$stateParams.venmoError && $scope.flowEligibility.venmo) {
                    return _uiRouter.$state.go('checkout.payWithSelection');
                } else if (!_uiRouter.$stateParams.venmoError && _thirdPartyInfo.thirdPartyInfo.isVenmoCookiePresent()) {
                    $scope.showVenmoAvailableSoonMsg = true;
                }

                if (_uiRouter.$stateParams.venmoError && _squid.$util.param('marketplaces_venmo_client') === '1') {
                    var cancel_url = $scope.checkoutAppData.urls.cancel_url;

                    _index5.$ReturnToMerchant.goTo(cancel_url);
                }

                // Baidu eligibility checks. Pending pxp throttle
                return _thirdPartyInfo.thirdPartyInfo.isBaiduEligible().then(function (baiduEligible) {
                    if (!_uiRouter.$stateParams.baiduError && baiduEligible) {
                        return (0, _squid.$pxp)('xo_hermesnode_baidu', {
                            'ctx.COUNTRY': $scope.checkoutAppData.get('merchant.merchant_country'),
                            'uid': $scope.checkoutPayeeModel.getId()
                        }, '(xo_hermesnodeweb_baidu)(.*)').then(function (result) {
                            if (result && result.treatment_name === 'xo_hermesnodeweb_baidu_treatment_4660') {
                                return _uiRouter.$state.go('checkout.payWithSelection');
                            }
                        });
                    }
                });
            }
            if ($scope.flowEligibility.guest) {
                return;
            }

            $('.paypalHeaderWrapper').removeClass('paypalCredit');
            $('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
        }).then(function () {
            var initKmliAndDeleteAT = function initKmliAndDeleteAT() {
                delete $scope.auth.access_token;
                _kmliUpsell.$KmliUpsell.init({});
            };

            // reload auth model for use cases where user is not logged in and access_token is in the hash
            // happens already in the middleware
            // basically if there is a param "euat" - there will be access token in the hash
            // otherwise I don't think we need to reload Auth model if user is logged in already
            if ($scope.auth.accessToken() && !$scope.auth.loggedIn()) {
                return $scope.auth.reload({
                    headers: {
                        'x-paypal-internal-euat': $scope.auth.accessToken()
                    },
                    resultModel: $scope.auth,
                    success: function success() {
                        initKmliAndDeleteAT();
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(name) {
                            throw new _squid.$FallbackError({
                                reason: name.toLowerCase(),
                                product: 'ux'
                            });
                        }
                    }
                });
            } else if ($scope.auth.loggedIn()) {
                initKmliAndDeleteAT();
            }
        }).then(function () {
            return (0, _loginEligibility.$loginEligibility)(_angular.$rootScope.token, !$scope.autoLogin).then(function (result) {
                if (result === 'unifiedLogin') {
                    $scope.ulEligibility = true;
                } else if (result === 'apsIntegration') {
                    $scope.apsIntegration = 'apsIntegration';
                } else if (result === 'apsIntegrationRM') {
                    $scope.apsIntegration = 'apsIntegrationRM';
                }
            }).then(function () {
                var reinitDisplay = function reinitDisplay() {
                    $scope.promptlogin = false;
                    $scope.hideGuest = false;
                    $scope.autoLogin = true;
                    delete _uiRouter.$stateParams.targetPage;
                    delete _uiRouter.$stateParams.showNotYou;
                };

                $scope.logout = $scope.promptlogin ? function () {
                    _logger.$logger.info('not_you_logout');
                    _logger.$logger.info('checkout_fpti', {
                        from: 'LOGIN_UL',
                        to: 'login_with_diff_user'
                    });
                    $scope.auth.logoutAndRedirect('NOT_YOU');
                } : function () {
                    _logger.$logger.info('logout_switch_display');
                    reinitDisplay();
                };
            });
        });
    }]
});

angular.value("$xoLoginPageComponent", $xoLoginPageComponent);
_angular.$q;

_angular.$rootScope;

_integration.$integration;

_miniBrowser.$miniBrowser;

_squid.$Class;

_squid.$Component;

_squid.$config;

_squid.$FallbackError;

_squid.$feature;

_squid.$locale;

_squid.$meta;

_squid.$populate;

_squid.$pxp;

_squid.$pxpFactors;

_squid.$renderContent;

_squid.$util;

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_index.$DeviceInfo;

_kmliUpsell.$KmliUpsell;

_index2.$TokenizedFundingCapabilitiesModel;

_index2.$TokenizedWalletEligibilityModel;

_index2.$TokenizedWalletInfoModel;

_index2.$TokenizedWalletMsbOfferModel;

_index2.$TokenizedWalletPinModel;

_auth.$AuthModel;

_index3.$CheckoutAppDataModel;

_index3.$CheckoutCartModel;

_index3.$CheckoutPayeeModel;

_index3.$CheckoutSessionModel;

_index3.$FlowEligibilityModel;

_index4.$WalletPreferences;

_marketingoffer.$MemberSegmentModel;

_newMember.$NewMemberEligibility;

_user.$EConsentModel;

_index5.$ReturnToMerchant;

_thirdPartyInfo.thirdPartyInfo;

_loginEligibility.$loginEligibility;

_factory.$TokenizedWalledLoaderFactory;

_util.$capeRedirectUtil;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "./pages/xo-login/guestThrottle.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$guestThrottle = $guestThrottle;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

function $guestThrottle(flowName, token, lang, country, mfid) {
    var models = {};

    function redirectToXoon() {
        return (0, _squid.$dispatch)('xoon', {
            exp: flowName,
            token: token,
            'locale.x': lang + '_' + country,
            'country.x': country,
            mfid: mfid
        });
    }

    function fallback(product, reason, params) {
        throw new _squid.$FallbackError({
            product: product || 'ux',
            reason: reason,
            entryPoint: flowName,
            params: params
        });
    }

    function checkWpsSubscriptionGuestEnabled() {
        return (0, _squid.$pxp)('xo_subscription_hermes_xoon', 'xo_subscription_treatment_xoon', undefined, false, true).then(function (result) {
            var treatmentName = result && result.treatment_name;

            return treatmentName === 'xo_subscription_treatment_xoon';
        });
    }

    function isGuestFlowEnabled() {
        return (0, _squid.$populate)(models, {
            checkoutAppData: _index.$CheckoutAppDataModel.instance(token).retrieve()
        }).then(function () {
            var appData = models.checkoutAppData;

            // For WPS subscription flows , enable guest flows if treatment name is returned else fallback
            if (appData && appData.is_wps_subscription_flow()) {
                return checkWpsSubscriptionGuestEnabled();
            } else {
                return _angular.$q.resolve(true);
            }
        });
    }

    return isGuestFlowEnabled().then(function (res) {
        if (!res) {
            _logger.$logger.info(flowName + '_to_ux_wps');
            return fallback('ux', flowName + '_to_ux_wps');
        }
        return redirectToXoon();
    });
}

angular.value("$guestThrottle", $guestThrottle);
_angular.$q;

_logger.$logger;

_squid.$dispatch;

_squid.$populate;

_squid.$FallbackError;

_squid.$pxp;

_index.$CheckoutAppDataModel;

/***/ }),

/***/ "./pages/xo-login/loginEligibility.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$forceLoginExperience = $forceLoginExperience;
exports.$loginEligibility = $loginEligibility;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index3 = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

function $forceLoginExperience(auth, merchant_country, forcedLogin) {
    var ULParam = _squid.$util.param('ul');

    if (auth.loggedIn() && !auth.stepupAuthRequired && !forcedLogin) {
        var ulReturn = _squid.$util.param('ulReturn');

        return {
            experience: 'apsIntegration',
            reason: ulReturn ? 'ulReturn' : 'sessionActive'
        };
    } else if (ULParam === '0' && !_squid.$config.deploy.isLive()) {
        return {
            experience: 'apsIntegration',
            reason: 'ulParamDisabled'
        };
    } else if (ULParam && ULParam.match(/[12]/)) {
        return {
            experience: 'unifiedLogin',
            reason: 'ulParam'
        };
    } else if (ULParam === '3') {
        return {
            experience: 'apsIntegrationRM',
            reason: 'ulParamApsRM'
        };
    } else if (auth.refreshToken()) {
        return {
            experience: 'unifiedLogin',
            reason: 'rememberedUser'
        };
    } else if (_squid.$meta.corp && _squid.$config.ulMeta.allowKMLIForInternalIP && (0, _squid.$feature)('enableOneTouchInternalIP', false, merchant_country)) {
        return {
            experience: 'unifiedLogin',
            reason: 'internalIP'
        };
    }
}

function $loginEligibility(token, forcedLogin) {
    var $scope = {};

    $scope.token = token;

    var routingReason = void 0;

    return (0, _squid.$populate)($scope, {
        auth: _index2.$AuthModel.instance(),
        checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token)
    }).then(function () {
        var forceLoginExperience = $forceLoginExperience($scope.auth, $scope.checkoutAppData.merchant.merchant_country, forcedLogin);
        var isIneligible = angular.isDefined(forceLoginExperience);

        // Check login param for hercules, otherwise, always using UL
        if (isIneligible) {
            routingReason = forceLoginExperience.reason;
            return forceLoginExperience.experience;
        } else {
            return 'unifiedLogin';
        }
    }).then(function (finalLoginExperience) {
        _logger.$logger.debug(finalLoginExperience === 'unifiedLogin' ? 'ULLOGIN_ELIGIBLE' : 'ULLOGIN_NOT_ELIGIBLE', {
            userGroup: [routingReason],
            routing_reason: routingReason
        });

        var app_int_type = _index3.$DeviceInfo.getAppIntegrationType();

        _logger.$logger.info('checkout_fpti', {
            'from': 'UL_ELG_CHK',
            'to': 'process_ul_elg_chk',
            'routing_reason': routingReason,
            'app_int_type': app_int_type
        });

        return finalLoginExperience;
    });
}

angular.value("$forceLoginExperience", $forceLoginExperience);
angular.value("$loginEligibility", $loginEligibility);
_squid.$util;

_squid.$meta;

_squid.$config;

_squid.$feature;

_squid.$populate;

_logger.$logger;

_index.$CheckoutAppDataModel;

_index2.$AuthModel;

_index3.$DeviceInfo;

/***/ }),

/***/ "./pages/xo-login/onboarding/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoOnboardingSectionComponent = undefined;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _credit = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _guestThrottle = __webpack_require__("./pages/xo-login/guestThrottle.js");

var _paypalplus = __webpack_require__("./pages/xo-login/paypalplus.js");

__webpack_require__("../node_modules/xo-wallet-components/src/fi-logos/directive.js");

var _template = __webpack_require__("./pages/xo-login/onboarding/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoOnboardingSectionComponent = exports.$xoOnboardingSectionComponent = _squid.$Component.extend('$xoOnboardingSectionComponent', {
    tag: 'xo-onboarding-section',
    template: _template2['default'],
    scope: {
        token: '=?'
    },
    controller: ['$scope', function ($scope) {
        function throttleOnboardingFlow(flow) {
            return (0, _guestThrottle.$guestThrottle)(flow, $scope.token, _squid.$locale.lang, _squid.$locale.country, _squid.$meta.mfid);
        }

        $scope.signupThrottle = function () {
            if ($scope.forceCAPESignup) {
                _uiRouter.$state.go('checkout.redirectToCape', {}, { location: false });
            } else {
                throttleOnboardingFlow('signup');
            }
        };

        $scope.guestThrottle = function () {
            throttleOnboardingFlow('guest');
        };

        function getFlowEligibility() {
            return _checkout.$FlowEligibilityModel.instance($scope.token).retrieve({
                params: {
                    'localeCountry': _squid.$locale.country
                }
            }).then(function (flowEligibility) {
                $scope.flowEligibility = flowEligibility;
            });
        }

        function getButtonLabelTreatment() {
            $scope.newUserVariant = false;
            $scope.newUserVariantWithText = false;

            return (0, _squid.$pxp)('xo_hermes_new_user', { 'ctx.COUNTRY': _squid.$locale.country }, 'xo_hermes_new_user_treatment_(a|b)', false, true).then(function (t) {
                if (t) {
                    $scope.newUserVariant = true;
                    if (t.treatment_name === 'xo_hermes_new_user_treatment_b') {
                        $scope.newUserVariantWithText = true;
                    }
                }
            });
        }

        (0, _squid.$populate)($scope, {
            checkoutAppData: _checkout.$CheckoutAppDataModel.instance($scope.token)
        }).then(function () {
            return getFlowEligibility();
        }).then(function () {
            return getButtonLabelTreatment();
        }).then(function () {
            var isPayPalCredit = $scope.checkoutAppData.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';

            $scope.creditDataModel = _credit.$CreditDataModel.instance($scope.token);
            $scope.forceCAPESignup = isPayPalCredit && !$scope.creditDataModel.payInFull;

            var useForcedSignupFlow = (0, _paypalplus.$isPayPalPlus)($scope.token) || $scope.forceCAPESignup;
            var guest = $scope.flowEligibility.guest;
            var signup = $scope.flowEligibility.signup;

            $scope.showGuestBtn = !useForcedSignupFlow && guest;
            $scope.showSignupBtn = useForcedSignupFlow || !guest && signup;
            $scope.hideOrSeparator = !$scope.showGuestBtn && !$scope.showSignupBtn;
        });
    }]
});

angular.value("$xoOnboardingSectionComponent", $xoOnboardingSectionComponent);
_uiRouter.$state;

_credit.$CreditDataModel;

_squid.$Class;

_squid.$Component;

_squid.$locale;

_squid.$meta;

_squid.$populate;

_squid.$pxp;

_checkout.$CheckoutAppDataModel;

_checkout.$FlowEligibilityModel;

_guestThrottle.$guestThrottle;

_paypalplus.$isPayPalPlus;

/***/ }),

/***/ "./pages/xo-login/onboarding/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"onboardingSection\" id=\"onboardingSection\" content>\n    <div class=\"guestHeading\" ng-if=\"guestVariant.guestBtnOnTop\">\n        <xo-title title-txt=\"{{content('login.guestTitle')}}\"></xo-title>\n        <xo-language-options class=\"span7\"></xo-language-options>\n    </div>\n\n    <div class=\"orSeparator\" ng-if=\"!hideOrSeparator\">\n        <span class=\"textInDivider\">\n            {{content('login.orLowercase')}}\n        </span>\n    </div>\n\n    <a link-button track-link=\"guest\" class=\"btn btn-secondary full submit\" id=\"checkoutAsAGuestBtn\" ng-if=\"showGuestBtn\" ng-click=\"guestThrottle()\">\n        {{ content(newUserVariant ? 'login.newToPayPal' : 'login.guestLinkBtn') }}\n    </a>\n\n    <a link-button track-link=\"signup\" class=\"btn btn-secondary full submit\" id=\"signupBtn\" ng-if=\"showSignupBtn\" ng-click=\"signupThrottle()\">\n        {{ content(newUserVariant ? 'login.newToPayPal' : 'login.createAccount') }}\n    </a>\n\n    <div class=\"inline-prop\" ng-if=\"newUserVariantWithText\" ng-bind-html=\"content('login.guestProp')\"></div>\n</div>\n"

/***/ }),

/***/ "./pages/xo-login/paypalplus.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$isPayPalPlus = $isPayPalPlus;

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

function $isPayPalPlus(token) {
    var checkoutAppDataModel = _index.$CheckoutAppDataModel.instance(token);
    var experienceInitiator = checkoutAppDataModel.get('flags.payment_experience_initiator');
    return experienceInitiator === 'PAYPAL_PLUS';
}

angular.value("$isPayPalPlus", $isPayPalPlus);
_index.$CheckoutAppDataModel;

/***/ }),

/***/ "./pages/xo-login/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$LoginRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("./pages/xo-login/directive.js");

var $LoginRoute = exports.$LoginRoute = _squid.$ComponentRoute.extend('$LoginRoute', {
    path: 'login',
    directive: 'xo-login-page',
    query: ['venmoError'],
    params: {
        targetPage: null,
        source: null,
        showNotYou: null
    },
    auth: false,
    titleContent: 'base.logIn',
    trackingData: {
        fptiState: 'login',
        suppressTransitionLog: true, // We will be suppressing the Server Side Tracking for this page
        templateName: 'login.dust',
        pageGoal: 'Payment Start',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-login',
                'pagename2': '%::fullpage-login:member:hermes:',
                'version': 'member:%:'
            },
            'ulLogin': {
                'pagename': '%::fullpage-ullogin',
                'pagename2': '%::fullpage-ullogin:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },
    children: []
});

angular.value("$LoginRoute", $LoginRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-login/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"login\"\n         id=\"login\" content>\n    <xo-message ng-if=\"showVenmoAvailableSoonMsg\" message=\"infoVenmo\"></xo-message>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\">\n\n            <!--\n                SetBuyer Batch call is dependent on data from various models such as CheckoutCartDataModel etc.\n                Use of populateComplete flag ensures that the directive doesn't fire off until the required data is available.\n                Note that the flow works even without this flag in most cases since the code has failsafe paths\n                [ though they may be getting triggered due to insufficient and not the right data ]\n            -->\n\n            <xo-login-handler ng-if=\"populateComplete\" token=token auto-login=\"autoLogin\" success-callback=\"onSuccess\"\n                              contingency-callback=\"onContingency\" ul-eligibility=\"ulEligibility\" pre-auth=\"preAuth\"\n                              aps-integration=\"apsIntegration\" batch=\"batch\"\n                              login-submit=\"loginSubmit\" flowcontext=\"flowcontext\" logout=\"logout\" export=\"loginHandler\"></xo-login-handler>\n\n            <div ng-if=\"promptlogin\" class=\"centerText\">\n                <hr class=\"sepPlain\" />\n\n                <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout(auth)\" class=\"ng-binding\" tabindex=\"0\">{{ content('memberReview.notYou')}}</a>\n            </div>\n\n            <xo-onboarding-section token=token ng-hide=\"hideGuest\"></xo-onboarding-section>\n\n        </div>\n        <div class=\"span10\" ng-if=\"!loginDesignExp\">\n            <xo-value-props type=\"login\" title=\"{{content('login.propHead')}}\"\n                            text-content=\"login.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" ng-if=\"loginDesignExp\">\n            <xo-value-props type=\"login\" title=\"{{content(loginDesignExp.propHeader)}}\"\n                            text-content=\"{{loginDesignExp.propText}}\"\n                            image-url=\"{{loginDesignExp.propImage}}\"></xo-value-props>\n        </div>\n    </div>\n\n    <xo-tokenized-wallet-loader\n        ng-if='isWalletTokenization'\n        plan-done='planDone'\n    >\n    </xo-tokenized-wallet-loader>\n</section>\n"

/***/ }),

/***/ "./pages/xo-login/tokenized-wallet-loader/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoTokenizedWalletLoader = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _factory = __webpack_require__("./pages/xo-login/tokenized-wallet-loader/factory.js");

__webpack_require__("../node_modules/xo-ui-components/src/card-loader/directive.js");

var _template = __webpack_require__("./pages/xo-login/tokenized-wallet-loader/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ANIMATION_STATUSES = {
    NOT_STARTED: 'notStarted',
    PENDING: 'pending',
    COMPLETED: 'completed'
};

// card loader component - used only in tokenized wallet flows.
var $xoTokenizedWalletLoader = exports.$xoTokenizedWalletLoader = _squid.$Component.extend('$xoTokenizedWalletLoader', {
    tag: 'xo-tokenized-wallet-loader',
    template: _template2['default'],
    props: {
        planDone: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance(_angular.$rootScope.token).retrieve()['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.auth = _auth.$AuthModel.instance();
            // start animation of the card
            this.setbuyerProgress = ANIMATION_STATUSES.NOT_STARTED;
            _logger.$logger.info('tokenized_wallet', {
                from: 'adding_pp_ap_animation',
                to: 'prepare_adding_pp_ap_animation',
                context_id: _angular.$rootScope.token,
                context_type: 'EC-Token',
                billing_token: _squid.$meta.baToken
            });

            // sets animation state to 80%
            (0, _angular.$timeout)(function () {
                _this.setbuyerProgress = ANIMATION_STATUSES.PENDING;
                _logger.$logger.info('tokenized_wallet', {
                    from: 'adding_pp_ap_animation',
                    to: 'process_adding_pp_ap_animation',
                    context_id: _angular.$rootScope.token,
                    context_type: 'EC-Token',
                    billing_token: _squid.$meta.baToken
                });
            }, 300);

            // watch when planning is completed in xo-login/directive
            // to redirect to "checkout.tokenizationInfo" page
            this.$watch('planDone', function (planDone) {
                if (planDone) {
                    _factory.$TokenizedWalledLoaderFactory.goToTokenizationInfoPage();
                }
            });
        },
        populate: function populate() {
            this.cardLoaderMessage = _factory.$TokenizedWalledLoaderFactory.getCardLoaderMessage(this.models.tokenizedWalletInfoModel);
            this.logoClass = this.models.tokenizedWalletInfoModel.getSubject();
        }
    }
});

angular.value("$xoTokenizedWalletLoader", $xoTokenizedWalletLoader);
_squid.$Component;

_squid.$meta;

_logger.$logger;

_angular.$timeout;

_angular.$rootScope;

_angular.noop;

_auth.$AuthModel;

_app.$TokenizedWalletInfoModel;

_factory.$TokenizedWalledLoaderFactory;

/***/ }),

/***/ "./pages/xo-login/tokenized-wallet-loader/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename, $) {

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$TokenizedWalledLoaderFactory', function () {
    var goToTokenizationInfoPage = function goToTokenizationInfoPage() {
        _logger.$logger.info('tokenized_wallet', {
            'from': 'PP_AndroidPay_Info',
            'to': 'prepare_PP_AndroidPay_Info',
            'context_id': _angular.$rootScope.token,
            'context_type': 'EC-Token',
            'billing_token': _squid.$meta.baToken
        });
        $('#outerWrapper').addClass('tokenization');
        _uiRouter.$state.go('checkout.tokenizationInfo');
    };

    var getCardLoaderMessage = function getCardLoaderMessage(tokenizedWalletInfoModel) {
        return (0, _squid.$renderContent)('topup.commonAdding', {
            type: tokenizedWalletInfoModel.brandName()
        }).toString();
    };

    return {
        goToTokenizationInfoPage: goToTokenizationInfoPage,
        getCardLoaderMessage: getCardLoaderMessage
    };
});

_uiRouter.$state;

_angular.$rootScope;

_squid.$meta;

_squid.$renderContent;

_logger.$logger;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-login/tokenized-wallet-loader", "pages/xo-login/tokenized-wallet-loader/factory.js", __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "./pages/xo-login/tokenized-wallet-loader/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"infoLoader\">\n    <div class='logo_wrapper'>\n        <div class='partner_logo' ng-class=\"[logoClass]\"></div>\n    </div>\n    <div class=\"loader\">\n        <xo-card-loader\n            state=\"setbuyerProgress\"\n            auth=\"auth\"\n            message=\"{{cardLoaderMessage}}\"\n        ></xo-card-loader>\n    </div>\n</div>\n"

/***/ }),

/***/ "./pages/xo-login/util.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _credit = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$capeRedirectUtil', function () {
    return {
        handleCapeRouting: function handleCapeRouting(checkoutSession, checkoutCart, token) {
            var fundingInstruments = void 0;
            var isCreditInWallet = void 0;

            if (checkoutCart.isBillingNoPurchase()) {
                fundingInstruments = checkoutSession.futurePaymentInstruments;
                isCreditInWallet = checkoutSession.futurePayment && checkoutSession.futurePayment.isCreditInWallet;
            } else {
                fundingInstruments = checkoutSession.fundingOptions && checkoutSession.fundingOptions.instruments;
                isCreditInWallet = fundingInstruments && _squid.$util.find(fundingInstruments, function (fi) {
                    return fi.name === 'BILL_ME_LATER';
                });
            }

            var creditDataModel = _credit.$CreditDataModel.instance(token);
            var isCapeReturnKey = creditDataModel.getCapeKey();
            var isCapeReturn = isCapeReturnKey && _squid.$util.param('success');
            var isPPCEligible = checkoutSession.creditOffer;

            // User does not have any FI in wallet but they choose to pay in full.
            // Show add card contingency page instead of redirecting to CAPE.

            if (checkoutSession.isCreditPromoted && !fundingInstruments && creditDataModel.payInFull || !fundingInstruments && !isPPCEligible) {

                return _uiRouter.$state.go('checkout.pageAddCard.addCardFlow.addCard');
            }

            // Handle case where it was timeout and status is to go back to cape
            else if (isCreditInWallet || isCapeReturn || creditDataModel.payInFull) {
                    return _uiRouter.$state.go('checkout.review');
                }

                // Handle acquisition customer send to CAPE
                else if (!isCreditInWallet && isPPCEligible) {
                        return _uiRouter.$state.go('checkout.redirectToCape', {}, { location: false });
                    } else {
                        // show error message
                        return _uiRouter.$state.go('checkout.review');
                    }
        }
    };
});

_squid.$util;

_uiRouter.$state;

_credit.$CreditDataModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-login", "pages/xo-login/util.js"))

/***/ }),

/***/ "./pages/xo-nbr/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _util = __webpack_require__("./pages/xo-login/util.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

var _template = __webpack_require__("./pages/xo-nbr/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-nbr/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoNbrDEPageDirective', {
    tag: 'xo-nbr-page',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        isUnbranded: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            var token = this.props.token;


            if (token) {
                return {
                    checkoutSession: _index.$CheckoutSessionModel.instance(token).retrieve({
                        contingencies: {
                            NEGATIVE_BALANCE_RECOVERY: _angular.noop,
                            EXPIRED_CREDIT_CARD: _angular.noop
                        }
                    })['catch'](_angular.noop),
                    checkoutAppData: _index.$CheckoutAppDataModel.instance(token).retrieve()['catch'](_angular.noop),
                    checkoutCart: _index.$CheckoutCartModel.instance(token).retrieve()['catch'](_angular.noop)
                };
            }
        }
    },
    lifecycle: {
        enter: function enter() {
            var self = this,
                configUrls = _squid.$config.urls;

            (0, _jquery2['default'])('.paypalHeaderWrapper').hide();
            (0, _jquery2['default'])('.footerWrapper').addClass('nbr');

            // this is only used by DE
            self.nbrUrl = configUrls.nbrUrl;

            // only invoked via DE view
            self.meft = function (evt) {
                evt.preventDefault();
                // forward to negative legacy balance collection flow
                _squid.$util.redirect(configUrls.nbrUrl);
            };

            self.resume = function (evt) {
                var models = self.models;

                evt.preventDefault();

                // throw original contingency
                if (models.checkoutSession.origContName) {
                    throw new _squid.$Contingency(models.checkoutSession.origContName);
                }

                // consider CAPE scenario first
                var isPayPalCredit = models.checkoutAppData.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';
                if (isPayPalCredit) {
                    _util.$capeRedirectUtil.handleCapeRouting(models.checkoutSession, models.checkoutCart, self.props.token);
                } else {
                    _uiRouter.$state.go('checkout.review');
                }
            };
        },
        exit: function exit() {
            (0, _jquery2['default'])('.paypalHeaderWrapper').show();
            (0, _jquery2['default'])('.footerWrapper').removeClass('nbr');
        },
        populate: function populate() {
            var tokenHash,
                self = this,
                checkoutSession = self.models.checkoutSession,
                negBals = checkoutSession.negBals,
                plan = checkoutSession.plan.sources && checkoutSession.plan.sources[0],
                bodyContentKey = 'nbr.body',
                preBankBtnKey = 'nbr.preBankBtn',
                prePayBtnKey = 'nbr.prePayBtn';

            if (negBals && negBals[0]) {
                tokenHash = {
                    neg_bal: (0, _squid.formatCurrency)(negBals[0] && negBals[0].amount, negBals[0].currency_code, false),
                    amt: plan && plan.amount && (0, _squid.formatCurrency)(plan.amount.amount, plan.amount.currency_code, false)
                };
            }

            if (negBals && negBals.length > 1) {
                bodyContentKey += 'Plural';
                preBankBtnKey += 'Plural';
                tokenHash.neg_bal2 = (0, _squid.formatCurrency)(negBals[1].amount, negBals[1].currency_code, false);
            }

            if (!plan) {
                prePayBtnKey += 'NoAmt';
            }

            self.bodyContentKey = bodyContentKey;
            self.tokenHash = tokenHash;
            self.isDE = _squid.$locale.metadata.country === 'DE';
            self.prePayBtnKey = prePayBtnKey;
            self.preBankBtnKey = preBankBtnKey;
        }
    }
});


_uiRouter.$state;

_angular.noop;

_squid.formatCurrency;

_squid.$Component;

_squid.$locale;

_squid.$util;

_squid.$config;

_squid.$Contingency;

_squid.$Class;

_index.$CheckoutSessionModel;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_util.$capeRedirectUtil;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-nbr/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoNbrDEPageRoute = undefined;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-nbr/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoNbrDEPageRoute = exports.$xoNbrDEPageRoute = _index.$Route.extend('$xoNbrDEPageRoute', {

    path: 'negativeBalanceRecovery',
    directive: _directive2['default'],
    // titleContent: 'nbr.title',

    // trackingData: {
    //     fptiState: 'econsent',
    //     templateName: 'eConsent.dust',
    //     pageGoal: 'eConsent',
    //     buzname: {
    //         'fullpage': {
    //             'pagename': '%::fullpage-econsent',
    //             'pagename2': '%::fullpage-econsent:member:hermes:',
    //             'version': 'member:%:'
    //         }
    //         // More page qualifiers come here...
    //     }
    // },

    children: []
});

angular.value("$xoNbrDEPageRoute", $xoNbrDEPageRoute);
_index.$Route;

/***/ }),

/***/ "./pages/xo-nbr/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-nbr/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"nbr\" content>\n    <div class=\"container\">\n        <div class=\"logo\" ng-if=\"!props.isUnbranded\"></div>\n        <div class=\"title\">\n            {{ content('nbr.title') }}\n        </div>\n        <div class=\"message\" ng-bind-html=\"content(bodyContentKey, tokenHash)\"></div>\n        <div ng-if=\"isDE\" class=\"actions message\">\n            <p class=\"bold\" ng-bind-html=\"content(prePayBtnKey, tokenHash)\"></p>\n            <button ng-click=\"resume($event)\" class=\"btn full\">\n                {{ content('nbr.payBtn') }}\n            </button>\n            <p class=\"small\">\n                {{ content('nbr.postPayBtn') }}\n            </p>\n            <p class=\"bold\" ng-bind-html=\"content(preBankBtnKey, tokenHash)\"></p>\n            <a href=\"{{nbrUrl}}\" ng-click=\"meft($event)\" class=\"btn full btn-secondary\">\n                {{ content('nbr.bankBtn') }}\n            </a>\n            <p class=\"small\">\n                {{ content('nbr.postBankBtn') }}\n            </p>\n        </div>\n        <p class=\"btn-spaced\" ng-if=\"!isDE\">\n            <button ng-click=\"resume($event)\" class=\"btn full\">\n                {{ content('nbr.payBtn') }}\n            </button>\n        </p>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-pay-with-selection/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoPayWithSelectionPageComponent = undefined;

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("./js/lib/index.js");

var _integration = __webpack_require__("./js/lib/integration.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index2 = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _user = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _util = __webpack_require__("./pages/xo-login/util.js");

var _loginEligibility = __webpack_require__("./pages/xo-login/loginEligibility.js");

var _factory = __webpack_require__("./pages/xo-login/tokenized-wallet-loader/factory.js");

var _kmliUpsell = __webpack_require__("../node_modules/xo-login-components/src/onetouch-interstitial/kmliUpsell.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/card-loader/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("./pages/xo-login/onboarding/directive.js");

__webpack_require__("../node_modules/xo-login-components/src/unified-login/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/language-options/directive.js");

__webpack_require__("../node_modules/xo-login-components/src/login/handler/directive.js");

var _template = __webpack_require__("./pages/xo-pay-with-selection/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-pay-with-selection/style.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoPayWithSelectionPageComponent = exports.$xoPayWithSelectionPageComponent = _squid.$Component.extend('$xoPayWithSelectionPageComponent', {
    tag: 'xo-pay-with-selection-page',
    template: _template2['default'],
    scope: {
        token: '=?'
    },
    link: function link() {
        _logger.$logger.info('login_link');
    },
    lifecycle: {
        enter: function enter() {
            (0, _jquery2['default'])('#contents').addClass('payWithSelection');
        },
        populate: function populate() {
            var $scope = this;

            (0, _squid.$populate)($scope, {
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
                flowEligibility: _checkout.$FlowEligibilityModel.instance(_angular.$rootScope.token).retrieve({
                    params: {
                        geolocation: _squid.$meta.geolocation,
                        localeCountry: _squid.$locale.country, // We need this till we completely migrate to server side locale resolution
                        braintreeInegration: _squid.$util.param('bt_int_type') === '2' ? 'SFAuthSession' : '',
                        fundingSource: _squid.$util.param('fundingSource')
                    }
                })
            }).then(function () {
                var country = $scope.checkoutAppData.merchant.merchant_country;

                return (0, _squid.$pxp)('xo_hermesnode_config', { 'ctx.COUNTRY': country }, 'xo_hermesnode_hide_cart_logo_treatment', false, true).then(function (result) {
                    var treatmentName = result && result.treatment_name || '';

                    if (treatmentName) {
                        _logger.$logger.info('xo_hermesnode_hide_cart_logo_treatment');
                        (0, _jquery2['default'])('.cartContainer').hide();
                        (0, _jquery2['default'])('.merchantHeader > .headerWrapper').hide();
                    }
                });
            });
        },
        exit: function exit() {
            (0, _jquery2['default'])('#contents').removeClass('payWithSelection');
            var $scope = this;

            (0, _squid.$populate)($scope, {
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token)
            }).then(function () {
                var country = $scope.checkoutAppData.merchant.merchant_country;

                return (0, _squid.$pxp)('xo_hermesnode_config', { 'ctx.COUNTRY': country }, 'xo_hermesnode_hide_cart_logo_treatment', false, true).then(function (result) {
                    var treatmentName = result && result.treatment_name || '';
                    if (treatmentName) {
                        (0, _jquery2['default'])('.cartContainer').show();
                        (0, _jquery2['default'])('.merchantHeader > .headerWrapper').show();
                    }
                });
            });
        }
    },
    rootEvents: {
        allLoaded: function allLoaded() {
            if (!_integration.$integration.getConfig('ALLOW_AUTH')) {
                if (_integration.$integration.getConfig('CAN_FRAMEBUST')) {
                    if (window.xchild) {
                        var isWebView = window.paypal && window.paypal.isWebView && window.paypal.isWebView();

                        if (!isWebView) {
                            _uiRouter.$state.go('checkout.framebust', { action: 'open', url: window.location.href.split('#')[0] });
                        }
                    } else {
                        return _index.$miniBrowser.frameBust(this.props.token);
                    }
                } else {
                    throw _integration.$integration.error('Can not framebust');
                }
            }
        }
    },
    controller: ['$scope', function ($scope) {
        _logger.$logger.info('xoPayWithSelection_controller');
        $scope.ulEligibility = false;
        $scope.useTokenizationAnimation = false;
        var fptiHardErrors = ['RESTRICTED_USER', 'PAYEE_BLOCKED_TRANSACTION', 'PAYMENT_ALREADY_DONE', 'PAYMENT_DENIED', 'PAYEE_ACCOUNT_RESTRICTED', 'INVALID_RESOURCE_ID', 'EXPIRED_SESSION', 'PAYER_COUNTRY_NOT_ALLOWED', 'PAYER_LOGIN_COUNTRY_NOT_ALLOWED', 'GAMING_FUNDING_SOURCE_VALIDATION_FAILED'];

        /* If we detect a back/forward button click to land on the app, do not auto-login. In this case, the buyer
         is attempting to navigate to a specific page, so we should not auto-redirect them.
          This also fixes an issue with users:
         - Authorizing the checkout session
         - Redirecting to the merchant
         - Hitting back and landing on login page
         - Calling create on checkout and overwriting the authorization
         - Hitting forward and landing again on merchant page
         */
        if (window.performance && window.performance.navigation && window.performance.navigation.type === 2) {
            _angular.$rootScope.forceLogin = true;
        }

        if (!_angular.$rootScope.forceLogin) {
            $scope.autoLogin = true;
        }

        _angular.$rootScope.forceLogin = true;

        $scope.hideGuest = _uiRouter.$stateParams.targetPage === 'PAYER_AUTHENTICATION_REQUIRED' || _uiRouter.$stateParams.showNotYou;
        $scope.promptlogin = $scope.hideGuest && !(0, _squid.$feature)('riskyLoginContingency');

        // log statement for mobile webview
        if (_index2.$DeviceInfo.isApp()) {
            _logger.$logger.debug('HERMES_IN_MOBILE_WEBVIEW');
        }

        if (!_index.$miniBrowser.isMiniBrowser() && _squid.$locale.country === 'BR') {
            var brPxp = _squid.$config.pxpExperiments.BR.xo_br_hermesnode_login_design;

            (0, _squid.$pxpFactors)(brPxp.pgName, brPxp.params, brPxp.pattern, false, true).then(function (result) {
                $scope.loginDesignExp = result;
            });
        }

        var ROUTE_MAPPING = {
            ECONSENT_REQUIRED: 'checkout.econsent'
        };

        $scope.onContingency = function (name, contingency) {
            if (!ROUTE_MAPPING[name]) {
                throw new _squid.$FallbackError({
                    reason: name.toLowerCase(),
                    product: 'ux'
                });
            }
            _uiRouter.$state.go(ROUTE_MAPPING[name]);
        };

        $scope.checkoutSession = _checkout.$CheckoutSessionModel.instance(_angular.$rootScope.token);
        $scope.eConsent = _user.$EConsentModel.instance(_angular.$rootScope.token);
        $scope.tokenizedWalletEligibility = _app.$TokenizedWalletEligibilityModel.instance(_angular.$rootScope.token);
        $scope.dependencyEligibility = true;

        $scope.setBuyer = function () {
            var fptiData = {
                from: 'CREATE_XO_SESSION',
                to: 'process_create_xo_session'
            };

            function handleContingency(name, err) {
                // Check if negative case has been previously handled.
                if (!$scope.dependencyEligibility) {
                    return;
                }
                fptiData.int_error_code = err.cause;
                fptiData.error_source = 'paymentapiplatformserv';
                fptiData.error_type = fptiHardErrors.indexOf(err.cause) > -1 ? 'hard_decline' : 'soft_decline';
                _logger.$logger.info('checkout_fpti', fptiData);
                throw err;
            }

            function handleNoValidTopupFiContingency(name, err) {
                // Check if negative case has been previously handled.
                if (!$scope.dependencyEligibility) {
                    return;
                }
                if ($scope.checkoutCart.isWalletTokenization()) {
                    $scope.checkoutSession.contingency = name;
                    _factory.$TokenizedWalledLoaderFactory.goToTokenizationInfoPage();
                } else {
                    handleContingency(name, err);
                }
            }

            _logger.$logger.info('checkout_fpti', {
                from: 'CREATE_XO_SESSION',
                to: 'prepare_create_xo_session'
            });

            $scope.useTokenizationAnimation = $scope.checkoutCart.isWalletTokenization();
            var walletTokenization = $scope.checkoutCart.isWalletTokenization();

            if ($scope.useTokenizationAnimation) {
                _angular.$rootScope.$emit('allLoaded');

                $scope.setbuyerProgress = 'notStarted';
                _logger.$logger.info('tokenized_wallet', {
                    'from': 'adding_pp_ap_animation',
                    'to': 'prepare_adding_pp_ap_animation',
                    'context_id': _angular.$rootScope.token,
                    'context_type': 'EC-Token',
                    'billing_token': _squid.$meta.baToken
                });

                (0, _angular.$timeout)(function () {
                    $scope.setbuyerProgress = 'pending'; // sets animation state to 80%
                    _logger.$logger.info('tokenized_wallet', {
                        'from': 'adding_pp_ap_animation',
                        'to': 'process_adding_pp_ap_animation',
                        'context_id': _angular.$rootScope.token,
                        'context_type': 'EC-Token',
                        'billing_token': _squid.$meta.baToken
                    });
                }, 300);
            }

            $scope.eConsent.reload({
                batch: {
                    name: 'setbuyer',
                    silent: $scope.useTokenizationAnimation,
                    id: 'eConsent',
                    dependencies: []
                },
                contingencies: {
                    ECONSENT_REQUIRED: function ECONSENT_REQUIRED(name, err) {
                        if ($scope.dependencyEligibility) {
                            $scope.dependencyEligibility = false;
                            _logger.$logger.debug('ULLOGIN_ECONSENT_REQUIRED');
                            _uiRouter.$state.go('checkout.econsent');
                        }
                    }
                }
            });

            if (walletTokenization) {
                var params = {
                    wallet_brand: 'APAY',
                    tenant_id: 'Hermes'
                };
                if (_squid.$meta.query && _squid.$meta.query.wallet_id) {
                    params.wallet_id = _squid.$meta.query.wallet_id;
                }
                if (_squid.$meta.query && _squid.$meta.query.jwt) {
                    params.jwt = _squid.$meta.query.jwt;
                }

                $scope.tokenizedWalletEligibility.reload({
                    params: params,
                    batch: {
                        name: 'setbuyer',
                        id: 'tokenizedWalletLightEligibility',
                        silent: $scope.useTokenizationAnimation,
                        dependencies: ['eConsent']
                    },
                    success: function success(result) {
                        if (!result.eligible) {
                            var msg = 'tokenized_wallet_ineligible_for_provisioning';
                            _logger.$logger.info(msg);

                            if ($scope.dependencyEligibility) {
                                $scope.dependencyEligibility = false;
                                _uiRouter.$state.go('checkout.genericError', {
                                    code: 'ANDROID_PAY_ELIGIBILITY_ERROR'
                                });
                            }
                        }
                    }
                });
            }

            var isPayPalCredit = $scope.checkoutAppData.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';

            $scope.checkoutSession.action('create', {
                data: {
                    baToken: $scope.checkoutCart.billing && $scope.checkoutCart.billing.ba_token,
                    preselected_fi_type: isPayPalCredit ? 'credit' : undefined
                },
                batch: {
                    name: 'setbuyer',
                    id: 'createCheckoutSession',
                    silent: $scope.useTokenizationAnimation,
                    dependencies: walletTokenization ? ['eConsent', 'tokenizedWalletLightEligibility'] : ['eConsent']
                },
                success: function success(result) {
                    fptiData.available_plan_count = $scope.checkoutSession.getPlanList() ? $scope.checkoutSession.getPlanList().length : '0';

                    _logger.$logger.info('checkout_fpti', fptiData);

                    if (!$scope.dependencyEligibility) {
                        return;
                    }

                    if ($scope.auth.password_less && $scope.checkoutCart.isBilling()) {
                        if ((0, _squid.$feature)('pomaPasswordRecovery')) {
                            _uiRouter.$state.go('checkout.createPassword', { targetPage: 'BILLING_AGREEMENTS' });
                        }
                        return;
                    }

                    if (isPayPalCredit) {
                        return _util.$capeRedirectUtil.handleCapeRouting(result, $scope.checkoutCart, _angular.$rootScope.token);
                    }

                    return _kmliUpsell.$KmliUpsell.eligible(_angular.$rootScope.token).then(function (isEligible) {
                        if (isEligible.eligible) {
                            var stateName = isEligible.type === 'member' ? 'KMLI_UPSELL' : 'KMLI_reactivation';

                            _logger.$logger.info('checkout_fpti', {
                                from: stateName,
                                to: 'prepare_kmli_upsell'
                            });

                            var path = _index2.$DeviceInfo.isMobile() ? 'checkout.FullpageOnetouchUpsell' : 'checkout.review.oneTouchUpsell';

                            return _uiRouter.$state.go(path, { oneTouchFlowName: 'checkout' });
                        }

                        if ($scope.auth.rtExchanged && (0, _squid.$feature)('rmSpinnerText')) {
                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['login.loggedInWithOneTouch']
                            };
                        }

                        if ($scope.checkoutSession.negBals) {
                            return _uiRouter.$state.go('checkout.negativeBalanceRecovery');
                        }

                        if ($scope.checkoutCart.isWalletTokenization()) {
                            _factory.$TokenizedWalledLoaderFactory.goToTokenizationInfoPage();
                        } else {
                            _uiRouter.$state.go('checkout.review');
                        }
                    });
                },
                contingencies: {
                    // override contingency.js handler with custom logic to support both xoon/hermes flows
                    NEED_AUTHENTICATED_CARD: function NEED_AUTHENTICATED_CARD(name, err) {
                        // Check if negative case has been previously handled.
                        if (!$scope.dependencyEligibility) {
                            return;
                        }
                        // come from guest or have alternate FI options, go to review
                        if (_squid.$util.param('redirectToHermesOnUpopCancel') === 'xoon' || err && err.resolution && err.resolution.data && err.resolution.data.alternate_options) {
                            _uiRouter.$state.go('checkout.review');
                        } else {
                            // else go to addCard
                            _uiRouter.$state.go('checkout.updateCard.addCardFlow.addCard');
                        }
                    },
                    NEED_DEBIT_CARD: handleNoValidTopupFiContingency,
                    EXPIRED_DEBIT_CARD: handleNoValidTopupFiContingency,
                    DEFAULT: handleContingency
                }
            });
        };

        // Sorry for the indirection here.  There's postAuth, so "preAuth" compliments it well (easier on the brain)
        $scope.preAuth = function () {
            // For UL, batch up eConsent, xoSession
            if ($scope.ulEligibility) {
                $scope.setBuyer();
            }
        };

        $scope.onSuccess = function () {
            _logger.$logger.info('checkout_fpti', {
                'from': 'CHOOSE_PAYMENT_METHOD',
                'to': 'process_continue_with_paypal'
            });

            // If the experiment is enabled, we already have what we need, so /quit.
            if ($scope.ulEligibility) {
                return;
            }

            $scope.setBuyer();
        };

        function fetchGuestButtonPxpVarients() {
            $scope.guestVariant = {};
            // PXP for showing Guest button Call-To-Actions
            return (0, _squid.$pxp)('xo_hermesnode_guest_cta', {
                'ctx.COUNTRY': _squid.$locale.country
            }, '(xo_hermesnode_guest_cta_)(.*)', false, true).then(function (result) {
                var treatmentName = result && result.treatment_name || '';

                switch (treatmentName) {
                    case 'xo_hermesnode_guest_cta_standard_label_treatment':
                        $scope.guestVariant.standardGuestBtn = true;
                        $scope.guestVariant.test = true;
                        break;
                    case 'xo_hermesnode_guest_cta_card_icons_treatment':
                        $scope.guestVariant.cardIconsAboveGuestBtn = true;
                        $scope.guestVariant.test = true;
                        break;
                    default:
                    // Do nothing
                }
            });
        }

        (0, _squid.$populate)($scope, {
            flowEligibility: _checkout.$FlowEligibilityModel.instance(_angular.$rootScope.token).retrieve({
                params: {
                    geolocation: _squid.$meta.geolocation,
                    localeCountry: _squid.$locale.country, // We need this till we completely migrate to server side locale resolution
                    braintreeInegration: _squid.$util.param('bt_int_type') === '2' ? 'SFAuthSession' : '',
                    fundingSource: _squid.$util.param('fundingSource')
                }
            }),
            auth: _auth.$AuthModel.instance(),
            checkoutAppData: _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
            checkoutCart: _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token)
        }).then(function () {
            if ($scope.flowEligibility.guest) {
                return fetchGuestButtonPxpVarients();
            }
            (0, _jquery2['default'])('.paypalHeaderWrapper').removeClass('paypalCredit');
            (0, _jquery2['default'])('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
        }).then(function () {
            $scope.expandPaypalDrawer = false;
            $scope.expandVenmoDrawer = false;
            $scope.expandBaiduDrawer = false;
            $scope.hideLoginHandlerTitle = true;

            $scope.clickPaypalDrawer = function () {
                $scope.expandPaypalDrawer = !$scope.expandPaypalDrawer;

                // if drawer expanded, we track it.
                if ($scope.expandPaypalDrawer) {
                    _logger.$logger.info('checkout_fpti', {
                        from: 'CHOOSE_PAYMENT_METHOD',
                        to: 'show_paypal_drawer'
                    });
                }

                // if Venmo is expanded, close it
                $scope.closeVenmoDrawer();
                $scope.closeBaiduDrawer();
                return $scope.expandPaypalDrawer;
            };

            $scope.clickVenmoDrawer = function () {
                $scope.expandVenmoDrawer = !$scope.expandVenmoDrawer;

                // if drawer expanded, we'll track it
                if ($scope.expandVenmoDrawer) {
                    _logger.$logger.info('checkout_fpti', {
                        from: 'CHOOSE_PAYMENT_METHOD',
                        to: 'show_venmo_drawer'
                    });
                }

                // if paypal is expanded, close it
                $scope.closePaypalDrawer();
                $scope.closeBaiduDrawer();
                return $scope.expandVenmoDrawer;
            };

            $scope.clickBaiduDrawer = function () {
                $scope.expandBaiduDrawer = !$scope.expandBaiduDrawer;

                if ($scope.expandBaiduDrawer) {
                    _logger.$logger.info('checkout_fpti', {
                        from: 'CHOOSE_PAYMENT_METHOD',
                        to: 'show_baidu_drawer'
                    });
                }

                // if other drawers expanded, close them
                $scope.closePaypalDrawer();
                $scope.closeVenmoDrawer();
                return $scope.expandBaiduDrawer;
            };

            $scope.closePaypalDrawer = function () {
                // if paypal is expanded, close it
                if ($scope.expandPaypalDrawer) {
                    $scope.expandPaypalDrawer = !$scope.expandPaypalDrawer;
                }
            };

            $scope.closeVenmoDrawer = function () {
                // if Venmo is expanded, close it
                if ($scope.expandVenmoDrawer) {
                    $scope.expandVenmoDrawer = !$scope.expandVenmoDrawer;
                }
            };

            $scope.closeBaiduDrawer = function () {
                // if other drawers expanded, close them
                if ($scope.expandBaiduDrawer) {
                    $scope.expandBaiduDrawer = !$scope.expandBaiduDrawer;
                }
            };

            $scope.displayBaiduDrawer = $scope.flowEligibility.baiduWallet;
            $scope.displayVenmoDrawer = $scope.flowEligibility.venmo;

            $scope.sendToVenmo = function () {
                window.location.href = _thirdPartyInfo.thirdPartyInfo.buildVenmoURL();
            };

            $scope.proceedWithBaidu = function () {
                // if incontext, we'll resize and center to allow for the minimum size of the Baidu flow.
                if (window.xprops) {
                    var xPos = window.screen.width / 2 - 800 / 2;
                    var yPos = window.screen.height / 2 - 800 / 2;
                    window.resizeTo(800, 800);
                    window.moveTo(xPos, yPos);
                }
                _uiRouter.$state.go('checkout.thirdPartyWalletFlow');
            };

            if ($scope.displayBaiduDrawer && $scope.displayVenmoDrawer) {
                (0, _angular.$timeout)($scope.clickBaiduDrawer, 800);
            } else if ($scope.displayVenmoDrawer) {
                (0, _angular.$timeout)($scope.clickVenmoDrawer, 800);
            } else {
                (0, _angular.$timeout)($scope.clickBaiduDrawer, 800);
            }

            return (0, _loginEligibility.$loginEligibility)(_angular.$rootScope.token, !$scope.autoLogin).then(function (result) {
                if (result === 'unifiedLogin') {
                    $scope.ulEligibility = true;
                } else if (result === 'apsIntegration') {
                    $scope.apsIntegration = 'apsIntegration';
                } else if (result === 'apsIntegrationRM') {
                    $scope.apsIntegration = 'apsIntegrationRM';
                }
            }).then(function () {
                var reinitDisplay = function reinitDisplay() {
                    $scope.promptlogin = false;
                    $scope.hideGuest = false;
                    $scope.autoLogin = true;
                    delete _uiRouter.$stateParams.targetPage;
                    delete _uiRouter.$stateParams.showNotYou;
                };

                $scope.logout = $scope.promptlogin ? function () {
                    _logger.$logger.info('not_you_logout');
                    _logger.$logger.info('checkout_fpti', {
                        from: 'LOGIN_UL',
                        to: 'login_with_diff_user'
                    });
                    $scope.auth.logout().then(function () {
                        $scope.auth.reload().then(function () {
                            reinitDisplay();
                            $scope.reload();
                        });
                    });
                } : function () {
                    _logger.$logger.info('logout_switch_display');
                    reinitDisplay();
                };
            });
        });
    }]
});

angular.value("$xoPayWithSelectionPageComponent", $xoPayWithSelectionPageComponent);
_angular.$rootScope;

_angular.$timeout;

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_index.$miniBrowser;

_integration.$integration;

_squid.$pxp;

_squid.$util;

_squid.$meta;

_squid.$Class;

_squid.$locale;

_squid.$config;

_squid.$feature;

_squid.$populate;

_squid.$Component;

_squid.$pxpFactors;

_squid.$FallbackError;

_index2.$DeviceInfo;

_auth.$AuthModel;

_user.$EConsentModel;

_app.$TokenizedWalletEligibilityModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutSessionModel;

_checkout.$FlowEligibilityModel;

_thirdPartyInfo.thirdPartyInfo;

_util.$capeRedirectUtil;

_loginEligibility.$loginEligibility;

_factory.$TokenizedWalledLoaderFactory;

_kmliUpsell.$KmliUpsell;

/***/ }),

/***/ "./pages/xo-pay-with-selection/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$PayWithSelectionRoute = undefined;

__webpack_require__("./pages/xo-pay-with-selection/directive.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var $PayWithSelectionRoute = exports.$PayWithSelectionRoute = _squid.$ComponentRoute.extend('$PayWithSelectionRoute', {

    path: 'payWithSelection',

    directive: 'xo-pay-with-selection-page',

    params: {
        targetPage: null,
        source: null,
        showNotYou: null
    },

    resolve: {
        action: function action() {
            var fromState = _uiRouter.$state.fromState;

            var isBackButton = window.performance && window.performance.navigation && window.performance.navigation.type === 2;
            if (!isBackButton && fromState.name === 'checkout.login') {
                // reset force login if coming from login route
                _angular.$rootScope.forceLogin = false;
            }
        }
    },

    auth: false,

    titleContent: 'base.logIn',

    venmoHeaders: {
        venmoTabs: true
    },

    trackingData: {
        fptiState: 'choose_payment_method',
        templateName: 'login.dust',
        trackStateExit: false,
        pageGoal: 'Select a payment scheme',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-login',
                'pagename2': '%::fullpage-login:member:hermes:',
                'version': 'member:%:'
            },
            'ulLogin': {
                'pagename': '%::fullpage-ullogin',
                'pagename2': '%::fullpage-ullogin:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },

    children: []
});

angular.value("$PayWithSelectionRoute", $PayWithSelectionRoute);
_squid.$ComponentRoute;

_angular.$rootScope;

_uiRouter.$state;

/***/ }),

/***/ "./pages/xo-pay-with-selection/style.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-pay-with-selection/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"payWithSelection\" ng-class=\"{standardGuestBtn: guestVariant.standardGuestBtn, guestBtnOnTop: guestVariant.guestBtnOnTop, cardIconsAboveGuestBtn: guestVariant.cardIconsAboveGuestBtn}\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\" id=\"selectPaymentMethodAccordion\">\n\n            <section id=\"paypalDrawer\" class=\"drawer\" ng-class=\"{hidden: !expandPaypalDrawer}\" ng-click=\"clickPaypalDrawer()\" content>\n                <xo-title title-txt=\"{{content('login.loginTitle')}}\" class=\"span17\"></xo-title>\n                <span class=\"arrow\" ng-class=\"{expand: expandPaypalDrawer }\"></span>\n\n                <xo-login-handler ng-click=\"$event.stopPropagation()\" ng-show=\"expandPaypalDrawer\" token=token auto-login=\"autoLogin\" success-callback=\"onSuccess\"\n                                  contingency-callback=\"onContingency\" ul-eligibility=\"ulEligibility\" pre-auth=\"preAuth\"\n                                  aps-integration=\"apsIntegration\" batch=\"batch\"\n                                  login-submit=\"loginSubmit\" flowcontext=\"flowcontext\" logout=\"logout\" export=\"loginHandler\" hide-title=\"hideLoginHandlerTitle\"></xo-login-handler>\n                <xo-onboarding-section ng-show=\"expandPaypalDrawer\" ng-click=\"$event.stopPropagation()\" token=token ng-hide=\"hideGuest\"></xo-onboarding-section>\n            </section>\n\n            <section ng-if=\"displayVenmoDrawer\" id=\"venmoDrawer\" class=\"drawer\" ng-class=\"{hidden: !expandVenmoDrawer}\" ng-click=\"clickVenmoDrawer()\" content>\n                <xo-title title-txt=\"{{'Pay with '}}\" class=\"span17\"></xo-title>\n                <span class=\"venmoLogo\"></span>\n                <span class=\"arrow\" ng-class=\"{expand: expandVenmoDrawer, paypalExpanded: expandPaypalDrawer}\"></span>\n                <p ng-click=\"$event.stopPropagation()\" class=\"legal\" bind-html-compile=\"htmlContent('landing.venmoLegal')\"></p>\n                <a track-link=\"choose_venmo\" class=\"btn full venmoBtn\" link-button ng-click=\"sendToVenmo()\">{{content('landing.venmoButton')}}</a>\n            </section>\n\n            <section ng-if=\"displayBaiduDrawer\" id=\"baiduDrawer\" class=\"drawer\" ng-class=\"{hidden: !expandBaiduDrawer}\" ng-click=\"clickBaiduDrawer()\" content>\n                <xo-title title-txt=\"{{content('landing.payWithBaidu')}}\" class=\"span17\"></xo-title>\n                <span class=\"baiduLogo\"></span>\n                <span class=\"arrow\" ng-class=\"{expand: expandBaiduDrawer, paypalExpanded: expandPaypalDrawer}\"></span>\n                <p class=\"legal disclaimer\">{{content('landing.paypalBaiduDisclaimer')}}</p>\n                <p ng-click=\"$event.stopPropagation()\" class=\"legal\" ></p>\n                <a track-link=\"choose_baidu\" class=\"full baiduBtn\" link-button ng-click=\"proceedWithBaidu()\"></a>\n            </section>\n\n\n            <div ng-if=\"promptlogin\" class=\"centerText\">\n                <hr class=\"sepPlain\" />\n\n                <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout(auth)\" class=\"ng-binding\" tabindex=\"0\">{{ content('memberReview.notYou')}}</a>\n            </div>\n\n        </div>\n        <div class=\"span10\" ng-if=\"!loginDesignExp\">\n            <xo-value-props type=\"login\" title=\"{{content('login.propHead')}}\"\n                            text-content=\"login.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" ng-if=\"loginDesignExp\">\n            <xo-value-props type=\"login\" title=\"{{content(loginDesignExp.propHeader)}}\"\n                            text-content=\"{{loginDesignExp.propText}}\"\n                            image-url=\"{{loginDesignExp.propImage}}\"></xo-value-props>\n        </div>\n    </div>\n    <div class=\"infoLoader\"  ng-if='useTokenizationAnimation'>\n        <div class='logo_wrapper'>\n            <div class='partner_logo'></div>\n        </div>\n        <div class=\"loader\">\n            <xo-card-loader state=\"setbuyerProgress\" auth=\"auth\" message=\"{{content('topup.addingAndroidPay')}}\"></xo-card-loader>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-pay/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _route = __webpack_require__("./pages/xo-pay/route.js");

Object.keys(_route).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _route[key];
    }
  });
});

/***/ }),

/***/ "./pages/xo-pay/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$PayRoute = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _integration = __webpack_require__("./js/lib/integration.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _inventory = __webpack_require__("../node_modules/xo-models/src/inventory/index.js");

var _profilemanagement = __webpack_require__("../node_modules/xo-models/src/profilemanagement/index.js");

var _shoppingcart = __webpack_require__("../node_modules/xo-models/src/shoppingcart/index.js");

/**
 * PayRoute
 * - Responsible for making the payment call and handling contingencies if any.
 */

var $PayRoute = exports.$PayRoute = _squid.$ComponentRoute.extend('PayRoute', {

    path: 'pay',

    trackingData: {
        fptiState: 'make_payment',
        trackStateExit: true
    },

    resolve: {
        action: function action() {

            var token = _angular.$rootScope.token;
            var models = {};

            var getMerchantPreferences = function getMerchantPreferences() {
                return (0, _squid.$populate)(models, {
                    pref: _profilemanagement.$MerchantPreferenceModel.instance(models.payee.merchant.id)
                });
            };

            var markCartCheckedout = function markCartCheckedout() {

                var enabled = _squid.$config.enableShoppingCartWPS && models.checkoutAppData.flags.is_shopping_cart_flow;

                if (!enabled) {
                    return _angular.$q.when();
                }

                var shoppingCartModel = _shoppingcart.$ShoppingCartModel.instance(token);

                return shoppingCartModel.action('cartCheckedOut', {
                    data: {
                        payee_email: models.checkoutAppData.get('merchant.merchant_email')
                    },
                    success: function success(result) {
                        _logger.$logger.info('CART_CHECKED_OUT');
                    }
                });
            };

            var manageInventory = function manageInventory(paymentStatus) {
                var cartHasInventory = models.checkoutCart.get('cartHasInventory');

                if (!cartHasInventory) {
                    return _angular.$q.when();
                }

                var inventoryModel = _inventory.$InventoryModel.instance(token);

                var inventoryItems = inventoryModel.getInventoryItems();

                paymentStatus = paymentStatus ? paymentStatus : 'success';

                var inventoryPatchInput = {
                    inventoryItems: inventoryItems,
                    cartItems: models.checkoutCart.get('purchaseUnits')[0].item_list.items,
                    merchantId: models.payee.get('merchant.id', ''),
                    paymentStatus: paymentStatus
                };

                return inventoryModel.action('patchInventory', {
                    data: inventoryPatchInput,
                    success: function success(patchResponse) {
                        if (patchResponse && patchResponse.showSoldoutPage) {
                            // show soldout page
                            return _angular.$q.when({
                                soldoutpage: true,
                                items: encodeURIComponent(patchResponse.soldoutItems),
                                soldoutUrl: encodeURIComponent(patchResponse.soldoutUrl)
                            });
                        } else if (patchResponse && patchResponse.patchCart) {
                            // patch cart with updated inventory
                            var purchase_unit = models.checkoutCart.get('purchaseUnits')[0];

                            purchase_unit.item_list.items = patchResponse.cartItems;

                            var patchCartPayload = {
                                id: token,
                                patchEntities: [{
                                    field: 'inventoryItems',
                                    value: purchase_unit.item_list.items
                                }]
                            };

                            return models.checkoutCart.action('patchCartData', {
                                data: patchCartPayload
                            });
                        }
                        return _angular.$q.when();
                    }
                });
            };

            var showSoldOutPage = function showSoldOutPage(soldOutData) {
                return _angular.$q.when({
                    to: 'checkout.soldout',
                    params: {
                        items: soldOutData.items,
                        soldOutUrl: soldOutData.soldoutUrl
                    }
                });
            };

            var showGenericError = function showGenericError(code) {
                return function () {
                    var encoded = code ? window.btoa(code) : code;

                    manageInventory('failed');
                    return _uiRouter.$state.go('checkout.genericError', { code: encoded });
                };
            };

            var makePayment = function makePayment() {

                var xclickParams = _squid.$util.decodeAndParse(_squid.$meta.xclickParams);

                return models.checkoutSession.action('createPayment', {
                    data: {
                        payer_id: models.checkoutSession.payer.id,
                        intent: models.checkoutCart.payment_action,
                        wa_type: xclickParams && xclickParams.wa_type,
                        correlation_id: _squid.$meta.correlationId,
                        merchant_id: models.payee.get('merchant.id'),
                        custom: models.checkoutCart.get('purchase.custom'),
                        invoice: models.checkoutCart.get('purchase.invoice')
                    },

                    success: function success(result) {
                        // flag used in other directives
                        _angular.$rootScope.paymentComplete = true;
                        // fire and forget
                        markCartCheckedout();
                        return 'success';
                    },

                    contingencies: {
                        TRANSACTION_REFUSED: showGenericError('TRANSACTION_REFUSED'),
                        PAYEE_BLOCKED_TRANSACTION: showGenericError('PAYMENT_DENIED'),
                        DUPLICATE_TRANSACTION: showGenericError('PAYMENT_ALREADY_DONE'),
                        DUPLICATE_INVOICE_ID: showGenericError('DUPLICATE_INVOICE_ID'),
                        // for cc_processor_declined / default , we can redirect back to review for a retry
                        CC_PROCESSOR_DECLINED: function CC_PROCESSOR_DECLINED() {
                            manageInventory('failed');

                            // call createCheckout again and throw processor decline error which will be handled in
                            // xo-review
                            return models.checkoutSession.action('create', {
                                success: function success(result) {
                                    return _angular.$q.reject('CC_PROCESSOR_DECLINED');
                                }
                            });
                        },
                        DEFAULT: function DEFAULT(name, err) {
                            manageInventory('failed');
                            throw err;
                        }
                    }
                });
            };

            return (0, _squid.$populate)(models, {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(token),
                checkoutCart: _index.$CheckoutCartModel.instance(token),
                checkoutSession: _index.$CheckoutSessionModel.instance(token),
                payee: _index.$CheckoutPayeeModel.instance(token)
            }).then(function () {
                // Check if inventory is available
                return manageInventory();
            }).then(function (inventoryStatus) {
                // Show Sold Out Page if inventory unavailable
                if (inventoryStatus && inventoryStatus.soldoutpage) {
                    return showSoldOutPage(inventoryStatus);
                }
                // Make Payment
                return _angular.$q.all([getMerchantPreferences(), makePayment() // Load the preferences here so its cached for later use in the done page
                ]).then(function () {
                    if (_angular.$rootScope.paymentComplete) {
                        if (_integration.$integration.getConfig('DONE_PAGE')) {
                            // Show Done Page [ Payment Confirmation ]
                            return 'checkout.done';
                        }
                        // default end state
                        return 'checkout.end';
                    }
                })['catch'](function (error) {
                    _logger.$logger.info('XO_PAY_ERROR', { error: error });
                    return 'checkout.review';
                });
            });
        }
    }
});

angular.value("$PayRoute", $PayRoute);
_angular.$q;

_angular.$rootScope;

_integration.$integration;

_uiRouter.$state;

_squid.$ComponentRoute;

_squid.$config;

_squid.$meta;

_squid.$populate;

_squid.$util;

_logger.$logger;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_index.$CheckoutSessionModel;

_inventory.$InventoryModel;

_profilemanagement.$MerchantPreferenceModel;

_shoppingcart.$ShoppingCartModel;

/***/ }),

/***/ "./pages/xo-pin-setup/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/app/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/mobile-pin/directive.js");

var _template = __webpack_require__("./pages/xo-pin-setup/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-pin-setup/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoPinSetupPageDirective', {
    tag: 'xo-pin-setup',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            _logger.$logger.info('tokenized_wallet', {
                'from': 'PINSETUP',
                'to': 'PREPARE_PINSETUP'
            });
        }
    },
    controller: ['$scope', function ($scope) {
        var currentPin = '';

        $scope.madeAttempt = false;
        $scope.pinError = '';
        $scope.pinChanged = false;

        function done(pinValue) {
            _index.$TokenizedWalletPinModel.instance(_angular.$rootScope.token).retrieve().then(function (WalletPinModel) {
                WalletPinModel.userPin = pinValue;
                _logger.$logger.info('tokenized_wallet', {
                    'from': 'PINSETUP',
                    'to': 'PROCESS_PINSETUP'
                });
                (0, _angular.$timeout)(function () {
                    return _uiRouter.$state.go('checkout.review');
                }, 1500);
            });
        }

        $scope.pinComplete = function (result) {
            var value = result && result.value;

            if (result && result.error === 'pin_too_simple') {
                $scope.pinError = 'toEasy';
                $scope.madeAttempt = false;
                currentPin = '';
                $scope.$broadcast('resetPin');
                return;
            }

            $scope.pinChanged = $scope.madeAttempt && currentPin === value;
            $scope.pinError = $scope.madeAttempt && !$scope.pinChanged ? 'missMatch' : '';
            currentPin = $scope.madeAttempt ? '' : value; // reset old pin if already made an attempt
            $scope.madeAttempt = !$scope.madeAttempt; // flip flag

            if (!$scope.pinChanged) {
                $scope.$broadcast('resetPin');
            } else {
                done(value);
            }
        };
    }]
});


_uiRouter.$state;

_squid.$Component;

_angular.$rootScope;

_angular.$timeout;

_logger.$logger;

_index.$TokenizedWalletPinModel;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-pin-setup/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoPinSetupPageRoute = undefined;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-pin-setup/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoPinSetupPageRoute = exports.$xoPinSetupPageRoute = _index.$Route.extend('$xoPinSetupPageRoute', {
    path: 'pinSetup',
    directive: _directive2['default'],
    titleContent: 'Wallet Pin Setup',
    trackingData: {
        fptiState: 'pinSetup'
    },

    children: []
});

angular.value("$xoPinSetupPageRoute", $xoPinSetupPageRoute);
_index.$Route;

/***/ }),

/***/ "./pages/xo-pin-setup/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-pin-setup/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"pinSetup\" modal-box content>\n    <div class=\"pinError\" ng-if=\"pinError\">\n        <div class=\"errorIcon\"></div>\n        <div class=\"errorText\">\n            <span ng-if=\"pinError==='missMatch'\">{{content('review.pinMissMatch')}}</span>\n            <span ng-if=\"pinError==='toEasy'\">{{content('review.pinEasy')}}</span>\n        </div>\n    </div>\n    <div class=\"content\">\n        <div class=\"pinUpdate\" ng-if=\"!pinChanged\">\n            <xo-mobile-pin done=\"pinComplete\"></xo-mobile-pin>\n            <div class=\"subtext\" ng-if=\"!pinMissMatch && !madeAttempt\">{{content('review.pinFirstEntry')}}</div>\n            <div class=\"subtext\" ng-if=\"!pinMissMatch && madeAttempt\">{{content('review.pinSecondEntry')}}</div>\n            <div class=\"subtext\" ng-if=\"pinMissMatch\">{{content('review.pinBadEntry')}}</div>\n            <div class=\"secondarySubtext\">{{content('review.pinSubText')}}</div>\n        </div>\n        <div class=\"pinSuccess\" ng-if=\"pinChanged\">\n            <div class=\"successGif\"></div>\n            <div class=\"successText\">{{content('review.pinChanged')}}</div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-review/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoReviewPageComponent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _index = __webpack_require__("./js/lib/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _integration = __webpack_require__("./js/lib/integration.js");

var _index2 = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _ul = __webpack_require__("../node_modules/xo-login-components/src/unified-login/ul.js");

var _pxp = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/pxp.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _kmliUpsell = __webpack_require__("../node_modules/xo-login-components/src/onetouch-interstitial/kmliUpsell.js");

var _utils = __webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/utils.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _fbMessenger = __webpack_require__("../node_modules/xo-page-components/src/constants/fbMessenger.js");

var _fbMessenger2 = _interopRequireDefault(_fbMessenger);

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _fiApis = __webpack_require__("../node_modules/xo-models/src/fi/lib/fiApis.js");

var _eligibility = __webpack_require__("../node_modules/xo-models/src/eligibility/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _index4 = _interopRequireDefault(_index3);

var _choice = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

var _fiMessages = __webpack_require__("../node_modules/xo-models/src/fi/lib/fiMessages.js");

var _donation = __webpack_require__("../node_modules/xo-models/src/donation/index.js");

var _bml = __webpack_require__("../node_modules/xo-models/src/bml/index.js");

var _credit = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _experiments = __webpack_require__("../node_modules/xo-models/src/experiments/index.js");

var Experiments = _interopRequireWildcard(_experiments);

var _marketingoffer = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");

var _newMember = __webpack_require__("../node_modules/xo-models/src/newMember/index.js");

var _shippingMethod = __webpack_require__("../node_modules/xo-models/src/shippingMethod/index.js");

var _user = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _factory = __webpack_require__("../node_modules/xo-member-components/src/give-at-checkout/factory.js");

var _factory2 = __webpack_require__("../node_modules/xo-member-components/src/no-balance/factory.js");

var _factory3 = __webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/factory.js");

var _factory4 = __webpack_require__("../node_modules/xo-member-components/src/show-more-fi/factory.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

__webpack_require__("../node_modules/xo-styles/dist/lib/toggle.less");

__webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");

__webpack_require__("../node_modules/xo-wallet-components/src/3ds/directive.js");

__webpack_require__("../node_modules/xo-address-components/src/address-display/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/select-shipping-method/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/offer/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/xo-offer-top-banner/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/bml-display/xo-bml-popup/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/offer/xo-credit-example-uk/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/no-balance/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/review-topup/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/review-address/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/review-paywith/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/give-at-checkout/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/review-shipping-options/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/notYou/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/marketingOffers/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/messenger-plugin/directive.js");

__webpack_require__("../node_modules/xo-third-party-components/src/review-paywith-baidu/directive.js");

__webpack_require__("../node_modules/xo-third-party-components/src/review-paywith-venmo/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/banner/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/sticky-cta/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/expired-message/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/user-assist-banner/directive.js");

var _cardartInstrument = __webpack_require__("./pages/services/cardart-instrument/index.js");

var _factory5 = __webpack_require__("./pages/xo-select-fi/factory.js");

var _factory6 = __webpack_require__("./pages/xo-review/factory.js");

var _tokenizedFactory = __webpack_require__("./pages/xo-review/tokenizedFactory.js");

var _shippingChangeFeature = __webpack_require__("./pages/xo-review/lib/shippingChangeFeature.js");

var _template = __webpack_require__("./pages/xo-review/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Create payload that contains relevant data about the checkout state at review page
function createReviewFptiPayload(_ref) {
    var checkoutSession = _ref.checkoutSession,
        _ref$isProcessTransit = _ref.isProcessTransition,
        isProcessTransition = _ref$isProcessTransit === undefined ? false : _ref$isProcessTransit;

    var payload = {
        shipping_address_id: checkoutSession.get('shipping.id')
    };

    if (checkoutSession.get('plan.conversion') && !isProcessTransition) {
        payload.currency_conversion_type = checkoutSession.get('plan.conversion.paypal') ? 'PAYPAL' : 'VENDOR';
        payload.is_conversion_shown = checkoutSession.get('plan.conversion.changeable') ? 1 : 0;
        payload.currency_conversion_from_curr = checkoutSession.get('plan.conversion.from_code');
        payload.currency_conversion_to_curr = checkoutSession.get('plan.conversion.to_code');
    } else if (checkoutSession.get('plan.conversion') && isProcessTransition) {
        payload.currency_conversion_selected = checkoutSession.get('plan.conversion.paypal') ? 'PAYPAL' : 'VENDOR';
        payload.currency_conversion_from_curr = checkoutSession.get('plan.conversion.from_code');
        payload.currency_conversion_to_curr = checkoutSession.get('plan.conversion.to_code');
    }
    if (_factory3.$RewardsCheckboxFactory.rewardsFound()) {
        var contentKeys = _factory3.$RewardsCheckboxFactory.getContentKeys(checkoutSession.plan);

        payload.fi_id = (0, _utils.getInstrumentID)(checkoutSession.plan);
        payload.rewards_type = contentKeys.issuerName;
        payload.rewards_amt = contentKeys.value.rewardAmount; // monetary amount
        if (!isProcessTransition) {
            payload.rewards_fi = _factory3.$RewardsCheckboxFactory.toString();
        }
    }
    return payload;
}

var $xoReviewPageComponent = exports.$xoReviewPageComponent = _squid.$Component.extend('$xoReviewPageComponent', {
    tag: 'xo-review-page',
    template: _template2['default'],
    scope: {
        redirectiframe: '=?',
        redirectLightbox: '=?'
    },
    actions: {
        updatePreferredFi: function updatePreferredFi(logger) {
            if (this.makeFiPreferred && this.makeFiPreferred.selected) {
                var PreferredFi = new _fi.$PreferredFi({
                    preferred: [this.makeFiPreferred.fiId]
                });

                logger.info('checkout_fpti', { 'pref_fi_set': '1' });
                return PreferredFi.save({
                    transientError: true,
                    contingencies: {
                        DEFAULT: function DEFAULT() {}
                    }
                });
            }

            logger.info('checkout_fpti', { 'pref_fi_set': '0' });

            return _angular.$q.when();
        }
    },
    lifecycle: {
        reenter: function reenter() {
            var msgKeys = this.checkoutSession.get('message.msgKeys', []);

            if (msgKeys.indexOf('confirmUpop.confirmUpopOrChooseAltMethod') === -1) {
                this.showUnconfirmedUpopMsg = !!this.checkoutSession.unconfirmed_upop;
            }

            // Reset the selectedmethod indicator and state change listener
            if (this.setupMultipleFi) {
                this.setupMultipleFi();
            }

            var instrumentId = this.checkoutSession.get('fundingOptions.plans.0.primaryFs.id');

            // If FS has changed due to an update, reset the preferred FI checkbox
            if (this.makeFiPreferred && this.makeFiPreferred.fiId !== instrumentId) {
                _logger.$logger.info('checkout_fpti', { 'pref_fi_option_shown': '1' });
                this.makeFiPreferred.selected = false;
            }

            this.topupError = false; // set default value to false (hide error when enter)

            _logger.$logger.info('checkout_fpti', _extends({
                from: 'REVIEW',
                to: 'prepare_review'
            }, createReviewFptiPayload({ checkoutSession: this.checkoutSession })));

            // TODO: turn off `xo_hermes_preferred_expired_msg_review_page` since currently
            // it's not running. However, AuthRate team will be running this experiement again
            // this.showExpiredMsg = $ExpiredMsgFactory.showExpiredMsg(
            //     this.isNmj,
            //     this.checkoutSession
            // );

            // if (this.showExpiredMsg) {
            //     $ExpiredMsgFactory.getPreferredExpiredPxpResult().then(result => {
            //         this.isNmjexpired = result === 'xo_hermes_preferred_expired_msg_review_page_nmj_treatment' ? true : false;
            //         this.preferredExpired = this.checkoutSession.getDisallowedPreferred();
            //     });
            // }

            this.checkForIxoShippingMethods();
        },
        populate: function populate() {
            if (this.checkoutCart.isWalletTokenization()) {
                (0, _jquery2['default'])('#outerWrapper').addClass('tokenization topup');
                var windowHeight = window.innerHeight || document.documentElement && document.documentElement.clientHeight;
                var footerHeaderHeight = document.querySelector('xo-header .paypalHeader').clientHeight + document.querySelector('xo-footer .footer').clientHeight;

                document.querySelector('.review .reviewTopup').style.minHeight = windowHeight - footerHeaderHeight - 5 + 'px'; // 5px for header/footer alignment
            }
        },
        exit: function exit() {
            if (this.checkoutCart.isWalletTokenization()) {
                (0, _jquery2['default'])('.tokenization').removeClass('topup');
            }
            _factory3.$RewardsCheckboxFactory.destroy();
        }
    },
    controller: ['$scope', '$element', function ($scope, $element) {
        $scope.choiceBalanceCheckboxState = _factory5.$BalanceFactory.get();
        $scope.tokenizedFactoryState = _tokenizedFactory.$TokenizedFactory.get();
        $scope.noBalanceFactoryState = _factory2.$NoBalanceFactory.get();

        $scope.isThirdPartyWalletExperience = function () {
            var experience = _thirdPartyInfo.thirdPartyExperience.getExperience(_angular.$rootScope.token);

            return experience === 'BAIDU_EXPERIENCE' || experience === 'VENMO_EXPERIENCE';
        };

        $scope.determineThirdPartyWalletExperience = function () {
            return _thirdPartyInfo.thirdPartyExperience.getExperience(_angular.$rootScope.token);
        };

        $scope.creditParentContext = {
            populated: false,
            newMember: {},
            showCreditOffer: true // Flag for experimenting with display of the Credit Offer based on CEP
        };

        $scope.memberSegment = _marketingoffer.$MemberSegmentModel.instance();

        $scope.showCreditPlacement = function () {
            // for xo-offer handling
            $scope.creditParentContext.newMember.creditOffer = $scope.memberSegment && $scope.memberSegment.creditOffer;

            var show = !$scope.isThirdPartyWalletExperience() && $scope.creditParentContext.populated && $scope.creditParentContext.showCreditOffer && !_angular.$rootScope.showFiSelectPage && ($scope.checkoutSession.creditOffer || $scope.isPPCReuseAndNotSelected());

            return show;
        };
        $scope.isProcessorDeclineExperiment = false;

        var placeholderExperimentName = 'xo_hermes_ppc_banner_placeholder';
        var placeholderTreatmentName = 'xo_hermes_ppc_banner_placeholder_treatment';
        $scope.isPlaceholderTreatment = false;
        (0, _squid.$pxp)(placeholderExperimentName, {}, placeholderTreatmentName, false, true).then(function (result) {
            var _$logger$info;

            $scope.isPlaceholderTreatment = result && result.treatment_name === placeholderTreatmentName || false;
            _logger.$logger.info('checkout_fpti', (_$logger$info = {}, _$logger$info[placeholderExperimentName] = result && result.treatment_name, _$logger$info));
        });

        var applyNewMemberVariant = function applyNewMemberVariant() {
            return _newMember.$NewMemberEligibility.instance().getVariant(_angular.$rootScope.token).then(function (variant) {
                // feature flag for one page nmj experience
                var isNmjDesign1 = $scope.isNmjDesign1 = variant === 'one_page';
                // feature flag for one page nmj design 2 experience
                var isNmjDesign2 = $scope.isNmjDesign2 = variant === 'design_2';
                // feature flag for one page nmj design 3 experience
                var isNmjDesign3 = $scope.isNmjDesign3 = variant === 'design_3';
                // umbrella flag for nmj experience
                var isNmj = $scope.isNmj = isNmjDesign1 || isNmjDesign2 || isNmjDesign3;

                $scope.showViewYourPaymentRights = (isNmjDesign2 || isNmjDesign3) && _squid.$locale.country === 'US';
                $scope.showGreyHeader = $scope.isNmjDesign2 || $scope.isNmjDesign3;
                $scope.nmjExperience = {
                    one_page: $scope.isNmjDesign1,
                    design_2: $scope.isNmjDesign2,
                    design_3: $scope.isNmjDesign3
                };

                // set assist-banner content based on type of nmj flow - if any
                var isPayNow = $scope.useraction === 'commit';
                var userName = $scope.auth.first_name ? $scope.auth.first_name : $scope.auth.email;

                if (isNmjDesign1) {
                    $scope.assistBannerHeader = _squid.$locale.content.get('memberReview.assistHeader_1page');
                    $scope.assistBannerBody = _squid.$locale.content.get(isPayNow ? 'memberReview.assistBody_paynow_1page' : 'memberReview.assistBody_continue_1page');
                } else if ($scope.showGreyHeader) {
                    if (isPayNow) {
                        $scope.headerMsg = (0, _squid.$renderContent)('memberReview.nmjDesign2HeaderMsgPayNow', { userName: userName });
                    } else {
                        $scope.headerMsg = (0, _squid.$renderContent)('memberReview.nmjDesign2HeaderMsgContinue', { userName: userName });
                    }
                }
                $scope.creditParentContext.newMember.variant = variant;
                $scope.creditParentContext.newMember.useCEPDecision = isNmj;
                $scope.creditParentContext.populated = true;
                $scope.showPaypalPolicy = !$scope.isThirdPartyWalletExperience() && $scope.showPaypalPolicies && !$scope.showViewYourPaymentRights;
                $scope.showPaymentRights = !$scope.isThirdPartyWalletExperience() && $scope.showPaypalPolicies && $scope.showViewYourPaymentRights;
                _logger.$logger.info('member_ryi_variant_' + (variant || 'unknown'), {
                    isNmj: isNmj,
                    variant: variant
                });
                triggerPersonalizedBanner();
            });
        };

        var triggerPersonalizedBanner = function triggerPersonalizedBanner() {
            $scope.personalizedBanner.trigger();
        };

        if ($scope.isThirdPartyWalletExperience()) {
            // log buyer type for third Party usecases
            _logger.$logger.info('buyer_info', {
                fpti_buyer_type: $scope.determineThirdPartyWalletExperience() === 'VENMO_EXPERIENCE' ? 'Guestuser_venmo' : 'nonloginmember_benteley'
            });
        } else {
            // log existing buyer
            _logger.$logger.info('buyer_info', { fpti_buyer_type: 'Existinguser' });
        }

        // ----------------- OUTRO PXP VARS - START -------------------- //
        // NOTES: `xo_hermes_exit_msg` pxp has ramped to 100% and will always
        // return `xo_hermes_exit_msg_option5` treatment.
        // See: https://engineering.paypalcorp.com/pxptool/configuration?exptId=2609&version=9
        var pxpMerchNameLimit = 20; // max length of the merchant name
        var pxpMerchName = void 0; // the brand or merchant name - resolved after retrieving appdata

        // ----------------- OUTRO PXP VARS - END -------------------- //
        $scope.token = _angular.$rootScope.token;
        $scope.backUri = 'checkout.review';
        $scope.installmentNotSelected = false;
        $scope.installment = {
            showBanner: false,
            showCYCO: false,
            showCreditExample: false
        };

        /* Flag to determine whether merchant supports callback shipping options for given address
         1. Default : true
         2. shippingRegionSupported : false -> Show shipping region not supported error in review page and do not allow Pay
         */
        $scope.instantUpdateFeature = {
            shippingRegionSupported: true
        };
        $scope.shippingChangeFeature = {};

        var initAndCallOnShippingChange = function initAndCallOnShippingChange() {
            $scope.shippingChangeFeature = (0, _shippingChangeFeature.createShippingChangeFeature)($scope.token, $scope.checkoutCart, $scope.checkoutSession, $scope.checkoutAppData, function () {
                return $scope.checkForIxoShippingMethods();
            });
            $scope.shippingChangeFeature.callOnShippingChange();
        };

        // PAD Toggle feature
        $scope.padToggleFeature = {
            applicable: false,
            checkboxEnabled: false,
            showCheckbox: false,
            defaultPlan: false,
            pxpControlEnabled: false,
            fptiLogged: false,
            multiFiCheckboxStates: {}
        };

        // 'continue' or 'pay now' button text
        $scope.payButtonText = function () {
            return '';
        };
        $scope.isGCcountry = (_squid.$config.giftCardSupportedCountries || '').indexOf(_squid.$locale.country) > -1;
        $scope.showPaypalPolicies = (0, _squid.$featureCountries)('showPaypalPolicies').indexOf(_squid.$locale.country) > -1;
        $scope.makeAddrPreferred = {
            shown: false,
            selected: false
        };
        $scope.showPolicyAgreement = (0, _squid.$feature)('showPolicyAgreement');

        var _ref2 = window.xprops || {},
            _ref2$experience = _ref2.experience,
            experience = _ref2$experience === undefined ? { facebook: false } : _ref2$experience;

        $scope.isFacebookBAIntegration = experience.facebook;
        $scope.isMessengerBAIntegration = _integration.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
        $scope.isPrechecked = _fbMessenger2['default'].PRECHECKED_COUNTRIES.indexOf(_squid.$locale.country) >= 0;

        $scope.personalizedBanner = {
            show: false,
            trigger: function trigger() {
                var isOneTouchBanner = $scope.auth.rememberedOT() && (0, _squid.$feature)('oneTouchPersonalization');
                var newMemberDesign1 = $scope.isNmjDesign1;

                $scope.personalizedBanner.show = newMemberDesign1 || isOneTouchBanner;
            }
        };

        $scope.optin_toggle = {
            isEnabled: false,
            value: false,
            showExpandedTerms: true,
            setValue: function setValue(val) {
                this.value = val;
                // this.showExpandedTerms = false; // hide terms upon user interaction
                _logger.$logger.debug('ryi_optin_toggle_setValue', {
                    value: this.value,
                    showExpandedTerms: this.showExpandedTerms
                });
            }
        };
        _logger.$logger.debug('kmliUpsell review: init');
        _kmliUpsell.$KmliUpsell.init(_angular.$rootScope.token, false, true);

        function optInUser() {
            // eslint-disable-line no-unused-vars
            _logger.$logger.info('ryi_optin', {
                'from': 'OT_Toggle',
                'to': 'prepare_optin'
            });
            $scope.optin_toggle.setValue(true);
            var optinSource = 'checkoutToggle';
            var silentSpinner = true;

            return _ul.$ul.optInToOneTouch(_angular.$rootScope.token, _squid.$locale.country, _squid.$locale.lang, silentSpinner, {
                'stateName': 'OT_Toggle',
                'transInfix': 'process_optin'
            }, optinSource).then(function (res) {
                _logger.$logger.debug('ryi_optin_toggle_process_optin');
            })['catch'](function (err) {
                // eslint-disable-line handle-callback-err
                _logger.$logger.debug('ryi_optin_toggle_process_optin_Error', {
                    'int_error_description': err && err.message
                });
            });
        }

        function optOutUser() {
            // eslint-disable-line no-unused-vars
            _logger.$logger.info('ryi_optin', {
                'from': 'OT_Toggle',
                'to': 'prepare_optout'
            });
            return $scope.auth.action('optout', { silent: true }).then(function (res) {
                _logger.$logger.info('ryi_optin', {
                    'from': 'OT_Toggle',
                    'to': 'process_optout'
                });
                $scope.$applyAsync(function () {
                    var bannerElement = $element.find('.oneTouchBanner');

                    bannerElement.addClass('leave_animation');
                    _logger.$logger.debug('ryi_optin bannerElement animate');
                    (0, _angular.$timeout)(function () {
                        $scope.optin_toggle.setValue(false);
                        $scope.optin_toggle.isEnabled = false;
                    }, 1400);
                });
            })['catch'](function (err) {
                _logger.$logger.info('ryi_optin', {
                    'from': 'OT_Toggle',
                    'to': 'process_optout',
                    'error_source': 'identityauthorizationserv',
                    'int_error_code': 'optout_failure',
                    'int_error_description': err && err.message
                });
            });
        }

        $scope.onTouchToggle = function (value) {
            _logger.$logger.debug('optin_toggle_change_attempt', {
                'ryi_optin': $scope.optin_toggle,
                'remembered': $scope.auth.remembered,
                'value': value
            });
            if ($scope.optin_toggle.isEnabled) {
                if (value) {
                    optInUser();
                } else {
                    optOutUser();
                }
            }
        };

        $scope.tagFamilyComputer = function () {
            // creates a log to tag device as family computer.
            // if we can distinguish between single user, family computer and shared computer
            // we may be able to offer a way to switch accounts
            var buyer_id = $scope.auth.buyer_id;
            var logPayload = {
                localStorageEnabled: false,
                isMobile: _index2.$DeviceInfo.isMobile()
            };

            if (_squid.$util.localStorageEnabled()) {
                var family_device_key = 'family_device_test';
                var public_device_key = 'public_device_test';

                logPayload.localStorageEnabled = true;

                var objStr = localStorage.getItem(family_device_key);
                var publicDeviceTest = localStorage.getItem(public_device_key);

                if (publicDeviceTest === 'true') {
                    // dont overuse localStorage there is a size limit
                    localStorage.removeItem(family_device_key);
                    logPayload.isPublicDevice = true;
                } else {
                    var buyerList = objStr ? JSON.parse(objStr) : [];

                    if (buyerList.indexOf(buyer_id) === -1) {
                        buyerList.push(buyer_id);
                    }
                    // assuming 5 or less users on a device as family computer
                    logPayload.isFamilyDevice = Boolean(buyerList.length > 1 && buyerList.length < 6);
                    logPayload.isPublicDevice = Boolean(buyerList.length > 20);
                    logPayload.userCount = buyerList.length;
                    objStr = JSON.stringify(buyerList);
                    localStorage.setItem(family_device_key, objStr);
                    localStorage.setItem(public_device_key, logPayload.isPublicDevice.toString());
                }
            }
            var eligibility_reason = 'localStorage:' + logPayload.localStorageEnabled + '_isPublicDevice:' + logPayload.isPublicDevice + '_isFamilyDevice:' + logPayload.isFamilyDevice + '_userCount:' + logPayload.userCount;

            _logger.$logger.debug('family_device_test', logPayload);
            _logger.$logger.info('checkout_fpti', {
                'from': 'family_device_test',
                'to': 'process_elg_chk',
                'eligibility_reason': eligibility_reason
            });
        };

        function stickyCTA() {
            return _eligibility.$stickyCTA.instance().getEligibility().then(function (eligibility) {
                $scope.stickyEligibility = eligibility;
            });
        }

        // Format the informal name if populated
        function setInformalName() {
            if ($scope.auth) {
                $scope.formattedNameInformal = (0, _squid.formatNameInformal)({
                    first_name: $scope.auth.first_name,
                    last_name: $scope.auth.last_name
                }) || $scope.auth.email;
            }
        }

        function donationAuthorize() {
            var donationConsent = _factory.$GiveAtCheckoutFactory.get().donateCheckboxSelected;
            var charity = _factory.$GiveAtCheckoutFactory.get().charity;

            if (donationConsent) {
                _logger.$logger.info('checkout_fpti', {
                    from: 'GIVE_AT_CHECKOUT',
                    to: 'process_give_at_checkout',
                    gac_model: charity.model_id,
                    gac_npid: charity.nonprofit_id
                });
                return _donation.$GiveAtCheckoutModel.instance().action('donationAuthorize', {
                    data: {
                        'ec_token': _angular.$rootScope.token,
                        'nonprofit_id': charity.nonprofit_id,
                        'charity_name': charity.name,
                        'money': {
                            'value': charity.amount,
                            'currency_code': charity.currency
                        }
                    },
                    success: function success() {
                        return _logger.$logger.info('donation_authorize_success', {});
                    },
                    error: function error() {
                        return _logger.$logger.error('donation_authorize_failure');
                    }
                });
            }
        }

        function updateAddressAsPreferred() {
            if ($scope.makeAddrPreferred.shown) {
                _logger.$logger.info('makeAddrPreferred.shown', {});
            }

            if ($scope.makeAddrPreferred.selected) {
                _logger.$logger.info('makeAddrPreferred.selected', {});
                // Ignore all errors from setPreferred api, by passing transientError as true
                return $scope.checkoutSession.shipping.action('setPreferred', {
                    transientError: true
                });
            }
            return _angular.$q.when();
        }

        function setStickyInstrument() {
            if (!_squid.$config.features.DEFAULT.enableStickyFunding || $scope.isThirdPartyWalletExperience()) {
                return _angular.$q.when();
            }

            // If the currently selected plan is not saved in the checkoutSession, make the call to save it.
            // For BA no purchase cases, the only way we track it is in the checkout session, so it should already be saved (selected id will equal sticky id).
            // For all other purchase cases, we need to look at the first in fundingOptions and match it to futurePaymentInstruments
            var savedSticky = $scope.checkoutSession.selectedFuturePaymentInstrument;
            var selectedSticky = $scope.checkoutSession.getSelectedStickyInstrument();

            // selectedSticky will not be populated if this isn't a billing case.
            if (!selectedSticky) {
                return _angular.$q.when();
            }

            // If we haven't saved the selected sticky instrument yet,
            // make the API call to save it
            if (!savedSticky || savedSticky.instrument_id !== selectedSticky.instrument_id) {
                return $scope.checkoutSession.action('setStickyFI', {
                    data: {
                        instrument_id: selectedSticky.instrument_id
                    }
                });
            }
            return _angular.$q.when();
        }

        function linkAuthConsent() {
            /* Check if its BA flow and we have merchant consent code */
            if ($scope.checkoutCart.isBilling() && $scope.checkoutCart.billing) {
                // Getting merchant account's billing consent code i.e. legal_text_code
                var billingConsentCode = $scope.checkoutCart.billing.consent_code;
                var FB_CONSENT_CODE = 'facebookp2p';
                var authConsentModel = _user.$AuthConsentModel.instance();

                if (billingConsentCode === FB_CONSENT_CODE) {
                    return authConsentModel.action('link', {
                        data: {
                            'ba_token': _squid.$meta.baToken
                        },
                        success: function success() {
                            return _logger.$logger.info('link_authconsent_success', {});
                        }
                    });
                }
            }
        }

        function setWalletTopupPreferences() {
            if ($scope.checkoutCart.isWalletTokenization()) {
                $scope.walletPreferences = _fi.$WalletPreferences.instance(_angular.$rootScope.token);
                return $scope.walletPreferences.save();
            }
        }

        function isValidPinSetup() {
            if ($scope.walletPinModel && $scope.walletPinModel.isSetupEligible()) {
                if (!$scope.walletPinModel.userPin) {
                    return false;
                }
            }
            return true;
        }

        function prepareTokenizedWallet() {
            if ($scope.checkoutCart.isWalletTokenization()) {
                return (0, _squid.$populate)($scope, {
                    walletPreferences: _fi.$WalletPreferences.instance(_angular.$rootScope.token),
                    walletPinModel: _app.$TokenizedWalletPinModel.instance(_angular.$rootScope.token),
                    tokenizedFundingCapabilitiesModel: _app.$TokenizedFundingCapabilitiesModel.instance(_angular.$rootScope.token).retrieve({
                        params: {
                            tokenizedWalletToken: $scope.checkoutCart.tokenizedWalletToken,
                            country: $scope.auth.country
                        }
                    })
                }).then(function (result) {
                    var fundingInstrument = $scope.walletPreferences.getPreferred();
                    var instrument_id = fundingInstrument.instrument_id;
                    var defaultTopupFI = _squid.$util.find($scope.checkoutSession.topupFundingSources, function (fs) {
                        return fs.instrument_id === instrument_id;
                    }) || {};
                    var defaultDirectFI = _squid.$util.find($scope.checkoutSession.futurePaymentInstruments, function (fs) {
                        return fs.instrument_id === instrument_id;
                    }) || {};
                    var pinStatus = 'default_pin_unavailable';

                    if ($scope.walletPinModel.isPinIdPresent()) {
                        pinStatus = 'already_exist';
                    } else if ($scope.walletPinModel.getPinOrigin() !== 'UNSET') {
                        pinStatus = 'pin_error';
                    } else if ($scope.walletPinModel.getSuggestedPin()) {
                        pinStatus = 'default_pin_available';
                    }

                    _logger.$logger.info('tokenized_wallet', {
                        'from': 'TopUp_REVIEW',
                        'to': 'prepare_review',
                        'context_id': $scope.token,
                        'context_type': 'EC-Token',
                        'billing_token': _squid.$meta.baToken,
                        'default_topup_fi': defaultTopupFI.type,
                        'default_direct_fi': defaultDirectFI.type,
                        'pin': pinStatus,
                        'flag': $scope.checkoutSession.get('sepa_mandate.bankId') ? 'sepa' : undefined
                    });
                });
            }
            return _angular.$q.when();
        }

        function checkJSV4PaymentDetails() {
            if (window.xprops && window.xprops.supplement && window.xprops.supplement.getPaymentDetails && ($scope.ixoShippingMethods || this.ixoShippingMethods)) {
                return window.xprops.supplement.getPaymentDetails($scope.checkoutAppData.get('payment_id')).then(function (details) {
                    if (!(details && details.selected_shipping_method)) {
                        $scope.checkoutSession.message = {
                            type: 'error',
                            msgKeys: ['shipping.bopisErrorMessage']
                        };
                        throw new Error('IXO_CANNOT_CHECKOUT_WITHOUT_SHIPPING_SELECTION');
                    } else {
                        delete $scope.checkoutSession.message;
                    }
                });
            }
            return _angular.$q.when();
        }

        function show3DSLightbox() {
            var cc_id = $scope.checkoutSession.get('resolve_3ds.ccId');
            var plans = $scope.checkoutSession.get('plan.sources', null);
            var plan = plans && plans.filter(function (e) {
                return e.instrument_id === cc_id;
            })[0].amount || null;

            $scope.resolve_3ds_data = {
                cc_id: cc_id,
                flow_id: 'HERMES',
                merchant_id: $scope.payee.get('merchant.id'),
                merchant_country_code: $scope.checkoutAppData.get('merchant.merchant_country'),
                transaction_amount_currency: plan && plan.currency_code || null,
                transaction_amount_value: plan && plan.amount || null
            };
            $scope.launch3DSResolver = true;
        }

        function applyProcessorDeclineMessage() {
            return (0, _squid.$elmo)('xo_hermesnodeweb_issuer_decline', { 'ctx.country': _squid.$locale.country }, 'Trmt_xo_hermesnodeweb_issuer_decline_1').then(function (result) {
                return result && result.treatment_name;
            });
        }

        function setProcessorDeclineMessage() {
            applyProcessorDeclineMessage().then(function (treatment) {

                $scope.isProcessorDeclineExperiment = treatment === 'Trmt_xo_hermesnodeweb_issuer_decline_1';
                var processorDeclinedMsg = _fiMessages.$fiMessages.processorDeclinedMsg($scope.checkoutSession, true, treatment, $scope.auth, $scope.fiMeta.wallet);

                if (processorDeclinedMsg) {
                    $scope.checkoutSession.message = {
                        type: processorDeclinedMsg.type,
                        msgs: [processorDeclinedMsg.msg]
                    };
                }
            });
        }

        function getPadToggleStatus() {
            var toggleStatus = 'NA'; // NOT APPLICABLE status

            if (_factory6.$PADFactory.isPadToggleFeatureApplicable($scope.padToggleFeature, $scope.isPadToggleEnabled)) {
                if ($scope.padToggleFeature.checkboxEnabled) {
                    toggleStatus = 'ON';
                } else {
                    toggleStatus = 'OFF';
                }
            }
            return toggleStatus;
        }

        /**
         * `Exit message` feature is currently only applied to:
         * 1) Only in US
         * 2) user action **not** "commit"
         * 3) not a billing agreement
         * 4) `DONE_PAGE` integration is false
         * @returns {boolean}
         */
        var applyExitMessage = function applyExitMessage() {
            return _squid.$locale.country === 'US' && $scope.useraction !== 'commit' && !$scope.checkoutCart.isBilling() && !_integration.$integration.getConfig('DONE_PAGE');
        };

        function authorize() {
            if ($scope.checkoutSession.resolve_3ds) {
                return show3DSLightbox();
            }

            function isXoonUpopRedirect() {
                if (!($scope.checkoutSession && $scope.checkoutSession.get('errorData.resolution.data.fi.type'))) {
                    return false;
                }

                return _squid.$util.param('redirectToHermesOnUpopCancel') === 'xoon' && $scope.checkoutSession.errorData.resolution.name === 'PAYER_TO_AUTHENTICATE_CARD' && !$scope.checkoutSession.errorData.resolution.data.alternate_options && $scope.checkoutSession.errorData.resolution.data.fi.type.toUpperCase() === 'CUP';
            }

            if ($scope.checkoutSession.unconfirmed_upop || isXoonUpopRedirect()) {
                var card = void 0;

                if ($scope.checkoutSession.unconfirmed_upop) {
                    card = $scope.checkoutSession.unconfirmed_upop;
                } else {
                    card = $scope.checkoutSession.errorData.resolution.data;
                }

                $scope.cardModel = new _fi.$AddCardModel({});
                $scope.cardModel.id = card.fundingId;
                $scope.cardModel.card = new _fi.$CardModel({
                    number: 'xxxx-xxxx-xxxx-' + card.fi.number,
                    type: card.fi.type.toUpperCase(),
                    productType: card.fi.productType
                });
                _uiRouter.$state.go('.confirmUpop');
                return;
            }

            // Currently, exit message will only be applicable to US. If we'd like
            // to expand exit message feature to other countries, we will need
            // translation from other countries.
            if (applyExitMessage()) {
                // HACK - REMOVE and REFACTOR ONCE DONE
                // overload base.processing in strings
                // since quid is hardcoded to use string each time
                // required only for testing - remove and refactor,
                // to properly allow for dynamic spinner messages

                // resolve merchant name
                var merchantName = pxpMerchName;
                // flag when name is missing or longer than 20 chars
                var badMerchantName = !merchantName || merchantName.length > pxpMerchNameLimit;
                var outroMsg = badMerchantName ? 'We’re sending you back to the merchant to complete this purchase.' : 'We\u2019re sending you back to <strong style="white-space:nowrap">' + merchantName + '</strong> to complete this purchase.';

                // capture current route
                var reviewRoute = _uiRouter.$state.current;

                // listen to !startLoad
                // this is the only way we can then manipulate the spinner
                var cancelOutroOverride = _angular.$rootScope.$on('startLoad', function () {
                    // if this is the review route...
                    // this is needed, in case the session has ended
                    // at this point, we need this listener to do nothing
                    if (_uiRouter.$state.current === reviewRoute) {
                        // force spinner styling and content
                        // this is delayed, because (for some reason)
                        // the spinner isn't in the DOM _yet_,
                        // even though #showSpinner() fired... UGH!
                        (0, _angular.$timeout)(function () {
                            var spinnerMessageEl = (0, _jquery2['default'])('#spinner-message');

                            if (spinnerMessageEl) {
                                spinnerMessageEl = spinnerMessageEl.css({
                                    width: '130%',
                                    marginLeft: '-15%'
                                });
                                if (spinnerMessageEl) {
                                    // setting here, since `ng-bind-html` didn't work in spinner directive
                                    spinnerMessageEl.html(outroMsg);
                                }
                            }
                        }, 1);
                    } else {
                        // (otherwise) when no longer the review route...
                        // this means something happened before redirect
                        // likely an expired session
                        // In that case we'll remove this listener
                        // It will just be re-added, in the next redirect attempt
                        cancelOutroOverride();
                    }
                });
            }

            var cardBackup = $scope.checkoutSession.cardBackup.getPlan();

            _logger.$logger.info('checkout_fpti', {
                from: 'processor_decline_retry',
                to: 'processor_decline_retry_eligibility',
                'is_bkp_funding_chosen': cardBackup && cardBackup.planId ? 1 : 0
            });

            _logger.$logger.info('checkout_fpti', _extends({
                from: 'REVIEW',
                to: 'process_review'
            }, createReviewFptiPayload({ checkoutSession: $scope.checkoutSession, isProcessTransition: true })));

            var isGoogleAccountLinking = _tokenizedFactory.$TokenizedFactory.isGoogleAccountLinking();

            // for Google account linking - make a batch call which includes "authorize" call first call
            // and updateIssuaceScope as second
            if (isGoogleAccountLinking) {
                _tokenizedFactory.$TokenizedFactory.updateIssuanceScope();
            }

            return $scope.checkoutSession.action('authorize', {
                batch: isGoogleAccountLinking && _tokenizedFactory.$TokenizedFactory.getAuthorizeBatch(),
                data: {
                    alternateFundingOptionId: cardBackup && cardBackup.planId
                },
                success: function success() {
                    if ($scope.checkoutSession.get('plan.paypal_credit')) {
                        _logger.$logger.info('checkout_fpti', { 'ppc_reuse_status': 'success' });
                    }

                    var padToggleStatus = getPadToggleStatus();

                    if (padToggleStatus === 'ON') {
                        _logger.$logger.info('checkout_fpti', {
                            'pad_toggle_status': 'padToggleOnSuccess'
                        });
                    } else if (padToggleStatus === 'OFF') {
                        _logger.$logger.info('checkout_fpti', {
                            'pad_toggle_status': 'padToggleOffSuccess'
                        });
                    }

                    // for all tokenized flows except google account linking - log FPTI in authorize sucess callback
                    if (!isGoogleAccountLinking && $scope.checkoutCart.isWalletTokenization()) {
                        _tokenizedFactory.$TokenizedFactory.logProcessReviewToFPTI();
                    }

                    // Just in case, cancel the state change listener checking if updateFs needs to be called
                    if ($scope.cancelUpdateListener) {
                        $scope.cancelUpdateListener();
                    }

                    if ($scope.checkoutSession.get('sepa_mandate.bankId')) {
                        return _uiRouter.$state.go('checkout.sepapage');
                    }

                    // xchild = V4 Incontext Integration. Do not initiate Payment.
                    if (!window.xchild && $scope.checkoutAppData.doec_on_approve()) {
                        return _uiRouter.$state.go('checkout.pay');
                    }

                    // for all flows except google account linking - go to end of checkout
                    // for google account linking - redirect happens in "updateIssuanceScope" call (see tokenizedFactory)
                    if (!isGoogleAccountLinking) {
                        return _uiRouter.$state.go('checkout.end');
                    }
                },
                contingencies: {
                    // Smart $x authorization check on the card fails
                    CREDIT_CARD_AUTH_FAILED: function CREDIT_CARD_AUTH_FAILED() {
                        $scope.checkoutSession.invalidate();
                        $scope.checkoutSession.smartDollarAuthFailed = true;
                        if ($scope.checkoutSession.selectedFuturePaymentInstrument) {
                            // Invalidate the saved FI selection to avoid display of stale selection on review page.
                            delete $scope.checkoutSession.selectedFuturePaymentInstrument;
                        }
                        return $scope.checkoutSession.action('create', {
                            success: function success() {
                                $scope.checkoutSession.smartDollarAuthFailed = false;
                                $scope.errorHandlerHelper.addPageError('payment.authFailureMultipleFIs');
                                return _uiRouter.$state.go('checkout.review', { message: 'CREDIT_CARD_AUTH_FAILED' });
                            }
                        });
                    }
                }
            });
        }

        function setShowShippingMethodProperty() {
            return (0, _squid.$populate)($scope, {
                shippingRulesSummary: _shippingMethod.$ShippingRuleSummaryModel.instance(_angular.$rootScope.token).retrieve({
                    params: {
                        merchant_id: $scope.payee.get('merchant.id'),
                        currency_code: $scope.checkoutCart.get('purchase.amounts.total.currency_code')
                    }
                })
            }).then(function () {
                if ($scope.shippingRulesSummary.isSnTEnabled) {
                    _logger.$logger.info('shipping_rules_summary_snt_enabled');
                } else {
                    _logger.$logger.info('shipping_rules_summary_snt_disabled');
                }
                $scope.showShippingMethod = $scope.shippingRulesSummary.isSnTEnabled || $scope.isInstantUpdateAPIFlow;
                return;
            });
        }

        function show3DSDeclineMsg(declineAfter3DSAccept) {
            // Instrument number of available plans for 3DS decline case.
            var numberOfPlans = $scope.checkoutSession.getPlanList() ? $scope.checkoutSession.getPlanList().length : 0;

            _logger.$logger.info('3DS_decline_plan_count', { 'plans': numberOfPlans });

            var key = 'threeDS.memberDecline';

            if (declineAfter3DSAccept) {
                key = 'threeDS.memberDeclineAfter3DSAccept';
            }

            var card = $scope.checkoutSession && $scope.checkoutSession.resolve_3ds;

            if (card) {
                var msg = (0, _squid.$renderContent)(key, {
                    cardType: card.type,
                    last4: card.number
                });

                $scope.checkoutSession.message = {
                    msgs: [msg],
                    type: 'warning'
                };
            }
        }

        /**
         * call patchXO API to clear the 3DS contingency and then call authorize API.
         */
        function clear3DSContingency() {
            var resolve_3ds = $scope.checkoutSession.resolve_3ds || {};

            return $scope.checkoutSession.action('clear3DSContingency', {
                data: {
                    ccId: resolve_3ds.ccId
                },
                success: function success() {
                    // Clear3DSContingency can change the plan ids, so reset the multipleFi indicator after this is called
                    if ($scope.setupMultipleFi) {
                        $scope.setupMultipleFi();
                    }

                    if (!$scope.checkoutSession.resolve_3ds) {
                        // For app redirect flow, we cannot continue directly to approve and redirect due to browser security
                        // Stop here and have the user click the "Continue" button again
                        var url = $scope.checkoutAppData.get('urls.return_url') || '';
                        var isHTTPUrl = Boolean(url.indexOf('http') === 0 || url.indexOf('www') === 0);
                        var isAppRedirect = Boolean(_index2.$DeviceInfo.isDevice() && !isHTTPUrl);

                        // Reset the message if present
                        delete $scope.checkoutSession.message;

                        if (isAppRedirect) {
                            return;
                        }

                        return authorize();
                    } else {
                        // Symphony is not able to clear the 3DS contingency
                        show3DSDeclineMsg(true);
                    }
                }
            });
        }

        $scope.onComplete3DSHandler = function (status) {
            $scope.launch3DSResolver = false;
            if (status === 'success') {
                return clear3DSContingency();
            } else if (status === 'decline') {
                // 3DS got declined
                show3DSDeclineMsg();
            }
        };

        $scope.upopCallbacks = {
            onConfirmUpopSuccess: function onConfirmUpopSuccess() {
                _uiRouter.$state.go('checkout.review');
                return $scope.checkoutSession.action('clearContingency', {
                    data: {
                        contingency: 'UNCONFIRMED_UPOP',
                        ccId: $scope.checkoutSession.get('unconfirmed_upop.fundingId') || $scope.checkoutSession.get('errorData.resolution.data.fundingId')
                    },
                    success: function success() {
                        if (!$scope.checkoutSession.unconfirmed_upop) {
                            return authorize();
                        } else {
                            $scope.checkoutSession.message = {
                                type: 'warning',
                                msgKeys: ['confirmUpop.confirmUpopOrChooseAltMethod']
                            };
                        }
                    }
                });
            },
            onConfirmUpopCancel: function onConfirmUpopCancel() {
                _uiRouter.$state.go('checkout.review');
                $scope.showUnconfirmedUpopMsg = false;
                $scope.checkoutSession.message = {
                    type: 'warning',
                    msgKeys: ['confirmUpop.confirmUpopOrChooseAltMethod']
                };
            }
        };

        $scope.errorHandlerHelper = {};
        $scope.errorHandlerHelper.addPageError = function (contentKey, dynamicValuesInContent) {
            var messages = [];
            var msg = void 0;

            if (dynamicValuesInContent) {
                msg = (0, _squid.$renderContent)(contentKey, dynamicValuesInContent);
            } else {
                msg = _squid.$locale.content.get(contentKey);
            }

            messages.push(msg);
            $scope.checkoutSession.message = {
                msgs: messages,
                type: 'error'
            };
        };

        $scope.errorHandlerHelper.clearPageErrors = function () {
            $scope.checkoutSession.message = '';
        };

        $scope.returnFromCape = function (isCapeReturnKey) {
            return $scope.creditDataModel.action('readCreditKey', {
                data: {
                    capeKey: isCapeReturnKey
                },
                success: function success(res) {
                    // if CAPE includes this field inside the mayfly payload, we will show-up a warning message
                    // on the top of the page ('offers.bmlInWalletDeniedMsg') regarding the declined credit application
                    if (res.show_cape_declined_msg) {
                        $scope.checkoutSession.message = {
                            type: 'warning',
                            msgKeys: ['offers.bmlInWalletDeniedMsg']
                        };
                    }

                    if (res.financial_instrument_id) {
                        var financial_instrument_id = res.financial_instrument_id.indexOf('BC') !== 0 ? 'BC' + res.financial_instrument_id : res.financial_instrument_id;

                        return $scope.checkoutSession.fundingOptions.action('update', {
                            resultModel: $scope.checkoutSession,
                            data: {
                                planId: financial_instrument_id
                            },
                            success: function success(result) {
                                $scope.checkoutSession.message = {
                                    type: 'success',
                                    msgKeys: ['offers.bmlInWalletSuccessMsg']
                                };

                                if ($scope.setupMultipleFi) {
                                    $scope.setupMultipleFi();
                                }
                            }
                        });
                    }

                    // User does not have any FI in wallet and they choose to pay in full.
                    else if (!$scope.checkoutSession.get('plan.sources') && $scope.checkoutSession.isCreditPromoted) {
                            _uiRouter.$state.go('checkout.pageAddCard.addCardFlow.addCard');
                        } else if ($scope.creditDataModel.isCapeInternalServiceError()) {
                            // Todo Show error message from CAPE
                            return _angular.$q.when();
                        } else {
                            return _angular.$q.when();
                        }
                },
                contingencies: {
                    DEFAULT: function DEFAULT(name, err) {
                        _logger.$logger.info('read_cape_key_failure');
                        return _angular.$q.when();
                    }
                }
            });
        };

        var ifPadThenUpdatePlan = function ifPadThenUpdatePlan(selectedMethodPlanId) {
            // For pad toggle feature with Choice Multi FI experience, we look up the plan ID here
            var padOrIachPlanId = _factory6.$PADFactory.isPadToggleFeatureApplicable($scope.padToggleFeature, $scope.isPadToggleEnabled) && _factory6.$PADFactory.getPadOrIachBankPlanId({
                selectedMethodPlanId: selectedMethodPlanId,
                fundingOptions: $scope.checkoutSession.fundingOptions,
                multiFiCheckboxStates: $scope.padToggleFeature.multiFiCheckboxStates
            });

            return padOrIachPlanId ? padOrIachPlanId : selectedMethodPlanId;
        };

        /**
         *  Decides the plan to use based on
         *  Pad, Credit, Rewards and any other
         *  bussiness logic
         *
         * @returns planID
         */
        var decidePlanSelection = function decidePlanSelection() {
            // TODO: Consider moving this to a generic wallet/plan factory
            // this will avoid repetition in RYI, SelectFI and PayWith
            var defaultPlan = $scope.checkoutSession.get('plan.sources') && $scope.checkoutSession.get('plan.sources')[0];
            var hasRewards = _factory3.$RewardsCheckboxFactory.isRewardsPlan($scope.checkoutSession.plan);
            var selectedMethodPlanId = (0, _utils.getSelectedPlan)($scope.selectedmethod, $scope.checkoutSession);

            if (!$scope.selectedmethod && !hasRewards) {
                return '';
            }

            selectedMethodPlanId = ifPadThenUpdatePlan(selectedMethodPlanId);
            selectedMethodPlanId = _factory3.$RewardsCheckboxFactory.ifRewardsThenUpdatePlan(selectedMethodPlanId, $scope.selectedmethod, $scope.checkoutSession);

            // If the plan is already selected, we don't need to duplicate the call
            if (selectedMethodPlanId === (defaultPlan && defaultPlan.id)) {
                return '';
            }

            // This is handled in onPay
            if (selectedMethodPlanId === 'applyForPPCRadio') {
                return '';
            }
            return selectedMethodPlanId;
        };

        /**
         *  Given a plan id perform a selection
         *  and handle any errors/contingencies
         *
         * @returns planID
         */
        var doPlanSelection = function doPlanSelection(selectedMethodPlanId) {
            return $scope.checkoutSession.fundingOptions.action('select', {
                data: {
                    planId: selectedMethodPlanId
                },
                success: function success(result) {
                    $scope.checkoutSession.populate(result);

                    // for multi fi use case after replan we need to reset index to 0
                    // since selected instrument will always be first
                    if ($scope.selectedmethod) {
                        $scope.selectedmethod.index = 0;
                    }
                },
                contingencies: {
                    NEED_AUTHENTICATED_CARD: function NEED_AUTHENTICATED_CARD(name, result) {
                        // Route to the Confirm Upop page
                        if (result && result.resolution) {
                            var card = result.resolution.data;

                            if (card.fundingId && card.fi && card.fi.type) {
                                $scope.cardModel = new _fi.$AddCardModel();
                                $scope.cardModel.id = card.fundingId;
                                $scope.cardModel.card = new _fi.$CardModel({
                                    number: 'xxxx-xxxx-xxxx-' + card.fi.number,
                                    type: card.fi.type.toUpperCase(),
                                    productType: card.fi.productType
                                });
                            }
                        }

                        // Before routing to confirm Upop route, we cancel the state change listener so that we don't call updateFS. At this point, the user has already made their selection, so this is unneeded.
                        if ($scope.cancelUpdateListener) {
                            $scope.cancelUpdateListener();
                        }

                        // Route to the Confirm Upop page. We'll hold on to this deferred promise until the confirmation flow is finished, so we can then continue the chain or cancel out
                        var upopResult = _angular.$q.defer();

                        // Create the handlers for Upop, specifically for this flow. They will act on the deferred promise when the flow is completed
                        $scope.upopCallbacks.isOnUpdate = true;
                        $scope.upopCallbacks.onUpdateSuccess = function () {
                            // On confirmed, update the checkout session then continue
                            return $scope.checkoutSession.fundingOptions.action('update', {
                                resultModel: $scope.checkoutSession,
                                silent: true,
                                data: {
                                    planId: $scope.cardModel.id
                                },
                                success: function success() {
                                    if ($scope.checkoutSession.cvvData) {
                                        $scope.checkoutSession.set('cvvData.security_code', $scope.cardModel.get('card.security_code'));
                                    }

                                    // Reset the callback flag
                                    $scope.upopCallbacks.isOnUpdate = false;
                                    $scope.setupMultipleFi();
                                    // Return to this route, resolve the promise
                                    _uiRouter.$state.go('checkout.review');
                                    upopResult.resolve();
                                }
                            });
                        };
                        $scope.upopCallbacks.onUpdateCancel = function () {
                            // Break the promise chain and return to the review page
                            $scope.upopCallbacks.isOnUpdate = false;
                            $scope.setupMultipleFi();
                            upopResult.reject();
                            $scope.upopCallbacks.onConfirmUpopCancel();
                        };

                        _uiRouter.$state.go('.confirmUpop');
                        return upopResult.promise;
                    }
                }
            });
        };

        // For the multiple FI variant of the choice experiment:
        // Update the funding option in the plan based on the user's stored selection
        var updateFS = function updateFS() {
            // Decide plan to select based on priority and bussness logic
            var selectedMethodPlanId = decidePlanSelection();

            // Perform a selection only if required
            return selectedMethodPlanId ? doPlanSelection(selectedMethodPlanId) : _angular.$q.when();
        };

        // The following functions are all used in the `$q.all` promise chain below
        var populateScope = function populateScope() {
            return (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance(),
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
                checkoutCart: _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token),
                checkoutSession: _checkout.$CheckoutSessionModel.instance(_angular.$rootScope.token),
                payee: _checkout.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
                tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance(_angular.$rootScope.token).retrieve(),
                fiMeta: _index4['default'].instance(_angular.$rootScope.token).fetch()['catch'](_angular.noop)
            });
        };

        var initializePadToggleSupport = function initializePadToggleSupport() {
            if ($scope.checkoutSession.fundingOptions.isPadToggleApplicable()) {
                return Experiments.padToggleFeatureSupported().then(function (result) {
                    $scope.isPadToggleEnabled = result;
                });
            } else {
                return _angular.$q.when($scope.isPadToggleEnabled = false);
            }
        };

        var applyChoiceExperimentVariant = function applyChoiceExperimentVariant() {
            $scope.tagFamilyComputer();
            // Get the choice experiment variant to determine what needs to be shown in the UI
            return _choice.$ChoiceEligibility.instance().getVariant($scope.token).then(function (variant) {
                $scope.choiceVariant = variant;
                var checkboxVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.preferredCheckbox || [];
                var multipleFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.multipleFi || [];
                var selectFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.selectFi || [];

                if (checkboxVariants.indexOf(variant) !== -1 && !$scope.checkoutCart.isBilling()) {
                    // Do setup for preferred checkbox
                    $scope.makeFiPreferred = {
                        selected: false
                    };
                }

                $scope.showMultipleFiVariants = multipleFiVariants.indexOf(variant) !== -1;

                if ($scope.showMultipleFiVariants) {
                    var planList = $scope.checkoutSession.get('plan.sources');
                    var defaultPlanId = planList && planList[0] && planList[0].id;

                    // Do the setup for the multipleFiVariant
                    $scope.setupMultipleFi = function () {
                        $scope.selectedmethod = {
                            index: 0,
                            planId: defaultPlanId
                        };

                        if ($scope.cancelUpdateListener) {
                            $scope.cancelUpdateListener();
                        }

                        // Before changing state, persist the change that the user selected
                        var stateChangeListener = _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
                            $scope.cancelUpdateListener();

                            // ensure we only listen to state changes initiated from the review page
                            if (_uiRouter.$state.fromState.name !== 'checkout.review') {
                                return;
                            }

                            // ignore if the FI selection hasn't been updated
                            if (defaultPlanId === $scope.selectedmethod && $scope.selectedmethod.planId) {
                                return;
                            }

                            event.preventDefault();
                            updateFS().then(function () {
                                return _uiRouter.$state.go(toState, toParams);
                            });
                        });

                        // If the checkout session changes, also change the planId according to the selected index in case plan ids were changed. Save the listener to destroy the handler when changing routes or re-calling setupMultipleFi
                        var fundingOptionsListener = $scope.$watch('checkoutSession.fundingOptions', function (newVal, oldVal) {
                            if (!newVal) {
                                return;
                            }

                            $scope.selectedmethod.planId = newVal.get('plans.' + $scope.selectedmethod.index + '.planId');
                        });

                        $scope.cancelUpdateListener = function () {
                            stateChangeListener();
                            fundingOptionsListener();
                        };

                        $scope.$on('$destroy', $scope.cancelUpdateListener);
                    };

                    $scope.setupMultipleFi();
                }

                if (selectFiVariants.indexOf(variant) !== -1) {
                    $scope.selectFiVariant = true;
                }
            })['catch'](function (err) {
                // TODO: Check what happens to PXP errors
                _logger.$logger.error('choice_eligibility_error', err);
            });
        };

        var applyMerchantName = function applyMerchantName() {
            // resolve merchant name now, just in case we're in a matching treatment
            pxpMerchName = $scope.checkoutAppData.merchant.brand_name || $scope.checkoutAppData.merchant.merchant_name;
        };

        // if IXO is providing shipping methods, we'll send them to xo-review-shipping-options component
        $scope.checkForIxoShippingMethods = function () {
            if (window.xprops && window.xprops.supplement && window.xprops.supplement.getPaymentOptions) {
                return window.xprops.supplement.getPaymentOptions($scope.checkoutAppData.get('payment_id')).then(function (payment) {
                    var paymentTransaction = payment && payment.transactions && payment.transactions[0];

                    $scope.ixoShippingMethods = paymentTransaction && paymentTransaction.item_list && paymentTransaction.item_list.shipping_options;
                    if ($scope.ixoShippingMethods) {
                        _logger.$logger.info('incontext_shipping_options_exist');
                    }
                });
            }
        };

        /**
         * Set up $watch for if `showMore` button has been clicked.
         * When `showMore` button has been clicked, we also need to
         * log all FIs that has a cardart FI
         */
        $scope.$watch(function () {
            return _factory4.$ShowMoreFiFactory.get().isShowMoreBtnClicked;
        }, function (clickedMore) {
            // ensure `showMore` button has been clicked for 3FIs pxp
            if (clickedMore) {
                logSessionDetails();
            }
        });

        var showGAC = function showGAC() {
            _factory.$GiveAtCheckoutFactory.decideEligibility().then(function (result) {
                $scope.isDonation = _factory.$GiveAtCheckoutFactory.get().eligible;
                var charity = _factory.$GiveAtCheckoutFactory.get().charity;

                if (_factory.$GiveAtCheckoutFactory.get().eligible) {
                    _logger.$logger.info('checkout_fpti', {
                        from: 'GIVE_AT_CHECKOUT',
                        to: 'prepare_give_at_checkout',
                        gac_model: charity.model_id,
                        gac_npid: charity.nonprofit_id
                    });
                }
            });
        };

        /**
         * Cardart instrumentation for review page comes in a few variations, and
         * it all depends on the pxp result. Following logSessionDetails()
         * logs cardart instrumentation based on:
         *
         * - showMultipleFiVariants pxp
         * - showMultipleFiVariants + 3FI pxp
         * - singleFI pxp
         *
         * See $CardArtInstrument.createPayload() for detailed implementation & explanation
         */
        var logSessionDetails = function logSessionDetails() {
            var isCardArtExp = _cardartInstrument.$CardArtInstrument.isCardArtEnable($scope.fiMeta) && !$scope.isThirdPartyWalletExperience();
            var renderMultipleFi = $scope.showMultipleFiVariants;
            var isBillingNoPurchase = $scope.checkoutCart.isBillingNoPurchase();
            var isBilling = $scope.checkoutCart.isBilling();
            var disableStickyForMerchant = _squid.$config.disableMerchantForStickyBA.indexOf($scope.payee.get('merchant.id')) > -1;
            var stickyEligible = isBilling && !disableStickyForMerchant;

            _logger.$logger.info('checkout_fpti', _extends({
                from: 'REVIEW',
                to: 'prepare_review'
            }, createReviewFptiPayload({ checkoutSession: $scope.checkoutSession }), isCardArtExp ? _cardartInstrument.$CardArtInstrument.createPayload({
                stickyEligible: stickyEligible,
                isBillingNoPurchase: isBillingNoPurchase,
                renderMultipleFi: renderMultipleFi,
                checkoutSession: $scope.checkoutSession,
                renderSingleFi: !$scope.showMultipleFiVariants,
                showMoreFiState: _factory4.$ShowMoreFiFactory.get()
            }) : null));
            // Log details about checkout session
        };

        // Reg E - Regulation E compliance guide mandates invoicing payers see a disclaimer message during payment review when RTR is present.
        // The Remittance Transfer Rule (RTR) is a rule published by the Consumer Financial Protection Bureau.
        // It applies to companies processing remittance transfers of more than $15 USD from a US-based consumer (Sender) to a foreign-based receiver (Recipient).
        var applyInvoicingRegEDetails = function applyInvoicingRegEDetails() {
            // Show invoicing RegE compliance message if its invoicing flow only and if RTR is present
            $scope.showInvoicingRegEMsg = $scope.checkoutAppData.flags.is_invoice_flow && $scope.checkoutSession.showRemittanceDisclosure ? true : false;
            _logger.$logger.info('show_invoicing_regE_msg', $scope.showInvoicingRegEMsg);

            if ($scope.showInvoicingRegEMsg) {
                var totalAmount = $scope.checkoutCart.purchase.amounts.total.amount_formatted_currency;
                var merchantName = $scope.checkoutAppData.merchant.brand_name;

                // The RegE message differs for cases with and without currency conversion
                if ($scope.checkoutSession.plan.hasConversion()) {
                    var total = 0;
                    var planSources = $scope.checkoutSession.get('plan.sources');
                    var currencyCode = planSources[0].amount.currency_code;

                    planSources.forEach(function (source) {
                        if (currencyCode !== source.amount.currency_code) {
                            $scope.showInvoicingRegEMsg = false;
                            return;
                        }

                        total = total + Number(source.amount.amount);
                    });

                    var totalInvoicePaymentAmount = (0, _squid.formatCurrency)(total, currencyCode);

                    $scope.invoicingRegEMsg = (0, _squid.$renderContent)('memberReview.invRegEMsgWithCurrConv', {
                        merchantName: merchantName,
                        amountInPayerCurrency: totalInvoicePaymentAmount,
                        amountInInvCurrency: totalAmount
                    });
                } else {
                    $scope.invoicingRegEMsg = (0, _squid.$renderContent)('memberReview.invRegEMsg', {
                        merchantName: merchantName,
                        amount: totalAmount
                    });
                }
            }
        };

        var applyKmliUpsellEligibility = function applyKmliUpsellEligibility() {
            if (_squid.$util.param('redirectToHermesOnUpopCancel') === 'xoon') {
                var fiModel = $scope.checkoutSession.get('plan.sources');

                if (fiModel && fiModel.length && fiModel[0].card_type === 'CHINA_UNION_PAY') {
                    $scope.checkoutSession.message = {
                        msgKeys: ['confirmUpop.confirmUpopToPay'],
                        type: 'warning'
                    };
                }
            }

            _kmliUpsell.$KmliUpsell.eligible().then(function (eligibility) {
                eligibility.interstitial = eligibility.interstitial ? eligibility.interstitial : {};
                $scope.optin_toggle.isEnabled = eligibility.banner;
                $scope.optin_toggle.value = $scope.auth.rememberedOT() // came in as OneTouch user
                || $scope.auth.isKmliSet // used to set toggle value via interstial
                || $scope.auth.loggedIn() && $scope.auth.refreshToken(); // FirstTime OT (check this for webview case)
                delete $scope.auth.isKmliSet;

                $scope.optin_toggle.showExpandedTerms = false; // collapse by default;
                var cookiePayload = {};

                if (eligibility.interstitial.eligible) {
                    // show optin interstitial only once per user per version
                    cookiePayload.ot_inter_shown = eligibility.interstitial.pxpVersion; // cookieList.push({ name: 'ot_inter_shown', value: eligibility.interstitial.pxpVersion });
                }
                if (Object.keys(cookiePayload).length > 0) {
                    $scope.auth.action('updateAuthExperience', {
                        silent: true,
                        data: cookiePayload
                    }).then(function (res) {
                        _logger.$logger.debug('optin_toggle_cookie_drop_success', res);
                    })['catch'](function (err) {
                        _logger.$logger.debug('optin_toggle_cookie_drop_err', err);
                    });
                }
                _logger.$logger.info('optin_toggle_init', $scope.optin_toggle);
            });

            $scope.personalizedBanner.trigger();
            $scope.showRemittanceDisclosure = _index2.$DeviceInfo.isMobile() && $scope.checkoutSession.showRemittanceDisclosure ? true : false;
        };

        // applyCreditOptions could potentially redirect out of the RYI.
        var applyCreditOptions = function applyCreditOptions() {
            $scope.creditDataModel = _credit.$CreditDataModel.instance($scope.token);
            var isChangeInstallments = $scope.creditDataModel.isChangeStatus();
            var isCapeReturnKey = $scope.creditDataModel.getCapeKey();
            var isCapeReturn = isCapeReturnKey && _squid.$util.param('success');

            if (isChangeInstallments && $scope.creditDataModel && !$scope.creditDataModel.payInFull) {
                _uiRouter.$state.go('checkout.chooseCreditOffer');
            }
            if (isCapeReturn) {
                $scope.returnFromCape(isCapeReturnKey);
            }

            if ((0, _squid.$feature)('creditInstallmentOffers') && ($scope.checkoutSession.get('plan.paypal_credit') || isCapeReturnKey)) {
                $scope.creditOptions = _credit.$CreditInstallmentModel.instance($scope.token);
                $scope.creditOptions.retrieve().then(function () {
                    $scope.creditOptions.apr = String($scope.creditOptions.apr);
                });
            }

            $scope.cartCurrency = $scope.checkoutCart.get('purchase.amounts.total.currency_code');

            // this function returns true if plan sources contains exactly PPCredit & Incentive
            $scope.isCreditIncentiveOption = function () {
                var plans = $scope.checkoutSession.get('plan.sources', null);

                if (plans && plans.length === 2 && plans.filter(function (fi) {
                    return fi.type === 'BILL_ME_LATER';
                }).length === 1 && plans.filter(function (fi) {
                    return fi.type === 'INCENTIVE';
                }).length === 1) {
                    return true;
                } else {
                    return false;
                }
            };

            $scope.isPPCReuseAndNotSelected = function () {
                var plans = $scope.checkoutSession.get('fundingOptions.instruments', null);
                if (plans && plans.filter(function (fi) {
                    return fi.name === 'BILL_ME_LATER' && !fi.selected;
                }).length === 1) {
                    return true;
                } else {
                    return false;
                }
            };

            // if PPCredit & Incentive are showing in the page together with installments we will hide installment details
            $scope.showInstallmentOptionWithoutIncentives = function () {
                if ($scope.creditOptions.creditType === 'INST') {
                    if (!$scope.isCreditIncentiveOption()) {
                        return true;
                    }
                }
                return false;
            };

            $scope.showInstallmentOption = function () {
                if ((0, _squid.$feature)('creditInstallmentOffers') && $scope.checkoutSession.get('plan.paypal_credit') && $scope.creditOptions && $scope.creditOptions.creditType) {
                    if ($scope.creditOptions.creditType === 'INST') {
                        $scope.installmentInfo = {
                            monthlyPaymentAmt: (0, _squid.formatCurrency)($scope.creditOptions.monthlyPayment, $scope.cartCurrency),
                            totalInterestAmt: (0, _squid.formatCurrency)($scope.creditOptions.totalInterest, $scope.cartCurrency),
                            totalPaymentAmt: (0, _squid.formatCurrency)($scope.creditOptions.totalPayment, $scope.cartCurrency)
                        };
                    }
                    return true;
                } else {
                    return false;
                }
            };

            // if PPCredit & Incentive are showing in the page together with installments, we will:
            // 1. add a warning message in the top of the page as the installment option selected in cyco page
            //    is not available with PayPal incentives balance.
            // 2. hide installment options (see above method showInstallmentOptionWithoutIncentives())
            if ($scope.showInstallmentOption() && $scope.creditOptions.creditType === 'INST' && $scope.isCreditIncentiveOption()) {
                $scope.checkoutSession.message = {
                    type: 'warning',
                    msgKeys: ['offers.bmlInWalletInvalidInstallmentsMsg']
                };
            } else if ($scope.checkoutSession.message && $scope.checkoutSession.message.msgKeys && $scope.checkoutSession.message.msgKeys[0] === 'offers.bmlInWalletInvalidInstallmentsMsg') {
                // Remove error message in review page if was showing before changing payment method
                $scope.checkoutSession.message = null;
            }

            $scope.showCYCO = function () {
                _uiRouter.$state.go('checkout.chooseCreditOffer');
            };

            if (_angular.$window.location.search.search('atoSuccess') !== -1) {
                _logger.$logger.debug('PLANNING_ATO_SUCCESS');
                var atoMsg = _squid.$locale.content.get('memberReview.stepupAuthSuccess');

                if (atoMsg) {
                    $scope.checkoutSession.message = {
                        msgs: [atoMsg],
                        type: 'success'
                    };
                }
            }

            $scope.$on('localeChange', setInformalName);
            setInformalName();

            $scope.showNotYou = $scope.auth && $scope.auth.showNotYou();

            if (_squid.$util.param('redirectToHermesOn3DSDecline')) {
                // check and show the 3DS decline message when the app is redirected from Xoon app
                show3DSDeclineMsg();
            }

            $scope.showAuthMsg = ['authorize', 'order'].indexOf($scope.checkoutCart.get('payment_action')) > -1 && !$scope.checkoutSession.get('plan.paypal_credit');

            if ($scope.showAuthMsg) {
                /*
                    new compliance message for AS1 / AS2 is not for US which displays LearnMore Link
                    have this scope variable set based on country
                */
                $scope.showAuthMsgLearnMore = _squid.$locale.country !== 'US' ? true : false;
            }

            $scope.showUnconfirmedUpopMsg = !!$scope.checkoutSession.unconfirmed_upop;

            $scope.useraction = $scope.checkoutAppData.useraction() && $scope.checkoutAppData.useraction().toLowerCase();

            // Non-AU merchants are subjected to PXP test when user action is not commit and line item details
            // are not available and purchase amount is not zero.
            var noLineItemDetails = $scope.useraction !== 'commit' && $scope.checkoutCart.get('purchase.items.length', 0) === 0;

            var fundingInstruments = $scope.checkoutSession.get('fundingOptions.instruments', []);
            var isCreditInWallet = false;

            if ($scope.checkoutCart.isBillingNoPurchase()) {
                isCreditInWallet = $scope.checkoutSession.get('futurePayment.isCreditInWallet');
            } else {
                isCreditInWallet = fundingInstruments.find(function (fi) {
                    return fi.name === 'BILL_ME_LATER';
                });
            }

            var isPPCEligible = $scope.checkoutSession && $scope.checkoutSession.creditOffer;
            var isPayPalCredit = $scope.checkoutAppData.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';

            _logger.$logger.debug('creditInstallmentOffer ' + $scope.checkoutSession.creditInstallmentOffer + ', ' + 'creditOffer ' + $scope.checkoutSession.creditOffer + ', ' + isCreditInWallet + ', ' + isPayPalCredit);

            if ($scope.checkoutSession.creditOffer) {
                if (!_angular.$rootScope.bml) {
                    _angular.$rootScope.bml = new _bml.$BMLModel();
                }
                _angular.$rootScope.bmlApply = new _bml.$ApplyForBMLModel();
            }
            // the second button user is ineligible for PPC, no credit in wallet, and has not selected to "pay with paypal"
            else if (isPayPalCredit && !isPPCEligible && !isCreditInWallet && !$scope.creditDataModel.payInFull && !isCapeReturn) {
                    $scope.checkoutSession.message = {
                        type: 'info',
                        msgKeys: ['offers.bmlIneligibleHeader', 'offers.bmlIneligibleContent']
                    };

                    _logger.$logger.info('checkout_fpti', {
                        from: 'Login',
                        to: 'Review',
                        error_type: 'second_btn_ineligible'
                    });
                }

            $scope.showSoftDescriptor = !$scope.checkoutAppData.flags.hide_soft_descriptor && $scope.checkoutCart.get('purchaseUnits.length', 0) <= 1;

            return (0, _pxp.$pxpCartAmt)($scope.checkoutAppData.get('merchant.merchant_country'), $scope.payee.get('merchant.id', ''), noLineItemDetails, $scope.checkoutCart.isPurchase()).then(function (showAmount) {
                $scope.showAmt = showAmount;
            });
        };

        var applyNegativeBalanceStatus = function applyNegativeBalanceStatus() {
            var checkoutSession = $scope.checkoutSession;
            var negBals = checkoutSession.negBals;
            var nbrMsgContentKey = void 0;
            var tokenHash = void 0;

            if (negBals) {
                nbrMsgContentKey = 'memberReview.nbrMsg';
                tokenHash = {
                    neg_bal: (0, _squid.formatCurrency)(negBals[0].amount, negBals[0].currency_code, false),
                    merchantName: $scope.checkoutAppData.get('merchant.brand_name')
                };

                if (negBals.length > 1) {
                    nbrMsgContentKey += 'Plural';
                    tokenHash.neg_bal2 = (0, _squid.formatCurrency)(negBals[1].amount, negBals[1].currency_code, false);
                }

                checkoutSession.message = {
                    type: 'warning',
                    msgs: [(0, _squid.$renderContent)(nbrMsgContentKey, tokenHash)]
                };
            }
        };

        var applyBrPxp = function applyBrPxp() {
            if (!_index.$miniBrowser.isMiniBrowser() && _squid.$locale.country === 'BR') {
                var brPxp = _squid.$config.pxpExperiments.BR.xo_br_hermesnode_ryi_design;

                return (0, _squid.$pxpFactors)(brPxp.pgName, brPxp.params, brPxp.pattern, false, true).then(function (result) {
                    $scope.ryiDesignExp = result;
                });
            }
        };

        var applyShowShippingMethod = function applyShowShippingMethod() {
            $scope.isInstantUpdateAPIFlow = $scope.checkoutCart && $scope.checkoutCart.get('instantUpdateIntegration');
            $scope.showShippingMethod = $scope.isInstantUpdateAPIFlow ? true : false;
            if (_integration.$integration.getConfig('SHOW_SHIPPING_METHOD')) {
                return setShowShippingMethodProperty();
            }
        };

        var applyPayButtonOption = function applyPayButtonOption() {
            $scope.cancel = $scope.checkoutAppData.urls.cancel_url;
            $scope.merchantMsg = $scope.checkoutCart.getBillingDescription();

            var isBilling = $scope.checkoutCart.isBilling();
            var merchant = $scope.checkoutAppData.merchant;

            $scope.merchantName = merchant.brand_name || merchant.merchant_name;

            // Determine whether the button type is a Pay button or Continue button
            $scope.buttonLabelIsPay = $scope.useraction === 'commit' || _integration.$integration.getConfig('SHOW_PAY_NOW_LABEL_ON_REVIEW');

            // log paybuttonText as paynow or continue
            // irrespective of PAD, credit, etc
            _logger.$logger.info('checkout_fpti', {
                'ryp_button_text': $scope.buttonLabelIsPay ? 'paynnow_y' : 'paynnow_n'
            });

            // show shipping address based on merchant passed in parameter
            $scope.showShippingAddress = Boolean(!$scope.checkoutAppData.flags.hide_shipping_address && $scope.checkoutAppData.flags.shipping_address_required && $scope.checkoutSession.shipping);

            // review page 'continue' or 'pay now' button logic to return the button text
            $scope.payButtonText = function () {
                if ($scope.selectedmethod && $scope.selectedmethod.planId === 'applyForPPCRadio') {
                    return _squid.$locale.content.get('applyForBml.bmlApplyHeadline');
                }

                if (isBilling) {
                    if ($scope.buttonLabelIsPay) {
                        return _squid.$locale.content.get('memberReview.agreeAndPayLabel');
                    } else {
                        return _squid.$locale.content.get('memberReview.agreeAndContinueLabel');
                    }
                } else if (getPadToggleStatus() === 'ON') {
                    return _squid.$locale.content.get('memberReview.padLabel');
                } else if ($scope.buttonLabelIsPay) {
                    if ($scope.checkoutSession.unconfirmed_upop) {
                        return _squid.$locale.content.get('memberReview.pay');
                    } else {
                        $scope.payButton = 'paynnow_y';
                        return _squid.$locale.content.get('memberReview.payLabel');
                    }
                } else {
                    $scope.payButton = 'paynnow_n';
                    return _squid.$locale.content.get('memberReview.continueLabel');
                }
            };

            $scope.onRedeemGC = function () {
                throw new _squid.$FallbackError({
                    reason: 'redeem_coupon_feature_not_supported',
                    product: 'ux'
                });
            };

            // Check if processor decline message needs to be set
            setProcessorDeclineMessage();

            $scope.promotion = {
                type: null,
                name: ''
            };

            var plccOffer = $scope.checkoutSession && $scope.checkoutSession.plccOffer;

            if (plccOffer) {
                $scope.promotion.logoUrl = plccOffer.product_logo;
                $scope.promotion.name = plccOffer.product_name;
            }

            $scope.onFBBANotNow = function () {
                var _$scope$checkoutSessi = $scope.checkoutSession.payer;
                _$scope$checkoutSessi = _$scope$checkoutSessi === undefined ? {} : _$scope$checkoutSessi;
                var payerId = _$scope$checkoutSessi.id;

                var isUnchecked = _squid.$util.sessionStorageEnabled() && window.sessionStorage.getItem('checkboxPluginState') === 'unchecked';

                _logger.$logger.info('checkout_fpti', {
                    buyer_country: _squid.$locale.country,
                    buyer_id: payerId,
                    context_id: $scope.token,
                    design: 'fbmessenger',
                    from: 'BILLING_AGREEMENT',
                    to: 'process_billing_agreement',
                    eligibility_reason: isUnchecked ? 'checkbox_plugin_unchecked' : 'checkbox_plugin_checked',
                    click_source: 'not_now'
                });

                window.xchild.close();
            };

            $scope.onPay = function (result) {
                // Track NMJ variations.
                var payEventName = void 0;

                if ($scope.isNmjDesign1) {
                    payEventName = 'member_ryi_onPayVariant_nmj_design1_page';
                } else if ($scope.isNmjDesign2) {
                    payEventName = 'member_ryi_onPayVariant_nmj_design2_page';
                } else if ($scope.isNmjDesign3) {
                    payEventName = 'member_ryi_onPayVariant_nmj_design3_page';
                } else {
                    payEventName = 'member_ryi_onPayVariant_control';
                }

                _logger.$logger.info(payEventName);

                if (!isValidPinSetup()) {
                    $scope.topupError = true;
                    _logger.$logger.debug('pin_missing');
                    _uiRouter.$state.go('checkout.pinSetup');
                    return;
                }

                if ($scope.checkoutSession.installments && $scope.checkoutSession.installments.length > 1 && !$scope.checkoutSession.selectedInstallmentData) {
                    $scope.installmentNotSelected = true;
                    return;
                }

                if ($scope.isInstantUpdateAPIFlow && !$scope.instantUpdateFeature.shippingRegionSupported) {
                    return;
                }

                // Determine whether or not to prevent going forward based on the status of the onShippingChange callback
                if ($scope.shippingChangeFeature && $scope.shippingChangeFeature.status) {
                    switch ($scope.shippingChangeFeature.status) {
                        case $scope.shippingChangeFeature.enums.LOADING:
                        case $scope.shippingChangeFeature.enums.REJECTED:
                        case $scope.shippingChangeFeature.enums.FAILED:
                            return;
                        default:
                    }
                }

                if ((0, _squid.$feature)('creditInstallmentOffers') && $scope.checkoutSession.get('plan.paypal_credit') && $scope.installment.showCYCO && $scope.creditOptions && !$scope.creditOptions.creditType) {
                    return _uiRouter.$state.go('checkout.chooseCreditOffer');
                }
                // "Paying" by applying for PPC
                if ($scope.selectedmethod && $scope.selectedmethod.planId === 'applyForPPCRadio') {
                    if ((0, _squid.$feature)('creditInstallmentOffers') && $scope.installment && $scope.installment.installmentOptionsPresent) {
                        return _uiRouter.$state.go('checkout.chooseCreditOffer');
                    } else {
                        return _uiRouter.$state.go('checkout.redirectToCape', {}, { location: false });
                    }
                }
                // Address Normalization Checks
                if ($scope.checkoutAppData.get('flags.allow_change_shipping', false) && (0, _squid.$feature)('shippingAddressNormalization') && $scope.checkoutSession.get('shipping.normalization_status') === 'UNKNOWN') {

                    return _uiRouter.$state.go('checkout.review.sidebar.updateShipping');
                }

                var padToggleStatus = getPadToggleStatus();

                if (padToggleStatus === 'ON') {
                    _logger.$logger.info('checkout_fpti', {
                        'pad_toggle_status': 'padToggleOnSubmit'
                    });
                } else if (padToggleStatus === 'OFF') {
                    _logger.$logger.info('checkout_fpti', {
                        'pad_toggle_status': 'padToggleOffSubmit'
                    });
                }

                /**
                 * Call updateFS so that if user has made a change in the multiple FI on RYI variant, we select their instrument before doing other logic
                 * Call patchCvv first, if error, need buyers to input again
                 * Call to set Sticky Funding Instrument for Billing Agreement.
                 * We have to ensure the sticky call happens before authorize due to symphony spec.
                 * We need to wait for the response from updateAddressAsPreferred before calling authorize                 */

                var preAuthorizeError = void 0;

                return updateFS()
                // Make PAPS patch calls sequentially. Concurrent patch calls are currently not supported
                .then(function () {
                    return checkJSV4PaymentDetails();
                }).then(function () {
                    return _tokenizedFactory.$TokenizedFactory.tokenizedOnPayCalls($scope.checkoutCart, $scope.checkoutSession, $scope.tokenizedWalletInfoModel, $scope.walletPinModel);
                }).then(function () {
                    return _fiApis.$fiApis.patchCvv($scope.checkoutSession);
                }).then(function () {
                    return setStickyInstrument();
                })
                // Other calls that won't affect the checkout session. Multiple patch calls to PAPS should not be made here
                .then(function () {
                    return _angular.$q.all([updateAddressAsPreferred(), // This is a patch call to PAPS
                    setWalletTopupPreferences(), linkAuthConsent(), $scope.actions.updatePreferredFi(_logger.$logger), donationAuthorize()])['catch'](function (err) {
                        // should we have more elaborate error handling here?
                        if ($scope.checkoutCart.isWalletTokenization()) {
                            if (err && err.message === 'WALLET_PREFERENCE_SET_ERROR') {
                                preAuthorizeError = err;
                            }
                        }
                        _logger.$logger.error('onPay() error', err);
                    })['finally'](function () {
                        if (preAuthorizeError) {
                            var code = 'ANDROID_PAY_SET_WALLET_PREFERENCE_ERROR';
                            code = window.btoa(code);
                            _uiRouter.$state.go('checkout.genericError', { code: code });
                        } else {
                            return authorize();
                        }
                    });
                }, function (err) {
                    if ($scope.ixoShippingMethods && err.message === 'IXO_CANNOT_CHECKOUT_WITHOUT_SHIPPING_SELECTION') {
                        return;
                    }

                    if ($scope.checkoutCart.isWalletTokenization()) {
                        if (err && err.message === 'ISSUANCE_PIN_SERVICE_ERROR') {
                            var code = 'ANDROID_PAY_SET_PIN_ERROR';
                            code = window.btoa(code);
                            _uiRouter.$state.go('checkout.genericError', { code: code });
                            return;
                        }
                    }
                    _logger.$logger.error('onPay() patchCvv error', err);
                });
            };

            /* This is used for a BML 'popup' that opens covering the whole review page,
             hiding the rest of the review page when its open. */
            $scope.bmlPopupOpen = false;
            $scope.showBmlPopup = function () {
                $scope.bmlPopupOpen = true;
            };
            $scope.hideBmlPopup = function () {
                $scope.bmlPopupOpen = false;
            };
        };

        var checkForReviewLaterTextTreatment = function checkForReviewLaterTextTreatment() {
            $scope.showReviewLaterText = true;
            // only get pxp if buttonlabel is not pay and for billingWithOutPurchase
            if ($scope.useraction !== 'commit' && !_integration.$integration.getConfig('SHOW_PAY_NOW_LABEL_ON_REVIEW') && $scope.checkoutCart.isBillingNoPurchase()) {
                _logger.$logger.info('billing_no_purchase_review_later_text_removal_ramp');
                return (0, _squid.$pxp)('review_later_text', 'showreviewlater_treatment', undefined, false, true).then(function (result) {
                    if (result && result.treatment_name) {
                        _logger.$logger.info('billing_no_purchase_review_later_text_removal_treatment');
                        $scope.showReviewLaterText = false;
                    }
                });
            }
        };

        var initBillingNoPurchasePlans = function initBillingNoPurchasePlans() {
            var isBillingNoPurchase = $scope.checkoutCart && $scope.checkoutCart.isBillingNoPurchase();

            $scope.plans = isBillingNoPurchase ? $scope.checkoutSession.get('futurePaymentInstruments') : $scope.checkoutSession.getPlanList();
        };

        var showBillingMessage = function showBillingMessage() {
            var isIndiaDomesticBilling = $scope.checkoutCart.isBilling() && _squid.$locale.country === 'IN' && $scope.checkoutAppData.get('merchant.merchant_country', 'US') === 'IN';
            var merchant = $scope.checkoutAppData.get('merchant');
            var merchantName = merchant.brand_name || merchant.merchant_name || 'Merchant';

            if (isIndiaDomesticBilling) {
                $scope.checkoutSession.message = {
                    type: 'info',
                    msgs: [(0, _squid.$renderContent)('memberReview.billingMerchant', { merchantName: merchantName })]
                };
            }
        };

        var showMoreFiInit = function showMoreFiInit() {
            var showMoreFiEligibility = _factory4.$ShowMoreFiFactory.decideEligibility({ plans: $scope.plans });

            if (showMoreFiEligibility) {
                showMoreFiEligibility.then(function () {
                    _factory4.$ShowMoreFiFactory.init($scope.plans);
                });
            }
        };

        // TODO: please talk with AuthRate team on `xo_hermes_preferred_expired_msg_review_page` pxp when
        // they decide to turn the experiement on next year!
        // https://engineering.paypalcorp.com/pxptool/history?exptId=3935
        // const showExpiredMsgInit = () => {
        //     $scope.showExpiredMsg = $ExpiredMsgFactory.showExpiredMsg($scope.isNmj, $scope.checkoutSession);
        //     if ($scope.showExpiredMsg) {
        //         $ExpiredMsgFactory.getPreferredExpiredPxpResult().then(result => {
        //             $scope.isNmjexpired = result === 'xo_hermes_preferred_expired_msg_review_page_nmj_treatment' ? true : false;
        //             $scope.preferredExpired = $scope.checkoutSession.getDisallowedPreferred();
        //         });
        //     }
        // };

        // lazy load some of the most popular routes to increase loading time
        var preloadCodeSplitRoutes = function preloadCodeSplitRoutes() {
            if (_squid.$meta.codeSplitting) {
                var routes = [];

                if (_integration.$integration.isFlow('WPS')) {
                    routes.push.apply(routes, [new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "./pages/xo-pay/route.js")), // eslint-disable-line
                    new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "../node_modules/xo-page-components/src/done/route.js")) // eslint-disable-line
                    ]);
                }

                routes.push.apply(routes, [new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "./pages/xo-sidebar/route.js"))]);

                // preload checkout.genericMessage route which is shown when transaction is completed
                // on devices. So basically user will see `Thanks for using PayPal!` and `You can close this tab at any time.`
                // and at the same time there will be client side redirect
                // https://github.paypal.com/Checkout/xo-return-to-merchant/blob/master/dist/util.js#L44
                // May help reduce noise in case of code split when it's trying to first download the js chunk and then make redirect
                // which may take longer than usual
                if (_index2.$DeviceInfo.isDevice()) {
                    routes.push(new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "./pages/xo-generic-message/route.js")));
                }

                Promise.all(routes)['catch'](function (err) {
                    _logger.$logger.info('code_split_review_routes_preload_failed', {
                        error: err && err.message
                    });
                });
            }
        };

        /**
         * This promise chain renders critical content in the page. Avoid
         * the temptation to tack on another `.then` to this promise chain.
         *
         * If you are making a critical network request, consider putting
         * function inside the `$q.all` array so it can be run in parallel
         * and not slow down page rendering.
         *
         * If your function requires values available on `$scope` after
         * the critical functions in `$q.all` are complete, put your
         * function in the following `.then` block.
         *
         * Otherwise, your function can likely go somewhere else.
         */
        populateScope().then(function () {
            stickyCTA();
            _factory3.$RewardsCheckboxFactory.buildCache();
            // applyCreditOptions could potentially redirect out of the RYI.
            // Seperate it out from the rest of the pack to avoid unnecessary code execution
            applyCreditOptions();
            triggerPersonalizedBanner();
            applyMerchantName();
            applyPayButtonOption();
            applyChoiceExperimentVariant();
            applyNegativeBalanceStatus();
            applyKmliUpsellEligibility();
            applyShowShippingMethod();
            applyInvoicingRegEDetails();
            $scope.checkForIxoShippingMethods();
            checkForReviewLaterTextTreatment();
            initAndCallOnShippingChange();
            initBillingNoPurchasePlans();
            showBillingMessage();
            applyBrPxp();
            initializePadToggleSupport();
            showGAC();
            _factory2.$NoBalanceFactory.decideEligibility();
            prepareTokenizedWallet();
            applyNewMemberVariant().then(function () {
                // TODO: see comment from above in regards to run this pxp again
                // showExpiredMsgInit();
            });
            showMoreFiInit();
            logSessionDetails();
            preloadCodeSplitRoutes();
        });
        (0, _jquery2['default'])('.paypalHeaderWrapper').removeClass('paypalCredit');
        (0, _jquery2['default'])('.paypalHeaderWrapper').removeClass('paypalCreditTnc');

        $scope.onComplete = function (params) {
            if (params) {
                _logger.$logger.debug('ryi_optin_isKmliSet_' + params.isKmliSet);
                if (params.isKmliSet) {
                    $scope.optin_toggle.setValue(true);
                }
            }
            _uiRouter.$state.go('checkout.review');
        };

        $scope.propValueObj = {};
        if ((0, _squid.$feature)('propValue')) {
            $scope.propValueObj.propHeader = 'memberReview.propHead';
            $scope.propValueObj.propVal = 'memberReview.propVal';
            $scope.propValueObj.propImage = 'https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_shield_bags.png';
        } else {
            $scope.propValueObj.propHeader = 'login.propHeadAlt';
            $scope.propValueObj.propVal = 'login.propValAlt';
            $scope.propValueObj.propImage = 'https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_wallet_card_v3.png';
        }
    }]
});

angular.value("$xoReviewPageComponent", $xoReviewPageComponent);
_uiRouter.$state;

_index.$miniBrowser;

_logger.$logger;

_integration.$integration;

_index2.$DeviceInfo;

_ul.$ul;

_pxp.$pxpCartAmt;

_angular.$q;

_angular.$rootScope;

_angular.$timeout;

_angular.$window;

_angular.noop;

_kmliUpsell.$KmliUpsell;

_utils.getSelectedPlan;

_utils.getInstrumentID;

_squid.$Class;

_squid.$Component;

_squid.$config;

_squid.$FallbackError;

_squid.$feature;

_squid.$featureCountries;

_squid.$locale;

_squid.$meta;

_squid.$populate;

_squid.$pxp;

_squid.$pxpFactors;

_squid.$renderContent;

_squid.$util;

_squid.formatCurrency;

_squid.formatNameInformal;

_squid.$elmo;

_thirdPartyInfo.thirdPartyExperience;

_auth.$AuthModel;

_fiApis.$fiApis;

_eligibility.$stickyCTA;

_choice.$ChoiceEligibility;

_fiMessages.$fiMessages;

_donation.$GiveAtCheckoutModel;

_bml.$ApplyForBMLModel;

_bml.$BMLModel;

_credit.$CreditDataModel;

_credit.$CreditInstallmentModel;

_fi.$AddCardModel;

_fi.$CardModel;

_fi.$PreferredFi;

_fi.$WalletPreferences;

_app.$TokenizedFundingCapabilitiesModel;

_app.$TokenizedWalletInfoModel;

_app.$TokenizedWalletPinModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutSessionModel;

_marketingoffer.$MemberSegmentModel;

_newMember.$NewMemberEligibility;

_shippingMethod.$ShippingRuleSummaryModel;

_user.$AuthConsentModel;

_factory.$GiveAtCheckoutFactory;

_factory2.$NoBalanceFactory;

_factory3.$RewardsCheckboxFactory;

_factory4.$ShowMoreFiFactory;

_cardartInstrument.$CardArtInstrument;

_factory5.$BalanceFactory;

_factory6.$PADFactory;

_tokenizedFactory.$TokenizedFactory;

_shippingChangeFeature.createShippingChangeFeature;

/***/ }),

/***/ "./pages/xo-review/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$PADFactory', function () {

    /**
     *
     * get PAD or IACH plan id based on selected plan id and PAD toggle status
     * if selected plan is IACH and toggle is on -> use associated PAD plan id
     * if selected plan is IACH and toggle is off -> use it's ID
     * if selected plan is PAD and toggle is on -> use it's ID
     * if selected plan is PAD and toggle is off -> use associated IACH plan id
     */
    var getPadOrIachBankPlanId = function getPadOrIachBankPlanId(_ref) {
        var selectedMethodPlanId = _ref.selectedMethodPlanId,
            fundingOptions = _ref.fundingOptions,
            multiFiCheckboxStates = _ref.multiFiCheckboxStates;

        var plan = fundingOptions.getPlanByPlanId(selectedMethodPlanId);
        var padOrIachPlanId = void 0;

        if (fundingOptions.isPAD(plan) || fundingOptions.isIACH(plan)) {
            if (multiFiCheckboxStates[plan.primaryFs.id]) {
                padOrIachPlanId = fundingOptions.getPadOrIachPlanIdBySelectedPlan({ plan: plan, isPadToggleSelected: true });
            } else {
                padOrIachPlanId = fundingOptions.getPadOrIachPlanIdBySelectedPlan({ plan: plan, isPadToggleSelected: false });
            }
        }
        return padOrIachPlanId;
    };

    // check if PAD feature is applicable
    var isPadToggleFeatureApplicable = function isPadToggleFeatureApplicable(padToggleFeature, isPadToggleEnabled) {
        return padToggleFeature.applicable && isPadToggleEnabled;
    };

    return {
        getPadOrIachBankPlanId: getPadOrIachBankPlanId,
        isPadToggleFeatureApplicable: isPadToggleFeatureApplicable
    };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-review", "pages/xo-review/factory.js"))

/***/ }),

/***/ "./pages/xo-review/lib/shippingChangeFeature.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.createShippingChangeFeature = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _factory = __webpack_require__("../node_modules/xo-shipping-change/src/factory.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var createShippingChangeFeature = exports.createShippingChangeFeature = function createShippingChangeFeature(token, checkoutCart, checkoutSession, checkoutAppData) {
    var callbackFn = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _squid.$util.noop;

    var feature = {
        enums: {
            LOADING: 'loading',
            REJECTED: 'rejected',
            UPDATED: 'updated',
            FAILED: 'failed'
        },
        status: null,
        shippingChangeFactory: (0, _factory.$ShippingChangeFactory)(token, checkoutAppData, checkoutSession, checkoutCart),
        callOnShippingChange: _squid.$util.noop
    };

    feature.callOnShippingChange = function () {
        var doneFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _squid.$util.noop;

        if (!window.xprops || !window.xprops.onShippingChange) {
            return doneFn();
        }

        var successFn = function successFn() {
            var updatedMsg = (0, _squid.$renderContent)('shippingCallback.updated', {
                amount: checkoutCart.get('purchase.amounts.total.amount_formatted')
            });

            feature.status = feature.enums.UPDATED;
            checkoutSession.message = {
                msgs: [updatedMsg],
                type: 'info'
            };
        };

        var rejectFn = function rejectFn() {
            var rejectedMsg = (0, _squid.$renderContent)('shippingMethod.shippingRegionUnsupported', {
                merchant: checkoutAppData.getMerchantDisplayName()
            });

            feature.status = feature.enums.REJECTED;
            checkoutSession.message = {
                msgs: [rejectedMsg],
                type: 'warning'
            };
        };

        var loadingMsg = _squid.$locale.content.get('shippingCallback.loading');

        _squid.$event.emit('loading');
        _squid.$event.emit('loadingMessage', loadingMsg);

        return feature.shippingChangeFactory.getPayload().then(function (payload) {
            _logger.$logger.info('shipping_change_payload_recieved', payload);

            return feature.shippingChangeFactory.callOnShippingChange(payload);
        }).then(function (_ref) {
            var cartHasChanged = _ref.cartHasChanged,
                rejected = _ref.rejected;


            _logger.$logger.info('shipping_change_called', { cartHasChanged: cartHasChanged, rejected: rejected });

            callbackFn();

            if (rejected) {
                return rejectFn();
            }

            if (cartHasChanged) {
                return successFn();
            }
        }).then(doneFn)['catch'](function (err) {
            _logger.$logger.error('shipping_change_error', err);

            feature.status = feature.enums.FAILED;
            _uiRouter.$state.go('checkout.genericError');
        })['finally'](function () {
            _squid.$event.emit('loaded');
        });
    };

    return feature;
};

_squid.$renderContent;

_squid.$util;

_squid.$locale;

_squid.$event;

_factory.$ShippingChangeFactory;

_uiRouter.$state;

_logger.$logger;

/***/ }),

/***/ "./pages/xo-review/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ReviewRoute = undefined;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

__webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/route.js");

__webpack_require__("../node_modules/xo-login-components/src/onetouch-interstitial/route.js");

__webpack_require__("./pages/xo-sidebar/route.js");

__webpack_require__("./pages/xo-sidepage/route.js");

var _directive = __webpack_require__("./pages/xo-review/directive.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _choice = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

var _credit = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

/* dynamic-import */

/* dynamic-import */
var $ReviewRoute = exports.$ReviewRoute = _squid.$ComponentRoute.extend('$ReviewRoute', {

    path: 'review',
    directive: _directive.$xoReviewPageComponent,
    titleContent: 'memberReview.memberReviewTitle',
    params: { message: null },
    trackingData: {
        fptiState: 'review',
        templateName: 'memberReview.dust',
        pageGoal: 'Payment Review',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-review',
                'pagename2': '%::fullpage-review:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },

    resolve: {
        action: function action() {

            // Determine if we should instead route to the selectFi choice experiment page
            if (!(0, _squid.$feature)('choiceExperiment')) {
                return;
            }

            var _$config$choiceExperi = _squid.$config.choiceExperiment;
            _$config$choiceExperi = _$config$choiceExperi === undefined ? {} : _$config$choiceExperi;
            var _$config$choiceExperi2 = _$config$choiceExperi.selectFi,
                fiPageVariants = _$config$choiceExperi2 === undefined ? [] : _$config$choiceExperi2,
                _$config$choiceExperi3 = _$config$choiceExperi.skipSelectFi,
                skipFiPageVariants = _$config$choiceExperi3 === undefined ? [] : _$config$choiceExperi3;
            var fromState = _uiRouter.$state.fromState;

            var skipStates = ['checkout.review', 'checkout.selectFi', 'checkout.authorizationmessage', 'checkout.pageAddCard.addCardFlow.addCard', 'checkout.chooseCreditOffer'];

            // Is review route hit a result of CREDIT_CARD_AUTH_FAILED, i.e. smart $x auth check failure?
            var isFromCcAuthFailure = _uiRouter.$stateParams.message && _uiRouter.$stateParams.message === 'CREDIT_CARD_AUTH_FAILED';
            if (!isFromCcAuthFailure && (!fromState.name ||
            // Current state contains one of the skip states (can be nested)
            skipStates.some(function (state) {
                return fromState.name.indexOf(state) !== -1;
            }))) {
                return;
            }

            // If returning from credit application, skip the selectFi page
            var isCapeReturnKey = _credit.$CreditDataModel.instance(_angular.$rootScope.token).getCapeKey();

            if (isCapeReturnKey) {
                return;
            }

            return _choice.$ChoiceEligibility.instance().getVariant(_angular.$rootScope.token).then(function (variant) {
                // Check if variant is selectFi variant
                if (fiPageVariants.indexOf(variant) === -1) {
                    return;
                }

                var models = {};

                // Check that there is more than one plan to choose from, or that plan is not preferred
                return (0, _squid.$populate)(models, {
                    checkoutSession: _checkout.$CheckoutSessionModel.instance(_angular.$rootScope.token)
                }).then(function () {
                    var plans = models.checkoutSession.get('fundingOptions.plans');
                    var isPreferredDefault = skipFiPageVariants.indexOf(variant) > -1 && plans && plans[0].primaryFs.isPreferred;
                    var stickyPlans = models.checkoutSession.futurePaymentInstruments;

                    if (!isPreferredDefault && (plans && plans.length > 1 || stickyPlans && stickyPlans.length > 1)) {
                        return {
                            to: 'checkout.selectFi',
                            newState: true
                        };
                    } else {
                        _logger.$logger.info('skip_selectFi', {
                            reason: isPreferredDefault ? 'default_is_preferred' : 'not_enough_plans'
                        });
                        return;
                    }
                });
            });
        }
    },

    children: [{
        name: '$SidebarRoute',
        attributes: {
            'back-uri': 'backUri',
            'shipping-change-feature': 'shippingChangeFeature',
            'promotion': 'promotion',
            'update': 'update',
            'token': 'token',
            'installment': 'installment'
        },
        lazyRoute: 'pages/xo-sidebar/route',
        slug: 'sidebar'
    }, {
        name: '$OneTouchUpsellRoute',
        attributes: {
            'token': 'token',
            'on-complete': 'onComplete'
        },
        lazyRoute: 'xo-login-components/src/onetouch-interstitial/route',
        slug: 'oneTouchUpsell'
    }, {
        name: '$xoConfirmUpopRoute',
        props: function props() {
            var props = {
                token: this.token,
                cardmodel: this.cardModel
            };

            if (this.upopCallbacks.isOnUpdate) {
                props.onSuccess = this.upopCallbacks.onUpdateSuccess;
                props.onCancel = this.upopCallbacks.onUpdateCancel;
            } else {
                props.onSuccess = this.upopCallbacks.onConfirmUpopSuccess;
                props.onCancel = this.upopCallbacks.onConfirmUpopCancel;
            }

            return props;
        },

        lazyRoute: 'xo-wallet-components/src/confirm-upop/route',
        slug: 'confirmUpop'
    }, {
        name: '$SidepageRoute',
        props: function props() {
            return {
                token: this.token
            };
        },

        lazyRoute: 'pages/xo-sidepage/route',
        slug: 'sidepage'
    }]
}); /* dynamic-import */
/* dynamic-import */


angular.value("$ReviewRoute", $ReviewRoute);
_logger.$logger;

_squid.$ComponentRoute;

_squid.$feature;

_squid.$config;

_squid.$populate;

_angular.$rootScope;

_uiRouter.$state;

_uiRouter.$stateParams;

_directive.$xoReviewPageComponent;

_checkout.$CheckoutSessionModel;

_choice.$ChoiceEligibility;

_credit.$CreditDataModel;

/***/ }),

/***/ "./pages/xo-review/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"review\" content ng-click=\"onPageClick($event)\" id=\"memberReview\" tabindex=-1 role=\"presentation\">\n    <xo-sticky-cta eligibility=\"stickyEligibility\" ng-if=\"stickyEligibility === 'top'\">\n        <!--Action button -->\n        <p ng-if=\"showPaypalPolicy\" class=\"paypalPoliciesLink disclaimer\" bind-html-compile=\"content('memberReview.viewPaypalPolicies')\"></p>\n\n        <div ng-if=\"showPaymentRights\">\n            <div class=\"paypalPoliciesLink disclaimer\" data-ng-bind-html=\"content('memberReview.viewYourPaymentMethodRights')\"></div>\n            <span class=\"diagonalArrow\"></span>\n        </div>\n\n        <!--Invoicing Flow RegE message in cases of RTR -->\n        <div ng-if=\"showInvoicingRegEMsg\" class=\"invRegE\">\n            <div>{{ invoicingRegEMsg }}</div>\n        </div>\n\n        <p class=\"unconfirmedUpopMsg\" ng-if=\"showUnconfirmedUpopMsg\">\n            {{ content('confirmUpop.confirmUpopToPay')}}\n        </p>\n\n        <p ng-if=\"!isThirdPartyWalletExperience() && showPolicyAgreement\" class=\"disclaimer\" id=\"policyAgreement\" data-ng-bind-html=\"content('memberReview.policyAgreement', {country: locale.country, lang: locale.lang})\">\n        </p>\n\n        <div id=\"messengerPlugin\" class=\"messengerBAPlugin\" ng-if=\"isMessengerBAIntegration\">\n            <!--content-->\n            <h4 class=\"noBottom paymentsHeader zeta\" ng-if=\"isPrechecked\">{{ content('messenger.pluginHeader') }}</h4>\n            <h4 class=\"noBottom paymentsHeader zeta\" ng-if=\"!isPrechecked\">{{ content('messenger.pluginHeader2') }}</h4>\n            <div>\n                <xo-messenger-plugin token=\"token\" plugin-type=\"CHECKBOX\"></xo-messenger-plugin>\n                <p class=\"messengerLegalTxt\" ng-if=\"isPrechecked\">{{ content('messenger.legal') }}</p>\n                <p class=\"messengerLegalTxt\" ng-if=\"!isPrechecked\">{{ content('messenger.legal2') }}</p>\n            </div>\n        </div>\n\n        <div id=\"button\" class=\"buttons reviewButton\">\n            <input track-submit type=\"submit\" value=\"{{payButtonText()}}\" id=\"confirmButtonTop\" class=\"btn full confirmButton continueButton\" data-test-id=\"continueButton\" validate-submit=\"onPay()\" form=\"ryiForm\"/>\n        </div>\n    </xo-sticky-cta>\n    <!-- >>> CTA Disclaimer -->\n    <span  ng-if=\"stickyEligibility === 'top'\" class=\"stickyCtaTopDisclaimers\">\n        <!-- checkoutSession.isRT need to review this -->\n        <p class=\"reviewLaterContainer disclaimer\" data-test-id=\"reviewLaterContainer\" ng-if=\"!buttonLabelIsPay && showReviewLaterText\">\n                {{ content('common.reviewLater')}}\n            </p>\n\n            <div id=\"disclaimerWithBmlCta\" class=\"disclaimer reviewMsg\" ng-if=\"!isThirdPartyWalletExperience() && showSoftDescriptor && checkoutSession.plan.soft_descriptor\"\n                ng-bind-html=\"content('memberReview.disclaimer', {merchantName: checkoutSession.plan.soft_descriptor})\"></div>\n\n            <div class=\"disclaimer reviewMsg\" ng-if=\"checkoutSession.displayBankChargeDisclaimer\">{{ content('memberReview.bankChargeDisclaimer')}}</div>\n\n            <div class=\"billingAddressConsent reviewMsg\" ng-if=\"checkoutAppData.flags.billing_address_consent_required\">\n                <p class=\"disclaimer\">{{ content('memberReview.billingRequired') }}\n                    <p>\n            </div>\n\n            <div class=\"disclaimer reviewMsg\" ng-if=\"!isThirdPartyWalletExperience() && (checkoutSession.plan.isAuthSignupEnabled || showAuthMsg)\">\n                <span class=\"authMsgContent\">{{ content('memberReview.authUser') }}</span>\n                <span ng-if=\"showAuthMsgLearnMore\">\n                    <a ui-sref=\"checkout.authorizationmessage\" class=\"authUserLink\" aria-describedby=\"authMsgHelp\">{{ content('memberReview.learnMore') }}</a>\n                    <span id=\"authMsgHelp\" class=\"accessAid\">{{content('authUserLearnMore.authUserTitle')}}</span>\n                </span>\n            </div>\n    </span>\n    <!-- <<< CTA Disclaimer -->\n\n    <xo-title title-txt=\"{{content('memberReview.memberReviewTitle')}}\" class=\"accessAid\"></xo-title>\n    <div ng-if=\"!checkoutCart.isWalletTokenization()\" class=\"row-fluid justMember\" ng-class=\"{ bmlPopupOpen: bmlPopupOpen }\">\n        <div class=\"span14 trayInner reviewSections\" ng-show=\"!bmlPopupOpen\">\n            <xo-no-balance-banner ng-if=\"noBalanceFactoryState.eligible\"></xo-no-balance-banner>\n            <div class=\"userBanner\">\n                <xo-banner ng-if=\"isNmjexpired || (personalizedBanner.show && !isMessengerBAIntegration)\" is-nmj=\"isNmj || isNmjexpired\">\n                    <p class=\"userEmail\" id=\"reviewUserInfo\">\n                        <span ng-if=\"isNmjDesign1\">{{ content('memberReview.hiUser_welcome', {userName: formattedNameInformal}) }}</span>\n                        <span ng-if=\"!isNmjDesign1 && !optin_toggle.isEnabled\">{{ content('memberReview.loggedInWithOneTouch', {userName: formattedNameInformal, lastName: auth.last_name, firstName: auth.first_name}) }}</span>\n                        <span ng-if=\"!isNmjDesign1 && optin_toggle.isEnabled\">{{ content('memberReview.hiUser', {userName: formattedNameInformal}) }}</span>\n                        <span ng-if=\"isNmjexpired && optin_toggle.isEnabled\">{{ content('memberReview.hiUser', {userName: formattedNameInformal}) }}</span>\n                        <span ng-if=\"showNotYou\">\n                            <xo-not-you></xo-not-you>\n                        </span>\n                        <div ng-if=\"isNmjexpired\" id=\"notifications\" content>\n                            <div class=\"msgPage msg-normal\">\n                                <span class=\"icon\"></span>\n                                <ul>\n                                    <li>\n                                        <span ng-bind-html=\"htmlContent('creditcard.preferredExpired', {cardType: preferredExpired.displayName, last4:\n                                            preferredExpired.lastDigits})\" ></span><span>\n                                            <a id=\"updatePreferredExpired\" track-submit=\"update_preferred_expired\" href\n                                               ng-click=\"actions.goToManageWallet(preferredExpired.id)\">{{content('creditcard.updateItNow')}}</a></span>\n                                    </li>\n                                </ul>\n                            </div>\n                        </div>\n                    </p>\n                </xo-banner>\n                <div class=\"greyHeader\" ng-if=\"showGreyHeader\">\n                    <xo-banner is-nmj=\"showGreyHeader\">\n                        <p class=\"userEmail\" id=\"reviewUserInfo\">\n                            <span>{{ headerMsg }}</span>\n                            <span ng-if=\"showNotYou\" class=\"greyHeaderNotYou\">\n                                <xo-not-you></xo-not-you>\n                            </span>\n                        </p>\n                    </xo-banner>\n                </div>\n                <xo-expired-message ng-if=\"showExpiredMsg && !isNmjexpired\" token=\"token\"></xo-expired-message>\n                <xo-message message=\"checkoutSession.message\" isGreyHeader=\"showGreyHeader\"></xo-message>\n                <div ng-if=\"!isNmj && !personalizedBanner.show && !isMessengerBAIntegration && !isNmjexpired && !isProcessorDeclineExperiment\">\n                    <p class=\"userEmail\" id=\"reviewUserInfo\">\n                        {{ content('memberReview.hiUser', {userName: formattedNameInformal}) }}\n                        <span ng-if=\"showNotYou\">\n                            <xo-not-you></xo-not-you>\n                        </span>\n                    </p>\n                </div>\n            </div>\n            <div ng-if=\"optin_toggle.isEnabled\" class=\"oneTouchBanner\">\n                <div ng-if=\"!isNmj\" class=\"highlight_bar\"></div>\n                <div class=\"oneTouchTerms\">\n                    <p class=\"enable_auto_login bold\" ng-if=\"!optin_toggle.value\">{{ content('memberReview.autoLoginOff') }}</p>\n                    <p class=\"enable_auto_login\" ng-if=\"optin_toggle.value\">{{ content('memberReview.autoLoginOn') }}</p>\n\n                    <div ng-show=\"optin_toggle.showExpandedTerms\" class=\"oneTouchTermsText\">\n                        <p class=\"expanded\" ng-bind-html=\"htmlContent('memberReview.expandedTermsOT')\"></p>\n                        <p class=\"securityInfo\">\n                            {{ content('memberReview.securityInfoOT') }} <a ng-click=\"optin_toggle.showExpandedTerms = !optin_toggle.showExpandedTerms\">{{ content('common.hide') }}</a>\n                        </p>\n                    </div>\n                    <div ng-show=\"!optin_toggle.showExpandedTerms\">\n                        <p class=\"securityInfo\">\n                            <span ng-show=\"!optin_toggle.value\">{{ content('memberReview.sharedDevicesOT') }}</span>\n                            <a ng-click=\"optin_toggle.showExpandedTerms = !optin_toggle.showExpandedTerms\">Details</a>\n                        </p>\n                    </div>\n                </div>\n                <div id=\"banner-switch\">\n                    <input id=\"optin_toggel\" class=\"cmn-toggle cmn-toggle-round\" type=\"checkbox\" ng-model=\"optin_toggle.value\" ng-change=\"onTouchToggle(optin_toggle.value)\">\n                    <label for=\"optin_toggel\"></label>\n                </div>\n            </div>\n\n            <form name=\"confirm\" class=\"proceed\" novalidate=\"novalidate\" id=\"ryiForm\">\n                <!-- {@if cond=\"'{data.updated}' === 'bmlSuccess'\" } -->\n                <div class=\"reviews\" ng-if=\"isNmjDesign1\">\n                    <xo-assist-banner\n                        header=\"assistBannerHeader\"\n                        body=\"assistBannerBody\"\n                        hide-highlight=\"checkoutSession.message\">\n                    </xo-assist-banner>\n                </div>\n\n                <xo-offer-top-banner ng-if=\"!isThirdPartyWalletExperience()\"></xo-offer-top-banner>\n\n                <div class=\"reviews\" ng-if=\"merchantMsg\">\n                    <h4 ng-if=\"!isMessengerBAIntegration\" class=\"noBottom gamma\" id=\"merchantMsgHeader\">\n                        {{ content('memberReview.merchantMsgHeader', { merchantName: merchantName }) }}\n                    </h4>\n                    <!--content-->\n                    <h1 ng-if=\"isFacebookBAIntegration\" class=\"messengerBAHeader\" id=\"merchantMsgHeader\">\n                        {{ content('messenger.fbHeader') }}\n                    </h1>\n                    <h1 ng-if=\"!isFacebookBAIntegration && isMessengerBAIntegration\" class=\"messengerBAHeader\" id=\"merchantMsgHeader\">\n                        {{ content('messenger.baHeader') }}\n                    </h1>\n                    <div class=\"merchantMsg\" id=\"merchantMsg\">\n                        <span class=\"given-name\">\n                            {{ merchantMsg }}\n                        </span>\n                    </div>\n                </div>\n\n                <div class=\"reviews\" ng-if=\"isNmjDesign1 || isNmjDesign2\">\n                    <div class=\"addPadding\" ng-if=\"isNmjDesign2\"></div>\n                    <xo-review-paywith ng-if=\"!isThirdPartyWalletExperience()\" token=\"token\" pay-button-text=\"payButtonText()\" show-auth-msg=\"showAuthMsg\"\n                                       installment-not-selected=\"installmentNotSelected\"\n                                       show-bml-popup=\"showBmlPopup\" installment=\"installment\"\n                                       pad-toggle-feature=\"padToggleFeature\"\n                                       make-fi-preferred=\"makeFiPreferred\"\n                                       selectedmethod=\"selectedmethod\"\n                                       select-fi-variant=\"selectFiVariant\"\n                                       nmj-experience=\"isNmj\"\n                                       credit-parent-context=\"creditParentContext\"\n                                       choice-balance-checkbox-state=\"choiceBalanceCheckboxState\">\n                    </xo-review-paywith>\n                    <xo-review-paywith-venmo ng-if=\"determineThirdPartyWalletExperience() === 'VENMO_EXPERIENCE'\" token=\"token\"></xo-review-paywith-venmo>\n                    <xo-review-paywith-baidu ng-if=\"determineThirdPartyWalletExperience() === 'BAIDU_EXPERIENCE'\" token=\"token\"></xo-review-paywith-baidu>\n                </div>\n\n                <div class=\"reviews\" ng-if=\"showInstallmentOption()\">\n                    <div id=\"installmentPlanInfo\" data-test-id=\"installmentPlanInfo\">\n                        <h4 class=\"noBottom gamma\" id=\"installmentInfoHeader\">\n                            {{content('chooseCreditOption.reviewPaymentPlan')}}\n                        </h4>\n                        <div class=\"merchantMsg installmentInfo\" ng-if=\"showInstallmentOptionWithoutIncentives()\">\n                            <p class=\"selectedCreditDesc\" ng-bind-html=\"htmlContent('chooseCreditOption.selectedOfferText1',{term:creditOptions.term, monthlyPayment: installmentInfo.monthlyPaymentAmt})\"> </p>\n                            <p class=\"selectedCreditDesc\" ng-bind-html=\"htmlContent('chooseCreditOption.selectedOfferText2',{apr:creditOptions.apr, interest: installmentInfo.totalInterestAmt, totalPayment: installmentInfo.totalPaymentAmt})\"> </p>\n                        </div>\n\n                        <div class=\"merchantMsg installmentInfo\" ng-if=\"creditOptions.creditType === 'SAC'\">\n                            <p class=\"selectedCreditDesc\" ng-bind-html=\"htmlContent('fundingInstruments.bmlDetails')\"> </p>\n                        </div>\n                        <div class=\"merchantMsg installmentInfo\" ng-if=\"creditOptions.creditType === 'NI'\">\n                            <p class=\"selectedCreditDesc\" ng-bind-html=\"htmlContent('fundingInstruments.bmlDetailsNI')\"> </p>\n                        </div>\n                        <a class=\"edits creditEdit\" ng-click=\"showCYCO()\">\n                            {{ content('common.change') }}\n                            <span class=\"frontArrow goTray ng-scope\"></span>\n                        </a>\n                    </div>\n                </div>\n\n                <div class=\"reviews\" ng-if=\"showShippingAddress\">\n                    <div class=\"addPadding\" ng-if=\"isNmjDesign3\"></div>\n                    <xo-review-address ng-if=\"!ixoShippingMethods\" token=\"token\" make-addr-preferred=\"makeAddrPreferred\" shipping-change-feature=\"shippingChangeFeature\" store-pick-up-selected=\"checkoutCart.isShippingMethodStorePickUp()\" nmj-experience=\"nmjExperience\"></xo-review-address>\n                    <xo-review-shipping-options ng-if=\"ixoShippingMethods\" token=\"token\" shipping-change-feature=\"shippingChangeFeature\" methods=\"ixoShippingMethods\"></xo-review-shipping-options>\n                </div>\n\n                <xo-select-shipping-method ng-if=\"showShippingMethod\" token=\"token\" show-shipping-address=\"showShippingAddress\" error-handler-helper=\"errorHandlerHelper\" instant-update-feature=\"instantUpdateFeature\"></xo-select-shipping-method>\n\n                <div class=\"reviews\" ng-if=\"!isNmj\">\n                    <xo-review-paywith ng-if=\"!isThirdPartyWalletExperience()\" token=\"token\" pay-button-text=\"payButtonText()\" show-auth-msg=\"showAuthMsg\"\n                                       installment-not-selected=\"installmentNotSelected\"\n                                       show-bml-popup=\"showBmlPopup\" installment=\"installment\"\n                                       pad-toggle-feature=\"padToggleFeature\"\n                                       make-fi-preferred=\"makeFiPreferred\"\n                                       selectedmethod=\"selectedmethod\"\n                                       select-fi-variant=\"selectFiVariant\"\n                                       nmj-experience=\"isNmj\"\n                                       credit-parent-context=\"creditParentContext\"\n                                       choice-balance-checkbox-state=\"choiceBalanceCheckboxState\">\n                    </xo-review-paywith>\n                    <xo-review-paywith-venmo ng-if=\"determineThirdPartyWalletExperience() === 'VENMO_EXPERIENCE'\" token=\"token\"></xo-review-paywith-venmo>\n                    <xo-review-paywith-baidu ng-if=\"determineThirdPartyWalletExperience() === 'BAIDU_EXPERIENCE'\" token=\"token\"></xo-review-paywith-baidu>\n                </div>\n\n                <div class=\"reviews\" ng-if=\"isNmjDesign3\">\n                    <xo-review-paywith ng-if=\"!isThirdPartyWalletExperience()\" token=\"token\" pay-button-text=\"payButtonText()\" show-auth-msg=\"showAuthMsg\"\n                                       installment-not-selected=\"installmentNotSelected\"\n                                       show-bml-popup=\"showBmlPopup\" installment=\"installment\"\n                                       pad-toggle-feature=\"padToggleFeature\"\n                                       make-fi-preferred=\"makeFiPreferred\"\n                                       selectedmethod=\"selectedmethod\"\n                                       select-fi-variant=\"selectFiVariant\"\n                                       nmj-experience=\"isNmj\"\n                                       credit-parent-context=\"creditParentContext\">\n                    </xo-review-paywith>\n                    <xo-review-paywith-venmo ng-if=\"determineThirdPartyWalletExperience() === 'VENMO_EXPERIENCE'\" token=\"token\"></xo-review-paywith-venmo>\n                    <xo-review-paywith-baidu ng-if=\"determineThirdPartyWalletExperience() === 'BAIDU_EXPERIENCE'\" token=\"token\"></xo-review-paywith-baidu>\n                </div>\n\n                <div ng-if=\"showCreditPlacement()\" ng-class=\"{ 'reviews hideOffersSeparator hideSeparator': isNmj, 'PPCOffers': isPlaceholderTreatment }\">\n                    <xo-offer token=\"token\" promotion=\"promotion\" bmlaction=\"bmlaction\" installment=\"installment\"\n                        selectedmethod=\"selectedmethod\" parent-context=\"creditParentContext\">\n                    </xo-offer>\n                </div>\n\n                <div ng-if=\"isDonation\" class=\"gacDonation\">\n                    <xo-donate merchant-name={{merchantName}}></xo-donate>\n                </div>\n\n                <div ng-if=\"showRemittanceDisclosure\" class=\"rtrWrap\">\n                    {{ content('memberReview.rtrMsg', { merchantName: checkoutAppData.merchant.brand_name }) }}\n                </div>\n\n                <!--inc/bmlLearnMore-->\n                <div>\n                    <div class=\"buttons bmlSeeTermsBtn hide\">\n                        <button class=\"btn full hide\" name=\"authUserBtn\">{{content('authUserLearnMore.ok')}}</button>\n                    </div>\n                </div>\n                <xo-sticky-cta eligibility=\"stickyEligibility\" ng-if=\"stickyEligibility === 'bottom'\">\n                    <!--Action button -->\n                    <p ng-if=\"showPaypalPolicy\" class=\"paypalPoliciesLink disclaimer\" bind-html-compile=\"content('memberReview.viewPaypalPolicies')\"></p>\n\n                    <div ng-if=\"showPaymentRights\">\n                        <div class=\"paypalPoliciesLink disclaimer\" data-ng-bind-html=\"content('memberReview.viewYourPaymentMethodRights')\"></div>\n                        <span class=\"diagonalArrow\"></span>\n                    </div>\n\n                    <!--Invoicing Flow RegE message in cases of RTR -->\n                    <div ng-if=\"showInvoicingRegEMsg\" class=\"invRegE\">\n                        <div>{{ invoicingRegEMsg }}</div>\n                    </div>\n\n                    <p class=\"unconfirmedUpopMsg\" ng-if=\"showUnconfirmedUpopMsg\">\n                        {{ content('confirmUpop.confirmUpopToPay')}}\n                    </p>\n\n                    <p ng-if=\"!isThirdPartyWalletExperience() && showPolicyAgreement\" class=\"disclaimer\" id=\"policyAgreement\" data-ng-bind-html=\"content('memberReview.policyAgreement', {country: locale.country, lang: locale.lang})\">\n                    </p>\n\n                    <div id=\"messengerPlugin\" class=\"messengerBAPlugin\" ng-if=\"isMessengerBAIntegration\">\n                        <!--content-->\n                        <h4 class=\"noBottom paymentsHeader zeta\" ng-if=\"isPrechecked\">{{ content('messenger.pluginHeader') }}</h4>\n                        <h4 class=\"noBottom paymentsHeader zeta\" ng-if=\"!isPrechecked\">{{ content('messenger.pluginHeader2') }}</h4>\n                        <div>\n                            <xo-messenger-plugin token=\"token\" plugin-type=\"CHECKBOX\"></xo-messenger-plugin>\n                            <p class=\"messengerLegalTxt\" ng-if=\"isPrechecked\">{{ content('messenger.legal') }}</p>\n                            <p class=\"messengerLegalTxt\" ng-if=\"!isPrechecked\">{{ content('messenger.legal2') }}</p>\n                        </div>\n                    </div>\n\n                    <div id=\"button\" class=\"buttons reviewButton\">\n                        <input track-submit type=\"submit\" value=\"{{payButtonText()}}\" id=\"confirmButtonTop\" class=\"btn full confirmButton continueButton\" data-test-id=\"continueButton\" validate-submit=\"onPay()\" />\n                    </div>\n                </xo-sticky-cta>\n                <div ng-if=\"!stickyEligibility\">\n                    <!--Action button -->\n                    <p ng-if=\"showPaypalPolicy\" class=\"paypalPoliciesLink disclaimer\" bind-html-compile=\"content('memberReview.viewPaypalPolicies')\"></p>\n\n                    <div ng-if=\"showPaymentRights\">\n                        <div class=\"paypalPoliciesLink disclaimer\" data-ng-bind-html=\"content('memberReview.viewYourPaymentMethodRights')\"></div>\n                        <span class=\"diagonalArrow\"></span>\n                    </div>\n\n                    <!--Invoicing Flow RegE message in cases of RTR -->\n                    <div ng-if=\"showInvoicingRegEMsg\" class=\"invRegE\">\n                        <div>{{ invoicingRegEMsg }}</div>\n                    </div>\n\n                    <p class=\"unconfirmedUpopMsg\" ng-if=\"showUnconfirmedUpopMsg\">\n                        {{ content('confirmUpop.confirmUpopToPay')}}\n                    </p>\n\n                    <p ng-if=\"!isThirdPartyWalletExperience() && showPolicyAgreement\" class=\"disclaimer\" id=\"policyAgreement\" data-ng-bind-html=\"content('memberReview.policyAgreement', {country: locale.country, lang: locale.lang})\">\n                    </p>\n\n                    <div id=\"messengerPlugin\" class=\"messengerBAPlugin\" ng-if=\"isMessengerBAIntegration\">\n                        <!--content-->\n                        <h4 class=\"noBottom paymentsHeader zeta\" ng-if=\"isPrechecked\">{{ content('messenger.pluginHeader') }}</h4>\n                        <h4 class=\"noBottom paymentsHeader zeta\" ng-if=\"!isPrechecked\">{{ content('messenger.pluginHeader2') }}</h4>\n                        <div>\n                            <xo-messenger-plugin token=\"token\" plugin-type=\"CHECKBOX\"></xo-messenger-plugin>\n                            <p class=\"messengerLegalTxt\" ng-if=\"isPrechecked\">{{ content('messenger.legal') }}</p>\n                            <p class=\"messengerLegalTxt\" ng-if=\"!isPrechecked\">{{ content('messenger.legal2') }}</p>\n                        </div>\n                    </div>\n\n                    <div id=\"button\" class=\"buttons reviewButton\">\n                        <input track-submit type=\"submit\" value=\"{{payButtonText()}}\" id=\"confirmButtonTop\" class=\"btn full confirmButton continueButton\" data-test-id=\"continueButton\" validate-submit=\"onPay()\" />\n                    </div>\n                </div>\n\n                <!--content-->\n                <div class=\"messengerBANotnow\" ng-if=\"isMessengerBAIntegration\">\n                    <a href=\"\" ng-click=\"onFBBANotNow()\">{{ content('messenger.button_notNow') }}</a>\n                </div>\n\n                <!-- >>> CTA Disclaimer -->\n                <span  ng-if=\"stickyEligibility !== 'top'\">\n                    <!-- checkoutSession.isRT need to review this -->\n                    <p class=\"reviewLaterContainer disclaimer\" data-test-id=\"reviewLaterContainer\" ng-if=\"!buttonLabelIsPay && showReviewLaterText\">\n                            {{ content('common.reviewLater')}}\n                        </p>\n\n                        <div id=\"disclaimerWithBmlCta\" class=\"disclaimer reviewMsg\" ng-if=\"!isThirdPartyWalletExperience() && showSoftDescriptor && checkoutSession.plan.soft_descriptor\"\n                            ng-bind-html=\"content('memberReview.disclaimer', {merchantName: checkoutSession.plan.soft_descriptor})\"></div>\n\n                        <div class=\"disclaimer reviewMsg\" ng-if=\"checkoutSession.displayBankChargeDisclaimer\">{{ content('memberReview.bankChargeDisclaimer')}}</div>\n\n                        <div class=\"billingAddressConsent reviewMsg\" ng-if=\"checkoutAppData.flags.billing_address_consent_required\">\n                            <p class=\"disclaimer\">{{ content('memberReview.billingRequired') }}\n                                <p>\n                        </div>\n\n                        <div class=\"disclaimer reviewMsg\" ng-if=\"!isThirdPartyWalletExperience() && (checkoutSession.plan.isAuthSignupEnabled || showAuthMsg)\">\n                            <span class=\"authMsgContent\">{{ content('memberReview.authUser') }}</span>\n                            <span ng-if=\"showAuthMsgLearnMore\">\n                                <a ui-sref=\"checkout.authorizationmessage\" class=\"authUserLink\" aria-describedby=\"authMsgHelp\">{{ content('memberReview.learnMore') }}</a>\n                                <span id=\"authMsgHelp\" class=\"accessAid\">{{content('authUserLearnMore.authUserTitle')}}</span>\n                            </span>\n                        </div>\n                </span>\n                <!-- <<< CTA Disclaimer -->\n\n                <xo-credit-example-uk ng-if=\"showCreditPlacement() && installment.showCreditExample\"/>\n            </form>\n\n        </div>\n\n        <xo-bml-popup ng-if=\"!isThirdPartyWalletExperience()\"></xo-bml-popup>\n\n        <div ng-show=\"bmlPopupOpen\" class=\"bmlPopup span14\">\n            <p>\n                {{ content('fundingInstruments.bmlLearnMoreDesc') }}\n            </p>\n\n            <input type=\"button\" class=\"btn full primary\" value=\"{{ content('fundingInstruments.ok') }}\" ng-click=\"hideBmlPopup()\" />\n        </div>\n\n        <div class=\"span10\" ng-if=\"!isThirdPartyWalletExperience()\">\n\n            <xo-marketing-offers placement-code=\"'202003'\"\n                                 token=\"token\"\n                                 page-name=\"'HERMES_RYI_PAGE'\"\n                                 title-txt-property=\"propValueObj.propHeader\"\n                                 subtitle-property=\"propValueObj.propVal\"\n                                 background-image= \"propValueObj.propImage\"\n                                 ng-if=\"!ryiDesignExp && !isMessengerBAIntegration\"\n            >\n            </xo-marketing-offers>\n\n            <xo-marketing-offers token=\"token\"\n                                 page-name=\"'HERMES_RYI_PAGE'\"\n                                 title-txt-property=\"'ryiDesignExp.propHeader'\"\n                                 subtitle-property=\"'ryiDesignExp.propText'\"\n                                 background-image=\"{{ryiDesignExp.propImage}}\"\n                                 ng-if=\"ryiDesignExp && !isMessengerBAIntegration\"\n\n            >\n            </xo-marketing-offers>\n        </div>\n    </div>\n    <div class=\"reviewTopup\" ng-if=\"checkoutCart.isWalletTokenization()\">\n        <div class=\"reviewTopupError\">\n            <xo-message message=\"tokenizedFactoryState.reviewTopupErrorMessage\"></xo-message>\n        </div>\n        <div class=\"topupError\" ng-if=\"topupError\">\n            <span class=\"topupErrorIcon\"></span>\n            <span>{{content('review.pinError')}}</span>\n        </div>\n        <xo-title title-txt=\"{{content('review.reviewDetailsTitle', {type: tokenizedWalletInfoModel.brandName()})}}\"></xo-title>\n        <div class=\"topupMsg\">\n            <span>{{content('review.tokenizationInfo', {type: tokenizedWalletInfoModel.brandName()})}}</span>\n        </div>\n\n        <xo-review-topup class=\"fillflex\" token=\"token\" flags=\"tokenizedFactoryState.tokenizationFlags\"></xo-review-topup>\n        <div ng-if=\"tokenizedFundingCapabilitiesModel.isTopupEnabled()\" class=\"disclaimer reviewMsg\" ng-bind-html=\"content('review.topupCommonSetting')\"></div>\n        <div class=\"disclaimer reviewMsg\" ng-bind-html=\"content('review.topupTokenizedWalletSetupAgreements', {type: tokenizedWalletInfoModel.brandName(), link: tokenizedWalletInfoModel.getDisclaimerLink()})\"></div>\n        <div id=\"button\" class=\"buttons reviewButton\">\n            <input track-submit type=\"submit\" value=\"{{payButtonText()}}\" id=\"confirmButtonTop\"\n                class=\"btn full confirmButton continueButton\" data-test-id=\"continueButton\" ng-click=\"onPay()\" />\n        </div>\n    </div>\n    <div ui-view></div>\n    <xo-3ds on-complete-3ds-handler=\"onComplete3DSHandler\" token=\"token\" data=\"resolve_3ds_data\" ng-if=\"launch3DSResolver\"></xo-3ds>\n</section>\n"

/***/ }),

/***/ "./pages/xo-review/tokenizedFactory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _user = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$TokenizedFactory', function () {

    var state = {
        reviewTopupErrorMessage: {},
        tokenizationFlags: {
            sepaAgree: false
        }
    };

    var get = function get() {
        return state;
    };

    var AUTHORIZE_AND_UPDATE_SCOPE_BATCH = 'authorizeAndUpdateScope';
    var AUTHORIZE_CALL = 'authorize';

    /**
     * PatchXO api call for tokenization flows
     */
    var tokenizationPatchXO = function tokenizationPatchXO(checkoutSession, instrumentId) {
        return checkoutSession.action('setTopupFI', {
            data: {
                instrument_id: instrumentId
            }
        });
    };

    /**
     * Agree Sepa Mandate:
     *  When user has clicked on the checkbox, call SepaAccept api, then calls PatchXO
     *  When user has not clicked on the checkbox, show page level error message
     */
    var agreeSepaMandate = function agreeSepaMandate(checkoutCart, checkoutSession, tokenizedWalletInfoModel) {
        if (checkoutCart.isWalletTokenization()) {
            var bankId = checkoutSession.get('sepa_mandate.bankId');
            if (bankId && state.tokenizationFlags.sepaAgree) {
                // User agreed to the Sepa mandate by clicking on the checkbox
                return _fi.$SepaModel.instance().action('sepaAccept', {
                    data: {
                        bank: {
                            id: bankId
                        }
                    },
                    success: function success() {
                        // Patch XO after Sepa agreed by user, so as to update PAPS
                        return tokenizationPatchXO(checkoutSession, bankId);
                    }
                });
            } else if (bankId) {
                // User did not agree to the Sepa mandate
                var msg = (0, _squid.$renderContent)('tokenization.agreeToSepaMsg', {
                    type: tokenizedWalletInfoModel.brandName()
                });

                state.reviewTopupErrorMessage = {
                    msgs: [msg],
                    type: 'warning'
                };
                return _angular.$q.reject();
            }
        }
        return _angular.$q.when();
    };

    /**
     * Save the pin when its available
     */
    var setTokenizedWalletPin = function setTokenizedWalletPin(walletPinModel) {
        if (walletPinModel) {
            var pinModel = {
                data: {
                    pin: walletPinModel.userPin
                },
                contingencies: {
                    DEFAULT: function DEFAULT(name, err) {
                        _logger.$logger.info('tokenized_wallet', {
                            'from': 'TopUp_REVIEW',
                            'to': 'process_review',
                            'context_id': _angular.$rootScope.token,
                            'context_type': 'BA-Token',
                            'billing_token': _squid.$meta.baToken,
                            'int_error_code': 'pin_setup_contingencies',
                            'int_error_description': err,
                            'error_source': 'issuancemanagementserv'
                        });

                        throw err;
                    }
                }
            };

            if (walletPinModel.isSetupEligible()) {
                if (walletPinModel.isPinIdPresent()) {
                    pinModel.data.pinId = walletPinModel.getPinId();
                }
                return walletPinModel.save(pinModel);
            }
        }
        return _angular.$q.when();
    };

    var tokenizedOnPayCalls = function tokenizedOnPayCalls(checkoutCart, checkoutSession, tokenizedWalletInfoModel, walletPinModel) {
        return agreeSepaMandate(checkoutCart, checkoutSession, tokenizedWalletInfoModel).then(function () {
            return setTokenizedWalletPin(walletPinModel);
        });
    };

    /**
     * log FPTI event after authorize or authorizeAndUpdateScope call
     */
    var logProcessReviewToFPTI = function logProcessReviewToFPTI() {
        var _$WalletPreferences$i = _fi.$WalletPreferences.instance(_angular.$rootScope.token),
            _$WalletPreferences$i2 = _$WalletPreferences$i.topup,
            topup = _$WalletPreferences$i2 === undefined ? {} : _$WalletPreferences$i2,
            _$WalletPreferences$i3 = _$WalletPreferences$i.direct,
            direct = _$WalletPreferences$i3 === undefined ? {} : _$WalletPreferences$i3,
            currency = _$WalletPreferences$i.currency;

        _logger.$logger.info('tokenized_wallet', {
            'from': 'TopUp_REVIEW',
            'to': 'process_review',
            'topup_amt': topup.amount,
            'chosen_topup_fi': topup.fundingSource && topup.fundingSource.type,
            'chosen_direct_fi': direct.fundingSource && direct.fundingSource.type,
            'currency_code': currency || topup.currency,
            'context_id': _angular.$rootScope.token,
            'context_type': 'BA-Token',
            'billing_token': _squid.$meta.baToken
        });
    };

    /**
     * Update user's scope with "issuance" scope for Google account linking flow
     * Call must be triggered only after successfull "authorize" call
     *
     * If successfull - redirect back to success url
     *
     * If there is a contingency (UAL_ISSUANCE_UPDATE_SCOPE_ERROR) - go to default tokenized wallet error page (see public/js/lib/contingency.js)
     *
     * To improve latency - batch it with "authorize" call
     */
    var updateIssuanceScope = function updateIssuanceScope() {
        var authConsentModel = _user.$AuthConsentModel.instance();

        return authConsentModel.action('updateIssuanceScope', {
            batch: {
                name: AUTHORIZE_AND_UPDATE_SCOPE_BATCH,
                id: 'updateIssuanceScope',
                dependencies: [AUTHORIZE_CALL]
            },
            data: {
                'ba_token': _squid.$meta.baToken
            },
            success: function success() {
                _logger.$logger.info('ual_update_issuance_scope_success');
                logProcessReviewToFPTI();

                return _uiRouter.$state.go('checkout.end');
            }
        });
    };

    /**
     * Check if flow is Google account linking
     */
    var isGoogleAccountLinking = function isGoogleAccountLinking() {
        var checkoutCart = _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token);
        var auth = _auth.$AuthModel.instance();

        return checkoutCart.isWalletTokenization() && auth.logged_in && auth.disallow_login_switch;
    };

    /**
     * Construct batch object for "authorize" call
     */
    var getAuthorizeBatch = function getAuthorizeBatch() {
        return {
            name: AUTHORIZE_AND_UPDATE_SCOPE_BATCH,
            id: AUTHORIZE_CALL,
            dependencies: []
        };
    };

    return {
        get: get,
        agreeSepaMandate: agreeSepaMandate,
        setTokenizedWalletPin: setTokenizedWalletPin,
        tokenizedOnPayCalls: tokenizedOnPayCalls,
        updateIssuanceScope: updateIssuanceScope,
        isGoogleAccountLinking: isGoogleAccountLinking,
        logProcessReviewToFPTI: logProcessReviewToFPTI,
        getAuthorizeBatch: getAuthorizeBatch
    };
});

_angular.$q;

_angular.$rootScope;

_squid.$meta;

_squid.$renderContent;

_fi.$SepaModel;

_logger.$logger;

_user.$AuthConsentModel;

_auth.$AuthModel;

_fi.$WalletPreferences;

_checkout.$CheckoutCartModel;

_uiRouter.$state;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-review", "pages/xo-review/tokenizedFactory.js"))

/***/ }),

/***/ "./pages/xo-select-fi/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoSelectFiComponent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _choice = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _fiMeta = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _fiMeta2 = _interopRequireDefault(_fiMeta);

__webpack_require__("./js/lib/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/banner/directive.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

__webpack_require__("../node_modules/xo-models/src/fi/lib/fiMessages.js");

__webpack_require__("../node_modules/xo-models/src/fi/lib/fiApis.js");

__webpack_require__("../node_modules/xo-ui-components/src/fi-panel/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/experience/directive.js");

__webpack_require__("../node_modules/xo-device-info/dist/index.js");

__webpack_require__("../node_modules/xo-credit-components/src/offer/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/offer/xo-credit-example-uk/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/review-paywith/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/marketingOffers/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/notYou/directive.js");

var _factory = __webpack_require__("./pages/xo-select-fi/factory.js");

var _cardartInstrument = __webpack_require__("./pages/services/cardart-instrument/index.js");

var _experiments = __webpack_require__("../node_modules/xo-models/src/experiments/index.js");

var Experiments = _interopRequireWildcard(_experiments);

var _template = __webpack_require__("./pages/xo-select-fi/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-select-fi/styles.less");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSelectFiComponent = exports.$xoSelectFiComponent = _squid.$Component.extend('$xoSelectFiComponent', {
    tag: 'xo-select-fi',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                cart: _checkout.$CheckoutCartModel.instance(this.props.token).retrieve(),
                auth: _auth.$AuthModel.instance().retrieve(),
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
                variant: _choice.$ChoiceEligibility.instance().getVariant(this.props.token),
                checkoutPayeeModel: _checkout.$CheckoutPayeeModel.instance(this.props.token).retrieve(),
                fiMeta: _fiMeta2['default'].instance(this.props.token).fetch()['catch'](_angular.noop)
            };
        },
        fiSource: function fiSource(resolvers) {
            return resolvers.models.then(function (models) {
                return {
                    isCardArtExp: _cardartInstrument.$CardArtInstrument.isCardArtEnable(models.fiMeta),
                    isBilling: models.cart && models.cart.isBilling(),
                    isBillingNoPurchase: models.cart && models.cart.isBillingNoPurchase()
                };
            });
        },
        padToggleFeature: function padToggleFeature(resolvers) {
            return resolvers.models.then(function (models) {
                var enabled = void 0;

                if (models.checkoutSession.fundingOptions.isPadToggleApplicable()) {
                    enabled = Experiments.padToggleFeatureSupported();
                } else {
                    // if pad not available
                    enabled = false;
                }
                return { enabled: enabled };
            });
        }
    },
    lifecycle: {
        enter: function enter() {
            // make this better
            this.propValueObj = {
                propHeader: 'memberReview.propHead',
                propVal: 'memberReview.propVal',
                propImage: 'https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_shield_bags.png'
            };
            this.isMessengerBAIntegration = _squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
            this.personalizedBanner = {
                show: false
            };
            this.locale = _squid.$locale;
            this.isCountryDE = _squid.$locale.country === 'DE';
            this.addBankAllowed = (0, _squid.$feature)('addBank');
        },
        populate: function populate() {
            var _this = this;

            var checkoutSession = this.models.checkoutSession;
            var _fiSource = this.fiSource,
                isCardArtExp = _fiSource.isCardArtExp,
                isBilling = _fiSource.isBilling,
                isBillingNoPurchase = _fiSource.isBillingNoPurchase;

            var masterPlanList = checkoutSession.getPlanList(); // initial fundingOptions that's returned by planning (unmodified)

            this.isBilling = isBilling;
            this.isBillingNoPurchase = isBillingNoPurchase;
            this.personalizedBanner.show = this.models.auth.rememberedOT() && (0, _squid.$feature)('oneTouchPersonalization');
            this.showNotYou = this.models.auth && this.models.auth.showNotYou();
            this.formattedNameInformal = (0, _squid.formatNameInformal)({
                first_name: this.models.auth.first_name,
                last_name: this.models.auth.last_name
            }) || this.models.auth.email;

            this.isIndiaDomesticBilling = isBilling && _squid.$locale.country === 'IN' && this.models.checkoutAppData.get('merchant.merchant_country', 'US') === 'IN';
            this.choicePageAddCardContentKey = this.isIndiaDomesticBilling ? 'fundingInstruments.addNewCardBilling' : 'fundingInstruments.addNewCard';

            var merchant = this.models.checkoutAppData.get('merchant');

            if (this.isIndiaDomesticBilling) {
                var merchantName = merchant.brand_name || merchant.merchant_name || 'Merchant';
                checkoutSession.message = {
                    type: 'info',
                    msgs: [(0, _squid.$renderContent)('memberReview.billingMerchant', { merchantName: merchantName })]
                };
            }

            /**
             * If it's cardart experience, log our current FIs (bank or cards)
             * NOTE: `balance` type is not being instrumented at the moment, cardart
             * instrumentation is only applicable to credit cards & banks right now.
             * See $CardArtInstrument.createPayload() for detail implmenetation
             */
            if (isCardArtExp) {
                _logger.$logger.info('checkout_fpti', _extends({
                    from: 'CHOICE',
                    to: 'prepare_choice'
                }, _cardartInstrument.$CardArtInstrument.createPayload({
                    checkoutSession: checkoutSession,
                    isBillingNoPurchase: isBillingNoPurchase
                })));
            }

            /**
            * checks for PPC in the wallet and selected as fi
            * This Determines whether to show the banner or not for a reuse customer
            */
            this.isPPCReuseAndNotSelected = function () {
                if (_this.isBillingNoPurchase) {
                    return checkoutSession.get('futurePayment.isCreditInWallet') && !checkoutSession.get('futurePayment.isCreditDefault');
                } else {
                    var plans = checkoutSession.get('fundingOptions.instruments', null);
                    if (plans && plans.filter(function (fi) {
                        return fi.name === 'BILL_ME_LATER' && !fi.selected;
                    }).length === 1) {
                        return true;
                    } else {
                        return false;
                    }
                }
            };

            /* checks for eligibility for acq PPC or PPC in wallet and not selected for reuse */
            this.creditOffer = checkoutSession.creditOffer || this.isPPCReuseAndNotSelected();

            // selected plan model
            var selectedmethod = this.selectedmethod = {
                // first selection to start
                index: 0,
                // needed by xo-reuse and will be resolved later
                planId: 0
            };

            var serializedPlans = {}; // index of all plans by primary and balance currency code(s)
            var balanceCodes = {}; // index of cataloged currency codes
            var primaryList = []; // list of plans with unique primaryFs ids
            var balanceList = this.balanceList = []; // list of unique balance currencies
            var cardMap = { // FI names that we know map to content keys
                BILL_ME_LATER: 'BILL_ME_LATER',
                PAD: 'PAD',
                PAYPAL_EXTRAS_MASTERCARD: 'PAYPAL_EXTRAS_MASTERCARD'
            };

            this.isUSGambling = function () {
                // US Only Real Money Gaming
                var isUSBuyer = _squid.$locale.country === 'US';
                var isUSmerchant = _this.models.checkoutAppData && _this.models.checkoutAppData.get('merchant.merchant_country') === 'US';

                return _this.models.checkoutPayeeModel && _this.models.checkoutPayeeModel.isGambling() && isUSBuyer && isUSmerchant;
            };

            // Return a representation of the primaryFs of a plan
            // Based on id, currency code, subtype to ensure uniqueness
            // TODO(refactor): $MultiFiPlanFactory.getSerializedPrimary()
            var getSerializedPrimary = function getSerializedPrimary(primary) {
                var serial = primary.id + primary.amount.currency_code.toLowerCase();

                // if there's a subtype...
                if (primary.subtype) {
                    serial += primary.subtype;
                }
                return serial;
            };

            // return a serialized key for the plan
            // plan - a plan object from checkoutSession.fundingOptions.plans
            // balances - array of currency code strings
            // TODO (refactor): $MultiFiPlanFactory.getSerializedPlanId()
            var getSerializedPlanId = function getSerializedPlanId(plan, balances) {
                var pid = getSerializedPrimary(plan.primaryFs);

                // if no balances array...
                if (!balances) {
                    // just return the pid
                    return pid;
                }

                // (otherwise) sort balances
                balances.sort();

                return pid + balances.join();
            };

            if (masterPlanList) {
                // If more than one fully funded balance plan, show the balance currency next to instrument name
                // TODO(refactor): the entire `showBalanceCurrencies` logic can be abstracted away
                // with $MultiFiPlanFactory.getShowBalanceCurrenciesStatus()
                var showBalanceCurrencies = checkoutSession.isMultipleBalancePlan();

                // if not multiple balance plans...
                if (!showBalanceCurrencies) {
                    // start with first plan's currency
                    var knownCurrency = masterPlanList[0].primaryFs.amount.currency_code;

                    // update flag if any plan has more than two secondaries or one with a different currency
                    showBalanceCurrencies = masterPlanList.some(function (plan) {
                        // show currencies, when this plan has a different one, or...
                        return plan.primaryFs.amount.currency_code !== knownCurrency ||
                        // this plan has secondaries, where...
                        plan.secondaryFIs && (
                        // there's more than one
                        plan.secondaryFIs.length > 1 ||
                        // the one has a different currency
                        plan.secondaryFIs[0].amount.currency_code !== knownCurrency);
                    });
                }

                // index of captured primaryFs ids
                var primaryFsIds = {};

                // Filter through the masterPlanList, set up the split balance lists for the checkboxes if present, and set up the primary FI list. This is mostly needed for split balance cases
                // TODO(refactor): use $MultiFiPlanFactory.getCompositeBalances() to get `balanceCodes`, `balanceList` and `balCurCodes`
                masterPlanList.forEach(function (plan) {
                    var balances = plan.secondaryFIs || [];
                    var balCurCodes = [];

                    // catalog balances
                    balances.forEach(function (balance) {
                        var code = balance.amount.currency_code;

                        // capture code (for serialization, next)
                        balCurCodes.push(code);
                        // if this code has not been cataloged...
                        if (!balanceCodes.hasOwnProperty(code)) {
                            var balInfoAndState = {
                                code: code,
                                checked: false,
                                enabled: true,
                                intent: false,
                                fake: false
                            };

                            if (showBalanceCurrencies) {
                                balInfoAndState.amount = balance.amount.amount_formatted_currency;
                            } else {
                                balInfoAndState.amount = balance.amount.amount_formatted;
                            }
                            // flag that we've cataloged this code
                            balanceCodes[code] = balInfoAndState;
                            // capture balance details and initial ui state
                            balanceList.push(balInfoAndState);
                        }
                    });

                    // if this is a primary split-balance plan...
                    if (plan.primaryFs.type === 'BALANCE') {
                        // add key to template
                        // NOTE: easier to build string here, than with template tags
                        plan.currencies = [plan.primaryFs.amount.currency_code].concat(balCurCodes).join(', ');
                    }

                    // catalog plan by serial and balances
                    serializedPlans[getSerializedPlanId(plan, balCurCodes)] = plan;

                    // get plan primary
                    var serialPrimary = getSerializedPrimary(plan.primaryFs);

                    // if haven't indexed the primary...
                    if (!primaryFsIds.hasOwnProperty(serialPrimary)) {
                        // note that we've cataloged this primary
                        primaryFsIds[serialPrimary] = 1;
                        // capture plan with unique primary
                        primaryList.push(plan);
                    }
                });

                // sort unique balances by currency code
                // TODO(refactor): part of $MultiFiPlanFactory.getCompositeBalances() logic
                balanceList.sort(function (balA, balB) {
                    // balance codes are never the same, so no need to return 0
                    return balA.code < balB.code ? -1 : 1;
                });

                // expose to template
                this.isMultipleBalance = showBalanceCurrencies;

                // filtering primary list by PAD specific logic so it combines IACH and PAD together
                if (this.padToggleFeature.enabled) {
                    primaryList = checkoutSession.fundingOptions.getPadAndIachCombinedPlans(primaryList);
                }

                this.primaryList = primaryList;
            }

            // TODO(refactor): use $MultiFiPlanFactory.getPlansByPrimaryId()
            var getPlansByPrimaryId = function getPlansByPrimaryId(pid) {
                var matchingPlans = {};

                // with each serialized plan
                for (var key in serializedPlans) {
                    // if this key is not inherited and begins with this pid...
                    if (serializedPlans.hasOwnProperty(key) && !key.indexOf(pid)) {
                        // add to matched plans
                        matchingPlans[key] = serializedPlans[key];
                    }
                }
                return matchingPlans;
            };

            // checkPad() determines whether to show/hide the PAD warning message and PAD label
            var checkPad = function checkPad() {
                var _$BalanceFactory$getP = _factory.$BalanceFactory.getPadAndCheckboxStatus(_this.balanceList, masterPlanList),
                    isChecked = _$BalanceFactory$getP.isChecked,
                    hasPad = _$BalanceFactory$getP.hasPad;

                // only display this warning message to current user who have selected PayPal balance and
                // currently has a PAD type funding option


                _this.displayPadMessage = isChecked && hasPad;
                // display PAD label when PayPal balance is unchecked
                _this.displayPadLabel = isChecked === false;

                _factory.$BalanceFactory.set({ checkbox: isChecked });
            };

            this.capUserIntent = function (code, state) {
                var balance = balanceCodes[code];

                // if this balance is enabled...
                if (balance.enabled) {
                    // capture user triggered state change
                    balance.intent = state;
                }

                // check PAD related business logic to display PAD label and PAD warning message
                checkPad();
            };

            // check if plan is MEFT and has associated IACH bank
            var isMEFTWithIACH = function isMEFTWithIACH(plan) {
                if (!checkoutSession.fundingOptions.isMEFT(plan)) {
                    return false;
                }
                return masterPlanList.some(function (p) {
                    return plan.primaryFs && plan.primaryFs.id === p.primaryFs.id && checkoutSession.fundingOptions.isIACH(p);
                });
            };

            // for PAD eligible countries only we show preferred only for PAD or IACH banks
            var showPreferredLabelForPadEligibleCountries = function showPreferredLabelForPadEligibleCountries(isPAD, isMEFT, isIACHWithPad) {
                return (isPAD || isIACHWithPad) && _this.padToggleFeature.enabled && !isMEFT; // if it's pad or iach and not meft
            };

            // for all countries except DE check if it's not PAD bank and not a MEFT bank with associated IACH
            var showPreferredLabelForAll = function showPreferredLabelForAll(isPAD, meftWithIach) {
                return !isPAD && !meftWithIach;
            };

            // for PAD isPreferred will never be true
            // only MEFT and IACH subtypes can have isPreferred as true
            this.showPreferredLabel = function (plan) {
                var preferred = checkoutSession.fundingOptions.isPreferred(plan);
                var isPAD = checkoutSession.fundingOptions.isPAD(plan);
                var isMEFT = checkoutSession.fundingOptions.isMEFT(plan);
                var isIACHWithPad = checkoutSession.fundingOptions.isIACHWithPad(plan);
                var meftWithIach = isMEFTWithIACH(plan);

                return !_this.isBilling && preferred && _this.preferredFiVariant && (showPreferredLabelForAll(isPAD, meftWithIach) || showPreferredLabelForPadEligibleCountries(isPAD, isMEFT, isIACHWithPad));
            };

            // Update the balance checkbox states based on the index of primaryFs user has selected
            this.updateBalances = function (index, clickChosenPlan) {
                var primary = primaryList[index].primaryFs;
                var bankOrOther = primary.type === 'BANK' ? 'BANK' : 'OTHER';
                var primaryCodeAsBalance = primary.type === 'BALANCE' && primary.amount.currency_code;
                var pid = getSerializedPrimary(primary);
                var matchingPlans = getPlansByPrimaryId(pid);

                // if no balances, set selected planId to the matching primaryFs by pid (should only be one) and exit early
                if (!balanceList.length) {
                    if (matchingPlans.hasOwnProperty(pid)) {
                        // capture the matching plan (needed by xo-reuse)
                        selectedmethod.planId = matchingPlans[pid].planId;
                    }

                    return;
                }

                // Otherwise, match the balances based on index of user choice
                var combinedSerials = Object.keys(matchingPlans).join();
                var cardName = cardMap[primary.name] || bankOrOther;
                var includeCodes = [];
                var excludeCodes = [];

                var selectedPlan = primaryList[index]; // current selected plan
                var id = selectedPlan.secondaryFIs.length && selectedPlan.primaryFs.subtype === 'IACH' && selectedPlan.primaryFs.padPlanId || selectedPlan.secondaryFIs === false && selectedPlan.primaryFs.subtype === 'PAD' && selectedPlan.primaryFs.iachPlanId;

                var foundCorrespondingPlan = masterPlanList.some(function (plan) {
                    return plan.planId === id;
                });

                // with each balance...
                // TODO(refactor)
                _squid.$util.forEach(balanceCodes, function (balState, code) {
                    var isFake =

                    // When the primary is Balance with the same currency
                    // user cannot deselect this balance, so show fake selected+disabled checkbox
                    balState.fake = primaryCodeAsBalance === code;

                    // if faking this checkbox
                    if (isFake) {
                        // fake that it's being forced
                        includeCodes.push(code);
                    }

                    // if no plans allow this balance...
                    if (combinedSerials.indexOf(code) === -1 && !foundCorrespondingPlan) {
                        // deselect and disable this balance
                        balState.checked = balState.enabled = false;
                        if (!isFake) {
                            // add currency code to exclude list
                            excludeCodes.push(code);
                        }
                    } else if (foundCorrespondingPlan && _this.padToggleFeature.enabled) {
                        // checks for crossed combination between IACH and PAD
                        balState.enabled = true;
                        balState.checked = balState.intent;
                    } else if (selectedPlan.secondaryFIs === false && selectedPlan.primaryFs.subtype === 'PAD') {
                        // disable balance if selected plan is PAD
                        balState.enabled = false;
                        balState.checked = false;
                    } else {
                        _this.installment = _this.installment || {};
                        _this.installment.isSplitBalance = true;

                        // assume all plans require this balance
                        var requiresBalance = true;

                        // with each plan...
                        for (var serial in matchingPlans) {
                            // if it can be used without this balance...
                            if (matchingPlans.hasOwnProperty(serial) && serial.indexOf(code) === -1) {
                                // flag that all plans do not use this balance
                                requiresBalance = false;
                                break;
                            }
                        }
                        // if this balance is required for this (or all) plans...
                        if (requiresBalance) {
                            // select this balance
                            balState.checked = true;
                            // disable this balance
                            balState.enabled = false;

                            // add currency code to include list
                            includeCodes.push(code);
                        } else {
                            // (otherwise) when this balance is optional for this primaryFs...
                            // just enable the balance checkbox
                            balState.enabled = true;
                            // use intent state to persist user intent
                            balState.checked = balState.intent;
                        }
                    }
                });

                // if not a balance plan, and we have any include and/or exclude messages to display...
                if (primary.type !== 'BALANCE' && (includeCodes.length || excludeCodes.length)) {
                    var msgs = [];
                    var fiName = (0, _squid.$renderContent)('fsMappings.' + primary.name).string || primary.name;

                    // log when user messaging occurs
                    _logger.$logger.info('checkout_fpti', {
                        primary: primary.id || primary.type,
                        denied: excludeCodes.join(),
                        forced: includeCodes.join()
                    });

                    // build include and exclude messages
                    [['yes', includeCodes], ['no', excludeCodes]].forEach(function (pair) {
                        var codes = pair[1];
                        var codesLn = codes.length;

                        // if there are codes to report as in/ex-cluded...
                        if (codesLn) {
                            var msgKey = 'memberReview.' + pair[0] + 'Bal_' + cardName;
                            var msgObj = { fi: fiName };

                            // if more than one code...
                            if (codesLn > 1) {
                                // use plural content key
                                msgKey += '_plural';
                                // if more than two codes...
                                if (codesLn > 2) {
                                    // group all but the last as the first code
                                    msgObj.code1 = codes.slice(0, -1).join(', ');
                                    // use last code alone
                                    msgObj.code2 = codes[codes.length - 1];
                                } else {
                                    // set code to each token
                                    msgObj.code1 = codes[0];
                                    msgObj.code2 = codes[1];
                                }
                            } else {
                                // (otherwise) when only one code...
                                // list as first code
                                msgObj.code1 = codes[0];
                            }
                            // capture final message
                            msgs.push((0, _squid.$renderContent)(msgKey, msgObj));
                        }
                    });
                    // show informational messages
                    checkoutSession.message = {
                        msgs: msgs,
                        type: 'info'
                    };
                } else {
                    // clear (any) existing message(s)
                    checkoutSession.message = '';
                }

                // check PAD related business logic to display PAD label and PAD warning message
                checkPad();
                if (_this.selectedmethod.planId === 0 && clickChosenPlan) {
                    _this.selectedmethod.planId = clickChosenPlan.planId;
                }
            };

            // determine which plan to pre-select

            // if BA txn...
            if (this.isBillingNoPurchase) {
                // just deal with plan id - ignore index approach
                var selectStickyInstrument = checkoutSession.getSelectedStickyInstrument();

                if (selectStickyInstrument) {
                    selectedmethod.planId = selectStickyInstrument.instrument_id;
                }
            } else if (balanceList.length) {
                // (or) there are balances...

                // Select checkboxes by default if first plan has balances by default
                if (masterPlanList[0].secondaryFIs) {
                    masterPlanList[0].secondaryFIs.forEach(function (bal) {
                        _this.capUserIntent(bal.amount.currency_code, true);
                    });
                }

                // update balance checkboxes for the first/default selected plan
                this.updateBalances(0);
            } else {

                // (otherwise) without balances...

                // honor preferred/active/current plan
                var preferredPlanId = checkoutSession.plan.id;

                // behave as if the preferred plan were selected - if not, the first/default
                var preferredPlanIndex = _squid.$util.findIndex(primaryList, function (plan) {
                    return plan.planId === preferredPlanId;
                }) || 0;

                var plan = primaryList[preferredPlanIndex];

                if (plan) {
                    // specify selected method
                    selectedmethod.index = preferredPlanIndex;

                    // capture preferred plan id - should be same as `preferredPlanId`
                    selectedmethod.planId = plan.planId;
                }
            }

            this.getBAPlans = function () {
                return checkoutSession.futurePaymentInstruments;
            };

            // Check if is variant where preferred can be set
            var preferredFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.preferredCheckbox || [];

            this.preferredFiVariant = preferredFiVariants.indexOf(this.models.variant) > -1;

            var updateFS = function updateFS() {
                var planId = void 0;

                if (_this.selectedmethod.index === 'applyForPPCRadio') {
                    return _squid.$promise.resolve();
                }

                // if BA plans...
                if (_this.isBillingNoPurchase) {
                    planId = selectedmethod.planId;
                } else {

                    // (otherwise) resolve plan from index and checked balance checkboxes

                    var index = selectedmethod.index;
                    var _plan = primaryList[index];

                    // TODO: refactor this to FundingOptionsModel
                    var getPadSplitBalPlan = function getPadSplitBalPlan(currentPlan) {
                        return masterPlanList && masterPlanList.find(function (p) {
                            return p.primaryFs.id === currentPlan.primaryFs.id && p.primaryFs.subtype === 'IACH' && p.secondaryFIs && p.secondaryFIs.length;
                        });
                    };

                    // find iach or pad plan without balance
                    var getIachOrPadPlanWithoutBalance = function getIachOrPadPlanWithoutBalance(currentPlan) {
                        return masterPlanList.find(function (p) {
                            return p.primaryFs.id === currentPlan.primaryFs.id && (checkoutSession.fundingOptions.isIACH(p) || checkoutSession.fundingOptions.isPAD(p)) && !p.secondaryFIs;
                        });
                    };

                    // check if plan is IACH with a balance
                    var isPlanIachWithBalance = function isPlanIachWithBalance(p) {
                        return checkoutSession.fundingOptions.isIACH(p) && p.secondaryFIs && p.secondaryFIs.length;
                    };

                    var isChecked = balanceList.some(function (balance) {
                        return balance.checked;
                    });
                    var planWithSplitBal = getPadSplitBalPlan(_plan);

                    // if balance checkbox is checked make sure the selected plan is correct by looking for a plan with a balance
                    // otherwise if unchecked and selected plan has balance -> find plan without balance
                    if (isChecked) {
                        if (planWithSplitBal) {
                            _plan = planWithSplitBal;
                        }
                    } else if (isPlanIachWithBalance(_plan)) {
                        var planWithIachOrPad = getIachOrPadPlanWithoutBalance(_plan);

                        if (planWithIachOrPad) {
                            _plan = planWithIachOrPad;
                        }
                    }

                    // get plan with serial, built from user selections
                    // TODO(refactor): use $MultiFiPlanFactory.getCheckedBalances()
                    var checkedBalances = [];

                    _squid.$util.forEach(balanceCodes, function (balance, code) {
                        if (balance.checked) {
                            checkedBalances.push(code);
                        }
                    });

                    // use plan with this primaryFs and balance options
                    var fundingsource = serializedPlans[getSerializedPlanId(_plan, checkedBalances)];

                    // if no plan matches the user's selections...
                    if (!fundingsource) {

                        // FUZZY MATCHING x-{

                        var pid = getSerializedPrimary(_plan.primaryFs);
                        var pidForLogger = _plan.primaryFs.id || _plan.primaryFs.type;

                        _logger.$logger.info('checkout_fpti', {
                            primary: pidForLogger,
                            denied: checkedBalances.join()
                        });

                        // (perhaps only one of the selected balances is applicable?)

                        // find a plan with each individual balance
                        checkedBalances.some(function (code) {
                            // match plan with this serial combination
                            fundingsource = serializedPlans[pid + code];
                            return fundingsource;
                        });

                        // flag that one of the checked balances was unusable
                        if (fundingsource) {
                            _logger.$logger.info('checkout_fpti', {
                                primary: pidForLogger,
                                denied: checkedBalances.join()
                            });
                        }

                        // if no plan yet...
                        // (perhaps the plan doesn't have any balance combination?)
                        if (!fundingsource) {
                            // get the plan with just this primaryFs
                            fundingsource = serializedPlans[pid];
                            // if we now have a plan...
                            if (fundingsource) {
                                _logger.$logger.info('checkout_fpti', {
                                    primary: pidForLogger,
                                    denied: checkedBalances.join()
                                });
                            }
                        }

                        // if still no plan...
                        // (at this point, the plan requires a specific balance combination)
                        if (!fundingsource) {
                            var serializedPlanKeys = Object.keys(serializedPlans);

                            // use the first plan that begins with this primary id
                            fundingsource = serializedPlans[serializedPlanKeys[_squid.$util.findIndex(serializedPlanKeys, function (serial) {
                                return serial.indexOf(pid) === 0;
                            })]];

                            _logger.$logger.info('checkout_fpti', {
                                primary: pidForLogger,
                                forced: balanceList.map(function (balance) {
                                    return balance.code;
                                }).join()
                            });
                        }
                    }
                    // use of the matched plan
                    planId = fundingsource.planId;
                }

                if (_this.isBillingNoPurchase && checkoutSession.getSelectedStickyInstrument() && checkoutSession.getSelectedStickyInstrument().instrument_id !== planId) {
                    return checkoutSession.action('setStickyFI', {
                        data: {
                            instrument_id: planId
                        },
                        success: function success(result) {
                            checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['paymentMethod.paymentMethodUpdated']
                            };
                            return result;
                        },
                        DEFAULT: function DEFAULT() {
                            // Error message for failures
                            _uiRouter.$state.go('checkout.review');
                        }
                    });
                } else if (!_this.isBillingNoPurchase && checkoutSession.get('plan.sources')[0].id !== planId) {

                    return checkoutSession.fundingOptions.action('select', {
                        data: {
                            planId: planId
                        },
                        success: function success(result) {
                            checkoutSession.populate(result);
                            return result;
                        },
                        contingencies: {
                            NEED_AUTHENTICATED_CARD: function NEED_AUTHENTICATED_CARD(name, result) {
                                // Route to the Confirm Upop page. When finished, use the default handlers to return to the review page
                                if (result && result.resolution) {
                                    var card = result.resolution.data;

                                    if (card.fundingId && card.fi && card.fi.type) {
                                        _this.cardModel = new _index.$AddCardModel();
                                        _this.cardModel.id = card.fundingId;
                                        _this.cardModel.card = new _index.$CardModel({
                                            number: 'xxxx-xxxx-xxxx-' + card.fi.number,
                                            type: card.fi.type.toUpperCase(),
                                            productType: card.fi.productType
                                        });
                                    }
                                }

                                // Reject to break out of the promise chain
                                _uiRouter.$state.go('.confirmUpop');
                                return _squid.$promise.shortCircuit();
                            },

                            DEFAULT: function DEFAULT() {
                                // Error message for failures
                                _uiRouter.$state.go('checkout.review');
                            }
                        }
                    });
                } else {
                    return _squid.$promise.resolve();
                }
            };

            this['continue'] = function (evt) {
                return updateFS().then(function (result) {
                    // clear (any) existing message(s)
                    checkoutSession.message = '';

                    // Decide routing after update
                    if (result) {
                        // Update the installments to support the user selecting a card that does not support installments.
                        _this.models.checkoutSession.installments = result.installments;
                    }

                    // If paypal credit, check for installments and redirect if needed
                    if ((_this.models.checkoutSession.get('plan.paypal_credit') || _this.selectedmethod.index === 'applyForPPCRadio') && _this.models.checkoutSession.creditInstallmentOffer) {
                        var token = _this.props.token;
                        var installments = _checkout.$InstallmentOptionsModel.instance(token);
                        var data = {
                            isMemberCredit: true
                        };

                        return (0, _squid.$populate)(data, {
                            payee: _this.models.checkoutPayeeModel,
                            checkoutCart: _checkout.$CheckoutCartModel.instance(token),
                            checkoutAppData: _this.models.checkoutAppData
                        }).then(function () {
                            return installments.save({
                                cache: true, // Cache between here and $ChoiceEligibilityModel
                                data: data,
                                success: function success(installmentResult) {
                                    var offers = installmentResult.installments && installmentResult.installments[0];
                                    var hasInstallments = offers && offers.installment_options && offers.installment_options.length;

                                    return hasInstallments;
                                },
                                contingencies: {
                                    DEFAULT: function DEFAULT() {
                                        // Assume is eligible if contingency
                                        return false;
                                    }
                                },
                                error: function error() {
                                    return false;
                                }
                            });
                        }).then(function (hasInstallments) {
                            if (hasInstallments) {
                                return _uiRouter.$state.go('checkout.chooseCreditOffer');
                            } else if (_this.selectedmethod.index === 'applyForPPCRadio') {
                                return _uiRouter.$state.go('checkout.redirectToCape', {}, { location: false });
                            } else {
                                return _uiRouter.$state.go('checkout.review');
                            }
                        });
                    } else {
                        return _uiRouter.$state.go('checkout.review');
                    }
                });
            };
        }
    },
    controller: ['$scope', function ($scope) {
        var _this2 = this;

        _angular.$rootScope.showFiSelectPage = true;
        $scope.installment = $scope.installment || {};
        $scope.installment.showBanner = false;
        $scope.installment.showCYCO = false;
        $scope.installment.showCreditExample = false;
        $scope.showPPCAcquisitionRadioButton = function () {
            return $scope.installment && $scope.installment.showPPCAcquisitionRadioButton;
        };
        $scope.continueButtonText = function () {
            if (_this2.selectedmethod && _this2.selectedmethod.index === 'applyForPPCRadio') {
                return _squid.$locale.content.get('applyForBml.bmlApplyHeadline');
            } else {
                return _squid.$locale.content.get('common.continuetext');
            }
        };
        $scope.showCreditPlacement = function (plan) {
            return plan && !plan.primaryFs.isPinlessDebit && plan.primaryFs.name === 'BILL_ME_LATER';
        };

        var placeholderExperimentName = 'xo_hermes_ppc_banner_placeholder';
        var placeholderTreatmentName = 'xo_hermes_ppc_banner_placeholder_treatment';
        $scope.isPlaceholderTreatment = false;
        (0, _squid.$pxp)(placeholderExperimentName, {}, placeholderTreatmentName, false, true).then(function (result) {
            var _$logger$info;

            $scope.isPlaceholderTreatment = result && result.treatment_name === placeholderTreatmentName || false;
            _logger.$logger.info('checkout_fpti', (_$logger$info = {}, _$logger$info[placeholderExperimentName] = result && result.treatment_name, _$logger$info));
        });
    }]
});

angular.value("$xoSelectFiComponent", $xoSelectFiComponent);
_squid.$Component;

_squid.$renderContent;

_squid.$populate;

_squid.$config;

_squid.$feature;

_squid.$integration;

_squid.formatNameInformal;

_squid.$util;

_squid.$locale;

_squid.$promise;

_squid.$pxp;

_angular.noop;

_angular.$rootScope;

_uiRouter.$state;

_logger.$logger;

_auth.$AuthModel;

_checkout.$CheckoutSessionModel;

_checkout.$InstallmentOptionsModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_choice.$ChoiceEligibility;

_index.$AddCardModel;

_index.$CardModel;

_factory.$BalanceFactory;

_cardartInstrument.$CardArtInstrument;

/***/ }),

/***/ "./pages/xo-select-fi/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$BalanceFactory', function () {
    // initial choiceBalanceState checkbox is unselected
    var state = {
        checkbox: undefined
    };

    var get = function get() {
        return state;
    };

    var set = function set(data) {
        return _squid.$util.extend(state, data);
    };

    var getPadAndCheckboxStatus = function getPadAndCheckboxStatus() {
        var balanceList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var planList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        var isChecked = balanceList.some(function (balance) {
            return balance.checked;
        });
        var hasPad = planList.some(function (plan) {
            return plan.primaryFs.subtype === 'PAD';
        });

        return {
            isChecked: isChecked,
            hasPad: hasPad
        };
    };

    return {
        get: get,
        set: set,
        getPadAndCheckboxStatus: getPadAndCheckboxStatus
    };
});

_squid.$util;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-select-fi", "pages/xo-select-fi/factory.js"))

/***/ }),

/***/ "./pages/xo-select-fi/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SelectFiRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/route.js");

var _directive = __webpack_require__("./pages/xo-select-fi/directive.js");

var $SelectFiRoute = exports.$SelectFiRoute = _squid.$ComponentRoute.extend('$SelectFiRoute', {
    path: 'selectFi',
    directive: _directive.$xoSelectFiComponent,
    titleContent: 'memberReview.selectFi',
    trackingData: {
        fptiState: 'choose_FI_interstitial',
        buzname: {
            'fullpage': {
                'pagename': '%::select-fi',
                'pagename2': '%::select-fi:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    children: [{
        name: '$xoConfirmUpopRoute',
        props: function props() {
            return {
                token: this.props.token,
                cardmodel: this.cardModel
            };
        },

        lazyRoute: 'xo-wallet-components/src/confirm-upop/route',
        slug: 'confirmUpop'
    }]
}); /* dynamic-import */

angular.value("$SelectFiRoute", $SelectFiRoute);
_squid.$ComponentRoute;

_directive.$xoSelectFiComponent;

/***/ }),

/***/ "./pages/xo-select-fi/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-select-fi/template.html":
/***/ (function(module, exports) {

module.exports = "<section id='xoSelectFi' class=\"review\" content tabindex=-1 role=\"presentation\">\n    <xo-title title-txt=\"{{content('memberReview.memberReviewTitle')}}\" class=\"accessAid\"></xo-title>\n\n    <div class=\"row-fluid justMember\">\n        <div class=\"span14 trayInner reviewSections\">\n            <xo-banner ng-if=\"personalizedBanner.show && !isMessengerBAIntegration\">\n                <p class=\"userEmail\" id=\"reviewUserInfo\">\n                    {{ content('memberReview.loggedInWithOneTouch', {userName: formattedNameInformal, lastName: models.auth.last_name, firstName: models.auth.first_name}) }}\n                    <span ng-if=\"showNotYou\">\n                        <xo-not-you></xo-not-you>\n                    </span>\n                </p>\n            </xo-banner>\n            <xo-message message=\"models.checkoutSession.message\"></xo-message>\n            <div ng-if=\"!personalizedBanner.show && !isMessengerBAIntegration\">\n                <p class=\"userEmail\" id=\"reviewUserInfo\">\n                    {{ content('creditcard.hi', {userName: formattedNameInformal}) }}\n                    <span ng-if=\"showNotYou\">\n                        <xo-not-you></xo-not-you>\n                    </span>\n                </p>\n            </div>\n\n            <div class=\"reviews reviews_first\">\n                <div class=\"paywith asideView\" content>\n                    <div class=\"trayInner trayInnerDefault multipleFi\">\n                        <div class=\"\">\n                            <h4 class=\"noBottom paymentsHeader alpha\">\n                                {{ content('memberReview.selectFi') }}\n                            </h4>\n                            <div\n                                class=\"split_bal_option\"\n                                ng-if=\"balanceList.length\">\n                                <div\n                                    class=\"sCheckbox checkbox\"\n                                    ng-repeat=\"balance in balanceList track by $index\"\n                                    ng-class=\"{disabled: !balance.enabled}\">\n                                    <input\n                                        ng-if=\"balance.fake\"\n                                        type=\"checkbox\"\n                                        disabled=\"disabled\"\n                                        checked=\"checked\">\n                                    <input\n                                        ng-if=\"!balance.fake\"\n                                        id=\"bal_{{balance.code}}\"\n                                        data-test-id=\"balanceCheckBox\"\n                                        type=\"checkbox\"\n                                        ng-model=\"balance.checked\"\n                                        ng-disabled=\"!balance.enabled\"\n                                        value=\"{{balance.code}}\"\n                                        ng-change=\"capUserIntent(balance.code, balance.checked)\">\n                                    <label\n                                        for=\"bal_{{balance.code}}\"\n                                        class=\"choice-split-balance\"\n                                        ng-class=\"{disabled: !balance.enabled}\"\n                                        bind-html-compile=\"htmlContent('memberReview.useBalanceLabel', { amt: balance.amount })\">\n                                    </label>\n                                </div>\n                            </div>\n\n                            <div ng-if=\"displayPadMessage\">\n                                <span class=\"padWarningMessage\">{{ content('memberReview.padWarningMsg') }}</span>\n                            </div>\n\n                            <ul class=\"charges\">\n                                <!--List of Plans-->\n                                <li role=\"presentation\" class=\"fundingsource\" ng-if=\"!isBillingNoPurchase\" ng-repeat=\"plan in primaryList track by $index\">\n                                    <experience flag='cardart'>\n                                        <div class=\"row-fluid radioButton fsPanelRadioWrapper\">\n                                            <input\n                                                type=\"radio\"\n                                                id=\"{{plan.planId}}\"\n                                                data-test-id=\"selectFIRadioButton\"\n                                                name=\"selectedFI\"\n                                                ng-value=\"$index\"\n                                                ng-model=\"selectedmethod.index\"\n                                                ng-change=\"updateBalances($index, plan)\"\n                                            />\n\n                                            <label class=\"noBottom\" for=\"{{plan.planId}}\">\n                                                <div class=\"positionDecoupler\">\n                                                    <xo-fi-panel fi=\"plan.primaryFs\" plan=\"plan\"\n                                                        show-all-currency-codes=\"\n                                                            plan.primaryFs.name === 'BALANCE' &&\n                                                            plan.secondaryFIs[0].name === 'BALANCE' &&\n                                                            isMultipleBalance\"\n                                                        show-currency-code=\"plan.primaryFs.name === 'BALANCE' && isMultipleBalance\"\n                                                    >\n                                                        <div ng-if=\"!isBilling && plan.primaryFs.isPreferred && preferredFiVariant && plan.primaryFs.subtype !== 'PAD'\">\n                                                            <span class=\"preferredLabel\">{{ content('memberReview.preferred') }}</span>\n                                                        </div>\n                                                        <div class=\"fsSubdetails\">\n                                                            <div ng-if=\"plan.primaryFs.subtype === 'ECHECK'\" class=\"disclaimer\">\n                                                                {{ content('paymentMethod.eCheckDescription') }}\n                                                            </div>\n                                                            <div ng-if=\"showCreditPlacement(plan)\">\n                                                                <xo-offer token=\"token\" promotion=\"promotion\"\n                                                                bmlaction=\"bmlaction\" installment=\"installment\"\n                                                                selectedmethod=\"selectedmethod\" reusetext=\"true\">\n                                                                </xo-offer>\n                                                            </div>\n                                                        </div>\n                                                    </xo-fi-panel>\n                                                </div>\n                                            </label>\n                                        </div>\n                                    </experience>\n\n                                    <experience flag='!cardart'>\n                                        <div class=\"row-fluid radioButton\">\n                                            <input\n                                                type=\"radio\"\n                                                id=\"{{plan.planId}}\"\n                                                data-test-id=\"selectFIRadioButton\"\n                                                name=\"selectedFI\"\n                                                ng-value=\"$index\"\n                                                ng-model=\"selectedmethod.index\"\n                                                ng-change=\"updateBalances($index)\"\n                                            />\n\n                                            <label class=\"noBottom multiFiLabelContainer\" for=\"{{plan.planId}}\">\n                                                <div ng-class=\"{singleInstrumentContainer: !plan.secondaryFIs}\" class='fiContainer'>\n                                                    <span class=\"fsIcon pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"plan.primaryFs.isPinlessDebit\"></span>\n                                                    <span class=\"fsIcon\" ng-class=\"[plan.primaryFs.type, plan.primaryFs.name]\" ng-if=\"!plan.primaryFs.isPinlessDebit\"></span>\n                                                    <div class=\"fsdetails\" ng-class=\"[plan.primaryFs.type]\">\n                                                        <div ng-switch=\"plan.primaryFs.subtype\">\n                                                            <div class=\"fundingContainerPAD\" ng-switch-when=\"PAD\">\n                                                                <div ng-if=\"!padToggleFeature.enabled\"><span class=\"subtype\">{{content('fundingInstruments.pad')}}</span></div>\n                                                                <span class=\"name\">{{content('fsMappings.'+plan.primaryFs.name) || plan.primaryFs.name}} </span>\n                                                                <span class=\"lastdigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}</span>\n                                                                <div class=\"iachMeftLabel\" ng-if=\"isCountryDE\">{{content('fundingInstruments.iach')}}</div>\n                                                            </div>\n\n                                                            <div ng-switch-default>\n                                                                <span class=\"fsName\" ng-if=\"plan.primaryFs.isPinlessDebit\">{{content('fsMappings.PINLESSDEBIT')}}</span>\n                                                                <span class=\"fsName\" ng-if=\"!plan.primaryFs.isPinlessDebit\">{{content('fsMappings.'+plan.primaryFs.name) || (plan.primaryFs.name)}} &rlm;</span>\n                                                                <span ng-if=\"plan.primaryFs.name === 'BALANCE' && isMultipleBalance\">({{plan.currencies}})</span>\n                                                                <span class=\"lastdigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}</span>\n                                                                <div class=\"iachMeftLabel\" ng-if=\"isCountryDE  && plan.primaryFs.subtype === 'MEFT'\">{{content('fundingInstruments.meft')}}</div>\n                                                                <div class=\"iachMeftLabel\" ng-if=\"isCountryDE && plan.primaryFs.subtype === 'IACH'\">{{content('fundingInstruments.iach')}}</div>\n                                                            </div>\n\n                                                        </div>\n                                                        <div ng-if=\"showPreferredLabel(plan)\">\n                                                            <span class=\"preferredLabel\">{{ content('memberReview.preferred') }}</span>\n                                                        </div>\n                                                        <div class=\"padLabel\" ng-if=\"(plan.primaryFs.subtype === 'PAD' || plan.primaryFs.padPlanId) && padToggleFeature.enabled && displayPadLabel\">\n                                                            <span>{{ content('memberReview.padLabel_2') }}</span>\n                                                        </div>\n                                                    </div>\n                                                    <div ng-if=\"showCreditPlacement(plan)\">\n                                                        <xo-offer token=\"token\" promotion=\"promotion\"\n                                                        bmlaction=\"bmlaction\" installment=\"installment\"\n                                                        selectedmethod=\"selectedmethod\" reusetext=\"true\">\n                                                        </xo-offer>\n                                                    </div>\n                                                </div>\n                                            </label>\n                                        </div>\n                                        <div class=\"fsSubdetails\">\n                                            <div ng-if=\"plan.primaryFs.subtype === 'ECHECK'\" class=\"disclaimer\">\n                                                {{ content('paymentMethod.eCheckDescription') }}\n                                            </div>\n                                        </div>\n                                    </experience>\n                                </li>\n                                <li role=\"presentation\" class=\"fundingsource\" ng-if=\"isBillingNoPurchase\" ng-repeat=\"stickyFI in getBAPlans() track by $index\">\n                                    <experience flag=\"!cardart\">\n                                        <div class=\"row-fluid radioButton\">\n                                            <input\n                                                type=\"radio\"\n                                                id=\"{{stickyFI.instrument_id}}\"\n                                                data-test-id=\"selectFIRadioButton\"\n                                                name=\"selectedFI\"\n                                                ng-value=\"stickyFI.instrument_id\"\n                                                ng-model=\"selectedmethod.planId\"\n                                            />\n                                            <label class=\"noBottom multiFiLabelContainer\" for=\"{{stickyFI.instrument_id}}\">\n                                                <div class=\"fiContainer\">\n                                                    <span class=\"fsIcon\" ng-class=\"[stickyFI.type, stickyFI.name, stickyFI.card_type]\"></span>\n                                                    <div class=\"fsdetails\">\n                                                        <span ng-switch=\"fundingsource.subtype\">\n                                                            <span ng-switch-default>\n                                                                <span class=\"name\">{{content('fsMappings.'+ stickyFI.name) || stickyFI.name}}</span>\n                                                                <span class=\"lastdigits\" ng-if=\"stickyFI.last4\">x-{{stickyFI.last4}}</span>\n                                                            </span>\n                                                        </span>\n                                                    </div>\n                                                    <div ng-if=\"stickyFI.type === 'BILL_ME_LATER'\">\n                                                        <xo-offer token=\"token\" promotion=\"promotion\"\n                                                                  bmlaction=\"bmlaction\" installment=\"installment\"\n                                                                  selectedmethod=\"selectedmethod\" reusetext=\"true\">\n                                                        </xo-offer>\n                                                    </div>\n                                                </div>\n                                            </label>\n                                        </div>\n                                    </experience>\n                                    <experience flag=\"cardart\">\n                                        <div class=\"row-fluid radioButton\">\n                                            <input\n                                                type=\"radio\"\n                                                id=\"{{stickyFI.instrument_id}}\"\n                                                data-test-id=\"selectFIRadioButton\"\n                                                name=\"selectedFI\"\n                                                ng-value=\"stickyFI.instrument_id\"\n                                                ng-model=\"selectedmethod.planId\"\n                                            />\n\n                                            <label class=\"noBottom\" for=\"{{stickyFI.instrument_id}}\">\n                                                <div class=\"positionDecoupler\">\n                                                    <xo-fi-panel fi=\"stickyFI\" plan=\"plan\">\n                                                        <div class=\"fsSubdetails\">\n                                                            <div ng-if=\"stickyFI.type === 'BILL_ME_LATER'\">\n                                                                <xo-offer token=\"token\" promotion=\"promotion\"\n                                                                          bmlaction=\"bmlaction\" installment=\"installment\"\n                                                                          selectedmethod=\"selectedmethod\" reusetext=\"true\">\n                                                                </xo-offer>\n                                                            </div>\n                                                        </div>\n                                                    </xo-fi-panel>\n                                                </div>\n                                    </experience>\n                                </li>\n                                <li role=\"presentation\" class=\"fundingsource\" ng-if=\"showPPCAcquisitionRadioButton()\">\n                                    <div class=\"row-fluid radioButton\">\n                                        <input type=\"radio\" id=\"applyForPPCRadio\" name=\"selectedFI\" value=\"applyForPPCRadio\"\n                                               ng-model=\"selectedmethod.index\" />\n                                        <label class=\"noBottom\" for=\"applyForPPCRadio\">\n                                            <xo-offer token=\"token\" promotion=\"promotion\" bmlaction=\"bmlaction\" installment=\"installment\"\n                                                      selectedmethod=\"selectedmethod\" radio=\"true\">\n                                            </xo-offer>\n                                        </label>\n                                    </div>\n                                </li>\n\n                            </ul>\n\n                            <div class=\"multipleFi addCard\" ng-if=\"!isUSGambling() && !addBankAllowed\">\n                                <a track-link=\"choose_FI_interstitial\" ui-sref=\"checkout.pageAddCard.addCardFlow.addCard\" class=\"addCardLink\" role=\"button\" data-test-id=\"addCardLink\">\n                                    <span class=\"plusicon\"></span>\n                                    <p class=\"addOption\">\n                                        <span class=\"name\">{{content(choicePageAddCardContentKey)}}</span>\n                                    </p>\n                                </a>\n                            </div>\n\n                            <div class=\"multipleFi addCard\" ng-if=\"!isUSGambling() && addBankAllowed\">\n                                <a track-link=\"choose_FI_interstitial\" ui-sref=\"checkout.pageAddFi.bank.add\" class=\"addCardLink\" role=\"button\" data-test-id=\"addCardLink\">\n                                    <span class=\"plusicon\"></span>\n                                    <p class=\"addOption\">\n                                        <span class=\"name\">{{ content('common.addNew') }}</span>\n                                    </p>\n                                </a>\n                            </div>\n\n                            <div ng-if=\"creditOffer\" ng-class=\"{ 'PPCOffers': isPlaceholderTreatment }\">\n                                <xo-offer token=\"token\" promotion=\"promotion\" bmlaction=\"bmlaction\"installment=\"installment\"\n                                    selectedmethod=\"selectedmethod\">\n                                </xo-offer>\n                            </div>\n                        </div>\n                    </div>\n                    <div id=\"button\" class=\"buttons reviewButton\">\n                        <button track-submit='choose_FI_interstitial' class=\"btn full confirmButton continueButton\" ng-click=\"continue()\">{{continueButtonText()}}</button>\n                    </div>\n\n                    <xo-credit-example-uk ng-if=\"installment.showCreditExample\"></xo-credit-example-uk>\n\n                </div>\n            </div>\n        </div>\n        <div class=\"span10\">\n            <xo-marketing-offers placement-code=\"'202003'\"\n                                 token=\"token\"\n                                 page-name=\"'HERMES_RYI_PAGE'\"\n                                 title-txt-property=\"propValueObj.propHeader\"\n                                 subtitle-property=\"propValueObj.propVal\"\n                                 background-image= \"propValueObj.propImage\"\n            >\n            </xo-marketing-offers>\n        </div>\n    </div>\n    <div ui-view></div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-sepa/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoSepaPageComponent = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");

var _template = __webpack_require__("./pages/xo-sepa/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSepaPageComponent = exports.$xoSepaPageComponent = _squid.$Component.extend('$xoSepaPageComponent', {
    tag: 'xo-sepa-page',
    template: _template2['default'],

    scope: {
        token: '=?'
    },

    controller: ['$scope', function ($scope) {
        $scope.callbacks = {
            success: function success(sepaModel) {

                (0, _squid.$populate)($scope, {
                    checkoutAppData: _checkout.$CheckoutAppDataModel.instance($scope.token),
                    checkoutSession: _checkout.$CheckoutSessionModel.instance($scope.token)
                }).then(function () {
                    return sepaModel.action('clearSepa', {
                        data: {
                            bank: {
                                id: sepaModel.bankId
                            },
                            token: $scope.token
                        },

                        success: function success() {
                            $scope.checkoutSession.action('authorize', {
                                success: function success() {
                                    // xchild = V4 Incontext Integration. Do not initiate Payment.
                                    if (!window.xchild && $scope.checkoutAppData.doec_on_approve()) {
                                        return _uiRouter.$state.go('checkout.pay');
                                    }
                                    _uiRouter.$state.go('checkout.end');
                                }

                            });
                        }

                    });
                });
            }
        };
        _uiRouter.$state.go('checkout.sepapage.membersepa.sepaAgreement');
    }]

});

angular.value("$xoSepaPageComponent", $xoSepaPageComponent);
_squid.$Component;

_squid.$populate;

_uiRouter.$state;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutSessionModel;

/***/ }),

/***/ "./pages/xo-sepa/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SepaPageRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/member-sepa/route.js");

__webpack_require__("./pages/xo-sepa/directive.js");

var $SepaPageRoute = exports.$SepaPageRoute = _squid.$ComponentRoute.extend('$SepaPageRoute', {
    path: 'sepapage',
    directive: 'xo-sepa-page',
    titleContent: 'DEMemberGuest.sepaTitle',
    query: ['message'],
    trackingData: {
        fptiState: 'membersepa',
        templateName: 'membersepa.dust',
        pageGoal: 'SEPA Review'
    },
    children: [{
        name: '$MemberSepaRoute',
        attributes: {
            token: 'token',
            'parent-callbacks': 'callbacks'
        }
    }]
});

angular.value("$SepaPageRoute", $SepaPageRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-sepa/template.html":
/***/ (function(module, exports) {

module.exports = "<ui-view></ui-view>\n"

/***/ }),

/***/ "./pages/xo-shipping/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoShippingComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

__webpack_require__("../node_modules/xo-member-components/src/select-shipping/directive.js");

var _template = __webpack_require__("./pages/xo-shipping/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoShippingComponent = exports.$xoShippingComponent = _squid.$Component.extend('$xoShippingComponent', {
    tag: 'xo-shipping',
    template: _template2['default'],

    scope: {
        backUri: '=?',
        shippingChangeFeature: '=?'
    },

    controller: ['$scope', function ($scope) {
        $scope.token = _angular.$rootScope.token;

        $scope.onComplete = function (result) {
            _uiRouter.$state.go($scope.backUri || 'checkout.review');
        };
    }]
});

angular.value("$xoShippingComponent", $xoShippingComponent);
_angular.$rootScope;

_squid.$Component;

_uiRouter.$state;

/***/ }),

/***/ "./pages/xo-shipping/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SidebarShippingRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("./pages/xo-shipping/directive.js");

var $SidebarShippingRoute = exports.$SidebarShippingRoute = _squid.$ComponentRoute.extend('$SidebarShippingRoute', {
    path: 'shipping',
    directive: 'xo-shipping',
    titleContent: 'asideHeader.selectShipping',
    trackingData: {
        fptiState: 'select_shipping_address',
        templateName: 'selectShipping.dust',
        pageGoal: 'Select Shipping',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-select-shipping-address',
                'pagename2': '%::fullpage-select-shipping-address:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    }
});

angular.value("$SidebarShippingRoute", $SidebarShippingRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-shipping/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"selectShipping\">\n    <xo-select-shipping done-fn=\"onComplete\" token=\"token\" shipping-change-feature=\"shippingChangeFeature\" back-uri=\"backUri\"></xo-select-shipping>\n</section>\n"

/***/ }),

/***/ "./pages/xo-sidebar-add-bank/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoSidebarAddBankPageComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-validation/dist/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-bank/directive.js");

var _template = __webpack_require__("./pages/xo-sidebar-add-bank/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarAddBankPageComponent = exports.$xoSidebarAddBankPageComponent = _squid.$Component.extend('$xoSidebarAddBankPageComponent', {
    tag: 'xo-sidebar-add-bank-page',
    template: _template2['default'],
    controller: ['$scope', function ($scope) {
        $scope.sidebar = true;
        $scope.token = _angular.$rootScope.token;
        $scope.message = {};
        $scope.callbacks = {
            done: function done() {
                _uiRouter.$state.go('checkout.review');
            }
        };
    }]
});

angular.value("$xoSidebarAddBankPageComponent", $xoSidebarAddBankPageComponent);
_angular.$rootScope;

_squid.$Component;

_uiRouter.$state;

/***/ }),

/***/ "./pages/xo-sidebar-add-bank/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SidebarAddBankRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-bank/route.js");

__webpack_require__("./pages/xo-sidebar-add-bank/directive.js");

var $SidebarAddBankRoute = exports.$SidebarAddBankRoute = _squid.$ComponentRoute.extend('$SidebarAddBankRoute', {
    path: 'sidebarAddBank',
    directive: 'xo-sidebar-add-bank-page',
    titleContent: 'asideHeader.addBank',
    trackingData: {
        templateName: 'tray/addBank.dust',
        pageGoal: 'Add Bank',
        buzname: {
            'fullpage': {
                'pagename': '%::add-bank',
                'pagename2': '%::add-bank:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },
    children: [{
        name: '$AddBankFlowRoute',
        attributes: {
            token: 'token',
            sidebar: 'sidebar',
            'parent-callbacks': 'callbacks'
        }
    }]
});

angular.value("$SidebarAddBankRoute", $SidebarAddBankRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-sidebar-add-bank/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"aside\" id=\"addBank\" content>\n    <ui-view></ui-view>\n</div>\n"

/***/ }),

/***/ "./pages/xo-sidebar-add-card/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoSidebarAddCardPageComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-validation/dist/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/directive.js");

var _template = __webpack_require__("./pages/xo-sidebar-add-card/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarAddCardPageComponent = exports.$xoSidebarAddCardPageComponent = _squid.$Component.extend('$xoSidebarAddCardPageComponent', {
    tag: 'xo-sidebar-add-card-page',
    template: _template2['default'],
    scope: {
        promotion: '=?',
        backUri: '=?',
        doneUri: '=?'
    },
    controller: ['$scope', function ($scope) {
        $scope.billingaddressupdated = {
            value: false
        };
        $scope.sidebar = true;
        $scope.token = _angular.$rootScope.token;
        $scope.message = {};
        $scope.callbacks = {
            finish: function finish() {
                _uiRouter.$state.go($scope.doneUri || 'checkout.review');
            }
        };
    }]
});

angular.value("$xoSidebarAddCardPageComponent", $xoSidebarAddCardPageComponent);
_angular.$rootScope;

_squid.$Component;

_uiRouter.$state;

/***/ }),

/***/ "./pages/xo-sidebar-add-card/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SidebarAddCardRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/route.js");

__webpack_require__("./pages/xo-sidebar-add-card/directive.js");

var $SidebarAddCardRoute = exports.$SidebarAddCardRoute = _squid.$ComponentRoute.extend('$SidebarAddCardRoute', {
    path: 'sidebarAddCard',
    directive: 'xo-sidebar-add-card-page',
    titleContent: 'asideHeader.addCard',
    trackingData: {
        templateName: 'tray/addCard.dust',
        pageGoal: 'Add Card',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-cc',
                'pagename2': '%::fullpage-add-cc:member:hermes:tray',
                'version': 'member:%:tray'
                // More page qualifiers come here...
            } }
    },
    children: [{
        name: '$AddCardFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            sidebar: 'sidebar',
            'back-uri': 'backUri',
            'parent-callbacks': 'callbacks',
            promotion: 'promotion'
        }
    }]
});

angular.value("$SidebarAddCardRoute", $SidebarAddCardRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-sidebar-add-card/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"aside\" id=\"addCard\" content>\n\t<ui-view sidebar=\"sidebar\"></ui-view>\n</div>\n"

/***/ }),

/***/ "./pages/xo-sidebar-add-new/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoSidebarAddNewPageComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _fiMessages = __webpack_require__("../node_modules/xo-models/src/fi/lib/fiMessages.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-validation/dist/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/directive.js");

var _template = __webpack_require__("./pages/xo-sidebar-add-new/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarAddNewPageComponent = exports.$xoSidebarAddNewPageComponent = _squid.$Component.extend('$xoSidebarAddNewPageComponent', {
    tag: 'xo-sidebar-add-new-page',
    template: _template2['default'],
    scope: {},
    controller: ['$scope', function ($scope) {
        $scope.sidebar = true;
        // TODO: refactor controller logic to use lifecycle() methods
        $scope.token = _angular.$rootScope.token;
        $scope.locale = _squid.$locale;
        $scope.hideparenthead = {
            toggle: false
        };
        $scope.callbacks = {
            finish: function finish() {
                return _uiRouter.$state.go('checkout.review');
            },
            done: function done() {
                return _uiRouter.$state.go('checkout.review');
            },
            cancel: function cancel(routeTo) {
                var destination = routeTo || $scope.parentState || '';

                if (destination) {
                    _uiRouter.$state.go(destination);
                }
            }
        };

        // TODO: remove nested $populate() logic to `resolve` and `lifecycle`
        var models = {};

        (0, _squid.$populate)($scope, {
            auth: _auth.$AuthModel.instance(),
            payee: _index.$CheckoutPayeeModel.instance($scope.token)
        }).then(function () {
            (0, _squid.$populate)(models, {
                checkoutSession: _index.$CheckoutSessionModel.instance($scope.token)
            }).then(function () {
                (0, _squid.$pxp)('xo_hermes_addcard_msg', { 'ctx.COUNTRY': $scope.locale.country }, 'xo_hermes_addcard_msg_treatment', false, true).then(function (result) {
                    var message = _fiMessages.$fiMessages.processorDeclinedMsg(models.checkoutSession, false);

                    // If no processor decline, retrieve and display the contingency message
                    if (!message && models.checkoutSession.get('errorData.cause')) {
                        if ($scope.payee.isGambling()) {
                            message = _fiMessages.$fiMessages.getGamblingMsg();
                        } else if (result) {
                            message = _fiMessages.$fiMessages.getAddCardTreatmentMsg(models.checkoutSession);
                        } else {
                            message = _fiMessages.$fiMessages.getAddCardControlMsg(models.checkoutSession);
                        }
                    }

                    if (message) {
                        $scope.pageLevel = $scope.pageLevel || {};
                        $scope.pageLevel.message = {
                            type: message.type,
                            msgs: [message.msg]
                        };
                        if (message.title) {
                            $scope.messagetitle = _squid.$locale.content.get(message.title.key);
                        }
                    }
                });
            });
        });
    }]
});

angular.value("$xoSidebarAddNewPageComponent", $xoSidebarAddNewPageComponent);
_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_squid.$populate;

_squid.$pxp;

_uiRouter.$state;

_auth.$AuthModel;

_index.$CheckoutPayeeModel;

_index.$CheckoutSessionModel;

_fiMessages.$fiMessages;

/***/ }),

/***/ "./pages/xo-sidebar-add-new/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SidebarAddNewRoute = undefined;

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/route.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-bank/route.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-sidebar-add-new/directive.js");

var $SidebarAddNewRoute = exports.$SidebarAddNewRoute = _squid.$ComponentRoute.extend('$SidebarAddNewRoute', {

    path: 'sidebarAddNew',

    directive: _directive.$xoSidebarAddNewPageComponent,

    titleContent: 'common.addNew',

    trackingData: {
        fptiState: 'add_new_de',
        templateName: 'tray/addNew.dust',
        pageGoal: 'Add a new bank or credit card for DE specific use case',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-new',
                'pagename2': '%::fullpage-add-new:member:hermes:tray',
                'version': 'member:%:tray'
            }
        }
    },

    children: [{
        name: '$AddBankFlowRoute',
        attributes: {
            token: 'token',
            sidebar: 'sidebar',
            message: 'message',
            hideparenthead: 'hideparenthead',
            billingaddressupdated: 'billingaddressupdated',
            'parent-callbacks': 'callbacks',
            'page-level': 'pageLevel',
            'show-cancel': false
        }
    }, {
        name: '$AddCardFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            hideparenthead: 'hideparenthead',
            'parent-callbacks': 'callbacks',
            'page-level': 'pageLevel',
            'show-cancel': false
        }
    }]
});

angular.value("$SidebarAddNewRoute", $SidebarAddNewRoute);
_squid.$ComponentRoute;

_directive.$xoSidebarAddNewPageComponent;

/***/ }),

/***/ "./pages/xo-sidebar-add-new/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"aside\" id=\"addBank\" content>\n    <section id=\"sidepageAddCard\">\n\n        <xo-aside-header ng-if=\"!hideparenthead.toggle\"\n                        heading=\"common.addNew\"\n                        hidex=\"true\"\n                        header-left-icon=\"true\"\n                        header-left=\"common.back\"\n                        back-url=\"checkout.review\">\n        </xo-aside-header>\n\n        <div trayInner trayInnerDefault>\n            <xo-message message=\"pageLevel.message\"></xo-message>\n            <div class=\"addFi\">\n                <ul class=\"form-tabs\" id=\"paymentTab\" ng-if=\"!hideparenthead.toggle\">\n                    <li class=\"bank\" ui-sref-active=\"active\">\n                        <a ui-sref=\"checkout.review.sidebar.sidebarAddNew.bank.add\" class=\"bankTab\">{{ content('bank.bank') }}</a>\n                    </li>\n                    <li class=\"card\" ui-sref-active=\"active\">\n                        <a ui-sref=\"checkout.review.sidebar.sidebarAddNew.addCardFlow.addCard\" class=\"cardTab\" for=\"cardTab\">{{ content('bank.card_2') }}</a>\n                    </li>\n                </ul>\n            </div>\n\n            <div class=\"content\">\n                <ui-view></ui-view>\n            </div>\n        </div>\n    </section>\n</div>\n"

/***/ }),

/***/ "./pages/xo-sidebar-add-shipping/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoSidebarAddShippingPageComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

__webpack_require__("../node_modules/xo-member-components/src/select-shipping/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-validation/dist/directive.js");

var _template = __webpack_require__("./pages/xo-sidebar-add-shipping/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarAddShippingPageComponent = exports.$xoSidebarAddShippingPageComponent = _squid.$Component.extend('$xoSidebarAddShippingPageComponent', {
    tag: 'xo-sidebar-add-shipping-page',
    template: _template2['default'],

    controller: ['$scope', function ($scope) {
        $scope.token = _angular.$rootScope.token;
        $scope.sidebar = true;

        $scope.onComplete = function () {
            _uiRouter.$state.go('checkout.review');
        };
    }]
});

angular.value("$xoSidebarAddShippingPageComponent", $xoSidebarAddShippingPageComponent);
_angular.$rootScope;

_squid.$Component;

_uiRouter.$state;

/***/ }),

/***/ "./pages/xo-sidebar-add-shipping/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SidebarAddShippingRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("./pages/xo-sidebar-add-shipping/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/select-shipping/add-shipping/route.js");

var $SidebarAddShippingRoute = exports.$SidebarAddShippingRoute = _squid.$ComponentRoute.extend('$SidebarAddShippingRoute', {

    path: 'sidebarAddShipping',
    directive: 'xo-sidebar-add-shipping-page',
    titleContent: 'addShipping.addAddress',
    trackingData: {
        templateName: 'tray/addShippingAddress.dust',
        pageGoal: 'Add Shipping',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-shipping-address',
                'pagename2': '%::fullpage-add-shipping-address:member:hermes:tray',
                'version': 'member:%:tray'
                // More page qualifiers come here...
            } }
    },
    children: [{
        name: '$AddShippingRoute',
        attributes: {
            token: 'token'
        },
        message: 'message',
        sidebar: 'sidebar',
        'parent-callbacks': 'callbacks'
    }]
});

angular.value("$SidebarAddShippingRoute", $SidebarAddShippingRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-sidebar-add-shipping/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"aside\" id=\"addShipping\">\n\n</div>\n"

/***/ }),

/***/ "./pages/xo-sidebar-currency-conversion/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoSidebarCurrencyConversionPageComponent = undefined;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion/directive.js");

var _template = __webpack_require__("./pages/xo-sidebar-currency-conversion/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarCurrencyConversionPageComponent = exports.$xoSidebarCurrencyConversionPageComponent = _squid.$Component.extend('$xoSidebarCurrencyConversionPageComponent', {
    tag: 'xo-sidebar-currency-conversion-page',
    template: _template2['default'],
    controller: ['$scope', function ($scope) {
        $scope.token = _angular.$rootScope.token;
        $scope.onComplete = function () {
            _uiRouter.$state.go('checkout.review');
        };
        $scope.$emit('populated');
    }]
});

angular.value("$xoSidebarCurrencyConversionPageComponent", $xoSidebarCurrencyConversionPageComponent);
_uiRouter.$state;

_squid.$Component;

_angular.$rootScope;

/***/ }),

/***/ "./pages/xo-sidebar-currency-conversion/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SidebarCurrencyConversionRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("./pages/xo-sidebar-currency-conversion/directive.js");

var $SidebarCurrencyConversionRoute = exports.$SidebarCurrencyConversionRoute = _squid.$ComponentRoute.extend('$SidebarCurrencyConversionRoute', {
    path: 'currencyConversion',
    directive: 'xo-sidebar-currency-conversion-page',
    titleContent: 'asideHeader.currencyConversion',
    trackingData: {
        fptiState: 'currency_conversion',
        templateName: 'tray/currencyOptions.dust',
        pageGoal: 'Currency Conversion',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-currency-options',
                'pagename2': '%::fullpage-currency-options::hermes:',
                'version': ':%:'
                // More page qualifiers come here...
            } }
    },
    children: []
});

angular.value("$SidebarCurrencyConversionRoute", $SidebarCurrencyConversionRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-sidebar-currency-conversion/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"aside\" id=\"currencyConversion\">\n    <xo-aside-header heading='asideHeader.currencyConversion'></xo-aside-header>\n    <div class=\"currencyConversion asideContent container\" xo-tray-height>\n       <xo-currency-conversion token=\"token\" done-fn=\"onComplete\"></xo-currency-conversion>\n    </div>\n</div>\n"

/***/ }),

/***/ "./pages/xo-sidebar-installment-options/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoSidebarInstallmentOptionsPageComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/installment-options/directive.js");

var _template = __webpack_require__("./pages/xo-sidebar-installment-options/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarInstallmentOptionsPageComponent = exports.$xoSidebarInstallmentOptionsPageComponent = _squid.$Component.extend('$xoSidebarInstallmentOptionsPageComponent', {
    tag: 'xo-sidebar-installment-options-page',
    template: _template2['default'],
    controller: ['$scope', function ($scope) {
        $scope.token = _angular.$rootScope.token;
        $scope.onComplete = function () {
            _uiRouter.$state.go('checkout.review');
        };
        $scope.$emit('populated');
    }]
});

angular.value("$xoSidebarInstallmentOptionsPageComponent", $xoSidebarInstallmentOptionsPageComponent);
_angular.$rootScope;

_squid.$Component;

_uiRouter.$state;

/***/ }),

/***/ "./pages/xo-sidebar-installment-options/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SidebarInstallmentOptionsRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("./pages/xo-sidebar-installment-options/directive.js");

var $SidebarInstallmentOptionsRoute = exports.$SidebarInstallmentOptionsRoute = _squid.$ComponentRoute.extend('$SidebarInstallmentOptionsRoute', {
    path: 'installmentOptions',
    directive: 'xo-sidebar-installment-options-page',
    titleContent: 'asideHeader.installmentsPanel',
    trackingData: {
        fptiState: 'installment_options',
        templateName: 'tray/installmentOptions.dust',
        pageGoal: 'Installment Options',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-installment-options',
                'pagename2': '%::fullpage-installment-options::hermes:',
                'version': ':%:'
            }
        }
    },
    children: []
});

angular.value("$SidebarInstallmentOptionsRoute", $SidebarInstallmentOptionsRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-sidebar-installment-options/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"aside\" id=\"installmentOptions\">\n    <xo-aside-header heading='asideHeader.installmentsPanel'></xo-aside-header>\n    <xo-installment-options token=\"token\" done-fn=\"onComplete\"></xo-installment-options>\n</div>\n"

/***/ }),

/***/ "./pages/xo-sidebar-manage-wallet/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _choice = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _factory = __webpack_require__("../node_modules/xo-ui-components/src/expired-fi-panel/factory.js");

var _fiMeta = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _fiMeta2 = _interopRequireDefault(_fiMeta);

__webpack_require__("../node_modules/xo-tray-height/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/popup/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/experience/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/fi-panel/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/cardicon/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/expired-fi-panel/directive.js");

var _cardartInstrument = __webpack_require__("./pages/services/cardart-instrument/index.js");

var _experiments = __webpack_require__("../node_modules/xo-models/src/experiments/index.js");

var Experiments = _interopRequireWildcard(_experiments);

var _template = __webpack_require__("./pages/xo-sidebar-manage-wallet/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-sidebar-manage-wallet/styles.less");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$SidebarManageWalletDirective', {
    tag: 'xo-manage-wallet',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                variant: _choice.$ChoiceEligibility.instance().getVariant(this.props.token),
                cart: _index2.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                fiMeta: _fiMeta2['default'].instance(this.props.token).fetch()['catch'](_angular.noop)
            };
        },
        fiSource: function fiSource(resolvers) {
            return resolvers.models.then(function (models) {
                return {
                    all: _factory.$ExpiredFiPanelFactory.getAllInstruments(models),
                    isCardArtExp: _cardartInstrument.$CardArtInstrument.isCardArtEnable(models.fiMeta),
                    isBillingNoPurchase: models.cart && models.cart.isBillingNoPurchase()
                };
            });
        },
        padToggleFeature: function padToggleFeature(resolvers) {
            return resolvers.models.then(function (models) {
                var enabled = void 0;

                if (models.checkoutSession.fundingOptions.isPadToggleApplicable()) {
                    enabled = Experiments.padToggleFeatureSupported();
                } else {
                    // if pad not availabe
                    enabled = false;
                }
                return { enabled: enabled };
            });
        }
    },
    actions: {
        toggleInfoMsg: function toggleInfoMsg($index) {
            this.disallowedIndex = this.disallowedIndex === $index ? -1 : $index;
        },
        confirm: function confirm($index) {
            this.selectedIndex = $index;
            this.deleteCard = true;
        },
        deleteFS: function deleteFS(fundingsource) {
            var _this = this;

            /**
             * Call walletfiserv to delete selected card and call Symphony's notifyChangeFundingInstruments api
             * to get back updated funding options.
             */
            this.deleteCardModel = new _index.$DeleteCardModel({
                id: fundingsource.id
            });
            this.deleteCardModel.save({
                data: this.deleteCardModel,

                contingencies: {
                    DELETE_CARD_CONTINGENCY: function DELETE_CARD_CONTINGENCY() {
                        _this.handleSingleContingency('creditcard.errorDeleteCard');
                        return;
                    }
                },

                error: function error() {
                    _this.handleSingleContingency('creditcard.errorDeleteCard');
                    return;
                },

                /**
                 * Call notifyChangeFundingInstruments to get updated funding options from checkout session
                 * During this call if any error or contingencies return back, just remove the deleted FI from checkout
                 * session as its already deleted successfully
                 */
                success: function success() {
                    _this.models.checkoutSession.fundingOptions.action('notifyChange', {
                        resultModel: _this.models.checkoutSession,

                        data: {
                            planId: fundingsource.id,
                            operation: 'REMOVED'
                        },
                        success: function success() {
                            _logger.$logger.info('manage_wallet: deleted FI - 1', fundingsource.id);
                            _this.selectedIndex = -1;
                            _this.disallowedIndex = -1;
                            return _factory.$ExpiredFiPanelFactory.getAllInstruments(_this.models).then(function (result) {

                                // Showing all plans but not pad plans for PAD2.0
                                if (_this.padToggleFeature.enabled) {
                                    _this.instruments = result.filter(function (plan) {
                                        return plan.subtype !== 'PAD';
                                    });
                                } else {
                                    _this.instruments = result;
                                }
                            });
                        },
                        contingencies: {
                            NOTIFY_FUNDING_CHANGE_CONTINGENCY: function NOTIFY_FUNDING_CHANGE_CONTINGENCY() {
                                return _this.removeFIFromCheckoutSession(fundingsource);
                            }
                        },
                        error: function error() {
                            return _this.removeFIFromCheckoutSession(fundingsource);
                        }
                    });
                }
            });
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this2 = this;

            this.handleSingleContingency = function (errorKey) {
                var messages = [];

                messages.push(_squid.$locale.content.get(errorKey));
                _this2.message = {
                    msgs: messages,
                    type: 'error'
                };
                _this2.isSystemError = true;
                _this2.selectedIndex = -1;
                _this2.disallowedIndex = -1;
            };

            this.removeFIFromCheckoutSession = function (fundingsource) {
                return _factory.$ExpiredFiPanelFactory.getAllInstruments(_this2.models).then(function (result) {
                    _this2.instruments = _squid.$util.filter(result, function (instrument) {
                        return instrument.id !== fundingsource.id;
                    });
                });
            };

            this.editDisallowedMsg = function (fi) {
                return _this2.models.fiMeta.getEditDisallowedContentKey(fi);
            };
        },
        populate: function populate() {
            var _models = this.models,
                checkoutSession = _models.checkoutSession,
                variant = _models.variant;
            var _fiSource = this.fiSource,
                all = _fiSource.all,
                isCardArtExp = _fiSource.isCardArtExp,
                isBillingNoPurchase = _fiSource.isBillingNoPurchase;

            var multipleFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.multipleFi || [];

            this.showMultipleFI = multipleFiVariants.indexOf(variant) > -1;
            this.message = checkoutSession && checkoutSession.message;
            this.isSystemError = this.message && this.message.type === 'error';
            this.models.checkoutSession.message = null;

            // Showing all plans but not pad plans for PAD2.0
            if (this.padToggleFeature.enabled) {
                this.instruments = all.filter(function (plan) {
                    return plan.subtype !== 'PAD';
                });
            } else {
                this.instruments = all;
            }

            /**
             * Log our cardart instrumentation.
             * See $CardArtInstrument.createPayload() for detailed implementation
             */
            if (isCardArtExp) {
                _logger.$logger.info('checkout_fpti', _extends({
                    from: 'MANAGE_WALLET',
                    to: 'prepare_manage_wallet'
                }, _cardartInstrument.$CardArtInstrument.createPayload({
                    checkoutSession: checkoutSession,
                    isBillingNoPurchase: isBillingNoPurchase
                })));
            }
        }
    }
});


_angular.noop;

_squid.$Component;

_squid.$locale;

_squid.$config;

_squid.$util;

_logger.$logger;

_choice.$ChoiceEligibility;

_index.$DeleteCardModel;

_index2.$CheckoutSessionModel;

_index2.$CheckoutCartModel;

_factory.$ExpiredFiPanelFactory;

_cardartInstrument.$CardArtInstrument;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-sidebar-manage-wallet/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SidebarManageWalletRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-sidebar-manage-wallet/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $SidebarManageWalletRoute = exports.$SidebarManageWalletRoute = _squid.$Route.extend('$SidebarManageWalletRoute', {
    path: 'sidebarManageWallet',
    directive: _directive2['default'],
    trackingData: {
        fptiState: 'manage_wallet',
        templateName: 'tray/manageWallet',
        pageGoal: 'Manage Instruments',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-manage-wallet',
                'pagename2': '%::fullpage-manage-wallet:member:hermes:tray',
                'version': 'member:%:tray'
            }
        }
    },
    loginRequired: true,
    children: []
});

angular.value("$SidebarManageWalletRoute", $SidebarManageWalletRoute);
_squid.$Route;

/***/ }),

/***/ "./pages/xo-sidebar-manage-wallet/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-sidebar-manage-wallet/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-aside-header\n    ng-if=\"!showMultipleFI\"\n    heading='asideHeader.manageWallet'\n    back-url='checkout.review.sidebar.wallet'>\n</xo-aside-header>\n\n<xo-aside-header\n    ng-if=\"showMultipleFI\"\n    heading='asideHeader.manageWallet'>\n</xo-aside-header>\n\n<div class=\"asideContent fundingCards\" id=\"manageFunding\" content xo-tray-height>\n    <xo-message message=\"message\"></xo-message>\n\n    <div class=\"allCards\">\n        <ul class=\"allFundingInstrumentsList clearfix\" select-box=\"instruments track by $index\" select-allow-tab-escape>\n            <li role=\"presentation\" class=\"fundingsource item\" ng-class=\"{'disallowed':fundingsource.declineReason}\" ng-repeat=\"fundingsource in instruments track by $index\" ng-if=\"!isBillingNoPurchase\">\n                <div ng-if=\"fundingsource.declineReason\" ng-class=\"{'disabled':fundingsource.declineReason}\"></div>\n                <div class=\"source\" ng-class=\"{showMsg: ($index == disallowedIndex), noInfoMsg: !editDisallowedMsg(fundingsource)}\">\n                    <!-- cardart experience -->\n                    <experience flag=\"cardart\">\n                        <div class=\"fsPanelRow\" ng-class=\"{'rowMask': editDisallowedMsg(fundingsource) || fundingsource.declineReason, slide: ($index == selectedIndex && deleteCard)}\">\n                            <xo-fi-panel fi=\"fundingsource\">\n                                <xo-expired-fi-panel token=\"token\" fi=\"fundingsource\"></xo-expired-fi-panel>\n                                <div class=\"manageLinks\" ng-class=\"{slideOut: ($index == selectedIndex && deleteCard)}\" ng-if=\"!editDisallowedMsg(fundingsource) && !isSystemError \">\n                                    <span ng-if=\"$index !== selectedIndex\">\n                                        <a track-submit=\"update_card\"\n                                           ui-sref='checkout.review.sidebar.sidebarUpdateCard.addCardFlow.addCard({planId: fundingsource.id})'\n                                           class=\"updateButton focusableIcon\"\n                                           aria-label=\"{{content('wallet.update') +' '+ fundingsource.name +'-'+ fundingsource.lastDigits}}\">\n                                            <span>{{ content('wallet.update') }}</span>\n                                        </a>\n                                        <span class=\"vertical\"></span>\n                                        <a href=\"\"\n                                           link-button class=\"deleteButton focusableIcon\"\n                                           ng-click=\"actions.confirm($index)\"\n                                           aria-label=\"{{content('wallet.delete') +' '+ fundingsource.name +'-'+ fundingsource.lastDigits}}\">\n                                            {{ content('wallet.delete') }}\n                                        </a>\n                                    </span>\n                                    <span ng-if=\"$index === selectedIndex\">\n                                        <span class=\"updateButton focusableIcon\"\n                                           aria-label=\"{{content('wallet.update') +' '+ fundingsource.name +'-'+ fundingsource.lastDigits}}\">\n                                            <span>{{ content('wallet.update') }}</span>\n                                        </span>\n                                        <span class=\"vertical\"></span>\n                                        <span class=\"deleteButton focusableIcon\"\n                                           aria-label=\"{{content('wallet.delete') +' '+ fundingsource.name +'-'+ fundingsource.lastDigits}}\">\n                                            {{ content('wallet.delete') }}\n                                        </span>\n                                    </span>\n                                </div>\n                            </xo-fi-panel>\n                            <a ng-if=\"editDisallowedMsg(fundingsource)\"\n                               ui-sref=\"checkout.review.sidebar.sidebarManageWallet\"\n                               ng-click=\"actions.toggleInfoMsg($index)\"\n                               class=\"infoIcon\"\n                               role=\"button\"\n                               aria-expanded=\"{{$index == disallowedIndex}}\"\n                               title=\"{{'More Info on '+ fundingsource.name +' '+ fundingsource.lastDigits}}\"\n                               aria-label=\"{{'More Info on '+ fundingsource.name +' '+ fundingsource.lastDigits}}\"></a>\n                            <p ng-if=\"editDisallowedMsg(fundingsource)\" class=\"infoMsg\" ng-class=\"{showMsg: ($index == disallowedIndex)}\">\n                                {{ content(editDisallowedMsg(fundingsource)) }}\n                            </p>\n                        </div>\n                        <div ng-class=\"{slideIn: ($index === selectedIndex && deleteCard)}\" class=\"confirm\" ng-if=\"!editDisallowedMsg(fundingsource) && !isSystemError\">\n                            <a ng-if=\"$index !== selectedIndex\"\n                               class=\"confirmButton focusableIcon\"\n                               title=\"{{content('common.confirm') +' '+ content('wallet.delete') +' '+ fundingsource.name +'-'+ fundingsource.lastDigits}}\"\n                               aria-label=\"{{content('common.confirm') +' '+ content('wallet.delete') +' '+ fundingsource.name +'-'+ fundingsource.lastDigits}}\">\n                                {{ content('common.confirm') }}\n                            </a>\n                            <a ng-if=\"$index === selectedIndex\"\n                               href=\"\" link-button track-submit=\"delete_card\"\n                               class=\"confirmButton focusableIcon\"\n                               ng-click=\"actions.deleteFS(fundingsource)\"\n                               aria-label=\"{{content('common.confirm') +' '+ content('wallet.delete') +' '+ fundingsource.name +'-'+ fundingsource.lastDigits}}\">\n                                {{ content('common.confirm') }}\n                            </a>\n                        </div>\n                    </experience>\n\n                    <!-- non-cardart experience -->\n                    <experience flag=\"!cardart\">\n                        <div ng-class=\"{'rowMask': editDisallowedMsg(fundingsource) || fundingsource.declineReason, slide: ($index === selectedIndex && deleteCard)}\">\n                            <span class=\"fsIcon nonCardArt pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"fundingsource.isPinlessDebit\"></span>\n                            <xo-fi-icon class-name=\"fsIcon nonCardArt\" fi=\"fundingsource\" ng-if=\"!fundingsource.isPinlessDebit\">\n                                <img class=\"plccInstIcon\" ng-src=\"{{fundingsource.productUrl}}\" ng-show=\"fundingsource.type === 'PLCC'\">\n                            </xo-fi-icon>\n                            <p class=\"fsdetails\">\n                                <span ng-switch=\"fundingsource.subtype\">\n                                    <span class=\"fundingContainerPAD\" ng-switch-when=\"PAD\">\n                                        <span class=\"subtype\">{{ content('fundingInstruments.pad') }}</span>\n                                        <span class=\"name\">{{ content('fsMappings.'+fundingsource.name) || fundingsource.name }}</span>\n                                        <span class=\"lastdigits\" ng-if=\"fundingsource.lastDigits\">x-{{ fundingsource.lastDigits }}</span>\n                                    </span>\n                                    <span ng-switch-default>\n                                        <span class=\"name\" ng-if=\"fundingsource.isPinlessDebit\">{{ content('fsMappings.PINLESSDEBIT') }}</span>\n                                        <span class=\"name\" ng-if=\"!fundingsource.isPinlessDebit\">{{ content('fsMappings.'+fundingsource.name) || fundingsource.name }}</span>\n                                        <span class=\"lastdigits\" ng-if=\"fundingsource.lastDigits\">x-{{ fundingsource.lastDigits }}</span>\n                                    </span>\n                                </span>\n                            </p>\n                        </div>\n\n                        <a class=\"infoIcon\"\n                           ng-if=\"editDisallowedMsg(fundingsource)\"\n                           ui-sref=\"checkout.review.sidebar.sidebarManageWallet\"\n                           ng-click=\"actions.toggleInfoMsg($index)\"\n                           aria-expanded=\"{{$index == disallowedIndex}}\"\n                           role=\"button\"\n                           aria-label=\"{{'More Info on '+ fundingsource.name +' '+ fundingsource.lastDigits}}\">\n                        </a>\n\n                        <p class=\"infoMsg\"\n                           ng-if=\"editDisallowedMsg(fundingsource)\"\n                           ng-class=\"{showMsg: ($index == disallowedIndex)}\">\n                            {{ content(editDisallowedMsg(fundingsource)) }}\n                        </p>\n\n                        <div class=\"manageLinks\"\n                             ng-class=\"{slideOut: ($index === selectedIndex && deleteCard)}\"\n                             ng-if=\"!editDisallowedMsg(fundingsource) &&  ($index !== selectedIndex) && !isSystemError\">\n                             <xo-expired-fi-panel token=\"token\" fi=\"fundingsource\"></xo-expired-fi-panel>\n                             <a track-submit=\"update_card\"\n                               ui-sref='checkout.review.sidebar.sidebarUpdateCard.addCardFlow.addCard({planId: fundingsource.id})'\n                               class=\"updateButton focusableIcon\"\n                               aria-label=\"{{content('wallet.update') +' '+ fundingsource.name +'-'+ fundingsource.lastDigits}}\">\n                                <span>{{ content('wallet.update') }}</span>\n                            </a>\n                            <span class=\"vertical\"></span>\n                            <a href=\"\"\n                               link-button class=\"deleteButton focusableIcon\"\n                               ng-click=\"actions.confirm($index)\"\n                               aria-label=\"{{content('wallet.delete') +' '+ fundingsource.name +'-'+ fundingsource.lastDigits}}\">\n                                {{ content('wallet.delete') }}\n                            </a>\n                        </div>\n\n                        <div class=\"confirm\"\n                             ng-class=\"{slideIn: ($index === selectedIndex && deleteCard)}\"\n                             ng-if=\"!editDisallowedMsg(fundingsource) && !isSystemError\">\n                            <a ng-if=\"$index !== selectedIndex\"\n                               class=\"confirmButton focusableIcon\"\n                               aria-label=\"{{content('common.confirm') +' '+ content('wallet.delete') +' '+ fundingsource.name +'-'+ fundingsource.lastDigits}}\">\n                                {{ content('common.confirm') }}\n                            </a>\n                            <a ng-if=\"$index === selectedIndex\"\n                               href=\"\"\n                               link-button track-submit=\"delete_card\"\n                               class=\"confirmButton focusableIcon\"\n                               ng-click=\"actions.deleteFS(fundingsource)\"\n                               aria-label=\"{{content('common.confirm') +' '+ content('wallet.delete') +' '+ fundingsource.name +'-'+ fundingsource.lastDigits}}\">\n                                {{ content('common.confirm') }}\n                            </a>\n                        </div>\n                    </experience>\n                </div>\n            </li>\n        </ul>\n    </div>\n</div>\n"

/***/ }),

/***/ "./pages/xo-sidebar-update-card/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoSidebarUpdateCardComponent = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _template = __webpack_require__("./pages/xo-sidebar-update-card/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarUpdateCardComponent = exports.$xoSidebarUpdateCardComponent = _squid.$Component.extend('$xoSidebarUpdateCardComponent', {
    tag: 'xo-sidebar-update-card',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        backUri: {
            type: 'var',
            required: false
        },
        doneUri: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            this.fundingid = _uiRouter.$stateParams.planId;
            this.sidebar = true;
            this.backUri = this.props.backUri;
            var doneUri = _uiRouter.$stateParams.doneUri;

            this.callbacks = {
                finish: function finish() {
                    _uiRouter.$state.go(doneUri || 'checkout.review.sidebar.sidebarManageWallet');
                }
            };
        }
    }
});

angular.value("$xoSidebarUpdateCardComponent", $xoSidebarUpdateCardComponent);
_squid.$Component;

_uiRouter.$state;

_uiRouter.$stateParams;

/***/ }),

/***/ "./pages/xo-sidebar-update-card/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SidebarUpdateCardRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/route.js");

__webpack_require__("./pages/xo-sidebar-update-card/directive.js");

var $SidebarUpdateCardRoute = exports.$SidebarUpdateCardRoute = _squid.$Route.extend('$SidebarUpdateCardRoute', {
    params: {
        planId: null,
        doneUri: null
    },
    path: 'sidebarUpdateCard',
    directive: 'xo-sidebar-update-card',
    titleContent: 'asideHeader.updateCard',
    trackingData: {
        templateName: 'tray/updateCard.dust',
        pageGoal: 'update Card',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-update-cc',
                'pagename2': '%::fullpage-update-cc:member:hermes:tray',
                'version': 'member:%:tray'
            }
        }
    },
    children: [{
        name: '$AddCardFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            sidebar: 'sidebar',
            'parent-callbacks': 'callbacks',
            logout: 'logout',
            fundingid: 'fundingid',
            'back-uri': 'backUri'
        }
    }]
});

angular.value("$SidebarUpdateCardRoute", $SidebarUpdateCardRoute);
_squid.$Route;

/***/ }),

/***/ "./pages/xo-sidebar-update-card/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"aside addCard\" id=\"addCard\" content>\n    <ui-view sidebar=\"sidebar\"></ui-view>\n</div>\n"

/***/ }),

/***/ "./pages/xo-sidebar/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _template = __webpack_require__("./pages/xo-sidebar/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoSidebarComponent', {

    tag: 'xo-sidebar',
    template: _template2['default'],

    props: {
        token: {
            required: false,
            type: 'var'
        },
        backUri: {
            required: false,
            type: 'var'
        },
        doneUri: {
            required: false,
            type: 'var'
        },
        promotion: {
            required: false,
            type: 'var'
        },
        update: {
            required: false,
            type: 'var'
        },
        installment: {
            required: false,
            type: 'var'
        },
        shippingChangeFeature: {
            required: false,
            type: 'var'
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            _squid.$util.assert(this.props.backUri, 'Expected backUri');

            this.sidebar = true;
            this.backUri = this.props.backUri;
            this.doneUri = this.props.doneUri;

            this.onPageClick = function ($event) {
                $event.stopPropagation();
            };

            /*
                Stores history of sidebar nested routes to be able to go to
                previous sidebar routes by calling back() on sidebar.
             */
            this.history = [this.props.backUri];
            this.cancelStateListener = _angular.$rootScope.$on('$stateChangeSuccess', function (event, to, toParams, from, fromParams) {
                var index = _this.history.indexOf(to.name);

                if (index === -1) {
                    _this.history.push(from.name);
                } else {
                    _this.history = _this.history.slice(0, index);
                }
            });

            this.back = function () {
                _uiRouter.$state.go(_this.history[_this.history.length - 1]);
            };

            this.close = function () {
                _uiRouter.$state.go(_this.props.backUri);
            };

            this.callbacks = {
                done: function done() {
                    _uiRouter.$state.go(this.doneUri || 'checkout.review');
                }
            };
        },
        populate: function populate() {
            (0, _jquery2['default'])('body').addClass('trayOpen');
            (0, _jquery2['default'])('#wrapper').addClass('maskMember');

            var payButton = (0, _jquery2['default'])('.confirmButton');

            if (payButton) {
                payButton.attr('disabled', true);
            }
        },
        exit: function exit() {
            (0, _jquery2['default'])('body').removeClass('trayOpen');

            var payButton = (0, _jquery2['default'])('.confirmButton');

            if (payButton) {
                payButton.attr('disabled', false);
            }

            this.cancelStateListener();
        }
    }
});


_angular.$rootScope;

_uiRouter.$state;

_squid.$Component;

_squid.$util;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-sidebar/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SidebarRoute = undefined;

__webpack_require__("../node_modules/xo-wallet-components/src/add-bank/route.js");

__webpack_require__("../node_modules/xo-member-components/src/select-shipping/add-shipping/route.js");

__webpack_require__("../node_modules/xo-member-components/src/select-shipping/delete-shipping/route.js");

__webpack_require__("../node_modules/xo-member-components/src/select-shipping/update-shipping/route.js");

__webpack_require__("./pages/xo-shipping/route.js");

__webpack_require__("./pages/xo-sidebar-add-shipping/route.js");

__webpack_require__("./pages/xo-sidebar-add-card/route.js");

__webpack_require__("./pages/xo-sidebar-add-bank/route.js");

__webpack_require__("./pages/xo-sidebar-currency-conversion/route.js");

__webpack_require__("./pages/xo-sidebar-installment-options/route.js");

__webpack_require__("./pages/xo-wallet/route.js");

__webpack_require__("./pages/xo-add-card/route.js");

__webpack_require__("./pages/xo-sidebar/directive.js");

__webpack_require__("./pages/xo-sidebar-manage-wallet/route.js");

__webpack_require__("./pages/xo-sidebar-update-card/route.js");

__webpack_require__("./pages/xo-sidebar-add-new/route.js");

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
var $SidebarRoute = exports.$SidebarRoute = _index.$Route.extend('$SidebarRoute', {
    path: 'sidebar',
    directive: 'xo-sidebar',
    children: [{
        name: '$SidebarShippingRoute',
        attributes: {
            token: 'props.token',
            'back-uri': 'props.backUri',
            'shipping-change-feature': 'props.shippingChangeFeature'
        },
        lazyRoute: 'pages/xo-shipping/route',
        slug: 'shipping'
    }, {
        name: '$SidebarAddShippingRoute',
        attributes: {
            token: 'props.token',
            'back-uri': 'props.backUri',
            'shipping-change-feature': 'props.shippingChangeFeature'
        },
        lazyRoute: 'pages/xo-sidebar-add-shipping/route',
        slug: 'sidebarAddShipping'
    }, {
        name: '$SidebarAddCardRoute',
        attributes: {
            token: 'props.token',
            promotion: 'props.promotion',
            'back-uri': 'props.backUri',
            'done-uri': 'props.doneUri'
        },
        lazyRoute: 'pages/xo-sidebar-add-card/route',
        slug: 'sidebarAddCard'
    }, {
        name: '$SidebarAddBankRoute',
        attributes: {
            token: 'props.token'
        },
        lazyRoute: 'pages/xo-sidebar-add-bank/route',
        slug: 'sidebarAddBank'
    }, {
        name: '$SidebarWalletRoute',
        props: function props() {
            return {
                token: this.props.token,
                promotion: this.props.promotion,
                installment: this.props.installment
            };
        },
        config: function config() {
            return {
                heading: 'asideHeader.fundingInstruments',
                subHeading: 'asideHeader.fundingInstrumentsSubHead',
                addRoute: 'checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard'
            };
        },

        lazyRoute: 'pages/xo-wallet/route',
        slug: 'wallet'
    }, {
        name: '$AddBankFlowRoute',
        attributes: {
            token: 'props.token',
            'parent-callbacks': 'callbacks'
        },
        lazyRoute: 'xo-wallet-components/src/add-bank/route',
        slug: 'bank'
    }, {
        name: '$AddCardPageRoute',
        attributes: {
            token: 'props.token',
            'parent-callbacks': 'callbacks'
        },
        lazyRoute: 'pages/xo-add-card/route',
        slug: 'pageAddCard'
    }, {
        name: '$AddShippingRoute',
        attributes: {
            token: 'props.token',
            'parent-callbacks': 'callbacks',
            'done-fn': 'callbacks.done',
            'back-uri': 'props.backUri',
            sidebar: 'sidebar',
            update: 'props.update',
            'shipping-change-feature': 'props.shippingChangeFeature'
        },
        lazyRoute: 'xo-member-components/src/select-shipping/add-shipping/route',
        slug: 'addShipping'
    }, {
        name: '$UpdateShippingRoute',
        attributes: {
            token: 'props.token',
            'parent-callbacks': 'callbacks',
            'done-fn': 'callbacks.done',
            'shipping-change-feature': 'props.shippingChangeFeature',
            sidebar: 'sidebar'
        },
        lazyRoute: 'xo-member-components/src/select-shipping/update-shipping/route',
        slug: 'updateShipping'
    }, {
        name: '$DeleteShippingRoute',
        attributes: {
            token: 'props.token',
            'parent-callbacks': 'callbacks',
            sidebar: 'sidebar'
        },
        lazyRoute: 'xo-member-components/src/select-shipping/delete-shipping/route',
        slug: 'deleteShipping'
    }, {
        name: '$SidebarCurrencyConversionRoute',
        attributes: {
            token: 'props.token'
        },
        lazyRoute: 'pages/xo-sidebar-currency-conversion/route',
        slug: 'currencyConversion'
    }, {
        name: '$SidebarInstallmentOptionsRoute',
        attributes: {
            token: 'props.token'
        },
        lazyRoute: 'pages/xo-sidebar-installment-options/route',
        slug: 'installmentOptions'
    }, {
        name: '$SidebarManageWalletRoute',
        props: function props() {
            return {
                token: this.token
            };
        },

        lazyRoute: 'pages/xo-sidebar-manage-wallet/route',
        slug: 'sidebarManageWallet'
    }, {
        name: '$SidebarUpdateCardRoute',
        props: function props() {
            return {
                token: this.token,
                backUri: this.props.backUri,
                doneUri: this.props.doneUri
            };
        },

        lazyRoute: 'pages/xo-sidebar-update-card/route',
        slug: 'sidebarUpdateCard'
    }, {
        name: '$SidebarAddNewRoute',
        props: function props() {
            return {
                token: this.props.token,
                backUri: this.props.backUri,
                doneUri: this.props.doneUri,
                promotion: this.props.promotion,
                'show-cancel': this.props.showCancel,
                'parent-callbacks': this.props.callbacks
            };
        },

        lazyRoute: 'pages/xo-sidebar-add-new/route',
        slug: 'sidebarAddNew'
    }]
}); /* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */


angular.value("$SidebarRoute", $SidebarRoute);
_index.$Route;

/***/ }),

/***/ "./pages/xo-sidebar/template.html":
/***/ (function(module, exports) {

module.exports = "<aside class=\"sidebar\" id=\"tray\" ng-click=\"onPageClick($event)\" modal-box modal-cancel=\"back()\" tabindex=\"-1\">\n\n    <div class=\"aside\" id=\"{{viewConfig.aside}}\">\n        <xo-aside-header ng-if=\"viewConfig.aside\" hdrtype=\"tall\" heading=\"{{viewConfig.heading}}\" sub-head='{{viewConfig.subHeading}}' add-link='{{viewConfig.addRoute}}'></xo-aside-header>\n        <div ui-view></div>\n    </div>\n</aside>\n\n<span class=\"trayViewMask\" ng-click=\"close()\"></span>\n"

/***/ }),

/***/ "./pages/xo-sidepage-add-card/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoSidepageAddCardPageComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-validation/dist/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/directive.js");

var _template = __webpack_require__("./pages/xo-sidepage-add-card/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidepageAddCardPageComponent = exports.$xoSidepageAddCardPageComponent = _squid.$Component.extend('$xoSidepageAddCardPageComponent', {
    tag: 'xo-sidepage-add-card-page',
    template: _template2['default'],
    scope: {
        token: '=?',
        callbacks: '=?'
    },
    lifecycle: {
        enter: function enter() {
            var interval = (0, _angular.$interval)(function () {
                var el = (0, _jquery2['default'])('#sidepageAddCard');

                if (el) {
                    _angular.$interval.cancel(interval);
                    el.addClass('sidepageAddCardOpen');
                }
            }, 100);
        }
    },
    controller: ['$scope', function ($scope) {
        $scope.billingaddressupdated = {
            value: false
        };
        $scope.isUpdateDebitCard = function () {
            return _uiRouter.$stateParams.message === 'EXPIRED_DEBIT_CARD';
        };
        $scope.token = _angular.$rootScope.token;
        $scope.message = {};
    }]
});

angular.value("$xoSidepageAddCardPageComponent", $xoSidepageAddCardPageComponent);
_angular.$interval;

_angular.$rootScope;

_squid.$Component;

_uiRouter.$stateParams;

/***/ }),

/***/ "./pages/xo-sidepage-add-card/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SidepageAddCardRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/route.js");

__webpack_require__("./pages/xo-sidepage-add-card/directive.js");

var $SidepageAddCardRoute = exports.$SidepageAddCardRoute = _squid.$ComponentRoute.extend('$SidepageAddCardRoute', {
    path: 'sidepageAddCard',
    directive: 'xo-sidepage-add-card-page',
    titleContent: 'asideHeader.addCard',
    trackingData: {
        templateName: 'tray/addCard.dust',
        pageGoal: 'Add Card',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-cc',
                'pagename2': '%::fullpage-add-cc:member:hermes:tray',
                'version': 'member:%:tray'
                // More page qualifiers come here...
            } }
    },
    children: [{
        name: '$AddCardFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            sidebar: 'sidebar',
            'parent-callbacks': 'callbacks',
            promotion: 'promotion',
            'show-cancel': true
        }
    }]
});

angular.value("$SidepageAddCardRoute", $SidepageAddCardRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-sidepage-add-card/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"aside\" id=\"sidepageAddCard\" modal-box content>\n    <xo-aside-header heading=\"{{isUpdateDebitCard() ? 'asideHeader.updateDebitCard' : 'asideHeader.addDebitCard'}}\"\n                     hidex=\"true\"></xo-aside-header>\n    <div class=\"content\">\n\t    <ui-view></ui-view>\n    </div>\n</div>\n"

/***/ }),

/***/ "./pages/xo-sidepage/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _template = __webpack_require__("./pages/xo-sidepage/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoSidepage', {

    tag: 'xo-sidepage',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        }
    },

    actions: {
        done: function done() {
            (0, _jquery2['default'])('body').removeClass('sidePageOpen');
            (0, _angular.$timeout)(function () {
                return _uiRouter.$state.go('checkout.review');
            }, 300);
        }
    },

    lifecycle: {
        populate: function populate() {
            (0, _jquery2['default'])('body').addClass('sidePageOpen');
        },
        exit: function exit() {
            this.actions.done();
        }
    }
});


_angular.$timeout;

_squid.$Component;

_uiRouter.$state;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-sidepage/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SidepageRoute = undefined;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-sidepage/directive.js");

var _directive2 = _interopRequireDefault(_directive);

var _route = __webpack_require__("../node_modules/xo-wallet-components/src/topup/topup-amount/route.js");

var _route2 = _interopRequireDefault(_route);

var _route3 = __webpack_require__("../node_modules/xo-wallet-components/src/topup/topup-funding/route.js");

var _route4 = _interopRequireDefault(_route3);

var _route5 = __webpack_require__("../node_modules/xo-wallet-components/src/topup/update-pin/route.js");

var _route6 = _interopRequireDefault(_route5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $SidepageRoute = exports.$SidepageRoute = _index.$Route.extend('$SidepageRoute', {

    path: 'sidepage',
    directive: _directive2['default'],
    children: [{
        route: _route4['default'],
        props: function props() {
            return {
                token: this.token,
                success: this.actions.done
            };
        }
    }, {
        route: _route2['default'],
        props: function props() {
            return {
                token: this.token,
                success: this.actions.done
            };
        }
    }, {
        route: _route6['default'],
        props: function props() {
            return {
                token: this.token,
                success: this.actions.done
            };
        }
    }]
});

angular.value("$SidepageRoute", $SidepageRoute);
_index.$Route;

/***/ }),

/***/ "./pages/xo-sidepage/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"sidepage\" modal-box tabindex=\"-1\">\n    <div ui-view></div>\n</div>\n"

/***/ }),

/***/ "./pages/xo-third-party-info/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, console) {

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _template = __webpack_require__("./pages/xo-third-party-info/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-third-party-info/styles.less");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/thirdPartyWallet/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

__webpack_require__("../node_modules/xo-form-components/src/select-shipping-country/directive.js");

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInput/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/emailInput/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/name-input/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoThirdPartyInfoFlowComponent', {
    tag: 'xo-third-party-info-collect',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: true
        }
    },

    resolve: {
        models: function models() {
            return {
                cart: _index.$CheckoutCartModel.instance(this.props.token).retrieve(),
                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
                checkoutPayee: _index.$CheckoutPayeeModel.instance(this.props.token).retrieve()
            };
        },
        payloadId: function payloadId() {
            return {
                payload_id: _uiRouter.$stateParams['payload_id']
            };
        }
    },

    actions: {
        handleFormValidation: function handleFormValidation(res) {
            var $el = $(this.$element);

            if (res && res.fields && res.fields.length) {
                res.fields.forEach(function (field) {
                    if (field.field) {
                        var $field = $($el.find('[name="' + field.field + '"]'));

                        if ($field.length === 0 && field.field === 'zip') {
                            $field = $($el.find('[ng-model="address.postal_code"], [ng-model="zipCode"]'));
                        }
                        $field.addClass('backendError');
                        $field.attr('aria-invalid', true);
                    }
                });
            }

            $el.find('form').find('.backendError, .ng-invalid').first().focus();
        },
        onSubmit: function onSubmit() {
            var _this = this;

            var createCheckoutSession = function createCheckoutSession() {
                var checkoutSessionModel = _index.$CheckoutSessionModel.instance(_this.token);

                return checkoutSessionModel.action('create', {
                    data: {
                        fraudnet_id: _this.models.cart.supplementary && _this.models.cart.supplementary.risk_correlation_id,
                        user_selected_funding_source: {
                            product_name: 'BAIDU'
                        },
                        is_skip_gfo: true
                    },
                    success: function success() {
                        return _uiRouter.$state.go('checkout.review');
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(msg, contingency) {
                            _logger.$logger.info('SYMPHONY CONTINGENCY', msg);
                            _uiRouter.$state.go('checkout.login', { baiduError: true });
                        }
                    }

                });
            };

            var refreshAuthState = function refreshAuthState() {
                var auth = _auth.$AuthModel.instance().reload();

                _squid.$locale.choose(auth.country, auth.language, false);
                return auth;
            };

            var onAuth = function onAuth(authModel) {

                if (window.xprops && window.xprops.onAuth && authModel && authModel.access_token) {

                    return window.xprops.onAuth({
                        accessToken: authModel.access_token
                    });
                }
            };

            var phone = this.buyerInfo.phone.telephone;

            phone = phone.replace(/\(|\)|\s|\-/g, ''); // removing parenthesis, commas, and dashes from the phone #

            var onboardRequest = {
                payload_id: this.buyerInfo.payload_id,
                phone: _extends({}, this.buyerInfo.phone, { telephone: phone }),
                email: this.buyerInfo.user.email,
                address: this.buyerInfo.address
            };

            var onboardMember = function onboardMember() {
                var thirdPartyModel = _index3.$ThirdPartyOnboard.instance(_this.token);

                return thirdPartyModel.action('onboard', {
                    data: onboardRequest,
                    success: function success(data) {
                        _logger.$logger.info('baidu_onboard_success');
                    },
                    error: function error(err) {
                        _logger.$logger.info('baidu_onboard_error: ', err);

                        _logger.$logger.info('checkout_fpti', {
                            from: 'third_party_info_collect',
                            to: 'process_third_party_info_collect',
                            'int_error_description': 'baidu_onboard_failure',
                            'error_type': 'soft_decline',
                            'error_source': 'hermesnodeweb'
                        });
                        _uiRouter.$state.go('checkout.login', { baiduError: true });
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(msg, contingency) {
                            _logger.$logger.info('THIS IS ONBOARD CONTINGENCY: ', msg);

                            _logger.$logger.info('checkout_fpti', {
                                from: 'third_party_info_collect',
                                to: 'process_third_party_info_collect',
                                'int_error_description': msg,
                                'error_type': 'soft_decline',
                                'error_source': 'hermesnodeweb'
                            });
                            _uiRouter.$state.go('checkout.login', { baiduError: true });
                        }
                    }
                });
            };

            var setBaiduExperience = function setBaiduExperience() {
                return _thirdPartyInfo.thirdPartyExperience.setAsBaiduExperience(_this.token);
            };

            var addressValidation = new _index2.$BillingAddressModel({
                line1: this.buyerInfo.address.line1,
                line2: this.buyerInfo.address.line2,
                city: this.buyerInfo.address.city,
                state: this.buyerInfo.address.state,
                postal_code: this.buyerInfo.address.postal_code,
                country: this.buyerInfo.address.country,
                id: '0'
            });

            addressValidation.save({
                success: function success() {
                    onboardMember().then(refreshAuthState).then(onAuth).then(setBaiduExperience).then(createCheckoutSession);
                },
                validation: function validation(res) {
                    _this.actions.handleFormValidation(res);
                },
                error: function error() {
                    console.log('address_validation_error');
                }
            });
        }
    },

    lifecycle: {
        enter: function enter() {
            this.buyerInfo = {
                address: {
                    country: _squid.$locale.country
                },
                user: {},
                phone: {}
            };
        },
        populate: function populate() {
            var payloadId = this.payloadId,
                cart = this.models.cart;


            var phone = cart.get('purchase.phone_fields.shipping_phone_number');
            var email = cart.get('payer.email');
            var shipping_address = cart.get('purchase.shipping_address');

            if (shipping_address) {
                shipping_address.country = shipping_address.country_code ? shipping_address.country_code : this.buyerInfo.address.country;
                shipping_address.country = shipping_address.country === 'CN' ? 'C2' : shipping_address.country;
                this.buyerInfo.address = shipping_address;
            }

            if (email) {
                this.buyerInfo.user.email = email;
            }

            if (phone) {
                this.buyerInfo.phone.telephone = phone;
            }

            this.buyerInfo.payload_id = payloadId.payload_id;
        }
    }
});


_squid.$Component;

_squid.$locale;

_uiRouter.$stateParams;

_uiRouter.$state;

_logger.$logger;

_index.$CheckoutPayeeModel;

_index.$CheckoutCartModel;

_index.$CheckoutAppDataModel;

_index.$CheckoutSessionModel;

_index2.$BillingAddressModel;

_auth.$AuthModel;

_index3.$ThirdPartyOnboard;

_thirdPartyInfo.thirdPartyExperience;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "./pages/xo-third-party-info/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ThirdPartyInfoCollectFlowRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-third-party-info/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $ThirdPartyInfoCollectFlowRoute = exports.$ThirdPartyInfoCollectFlowRoute = _squid.$Route.extend('$ThirdPartyInfoCollectFlowRoute', {
    path: 'thirdPartyInfoCollectFlow',
    directive: _directive2['default'],
    query: ['payload_id'],

    auth: false,

    trackingData: {
        fptiState: 'third_party_info_collect'
    }
});

angular.value("$ThirdPartyInfoCollectFlowRoute", $ThirdPartyInfoCollectFlowRoute);
_squid.$Route;

/***/ }),

/***/ "./pages/xo-third-party-info/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-third-party-info/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"review\" content tabindex=-1 role=\"presentation\">\n    <div class=\"thirdPartyInfoCollect row-fluid\">\n        <div class=\"span14 trayInner reviewSections\">\n            <xo-message ng-if=\"message\" message=\"message\"></xo-message>\n            <h1 class=\"alpha\">{{ content('common.confirmShippingDetails') }}</h1>\n            <p class=\"subTitle\">{{content('common.confirmShippingDetailsReqs')}}</p>\n\n\n            <form id=\"buyerInformationForm\" name=\"buyerInformationForm\" class=\"\" content novalidate form-autofocus>\n                <h1 class=\"gamma\">{{content('common.confirmShippingDetailsSub')}}</h1>\n                <xo-select-shipping-country shipping-address=\"buyerInfo.address\"\n                                            token=\"token\" ng-click=\"removeValidation()\"></xo-select-shipping-country>\n\n                <xo-name-input  user=\"buyerInfo.address\" country=\"{{buyerInfo.address.country}}\"></xo-name-input>\n\n                <xo-phone-input phone=\"buyerInfo.phone\" country=\"buyerInfo.address.country\"></xo-phone-input>\n\n                <xo-add-address address=\"buyerInfo.address\" country=\"buyerInfo.address.country\"></xo-add-address>\n\n                <h1 class=\"gamma\">{{content('applyForBmlUK.personalInformation')}}</h1>\n\n                <xo-email-input class=\"emailInputBelowName\" hide-helper=\"true\" flags=\"flags\" user=\"buyerInfo.user\"></xo-email-input>\n\n                <p class=\"legal\" ng-bind-html='htmlContent(\"common.confirmBaiduPaypalPolicyAgreement\")'></p>\n\n                <div class=\"buttons\">\n                    <input track-submit type=\"submit\" id=\"proceedButton\" value=\"{{content('memberReview.agreeAndContinueLabel')}}\" class=\"btn full\"  validate-submit=\"actions.onSubmit()\"/>\n                </div>\n            </form>\n\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-third-party-wallet/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {

exports.__esModule = true;

var _template = __webpack_require__("./pages/xo-third-party-wallet/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-third-party-wallet/styles.less");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/thirdPartyWallet/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoThirdPartyFlowComponent', {
    tag: 'xo-third-party-flow',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            return {
                cart: _index.$CheckoutCartModel.instance(this.props.token).retrieve(),
                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
                checkoutPayee: _index.$CheckoutPayeeModel.instance(this.props.token).retrieve()
            };
        }
    },

    actions: {},

    lifecycle: {
        enter: function enter() {
            if (_squid.$locale.country === 'CN') {
                _squid.$locale.choose('C2', 'zh_C2', false);
            }
        },
        populate: function populate() {
            var _this = this;

            var routingDecision = function routingDecision(payload_id) {
                var thirdPartyOnboard = _index2.$ThirdPartyOnboard.instance(_this.token);

                return thirdPartyOnboard.action('lookup', {
                    data: { payload_id: payload_id },
                    success: function success(result) {

                        _logger.$logger.info('checkout_fpti', { 'is_repeat_buyer': '1' });

                        refreshAuthState().then(onAuth).then(setBaiduExperience).then(createCheckoutSession);
                    },
                    error: function error(err) {
                        _logger.$logger.error('lookup_api_error', err);
                        _logger.$logger.info('checkout_fpti', {
                            from: 'third_party_wallet_flow',
                            to: 'process_third_party_wallet_flow',
                            'int_error_description': 'baidu_lookup_failure',
                            'error_type': 'soft_decline',
                            'error_source': 'hermesnodeweb'
                        });

                        _uiRouter.$state.go('checkout.login', { baiduError: true });
                    },
                    contingencies: {
                        NO_PAYMENT_TOKEN_FOUND: function NO_PAYMENT_TOKEN_FOUND(msg, contingency) {
                            _uiRouter.$state.go('checkout.thirdPartyInfoCollectFlow', { payload_id: payload_id });
                        },
                        DEFAULT: function DEFAULT(msg, contingency) {
                            _logger.$logger.info('checkout_fpti', {
                                from: 'third_party_wallet_flow',
                                to: 'process_third_party_wallet_flow',
                                'int_error_description': 'baidu_lookup_failure',
                                'error_type': 'soft_decline',
                                'error_source': 'hermesnodeweb'
                            });
                            _uiRouter.$state.go('checkout.login', { baiduError: true });
                        }
                    }
                });
            };

            var createCheckoutSession = function createCheckoutSession() {
                var checkoutSessionModel = _index.$CheckoutSessionModel.instance(_this.token);

                return checkoutSessionModel.action('create', {
                    data: {
                        fraudnet_id: _this.models.cart.supplementary && _this.models.cart.supplementary.risk_correlation_id,
                        user_selected_funding_source: {
                            product_name: 'BAIDU'
                        },
                        is_skip_gfo: true
                    },
                    success: function success() {
                        return _uiRouter.$state.go('checkout.review');
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(msg, contingency) {
                            _logger.$logger.info('SYMPHONY CONTINGENCY', msg);
                            _uiRouter.$state.go('checkout.login', { baiduError: true });
                        }
                    }

                });
            };

            var refreshAuthState = function refreshAuthState() {
                var auth = _auth.$AuthModel.instance().reload();

                _squid.$locale.choose(auth.country, auth.language, false);
                return auth;
            };

            var onAuth = function onAuth(authModel) {
                if (window.xprops && window.xprops.onAuth && authModel && authModel.access_token) {
                    return window.xprops.onAuth({
                        accessToken: authModel.access_token
                    });
                }
            };

            var setBaiduExperience = function setBaiduExperience() {
                return _thirdPartyInfo.thirdPartyExperience.setAsBaiduExperience(_this.token);
            };

            var _models = this.models,
                cart = _models.cart,
                checkoutPayee = _models.checkoutPayee;


            var hashResult = _index2.$ThirdPartyOnboard.instance(this.token).action('hash-info', {
                data: {
                    payToken: this.token
                },
                success: function success(result) {
                    return result;
                },
                contingencies: {
                    DEFAULT: function DEFAULT(msg, contingency) {
                        _uiRouter.$state.go('checkout.login', { baiduError: true });
                    }
                }
            });

            hashResult.then(function (result) {
                return _squid.$dom.loadScript('baiduComponent', 'https://www.paypalobjects.com/api/thirdPartyWallet.js').then(function () {
                    _logger.$logger.info('rendering_baidu_flow');
                    _logger.$logger.info('checkout_fpti', { to: 'rendering_baidu_iframe' });
                    return window.paypal.ThirdPartyWallet.render({
                        env: _squid.$config.thirdPartyWallet.baidu,
                        timeout: 10000,
                        properties: {
                            paypal_order_id: _this.token,

                            business_id: checkoutPayee.get('merchant.id'),

                            currency_code: cart.get('purchase.amounts.total.currency_code'),

                            transaction_amount: cart.get('purchase.amounts.total.amount'),

                            payload_hash: result.hash,

                            key_id: result.keyId
                        },

                        onComplete: function onComplete(data) {
                            _logger.$logger.info('complete_bently_flow', { payload_id: data.payloadID });
                            _logger.$logger.info('checkout_fpti', { to: 'completing_baidu_iframe' });

                            if (data && data.payloadID) {
                                return routingDecision(data.payloadID);
                            } else {

                                _uiRouter.$state.go('checkout.login', { baiduError: true });
                            }
                        },
                        onCancel: function onCancel(data) {

                            _uiRouter.$state.go('checkout.login', { baiduError: true });
                        },
                        onError: function onError(data) {
                            _logger.$logger.info('baidu_error', data);
                            _logger.$logger.info('checkout_fpti', { int_error_code: data.error_code, int_error_desc: data.error_message });
                        },
                        onTransitionStart: function onTransitionStart(data) {
                            console.log('transition start happened ', data);
                        },
                        onTransitionEnd: function onTransitionEnd(data) {
                            console.log('transition end happened ', data);
                        },
                        onTimeout: function onTimeout(data) {
                            _logger.$logger.info('baidu_flow_load_timeout');
                            _logger.$logger.info('checkout_fpti', { int_error_code: 'TIMEOUT', int_error_desc: 'Iframe timeout' });
                            _uiRouter.$state.go('checkout.login', { baiduError: true });
                        }
                    }, '#thirdPartyWalletContainer')['catch'](function (err) {
                        _logger.$logger.info('baidu_render_error', {
                            error: err.message,
                            stack: err.stack
                        });
                    });
                });
            });
        },
        exit: function exit() {}
    }

});


_squid.$Component;

_squid.$dom;

_squid.$locale;

_squid.$config;

_logger.$logger;

_index.$CheckoutPayeeModel;

_index.$CheckoutCartModel;

_index.$CheckoutAppDataModel;

_index.$CheckoutSessionModel;

_auth.$AuthModel;

_index2.$ThirdPartyOnboard;

_thirdPartyInfo.thirdPartyExperience;

_uiRouter.$state;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "./pages/xo-third-party-wallet/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ThirdPartyWalletFlowRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-third-party-wallet/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $ThirdPartyWalletFlowRoute = exports.$ThirdPartyWalletFlowRoute = _squid.$Route.extend('$ThirdPartyWalletFlowRoute', {
    path: 'thirdPartyWalletFlow',
    directive: _directive2['default'],

    auth: false,

    trackingData: {
        fptiState: 'third_party_wallet_flow',
        trackStateExit: true
    }
});

angular.value("$ThirdPartyWalletFlowRoute", $ThirdPartyWalletFlowRoute);
_squid.$Route;

/***/ }),

/***/ "./pages/xo-third-party-wallet/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-third-party-wallet/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"thirdPartyWalletContainer\"></div>\n"

/***/ }),

/***/ "./pages/xo-tokenization-info/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("./pages/xo-tokenization-info/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-tokenization-info/styles.less");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");

__webpack_require__("./pages/xo-tokenization-info/msbOffer/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoTokenizationInfoPageDirective', {
    tag: 'xo-tokenization-info',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            var checkoutCart = _checkout.$CheckoutCartModel.instance(this.props.token);
            var auth = _auth.$AuthModel.instance();
            return {
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                walletPinModel: _app.$TokenizedWalletPinModel.instance(this.props.token).retrieve(),
                tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance(this.props.token).retrieve(),
                tokenizedWalletMsbOfferModel: _app.$TokenizedWalletMsbOfferModel.instance(this.props.token).retrieve({
                    params: {
                        tokenizedWalletToken: checkoutCart.tokenizedWalletToken
                    }
                }),
                tokenizedFundingCapabilitiesModel: _app.$TokenizedFundingCapabilitiesModel.instance(this.props.token).retrieve({
                    params: {
                        tokenizedWalletToken: checkoutCart.tokenizedWalletToken,
                        country: auth.country
                    }
                }),
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(this.props.token).retrieve()
            };
        }
    },

    actions: {
        logout: function logout() {
            var _this = this;

            this.auth.logout().then(function () {
                _logger.$logger.info('tokenized_wallet', {
                    'from': 'PP_AndroidPay_Info',
                    'to': 'process_PP_AndroidPay_Info',
                    'context_id': _this.props.token,
                    'context_type': 'EC-Token'
                });
                _this.auth.redirectToLogin('NOT_YOU');
            });
        },
        redirectToCancelUrl: function redirectToCancelUrl() {
            var cancelUrl = this.models.checkoutAppData.urls.cancel_url;
            _index.$ReturnToMerchant.goTo(cancelUrl);
        },
        'continue': function _continue() {
            _logger.$logger.info('tokenized_wallet', {
                'from': 'PP_AndroidPay_Info',
                'to': 'process_PP_AndroidPay_Info',
                'context_id': this.props.token,
                'context_type': 'EC-Token'
            });

            var fi = this.models.checkoutSession.get('errorData.resolution.data.fi');

            if (fi) {
                var contingency = new _squid.$Contingency(fi.fundingId ? 'EXPIRED_DEBIT_CARD' : 'NEED_DEBIT_CARD');

                _squid.$util.extend(contingency, this.models.checkoutSession.errorData);
                throw contingency;
            }

            if (this.directFundingEnabled) {
                // if direct funding is enabled and the returned future payments does not have FI other than balance,
                // we should not allow user onboard
                var futurePaymentInstruments = this.models.checkoutSession.get('futurePaymentInstruments', []);
                var validFI = futurePaymentInstruments.filter(function (fufI) {
                    return fufI.type !== 'BALANCE';
                });

                _logger.$logger.info('direct_funding_instruments', {
                    'futurePaymentInstruments': futurePaymentInstruments.length,
                    'validFI': validFI.length
                });

                if (validFI && validFI.length === 0) {

                    _logger.$logger.info('tokenized_wallet', {
                        'from': 'PP_AndroidPay_Info',
                        'to': 'process_PP_AndroidPay_Info',
                        'context_id': this.props.token,
                        'context_type': 'EC-Token',
                        'int_error_code': 'NoBankAlert'
                    });

                    // Show the No Bank Alert page
                    this.noBank = true;
                    return;
                }
            }
            if (this.models.walletPinModel.isSetupEligible()) {
                _logger.$logger.debug('pinSetup_required');
                _uiRouter.$state.go('checkout.pinSetup');
            } else {
                _uiRouter.$state.go('checkout.review');
            }
        }
    },

    lifecycle: {
        enter: function enter() {
            this.auth = _auth.$AuthModel.instance();
            this.noBank = false;
            this.showNotYou = this.auth && this.auth.showNotYou();
            this.userName = (0, _squid.formatNameInformal)({
                first_name: this.auth.first_name,
                last_name: this.auth.last_name
            }) || this.auth.email;
        },
        populate: function populate() {
            (0, _jquery2['default'])('#tokenizationInfo .infoPage').css('min-height', function () {
                var height = window.innerHeight || document.documentElement && document.documentElement.clientHeight;

                return height && height - 125; // 125px => height of header & action button bottom padding
            });

            this.brandName = this.models.tokenizedWalletInfoModel.brandName();
            this.topupEnabled = this.models.tokenizedFundingCapabilitiesModel.isTopupEnabled();
            this.directFundingEnabled = this.models.tokenizedFundingCapabilitiesModel.isDirectFundingEnabled();

            if (this.topupEnabled) {
                this.showMsbOffer = this.models.tokenizedWalletMsbOfferModel && this.models.tokenizedWalletMsbOfferModel.enabled;
                this.tokenizationContent = {
                    heading: (0, _squid.$renderContent)('topup.commonTopupInfoHeading', { type: this.brandName }),
                    info1: (0, _squid.$renderContent)('topup.commonTopupInfo1', { type: this.brandName }),
                    info2: (0, _squid.$renderContent)('topup.commonTopupInfo2', { type: this.brandName }),
                    infoMayNeedPin: (0, _squid.$renderContent)('topup.topupInfoMayNeedPin')
                };
            } else {
                this.tokenizationContent = {
                    heading: (0, _squid.$renderContent)('tokenization.infoHeading', { type: this.brandName }),
                    info1: (0, _squid.$renderContent)('tokenization.info1', { type: this.brandName }),
                    info2: (0, _squid.$renderContent)('tokenization.info2'),
                    infoMayNeedPin: (0, _squid.$renderContent)('tokenization.infoMayNeedPin')
                };

                this.noBankErrorMessage = {
                    type: 'warning',
                    msgs: [(0, _squid.$renderContent)('tokenization.noBankHeaderSuggestion', { type: this.brandName })]
                };
            }
        }
    }
});


_auth.$AuthModel;

_squid.$Component;

_squid.$Contingency;

_squid.formatNameInformal;

_squid.$util;

_squid.$renderContent;

_uiRouter.$state;

_logger.$logger;

_app.$TokenizedWalletInfoModel;

_app.$TokenizedWalletMsbOfferModel;

_app.$TokenizedFundingCapabilitiesModel;

_app.$TokenizedWalletPinModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutAppDataModel;

_index.$ReturnToMerchant;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-tokenization-info/msbOffer/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");

__webpack_require__("./pages/xo-tokenization-info/msbOffer/styles.less");

var _template = __webpack_require__("./pages/xo-tokenization-info/msbOffer/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var logFpti = function logFpti(tokenizedWalletMsbOfferModel, toState) {
    var currency = tokenizedWalletMsbOfferModel.currency,
        amount = tokenizedWalletMsbOfferModel.amount;


    _logger.$logger.info('tokenized_wallet', {
        from: 'msb_page',
        to: toState,
        context_id: _angular.$rootScope.token,
        context_type: 'EC-Token',
        msb_currency_code: currency,
        msb_amt: amount
    });
};

var POPUP_TIMEOUT = 1000;

exports['default'] = _squid.$Component.extend('$xoTokenizedWalletMsbDirective', {
    tag: 'msb-offer',
    template: _template2['default'],

    resolve: {
        models: function models() {
            return {
                tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance(_angular.$rootScope.token).retrieve(),
                tokenizedWalletMsbOfferModel: _app.$TokenizedWalletMsbOfferModel.instance(_angular.$rootScope.token).retrieve()
            };
        }
    },

    actions: {
        closeModal: function closeModal() {
            this.showModal = false;
            logFpti(this.models.tokenizedWalletMsbOfferModel, 'process_msb');
        }
    },

    lifecycle: {
        populate: function populate() {
            var _this = this;

            var _models = this.models,
                tokenizedWalletMsbOfferModel = _models.tokenizedWalletMsbOfferModel,
                tokenizedWalletInfoModel = _models.tokenizedWalletInfoModel;


            logFpti(tokenizedWalletMsbOfferModel, 'prepare_msb');
            this.showModal = true;
            // show animated popup with a delay
            (0, _angular.$timeout)(function () {
                _this.$element.find('.modal-dialog, .modal-overlay').addClass('tokenizedWalletMsbFadeIn');
            }, POPUP_TIMEOUT);

            this.brandName = tokenizedWalletInfoModel.brandName();
            var currency = tokenizedWalletMsbOfferModel.currency,
                amount = tokenizedWalletMsbOfferModel.amount;


            this.amount = (0, _squid.formatCurrency)(amount, currency);
            this.termsLink = tokenizedWalletInfoModel.getMsbDisclaimerLink();
            this.brandName = tokenizedWalletInfoModel.brandName();
        }
    }
});


_angular.$rootScope;

_angular.$timeout;

_squid.$Component;

_squid.formatCurrency;

_logger.$logger;

_app.$TokenizedWalletInfoModel;

_app.$TokenizedWalletMsbOfferModel;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-tokenization-info/msbOffer/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-tokenization-info/msbOffer/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"tokenizedMsbOffer\" content>\n    <xo-modal show=showModal show-close-button=\"true\" on-close=\"actions.closeModal\">\n        <div class=\"modal-interior\">\n            <div class=\"gift-icon-wrap\">\n                 <span class=\"icon icon-gift\"></span>\n            </div>\n            <p class=\"content\" ng-bind-html=\"content('msb.popupContent', { amount: amount, type: brandName })\"></p>\n            <input type=\"button\" class=\"confirmation btn\" value=\"{{content('msb.popupBtn')}}\" ng-click=\"actions.closeModal()\">\n            <div>\n                <a class=\"termsLink\" target=\"_blank\" href=\"{{ termsLink }}\">{{content('msb.popupLink')}}</a>\n            </div>\n        </div>\n    </xo-modal>\n</div>\n"

/***/ }),

/***/ "./pages/xo-tokenization-info/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoTokenizationInfoPageRoute = undefined;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-tokenization-info/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoTokenizationInfoPageRoute = exports.$xoTokenizationInfoPageRoute = _index.$Route.extend('$xoTokenizationInfoPageRoute', {
    path: 'tokenizationInfo',
    directive: _directive2['default'],
    titleContent: 'Tokenization Info Page',
    trackingData: {
        fptiState: 'tokenizationInfo'
    },

    children: []
});

angular.value("$xoTokenizationInfoPageRoute", $xoTokenizationInfoPageRoute);
_index.$Route;

/***/ }),

/***/ "./pages/xo-tokenization-info/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-tokenization-info/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"tokenizationInfo\" modal-box content>\n    <div class=\"infoPage\" ng-if=\"!noBank\">\n        <span>\n            {{ content('creditcard.hi', {userName: userName}) }}\n            <span ng-if=\"showNotYou\">\n                <a track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"actions.logout()\">{{ content('memberReview.notYou')}}</a>\n            </span>\n        </span>\n        <div class=\"info_content\">\n            <div class=\"heading\">{{ tokenizationContent.heading }}</div>\n            <div class=\"content_wrapper\">\n                <div class=\"segment\">\n                    <div ng-class=\"{glyph_a: topupEnabled, glyph_contactless: directFundingEnabled}\" class=\"glyph\"></div>\n                    <div class=\"text\" ng-bind-html=\"tokenizationContent.info1\"></div>\n                </div>\n                <div class=\"segment\">\n                    <div ng-class=\"{glyph_b: topupEnabled, glyph_bank: directFundingEnabled}\" class=\"glyph\"></div>\n                    <div class=\"text\" ng-bind-html=\"tokenizationContent.info2\"></div>\n                </div>\n                <div class=\"segment\">\n                    <div class=\"glyph glyph_c\"></div>\n                    <div class=\"text\" ng-bind-html=\"tokenizationContent.infoMayNeedPin\"></div>\n                </div>\n            </div>\n        </div>\n\n        <input ng-click=\"actions.continue()\" type=\"button\" value=\"{{content('common.next')}}\" class=\"btn full continueButton\">\n    </div>\n    <div id=\"noBankInfo\" ng-if=\"noBank\">\n        <div class=\"noBankErrorMessage\">\n            <xo-message message=\"noBankErrorMessage\"></xo-message>\n        </div>\n        <div class=\"infoPage\">\n            <div class=\"info_content\">\n                <div class =\"no_bank_heading\" ng-bind-html=\"content('tokenization.noBankHeader1')\"></div>\n                <div class=\"content_wrapper\">\n                     <ol>\n                        <li>\n                            <span ng-bind-html=\"content('tokenization.noBankInfo1')\"></span>\n                        </li>\n                       <li>\n                            <span ng-bind-html=\"content('tokenization.noBankInfo2')\"></span>\n                       </li>\n                       <li>\n                            <span ng-bind-html=\"content('tokenization.noBankInfo3', {type: brandName})\"></span>\n                       </li>\n                    </ol>\n                </div>\n            </div>\n            <a href=\"/myaccount/money\" class=\"btn full continueButton\">{{content('tokenization.noBankBtnInfo')}}</a>\n            <div class=\"cancel_back\">\n                <a ng-click=\"actions.redirectToCancelUrl()\" ng-bind-html=\"content('tokenization.noBankRtnLink', {type: brandName})\"></a>\n            </div>\n        </div>\n    </div>\n    <msb-offer ng-if=\"showMsbOffer\"></msb-offer>\n</section>"

/***/ }),

/***/ "./pages/xo-travel-rule/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _template = __webpack_require__("./pages/xo-travel-rule/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-form-components/src/travel-rule/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoTravelRulePageComponent', {

    tag: 'xo-travel-rule-page',

    template: _template2['default'],

    lifecycle: {
        enter: function enter() {
            this.token = _angular.$rootScope.token;
            this.locale = _squid.$locale;

            this.finish = function () {
                _uiRouter.$state.go('checkout.review');
            };
        }
    }

});


_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_uiRouter.$state;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-travel-rule/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$TravelRuleRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("./pages/xo-travel-rule/directive.js");

var $TravelRuleRoute = exports.$TravelRuleRoute = _squid.$ComponentRoute.extend('$TravelRuleRoute', {
    path: 'travelRule',
    directive: 'xo-travel-rule-page',
    titleContent: 'travelRule.travelRule',
    trackingData: {
        templateName: 'travelRule.dust',
        pageGoal: 'collect payer ssn and/or taxId',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-travel-rule',
                'pagename2': '%::fullpage-travel-rule:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },
    loginRequired: true,
    children: []
});

angular.value("$TravelRuleRoute", $TravelRuleRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-travel-rule/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"travelRule\" id=\"travelRule\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-travel-rule token=\"token\" finish=\"finish\"></xo-travel-rule>\n        </div>\n\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"addTaxId\" title=\"{{content('login.propHead')}}\" text-content=\"login.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"addTaxId\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-update-card/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoUpdateCardPageComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-validation/dist/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/directive.js");

var _template = __webpack_require__("./pages/xo-update-card/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoUpdateCardPageComponent = exports.$xoUpdateCardPageComponent = _squid.$Component.extend('$xoUpdateCardPageComponent', {

    tag: 'xo-update-card-page',
    template: _template2['default'],

    controller: ['$scope', function ($scope) {
        // eslint-disable-line no-shadow
        $scope.callbacks = {
            finish: function finish() {
                _uiRouter.$state.go('checkout.review');
            }
        };
        $scope.token = _angular.$rootScope.token;
        $scope.locale = _squid.$locale;

        var models = {};

        function setErrorMessage(contentKey, msgType) {
            $scope.message = {
                msgs: [(0, _squid.$renderContent)(contentKey)],
                type: msgType
            };
        }

        (0, _squid.$populate)(models, {
            checkoutSession: _index.$CheckoutSessionModel.instance($scope.token).retrieve({
                contingencies: {
                    NEED_CREDIT_CARD: angular.noop,
                    EXPIRED_CREDIT_CARD: angular.noop,
                    NEED_DEBIT_CARD: angular.noop,
                    EXPIRED_DEBIT_CARD: angular.noop
                }
            }),
            checkoutCart: _index.$CheckoutCartModel.instance($scope.token),
            checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token).retrieve()
        }).then(function () {

            if (models.checkoutSession.get('errorData.cause') === 'NEED_AUTHENTICATED_CARD') {
                setErrorMessage('creditcard.errorUnconfirmedCard');
            } else if (_squid.$locale.country === 'IN' && models.checkoutCart.isBilling() && models.checkoutAppData.get('merchant.merchant_country', 'US') === 'IN') {
                setErrorMessage('creditcard.errorBAExpiredCard', _uiRouter.$stateParams.message === 'EXPIRED_DEBIT_CARD' ? 'error' : 'info');
            } else {
                setErrorMessage('creditcard.errorExpiredCard', _uiRouter.$stateParams.message === 'EXPIRED_DEBIT_CARD' ? 'error' : 'info');
            }
        });
    }]
});

angular.value("$xoUpdateCardPageComponent", $xoUpdateCardPageComponent);
_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_squid.$populate;

_squid.$renderContent;

_uiRouter.$state;

_uiRouter.$stateParams;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_index.$CheckoutSessionModel;

/***/ }),

/***/ "./pages/xo-update-card/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$UpdateCardPageRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/route.js");

__webpack_require__("./pages/xo-update-card/directive.js");

var $UpdateCardPageRoute = exports.$UpdateCardPageRoute = _squid.$ComponentRoute.extend('$UpdateCardPageRoute', {
    path: 'updateCard',
    directive: 'xo-update-card-page',
    titleContent: 'asideHeader.update',
    query: ['message'],
    trackingData: {
        templateName: 'tray/editCard.dust',
        pageGoal: 'Update Card',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-edit-cc',
                'pagename2': '%::fullpage-edit-cc:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },
    children: [{
        name: '$AddCardFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            pagetitle: 'pagetitle',
            isUpdateFlow: 'isUpdateFlow',
            cardmodel: 'cardmodel',
            'parent-callbacks': 'callbacks'

        }
    }]
});

angular.value("$UpdateCardPageRoute", $UpdateCardPageRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-update-card/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"addCard updateCard\" id=\"addCard\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <ui-view></ui-view>\n        </div>\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"addCard\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"addCard\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-venmo/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.COOKIE_AGE = exports.COOKIE_NAME = exports.VENMO_VERSION = exports.TOKEN_PARAM_NAME = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _venmoModels = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-models/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _template = __webpack_require__("./pages/xo-venmo/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TOKEN_PARAM_NAME = exports.TOKEN_PARAM_NAME = 'payload_id';
var VENMO_VERSION = exports.VENMO_VERSION = 'venmo-version';
var COOKIE_NAME = exports.COOKIE_NAME = 'pwv';
var COOKIE_AGE = exports.COOKIE_AGE = 365 * 4 * 24 * 60 * 60 * 1000;

exports['default'] = _squid.$Component.extend('$VenmoPayloadBootstrap', {
    tag: 'venmo-payload-bootstrap',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            optional: true
        }
    },

    resolve: {
        venmoParams: function venmoParams() {
            var _ref;

            return _ref = {}, _ref[TOKEN_PARAM_NAME] = _uiRouter.$stateParams[TOKEN_PARAM_NAME], _ref;
        },
        venmoAppVersion: function venmoAppVersion() {
            var _ref2;

            return _ref2 = {}, _ref2[VENMO_VERSION] = _uiRouter.$stateParams[VENMO_VERSION], _ref2;
        },
        checkoutCart: function checkoutCart() {
            return _checkout.$CheckoutCartModel.instance(this.token).retrieve();
        },
        checkoutPayee: function checkoutPayee() {
            return _checkout.$CheckoutPayeeModel.instance(this.token).retrieve();
        },
        appData: function appData() {
            return _checkout.$CheckoutAppDataModel.instance(this.token).retrieve();
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            _logger.$logger.info(['xo-venmo directive', 'lifecycle', 'enter'].join('::'));

            this.done = function (shippingAddress) {

                // usecase 1: the billing address of the venmo user existed
                // usecase 2: the checkbox was displayed on the shipping address form and the venmo user checked it
                // usecase 3: the checkbox was displayed on the shipping address form and the venmo user did not check it -> go to billing page

                if (!_this.renderBillingAddCheckbox) {
                    // usecase 1
                    _this.goto('checkout.review');
                } else if (shippingAddress) {
                    // usecase 2

                    // Transform shipping address into billing address : format
                    var add = {
                        newAddress: {
                            address1: shippingAddress.line1,
                            address2: shippingAddress.line2,
                            city: shippingAddress.city,
                            state: shippingAddress.state,
                            zip: shippingAddress.postal_code,
                            isoCountry: shippingAddress.country
                        }
                    };
                    var billingAddress = new _index.$AddBillingAddressModel({ instrumentid: _this.instrumentID });
                    var self = _this;
                    billingAddress.save({
                        data: add,
                        success: function success() {
                            _logger.$logger.info(['xo-venmo directive', 'Billing Address', 'added'].join('::'));

                            // Fix to mitigate the symphony issue with POSTAL CODE MISSING
                            // Need to have a better solution
                            _logger.$logger.info(['xo-venmo directive', 'Calling checkout session again'].join('::'));

                            var sessionModel = _checkout.$CheckoutSessionModel.instance(self.token);
                            var cartModel = _checkout.$CheckoutCartModel.instance(self.token);
                            var venmoOnboardModel = _venmoModels.$VenmoOnboardModel.instance(self.token);

                            sessionModel.action('create', {
                                data: {
                                    fraudnet_id: cartModel.supplementary && cartModel.supplementary.risk_correlation_id,
                                    baToken: cartModel.billing && cartModel.billing.ba_token,
                                    user_selected_funding_source: {
                                        dcvv: venmoOnboardModel.dcvv,
                                        product_name: 'VENMO_US_PPMERCHANT_SINGLEUSETOKEN'
                                    },
                                    is_skip_gfo: true
                                },
                                success: function success() {
                                    _uiRouter.$state.go('checkout.review');
                                }
                            });
                        },
                        error: function error(err) {
                            _logger.$logger.error('billingAddressSaveError', err);
                            _uiRouter.$state.go('checkout.login', { venmoError: true });
                        },
                        validation: function validation(_validation) {
                            _logger.$logger.error('billingAddressValidationError', _validation);
                            _uiRouter.$state.go('checkout.login', { venmoError: true });
                        }
                    });
                } else {
                    // usecase 3
                    _this.goto('checkout.venmo.addBilling');
                }
            };
        },
        populate: function populate() {
            var _this2 = this;

            (0, _jquery2['default'])('#preloaderSpinner').show();
            var venmoParams = this.venmoParams,
                venmoAppVersion = this.venmoAppVersion,
                checkoutCart = this.checkoutCart,
                checkoutPayee = this.checkoutPayee,
                appData = this.appData;

            // Placeholder to update the value of the venmo cookie with the incoming app version

            this.updateVenmoCookie = function () {
                var appVersion = venmoAppVersion[VENMO_VERSION];
                if (appVersion) {
                    var expires = ';expires=' + new Date(Date.now() + COOKIE_AGE);
                    window.document.cookie = COOKIE_NAME + '=' + appVersion + expires + ';domain=.paypal.com;path=/';
                    _logger.$logger.info('pwv_cookie_updated', appVersion);
                }
            };
            this.updateVenmoCookie();

            var checkoutSessionModel = _checkout.$CheckoutSessionModel.instance(this.token);
            var venmoOnboardModel = _venmoModels.$VenmoOnboardModel.instance(this.token);
            var venmoDcvv = void 0;

            var totalTransaction = checkoutCart && checkoutCart.purchase && checkoutCart.purchase.amounts && checkoutCart.purchase.amounts.total;

            var onboardRequest = {
                payload_id: venmoParams.payload_id,
                limit: {
                    currency: totalTransaction.currency_code,
                    amount: totalTransaction.amount
                },
                intent: checkoutCart.payment_action,
                merchant_id: checkoutPayee.merchant.id
            };

            // define steps
            var onboardMember = function onboardMember() {
                return venmoOnboardModel.save({
                    data: onboardRequest,
                    success: function success(data) {
                        _logger.$logger.info(data);
                        venmoDcvv = data.dcvv;
                        _this2.instrumentID = data.instrument_id;
                        return data;
                    },
                    error: function error(err) {

                        failureHandling('hermesnodeweb', err && err.stack || err);
                    },
                    validation: function validation(_validation2) {
                        return _uiRouter.$state.go('checkout.login', { venmoError: true });
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(msg, contingency) {
                            failureHandling('hermesnodeweb', contingency && contingency.message);
                        }
                    }
                });
            };

            var setVenmoToken = function setVenmoToken() {
                return _thirdPartyInfo.thirdPartyExperience.setAsVenmoExperience(_this2.token);
            };

            var self = this;
            var createCheckoutSession = function createCheckoutSession() {
                return checkoutSessionModel.action('create', {
                    data: {
                        fraudnet_id: checkoutCart.supplementary && checkoutCart.supplementary.risk_correlation_id,
                        baToken: checkoutCart.billing && checkoutCart.billing.ba_token,
                        user_selected_funding_source: {
                            dcvv: venmoDcvv,
                            product_name: 'VENMO_US_PPMERCHANT_SINGLEUSETOKEN'
                        },
                        is_skip_gfo: true
                    },
                    success: function success(result) {
                        return result;
                    },
                    contingencies: {
                        NEED_SHIPPING_ADDRESS: function NEED_SHIPPING_ADDRESS(msg, contingency) {

                            // In the case the merchant only ships to local country
                            _logger.$logger.info('venmo_shipping_contingency');

                            // If the user hasn't entered a billing address, we'll also take it into consideration.
                            return _index.$BillingAddressesModel.instance().retrieve().then(function (billingAddresses) {

                                self.renderBillingAddCheckbox = !(billingAddresses && billingAddresses.addresses && billingAddresses.addresses['0']);

                                _uiRouter.$state.go('checkout.venmo.addShipping');
                            });
                        },
                        DEFAULT: function DEFAULT(msg, contingency) {
                            _logger.$logger.info('venmo_unhandled_symphony_contingency', msg);
                            failureHandling('paymentapiplatserv', contingency && contingency.message);
                        }
                    }
                });
            };
            var refreshAuthState = function refreshAuthState() {
                var auth = _auth.$AuthModel.instance().reload();
                _squid.$locale.choose(auth.country, auth.language, false);
                return auth;
            };

            var onAuth = function onAuth(authModel) {

                if (window.xprops && window.xprops.onAuth && authModel && authModel.access_token) {

                    return window.xprops.onAuth({
                        accessToken: authModel.access_token
                    });
                }
            };

            var routeDecision = function routeDecision(checkoutSession) {

                if (checkoutSession) {

                    _index.$BillingAddressesModel.instance().retrieve().then(function (billingAddresses) {

                        // if the billing address model retrieves an existing address, the addresses array will have a property '0'
                        _this2.renderBillingAddCheckbox = !(billingAddresses && billingAddresses.addresses && billingAddresses.addresses['0']);

                        if (appData && appData.flags && appData.flags.shipping_address_required && !checkoutSession.shipping) {
                            // if shipping is required and no shipping is sent in xo session, we route to shipping address page
                            return _uiRouter.$state.go('checkout.venmo.addShipping');
                        } else if (_this2.renderBillingAddCheckbox) {
                            // shipping address exists, go to billing page
                            return _uiRouter.$state.go('checkout.venmo.addBilling');
                        } else {
                            // else, we go to review page

                            return _uiRouter.$state.go('checkout.review');
                        }
                    });
                } else {
                    _logger.$logger.info('venmo_empty_checkoutSession');
                }
            };

            var failureHandling = function failureHandling(source, err) {
                _logger.$logger.info('checkout_fpti', {
                    from: 'VENMO_ENTRYPOINT',
                    to: 'process_venmo_entrypoint',
                    'int_error_description': 'venmo_onboard_failure',
                    'error_type': 'soft_decline',
                    'error_source': source
                });

                _logger.$logger.error('venmoOnboardingError', err);

                // go back to login with an error param to show the buyer oupon landing
                _uiRouter.$state.go('checkout.login', { venmoError: true });
            };

            onboardMember().then(setVenmoToken).then(refreshAuthState).then(onAuth).then(createCheckoutSession).then(routeDecision)['catch'](function (err) {
                venmoOnboardModel.invalidate();
                if (err instanceof _squid.$Forbidden) {// ignore forbidden errors

                } else {
                    failureHandling('hermesnodeweb', err && err.stack || err);
                }
            });
        },
        exit: function exit() {
            (0, _jquery2['default'])('#preloaderSpinner').hide();
        }
    }
});


_squid.$Component;

_squid.$locale;

_squid.$Forbidden;

_logger.$logger;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutPayeeModel;

_index.$AddBillingAddressModel;

_index.$BillingAddressesModel;

_auth.$AuthModel;

_venmoModels.$VenmoOnboardModel;

_thirdPartyInfo.thirdPartyExperience;

_uiRouter.$stateParams;

_uiRouter.$state;

/***/ }),

/***/ "./pages/xo-venmo/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$VenmoRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-venmo/directive.js");

var _directive2 = _interopRequireDefault(_directive);

var _route = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-billing/route.js");

var _route2 = _interopRequireDefault(_route);

__webpack_require__("../node_modules/xo-member-components/src/select-shipping/add-shipping/route.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $VenmoRoute = exports.$VenmoRoute = _squid.$Route.extend('$VenmoRoute', {
    path: 'venmo',
    directive: _directive2['default'],

    auth: false,
    query: [_directive.TOKEN_PARAM_NAME, _directive.VENMO_VERSION],

    trackingData: {
        fptiState: 'venmo_entrypoint',
        trackStateExit: true
    },
    children: [{
        name: '$AddShippingRoute',
        attributes: {
            token: 'token',
            'done-fn': 'done',
            sidebar: 'sidebar',
            'render-billing-add-checkbox': 'renderBillingAddCheckbox'
        }
    }, {
        route: _route2['default'],
        attributes: {
            token: 'token',
            sidebar: 'sidebar'
        }
    }]
});

angular.value("$VenmoRoute", $VenmoRoute);
_squid.$Route;

_directive.TOKEN_PARAM_NAME;

_directive.VENMO_VERSION;

/***/ }),

/***/ "./pages/xo-venmo/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"addShipping\" id=\"addShipping\" content>\n    <div class=\"row-fluid\">\n\n        <div class=\"span14\">\n            <ui-view></ui-view>\n        </div>\n\n    </div>\n</section>\n\n"

/***/ }),

/***/ "./pages/xo-wallet/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _choice = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _index4 = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _fiMeta = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _fiMeta2 = _interopRequireDefault(_fiMeta);

__webpack_require__("../node_modules/xo-credit-components/src/offer/directive.js");

__webpack_require__("../node_modules/xo-tray-height/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/popup/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/experience/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/fi-panel/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/expired-fi-panel/directive.js");

var _marketingoffer = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");

var _newMember = __webpack_require__("../node_modules/xo-models/src/newMember/index.js");

var _factory = __webpack_require__("../node_modules/xo-ui-components/src/expired-fi-panel/factory.js");

var _cardartInstrument = __webpack_require__("./pages/services/cardart-instrument/index.js");

var _template = __webpack_require__("./pages/xo-wallet/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-wallet/styles.less");

var _experiments = __webpack_require__("../node_modules/xo-models/src/experiments/index.js");

var Experiments = _interopRequireWildcard(_experiments);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend({
    tag: 'xo-wallet',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        promotion: {
            type: 'var',
            required: false
        },
        installment: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                choiceVariant: _choice.$ChoiceEligibility.instance().getVariant(this.props.token),
                cart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                fiMeta: _fiMeta2['default'].instance(this.props.token).fetch()['catch'](_angular.noop)
            };
        },
        disallowedInstruments: function disallowedInstruments(resolvers) {
            return resolvers.models.then(function (models) {
                return {
                    expired: _factory.$ExpiredFiPanelFactory.getAllInstruments(models)
                };
            });
        },
        fiSource: function fiSource(resolvers) {
            return resolvers.models.then(function (models) {
                return {
                    isCardArtExp: _cardartInstrument.$CardArtInstrument.isCardArtEnable(models.fiMeta),
                    isBillingNoPurchase: models.cart && models.cart.isBillingNoPurchase()
                };
            });
        }
    },

    lifecycle: {
        enter: function enter() {
            this.isDE = _squid.$locale.country === 'DE';
        },
        populate: function populate() {
            var _this = this;

            var $scope = this;
            var creditDataModel = void 0;

            $scope.locale = _squid.$locale;
            $scope.showDisallowedMessage = false;

            $scope.toggleDisallowedMessage = function () {
                $scope.showDisallowedMessage = !$scope.showDisallowedMessage;
            };

            $scope.doneFn = function (result) {
                if ($scope.checkoutSession.plan.paypal_credit && $scope.installment.showCYCO) {
                    _uiRouter.$state.go('checkout.chooseCreditOffer');
                } else {
                    _uiRouter.$state.go('checkout.review');
                }
            };

            $scope.showCreditPlacement = function (plan) {
                return plan && !plan.primaryFs.isPinlessDebit && plan.primaryFs.name === 'BILL_ME_LATER';
            };

            $scope.showDualFi = (0, _squid.$feature)('addBank');
            $scope.padToggleFeature = _uiRouter.$stateParams.padToggleFeature;
            $scope.creditParentContext = {};
            $scope.memberSegment = _marketingoffer.$MemberSegmentModel.instance();

            var newMemberExperience = function newMemberExperience(result) {
                var isNmj = result;

                $scope.creditParentContext.newMember = {
                    creditOffer: $scope.memberSegment && $scope.memberSegment.creditOffer,
                    useCEPDecision: isNmj
                };
            };

            $scope.isPadToggleFeatureApplicable = function () {
                var applicable = false;

                if ($scope.padToggleFeature && $scope.padToggleFeature.applicable && $scope.padToggleFeatureSupported && $scope.padToggleFeature) {
                    applicable = true;
                }

                return applicable;
            };

            var isCreditInWallet = void 0;
            var isCoreSACEligible = void 0;

            var CREDIT_TYPE = {
                'CORE': 'CORE',
                'SAC': 'SAC',
                'EZP': 'EZP',
                'NI': 'NI'
            };

            var getMORSCreditIncentiveCampaign = function getMORSCreditIncentiveCampaign(MORSCampaigns) {
                var creditIncentiveCampaign = null;

                Object.keys(MORSCampaigns).forEach(function (key) {
                    // A "credit incentive" campaign is one that contains
                    // the "incentiveOfferProgramId" property
                    if (MORSCampaigns[key] && MORSCampaigns[key].hasOwnProperty('incentiveOfferProgramId')) {
                        creditIncentiveCampaign = MORSCampaigns[key];
                    }
                });
                return creditIncentiveCampaign;
            };

            var getCreditIncentiveBanner = function getCreditIncentiveBanner(creditIncentiveCampaign) {
                return {
                    bodyText: creditIncentiveCampaign.OfferText1,
                    bodyText2: creditIncentiveCampaign.OfferText2,
                    ctaText: (0, _squid.$renderContent)('offers.assetLite.bmlOfferPassiveCta'),
                    termsText: creditIncentiveCampaign.TermsText,
                    termsLink: creditIncentiveCampaign.TermsLink,
                    termsLinkText: creditIncentiveCampaign.TermsLinkText
                };
            };

            var getDefaultBanner = function getDefaultBanner(creditType, amount, termsLink) {
                if (creditType === CREDIT_TYPE.CORE) {
                    return {
                        bodyText: (0, _squid.$renderContent)('offers.assetLite.bmlOfferPassiveDetails', { cartAmount: amount }),
                        ctaText: (0, _squid.$renderContent)('offers.assetLite.bmlOfferPassiveCta'),
                        termsText: (0, _squid.$renderContent)('offers.subjectToApproval'),
                        termsLink: termsLink,
                        termsLinkText: (0, _squid.$renderContent)('offers.seeTermsText')
                    };
                } else if (creditType === CREDIT_TYPE.NI) {
                    return {
                        bodyText: (0, _squid.$renderContent)('offers.assetLite.bmlOfferNIWalletDetails'),
                        ctaText: (0, _squid.$renderContent)('offers.assetLite.bmlOfferNIWalletCta')
                    };
                } else if (creditType === CREDIT_TYPE.EZP) {
                    return {
                        bodyText: (0, _squid.$renderContent)('offers.assetLite.bmlOfferPassiveEZPDetails', { cartAmount: amount }),
                        ctaText: (0, _squid.$renderContent)('offers.assetLite.bmlOfferPassiveEZPCta'),
                        termsText: (0, _squid.$renderContent)('offers.subjectToApproval')
                    };
                }
            };

            var initializePadToggleFeature = function initializePadToggleFeature() {
                if ($scope.checkoutSession.fundingOptions.isPadToggleApplicable()) {
                    return Experiments.padToggleFeatureSupported().then(function (result) {
                        $scope.padToggleFeatureSupported = result;
                    });
                }

                return _squid.$promise.resolve();
            };

            $scope.isUSGambling = function () {
                // US Only Real Money Gaming
                var isUSBuyer = _squid.$locale.country === 'US';
                var isUSmerchant = $scope.checkoutAppData && $scope.checkoutAppData.get('merchant.merchant_country') === 'US';
                var isGambling = $scope.payee && $scope.payee.isGambling();

                return isGambling && isUSBuyer && isUSmerchant;
            };

            (0, _squid.$populate)($scope, {
                auth: _index4.$AuthModel.instance($scope.token),
                checkoutSession: _index.$CheckoutSessionModel.instance($scope.token),
                checkoutCart: _index.$CheckoutCartModel.create($scope.token),
                checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token),
                payee: _index.$CheckoutPayeeModel.instance($scope.token)
            }).then(function () {
                _squid.$promise.all([_newMember.$NewMemberEligibility.instance().isNmj($scope.token), initializePadToggleFeature()]).then(function (_ref) {
                    var newMemberResult = _ref[0];

                    newMemberExperience(newMemberResult);

                    var padToggleApplicable = $scope.checkoutSession.fundingOptions.isPadToggleApplicable();

                    if (padToggleApplicable && $scope.padToggleFeatureSupported && $scope.padToggleFeature === null) {

                        $scope.padToggleFeature = {
                            applicable: padToggleApplicable
                        };
                    }

                    $scope.isCurrentPlanPad = $scope.checkoutSession.plan.isPAD();
                });
            }).then(function () {
                creditDataModel = _index3.$CreditDataModel.instance($scope.token);
                var fundingInstruments = _index.$CheckoutSessionModel.instance($scope.token).get('fundingOptions.instruments');

                isCreditInWallet = _squid.$util.find(fundingInstruments, function (fi) {
                    return fi.name === 'BILL_ME_LATER';
                });
                isCoreSACEligible = $scope.checkoutSession.creditOffer;

                var getCreditType = function getCreditType(creditOfferIntensity, isInst) {
                    // Check if there is an offer already selected
                    var instModel = _index3.$CreditInstallmentModel.instance($scope.token);

                    if (instModel && instModel.creditType === CREDIT_TYPE.SAC) {
                        return CREDIT_TYPE.SAC;
                    } else if (instModel && instModel.creditType === CREDIT_TYPE.NI) {
                        return CREDIT_TYPE.NI;
                    } else if (isInst) {
                        return CREDIT_TYPE.EZP;
                    } else if (creditOfferIntensity === 1) {
                        return CREDIT_TYPE.NI;
                    } else if (creditOfferIntensity === 2) {
                        return CREDIT_TYPE.CORE;
                    }
                    _logger.$logger.warn('unknown_credit_type');
                };

                var mapDefaultToBanner = function mapDefaultToBanner(creditReuseTerms, creditTerms) {
                    $scope.useFallbackBanner = true;

                    _logger.$logger.info('checkout_fpti', {
                        'banner_type': 'ACQUISITION_wallet'
                    });

                    $scope.banner = getDefaultBanner(getCreditType($scope.installment.creditOfferIntensity, $scope.installment.installmentOptionsPresent), $scope.checkoutCart.get('purchase.amounts.total.amount_formatted'), isCreditInWallet ? creditReuseTerms : creditTerms);
                };

                var mapCreditIncentiveToBanner = function mapCreditIncentiveToBanner(creditIncentive) {
                    $scope.useCreditIncentiveBanner = true;

                    _logger.$logger.info('checkout_fpti', {
                        'banner_type': 'ACQUISITION_wallet'
                    });

                    $scope.banner = getCreditIncentiveBanner(creditIncentive);
                };

                if (_squid.$locale.country === 'US' && !isCreditInWallet) {
                    $scope.banner = {};
                    var creditIncentive = getMORSCreditIncentiveCampaign($scope.$root.MORS || {});

                    if (creditIncentive) {
                        return mapCreditIncentiveToBanner(creditIncentive);
                    }

                    return mapDefaultToBanner(_squid.$config.urls.creditReuseTerms, _squid.$config.urls.creditTerms);
                }
            }).then(function () {
                $scope.isBillingNoPurchase = $scope.checkoutCart.isBillingNoPurchase();
                $scope.isBilling = $scope.checkoutCart.isBilling();
                var disallowedList = $scope.checkoutSession.get('fundingOptions.disallowedInstruments');
                if (disallowedList) {
                    $scope.disallowedInstruments = $scope.disallowedInstruments.expired.length && $scope.disallowedInstruments.expired.filter(function (i) {
                        return disallowedList.includes(i);
                    });
                }

                if (!$scope.isBillingNoPurchase && $scope.disallowedInstruments && $scope.disallowedInstruments.length > 0) {
                    $scope.displayPosition = true;
                }
                if ((0, _squid.$feature)('giftCard')) {
                    $scope.showGC = Math.random() < 0.01 && !$scope.isBillingNoPurchase;

                    if ($scope.showGC) {
                        _logger.$logger.info('wallet_gift_card_redeem_link_shown');
                    } else {
                        _logger.$logger.info('wallet_gift_card_redeem_link_not_shown');
                    }
                }

                // Manage wallet feature can be turned on by country.
                // User will see manage link on wallet page if feature is turned on and has FIs allowed to edit.
                if ((0, _squid.$feature)('enableManageWallet')) {
                    var instruments = $scope.checkoutSession.get('fundingOptions.instruments');
                    var managebleFIs = _squid.$util.filter(instruments, function (funding) {
                        if (funding && !funding.editDisallowedMsg) {
                            return funding;
                        }
                    });

                    $scope.showManageLink = managebleFIs && managebleFIs.length > 0;
                }

                $scope.checkoutSession.message = null;
                $scope.showAddLink = _squid.$locale.country !== 'DE';
                $scope.showPlcc = $scope.checkoutSession.plccOffer && !$scope.checkoutCart.isBilling();

                $scope.showBML = function () {
                    return _squid.$locale.country !== 'GB' && !isCreditInWallet && isCoreSACEligible && !$scope.installment.showWalletBanner && !creditDataModel.isRedirectFromCape();
                };

                $scope.bml = function () {
                    // TODO: Deprecate creditOffer() - installment should not be a different banner
                    if ($scope.installment.showWalletBanner) {
                        _uiRouter.$state.go('checkout.chooseCreditOffer');
                    } else {
                        _uiRouter.$state.go('checkout.redirectToCape', {}, { location: false });
                    }
                };

                $scope.onRedeemGC = function () {
                    throw new _squid.$FallbackError({
                        reason: 'redeem_coupon_feature_not_supported',
                        product: 'ux',
                        entryPoint: 'giftCard'
                    });
                };

                $scope.addPlcc = function () {
                    if ($scope.promotion) {
                        $scope.promotion.type = 'plcc';
                    }
                    _uiRouter.$state.go('checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard');
                };

                $scope.sacEligible = function (fsName) {
                    // Return false for non BML products
                    if (fsName !== 'BILL_ME_LATER') {
                        return false;
                    }

                    if (!$scope.installment.showCYCO && parseFloat($scope.checkoutCart.purchase.amounts.total.amount) >= _index.$CreditOptionsModel.sacEligibleAmount[_squid.$locale.country]) {
                        return true;
                    }
                };

                $scope.cardModel = new _index2.$AddCardModel({
                    card: new _index2.$CardModel()
                });

                $scope.creditOffer = function () {
                    _uiRouter.$state.go('checkout.chooseCreditOffer');
                };

                $scope.showBannerinWallet = function () {
                    if ($scope.installment.showBanner && _squid.$locale.country === 'GB') {
                        if ($scope.installment.installmentOptionsPresent) {
                            $scope.showInstallmentBannerContent = true;
                            $scope.showBannerContent = false;
                        } else {
                            $scope.showBannerContent = true;
                            $scope.showInstallmentBannerContent = false;
                        }
                        return true;
                    }
                    return false;
                };

                $scope.userSelectedFI = $scope.checkoutSession.getSelectedStickyInstrument() && $scope.checkoutSession.getSelectedStickyInstrument().instrument_id;

                $scope.updateStickyFS = function (stickyFI) {
                    if (stickyFI.instrument_id !== $scope.userSelectedFI) {
                        $scope.checkoutSession.action('setStickyFI', {
                            data: {
                                instrument_id: stickyFI.instrument_id
                            },
                            success: function success(result) {
                                $scope.checkoutSession.message = {
                                    type: 'success',
                                    msgKeys: ['paymentMethod.paymentMethodUpdated']
                                };
                                $scope.doneFn(result);
                            }
                        });
                    } else {
                        _uiRouter.$state.go('checkout.review');
                    }
                };

                var _fiSource = _this.fiSource,
                    isCardArtExp = _fiSource.isCardArtExp,
                    isBillingNoPurchase = _fiSource.isBillingNoPurchase;

                var masterPlanList = $scope.checkoutSession.getPlanList();
                var serializedPlans = {}; // index of all plans by primary and balance currency code(s)
                var balanceCodes = {}; // index of cataloged currency codes
                var primaryList = []; // list of plans with unique primaryFs ids
                var balanceList = $scope.balanceList = []; // list of unique balance currencies
                // determine if the selectFi variant is active
                var isSelectFiVariant = $scope.isSelectFiVariant = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.selectFi && $scope.models && $scope.models.choiceVariant && _squid.$config.choiceExperiment.selectFi.indexOf($scope.models.choiceVariant) !== -1;

                // Log our cardart FIs instrumentation if we're currently in the cardart experience
                if (isCardArtExp) {
                    _logger.$logger.info('checkout_fpti', _extends({
                        from: 'WALLET',
                        to: 'prepare_wallet'
                    }, _cardartInstrument.$CardArtInstrument.createPayload({
                        isBillingNoPurchase: isBillingNoPurchase,
                        checkoutSession: $scope.checkoutSession
                    })));
                }

                // TODO(refactor): $MultiFiPlanFactory.getSerializedPrimary()
                var getSerializedPrimary = function getSerializedPrimary(primary) {
                    var serial = primary.id + primary.amount.currency_code.toLowerCase();

                    // if there's a subtype...
                    if (primary.subtype) {
                        serial += primary.subtype;
                    }
                    return serial;
                };

                // return a serialized key for the plan
                // plan - a plan object from checkoutSession.fundingOptions.plans
                // balances - array of currency code strings
                // TODO (refactor): $MultiFiPlanFactory.getSerializedPlanId()
                var getSerializedPlanId = function getSerializedPlanId(plan, balances) {
                    var pid = getSerializedPrimary(plan.primaryFs);

                    // if no balances array...
                    if (!balances) {
                        // just return the pid
                        return pid;
                    }

                    // (otherwise) sort balances
                    balances.sort();

                    return pid + balances.join();
                };

                if (masterPlanList) {
                    var initiallyActiveBalances = [];
                    // TODO(refactor): $MultiFiPlanFactory.getShowBalanceCurrenciesStatus()
                    var showBalanceCurrencies = $scope.checkoutSession.isMultipleBalancePlan();

                    // if selectFi variant...
                    if (isSelectFiVariant) {

                        // if not multiple balance plans...
                        if (!showBalanceCurrencies) {
                            // start with first plan's currency
                            var knownCurrency = masterPlanList[0].primaryFs.amount.currency_code;

                            // update flag if any plan has more than two secondaries or one with a different currency
                            showBalanceCurrencies = masterPlanList.some(function (plan) {
                                // show currencies, when this plan has a different one, or...
                                return plan.primaryFs.amount.currency_code !== knownCurrency ||
                                // this plan has secondaries, where...
                                plan.secondaryFIs && (
                                // there's more than one
                                plan.secondaryFIs.length > 1 ||
                                // the one has a different currency
                                plan.secondaryFIs[0].amount.currency_code !== knownCurrency);
                            });
                        }

                        // index of captured primaryFs ids
                        var primaryFsIds = {};

                        // with each plan...
                        // TODO(refactor): use $MultiFiPlanFactory.getCompositeBalances() to get `balanceCodes`, `balanceList` and `balCurCodes`
                        masterPlanList.forEach(function (plan) {
                            var balances = plan.secondaryFIs || [];
                            var balCurCodes = [];

                            // if this is the active plan...
                            if ($scope.checkoutSession.plan.id === plan.planId) {
                                // capture it's balances - to be processed later
                                initiallyActiveBalances = balances;
                            }

                            // catalog balances
                            balances.forEach(function (balance) {
                                var code = balance.amount.currency_code;

                                // capture code (for serialization, next)
                                balCurCodes.push(code);
                                // if this code has not been cataloged...
                                if (!balanceCodes.hasOwnProperty(code)) {
                                    var balInfoAndState = {
                                        code: code,
                                        checked: false
                                    };

                                    if (showBalanceCurrencies) {
                                        balInfoAndState.amount = balance.amount.amount_formatted_currency;
                                    } else {
                                        balInfoAndState.amount = balance.amount.amount_formatted;
                                    }
                                    // flag that we've cataloged this code
                                    balanceCodes[code] = balInfoAndState;
                                    // capture balance details and initial ui state
                                    balanceList.push(balInfoAndState);
                                }
                            });

                            // if this is a primary split-balance plan...
                            if (plan.primaryFs.type === 'BALANCE') {
                                // add key to template
                                // NOTE: easier to build string here, than with template tags
                                plan.currencies = [plan.primaryFs.amount.currency_code].concat(balCurCodes).join(', ');
                            }

                            // catalog plan by serial and balances
                            serializedPlans[getSerializedPlanId(plan, balCurCodes)] = plan;

                            // get plan primary
                            var serialPrimary = getSerializedPrimary(plan.primaryFs);

                            // if haven't indexed the primary...
                            if (!primaryFsIds.hasOwnProperty(serialPrimary)) {
                                // note that we've cataloged this primary
                                primaryFsIds[serialPrimary] = 1;
                                // capture plan with unique primary
                                primaryList.push(plan);
                            }
                        });

                        // sort unique balances by currency code
                        balanceList.sort(function (balA, balB) {
                            // balance codes are never the same, so no need to return 0
                            return balA.code < balB.code ? -1 : 1;
                        });

                        // pre-check balances that match the active plan's balances (if any)
                        initiallyActiveBalances.forEach(function (balance) {
                            balanceCodes[balance.amount.currency_code].checked = true;
                        });
                    } else {
                        // (otherwise) use master as local and scoped list
                        primaryList = masterPlanList;
                    }

                    // expose to template
                    $scope.isMultipleBalance = showBalanceCurrencies;
                    // expose final list
                    $scope.primaryList = primaryList;
                }

                $scope.updateFS = function (index) {
                    // impacts when/how to notify user that balances were unusable
                    var unusableBalances = 0;
                    // impacts when/how to notify user that balances were required
                    var requiredBalances = 0;
                    // the plan to use
                    var fundingsource = void 0;

                    // flag when the plan has changed
                    var updateMessaging = function updateMessaging(planWasChanged) {
                        // if this is a primary balance plan...
                        if ($scope.checkoutSession.plan.sources[0].type === 'BALANCE') {
                            // suppress any info messages
                            unusableBalances = requiredBalances = 0;
                        }
                        if (unusableBalances) {
                            // show info message about failed balances
                            $scope.checkoutSession.message = {
                                type: 'info',
                                msgKeys: [unusableBalances === 1 ? 'memberReview.ryi_noBal' : 'memberReview.ryi_noBal_plural']
                            };
                        } else if (requiredBalances) {
                            // show info message about added balances
                            $scope.checkoutSession.message = {
                                type: 'info',
                                msgKeys: [requiredBalances === 1 ? 'memberReview.ryi_yesBal' : 'memberReview.ryi_yesBal_plural']
                            };
                        } else if (planWasChanged) {
                            // show that their selection went fine
                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['paymentMethod.paymentMethodUpdated']
                            };
                        }
                    };

                    if (isSelectFiVariant) {
                        // get plan with serial, built from user selections
                        var checkedBalances = [];

                        // capture checked balance codes
                        _squid.$util.forEach(balanceCodes, function (balInfoAndState, code) {
                            if (balInfoAndState.checked) {
                                // capture balance object
                                // this is what getSerializedPlanId expects - ugh
                                checkedBalances.push(code);
                            }
                        });
                        var plan = primaryList[index];
                        var pid = void 0;
                        var pidForLogger = void 0;

                        // use plan with this primaryFs and balance options - if any
                        fundingsource = serializedPlans[getSerializedPlanId(plan, checkedBalances)];

                        // if no plan yet...
                        // (perhaps only one of the selected balances is applicable?)
                        if (!fundingsource) {
                            // resolve pid now
                            pid = getSerializedPrimary(plan.primaryFs);
                            pidForLogger = plan.primaryFs.id || plan.primaryFs.type;
                            // find a plan with each individual balance
                            checkedBalances.some(function (code) {
                                // match plan with this serial combination
                                fundingsource = serializedPlans[pid + code];
                                return fundingsource;
                            });
                            // flag that one of the checked balances was unusable
                            if (fundingsource) {
                                unusableBalances = 2;

                                _logger.$logger.info('checkout_fpti', {
                                    primary: pidForLogger,
                                    denied: checkedBalances.join()
                                });
                            }
                        }

                        // if no plan yet...
                        // (perhaps the plan doesn't have any balance combination?)
                        if (!fundingsource) {
                            // get the plan with just this primaryFs
                            fundingsource = serializedPlans[pid];
                            // if we now have a plan...
                            if (fundingsource) {
                                // note how many desired balances we're ignoring (if any)
                                unusableBalances = checkedBalances.length;

                                _logger.$logger.info('checkout_fpti', {
                                    primary: pidForLogger,
                                    denied: checkedBalances.join()
                                });
                            }
                        }

                        // if still no plan...
                        // (at this point, the plan requires a specific balance combination)
                        if (!fundingsource) {
                            var serializedPlanKeys = Object.keys(serializedPlans);

                            // use the first plan that begins with this primary
                            fundingsource = serializedPlans[serializedPlanKeys[_squid.$util.findIndex(serializedPlanKeys, function (serial) {
                                return serial.indexOf(pid) === 0;
                            })]];
                            // indicate that one or more balances were required for this plan
                            requiredBalances = balanceList.length;

                            _logger.$logger.info('checkout_fpti', {
                                primary: pidForLogger,
                                forced: balanceList.map(function (balance) {
                                    return balance.code;
                                }).join()
                            });
                        }
                    } else {
                        // (otherwise) when performing control logic...
                        // the first argument is the funding source
                        fundingsource = index;
                    }

                    // clear messaging - by default
                    $scope.checkoutSession.message = '';

                    if (fundingsource.infoMsg) {
                        $scope.disallowedIndex = index;
                        return;
                    }

                    // if the final plan hasn't changed...
                    if (fundingsource.planId === $scope.checkoutSession.plan.id) {
                        // tells user if any balances were not used or were required
                        updateMessaging();
                        // show message if balances were selected, but couldn't be used
                        $scope.doneFn();
                        return;
                    }

                    $scope.checkoutSession.fundingOptions.action('select', {
                        data: {
                            planId: fundingsource.planId
                        },
                        success: function success(result) {
                            $scope.checkoutSession.populate(result);

                            if (result) {
                                // Update the installments to support the user selecting a card that does not support installments.
                                $scope.checkoutSession.installments = result.installments;
                            }

                            if ($scope.checkoutSession.plan.paypal_credit && $scope.installment.showCYCO) {
                                _uiRouter.$state.go('checkout.chooseCreditOffer');
                            } else {
                                if (!fundingsource.selected) {
                                    // handle messaging around unusable balances (if any)
                                    // send flag that the plan was changed
                                    updateMessaging(true);

                                    if ($scope.checkoutSession.selectedInstallmentData && !$scope.checkoutSession.selectedInstallmentData.preventChange) {
                                        // Resetting selected installment data, if installment change is not explicitly prohibited.
                                        $scope.checkoutSession.selectedInstallmentData = undefined;
                                    }
                                }

                                $scope.doneFn(result);
                            }
                        },
                        contingencies: {
                            NEED_AUTHENTICATED_CARD: function NEED_AUTHENTICATED_CARD(name, result) {
                                if (result && result.resolution) {
                                    var card = result.resolution.data;

                                    if (card.fundingId && card.fi && card.fi.type) {
                                        $scope.cardModel.id = card.fundingId;
                                        $scope.cardModel.card = new _index2.$CardModel({
                                            number: 'xxxx-xxxx-xxxx-' + card.fi.number,
                                            type: card.fi.type.toUpperCase(),
                                            productType: card.fi.productType
                                        });
                                    }
                                }

                                _uiRouter.$state.go('.confirmUpop');
                            }
                        }
                    });
                };

                $scope.shouldShowFSTile = function (fundingsource) {
                    var showFS = true;

                    if ($scope.isPadToggleFeatureApplicable()) {
                        // If PAD is not the current plan, then we will not show any PAD plan and show IACH plans.
                        // If PAD is the current plan, then we will visualize it as a bank plan and IACH plan without balance for corresponding bank will not be shown
                        if (!$scope.isCurrentPlanPad && fundingsource.primaryFs && fundingsource.primaryFs.subtype === 'PAD') {
                            showFS = false;
                        } else if ($scope.isCurrentPlanPad && fundingsource.primaryFs && fundingsource.primaryFs.subtype === 'PAD' && fundingsource.planId !== $scope.checkoutSession.plan.id) {
                            showFS = false;
                        } else if ($scope.isCurrentPlanPad && fundingsource.primaryFs && fundingsource.primaryFs.subtype === 'IACH' && fundingsource.primaryFs.id === $scope.checkoutSession.plan.sources[0].instrument_id && !fundingsource.secondaryFIs) {
                            showFS = false;
                        }
                    }

                    return showFS;
                };
            });

            // Check if is variant where preferred label can be shown
            var preferredFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.preferredCheckbox || [];

            this.preferredFiVariant = preferredFiVariants.indexOf(this.models.choiceVariant) > -1;
        }
    }
});


_angular.noop;

_uiRouter.$state;

_uiRouter.$stateParams;

_squid.$Component;

_squid.$populate;

_squid.$FallbackError;

_squid.$feature;

_squid.$locale;

_squid.$util;

_squid.$config;

_squid.$renderContent;

_squid.$promise;

_logger.$logger;

_choice.$ChoiceEligibility;

_index.$CheckoutSessionModel;

_index.$CheckoutCartModel;

_index.$CheckoutAppDataModel;

_index.$CreditOptionsModel;

_index.$CheckoutPayeeModel;

_index2.$AddCardModel;

_index2.$CardModel;

_index3.$CreditDataModel;

_index3.$CreditInstallmentModel;

_index4.$AuthModel;

_marketingoffer.$MemberSegmentModel;

_newMember.$NewMemberEligibility;

_factory.$ExpiredFiPanelFactory;

_cardartInstrument.$CardArtInstrument;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-wallet/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SidebarWalletRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _route = __webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/route.js");

__webpack_require__("./pages/xo-wallet/directive.js");

var $SidebarWalletRoute = exports.$SidebarWalletRoute = _squid.$ComponentRoute.extend('$SidebarWalletRoute', {
    path: 'wallet',
    directive: 'xo-wallet',
    titleContent: 'asideHeader.wallet',
    trackingData: {
        fptiState: 'funding_option_selection',
        templateName: 'fundingInstruments.dust',
        pageGoal: 'Change Instruments',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-wallet-fundingsources',
                'pagename2': '%::fullpage-wallet-fundingsources:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },
    params: {
        padToggleFeature: null
    },
    children: [{
        route: _route.$xoConfirmUpopRoute,
        attributes: {
            token: 'token',
            phone: 'phone',
            cardmodel: 'cardModel'
        }
    }]
});

angular.value("$SidebarWalletRoute", $SidebarWalletRoute);
_squid.$ComponentRoute;

_route.$xoConfirmUpopRoute;

/***/ }),

/***/ "./pages/xo-wallet/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-wallet/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-aside-header ng-if=\"isUSGambling()\" hdrtype='tall' heading='asideHeader.fundingInstruments'\n                 sub-header-right-link='checkout.review.sidebar.sidebarManageWallet'\n                 sub-header-right=\"asideHeader.manage\"\n                 sub-header-right-icon=\"true\"\n                 show-dual-fi=\"showDualFi\"></xo-aside-header>\n<xo-aside-header ng-if=\"showManageLink && !isDE && !isUSGambling()\"\n                 hdrtype='tall'\n                 heading='asideHeader.fundingInstruments'\n                 sub-header-left-link='checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard'\n                 sub-header-left=\"asideHeader.add\"\n                 sub-header-left-icon=\"true\"\n                 sub-header-right-link='checkout.review.sidebar.sidebarManageWallet'\n                 sub-header-right=\"asideHeader.manage\"\n                 sub-header-right-icon=\"true\"\n                 show-dual-fi=\"showDualFi\">\n</xo-aside-header>\n\n<xo-aside-header ng-if=\"!showManageLink && !isDE && !isUSGambling()\"\n                 hdrtype='tall'\n                 heading='asideHeader.fundingInstruments'\n                 sub-header-left-link='checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard'\n                 sub-header-left=\"asideHeader.add\"\n                 sub-header-left-icon=\"true\"\n                 show-dual-fi=\"showDualFi\">\n</xo-aside-header>\n\n<xo-aside-header ng-if=\"!showManageLink && isDE\"\n                 hdrtype='tall'\n                 heading='asideHeader.fundingInstruments'\n                 sub-header-left-link='checkout.review.sidebar.sidebarAddNew.bank.add'\n                 sub-header-left=\"common.addNew\"\n                 sub-header-left-icon=\"true\"\n                 show-dual-fi=\"false\">\n</xo-aside-header>\n\n<xo-aside-header ng-if=\"showManageLink && isDE\"\n                 hdrtype='tall'\n                 heading='asideHeader.fundingInstruments'\n                 sub-header-left-link='checkout.review.sidebar.sidebarAddNew.bank.add'\n                 sub-header-left=\"common.addNew\"\n                 sub-header-left-icon=\"true\"\n                 show-dual-fi=\"false\"\n                 sub-header-right-link='checkout.review.sidebar.sidebarManageWallet'\n                 sub-header-right=\"asideHeader.manage\"\n                 sub-header-right-icon=\"true\">\n</xo-aside-header>\n\n<div class=\"asideContent fundingCards\" id=\"selectFunding\" content xo-tray-height>\n    <div class=\"split_bal_option\" ng-if=\"balanceList.length\">\n        <div\n            class=\"sCheckbox checkbox\"\n            ng-repeat=\"balance in balanceList track by $index\">\n            <input\n                id=\"bal_{{balance.code}}\"\n                type=\"checkbox\"\n                ng-model=\"balance.checked\"\n                value=\"{{balance.code}}\">\n            <label\n                class=\"choice-split-balance\" for=\"bal_{{balance.code}}\"\n                bind-html-compile=\"htmlContent('memberReview.useBalanceLabel', { amt: balance.amount })\">\n            </label>\n        </div>\n    </div>\n    <div class=\"allCards\">\n        <ul\n            ng-class=\"{varSelectFi: isSelectFiVariant}\"\n            class=\"allPlanList clearfix\"\n            select-box=\"checkoutSession.fundingOptions.plans\"\n            select-allow-tab-escape>\n\n            <experience flag='cardart'>\n                <!--List of Plans : selectFi variant-->\n                <li role=\"presentation\" class=\"fundingsource\" ng-repeat=\"plan in primaryList track by $index\" ng-if=\"isSelectFiVariant && !isBillingNoPurchase && shouldShowFSTile(plan)\">\n                    <a track-submit href=\"#\" prevent-default class=\"source\" ng-click=\"updateFS($index)\" role=\"button\" ng-class=\"{showMsg: ($index == disallowedIndex), noInfoMsg: !plan.infoMsg}\" select-option=\"plan.selected\" focus-when=\"plan.selected\" ng-attr-aria-selected=\"{{ plan.selected ? 'true' : undefined }}\">\n\n                        <span class=\"checkIcon\" ng-if=\"plan.selected\">\n                            <span class=\"accessAid\" ng-if=\"locale.lang === 'en'\">Selected</span>\n                        </span>\n\n                        <div class=\"instrumentContainer\">\n                            <xo-fi-panel fi=\"plan.primaryFs\" plan=\"plan\"\n                                show-all-currency-codes=\"isSelectFiVariant && plan.primaryFs.type === 'BALANCE' && isMultipleBalance\"\n                                ignore-pad=\"plan.primaryFs.subtype === 'PAD' && plan.selected && isPadToggleFeatureApplicable()\"\n                            >\n                                <div ng-if=\"!isBilling && plan.primaryFs.isPreferred && !plan.secondaryFIs && preferredFiVariant\">\n                                    <span class=\"preferredLabel\">{{ content('memberReview.preferred') }}</span>\n                                </div>\n                                <p class=\"fsdetails\" ng-class=\"[plan.primaryFs.type]\">\n                                    <span ng-if=\"showCreditPlacement(plan)\">\n                                        <xo-offer token=\"token\" promotion=\"promotion\"\n                                            bmlaction=\"bmlaction\" installment=\"installment\"\n                                            selectedmethod=\"selectedmethod\" reusetext=\"true\"\n                                            parent-context=\"creditParentContext\">\n                                        </xo-offer>\n                                    </span>\n                                </p>\n                            </xo-fi-panel>\n                        </div>\n                    </a>\n                </li>\n\n                <!--List of Plans : control-->\n                <li role=\"presentation\" class=\"fundingsource\" ng-repeat=\"plan in primaryList track by $index\" ng-if=\"!isSelectFiVariant && !isBillingNoPurchase && shouldShowFSTile(plan)\">\n                    <a track-submit href=\"#\" prevent-default class=\"source\" ng-click=\"updateFS(plan, $index)\" role=\"button\" ng-class=\"{showMsg: ($index == disallowedIndex), noInfoMsg: !plan.infoMsg}\" select-option=\"plan.selected\" focus-when=\"plan.selected\" ng-attr-aria-selected=\"{{ plan.selected ? 'true' : undefined }}\">\n\n                        <span class=\"checkIcon\" ng-if=\"plan.selected\">\n                            <span class=\"accessAid\" ng-if=\"locale.lang === 'en'\">Selected</span>\n                        </span>\n                        <div class=\"instrumentContainer\" ng-if=\"plan.secondaryFIs && plan.secondaryFIs.length\">\n                            <xo-fi-panel fi=\"plan.secondaryFIs[0]\"\n                                show-amount=\"plan.secondaryFIs.length === 1\"\n                            ></xo-fi-panel>\n                        </div>\n                        <div class=\"instrumentContainer\">\n                            <xo-fi-panel fi=\"plan.primaryFs\"\n                                show-amount=\"plan.secondaryFIs && plan.secondaryFIs.length === 1 && plan.primaryFs.amount && plan.primaryFs.type !== 'INCENTIVE'\"\n                                show-currency-code=\"plan.primaryFs.name === 'BALANCE' && isMultipleBalance\"\n                                ignore-pad=\"plan.primaryFs.subtype === 'PAD' && plan.selected && isPadToggleFeatureApplicable()\"\n\n                            >\n                                <div ng-if=\"!isBilling && plan.primaryFs.isPreferred && !plan.secondaryFIs && preferredFiVariant\">\n                                    <span class=\"preferredLabel\">{{ content('memberReview.preferred') }}</span>\n                                </div>\n                                <p class=\"fsdetails\" ng-class=\"[plan.primaryFs.type]\">\n                                    <span ng-if=\"showCreditPlacement(plan)\">\n                                        <xo-offer token=\"token\" promotion=\"promotion\"\n                                            bmlaction=\"bmlaction\" installment=\"installment\"\n                                            selectedmethod=\"selectedmethod\" reusetext=\"true\"\n                                            parent-context=\"creditParentContext\">\n                                        </xo-offer>\n                                    </span>\n                                </p>\n                            </xo-fi-panel>\n                        </div>\n                    </a>\n                </li>\n            </experience>\n            <experience flag='!cardart'>\n                <!--List of Plans : selectFi variant-->\n                <li role=\"presentation\" class=\"fundingsource\" ng-repeat=\"plan in primaryList track by $index\" ng-if=\"isSelectFiVariant && !isBillingNoPurchase && shouldShowFSTile(plan)\">\n                    <a track-submit href=\"#\" prevent-default class=\"source\" ng-click=\"updateFS($index)\" role=\"button\" ng-class=\"{showMsg: ($index == disallowedIndex), noInfoMsg: !plan.infoMsg}\" select-option=\"plan.selected\" focus-when=\"plan.selected\" ng-attr-aria-selected=\"{{ plan.selected ? 'true' : undefined }}\">\n\n                        <span class=\"checkIcon\" ng-if=\"plan.selected\">\n                            <span class=\"accessAid\" ng-if=\"locale.lang === 'en'\">Selected</span>\n                        </span>\n                        <div class=\"instrumentContainer\" ng-class=\"{singleInstrumentContainer: !plan.secondaryFIs}\" ng-if=\"plan.primaryFs.subtype === 'PAD' && plan.selected && isPadToggleFeatureApplicable()\">\n                            <span class=\"fsIcon pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"plan.primaryFs.isPinlessDebit\"></span>\n                            <span class=\"fsIcon\" ng-class=\"[plan.primaryFs.type, plan.primaryFs.name]\" ng-if=\"!plan.primaryFs.isPinlessDebit\"></span>\n                            <p class=\"fsdetails\" ng-class=\"[plan.primaryFs.type]\">\n                                <span>\n                                    <span class=\"fsName\">{{content('fsMappings.'+plan.primaryFs.name) || (plan.primaryFs.name)}} &rlm;</span>\n                                    <div class=\"lastdigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}\n                                        <span class=\"subtype\" ng-if=\"locale.country === 'DE'\">{{content('fundingInstruments.iach')}}</span>\n                                    </div>\n                                </span>\n                            </p>\n                        </div>\n                        <div class=\"instrumentContainer\" ng-class=\"{singleInstrumentContainer: !plan.secondaryFIs}\" ng-if=\"!(plan.primaryFs.subtype === 'PAD' && plan.selected && isPadToggleFeatureApplicable())\">\n                            <span class=\"fsIcon pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"plan.primaryFs.isPinlessDebit\"></span>\n                            <span class=\"fsIcon\" ng-class=\"[plan.primaryFs.type, plan.primaryFs.name]\" ng-if=\"!plan.primaryFs.isPinlessDebit\"></span>\n                            <p class=\"fsdetails\" ng-class=\"[plan.primaryFs.type]\">\n                                <span ng-switch=\"plan.primaryFs.subtype\">\n                                    <span class=\"fundingContainerPAD\" ng-switch-when=\"PAD\">\n                                        <span class=\"subtype\">{{content('fundingInstruments.pad')}}</span><br>\n                                        <span class=\"name\">{{content('fsMappings.'+plan.primaryFs.name) || plan.primaryFs.name}}</span>\n                                        <span class=\"lastdigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}</span>\n                                        <span ng-if=\"!isBilling && plan.primaryFs.isPreferred && preferredFiVariant && plan.primaryFs.subtype !== 'PAD'\">\n                                            <br>\n                                            <span class=\"preferredLabel\">{{ content('memberReview.preferred') }}</span>\n                                        </span>\n                                    </span>\n                                    <span ng-switch-default>\n                                        <span class=\"fsName\" ng-if=\"plan.primaryFs.isPinlessDebit\">{{content('fsMappings.PINLESSDEBIT')}}</span>\n                                        <span class=\"fsName\" ng-if=\"!plan.primaryFs.isPinlessDebit\">{{content('fsMappings.'+plan.primaryFs.name) || (plan.primaryFs.name)}} &rlm;</span>\n                                        <span ng-if=\"!isSelectFiVariant && plan.primaryFs.name === 'BALANCE' && isMultipleBalance\">({{plan.primaryFs.amount.currency_code}})</span>\n                                        <span ng-if=\"isSelectFiVariant && plan.primaryFs.name === 'BALANCE' && isMultipleBalance\">({{plan.currencies}})</span>\n                                        <div class=\"lastdigits\" ng-if=\"plan.primaryFs.subtype !== 'PAD'\">\n                                            <span ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}</span>\n                                            <span class=\"subtype\" ng-if=\"locale.country === 'DE' && plan.primaryFs.subtype === 'MEFT'\">{{content('fundingInstruments.meft')}}</span>\n                                            <span class=\"subtype\" ng-if=\"locale.country === 'DE' && plan.primaryFs.subtype === 'IACH'\">{{content('fundingInstruments.iach')}}</span>\n                                            <span class=\"subtype\" ng-if=\"plan.primaryFs.subtype === 'ECHECK'\">{{content('fundingInstruments.eCheck')}}</span>\n                                            <span ng-if=\"!isPreferLabelColor && !isBilling && plan.primaryFs.isPreferred && preferredFiVariant && plan.primaryFs.subtype !== 'PAD'\" class=\"preferredLabel\">\n                                                ({{ content('memberReview.preferred') }})\n                                            </span>\n                                            <span ng-if=\"isPreferLabelColor && !isBilling && plan.primaryFs.isPreferred && preferredFiVariant && plan.primaryFs.subtype !== 'PAD'\">\n                                                <br>\n                                                <span class=\"preferredLabel pxpColor\">{{ content('memberReview.preferred') }}</span>\n                                            </span>\n                                        </div>\n                                    </span>\n                                </span>\n                                <span ng-if=\"!plan.primaryFs.isPinlessDebit && plan.primaryFs.name === 'BILL_ME_LATER'\">\n                                    <xo-reuse-offer token=\"token\" promotion=\"promotion\"\n                                        bmlaction=\"bmlaction\" installment=\"installment\"\n                                        selectedmethod=\"selectedmethod\">\n                                    </xo-reuse-offer>\n                                </span>\n                            </p>\n                        </div>\n                    </a>\n                </li>\n\n                <!--List of Plans : control-->\n                <li role=\"presentation\" class=\"fundingsource\" ng-repeat=\"plan in primaryList track by $index\" ng-if=\"!isSelectFiVariant && !isBillingNoPurchase && shouldShowFSTile(plan)\">\n                    <a track-submit href=\"#\" prevent-default class=\"source\" ng-click=\"updateFS(plan, $index)\" role=\"button\" ng-class=\"{showMsg: ($index == disallowedIndex), noInfoMsg: !plan.infoMsg}\" select-option=\"plan.selected\" focus-when=\"plan.selected\" ng-attr-aria-selected=\"{{ plan.selected ? 'true' : undefined }}\">\n\n                        <span class=\"checkIcon\" ng-if=\"plan.selected\">\n                            <span class=\"accessAid\" ng-if=\"locale.lang === 'en'\">Selected</span>\n                        </span>\n                        <div class=\"instrumentContainer\" ng-if=\"plan.secondaryFIs && plan.secondaryFIs.length\">\n                            <p class=\"fsdetails\" ng-class=\"[plan.secondaryFIs[0].type]\">\n                                <span class=\"fsIcon\" ng-class=\"[plan.secondaryFIs[0].type, plan.secondaryFIs[0].name]\"></span>\n                                <span class=\"fsName\">{{content('fsMappings.'+ plan.secondaryFIs[0].name) || plan.secondaryFIs[0].name}}</span>\n                                <span class=\"colon\" ng-if=\"plan.secondaryFIs.length === 1\">: </span>\n                                <span class=\"amount\" ng-if=\"plan.secondaryFIs.length === 1 && plan.secondaryFIs[0].amount\">{{plan.secondaryFIs[0].amount.amount_formatted}}</span>\n                            </p>\n                        </div>\n                        <div class=\"instrumentContainer\" ng-class=\"{singleInstrumentContainer: !plan.secondaryFIs}\" ng-if=\"plan.primaryFs.subtype === 'PAD' && plan.selected && isPadToggleFeatureApplicable()\">\n                            <span class=\"fsIcon pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"plan.primaryFs.isPinlessDebit\"></span>\n                            <span class=\"fsIcon\" ng-class=\"[plan.primaryFs.type, plan.primaryFs.name]\" ng-if=\"!plan.primaryFs.isPinlessDebit\"></span>\n                            <p class=\"fsdetails\" ng-class=\"[plan.primaryFs.type]\">\n                                <span>\n                                    <span class=\"fsName\">{{content('fsMappings.'+plan.primaryFs.name) || (plan.primaryFs.name)}} &rlm;</span>\n                                    <span class=\"lastdigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}\n                                        <span class=\"subtype\" ng-if=\"locale.country === 'DE'\">{{content('fundingInstruments.iach')}}</span>\n                                    </span>\n                                </span>\n                            </p>\n                        </div>\n                        <div class=\"instrumentContainer\" ng-class=\"{singleInstrumentContainer: !plan.secondaryFIs}\" ng-if=\"!(plan.primaryFs.subtype === 'PAD' && plan.selected && isPadToggleFeatureApplicable())\">\n                            <span class=\"fsIcon pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"plan.primaryFs.isPinlessDebit\"></span>\n                            <span class=\"fsIcon\" ng-class=\"[plan.primaryFs.type, plan.primaryFs.name]\" ng-if=\"!plan.primaryFs.isPinlessDebit\"></span>\n                            <p class=\"fsdetails\" ng-class=\"[plan.primaryFs.type]\">\n                                <span ng-switch=\"plan.primaryFs.subtype\">\n                                    <span class=\"fundingContainerPAD\" ng-switch-when=\"PAD\">\n                                        <span class=\"subtype\">{{content('fundingInstruments.pad')}}</span><br>\n                                        <span class=\"name\">{{content('fsMappings.'+plan.primaryFs.name) || plan.primaryFs.name}}</span>\n                                        <span class=\"lastdigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}</span>\n                                    </span>\n                                    <span ng-switch-default>\n                                        <span class=\"fsName\" ng-if=\"plan.primaryFs.isPinlessDebit\">{{content('fsMappings.PINLESSDEBIT')}}</span>\n                                        <span class=\"fsName\" ng-if=\"!plan.primaryFs.isPinlessDebit\">{{content('fsMappings.'+plan.primaryFs.name) || (plan.primaryFs.name)}} &rlm;</span>\n                                        <span ng-if=\"plan.primaryFs.name === 'BALANCE' && isMultipleBalance\">({{plan.primaryFs.amount.currency_code}})</span>\n                                        <span class=\"lastdigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}\n                                            <span class=\"subtype\" ng-if=\"locale.country === 'DE' && plan.primaryFs.subtype === 'MEFT'\">{{content('fundingInstruments.meft')}}</span>\n                                            <span class=\"subtype\" ng-if=\"locale.country === 'DE' && plan.primaryFs.subtype === 'IACH'\">{{content('fundingInstruments.iach')}}</span>\n                                            <span class=\"subtype\" ng-if=\"plan.primaryFs.subtype === 'ECHECK'\">{{content('fundingInstruments.eCheck')}}</span>\n                                        </span>\n                                        <span class=\"colon\" ng-if=\"plan.secondaryFIs.length === 1 && plan.primaryFs.type !== 'INCENTIVE'\">: </span>\n                                    </span>\n                                </span>\n                                <span class=\"amount\" ng-if=\"plan.secondaryFIs && plan.secondaryFIs.length === 1 && plan.primaryFs.amount && plan.primaryFs.type !== 'INCENTIVE'\">{{plan.primaryFs.amount.amount_formatted}}</span>\n                                <span ng-if=\"!isPreferLabelColor && !isBilling && plan.primaryFs.isPreferred && !plan.secondaryFIs && preferredFiVariant\" class=\"preferredLabel\">\n                                    <br>\n                                    ({{ content('memberReview.preferred') }})\n                                </span>\n                                <span ng-if=\"isPreferLabelColor && !isBilling && plan.primaryFs.isPreferred && !plan.secondaryFIs && preferredFiVariant\">\n                                    <br>\n                                    <span class=\"preferredLabel pxpColor\">{{ content('memberReview.preferred') }}</span>\n                                </span>\n                                <span ng-if=\"showCreditPlacement(plan)\">\n                                    <xo-offer token=\"token\" promotion=\"promotion\"\n                                        bmlaction=\"bmlaction\" installment=\"installment\"\n                                        selectedmethod=\"selectedmethod\" reusetext=\"true\"\n                                        parent-context=\"creditParentContext\">\n                                    </xo-offer>\n                                </span>\n                            </p>\n                        </div>\n                    </a>\n                </li>\n            </experience>\n\n\n            <li role=\"presentation\" class=\"fundingsource fs-item\" ng-repeat=\"stickyFI in checkoutSession.futurePaymentInstruments track by $index\" ng-if=\"isBillingNoPurchase\">\n                <a class=\"source\" href=\"#\" ng-click=\"updateStickyFS(stickyFI)\" select-option role=\"button\"\n                    ng-attr-aria-selected=\"{{ (stickyFI.instrument_id===userSelectedFI) ? 'true' : undefined }}\"\n                    focus-when=\"stickyFI.instrument_id===userSelectedFI\">\n                    <div class=\"instrumentContainer singleInstrumentContainer\">\n                        <experience flag=\"!cardart\">\n                            <span class=\"fsIcon\" ng-class=\"[stickyFI.type, stickyFI.name, stickyFI.card_type]\"></span>\n                            <p class=\"fsdetails\">\n                                <span ng-switch=\"fundingsource.subtype\">\n                                    <span ng-switch-default>\n                                        <span class=\"name\">{{content('fsMappings.'+ stickyFI.name) || stickyFI.name}}</span>\n                                        <div class=\"lastdigits\" ng-if=\"stickyFI.last4\">x-{{stickyFI.last4}}</div>\n                                    </span>\n                                </span>\n                            </p>\n                        </experience>\n                        <experience flag=\"cardart\">\n                            <xo-fi-panel fi=\"stickyFI\"></xo-fi-panel>\n                        </experience>\n                    </div>\n                    <span class=\"checkIcon\" ng-if=\"stickyFI.instrument_id===userSelectedFI\">\n                        <span class=\"accessAid\" ng-if=\"locale.lang === 'en'\">Selected</span>\n                    </span>\n                </a>\n            </li>\n\n            <div ng-if=\"displayPosition\" class=\"horizontalBar\"></div>\n            <li role=\"presentation\" ng-if=\"displayPosition\" class=\"fundingsource\"\n                ng-repeat=\"instrument in disallowedInstruments track by $index\">\n\n                <a href=\"#\" prevent-default class=\"source\" role=\"button\">\n                    <div class=\"disallowedContainer\">\n                        <experience flag='!cardart'>\n                            <span class=\"fsIcon pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"instrument.isPinlessDebit\"></span>\n                            <span class=\"fsIcon\" ng-class=\"[instrument.type, instrument.name]\" ng-if=\"!instrument.isPinlessDebit\"></span>\n                            <div class=\"fsdetails\">\n                                <span ng-if=\"instrument.isPinlessDebit\">{{content('fsMappings.PINLESSDEBIT')}}</span>\n                                <span ng-if=\"!instrument.isPinlessDebit\">{{content('fsMappings.'+instrument.name) || instrument.name}}</span>\n                                <span class=\"lastdigits\" ng-if=\"instrument.lastDigits\">x-{{instrument.lastDigits}}\n                                    <span class=\"subtype\" ng-if=\"locale.country === 'DE' && instrument.subtype === 'MEFT'\">{{content('fundingInstruments.meft')}}</span>\n                                    <span class=\"subtype\" ng-if=\"locale.country === 'DE' && instrument.subtype === 'IACH'\">{{content('fundingInstruments.iach')}}</span>\n                                    <span class=\"subtype\" ng-if=\"instrument.subtype === 'ECHECK'\">{{content('fundingInstruments.eCheck')}}</span>\n                                </span>\n                            </div>\n                            <xo-expired-fi-panel token=\"token\" fi=\"instrument\"></xo-expired-fi-panel>\n                        </experience>\n                        <experience flag='cardart'>\n                            <xo-fi-panel fi=\"instrument\">\n                                <xo-expired-fi-panel token=\"token\" fi=\"instrument\"></xo-expired-fi-panel>\n                            </xo-fi-panel>\n                            </experience>\n                    </div>\n                </a>\n            </li>\n\n            <li role=\"presentation\" ng-if=\"banner.bodyText && (installment.showWalletBanner || showBML())\"\n                class=\"plusLink creditBanner\">\n                <form class=\"bmlAsideOffer\">\n                    <div class=\"fundingContainerBml\">\n                        <div id=\"bmlAcqOfferPassive\" class=\"payWithOption\">\n                            <span class=\"plusicon\" ng-click=\"bml()\" role=\"button\"></span>\n                            <div class=\"payWithOptionBody\">\n                                <div class=\"payWithOptionIcon\" ng-click=\"bml()\" role=\"button\">\n                                    <span class=\"fsIcon BILL_ME_LATER\" ng-if=\"useFallbackBanner || useCreditIncentiveBanner\"></span>\n                                    <img src=\"{{banner.logo}}\" ng-if=\"!useFallbackBanner\" />\n                                </div>\n                                <div class=\"payWithOptionContent\">\n                                    <div><a link-button ng-click=\"bml()\" class=\"name proceed\" ng-bind-html=\"banner.ctaText\" link-button></a></div>\n                                    <div>\n                                        <span class=\"payWithOptionDetails\" ng-class=\"{'strongBmlOfferTitle': useCreditIncentiveBanner}\" ng-bind-html=\"banner.bodyText\"></span> <span class=\"payWithOptionDetails\" ng-if=\"useCreditIncentiveBanner\" ng-bind-html=\"banner.bodyText2\"></span>\n                                    </div>\n                                    <div>\n                                        <span class=\"payWithOptionTerms\" ng-bind-html=\"banner.termsText\"></span>\n                                        <a href=\"{{banner.termsLink}}\" class=\"popup payWithOptionTermsLink\" target='_blank'\n                                           ng-bind-html=\"banner.termsLinkText\"></a>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n            </li>\n\n            <li role=\"presentation\" ng-if=\"showBannerinWallet()\"\n                class=\"trayInner trayInnerDefault editable offerTile\" ng-click=\"creditOffer()\">\n                <form class=\"bmlAsideOffer\">\n                    <div class=\"fundingContainerBml\">\n                        <div>\n                            <div class=\"creditOffer\" ng-if=\"showInstallmentBannerContent\" ng-click=\"creditOffer()\"\n                                 class=\"proceed\"\n                               select-option>{{content('offers.bmlWalletTitleInstallments')}}</div>\n                            <div class=\"creditOffer\" ng-if=\"showBannerContent\" ng-click=\"creditOffer()\"\n                                class=\"proceed\"\n                                select-option>{{content('offers.bmlWalletTitle')}}</div>\n                            <div class=\"cycoApplyLink\">\n                                <a track-click=\"wallet_acquisition_offer_banner\" link-button ng-click=\"creditOffer()\" class=\"proceed apply_uk_credit\">{{content('offers.bmlOfferBtn')}}\n                                    <span class=\"frontArrow goTray\"></span>\n                                </a>\n                            </div>\n                        </div>\n                        <div class=\"fundingContainerBmlOffer disclaimer clearfix\"\n                                  bind-html-compile=\"htmlContent('applyForBml.subjectApproval')\">\n                        </div>\n                    </div>\n                </form>\n            </li>\n\n\n            <!-- Gift Card link offer -->\n            <!-- changes for the coupon remdeem -->\n            <li role=\"presentation\" ng-if=\"showGC\" class=\"fundingsource redeemGC\" ng-click=\"onRedeemGC()\">\n                <p class=\"addOption\">\n                    <span>\n                        <a ng-click=\"onRedeemGC()\" class=\"proceed\" select-option> {{ content('memberReview.redeemGiftLink') }} {{ content('memberReview.giftCardDec') }}</a>\n                    </span>\n                </p>\n            </li>\n\n            <li role=\"presentation\" ng-if=\"showPlcc\" class=\"trayInner trayInnerDefault editable offerTile\"\n                ng-click=\"addPlcc()\">\n                <form class=\"bmlAsideOffer\">\n                    <div class=\"fundingContainerPlcc\">\n                        <div class=\"plccOfferHeader\">\n                            <img class=\"plccIcon\" ng-src=\"{{promotion.logoUrl}}\"/>\n                            <p class=\"headerText\"> {{ content('memberReview.plccCardOfferHeader',{merchantName:promotion.name}) }}</p>\n                            <p class=\"plccOfferDesc\">{{ content('memberReview.plccCardOfferDesc',{merchantName:promotion.name})}}</p>\n                        </div>\n\n                    </div>\n                    <input type=\"hidden\" name=\"_csrf\" value=\"{data._csrf}\"/>\n                </form>\n            </li>\n        </ul>\n    </div>\n\n    <ui-view></ui-view>\n\n</div>\n"

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/xo-webpack-config/polyfills.js");
module.exports = __webpack_require__("./js/bootstrap.js");


/***/ })

},[0]);


// WEBPACK FOOTER //
// js/main.js